
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("ac4Ca", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $a0d75b8779a6799a$export$2e2bcd8739ae039);

var $9oNqL = parcelRequire("9oNqL");

var $5uXOq = parcelRequire("5uXOq");
parcelRequire("3avtZ");

var $8Uumt = parcelRequire("8Uumt");

var $g99jC = parcelRequire("g99jC");

var $x8FYU = parcelRequire("x8FYU");

var $1kpI8 = parcelRequire("1kpI8");

var $9oNqL = parcelRequire("9oNqL");

var $9dbF6 = parcelRequire("9dbF6");

var $9NiTW = parcelRequire("9NiTW");

var $l8ruj = parcelRequire("l8ruj");

var $eDEaT = parcelRequire("eDEaT");

var $7y8jx = parcelRequire("7y8jx");
const $a0d75b8779a6799a$var$JiraBusinessBoardApp = ({ queries: { boardQuery: boardQuery } })=>{
    const environment = (0, $8Uumt.useRelayEnvironment)();
    const [queryRef, loadQuery] = (0, $8Uumt.useQueryLoader)((0, $9oNqL.default), boardQuery);
    const [isRefreshing, setIsRefreshing] = (0, $5uXOq.useState)(false);
    if (!queryRef) throw new Error('Query reference not found');
    const data = (0, $8Uumt.usePreloadedQuery)((0, $9oNqL.default), queryRef);
    const refresh = (0, $5uXOq.useCallback)(()=>{
        if (isRefreshing) return;
        const { variables: variables } = boardQuery;
        const newVariables = {
            ...variables,
            viewInput: {
                ...variables.viewInput,
                settings: (0, $7y8jx.getBoardQueryParams)()
            }
        };
        setIsRefreshing(true); // using fetchQuery to avoid triggering any suspense/loading state
        (0, $8Uumt.fetchQuery)(environment, (0, $9oNqL.default), newVariables).subscribe({
            complete: ()=>{
                setIsRefreshing(false);
                loadQuery(newVariables, {
                    fetchPolicy: 'store-only'
                });
            },
            error: ()=>{
                setIsRefreshing(false);
            }
        });
    }, [
        boardQuery,
        environment,
        isRefreshing,
        loadQuery
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "business-board-app"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9NiTW.AuthenticationCheck), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g99jC.ProjectContextProvider), {
        projectFragment: data.jira?.jiraProjectByKey
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1kpI8.ViewPreferencesProvider), {
        view: "board",
        preferences: (0, $x8FYU.BOARD_VIEW_PREFERENCES)
    }, data.jira?.jiraProjectByKey && data.jira_boardView && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eDEaT.default), {
        key: data.jira_boardView.id,
        queryFragment: data,
        projectFragment: data.jira.jiraProjectByKey,
        viewFragment: data.jira_boardView,
        refresh: refresh
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9dbF6.SubProductUpdater), {
        subProduct: "core"
    })));
};
var $a0d75b8779a6799a$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($a0d75b8779a6799a$var$JiraBusinessBoardApp);

});
parcelRegister("9oNqL", function(module, exports) {

$parcel$export(module.exports, "default", () => $9bce8588010e7cd2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<851ce7c0e4127a78b1435ca2f43e94b8>>
 * @relayHash ed1657375c0cf4da97e5232f866f32a3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e13a6924a093b85b1aea4f465273a832ec9c3a84bc57800ec328c38ab6b2e088

var $apYuT = parcelRequire("apYuT");

var $eiowN = parcelRequire("eiowN");
const $9bce8588010e7cd2$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewInput"
    }, v3 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v4 = [
        v3 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "projectKey"
        }
    ], v5 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "viewInput"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "id"
    }, v7 = [
        v3 /*: any*/ 
    ], v8 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v9 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v10 = [
        {
            "kind": "Literal",
            "name": "type",
            "value": "CREATE_ISSUES"
        }
    ], v11 = [
        {
            "kind": "ScalarField",
            "name": "canPerform"
        }
    ], v12 = [
        {
            "kind": "Literal",
            "name": "type",
            "value": "EDIT_PROJECT_CONFIG"
        }
    ], v13 = {
        "kind": "ScalarField",
        "name": "name"
    }, v14 = [
        v8 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "fieldName"
        }
    ], v15 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "src_jiraBusinessBoardQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "BusinessBoard_query"
                },
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "BusinessBoard_project"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "ProjectContextProvider"
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v5 /*: any*/ ,
                    "concreteType": "JiraBoardView",
                    "kind": "LinkedField",
                    "name": "jira_boardView",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": v6 /*: any*/ ,
                            "action": "THROW",
                            "path": "jira_boardView.id"
                        },
                        {
                            "kind": "FragmentSpread",
                            "name": "BusinessBoard_view"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcmergeboardworkflowsrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "src_jiraBusinessBoardQuery",
            "selections": [
                {
                    "args": v7 /*: any*/ ,
                    "concreteType": "JiraJqlField",
                    "kind": "LinkedField",
                    "name": "jira_categoryField",
                    "plural": false,
                    "selections": [
                        v8 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "displayName"
                        }
                    ]
                },
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v7 /*: any*/ ,
                            "kind": "ScalarField",
                            "name": "mediaClientId"
                        },
                        {
                            "args": v7 /*: any*/ ,
                            "kind": "ScalarField",
                            "name": "mediaExternalEndpointUrl"
                        },
                        {
                            "args": v7 /*: any*/ ,
                            "concreteType": "JiraJqlFieldWithAliases",
                            "kind": "LinkedField",
                            "name": "rankField",
                            "plural": false,
                            "selections": [
                                v8 /*: any*/ 
                            ]
                        },
                        {
                            "args": v7 /*: any*/ ,
                            "concreteType": "JiraIssueLinkTypeConnection",
                            "kind": "LinkedField",
                            "name": "issueLinkTypes",
                            "plural": false,
                            "selections": [
                                v9 /*: any*/ 
                            ]
                        },
                        {
                            "args": v4 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                v6 /*: any*/ ,
                                {
                                    "alias": "canCreateIssues",
                                    "args": v10 /*: any*/ ,
                                    "concreteType": "JiraProjectAction",
                                    "kind": "LinkedField",
                                    "name": "action",
                                    "plural": false,
                                    "selections": v11 /*: any*/ ,
                                    "storageKey": "action(type:\"CREATE_ISSUES\")"
                                },
                                {
                                    "alias": "canAdministerProject",
                                    "args": v12 /*: any*/ ,
                                    "concreteType": "JiraProjectAction",
                                    "kind": "LinkedField",
                                    "name": "action",
                                    "plural": false,
                                    "selections": v11 /*: any*/ ,
                                    "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "projectStyle"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "projectId"
                                },
                                {
                                    "concreteType": "JiraAvatar",
                                    "kind": "LinkedField",
                                    "name": "avatar",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "large"
                                        }
                                    ]
                                },
                                v13 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "projectType"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "status"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isFavourite"
                                },
                                {
                                    "alias": "assignIssues",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "type",
                                            "value": "ASSIGN_ISSUES"
                                        }
                                    ],
                                    "concreteType": "JiraProjectAction",
                                    "kind": "LinkedField",
                                    "name": "action",
                                    "plural": false,
                                    "selections": v11 /*: any*/ ,
                                    "storageKey": "action(type:\"ASSIGN_ISSUES\")"
                                },
                                {
                                    "alias": "administerProject",
                                    "args": v12 /*: any*/ ,
                                    "concreteType": "JiraProjectAction",
                                    "kind": "LinkedField",
                                    "name": "action",
                                    "plural": false,
                                    "selections": v11 /*: any*/ ,
                                    "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
                                },
                                {
                                    "alias": "createIssues",
                                    "args": v10 /*: any*/ ,
                                    "concreteType": "JiraProjectAction",
                                    "kind": "LinkedField",
                                    "name": "action",
                                    "plural": false,
                                    "selections": v11 /*: any*/ ,
                                    "storageKey": "action(type:\"CREATE_ISSUES\")"
                                },
                                {
                                    "alias": "deleteIssues",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "type",
                                            "value": "DELETE_ISSUES"
                                        }
                                    ],
                                    "concreteType": "JiraProjectAction",
                                    "kind": "LinkedField",
                                    "name": "action",
                                    "plural": false,
                                    "selections": v11 /*: any*/ ,
                                    "storageKey": "action(type:\"DELETE_ISSUES\")"
                                },
                                {
                                    "alias": "editIssues",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "type",
                                            "value": "EDIT_ISSUES"
                                        }
                                    ],
                                    "concreteType": "JiraProjectAction",
                                    "kind": "LinkedField",
                                    "name": "action",
                                    "plural": false,
                                    "selections": v11 /*: any*/ ,
                                    "storageKey": "action(type:\"EDIT_ISSUES\")"
                                },
                                {
                                    "alias": "linkIssues",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "type",
                                            "value": "LINK_ISSUES"
                                        }
                                    ],
                                    "concreteType": "JiraProjectAction",
                                    "kind": "LinkedField",
                                    "name": "action",
                                    "plural": false,
                                    "selections": v11 /*: any*/ ,
                                    "storageKey": "action(type:\"LINK_ISSUES\")"
                                },
                                {
                                    "alias": "scheduleIssues",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "type",
                                            "value": "SCHEDULE_ISSUES"
                                        }
                                    ],
                                    "concreteType": "JiraProjectAction",
                                    "kind": "LinkedField",
                                    "name": "action",
                                    "plural": false,
                                    "selections": v11 /*: any*/ ,
                                    "storageKey": "action(type:\"SCHEDULE_ISSUES\")"
                                },
                                {
                                    "alias": "transitionIssues",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "type",
                                            "value": "TRANSITION_ISSUES"
                                        }
                                    ],
                                    "concreteType": "JiraProjectAction",
                                    "kind": "LinkedField",
                                    "name": "action",
                                    "plural": false,
                                    "selections": v11 /*: any*/ ,
                                    "storageKey": "action(type:\"TRANSITION_ISSUES\")"
                                },
                                {
                                    "alias": "viewIssues",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "type",
                                            "value": "VIEW_ISSUES"
                                        }
                                    ],
                                    "concreteType": "JiraProjectAction",
                                    "kind": "LinkedField",
                                    "name": "action",
                                    "plural": false,
                                    "selections": v11 /*: any*/ ,
                                    "storageKey": "action(type:\"VIEW_ISSUES\")"
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v5 /*: any*/ ,
                    "concreteType": "JiraBoardView",
                    "kind": "LinkedField",
                    "name": "jira_boardView",
                    "plural": false,
                    "selections": [
                        v6 /*: any*/ ,
                        {
                            "concreteType": "JiraViewFilterConfig",
                            "kind": "LinkedField",
                            "name": "filterConfig",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "jql"
                                }
                            ]
                        },
                        {
                            "concreteType": "JiraViewGroupByConfig",
                            "kind": "LinkedField",
                            "name": "groupByConfig",
                            "plural": false,
                            "selections": v14 /*: any*/ 
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isViewConfigModified"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "canPublishViewConfig"
                        },
                        {
                            "concreteType": "JiraViewGroupByConfig",
                            "kind": "LinkedField",
                            "name": "groupByOptions",
                            "plural": true,
                            "selections": v14 /*: any*/ 
                        },
                        {
                            "concreteType": "JiraBoardViewColumnConnection",
                            "kind": "LinkedField",
                            "name": "columns",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraBoardViewColumnEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v15 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "collapsed"
                                                },
                                                {
                                                    "kind": "TypeDiscriminator",
                                                    "abstractKey": "__isJiraBoardViewColumn"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraStatus",
                                                            "kind": "LinkedField",
                                                            "name": "statuses",
                                                            "plural": true,
                                                            "selections": [
                                                                v13 /*: any*/ ,
                                                                v6 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "statusId"
                                                                },
                                                                {
                                                                    "concreteType": "JiraStatusCategory",
                                                                    "kind": "LinkedField",
                                                                    "name": "statusCategory",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "statusCategoryId"
                                                                        },
                                                                        v6 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraBoardViewStatusColumn"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraPriority",
                                                            "kind": "LinkedField",
                                                            "name": "priority",
                                                            "plural": false,
                                                            "selections": [
                                                                v13 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "priorityId"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "iconUrl"
                                                                },
                                                                v6 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraBoardViewPriorityColumn"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "user",
                                                            "plural": false,
                                                            "selections": [
                                                                v15 /*: any*/ ,
                                                                v13 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "accountId"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "picture"
                                                                },
                                                                v6 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraBoardViewAssigneeColumn"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraOption",
                                                            "kind": "LinkedField",
                                                            "name": "category",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "value"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "optionId"
                                                                },
                                                                {
                                                                    "concreteType": "JiraColor",
                                                                    "kind": "LinkedField",
                                                                    "name": "color",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "colorKey"
                                                                        },
                                                                        v6 /*: any*/ 
                                                                    ]
                                                                },
                                                                v6 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraBoardViewCategoryColumn"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "cursor"
                                        }
                                    ]
                                },
                                v9 /*: any*/ ,
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "endCursor"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasNextPage"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "handle": "connection",
                            "key": "business_board_columns",
                            "kind": "LinkedHandle",
                            "name": "columns"
                        },
                        {
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "enabledOnly",
                                    "value": true
                                },
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 100
                                }
                            ],
                            "concreteType": "JiraBoardViewCardOptionConnection",
                            "kind": "LinkedField",
                            "name": "cardOptions",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraBoardViewCardOptionEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v15 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraField",
                                                            "kind": "LinkedField",
                                                            "name": "field",
                                                            "plural": false,
                                                            "selections": [
                                                                v8 /*: any*/ ,
                                                                v6 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraBoardViewFieldCardOption"
                                                },
                                                v6 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "cardOptions(enabledOnly:true,first:100)"
                        },
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcmergeboardworkflowsrelayprovider",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "selectedWorkflowId"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "e13a6924a093b85b1aea4f465273a832ec9c3a84bc57800ec328c38ab6b2e088",
            "metadata": {},
            "name": "src_jiraBusinessBoardQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcmergeboardworkflowsrelayprovider": (0, $apYuT.default)
            }
        }
    };
}();
$9bce8588010e7cd2$var$node.hash = "1598cbab475a3fc7bcf926476911b322";
(0, $eiowN.PreloadableQueryRegistry).set($9bce8588010e7cd2$var$node.params.id, $9bce8588010e7cd2$var$node);
var $9bce8588010e7cd2$export$2e2bcd8739ae039 = $9bce8588010e7cd2$var$node;

});

parcelRegister("g99jC", function(module, exports) {

$parcel$export(module.exports, "ProjectContextProvider", () => $c897bf0612de228a$export$a85f6b5857d2176);

var $g6hRl = parcelRequire("g6hRl");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $12jwF = parcelRequire("12jwF");

var $54qG5 = parcelRequire("54qG5");

var $5YBrl = parcelRequire("5YBrl");

var $1Zr0i = parcelRequire("1Zr0i");

var $daQYX = parcelRequire("daQYX");

var $cm8b5 = parcelRequire("cm8b5");

var $gxGcZ = parcelRequire("gxGcZ");

var $iXVV6 = parcelRequire("iXVV6");

var $lVJAU = parcelRequire("lVJAU");

var $k7McJ = parcelRequire("k7McJ");

var $8OqLl = parcelRequire("8OqLl");
const $c897bf0612de228a$export$a85f6b5857d2176 = ({ children: children, projectFragment: projectFragment = null })=>{
    const { replace: replace } = (0, $lVJAU.useRouterActions)();
    const projectData = (0, $8Uumt.useFragment)((0, $g6hRl.default), projectFragment);
    const project = (0, $5uXOq.useMemo)(()=>projectData ? {
            id: Number(projectData.projectId),
            key: projectData.key,
            avatarUrl: projectData.avatar.large,
            name: projectData.name,
            type: projectData.projectType.toLowerCase(),
            isSimplified: projectData.projectStyle === 'TEAM_MANAGED_PROJECT',
            isFavorite: projectData.isFavourite,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            status: projectData.status,
            permissions: {
                assignIssues: projectData.assignIssues.canPerform,
                administerProject: projectData.administerProject.canPerform,
                createIssues: projectData.createIssues.canPerform,
                deleteIssues: projectData.deleteIssues.canPerform,
                editIssues: projectData.editIssues.canPerform,
                linkIssues: projectData.linkIssues.canPerform,
                scheduleIssues: projectData.scheduleIssues.canPerform,
                transitionIssues: projectData.transitionIssues.canPerform,
                viewIssues: projectData.viewIssues.canPerform
            }
        } : null, [
        projectData
    ]);
    const jqlContext = projectData ? `project = '${projectData.key}'` : '';
    const analyticsAttributes = (0, $5uXOq.useMemo)(()=>({
            projectId: Number(projectData?.projectId),
            isTeamManaged: projectData?.projectStyle === 'TEAM_MANAGED_PROJECT',
            projectType: projectData?.projectType.toLowerCase()
        }), [
        projectData
    ]);
    const entityData = (0, $5uXOq.useMemo)(()=>projectData?.viewIssues.canPerform ? {
            name: projectData.name,
            id: String(projectData.projectId)
        } : null, [
        projectData
    ]);
    const projects = (0, $5uXOq.useMemo)(()=>project ? [
            project
        ] : undefined, [
        project
    ]);
    const projectIdList = (0, $5uXOq.useMemo)(()=>projectData ? [
            Number(projectData.projectId)
        ] : undefined, [
        projectData
    ]);
    if (projectData?.status === 'ARCHIVED') {
        replace('/jira/errors/project-archived');
        return null;
    }
    let content;
    if (projectData == null || project == null || entityData == null) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8OqLl.default), null);
    else content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $daQYX.ProjectHookProvider), {
        project: project
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $54qG5.BusinessEntityProvider), {
        data: entityData
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1Zr0i.RealtimeProvider), {
        ids: projectIdList
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $12jwF.AriProvider), {
        ari: projectData.id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5YBrl.JqlProvider), {
        jqlContext: jqlContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gxGcZ.FiltersProvider), {
        projects: projects
    }, children)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cm8b5.ExperienceSuccess), {
        experience: (0, $k7McJ.FETCH_PROJECT_EXPERIENCE)
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        containerId: projectData?.projectId,
        containerType: "project",
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
        sourceName: "businessProjectContext",
        attributes: analyticsAttributes,
        // we set a key on the first element to force React to re-render when the context changes
        // to avoid query race-conditions that would lead to promises from a previous context
        // resolving in the current context view, and thus seeing unrelated data
        key: projectData?.projectId
    }, content);
};

});
parcelRegister("g6hRl", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca223f7fcde9b08b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f2fac8fffa8442fe537760fd97524aa5>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $ca223f7fcde9b08b$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "canPerform"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "ProjectContextProvider",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "id"
                },
                "action": "THROW",
                "path": "id"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "key"
                },
                "action": "THROW",
                "path": "key"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "projectId"
                },
                "action": "THROW",
                "path": "projectId"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraAvatar",
                    "kind": "LinkedField",
                    "name": "avatar",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "kind": "ScalarField",
                                "name": "large"
                            },
                            "action": "THROW",
                            "path": "avatar.large"
                        }
                    ]
                },
                "action": "THROW",
                "path": "avatar"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "name"
                },
                "action": "THROW",
                "path": "name"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "projectType"
                },
                "action": "THROW",
                "path": "projectType"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "status"
                },
                "action": "THROW",
                "path": "status"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "projectStyle"
                },
                "action": "THROW",
                "path": "projectStyle"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "isFavourite"
                },
                "action": "THROW",
                "path": "isFavourite"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "alias": "assignIssues",
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "type",
                            "value": "ASSIGN_ISSUES"
                        }
                    ],
                    "concreteType": "JiraProjectAction",
                    "kind": "LinkedField",
                    "name": "action",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": v0 /*: any*/ ,
                            "action": "THROW",
                            "path": "assignIssues.canPerform"
                        }
                    ],
                    "storageKey": "action(type:\"ASSIGN_ISSUES\")"
                },
                "action": "THROW",
                "path": "assignIssues"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "alias": "administerProject",
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "type",
                            "value": "EDIT_PROJECT_CONFIG"
                        }
                    ],
                    "concreteType": "JiraProjectAction",
                    "kind": "LinkedField",
                    "name": "action",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": v0 /*: any*/ ,
                            "action": "THROW",
                            "path": "administerProject.canPerform"
                        }
                    ],
                    "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
                },
                "action": "THROW",
                "path": "administerProject"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "alias": "createIssues",
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "type",
                            "value": "CREATE_ISSUES"
                        }
                    ],
                    "concreteType": "JiraProjectAction",
                    "kind": "LinkedField",
                    "name": "action",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": v0 /*: any*/ ,
                            "action": "THROW",
                            "path": "createIssues.canPerform"
                        }
                    ],
                    "storageKey": "action(type:\"CREATE_ISSUES\")"
                },
                "action": "THROW",
                "path": "createIssues"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "alias": "deleteIssues",
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "type",
                            "value": "DELETE_ISSUES"
                        }
                    ],
                    "concreteType": "JiraProjectAction",
                    "kind": "LinkedField",
                    "name": "action",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": v0 /*: any*/ ,
                            "action": "THROW",
                            "path": "deleteIssues.canPerform"
                        }
                    ],
                    "storageKey": "action(type:\"DELETE_ISSUES\")"
                },
                "action": "THROW",
                "path": "deleteIssues"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "alias": "editIssues",
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "type",
                            "value": "EDIT_ISSUES"
                        }
                    ],
                    "concreteType": "JiraProjectAction",
                    "kind": "LinkedField",
                    "name": "action",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": v0 /*: any*/ ,
                            "action": "THROW",
                            "path": "editIssues.canPerform"
                        }
                    ],
                    "storageKey": "action(type:\"EDIT_ISSUES\")"
                },
                "action": "THROW",
                "path": "editIssues"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "alias": "linkIssues",
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "type",
                            "value": "LINK_ISSUES"
                        }
                    ],
                    "concreteType": "JiraProjectAction",
                    "kind": "LinkedField",
                    "name": "action",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": v0 /*: any*/ ,
                            "action": "THROW",
                            "path": "linkIssues.canPerform"
                        }
                    ],
                    "storageKey": "action(type:\"LINK_ISSUES\")"
                },
                "action": "THROW",
                "path": "linkIssues"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "alias": "scheduleIssues",
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "type",
                            "value": "SCHEDULE_ISSUES"
                        }
                    ],
                    "concreteType": "JiraProjectAction",
                    "kind": "LinkedField",
                    "name": "action",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": v0 /*: any*/ ,
                            "action": "THROW",
                            "path": "scheduleIssues.canPerform"
                        }
                    ],
                    "storageKey": "action(type:\"SCHEDULE_ISSUES\")"
                },
                "action": "THROW",
                "path": "scheduleIssues"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "alias": "transitionIssues",
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "type",
                            "value": "TRANSITION_ISSUES"
                        }
                    ],
                    "concreteType": "JiraProjectAction",
                    "kind": "LinkedField",
                    "name": "action",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": v0 /*: any*/ ,
                            "action": "THROW",
                            "path": "transitionIssues.canPerform"
                        }
                    ],
                    "storageKey": "action(type:\"TRANSITION_ISSUES\")"
                },
                "action": "THROW",
                "path": "transitionIssues"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "alias": "viewIssues",
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "type",
                            "value": "VIEW_ISSUES"
                        }
                    ],
                    "concreteType": "JiraProjectAction",
                    "kind": "LinkedField",
                    "name": "action",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": v0 /*: any*/ ,
                            "action": "THROW",
                            "path": "viewIssues.canPerform"
                        }
                    ],
                    "storageKey": "action(type:\"VIEW_ISSUES\")"
                },
                "action": "THROW",
                "path": "viewIssues"
            }
        ],
        "type": "JiraProject"
    };
}();
$ca223f7fcde9b08b$var$node.hash = "b80353b73daa33fbcfe6685edf0b4639";
var $ca223f7fcde9b08b$export$2e2bcd8739ae039 = $ca223f7fcde9b08b$var$node;

});

parcelRegister("12jwF", function(module, exports) {

$parcel$export(module.exports, "AriProvider", () => $d9a27a44a6301e03$export$c806f8ac05dc61fa);
$parcel$export(module.exports, "useEntityAri", () => $d9a27a44a6301e03$export$badcacdc306567b8);

var $5uXOq = parcelRequire("5uXOq");
const $d9a27a44a6301e03$var$AriContext = /*#__PURE__*/ (0, $5uXOq.createContext)('');
const $d9a27a44a6301e03$export$c806f8ac05dc61fa = ({ ari: ari, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d9a27a44a6301e03$var$AriContext.Provider, {
        value: ari
    }, children);
const $d9a27a44a6301e03$export$badcacdc306567b8 = ()=>(0, $5uXOq.useContext)($d9a27a44a6301e03$var$AriContext);

});

parcelRegister("54qG5", function(module, exports) {

$parcel$export(module.exports, "BusinessEntityProvider", () => $a71d927d8f07dfcc$export$c800e064c3c327ef);
$parcel$export(module.exports, "useBusinessEntity", () => $a71d927d8f07dfcc$export$ff2574b00bc1c100);

var $5uXOq = parcelRequire("5uXOq");
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
const $a71d927d8f07dfcc$var$BusinessEntityContext = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $a71d927d8f07dfcc$export$c800e064c3c327ef = ({ data: data, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a71d927d8f07dfcc$var$BusinessEntityContext.Provider, {
        value: data
    }, children);
const $a71d927d8f07dfcc$export$ff2574b00bc1c100 = ()=>{
    const entity = (0, $5uXOq.useContext)($a71d927d8f07dfcc$var$BusinessEntityContext);
    return {
        data: entity
    };
};

});

parcelRegister("5YBrl", function(module, exports) {

$parcel$export(module.exports, "JqlProvider", () => $81e54c5b62a4ab4d$export$fdc879e2ba0da048);
$parcel$export(module.exports, "useJqlContext", () => $81e54c5b62a4ab4d$export$f32e2f688fc08561);

var $5uXOq = parcelRequire("5uXOq");
const $81e54c5b62a4ab4d$var$JqlContext = /*#__PURE__*/ (0, $5uXOq.createContext)('');
const $81e54c5b62a4ab4d$export$fdc879e2ba0da048 = ({ jqlContext: jqlContext, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($81e54c5b62a4ab4d$var$JqlContext.Provider, {
        value: jqlContext
    }, children);
const $81e54c5b62a4ab4d$export$f32e2f688fc08561 = ()=>(0, $5uXOq.useContext)($81e54c5b62a4ab4d$var$JqlContext);

});

parcelRegister("1Zr0i", function(module, exports) {

$parcel$export(module.exports, "RealtimeProvider", () => $6a65786548fb921c$export$64d242981d970821);
$parcel$export(module.exports, "useRealtimeContext", () => $6a65786548fb921c$export$f39c07717ad8c35b);

var $5uXOq = parcelRequire("5uXOq");
const $6a65786548fb921c$var$RealtimeContext = /*#__PURE__*/ (0, $5uXOq.createContext)([]);
const $6a65786548fb921c$export$64d242981d970821 = ({ ids: ids, children: children })=>{
    const projectsIds = (0, $5uXOq.useMemo)(()=>ids ? ids.map((pid)=>String(pid)) : [], [
        ids
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6a65786548fb921c$var$RealtimeContext.Provider, {
        value: projectsIds
    }, children);
};
const $6a65786548fb921c$export$f39c07717ad8c35b = ()=>(0, $5uXOq.useContext)($6a65786548fb921c$var$RealtimeContext);

});

parcelRegister("daQYX", function(module, exports) {

$parcel$export(module.exports, "ProjectHookProvider", () => $cf7f84dff81db95f$export$f1938a4916a14d9f);
$parcel$export(module.exports, "useProject", () => $cf7f84dff81db95f$export$51b1383ef8844a7);

var $5uXOq = parcelRequire("5uXOq");
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
const $cf7f84dff81db95f$var$Context = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $cf7f84dff81db95f$export$f1938a4916a14d9f = ({ project: project, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cf7f84dff81db95f$var$Context.Provider, {
        value: project
    }, children);
const $cf7f84dff81db95f$export$51b1383ef8844a7 = ()=>{
    const project = (0, $5uXOq.useContext)($cf7f84dff81db95f$var$Context);
    if (!project) throw new Error('useProject must be used within a ProjectHookProvider');
    return project;
};

});

parcelRegister("gxGcZ", function(module, exports) {

$parcel$export(module.exports, "FiltersProvider", () => $5ac2d1f4676106ae$export$905df3588d1d8c75);
$parcel$export(module.exports, "useAssigneesFilterQuery", () => $5ac2d1f4676106ae$export$f39bce8705b01ff5);
$parcel$export(module.exports, "useProjectFilter", () => $5ac2d1f4676106ae$export$b71768ffb8163578);
$parcel$export(module.exports, "useAllowedFieldTypes", () => $5ac2d1f4676106ae$export$9dc8a291956c2fa9);

var $5uXOq = parcelRequire("5uXOq");

var $5fc53 = parcelRequire("5fc53");

var $gzkAf = parcelRequire("gzkAf");
const $5ac2d1f4676106ae$var$DEFAULT_VALUE = {
    assigneeQuery: '',
    projectFilter: {
        totalCount: 0,
        options: []
    }
};
const $5ac2d1f4676106ae$var$FiltersContext = /*#__PURE__*/ (0, $5uXOq.createContext)($5ac2d1f4676106ae$var$DEFAULT_VALUE);
const $5ac2d1f4676106ae$export$905df3588d1d8c75 = ({ projects: projects, children: children })=>{
    const value = (0, $5uXOq.useMemo)(()=>{
        if (!projects) return $5ac2d1f4676106ae$var$DEFAULT_VALUE;
        const assigneeQuery = `is assignee of (${projects.map((project)=>project.key).join(', ')})`;
        const projectFilter = {
            totalCount: projects.length,
            options: projects.map((project)=>({
                    label: project.name,
                    value: String(project.id),
                    avatar: project.avatarUrl,
                    square: true
                }))
        };
        return {
            assigneeQuery: assigneeQuery,
            projectFilter: projectFilter
        };
    }, [
        projects
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5ac2d1f4676106ae$var$FiltersContext.Provider, {
        value: value
    }, children);
};
const $5ac2d1f4676106ae$export$f39bce8705b01ff5 = ()=>(0, $5uXOq.useContext)($5ac2d1f4676106ae$var$FiltersContext).assigneeQuery;
const $5ac2d1f4676106ae$export$b71768ffb8163578 = ()=>(0, $5uXOq.useContext)($5ac2d1f4676106ae$var$FiltersContext).projectFilter;
const $5ac2d1f4676106ae$export$9dc8a291956c2fa9 = (inputAllowedFieldTypes)=>{
    const filtersContext = (0, $5uXOq.useContext)($5ac2d1f4676106ae$var$FiltersContext);
    return (0, $5uXOq.useMemo)(()=>{
        const result = new Set(inputAllowedFieldTypes ?? (0, $gzkAf.BUSINESS_FIELD_TYPES));
        if (filtersContext.projectFilter.totalCount <= 1) result.delete((0, $5fc53.PROJECT_TYPE));
        return result;
    }, [
        filtersContext,
        inputAllowedFieldTypes
    ]);
};

});
parcelRegister("gzkAf", function(module, exports) {

$parcel$export(module.exports, "POPUP_WIDTH", () => $92b04c6ea9a59b67$export$b6d617db656efcca);
$parcel$export(module.exports, "SHOW_MORE_OPTIONS_BTN_SIZE", () => $92b04c6ea9a59b67$export$dd535f74d98d8b3);
$parcel$export(module.exports, "OPTIONS_AVAILABLE_WIDTH", () => $92b04c6ea9a59b67$export$dba112976ea61483);
$parcel$export(module.exports, "GAP_BETWEEN_OPTION", () => $92b04c6ea9a59b67$export$fe1082abeeda69ed);
$parcel$export(module.exports, "OPTION_SPAN_PADDING", () => $92b04c6ea9a59b67$export$17ed91292eb6c163);
$parcel$export(module.exports, "POPUP_OFFSET_TOP", () => $92b04c6ea9a59b67$export$15839778e99d81e7);
$parcel$export(module.exports, "OPTION_MAX_WIDTH", () => $92b04c6ea9a59b67$export$39aa3a14ebf850c7);
$parcel$export(module.exports, "DATE_RANGE_TYPE", () => $92b04c6ea9a59b67$export$1178808c606e043b);
$parcel$export(module.exports, "BUSINESS_FIELD_TYPES", () => $92b04c6ea9a59b67$export$c269ba5d631cb115);
$parcel$export(module.exports, "SOFTWARE_FIELD_TYPES", () => $92b04c6ea9a59b67$export$232814e45256d5dc);
$parcel$export(module.exports, "IMPLEMENTED_TYPES", () => $92b04c6ea9a59b67$export$9615a3d79408a88a);
$parcel$export(module.exports, "EXTRA_CUSTOM_FIELD_TYPES", () => $92b04c6ea9a59b67$export$a21166a4b76932b5);
$parcel$export(module.exports, "SAVED_FILTERS_PER_PAGE", () => $92b04c6ea9a59b67$export$1989c7236a398e8a);

var $gwIPs = parcelRequire("gwIPs");

var $5fc53 = parcelRequire("5fc53");
const $92b04c6ea9a59b67$export$b6d617db656efcca = 360;
const $92b04c6ea9a59b67$export$90bfd0dcc25478e1 = (0, $gwIPs.gridSize) * 2.5;
const $92b04c6ea9a59b67$export$dd535f74d98d8b3 = 32;
const $92b04c6ea9a59b67$export$dba112976ea61483 = $92b04c6ea9a59b67$export$b6d617db656efcca - $92b04c6ea9a59b67$export$90bfd0dcc25478e1 * 2;
const $92b04c6ea9a59b67$export$fe1082abeeda69ed = (0, $gwIPs.gridSize) / 2;
const $92b04c6ea9a59b67$export$17ed91292eb6c163 = (0, $gwIPs.gridSize) * 2;
const $92b04c6ea9a59b67$export$15839778e99d81e7 = 215;
const $92b04c6ea9a59b67$export$de3cbeaaf9d2669 = 28;
const $92b04c6ea9a59b67$export$39aa3a14ebf850c7 = 150;
const $92b04c6ea9a59b67$export$1178808c606e043b = 'dateRange';
const $92b04c6ea9a59b67$export$c269ba5d631cb115 = [
    (0, $5fc53.ASSIGNEE_TYPE),
    (0, $5fc53.CATEGORY_TYPE),
    (0, $5fc53.COMPONENTS_TYPE),
    (0, $5fc53.CREATED),
    $92b04c6ea9a59b67$export$1178808c606e043b,
    (0, $5fc53.ISSUE_TYPE),
    (0, $5fc53.LABELS_TYPE),
    (0, $5fc53.PRIORITY_TYPE),
    (0, $5fc53.PROJECT_TYPE),
    (0, $5fc53.REPORTER_TYPE),
    (0, $5fc53.STATUS_TYPE),
    (0, $5fc53.UPDATED),
    (0, $5fc53.USER_CF_TYPE),
    (0, $5fc53.SELECT_CF_TYPE),
    (0, $5fc53.MULTI_SELECT_CF_TYPE),
    (0, $5fc53.MULTI_CHECKBOXES_CF_TYPE),
    (0, $5fc53.PEOPLE_CF_TYPE),
    (0, $5fc53.DATE_CF_TYPE),
    (0, $5fc53.GOALS_CF_TYPE),
    (0, $5fc53.TEAMS_PLATFORM_CF_TYPE),
    (0, $5fc53.PARENT_FIELD_TYPE)
];
const $92b04c6ea9a59b67$export$232814e45256d5dc = [
    (0, $5fc53.SPRINT_TYPE),
    (0, $5fc53.FIX_VERSIONS_TYPE)
];
const $92b04c6ea9a59b67$export$9615a3d79408a88a = new Set([
    ...$92b04c6ea9a59b67$export$c269ba5d631cb115,
    ...$92b04c6ea9a59b67$export$232814e45256d5dc
]);
const $92b04c6ea9a59b67$export$a21166a4b76932b5 = new Set([
    (0, $5fc53.USER_CF_TYPE),
    (0, $5fc53.SELECT_CF_TYPE),
    (0, $5fc53.MULTI_SELECT_CF_TYPE),
    (0, $5fc53.MULTI_CHECKBOXES_CF_TYPE),
    (0, $5fc53.PEOPLE_CF_TYPE),
    (0, $5fc53.DATE_CF_TYPE)
]);
const $92b04c6ea9a59b67$export$6a2e733db5135f27 = (0, $gwIPs.gridSize) * 3.5;
const $92b04c6ea9a59b67$export$1989c7236a398e8a = 50;
const $92b04c6ea9a59b67$export$91fc9d65fca142a3 = 'users';
const $92b04c6ea9a59b67$export$d74c70f8fb216c6b = 'recentlyUsedUsers';

});


// SCREENS
const $4d5e0871c06cee03$export$f636b5b56f1d624a = 'Screen';
const $4d5e0871c06cee03$export$9d2de6eebf7462b5 = 'Drawer';
const $4d5e0871c06cee03$export$1171103ea9083ffa = 'Modal';
const $4d5e0871c06cee03$export$cae2783c9279926 = 'InlineDialog';
const $4d5e0871c06cee03$export$d1123261ca8831d2 = 'Dropdown';
const $4d5e0871c06cee03$export$238d30785c4bca84 = 'Banner';
const $4d5e0871c06cee03$export$a1562d08625f5d7e = 'UI';
const $4d5e0871c06cee03$export$947dac6c72b26f81 = 'TRACK';
const $4d5e0871c06cee03$export$f1d537d508d2945a = 'SCREEN';
const $4d5e0871c06cee03$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("k7McJ", function(module, exports) {

$parcel$export(module.exports, "FETCH_PROJECT_EXPERIENCE", () => $47951bf9c4bef1f5$export$cb40bbf7ea51db63);
const $47951bf9c4bef1f5$export$cb40bbf7ea51db63 = {
    experience: 'fetch-project',
    packageName: 'jiraBusinessEntityProjectProvider',
    teamName: 'wanjel'
};

});

parcelRegister("8OqLl", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5cc2e237e9a9763$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

const $a5cc2e237e9a9763$var$NotFoundComponent = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("dDX2b")), {
    moduleId: "./src/packages/business/entity/project-provider/src/ui/project-context/not-found/main.tsx"
});
const $a5cc2e237e9a9763$var$NotFoundAsync = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "not-found-component",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a5cc2e237e9a9763$var$NotFoundComponent, null));
var $a5cc2e237e9a9763$export$2e2bcd8739ae039 = $a5cc2e237e9a9763$var$NotFoundAsync;

});
parcelRegister("dDX2b", function(module, exports) {

let $9eecb5dea26f1017$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9eecb5dea26f1017$var$load("gUneV").then(()=>parcelRequire('4zX1V'));

});



parcelRegister("x8FYU", function(module, exports) {

$parcel$export(module.exports, "CREATE_TYPE_ID_PREFERENCE", () => $3a8fd327ed3934d4$export$2df4c3d44dcb1e5b);
$parcel$export(module.exports, "EXPANDED_ISSUES_PREFERENCE", () => $3a8fd327ed3934d4$export$638c3932e4cbdede);
$parcel$export(module.exports, "FIELDS_PREFERENCE", () => $3a8fd327ed3934d4$export$e3ddfc509464e305);
$parcel$export(module.exports, "FIELDS_DETAIL_PREFERENCE", () => $3a8fd327ed3934d4$export$ffcb5603c64e12d0);
$parcel$export(module.exports, "FILTER_PREFERENCE", () => $3a8fd327ed3934d4$export$f50d5db589fb1475);
$parcel$export(module.exports, "GROUPING_PREFERENCE", () => $3a8fd327ed3934d4$export$ac8a4771da7f03af);
$parcel$export(module.exports, "HIDE_DONE_ITEMS_PREFERENCE", () => $3a8fd327ed3934d4$export$4aace169721c2927);
$parcel$export(module.exports, "HIDE_SOFTWARE_RELEASE_PREFERENCE", () => $3a8fd327ed3934d4$export$983f0d3325e2938);
$parcel$export(module.exports, "RANGE_MODE_PREFERENCE", () => $3a8fd327ed3934d4$export$f43988a3762bf711);
$parcel$export(module.exports, "SORTING_PREFERENCE", () => $3a8fd327ed3934d4$export$373eea1341dcff74);
$parcel$export(module.exports, "BOARD_VIEW_PREFERENCES", () => $3a8fd327ed3934d4$export$4ec60be96e9eadc0);
$parcel$export(module.exports, "LIST_VIEW_PREFERENCES", () => $3a8fd327ed3934d4$export$43fc1ec27b2f1801);
$parcel$export(module.exports, "CALENDAR_VIEW_PREFERENCES", () => $3a8fd327ed3934d4$export$14e2a519a8c2881a);
$parcel$export(module.exports, "TIMELINE_VIEW_PREFERENCES", () => $3a8fd327ed3934d4$export$8443f3f4fd94276);
$parcel$export(module.exports, "ATTACHMENTS_VIEW_PREFERENCES", () => $3a8fd327ed3934d4$export$2e2923d9c9daba20);

var $hE5wF = parcelRequire("hE5wF");

var $54zCO = parcelRequire("54zCO");
const $3a8fd327ed3934d4$export$5d3f940b56d7af28 = (0, $54zCO.createSimplePreference)('activeWorkflow');
const $3a8fd327ed3934d4$export$8019dfa5a44f6d46 = (0, $54zCO.createSimplePreference)('collapsedColumns');
const $3a8fd327ed3934d4$export$3ef984a9f784490f = (0, $54zCO.createSimplePreference)('columnOrder');
const $3a8fd327ed3934d4$export$2df4c3d44dcb1e5b = (0, $54zCO.createSimplePreference)('createType');
const $3a8fd327ed3934d4$export$638c3932e4cbdede = (0, $54zCO.createSimplePreference)('expandedIssues');
const $3a8fd327ed3934d4$export$e3ddfc509464e305 = (0, $54zCO.createSimplePreference)('fields');
const $3a8fd327ed3934d4$export$ffcb5603c64e12d0 = (0, $54zCO.createSimplePreference)('fieldsDetail');
const $3a8fd327ed3934d4$export$f50d5db589fb1475 = (0, $54zCO.createSimpleUrlPreference)((0, $hE5wF.FILTER_PARAM));
const $3a8fd327ed3934d4$export$ac8a4771da7f03af = (0, $54zCO.createSimpleUrlPreference)('groupBy');
const $3a8fd327ed3934d4$export$4aace169721c2927 = (0, $54zCO.createSimpleUrlPreference)('hideDone');
const $3a8fd327ed3934d4$export$983f0d3325e2938 = (0, $54zCO.createSimpleUrlPreference)('hideSoftwareRelease');
const $3a8fd327ed3934d4$export$f43988a3762bf711 = (0, $54zCO.createSimpleUrlPreference)('rangeMode');
const $3a8fd327ed3934d4$export$373eea1341dcff74 = {
    ...(0, $54zCO.createSimplePreference)('sorting'),
    queryParameter: {
        serialize: (value)=>({
                sortBy: value?.sortBy,
                direction: value?.direction
            }),
        deserialize: (value)=>value.sortBy ? {
                sortBy: value.sortBy,
                direction: value.direction
            } : undefined
    }
};
const $3a8fd327ed3934d4$export$4ec60be96e9eadc0 = [
    $3a8fd327ed3934d4$export$2df4c3d44dcb1e5b,
    $3a8fd327ed3934d4$export$638c3932e4cbdede
];
const $3a8fd327ed3934d4$export$43fc1ec27b2f1801 = [
    $3a8fd327ed3934d4$export$2df4c3d44dcb1e5b,
    $3a8fd327ed3934d4$export$e3ddfc509464e305,
    $3a8fd327ed3934d4$export$ffcb5603c64e12d0,
    $3a8fd327ed3934d4$export$f50d5db589fb1475,
    $3a8fd327ed3934d4$export$ac8a4771da7f03af,
    $3a8fd327ed3934d4$export$4aace169721c2927,
    $3a8fd327ed3934d4$export$373eea1341dcff74
];
const $3a8fd327ed3934d4$export$14e2a519a8c2881a = [
    $3a8fd327ed3934d4$export$2df4c3d44dcb1e5b,
    $3a8fd327ed3934d4$export$f50d5db589fb1475,
    $3a8fd327ed3934d4$export$4aace169721c2927,
    $3a8fd327ed3934d4$export$983f0d3325e2938
];
const $3a8fd327ed3934d4$export$8443f3f4fd94276 = [
    $3a8fd327ed3934d4$export$2df4c3d44dcb1e5b,
    $3a8fd327ed3934d4$export$f50d5db589fb1475,
    $3a8fd327ed3934d4$export$4aace169721c2927,
    $3a8fd327ed3934d4$export$f43988a3762bf711
];
const $3a8fd327ed3934d4$export$2e2923d9c9daba20 = [
    $3a8fd327ed3934d4$export$f50d5db589fb1475
];

});
parcelRegister("hE5wF", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_RANK_SORTING_DIRECTION", () => $bfd6cbe4770149b5$export$8386e51ba415e85d);
$parcel$export(module.exports, "DEFAULT_AVATAR_RES", () => $bfd6cbe4770149b5$export$159fe44438c210e9);
$parcel$export(module.exports, "FILTER_PARAM", () => $bfd6cbe4770149b5$export$d8301e0b33832d94);
$parcel$export(module.exports, "INLINE_CREATE_PARAM", () => $bfd6cbe4770149b5$export$599c163c1570a353);
$parcel$export(module.exports, "INVITE_OPEN_PARAM", () => $bfd6cbe4770149b5$export$3a74d1a195d2f007);
$parcel$export(module.exports, "SELECTED_ISSUE_PARAM", () => $bfd6cbe4770149b5$export$c070acdc9b0f1be5);
$parcel$export(module.exports, "SELECTED_COMMENT_PARAM", () => $bfd6cbe4770149b5$export$3bcbd99d0f9ad6d8);
$parcel$export(module.exports, "GROUP_BY_ASSIGNEE", () => $bfd6cbe4770149b5$export$dba794af6c0f2afc);
$parcel$export(module.exports, "GROUP_BY_PRIORITY", () => $bfd6cbe4770149b5$export$56ecb5d2dfb80edc);
$parcel$export(module.exports, "GROUP_BY_CATEGORY", () => $bfd6cbe4770149b5$export$22ef551f315f2786);
$parcel$export(module.exports, "GROUP_BY_STATUS", () => $bfd6cbe4770149b5$export$6d69efb296b78a);
$parcel$export(module.exports, "START_DATE_ALIAS_FIELD_ID", () => $bfd6cbe4770149b5$export$e23e1d1ea45171c2);
$parcel$export(module.exports, "RANK_ALIAS_FIELD_ID", () => $bfd6cbe4770149b5$export$e35c6e217c75dc4b);
$parcel$export(module.exports, "REMOTE_ISSUE_LINKS_TYPE", () => $bfd6cbe4770149b5$export$e5eab344feb92af9);
$parcel$export(module.exports, "COMMENT_SUMMARY_TYPE", () => $bfd6cbe4770149b5$export$a311e1b78816c048);
$parcel$export(module.exports, "CARD_COVERS_TYPE", () => $bfd6cbe4770149b5$export$f5583ff4ab4d63e5);
$parcel$export(module.exports, "DEFAULT_PAGE_SIZE", () => $bfd6cbe4770149b5$export$5716e8bcb003888d);
$parcel$export(module.exports, "STORY_POINTS_ALIAS_FIELD_ID", () => $bfd6cbe4770149b5$export$1f9fb9f15184100f);
$parcel$export(module.exports, "STORY_POINT_ESTIMATE_ALIAS_FIELD_ID", () => $bfd6cbe4770149b5$export$c72ea455b368cdd9);
$parcel$export(module.exports, "UNASSIGNED_USER_ID", () => $bfd6cbe4770149b5$export$12e572fd459c10dc);

const $bfd6cbe4770149b5$export$8386e51ba415e85d = (0, $2a9e000a443b1a95$export$1dee026a19752d6b);
const $bfd6cbe4770149b5$export$159fe44438c210e9 = '48x48';
const $bfd6cbe4770149b5$export$d8301e0b33832d94 = 'filter';
const $bfd6cbe4770149b5$export$599c163c1570a353 = 'inlineCreate';
const $bfd6cbe4770149b5$export$3a74d1a195d2f007 = 'inviteOpen';
const $bfd6cbe4770149b5$export$e1e3f9fa6f04d6d = 'quickFilters';
const $bfd6cbe4770149b5$export$c070acdc9b0f1be5 = 'selectedIssue';
const $bfd6cbe4770149b5$export$3bcbd99d0f9ad6d8 = 'selectedComment';
const $bfd6cbe4770149b5$export$dba794af6c0f2afc = 'assignee';
const $bfd6cbe4770149b5$export$56ecb5d2dfb80edc = 'priority';
const $bfd6cbe4770149b5$export$22ef551f315f2786 = 'category';
const $bfd6cbe4770149b5$export$6d69efb296b78a = 'status';
const $bfd6cbe4770149b5$export$e23e1d1ea45171c2 = 'startdate';
const $bfd6cbe4770149b5$export$e35c6e217c75dc4b = 'rank';
const $bfd6cbe4770149b5$export$e5eab344feb92af9 = 'remoteIssueLinks';
const $bfd6cbe4770149b5$export$a311e1b78816c048 = 'commentsummary';
const $bfd6cbe4770149b5$export$f5583ff4ab4d63e5 = 'cardCovers';
const $bfd6cbe4770149b5$export$5716e8bcb003888d = 25;
const $bfd6cbe4770149b5$export$1f9fb9f15184100f = 'storypoints';
const $bfd6cbe4770149b5$export$c72ea455b368cdd9 = 'storypointestimate';
const $bfd6cbe4770149b5$export$786b42b4618e6ee4 = 'sprint';
const $bfd6cbe4770149b5$export$12e572fd459c10dc = 'unassigned';

});
const $2a9e000a443b1a95$export$1dee026a19752d6b = 'ASC';
const $2a9e000a443b1a95$export$b6abcf7fa1d94f65 = 'DESC';


parcelRegister("54zCO", function(module, exports) {

$parcel$export(module.exports, "createSimplePreference", () => $7a26b5020c269cbd$export$464a71be397e5f3d);
$parcel$export(module.exports, "createSimpleUrlPreference", () => $7a26b5020c269cbd$export$78f3983105936d30);

var $etyzk = parcelRequire("etyzk");
const $7a26b5020c269cbd$export$464a71be397e5f3d = (id)=>({
        id: id,
        serialize: (0, (/*@__PURE__*/$parcel$interopDefault($etyzk))),
        deserialize: (0, (/*@__PURE__*/$parcel$interopDefault($etyzk)))
    });
const $7a26b5020c269cbd$export$78f3983105936d30 = (queryParameter)=>({
        id: queryParameter,
        serialize: (0, (/*@__PURE__*/$parcel$interopDefault($etyzk))),
        deserialize: (0, (/*@__PURE__*/$parcel$interopDefault($etyzk))),
        queryParameter: {
            serialize: (value)=>({
                    [queryParameter]: value
                }),
            deserialize: (value)=>value[queryParameter]
        }
    });

});


parcelRegister("1kpI8", function(module, exports) {

$parcel$export(module.exports, "ViewPreferencesProvider", () => $5141bcd6fd206946$export$1db44e21d818b27);
$parcel$export(module.exports, "useViewPreference", () => $5141bcd6fd206946$export$ee494de6c0ff45d7);

var $5uXOq = parcelRequire("5uXOq");

var $ajpes = parcelRequire("ajpes");

var $54qG5 = parcelRequire("54qG5");

var $1XJ20 = parcelRequire("1XJ20");

var $doZTA = parcelRequire("doZTA");

var $kGDhO = parcelRequire("kGDhO");
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
const $5141bcd6fd206946$var$ViewPreferencesContext = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $5141bcd6fd206946$export$1db44e21d818b27 = ({ view: view, preferences: preferences, children: children, persistChanges: persistChanges = true })=>{
    const { data: entity } = (0, $54qG5.useBusinessEntity)();
    const [{ query: query }, routerActions] = (0, $doZTA.useRouter)();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const { updateQueryParam: updateQueryParam } = routerActions;
    const prevQuery = (0, $1XJ20.usePreviousWithInitial)(query);
    const [store, setStore] = (0, $5uXOq.useState)(()=>preferences.reduce((acc, preference)=>{
            let value;
            const { id: id, queryParameter: queryParameter } = preference;
            // a preference value of an empty string, indicates that any value in local storage should be ignored and cleared
            const rawQueryValue = queryParameter && queryParameter.deserialize(query);
            const hasQueryValue = rawQueryValue !== undefined;
            // if the URL has a preference value set
            // we prioritize those values over the persisted ones
            if (hasQueryValue) // if the value matches the clearable value, we treat the value as `undefined`
            value = rawQueryValue === '' ? undefined : rawQueryValue;
            else if (persistChanges) value = preference.deserialize((0, $kGDhO.getPreference)(entity.id, view, preference.id));
            acc[id] = value;
            return acc;
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        }, {}));
    const setPreferenceValue = (0, $5uXOq.useCallback)((preference, value, action)=>{
        // set the new preference value in the store
        setStore((prevStore)=>{
            const newStore = {
                ...prevStore,
                [preference.id]: value
            };
            return newStore;
        });
        // if the preference serialises to the URL, update the URL
        if (preference.queryParameter && action !== 'none') updateQueryParam(preference.queryParameter.serialize(value), action);
        // if the view is persisting changes, update the preference in local storage
        if (persistChanges) {
            const serializedValue = preference.serialize(value);
            (0, $kGDhO.setPreference)(entity.id, view, preference.id, serializedValue);
        }
    }, [
        persistChanges,
        updateQueryParam,
        entity.id,
        view
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // if the view is persisting changes, on initial mount
        // check all preferences that serialise to the URL, and set their values to the URL
        if (!persistChanges) return;
        let restoredQuery = {};
        for (const preference of preferences){
            const value = store[preference.id];
            if (value && preference.queryParameter) restoredQuery = {
                ...restoredQuery,
                ...preference.queryParameter.serialize(value)
            };
        }
        updateQueryParam({
            ...restoredQuery,
            ...query
        }, 'replace');
    // only run this effect on mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $5uXOq.useEffect)(()=>{
        // this effect updates the store value only when the query has changed
        // we shouldn't run it when the component is mounting the first time
        // or when the query hasn't changed
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(prevQuery, query)) {
            // update the store if the query is updated
            const newState = preferences.reduce((acc, preference)=>{
                const { id: id, queryParameter: queryParameter } = preference;
                if (queryParameter) {
                    const queryValue = queryParameter.deserialize(query);
                    acc[id] = queryValue;
                }
                return acc;
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            }, {});
            setStore({
                ...store,
                ...newState
            });
        }
    }, [
        preferences,
        query,
        store,
        entity.id,
        view,
        prevQuery
    ]);
    const contextValue = (0, $5uXOq.useMemo)(()=>({
            store: store,
            setPreferenceValue: setPreferenceValue
        }), [
        store,
        setPreferenceValue
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5141bcd6fd206946$var$ViewPreferencesContext.Provider, {
        value: contextValue
    }, children);
};
const $5141bcd6fd206946$export$ee494de6c0ff45d7 = (preference)=>{
    const { store: store, setPreferenceValue: setPreferenceValue } = (0, $5uXOq.useContext)($5141bcd6fd206946$var$ViewPreferencesContext);
    const setValue = (0, $5uXOq.useCallback)((value, action = 'push')=>{
        setPreferenceValue(preference, value, action);
    }, [
        preference,
        setPreferenceValue
    ]);
    const value = store[preference.id];
    return [
        value,
        setValue
    ];
};

});
parcelRegister("kGDhO", function(module, exports) {

$parcel$export(module.exports, "setPreference", () => $39001b1dd806b76a$export$c6483f3cdc3e51e1);
$parcel$export(module.exports, "getPreference", () => $39001b1dd806b76a$export$5fa261395d19a143);

var $bSSG7 = parcelRequire("bSSG7");
const $39001b1dd806b76a$var$store = (0, $bSSG7.createLocalStorageProvider)('jwm-view-preferences');
const $39001b1dd806b76a$var$buildPreferenceKey = (entityId, viewId, preferenceId)=>`${entityId}_${viewId}_${preferenceId}`;
const $39001b1dd806b76a$export$c6483f3cdc3e51e1 = (entityId, viewId, preferenceId, value)=>{
    const key = $39001b1dd806b76a$var$buildPreferenceKey(entityId, viewId, preferenceId);
    $39001b1dd806b76a$var$store.set(key, value);
};
const $39001b1dd806b76a$export$5fa261395d19a143 = (entityId, viewId, preferenceId)=>{
    const key = $39001b1dd806b76a$var$buildPreferenceKey(entityId, viewId, preferenceId);
    return $39001b1dd806b76a$var$store.get(key);
};

});


parcelRegister("9dbF6", function(module, exports) {

$parcel$export(module.exports, "SubProductUpdater", () => $5979c081afa32bfa$export$eb40d3df56aa5c53);

var $5uXOq = parcelRequire("5uXOq");

var $5h5Fg = parcelRequire("5h5Fg");

var $16v4H = parcelRequire("16v4H");

var $3iTiR = parcelRequire("3iTiR");

var $54I24 = parcelRequire("54I24");

var $8OHH4 = parcelRequire("8OHH4");
const $5979c081afa32bfa$export$eb40d3df56aa5c53 = ({ allowMonolithDeferral: allowMonolithDeferral = false, ...props })=>{
    const subProduct = (0, $8OHH4.isSubProductProps)(props) ? props.subProduct : (0, $16v4H.subProductFromProjectTypeForAnalytics)(props.projectType);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5h5Fg.default), {
        op: (0, $54I24.default),
        args: [
            subProduct,
            allowMonolithDeferral
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3iTiR.default), {
        subProduct: subProduct
    }));
};

});
parcelRegister("3iTiR", function(module, exports) {

$parcel$export(module.exports, "default", () => $1214b0731559b377$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $01Rn4 = parcelRequire("01Rn4");

var $hFChZ = parcelRequire("hFChZ");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1214b0731559b377$export$2e2bcd8739ae039 = ({ subProduct: subProduct })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $01Rn4.default), {
        op: (0, $hFChZ.default),
        args: [
            subProduct
        ]
    });

});
parcelRegister("hFChZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e606430ead76cd8$export$2e2bcd8739ae039);

var $2YZCu = parcelRequire("2YZCu");

var $eusud = parcelRequire("eusud");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0e606430ead76cd8$export$2e2bcd8739ae039 = (subProduct)=>{
    (0, $eusud.performGetRequest)(`/rest/internal/2/mauTag/${subProduct}`).catch((err)=>{
        (0, $2YZCu.default).safeErrorWithoutCustomerData('common.tag-mau.tag-mau-event', 'Error connecting to monolith mau tag endpoint', err);
    });
};

});


parcelRegister("54I24", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcbbcd48ca398ed4$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $7T84i = parcelRequire("7T84i");
var $9B86Q = parcelRequire("9B86Q");
var $cQZXC = parcelRequire("cQZXC");


var $2YZCu = parcelRequire("2YZCu");

var $fjcgS = parcelRequire("fjcgS");
const $bcbbcd48ca398ed4$var$maybeDelayAndRace = (// @ts-expect-error - TS2304 - Cannot find name 'Deferred'.
maybeWaitPromise, getDefaultPromise, getRacePromise)=>maybeWaitPromise ? Promise.race([
        maybeWaitPromise.then(getDefaultPromise),
        getRacePromise()
    ]) : getDefaultPromise();
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$bcbbcd48ca398ed4$export$2e2bcd8739ae039 = async (subProduct, allowMonolithDeferral)=>{
    (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>{
        client.setSubProduct(subProduct);
        if (subProduct === 'serviceDesk') client.setUIViewedAttributes({
            solutions: [
                (0, $86344d58e71e925a$export$c8b406ad8ee0dab9)
            ]
        });
        else client.removeUIViewedAttribute('solutions');
    });
    // IMPORTANT -
    // Until such time as all pre-TTI WRM loads are removed we find that waitForHeritage() then
    // loadBridgeStrict() is too slow, resulting in `subproduct:unknown` for analytics events.
    // In that same case however, profiling shows us that polling in loadBridgeWeak() somehow
    // resolves the same AMD code faster.
    // This is not well understood, but it does allow us to work around the issue by racing these
    // two techniques.
    // Once there is no pre-TTI WRM loads we the waitForHeritage() then loadBridgeStrict() does seem
    // to be faster such that we can remove the `Promise.race()`.
    /* eslint-disable jira/wrm/no-load-bridge */ $bcbbcd48ca398ed4$var$maybeDelayAndRace(allowMonolithDeferral ? (0, $cQZXC.waitForHeritage)() : null, ()=>(0, $7T84i.loadBridgeStrict)({
            name: 'jira/analytics/sub-product-resolver',
            wrmKeys: [
                'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client'
            ]
        }), ()=>(0, $9B86Q.loadBridgeWeak)({
            name: 'jira/analytics/sub-product-resolver'
        })).then((subProductResolver)=>{
        subProductResolver.setSubProduct(subProduct);
    }).catch((e)=>(0, $2YZCu.default).safeErrorWithoutCustomerData('common.analytics-sub-product.sub-product-updater', 'Error connecting to monolith sub product resolver', e));
/* eslint-enable jira/wrm/no-load-bridge */ };

});
const $86344d58e71e925a$export$c8b406ad8ee0dab9 = 'jiraServiceManagement';


parcelRegister("8OHH4", function(module, exports) {

$parcel$export(module.exports, "isSubProductProps", () => $701d07b56c3e3574$export$c3063d6d7a8c075f);
const $701d07b56c3e3574$export$c3063d6d7a8c075f = (props)=>'subProduct' in props && typeof props.subProduct === 'string';

});


parcelRegister("eDEaT", function(module, exports) {

$parcel$export(module.exports, "default", () => $251cd340bf04f815$export$2e2bcd8739ae039);

var $dmlYL = parcelRequire("dmlYL");

var $9CxGa = parcelRequire("9CxGa");

var $buLPj = parcelRequire("buLPj");

var $haIsI = parcelRequire("haIsI");

var $hm3WY = parcelRequire("hm3WY");

var $amIgA = parcelRequire("amIgA");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $aXhsp = parcelRequire("aXhsp");

var $AeWM3 = parcelRequire("AeWM3");

var $eiOkd = parcelRequire("eiOkd");

var $54aDJ = parcelRequire("54aDJ");

var $imVeH = parcelRequire("imVeH");

var $e21nk = parcelRequire("e21nk");

var $adJfs = parcelRequire("adJfs");

var $cm8b5 = parcelRequire("cm8b5");

var $1TU9r = parcelRequire("1TU9r");

var $33Toe = parcelRequire("33Toe");

var $8xg9P = parcelRequire("8xg9P");

var $l9KLJ = parcelRequire("l9KLJ");

var $95qxs = parcelRequire("95qxs");

var $koVbs = parcelRequire("koVbs");

var $iXVV6 = parcelRequire("iXVV6");

var $iZgee = parcelRequire("iZgee");

var $cvj5l = parcelRequire("cvj5l");

var $fPzrH = parcelRequire("fPzrH");

var $gEtYC = parcelRequire("gEtYC");

var $jTnjM = parcelRequire("jTnjM");

var $kiyQL = parcelRequire("kiyQL");

var $eDKuf = parcelRequire("eDKuf");

var $dI6Zj = parcelRequire("dI6Zj");

var $2PV8T = parcelRequire("2PV8T");

var $4kGgG = parcelRequire("4kGgG");

var $jgcJl = parcelRequire("jgcJl");

var $5gFbH = parcelRequire("5gFbH");

var $hwtkc = parcelRequire("hwtkc");

var $enS24 = parcelRequire("enS24");

var $3ZzsP = parcelRequire("3ZzsP");

var $d9Nxy = parcelRequire("d9Nxy");

var $iYmhw = parcelRequire("iYmhw");

var $4lW8s = parcelRequire("4lW8s");

var $7OM52 = parcelRequire("7OM52");
const $251cd340bf04f815$var$analyticsSourceName = 'board';
const $251cd340bf04f815$var$BoardWithWorkflowsData = ({ queryFragment: queryFragment, projectFragment: projectFragment, viewFragment: viewFragment, refresh: refresh })=>{
    const { workflows: workflows } = (0, $jgcJl.useWorkflowStoreState)();
    const workflowsProviderWorkflows = (0, $5uXOq.useMemo)(()=>workflows.map((0, $d9Nxy.transformWorkflow)), [
        workflows
    ]);
    (0, $95qxs.useMergeWorkflowsOnboarding)({
        isEligible: workflows.length > 1
    });
    const data = (0, $8Uumt.useFragment)((0, $amIgA.default), queryFragment);
    const project = (0, $8Uumt.useFragment)((0, $hm3WY.default), projectFragment);
    const view = (0, $8Uumt.useFragment)((0, $haIsI.default), viewFragment);
    const categoryFieldId = data.jira_categoryField?.fieldId ?? null;
    const services = (0, $hwtkc.useCreateIssue)({
        categoryFieldId: categoryFieldId
    });
    const analyticsAttributes = (0, $5uXOq.useMemo)(()=>({
            groupBy: view.groupByConfig.fieldId,
            viewId: view.id
        }), [
        view.groupByConfig.fieldId,
        view.id
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l9KLJ.WorkflowsProvider), {
        workflows: workflowsProviderWorkflows
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $33Toe.IssueCreateProvider), {
        onCreateIssue: services.createIssue,
        onRefetchIssue: services.refetchIssue,
        ignoreFiltersContext: true,
        queryFragment: data
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iZgee.IssueLinkingProvider), {
        queryFragment: data
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        objectType: "jwmBoard",
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
        sourceName: $251cd340bf04f815$var$analyticsSourceName,
        attributes: analyticsAttributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1TU9r.DeserialisedFiltersProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8xg9P.WorkflowActionsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gEtYC.IssueStoreContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dI6Zj.ColumnDragDropProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kiyQL.CardDragDropProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7OM52.BoardFieldIdsProvider), {
        queryFragment: data,
        viewFragment: view
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fPzrH.BoardDataProvider), {
        projectFragment: project,
        viewFragment: view
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4kGgG.IssuesByGroupProvider), {
        viewFragment: view
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2PV8T.IssueTransitionsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jTnjM.ConfettiColumnsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3ZzsP.default), {
        projectFragment: project,
        viewFragment: view
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $enS24.default), {
        queryFragment: data,
        projectFragment: project,
        viewFragment: view,
        refresh: refresh
    })))))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iYmhw.BusinessBoardScreenAnalytics), {
        viewFragment: view
    }))))));
};
const $251cd340bf04f815$var$BusinessBoardRoot = ({ queryFragment: queryFragment, projectFragment: projectFragment, viewFragment: viewFragment, refresh: refresh })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const pageHeading = formatMessage((0, $5gFbH.default).boardHeading);
    const hasConfluence = (0, $imVeH.useTenantHasConfluence)();
    const data = (0, $8Uumt.useFragment)((0, $buLPj.default), queryFragment);
    const project = (0, $8Uumt.useFragment)((0, $9CxGa.default), projectFragment);
    const view = (0, $8Uumt.useFragment)((0, $dmlYL.default), viewFragment);
    const innerContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $AeWM3.ApolloClientProvider), {
        client: (0, $aXhsp.default)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $adJfs.IssueTypesAndFieldsContext), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgcJl.WorkflowStoreContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($251cd340bf04f815$var$BoardWithWorkflowsData, {
        queryFragment: data,
        projectFragment: project,
        viewFragment: view,
        refresh: refresh
    }))));
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4lW8s.BusinessBoardQueryParamSync), {
        viewFragment: view
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e21nk.BusinessDocumentTitle), {
        pageHeading: pageHeading
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eiOkd.default), {
        withSidebar: true,
        withOverflow: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eDKuf.BoardFiltersProvider), {
        viewFragment: view
    }, innerContent)));
    if (hasConfluence) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $54aDJ.ConfluenceModalProvider), null, content);
    return content;
};
const $251cd340bf04f815$var$BusinessBoard = ({ queryFragment: queryFragment, projectFragment: projectFragment, viewFragment: viewFragment, refresh: refresh })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cm8b5.ExperienceErrorBoundary), {
        experience: (0, $cvj5l.VIEW_EXPERIENCE),
        shouldStartExperience: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($251cd340bf04f815$var$BusinessBoardRoot, {
        queryFragment: queryFragment,
        projectFragment: projectFragment,
        viewFragment: viewFragment,
        refresh: refresh
    }));
var $251cd340bf04f815$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($251cd340bf04f815$var$BusinessBoard);

});
parcelRegister("dmlYL", function(module, exports) {

$parcel$export(module.exports, "default", () => $cafa6d82a95890ba$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d1472225cc14f3a0bb72c3e367f20074>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $cafa6d82a95890ba$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "BusinessBoard_view",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "BusinessBoardQueryParamSync_view"
        },
        {
            "kind": "FragmentSpread",
            "name": "BoardFiltersProvider"
        },
        {
            "kind": "FragmentSpread",
            "name": "BusinessBoard_withWorkflow_view"
        }
    ],
    "type": "JiraBoardView"
};
$cafa6d82a95890ba$var$node.hash = "9fc14a4f5d5cf526fdec2256e1d9fff3";
var $cafa6d82a95890ba$export$2e2bcd8739ae039 = $cafa6d82a95890ba$var$node;

});

parcelRegister("9CxGa", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2049239b6f312af$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e4f4507bf4bd7130602c95e78541a834>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $c2049239b6f312af$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "BusinessBoard_project",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "BusinessBoard_withWorkflow_project"
        }
    ],
    "type": "JiraProject"
};
$c2049239b6f312af$var$node.hash = "9f07241b1148b1c97d5f1d47d5f492bd";
var $c2049239b6f312af$export$2e2bcd8739ae039 = $c2049239b6f312af$var$node;

});

parcelRegister("buLPj", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c2eb91af97f9bf7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<42f152ebc3a1cd3a7330fdd9a45b3d82>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $1c2eb91af97f9bf7$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "BusinessBoard_query",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "BusinessBoard_withWorkflow_query"
        }
    ],
    "type": "Query"
};
$1c2eb91af97f9bf7$var$node.hash = "f99ec3c2d35a75668d7e0bbd92a6cde2";
var $1c2eb91af97f9bf7$export$2e2bcd8739ae039 = $1c2eb91af97f9bf7$var$node;

});

parcelRegister("haIsI", function(module, exports) {

$parcel$export(module.exports, "default", () => $6efca26bb990920c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<aca0b4cc6d9f902bb7b7aa85bea8298c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6efca26bb990920c$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "BusinessBoard_withWorkflow_view",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "BoardDataProvider_view"
        },
        {
            "kind": "FragmentSpread",
            "name": "BoardHeader_view"
        },
        {
            "kind": "FragmentSpread",
            "name": "BoardContent_view"
        },
        {
            "kind": "FragmentSpread",
            "name": "BusinessBoardScreenAnalytics_view"
        },
        {
            "kind": "FragmentSpread",
            "name": "IssuesByGroupProvider_view"
        },
        {
            "kind": "FragmentSpread",
            "name": "BoardFieldIdsProvider_view"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "id"
            },
            "action": "THROW",
            "path": "id"
        },
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "JiraViewGroupByConfig",
                "kind": "LinkedField",
                "name": "groupByConfig",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "fieldId"
                        },
                        "action": "THROW",
                        "path": "groupByConfig.fieldId"
                    }
                ]
            },
            "action": "THROW",
            "path": "groupByConfig"
        }
    ],
    "type": "JiraBoardView"
};
$6efca26bb990920c$var$node.hash = "f0db343c248ca8e355aa5ffb7ab19088";
var $6efca26bb990920c$export$2e2bcd8739ae039 = $6efca26bb990920c$var$node;

});

parcelRegister("hm3WY", function(module, exports) {

$parcel$export(module.exports, "default", () => $143942b667db5b77$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3568e71aa42b73958c8093f2dee8085f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $143942b667db5b77$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "BusinessBoard_withWorkflow_project",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "BoardDataProvider_project"
        },
        {
            "kind": "FragmentSpread",
            "name": "BoardHeader_project"
        },
        {
            "kind": "FragmentSpread",
            "name": "BoardContent_project"
        }
    ],
    "type": "JiraProject"
};
$143942b667db5b77$var$node.hash = "c335dc029ba1d5e31c84e85c466b42a6";
var $143942b667db5b77$export$2e2bcd8739ae039 = $143942b667db5b77$var$node;

});

parcelRegister("amIgA", function(module, exports) {

$parcel$export(module.exports, "default", () => $b38bd863a53fc1e0$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<78b902e52e7892e83212c6ebd1f26349>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b38bd863a53fc1e0$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "cloudId"
        }
    ],
    "kind": "Fragment",
    "name": "BusinessBoard_withWorkflow_query",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "BoardFieldIdsProvider_query"
        },
        {
            "kind": "FragmentSpread",
            "name": "BoardContent_query"
        },
        {
            "kind": "FragmentSpread",
            "name": "IssueCreateProvider"
        },
        {
            "kind": "FragmentSpread",
            "name": "IssueLinkingProvider"
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                }
            ],
            "concreteType": "JiraJqlField",
            "kind": "LinkedField",
            "name": "jira_categoryField",
            "plural": false,
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "kind": "ScalarField",
                        "name": "fieldId"
                    },
                    "action": "THROW",
                    "path": "jira_categoryField.fieldId"
                }
            ]
        }
    ],
    "type": "Query"
};
$b38bd863a53fc1e0$var$node.hash = "e825ca904173c6cf6cf4a8f4ec23933f";
var $b38bd863a53fc1e0$export$2e2bcd8739ae039 = $b38bd863a53fc1e0$var$node;

});

parcelRegister("aXhsp", function(module, exports) {

$parcel$export(module.exports, "default", () => $d88f4e626c9babc0$export$2e2bcd8739ae039);

var $9XE6b = parcelRequire("9XE6b");

var $ivfDv = parcelRequire("ivfDv");

var $e3a3O = parcelRequire("e3a3O");

var $clSzL = parcelRequire("clSzL");

var $h4ppL = parcelRequire("h4ppL");

var $JPsIz = parcelRequire("JPsIz");

var $lC4FX = parcelRequire("lC4FX");

var $cuKXc = parcelRequire("cuKXc");

var $2YZCu = parcelRequire("2YZCu");

var $dxpxC = parcelRequire("dxpxC");

var $l0T7c = parcelRequire("l0T7c");

var $9g713 = parcelRequire("9g713");


const $d88f4e626c9babc0$var$GIRA_APOLLO_CLIENT_ID = 'gira';
const $d88f4e626c9babc0$var$CACHE_NAME = `apollo-cache/${$d88f4e626c9babc0$var$GIRA_APOLLO_CLIENT_ID}`;
const $d88f4e626c9babc0$var$LOG_NAMESPACE = `apollo.${$d88f4e626c9babc0$var$GIRA_APOLLO_CLIENT_ID}.error.graphql`;
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $d88f4e626c9babc0$var$isSsrSuccessful = ()=>false ? true : !window || !window.SPA_STATE;
const $d88f4e626c9babc0$var$NETWORK_ERRORS_COUNTER_KEY = 'networkErrorsCounter';
const $d88f4e626c9babc0$export$851a7159daf49c89 = new (0, $ivfDv.IntrospectionFragmentMatcher)({
    introspectionQueryResultData: (/*@__PURE__*/$parcel$interopDefault($l0T7c))
});
const $d88f4e626c9babc0$var$errorLink = (0, $h4ppL.onError)(({ graphQLErrors: graphQLErrors, networkError: networkError, operation: operation })=>{
    // Ignore network errors as they will be logged in the retry link
    (0, $9g713.reportErrors)({
        graphQLErrors: graphQLErrors,
        operation: operation
    });
    // Skip default error logging if analytics context data is defined for the query.
    const errorAnalytics = (0, $9g713.getErrorAnalyticsContext)(operation.getContext());
    if (errorAnalytics !== undefined) return;
    if (graphQLErrors) {
        if (Array.isArray(graphQLErrors)) graphQLErrors.map(({ message: message, locations: locations, path: path })=>(0, $2YZCu.default).safeErrorWithoutCustomerData($d88f4e626c9babc0$var$LOG_NAMESPACE, `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`, {
                message: JSON.stringify(message),
                path: JSON.stringify(path),
                locations: JSON.stringify(locations)
            }));
        else (0, $2YZCu.default).safeErrorWithoutCustomerData($d88f4e626c9babc0$var$LOG_NAMESPACE, '[GraphQL error]: Unexpected error message format', {
            message: JSON.stringify(graphQLErrors)
        });
    }
    if (networkError) {
        const occuredNetworkErrorsBefore = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(operation.getContext(), [
            $d88f4e626c9babc0$var$NETWORK_ERRORS_COUNTER_KEY
        ], 0);
        (0, $2YZCu.default).safeErrorWithoutCustomerData($d88f4e626c9babc0$var$LOG_NAMESPACE, `[Network error]: ${networkError}, attempt ${occuredNetworkErrorsBefore + 1}`);
        operation.setContext({
            [$d88f4e626c9babc0$var$NETWORK_ERRORS_COUNTER_KEY]: occuredNetworkErrorsBefore + 1
        });
    }
});
const $d88f4e626c9babc0$var$retryLinkWithFama = new (0, $lC4FX.RetryLink)({
    delay: {
        initial: 300,
        max: 120000,
        jitter: true
    },
    attempts: (count, operation, networkError)=>{
        const retry = count < 5 && networkError && !networkError.statusCode;
        // Don't report any error if we're going to attempt a retry
        if (!retry) (0, $9g713.reportErrors)({
            networkError: networkError,
            operation: operation
        });
        return retry;
    }
});
class $d88f4e626c9babc0$var$CancelableRequestLink extends (0, $clSzL.ApolloLink) {
    constructor(){
        super();
        this.inFlightRequestControllers = {};
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    request(operation, forward) {
        const context = operation.getContext();
        if (!context.cancelable) return forward(operation);
        const key = JSON.stringify([
            operation.operationName,
            operation.query
        ]); // Equivalent to `operation.toKey` less the _actual_ variables
        this.inFlightRequestControllers[key]?.abort(); // Always abort the previous request
        const abortController = new AbortController();
        operation.setContext({
            ...context,
            fetchOptions: {
                signal: abortController.signal
            } // HttpLink passes this directly to fetch implementation
        });
        this.inFlightRequestControllers[key] = abortController;
        const cleanup = ()=>{
            // This callback may be called long after the request is replaced
            if (this.inFlightRequestControllers[key] === abortController) delete this.inFlightRequestControllers[key];
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return new (0, $clSzL.Observable)((observer)=>{
            const subscription = forward(operation).subscribe({
                next: observer.next.bind(observer),
                // @ts-expect-error - TS7006 - Parameter 'error' implicitly has an 'any' type.
                error: (error)=>{
                    observer.error(error);
                    cleanup();
                },
                complete: observer.complete.bind(observer)
            });
            return ()=>{
                subscription?.unsubscribe();
                cleanup();
            };
        });
    }
}
const $d88f4e626c9babc0$var$cache = new (0, $ivfDv.InMemoryCache)({
    cacheRedirects: {
        Query: {
            ...(0, $cuKXc.fragmentCacheRedirect)()
        }
    },
    fragmentMatcher: $d88f4e626c9babc0$export$851a7159daf49c89,
    dataIdFromObject: (object)=>object.id && `${object.id}${object.__typename}`
})// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
.restore(!$d88f4e626c9babc0$var$isSsrSuccessful() && window.SPA_STATE[$d88f4e626c9babc0$var$CACHE_NAME] || {});
const $d88f4e626c9babc0$export$de66868aab9e79ea = (baseUrl)=>new (0, $e3a3O.ApolloClient)({
        name: $d88f4e626c9babc0$var$GIRA_APOLLO_CLIENT_ID,
        ssrMode: $d88f4e626c9babc0$var$isSsrSuccessful(),
        // @ts-expect-error - TS2345 - Argument of type '{ name: string; ssrMode: boolean; addTypename: boolean; link: ApolloLink; cache: InMemoryCache; connectToDevTools: boolean; }' is not assignable to parameter of type 'ApolloClientOptions<NormalizedCacheObject>'.
        addTypename: true,
        link: (0, $clSzL.ApolloLink).from([
            $d88f4e626c9babc0$var$retryLinkWithFama,
            $d88f4e626c9babc0$var$errorLink,
            (0, $dxpxC.UFOLoggerLink),
            (0, $cuKXc.fragmentLinkState)($d88f4e626c9babc0$var$cache),
            ...!$d88f4e626c9babc0$var$isSsrSuccessful() ? [
                new $d88f4e626c9babc0$var$CancelableRequestLink()
            ] : [],
            new (0, $JPsIz.HttpLink)({
                uri: ({ operationName: operationName })=>`${baseUrl}/rest/${$d88f4e626c9babc0$var$GIRA_APOLLO_CLIENT_ID}/1/?operation=${encodeURIComponent(operationName)}`,
                credentials: 'same-origin',
                // @ts-expect-error - TS2345 - Argument of type '{ uri: ({ operationName }: Operation) => string; credentials: string; abortErrorDoesNotCauseError: boolean; }' is not assignable to parameter of type 'Options'.
                abortErrorDoesNotCauseError: !$d88f4e626c9babc0$var$isSsrSuccessful()
            })
        ].filter(Boolean)),
        cache: $d88f4e626c9babc0$var$cache,
        connectToDevTools: false
    });
var $d88f4e626c9babc0$export$2e2bcd8739ae039 = {
    clientId: $d88f4e626c9babc0$var$GIRA_APOLLO_CLIENT_ID,
    clientCreator: $d88f4e626c9babc0$export$de66868aab9e79ea
};

});
parcelRegister("ivfDv", function(module, exports) {

$parcel$export(module.exports, "IntrospectionFragmentMatcher", () => $d7874048ca668ecb$export$3b71c6b829c99d21);
$parcel$export(module.exports, "defaultDataIdFromObject", () => $d7874048ca668ecb$export$bd03c5a9c99d6bce);
$parcel$export(module.exports, "InMemoryCache", () => $d7874048ca668ecb$export$467265324939f47f);

var $3VFsf = parcelRequire("3VFsf");

var $hzuXv = parcelRequire("hzuXv");

var $jojW6 = parcelRequire("jojW6");
var $bqMzA = parcelRequire("bqMzA");

var $gLy2H = parcelRequire("gLy2H");

var $1DiV8 = parcelRequire("1DiV8");
var $d7874048ca668ecb$var$haveWarned = false;
function $d7874048ca668ecb$var$shouldWarn() {
    var answer = !$d7874048ca668ecb$var$haveWarned;
    if (!(0, $jojW6.isTest)()) $d7874048ca668ecb$var$haveWarned = true;
    return answer;
}
var $d7874048ca668ecb$export$5d3fcf53267091de = function() {
    function HeuristicFragmentMatcher() {}
    HeuristicFragmentMatcher.prototype.ensureReady = function() {
        return Promise.resolve();
    };
    HeuristicFragmentMatcher.prototype.canBypassInit = function() {
        return true;
    };
    HeuristicFragmentMatcher.prototype.match = function(idValue, typeCondition, context) {
        var obj = context.store.get(idValue.id);
        var isRootQuery = idValue.id === 'ROOT_QUERY';
        if (!obj) return isRootQuery;
        var _a = obj.__typename, __typename = _a === void 0 ? isRootQuery && 'Query' : _a;
        if (!__typename) {
            $d7874048ca668ecb$var$shouldWarn();
            return 'heuristic';
        }
        if (__typename === typeCondition) return true;
        $d7874048ca668ecb$var$shouldWarn();
        return 'heuristic';
    };
    return HeuristicFragmentMatcher;
}();
var $d7874048ca668ecb$export$3b71c6b829c99d21 = function() {
    function IntrospectionFragmentMatcher(options) {
        if (options && options.introspectionQueryResultData) {
            this.possibleTypesMap = this.parseIntrospectionResult(options.introspectionQueryResultData);
            this.isReady = true;
        } else this.isReady = false;
        this.match = this.match.bind(this);
    }
    IntrospectionFragmentMatcher.prototype.match = function(idValue, typeCondition, context) {
        (0, $1DiV8.invariant)(this.isReady, 1);
        var obj = context.store.get(idValue.id);
        var isRootQuery = idValue.id === 'ROOT_QUERY';
        if (!obj) return isRootQuery;
        var _a = obj.__typename, __typename = _a === void 0 ? isRootQuery && 'Query' : _a;
        (0, $1DiV8.invariant)(__typename, 2);
        if (__typename === typeCondition) return true;
        var implementingTypes = this.possibleTypesMap[typeCondition];
        if (__typename && implementingTypes && implementingTypes.indexOf(__typename) > -1) return true;
        return false;
    };
    IntrospectionFragmentMatcher.prototype.parseIntrospectionResult = function(introspectionResultData) {
        var typeMap = {};
        introspectionResultData.__schema.types.forEach(function(type) {
            if (type.kind === 'UNION' || type.kind === 'INTERFACE') typeMap[type.name] = type.possibleTypes.map(function(implementingType) {
                return implementingType.name;
            });
        });
        return typeMap;
    };
    return IntrospectionFragmentMatcher;
}();
var $d7874048ca668ecb$var$hasOwn = Object.prototype.hasOwnProperty;
var $d7874048ca668ecb$var$DepTrackingCache = function() {
    function DepTrackingCache(data) {
        var _this = this;
        if (data === void 0) data = Object.create(null);
        this.data = data;
        this.depend = (0, $gLy2H.wrap)(function(dataId) {
            return _this.data[dataId];
        }, {
            disposable: true,
            makeCacheKey: function(dataId) {
                return dataId;
            }
        });
    }
    DepTrackingCache.prototype.toObject = function() {
        return this.data;
    };
    DepTrackingCache.prototype.get = function(dataId) {
        this.depend(dataId);
        return this.data[dataId];
    };
    DepTrackingCache.prototype.set = function(dataId, value) {
        var oldValue = this.data[dataId];
        if (value !== oldValue) {
            this.data[dataId] = value;
            this.depend.dirty(dataId);
        }
    };
    DepTrackingCache.prototype.delete = function(dataId) {
        if ($d7874048ca668ecb$var$hasOwn.call(this.data, dataId)) {
            delete this.data[dataId];
            this.depend.dirty(dataId);
        }
    };
    DepTrackingCache.prototype.clear = function() {
        this.replace(null);
    };
    DepTrackingCache.prototype.replace = function(newData) {
        var _this = this;
        if (newData) {
            Object.keys(newData).forEach(function(dataId) {
                _this.set(dataId, newData[dataId]);
            });
            Object.keys(this.data).forEach(function(dataId) {
                if (!$d7874048ca668ecb$var$hasOwn.call(newData, dataId)) _this.delete(dataId);
            });
        } else Object.keys(this.data).forEach(function(dataId) {
            _this.delete(dataId);
        });
    };
    return DepTrackingCache;
}();
function $d7874048ca668ecb$var$defaultNormalizedCacheFactory(seed) {
    return new $d7874048ca668ecb$var$DepTrackingCache(seed);
}
var $d7874048ca668ecb$export$628ef07ba8965f12 = function() {
    function StoreReader(_a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, _c = _b.cacheKeyRoot, cacheKeyRoot = _c === void 0 ? new (0, $gLy2H.KeyTrie)((0, $jojW6.canUseWeakMap)) : _c, _d = _b.freezeResults, freezeResults = _d === void 0 ? false : _d;
        var _e = this, executeStoreQuery = _e.executeStoreQuery, executeSelectionSet = _e.executeSelectionSet, executeSubSelectedArray = _e.executeSubSelectedArray;
        this.freezeResults = freezeResults;
        this.executeStoreQuery = (0, $gLy2H.wrap)(function(options) {
            return executeStoreQuery.call(_this, options);
        }, {
            makeCacheKey: function(_a) {
                var query = _a.query, rootValue = _a.rootValue, contextValue = _a.contextValue, variableValues = _a.variableValues, fragmentMatcher = _a.fragmentMatcher;
                if (contextValue.store instanceof $d7874048ca668ecb$var$DepTrackingCache) return cacheKeyRoot.lookup(contextValue.store, query, fragmentMatcher, JSON.stringify(variableValues), rootValue.id);
            }
        });
        this.executeSelectionSet = (0, $gLy2H.wrap)(function(options) {
            return executeSelectionSet.call(_this, options);
        }, {
            makeCacheKey: function(_a) {
                var selectionSet = _a.selectionSet, rootValue = _a.rootValue, execContext = _a.execContext;
                if (execContext.contextValue.store instanceof $d7874048ca668ecb$var$DepTrackingCache) return cacheKeyRoot.lookup(execContext.contextValue.store, selectionSet, execContext.fragmentMatcher, JSON.stringify(execContext.variableValues), rootValue.id);
            }
        });
        this.executeSubSelectedArray = (0, $gLy2H.wrap)(function(options) {
            return executeSubSelectedArray.call(_this, options);
        }, {
            makeCacheKey: function(_a) {
                var field = _a.field, array = _a.array, execContext = _a.execContext;
                if (execContext.contextValue.store instanceof $d7874048ca668ecb$var$DepTrackingCache) return cacheKeyRoot.lookup(execContext.contextValue.store, field, array, JSON.stringify(execContext.variableValues));
            }
        });
    }
    StoreReader.prototype.readQueryFromStore = function(options) {
        return this.diffQueryAgainstStore((0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, options), {
            returnPartialData: false
        })).result;
    };
    StoreReader.prototype.diffQueryAgainstStore = function(_a) {
        var store = _a.store, query = _a.query, variables = _a.variables, previousResult = _a.previousResult, _b = _a.returnPartialData, returnPartialData = _b === void 0 ? true : _b, _c = _a.rootId, rootId = _c === void 0 ? 'ROOT_QUERY' : _c, fragmentMatcherFunction = _a.fragmentMatcherFunction, config = _a.config;
        var queryDefinition = (0, $jojW6.getQueryDefinition)(query);
        variables = (0, $jojW6.assign)({}, (0, $jojW6.getDefaultValues)(queryDefinition), variables);
        var context = {
            store: store,
            dataIdFromObject: config && config.dataIdFromObject,
            cacheRedirects: config && config.cacheRedirects || {}
        };
        var execResult = this.executeStoreQuery({
            query: query,
            rootValue: {
                type: 'id',
                id: rootId,
                generated: true,
                typename: 'Query'
            },
            contextValue: context,
            variableValues: variables,
            fragmentMatcher: fragmentMatcherFunction
        });
        var hasMissingFields = execResult.missing && execResult.missing.length > 0;
        if (hasMissingFields && !returnPartialData) execResult.missing.forEach(function(info) {
            if (info.tolerable) return;
            throw new (0, $1DiV8.InvariantError)(8);
        });
        if (previousResult) {
            if ((0, $bqMzA.equal)(previousResult, execResult.result)) execResult.result = previousResult;
        }
        return {
            result: execResult.result,
            complete: !hasMissingFields
        };
    };
    StoreReader.prototype.executeStoreQuery = function(_a) {
        var query = _a.query, rootValue = _a.rootValue, contextValue = _a.contextValue, variableValues = _a.variableValues, _b = _a.fragmentMatcher, fragmentMatcher = _b === void 0 ? $d7874048ca668ecb$var$defaultFragmentMatcher : _b;
        var mainDefinition = (0, $jojW6.getMainDefinition)(query);
        var fragments = (0, $jojW6.getFragmentDefinitions)(query);
        var fragmentMap = (0, $jojW6.createFragmentMap)(fragments);
        var execContext = {
            query: query,
            fragmentMap: fragmentMap,
            contextValue: contextValue,
            variableValues: variableValues,
            fragmentMatcher: fragmentMatcher
        };
        return this.executeSelectionSet({
            selectionSet: mainDefinition.selectionSet,
            rootValue: rootValue,
            execContext: execContext
        });
    };
    StoreReader.prototype.executeSelectionSet = function(_a) {
        var _this = this;
        var selectionSet = _a.selectionSet, rootValue = _a.rootValue, execContext = _a.execContext;
        var fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
        var finalResult = {
            result: null
        };
        var objectsToMerge = [];
        var object = contextValue.store.get(rootValue.id);
        var typename = object && object.__typename || rootValue.id === 'ROOT_QUERY' && 'Query' || void 0;
        function handleMissing(result) {
            var _a;
            if (result.missing) {
                finalResult.missing = finalResult.missing || [];
                (_a = finalResult.missing).push.apply(_a, result.missing);
            }
            return result.result;
        }
        selectionSet.selections.forEach(function(selection) {
            var _a;
            if (!(0, $jojW6.shouldInclude)(selection, variables)) return;
            if ((0, $jojW6.isField)(selection)) {
                var fieldResult = handleMissing(_this.executeField(object, typename, selection, execContext));
                if (typeof fieldResult !== 'undefined') objectsToMerge.push((_a = {}, _a[(0, $jojW6.resultKeyNameFromField)(selection)] = fieldResult, _a));
            } else {
                var fragment = void 0;
                if ((0, $jojW6.isInlineFragment)(selection)) fragment = selection;
                else {
                    fragment = fragmentMap[selection.name.value];
                    if (!fragment) throw new (0, $1DiV8.InvariantError)(9);
                }
                var typeCondition = fragment.typeCondition && fragment.typeCondition.name.value;
                var match = !typeCondition || execContext.fragmentMatcher(rootValue, typeCondition, contextValue);
                if (match) {
                    var fragmentExecResult = _this.executeSelectionSet({
                        selectionSet: fragment.selectionSet,
                        rootValue: rootValue,
                        execContext: execContext
                    });
                    if (match === 'heuristic' && fragmentExecResult.missing) fragmentExecResult = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, fragmentExecResult), {
                        missing: fragmentExecResult.missing.map(function(info) {
                            return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, info), {
                                tolerable: true
                            });
                        })
                    });
                    objectsToMerge.push(handleMissing(fragmentExecResult));
                }
            }
        });
        finalResult.result = (0, $jojW6.mergeDeepArray)(objectsToMerge);
        this.freezeResults;
        return finalResult;
    };
    StoreReader.prototype.executeField = function(object, typename, field, execContext) {
        var variables = execContext.variableValues, contextValue = execContext.contextValue;
        var fieldName = field.name.value;
        var args = (0, $jojW6.argumentsObjectFromField)(field, variables);
        var info = {
            resultKey: (0, $jojW6.resultKeyNameFromField)(field),
            directives: (0, $jojW6.getDirectiveInfoFromField)(field, variables)
        };
        var readStoreResult = $d7874048ca668ecb$var$readStoreResolver(object, typename, fieldName, args, contextValue, info);
        if (Array.isArray(readStoreResult.result)) return this.combineExecResults(readStoreResult, this.executeSubSelectedArray({
            field: field,
            array: readStoreResult.result,
            execContext: execContext
        }));
        if (!field.selectionSet) {
            $d7874048ca668ecb$var$assertSelectionSetForIdValue(field, readStoreResult.result);
            this.freezeResults;
            return readStoreResult;
        }
        if (readStoreResult.result == null) return readStoreResult;
        return this.combineExecResults(readStoreResult, this.executeSelectionSet({
            selectionSet: field.selectionSet,
            rootValue: readStoreResult.result,
            execContext: execContext
        }));
    };
    StoreReader.prototype.combineExecResults = function() {
        var execResults = [];
        for(var _i = 0; _i < arguments.length; _i++)execResults[_i] = arguments[_i];
        var missing;
        execResults.forEach(function(execResult) {
            if (execResult.missing) {
                missing = missing || [];
                missing.push.apply(missing, execResult.missing);
            }
        });
        return {
            result: execResults.pop().result,
            missing: missing
        };
    };
    StoreReader.prototype.executeSubSelectedArray = function(_a) {
        var _this = this;
        var field = _a.field, array = _a.array, execContext = _a.execContext;
        var missing;
        function handleMissing(childResult) {
            if (childResult.missing) {
                missing = missing || [];
                missing.push.apply(missing, childResult.missing);
            }
            return childResult.result;
        }
        array = array.map(function(item) {
            if (item === null) return null;
            if (Array.isArray(item)) return handleMissing(_this.executeSubSelectedArray({
                field: field,
                array: item,
                execContext: execContext
            }));
            if (field.selectionSet) return handleMissing(_this.executeSelectionSet({
                selectionSet: field.selectionSet,
                rootValue: item,
                execContext: execContext
            }));
            $d7874048ca668ecb$var$assertSelectionSetForIdValue(field, item);
            return item;
        });
        this.freezeResults;
        return {
            result: array,
            missing: missing
        };
    };
    return StoreReader;
}();
function $d7874048ca668ecb$var$assertSelectionSetForIdValue(field, value) {
    if (!field.selectionSet && (0, $jojW6.isIdValue)(value)) throw new (0, $1DiV8.InvariantError)(10);
}
function $d7874048ca668ecb$var$defaultFragmentMatcher() {
    return true;
}
function $d7874048ca668ecb$export$7a4899fe13f33235(idValue) {
    (0, $1DiV8.invariant)((0, $jojW6.isIdValue)(idValue), 11);
}
function $d7874048ca668ecb$var$readStoreResolver(object, typename, fieldName, args, context, _a) {
    var resultKey = _a.resultKey, directives = _a.directives;
    var storeKeyName = fieldName;
    if (args || directives) storeKeyName = (0, $jojW6.getStoreKeyName)(storeKeyName, args, directives);
    var fieldValue = void 0;
    if (object) {
        fieldValue = object[storeKeyName];
        if (typeof fieldValue === 'undefined' && context.cacheRedirects && typeof typename === 'string') {
            var type = context.cacheRedirects[typename];
            if (type) {
                var resolver = type[fieldName];
                if (resolver) fieldValue = resolver(object, args, {
                    getCacheKey: function(storeObj) {
                        var id = context.dataIdFromObject(storeObj);
                        return id && (0, $jojW6.toIdValue)({
                            id: id,
                            typename: storeObj.__typename
                        });
                    }
                });
            }
        }
    }
    if (typeof fieldValue === 'undefined') return {
        result: fieldValue,
        missing: [
            {
                object: object,
                fieldName: storeKeyName,
                tolerable: false
            }
        ]
    };
    if ((0, $jojW6.isJsonValue)(fieldValue)) fieldValue = fieldValue.json;
    return {
        result: fieldValue
    };
}
var $d7874048ca668ecb$export$ee7258b8691956a3 = function() {
    function ObjectCache(data) {
        if (data === void 0) data = Object.create(null);
        this.data = data;
    }
    ObjectCache.prototype.toObject = function() {
        return this.data;
    };
    ObjectCache.prototype.get = function(dataId) {
        return this.data[dataId];
    };
    ObjectCache.prototype.set = function(dataId, value) {
        this.data[dataId] = value;
    };
    ObjectCache.prototype.delete = function(dataId) {
        this.data[dataId] = void 0;
    };
    ObjectCache.prototype.clear = function() {
        this.data = Object.create(null);
    };
    ObjectCache.prototype.replace = function(newData) {
        this.data = newData || Object.create(null);
    };
    return ObjectCache;
}();
function $d7874048ca668ecb$export$7e2b40d1002de152(seed) {
    return new $d7874048ca668ecb$export$ee7258b8691956a3(seed);
}
var $d7874048ca668ecb$export$de4e6870dc6ac801 = function(_super) {
    (0, $3VFsf.__extends)(WriteError, _super);
    function WriteError() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'WriteError';
        return _this;
    }
    return WriteError;
}(Error);
function $d7874048ca668ecb$export$fb86e3236e77e3(error, document) {
    var enhancedError = new $d7874048ca668ecb$export$de4e6870dc6ac801("Error writing result to store for query:\n " + JSON.stringify(document));
    enhancedError.message += '\n' + error.message;
    enhancedError.stack = error.stack;
    return enhancedError;
}
var $d7874048ca668ecb$export$eb8361c5d132fb8f = function() {
    function StoreWriter() {}
    StoreWriter.prototype.writeQueryToStore = function(_a) {
        var query = _a.query, result = _a.result, _b = _a.store, store = _b === void 0 ? $d7874048ca668ecb$var$defaultNormalizedCacheFactory() : _b, variables = _a.variables, dataIdFromObject = _a.dataIdFromObject, fragmentMatcherFunction = _a.fragmentMatcherFunction;
        return this.writeResultToStore({
            dataId: 'ROOT_QUERY',
            result: result,
            document: query,
            store: store,
            variables: variables,
            dataIdFromObject: dataIdFromObject,
            fragmentMatcherFunction: fragmentMatcherFunction
        });
    };
    StoreWriter.prototype.writeResultToStore = function(_a) {
        var dataId = _a.dataId, result = _a.result, document = _a.document, _b = _a.store, store = _b === void 0 ? $d7874048ca668ecb$var$defaultNormalizedCacheFactory() : _b, variables = _a.variables, dataIdFromObject = _a.dataIdFromObject, fragmentMatcherFunction = _a.fragmentMatcherFunction;
        var operationDefinition = (0, $jojW6.getOperationDefinition)(document);
        try {
            return this.writeSelectionSetToStore({
                result: result,
                dataId: dataId,
                selectionSet: operationDefinition.selectionSet,
                context: {
                    store: store,
                    processedData: {},
                    variables: (0, $jojW6.assign)({}, (0, $jojW6.getDefaultValues)(operationDefinition), variables),
                    dataIdFromObject: dataIdFromObject,
                    fragmentMap: (0, $jojW6.createFragmentMap)((0, $jojW6.getFragmentDefinitions)(document)),
                    fragmentMatcherFunction: fragmentMatcherFunction
                }
            });
        } catch (e) {
            throw $d7874048ca668ecb$export$fb86e3236e77e3(e, document);
        }
    };
    StoreWriter.prototype.writeSelectionSetToStore = function(_a) {
        var _this = this;
        var result = _a.result, dataId = _a.dataId, selectionSet = _a.selectionSet, context = _a.context;
        var variables = context.variables, store = context.store, fragmentMap = context.fragmentMap;
        selectionSet.selections.forEach(function(selection) {
            var _a;
            if (!(0, $jojW6.shouldInclude)(selection, variables)) return;
            if ((0, $jojW6.isField)(selection)) {
                var resultFieldKey = (0, $jojW6.resultKeyNameFromField)(selection);
                var value = result[resultFieldKey];
                if (typeof value !== 'undefined') _this.writeFieldToStore({
                    dataId: dataId,
                    value: value,
                    field: selection,
                    context: context
                });
                else {
                    var isDefered = false;
                    var isClient = false;
                    if (selection.directives && selection.directives.length) {
                        isDefered = selection.directives.some(function(directive) {
                            return directive.name && directive.name.value === 'defer';
                        });
                        isClient = selection.directives.some(function(directive) {
                            return directive.name && directive.name.value === 'client';
                        });
                    }
                    !isDefered && !isClient && context.fragmentMatcherFunction;
                }
            } else {
                var fragment = void 0;
                if ((0, $jojW6.isInlineFragment)(selection)) fragment = selection;
                else {
                    fragment = (fragmentMap || {})[selection.name.value];
                    (0, $1DiV8.invariant)(fragment, 3);
                }
                var matches = true;
                if (context.fragmentMatcherFunction && fragment.typeCondition) {
                    var id = dataId || 'self';
                    var idValue = (0, $jojW6.toIdValue)({
                        id: id,
                        typename: undefined
                    });
                    var fakeContext = {
                        store: new $d7874048ca668ecb$export$ee7258b8691956a3((_a = {}, _a[id] = result, _a)),
                        cacheRedirects: {}
                    };
                    var match = context.fragmentMatcherFunction(idValue, fragment.typeCondition.name.value, fakeContext);
                    !(0, $jojW6.isProduction)() && match;
                    matches = !!match;
                }
                if (matches) _this.writeSelectionSetToStore({
                    result: result,
                    selectionSet: fragment.selectionSet,
                    dataId: dataId,
                    context: context
                });
            }
        });
        return store;
    };
    StoreWriter.prototype.writeFieldToStore = function(_a) {
        var _b;
        var field = _a.field, value = _a.value, dataId = _a.dataId, context = _a.context;
        var variables = context.variables, dataIdFromObject = context.dataIdFromObject, store = context.store;
        var storeValue;
        var storeObject;
        var storeFieldName = (0, $jojW6.storeKeyNameFromField)(field, variables);
        if (!field.selectionSet || value === null) storeValue = value != null && typeof value === 'object' ? {
            type: 'json',
            json: value
        } : value;
        else if (Array.isArray(value)) {
            var generatedId = dataId + "." + storeFieldName;
            storeValue = this.processArrayValue(value, generatedId, field.selectionSet, context);
        } else {
            var valueDataId = dataId + "." + storeFieldName;
            var generated = true;
            if (!$d7874048ca668ecb$var$isGeneratedId(valueDataId)) valueDataId = '$' + valueDataId;
            if (dataIdFromObject) {
                var semanticId = dataIdFromObject(value);
                (0, $1DiV8.invariant)(!semanticId || !$d7874048ca668ecb$var$isGeneratedId(semanticId), 4);
                if (semanticId || typeof semanticId === 'number' && semanticId === 0) {
                    valueDataId = semanticId;
                    generated = false;
                }
            }
            if (!$d7874048ca668ecb$var$isDataProcessed(valueDataId, field, context.processedData)) this.writeSelectionSetToStore({
                dataId: valueDataId,
                result: value,
                selectionSet: field.selectionSet,
                context: context
            });
            var typename = value.__typename;
            storeValue = (0, $jojW6.toIdValue)({
                id: valueDataId,
                typename: typename
            }, generated);
            storeObject = store.get(dataId);
            var escapedId = storeObject && storeObject[storeFieldName];
            if (escapedId !== storeValue && (0, $jojW6.isIdValue)(escapedId)) {
                var hadTypename = escapedId.typename !== undefined;
                var hasTypename = typename !== undefined;
                var typenameChanged = hadTypename && hasTypename && escapedId.typename !== typename;
                (0, $1DiV8.invariant)(!generated || escapedId.generated || typenameChanged, 5);
                (0, $1DiV8.invariant)(!hadTypename || hasTypename, 6);
                if (escapedId.generated) {
                    if (typenameChanged) {
                        if (!generated) store.delete(escapedId.id);
                    } else $d7874048ca668ecb$var$mergeWithGenerated(escapedId.id, storeValue.id, store);
                }
            }
        }
        storeObject = store.get(dataId);
        if (!storeObject || !(0, $bqMzA.equal)(storeValue, storeObject[storeFieldName])) store.set(dataId, (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, storeObject), (_b = {}, _b[storeFieldName] = storeValue, _b)));
    };
    StoreWriter.prototype.processArrayValue = function(value, generatedId, selectionSet, context) {
        var _this = this;
        return value.map(function(item, index) {
            if (item === null) return null;
            var itemDataId = generatedId + "." + index;
            if (Array.isArray(item)) return _this.processArrayValue(item, itemDataId, selectionSet, context);
            var generated = true;
            if (context.dataIdFromObject) {
                var semanticId = context.dataIdFromObject(item);
                if (semanticId) {
                    itemDataId = semanticId;
                    generated = false;
                }
            }
            if (!$d7874048ca668ecb$var$isDataProcessed(itemDataId, selectionSet, context.processedData)) _this.writeSelectionSetToStore({
                dataId: itemDataId,
                result: item,
                selectionSet: selectionSet,
                context: context
            });
            return (0, $jojW6.toIdValue)({
                id: itemDataId,
                typename: item.__typename
            }, generated);
        });
    };
    return StoreWriter;
}();
function $d7874048ca668ecb$var$isGeneratedId(id) {
    return id[0] === '$';
}
function $d7874048ca668ecb$var$mergeWithGenerated(generatedKey, realKey, cache) {
    if (generatedKey === realKey) return false;
    var generated = cache.get(generatedKey);
    var real = cache.get(realKey);
    var madeChanges = false;
    Object.keys(generated).forEach(function(key) {
        var value = generated[key];
        var realValue = real[key];
        if ((0, $jojW6.isIdValue)(value) && $d7874048ca668ecb$var$isGeneratedId(value.id) && (0, $jojW6.isIdValue)(realValue) && !(0, $bqMzA.equal)(value, realValue) && $d7874048ca668ecb$var$mergeWithGenerated(value.id, realValue.id, cache)) madeChanges = true;
    });
    cache.delete(generatedKey);
    var newRealValue = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, generated), real);
    if ((0, $bqMzA.equal)(newRealValue, real)) return madeChanges;
    cache.set(realKey, newRealValue);
    return true;
}
function $d7874048ca668ecb$var$isDataProcessed(dataId, field, processedData) {
    if (!processedData) return false;
    if (processedData[dataId]) {
        if (processedData[dataId].indexOf(field) >= 0) return true;
        else processedData[dataId].push(field);
    } else processedData[dataId] = [
        field
    ];
    return false;
}
var $d7874048ca668ecb$var$defaultConfig = {
    fragmentMatcher: new $d7874048ca668ecb$export$5d3fcf53267091de(),
    dataIdFromObject: $d7874048ca668ecb$export$bd03c5a9c99d6bce,
    addTypename: true,
    resultCaching: true,
    freezeResults: false
};
function $d7874048ca668ecb$export$bd03c5a9c99d6bce(result) {
    if (result.__typename) {
        if (result.id !== undefined) return result.__typename + ":" + result.id;
        if (result._id !== undefined) return result.__typename + ":" + result._id;
    }
    return null;
}
var $d7874048ca668ecb$var$hasOwn$1 = Object.prototype.hasOwnProperty;
var $d7874048ca668ecb$var$OptimisticCacheLayer = function(_super) {
    (0, $3VFsf.__extends)(OptimisticCacheLayer, _super);
    function OptimisticCacheLayer(optimisticId, parent, transaction) {
        var _this = _super.call(this, Object.create(null)) || this;
        _this.optimisticId = optimisticId;
        _this.parent = parent;
        _this.transaction = transaction;
        return _this;
    }
    OptimisticCacheLayer.prototype.toObject = function() {
        return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this.parent.toObject()), this.data);
    };
    OptimisticCacheLayer.prototype.get = function(dataId) {
        return $d7874048ca668ecb$var$hasOwn$1.call(this.data, dataId) ? this.data[dataId] : this.parent.get(dataId);
    };
    return OptimisticCacheLayer;
}($d7874048ca668ecb$export$ee7258b8691956a3);
var $d7874048ca668ecb$export$467265324939f47f = function(_super) {
    (0, $3VFsf.__extends)(InMemoryCache, _super);
    function InMemoryCache(config) {
        if (config === void 0) config = {};
        var _this = _super.call(this) || this;
        _this.watches = new Set();
        _this.typenameDocumentCache = new Map();
        _this.cacheKeyRoot = new (0, $gLy2H.KeyTrie)((0, $jojW6.canUseWeakMap));
        _this.silenceBroadcast = false;
        _this.config = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, $d7874048ca668ecb$var$defaultConfig), config);
        if (_this.config.customResolvers) _this.config.cacheRedirects = _this.config.customResolvers;
        if (_this.config.cacheResolvers) _this.config.cacheRedirects = _this.config.cacheResolvers;
        _this.addTypename = !!_this.config.addTypename;
        _this.data = _this.config.resultCaching ? new $d7874048ca668ecb$var$DepTrackingCache() : new $d7874048ca668ecb$export$ee7258b8691956a3();
        _this.optimisticData = _this.data;
        _this.storeWriter = new $d7874048ca668ecb$export$eb8361c5d132fb8f();
        _this.storeReader = new $d7874048ca668ecb$export$628ef07ba8965f12({
            cacheKeyRoot: _this.cacheKeyRoot,
            freezeResults: config.freezeResults
        });
        var cache = _this;
        var maybeBroadcastWatch = cache.maybeBroadcastWatch;
        _this.maybeBroadcastWatch = (0, $gLy2H.wrap)(function(c) {
            return maybeBroadcastWatch.call(_this, c);
        }, {
            makeCacheKey: function(c) {
                if (c.optimistic) return;
                if (c.previousResult) return;
                if (cache.data instanceof $d7874048ca668ecb$var$DepTrackingCache) return cache.cacheKeyRoot.lookup(c.query, JSON.stringify(c.variables));
            }
        });
        return _this;
    }
    InMemoryCache.prototype.restore = function(data) {
        if (data) this.data.replace(data);
        return this;
    };
    InMemoryCache.prototype.extract = function(optimistic) {
        if (optimistic === void 0) optimistic = false;
        return (optimistic ? this.optimisticData : this.data).toObject();
    };
    InMemoryCache.prototype.read = function(options) {
        if (typeof options.rootId === 'string' && typeof this.data.get(options.rootId) === 'undefined') return null;
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        return this.storeReader.readQueryFromStore({
            store: options.optimistic ? this.optimisticData : this.data,
            query: this.transformDocument(options.query),
            variables: options.variables,
            rootId: options.rootId,
            fragmentMatcherFunction: fragmentMatcherFunction,
            previousResult: options.previousResult,
            config: this.config
        }) || null;
    };
    InMemoryCache.prototype.write = function(write) {
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        this.storeWriter.writeResultToStore({
            dataId: write.dataId,
            result: write.result,
            variables: write.variables,
            document: this.transformDocument(write.query),
            store: this.data,
            dataIdFromObject: this.config.dataIdFromObject,
            fragmentMatcherFunction: fragmentMatcherFunction
        });
        this.broadcastWatches();
    };
    InMemoryCache.prototype.diff = function(query) {
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        return this.storeReader.diffQueryAgainstStore({
            store: query.optimistic ? this.optimisticData : this.data,
            query: this.transformDocument(query.query),
            variables: query.variables,
            returnPartialData: query.returnPartialData,
            previousResult: query.previousResult,
            fragmentMatcherFunction: fragmentMatcherFunction,
            config: this.config
        });
    };
    InMemoryCache.prototype.watch = function(watch) {
        var _this = this;
        this.watches.add(watch);
        return function() {
            _this.watches.delete(watch);
        };
    };
    InMemoryCache.prototype.evict = function(query) {
        throw new (0, $1DiV8.InvariantError)(7);
    };
    InMemoryCache.prototype.reset = function() {
        this.data.clear();
        this.broadcastWatches();
        return Promise.resolve();
    };
    InMemoryCache.prototype.removeOptimistic = function(idToRemove) {
        var toReapply = [];
        var removedCount = 0;
        var layer = this.optimisticData;
        while(layer instanceof $d7874048ca668ecb$var$OptimisticCacheLayer){
            if (layer.optimisticId === idToRemove) ++removedCount;
            else toReapply.push(layer);
            layer = layer.parent;
        }
        if (removedCount > 0) {
            this.optimisticData = layer;
            while(toReapply.length > 0){
                var layer_1 = toReapply.pop();
                this.performTransaction(layer_1.transaction, layer_1.optimisticId);
            }
            this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.performTransaction = function(transaction, optimisticId) {
        var _a = this, data = _a.data, silenceBroadcast = _a.silenceBroadcast;
        this.silenceBroadcast = true;
        if (typeof optimisticId === 'string') this.data = this.optimisticData = new $d7874048ca668ecb$var$OptimisticCacheLayer(optimisticId, this.optimisticData, transaction);
        try {
            transaction(this);
        } finally{
            this.silenceBroadcast = silenceBroadcast;
            this.data = data;
        }
        this.broadcastWatches();
    };
    InMemoryCache.prototype.recordOptimisticTransaction = function(transaction, id) {
        return this.performTransaction(transaction, id);
    };
    InMemoryCache.prototype.transformDocument = function(document) {
        if (this.addTypename) {
            var result = this.typenameDocumentCache.get(document);
            if (!result) {
                result = (0, $jojW6.addTypenameToDocument)(document);
                this.typenameDocumentCache.set(document, result);
                this.typenameDocumentCache.set(result, result);
            }
            return result;
        }
        return document;
    };
    InMemoryCache.prototype.broadcastWatches = function() {
        var _this = this;
        if (!this.silenceBroadcast) this.watches.forEach(function(c) {
            return _this.maybeBroadcastWatch(c);
        });
    };
    InMemoryCache.prototype.maybeBroadcastWatch = function(c) {
        c.callback(this.diff({
            query: c.query,
            variables: c.variables,
            previousResult: c.previousResult && c.previousResult(),
            optimistic: c.optimistic
        }));
    };
    return InMemoryCache;
}((0, $hzuXv.ApolloCache));

});
parcelRegister("hzuXv", function(module, exports) {

$parcel$export(module.exports, "ApolloCache", () => $ccadb856bf057658$export$5fc74f25506aa9c);

var $jojW6 = parcelRequire("jojW6");
function $ccadb856bf057658$var$queryFromPojo(obj) {
    var op = {
        kind: 'OperationDefinition',
        operation: 'query',
        name: {
            kind: 'Name',
            value: 'GeneratedClientQuery'
        },
        selectionSet: $ccadb856bf057658$var$selectionSetFromObj(obj)
    };
    var out = {
        kind: 'Document',
        definitions: [
            op
        ]
    };
    return out;
}
function $ccadb856bf057658$var$fragmentFromPojo(obj, typename) {
    var frag = {
        kind: 'FragmentDefinition',
        typeCondition: {
            kind: 'NamedType',
            name: {
                kind: 'Name',
                value: typename || '__FakeType'
            }
        },
        name: {
            kind: 'Name',
            value: 'GeneratedClientQuery'
        },
        selectionSet: $ccadb856bf057658$var$selectionSetFromObj(obj)
    };
    var out = {
        kind: 'Document',
        definitions: [
            frag
        ]
    };
    return out;
}
function $ccadb856bf057658$var$selectionSetFromObj(obj) {
    if (typeof obj === 'number' || typeof obj === 'boolean' || typeof obj === 'string' || typeof obj === 'undefined' || obj === null) return null;
    if (Array.isArray(obj)) return $ccadb856bf057658$var$selectionSetFromObj(obj[0]);
    var selections = [];
    Object.keys(obj).forEach(function(key) {
        var nestedSelSet = $ccadb856bf057658$var$selectionSetFromObj(obj[key]);
        var field = {
            kind: 'Field',
            name: {
                kind: 'Name',
                value: key
            },
            selectionSet: nestedSelSet || undefined
        };
        selections.push(field);
    });
    var selectionSet = {
        kind: 'SelectionSet',
        selections: selections
    };
    return selectionSet;
}
var $ccadb856bf057658$var$justTypenameQuery = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: null,
            variableDefinitions: null,
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        alias: null,
                        name: {
                            kind: 'Name',
                            value: '__typename'
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: null
                    }
                ]
            }
        }
    ]
};
var $ccadb856bf057658$export$5fc74f25506aa9c = function() {
    function ApolloCache() {}
    ApolloCache.prototype.transformDocument = function(document) {
        return document;
    };
    ApolloCache.prototype.transformForLink = function(document) {
        return document;
    };
    ApolloCache.prototype.readQuery = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.read({
            query: options.query,
            variables: options.variables,
            optimistic: optimistic
        });
    };
    ApolloCache.prototype.readFragment = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.read({
            query: (0, $jojW6.getFragmentQueryDocument)(options.fragment, options.fragmentName),
            variables: options.variables,
            rootId: options.id,
            optimistic: optimistic
        });
    };
    ApolloCache.prototype.writeQuery = function(options) {
        this.write({
            dataId: 'ROOT_QUERY',
            result: options.data,
            query: options.query,
            variables: options.variables
        });
    };
    ApolloCache.prototype.writeFragment = function(options) {
        this.write({
            dataId: options.id,
            result: options.data,
            variables: options.variables,
            query: (0, $jojW6.getFragmentQueryDocument)(options.fragment, options.fragmentName)
        });
    };
    ApolloCache.prototype.writeData = function(_a) {
        var id = _a.id, data = _a.data;
        if (typeof id !== 'undefined') {
            var typenameResult = null;
            try {
                typenameResult = this.read({
                    rootId: id,
                    optimistic: false,
                    query: $ccadb856bf057658$var$justTypenameQuery
                });
            } catch (e) {}
            var __typename = typenameResult && typenameResult.__typename || '__ClientData';
            var dataToWrite = Object.assign({
                __typename: __typename
            }, data);
            this.writeFragment({
                id: id,
                fragment: $ccadb856bf057658$var$fragmentFromPojo(dataToWrite, __typename),
                data: dataToWrite
            });
        } else this.writeQuery({
            query: $ccadb856bf057658$var$queryFromPojo(data),
            data: data
        });
    };
    return ApolloCache;
}();
var $ccadb856bf057658$export$94affb487e701bf2;
$ccadb856bf057658$export$94affb487e701bf2 || ($ccadb856bf057658$export$94affb487e701bf2 = {});

});

parcelRegister("gLy2H", function(module, exports) {

$parcel$export(module.exports, "KeyTrie", () => $c34b71496108423e$export$6bd8d8299be3ac82);
$parcel$export(module.exports, "wrap", () => $c34b71496108423e$export$4997ffc0176396a6);

var $jFbNy = parcelRequire("jFbNy");
function $c34b71496108423e$var$defaultDispose() {}
var $c34b71496108423e$var$Cache = /** @class */ function() {
    function Cache(max, dispose) {
        if (max === void 0) max = Infinity;
        if (dispose === void 0) dispose = $c34b71496108423e$var$defaultDispose;
        this.max = max;
        this.dispose = dispose;
        this.map = new Map();
        this.newest = null;
        this.oldest = null;
    }
    Cache.prototype.has = function(key) {
        return this.map.has(key);
    };
    Cache.prototype.get = function(key) {
        var entry = this.getEntry(key);
        return entry && entry.value;
    };
    Cache.prototype.getEntry = function(key) {
        var entry = this.map.get(key);
        if (entry && entry !== this.newest) {
            var older = entry.older, newer = entry.newer;
            if (newer) newer.older = older;
            if (older) older.newer = newer;
            entry.older = this.newest;
            entry.older.newer = entry;
            entry.newer = null;
            this.newest = entry;
            if (entry === this.oldest) this.oldest = newer;
        }
        return entry;
    };
    Cache.prototype.set = function(key, value) {
        var entry = this.getEntry(key);
        if (entry) return entry.value = value;
        entry = {
            key: key,
            value: value,
            newer: null,
            older: this.newest
        };
        if (this.newest) this.newest.newer = entry;
        this.newest = entry;
        this.oldest = this.oldest || entry;
        this.map.set(key, entry);
        return entry.value;
    };
    Cache.prototype.clean = function() {
        while(this.oldest && this.map.size > this.max)this.delete(this.oldest.key);
    };
    Cache.prototype.delete = function(key) {
        var entry = this.map.get(key);
        if (entry) {
            if (entry === this.newest) this.newest = entry.older;
            if (entry === this.oldest) this.oldest = entry.newer;
            if (entry.newer) entry.newer.older = entry.older;
            if (entry.older) entry.older.newer = entry.newer;
            this.map.delete(key);
            this.dispose(entry.value, key);
            return true;
        }
        return false;
    };
    return Cache;
}();
var $c34b71496108423e$var$parentEntrySlot = new (0, $jFbNy.Slot)();
var $c34b71496108423e$var$reusableEmptyArray = [];
var $c34b71496108423e$var$emptySetPool = [];
var $c34b71496108423e$var$POOL_TARGET_SIZE = 100;
// Since this package might be used browsers, we should avoid using the
// Node built-in assert module.
function $c34b71496108423e$var$assert(condition, optionalMessage) {
    if (!condition) throw new Error(optionalMessage || "assertion failure");
}
function $c34b71496108423e$var$valueIs(a, b) {
    var len = a.length;
    return(// Unknown values are not equal to each other.
    len > 0 && // Both values must be ordinary (or both exceptional) to be equal.
    len === b.length && // The underlying value or exception must be the same.
    a[len - 1] === b[len - 1]);
}
function $c34b71496108423e$var$valueGet(value) {
    switch(value.length){
        case 0:
            throw new Error("unknown value");
        case 1:
            return value[0];
        case 2:
            throw value[1];
    }
}
function $c34b71496108423e$var$valueCopy(value) {
    return value.slice(0);
}
var $c34b71496108423e$var$Entry = /** @class */ function() {
    function Entry(fn, args) {
        this.fn = fn;
        this.args = args;
        this.parents = new Set();
        this.childValues = new Map();
        // When this Entry has children that are dirty, this property becomes
        // a Set containing other Entry objects, borrowed from emptySetPool.
        // When the set becomes empty, it gets recycled back to emptySetPool.
        this.dirtyChildren = null;
        this.dirty = true;
        this.recomputing = false;
        this.value = [];
        ++Entry.count;
    }
    // This is the most important method of the Entry API, because it
    // determines whether the cached this.value can be returned immediately,
    // or must be recomputed. The overall performance of the caching system
    // depends on the truth of the following observations: (1) this.dirty is
    // usually false, (2) this.dirtyChildren is usually null/empty, and thus
    // (3) valueGet(this.value) is usually returned without recomputation.
    Entry.prototype.recompute = function() {
        $c34b71496108423e$var$assert(!this.recomputing, "already recomputing");
        if (!$c34b71496108423e$var$rememberParent(this) && $c34b71496108423e$var$maybeReportOrphan(this)) // The recipient of the entry.reportOrphan callback decided to dispose
        // of this orphan entry by calling entry.dispose(), so we don't need to
        // (and should not) proceed with the recomputation.
        return void 0;
        return $c34b71496108423e$var$mightBeDirty(this) ? $c34b71496108423e$var$reallyRecompute(this) : $c34b71496108423e$var$valueGet(this.value);
    };
    Entry.prototype.setDirty = function() {
        if (this.dirty) return;
        this.dirty = true;
        this.value.length = 0;
        $c34b71496108423e$var$reportDirty(this);
        // We can go ahead and unsubscribe here, since any further dirty
        // notifications we receive will be redundant, and unsubscribing may
        // free up some resources, e.g. file watchers.
        $c34b71496108423e$var$maybeUnsubscribe(this);
    };
    Entry.prototype.dispose = function() {
        var _this = this;
        $c34b71496108423e$var$forgetChildren(this).forEach($c34b71496108423e$var$maybeReportOrphan);
        $c34b71496108423e$var$maybeUnsubscribe(this);
        // Because this entry has been kicked out of the cache (in index.js),
        // we've lost the ability to find out if/when this entry becomes dirty,
        // whether that happens through a subscription, because of a direct call
        // to entry.setDirty(), or because one of its children becomes dirty.
        // Because of this loss of future information, we have to assume the
        // worst (that this entry might have become dirty very soon), so we must
        // immediately mark this entry's parents as dirty. Normally we could
        // just call entry.setDirty() rather than calling parent.setDirty() for
        // each parent, but that would leave this entry in parent.childValues
        // and parent.dirtyChildren, which would prevent the child from being
        // truly forgotten.
        this.parents.forEach(function(parent) {
            parent.setDirty();
            $c34b71496108423e$var$forgetChild(parent, _this);
        });
    };
    Entry.count = 0;
    return Entry;
}();
function $c34b71496108423e$var$rememberParent(child) {
    var parent = $c34b71496108423e$var$parentEntrySlot.getValue();
    if (parent) {
        child.parents.add(parent);
        if (!parent.childValues.has(child)) parent.childValues.set(child, []);
        if ($c34b71496108423e$var$mightBeDirty(child)) $c34b71496108423e$var$reportDirtyChild(parent, child);
        else $c34b71496108423e$var$reportCleanChild(parent, child);
        return parent;
    }
}
function $c34b71496108423e$var$reallyRecompute(entry) {
    // Since this recomputation is likely to re-remember some of this
    // entry's children, we forget our children here but do not call
    // maybeReportOrphan until after the recomputation finishes.
    var originalChildren = $c34b71496108423e$var$forgetChildren(entry);
    // Set entry as the parent entry while calling recomputeNewValue(entry).
    $c34b71496108423e$var$parentEntrySlot.withValue(entry, $c34b71496108423e$var$recomputeNewValue, [
        entry
    ]);
    if ($c34b71496108423e$var$maybeSubscribe(entry)) // If we successfully recomputed entry.value and did not fail to
    // (re)subscribe, then this Entry is no longer explicitly dirty.
    $c34b71496108423e$var$setClean(entry);
    // Now that we've had a chance to re-remember any children that were
    // involved in the recomputation, we can safely report any orphan
    // children that remain.
    originalChildren.forEach($c34b71496108423e$var$maybeReportOrphan);
    return $c34b71496108423e$var$valueGet(entry.value);
}
function $c34b71496108423e$var$recomputeNewValue(entry) {
    entry.recomputing = true;
    // Set entry.value as unknown.
    entry.value.length = 0;
    try {
        // If entry.fn succeeds, entry.value will become a normal Value.
        entry.value[0] = entry.fn.apply(null, entry.args);
    } catch (e) {
        // If entry.fn throws, entry.value will become exceptional.
        entry.value[1] = e;
    }
    // Either way, this line is always reached.
    entry.recomputing = false;
}
function $c34b71496108423e$var$mightBeDirty(entry) {
    return entry.dirty || !!(entry.dirtyChildren && entry.dirtyChildren.size);
}
function $c34b71496108423e$var$setClean(entry) {
    entry.dirty = false;
    if ($c34b71496108423e$var$mightBeDirty(entry)) // This Entry may still have dirty children, in which case we can't
    // let our parents know we're clean just yet.
    return;
    $c34b71496108423e$var$reportClean(entry);
}
function $c34b71496108423e$var$reportDirty(child) {
    child.parents.forEach(function(parent) {
        return $c34b71496108423e$var$reportDirtyChild(parent, child);
    });
}
function $c34b71496108423e$var$reportClean(child) {
    child.parents.forEach(function(parent) {
        return $c34b71496108423e$var$reportCleanChild(parent, child);
    });
}
// Let a parent Entry know that one of its children may be dirty.
function $c34b71496108423e$var$reportDirtyChild(parent, child) {
    // Must have called rememberParent(child) before calling
    // reportDirtyChild(parent, child).
    $c34b71496108423e$var$assert(parent.childValues.has(child));
    $c34b71496108423e$var$assert($c34b71496108423e$var$mightBeDirty(child));
    if (!parent.dirtyChildren) parent.dirtyChildren = $c34b71496108423e$var$emptySetPool.pop() || new Set;
    else if (parent.dirtyChildren.has(child)) // If we already know this child is dirty, then we must have already
    // informed our own parents that we are dirty, so we can terminate
    // the recursion early.
    return;
    parent.dirtyChildren.add(child);
    $c34b71496108423e$var$reportDirty(parent);
}
// Let a parent Entry know that one of its children is no longer dirty.
function $c34b71496108423e$var$reportCleanChild(parent, child) {
    // Must have called rememberChild(child) before calling
    // reportCleanChild(parent, child).
    $c34b71496108423e$var$assert(parent.childValues.has(child));
    $c34b71496108423e$var$assert(!$c34b71496108423e$var$mightBeDirty(child));
    var childValue = parent.childValues.get(child);
    if (childValue.length === 0) parent.childValues.set(child, $c34b71496108423e$var$valueCopy(child.value));
    else if (!$c34b71496108423e$var$valueIs(childValue, child.value)) parent.setDirty();
    $c34b71496108423e$var$removeDirtyChild(parent, child);
    if ($c34b71496108423e$var$mightBeDirty(parent)) return;
    $c34b71496108423e$var$reportClean(parent);
}
function $c34b71496108423e$var$removeDirtyChild(parent, child) {
    var dc = parent.dirtyChildren;
    if (dc) {
        dc.delete(child);
        if (dc.size === 0) {
            if ($c34b71496108423e$var$emptySetPool.length < $c34b71496108423e$var$POOL_TARGET_SIZE) $c34b71496108423e$var$emptySetPool.push(dc);
            parent.dirtyChildren = null;
        }
    }
}
// If the given entry has a reportOrphan method, and no remaining parents,
// call entry.reportOrphan and return true iff it returns true. The
// reportOrphan function should return true to indicate entry.dispose()
// has been called, and the entry has been removed from any other caches
// (see index.js for the only current example).
function $c34b71496108423e$var$maybeReportOrphan(entry) {
    return entry.parents.size === 0 && typeof entry.reportOrphan === "function" && entry.reportOrphan() === true;
}
// Removes all children from this entry and returns an array of the
// removed children.
function $c34b71496108423e$var$forgetChildren(parent) {
    var children = $c34b71496108423e$var$reusableEmptyArray;
    if (parent.childValues.size > 0) {
        children = [];
        parent.childValues.forEach(function(_value, child) {
            $c34b71496108423e$var$forgetChild(parent, child);
            children.push(child);
        });
    }
    // After we forget all our children, this.dirtyChildren must be empty
    // and therefore must have been reset to null.
    $c34b71496108423e$var$assert(parent.dirtyChildren === null);
    return children;
}
function $c34b71496108423e$var$forgetChild(parent, child) {
    child.parents.delete(parent);
    parent.childValues.delete(child);
    $c34b71496108423e$var$removeDirtyChild(parent, child);
}
function $c34b71496108423e$var$maybeSubscribe(entry) {
    if (typeof entry.subscribe === "function") try {
        $c34b71496108423e$var$maybeUnsubscribe(entry); // Prevent double subscriptions.
        entry.unsubscribe = entry.subscribe.apply(null, entry.args);
    } catch (e) {
        // If this Entry has a subscribe function and it threw an exception
        // (or an unsubscribe function it previously returned now throws),
        // return false to indicate that we were not able to subscribe (or
        // unsubscribe), and this Entry should remain dirty.
        entry.setDirty();
        return false;
    }
    // Returning true indicates either that there was no entry.subscribe
    // function or that it succeeded.
    return true;
}
function $c34b71496108423e$var$maybeUnsubscribe(entry) {
    var unsubscribe = entry.unsubscribe;
    if (typeof unsubscribe === "function") {
        entry.unsubscribe = void 0;
        unsubscribe();
    }
}
// A trie data structure that holds object keys weakly, yet can also hold
// non-object keys, unlike the native `WeakMap`.
var $c34b71496108423e$export$6bd8d8299be3ac82 = /** @class */ function() {
    function KeyTrie(weakness) {
        this.weakness = weakness;
    }
    KeyTrie.prototype.lookup = function() {
        var array = [];
        for(var _i = 0; _i < arguments.length; _i++)array[_i] = arguments[_i];
        return this.lookupArray(array);
    };
    KeyTrie.prototype.lookupArray = function(array) {
        var node = this;
        array.forEach(function(key) {
            return node = node.getChildTrie(key);
        });
        return node.data || (node.data = Object.create(null));
    };
    KeyTrie.prototype.getChildTrie = function(key) {
        var map = this.weakness && $c34b71496108423e$var$isObjRef(key) ? this.weak || (this.weak = new WeakMap()) : this.strong || (this.strong = new Map());
        var child = map.get(key);
        if (!child) map.set(key, child = new KeyTrie(this.weakness));
        return child;
    };
    return KeyTrie;
}();
function $c34b71496108423e$var$isObjRef(value) {
    switch(typeof value){
        case "object":
            if (value === null) break;
        // Fall through to return true...
        case "function":
            return true;
    }
    return false;
}
// The defaultMakeCacheKey function is remarkably powerful, because it gives
// a unique object for any shallow-identical list of arguments. If you need
// to implement a custom makeCacheKey function, you may find it helpful to
// delegate the final work to defaultMakeCacheKey, which is why we export it
// here. However, you may want to avoid defaultMakeCacheKey if your runtime
// does not support WeakMap, or you have the ability to return a string key.
// In those cases, just write your own custom makeCacheKey functions.
var $c34b71496108423e$var$keyTrie = new $c34b71496108423e$export$6bd8d8299be3ac82(typeof WeakMap === "function");
function $c34b71496108423e$export$cd3144f8dd136006() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return $c34b71496108423e$var$keyTrie.lookupArray(args);
}
var $c34b71496108423e$var$caches = new Set();
function $c34b71496108423e$export$4997ffc0176396a6(originalFunction, options) {
    if (options === void 0) options = Object.create(null);
    var cache = new $c34b71496108423e$var$Cache(options.max || Math.pow(2, 16), function(entry) {
        return entry.dispose();
    });
    var disposable = !!options.disposable;
    var makeCacheKey = options.makeCacheKey || $c34b71496108423e$export$cd3144f8dd136006;
    function optimistic() {
        if (disposable && !$c34b71496108423e$var$parentEntrySlot.hasValue()) // If there's no current parent computation, and this wrapped
        // function is disposable (meaning we don't care about entry.value,
        // just dependency tracking), then we can short-cut everything else
        // in this function, because entry.recompute() is going to recycle
        // the entry object without recomputing anything, anyway.
        return void 0;
        var key = makeCacheKey.apply(null, arguments);
        if (key === void 0) return originalFunction.apply(null, arguments);
        var args = Array.prototype.slice.call(arguments);
        var entry = cache.get(key);
        if (entry) entry.args = args;
        else {
            entry = new $c34b71496108423e$var$Entry(originalFunction, args);
            cache.set(key, entry);
            entry.subscribe = options.subscribe;
            if (disposable) entry.reportOrphan = function() {
                return cache.delete(key);
            };
        }
        var value = entry.recompute();
        // Move this entry to the front of the least-recently used queue,
        // since we just finished computing its value.
        cache.set(key, entry);
        $c34b71496108423e$var$caches.add(cache);
        // Clean up any excess entries in the cache, but only if there is no
        // active parent entry, meaning we're not in the middle of a larger
        // computation that might be flummoxed by the cleaning.
        if (!$c34b71496108423e$var$parentEntrySlot.hasValue()) {
            $c34b71496108423e$var$caches.forEach(function(cache) {
                return cache.clean();
            });
            $c34b71496108423e$var$caches.clear();
        }
        // If options.disposable is truthy, the caller of wrap is telling us
        // they don't care about the result of entry.recompute(), so we should
        // avoid returning the value, so it won't be accidentally used.
        return disposable ? void 0 : value;
    }
    optimistic.dirty = function() {
        var key = makeCacheKey.apply(null, arguments);
        var child = key !== void 0 && cache.get(key);
        if (child) child.setDirty();
    };
    return optimistic;
}

});
parcelRegister("jFbNy", function(module, exports) {

$parcel$export(module.exports, "Slot", () => $e50aff8f879ebe36$export$8c6ed5c666ac1360);
// This currentContext variable will only be used if the makeSlotClass
// function is called, which happens only if this is the first copy of the
// @wry/context package to be imported.
var $e50aff8f879ebe36$var$currentContext = null;
// This unique internal object is used to denote the absence of a value
// for a given Slot, and is never exposed to outside code.
var $e50aff8f879ebe36$var$MISSING_VALUE = {};
var $e50aff8f879ebe36$var$idCounter = 1;
// Although we can't do anything about the cost of duplicated code from
// accidentally bundling multiple copies of the @wry/context package, we can
// avoid creating the Slot class more than once using makeSlotClass.
var $e50aff8f879ebe36$var$makeSlotClass = function() {
    return /** @class */ function() {
        function Slot() {
            // If you have a Slot object, you can find out its slot.id, but you cannot
            // guess the slot.id of a Slot you don't have access to, thanks to the
            // randomized suffix.
            this.id = [
                "slot",
                $e50aff8f879ebe36$var$idCounter++,
                Date.now(),
                Math.random().toString(36).slice(2)
            ].join(":");
        }
        Slot.prototype.hasValue = function() {
            for(var context_1 = $e50aff8f879ebe36$var$currentContext; context_1; context_1 = context_1.parent)// We use the Slot object iself as a key to its value, which means the
            // value cannot be obtained without a reference to the Slot object.
            if (this.id in context_1.slots) {
                var value = context_1.slots[this.id];
                if (value === $e50aff8f879ebe36$var$MISSING_VALUE) break;
                if (context_1 !== $e50aff8f879ebe36$var$currentContext) // Cache the value in currentContext.slots so the next lookup will
                // be faster. This caching is safe because the tree of contexts and
                // the values of the slots are logically immutable.
                $e50aff8f879ebe36$var$currentContext.slots[this.id] = value;
                return true;
            }
            if ($e50aff8f879ebe36$var$currentContext) // If a value was not found for this Slot, it's never going to be found
            // no matter how many times we look it up, so we might as well cache
            // the absence of the value, too.
            $e50aff8f879ebe36$var$currentContext.slots[this.id] = $e50aff8f879ebe36$var$MISSING_VALUE;
            return false;
        };
        Slot.prototype.getValue = function() {
            if (this.hasValue()) return $e50aff8f879ebe36$var$currentContext.slots[this.id];
        };
        Slot.prototype.withValue = function(value, callback, // Given the prevalence of arrow functions, specifying arguments is likely
        // to be much more common than specifying `this`, hence this ordering:
        args, thisArg) {
            var _a;
            var slots = (_a = {
                __proto__: null
            }, _a[this.id] = value, _a);
            var parent = $e50aff8f879ebe36$var$currentContext;
            $e50aff8f879ebe36$var$currentContext = {
                parent: parent,
                slots: slots
            };
            try {
                // Function.prototype.apply allows the arguments array argument to be
                // omitted or undefined, so args! is fine here.
                return callback.apply(thisArg, args);
            } finally{
                $e50aff8f879ebe36$var$currentContext = parent;
            }
        };
        // Capture the current context and wrap a callback function so that it
        // reestablishes the captured context when called.
        Slot.bind = function(callback) {
            var context = $e50aff8f879ebe36$var$currentContext;
            return function() {
                var saved = $e50aff8f879ebe36$var$currentContext;
                try {
                    $e50aff8f879ebe36$var$currentContext = context;
                    return callback.apply(this, arguments);
                } finally{
                    $e50aff8f879ebe36$var$currentContext = saved;
                }
            };
        };
        // Immediately run a callback function without any captured context.
        Slot.noContext = function(callback, // Given the prevalence of arrow functions, specifying arguments is likely
        // to be much more common than specifying `this`, hence this ordering:
        args, thisArg) {
            if ($e50aff8f879ebe36$var$currentContext) {
                var saved = $e50aff8f879ebe36$var$currentContext;
                try {
                    $e50aff8f879ebe36$var$currentContext = null;
                    // Function.prototype.apply allows the arguments array argument to be
                    // omitted or undefined, so args! is fine here.
                    return callback.apply(thisArg, args);
                } finally{
                    $e50aff8f879ebe36$var$currentContext = saved;
                }
            } else return callback.apply(thisArg, args);
        };
        return Slot;
    }();
};
// We store a single global implementation of the Slot class as a permanent
// non-enumerable symbol property of the Array constructor. This obfuscation
// does nothing to prevent access to the Slot class, but at least it ensures
// the implementation (i.e. currentContext) cannot be tampered with, and all
// copies of the @wry/context package (hopefully just one) will share the
// same Slot implementation. Since the first copy of the @wry/context package
// to be imported wins, this technique imposes a very high cost for any
// future breaking changes to the Slot class.
var $e50aff8f879ebe36$var$globalKey = "@wry/context:Slot";
var $e50aff8f879ebe36$var$host = Array;
var $e50aff8f879ebe36$export$8c6ed5c666ac1360 = $e50aff8f879ebe36$var$host[$e50aff8f879ebe36$var$globalKey] || function() {
    var Slot = $e50aff8f879ebe36$var$makeSlotClass();
    try {
        Object.defineProperty($e50aff8f879ebe36$var$host, $e50aff8f879ebe36$var$globalKey, {
            value: $e50aff8f879ebe36$var$host[$e50aff8f879ebe36$var$globalKey] = Slot,
            enumerable: false,
            writable: false,
            configurable: false
        });
    } finally{
        return Slot;
    }
}();
var $e50aff8f879ebe36$export$2385a24977818dd0 = $e50aff8f879ebe36$export$8c6ed5c666ac1360.bind, $e50aff8f879ebe36$export$9fa6f2e300a97f8 = $e50aff8f879ebe36$export$8c6ed5c666ac1360.noContext;
function $e50aff8f879ebe36$export$831dc9f2ab0a617b(callback, delay) {
    return setTimeout($e50aff8f879ebe36$export$2385a24977818dd0(callback), delay);
}
// Turn any generator function into an async function (using yield instead
// of await), with context automatically preserved across yields.
function $e50aff8f879ebe36$export$d5d7536e965c82da(genFn) {
    return function() {
        var gen = genFn.apply(this, arguments);
        var boundNext = $e50aff8f879ebe36$export$2385a24977818dd0(gen.next);
        var boundThrow = $e50aff8f879ebe36$export$2385a24977818dd0(gen.throw);
        return new Promise(function(resolve, reject) {
            function invoke(method, argument) {
                try {
                    var result = method.call(gen, argument);
                } catch (error) {
                    return reject(error);
                }
                var next = result.done ? resolve : invokeNext;
                if ($e50aff8f879ebe36$var$isPromiseLike(result.value)) result.value.then(next, result.done ? reject : invokeThrow);
                else next(result.value);
            }
            var invokeNext = function(value) {
                return invoke(boundNext, value);
            };
            var invokeThrow = function(error) {
                return invoke(boundThrow, error);
            };
            invokeNext();
        });
    };
}
function $e50aff8f879ebe36$var$isPromiseLike(value) {
    return value && typeof value.then === "function";
}
// If you use the fibers npm package to implement coroutines in Node.js,
// you should call this function at least once to ensure context management
// remains coherent across any yields.
var $e50aff8f879ebe36$var$wrappedFibers = [];
function $e50aff8f879ebe36$export$14794f6e0a4dc6a0(Fiber) {
    // There can be only one implementation of Fiber per process, so this array
    // should never grow longer than one element.
    if ($e50aff8f879ebe36$var$wrappedFibers.indexOf(Fiber) < 0) {
        var wrap = function(obj, method) {
            var fn = obj[method];
            obj[method] = function() {
                return $e50aff8f879ebe36$export$9fa6f2e300a97f8(fn, arguments, this);
            };
        };
        // These methods can yield, according to
        // https://github.com/laverdet/node-fibers/blob/ddebed9b8ae3883e57f822e2108e6943e5c8d2a8/fibers.js#L97-L100
        wrap(Fiber, "yield");
        wrap(Fiber.prototype, "run");
        wrap(Fiber.prototype, "throwInto");
        $e50aff8f879ebe36$var$wrappedFibers.push(Fiber);
    }
    return Fiber;
}

});



parcelRegister("h4ppL", function(module, exports) {

$parcel$export(module.exports, "onError", () => $c6d6862dd229df53$export$2288787135a8f66e);

var $3VFsf = parcelRequire("3VFsf");

var $clSzL = parcelRequire("clSzL");
function $c6d6862dd229df53$export$2288787135a8f66e(errorHandler) {
    return new (0, $clSzL.ApolloLink)(function(operation, forward) {
        return new (0, $clSzL.Observable)(function(observer) {
            var sub;
            var retriedSub;
            var retriedResult;
            try {
                sub = forward(operation).subscribe({
                    next: function(result) {
                        if (result.errors) {
                            retriedResult = errorHandler({
                                graphQLErrors: result.errors,
                                response: result,
                                operation: operation,
                                forward: forward
                            });
                            if (retriedResult) {
                                retriedSub = retriedResult.subscribe({
                                    next: observer.next.bind(observer),
                                    error: observer.error.bind(observer),
                                    complete: observer.complete.bind(observer)
                                });
                                return;
                            }
                        }
                        observer.next(result);
                    },
                    error: function(networkError) {
                        retriedResult = errorHandler({
                            operation: operation,
                            networkError: networkError,
                            graphQLErrors: networkError && networkError.result && networkError.result.errors,
                            forward: forward
                        });
                        if (retriedResult) {
                            retriedSub = retriedResult.subscribe({
                                next: observer.next.bind(observer),
                                error: observer.error.bind(observer),
                                complete: observer.complete.bind(observer)
                            });
                            return;
                        }
                        observer.error(networkError);
                    },
                    complete: function() {
                        if (!retriedResult) observer.complete.bind(observer)();
                    }
                });
            } catch (e) {
                errorHandler({
                    networkError: e,
                    operation: operation,
                    forward: forward
                });
                observer.error(e);
            }
            return function() {
                if (sub) sub.unsubscribe();
                if (retriedSub) sub.unsubscribe();
            };
        });
    });
}
var $c6d6862dd229df53$export$d2c8415987899609 = function(_super) {
    (0, $3VFsf.__extends)(ErrorLink, _super);
    function ErrorLink(errorHandler) {
        var _this = _super.call(this) || this;
        _this.link = $c6d6862dd229df53$export$2288787135a8f66e(errorHandler);
        return _this;
    }
    ErrorLink.prototype.request = function(operation, forward) {
        return this.link.request(operation, forward);
    };
    return ErrorLink;
}((0, $clSzL.ApolloLink));

});

parcelRegister("JPsIz", function(module, exports) {

$parcel$export(module.exports, "HttpLink", () => $089c1f6736cf7295$export$f4bbf1aec241cc1);

var $3VFsf = parcelRequire("3VFsf");

var $clSzL = parcelRequire("clSzL");

var $f0Elb = parcelRequire("f0Elb");
var $089c1f6736cf7295$export$95180a16573d6675 = function(linkOptions) {
    if (linkOptions === void 0) linkOptions = {};
    var _a = linkOptions.uri, uri = _a === void 0 ? '/graphql' : _a, fetcher = linkOptions.fetch, includeExtensions = linkOptions.includeExtensions, useGETForQueries = linkOptions.useGETForQueries, abortErrorDoesNotCauseError = linkOptions.abortErrorDoesNotCauseError, requestOptions = (0, $3VFsf.__rest)(linkOptions, [
        "uri",
        "fetch",
        "includeExtensions",
        "useGETForQueries",
        "abortErrorDoesNotCauseError"
    ]);
    (0, $f0Elb.checkFetcher)(fetcher);
    if (!fetcher) fetcher = fetch;
    var linkConfig = {
        http: {
            includeExtensions: includeExtensions
        },
        options: requestOptions.fetchOptions,
        credentials: requestOptions.credentials,
        headers: requestOptions.headers
    };
    return new (0, $clSzL.ApolloLink)(function(operation) {
        var chosenURI = (0, $f0Elb.selectURI)(operation, uri);
        var context = operation.getContext();
        var clientAwarenessHeaders = {};
        if (context.clientAwareness) {
            var _a = context.clientAwareness, name_1 = _a.name, version = _a.version;
            if (name_1) clientAwarenessHeaders['apollographql-client-name'] = name_1;
            if (version) clientAwarenessHeaders['apollographql-client-version'] = version;
        }
        var contextHeaders = (0, $3VFsf.__assign)({}, clientAwarenessHeaders, context.headers);
        var contextConfig = {
            http: context.http,
            options: context.fetchOptions,
            credentials: context.credentials,
            headers: contextHeaders
        };
        var _b = (0, $f0Elb.selectHttpOptionsAndBody)(operation, (0, $f0Elb.fallbackHttpConfig), linkConfig, contextConfig), options = _b.options, body = _b.body;
        var controller;
        if (!options.signal) {
            var _c = (0, $f0Elb.createSignalIfSupported)(), _controller = _c.controller, signal = _c.signal;
            controller = _controller;
            if (controller) options.signal = signal;
        }
        var definitionIsMutation = function(d) {
            return d.kind === 'OperationDefinition' && d.operation === 'mutation';
        };
        if (useGETForQueries && !operation.query.definitions.some(definitionIsMutation)) options.method = 'GET';
        if (options.method === 'GET') {
            var _d = $089c1f6736cf7295$var$rewriteURIForGET(chosenURI, body), newURI = _d.newURI, parseError = _d.parseError;
            if (parseError) return (0, $clSzL.fromError)(parseError);
            chosenURI = newURI;
        } else try {
            options.body = (0, $f0Elb.serializeFetchParameter)(body, 'Payload');
        } catch (parseError) {
            return (0, $clSzL.fromError)(parseError);
        }
        return new (0, $clSzL.Observable)(function(observer) {
            fetcher(chosenURI, options).then(function(response) {
                operation.setContext({
                    response: response
                });
                return response;
            }).then((0, $f0Elb.parseAndCheckHttpResponse)(operation)).then(function(result) {
                observer.next(result);
                observer.complete();
                return result;
            }).catch(function(err) {
                if (err.name === 'AbortError' && !abortErrorDoesNotCauseError) return;
                if (err.result && err.result.errors && err.result.data) observer.next(err.result);
                observer.error(err);
            });
            return function() {
                if (controller) controller.abort();
            };
        });
    });
};
function $089c1f6736cf7295$var$rewriteURIForGET(chosenURI, body) {
    var queryParams = [];
    var addQueryParam = function(key, value) {
        queryParams.push(key + "=" + encodeURIComponent(value));
    };
    if ('query' in body) addQueryParam('query', body.query);
    if (body.operationName) addQueryParam('operationName', body.operationName);
    if (body.variables) {
        var serializedVariables = void 0;
        try {
            serializedVariables = (0, $f0Elb.serializeFetchParameter)(body.variables, 'Variables map');
        } catch (parseError) {
            return {
                parseError: parseError
            };
        }
        addQueryParam('variables', serializedVariables);
    }
    if (body.extensions) {
        var serializedExtensions = void 0;
        try {
            serializedExtensions = (0, $f0Elb.serializeFetchParameter)(body.extensions, 'Extensions map');
        } catch (parseError) {
            return {
                parseError: parseError
            };
        }
        addQueryParam('extensions', serializedExtensions);
    }
    var fragment = '', preFragment = chosenURI;
    var fragmentStart = chosenURI.indexOf('#');
    if (fragmentStart !== -1) {
        fragment = chosenURI.substr(fragmentStart);
        preFragment = chosenURI.substr(0, fragmentStart);
    }
    var queryParamsPrefix = preFragment.indexOf('?') === -1 ? '?' : '&';
    var newURI = preFragment + queryParamsPrefix + queryParams.join('&') + fragment;
    return {
        newURI: newURI
    };
}
var $089c1f6736cf7295$export$f4bbf1aec241cc1 = function(_super) {
    (0, $3VFsf.__extends)(HttpLink, _super);
    function HttpLink(opts) {
        return _super.call(this, $089c1f6736cf7295$export$95180a16573d6675(opts).request) || this;
    }
    return HttpLink;
}((0, $clSzL.ApolloLink));

});
parcelRegister("f0Elb", function(module, exports) {

$parcel$export(module.exports, "fallbackHttpConfig", () => $aed625edf13c57eb$export$dd86f00dc866e75d);
$parcel$export(module.exports, "parseAndCheckHttpResponse", () => $aed625edf13c57eb$export$d4051215bea0639f);
$parcel$export(module.exports, "checkFetcher", () => $aed625edf13c57eb$export$8423f0cd3773115e);
$parcel$export(module.exports, "createSignalIfSupported", () => $aed625edf13c57eb$export$f5853cd1fc39aea6);
$parcel$export(module.exports, "selectHttpOptionsAndBody", () => $aed625edf13c57eb$export$a00ebfd5f1eebfb1);
$parcel$export(module.exports, "serializeFetchParameter", () => $aed625edf13c57eb$export$5f8e80ac52052e28);
$parcel$export(module.exports, "selectURI", () => $aed625edf13c57eb$export$63ccc2571850f81a);

var $3VFsf = parcelRequire("3VFsf");

var $1c8Um = parcelRequire("1c8Um");

var $1DiV8 = parcelRequire("1DiV8");
var $aed625edf13c57eb$var$defaultHttpOptions = {
    includeQuery: true,
    includeExtensions: false
};
var $aed625edf13c57eb$var$defaultHeaders = {
    accept: '*/*',
    'content-type': 'application/json'
};
var $aed625edf13c57eb$var$defaultOptions = {
    method: 'POST'
};
var $aed625edf13c57eb$export$dd86f00dc866e75d = {
    http: $aed625edf13c57eb$var$defaultHttpOptions,
    headers: $aed625edf13c57eb$var$defaultHeaders,
    options: $aed625edf13c57eb$var$defaultOptions
};
var $aed625edf13c57eb$export$c33ef9219f27efd7 = function(response, result, message) {
    var error = new Error(message);
    error.name = 'ServerError';
    error.response = response;
    error.statusCode = response.status;
    error.result = result;
    throw error;
};
var $aed625edf13c57eb$export$d4051215bea0639f = function(operations) {
    return function(response) {
        return response.text().then(function(bodyText) {
            try {
                return JSON.parse(bodyText);
            } catch (err) {
                var parseError = err;
                parseError.name = 'ServerParseError';
                parseError.response = response;
                parseError.statusCode = response.status;
                parseError.bodyText = bodyText;
                return Promise.reject(parseError);
            }
        }).then(function(result) {
            if (response.status >= 300) $aed625edf13c57eb$export$c33ef9219f27efd7(response, result, "Response not successful: Received status code " + response.status);
            if (!Array.isArray(result) && !result.hasOwnProperty('data') && !result.hasOwnProperty('errors')) $aed625edf13c57eb$export$c33ef9219f27efd7(response, result, "Server response was missing for query '" + (Array.isArray(operations) ? operations.map(function(op) {
                return op.operationName;
            }) : operations.operationName) + "'.");
            return result;
        });
    };
};
var $aed625edf13c57eb$export$8423f0cd3773115e = function(fetcher) {
    if (!fetcher && typeof fetch === 'undefined') {
        var library = 'unfetch';
        if (typeof window === 'undefined') library = 'node-fetch';
        throw new (0, $1DiV8.InvariantError)(1);
    }
};
var $aed625edf13c57eb$export$f5853cd1fc39aea6 = function() {
    if (typeof AbortController === 'undefined') return {
        controller: false,
        signal: false
    };
    var controller = new AbortController();
    var signal = controller.signal;
    return {
        controller: controller,
        signal: signal
    };
};
var $aed625edf13c57eb$export$a00ebfd5f1eebfb1 = function(operation, fallbackConfig) {
    var configs = [];
    for(var _i = 2; _i < arguments.length; _i++)configs[_i - 2] = arguments[_i];
    var options = (0, $3VFsf.__assign)({}, fallbackConfig.options, {
        headers: fallbackConfig.headers,
        credentials: fallbackConfig.credentials
    });
    var http = fallbackConfig.http;
    configs.forEach(function(config) {
        options = (0, $3VFsf.__assign)({}, options, config.options, {
            headers: (0, $3VFsf.__assign)({}, options.headers, config.headers)
        });
        if (config.credentials) options.credentials = config.credentials;
        http = (0, $3VFsf.__assign)({}, http, config.http);
    });
    var operationName = operation.operationName, extensions = operation.extensions, variables = operation.variables, query = operation.query;
    var body = {
        operationName: operationName,
        variables: variables
    };
    if (http.includeExtensions) body.extensions = extensions;
    if (http.includeQuery) body.query = (0, $1c8Um.print)(query);
    return {
        options: options,
        body: body
    };
};
var $aed625edf13c57eb$export$5f8e80ac52052e28 = function(p, label) {
    var serialized;
    try {
        serialized = JSON.stringify(p);
    } catch (e) {
        var parseError = new (0, $1DiV8.InvariantError)(2);
        parseError.parseError = e;
        throw parseError;
    }
    return serialized;
};
var $aed625edf13c57eb$export$63ccc2571850f81a = function(operation, fallbackURI) {
    var context = operation.getContext();
    var contextURI = context.uri;
    if (contextURI) return contextURI;
    else if (typeof fallbackURI === 'function') return fallbackURI(operation);
    else return fallbackURI || '/graphql';
};

});


parcelRegister("lC4FX", function(module, exports) {

$parcel$export(module.exports, "RetryLink", () => $fbc0c610016bf5c5$export$943d544ad120494a);

var $3VFsf = parcelRequire("3VFsf");

var $clSzL = parcelRequire("clSzL");
function $fbc0c610016bf5c5$var$buildDelayFunction(delayOptions) {
    var _a = delayOptions || {}, _b = _a.initial, initial = _b === void 0 ? 300 : _b, _c = _a.jitter, jitter = _c === void 0 ? true : _c, _d = _a.max, max = _d === void 0 ? Infinity : _d;
    var baseDelay = jitter ? initial : initial / 2;
    return function delayFunction(count) {
        var delay = Math.min(max, baseDelay * Math.pow(2, count));
        if (jitter) delay = Math.random() * delay;
        return delay;
    };
}
function $fbc0c610016bf5c5$var$buildRetryFunction(retryOptions) {
    var _a = retryOptions || {}, retryIf = _a.retryIf, _b = _a.max, max = _b === void 0 ? 5 : _b;
    return function retryFunction(count, operation, error) {
        if (count >= max) return false;
        return retryIf ? retryIf(error, operation) : !!error;
    };
}
var $fbc0c610016bf5c5$var$RetryableOperation = function() {
    function RetryableOperation(operation, nextLink, delayFor, retryIf) {
        var _this = this;
        this.operation = operation;
        this.nextLink = nextLink;
        this.delayFor = delayFor;
        this.retryIf = retryIf;
        this.retryCount = 0;
        this.values = [];
        this.complete = false;
        this.canceled = false;
        this.observers = [];
        this.currentSubscription = null;
        this.onNext = function(value) {
            _this.values.push(value);
            for(var _i = 0, _a = _this.observers; _i < _a.length; _i++){
                var observer = _a[_i];
                if (!observer) continue;
                observer.next(value);
            }
        };
        this.onComplete = function() {
            _this.complete = true;
            for(var _i = 0, _a = _this.observers; _i < _a.length; _i++){
                var observer = _a[_i];
                if (!observer) continue;
                observer.complete();
            }
        };
        this.onError = function(error) {
            return (0, $3VFsf.__awaiter)(_this, void 0, void 0, function() {
                var shouldRetry, _i, _a, observer;
                return (0, $3VFsf.__generator)(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            this.retryCount += 1;
                            return [
                                4,
                                this.retryIf(this.retryCount, this.operation, error)
                            ];
                        case 1:
                            shouldRetry = _b.sent();
                            if (shouldRetry) {
                                this.scheduleRetry(this.delayFor(this.retryCount, this.operation, error));
                                return [
                                    2
                                ];
                            }
                            this.error = error;
                            for(_i = 0, _a = this.observers; _i < _a.length; _i++){
                                observer = _a[_i];
                                if (!observer) continue;
                                observer.error(error);
                            }
                            return [
                                2
                            ];
                    }
                });
            });
        };
    }
    RetryableOperation.prototype.subscribe = function(observer) {
        if (this.canceled) throw new Error("Subscribing to a retryable link that was canceled is not supported");
        this.observers.push(observer);
        for(var _i = 0, _a = this.values; _i < _a.length; _i++){
            var value = _a[_i];
            observer.next(value);
        }
        if (this.complete) observer.complete();
        else if (this.error) observer.error(this.error);
    };
    RetryableOperation.prototype.unsubscribe = function(observer) {
        var index = this.observers.indexOf(observer);
        if (index < 0) throw new Error("RetryLink BUG! Attempting to unsubscribe unknown observer!");
        this.observers[index] = null;
        if (this.observers.every(function(o) {
            return o === null;
        })) this.cancel();
    };
    RetryableOperation.prototype.start = function() {
        if (this.currentSubscription) return;
        this.try();
    };
    RetryableOperation.prototype.cancel = function() {
        if (this.currentSubscription) this.currentSubscription.unsubscribe();
        clearTimeout(this.timerId);
        this.timerId = null;
        this.currentSubscription = null;
        this.canceled = true;
    };
    RetryableOperation.prototype.try = function() {
        this.currentSubscription = this.nextLink(this.operation).subscribe({
            next: this.onNext,
            error: this.onError,
            complete: this.onComplete
        });
    };
    RetryableOperation.prototype.scheduleRetry = function(delay) {
        var _this = this;
        if (this.timerId) throw new Error("RetryLink BUG! Encountered overlapping retries");
        this.timerId = setTimeout(function() {
            _this.timerId = null;
            _this.try();
        }, delay);
    };
    return RetryableOperation;
}();
var $fbc0c610016bf5c5$export$943d544ad120494a = function(_super) {
    (0, $3VFsf.__extends)(RetryLink, _super);
    function RetryLink(options) {
        var _this = _super.call(this) || this;
        var _a = options || {}, attempts = _a.attempts, delay = _a.delay;
        _this.delayFor = typeof delay === 'function' ? delay : $fbc0c610016bf5c5$var$buildDelayFunction(delay);
        _this.retryIf = typeof attempts === 'function' ? attempts : $fbc0c610016bf5c5$var$buildRetryFunction(attempts);
        return _this;
    }
    RetryLink.prototype.request = function(operation, nextLink) {
        var retryable = new $fbc0c610016bf5c5$var$RetryableOperation(operation, nextLink, this.delayFor, this.retryIf);
        retryable.start();
        return new (0, $clSzL.Observable)(function(observer) {
            retryable.subscribe(observer);
            return function() {
                retryable.unsubscribe(observer);
            };
        });
    };
    return RetryLink;
}((0, $clSzL.ApolloLink));

});

parcelRegister("cuKXc", function(module, exports) {

$parcel$export(module.exports, "fragmentCacheRedirect", () => $918cb5692ff82562$export$5133c88128301697);
$parcel$export(module.exports, "fragmentLinkState", () => $918cb5692ff82562$export$3f9ecfb4d42ab23d);

var $jojW6 = parcelRequire("jojW6");

var $9HlP2 = parcelRequire("9HlP2");

var $ivfDv = parcelRequire("ivfDv");
function $918cb5692ff82562$export$5133c88128301697(dataIdFromObject) {
    if (dataIdFromObject === void 0) dataIdFromObject = (0, $ivfDv.defaultDataIdFromObject);
    return {
        getFragment: function(_, _a) {
            var id = _a.id, __typename = _a.__typename;
            return (0, $jojW6.toIdValue)(dataIdFromObject({
                __typename: __typename,
                id: id
            }));
        }
    };
}
function $918cb5692ff82562$export$3f9ecfb4d42ab23d(apolloCache) {
    return (0, $9HlP2.withClientState)({
        cache: apolloCache,
        resolvers: {
            Query: {
                getFragment: function(_, _a, _b) {
                    var __typename = _a.__typename, id = _a.id;
                    var cache = _b.cache;
                    var fragmentId = cache.config.dataIdFromObject({
                        __typename: __typename,
                        id: id
                    });
                    return cache.data.data[fragmentId];
                }
            }
        }
    });
}

});
parcelRegister("9HlP2", function(module, exports) {

$parcel$export(module.exports, "withClientState", () => $70f90ea50d538958$export$a13f755900e15d9e);

var $clSzL = parcelRequire("clSzL");

var $jojW6 = parcelRequire("jojW6");

var $jWd7i = parcelRequire("jWd7i");

var $b2p88 = parcelRequire("b2p88");
var $70f90ea50d538958$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $70f90ea50d538958$var$graphql = $jWd7i.graphql;
var $70f90ea50d538958$var$capitalizeFirstLetter = function(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
};
var $70f90ea50d538958$export$a13f755900e15d9e = function(clientStateConfig) {
    if (clientStateConfig === void 0) clientStateConfig = {
        resolvers: {},
        defaults: {}
    };
    var defaults = clientStateConfig.defaults, cache = clientStateConfig.cache, typeDefs = clientStateConfig.typeDefs, fragmentMatcher = clientStateConfig.fragmentMatcher;
    if (cache && defaults) cache.writeData({
        data: defaults
    });
    return new (function(_super) {
        $70f90ea50d538958$var$__extends(StateLink, _super);
        function StateLink() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        StateLink.prototype.writeDefaults = function() {
            if (cache && defaults) cache.writeData({
                data: defaults
            });
        };
        StateLink.prototype.request = function(operation, forward) {
            if (forward === void 0) forward = function() {
                return (0, $clSzL.Observable).of({
                    data: {}
                });
            };
            if (typeDefs) {
                var directives_1 = 'directive @client on FIELD';
                var definition_1 = (0, $b2p88.normalizeTypeDefs)(typeDefs);
                operation.setContext(function(_a) {
                    var _b = _a.schemas, schemas = _b === void 0 ? [] : _b;
                    return {
                        schemas: schemas.concat([
                            {
                                definition: definition_1,
                                directives: directives_1
                            }
                        ])
                    };
                });
            }
            var isClient = (0, $jojW6.hasDirectives)([
                'client'
            ], operation.query);
            if (!isClient) return forward(operation);
            var resolvers = typeof clientStateConfig.resolvers === 'function' ? clientStateConfig.resolvers() : clientStateConfig.resolvers;
            var server = (0, $b2p88.removeClientSetsFromDocument)(operation.query);
            var query = operation.query;
            var type = $70f90ea50d538958$var$capitalizeFirstLetter(((0, $jojW6.getMainDefinition)(query) || {}).operation) || 'Query';
            var resolver = function(fieldName, rootValue, args, context, info) {
                if (rootValue === void 0) rootValue = {};
                var resultKey = info.resultKey;
                var aliasedNode = rootValue[resultKey];
                var preAliasingNode = rootValue[fieldName];
                var aliasNeeded = resultKey !== fieldName;
                if (aliasedNode !== undefined || preAliasingNode !== undefined) return aliasedNode || preAliasingNode;
                var resolverMap = resolvers[rootValue.__typename || type];
                if (resolverMap) {
                    var resolve = resolverMap[fieldName];
                    if (resolve) return resolve(rootValue, args, context, info);
                }
                return (aliasNeeded ? aliasedNode : preAliasingNode) || (defaults || {})[fieldName];
            };
            if (server) operation.query = server;
            var obs = server && forward ? forward(operation) : (0, $clSzL.Observable).of({
                data: {}
            });
            return new (0, $clSzL.Observable)(function(observer) {
                var complete = false;
                var handlingNext = false;
                obs.subscribe({
                    next: function(_a) {
                        var data = _a.data, errors = _a.errors;
                        var observerErrorHandler = observer.error.bind(observer);
                        var context = operation.getContext();
                        handlingNext = true;
                        $70f90ea50d538958$var$graphql(resolver, query, data, context, operation.variables, {
                            fragmentMatcher: fragmentMatcher
                        }).then(function(nextData) {
                            observer.next({
                                data: nextData,
                                errors: errors
                            });
                            if (complete) observer.complete();
                            handlingNext = false;
                        }).catch(observerErrorHandler);
                    },
                    error: observer.error.bind(observer),
                    complete: function() {
                        if (!handlingNext) observer.complete();
                        complete = true;
                    }
                });
            });
        };
        return StateLink;
    }((0, $clSzL.ApolloLink)))();
};

});
parcelRegister("jWd7i", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3VFsf = parcelRequire("3VFsf");

var $jojW6 = parcelRequire("jojW6");

var $jDjTr = parcelRequire("jDjTr");
function $e83d9bca6fb9481d$var$graphql(resolver, document, rootValue, contextValue, variableValues, execOptions) {
    if (execOptions === void 0) execOptions = {};
    var mainDefinition = $jojW6.getMainDefinition(document);
    var fragments = $jojW6.getFragmentDefinitions(document);
    var fragmentMap = $jojW6.createFragmentMap(fragments);
    var resultMapper = execOptions.resultMapper;
    var fragmentMatcher = execOptions.fragmentMatcher || function() {
        return true;
    };
    var execContext = {
        fragmentMap: fragmentMap,
        contextValue: contextValue,
        variableValues: variableValues,
        resultMapper: resultMapper,
        resolver: resolver,
        fragmentMatcher: fragmentMatcher
    };
    return $e83d9bca6fb9481d$var$executeSelectionSet(mainDefinition.selectionSet, rootValue, execContext);
}
module.exports.graphql = $e83d9bca6fb9481d$var$graphql;
function $e83d9bca6fb9481d$var$executeSelectionSet(selectionSet, rootValue, execContext) {
    return $3VFsf.__awaiter(this, void 0, void 0, function() {
        var fragmentMap, contextValue, variables, result, execute;
        var _this = this;
        return $3VFsf.__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
                    result = {};
                    execute = function(selection) {
                        return $3VFsf.__awaiter(_this, void 0, void 0, function() {
                            var fieldResult, resultFieldKey, fragment, typeCondition, fragmentResult;
                            return $3VFsf.__generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        if (!$jojW6.shouldInclude(selection, variables)) return [
                                            2
                                        ];
                                        if (!$jojW6.isField(selection)) return [
                                            3,
                                            2
                                        ];
                                        return [
                                            4,
                                            $e83d9bca6fb9481d$var$executeField(selection, rootValue, execContext)
                                        ];
                                    case 1:
                                        fieldResult = _a.sent();
                                        resultFieldKey = $jojW6.resultKeyNameFromField(selection);
                                        if (fieldResult !== undefined) {
                                            if (result[resultFieldKey] === undefined) result[resultFieldKey] = fieldResult;
                                            else $jDjTr.merge(result[resultFieldKey], fieldResult);
                                        }
                                        return [
                                            2
                                        ];
                                    case 2:
                                        if ($jojW6.isInlineFragment(selection)) fragment = selection;
                                        else {
                                            fragment = fragmentMap[selection.name.value];
                                            if (!fragment) throw new Error("No fragment named " + selection.name.value);
                                        }
                                        typeCondition = fragment.typeCondition.name.value;
                                        if (!execContext.fragmentMatcher(rootValue, typeCondition, contextValue)) return [
                                            3,
                                            4
                                        ];
                                        return [
                                            4,
                                            $e83d9bca6fb9481d$var$executeSelectionSet(fragment.selectionSet, rootValue, execContext)
                                        ];
                                    case 3:
                                        fragmentResult = _a.sent();
                                        $jDjTr.merge(result, fragmentResult);
                                        _a.label = 4;
                                    case 4:
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                    };
                    return [
                        4,
                        Promise.all(selectionSet.selections.map(execute))
                    ];
                case 1:
                    _a.sent();
                    if (execContext.resultMapper) return [
                        2,
                        execContext.resultMapper(result, rootValue)
                    ];
                    return [
                        2,
                        result
                    ];
            }
        });
    });
}
function $e83d9bca6fb9481d$var$executeField(field, rootValue, execContext) {
    return $3VFsf.__awaiter(this, void 0, void 0, function() {
        var variables, contextValue, resolver, fieldName, args, info, result;
        return $3VFsf.__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    variables = execContext.variableValues, contextValue = execContext.contextValue, resolver = execContext.resolver;
                    fieldName = field.name.value;
                    args = $jojW6.argumentsObjectFromField(field, variables);
                    info = {
                        isLeaf: !field.selectionSet,
                        resultKey: $jojW6.resultKeyNameFromField(field),
                        directives: $jojW6.getDirectiveInfoFromField(field, variables),
                        field: field
                    };
                    return [
                        4,
                        resolver(fieldName, rootValue, args, contextValue, info)
                    ];
                case 1:
                    result = _a.sent();
                    if (!field.selectionSet) return [
                        2,
                        result
                    ];
                    if (result == null) return [
                        2,
                        result
                    ];
                    if (Array.isArray(result)) return [
                        2,
                        $e83d9bca6fb9481d$var$executeSubSelectedArray(field, result, execContext)
                    ];
                    return [
                        2,
                        $e83d9bca6fb9481d$var$executeSelectionSet(field.selectionSet, result, execContext)
                    ];
            }
        });
    });
}
function $e83d9bca6fb9481d$var$executeSubSelectedArray(field, result, execContext) {
    return Promise.all(result.map(function(item) {
        if (item === null) return null;
        if (Array.isArray(item)) return $e83d9bca6fb9481d$var$executeSubSelectedArray(field, item, execContext);
        return $e83d9bca6fb9481d$var$executeSelectionSet(field.selectionSet, item, execContext);
    }));
}

});
parcelRegister("jDjTr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $jojW6 = parcelRequire("jojW6");
function $e4b11739b667b187$var$graphql(resolver, document, rootValue, contextValue, variableValues, execOptions) {
    if (variableValues === void 0) variableValues = {};
    if (execOptions === void 0) execOptions = {};
    var mainDefinition = $jojW6.getMainDefinition(document);
    var fragments = $jojW6.getFragmentDefinitions(document);
    var fragmentMap = $jojW6.createFragmentMap(fragments);
    var resultMapper = execOptions.resultMapper;
    var fragmentMatcher = execOptions.fragmentMatcher || function() {
        return true;
    };
    var execContext = {
        fragmentMap: fragmentMap,
        contextValue: contextValue,
        variableValues: variableValues,
        resultMapper: resultMapper,
        resolver: resolver,
        fragmentMatcher: fragmentMatcher
    };
    return $e4b11739b667b187$var$executeSelectionSet(mainDefinition.selectionSet, rootValue, execContext);
}
module.exports.graphql = $e4b11739b667b187$var$graphql;
function $e4b11739b667b187$var$executeSelectionSet(selectionSet, rootValue, execContext) {
    var fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
    var result = {};
    selectionSet.selections.forEach(function(selection) {
        if (variables && !$jojW6.shouldInclude(selection, variables)) return;
        if ($jojW6.isField(selection)) {
            var fieldResult = $e4b11739b667b187$var$executeField(selection, rootValue, execContext);
            var resultFieldKey = $jojW6.resultKeyNameFromField(selection);
            if (fieldResult !== undefined) {
                if (result[resultFieldKey] === undefined) result[resultFieldKey] = fieldResult;
                else $e4b11739b667b187$var$merge(result[resultFieldKey], fieldResult);
            }
        } else {
            var fragment = void 0;
            if ($jojW6.isInlineFragment(selection)) fragment = selection;
            else {
                fragment = fragmentMap[selection.name.value];
                if (!fragment) throw new Error("No fragment named " + selection.name.value);
            }
            var typeCondition = fragment.typeCondition.name.value;
            if (execContext.fragmentMatcher(rootValue, typeCondition, contextValue)) {
                var fragmentResult = $e4b11739b667b187$var$executeSelectionSet(fragment.selectionSet, rootValue, execContext);
                $e4b11739b667b187$var$merge(result, fragmentResult);
            }
        }
    });
    if (execContext.resultMapper) return execContext.resultMapper(result, rootValue);
    return result;
}
function $e4b11739b667b187$var$executeField(field, rootValue, execContext) {
    var variables = execContext.variableValues, contextValue = execContext.contextValue, resolver = execContext.resolver;
    var fieldName = field.name.value;
    var args = $jojW6.argumentsObjectFromField(field, variables);
    var info = {
        isLeaf: !field.selectionSet,
        resultKey: $jojW6.resultKeyNameFromField(field),
        directives: $jojW6.getDirectiveInfoFromField(field, variables),
        field: field
    };
    var result = resolver(fieldName, rootValue, args, contextValue, info);
    if (!field.selectionSet) return result;
    if (result == null) return result;
    if (Array.isArray(result)) return $e4b11739b667b187$var$executeSubSelectedArray(field, result, execContext);
    return $e4b11739b667b187$var$executeSelectionSet(field.selectionSet, result, execContext);
}
function $e4b11739b667b187$var$executeSubSelectedArray(field, result, execContext) {
    return result.map(function(item) {
        if (item === null) return null;
        if (Array.isArray(item)) return $e4b11739b667b187$var$executeSubSelectedArray(field, item, execContext);
        return $e4b11739b667b187$var$executeSelectionSet(field.selectionSet, item, execContext);
    });
}
var $e4b11739b667b187$var$hasOwn = Object.prototype.hasOwnProperty;
function $e4b11739b667b187$var$merge(dest, src) {
    if (src !== null && typeof src === 'object') Object.keys(src).forEach(function(key) {
        var srcVal = src[key];
        if (!$e4b11739b667b187$var$hasOwn.call(dest, key)) dest[key] = srcVal;
        else $e4b11739b667b187$var$merge(dest[key], srcVal);
    });
}
module.exports.merge = $e4b11739b667b187$var$merge;

});


parcelRegister("b2p88", function(module, exports) {

$parcel$export(module.exports, "removeClientSetsFromDocument", () => $80935fed9657b3c7$export$8eae69e876ee321e);
$parcel$export(module.exports, "normalizeTypeDefs", () => $80935fed9657b3c7$export$467f9c465e4ace4e);

var $1c8Um = parcelRequire("1c8Um");

var $jojW6 = parcelRequire("jojW6");
var $80935fed9657b3c7$var$connectionRemoveConfig = {
    test: function(directive) {
        return directive.name.value === 'client';
    },
    remove: true
};
var $80935fed9657b3c7$var$removed = new Map();
function $80935fed9657b3c7$export$8eae69e876ee321e(query) {
    var cached = $80935fed9657b3c7$var$removed.get(query);
    if (cached) return cached;
    (0, $jojW6.checkDocument)(query);
    var docClone = (0, $jojW6.removeDirectivesFromDocument)([
        $80935fed9657b3c7$var$connectionRemoveConfig
    ], query);
    $80935fed9657b3c7$var$removed.set(query, docClone);
    return docClone;
}
function $80935fed9657b3c7$export$467f9c465e4ace4e(typeDefs) {
    var defs = Array.isArray(typeDefs) ? typeDefs : [
        typeDefs
    ];
    return defs.map(function(typeDef) {
        return typeof typeDef === 'string' ? typeDef : (0, $1c8Um.print)(typeDef);
    }).map(function(str) {
        return str.trim();
    }).join('\n');
}

});



parcelRegister("dxpxC", function(module, exports) {

$parcel$export(module.exports, "UFOLoggerLink", () => $4350c2bcf1320fcf$export$fb326ed954631f3f);

var $clSzL = parcelRequire("clSzL");

var $bFU4G = parcelRequire("bFU4G");
const $4350c2bcf1320fcf$export$fb326ed954631f3f = new (0, $clSzL.ApolloLink)((operation, forward)=>{
    const networkStart = performance.now();
    return forward(operation).map((response)=>{
        const networkComplete = performance.now();
        const operationName = operation.operationName ?? 'unnamed';
        (0, $bFU4G.addSpanToAll)('graphql', operationName, [
            {
                name: 'network'
            }
        ], networkStart, networkComplete);
        return response;
    });
});

});

parcelRegister("l0T7c", function(module, exports) {
module.exports = JSON.parse("{\"__schema\":{\"types\":[{\"kind\":\"UNION\",\"name\":\"AllActivityFeedItemUnion\",\"possibleTypes\":[{\"name\":\"HistoryItem\"},{\"name\":\"CommentItem\"},{\"name\":\"WorklogItem\"},{\"name\":\"IncidentItem\"},{\"name\":\"ApprovalItem\"},{\"name\":\"HiddenCommentItem\"}]},{\"kind\":\"UNION\",\"name\":\"ApprovalActivityValueUnion\",\"possibleTypes\":[{\"name\":\"ApprovalCreated\"},{\"name\":\"ApproverDecision\"},{\"name\":\"ApprovalCompleted\"}]},{\"kind\":\"UNION\",\"name\":\"ConfluencePageUnion\",\"possibleTypes\":[{\"name\":\"ConfluencePage\"},{\"name\":\"FailedRemoteLink\"}]},{\"kind\":\"UNION\",\"name\":\"GQLCategorizedField\",\"possibleTypes\":[{\"name\":\"GQLSortableField\"},{\"name\":\"GQLSearchableField\"}]},{\"kind\":\"UNION\",\"name\":\"GadgetParameters\",\"possibleTypes\":[{\"name\":\"VotedGadgetParameters\"},{\"name\":\"AssignedToMeGadgetParameters\"},{\"name\":\"WatchedGadgetParameters\"},{\"name\":\"InProgressGadgetParameters\"},{\"name\":\"FilterResultsGadgetParameters\"},{\"name\":\"TwoDimensionalStatisticsParameters\"},{\"name\":\"PieChartParameters\"},{\"name\":\"IssueStatisticsParameters\"},{\"name\":\"WorkloadPieChartParameters\"},{\"name\":\"ActivityStreamGadgetParameters\"},{\"name\":\"CreatedVsResolvedGadgetParameters\"},{\"name\":\"SprintGadgetParameters\"},{\"name\":\"ProjectsGadgetParameters\"},{\"name\":\"ConnectGadgetParameters\"},{\"name\":\"NotConfiguredGadgetParameters\"},{\"name\":\"UnsupportedGadgetParameters\"}]},{\"kind\":\"UNION\",\"name\":\"GroupByFieldUnion\",\"possibleTypes\":[{\"name\":\"PriorityField\"},{\"name\":\"StatusField\"},{\"name\":\"UserField\"},{\"name\":\"LabelsField\"},{\"name\":\"SelectCustomField\"},{\"name\":\"JWMCategoryCustomField\"},{\"name\":\"IssueTypeField\"},{\"name\":\"StoryPointsField\"},{\"name\":\"SprintCustomField\"},{\"name\":\"FloatCustomField\"}]},{\"kind\":\"UNION\",\"name\":\"GroupSectionItem\",\"possibleTypes\":[{\"name\":\"FieldSectionItem\"},{\"name\":\"EcosystemSectionItem\"},{\"name\":\"ForgeSectionItem\"},{\"name\":\"PanelSectionItem\"}]},{\"kind\":\"UNION\",\"name\":\"HistoryValue\",\"possibleTypes\":[{\"name\":\"AssigneeFieldValue\"},{\"name\":\"PriorityFieldValue\"},{\"name\":\"StatusFieldValue\"},{\"name\":\"WorkLogFieldValue\"},{\"name\":\"RespondersFieldValue\"},{\"name\":\"GenericFieldValue\"}]},{\"kind\":\"UNION\",\"name\":\"IncidentActivityValueUnion\",\"possibleTypes\":[{\"name\":\"ResponderAlertAssignedValue\"},{\"name\":\"AlertValue\"},{\"name\":\"ResponderAlertPriorityChangedValue\"},{\"name\":\"IccSessionValue\"},{\"name\":\"IccSessionInvitationValue\"},{\"name\":\"StakeholderUpdatedValue\"},{\"name\":\"IncidentStakeholderActionValue\"}]},{\"kind\":\"UNION\",\"name\":\"IssueFieldUnion\",\"possibleTypes\":[{\"name\":\"PriorityField\"},{\"name\":\"StatusField\"},{\"name\":\"IssueTypeField\"},{\"name\":\"ProjectComponentsField\"},{\"name\":\"LabelsField\"},{\"name\":\"WatchersField\"},{\"name\":\"UserField\"},{\"name\":\"TextField\"},{\"name\":\"VersionsField\"},{\"name\":\"DateField\"},{\"name\":\"DateTimeField\"},{\"name\":\"IssueKeyField\"},{\"name\":\"ProjectField\"},{\"name\":\"ResolutionField\"},{\"name\":\"TimeTrackingField\"},{\"name\":\"TimeOriginalEstimateField\"},{\"name\":\"TimeEstimateField\"},{\"name\":\"TimeSpentField\"},{\"name\":\"StoryPointsField\"},{\"name\":\"EpicLinkField\"},{\"name\":\"EpicNameField\"},{\"name\":\"ColorField\"},{\"name\":\"EpicColorField\"},{\"name\":\"SprintCustomField\"},{\"name\":\"SelectCustomField\"},{\"name\":\"FlaggedCustomField\"},{\"name\":\"UserPickerCustomField\"},{\"name\":\"TextAreaCustomField\"},{\"name\":\"FloatCustomField\"},{\"name\":\"DatePickerCustomField\"},{\"name\":\"TextFieldCustomField\"},{\"name\":\"MultiSelectCustomField\"},{\"name\":\"LabelsCustomField\"},{\"name\":\"MultiUserPickerCustomField\"},{\"name\":\"PeopleCustomField\"},{\"name\":\"UrlCustomField\"},{\"name\":\"VersionCustomField\"},{\"name\":\"GroupPickerCustomField\"},{\"name\":\"MultiVersionCustomField\"},{\"name\":\"MultiGroupPickerCustomField\"},{\"name\":\"CheckBoxesCustomField\"},{\"name\":\"RadioButtonsCustomField\"},{\"name\":\"DateTimeCustomField\"},{\"name\":\"SeverityField\"},{\"name\":\"AffectedServicesField\"},{\"name\":\"TechLeadField\"},{\"name\":\"AttachmentsField\"},{\"name\":\"GlancesField\"},{\"name\":\"SecurityLevelField\"},{\"name\":\"IssueLinksField\"},{\"name\":\"IssuesInEpicField\"},{\"name\":\"SubtasksField\"},{\"name\":\"ChildIssuesField\"},{\"name\":\"CascadingSelectCustomField\"},{\"name\":\"CmdbField\"},{\"name\":\"SLACustomField\"},{\"name\":\"ProjectCustomField\"},{\"name\":\"EpicStatusField\"},{\"name\":\"ParentField\"},{\"name\":\"JWMCategoryCustomField\"},{\"name\":\"CommentSummaryField\"}]},{\"kind\":\"UNION\",\"name\":\"IssueSections\",\"possibleTypes\":[{\"name\":\"PrimarySecondaryContextSections\"},{\"name\":\"JsdSections\"}]},{\"kind\":\"UNION\",\"name\":\"JiraActiveBackgroundDetailsResult\",\"possibleTypes\":[{\"name\":\"JiraColorBackground\"},{\"name\":\"JiraGradientBackground\"},{\"name\":\"JiraMediaBackground\"},{\"name\":\"JiraAttachmentBackground\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraAtlassianIntelligenceAction\",\"possibleTypes\":[{\"name\":\"JiraAccessAtlassianIntelligenceFeature\"},{\"name\":\"JiraEnableAtlassianIntelligenceDeepLink\"},{\"name\":\"JiraContactOrgAdminToEnableAtlassianIntelligence\"}]},{\"kind\":\"UNION\",\"name\":\"JiraBackgroundUploadTokenResult\",\"possibleTypes\":[{\"name\":\"JiraBackgroundUploadToken\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraBoardResult\",\"possibleTypes\":[{\"name\":\"JiraBoard\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraChildIssues\",\"possibleTypes\":[{\"name\":\"JiraChildIssuesWithinLimit\"},{\"name\":\"JiraChildIssuesExceedingLimit\"}]},{\"kind\":\"UNION\",\"name\":\"JiraCommentVisibility\",\"possibleTypes\":[{\"name\":\"JiraRoleVisibility\"},{\"name\":\"JiraGroupVisibility\"}]},{\"kind\":\"UNION\",\"name\":\"JiraConfluencePageContent\",\"possibleTypes\":[{\"name\":\"JiraConfluencePageContentDetails\"},{\"name\":\"JiraConfluencePageContentError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraContainerNavigationResult\",\"possibleTypes\":[{\"name\":\"JiraContainerNavigation\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraDefaultUnsplashImagesPageResult\",\"possibleTypes\":[{\"name\":\"JiraDefaultUnsplashImagesPage\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraFavourite\",\"possibleTypes\":[{\"name\":\"JiraProject\"},{\"name\":\"JiraSystemFilter\"},{\"name\":\"JiraCustomFilter\"},{\"name\":\"JiraDashboard\"},{\"name\":\"JiraPlan\"},{\"name\":\"JiraBoard\"},{\"name\":\"JiraServiceManagementQueue\"}]},{\"kind\":\"UNION\",\"name\":\"JiraFieldFormatConfig\",\"possibleTypes\":[{\"name\":\"JiraNumberFieldFormatConfig\"}]},{\"kind\":\"UNION\",\"name\":\"JiraFieldSetViewResult\",\"possibleTypes\":[{\"name\":\"JiraFieldSetView\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraFormattingExpression\",\"possibleTypes\":[{\"name\":\"JiraFormattingSingleValueOperand\"},{\"name\":\"JiraFormattingTwoValueOperand\"},{\"name\":\"JiraFormattingMultipleValueOperand\"},{\"name\":\"JiraFormattingNoValueOperand\"}]},{\"kind\":\"UNION\",\"name\":\"JiraGlobalPermissionGrantsResult\",\"possibleTypes\":[{\"name\":\"JiraGlobalPermissionGrantsList\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraGrantTypeValue\",\"possibleTypes\":[{\"name\":\"JiraDefaultGrantTypeValue\"},{\"name\":\"JiraUserGrantTypeValue\"},{\"name\":\"JiraProjectRoleGrantTypeValue\"},{\"name\":\"JiraGroupGrantTypeValue\"},{\"name\":\"JiraIssueFieldGrantTypeValue\"}]},{\"kind\":\"UNION\",\"name\":\"JiraGroupLayoutItem\",\"possibleTypes\":[{\"name\":\"JiraFieldLayoutItem\"},{\"name\":\"JiraEcosystemLayoutItem\"},{\"name\":\"JiraForgeLayoutItem\"},{\"name\":\"JiraPanelLayoutItem\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueCreateAdditionalServicesResult\",\"possibleTypes\":[{\"name\":\"JiraIssueCreateAdditionalServices\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueCreateFieldsResult\",\"possibleTypes\":[{\"name\":\"JiraIssueCreateFields\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueCreateLayoutResult\",\"possibleTypes\":[{\"name\":\"JiraIssueCreateLayout\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueExportEvent\",\"possibleTypes\":[{\"name\":\"JiraIssueExportTaskSubmitted\"},{\"name\":\"JiraIssueExportTaskProgress\"},{\"name\":\"JiraIssueExportTaskCompleted\"},{\"name\":\"JiraIssueExportTaskTerminated\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueItemContainerItem\",\"possibleTypes\":[{\"name\":\"JiraIssueItemFieldItem\"},{\"name\":\"JiraIssueItemPanelItem\"},{\"name\":\"JiraIssueItemGroupContainer\"},{\"name\":\"JiraIssueItemTabContainer\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueItemContainersResult\",\"possibleTypes\":[{\"name\":\"JiraIssueItemContainers\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueItemGroupContainerItem\",\"possibleTypes\":[{\"name\":\"JiraIssueItemFieldItem\"},{\"name\":\"JiraIssueItemPanelItem\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueItemTabContainerItem\",\"possibleTypes\":[{\"name\":\"JiraIssueItemFieldItem\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayout\",\"possibleTypes\":[{\"name\":\"JiraDefaultIssueLayout\"},{\"name\":\"JiraIssueCreateLayout\"},{\"name\":\"JiraLegacyIssueLayout\"},{\"name\":\"JsdDefaultIssueLayout\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutConfiguration\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutConfigurationResult\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutFieldConfigurationHiddenIn\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutFieldConfigurationHiddenInGlobal\"},{\"name\":\"JiraIssueLayoutFieldConfigurationHiddenInLayoutOwner\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutFieldPanelItemConfiguration\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutFieldItemConfiguration\"},{\"name\":\"JiraIssueLayoutPanelItemConfiguration\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutItemConfiguration\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutContainerConfiguration\"},{\"name\":\"JiraIssueLayoutFieldItemConfiguration\"},{\"name\":\"JiraIssueLayoutGroupContainerConfiguration\"},{\"name\":\"JiraIssueLayoutTabContainerConfiguration\"},{\"name\":\"JiraIssueLayoutPanelItemConfiguration\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutOwner\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutIssueTypeOwner\"},{\"name\":\"JiraIssueLayoutRequestTypeOwner\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutOwners\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutOwnersResult\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueResult\",\"possibleTypes\":[{\"name\":\"JiraIssue\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueSearchByFilterResult\",\"possibleTypes\":[{\"name\":\"JiraIssueSearchByFilter\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueSearchByJqlResult\",\"possibleTypes\":[{\"name\":\"JiraIssueSearchByJql\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueSearchError\",\"possibleTypes\":[{\"name\":\"JiraInvalidJqlError\"},{\"name\":\"JiraInvalidSyntaxError\"},{\"name\":\"JiraServerError\"},{\"name\":\"JiraCustomIssueSearchError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueSearchViewResult\",\"possibleTypes\":[{\"name\":\"JiraIssueSearchView\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJQLGenerationError\",\"possibleTypes\":[{\"name\":\"JiraInvalidJqlError\"},{\"name\":\"JiraInvalidSyntaxError\"},{\"name\":\"JiraServerError\"},{\"name\":\"JiraUIExposedError\"},{\"name\":\"JiraUsageLimitExceededError\"},{\"name\":\"JiraUnsupportedLanguageError\"},{\"name\":\"JiraGeneratedJqlInvalidError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJourneyItem\",\"possibleTypes\":[{\"name\":\"JiraJourneyWorkItem\"},{\"name\":\"JiraJourneyStatusDependency\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJourneyParentIssueValueType\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementRequestType\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJourneyTriggerConfiguration\",\"possibleTypes\":[{\"name\":\"JiraJourneyWorkdayIntegrationTriggerConfiguration\"},{\"name\":\"JiraJourneyParentIssueTriggerConfiguration\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJqlFieldConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraJqlFieldConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJqlHydratedQueryResult\",\"possibleTypes\":[{\"name\":\"JiraJqlHydratedQuery\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJqlQueryHydratedFieldResult\",\"possibleTypes\":[{\"name\":\"JiraJqlQueryHydratedField\"},{\"name\":\"JiraJqlQueryHydratedError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJqlQueryHydratedValueResult\",\"possibleTypes\":[{\"name\":\"JiraJqlQueryHydratedValue\"},{\"name\":\"JiraJqlQueryHydratedError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraMediaUploadTokenResult\",\"possibleTypes\":[{\"name\":\"JiraMediaUploadToken\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraNavigationItemResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementSavedView\"},{\"name\":\"JiraSoftwareBuiltInNavigationItem\"},{\"name\":\"JiraAppNavigationItem\"},{\"name\":\"JiraShortcutNavigationItem\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraOnSuggestedChildIssueResult\",\"possibleTypes\":[{\"name\":\"JiraSuggestedIssue\"},{\"name\":\"JiraSuggestedChildIssueStatus\"},{\"name\":\"JiraSuggestedChildIssueError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraOverviewPlanMigrationStateResult\",\"possibleTypes\":[{\"name\":\"JiraOverviewPlanMigrationState\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraPermissionSchemeViewResult\",\"possibleTypes\":[{\"name\":\"JiraPermissionSchemeView\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraProjectConfiguration\",\"possibleTypes\":[{\"name\":\"JiraProjectConfigurationResult\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraProjectNavigationMetadata\",\"possibleTypes\":[{\"name\":\"JiraSoftwareProjectNavigationMetadata\"},{\"name\":\"JiraServiceManagementProjectNavigationMetadata\"},{\"name\":\"JiraWorkManagementProjectNavigationMetadata\"}]},{\"kind\":\"UNION\",\"name\":\"JiraProjectsUsingField\",\"possibleTypes\":[{\"name\":\"JiraProjectsUsingFieldResult\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraRemoteIssueLink\",\"possibleTypes\":[{\"name\":\"JiraIssueRemoteIssueLink\"},{\"name\":\"JiraConfluenceRemoteIssueLink\"},{\"name\":\"JiraWebRemoteIssueLink\"},{\"name\":\"JiraCustomRemoteIssueLink\"}]},{\"kind\":\"UNION\",\"name\":\"JiraSearchableEntity\",\"possibleTypes\":[{\"name\":\"JiraProject\"},{\"name\":\"JiraSystemFilter\"},{\"name\":\"JiraCustomFilter\"},{\"name\":\"JiraBoard\"},{\"name\":\"JiraDashboard\"},{\"name\":\"JiraIssue\"},{\"name\":\"JiraServiceManagementQueue\"},{\"name\":\"JiraPlan\"}]},{\"kind\":\"UNION\",\"name\":\"JiraSectionLayoutItem\",\"possibleTypes\":[{\"name\":\"JiraGroupLayout\"},{\"name\":\"JiraTabLayout\"},{\"name\":\"JiraFieldLayoutItem\"},{\"name\":\"JiraEcosystemLayoutItem\"},{\"name\":\"JiraForgeLayoutItem\"},{\"name\":\"JiraPanelLayoutItem\"}]},{\"kind\":\"UNION\",\"name\":\"JiraServiceManagementApproverPrincipal\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementUserApproverPrincipal\"},{\"name\":\"JiraServiceManagementGroupApproverPrincipal\"}]},{\"kind\":\"UNION\",\"name\":\"JiraServiceManagementEntitledEntity\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementEntitlementCustomer\"},{\"name\":\"JiraServiceManagementEntitlementOrganization\"}]},{\"kind\":\"UNION\",\"name\":\"JiraServiceManagementRequestTypePreviewField\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementTextPreviewField\"},{\"name\":\"JiraServiceManagementTextAreaPreviewField\"},{\"name\":\"JiraServiceManagementDueDatePreviewField\"},{\"name\":\"JiraServiceManagementDatePreviewField\"},{\"name\":\"JiraServiceManagementDateTimePreviewField\"},{\"name\":\"JiraServiceManagementAttachmentPreviewField\"},{\"name\":\"JiraServiceManagementSelectPreviewField\"},{\"name\":\"JiraServiceManagementMultiSelectPreviewField\"},{\"name\":\"JiraServiceManagementMultiUserPickerPreviewField\"},{\"name\":\"JiraServiceManagementMultiServicePickerPreviewField\"},{\"name\":\"JiraServiceManagementMultiCheckboxesPreviewField\"},{\"name\":\"JiraServiceManagementPeoplePreviewField\"},{\"name\":\"JiraServiceManagementUnknownPreviewField\"}]},{\"kind\":\"UNION\",\"name\":\"JiraServiceManagementResponder\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementUserResponder\"},{\"name\":\"JiraServiceManagementTeamResponder\"}]},{\"kind\":\"UNION\",\"name\":\"JiraShareableEntityEditGrant\",\"possibleTypes\":[{\"name\":\"JiraShareableEntityGroupGrant\"},{\"name\":\"JiraShareableEntityProjectRoleGrant\"},{\"name\":\"JiraShareableEntityUserGrant\"},{\"name\":\"JiraShareableEntityProjectGrant\"},{\"name\":\"JiraShareableEntityUnknownProjectGrant\"}]},{\"kind\":\"UNION\",\"name\":\"JiraShareableEntityShareGrant\",\"possibleTypes\":[{\"name\":\"JiraShareableEntityGroupGrant\"},{\"name\":\"JiraShareableEntityProjectRoleGrant\"},{\"name\":\"JiraShareableEntityProjectGrant\"},{\"name\":\"JiraShareableEntityAnonymousAccessGrant\"},{\"name\":\"JiraShareableEntityAnyLoggedInUserGrant\"},{\"name\":\"JiraShareableEntityUnknownProjectGrant\"},{\"name\":\"JiraShareableEntityUserGrant\"}]},{\"kind\":\"UNION\",\"name\":\"JiraSpreadsheetGroupFieldValue\",\"possibleTypes\":[{\"name\":\"AtlassianAccountUser\"},{\"name\":\"JiraOption\"},{\"name\":\"JiraStatus\"},{\"name\":\"JiraPriority\"},{\"name\":\"JiraStoryPoint\"},{\"name\":\"JiraGoal\"}]},{\"kind\":\"UNION\",\"name\":\"JiraUnsplashImageSearchPageResult\",\"possibleTypes\":[{\"name\":\"JiraUnsplashImageSearchPage\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraVersionConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraVersionConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraVersionResult\",\"possibleTypes\":[{\"name\":\"JiraVersion\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementActiveBackgroundDetailsResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementColorBackground\"},{\"name\":\"JiraWorkManagementGradientBackground\"},{\"name\":\"JiraWorkManagementMediaBackground\"},{\"name\":\"JiraWorkManagementAttachmentBackground\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementBackgroundUploadTokenResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementBackgroundUploadToken\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementCategoryOptionConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementCategoryOptionConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementFieldConfigurationConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementFieldConfigurationConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementFilterConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementFilterConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementGiraOverviewResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementGiraOverview\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementSavedViewResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementSavedView\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementViewItemConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementViewItemConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JqlFieldConnectionResult\",\"possibleTypes\":[{\"name\":\"JqlFieldConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JqlHydratedQueryResult\",\"possibleTypes\":[{\"name\":\"JqlHydratedQuery\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JqlQueryHydratedFieldResult\",\"possibleTypes\":[{\"name\":\"JqlQueryHydratedField\"},{\"name\":\"JqlQueryHydratedError\"}]},{\"kind\":\"UNION\",\"name\":\"JqlQueryHydratedValueResult\",\"possibleTypes\":[{\"name\":\"JqlQueryHydratedValue\"},{\"name\":\"JqlQueryHydratedError\"}]},{\"kind\":\"UNION\",\"name\":\"LayoutDefiner\",\"possibleTypes\":[{\"name\":\"FieldLayoutScreen\"},{\"name\":\"JiraRequestType\"}]},{\"kind\":\"UNION\",\"name\":\"MediaUploadTokenUnion\",\"possibleTypes\":[{\"name\":\"MediaUploadToken\"},{\"name\":\"FailedMediaUploadToken\"}]},{\"kind\":\"UNION\",\"name\":\"MergedFieldUnion\",\"possibleTypes\":[{\"name\":\"IssueTypeField\"},{\"name\":\"StatusField\"}]},{\"kind\":\"UNION\",\"name\":\"ProjectCategoryGadgetUnion\",\"possibleTypes\":[{\"name\":\"ProjectsGadgetItem\"},{\"name\":\"CategoriesGadgetItem\"}]},{\"kind\":\"UNION\",\"name\":\"RemoteIssueDetailsUnion\",\"possibleTypes\":[{\"name\":\"AssociatedIssueWrapper\"},{\"name\":\"FailedRemoteIssue\"}]},{\"kind\":\"UNION\",\"name\":\"SectionItem\",\"possibleTypes\":[{\"name\":\"GroupLayout\"},{\"name\":\"TabLayout\"},{\"name\":\"FieldSectionItem\"},{\"name\":\"EcosystemSectionItem\"},{\"name\":\"ForgeSectionItem\"},{\"name\":\"PanelSectionItem\"}]},{\"kind\":\"UNION\",\"name\":\"TimeSeriesChartAdditionalPropertiesUnion\",\"possibleTypes\":[{\"name\":\"CreatedVsResolvedProperties\"}]}]}}");

});

parcelRegister("9g713", function(module, exports) {

$parcel$export(module.exports, "getErrorAnalyticsContext", () => $a87e716199660ede$export$bd030713895ed5e2);
$parcel$export(module.exports, "reportErrors", () => $a87e716199660ede$export$a78ebe1911f50d41);

var $9XE6b = parcelRequire("9XE6b");

var $e3a3O = parcelRequire("e3a3O");

var $jcw0u = parcelRequire("jcw0u");
const $a87e716199660ede$export$15d632fe38832073 = 'giraErrorAnalytics';
const $a87e716199660ede$export$fc6a71db0f9a33f9 = (errorAnalytics, context = {})=>({
        ...context,
        [$a87e716199660ede$export$15d632fe38832073]: errorAnalytics
    });
const $a87e716199660ede$export$bd030713895ed5e2 = (context)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const errorAnalytics = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(context, [
        $a87e716199660ede$export$15d632fe38832073
    ], undefined);
    if (typeof errorAnalytics === 'object' && typeof errorAnalytics.id === 'string' && (errorAnalytics.packageName === undefined || typeof errorAnalytics.packageName === 'string') && (errorAnalytics.teamName === undefined || typeof errorAnalytics.teamName === 'string') && (errorAnalytics.attributes === undefined || typeof errorAnalytics.attributes === 'object') && (errorAnalytics.sendToPrivacyUnsafeSplunk === undefined || typeof errorAnalytics.sendToPrivacyUnsafeSplunk === 'boolean')) return {
        id: errorAnalytics.id,
        packageName: errorAnalytics.packageName,
        teamName: errorAnalytics.teamName,
        attributes: errorAnalytics.attributes,
        sendToPrivacyUnsafeSplunk: errorAnalytics.sendToPrivacyUnsafeSplunk
    };
    return undefined;
};
const $a87e716199660ede$export$a78ebe1911f50d41 = ({ graphQLErrors: graphQLErrors, networkError: networkError, operation: operation })=>{
    const errorAnalytics = $a87e716199660ede$export$bd030713895ed5e2(operation.getContext());
    // Refine mixed type to Array | void
    if (graphQLErrors !== undefined && !Array.isArray(graphQLErrors)) return;
    const hasGraphQLError = graphQLErrors !== undefined && graphQLErrors.length > 0;
    const hasNetworkError = networkError !== undefined;
    // Only report errors using the JFE analytics pipeline if analytics context data is defined for the query.
    if (errorAnalytics === undefined || !hasGraphQLError && !hasNetworkError) return;
    const { id: id, packageName: packageName, teamName: teamName, attributes: attributes, sendToPrivacyUnsafeSplunk: sendToPrivacyUnsafeSplunk } = errorAnalytics;
    const error = new (0, $e3a3O.ApolloError)({
        // Above Array.isArray check will refine the type to a read-only array. We need this spread to keep flow happy.
        graphQLErrors: graphQLErrors ? [
            ...graphQLErrors
        ] : undefined,
        networkError: networkError
    });
    const attributesWithOperationName = {
        ...attributes,
        operationName: operation.operationName,
        hasGraphQLError: hasGraphQLError,
        hasNetworkError: hasNetworkError
    };
    (0, $jcw0u.default)({
        error: error,
        meta: {
            id: id,
            packageName: packageName,
            teamName: teamName
        },
        attributes: attributesWithOperationName,
        sendToPrivacyUnsafeSplunk: sendToPrivacyUnsafeSplunk
    });
};

});


parcelRegister("AeWM3", function(module, exports) {

$parcel$export(module.exports, "resetCache", () => $63ae5caf575c2d55$export$6e5dca841bdf93e3);
$parcel$export(module.exports, "resetCacheAsync", () => $63ae5caf575c2d55$export$cd62f60830f74ae2);
$parcel$export(module.exports, "getClient", () => $63ae5caf575c2d55$export$6bb76d6eba7e258c);
$parcel$export(module.exports, "ApolloClientProvider", () => $63ae5caf575c2d55$export$8e363dbef886ff17);

var $5uXOq = parcelRequire("5uXOq");

var $9XE6b = parcelRequire("9XE6b");

var $bvsgq = parcelRequire("bvsgq");

var $9OXo1 = parcelRequire("9OXo1");
const $63ae5caf575c2d55$var$CLIENTS_CACHE = {};
const $63ae5caf575c2d55$export$6e5dca841bdf93e3 = (clientId)=>{
    // we need to `clearStore` directly to the InMemoryCache instance
    $63ae5caf575c2d55$var$CLIENTS_CACHE[clientId]?.clearStore();
    delete $63ae5caf575c2d55$var$CLIENTS_CACHE[clientId];
};
const $63ae5caf575c2d55$export$cd62f60830f74ae2 = async (clientId)=>{
    // we need to `clearStore` directly to the InMemoryCache instance
    const client = $63ae5caf575c2d55$var$CLIENTS_CACHE[clientId];
    delete $63ae5caf575c2d55$var$CLIENTS_CACHE[clientId];
    await client?.clearStore();
};
const $63ae5caf575c2d55$export$44dd3e9494f887fc = ()=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys($63ae5caf575c2d55$var$CLIENTS_CACHE).reduce((acc, key)=>Object.assign(acc, {
            [`apollo-cache/${key}`]: $63ae5caf575c2d55$var$CLIENTS_CACHE[key].extract()
        }), {});
const $63ae5caf575c2d55$export$6bb76d6eba7e258c = (baseUrl, { clientId: clientId, clientCreator: clientCreator }, xsrfToken)=>{
    let client = $63ae5caf575c2d55$var$CLIENTS_CACHE[clientId];
    if (!client) {
        client = clientCreator(baseUrl, xsrfToken);
        $63ae5caf575c2d55$var$CLIENTS_CACHE[clientId] = client;
    }
    return client;
};
class $63ae5caf575c2d55$export$8e363dbef886ff17 extends (0, $5uXOq.Component) {
    getClient(baseUrl, xsrfToken) {
        return $63ae5caf575c2d55$export$6bb76d6eba7e258c(baseUrl, this.props.client, xsrfToken != null ? xsrfToken : undefined);
    }
    render() {
        const { children: children } = this.props;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(this.props, 'client.clientId')) throw new Error('Please provide a client configuration');
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9OXo1.TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>{
            const client = this.getClient(tenantContext.baseUrl, tenantContext.xsrfToken);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bvsgq.ApolloProvider), {
                client: client
            }, children);
        });
    }
}

});
parcelRegister("bvsgq", function(module, exports) {

$parcel$export(module.exports, "getApolloContext", () => $02296d7a3662bd2d$export$a47505d961ee3a1);
$parcel$export(module.exports, "ApolloProvider", () => $02296d7a3662bd2d$export$c16b04c8a9956446);
$parcel$export(module.exports, "DocumentType", () => $02296d7a3662bd2d$export$d1d99cf900472499);
$parcel$export(module.exports, "operationName", () => $02296d7a3662bd2d$export$5db520940cf00715);
$parcel$export(module.exports, "parser", () => $02296d7a3662bd2d$export$8f49e4af10703ce3);

var $5uXOq = parcelRequire("5uXOq");

var $1DiV8 = parcelRequire("1DiV8");
var $02296d7a3662bd2d$var$apolloContext;
function $02296d7a3662bd2d$export$a47505d961ee3a1() {
    if (!$02296d7a3662bd2d$var$apolloContext) $02296d7a3662bd2d$var$apolloContext = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext({});
    return $02296d7a3662bd2d$var$apolloContext;
}
function $02296d7a3662bd2d$export$c2ee824bcc89ca6a() {
    $02296d7a3662bd2d$var$apolloContext = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext({});
}
var $02296d7a3662bd2d$export$c16b04c8a9956446 = function(_a) {
    var client = _a.client, children = _a.children;
    var ApolloContext = $02296d7a3662bd2d$export$a47505d961ee3a1();
    return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ApolloContext.Consumer, null, function(context) {
        if (context === void 0) context = {};
        if (client && context.client !== client) context = Object.assign({}, context, {
            client: client
        });
        (0, $1DiV8.invariant)(context.client, 5);
        return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ApolloContext.Provider, {
            value: context
        }, children);
    });
};
var $02296d7a3662bd2d$export$ed5ceab8c2bb5ce4 = function(props) {
    var ApolloContext = $02296d7a3662bd2d$export$a47505d961ee3a1();
    return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ApolloContext.Consumer, null, function(context) {
        (0, $1DiV8.invariant)(context && context.client, 6);
        return props.children(context.client);
    });
};
var $02296d7a3662bd2d$export$d1d99cf900472499;
(function(DocumentType) {
    DocumentType[DocumentType["Query"] = 0] = "Query";
    DocumentType[DocumentType["Mutation"] = 1] = "Mutation";
    DocumentType[DocumentType["Subscription"] = 2] = "Subscription";
})($02296d7a3662bd2d$export$d1d99cf900472499 || ($02296d7a3662bd2d$export$d1d99cf900472499 = {}));
var $02296d7a3662bd2d$var$cache = new Map();
function $02296d7a3662bd2d$export$5db520940cf00715(type) {
    var name;
    switch(type){
        case $02296d7a3662bd2d$export$d1d99cf900472499.Query:
            name = 'Query';
            break;
        case $02296d7a3662bd2d$export$d1d99cf900472499.Mutation:
            name = 'Mutation';
            break;
        case $02296d7a3662bd2d$export$d1d99cf900472499.Subscription:
            name = 'Subscription';
            break;
    }
    return name;
}
function $02296d7a3662bd2d$export$8f49e4af10703ce3(document) {
    var cached = $02296d7a3662bd2d$var$cache.get(document);
    if (cached) return cached;
    var variables, type, name;
    (0, $1DiV8.invariant)(!!document && !!document.kind, 1);
    var fragments = document.definitions.filter(function(x) {
        return x.kind === 'FragmentDefinition';
    });
    var queries = document.definitions.filter(function(x) {
        return x.kind === 'OperationDefinition' && x.operation === 'query';
    });
    var mutations = document.definitions.filter(function(x) {
        return x.kind === 'OperationDefinition' && x.operation === 'mutation';
    });
    var subscriptions = document.definitions.filter(function(x) {
        return x.kind === 'OperationDefinition' && x.operation === 'subscription';
    });
    (0, $1DiV8.invariant)(!fragments.length || queries.length || mutations.length || subscriptions.length, 2);
    (0, $1DiV8.invariant)(queries.length + mutations.length + subscriptions.length <= 1, 3);
    type = queries.length ? $02296d7a3662bd2d$export$d1d99cf900472499.Query : $02296d7a3662bd2d$export$d1d99cf900472499.Mutation;
    if (!queries.length && !mutations.length) type = $02296d7a3662bd2d$export$d1d99cf900472499.Subscription;
    var definitions = queries.length ? queries : mutations.length ? mutations : subscriptions;
    (0, $1DiV8.invariant)(definitions.length === 1, 4);
    var definition = definitions[0];
    variables = definition.variableDefinitions || [];
    if (definition.name && definition.name.kind === 'Name') name = definition.name.value;
    else name = 'data';
    var payload = {
        name: name,
        type: type,
        variables: variables
    };
    $02296d7a3662bd2d$var$cache.set(document, payload);
    return payload;
}

});


parcelRegister("eiOkd", function(module, exports) {

$parcel$export(module.exports, "default", () => $b98d0f47ed36cd9a$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $6cG4N = parcelRequire("6cG4N");


var $bUSNl = parcelRequire("bUSNl");

var $lLfAu = parcelRequire("lLfAu");
// This wrapper should be agnostic, please don't add any project or overview logic here.
const $b98d0f47ed36cd9a$var$BusinessAppWrapper = ({ children: children, className: className, header: header, sidebarTheme: sidebarTheme, shouldAddPadding: shouldAddPadding = true, withSidebar: withSidebar = false, withDynamicHeight: withDynamicHeight = false, withOverflow: withOverflow = false })=>{
    const [{ content: sidebarContent }] = (0, $bUSNl.useSidebar)();
    const isSidebarOpen = withSidebar && sidebarContent != null;
    let content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, header, children);
    if (withSidebar) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lLfAu.SidebarLayout), {
        theme: sidebarTheme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $b98d0f47ed36cd9a$var$contentWrapperStyles,
            isSidebarOpen && $b98d0f47ed36cd9a$var$sidebarOpenContentWrapperStyles
        ]
    }, content));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b98d0f47ed36cd9a$var$ThemedContainer, {
        shouldAddPadding: shouldAddPadding,
        isSidebarOpen: isSidebarOpen,
        withSidebar: withSidebar,
        withDynamicHeight: withDynamicHeight,
        withOverflow: withOverflow,
        id: (0, $c15b7ab4e654e0c4$export$e5e75ff4daca6597),
        // Used for styling
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: className
    }, content);
};
const $b98d0f47ed36cd9a$var$contentWrapperStyles = (0, $8CUq3.xcss)({
    // @ts-expect-error - we need to use Tokens to correctly set the color value using CSS variables
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    color: (0, $6cG4N.Tokens).COLOR_TEXT,
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    flexShrink: 1,
    maxWidth: '100%',
    minWidth: '0',
    width: 'auto'
});
const $b98d0f47ed36cd9a$var$sidebarOpenContentWrapperStyles = (0, $8CUq3.xcss)({
    paddingRight: 'space.300',
    paddingBottom: 'space.300'
});
var $b98d0f47ed36cd9a$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($b98d0f47ed36cd9a$var$BusinessAppWrapper);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $b98d0f47ed36cd9a$var$ThemedContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { withSidebar: withSidebar, withDynamicHeight: withDynamicHeight, shouldAddPadding: shouldAddPadding, isSidebarOpen: isSidebarOpen, withOverflow: withOverflow, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2lx21bp4 _1n261q9c _vchhusvi _1e0c1txw _1bah1y6m _ca0qidpf",
            !__cmplp.withSidebar && "_syazfrbu",
            __cmplp.withDynamicHeight ? "_4t3i1wug" : "_4t3i1osq",
            __cmplp.withDynamicHeight ? "_1tke1osq" : "_1tke1wug",
            !__cmplp.shouldAddPadding || __cmplp.isSidebarOpen ? "_u5f3idpf" : "_u5f31ejb",
            !__cmplp.shouldAddPadding || __cmplp.isSidebarOpen ? "_n3tdidpf" : "_n3td1ejb",
            __cmplp.shouldAddPadding ? "_19bv1ejb" : "_19bvidpf",
            __cmplp.withOverflow ? "_1reo1wug _18m91wug" : "_1reoewfl _18m9ewfl",
            __cmplp.className
        ])
    });
});

});
const $c15b7ab4e654e0c4$export$e5e75ff4daca6597 = 'jwm-container';

parcelRegister("bUSNl", function(module, exports) {

$parcel$export(module.exports, "getSidebarQueryParams", () => $39fc2da09b28cabf$export$ddc11e4d41e7cf62);
$parcel$export(module.exports, "useSidebar", () => $39fc2da09b28cabf$export$54c70f22f548bff8);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $hE5wF = parcelRequire("hE5wF");

var $3hGWp = parcelRequire("3hGWp");

var $dCm1o = parcelRequire("dCm1o");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $4R6GH = parcelRequire("4R6GH");

var $jnA4H = parcelRequire("jnA4H");

const $39fc2da09b28cabf$export$ddc11e4d41e7cf62 = ()=>[
        (0, $hE5wF.SELECTED_ISSUE_PARAM),
        (0, $hE5wF.SELECTED_COMMENT_PARAM)
    ];
const $39fc2da09b28cabf$export$b3747bec68e731a9 = ()=>(0, $dCm1o.isVisualRefreshEnabled)() ? (0, $55f230b510f63572$export$b16f75f2e0c3c029) : (0, $55f230b510f63572$export$2146fa818259227f);
const $39fc2da09b28cabf$var$setSidebarContent = (content)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        setState({
            ...state,
            content: content
        });
    };
const $39fc2da09b28cabf$var$setSidebarWidth = (width)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        let minWidth;
        const sidebarWidthFromStore = (0, $jnA4H.getSidebarWidthFromStore)(state);
        if ((0, $4R6GH.fg)('fix_reply_editor_width')) minWidth = Math.min(sidebarWidthFromStore, (0, $55f230b510f63572$export$77e787f7c2e430e5));
        else minWidth = Math.min(sidebarWidthFromStore, $39fc2da09b28cabf$export$b3747bec68e731a9());
        const newWidth = Math.max(width, minWidth);
        if (newWidth === state.sidebarWidth) return;
        setState({
            ...state,
            sidebarWidth: newWidth
        });
        (0, $jnA4H.localStorage).set((0, $55f230b510f63572$export$86880b4b2e1a2384), newWidth);
    };
const $39fc2da09b28cabf$var$setSidebarOnClose = (onSidebarClose)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        setState({
            ...state,
            onSidebarClose: onSidebarClose
        });
    };
const $39fc2da09b28cabf$var$closeSidebar = ()=>({ setState: setState, getState: getState })=>{
        const state = getState();
        state.onSidebarClose();
        setState({
            ...state,
            content: null,
            onSidebarClose: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        });
    };
const $39fc2da09b28cabf$var$actions = {
    setSidebarContent: $39fc2da09b28cabf$var$setSidebarContent,
    setSidebarWidth: $39fc2da09b28cabf$var$setSidebarWidth,
    setSidebarOnClose: $39fc2da09b28cabf$var$setSidebarOnClose,
    closeSidebar: $39fc2da09b28cabf$var$closeSidebar
};
const $39fc2da09b28cabf$var$Store = (0, $iXqE5.createStore)({
    initialState: {
        content: null,
        sidebarWidth: null,
        onSidebarClose: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
    },
    actions: $39fc2da09b28cabf$var$actions,
    name: 'JWMSidebarStore'
});
const $39fc2da09b28cabf$var$useHook = (0, $3sQ5x.createHook)($39fc2da09b28cabf$var$Store);
const $39fc2da09b28cabf$export$54c70f22f548bff8 = ()=>{
    const [state, hookActions] = $39fc2da09b28cabf$var$useHook();
    const sidebarQueryParams = $39fc2da09b28cabf$export$ddc11e4d41e7cf62();
    const [, setQueryParams] = (0, $3hGWp.useQueryParams)(...sidebarQueryParams);
    const resetSidebarQueryParams = (0, $5uXOq.useCallback)(()=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newQueryParams = sidebarQueryParams.reduce((acc, param)=>Object.assign(acc, {
                [param]: undefined
            }), {});
        setQueryParams(newQueryParams);
    }, [
        setQueryParams,
        sidebarQueryParams
    ]);
    return [
        state,
        {
            ...hookActions,
            resetSidebarQueryParams: resetSidebarQueryParams
        }
    ];
};

});
parcelRegister("jnA4H", function(module, exports) {

$parcel$export(module.exports, "localStorage", () => $301038d04a64b539$export$c2ed3351cac403d1);
$parcel$export(module.exports, "getSidebarWidthFromStore", () => $301038d04a64b539$export$ff9cb331cac6c6b5);

var $bSSG7 = parcelRequire("bSSG7");

var $dCm1o = parcelRequire("dCm1o");

var $4R6GH = parcelRequire("4R6GH");

const $301038d04a64b539$export$c2ed3351cac403d1 = (0, $bSSG7.createLocalStorageProvider)('jira_business_common');
const $301038d04a64b539$export$ff9cb331cac6c6b5 = (store)=>{
    if (store.sidebarWidth) return store.sidebarWidth;
    if ((0, $4R6GH.fg)('fix_reply_editor_width')) return 0, $55f230b510f63572$export$77e787f7c2e430e5;
    return (0, $dCm1o.isVisualRefreshEnabled)() ? (0, $55f230b510f63572$export$b16f75f2e0c3c029) : (0, $55f230b510f63572$export$2146fa818259227f);
};

});
const $55f230b510f63572$export$86880b4b2e1a2384 = 'jwm.sidebar';
const $55f230b510f63572$export$2146fa818259227f = 360;
const $55f230b510f63572$export$b16f75f2e0c3c029 = 435;
const $55f230b510f63572$export$77e787f7c2e430e5 = 463;



parcelRegister("lLfAu", function(module, exports) {

$parcel$export(module.exports, "SidebarLayout", () => $1dbab6fa0f2d1b51$export$8295a33ab8a36876);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $lmBAt = parcelRequire("lmBAt");

var $getxR = parcelRequire("getxR");

var $He4jn = parcelRequire("He4jn");

var $bUSNl = parcelRequire("bUSNl");

var $jnA4H = parcelRequire("jnA4H");

var $eHSp3 = parcelRequire("eHSp3");
const $1dbab6fa0f2d1b51$var$Sidebar = ({ children: children, sidebarWidth: sidebarWidth, theme: theme })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $1dbab6fa0f2d1b51$var$sidebarStyles,
            /* styles now for all project theming. remove || 'business' condition on nav4 has been fully rolled out and jira_theming_milestone_1 has been cleaned up */ (theme === 'business' || theme && (0, $lmBAt.getIsSoftwareThemingEnabled)()) && $1dbab6fa0f2d1b51$var$businessSidebarStyles
        ],
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            width: sidebarWidth
        }
    }, children);
};
const $1dbab6fa0f2d1b51$export$8295a33ab8a36876 = ({ children: children, theme: theme = 'business' })=>{
    (0, $getxR.useSidebarQueryParams)();
    const [store, { setSidebarContent: setSidebarContent }] = (0, $bUSNl.useSidebar)();
    const { content: content } = store;
    const sidebarWidth = (0, $jnA4H.getSidebarWidthFromStore)(store);
    const { onMouseDown: onMouseDown, isResizing: isResizing } = (0, $He4jn.useResizer)();
    // reset sidebar content on view unmount
    (0, $5uXOq.useEffect)(()=>()=>{
            setSidebarContent(null);
        }, [
        setSidebarContent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eHSp3.Wrapper), {
        isResizing: isResizing,
        "data-testid": "business-app-wrapper.ui.app-wrapper.sidebar-layout.sidebar-layout-wrapper"
    }, children, content && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1dbab6fa0f2d1b51$var$Sidebar, {
        sidebarWidth: sidebarWidth,
        theme: theme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eHSp3.ResizeHandle), {
        onMouseDown: onMouseDown
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eHSp3.SidebarContent), null, content)));
};
const $1dbab6fa0f2d1b51$var$sidebarStyles = (0, $8CUq3.xcss)({
    backgroundColor: 'elevation.surface',
    flexGrow: 0,
    flexShrink: 0,
    position: 'relative',
    zIndex: 'card',
    maxWidth: '75%'
});
const $1dbab6fa0f2d1b51$var$businessSidebarStyles = (0, $8CUq3.xcss)({
    borderTopLeftRadius: 'border.radius.200',
    borderTopRightRadius: 'border.radius.200',
    boxShadow: 'elevation.shadow.overlay',
    marginRight: 'space.300',
    marginTop: 'space.300'
});

});
parcelRegister("getxR", function(module, exports) {

$parcel$export(module.exports, "useSidebarQueryParams", () => $7ddee5a34b903b90$export$34adbeffbeceba68);

var $5uXOq = parcelRequire("5uXOq");

var $hE5wF = parcelRequire("hE5wF");

var $1XJ20 = parcelRequire("1XJ20");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $3hGWp = parcelRequire("3hGWp");

var $bUSNl = parcelRequire("bUSNl");
const $7ddee5a34b903b90$var$isEscapeEvent = (e)=>e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27;
const $7ddee5a34b903b90$export$34adbeffbeceba68 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [{ content: content }, { setSidebarContent: setSidebarContent, resetSidebarQueryParams: resetSidebarQueryParams }] = (0, $bUSNl.useSidebar)();
    const sidebarQueryParams = (0, $bUSNl.getSidebarQueryParams)();
    const [queryParams, setQueryParams] = (0, $3hGWp.useQueryParams)(...sidebarQueryParams);
    const prevQueryParams = (0, $1XJ20.usePreviousWithInitial)(queryParams);
    const closeSidebar = (0, $5uXOq.useCallback)(()=>{
        // reset sidebar query params (IssueApp, Comments)
        resetSidebarQueryParams();
        // reset sidebar content
        setSidebarContent(null);
    }, [
        resetSidebarQueryParams,
        setSidebarContent
    ]);
    // keep only one sidebar-related query param at the time
    (0, $5uXOq.useEffect)(()=>{
        sidebarQueryParams.forEach((queryParam)=>{
            if (!prevQueryParams[queryParam] && queryParams[queryParam]) {
                const newQueryParams = sidebarQueryParams.filter((param)=>param !== queryParam).reduce((acc, param)=>Object.assign(acc, {
                        [param]: undefined
                    }), {});
                setQueryParams(newQueryParams);
            }
        });
    }, [
        prevQueryParams,
        queryParams,
        setQueryParams,
        sidebarQueryParams
    ]);
    // handle closing sidebar on Escape
    (0, $5uXOq.useEffect)(()=>{
        const handleKeydown = (event)=>{
            if (!queryParams[0, $hE5wF.SELECTED_ISSUE_PARAM]) // sidebar is not open, exit
            return;
            if (queryParams[0, $hE5wF.SELECTED_ISSUE_PARAM] && content?.key === 'unscheduledSidebar') // should not close the sidebar if the sidebar and modal is open
            return;
            if ($7ddee5a34b903b90$var$isEscapeEvent(event)) {
                (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'sidebar closed', 'esc');
                closeSidebar();
            }
        };
        typeof document !== 'undefined' && document.addEventListener('keydown', handleKeydown);
        return ()=>{
            typeof document !== 'undefined' && document.removeEventListener('keydown', handleKeydown);
        };
    }, [
        closeSidebar,
        content?.key,
        createAnalyticsEvent,
        queryParams
    ]);
};

});

parcelRegister("He4jn", function(module, exports) {

$parcel$export(module.exports, "useResizer", () => $80d7a99fb39f1e91$export$faede3f1542958fc);

var $5uXOq = parcelRequire("5uXOq");

var $34ck9 = parcelRequire("34ck9");

var $bUSNl = parcelRequire("bUSNl");

var $jnA4H = parcelRequire("jnA4H");
const $80d7a99fb39f1e91$var$THROTTLE_TIME = 16;
const $80d7a99fb39f1e91$export$faede3f1542958fc = ()=>{
    const [store, { setSidebarWidth: setSidebarWidth }] = (0, $bUSNl.useSidebar)();
    const sidebarWidth = (0, $jnA4H.getSidebarWidthFromStore)(store);
    const startRef = (0, $5uXOq.useRef)(0);
    // storing width in a ref to avoid re-creating onMouseMove handler during resize
    const width = (0, $5uXOq.useRef)(0);
    const [isResizing, setIsResizing] = (0, $5uXOq.useState)(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const resize = (0, $5uXOq.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($34ck9)))((clientX)=>{
        const proposedWidth = width.current + startRef.current - clientX;
        setSidebarWidth(proposedWidth);
    }, $80d7a99fb39f1e91$var$THROTTLE_TIME), [
        setSidebarWidth
    ]);
    const onMouseMove = (0, $5uXOq.useCallback)((event)=>{
        event.preventDefault();
        resize(event.clientX);
    }, [
        resize
    ]);
    const onMouseUp = (0, $5uXOq.useCallback)(()=>{
        startRef.current = 0;
        width.current = 0;
        setIsResizing(false);
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.removeEventListener('mousemove', onMouseMove);
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.removeEventListener('mouseup', onMouseUp);
    }, [
        onMouseMove
    ]);
    (0, $5uXOq.useEffect)(()=>()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.removeEventListener('mousemove', onMouseMove);
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.removeEventListener('mouseup', onMouseUp);
        }, [
        onMouseMove,
        onMouseUp
    ]);
    const onMouseDown = (0, $5uXOq.useCallback)((event)=>{
        startRef.current = event.clientX;
        width.current = sidebarWidth;
        setIsResizing(true);
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.addEventListener('mousemove', onMouseMove);
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.addEventListener('mouseup', onMouseUp);
    }, [
        onMouseMove,
        onMouseUp,
        sidebarWidth
    ]);
    return {
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onMouseMove: onMouseMove,
        isResizing: isResizing
    };
};

});

parcelRegister("eHSp3", function(module, exports) {

$parcel$export(module.exports, "Wrapper", () => $71d20039839e60ab$export$e6dfd72ab29f8598);
$parcel$export(module.exports, "SidebarContent", () => $71d20039839e60ab$export$49e8f7b58a4df4ea);
$parcel$export(module.exports, "ResizeHandle", () => $71d20039839e60ab$export$33f2411a0ad35be7);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $71d20039839e60ab$export$e6dfd72ab29f8598 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isResizing: isResizing, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _4cvr1fhb _4t3i1osq",
            __cmplp.isResizing ? "_80omuf7j" : "_80om73ad",
            __cmplp.className
        ])
    });
});
const $71d20039839e60ab$export$49e8f7b58a4df4ea = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18m91wug _13wustnw _1igsidpf _184nidpf _bhl91osq _ogwtu2gc _6tinidpf _1cezu2gc _m3zkidpf _134m1txw _sojr1h6o",
            __cmplp.className
        ])
    });
});
const $71d20039839e60ab$export$33f2411a0ad35be7 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bsb1tcg _80omuf7j _kqswh2mm _1wpz1fhb _1pbybfng _1ltvxmi2 _4t3i1osq _16r2glyw _qc5othzt _aetrb3bt _18postnw _z0aiyh40 _15l2idpf _19doutpp _1qdg1osq _gcm11p6i _4tpu1p6i",
            __cmplp.className
        ])
    });
});

});



parcelRegister("54aDJ", function(module, exports) {

$parcel$export(module.exports, "ConfluenceModalProvider", () => $80aa91d8ae783d16$export$465701d340b2a0fb);

var $5uXOq = parcelRequire("5uXOq");

var $i8Qvm = parcelRequire("i8Qvm");

var $bKinl = parcelRequire("bKinl");

var $3kWBc = parcelRequire("3kWBc");

var $hInrt = parcelRequire("hInrt");

var $7X77D = parcelRequire("7X77D");
const $80aa91d8ae783d16$export$465701d340b2a0fb = ({ children: children })=>{
    const viewModalControlNew = (0, $hInrt.useConfluenceViewModalNew)();
    const { createModalProps: createModalProps, showCreatePage: showCreatePage, hideCreatePage: hideCreatePage } = (0, $hInrt.useConfluenceCreatePageModal)();
    const confluenceContext = (0, $5uXOq.useMemo)(()=>({
            showConfluencePage: viewModalControlNew.showConfluencePage,
            showCreatePage: showCreatePage
        }), [
        viewModalControlNew.showConfluencePage,
        showCreatePage
    ]);
    const { confluencePageUrl: confluencePageUrl, viewMode: viewMode, onCloseCompleteCallback: onCloseCompleteCallback } = viewModalControlNew.viewModalProps;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bKinl.confluencePagesContext).Provider, {
        value: confluenceContext
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i8Qvm.default), null, confluencePageUrl != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7X77D.default), {
        onClose: viewModalControlNew.hideConfluencePage,
        confluenceUrl: confluencePageUrl || '',
        mode: viewMode,
        onCloseComplete: onCloseCompleteCallback,
        isOpen: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3kWBc.default), {
        onClose: hideCreatePage,
        ...createModalProps
    }));
};

});
parcelRegister("bKinl", function(module, exports) {

$parcel$export(module.exports, "confluencePagesContext", () => $2f6ddafdd32c5a4c$export$4cb8e522e2ecb030);
$parcel$export(module.exports, "useConfluencePagesModals", () => $2f6ddafdd32c5a4c$export$750ed67ce7764287);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");
const $2f6ddafdd32c5a4c$export$4cb8e522e2ecb030 = /*#__PURE__*/ (0, $5uXOq.createContext)({
    showConfluencePage: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    showCreatePage: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
});
const $2f6ddafdd32c5a4c$export$750ed67ce7764287 = ()=>{
    const context = (0, $5uXOq.useContext)($2f6ddafdd32c5a4c$export$4cb8e522e2ecb030);
    const { showConfluencePage: showConfluencePage, showCreatePage: showCreatePage } = context;
    return {
        showConfluencePage: showConfluencePage,
        showCreatePage: showCreatePage
    };
};

});

parcelRegister("3kWBc", function(module, exports) {

$parcel$export(module.exports, "default", () => $d0652eb4cfa0c28f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $d0652eb4cfa0c28f$var$LazyCreatePage = (0, $kxZPA.lazy)(()=>(parcelRequire("2sZT1")), {
    ssr: false,
    moduleId: "./src/packages/business/shared/components/confluence-pages/src/ui/confluence-view-modal/create-page-modal/main.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$d0652eb4cfa0c28f$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "create-page-modal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d0652eb4cfa0c28f$var$LazyCreatePage, props));

});
parcelRegister("2sZT1", function(module, exports) {

let $1cbe33a4a1964bec$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1cbe33a4a1964bec$var$load("3qpkO").then(()=>parcelRequire('5mDXx'));

});


parcelRegister("hInrt", function(module, exports) {

$parcel$export(module.exports, "useConfluenceCreatePageModal", () => $ee59ca0344a0436e$export$81799af04beb008f);
$parcel$export(module.exports, "useConfluenceViewModalNew", () => $ee59ca0344a0436e$export$3cac20211c8788d8);

var $5uXOq = parcelRequire("5uXOq");

var $gVnoy = parcelRequire("gVnoy");

var $2NMNM = parcelRequire("2NMNM");

var $8zOmE = parcelRequire("8zOmE");
const $ee59ca0344a0436e$export$81799af04beb008f = ()=>{
    const [createModalProps, setCreateModalProps] = (0, $5uXOq.useState)({
        showCreateModal: false,
        onCreate: undefined
    });
    const showCreatePage = (0, $5uXOq.useCallback)(({ onCreate: onCreate, onCloseComplete: onCloseComplete, onCancel: onCancel } = {})=>setCreateModalProps({
            showCreateModal: true,
            onCreate: onCreate,
            onCloseComplete: onCloseComplete,
            onCancel: onCancel
        }), []);
    const hideCreatePage = (0, $5uXOq.useCallback)(()=>setCreateModalProps({
            showCreateModal: false,
            onCreate: undefined
        }), []);
    return {
        createModalProps: createModalProps,
        showCreatePage: showCreatePage,
        hideCreatePage: hideCreatePage
    };
};
const $ee59ca0344a0436e$export$3cac20211c8788d8 = ()=>{
    const [viewModalProps, setViewModalProps] = (0, $5uXOq.useState)({
        confluencePageUrl: null,
        viewMode: (0, $gVnoy.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE,
        onCloseCompleteCallback: undefined
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const showConfluencePage = (0, $5uXOq.useCallback)(({ confluenceUrl: confluenceUrl, mode: mode, onCloseComplete: onCloseComplete })=>{
        setViewModalProps({
            confluencePageUrl: confluenceUrl,
            viewMode: mode || (0, $gVnoy.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE,
            onCloseCompleteCallback: onCloseComplete
        });
        (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'jwmConfluenceModal viewed');
    }, [
        createAnalyticsEvent
    ]);
    /**
	 * Sets the modal props state back to a default state, which will cause the modal to close
	 *
	 * NOTE: There's a [StrictMode](https://react.dev/reference/react/StrictMode) bug using the
	 * `onCloseCompleteCallback` prop on `@atlaskit/modal-dialog`. This issue has been raised with the
	 * Design System team in the following [thread](https://atlassian.slack.com/archives/CFJ9DU39U/p1715670965075749).
	 * StrictMode is enabled by default in local development so this will not work in local dev
	 * until fixed but works in production.
	 */ const hideConfluencePage = (0, $5uXOq.useCallback)(()=>{
        setViewModalProps({
            confluencePageUrl: null,
            viewMode: (0, $gVnoy.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE,
            onCloseCompleteCallback: undefined
        });
        (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'jwmConfluenceModal closed');
    }, [
        createAnalyticsEvent
    ]);
    return {
        viewModalProps: viewModalProps,
        showConfluencePage: showConfluencePage,
        hideConfluencePage: hideConfluencePage
    };
};

});

parcelRegister("7X77D", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3e7a84b08712e0f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $a3e7a84b08712e0f$var$LazyConfluenceViewModal = (0, $kxZPA.lazy)(()=>(parcelRequire("5C3Dz")), {
    ssr: false,
    moduleId: "./src/packages/business/shared/components/confluence-pages/src/ui/confluence-view-modal/view-page-modal/main.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$a3e7a84b08712e0f$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "view-modal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a3e7a84b08712e0f$var$LazyConfluenceViewModal, props));

});
parcelRegister("5C3Dz", function(module, exports) {

let $416352a0bba24906$var$load = (parcelRequire("28QjX"))(4);
module.exports = $416352a0bba24906$var$load("5knyw").then(()=>parcelRequire('17Ef1'));

});



parcelRegister("imVeH", function(module, exports) {

$parcel$export(module.exports, "useTenantHasConfluence", () => $734552c5f3b177b5$export$964fe2dd9242a588);

var $4Pf62 = parcelRequire("4Pf62");

var $hqBSi = parcelRequire("hqBSi");
const $734552c5f3b177b5$export$964fe2dd9242a588 = ()=>{
    const licensedProducts = (0, $hqBSi.useLicensedProducts)();
    return Boolean(licensedProducts[(0, $4Pf62.LICENSED_PRODUCTS).CONFLUENCE]);
};

});

parcelRegister("e21nk", function(module, exports) {

$parcel$export(module.exports, "BusinessDocumentTitle", () => $aa5670652f17dfc4$export$416064ba09d98e69);

var $5uXOq = parcelRequire("5uXOq");

var $id7K0 = parcelRequire("id7K0");

var $54qG5 = parcelRequire("54qG5");
const $aa5670652f17dfc4$export$416064ba09d98e69 = /*#__PURE__*/ (0, $5uXOq.memo)(({ pageHeading: pageHeading })=>{
    const { data: entity } = (0, $54qG5.useBusinessEntity)();
    const documentTitle = entity?.name ? `${pageHeading} - ${entity.name}` : pageHeading;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $id7K0.DocumentTitle), {
        title: documentTitle
    });
});

});
parcelRegister("id7K0", function(module, exports) {

$parcel$export(module.exports, "DocumentTitle", () => $938046587fdeeb52$export$dd5ad0b65cf665da);

var $5uXOq = parcelRequire("5uXOq");

var $cSD7y = parcelRequire("cSD7y");

var $4CAXd = parcelRequire("4CAXd");
// eslint-disable-next-line jira/react/no-class-components
class $938046587fdeeb52$var$DocumentTitleOld extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            TitleSubscriber: (0, $4CAXd.DocumentTitleSubscriber)
        };
    }
    shouldComponentUpdate(nextProps) {
        return nextProps.title !== this.props.title;
    }
    render() {
        const { title: title, TitleSubscriber: TitleSubscriber = (0, $4CAXd.DocumentTitleSubscriber) } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(TitleSubscriber, null, ({ contextArray: contextArray }, { setTitle: setTitle, addDocumentTitle: addDocumentTitle, removeDocumentTitle: removeDocumentTitle })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4CAXd.DocumentTitleHelperOld), {
                title: title,
                setTitle: setTitle,
                addDocumentTitle: addDocumentTitle,
                contextArray: contextArray,
                removeDocumentTitle: removeDocumentTitle,
                TitleSubscriber: TitleSubscriber
            }));
    }
}
const $938046587fdeeb52$export$dd5ad0b65cf665da = (0, $cSD7y.componentWithFG)('jira-concurrent-document-title', (0, $4CAXd.DocumentTitleHelper), $938046587fdeeb52$var$DocumentTitleOld);

});


parcelRegister("adJfs", function(module, exports) {

$parcel$export(module.exports, "IssueTypesAndFieldsContext", () => $1c25c33c14b14fda$export$31eaf35dc72d0fa0);

var $5uXOq = parcelRequire("5uXOq");

var $5tTFS = parcelRequire("5tTFS");

var $gKZoD = parcelRequire("gKZoD");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $1T2vX = parcelRequire("1T2vX");
// Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
const $1c25c33c14b14fda$var$noop = ()=>{};
// track Apollo cache watchers 1 sec after availableFields query finishes to make sure UI is fully rendered
const $1c25c33c14b14fda$var$TRACKING_TIMEOUT = 1000;
const $1c25c33c14b14fda$export$31eaf35dc72d0fa0 = ({ children: children })=>{
    (0, $gKZoD.di)(setTimeout);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const client = (0, $5tTFS.useApolloClient)();
    const IssueTypesAndFieldsViewContextProps = (0, $1T2vX.useIssueTypesAndFieldsService)({
        issueOperation: 'VIEW'
    });
    const IssueTypesAndFieldsCreateContextProps = (0, $1T2vX.useIssueTypesAndFieldsService)({
        issueOperation: 'CREATE'
    });
    const loading = IssueTypesAndFieldsViewContextProps.loading || IssueTypesAndFieldsCreateContextProps.loading;
    (0, $5uXOq.useEffect)(()=>{
        if (loading) return $1c25c33c14b14fda$var$noop;
        const timeoutId = setTimeout(()=>{
            // tracking the number of Apollo cache watches
            // the lower the number, the faster UI
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'apolloCacheWatches created', {
                // @ts-expect-error - TS2551 - Property 'watches' does not exist on type 'ApolloCache<object>'. Did you mean 'watch'?
                watches: client?.cache?.watches?.size
            });
        }, $1c25c33c14b14fda$var$TRACKING_TIMEOUT);
        return ()=>{
            if (timeoutId) clearTimeout(timeoutId);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        createAnalyticsEvent,
        loading
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1T2vX.IssueTypesAndFieldsContextView).Provider, {
        value: IssueTypesAndFieldsViewContextProps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1T2vX.IssueTypesAndFieldsContextCreate).Provider, {
        value: IssueTypesAndFieldsCreateContextProps
    }, children));
};

});
parcelRegister("5tTFS", function(module, exports) {

$parcel$export(module.exports, "useQuery", () => $3fdad8fd02cd9507$export$dd0a697e1782aedd);
$parcel$export(module.exports, "useLazyQuery", () => $3fdad8fd02cd9507$export$fd83eea6ecd2d8fa);
$parcel$export(module.exports, "useMutation", () => $3fdad8fd02cd9507$export$609860bf8b0084c);
$parcel$export(module.exports, "useApolloClient", () => $3fdad8fd02cd9507$export$eb9a56e7a29e494);

var $bvsgq = parcelRequire("bvsgq");

var $3VFsf = parcelRequire("3VFsf");

var $5uXOq = parcelRequire("5uXOq");

var $e3a3O = parcelRequire("e3a3O");

var $bqMzA = parcelRequire("bqMzA");

var $1DiV8 = parcelRequire("1DiV8");
var $3fdad8fd02cd9507$var$OperationData = function() {
    function OperationData(options, context) {
        this.isMounted = false;
        this.previousOptions = {};
        this.context = {};
        this.options = {};
        this.options = options || {};
        this.context = context || {};
    }
    OperationData.prototype.getOptions = function() {
        return this.options;
    };
    OperationData.prototype.setOptions = function(newOptions, storePrevious) {
        if (storePrevious === void 0) storePrevious = false;
        if (storePrevious && !(0, $bqMzA.equal)(this.options, newOptions)) this.previousOptions = this.options;
        this.options = newOptions;
    };
    OperationData.prototype.unmount = function() {
        this.isMounted = false;
    };
    OperationData.prototype.refreshClient = function() {
        var client = this.options && this.options.client || this.context && this.context.client;
        (0, $1DiV8.invariant)(!!client, 2);
        var isNew = false;
        if (client !== this.client) {
            isNew = true;
            this.client = client;
            this.cleanup();
        }
        return {
            client: this.client,
            isNew: isNew
        };
    };
    OperationData.prototype.verifyDocumentType = function(document, type) {
        var operation = (0, $bvsgq.parser)(document);
        var requiredOperationName = (0, $bvsgq.operationName)(type);
        var usedOperationName = (0, $bvsgq.operationName)(operation.type);
        (0, $1DiV8.invariant)(operation.type === type, 3);
    };
    return OperationData;
}();
var $3fdad8fd02cd9507$var$QueryData = function(_super) {
    (0, $3VFsf.__extends)(QueryData, _super);
    function QueryData(_a) {
        var options = _a.options, context = _a.context, forceUpdate = _a.forceUpdate;
        var _this = _super.call(this, options, context) || this;
        _this.previousData = {};
        _this.currentObservable = {};
        _this.runLazy = false;
        _this.runLazyQuery = function(options) {
            _this.cleanup();
            _this.runLazy = true;
            _this.lazyOptions = options;
            _this.forceUpdate();
        };
        _this.getExecuteResult = function() {
            var result = _this.getQueryResult();
            _this.startQuerySubscription();
            return result;
        };
        _this.obsRefetch = function(variables) {
            return _this.currentObservable.query.refetch(variables);
        };
        _this.obsFetchMore = function(fetchMoreOptions) {
            return _this.currentObservable.query.fetchMore(fetchMoreOptions);
        };
        _this.obsUpdateQuery = function(mapFn) {
            return _this.currentObservable.query.updateQuery(mapFn);
        };
        _this.obsStartPolling = function(pollInterval) {
            _this.currentObservable && _this.currentObservable.query && _this.currentObservable.query.startPolling(pollInterval);
        };
        _this.obsStopPolling = function() {
            _this.currentObservable && _this.currentObservable.query && _this.currentObservable.query.stopPolling();
        };
        _this.obsSubscribeToMore = function(options) {
            return _this.currentObservable.query.subscribeToMore(options);
        };
        _this.forceUpdate = forceUpdate;
        return _this;
    }
    QueryData.prototype.execute = function() {
        this.refreshClient();
        var _a = this.getOptions(), skip = _a.skip, query = _a.query;
        if (skip || query !== this.previousData.query) {
            this.removeQuerySubscription();
            this.previousData.query = query;
        }
        this.updateObservableQuery();
        if (this.isMounted) this.startQuerySubscription();
        return this.getExecuteSsrResult() || this.getExecuteResult();
    };
    QueryData.prototype.executeLazy = function() {
        return !this.runLazy ? [
            this.runLazyQuery,
            {
                loading: false,
                networkStatus: (0, $e3a3O.NetworkStatus).ready,
                called: false,
                data: undefined
            }
        ] : [
            this.runLazyQuery,
            this.execute()
        ];
    };
    QueryData.prototype.fetchData = function() {
        var options = this.getOptions();
        if (options.skip || options.ssr === false) return false;
        var obs = this.currentObservable.query;
        var currentResult = obs.getCurrentResult();
        return currentResult.loading ? obs.result() : false;
    };
    QueryData.prototype.afterExecute = function(_a) {
        var _this = this;
        var _b = (_a === void 0 ? {} : _a).lazy, lazy = _b === void 0 ? false : _b;
        this.isMounted = true;
        if (!lazy || this.runLazy) {
            this.handleErrorOrCompleted();
            setTimeout(function() {
                _this.currentObservable.query && _this.currentObservable.query.resetQueryStoreErrors();
            });
        }
        this.previousOptions = this.getOptions();
        return this.unmount.bind(this);
    };
    QueryData.prototype.cleanup = function() {
        this.removeQuerySubscription();
        delete this.currentObservable.query;
        delete this.previousData.result;
    };
    QueryData.prototype.getOptions = function() {
        var options = _super.prototype.getOptions.call(this);
        if (this.lazyOptions) {
            options.variables = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, options.variables), this.lazyOptions.variables);
            options.context = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, options.context), this.lazyOptions.context);
        }
        if (this.runLazy) delete options.skip;
        return options;
    };
    QueryData.prototype.getExecuteSsrResult = function() {
        var treeRenderingInitiated = this.context && this.context.renderPromises;
        var ssrDisabled = this.getOptions().ssr === false;
        var fetchDisabled = this.refreshClient().client.disableNetworkFetches;
        var ssrLoading = {
            loading: true,
            networkStatus: (0, $e3a3O.NetworkStatus).loading,
            called: true,
            data: undefined
        };
        if (ssrDisabled && (treeRenderingInitiated || fetchDisabled)) return ssrLoading;
        var result;
        if (treeRenderingInitiated) result = this.context.renderPromises.addQueryPromise(this, this.getExecuteResult) || ssrLoading;
        return result;
    };
    QueryData.prototype.prepareObservableQueryOptions = function() {
        var options = this.getOptions();
        this.verifyDocumentType(options.query, (0, $bvsgq.DocumentType).Query);
        var displayName = options.displayName || 'Query';
        if (this.context && this.context.renderPromises && (options.fetchPolicy === 'network-only' || options.fetchPolicy === 'cache-and-network')) options.fetchPolicy = 'cache-first';
        return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, options), {
            displayName: displayName,
            context: options.context,
            metadata: {
                reactComponent: {
                    displayName: displayName
                }
            }
        });
    };
    QueryData.prototype.initializeObservableQuery = function() {
        if (this.context && this.context.renderPromises) this.currentObservable.query = this.context.renderPromises.getSSRObservable(this.getOptions());
        if (!this.currentObservable.query) {
            var observableQueryOptions = this.prepareObservableQueryOptions();
            this.previousData.observableQueryOptions = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, observableQueryOptions), {
                children: null
            });
            this.currentObservable.query = this.refreshClient().client.watchQuery((0, $3VFsf.__assign)({}, observableQueryOptions));
            if (this.context && this.context.renderPromises) this.context.renderPromises.registerSSRObservable(this.currentObservable.query, observableQueryOptions);
        }
    };
    QueryData.prototype.updateObservableQuery = function() {
        if (!this.currentObservable.query) {
            this.initializeObservableQuery();
            return;
        }
        var newObservableQueryOptions = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this.prepareObservableQueryOptions()), {
            children: null
        });
        if (!(0, $bqMzA.equal)(newObservableQueryOptions, this.previousData.observableQueryOptions)) {
            this.previousData.observableQueryOptions = newObservableQueryOptions;
            this.currentObservable.query.setOptions(newObservableQueryOptions).catch(function() {});
        }
    };
    QueryData.prototype.startQuerySubscription = function() {
        var _this = this;
        if (this.currentObservable.subscription || this.getOptions().skip) return;
        var obsQuery = this.currentObservable.query;
        this.currentObservable.subscription = obsQuery.subscribe({
            next: function(_a) {
                var loading = _a.loading, networkStatus = _a.networkStatus, data = _a.data;
                var previousResult = _this.previousData.result;
                if (previousResult && previousResult.loading === loading && previousResult.networkStatus === networkStatus && (0, $bqMzA.equal)(previousResult.data, data)) return;
                _this.forceUpdate();
            },
            error: function(error) {
                _this.resubscribeToQuery();
                if (!error.hasOwnProperty('graphQLErrors')) throw error;
                var previousResult = _this.previousData.result;
                if (previousResult && previousResult.loading || !(0, $bqMzA.equal)(error, _this.previousData.error)) {
                    _this.previousData.error = error;
                    _this.forceUpdate();
                }
            }
        });
    };
    QueryData.prototype.resubscribeToQuery = function() {
        this.removeQuerySubscription();
        var lastError = this.currentObservable.query.getLastError();
        var lastResult = this.currentObservable.query.getLastResult();
        this.currentObservable.query.resetLastResults();
        this.startQuerySubscription();
        Object.assign(this.currentObservable.query, {
            lastError: lastError,
            lastResult: lastResult
        });
    };
    QueryData.prototype.getQueryResult = function() {
        var result = this.observableQueryFields();
        var options = this.getOptions();
        if (options.skip) result = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, result), {
            data: undefined,
            error: undefined,
            loading: false,
            called: true
        });
        else {
            var currentResult = this.currentObservable.query.getCurrentResult();
            var loading = currentResult.loading, partial = currentResult.partial, networkStatus = currentResult.networkStatus, errors = currentResult.errors;
            var error = currentResult.error, data = currentResult.data;
            if (errors && errors.length > 0) error = new (0, $e3a3O.ApolloError)({
                graphQLErrors: errors
            });
            result = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, result), {
                loading: loading,
                networkStatus: networkStatus,
                error: error,
                called: true
            });
            if (loading) {
                var previousData = this.previousData.result && this.previousData.result.data;
                result.data = previousData && data ? (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, previousData), data) : previousData || data;
            } else if (error) Object.assign(result, {
                data: (this.currentObservable.query.getLastResult() || {}).data
            });
            else {
                var fetchPolicy = this.currentObservable.query.options.fetchPolicy;
                var partialRefetch = options.partialRefetch;
                if (partialRefetch && !data && partial && fetchPolicy !== 'cache-only') {
                    Object.assign(result, {
                        loading: true,
                        networkStatus: (0, $e3a3O.NetworkStatus).loading
                    });
                    result.refetch();
                    return result;
                }
                result.data = data;
            }
        }
        result.client = this.client;
        this.previousData.loading = this.previousData.result && this.previousData.result.loading || false;
        this.previousData.result = result;
        return result;
    };
    QueryData.prototype.handleErrorOrCompleted = function() {
        var obsQuery = this.currentObservable.query;
        if (!obsQuery) return;
        var _a = obsQuery.getCurrentResult(), data = _a.data, loading = _a.loading, error = _a.error;
        if (!loading) {
            var _b = this.getOptions(), query = _b.query, variables = _b.variables, onCompleted = _b.onCompleted, onError = _b.onError;
            if (this.previousOptions && !this.previousData.loading && (0, $bqMzA.equal)(this.previousOptions.query, query) && (0, $bqMzA.equal)(this.previousOptions.variables, variables)) return;
            if (onCompleted && !error) onCompleted(data);
            else if (onError && error) onError(error);
        }
    };
    QueryData.prototype.removeQuerySubscription = function() {
        if (this.currentObservable.subscription) {
            this.currentObservable.subscription.unsubscribe();
            delete this.currentObservable.subscription;
        }
    };
    QueryData.prototype.observableQueryFields = function() {
        var observable = this.currentObservable.query;
        return {
            variables: observable.variables,
            refetch: this.obsRefetch,
            fetchMore: this.obsFetchMore,
            updateQuery: this.obsUpdateQuery,
            startPolling: this.obsStartPolling,
            stopPolling: this.obsStopPolling,
            subscribeToMore: this.obsSubscribeToMore
        };
    };
    return QueryData;
}($3fdad8fd02cd9507$var$OperationData);
function $3fdad8fd02cd9507$var$useDeepMemo(memoFn, key) {
    var ref = (0, $5uXOq.useRef)();
    if (!ref.current || !(0, $bqMzA.equal)(key, ref.current.key)) ref.current = {
        key: key,
        value: memoFn()
    };
    return ref.current.value;
}
function $3fdad8fd02cd9507$var$useBaseQuery(query, options, lazy) {
    if (lazy === void 0) lazy = false;
    var context = (0, $5uXOq.useContext)((0, $bvsgq.getApolloContext)());
    var _a = (0, $5uXOq.useReducer)(function(x) {
        return x + 1;
    }, 0), tick = _a[0], forceUpdate = _a[1];
    var updatedOptions = options ? (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, options), {
        query: query
    }) : {
        query: query
    };
    var queryDataRef = (0, $5uXOq.useRef)();
    if (!queryDataRef.current) queryDataRef.current = new $3fdad8fd02cd9507$var$QueryData({
        options: updatedOptions,
        context: context,
        forceUpdate: forceUpdate
    });
    var queryData = queryDataRef.current;
    queryData.setOptions(updatedOptions);
    queryData.context = context;
    var memo = {
        options: (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, updatedOptions), {
            onError: undefined,
            onCompleted: undefined
        }),
        context: context,
        tick: tick
    };
    var result = $3fdad8fd02cd9507$var$useDeepMemo(function() {
        return lazy ? queryData.executeLazy() : queryData.execute();
    }, memo);
    var queryResult = lazy ? result[1] : result;
    (0, $5uXOq.useEffect)(function() {
        return queryData.afterExecute({
            lazy: lazy
        });
    }, [
        queryResult.loading,
        queryResult.networkStatus,
        queryResult.error,
        queryResult.data
    ]);
    (0, $5uXOq.useEffect)(function() {
        return function() {
            return queryData.cleanup();
        };
    }, []);
    return result;
}
function $3fdad8fd02cd9507$export$dd0a697e1782aedd(query, options) {
    return $3fdad8fd02cd9507$var$useBaseQuery(query, options, false);
}
function $3fdad8fd02cd9507$export$fd83eea6ecd2d8fa(query, options) {
    return $3fdad8fd02cd9507$var$useBaseQuery(query, options, true);
}
var $3fdad8fd02cd9507$var$MutationData = function(_super) {
    (0, $3VFsf.__extends)(MutationData, _super);
    function MutationData(_a) {
        var options = _a.options, context = _a.context, result = _a.result, setResult = _a.setResult;
        var _this = _super.call(this, options, context) || this;
        _this.runMutation = function(mutationFunctionOptions) {
            if (mutationFunctionOptions === void 0) mutationFunctionOptions = {};
            _this.onMutationStart();
            var mutationId = _this.generateNewMutationId();
            return _this.mutate(mutationFunctionOptions).then(function(response) {
                _this.onMutationCompleted(response, mutationId);
                return response;
            }).catch(function(error) {
                _this.onMutationError(error, mutationId);
                if (!_this.getOptions().onError) throw error;
            });
        };
        _this.verifyDocumentType(options.mutation, (0, $bvsgq.DocumentType).Mutation);
        _this.result = result;
        _this.setResult = setResult;
        _this.mostRecentMutationId = 0;
        return _this;
    }
    MutationData.prototype.execute = function(result) {
        this.isMounted = true;
        this.verifyDocumentType(this.getOptions().mutation, (0, $bvsgq.DocumentType).Mutation);
        result.client = this.refreshClient().client;
        return [
            this.runMutation,
            result
        ];
    };
    MutationData.prototype.afterExecute = function() {
        this.isMounted = true;
        return this.unmount.bind(this);
    };
    MutationData.prototype.cleanup = function() {};
    MutationData.prototype.mutate = function(mutationFunctionOptions) {
        var _a = this.getOptions(), mutation = _a.mutation, variables = _a.variables, optimisticResponse = _a.optimisticResponse, update = _a.update, _b = _a.context, mutationContext = _b === void 0 ? {} : _b, _c = _a.awaitRefetchQueries, awaitRefetchQueries = _c === void 0 ? false : _c, fetchPolicy = _a.fetchPolicy;
        var mutateOptions = (0, $3VFsf.__assign)({}, mutationFunctionOptions);
        var mutateVariables = Object.assign({}, variables, mutateOptions.variables);
        delete mutateOptions.variables;
        return this.refreshClient().client.mutate((0, $3VFsf.__assign)({
            mutation: mutation,
            optimisticResponse: optimisticResponse,
            refetchQueries: mutateOptions.refetchQueries || this.getOptions().refetchQueries,
            awaitRefetchQueries: awaitRefetchQueries,
            update: update,
            context: mutationContext,
            fetchPolicy: fetchPolicy,
            variables: mutateVariables
        }, mutateOptions));
    };
    MutationData.prototype.onMutationStart = function() {
        if (!this.result.loading && !this.getOptions().ignoreResults) this.updateResult({
            loading: true,
            error: undefined,
            data: undefined,
            called: true
        });
    };
    MutationData.prototype.onMutationCompleted = function(response, mutationId) {
        var _a = this.getOptions(), onCompleted = _a.onCompleted, ignoreResults = _a.ignoreResults;
        var data = response.data, errors = response.errors;
        var error = errors && errors.length > 0 ? new (0, $e3a3O.ApolloError)({
            graphQLErrors: errors
        }) : undefined;
        var callOncomplete = function() {
            return onCompleted ? onCompleted(data) : null;
        };
        if (this.isMostRecentMutation(mutationId) && !ignoreResults) this.updateResult({
            called: true,
            loading: false,
            data: data,
            error: error
        });
        callOncomplete();
    };
    MutationData.prototype.onMutationError = function(error, mutationId) {
        var onError = this.getOptions().onError;
        if (this.isMostRecentMutation(mutationId)) this.updateResult({
            loading: false,
            error: error,
            data: undefined,
            called: true
        });
        if (onError) onError(error);
    };
    MutationData.prototype.generateNewMutationId = function() {
        return ++this.mostRecentMutationId;
    };
    MutationData.prototype.isMostRecentMutation = function(mutationId) {
        return this.mostRecentMutationId === mutationId;
    };
    MutationData.prototype.updateResult = function(result) {
        if (this.isMounted && (!this.previousResult || !(0, $bqMzA.equal)(this.previousResult, result))) {
            this.setResult(result);
            this.previousResult = result;
        }
    };
    return MutationData;
}($3fdad8fd02cd9507$var$OperationData);
function $3fdad8fd02cd9507$export$609860bf8b0084c(mutation, options) {
    var context = (0, $5uXOq.useContext)((0, $bvsgq.getApolloContext)());
    var _a = (0, $5uXOq.useState)({
        called: false,
        loading: false
    }), result = _a[0], setResult = _a[1];
    var updatedOptions = options ? (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, options), {
        mutation: mutation
    }) : {
        mutation: mutation
    };
    var mutationDataRef = (0, $5uXOq.useRef)();
    function getMutationDataRef() {
        if (!mutationDataRef.current) mutationDataRef.current = new $3fdad8fd02cd9507$var$MutationData({
            options: updatedOptions,
            context: context,
            result: result,
            setResult: setResult
        });
        return mutationDataRef.current;
    }
    var mutationData = getMutationDataRef();
    mutationData.setOptions(updatedOptions);
    mutationData.context = context;
    (0, $5uXOq.useEffect)(function() {
        return mutationData.afterExecute();
    });
    return mutationData.execute(result);
}
var $3fdad8fd02cd9507$var$SubscriptionData = function(_super) {
    (0, $3VFsf.__extends)(SubscriptionData, _super);
    function SubscriptionData(_a) {
        var options = _a.options, context = _a.context, setResult = _a.setResult;
        var _this = _super.call(this, options, context) || this;
        _this.currentObservable = {};
        _this.setResult = setResult;
        _this.initialize(options);
        return _this;
    }
    SubscriptionData.prototype.execute = function(result) {
        if (this.getOptions().skip === true) {
            this.cleanup();
            return {
                loading: false,
                error: undefined,
                data: undefined,
                variables: this.getOptions().variables
            };
        }
        var currentResult = result;
        if (this.refreshClient().isNew) currentResult = this.getLoadingResult();
        var shouldResubscribe = this.getOptions().shouldResubscribe;
        if (typeof shouldResubscribe === 'function') shouldResubscribe = !!shouldResubscribe(this.getOptions());
        if (shouldResubscribe !== false && this.previousOptions && Object.keys(this.previousOptions).length > 0 && (this.previousOptions.subscription !== this.getOptions().subscription || !(0, $bqMzA.equal)(this.previousOptions.variables, this.getOptions().variables) || this.previousOptions.skip !== this.getOptions().skip)) {
            this.cleanup();
            currentResult = this.getLoadingResult();
        }
        this.initialize(this.getOptions());
        this.startSubscription();
        this.previousOptions = this.getOptions();
        return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, currentResult), {
            variables: this.getOptions().variables
        });
    };
    SubscriptionData.prototype.afterExecute = function() {
        this.isMounted = true;
    };
    SubscriptionData.prototype.cleanup = function() {
        this.endSubscription();
        delete this.currentObservable.query;
    };
    SubscriptionData.prototype.initialize = function(options) {
        if (this.currentObservable.query || this.getOptions().skip === true) return;
        this.currentObservable.query = this.refreshClient().client.subscribe({
            query: options.subscription,
            variables: options.variables,
            fetchPolicy: options.fetchPolicy
        });
    };
    SubscriptionData.prototype.startSubscription = function() {
        if (this.currentObservable.subscription) return;
        this.currentObservable.subscription = this.currentObservable.query.subscribe({
            next: this.updateCurrentData.bind(this),
            error: this.updateError.bind(this),
            complete: this.completeSubscription.bind(this)
        });
    };
    SubscriptionData.prototype.getLoadingResult = function() {
        return {
            loading: true,
            error: undefined,
            data: undefined
        };
    };
    SubscriptionData.prototype.updateResult = function(result) {
        if (this.isMounted) this.setResult(result);
    };
    SubscriptionData.prototype.updateCurrentData = function(result) {
        var onSubscriptionData = this.getOptions().onSubscriptionData;
        this.updateResult({
            data: result.data,
            loading: false,
            error: undefined
        });
        if (onSubscriptionData) onSubscriptionData({
            client: this.refreshClient().client,
            subscriptionData: result
        });
    };
    SubscriptionData.prototype.updateError = function(error) {
        this.updateResult({
            error: error,
            loading: false
        });
    };
    SubscriptionData.prototype.completeSubscription = function() {
        var onSubscriptionComplete = this.getOptions().onSubscriptionComplete;
        if (onSubscriptionComplete) onSubscriptionComplete();
        this.endSubscription();
    };
    SubscriptionData.prototype.endSubscription = function() {
        if (this.currentObservable.subscription) {
            this.currentObservable.subscription.unsubscribe();
            delete this.currentObservable.subscription;
        }
    };
    return SubscriptionData;
}($3fdad8fd02cd9507$var$OperationData);
function $3fdad8fd02cd9507$export$368b4214baeb914c(subscription, options) {
    var context = (0, $5uXOq.useContext)((0, $bvsgq.getApolloContext)());
    var updatedOptions = options ? (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, options), {
        subscription: subscription
    }) : {
        subscription: subscription
    };
    var _a = (0, $5uXOq.useState)({
        loading: !updatedOptions.skip,
        error: undefined,
        data: undefined
    }), result = _a[0], setResult = _a[1];
    var subscriptionDataRef = (0, $5uXOq.useRef)();
    function getSubscriptionDataRef() {
        if (!subscriptionDataRef.current) subscriptionDataRef.current = new $3fdad8fd02cd9507$var$SubscriptionData({
            options: updatedOptions,
            context: context,
            setResult: setResult
        });
        return subscriptionDataRef.current;
    }
    var subscriptionData = getSubscriptionDataRef();
    subscriptionData.setOptions(updatedOptions, true);
    subscriptionData.context = context;
    (0, $5uXOq.useEffect)(function() {
        return subscriptionData.afterExecute();
    });
    (0, $5uXOq.useEffect)(function() {
        return subscriptionData.cleanup.bind(subscriptionData);
    }, []);
    return subscriptionData.execute(result);
}
function $3fdad8fd02cd9507$export$eb9a56e7a29e494() {
    var client = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useContext((0, $bvsgq.getApolloContext)()).client;
    (0, $1DiV8.invariant)(client, 1);
    return client;
}
function $3fdad8fd02cd9507$var$makeDefaultQueryInfo() {
    return {
        seen: false,
        observable: null
    };
}
var $3fdad8fd02cd9507$export$260e90e395a79974 = function() {
    function RenderPromises() {
        this.queryPromises = new Map();
        this.queryInfoTrie = new Map();
    }
    RenderPromises.prototype.registerSSRObservable = function(observable, props) {
        this.lookupQueryInfo(props).observable = observable;
    };
    RenderPromises.prototype.getSSRObservable = function(props) {
        return this.lookupQueryInfo(props).observable;
    };
    RenderPromises.prototype.addQueryPromise = function(queryInstance, finish) {
        var info = this.lookupQueryInfo(queryInstance.getOptions());
        if (!info.seen) {
            this.queryPromises.set(queryInstance.getOptions(), new Promise(function(resolve) {
                resolve(queryInstance.fetchData());
            }));
            return null;
        }
        return finish();
    };
    RenderPromises.prototype.hasPromises = function() {
        return this.queryPromises.size > 0;
    };
    RenderPromises.prototype.consumeAndAwaitPromises = function() {
        var _this = this;
        var promises = [];
        this.queryPromises.forEach(function(promise, queryInstance) {
            _this.lookupQueryInfo(queryInstance).seen = true;
            promises.push(promise);
        });
        this.queryPromises.clear();
        return Promise.all(promises);
    };
    RenderPromises.prototype.lookupQueryInfo = function(props) {
        var queryInfoTrie = this.queryInfoTrie;
        var query = props.query, variables = props.variables;
        var varMap = queryInfoTrie.get(query) || new Map();
        if (!queryInfoTrie.has(query)) queryInfoTrie.set(query, varMap);
        var variablesString = JSON.stringify(variables);
        var info = varMap.get(variablesString) || $3fdad8fd02cd9507$var$makeDefaultQueryInfo();
        if (!varMap.has(variablesString)) varMap.set(variablesString, info);
        return info;
    };
    return RenderPromises;
}();

});

parcelRegister("1T2vX", function(module, exports) {

$parcel$export(module.exports, "useIssueTypesAndFieldsService", () => $90cf08abf5e3ede7$export$3ef3324b7f7d6a38);
$parcel$export(module.exports, "IssueTypesAndFieldsContextView", () => $90cf08abf5e3ede7$export$77937175321fab39);
$parcel$export(module.exports, "IssueTypesAndFieldsContextCreate", () => $90cf08abf5e3ede7$export$fbd286e14113bfc);
$parcel$export(module.exports, "useIssueTypesAndFields", () => $90cf08abf5e3ede7$export$d2121b02f0b65782);

var $5uXOq = parcelRequire("5uXOq");

var $5tTFS = parcelRequire("5tTFS");


var $gN11a = parcelRequire("gN11a");

var $jcw0u = parcelRequire("jcw0u");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $1nb22 = parcelRequire("1nb22");

var $doZTA = parcelRequire("doZTA");

var $4R6GH = parcelRequire("4R6GH");

var $8Zw8m = parcelRequire("8Zw8m");

var $8tTgF = parcelRequire("8tTgF");
const $90cf08abf5e3ede7$export$d7241b17c19f0a9c = 'PROJECT_NOT_FOUND';
const $90cf08abf5e3ede7$export$4c72baf45fce4585 = 'VIEW_PROJECT_PERMISSION_ERROR';
const $90cf08abf5e3ede7$var$isProjectPermissionError = (error)=>error.message.indexOf($90cf08abf5e3ede7$export$d7241b17c19f0a9c) > -1 || error.message.indexOf($90cf08abf5e3ede7$export$4c72baf45fce4585) > -1 || // @ts-expect-error TS2339 - Property 'extensions' does not exist on type 'ApolloError'
    error.extensions?.statusCode === 403 || // @ts-expect-error TS2339 - Property 'extensions' does not exist on type 'ApolloError'
    error.extensions?.statusCode === 404;
const $90cf08abf5e3ede7$export$6b9bc8a33ade0736 = (input)=>{
    const [routerState] = (0, $doZTA.useRouter)();
    const { projectKey: projectKey } = (0, $1nb22.getProjectKeyId)(routerState?.match, routerState?.query);
    const variables = (0, $5uXOq.useMemo)(()=>({
            projectKey: projectKey,
            issueOperation: // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            input.issueOperation,
            first: 100,
            isSearchableInJqlEnabled: (0, $4R6GH.fg)('jira_issue_field_searchable_in_jql_data_fetcher')
        }), [
        input.issueOperation,
        projectKey
    ]);
    const { query: query, view: view } = // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly "classic-business-form": { readonly view: "Form"; readonly query: DocumentNode; }; readonly "classic-business-form-submit": { readonly view: "FormSubmit"; readonly query: DocumentNode; }; ... 8 more ...; readonly default: { ...; }; }'.
    (0, $8tTgF.JWMQueryByRouteMap)?.[routerState?.route?.name] ?? (0, $8tTgF.JWMQueryByRouteMap)[0, $8Zw8m.DEFAULT];
    return (0, $5uXOq.useMemo)(()=>({
            loading: false,
            query: query,
            view: view,
            variables: variables
        }), [
        query,
        view,
        variables
    ]);
};
const $90cf08abf5e3ede7$export$1768f0a0f85b4de9 = (input)=>{
    const client = (0, $5tTFS.useApolloClient)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { variables: queryVariables, query: query } = $90cf08abf5e3ede7$export$6b9bc8a33ade0736(input);
    const analyticsTaskName = 'useIssueTypesAndFieldsCacheApolloCacheActions';
    return (0, $5uXOq.useCallback)(({ findField: findField, updateItem: updateItem })=>{
        const getCacheData = ()=>{
            try {
                const read = client.readQuery({
                    query: query,
                    variables: queryVariables
                });
                (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloCacheRead taskSuccess', {
                    task: analyticsTaskName
                });
                return read;
            } catch (e) {
                (0, $jcw0u.default)({
                    error: e instanceof Error ? e : new Error('Unknown cache read error'),
                    meta: {
                        id: 'useIssueTypesAndFieldsCache',
                        packageName: 'jiraBusinessEntityProject',
                        teamName: 'wanjel'
                    },
                    sendToPrivacyUnsafeSplunk: true,
                    skipSentry: true,
                    attributes: {
                        task: analyticsTaskName,
                        query: JSON.stringify(query),
                        variables: JSON.stringify(queryVariables),
                        eventName: 'apolloCacheRead taskFail',
                        error: JSON.stringify(e)
                    }
                });
                return null;
            }
        };
        const cacheData = getCacheData();
        const existingEdges = cacheData?.jiraBusinessAvailableFields?.edges;
        if (existingEdges == null) return;
        let shouldUpdate = false;
        const newEdges = existingEdges.map((edge)=>{
            const existingFields = edge?.node?.fields?.edges;
            if (existingFields == null) return edge;
            const itemToUpdateIndex = existingFields.findIndex((fieldEdge)=>findField ? findField(fieldEdge?.node) : false) ?? undefined;
            const existingField = existingFields[itemToUpdateIndex]?.node;
            if (itemToUpdateIndex === undefined || itemToUpdateIndex === -1 || existingField == null) return edge;
            const itemOverride = updateItem(existingField);
            if (itemOverride === undefined) return edge;
            const newFields = [
                ...existingFields
            ];
            newFields[itemToUpdateIndex] = {
                node: itemOverride,
                __typename: 'JiraIssueFieldEdge'
            };
            shouldUpdate = true;
            return {
                ...edge,
                node: {
                    ...edge?.node || {},
                    fields: {
                        edges: newFields,
                        __typename: 'JiraIssueFieldConnection'
                    }
                }
            };
        });
        if (!shouldUpdate) return;
        const newData = {
            ...cacheData,
            jiraBusinessAvailableFields: {
                ...cacheData?.jiraBusinessAvailableFields || {},
                edges: newEdges
            }
        };
        try {
            client.writeQuery({
                query: query,
                variables: queryVariables,
                // @ts-expect-error - TS2345 - Argument of type '{ query: any; variables: { projectId: number | undefined; issueOperation: IssueOperation; first: number; } | undefined; notifyOnNetworkStatusChange: boolean; data: { jiraBusinessAvailableFields: { ...; }; }; }' is not assignable to parameter of type 'WriteQueryOptions<{ jiraBusinessAvailableFields: { edges: (JiraBusinessAvailableFieldsListView_jiraBusinessAvailableFields_edges | { ...; } | null)[]; __typename?: "JiraBusinessAvailableFieldsConnection" | undefined; }; }, { ...; }>'.
                notifyOnNetworkStatusChange: true,
                data: newData
            });
            (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloCacheWrite taskSuccess', {
                task: analyticsTaskName
            });
        } catch (e) {
            (0, $jcw0u.default)({
                error: e instanceof Error ? e : new Error('Unknown cache write error'),
                meta: {
                    id: 'useIssueTypesAndFieldsCache',
                    packageName: 'jiraBusinessEntityProject',
                    teamName: 'wanjel'
                },
                sendToPrivacyUnsafeSplunk: true,
                skipSentry: true,
                attributes: {
                    task: analyticsTaskName,
                    query: JSON.stringify(query),
                    variables: JSON.stringify(queryVariables),
                    eventName: 'apolloCacheWrite taskFail',
                    error: JSON.stringify(e)
                }
            });
        }
    }, [
        client,
        createAnalyticsEvent,
        query,
        queryVariables
    ]);
};
const $90cf08abf5e3ede7$export$3ef3324b7f7d6a38 = (input)=>{
    const [hasStartedFetchingFields, setHasStartedFetchingFields] = (0, $5uXOq.useState)(false);
    const fetchAttempts = (0, $5uXOq.useRef)(0);
    const { variables: queryVariables, loading: isQueryLoading, query: query, view: view } = $90cf08abf5e3ede7$export$6b9bc8a33ade0736(input);
    const [getAvailableFields, { data: data, called: called, loading: loading, error: error, refetch: refetchQuery }] = (0, $5tTFS.useLazyQuery)(query, {
        variables: queryVariables,
        errorPolicy: 'all',
        fetchPolicy: 'cache-first',
        onError: (apolloError)=>{
            (0, $gN11a.markViewMetric)(view.toLowerCase(), (0, $a286480ec63fa4c8$export$ac953882305d6102));
            // do not fire error if user doesn't have project permissions
            if ($90cf08abf5e3ede7$var$isProjectPermissionError(apolloError)) return;
            (0, $jcw0u.default)({
                meta: {
                    id: `availableFields${view}ViewQuery`,
                    packageName: 'jiraBusinessEntityProject',
                    teamName: 'wanjel'
                },
                attributes: {
                    message: `Failed to fetch available fields in ${view} view`
                },
                error: apolloError,
                sendToPrivacyUnsafeSplunk: true
            });
        },
        onCompleted: (onCompletedData)=>{
            (0, $gN11a.markViewMetric)(view.toLowerCase(), (0, $a286480ec63fa4c8$export$ac953882305d6102));
            if (onCompletedData?.jiraBusinessAvailableFields == null) throw error || new Error('No available fields data');
            onCompletedData?.jiraBusinessAvailableFields?.edges?.forEach((e)=>{
                const fieldEdges = e?.node?.fields?.edges;
                if (fieldEdges == null || fieldEdges?.length === 0) {
                    const emptyMessage = fieldEdges == null ? 'null fields' : '0 length fields';
                    const emptyFieldsError = new Error(`availableFieldsAPI is returning ${emptyMessage} for issueType ${e?.node?.issueType.name ?? 'UNKNOWN'}`);
                    // retrying due to intermittent error related to new projects: FUN-570
                    if (fetchAttempts.current < 1) {
                        fetchAttempts.current += 1;
                        refetch();
                    } else throw emptyFieldsError;
                }
            });
        }
    });
    (0, $5uXOq.useEffect)(()=>{
        if (queryVariables && !hasStartedFetchingFields && !error) {
            setHasStartedFetchingFields(true);
            (0, $gN11a.markViewMetric)(view.toLowerCase(), (0, $a286480ec63fa4c8$export$7b887ee35f2b465e));
            getAvailableFields();
        }
    }, [
        error,
        getAvailableFields,
        hasStartedFetchingFields,
        queryVariables,
        view
    ]);
    const refetch = (0, $5uXOq.useCallback)(()=>{
        if (called && typeof refetchQuery === 'function') return refetchQuery(queryVariables);
        const err = new Error('availableFields refetch is undefined because the service has not been called yet');
        (0, $jcw0u.default)({
            meta: {
                id: 'availableFieldsRefetchIsUndefined',
                packageName: 'jiraBusinessEntityProject',
                teamName: 'wanjel'
            },
            error: err,
            sendToPrivacyUnsafeSplunk: true
        });
        throw err;
    }, [
        called,
        refetchQuery,
        queryVariables
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (hasStartedFetchingFields && error) setHasStartedFetchingFields(false);
    }, [
        hasStartedFetchingFields,
        error
    ]);
    const result = (0, $5uXOq.useMemo)(()=>(0, $8tTgF.transformResult)(data), [
        data
    ]);
    const typesWithFields = (0, $5uXOq.useMemo)(()=>(0, $8tTgF.transformResultToTypesWithFields)(data), [
        data
    ]);
    const hierarchyLevels = (0, $5uXOq.useMemo)(()=>result.issueTypes.map((issueType)=>({
                level: issueType.hierarchyLevel,
                name: issueType.name,
                id: issueType.id
            })).sort((a, b)=>a.level !== b.level ? b.level - a.level : a.name.localeCompare(b.name)), [
        result.issueTypes
    ]);
    // make sure "loading" flag starts from "true"
    const isFieldsLoading = hasStartedFetchingFields ? loading : true;
    return {
        error: error,
        loading: error ? false : isQueryLoading || isFieldsLoading,
        data: result,
        typesWithFields: typesWithFields,
        hierarchyLevels: hierarchyLevels,
        refetch: refetch
    };
};
const $90cf08abf5e3ede7$var$issueTypesAndFieldsContextDefaultValue = {
    data: {
        fields: [],
        issueTypes: []
    },
    loading: false,
    error: undefined,
    typesWithFields: [],
    hierarchyLevels: []
};
const $90cf08abf5e3ede7$export$77937175321fab39 = /*#__PURE__*/ (0, $5uXOq.createContext)({
    ...$90cf08abf5e3ede7$var$issueTypesAndFieldsContextDefaultValue
});
const $90cf08abf5e3ede7$export$fbd286e14113bfc = /*#__PURE__*/ (0, $5uXOq.createContext)({
    ...$90cf08abf5e3ede7$var$issueTypesAndFieldsContextDefaultValue
});
const $90cf08abf5e3ede7$export$d2121b02f0b65782 = (input)=>{
    const issueTypesAndFieldsViewData = (0, $5uXOq.useContext)($90cf08abf5e3ede7$export$77937175321fab39);
    const issueTypesAndFieldsCreateData = (0, $5uXOq.useContext)($90cf08abf5e3ede7$export$fbd286e14113bfc);
    if (!input || input.issueOperation === 'VIEW') return issueTypesAndFieldsViewData;
    return issueTypesAndFieldsCreateData;
};

});
const $a286480ec63fa4c8$export$747aad128920134d = 3000;
const $a286480ec63fa4c8$export$e4f8d353742c04ac = 4000;
const $a286480ec63fa4c8$export$540ffd289e5e0562 = 'timeWaitingForBackendData';
const $a286480ec63fa4c8$export$23e322eb7c526958 = 'REQUEST_START';
const $a286480ec63fa4c8$export$83ca21a50372ea3b = 'REQUEST_END';
const $a286480ec63fa4c8$export$821ca6ff41f300ec = 'jwm-availableFieldsQuery';
const $a286480ec63fa4c8$export$7b887ee35f2b465e = 'AVAILABLE_FIELDS_QUERY_START';
const $a286480ec63fa4c8$export$ac953882305d6102 = 'AVAILABLE_FIELDS_QUERY_END';
const $a286480ec63fa4c8$export$7f7f60b5526c5ee3 = 'jwm-ui-render-time';
const $a286480ec63fa4c8$export$b78f0bbf209e5f4 = 'UI_RENDER_START';
const $a286480ec63fa4c8$export$88ea1e280513690f = 'UI_RENDER_END';

parcelRegister("8Zw8m", function(module, exports) {

$parcel$export(module.exports, "DEFAULT", () => $c9bd1f086657e924$export$e6952b12ade67489);
$parcel$export(module.exports, "HierarchyLevel", () => $c9bd1f086657e924$export$7faaf3222dfd10db);
const $c9bd1f086657e924$export$e6952b12ade67489 = 'default';
const $c9bd1f086657e924$export$7faaf3222dfd10db = Object.freeze({
    EPIC: 1,
    BASE: 0,
    SUBTASK: -1
});

});

parcelRegister("8tTgF", function(module, exports) {

$parcel$export(module.exports, "transformResult", () => $66b8ed432f1db6bc$export$f13b29f9ed0c5a03);
$parcel$export(module.exports, "transformResultToTypesWithFields", () => $66b8ed432f1db6bc$export$55ab7865f91ba09b);
$parcel$export(module.exports, "JWMQueryByRouteMap", () => $66b8ed432f1db6bc$export$7188da46161cbb8f);

var $5fc53 = parcelRequire("5fc53");

var $4R6GH = parcelRequire("4R6GH");

var $8Zw8m = parcelRequire("8Zw8m");

var $e3MSU = parcelRequire("e3MSU");
const $66b8ed432f1db6bc$export$b07b0d8dc0894ecf = {
    fields: [],
    issueTypes: []
};
const $66b8ed432f1db6bc$var$emptyArray = [];
const $66b8ed432f1db6bc$export$bffa388e20165996 = (node, issueType)=>{
    const fieldConfig = {
        isRequired: !!node.fieldConfig?.isRequired,
        isEditable: !!node.fieldConfig?.isEditable
    };
    if (node.type === 'priority') {
        fieldConfig.options = node.priorities.nodes;
        // Set middle priority as default if backend doesn't return any
        if (node.priority) fieldConfig.defaultPriorityId = node.priority.priorityId;
        else if (fieldConfig.options.length > 0) fieldConfig.defaultPriorityId = // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
        node.priorities.nodes[Math.floor(fieldConfig.options.length / 2)].priorityId;
    }
    if (node.type === 'issuetype') {
        fieldConfig.options = node.issueTypes.nodes;
        fieldConfig.avatarId = issueType.avatarId;
        fieldConfig.avatarUrl = issueType.avatar?.medium;
    }
    if (node.type === 'issuelinks' && node.issueLinkTypeRelations) // 'is blocked by' / 'blocks' is used as the default issue link type
    fieldConfig.defaultIssueLinkTypeId = node.issueLinkTypeRelations.nodes.find(// @ts-expect-error - TS7006 - Parameter 'linkNode' implicitly has an 'any' type.
    (linkNode)=>linkNode.relationName === 'is blocked by')?.linkTypeId || // take the first awailable otherwise
    node.issueLinkTypeRelations.nodes[0]?.linkTypeId;
    if (node.type === (0, $5fc53.MULTI_SELECT_CF_TYPE) || node.type === (0, $5fc53.SELECT_CF_TYPE)) {
        const fieldOptions = [];
        // convert so that it can be used by the select field
        // @ts-expect-error - TS7031 - Binding element 'value' implicitly has an 'any' type. | TS7031 - Binding element 'optionId' implicitly has an 'any' type.
        node.fieldOptions.nodes.forEach(({ value: value, optionId: optionId })=>{
            fieldOptions.push({
                value: value,
                label: value,
                optionId: optionId
            });
        });
        fieldConfig.selectOptions = fieldOptions;
    }
    if (node.type === (0, $5fc53.MULTI_CHECKBOXES_CF_TYPE)) {
        const fieldOptions = [];
        // convert so that it can be used by the select field
        // @ts-expect-error - TS7031 - Binding element 'value' implicitly has an 'any' type. | TS7031 - Binding element 'optionId' implicitly has an 'any' type.
        node.fieldOptions.nodes.forEach(({ value: value, optionId: optionId })=>{
            fieldOptions.push({
                value: value,
                label: value,
                optionId: optionId
            });
        });
        fieldConfig.selectOptions = fieldOptions;
    }
    if (node.type === (0, $5fc53.CATEGORY_TYPE)) {
        // @ts-expect-error - TS2304 - Cannot find name 'SelectOption'.
        const fieldOptions = [];
        // convert so that it can be used by the select field
        // @ts-expect-error - TS7031 - Binding element 'value' implicitly has an 'any' type. | TS7031 - Binding element 'optionId' implicitly has an 'any' type.
        node.fieldOptions.nodes.forEach(({ value: value, optionId: optionId, color: color })=>{
            fieldOptions.push({
                value: value,
                label: value,
                optionId: optionId,
                color: color?.colorKey ?? null
            });
        });
        fieldConfig.selectOptions = fieldOptions;
    }
    const shouldAddIsSearchableInJql = (0, $4R6GH.fg)('jira_issue_field_searchable_in_jql_data_fetcher') && typeof node.isSearchableInJql === 'boolean';
    return {
        id: node.fieldId,
        aliasFieldId: node.aliasFieldId,
        name: node.name,
        type: node.type,
        fieldConfig: fieldConfig,
        ...shouldAddIsSearchableInJql && {
            isSearchableInJql: node.isSearchableInJql
        },
        issueTypes: [],
        __typename: node.__typename
    };
};
const $66b8ed432f1db6bc$export$f13b29f9ed0c5a03 = (data)=>{
    if (data && data.jiraBusinessAvailableFields && data.jiraBusinessAvailableFields.edges) {
        const issueFieldsById = {};
        const issueTypesById = {};
        data.jiraBusinessAvailableFields.edges.map((edge)=>edge && edge.node || {}).forEach(// @ts-expect-error - TS2345 - Argument of type '({ issueType, fields, isDefaultIssueType, }: { issueType: {    name: string;    issueTypeId: string;    type: string;    avatarId: string;    hierarchy?: {        level: number;    };}; fields: {    edges: {        nodes: [];    }[];}; isDefaultIssueType: boolean; }) => void' is not assignable to parameter of type '(value: {}, index: number, array: {}[]) => void'.
        ({ issueType: issueType, fields: fields, isDefaultIssueType: isDefaultIssueType })=>{
            issueTypesById[issueType.issueTypeId] = {
                id: issueType.issueTypeId,
                isDefault: isDefaultIssueType,
                name: issueType.name,
                subtask: issueType.type === 'SUB_TASK',
                avatarId: issueType.avatarId,
                avatarUrl: issueType.avatar?.medium ?? null,
                hierarchyLevel: issueType.hierarchy?.level ?? 0
            };
            fields.edges// @ts-expect-error - TS2551 - Property 'node' does not exist on type '{ nodes: []; }'. Did you mean 'nodes'?
            .map((edge)=>edge && edge.node || {}).forEach((node)=>{
                if (node.fieldId) {
                    if (!issueFieldsById[node.fieldId]) issueFieldsById[node.fieldId] = $66b8ed432f1db6bc$export$bffa388e20165996(node, issueType);
                    issueFieldsById[node.fieldId].issueTypes = issueFieldsById[node.fieldId].issueTypes || [];
                    // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
                    issueFieldsById[node.fieldId].issueTypes.push(issueType.issueTypeId);
                }
            });
        });
        return {
            fields: Object.keys(issueFieldsById).map((id)=>issueFieldsById[id]),
            issueTypes: Object.keys(issueTypesById).map((id)=>issueTypesById[id])
        };
    }
    // @ts-expect-error - TS2322 - Type '{ readonly fields: readonly []; readonly issueTypes: readonly []; }' is not assignable to type '{ fields: BusinessIssueField[]; issueTypes: BusinessIssueType[]; }'.
    return $66b8ed432f1db6bc$export$b07b0d8dc0894ecf;
};
const $66b8ed432f1db6bc$export$55ab7865f91ba09b = (data)=>{
    if (data && data.jiraBusinessAvailableFields && data.jiraBusinessAvailableFields.edges) return data.jiraBusinessAvailableFields.edges.map((edge)=>edge && edge.node || {}).map(// @ts-expect-error - TS2345 - Argument of type '({ issueType, fields, isDefaultIssueType, }: { issueType: {    name: string;    issueTypeId: string;    type: string;    avatarId: string;    hierarchy?: {        level: number;    };}; fields: {    edges: {        nodes: [];    }[];}; isDefaultIssueType: boolean; }) => { issueType: { id: string; isDefault: boolean;...' is not assignable to parameter of type '(value: {}, index: number, array: {}[]) => { issueType: { id: string; isDefault: boolean; name: string; subtask: boolean; avatarId: string; hierarchyLevel: number; }; fields: BusinessIssueField[]; }'.
    ({ issueType: issueType, fields: fields, isDefaultIssueType: isDefaultIssueType })=>({
            issueType: {
                id: issueType.issueTypeId,
                isDefault: isDefaultIssueType,
                name: issueType.name,
                subtask: issueType.type === 'SUB_TASK',
                avatarId: issueType.avatarId,
                avatarUrl: issueType.avatar?.medium ?? '',
                hierarchyLevel: issueType.hierarchy?.level ?? 0
            },
            fields: fields.edges// @ts-expect-error - TS2551 - Property 'node' does not exist on type '{ nodes: []; }'. Did you mean 'nodes'?
            .map((edge)=>edge && edge.node || {}).map((node)=>$66b8ed432f1db6bc$export$bffa388e20165996(node, issueType))
        }));
    return $66b8ed432f1db6bc$var$emptyArray;
};
const $66b8ed432f1db6bc$export$7188da46161cbb8f = {
    'classic-business-form': {
        view: 'Form',
        query: (0, $e3MSU.ISSUE_TYPES_AND_FIELDS_FORM_QUERY)
    },
    'classic-business-form-submit': {
        view: 'FormSubmit',
        query: (0, $e3MSU.ISSUE_TYPES_AND_FIELDS_FORM_SUBMIT_QUERY)
    },
    'classic-business-calendar': {
        view: 'Calendar',
        query: (0, $e3MSU.ISSUE_TYPES_AND_FIELDS_CALENDAR_QUERY)
    },
    'classic-business-calendar-embed': {
        view: 'CalendarEmbed',
        query: (0, $e3MSU.ISSUE_TYPES_AND_FIELDS_CALENDAR_QUERY)
    },
    'classic-business-list': {
        view: 'List',
        query: (0, $e3MSU.ISSUE_TYPES_AND_FIELDS_LIST_QUERY)
    },
    'classic-business-list-embed': {
        view: 'ListEmbed',
        query: (0, $e3MSU.ISSUE_TYPES_AND_FIELDS_LIST_QUERY)
    },
    'classic-business-timeline': {
        view: 'Timeline',
        query: (0, $e3MSU.ISSUE_TYPES_AND_FIELDS_TIMELINE_QUERY)
    },
    'classic-business-timeline-embed': {
        view: 'TimelineEmbed',
        query: (0, $e3MSU.ISSUE_TYPES_AND_FIELDS_TIMELINE_QUERY)
    },
    'classic-business-board': {
        view: 'Board',
        query: (0, $e3MSU.ISSUE_TYPES_AND_FIELDS_BOARD_QUERY)
    },
    'classic-business-board-embed': {
        view: 'BoardEmbed',
        query: (0, $e3MSU.ISSUE_TYPES_AND_FIELDS_BOARD_QUERY)
    },
    'classic-business-board-custom-embed': {
        view: 'BoardEmbed',
        query: (0, $e3MSU.ISSUE_TYPES_AND_FIELDS_BOARD_QUERY)
    },
    [(0, $8Zw8m.DEFAULT)]: {
        view: 'Common',
        query: (0, $e3MSU.ISSUE_TYPES_AND_FIELDS_LIST_QUERY)
    }
};

});
parcelRegister("e3MSU", function(module, exports) {

$parcel$export(module.exports, "ISSUE_TYPES_AND_FIELDS_LIST_QUERY", () => $32ca725097f9e68f$export$ba5f98a8d6136727);
$parcel$export(module.exports, "ISSUE_TYPES_AND_FIELDS_CALENDAR_QUERY", () => $32ca725097f9e68f$export$cba408dff1091b60);
$parcel$export(module.exports, "ISSUE_TYPES_AND_FIELDS_TIMELINE_QUERY", () => $32ca725097f9e68f$export$363435cea078aa93);
$parcel$export(module.exports, "ISSUE_TYPES_AND_FIELDS_BOARD_QUERY", () => $32ca725097f9e68f$export$1641a42cf2cdb09a);
$parcel$export(module.exports, "ISSUE_TYPES_AND_FIELDS_FORM_QUERY", () => $32ca725097f9e68f$export$7903c43b0ec55315);
$parcel$export(module.exports, "ISSUE_TYPES_AND_FIELDS_FORM_SUBMIT_QUERY", () => $32ca725097f9e68f$export$79304c172f5555ae);

var $5cllN = parcelRequire("5cllN");
const $32ca725097f9e68f$export$ec2562ca5badac3b = (0, $5cllN.default)`
  fragment GetIssueTypesAndFields on JiraBusinessAvailableFields {
    issueType {
      issueTypeId
      name
      type
      avatarId
      avatar {
        medium
      }
      hierarchy {
        level
      }
    }
    isDefaultIssueType
    fields {
      edges {
        node {
          fieldId
          type
          name
          aliasFieldId
          isSearchableInJql @include(if: $isSearchableInJqlEnabled)
          ... on GenericIssueField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraIssueTypeField {
            fieldConfig {
              isRequired
              isEditable
            }
            issueTypes {
              nodes {
                name
                id
              }
            }
          }
          ... on JiraPriorityField {
            fieldConfig {
              isRequired
              isEditable
            }
            priority {
              priorityId
            }
            priorities {
              nodes {
                priorityId
                name
                iconUrl
              }
            }
          }
          ... on JiraLabelsField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraSingleSelectUserPickerField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraSingleLineTextField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraDatePickerField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraAffectedServicesField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraAttachmentsField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraCMDBField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraCascadingSelectField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraCheckboxesField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraColorField {
            fieldConfig {
              isRequired
              isEditable
            }
            color {
              colorKey
            }
          }
          ... on JiraComponentsField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraDateTimePickerField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraEpicLinkField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraIssueLinkField {
            fieldConfig {
              isRequired
              isEditable
            }
            issueLinkTypeRelations(first: 10) {
              nodes {
                linkTypeId
                relationName
              }
            }
          }
          ... on JiraIssueRestrictionField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraMultipleGroupPickerField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraMultipleSelectField {
            fieldConfig {
              isRequired
              isEditable
            }
            fieldOptions {
              nodes {
                id
                optionId
                value
              }
            }
          }
          ... on JiraMultipleSelectUserPickerField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraMultipleVersionPickerField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraNumberField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
					... on JiraParentIssueField {
						fieldConfig {
							isRequired
							isEditable
						}
					}
          ... on JiraPeopleField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraProjectField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraRadioSelectField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraResolutionField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraRichTextField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraSecurityLevelField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraSingleGroupPickerField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraSingleSelectField {
            fieldConfig {
              isRequired
              isEditable
            }
            fieldOptions {
              nodes {
                id
                optionId
                value
              }
            }
          }
          ... on JiraSingleVersionPickerField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraSprintField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraTeamField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraUrlField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JsmRequestTypeField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JWMCategoryField {
            fieldConfig {
              isRequired
              isEditable
            }
            fieldOptions {
              nodes {
                id
                optionId
                value
                color {
                    colorKey
                }
              }
            }
          }
          ... on JiraCheckboxesField {
            fieldConfig {
              isRequired
              isEditable
            }
            fieldOptions {
              nodes {
                id
                optionId
                value
              }
            }
          }
          ... on JiraAtlassianTeamField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraGoalsField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
        }
      }
    }
  }
`;
const $32ca725097f9e68f$export$ba5f98a8d6136727 = (0, $5cllN.default)`
  query JiraBusinessAvailableFieldsListView ($projectKey: String!, $issueOperation: JiraBusinessIssueOperation, $first: Int, $last: Int, $before: String, $after: String, $isSearchableInJqlEnabled: Boolean = false) {
      jiraBusinessAvailableFields(projectKey: $projectKey, issueOperation: $issueOperation, first: $first, last: $last, before: $before, after: $after) {
        edges {
          node {
            ...GetIssueTypesAndFields
          }
        }
      }
  }
  ${$32ca725097f9e68f$export$ec2562ca5badac3b}
`;
const $32ca725097f9e68f$export$cba408dff1091b60 = (0, $5cllN.default)`
  query JiraBusinessAvailableFieldsCalendarView ($projectKey: String!, $issueOperation: JiraBusinessIssueOperation, $first: Int, $last: Int, $before: String, $after: String, $isSearchableInJqlEnabled: Boolean = false) {
      jiraBusinessAvailableFields(projectKey: $projectKey, issueOperation: $issueOperation, first: $first, last: $last, before: $before, after: $after) {
        edges {
          node {
            ...GetIssueTypesAndFields
          }
        }
      }
  }
  ${$32ca725097f9e68f$export$ec2562ca5badac3b}
`;
const $32ca725097f9e68f$export$363435cea078aa93 = (0, $5cllN.default)`
  query JiraBusinessAvailableFieldsTimelineView ($projectKey: String!, $issueOperation: JiraBusinessIssueOperation, $first: Int, $last: Int, $before: String, $after: String, $isSearchableInJqlEnabled: Boolean = false) {
      jiraBusinessAvailableFields(projectKey: $projectKey, issueOperation: $issueOperation, first: $first, last: $last, before: $before, after: $after) {
        edges {
          node {
            ...GetIssueTypesAndFields
          }
        }
      }
  }
  ${$32ca725097f9e68f$export$ec2562ca5badac3b}
`;
const $32ca725097f9e68f$export$1641a42cf2cdb09a = (0, $5cllN.default)`
  query JiraBusinessAvailableFieldsBoardView ($projectKey: String!, $issueOperation: JiraBusinessIssueOperation, $first: Int, $last: Int, $before: String, $after: String, $isSearchableInJqlEnabled: Boolean = false) {
      jiraBusinessAvailableFields(projectKey: $projectKey, issueOperation: $issueOperation, first: $first, last: $last, before: $before, after: $after) {
        edges {
          node {
            ...GetIssueTypesAndFields
          }
        }
      }
  }
  ${$32ca725097f9e68f$export$ec2562ca5badac3b}
`;
const $32ca725097f9e68f$export$7903c43b0ec55315 = (0, $5cllN.default)`
  query JiraBusinessAvailableFieldsFormView ($projectKey: String!, $issueOperation: JiraBusinessIssueOperation, $first: Int, $last: Int, $before: String, $after: String, $isSearchableInJqlEnabled: Boolean = false) {
      jiraBusinessAvailableFields(projectKey: $projectKey, issueOperation: $issueOperation, first: $first, last: $last, before: $before, after: $after) {
        edges {
          node {
            ...GetIssueTypesAndFields
          }
        }
      }
  }
  ${$32ca725097f9e68f$export$ec2562ca5badac3b}
`;
const $32ca725097f9e68f$export$79304c172f5555ae = (0, $5cllN.default)`
  query JiraBusinessAvailableFieldsFormSubmitView ($projectKey: String!, $issueOperation: JiraBusinessIssueOperation, $first: Int, $last: Int, $before: String, $after: String, $isSearchableInJqlEnabled: Boolean = false) {
      jiraBusinessAvailableFields(projectKey: $projectKey, issueOperation: $issueOperation, first: $first, last: $last, before: $before, after: $after) {
        edges {
          node {
            ...GetIssueTypesAndFields
          }
        }
      }
  }
  ${$32ca725097f9e68f$export$ec2562ca5badac3b}
`;

});




parcelRegister("1TU9r", function(module, exports) {

$parcel$export(module.exports, "DeserialisedFiltersProvider", () => $fbaf3c30d9711dbc$export$c5640c1fbeb250b6);
$parcel$export(module.exports, "useDeserialisedFilters", () => $fbaf3c30d9711dbc$export$ac7ff3aa0620d1a7);
$parcel$export(module.exports, "useDeserialiseJqlFilters", () => $fbaf3c30d9711dbc$export$eaa578dc219a620a);
$parcel$export(module.exports, "useDeserialiseJqlFiltersWithContext", () => $fbaf3c30d9711dbc$export$87f52da20e747485);

var $5uXOq = parcelRequire("5uXOq");

var $g9ql5 = parcelRequire("g9ql5");

var $8DJTW = parcelRequire("8DJTW");

var $17ot5 = parcelRequire("17ot5");

var $l4Ejo = parcelRequire("l4Ejo");

var $dpQnO = parcelRequire("dpQnO");

var $2RV6Z = parcelRequire("2RV6Z");
const $fbaf3c30d9711dbc$var$DEFAULT_VALUE = {
    filters: {}
};
/* Context used by the board view until the filters get implemented in the backend */ const $fbaf3c30d9711dbc$var$DeserialisedFiltersContext = /*#__PURE__*/ (0, $5uXOq.createContext)($fbaf3c30d9711dbc$var$DEFAULT_VALUE);
const $fbaf3c30d9711dbc$export$c5640c1fbeb250b6 = ({ children: children })=>{
    const [filters, setFilters] = (0, $5uXOq.useState)({});
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(true);
    const value = (0, $5uXOq.useMemo)(()=>({
            filters: filters,
            setFilters: setFilters,
            isLoading: isLoading,
            setIsLoading: setIsLoading
        }), [
        filters,
        isLoading
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fbaf3c30d9711dbc$var$DeserialisedFiltersContext.Provider, {
        value: value
    }, children);
};
const $fbaf3c30d9711dbc$export$ac7ff3aa0620d1a7 = ()=>(0, $5uXOq.useContext)($fbaf3c30d9711dbc$var$DeserialisedFiltersContext);
const $fbaf3c30d9711dbc$var$EMPTY_FILTER = {};
const $fbaf3c30d9711dbc$export$eaa578dc219a620a = ({ view: view, allowedFieldTypes: allowedFieldTypes, allowedAliasFieldId: allowedAliasFieldId, allowCustomFields: allowCustomFields })=>{
    const { jql: jql, setFilter: setFilter } = (0, $l4Ejo.useFilters)();
    const { fieldConfig: fieldConfig, resolvers: resolvers, customFieldsLoader: customFieldsLoader, loading: isLoadingFieldConfig } = (0, $g9ql5.useFieldConfigWithCustomFields)({
        view: view,
        allowedFieldTypes: allowedFieldTypes,
        allowedAliasFieldId: allowedAliasFieldId,
        allowCustomFields: allowCustomFields
    });
    const { setFilters: setContextFilters, setIsLoading: setIsLoadingFilters } = $fbaf3c30d9711dbc$export$ac7ff3aa0620d1a7();
    const [filters, setFilters] = (0, $5uXOq.useState)({});
    const [error, setError] = (0, $5uXOq.useState)(null);
    const hasFilterError = error != null;
    const [isDeserialisingFilters, setIsDeserialisingFilters] = (0, $5uXOq.useState)(false);
    const [filtersCache, setFiltersCache] = (0, $5uXOq.useState)({});
    const { data: filterFields, loading: isLoadingFilterFields } = (0, $8DJTW.useFilterFields)();
    const { quickFiltersJql: quickFiltersJql } = (0, $dpQnO.useQuickFilters)();
    (0, $5uXOq.useEffect)(()=>{
        // Skip if loading
        if (isDeserialisingFilters || isLoadingFieldConfig || isLoadingFilterFields) return;
        // Skip if no fields supported
        if (!Object.keys(fieldConfig).length) return;
        // Skip if deserialised this jql before
        if (jql != null && filters === filtersCache[jql]) return;
        // Skip if has error and jql not empty
        if (hasFilterError && jql != null) return;
        if (jql == null) {
            if (hasFilterError) setError(null);
            if (filters !== $fbaf3c30d9711dbc$var$EMPTY_FILTER) setFilters($fbaf3c30d9711dbc$var$EMPTY_FILTER);
            return;
        }
        if (quickFiltersJql !== null) {
            setFilters($fbaf3c30d9711dbc$var$EMPTY_FILTER);
            return;
        }
        if (filtersCache[jql]) {
            setFilters(filtersCache[jql]);
            return;
        }
        setIsDeserialisingFilters(true);
        setIsLoadingFilters?.(true);
        (0, $2RV6Z.deserialiseJql)(jql, fieldConfig, filterFields, resolvers).then((result)=>{
            setFilters(result);
            setFiltersCache({
                ...filtersCache,
                [jql]: result
            });
            setContextFilters?.(result);
        }).catch((e)=>{
            setError(e);
        }).finally(()=>{
            setIsDeserialisingFilters(false);
            setIsLoadingFilters?.(false);
        });
    }, [
        hasFilterError,
        quickFiltersJql,
        error,
        filters,
        isLoadingFieldConfig,
        isLoadingFilterFields,
        fieldConfig,
        jql,
        filtersCache,
        filterFields,
        resolvers,
        isDeserialisingFilters,
        setIsLoadingFilters,
        setContextFilters
    ]);
    (0, $17ot5.useInferHideDoneItemsWithFilters)({
        filters: filters
    });
    return {
        fieldConfig: fieldConfig,
        filters: filters,
        hasFilterError: hasFilterError,
        customFieldsLoader: customFieldsLoader,
        setFilters: setFilter,
        loading: isLoadingFieldConfig || isDeserialisingFilters
    };
};
const $fbaf3c30d9711dbc$export$87f52da20e747485 = (props)=>{
    const { fieldConfig: fieldConfig, filters: filters, hasFilterError: hasFilterError, customFieldsLoader: customFieldsLoader, setFilters: setFilters, loading: loading } = $fbaf3c30d9711dbc$export$eaa578dc219a620a(props);
    const { setFilters: setContextFilters, setIsLoading: setIsLoadingFilters } = $fbaf3c30d9711dbc$export$ac7ff3aa0620d1a7();
    (0, $5uXOq.useEffect)(()=>{
        if (setContextFilters) setContextFilters(filters);
    }, [
        filters,
        setContextFilters
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (setIsLoadingFilters) setIsLoadingFilters(loading);
    }, [
        loading,
        setIsLoadingFilters
    ]);
    return {
        fieldConfig: fieldConfig,
        filters: filters,
        hasFilterError: hasFilterError,
        customFieldsLoader: customFieldsLoader,
        setFilters: setFilters
    };
};

});
parcelRegister("g9ql5", function(module, exports) {

$parcel$export(module.exports, "useFieldConfigWithCustomFields", () => $937abfae1d89db7d$export$9f6dc7e3584916fa);

var $5uXOq = parcelRequire("5uXOq");

var $5fc53 = parcelRequire("5fc53");

var $gzkAf = parcelRequire("gzkAf");

var $5FlVd = parcelRequire("5FlVd");

var $RjSi3 = parcelRequire("RjSi3");

var $cLe9v = parcelRequire("cLe9v");
const $937abfae1d89db7d$var$emptySet = new Set();
const $937abfae1d89db7d$var$CustomFieldsLoader = ({ allowedFieldTypes: allowedFieldTypes, allowedAliasFieldId: allowedAliasFieldId, setFieldConfig: setFieldConfig })=>{
    const { fieldConfig: fieldConfig, resolvers: resolvers, loading: loading } = (0, $cLe9v.useFieldConfig)({
        allowedFieldTypes: allowedFieldTypes,
        allowedAliasFieldId: allowedAliasFieldId
    });
    (0, $5uXOq.useEffect)(()=>{
        setFieldConfig({
            fieldConfig: fieldConfig,
            resolvers: resolvers,
            loading: loading
        });
    }, [
        fieldConfig,
        resolvers,
        loading,
        setFieldConfig
    ]);
    return null;
};
const $937abfae1d89db7d$export$9f6dc7e3584916fa = ({ view: view, allowCustomFields: allowCustomFields, allowedAliasFieldId: allowedAliasFieldId, allowedFieldTypes: allowedFieldTypes })=>{
    const [newAllowedFieldTypes, oldAllowedFieldTypes] = (0, $5uXOq.useMemo)(()=>{
        // split allowedFieldTypes into new and old input for useFieldConfigV2 and useFieldConfigOld
        const newTypes = new Set(allowedFieldTypes);
        const oldTypes = new Set();
        (0, $gzkAf.EXTRA_CUSTOM_FIELD_TYPES).forEach((type)=>{
            if (allowedFieldTypes.has(type)) {
                newTypes.delete(type);
                oldTypes.add(type);
            }
        });
        return [
            newTypes,
            oldTypes
        ];
    }, [
        allowedFieldTypes
    ]);
    const hasCustomFields = Boolean(allowCustomFields) && oldAllowedFieldTypes.size > 0;
    const hasAliasFields = allowedAliasFieldId != null && allowedAliasFieldId.size > 0;
    const shouldLoadOldFieldConfig = hasAliasFields || hasCustomFields;
    const { fieldConfig: fieldConfigNew, resolvers: resolversNew, loading: isLoadingFieldConfigNew } = (0, $RjSi3.useFieldConfigV2)({
        view: view,
        allowedFieldTypes: newAllowedFieldTypes
    });
    const [{ fieldConfig: fieldConfigOld, loading: isLoadingFieldConfigOld, resolvers: resolversOld }, setFieldConfig] = (0, $5uXOq.useState)({
        fieldConfig: {},
        resolvers: {},
        loading: shouldLoadOldFieldConfig
    });
    const customFieldsLoader = (0, $5uXOq.useMemo)(()=>{
        if (!shouldLoadOldFieldConfig) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($937abfae1d89db7d$var$CustomFieldsLoader, {
            allowedFieldTypes: allowCustomFields ? oldAllowedFieldTypes : $937abfae1d89db7d$var$emptySet,
            allowedAliasFieldId: allowedAliasFieldId,
            setFieldConfig: setFieldConfig
        });
    }, [
        allowCustomFields,
        allowedAliasFieldId,
        oldAllowedFieldTypes,
        shouldLoadOldFieldConfig
    ]);
    const { fetchUsers: fetchUsers } = (0, $5FlVd.useFetchFieldValues)({
        view: view,
        allowedFieldTypes: allowedFieldTypes
    });
    const fieldConfig = (0, $5uXOq.useMemo)(()=>{
        const aliasFields = {};
        const otherFields = {};
        Object.keys(fieldConfigOld).forEach((id)=>{
            if (fieldConfigOld[id].systemType === (0, $5fc53.PEOPLE_CF_TYPE) || fieldConfigOld[id].systemType === (0, $5fc53.USER_CF_TYPE)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            fieldConfigOld[id] = {
                ...fieldConfigOld[id],
                loadOptions: fetchUsers
            };
            // We want to assure that alias fields are always at the end of the filter
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            if (fieldConfigOld[id].aliasFieldId != null) aliasFields[id] = fieldConfigOld[id];
            else otherFields[id] = fieldConfigOld[id];
        });
        return {
            ...otherFields,
            ...fieldConfigNew,
            ...aliasFields
        };
    }, [
        fieldConfigOld,
        fieldConfigNew,
        fetchUsers
    ]);
    return {
        fieldConfig: fieldConfig,
        resolvers: {
            ...resolversOld,
            ...resolversNew
        },
        customFieldsLoader: customFieldsLoader,
        loading: isLoadingFieldConfigNew || isLoadingFieldConfigOld
    };
};

});
parcelRegister("5FlVd", function(module, exports) {

$parcel$export(module.exports, "useFetchFieldValues", () => $b6820483a00ce3be$export$6cb851ed13e3949e);

var $5uXOq = parcelRequire("5uXOq");

var $8QpSo = parcelRequire("8QpSo");

var $hE5wF = parcelRequire("hE5wF");

var $5YBrl = parcelRequire("5YBrl");

var $jlq4V = parcelRequire("jlq4V");

var $eusud = parcelRequire("eusud");

var $5fc53 = parcelRequire("5fc53");

var $koeKL = parcelRequire("koeKL");

var $ieDtd = parcelRequire("ieDtd");

var $b4fG8 = parcelRequire("b4fG8");

var $34JdM = parcelRequire("34JdM");

var $czmU8 = parcelRequire("czmU8");

var $84pWT = parcelRequire("84pWT");


var $ldL1T = parcelRequire("ldL1T");
const $b6820483a00ce3be$var$MAX_NUMBER_OF_OPTIONS = 20; // min number to render two rows of the priority filter
const $b6820483a00ce3be$var$MAX_INITIAL_NUMBER_OF_OPTIONS = 50; // Increased initial number of options fetched
const $b6820483a00ce3be$var$EMPTY_FIELD_DATA = {
    totalCount: 0,
    options: []
};
const $b6820483a00ce3be$var$ACTIVE_SPRINTS_JQL = '(sprint in openSprints() OR sprint in futureSprints())';
const $b6820483a00ce3be$var$fetchInitialDataInternal = async (cloudId, jqlContext, jqlURLParam, allowedFieldTypes, goalsJqlTerm)=>{
    try {
        const response = await (0, $eusud.performPostRequest)('/rest/gira/1/?operation=JWMInitialFilterFieldValues', {
            body: JSON.stringify({
                query: (0, $c4148dc6c1f759d4$export$a48313dd44fc9855),
                variables: {
                    cloudId: cloudId,
                    first: $b6820483a00ce3be$var$MAX_INITIAL_NUMBER_OF_OPTIONS,
                    jql: jqlContext,
                    shouldFetchSoftwareFields: Boolean(allowedFieldTypes?.has((0, $5fc53.FIX_VERSIONS_TYPE))) || Boolean(allowedFieldTypes?.has((0, $5fc53.SPRINT_TYPE))),
                    shouldFetchGoalsField: Boolean(allowedFieldTypes?.has((0, $5fc53.GOALS_CF_TYPE)) && !!goalsJqlTerm),
                    goalsJqlTerm: goalsJqlTerm || '',
                    sprintsJqlContext: allowedFieldTypes?.has((0, $5fc53.SPRINT_TYPE)) ? `${jqlContext} AND ${$b6820483a00ce3be$var$ACTIVE_SPRINTS_JQL}` : undefined
                }
            })
        });
        if (response.data?.jira?.jqlBuilder == null && response.data?.jwmCategoryOptions == null) throw new (0, $jlq4V.GraphQLErrors)(response.errors);
        const hydratedValues = jqlURLParam ? await (0, $czmU8.hydrateFilterValues)(cloudId, jqlURLParam) : null;
        const transformedInitialData = (0, $ldL1T.transformInitialData)(response.data);
        if (hydratedValues !== null) {
            const transformedHydratedValues = (0, $84pWT.transformHydratedValues)(hydratedValues);
            return (0, $84pWT.mergeHydratedValues)(transformedInitialData, transformedHydratedValues);
        }
        return transformedInitialData;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        (0, $ldL1T.fireFieldValuesErrorAnalytics)('initialiseFilterData', 'Failed to initialise filter data', err);
    }
    return null;
};
const $b6820483a00ce3be$var$memoizedFetchInitialData = (0, $8QpSo.default)($b6820483a00ce3be$var$fetchInitialDataInternal);
const $b6820483a00ce3be$export$6cb851ed13e3949e = ({ view: view, allowedFieldTypes: allowedFieldTypes, filterFields: filterFields })=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const jqlContext = (0, $5YBrl.useJqlContext)();
    const [jqlURLParam] = (0, $ieDtd.useQueryParam)((0, $hE5wF.FILTER_PARAM));
    const jqlURLParamRef = (0, $5uXOq.useRef)(jqlURLParam);
    const goalsJqlTerm = (0, $ldL1T.useGoalsJqlTerm)(filterFields);
    const fetchTeamsService = (0, $34JdM.useFetchTeams)();
    const fetchTeamsServiceNew = (0, $5uXOq.useCallback)(()=>{
        if (allowedFieldTypes?.has((0, $5fc53.TEAMS_PLATFORM_CF_TYPE))) return fetchTeamsService({
            first: $b6820483a00ce3be$var$MAX_NUMBER_OF_OPTIONS
        });
        return Promise.resolve();
    }, [
        allowedFieldTypes,
        fetchTeamsService
    ]);
    const fetchInitialData = (0, $5uXOq.useCallback)(async ()=>{
        return Promise.all([
            $b6820483a00ce3be$var$memoizedFetchInitialData(cloudId, jqlContext, jqlURLParamRef.current, allowedFieldTypes, goalsJqlTerm),
            fetchTeamsServiceNew()
        ]).then((values)=>{
            let result = (0, $b4fG8.EMPTY_TRANSFORMED_DATA);
            values.forEach((value)=>{
                result = {
                    ...result,
                    ...value
                };
            });
            return result;
        });
    }, [
        allowedFieldTypes,
        cloudId,
        fetchTeamsServiceNew,
        goalsJqlTerm,
        jqlContext
    ]);
    const fetchData = (0, $5uXOq.useCallback)(async ({ fieldName: fieldName, query: query = '', first: first = $b6820483a00ce3be$var$MAX_NUMBER_OF_OPTIONS, afterCursor: afterCursor, jqlContext: jqlContextProp })=>{
        const response = await (0, $eusud.performPostRequest)('/rest/gira/1/?operation=JWMFilterFieldValues', {
            body: JSON.stringify({
                query: (0, $c4148dc6c1f759d4$export$f8e8a5f34f6ea725),
                variables: {
                    cloudId: cloudId,
                    first: first,
                    jqlTerm: fieldName,
                    jql: jqlContextProp ?? jqlContext,
                    searchString: query,
                    after: afterCursor
                }
            })
        });
        if (response.data?.jira?.jqlBuilder?.fieldValues == null) throw new (0, $jlq4V.GraphQLErrors)(response.errors);
        return response.data.jira.jqlBuilder.fieldValues;
    }, [
        cloudId,
        jqlContext
    ]);
    const fetchLabels = (0, $5uXOq.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first })=>{
        try {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const fieldValuesData = await fetchData({
                fieldName: 'labels',
                query: query,
                first: first,
                afterCursor: afterCursor
            });
            return {
                totalCount: fieldValuesData.totalCount,
                options: (0, $b4fG8.transformDefaultField)(fieldValuesData)
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $ldL1T.fireFieldValuesErrorAnalytics)('searchFilterLabels', 'Failed to search labels', err);
        }
        return $b6820483a00ce3be$var$EMPTY_FIELD_DATA;
    }, [
        fetchData
    ]);
    const fetchComponents = (0, $5uXOq.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first })=>{
        try {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const fieldValuesData = await fetchData({
                fieldName: 'component',
                query: query,
                first: first,
                afterCursor: afterCursor
            });
            return {
                totalCount: fieldValuesData.totalCount,
                options: (0, $b4fG8.transformDefaultField)(fieldValuesData)
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $ldL1T.fireFieldValuesErrorAnalytics)('searchFilterComponents', 'Failed to search components', err);
        }
        return $b6820483a00ce3be$var$EMPTY_FIELD_DATA;
    }, [
        fetchData
    ]);
    const fetchPriorities = (0, $5uXOq.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first })=>{
        try {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const fieldValuesData = await fetchData({
                fieldName: 'priority',
                query: query,
                first: first,
                afterCursor: afterCursor
            });
            return {
                totalCount: fieldValuesData.totalCount,
                options: (0, $b4fG8.transformPriorities)(fieldValuesData)
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $ldL1T.fireFieldValuesErrorAnalytics)('searchFilterPriorities', 'Failed to search priorities', err);
        }
        return $b6820483a00ce3be$var$EMPTY_FIELD_DATA;
    }, [
        fetchData
    ]);
    const fetchUsers = (0, $5uXOq.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first })=>{
        try {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const fieldValuesData = await fetchData({
                fieldName: 'assignee',
                query: query,
                first: first,
                afterCursor: afterCursor
            });
            return {
                totalCount: fieldValuesData.totalCount,
                options: (0, $b4fG8.transformUsers)(fieldValuesData)
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $ldL1T.fireFieldValuesErrorAnalytics)('searchFilterUsers', 'Failed to search users', err);
        }
        return $b6820483a00ce3be$var$EMPTY_FIELD_DATA;
    }, [
        fetchData
    ]);
    const fetchIssueTypes = (0, $5uXOq.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first })=>{
        try {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const fieldValuesData = await fetchData({
                fieldName: 'issuetype',
                query: query,
                first: first,
                afterCursor: afterCursor
            });
            let options = (0, $b4fG8.transformIssueTypes)(fieldValuesData);
            if (view === 'board') options = options.filter((option)=>option.hierarchyLevel !== -1);
            return {
                totalCount: fieldValuesData.totalCount,
                options: options
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $ldL1T.fireFieldValuesErrorAnalytics)('searchFilterIssueTypes', 'Failed to search issue types', err);
        }
        return $b6820483a00ce3be$var$EMPTY_FIELD_DATA;
    }, [
        fetchData,
        view
    ]);
    const fetchStatuses = (0, $5uXOq.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first })=>{
        try {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const fieldValuesData = await fetchData({
                fieldName: 'status',
                query: query,
                first: first,
                afterCursor: afterCursor
            });
            return {
                totalCount: fieldValuesData.totalCount,
                options: (0, $b4fG8.transformStatuses)(fieldValuesData)
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $ldL1T.fireFieldValuesErrorAnalytics)('searchFilterStatuses', 'Failed to search statuses', err);
        }
        return $b6820483a00ce3be$var$EMPTY_FIELD_DATA;
    }, [
        fetchData
    ]);
    const fetchCategories = (0, $5uXOq.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first = $b6820483a00ce3be$var$MAX_NUMBER_OF_OPTIONS })=>{
        try {
            const response = await (0, $eusud.performPostRequest)('/rest/gira/1/?operation=JWMCategoryFieldValuesSearch', {
                body: JSON.stringify({
                    query: (0, $c4148dc6c1f759d4$export$562e34ec948f373d),
                    variables: {
                        first: first,
                        jql: jqlContext,
                        searchQuery: query,
                        after: afterCursor
                    }
                })
            });
            if (response.errors != null) throw new (0, $jlq4V.GraphQLErrors)(response.errors);
            if (response.data?.jira?.jwmCategoryOptions?.edges == null) throw new Error('GraphQL response has no data');
            return {
                totalCount: response.data.jira.jwmCategoryOptions.totalCount,
                options: (0, $b4fG8.transformCategories)(response.data.jira.jwmCategoryOptions)
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $ldL1T.fireFieldValuesErrorAnalytics)('searchFilterCategories', 'Failed to search categories', err);
        }
        return $b6820483a00ce3be$var$EMPTY_FIELD_DATA;
    }, [
        jqlContext
    ]);
    const fetchSprints = (0, $5uXOq.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first })=>{
        try {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const fieldValuesData = await fetchData({
                fieldName: 'sprint',
                query: query,
                first: first,
                afterCursor: afterCursor,
                jqlContext: `${jqlContext} AND ${$b6820483a00ce3be$var$ACTIVE_SPRINTS_JQL}`
            });
            return {
                totalCount: fieldValuesData.totalCount,
                options: (0, $b4fG8.transformSprints)(fieldValuesData)
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $ldL1T.fireFieldValuesErrorAnalytics)('searchFilterSprints', 'Failed to search sprints', err);
        }
        return $b6820483a00ce3be$var$EMPTY_FIELD_DATA;
    }, [
        fetchData,
        jqlContext
    ]);
    const fetchFixVersions = (0, $5uXOq.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first })=>{
        try {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const fieldValuesData = await fetchData({
                fieldName: 'fixVersion',
                query: query,
                first: first,
                afterCursor: afterCursor
            });
            return {
                totalCount: fieldValuesData.totalCount,
                options: (0, $b4fG8.transformDefaultField)(fieldValuesData)
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $ldL1T.fireFieldValuesErrorAnalytics)('searchFilterFixVersion', 'Failed to search fix version', err);
        }
        return $b6820483a00ce3be$var$EMPTY_FIELD_DATA;
    }, [
        fetchData
    ]);
    const fetchParents = (0, $5uXOq.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first })=>{
        try {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const fieldValuesData = await fetchData({
                fieldName: 'parent',
                query: query,
                first: first,
                afterCursor: afterCursor
            });
            return {
                totalCount: fieldValuesData.totalCount,
                options: (0, $b4fG8.transformParent)(fieldValuesData)
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $ldL1T.fireFieldValuesErrorAnalytics)('searchFilterParent', 'Failed to search parents', err);
        }
        return $b6820483a00ce3be$var$EMPTY_FIELD_DATA;
    }, [
        fetchData
    ]);
    const fetchGoals = (0, $5uXOq.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first })=>{
        if (!goalsJqlTerm) return $b6820483a00ce3be$var$EMPTY_FIELD_DATA;
        try {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const fieldValuesData = await fetchData({
                fieldName: goalsJqlTerm,
                query: query,
                first: first,
                afterCursor: afterCursor
            });
            return {
                totalCount: fieldValuesData.totalCount,
                options: (0, $b4fG8.transformGoals)(fieldValuesData)
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $ldL1T.fireFieldValuesErrorAnalytics)('searchFilterGoals', 'Failed to search goals', err);
        }
        return $b6820483a00ce3be$var$EMPTY_FIELD_DATA;
    }, [
        fetchData,
        goalsJqlTerm
    ]);
    const fetchTeams = (0, $5uXOq.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first })=>{
        try {
            const fieldValuesData = await fetchTeamsService({
                query: query,
                first: first,
                after: afterCursor
            });
            return fieldValuesData[0, $5fc53.TEAMS_PLATFORM_CF_TYPE];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $ldL1T.fireFieldValuesErrorAnalytics)('searchFilterTeams', 'Failed to search teams', err);
        }
        return $b6820483a00ce3be$var$EMPTY_FIELD_DATA;
    }, [
        fetchTeamsService
    ]);
    return {
        fetchInitialData: fetchInitialData,
        fetchLabels: fetchLabels,
        fetchComponents: fetchComponents,
        fetchPriorities: fetchPriorities,
        fetchUsers: fetchUsers,
        fetchIssueTypes: fetchIssueTypes,
        fetchStatuses: fetchStatuses,
        fetchCategories: fetchCategories,
        fetchSprints: fetchSprints,
        fetchFixVersions: fetchFixVersions,
        fetchParents: fetchParents,
        fetchTeams: fetchTeams,
        fetchGoals: fetchGoals
    };
};

});
parcelRegister("b4fG8", function(module, exports) {

$parcel$export(module.exports, "transformPriorities", () => $7c1a01ddd808f237$export$86ca92dec35c4797);
$parcel$export(module.exports, "transformUsers", () => $7c1a01ddd808f237$export$fb8c90bfc4beaa59);
$parcel$export(module.exports, "transformIssueTypes", () => $7c1a01ddd808f237$export$4c05e2584b34e4d8);
$parcel$export(module.exports, "transformStatuses", () => $7c1a01ddd808f237$export$20a57a5ec025f2d);
$parcel$export(module.exports, "transformCategories", () => $7c1a01ddd808f237$export$1b389c47cf1df04e);
$parcel$export(module.exports, "transformDefaultField", () => $7c1a01ddd808f237$export$6133e08eeff30d5f);
$parcel$export(module.exports, "transformSprints", () => $7c1a01ddd808f237$export$6a33be7fc7f04943);
$parcel$export(module.exports, "transformGoals", () => $7c1a01ddd808f237$export$673d4fceed3e8383);
$parcel$export(module.exports, "transformParent", () => $7c1a01ddd808f237$export$87e9766fb5100314);
$parcel$export(module.exports, "transformTeams", () => $7c1a01ddd808f237$export$fd398a52d6f57b46);
$parcel$export(module.exports, "EMPTY_TRANSFORMED_DATA", () => $7c1a01ddd808f237$export$ca9df9cab9cc134f);
$parcel$export(module.exports, "transformValuesData", () => $7c1a01ddd808f237$export$8e327b5f9ebc175d);

var $3JOCw = parcelRequire("3JOCw");

var $5fc53 = parcelRequire("5fc53");

var $dCm1o = parcelRequire("dCm1o");
const $7c1a01ddd808f237$var$getFirstIssueTypeAvatar = (node)=>node.issueTypes?.find((issueType)=>issueType?.avatar?.medium != null)?.avatar?.medium;
const $7c1a01ddd808f237$var$getFirstIssueTypeId = (node)=>node.issueTypes[0]?.issueTypeId;
const $7c1a01ddd808f237$var$getFirstIssueTypeHierarchyLevel = (node)=>node.issueTypes[0]?.hierarchy?.level;
const $7c1a01ddd808f237$export$86ca92dec35c4797 = (data)=>data.edges.map(({ node: node, cursor: cursor })=>({
            cursor: cursor,
            value: node.jqlTerm,
            label: node.displayName,
            avatar: node.priority.iconUrl || ''
        }));
const $7c1a01ddd808f237$export$fb8c90bfc4beaa59 = (data)=>data.edges.filter(({ node: node })=>node?.user != null).map(({ node: node, cursor: cursor })=>({
            cursor: cursor,
            value: node.jqlTerm,
            label: node.displayName,
            avatar: node?.user?.picture || ''
        }));
const $7c1a01ddd808f237$export$4c05e2584b34e4d8 = (data)=>data.edges.map(({ node: node, cursor: cursor })=>({
            cursor: cursor,
            value: node.jqlTerm,
            label: node.displayName,
            id: $7c1a01ddd808f237$var$getFirstIssueTypeId(node),
            avatar: $7c1a01ddd808f237$var$getFirstIssueTypeAvatar(node) || '',
            square: true,
            hierarchyLevel: $7c1a01ddd808f237$var$getFirstIssueTypeHierarchyLevel(node) || 0
        }));
const $7c1a01ddd808f237$export$20a57a5ec025f2d = (data)=>data.edges.map(({ node: node, cursor: cursor })=>({
            cursor: cursor,
            value: node.jqlTerm,
            label: node.displayName,
            categoryId: node.statusCategory.statusCategoryId
        }));
const $7c1a01ddd808f237$export$1b389c47cf1df04e = (data)=>{
    const transformedCategories = data.edges.map((edge)=>({
            cursor: edge?.cursor,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            value: edge.node.option.value,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            label: edge.node.option.value,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            color: edge.node.color
        }));
    // Remove any categories that have the same name across multiple projects
    return (0, (/*@__PURE__*/$parcel$interopDefault($3JOCw)))(transformedCategories, ({ value: value })=>value);
};
const $7c1a01ddd808f237$export$6133e08eeff30d5f = (data)=>data.edges.map(({ node: node, cursor: cursor })=>({
            cursor: cursor,
            value: node.jqlTerm,
            label: node.displayName
        }));
const $7c1a01ddd808f237$export$6a33be7fc7f04943 = (data)=>data.edges.filter(({ node: node })=>node?.sprint != null).map(({ node: node, cursor: cursor })=>({
            cursor: cursor,
            value: node.displayName,
            label: node.sprint?.name || ''
        }));
const $7c1a01ddd808f237$export$673d4fceed3e8383 = (data)=>data.edges.map(({ node: node, cursor: cursor })=>({
            cursor: cursor,
            value: node.jqlTerm,
            label: node.goal.name || '',
            status: node.goal.status || ''
        }));
const $7c1a01ddd808f237$export$87e9766fb5100314 = (data)=>data?.edges.map(({ node: node, cursor: cursor })=>{
        let avatar = '';
        if (node.issue?.fieldsByIdOrAlias && node.issue.fieldsByIdOrAlias.length > 0) avatar = node.issue.fieldsByIdOrAlias[0].issueType?.avatar?.medium || '';
        return {
            cursor: cursor,
            value: node.jqlTerm,
            label: node.displayName,
            avatar: avatar,
            ...(0, $dCm1o.isVisualRefreshEnabled)() && {
                square: true
            }
        };
    });
const $7c1a01ddd808f237$export$fd398a52d6f57b46 = (data)=>data?.edges.filter(({ node: node })=>node?.team != null).map(({ node: node })=>({
            cursor: data.pageInfo?.endCursor,
            value: node.team.id.replace('ari:cloud:identity::team/', ''),
            label: node.team.displayName || '',
            avatar: node.team.smallAvatarImageUrl || ''
        }));
// Type predicted
const $7c1a01ddd808f237$var$isIssueType = (fieldValue)=>{
    const { node: node } = fieldValue.edges[0];
    return Boolean(node && 'issueTypes' in node);
};
const $7c1a01ddd808f237$var$isPriority = (fieldValue)=>{
    const { node: node } = fieldValue.edges[0];
    return Boolean(node && 'priority' in node);
};
const $7c1a01ddd808f237$var$isStatus = (fieldValue)=>{
    const { node: node } = fieldValue.edges[0];
    return Boolean(node && 'statusCategory' in node);
};
const $7c1a01ddd808f237$var$isSprint = (fieldValue)=>{
    const { node: node } = fieldValue.edges[0];
    return Boolean(node && 'sprint' in node);
};
const $7c1a01ddd808f237$var$isGoal = (fieldValue)=>{
    const { node: node } = fieldValue.edges[0];
    return Boolean(node && 'goal' in node);
};
const $7c1a01ddd808f237$var$isParent = (fieldValue)=>{
    const { node: node } = fieldValue.edges[0];
    return Boolean(node && 'issue' in node);
};
// any fieldValue could be a UserFieldValues because the edges could have some node with "user" undefined
// for example : { node: { displayName: "administrators", jqlTerm: "membersOf(administrators)" }}
const $7c1a01ddd808f237$var$isUser = (fieldValue)=>true;
const $7c1a01ddd808f237$var$isDefaultField = (fieldValue)=>Boolean(fieldValue.edges[0]);
const $7c1a01ddd808f237$export$ca9df9cab9cc134f = {
    labels: {
        totalCount: 0,
        options: []
    },
    components: {
        totalCount: 0,
        options: []
    },
    priority: {
        totalCount: 0,
        options: []
    },
    users: {
        totalCount: 0,
        options: []
    },
    issuetype: {
        totalCount: 0,
        options: []
    },
    status: {
        totalCount: 0,
        options: []
    },
    [(0, $5fc53.CATEGORY_TYPE)]: {
        totalCount: 0,
        options: []
    },
    [(0, $5fc53.SPRINT_TYPE)]: {
        totalCount: 0,
        options: []
    },
    [(0, $5fc53.FIX_VERSIONS_TYPE)]: {
        totalCount: 0,
        options: []
    },
    [(0, $5fc53.PARENT_FIELD_TYPE)]: {
        totalCount: 0,
        options: []
    },
    [(0, $5fc53.GOALS_CF_TYPE)]: {
        totalCount: 0,
        options: []
    },
    [(0, $5fc53.TEAMS_PLATFORM_CF_TYPE)]: {
        totalCount: 0,
        options: []
    }
};
const $7c1a01ddd808f237$export$8e327b5f9ebc175d = (data)=>{
    const transformedData = {
        ...$7c1a01ddd808f237$export$ca9df9cab9cc134f
    };
    Object.entries(data).forEach(([key, fieldValue])=>{
        if (fieldValue && fieldValue.edges && Array.isArray(fieldValue.edges) && fieldValue.edges.length) switch(key){
            case 'issuetype':
                if ($7c1a01ddd808f237$var$isIssueType(fieldValue)) transformedData.issuetype = {
                    totalCount: fieldValue.totalCount,
                    options: $7c1a01ddd808f237$export$4c05e2584b34e4d8(fieldValue)
                };
                break;
            case 'priority':
                if ($7c1a01ddd808f237$var$isPriority(fieldValue)) transformedData.priority = {
                    totalCount: fieldValue.totalCount,
                    options: $7c1a01ddd808f237$export$86ca92dec35c4797(fieldValue)
                };
                break;
            case 'status':
                if ($7c1a01ddd808f237$var$isStatus(fieldValue)) transformedData.status = {
                    totalCount: fieldValue.totalCount,
                    options: $7c1a01ddd808f237$export$20a57a5ec025f2d(fieldValue)
                };
                break;
            case 'component':
            case 'components':
            case 'fixVersions':
            case 'labels':
                if ($7c1a01ddd808f237$var$isDefaultField(fieldValue)) {
                    const transformedKey = key === 'component' ? (0, $5fc53.COMPONENTS_TYPE) : key;
                    transformedData[transformedKey] = {
                        totalCount: fieldValue.totalCount,
                        options: $7c1a01ddd808f237$export$6133e08eeff30d5f(fieldValue)
                    };
                }
                break;
            case 'parent':
                if ($7c1a01ddd808f237$var$isParent(fieldValue)) transformedData[key] = {
                    totalCount: fieldValue.totalCount,
                    options: $7c1a01ddd808f237$export$87e9766fb5100314(fieldValue)
                };
                break;
            default:
                if ($7c1a01ddd808f237$var$isSprint(fieldValue)) transformedData[0, $5fc53.SPRINT_TYPE] = {
                    totalCount: fieldValue.totalCount,
                    options: $7c1a01ddd808f237$export$6a33be7fc7f04943(fieldValue)
                };
                else if (fieldValue.edges.some((item)=>item.node && 'user' in item.node) && $7c1a01ddd808f237$var$isUser(fieldValue)) {
                    const usersData = $7c1a01ddd808f237$export$fb8c90bfc4beaa59(fieldValue);
                    const userOptions = (0, (/*@__PURE__*/$parcel$interopDefault($3JOCw)))([
                        ...usersData,
                        ...transformedData.users?.options ?? []
                    ], ({ value: value })=>value);
                    transformedData.users = {
                        totalCount: userOptions.length,
                        options: userOptions
                    };
                } else if ($7c1a01ddd808f237$var$isGoal(fieldValue)) transformedData[0, $5fc53.GOALS_CF_TYPE] = {
                    totalCount: fieldValue.totalCount,
                    options: $7c1a01ddd808f237$export$673d4fceed3e8383(fieldValue)
                };
        }
    });
    return transformedData;
};

});

parcelRegister("34JdM", function(module, exports) {

$parcel$export(module.exports, "useFetchTeams", () => $96faa576a82047b8$export$da1ab223b3f1410c);
$parcel$export(module.exports, "useFetchTeamsById", () => $96faa576a82047b8$export$c8925d7eebfccb3d);

var $5uXOq = parcelRequire("5uXOq");

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

var $5fc53 = parcelRequire("5fc53");

var $jlq4V = parcelRequire("jlq4V");

var $4R6GH = parcelRequire("4R6GH");

var $14XJw = parcelRequire("14XJw");

var $koeKL = parcelRequire("koeKL");

var $b4fG8 = parcelRequire("b4fG8");

// use ari functions from @atlassian/ari whenever it is ready for import
const $96faa576a82047b8$var$prependOrgIdAri = (orgId)=>`ari:cloud:platform::org/${orgId}`;
const $96faa576a82047b8$export$37430da53242c305 = {
    [(0, $5fc53.TEAMS_PLATFORM_CF_TYPE)]: {
        totalCount: 0,
        options: []
    }
};
const $96faa576a82047b8$var$MAX_NUMBER_OF_OPTIONS = 20;
const $96faa576a82047b8$var$EMPTY_ARRAY = [];
const $96faa576a82047b8$export$da1ab223b3f1410c = ()=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const { data: orgId } = (0, $14XJw.useOrgId)();
    const fetchTeams = (0, $5uXOq.useCallback)(async ({ query: query, first: first = $96faa576a82047b8$var$MAX_NUMBER_OF_OPTIONS, after: after })=>{
        if (orgId) try {
            const response = await (0, $eusud.performPostRequest)('/gateway/api/graphql', {
                body: JSON.stringify({
                    query: (0, $31f39d27d8739895$export$cbe5a6af25588495),
                    variables: {
                        orgId: $96faa576a82047b8$var$prependOrgIdAri(orgId),
                        cloudId: cloudId,
                        queryString: query,
                        first: first,
                        after: after
                    }
                })
            });
            // eslint-disable-next-line jira/ff/no-preconditioning
            if ((0, $4R6GH.fg)('fun-1733-handle-team-search-error') && response.errors != null) {
                if (response.errors[0]?.extensions?.statusCode === 403) return $96faa576a82047b8$export$37430da53242c305;
                throw new (0, $jlq4V.GraphQLErrors)(response.errors);
            }
            const teamData = response.data.team;
            if (!teamData) throw new Error('Empty team data');
            const options = (0, $b4fG8.transformTeams)(teamData.teamSearchV2) || [];
            // Teams query doesn't return the total count
            const totalCount = options.length >= first ? first : options.length;
            return {
                [(0, $5fc53.TEAMS_PLATFORM_CF_TYPE)]: {
                    totalCount: totalCount,
                    options: options
                }
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $jcw0u.default)({
                meta: {
                    id: 'fetchTeams',
                    packageName: 'jiraBusinessFilters',
                    teamName: 'wanjel'
                },
                attributes: {
                    message: 'Failed to fetch team filter data'
                },
                error: err,
                sendToPrivacyUnsafeSplunk: true
            });
        }
        return $96faa576a82047b8$export$37430da53242c305;
    }, [
        cloudId,
        orgId
    ]);
    return fetchTeams;
};
const $96faa576a82047b8$export$c8925d7eebfccb3d = ()=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const fetchTeamsById = (0, $5uXOq.useCallback)(async ({ teamIds: teamIds })=>Promise.all(teamIds.map((teamId)=>(0, $eusud.performPostRequest)('/gateway/api/graphql', {
                body: JSON.stringify({
                    query: (0, $31f39d27d8739895$export$32a6317a30e26003),
                    variables: {
                        cloudId: cloudId,
                        teamId: `ari:cloud:identity::team/${teamId}`
                    }
                })
            }))).then((result)=>{
            const options = result.map((response)=>{
                const teamOption = response.data.team.teamV2;
                return {
                    value: teamOption.id.replace('ari:cloud:identity::team/', ''),
                    label: teamOption.displayName || '',
                    avatar: teamOption.smallAvatarImageUrl || ''
                };
            }) || [];
            return options;
        })// eslint-disable-next-line @typescript-eslint/no-explicit-any
        .catch((err)=>{
            (0, $jcw0u.default)({
                meta: {
                    id: 'fetchTeamsById',
                    packageName: 'jiraBusinessFilters',
                    teamName: 'wanjel'
                },
                attributes: {
                    message: 'Failed to fetch team by ID filter data'
                },
                error: err,
                sendToPrivacyUnsafeSplunk: true
            });
            return $96faa576a82047b8$var$EMPTY_ARRAY;
        }), [
        cloudId
    ]);
    return fetchTeamsById;
};

});
const $31f39d27d8739895$export$cbe5a6af25588495 = `
    query JWMTeamFilterValues($cloudId: String!, $orgId: ID!, $queryString: String, $first: Int, $after: String) {
        team @optIn(to: "Team-search-v2") {
            teamSearchV2(
                organizationId: $orgId
                siteId: $cloudId
                first: $first
                after: $after
                filter: {query: $queryString}
            ) {
                pageInfo {
                    hasNextPage
                    endCursor
                }
                edges {
                    node {
                        team {
                            id
                            displayName
                            smallAvatarImageUrl
                        }
                    }
                }
            }
        }
    }
`;
const $31f39d27d8739895$export$32a6317a30e26003 = `
    query JWMTeamFilterById($teamId: ID!, $cloudId: String!) {
        team @optIn(to: "Team-search-v2") {
            teamV2(id: $teamId, siteId: $cloudId) {
                id
                displayName
                smallAvatarImageUrl
            }
        }
    }
`;


parcelRegister("czmU8", function(module, exports) {

$parcel$export(module.exports, "hydrateFilterValues", () => $3268558672fc0eb1$export$b18eef22aaa99c21);

var $8QpSo = parcelRequire("8QpSo");

var $c9Ur7 = parcelRequire("c9Ur7");

var $jlq4V = parcelRequire("jlq4V");

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

const $3268558672fc0eb1$export$3361e9be8093ddcc = (fields)=>{
    const hydratedValues = {};
    fields.forEach((hydratedField)=>{
        if (!hydratedField) return;
        const { field: field, values: values } = hydratedField;
        if (!field || !values) return;
        hydratedValues[field.jqlTerm] = {
            edges: values.map((item)=>(item && item.values && item.values[0]) ?? null).filter(Boolean).map((item)=>({
                    node: item
                })),
            totalCount: 0
        };
    });
    return hydratedValues;
};
const $3268558672fc0eb1$export$7a89edfb546e2344 = async (cloudId, jqlContext)=>{
    try {
        const response = await (0, $eusud.performPostRequest)('/rest/gira/1/?operation=JWMHydrateFilterValues', {
            body: JSON.stringify({
                query: (0, $d73ce8e52a931002$export$2bd792833522f1f1),
                variables: {
                    cloudId: cloudId,
                    jql: jqlContext
                }
            })
        });
        if (response.errors != null) throw new (0, $jlq4V.GraphQLErrors)(response.errors);
        if (response.data?.jira?.jqlBuilder?.hydrateJqlQuery?.fields == null) {
            if (response.data?.jira?.jqlBuilder?.hydrateJqlQuery?.__typename === 'QueryError') throw new (0, $c9Ur7.QueryError)(response.data.jira.jqlBuilder.hydrateJqlQuery);
            throw new Error('Failed to fetch on hydrateFilterValuesService');
        }
        return $3268558672fc0eb1$export$3361e9be8093ddcc(response.data.jira.jqlBuilder.hydrateJqlQuery.fields);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            meta: {
                id: 'JWMHydrateFilterValues',
                packageName: 'jiraBusinessFilters',
                teamName: 'wanjel'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};
const $3268558672fc0eb1$export$b18eef22aaa99c21 = (0, $8QpSo.default)($3268558672fc0eb1$export$7a89edfb546e2344);

});
parcelRegister("c9Ur7", function(module, exports) {

$parcel$export(module.exports, "QueryError", () => $835bdf2aa5daa049$export$83dcbdfe8cbc1e17);
const $835bdf2aa5daa049$export$f215947b3d76a6b7 = 'QueryError';
class $835bdf2aa5daa049$export$83dcbdfe8cbc1e17 extends Error {
    constructor(payload){
        super(payload.message ?? undefined);
        this.extensions = payload.extensions;
        this.message = payload.message ?? '';
        this.statusCode = payload.extensions?.[0]?.statusCode ?? -1;
    }
}

});

const $d73ce8e52a931002$var$FIELD_VALUE_NODE_FRAGMENT = `
fragment FieldValueNodeFragment on JiraJqlFieldValue {
    jqlTerm
    displayName
    ... on JiraJqlUserFieldValue {
        user {
            picture
        }
    }
    ... on JiraJqlPriorityFieldValue {
        priority {
            iconUrl
        }
    }
    ... on JiraJqlIssueTypeFieldValue {
        issueTypes {
            issueTypeId
            avatar {
                medium
            }
            hierarchy {
                level
            }
        }
    }
    ... on JiraJqlStatusFieldValue {
        statusCategory {
            statusCategoryId
        }
    }
    ... on JiraJqlSprintFieldValue {
        sprint {
            sprintId
            name
        }
    }
    ... on JiraJqlGoalsFieldValue {
        goal {
            name
            status
        }
    }
    ... on JiraJqlIssueFieldValue {
        issue {
            fieldsByIdOrAlias(idsOrAliases: ["issuetype"]) {
                ... on JiraIssueTypeField {
                    issueType {
                        avatar {
                            medium
                        }
                    }
                }
            }
        }
    }
}
`;
const $d73ce8e52a931002$export$2bd792833522f1f1 = `
query JwmHydrateFilterValues($cloudId: ID!, $jql: String!) {
	jira {
        jqlBuilder(cloudId: $cloudId) {
            hydrateJqlQuery(query: $jql, viewContext: JWM) {
                ... on JiraJqlHydratedQuery {
                    fields {
                        ... on JiraJqlQueryHydratedField {
                            field {
                                jqlTerm
                            }
                            values {
                                ... on JiraJqlQueryHydratedValue {
                                    values {
                                        jqlTerm
                                        displayName
                                        ...FieldValueNodeFragment
                                    }
                                }
                            }
                        }
                    }
                }
                ... on QueryError {
                    message
                    extensions {
                      statusCode
                    }
                }
                __typename
            }
        }
	}
}
${$d73ce8e52a931002$var$FIELD_VALUE_NODE_FRAGMENT}
`;


parcelRegister("84pWT", function(module, exports) {

$parcel$export(module.exports, "transformHydratedValues", () => $b845ee1bf81ff96f$export$56282b201a60959e);
$parcel$export(module.exports, "mergeHydratedValues", () => $b845ee1bf81ff96f$export$8f60413c08081990);

var $3JOCw = parcelRequire("3JOCw");

var $5fc53 = parcelRequire("5fc53");

var $b4fG8 = parcelRequire("b4fG8");
const $b845ee1bf81ff96f$export$56282b201a60959e = (data)=>{
    return (0, $b4fG8.transformValuesData)(data);
};
const $b845ee1bf81ff96f$export$8f60413c08081990 = (initialData, hydratedValues)=>({
        labels: {
            totalCount: initialData.labels.totalCount,
            options: (0, (/*@__PURE__*/$parcel$interopDefault($3JOCw)))([
                ...hydratedValues.labels.options,
                ...initialData.labels.options
            ], ({ value: value })=>value)
        },
        components: {
            totalCount: initialData.components.totalCount,
            options: (0, (/*@__PURE__*/$parcel$interopDefault($3JOCw)))([
                ...hydratedValues.components.options,
                ...initialData.components.options
            ], ({ value: value })=>value)
        },
        priority: {
            totalCount: initialData.priority.totalCount,
            options: (0, (/*@__PURE__*/$parcel$interopDefault($3JOCw)))([
                ...hydratedValues.priority.options,
                ...initialData.priority.options
            ], ({ value: value })=>value)
        },
        users: {
            totalCount: initialData.users.totalCount,
            options: (0, (/*@__PURE__*/$parcel$interopDefault($3JOCw)))([
                ...hydratedValues.users.options,
                ...initialData.users.options
            ], ({ value: value })=>value)
        },
        issuetype: {
            totalCount: initialData.issuetype.totalCount,
            options: (0, (/*@__PURE__*/$parcel$interopDefault($3JOCw)))([
                ...hydratedValues.issuetype.options,
                ...initialData.issuetype.options
            ], ({ value: value })=>value)
        },
        status: {
            totalCount: initialData.status.totalCount,
            options: (0, (/*@__PURE__*/$parcel$interopDefault($3JOCw)))([
                ...hydratedValues.status.options,
                ...initialData.status.options
            ], ({ value: value })=>value)
        },
        // hydrate values endpoint doesn't support categories
        [(0, $5fc53.CATEGORY_TYPE)]: initialData[0, $5fc53.CATEGORY_TYPE],
        [(0, $5fc53.SPRINT_TYPE)]: {
            totalCount: initialData[0, $5fc53.SPRINT_TYPE].totalCount,
            options: (0, (/*@__PURE__*/$parcel$interopDefault($3JOCw)))([
                ...hydratedValues[0, $5fc53.SPRINT_TYPE].options,
                ...initialData[0, $5fc53.SPRINT_TYPE].options
            ], ({ value: value })=>value)
        },
        [(0, $5fc53.FIX_VERSIONS_TYPE)]: {
            totalCount: initialData[0, $5fc53.FIX_VERSIONS_TYPE]?.totalCount || 0,
            options: (0, (/*@__PURE__*/$parcel$interopDefault($3JOCw)))([
                ...hydratedValues[0, $5fc53.FIX_VERSIONS_TYPE].options || [],
                ...initialData[0, $5fc53.FIX_VERSIONS_TYPE].options || []
            ], ({ value: value })=>value)
        },
        [(0, $5fc53.PARENT_FIELD_TYPE)]: {
            totalCount: initialData[0, $5fc53.PARENT_FIELD_TYPE]?.totalCount || 0,
            options: (0, (/*@__PURE__*/$parcel$interopDefault($3JOCw)))([
                ...hydratedValues[0, $5fc53.PARENT_FIELD_TYPE].options || [],
                ...initialData[0, $5fc53.PARENT_FIELD_TYPE].options || []
            ], ({ value: value })=>value)
        },
        [(0, $5fc53.GOALS_CF_TYPE)]: {
            totalCount: initialData[0, $5fc53.GOALS_CF_TYPE]?.totalCount || 0,
            options: (0, (/*@__PURE__*/$parcel$interopDefault($3JOCw)))([
                ...hydratedValues[0, $5fc53.GOALS_CF_TYPE].options,
                ...initialData[0, $5fc53.GOALS_CF_TYPE].options
            ], ({ value: value })=>value)
        },
        [(0, $5fc53.TEAMS_PLATFORM_CF_TYPE)]: {
            totalCount: initialData[0, $5fc53.TEAMS_PLATFORM_CF_TYPE]?.totalCount || 0,
            options: (0, (/*@__PURE__*/$parcel$interopDefault($3JOCw)))([
                ...hydratedValues[0, $5fc53.TEAMS_PLATFORM_CF_TYPE].options || [],
                ...initialData[0, $5fc53.TEAMS_PLATFORM_CF_TYPE].options || []
            ], ({ value: value })=>value)
        }
    });

});

const $c4148dc6c1f759d4$var$FIELD_VALUE_NODE_FRAGMENT = `
fragment FieldValueNodeFragment on JiraJqlFieldValue {
    jqlTerm
    displayName
    ... on JiraJqlUserFieldValue {
        user {
            picture
        }
    }
    ... on JiraJqlPriorityFieldValue {
        priority {
            iconUrl
        }
    }
    ... on JiraJqlIssueTypeFieldValue {
        issueTypes {
            issueTypeId
            avatar {
                medium
            }
            hierarchy {
                level
            }
        }
    }
    ... on JiraJqlStatusFieldValue {
        statusCategory {
            statusCategoryId
        }
    }
    ... on JiraJqlSprintFieldValue {
        sprint {
            sprintId
            name
        }
    }
    ... on JiraJqlGoalsFieldValue {
        goal {
            name
            status
        }
    }
    ... on JiraJqlIssueFieldValue {
        issue {
            fieldsByIdOrAlias(idsOrAliases: ["issuetype"]) {
                ... on JiraIssueTypeField {
                    issueType {
                        avatar {
                            medium
                        }
                    }
                }
            }
        }
    }
}
`;
const $c4148dc6c1f759d4$var$CATEGORY_CONNECTION_FRAGMENT = `
fragment CategoryConnection on JiraWorkManagementCategoryOptionConnection {
    edges {
        cursor
        node {
            option {
              value
            }
            color
        }
    }
    totalCount
}
`;
const $c4148dc6c1f759d4$export$a48313dd44fc9855 = `
query JwmInitialFilterValues($cloudId: ID!, $first: Int, $jql: String!, $shouldFetchSoftwareFields: Boolean = false, $sprintsJqlContext: String, $goalsJqlTerm: String!, $shouldFetchGoalsField: Boolean = false) {
    jira {
        jqlBuilder(cloudId: $cloudId) {
            labels: fieldValues(
                first: $first
                jqlTerm: "labels"
                jqlContext: $jql
                viewContext: JWM
            ) {
                edges {
                    cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }
            components: fieldValues(
                first: $first
                jqlTerm: "component"
                jqlContext: $jql
                viewContext: JWM
            ) {
                edges {
                    cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }
            priority: fieldValues(
                first: $first
                jqlTerm: "priority"
                jqlContext: $jql
                viewContext: JWM
            ) {
                edges {
                    cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }
            users: fieldValues(
                first: $first
                jqlTerm: "assignee"
                jqlContext: $jql
                viewContext: JWM
            ) {
                edges {
                    cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }
            recentlyUsedUsers(
                first: $first
            ) {
                edges {
                    cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }
            issuetype: fieldValues(
                first: $first
                jqlTerm: "issuetype"
                jqlContext: $jql
                viewContext: JWM
            ) {
                edges {
                     cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }
            status: fieldValues(
                first: $first
                jqlTerm: "status"
                jqlContext: $jql
                viewContext: JWM
            ) {
                edges {
                    cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }
            sprints: fieldValues(
                first: $first
                jqlTerm: "sprint"
                jqlContext: $sprintsJqlContext
                viewContext: JSW
            ) @include(if: $shouldFetchSoftwareFields) {
                edges {
                    cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }
            fixVersions: fieldValues(
                first: $first
                jqlTerm: "fixVersion"
                jqlContext: $jql
                viewContext: JWM
            ) @include(if: $shouldFetchSoftwareFields) {
                edges {
                    cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }
            parent: fieldValues(
                first: $first
                jqlTerm: "parent"
                jqlContext: $jql
                viewContext: JSW
            ) {
                edges {
                    cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }

            goals: fieldValues(
                first: $first
                jqlTerm: $goalsJqlTerm
                jqlContext: $jql
                viewContext: JWM
            ) @include(if: $shouldFetchGoalsField) {
                edges {
                    cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }
        }
        jwmCategoryOptions(jqlContext: $jql, first: $first) {
            ...CategoryConnection
        }
    }
}
${$c4148dc6c1f759d4$var$FIELD_VALUE_NODE_FRAGMENT}
${$c4148dc6c1f759d4$var$CATEGORY_CONNECTION_FRAGMENT}
`;
const $c4148dc6c1f759d4$export$f8e8a5f34f6ea725 = `
query JwmSearchFilterValues($cloudId: ID!, $first: Int, $jqlTerm: String!, $jql: String!, $searchString: String, $after: String) {
    jira {
        jqlBuilder(cloudId: $cloudId) {
            fieldValues(
                first: $first
                jqlTerm: $jqlTerm
                jqlContext: $jql
                searchString: $searchString
                after: $after
                viewContext: JWM
            ) {
                edges {
                    cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }
        }
    }
}
${$c4148dc6c1f759d4$var$FIELD_VALUE_NODE_FRAGMENT}
`;
const $c4148dc6c1f759d4$export$562e34ec948f373d = `
query JwmCategorySearchFilterValues($first: Int, $jql: String!, $searchQuery: String, $after: String) {
    jira {       
        jwmCategoryOptions(jqlContext: $jql, first: $first, searchQuery: $searchQuery, after: $after) {
            ...CategoryConnection
        }
    }
}
${$c4148dc6c1f759d4$var$CATEGORY_CONNECTION_FRAGMENT}
`;

parcelRegister("ldL1T", function(module, exports) {

$parcel$export(module.exports, "transformInitialData", () => $6a7ee4f9267edb3b$export$93219b8691fe49a0);
$parcel$export(module.exports, "fireFieldValuesErrorAnalytics", () => $6a7ee4f9267edb3b$export$c3c62a63250fc6f8);
$parcel$export(module.exports, "useGoalsJqlTerm", () => $6a7ee4f9267edb3b$export$674eff5ec8403101);

var $5uXOq = parcelRequire("5uXOq");

var $jcw0u = parcelRequire("jcw0u");

var $5fc53 = parcelRequire("5fc53");

var $b4fG8 = parcelRequire("b4fG8");
const $6a7ee4f9267edb3b$var$transformInitialCategories = (data)=>{
    if (data.jira.jwmCategoryOptions?.edges != null && Array.isArray(data.jira.jwmCategoryOptions.edges)) return {
        totalCount: data.jira.jwmCategoryOptions.totalCount,
        options: (0, $b4fG8.transformCategories)(data.jira.jwmCategoryOptions)
    };
    return undefined;
};
const $6a7ee4f9267edb3b$export$93219b8691fe49a0 = (data)=>{
    const transformedData = (0, $b4fG8.transformValuesData)(data.jira.jqlBuilder);
    const categories = $6a7ee4f9267edb3b$var$transformInitialCategories(data);
    if (categories) transformedData[0, $5fc53.CATEGORY_TYPE] = categories;
    return transformedData;
};
const $6a7ee4f9267edb3b$export$c3c62a63250fc6f8 = (errorId, errorMessage, // eslint-disable-next-line @typescript-eslint/no-explicit-any
error)=>{
    (0, $jcw0u.default)({
        meta: {
            id: errorId,
            packageName: 'jiraBusinessFilters',
            teamName: 'wanjel'
        },
        attributes: {
            message: errorMessage
        },
        error: error,
        sendToPrivacyUnsafeSplunk: true
    });
};
const $6a7ee4f9267edb3b$export$674eff5ec8403101 = (filterFields)=>{
    const goalsJqlTerm = (0, $5uXOq.useMemo)(()=>filterFields?.find((field)=>field?.type === (0, $5fc53.GOALS_CF_TYPE))?.id, [
        filterFields
    ]);
    return goalsJqlTerm;
};

});


parcelRegister("RjSi3", function(module, exports) {

$parcel$export(module.exports, "useFieldConfigV2", () => $95c9fbd80a67ba2b$export$c041141a7ef797c1);

var $5uXOq = parcelRequire("5uXOq");

var $54qG5 = parcelRequire("54qG5");

var $aJfd5 = parcelRequire("aJfd5");

var $koVbs = parcelRequire("koVbs");

var $5fc53 = parcelRequire("5fc53");

var $5FlVd = parcelRequire("5FlVd");

var $8DJTW = parcelRequire("8DJTW");

var $gxGcZ = parcelRequire("gxGcZ");

var $34JdM = parcelRequire("34JdM");

var $1qi71 = parcelRequire("1qi71");
const $95c9fbd80a67ba2b$var$EMPTY_FIELD_DATA = {
    totalCount: 0,
    options: []
};
const $95c9fbd80a67ba2b$var$EMPTY_FILTER_DATA = {
    initialUsers: $95c9fbd80a67ba2b$var$EMPTY_FIELD_DATA,
    initialLabels: $95c9fbd80a67ba2b$var$EMPTY_FIELD_DATA,
    initialComponents: $95c9fbd80a67ba2b$var$EMPTY_FIELD_DATA,
    initialPriorities: $95c9fbd80a67ba2b$var$EMPTY_FIELD_DATA,
    initialIssueTypes: $95c9fbd80a67ba2b$var$EMPTY_FIELD_DATA,
    initialStatuses: $95c9fbd80a67ba2b$var$EMPTY_FIELD_DATA,
    initialCategories: $95c9fbd80a67ba2b$var$EMPTY_FIELD_DATA,
    initialSprints: $95c9fbd80a67ba2b$var$EMPTY_FIELD_DATA,
    initialFixVersions: $95c9fbd80a67ba2b$var$EMPTY_FIELD_DATA,
    initialParents: $95c9fbd80a67ba2b$var$EMPTY_FIELD_DATA,
    initialGoals: $95c9fbd80a67ba2b$var$EMPTY_FIELD_DATA,
    initialTeams: $95c9fbd80a67ba2b$var$EMPTY_FIELD_DATA
};
const $95c9fbd80a67ba2b$var$initialState = {
    data: undefined,
    loadingData: true
};
const $95c9fbd80a67ba2b$var$reducer = (state, action)=>{
    switch(action.type){
        case 'init':
            return $95c9fbd80a67ba2b$var$initialState;
        case 'fetch-data-success':
            return {
                ...state,
                data: action.value,
                loadingData: false
            };
        case 'fetch-data-error':
            return {
                ...state,
                data: $95c9fbd80a67ba2b$var$EMPTY_FILTER_DATA,
                loadingData: false
            };
        default:
            return state;
    }
};
/**
 * useFieldConfig hook that is used to populate the field and field values for JWM Filters.
 * It can be used for JWM Overviews which includes multiple Jira Projects.
 */ const $95c9fbd80a67ba2b$var$emptyFieldValue = {
    totalCount: 0,
    options: []
};
const $95c9fbd80a67ba2b$export$c041141a7ef797c1 = ({ view: view, allowedFieldTypes: allowedFieldTypes })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const projectFieldData = (0, $gxGcZ.useProjectFilter)();
    const { data: filterFields, loading: loadingFilterFields } = (0, $8DJTW.useFilterFields)();
    const [{ data: data, loadingData: loadingData }, dispatch] = (0, $5uXOq.useReducer)($95c9fbd80a67ba2b$var$reducer, $95c9fbd80a67ba2b$var$initialState);
    const userResolver = (0, $5uXOq.useRef)(new (0, $aJfd5.UserResolver)());
    const fetchTeamsById = (0, $34JdM.useFetchTeamsById)();
    const { fetchLabels: fetchLabels, fetchComponents: fetchComponents, fetchUsers: fetchUsers, fetchCategories: fetchCategories, fetchInitialData: fetchInitialData, ...fetchOptions } = (0, $5FlVd.useFetchFieldValues)({
        view: view,
        allowedFieldTypes: allowedFieldTypes,
        filterFields: filterFields
    });
    const { data: entity } = (0, $54qG5.useBusinessEntity)();
    const businessEntityId = entity.id;
    const initialiseDefaultData = (0, $5uXOq.useCallback)(()=>{
        fetchInitialData().then((initialData)=>{
            dispatch({
                type: 'fetch-data-success',
                value: {
                    initialUsers: initialData?.users ?? $95c9fbd80a67ba2b$var$emptyFieldValue,
                    initialLabels: initialData?.labels ?? $95c9fbd80a67ba2b$var$emptyFieldValue,
                    initialComponents: initialData?.components ?? $95c9fbd80a67ba2b$var$emptyFieldValue,
                    initialPriorities: initialData?.priority ?? $95c9fbd80a67ba2b$var$emptyFieldValue,
                    initialIssueTypes: initialData?.issuetype ?? $95c9fbd80a67ba2b$var$emptyFieldValue,
                    initialStatuses: initialData?.status ?? $95c9fbd80a67ba2b$var$emptyFieldValue,
                    initialCategories: initialData?.[0, $5fc53.CATEGORY_TYPE] ?? $95c9fbd80a67ba2b$var$emptyFieldValue,
                    initialSprints: initialData?.[0, $5fc53.SPRINT_TYPE] ?? $95c9fbd80a67ba2b$var$emptyFieldValue,
                    initialFixVersions: initialData?.[0, $5fc53.FIX_VERSIONS_TYPE] ?? $95c9fbd80a67ba2b$var$emptyFieldValue,
                    initialParents: initialData?.[0, $5fc53.PARENT_FIELD_TYPE] ?? $95c9fbd80a67ba2b$var$emptyFieldValue,
                    initialTeams: initialData?.[0, $5fc53.TEAMS_PLATFORM_CF_TYPE] ?? $95c9fbd80a67ba2b$var$emptyFieldValue,
                    initialGoals: initialData?.[0, $5fc53.GOALS_CF_TYPE] ?? $95c9fbd80a67ba2b$var$emptyFieldValue
                }
            });
        }).catch(()=>{
            dispatch({
                type: 'fetch-data-error'
            });
        });
    }, [
        fetchInitialData
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!loadingFilterFields) {
            dispatch({
                type: 'init'
            });
            initialiseDefaultData();
        }
    }, [
        initialiseDefaultData,
        loadingFilterFields,
        businessEntityId
    ]);
    // TODO: JFP-2824 | Suppressed to enable upgrade to ESLint v9 - please fix this if you can!
    const { fieldConfig: fieldConfig, resolvers: resolvers } = (0, $5uXOq.useMemo)(()=>{
        const fieldOptionsData = {
            priority: data?.initialPriorities ?? $95c9fbd80a67ba2b$var$emptyFieldValue,
            issuetype: data?.initialIssueTypes ?? $95c9fbd80a67ba2b$var$emptyFieldValue,
            status: data?.initialStatuses ?? $95c9fbd80a67ba2b$var$emptyFieldValue,
            users: data?.initialUsers ?? $95c9fbd80a67ba2b$var$emptyFieldValue,
            labels: data?.initialLabels ?? $95c9fbd80a67ba2b$var$emptyFieldValue,
            components: data?.initialComponents ?? $95c9fbd80a67ba2b$var$emptyFieldValue,
            [(0, $5fc53.CATEGORY_TYPE)]: data?.initialCategories ?? $95c9fbd80a67ba2b$var$emptyFieldValue,
            [(0, $5fc53.SPRINT_TYPE)]: data?.initialSprints ?? $95c9fbd80a67ba2b$var$emptyFieldValue,
            project: projectFieldData,
            [(0, $5fc53.FIX_VERSIONS_TYPE)]: data?.initialFixVersions ?? $95c9fbd80a67ba2b$var$emptyFieldValue,
            [(0, $5fc53.PARENT_FIELD_TYPE)]: data?.initialParents ?? $95c9fbd80a67ba2b$var$emptyFieldValue,
            [(0, $5fc53.TEAMS_PLATFORM_CF_TYPE)]: data?.initialTeams ?? $95c9fbd80a67ba2b$var$emptyFieldValue,
            [(0, $5fc53.GOALS_CF_TYPE)]: data?.initialGoals ?? $95c9fbd80a67ba2b$var$emptyFieldValue
        };
        return (0, $1qi71.getFilterFieldConfigAndResolvers)({
            view: view,
            formatMessage: formatMessage,
            allFields: filterFields,
            allowedFieldTypes: allowedFieldTypes,
            fieldOptionsData: fieldOptionsData,
            fetchUsers: fetchUsers,
            fetchLabels: fetchLabels,
            fetchComponents: fetchComponents,
            fetchCategories: fetchCategories,
            fetchTeamsById: fetchTeamsById,
            ...fetchOptions,
            userResolver: userResolver.current
        });
    }, [
        data?.initialPriorities,
        data?.initialIssueTypes,
        data?.initialStatuses,
        data?.initialUsers,
        data?.initialLabels,
        data?.initialComponents,
        data?.initialCategories,
        data?.initialSprints,
        data?.initialFixVersions,
        data?.initialParents,
        data?.initialGoals,
        data?.initialTeams,
        projectFieldData,
        view,
        formatMessage,
        filterFields,
        allowedFieldTypes,
        fetchUsers,
        fetchLabels,
        fetchComponents,
        fetchCategories,
        fetchOptions,
        fetchTeamsById
    ]);
    return {
        fieldConfig: fieldConfig,
        resolvers: resolvers,
        loading: loadingData || loadingFilterFields || data == null
    };
};

});
parcelRegister("aJfd5", function(module, exports) {

$parcel$export(module.exports, "UserResolver", () => $c1905445333aa67f$export$723df28d03868f02);

var $2YZCu = parcelRequire("2YZCu");

var $7f4tk = parcelRequire("7f4tk");
class $c1905445333aa67f$export$723df28d03868f02 {
    constructor(){
        // eslint-disable-next-line @typescript-eslint/no-invalid-void-type
        this.getUsersFromAccountId = (accountIds)=>{
            const recoveredFromCache = [];
            const missingFromCache = [];
            accountIds.forEach((accountId)=>{
                const user = this.cache.get(accountId);
                if (user) recoveredFromCache.push(user);
                else missingFromCache.push(accountId);
            });
            if (missingFromCache.length === 0) // @ts-expect-error - User is not assignable to type 'string'
            return Promise.resolve(recoveredFromCache);
            return (0, $7f4tk.default)(`/rest/api/2/user/bulk?maxResults=10&${missingFromCache.map((accountId)=>`accountId=${accountId}`).join('&')}`).then((response)=>response && response.values.length > 0 && // @ts-expect-error - TS2339 - Property 'forEach' does not exist on type '() => IterableIterator<Readonly<Partial<Diff<ResponseSuccess, Record<any, any>>> & { accountId: string | null; displayName: string; avatarUrls: { readonly "48x48"?: string | undefined; readonly "32x32"?: string | undefined; readonly "24x24"?: string | undefined; readonly "16x16"?: string | undefined; }; }>>'. | TS7006 - Parameter 'user' implicitly has an 'any' type.
                response.values.forEach((user)=>{
                    if (user) this.cache.set(user.accountId, user);
                })).then(()=>this.getUsersFromAccountId(accountIds)).catch((err)=>{
                (0, $2YZCu.default).safeErrorWithoutCustomerData('jwm.services.get-users', 'Failed to fetch users', err);
            });
        };
        this.cache = new Map();
    }
}

});

parcelRegister("8DJTW", function(module, exports) {

$parcel$export(module.exports, "useFilterFields", () => $058acf7f8802e33f$export$b2d30fa5478b571a);

var $5uXOq = parcelRequire("5uXOq");

var $g4ZHz = parcelRequire("g4ZHz");
const $058acf7f8802e33f$export$b2d30fa5478b571a = ()=>{
    const { data: fields, loading: loading } = (0, $g4ZHz.useFieldsResource)();
    const data = (0, $5uXOq.useMemo)(()=>fields?.map((field)=>({
                id: field.jqlTerm,
                name: field.displayName,
                type: field.type
            })) ?? [], [
        fields
    ]);
    return {
        data: data,
        loading: loading,
        error: undefined
    };
};

});

parcelRegister("1qi71", function(module, exports) {

$parcel$export(module.exports, "getFilterFieldConfigAndResolvers", () => $beea8d83023eb0fe$export$ba4f3d2149c2bf3b);

var $9XE6b = parcelRequire("9XE6b");

var $8QpSo = parcelRequire("8QpSo");

var $4R6GH = parcelRequire("4R6GH");

var $5fc53 = parcelRequire("5fc53");

var $dCm1o = parcelRequire("dCm1o");

var $gzkAf = parcelRequire("gzkAf");

var $gBF4Z = parcelRequire("gBF4Z");

var $7htvz = parcelRequire("7htvz");

var $j0h5m = parcelRequire("j0h5m");
const $beea8d83023eb0fe$export$fb8c90bfc4beaa59 = (0, $8QpSo.default)((users)=>{
    if ((users == null || !Array.isArray(users)) && (0, $4R6GH.fg)('prevent_user_transformation_on_non-array_input')) return [];
    // Remove this lint and ts ignore when 'prevent_user_transformation_on_non-array_input' gets clean up
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return users.reduce((acc, next)=>{
        acc.push({
            value: next.accountId || '',
            label: next.displayName,
            avatar: (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(next, [
                'avatarUrls',
                '24x24'
            ], '')
        });
        return acc;
    }, []);
});
const $beea8d83023eb0fe$var$getType = (type)=>{
    switch(type){
        case 0, $5fc53.CATEGORY_TYPE:
            return (0, $gBF4Z.FieldType).CategorySelectFilter;
        case 0, $5fc53.PRIORITY_TYPE:
            return (0, $gBF4Z.FieldType).PrioritySelectFilter;
        case 0, $5fc53.ASSIGNEE_TYPE:
        case 0, $5fc53.REPORTER_TYPE:
        case 0, $5fc53.USER_CF_TYPE:
            return (0, $gBF4Z.FieldType).AvatarAsyncSelectFilter;
        case 0, $5fc53.ISSUE_TYPE:
        case 0, $5fc53.PARENT_FIELD_TYPE:
        case 0, $5fc53.TEAMS_PLATFORM_CF_TYPE:
            return (0, $gBF4Z.FieldType).AvatarSelectFilter;
        case 0, $5fc53.STATUS_TYPE:
            return (0, $gBF4Z.FieldType).LozengeSelectFilter;
        case 0, $5fc53.LABELS_TYPE:
        case 0, $5fc53.COMPONENTS_TYPE:
        case 0, $5fc53.FIX_VERSIONS_TYPE:
        case 0, $5fc53.SPRINT_TYPE:
            return (0, $gBF4Z.FieldType).AsyncSelectFilter;
        case 0, $5fc53.CREATED:
        case 0, $5fc53.UPDATED:
            return (0, $gBF4Z.FieldType).DateFilter;
        case 0, $5fc53.PROJECT_TYPE:
            return (0, $gBF4Z.FieldType).ProjectFilter;
        case 0, $5fc53.GOALS_CF_TYPE:
            return (0, $gBF4Z.FieldType).GoalsSelectFilter;
        default:
            return (0, $gBF4Z.FieldType).SelectFilter;
    }
};
const $beea8d83023eb0fe$var$getValues = (type, fieldOptionsData)=>{
    switch(type){
        case 0, $5fc53.ASSIGNEE_TYPE:
        case 0, $5fc53.REPORTER_TYPE:
        case 0, $5fc53.USER_CF_TYPE:
            return fieldOptionsData.users;
        default:
            return fieldOptionsData[type];
    }
};
const $beea8d83023eb0fe$var$isUserField = (type)=>{
    switch(type){
        case 0, $5fc53.ASSIGNEE_TYPE:
        case 0, $5fc53.REPORTER_TYPE:
        case 0, $5fc53.USER_CF_TYPE:
            return true;
        default:
            return false;
    }
};
const $beea8d83023eb0fe$var$isCustomField = (type)=>{
    switch(type){
        case 0, $5fc53.USER_CF_TYPE:
        case 0, $5fc53.PEOPLE_CF_TYPE:
        case 0, $5fc53.SELECT_CF_TYPE:
        case 0, $5fc53.MULTI_SELECT_CF_TYPE:
        case 0, $5fc53.MULTI_CHECKBOXES_CF_TYPE:
            return true;
        default:
            return false;
    }
};
const $beea8d83023eb0fe$var$createUserValueGetter = (userResolver)=>(0, $8QpSo.default)((accountIds)=>userResolver.getUsersFromAccountId(accountIds) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .then((response)=>$beea8d83023eb0fe$export$fb8c90bfc4beaa59(response)));
const $beea8d83023eb0fe$var$createTeamValueGetter = ({ fetchTeamsById: fetchTeamsById, options: options })=>(0, $8QpSo.default)((teamIds)=>{
        // if the team is already loaded not fetch the team data
        const teamsLoadedOptions = options.filter((option)=>option.value ? teamIds.includes(option.value) : false);
        if (teamsLoadedOptions.length === teamIds.length) return teamsLoadedOptions;
        const loadedTeamIds = teamsLoadedOptions.map((option)=>option.value);
        const teamIdsToFetch = teamsLoadedOptions.length ? teamIds.filter((teamId)=>!loadedTeamIds.includes(teamId)) : teamIds;
        return fetchTeamsById({
            teamIds: teamIdsToFetch
        });
    });
const $beea8d83023eb0fe$export$ba4f3d2149c2bf3b = ({ view: view, formatMessage: formatMessage, allowedFieldTypes: allowedFieldTypes, allFields: allFields, fieldOptionsData: fieldOptionsData, userResolver: userResolver, fetchUsers: fetchUsers, fetchLabels: fetchLabels, fetchComponents: fetchComponents, fetchCategories: fetchCategories, fetchStatuses: fetchStatuses, fetchPriorities: fetchPriorities, fetchIssueTypes: fetchIssueTypes, fetchSprints: fetchSprints, fetchFixVersions: fetchFixVersions, fetchParents: fetchParents, fetchGoals: fetchGoals, fetchTeams: fetchTeams, fetchTeamsById: fetchTeamsById })=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const fieldConfig = {};
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const resolvers = {};
    if (allowedFieldTypes.has((0, $gzkAf.DATE_RANGE_TYPE))) // manually add dateRange to fieldConfig
    fieldConfig.dateRange = {
        label: formatMessage((0, $j0h5m.default).dateRangeLabel),
        type: (0, $gBF4Z.FieldType).DateFilter,
        fromLabel: formatMessage((0, $j0h5m.default).startDateLabel),
        toLabel: formatMessage((0, $j0h5m.default).dueDateLabel)
    };
    const fields = allFields.filter((field)=>allowedFieldTypes.has(field.type ?? ''));
    fields.forEach((field)=>{
        const { name: name, type: type, id: id } = field;
        const fieldType = type ?? '';
        const fieldValues = $beea8d83023eb0fe$var$getValues(fieldType, fieldOptionsData);
        fieldConfig[id] = {
            label: name,
            type: $beea8d83023eb0fe$var$getType(fieldType),
            placeholder: formatMessage((0, $j0h5m.default).filterPlaceholder),
            options: fieldValues?.options || [],
            totalCount: fieldValues?.totalCount || 0,
            isCustomField: $beea8d83023eb0fe$var$isCustomField(fieldType),
            fieldConfigVersion: 2
        };
        // issue type
        if (type === (0, $5fc53.ISSUE_TYPE)) {
            let options = fieldValues?.options || [];
            if (view === 'board') {
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                options = (fieldValues?.options).filter((option)=>option.hierarchyLevel !== -1);
                fieldConfig[id].options = options;
            }
            if (fetchIssueTypes) {
                fieldConfig[id].loadOptions = fetchIssueTypes;
                fieldConfig[id].defaultOptions = options;
            }
        } else if ($beea8d83023eb0fe$var$isUserField(fieldType)) {
            fieldConfig[id].loadOptions = fetchUsers;
            fieldConfig[id].defaultOptions = fieldValues?.options || [];
            resolvers[id] = $beea8d83023eb0fe$var$createUserValueGetter(userResolver);
            fieldConfig[id].options = [
                ...fieldConfig[id].options,
                {
                    value: (0, $7htvz.EMPTY_FILTER_VALUE),
                    label: formatMessage((0, $j0h5m.default).unassignedLabel),
                    isEmptyOption: true
                }
            ];
            fieldConfig[id].totalCount += 1;
        } else if (fieldType === (0, $5fc53.LABELS_TYPE)) {
            fieldConfig[id].loadOptions = fetchLabels;
            fieldConfig[id].defaultOptions = fieldValues?.options || [];
            fieldConfig[id].options = [
                ...fieldConfig[id].options,
                {
                    value: (0, $7htvz.EMPTY_FILTER_VALUE),
                    label: formatMessage((0, $j0h5m.default).noLabelsLabel),
                    isEmptyOption: true
                }
            ];
            fieldConfig[id].totalCount += 1;
        } else if (fieldType === (0, $5fc53.COMPONENTS_TYPE)) {
            fieldConfig[id].loadOptions = fetchComponents;
            fieldConfig[id].defaultOptions = fieldValues?.options || [];
            fieldConfig[id].options = [
                ...fieldConfig[id].options,
                {
                    value: (0, $7htvz.EMPTY_FILTER_VALUE),
                    label: formatMessage((0, $j0h5m.default).noComponentsLabel),
                    isEmptyOption: true
                }
            ];
            fieldConfig[id].totalCount += 1;
        } else if (fieldType === (0, $5fc53.CATEGORY_TYPE)) {
            fieldConfig[id].loadOptions = fetchCategories;
            fieldConfig[id].defaultOptions = fieldValues?.options || [];
            fieldConfig[id].options = [
                ...fieldConfig[id].options,
                {
                    value: (0, $7htvz.EMPTY_FILTER_VALUE),
                    label: formatMessage((0, $j0h5m.default).noCategoriesLabel),
                    isEmptyOption: true
                }
            ];
            fieldConfig[id].totalCount += 1;
        } else if (fieldType === (0, $5fc53.STATUS_TYPE) && fetchStatuses) {
            fieldConfig[id].loadOptions = fetchStatuses;
            fieldConfig[id].defaultOptions = fieldValues?.options || [];
        } else if (fieldType === (0, $5fc53.PRIORITY_TYPE) && fetchPriorities) {
            fieldConfig[id].loadOptions = fetchPriorities;
            fieldConfig[id].defaultOptions = fieldValues?.options || [];
        } else if (fieldType === (0, $5fc53.SPRINT_TYPE) && fetchSprints) {
            fieldConfig[id].loadOptions = fetchSprints;
            fieldConfig[id].defaultOptions = fieldValues?.options || [];
            fieldConfig[id].options = [
                ...fieldConfig[id].options,
                {
                    value: (0, $7htvz.EMPTY_FILTER_VALUE),
                    label: formatMessage((0, $j0h5m.default).noSprintLabel),
                    isEmptyOption: true
                }
            ];
            fieldConfig[id].totalCount += 1;
        } else if (fieldType === (0, $5fc53.FIX_VERSIONS_TYPE) && fetchFixVersions) {
            fieldConfig[id].loadOptions = fetchFixVersions;
            fieldConfig[id].defaultOptions = fieldValues?.options || [];
            fieldConfig[id].options = [
                ...fieldConfig[id].options,
                {
                    value: (0, $7htvz.EMPTY_FILTER_VALUE),
                    label: formatMessage((0, $j0h5m.default).noVersionLabel),
                    isEmptyOption: true
                }
            ];
            fieldConfig[id].totalCount += 1;
        } else if (fieldType === (0, $5fc53.PARENT_FIELD_TYPE) && fetchParents) {
            fieldConfig[id].loadOptions = fetchParents;
            fieldConfig[id].defaultOptions = fieldValues?.options || [];
            fieldConfig[id].options = [
                ...fieldConfig[id].options,
                {
                    value: (0, $7htvz.EMPTY_FILTER_VALUE),
                    label: formatMessage((0, $j0h5m.default).noParentLabel),
                    isEmptyOption: true,
                    ...(0, $dCm1o.isVisualRefreshEnabled)() && {
                        square: true
                    }
                }
            ];
            fieldConfig[id].totalCount += 1;
        } else if (fieldType === (0, $5fc53.GOALS_CF_TYPE) && fetchGoals) {
            fieldConfig[id].loadOptions = fetchGoals;
            fieldConfig[id].options = [
                ...fieldConfig[id].options,
                {
                    value: (0, $7htvz.EMPTY_FILTER_VALUE),
                    label: formatMessage((0, $j0h5m.default).noGoalLabel),
                    isEmptyOption: true
                }
            ];
            fieldConfig[id].totalCount += 1;
        } else if (fetchTeams && fieldType === (0, $5fc53.TEAMS_PLATFORM_CF_TYPE)) {
            fieldConfig[id].loadOptions = fetchTeams;
            fieldConfig[id].defaultOptions = fieldValues?.options || [];
            fieldConfig[id].options = [
                ...fieldConfig[id].options,
                {
                    value: (0, $7htvz.EMPTY_FILTER_VALUE),
                    label: formatMessage((0, $j0h5m.default).noTeamLabel),
                    isEmptyOption: true
                }
            ];
            if (fetchTeamsById) resolvers[id] = $beea8d83023eb0fe$var$createTeamValueGetter({
                fetchTeamsById: fetchTeamsById,
                options: fieldConfig[id].options
            });
            fieldConfig[id].totalCount += 1;
        }
    });
    return {
        fieldConfig: fieldConfig,
        resolvers: resolvers
    };
};

});
parcelRegister("gBF4Z", function(module, exports) {

$parcel$export(module.exports, "FieldType", () => $8ecd5c1ebfc76de6$export$ed12481c953b8653);
$parcel$export(module.exports, "isDateField", () => $8ecd5c1ebfc76de6$export$7d34c8548269835d);
const $8ecd5c1ebfc76de6$export$ed12481c953b8653 = {
    AsyncSelectFilter: 'AsyncSelectFilter',
    AvatarSelectFilter: 'AvatarSelectFilter',
    AvatarAsyncSelectFilter: 'AvatarAsyncSelectFilter',
    PaginatedAsyncSelectFilter: 'PaginatedAsyncSelectFilter',
    LozengeAsyncSelectFilter: 'LozengeAsyncSelectFilter',
    PaginatedLozengeAsyncSelectFilter: 'PaginatedLozengeAsyncSelectFilter',
    LozengeSelectFilter: 'LozengeSelectFilter',
    PrioritySelectFilter: 'PrioritySelectFilter',
    CategorySelectFilter: 'CategorySelectFilter',
    GoalsSelectFilter: 'GoalsSelectFilter',
    PaginatedAvatarAsyncSelectFilter: 'PaginatedAvatarAsyncSelectFilter',
    NumberFilter: 'NumberFilter',
    SelectFilter: 'SelectFilter',
    SearchFilter: 'SearchFilter',
    TextFilter: 'TextFilter',
    DateFilter: 'DateFilter',
    ProjectFilter: 'ProjectFilter'
};
const $8ecd5c1ebfc76de6$export$7d34c8548269835d = (field)=>field.type === $8ecd5c1ebfc76de6$export$ed12481c953b8653.DateFilter;

});

parcelRegister("7htvz", function(module, exports) {

$parcel$export(module.exports, "OPTIMISTIC_ID", () => $d5b40c70d7e37442$export$6e40821019289c70);
$parcel$export(module.exports, "CREATE_FILTER_EXPERIENCE", () => $d5b40c70d7e37442$export$d6ceedee35ae2c19);
$parcel$export(module.exports, "UPDATE_FILTER_EXPERIENCE", () => $d5b40c70d7e37442$export$ca3691ea47eec823);
$parcel$export(module.exports, "DELETE_FILTER_EXPERIENCE", () => $d5b40c70d7e37442$export$2a5fce320f18ac6c);
$parcel$export(module.exports, "STAR_FILTER_EXPERIENCE", () => $d5b40c70d7e37442$export$b0ec8deb6068dc3b);
$parcel$export(module.exports, "SAVED_FILTER_EXPERIENCE", () => $d5b40c70d7e37442$export$6c99c87a0ac0052a);
$parcel$export(module.exports, "EMPTY_FILTER_VALUE", () => $d5b40c70d7e37442$export$9ebaf9fe814731d3);
$parcel$export(module.exports, "SIMPLE_SEARCH_PARAM", () => $d5b40c70d7e37442$export$9b72011e2eb8d7d0);
const $d5b40c70d7e37442$export$b8b9d90f9e5bd72b = 'jiraBusinessFilters';
const $d5b40c70d7e37442$export$6e40821019289c70 = 'optimistic-filter-id';
const $d5b40c70d7e37442$export$d6ceedee35ae2c19 = {
    experience: 'filtersCreateSavedFilters',
    packageName: $d5b40c70d7e37442$export$b8b9d90f9e5bd72b,
    teamName: 'wanjel'
};
const $d5b40c70d7e37442$export$ca3691ea47eec823 = {
    experience: 'filtersUpdateSavedFilters',
    packageName: $d5b40c70d7e37442$export$b8b9d90f9e5bd72b,
    teamName: 'wanjel'
};
const $d5b40c70d7e37442$export$2a5fce320f18ac6c = {
    experience: 'filtersDeleteSavedFilters',
    packageName: $d5b40c70d7e37442$export$b8b9d90f9e5bd72b,
    teamName: 'wanjel'
};
const $d5b40c70d7e37442$export$b0ec8deb6068dc3b = {
    experience: 'filtersStarSavedFilters',
    packageName: $d5b40c70d7e37442$export$b8b9d90f9e5bd72b,
    teamName: 'wanjel'
};
const $d5b40c70d7e37442$export$6c99c87a0ac0052a = {
    experience: 'filtersLoadSavedFilters',
    packageName: $d5b40c70d7e37442$export$b8b9d90f9e5bd72b,
    teamName: 'wanjel'
};
const $d5b40c70d7e37442$export$9ebaf9fe814731d3 = null;
const $d5b40c70d7e37442$export$9b72011e2eb8d7d0 = 'text';

});

parcelRegister("j0h5m", function(module, exports) {

$parcel$export(module.exports, "default", () => $73773c42d63775af$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $73773c42d63775af$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    filterPlaceholder: {
        "id": "business-filters.controllers.field-config-v2.filter-placeholder",
        "defaultMessage": "Search"
    },
    dateRangeLabel: {
        "id": "business-filters.controllers.field-config-v2.date-range-label",
        "defaultMessage": "Date range"
    },
    startDateLabel: {
        "id": "business-filters.controllers.field-config-v2.start-date-label",
        "defaultMessage": "Start date"
    },
    dueDateLabel: {
        "id": "business-filters.controllers.field-config-v2.due-date-label",
        "defaultMessage": "Due date"
    },
    unassignedLabel: {
        "id": "business-filters.controllers.field-config-v2.unassigned-label",
        "defaultMessage": "Unassigned"
    },
    noLabelsLabel: {
        "id": "business-filters.controllers.field-config-v2.no-labels-label",
        "defaultMessage": "No label"
    },
    noCategoriesLabel: {
        "id": "business-filters.controllers.field-config-v2.no-categories-label",
        "defaultMessage": "No category"
    },
    noComponentsLabel: {
        "id": "business-filters.controllers.field-config-v2.no-components-label",
        "defaultMessage": "No component"
    },
    noSprintLabel: {
        "id": "business-filters.controllers.field-config-v2.no-sprint-label",
        "defaultMessage": "Backlog"
    },
    noVersionLabel: {
        "id": "business-filters.controllers.field-config-v2.no-version-label",
        "defaultMessage": "No version"
    },
    noParentLabel: {
        "id": "business-filters.controllers.field-config-v2.no-parent-label",
        "defaultMessage": "No parent"
    },
    noGoalLabel: {
        "id": "business-filters.controllers.field-config-v2.no-goal-label",
        "defaultMessage": "No goal"
    },
    noTeamLabel: {
        "id": "business-filters.controllers.field-config-v2.no-team-label",
        "defaultMessage": "No team"
    }
});

});



parcelRegister("cLe9v", function(module, exports) {

$parcel$export(module.exports, "useFieldConfig", () => $bad07c14bc3eb691$export$70da50df1be2dbe1);

var $5uXOq = parcelRequire("5uXOq");

var $3JOCw = parcelRequire("3JOCw");

var $hE5wF = parcelRequire("hE5wF");

var $ftuRD = parcelRequire("ftuRD");

var $1T2vX = parcelRequire("1T2vX");

var $2H8QW = parcelRequire("2H8QW");

var $2Lcoi = parcelRequire("2Lcoi");

var $aJfd5 = parcelRequire("aJfd5");

var $jcw0u = parcelRequire("jcw0u");

var $7f4tk = parcelRequire("7f4tk");

var $koVbs = parcelRequire("koVbs");

var $5fc53 = parcelRequire("5fc53");

var $koeKL = parcelRequire("koeKL");

var $ieDtd = parcelRequire("ieDtd");
var $doZTA = parcelRequire("doZTA");

var $czmU8 = parcelRequire("czmU8");

var $84pWT = parcelRequire("84pWT");

var $8841m = parcelRequire("8841m");

var $1vUxa = parcelRequire("1vUxa");

var $e3P1V = parcelRequire("e3P1V");
const $bad07c14bc3eb691$var$MAX_NUMBER_OF_OPTIONS = 10;
const $bad07c14bc3eb691$var$useFilterMapper = true;
const $bad07c14bc3eb691$var$EMPTY_ARRAY = [];
const $bad07c14bc3eb691$var$EMPTY_USER_ARRAY = [];
const $bad07c14bc3eb691$var$EMPTY_COMPONENT_ARRAY = [];
const $bad07c14bc3eb691$var$EMPTY_CATEGORY_ARRAY = [];
const $bad07c14bc3eb691$export$1fe8227c57fa0d68 = ()=>({
        initialUsers: {
            data: $bad07c14bc3eb691$var$EMPTY_USER_ARRAY,
            isLoading: false
        },
        initialLabels: {
            data: $bad07c14bc3eb691$var$EMPTY_ARRAY,
            isLoading: false
        },
        initialComponents: {
            data: $bad07c14bc3eb691$var$EMPTY_COMPONENT_ARRAY,
            isLoading: false
        },
        initialCategories: {
            data: $bad07c14bc3eb691$var$EMPTY_CATEGORY_ARRAY,
            isLoading: false
        },
        projectKey: null
    });
const $bad07c14bc3eb691$export$74cea4b24a6bc9fa = $bad07c14bc3eb691$export$1fe8227c57fa0d68();
const $bad07c14bc3eb691$var$useForceUpdate = ()=>{
    const [, setValue] = (0, $5uXOq.useState)(0);
    return (0, $5uXOq.useCallback)(()=>setValue((value)=>value + 1), []);
};
const $bad07c14bc3eb691$export$70da50df1be2dbe1 = ({ allowedFieldTypes: allowedFieldTypes, allowedAliasFieldId: allowedAliasFieldId })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [userResolver] = (0, $5uXOq.useState)(new (0, $aJfd5.UserResolver)());
    const forceUpdate = $bad07c14bc3eb691$var$useForceUpdate();
    const [priorityFieldConfig] = (0, $ftuRD.useIssueTypeFieldConfig)({
        screen: 'VIEW',
        issueTypeId: 'default',
        fieldId: 'priority'
    });
    const { data: issueTypeData, loading: loadingIssueTypesAndFields } = (0, $1T2vX.useIssueTypesAndFields)({
        issueOperation: 'VIEW'
    });
    const formattedCategoryOptions = (0, $5uXOq.useMemo)(()=>{
        const categoryOptions = issueTypeData.fields.find((field)=>field.type === (0, $5fc53.CATEGORY_TYPE))?.fieldConfig?.selectOptions ?? [];
        return categoryOptions.map(({ value: value })=>({
                label: value,
                value: value
            }));
    }, [
        issueTypeData
    ]);
    const { statuses: statuses, loading: loadingStatuses } = (0, $8841m.useProjectStatuses)();
    const [{ match: { params: { projectKey: projectKey } } }] = (0, $doZTA.useRouter)();
    const cloudId = (0, $koeKL.useCloudId)();
    const [jqlURLParam] = (0, $ieDtd.useQueryParam)((0, $hE5wF.FILTER_PARAM));
    const jqlURLParamRef = (0, $5uXOq.useRef)(jqlURLParam);
    const hydratedUsers = (0, $5uXOq.useRef)(null);
    const fetchInitialUsers = (0, $5uXOq.useCallback)(async ()=>{
        $bad07c14bc3eb691$export$74cea4b24a6bc9fa.initialUsers.isLoading = true;
        let users = [];
        const hydratedValues = jqlURLParamRef.current ? await (0, $czmU8.hydrateFilterValues)(cloudId, jqlURLParamRef.current) : null;
        if (hydratedValues !== null) {
            const transformedHydratedValues = (0, $84pWT.transformHydratedValues)(hydratedValues);
            hydratedUsers.current = transformedHydratedValues.users.options;
        }
        const url = `/rest/api/3/user/search?maxResults=${$bad07c14bc3eb691$var$MAX_NUMBER_OF_OPTIONS}&query=`;
        users = await (0, $7f4tk.default)(url);
        $bad07c14bc3eb691$export$74cea4b24a6bc9fa.initialUsers = {
            data: users,
            isLoading: false
        };
        forceUpdate();
        return users;
    }, [
        cloudId,
        forceUpdate
    ]);
    const fetchInitialLabels = (0, $5uXOq.useCallback)(async ()=>{
        const url = `/rest/api/3/label?maxResults=${$bad07c14bc3eb691$var$MAX_NUMBER_OF_OPTIONS}`;
        try {
            $bad07c14bc3eb691$export$74cea4b24a6bc9fa.initialLabels.isLoading = true;
            const response = await (0, $7f4tk.default)(url);
            const labels = response.values;
            $bad07c14bc3eb691$export$74cea4b24a6bc9fa.initialLabels = {
                data: labels,
                isLoading: false
            };
            forceUpdate();
            return labels;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $jcw0u.default)({
                meta: {
                    id: 'fetchFilterInitialLabels',
                    packageName: 'jiraBusinessFilters',
                    teamName: 'wanjel'
                },
                attributes: {
                    message: 'Failed to fetch initial labels',
                    errorType: (0, $2H8QW.getErrorType)(err)
                },
                error: err,
                sendToPrivacyUnsafeSplunk: true
            });
        }
        $bad07c14bc3eb691$export$74cea4b24a6bc9fa.initialLabels = {
            data: $bad07c14bc3eb691$var$EMPTY_ARRAY,
            isLoading: false
        };
        forceUpdate();
        return $bad07c14bc3eb691$var$EMPTY_ARRAY;
    }, [
        forceUpdate
    ]);
    const fetchUsers = (0, $5uXOq.useCallback)(async (query = '')=>{
        if (projectKey != null) {
            const url = `/rest/api/2/user/assignable/search?project=${projectKey}&maxResults=${$bad07c14bc3eb691$var$MAX_NUMBER_OF_OPTIONS}&query=${query}`;
            try {
                const response = await (0, $7f4tk.default)(url);
                return response;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (err) {
                (0, $jcw0u.default)({
                    meta: {
                        id: 'searchFilterUsers',
                        packageName: 'jiraBusinessFilters',
                        teamName: 'wanjel'
                    },
                    attributes: {
                        message: 'Failed to search users',
                        errorType: (0, $2H8QW.getErrorType)(err)
                    },
                    error: err,
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        }
        return $bad07c14bc3eb691$var$EMPTY_USER_ARRAY;
    }, [
        projectKey
    ]);
    const fetchProjectComponents = (0, $5uXOq.useCallback)(async (query = '')=>{
        if (projectKey != null) try {
            const response = await (0, $2Lcoi.fetchComponents)({
                inputValue: query,
                autoCompleteUrl: `/rest/api/3/project/${projectKey}/component`,
                useFilterMapper: $bad07c14bc3eb691$var$useFilterMapper
            });
            return response;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $jcw0u.default)({
                meta: {
                    id: 'fetchFilterComponents',
                    packageName: 'jiraBusinessFilters',
                    teamName: 'wanjel'
                },
                attributes: {
                    message: 'Failed to fetch components',
                    errorType: (0, $2H8QW.getErrorType)(err)
                },
                error: err,
                sendToPrivacyUnsafeSplunk: true
            });
        }
        return [];
    }, [
        projectKey
    ]);
    const fetchLabels = (0, $5uXOq.useCallback)((query = '')=>(0, $7f4tk.default)(`/rest/api/1.0/labels/suggest?query=${query}`).catch((err)=>{
            (0, $jcw0u.default)({
                meta: {
                    id: 'searchFilterLabels',
                    packageName: 'jiraBusinessFilters',
                    teamName: 'wanjel'
                },
                attributes: {
                    message: 'Failed to search labels',
                    errorType: (0, $2H8QW.getErrorType)(err)
                },
                error: err,
                sendToPrivacyUnsafeSplunk: true
            });
        }), []);
    const fetchProjectCategories = (0, $5uXOq.useCallback)((query = '')=>{
        // TODO Replace with back end fetch API
        const filteredCategoriesQuery = formattedCategoryOptions?.filter((categoryOption)=>categoryOption.label.toLowerCase().startsWith(query.toLowerCase()));
        return Promise.resolve(filteredCategoriesQuery ?? []);
    }, [
        formattedCategoryOptions
    ]);
    const { fetch: fetchInitialStoryPointsData, data: initialStoryPoints, loading: loadingStoryPoints } = (0, $1vUxa.useGroupItemValues)({
        groupFieldId: (0, $hE5wF.STORY_POINTS_ALIAS_FIELD_ID)
    });
    const { fetch: fetchInitialStoryPointsEstimateData, data: initialStoryPointsEstimate, loading: loadingStoryPointsEstimate } = (0, $1vUxa.useGroupItemValues)({
        groupFieldId: (0, $hE5wF.STORY_POINT_ESTIMATE_ALIAS_FIELD_ID)
    });
    (0, $5uXOq.useEffect)(()=>{
        if (allowedAliasFieldId != null && allowedAliasFieldId.has((0, $hE5wF.STORY_POINTS_ALIAS_FIELD_ID))) fetchInitialStoryPointsData();
    }, [
        allowedAliasFieldId,
        fetchInitialStoryPointsData
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (allowedAliasFieldId != null && allowedAliasFieldId.has((0, $hE5wF.STORY_POINT_ESTIMATE_ALIAS_FIELD_ID))) fetchInitialStoryPointsEstimateData();
    }, [
        allowedAliasFieldId,
        fetchInitialStoryPointsEstimateData
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (projectKey != null && // Initially fetch for everything if projectKey is updated or users is empty
        ($bad07c14bc3eb691$export$74cea4b24a6bc9fa.projectKey !== projectKey || $bad07c14bc3eb691$export$74cea4b24a6bc9fa.initialUsers.data === $bad07c14bc3eb691$var$EMPTY_USER_ARRAY)) {
            if ($bad07c14bc3eb691$export$74cea4b24a6bc9fa.initialUsers.isLoading === false) {
                $bad07c14bc3eb691$export$74cea4b24a6bc9fa.projectKey = projectKey;
                fetchInitialUsers();
            }
        }
    }, [
        fetchInitialUsers,
        fetchProjectComponents,
        projectKey,
        fetchInitialLabels,
        fetchProjectCategories,
        forceUpdate
    ]);
    const { data: initialUsers, isLoading: isLoadingUsers } = $bad07c14bc3eb691$export$74cea4b24a6bc9fa.initialUsers;
    const { data: initialLabels, isLoading: isLoadingLabels } = $bad07c14bc3eb691$export$74cea4b24a6bc9fa.initialLabels;
    const { data: initialComponents, isLoading: isLoadingComponents } = $bad07c14bc3eb691$export$74cea4b24a6bc9fa.initialComponents;
    const { data: initialCategories, isLoading: isLoadingCategories } = $bad07c14bc3eb691$export$74cea4b24a6bc9fa.initialCategories;
    const fieldOptionsData = (0, $5uXOq.useMemo)(()=>({
            priority: (0, $e3P1V.transformPriority)(priorityFieldConfig),
            issuetype: (0, $e3P1V.transformIssueType)(issueTypeData),
            status: (0, $e3P1V.transformStatuses)(statuses),
            users: (0, $e3P1V.transformUsers)(initialUsers),
            labels: (0, $e3P1V.transformLabels)(initialLabels),
            components: initialComponents,
            [(0, $5fc53.CATEGORY_TYPE)]: initialCategories,
            [(0, $hE5wF.STORY_POINTS_ALIAS_FIELD_ID)]: initialStoryPoints?.options || [],
            [(0, $hE5wF.STORY_POINT_ESTIMATE_ALIAS_FIELD_ID)]: initialStoryPointsEstimate?.options || []
        }), [
        priorityFieldConfig,
        issueTypeData,
        statuses,
        initialUsers,
        initialLabels,
        initialComponents,
        initialCategories,
        initialStoryPoints?.options,
        initialStoryPointsEstimate?.options
    ]);
    fieldOptionsData.users = (0, $5uXOq.useMemo)(()=>{
        if (hydratedUsers.current === null) return fieldOptionsData.users;
        return (0, (/*@__PURE__*/$parcel$interopDefault($3JOCw)))([
            ...hydratedUsers.current ?? [],
            ...fieldOptionsData.users ?? []
        ], ({ value: value })=>value);
    }, [
        fieldOptionsData
    ]);
    const { fieldConfig: fieldConfig, resolvers: resolvers } = (0, $e3P1V.getFilterFieldConfigAndResolvers)({
        formatMessage: formatMessage,
        allowedFieldTypes: allowedFieldTypes,
        allowedAliasFieldId: allowedAliasFieldId,
        allFields: issueTypeData.fields,
        fieldOptionsData: fieldOptionsData,
        fetchUsers: (query)=>fetchUsers(query).then((users)=>(0, $e3P1V.transformUsers)(users || [])),
        fetchLabels: (query)=>fetchLabels(query).then((labels)=>labels ? (0, $e3P1V.transformLabelSuggestions)(labels) : []),
        fetchComponents: (query)=>fetchProjectComponents(query).then((components)=>components),
        fetchCategories: (query)=>fetchProjectCategories(query).then((categoriesResponse)=>categoriesResponse),
        userResolver: userResolver
    });
    const fetching = isLoadingUsers || isLoadingLabels || isLoadingComponents || isLoadingCategories || loadingStoryPoints || loadingStoryPointsEstimate;
    return {
        fieldConfig: fieldConfig,
        resolvers: resolvers,
        loading: loadingIssueTypesAndFields || loadingStatuses || fetching
    };
};

});
parcelRegister("ftuRD", function(module, exports) {

$parcel$export(module.exports, "useIssueTypeFieldConfig", () => $66b06940d67822ac$export$42e875bfb69ded2);

var $5uXOq = parcelRequire("5uXOq");

var $9XE6b = parcelRequire("9XE6b");

var $3sQ5x = parcelRequire("3sQ5x");
var $6dDSs = parcelRequire("6dDSs");
var $iXqE5 = parcelRequire("iXqE5");

var $1T2vX = parcelRequire("1T2vX");
const $66b06940d67822ac$var$merge = (screen, issueTypeId, configs)=>({ setState: setState, getState: getState })=>{
        setState({
            ...getState(),
            [screen]: {
                ...(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(getState(), [
                    screen
                ], {}),
                [issueTypeId]: configs
            }
        });
    };
const $66b06940d67822ac$var$actions = {
    merge: $66b06940d67822ac$var$merge
};
const $66b06940d67822ac$export$cbf0f7fe9ca42a65 = (0, $iXqE5.createStore)({
    initialState: {},
    actions: $66b06940d67822ac$var$actions,
    name: 'issueTypeFieldConfig'
});
const $66b06940d67822ac$var$getIssueTypeFieldConfigSelector = (0, $6dDSs.createSelector)((state)=>state, (_, props)=>props?.screen ?? undefined, (_, props)=>props?.issueTypeId ?? undefined, (_, props)=>props?.fieldId ?? undefined, (state, screen, issueTypeId, fieldId)=>{
    if (screen === undefined || issueTypeId === undefined || fieldId === undefined) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(state, [
        screen,
        issueTypeId,
        fieldId
    ], null);
});
const $66b06940d67822ac$export$47647eb426e85a25 = (0, $3sQ5x.createHook)($66b06940d67822ac$export$cbf0f7fe9ca42a65, {
    selector: $66b06940d67822ac$var$getIssueTypeFieldConfigSelector
});
const $66b06940d67822ac$export$42e875bfb69ded2 = (props)=>{
    const [state, fieldsConfigActions] = $66b06940d67822ac$export$47647eb426e85a25(props);
    const screen = props?.screen || 'VIEW';
    const { data: data, loading: loading, error: error } = (0, $1T2vX.useIssueTypesAndFields)({
        issueOperation: screen
    });
    // store field config to be consumed at the cell level
    return (0, $5uXOq.useMemo)(()=>{
        if (state != null) return [
            state,
            fieldsConfigActions,
            {
                loading: false,
                error: undefined
            }
        ];
        if (loading === false && (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(data, [
            'issueTypes'
        ], []).length > 0) data.issueTypes.forEach((issueType)=>{
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const config = {};
            data.fields.forEach((field)=>{
                if ((field.issueTypes || []).includes(issueType.id) && field.id != null) config[field.id] = {
                    ...field.fieldConfig,
                    fieldType: field.type
                };
            });
            fieldsConfigActions.merge(screen, issueType.id, config);
            if (issueType.isDefault) fieldsConfigActions.merge(screen, 'default', config);
        });
        return [
            state,
            fieldsConfigActions,
            {
                loading: loading,
                error: error
            }
        ];
    }, [
        data,
        error,
        fieldsConfigActions,
        loading,
        screen,
        state
    ]);
};

});

parcelRegister("2H8QW", function(module, exports) {

$parcel$export(module.exports, "getErrorType", () => $3122aab38ac46d24$export$e19f9f08a6d79fd2);

var $jJZqs = parcelRequire("jJZqs");
const $3122aab38ac46d24$export$7453182ebe5973d4 = 'APOLLO_NETWORK_ERROR';
const $3122aab38ac46d24$export$9705762bba4e9e25 = 'NULL_OR_UNDEFINED';
const $3122aab38ac46d24$export$d46a05f8561f868a = 'OTHER';
const $3122aab38ac46d24$export$c748438cec453c9f = {
    FAILED_TO_FETCH: 'Failed to fetch',
    NETWORK_ERROR: 'NetworkError when attempting to fetch resource.',
    NETWORK_REQUEST_FAILED: 'Network request failed',
    NETWORK_CONNECTION_LOST: 'The network connection was lost.',
    NETWORK_CONNECTION_ERROR: 'upstream connect error or disconnect/reset before headers. reset reason: connection',
    UNEXPECTED_ERROR_OCCURRED: 'Response ended with an error message: An unexpected error occurred',
    ABORTED: 'operation was aborted.',
    CANCELLED: 'cancelled',
    TIMEOUT: 'The request timed out.'
};
const $3122aab38ac46d24$var$isApolloClientNetworkError = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
error)=>error.networkError !== undefined && error.networkError !== null;
const $3122aab38ac46d24$export$e19f9f08a6d79fd2 = (error)=>{
    if (error == null) return $3122aab38ac46d24$export$9705762bba4e9e25;
    const message = String(error instanceof Error ? error.message : error).trim();
    if (error instanceof (0, $jJZqs.default)) {
        const { statusCode: statusCode } = error;
        if (statusCode) return `FETCH_ERROR_${statusCode}`;
    }
    if ($3122aab38ac46d24$var$isApolloClientNetworkError(error)) return $3122aab38ac46d24$export$7453182ebe5973d4;
    const entry = Object.entries($3122aab38ac46d24$export$c748438cec453c9f).find((arrayItem)=>String(arrayItem[1]).toLowerCase() === message.toLowerCase());
    return entry ? entry[0] : $3122aab38ac46d24$export$d46a05f8561f868a;
};

});

parcelRegister("2Lcoi", function(module, exports) {

$parcel$export(module.exports, "fetchComponents", () => $14f8d378ed2868dc$export$4f703ddb7c8cc5b3);

var $ebyGx = parcelRequire("ebyGx");

var $2H8QW = parcelRequire("2H8QW");

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

var $lb7V6 = parcelRequire("lb7V6");
const $14f8d378ed2868dc$export$4f703ddb7c8cc5b3 = ({ inputValue: inputValue, autoCompleteUrl: autoCompleteUrl, useFilterMapper: useFilterMapper, queryParameters: queryParameters })=>{
    const mapperFunction = useFilterMapper === true ? (0, $lb7V6.mapComponentsToFilterOptions) : (0, $lb7V6.mapComponentsToOptions);
    const query = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify({
        query: inputValue,
        ...queryParameters
    });
    return (0, $eusud.performGetRequest)(`${autoCompleteUrl}?${query}`).then((response)=>mapperFunction(response.values)).catch((error)=>{
        (0, $jcw0u.default)({
            meta: {
                id: 'fetchProjectComponents',
                packageName: 'jiraBusinessFetchComponents',
                teamName: 'wanjel'
            },
            attributes: {
                message: 'Failed to fetch jwm project components',
                errorType: (0, $2H8QW.getErrorType)(error)
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    });
};

});
parcelRegister("lb7V6", function(module, exports) {

$parcel$export(module.exports, "mapComponentsToOptions", () => $4c5d47ac0f899709$export$85e44418187c2c1e);
$parcel$export(module.exports, "mapComponentsToFilterOptions", () => $4c5d47ac0f899709$export$b4ef58d3e943e4d5);
const $4c5d47ac0f899709$export$85e44418187c2c1e = (components)=>components.map(({ id: id, componentId: componentId, name: name })=>({
            label: name,
            value: componentId !== undefined ? String(componentId) : String(id)
        }));
const $4c5d47ac0f899709$export$b4ef58d3e943e4d5 = (components)=>components.map(({ name: name })=>({
            label: name,
            value: name
        }));

});


parcelRegister("8841m", function(module, exports) {

$parcel$export(module.exports, "useProjectStatuses", () => $f2e77b2d189a9e48$export$11ff6a520db76faf);

var $5uXOq = parcelRequire("5uXOq");

var $7qDUb = parcelRequire("7qDUb");

var $3JOCw = parcelRequire("3JOCw");

var $daQYX = parcelRequire("daQYX");

var $2YZCu = parcelRequire("2YZCu");

var $3sQ5x = parcelRequire("3sQ5x");
var $6dDSs = parcelRequire("6dDSs");
var $iXqE5 = parcelRequire("iXqE5");
const $f2e77b2d189a9e48$var$PACKAGE_LOCATION = 'jira-business.common.services.project-statuses';
const $f2e77b2d189a9e48$var$MAX_RETRIES = 3;
const $f2e77b2d189a9e48$var$set = (projectKey, statuses)=>({ setState: setState })=>setState({
            [projectKey]: statuses
        });
const $f2e77b2d189a9e48$var$actions = {
    set: $f2e77b2d189a9e48$var$set
};
const $f2e77b2d189a9e48$var$ProjectStatusesStore = (0, $iXqE5.createStore)({
    initialState: {},
    actions: $f2e77b2d189a9e48$var$actions,
    name: 'projectStatuses'
});
const $f2e77b2d189a9e48$var$getProjectStatusesSelector = (0, $6dDSs.createSelector)((state)=>state, (_, props)=>props?.projectKey ?? undefined, (state, projectKey)=>{
    if (projectKey === undefined || state[projectKey] == null) return [];
    return state[projectKey];
});
const $f2e77b2d189a9e48$export$482f388228eef22c = (0, $3sQ5x.createHook)($f2e77b2d189a9e48$var$ProjectStatusesStore, {
    selector: $f2e77b2d189a9e48$var$getProjectStatusesSelector
});
const $f2e77b2d189a9e48$var$emptyArray = [];
const $f2e77b2d189a9e48$export$11ff6a520db76faf = ()=>{
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
    const requestInFlight = (0, $5uXOq.useRef)(false);
    const [retriesCount, setRetriesCount] = (0, $5uXOq.useState)(0);
    const projectData = (0, $daQYX.useProject)();
    const projectKey = projectData.key;
    const [statuses, statusActions] = $f2e77b2d189a9e48$export$482f388228eef22c({
        projectKey: projectKey
    });
    const retry = (0, $5uXOq.useCallback)(()=>{
        requestInFlight.current = false;
        setRetriesCount(retriesCount + 1);
    }, [
        retriesCount
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (requestInFlight.current === false) {
            requestInFlight.current = true;
            fetch(`/rest/api/3/project/${projectKey}/statuses`).then((response)=>response.json()).then((issueTypes)=>{
                const allStatuses = issueTypes.reduce(// @ts-expect-error - TS7006 - Parameter 'acc' implicitly has an 'any' type. | TS7006 - Parameter 'next' implicitly has an 'any' type.
                (acc, next)=>acc.concat(next.statuses), []);
                const dedupedResults = (0, (/*@__PURE__*/$parcel$interopDefault($3JOCw)))(allStatuses, 'id');
                return (0, (/*@__PURE__*/$parcel$interopDefault($7qDUb)))(dedupedResults, [
                    'name'
                ]);
            }).then((uniqueStatuses)=>{
                statusActions.set(projectKey, uniqueStatuses);
                setIsLoading(false);
            }).catch(()=>{
                (0, $2YZCu.default).safeErrorWithoutCustomerData($f2e77b2d189a9e48$var$PACKAGE_LOCATION, `Failed to retrieve project statuses - Retry #${retriesCount}`);
                setIsLoading(false);
                if (retriesCount < $f2e77b2d189a9e48$var$MAX_RETRIES) retry();
            }).finally(()=>{
                requestInFlight.current = false;
            });
            setIsLoading(true);
        }
    }, [
        projectKey,
        statusActions,
        retriesCount,
        retry
    ]);
    if (projectKey != null && Array.isArray(statuses) && statuses.length > 0) return {
        statuses: statuses,
        loading: isLoading
    };
    return {
        statuses: $f2e77b2d189a9e48$var$emptyArray,
        loading: isLoading
    };
};

});

parcelRegister("1vUxa", function(module, exports) {

$parcel$export(module.exports, "useGroupItemValues", () => $f2df8273d684a2c0$export$f05af123f98299b0);

var $5uXOq = parcelRequire("5uXOq");

var $ccvFs = parcelRequire("ccvFs");

var $5YBrl = parcelRequire("5YBrl");

var $jlq4V = parcelRequire("jlq4V");

var $koVbs = parcelRequire("koVbs");

var $g31qf = parcelRequire("g31qf");

var $baeZQ = parcelRequire("baeZQ");
const $f2df8273d684a2c0$var$reducer = (state, action)=>{
    switch(action.type){
        case 'loading':
            return {
                loading: true
            };
        case 'success':
            return {
                loading: false,
                data: action.payload
            };
        case 'error':
            return {
                loading: false,
                data: null
            };
        default:
            return state;
    }
};
const $f2df8273d684a2c0$export$f05af123f98299b0 = ({ groupFieldId: groupFieldId })=>{
    const [state, dispatch] = (0, $5uXOq.useReducer)($f2df8273d684a2c0$var$reducer, {
        loading: false
    });
    const jqlContext = (0, $5YBrl.useJqlContext)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const fetchDataAbortable = (0, $ccvFs.useAbortable)((0, $g31qf.fetchGroupItemValues));
    const fetch = (0, $5uXOq.useCallback)(async ()=>{
        try {
            dispatch({
                type: 'loading'
            });
            const response = await fetchDataAbortable(groupFieldId, jqlContext);
            if (response.data?.items == null) throw new (0, $jlq4V.GraphQLErrors)(response.errors);
            dispatch({
                type: 'success',
                payload: (0, $baeZQ.transformInitialData)({
                    data: response.data,
                    formatMessage: formatMessage
                })
            });
        } catch (error) {
            if (error === (0, $ccvFs.ABORTED)) return;
            dispatch({
                type: 'error'
            });
        }
    }, [
        fetchDataAbortable,
        formatMessage,
        groupFieldId,
        jqlContext
    ]);
    return {
        fetch: fetch,
        data: state.data,
        loading: state.loading
    };
};

});
parcelRegister("ccvFs", function(module, exports) {

$parcel$export(module.exports, "ABORTED", () => $e04e223192d877be$export$23e29024ea698a35);
$parcel$export(module.exports, "useAbortable", () => $e04e223192d877be$export$a487c7eb4387f959);
/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $5uXOq = parcelRequire("5uXOq");
const $e04e223192d877be$export$23e29024ea698a35 = Symbol('ABORTED');
const $e04e223192d877be$export$a487c7eb4387f959 = (fetch)=>{
    const prevControllerRef = (0, $5uXOq.useRef)(null);
    return (0, $5uXOq.useCallback)((...args)=>{
        if (prevControllerRef.current) prevControllerRef.current.abort();
        const controller = new AbortController();
        prevControllerRef.current = controller;
        return fetch(controller.signal, ...args).catch((error)=>{
            if (controller.signal.aborted) throw $e04e223192d877be$export$23e29024ea698a35;
            else throw error;
        });
    }, [
        fetch
    ]);
};

});

parcelRegister("g31qf", function(module, exports) {

$parcel$export(module.exports, "fetchGroupItemValues", () => $71087c8bd1916bd2$export$7e6e0c3f4468ce45);

var $jcw0u = parcelRequire("jcw0u");

var $fZneA = parcelRequire("fZneA");

var $eusud = parcelRequire("eusud");

const $71087c8bd1916bd2$var$MAX_NUMBER_OF_OPTIONS = 20; // min number to render two rows
const $71087c8bd1916bd2$export$7e6e0c3f4468ce45 = async (signal, groupFieldId, jqlContext)=>{
    try {
        const variables = {
            fieldId: groupFieldId,
            first: $71087c8bd1916bd2$var$MAX_NUMBER_OF_OPTIONS,
            jql: jqlContext
        };
        const response = await (0, $eusud.performPostRequest)('/rest/gira/1/?operation=JWMFilterValuesByGroupItems', {
            body: JSON.stringify({
                query: (0, $626c877b75948b48$export$a48313dd44fc9855),
                variables: variables
            })
        });
        return response;
    } catch (error) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        if (!(0, $fZneA.isHttpClientErrorResponse)(error) && !signal.aborted) (0, $jcw0u.default)({
            meta: {
                id: 'initializeFilterGroupItemsData',
                packageName: 'jiraBusinessFilters',
                teamName: 'wanjel'
            },
            attributes: {
                message: 'Failed to initialize filter data using the group query'
            },
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};

});
const $626c877b75948b48$export$a48313dd44fc9855 = `
query JWMFilterValuesByGroupItems($fieldId: ID!, $jql: String!, $first: Int!) {
  items: jwmItemGroups(jql: $jql, groupByFieldId: $fieldId, fieldIds: [], first: $first) {
    totalCount
    edges {
      node {
        id
        field {
          __typename
          ... on FloatCustomField {
            floatValue
          }
        }
      }
    }
  }
}
`;


parcelRegister("baeZQ", function(module, exports) {

$parcel$export(module.exports, "transformInitialData", () => $a3e52c0a295405a4$export$93219b8691fe49a0);

var $9D5f1 = parcelRequire("9D5f1");
const $a3e52c0a295405a4$export$93219b8691fe49a0 = ({ data: data, formatMessage: formatMessage })=>({
        totalCount: data.items.totalCount,
        options: data.items.edges.map((edge)=>{
            if (edge.node.field.floatValue == null) return {
                value: null,
                label: formatMessage((0, $9D5f1.default).noneOption)
            };
            const stringFloatValue = String(edge.node.field.floatValue);
            return {
                value: stringFloatValue,
                label: stringFloatValue
            };
        })
    });

});
parcelRegister("9D5f1", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff2b830268d99634$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $ff2b830268d99634$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    noneOption: {
        "id": "business-filters.controllers.group-item-values.none-option",
        "defaultMessage": "None"
    }
});

});



parcelRegister("e3P1V", function(module, exports) {

$parcel$export(module.exports, "transformPriority", () => $b808701b322de4e8$export$1b9f55a39456e911);
$parcel$export(module.exports, "transformIssueType", () => $b808701b322de4e8$export$96520244689f81c1);
$parcel$export(module.exports, "transformStatuses", () => $b808701b322de4e8$export$20a57a5ec025f2d);
$parcel$export(module.exports, "transformUsers", () => $b808701b322de4e8$export$fb8c90bfc4beaa59);
$parcel$export(module.exports, "transformLabels", () => $b808701b322de4e8$export$c072126708d93f04);
$parcel$export(module.exports, "transformLabelSuggestions", () => $b808701b322de4e8$export$cdfcc40760c1a4f8);
$parcel$export(module.exports, "getFilterFieldConfigAndResolvers", () => $b808701b322de4e8$export$ba4f3d2149c2bf3b);

var $9XE6b = parcelRequire("9XE6b");

var $8QpSo = parcelRequire("8QpSo");

var $hE5wF = parcelRequire("hE5wF");

var $5fc53 = parcelRequire("5fc53");

var $4R6GH = parcelRequire("4R6GH");

var $gzkAf = parcelRequire("gzkAf");

var $gBF4Z = parcelRequire("gBF4Z");

var $7htvz = parcelRequire("7htvz");

var $6S22M = parcelRequire("6S22M");
const $b808701b322de4e8$export$1b9f55a39456e911 = (0, $8QpSo.default)((priorityFieldConfig)=>[
        ...priorityFieldConfig?.options || []
    ].reduce((acc, next)=>{
        acc.push({
            value: next.name,
            label: next.name,
            avatar: next.iconUrl || ''
        });
        return acc;
    }, []));
const $b808701b322de4e8$export$96520244689f81c1 = (0, $8QpSo.default)((issueTypeData)=>issueTypeData.issueTypes.reduce((acc, next)=>{
        acc.push({
            value: next.id,
            label: next.name,
            id: next.id,
            avatar: next.avatarUrl,
            square: true
        });
        return acc;
    }, []));
const $b808701b322de4e8$export$20a57a5ec025f2d = (0, $8QpSo.default)((statuses)=>statuses.reduce((acc, next)=>{
        acc.push({
            value: next.untranslatedName,
            label: next.name,
            categoryId: next.statusCategory.id,
            // Board needs the status id as number for client side filtering
            id: Number(next.id)
        });
        return acc;
    }, []));
const $b808701b322de4e8$export$fb8c90bfc4beaa59 = (0, $8QpSo.default)((users)=>users.reduce((acc, next)=>{
        acc.push({
            value: next.accountId || '',
            label: next.displayName,
            avatar: (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(next, [
                'avatarUrls',
                '24x24'
            ], '')
        });
        return acc;
    }, []));
const $b808701b322de4e8$export$c072126708d93f04 = (0, $8QpSo.default)((labels)=>labels.reduce((acc, next)=>{
        acc.push({
            value: next || '',
            label: next
        });
        return acc;
    }, []));
const $b808701b322de4e8$export$cdfcc40760c1a4f8 = (0, $8QpSo.default)((labels)=>labels?.suggestions.reduce((acc, next)=>{
        acc.push({
            value: next.label || '',
            label: next.label
        });
        return acc;
    }, []));
const $b808701b322de4e8$var$getType = ({ type: type })=>{
    switch(type){
        case 0, $5fc53.PRIORITY_TYPE:
            return (0, $gBF4Z.FieldType).PrioritySelectFilter;
        case 0, $5fc53.ASSIGNEE_TYPE:
        case 0, $5fc53.REPORTER_TYPE:
        case 0, $5fc53.USER_CF_TYPE:
        case 0, $5fc53.PEOPLE_CF_TYPE:
            return (0, $gBF4Z.FieldType).AvatarAsyncSelectFilter;
        case 0, $5fc53.ISSUE_TYPE:
            return (0, $gBF4Z.FieldType).AvatarSelectFilter;
        case 0, $5fc53.STATUS_TYPE:
            return (0, $gBF4Z.FieldType).LozengeSelectFilter;
        case 0, $5fc53.LABELS_TYPE:
        case 0, $5fc53.COMPONENTS_TYPE:
        case 0, $5fc53.SELECT_CF_TYPE:
        case 0, $5fc53.MULTI_SELECT_CF_TYPE:
            return (0, $gBF4Z.FieldType).AsyncSelectFilter;
        case 0, $5fc53.CREATED:
        case 0, $5fc53.UPDATED:
        case 0, $5fc53.DATE_CF_TYPE:
            return (0, $gBF4Z.FieldType).DateFilter;
        case 0, $5fc53.CATEGORY_TYPE:
            return (0, $gBF4Z.FieldType).CategorySelectFilter;
        case 0, $5fc53.NUMBER_CF_TYPE:
        case 0, $5fc53.STORY_POINT_ESTIMATE_CF_TYPE:
        default:
            return (0, $gBF4Z.FieldType).SelectFilter;
    }
};
const $b808701b322de4e8$var$getSelectCustomFieldValues = (field)=>(field?.fieldConfig?.selectOptions ?? []).map(({ value: value })=>({
            label: value,
            value: value
        }));
const $b808701b322de4e8$var$getValues = ({ type: type, fieldOptionsData: fieldOptionsData, field: field, aliasFieldId: aliasFieldId })=>{
    switch(type){
        case 0, $5fc53.ASSIGNEE_TYPE:
        case 0, $5fc53.REPORTER_TYPE:
        case 0, $5fc53.USER_CF_TYPE:
        case 0, $5fc53.PEOPLE_CF_TYPE:
            return fieldOptionsData.users;
        case 0, $5fc53.SELECT_CF_TYPE:
        case 0, $5fc53.MULTI_SELECT_CF_TYPE:
        case 0, $5fc53.MULTI_CHECKBOXES_CF_TYPE:
            return $b808701b322de4e8$var$getSelectCustomFieldValues(field);
        case 0, $5fc53.NUMBER_CF_TYPE:
            if (aliasFieldId === (0, $hE5wF.STORY_POINTS_ALIAS_FIELD_ID)) return fieldOptionsData[0, $hE5wF.STORY_POINTS_ALIAS_FIELD_ID];
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return fieldOptionsData[type];
        case 0, $5fc53.STORY_POINT_ESTIMATE_CF_TYPE:
            return fieldOptionsData[0, $hE5wF.STORY_POINT_ESTIMATE_ALIAS_FIELD_ID];
        default:
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return fieldOptionsData[type];
    }
};
const $b808701b322de4e8$var$isUserField = (type)=>{
    switch(type){
        case 0, $5fc53.ASSIGNEE_TYPE:
        case 0, $5fc53.REPORTER_TYPE:
        case 0, $5fc53.USER_CF_TYPE:
        case 0, $5fc53.PEOPLE_CF_TYPE:
            return true;
        default:
            return false;
    }
};
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
const $b808701b322de4e8$var$isCustomField = (type)=>(0, $gzkAf.EXTRA_CUSTOM_FIELD_TYPES).has(type);
const $b808701b322de4e8$var$createUserValueGetter = (userResolver)=>(0, $8QpSo.default)((accountIds)=>// @ts-expect-error - TS7006 - Parameter 'response' implicitly has an 'any' type.
        userResolver.getUsersFromAccountId(accountIds).then((response)=>$b808701b322de4e8$export$fb8c90bfc4beaa59(response)));
const $b808701b322de4e8$export$ba4f3d2149c2bf3b = ({ formatMessage: formatMessage, allowedFieldTypes: allowedFieldTypes, allowedAliasFieldId: allowedAliasFieldId = new Set(), allFields: allFields, fieldOptionsData: fieldOptionsData, fetchUsers: fetchUsers, fetchLabels: fetchLabels, fetchComponents: fetchComponents, fetchCategories: fetchCategories, userResolver: userResolver })=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const fieldConfig = {};
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const resolvers = {};
    if (allowedFieldTypes.has((0, $gzkAf.DATE_RANGE_TYPE))) // manually add dateRange to fieldConfig
    fieldConfig.dateRange = {
        label: formatMessage((0, $6S22M.default).dateRangeLabel),
        type: (0, $gBF4Z.FieldType).DateFilter
    };
    const fields = allFields.filter((field)=>allowedFieldTypes.has(field.type ?? '') || allowedAliasFieldId.has(field.aliasFieldId || ''));
    fields.forEach((field)=>{
        const { name: name, type: type, id: id, aliasFieldId: aliasFieldId } = field;
        // if the type is unsupported
        // or it's the start date field (which is handled separately as 'date range')
        // then skip
        if (type == null || aliasFieldId === (0, $hE5wF.START_DATE_ALIAS_FIELD_ID)) return;
        const selectType = $b808701b322de4e8$var$getType({
            type: type
        });
        const shouldAddIsSearchableInJql = (0, $4R6GH.fg)('jira_issue_field_searchable_in_jql_data_fetcher') && typeof field.isSearchableInJql === 'boolean';
        fieldConfig[id] = {
            systemType: type,
            label: name,
            type: selectType,
            placeholder: formatMessage((0, $6S22M.default).filterPlaceholder),
            options: $b808701b322de4e8$var$getValues({
                type: type,
                fieldOptionsData: fieldOptionsData,
                field: field,
                aliasFieldId: aliasFieldId
            }),
            isCustomField: $b808701b322de4e8$var$isCustomField(type),
            ...shouldAddIsSearchableInJql && {
                isSearchableInJql: field.isSearchableInJql
            },
            fieldConfigVersion: 1
        };
        if (aliasFieldId != null && allowedAliasFieldId.has(aliasFieldId)) fieldConfig[id].aliasFieldId = aliasFieldId;
        if (type === (0, $5fc53.ISSUE_TYPE)) fieldConfig[id].label = formatMessage((0, $6S22M.default).typeLabel);
        if ($b808701b322de4e8$var$isUserField(type)) {
            fieldConfig[id].loadOptions = fetchUsers;
            fieldConfig[id].defaultOptions = $b808701b322de4e8$var$getValues({
                type: type,
                fieldOptionsData: fieldOptionsData
            });
            resolvers[id] = $b808701b322de4e8$var$createUserValueGetter(userResolver);
            fieldConfig[id].options = [
                ...fieldConfig[id].options,
                {
                    value: 'EMPTY',
                    label: formatMessage((0, $6S22M.default).unassignedLabel),
                    isEmptyOption: true
                }
            ];
        }
        if (type === (0, $5fc53.LABELS_TYPE)) {
            fieldConfig[id].loadOptions = fetchLabels;
            fieldConfig[id].defaultOptions = $b808701b322de4e8$var$getValues({
                type: type,
                fieldOptionsData: fieldOptionsData
            });
        }
        if (type === (0, $5fc53.COMPONENTS_TYPE)) {
            fieldConfig[id].loadOptions = fetchComponents;
            fieldConfig[id].defaultOptions = $b808701b322de4e8$var$getValues({
                type: type,
                fieldOptionsData: fieldOptionsData
            });
        }
        if (type === (0, $5fc53.CATEGORY_TYPE)) {
            fieldConfig[id].loadOptions = fetchCategories;
            fieldConfig[id].defaultOptions = $b808701b322de4e8$var$getValues({
                type: type,
                fieldOptionsData: fieldOptionsData
            });
        }
        if (type === (0, $5fc53.SELECT_CF_TYPE) || type === (0, $5fc53.MULTI_SELECT_CF_TYPE) || type === (0, $5fc53.MULTI_CHECKBOXES_CF_TYPE)) fieldConfig[id].options = [
            ...fieldConfig[id].options,
            {
                value: (0, $7htvz.EMPTY_FILTER_VALUE),
                label: formatMessage((0, $6S22M.default).noneOption),
                isEmptyOption: true
            }
        ];
    });
    return {
        fieldConfig: fieldConfig,
        resolvers: resolvers
    };
};

});
parcelRegister("6S22M", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0167d244ddce5b9$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $c0167d244ddce5b9$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    filterPlaceholder: {
        "id": "business-filters.controllers.field-config.filter-placeholder",
        "defaultMessage": "Search"
    },
    dateRangeLabel: {
        "id": "business-filters.controllers.field-config.date-range-label",
        "defaultMessage": "Date range"
    },
    typeLabel: {
        "id": "business-filters.controllers.field-config.type-label",
        "defaultMessage": "Type"
    },
    unassignedLabel: {
        "id": "business-filters.controllers.field-config.unassigned-label",
        "defaultMessage": "Unassigned"
    },
    noneOption: {
        "id": "business-filters.controllers.field-config.none-option",
        "defaultMessage": "None"
    }
});

});




parcelRegister("17ot5", function(module, exports) {

$parcel$export(module.exports, "useHideDoneItems", () => $f683983c23bf92d0$export$c2cb7b17819b92d4);
$parcel$export(module.exports, "useInferHideDoneItemsWithFilters", () => $f683983c23bf92d0$export$a14bc8305f71e469);

var $5uXOq = parcelRequire("5uXOq");

var $x8FYU = parcelRequire("x8FYU");

var $1kpI8 = parcelRequire("1kpI8");

var $gULOk = parcelRequire("gULOk");

var $dpQnO = parcelRequire("dpQnO");
const $f683983c23bf92d0$export$c2cb7b17819b92d4 = ()=>{
    const [hideDoneItems, persistHideDoneItems] = (0, $1kpI8.useViewPreference)((0, $x8FYU.HIDE_DONE_ITEMS_PREFERENCE));
    const setHideDoneItems = (0, $5uXOq.useCallback)((hide, action = 'push')=>persistHideDoneItems(hide ? 'true' : undefined, action), [
        persistHideDoneItems
    ]);
    return [
        hideDoneItems === 'true',
        setHideDoneItems
    ];
};
const $f683983c23bf92d0$export$a14bc8305f71e469 = ({ filters: filters })=>{
    const [hideDoneItems, setHideDoneItems] = $f683983c23bf92d0$export$c2cb7b17819b92d4();
    const { quickFilters: quickFilters } = (0, $dpQnO.useQuickFilters)();
    (0, $5uXOq.useEffect)(()=>{
        if (hideDoneItems) {
            const isFilteringByDoneStatus = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            (filters && filters.status)?.find((status)=>Number(status.categoryId) === (0, $gULOk.StatusCategoryIds)[(0, $gULOk.StatusCategoryTypes).DONE]);
            if (isFilteringByDoneStatus || quickFilters?.DONE) setHideDoneItems(false, 'replace');
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        filters,
        quickFilters?.DONE
    ]);
};

});
parcelRegister("dpQnO", function(module, exports) {

$parcel$export(module.exports, "useQuickFilters", () => $59496077a2cce3b6$export$3dae1bb95b659fd4);

var $5uXOq = parcelRequire("5uXOq");

var $5fc53 = parcelRequire("5fc53");

var $g4ZHz = parcelRequire("g4ZHz");

var $l4Ejo = parcelRequire("l4Ejo");
const $59496077a2cce3b6$var$quickFilterToJQLMapOld = {
    ASSIGNED_TO_ME: 'assignee = currentUser()',
    DONE: "StatusCategory = 'Complete'",
    DUE_THIS_WEEK: 'duedate <= endOfWeek() and duedate > startOfWeek()'
};
const $59496077a2cce3b6$export$808f76242d61e1a5 = (sprintJQLTerm)=>{
    if (sprintJQLTerm == null) return $59496077a2cce3b6$var$quickFilterToJQLMapOld;
    return {
        ...$59496077a2cce3b6$var$quickFilterToJQLMapOld,
        ACTIVE_SPRINTS: `${sprintJQLTerm} in openSprints()`
    };
};
const $59496077a2cce3b6$var$buildJQLFromQuickFilters = (quickFilters, { quickFilterToJQLMap: quickFilterToJQLMap = $59496077a2cce3b6$var$quickFilterToJQLMapOld } = {})=>{
    const jqlClauses = Object.entries(quickFilters).map(// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ readonly ASSIGNED_TO_ME: "assignee = currentUser()"; readonly DONE: "StatusCategory = 'Complete'"; readonly DUE_THIS_WEEK: "duedate <= endOfWeek() and duedate > startOfWeek()"; }'.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ([key, isEnabled])=>isEnabled === true && quickFilterToJQLMap[key]);
    const enabledFilters = jqlClauses.filter((jql)=>jql);
    return enabledFilters.join(' AND ') || null;
};
const $59496077a2cce3b6$export$9294471da4d3c33f = {
    ASSIGNED_TO_ME: false,
    DONE: false,
    DUE_THIS_WEEK: false,
    ACTIVE_SPRINTS: false
};
const $59496077a2cce3b6$export$9692fc1a2fd983f5 = (jql, { quickFilterToJQLMap: quickFilterToJQLMap = $59496077a2cce3b6$var$quickFilterToJQLMapOld } = {})=>{
    const quickFilters = {
        ...$59496077a2cce3b6$export$9294471da4d3c33f
    };
    if (!jql) return quickFilters;
    if (jql.includes(quickFilterToJQLMap.ASSIGNED_TO_ME)) quickFilters.ASSIGNED_TO_ME = true;
    if (jql.includes(quickFilterToJQLMap.DONE)) quickFilters.DONE = true;
    if (jql.includes(quickFilterToJQLMap.DUE_THIS_WEEK)) quickFilters.DUE_THIS_WEEK = true;
    if (quickFilterToJQLMap.ACTIVE_SPRINTS && jql.includes(quickFilterToJQLMap.ACTIVE_SPRINTS)) quickFilters.ACTIVE_SPRINTS = true;
    return quickFilters;
};
const $59496077a2cce3b6$var$useSprintFieldJQLTerm = ()=>{
    const { data: fields } = (0, $g4ZHz.useFieldsResource)();
    return (0, $5uXOq.useMemo)(()=>{
        if (fields == null) return undefined;
        const sprintField = fields.find((field)=>field.type === (0, $5fc53.SPRINT_TYPE));
        return sprintField != null ? sprintField.jqlTerm : undefined;
    }, [
        fields
    ]);
};
const $59496077a2cce3b6$export$3dae1bb95b659fd4 = ()=>{
    const sprintFieldJQLTerm = $59496077a2cce3b6$var$useSprintFieldJQLTerm();
    const quickFilterToJQLMap = (0, $5uXOq.useMemo)(()=>$59496077a2cce3b6$export$808f76242d61e1a5(sprintFieldJQLTerm), [
        sprintFieldJQLTerm
    ]);
    const { jql: jql, saveJql: saveJql } = (0, $l4Ejo.useFiltersPreference)();
    const setQuickFilters = (0, $5uXOq.useCallback)((newQuickFilters)=>{
        if (newQuickFilters) {
            const newJql = $59496077a2cce3b6$var$buildJQLFromQuickFilters(newQuickFilters, {
                quickFilterToJQLMap: quickFilterToJQLMap
            });
            if (newJql == null) saveJql(undefined);
            else saveJql(newJql);
        } else saveJql(undefined);
    }, [
        quickFilterToJQLMap,
        saveJql
    ]);
    const quickFilters = (0, $5uXOq.useMemo)(()=>$59496077a2cce3b6$export$9692fc1a2fd983f5(jql, {
            quickFilterToJQLMap: quickFilterToJQLMap
        }), [
        jql,
        quickFilterToJQLMap
    ]);
    return {
        quickFilters: quickFilters,
        persistQuickFilters: setQuickFilters,
        quickFiltersJql: $59496077a2cce3b6$var$buildJQLFromQuickFilters(quickFilters, {
            quickFilterToJQLMap: quickFilterToJQLMap
        })
    };
};

});
parcelRegister("l4Ejo", function(module, exports) {

$parcel$export(module.exports, "InternalFiltersJqlProvider", () => $8a462d10017c11b6$export$db1e4f4070782197);
$parcel$export(module.exports, "useFiltersPreference", () => $8a462d10017c11b6$export$4eb37722e136bcfd);
$parcel$export(module.exports, "useFilters", () => $8a462d10017c11b6$export$973ca22476b0e05f);

var $5uXOq = parcelRequire("5uXOq");

var $1tESh = parcelRequire("1tESh");
const $8a462d10017c11b6$var$Context = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $8a462d10017c11b6$export$db1e4f4070782197 = ({ children: children, jql: jql, saveJql: saveJql })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8a462d10017c11b6$var$Context.Provider, {
        value: (0, $5uXOq.useMemo)(()=>({
                jql: jql,
                saveJql: saveJql
            }), [
            jql,
            saveJql
        ])
    }, children);
};
const $8a462d10017c11b6$export$4eb37722e136bcfd = ()=>{
    const context = (0, $5uXOq.useContext)($8a462d10017c11b6$var$Context);
    if (!context) throw new Error('useFiltersPreference must be used within a InternalFiltersJqlProvider');
    return context;
};
const $8a462d10017c11b6$export$973ca22476b0e05f = ()=>{
    const { jql: jql, saveJql: saveJql } = $8a462d10017c11b6$export$4eb37722e136bcfd();
    const setFilter = (0, $5uXOq.useCallback)((filters)=>{
        const serialisedJql = (0, $1tESh.serialiseJql)(filters);
        saveJql(serialisedJql !== '' ? serialisedJql : undefined);
    }, [
        saveJql
    ]);
    return {
        jql: jql,
        setFilter: setFilter
    };
};

});
parcelRegister("1tESh", function(module, exports) {

$parcel$export(module.exports, "serialiseJql", () => $1e9d101255159a24$export$e1718e1e441cb0f6);
$parcel$export(module.exports, "extractAnalyticsFilterDataFromJQL", () => $1e9d101255159a24$export$9ee6085825c9cbfa);

var $gccSB = parcelRequire("gccSB");

var $2nvJN = parcelRequire("2nvJN");

var $gwejS = parcelRequire("gwejS");

var $f9ece = parcelRequire("f9ece");

var $iEIQF = parcelRequire("iEIQF");
var $bzbto = parcelRequire("bzbto");
var $l0V05 = parcelRequire("l0V05");

var $7htvz = parcelRequire("7htvz");
const $1e9d101255159a24$var$START_DATE_JQL = 'Start date[Date]';
const $1e9d101255159a24$var$EMPTY = 'EMPTY';
const $1e9d101255159a24$var$getQuotedFieldName = (fieldName)=>`"${fieldName}"`;
const $1e9d101255159a24$var$getFieldNameForJqlRaw = (fieldName)=>{
    // custom fields are indexed by their ids and only work with JQL when referenced as such `cf[id]`.
    if (fieldName.indexOf('customfield_') === 0) {
        const customFieldId = fieldName.split('customfield_')[1];
        return `cf[${customFieldId}]`;
    }
    // date range jql will be formatted to e.g. "Start date[Date]" >= "2021-12-01" AND due < "2021-12-31"
    // the "to" fieldName for the date range will be transformed to "due" in the "serialiseJql" function
    // where "const toFieldName = fieldId === 'dateRange' ? 'due' : fieldName;"
    if (fieldName === 'dateRange') return $1e9d101255159a24$var$START_DATE_JQL;
    return fieldName;
};
const $1e9d101255159a24$var$getFieldNameForJql = (fieldName)=>$1e9d101255159a24$var$getQuotedFieldName($1e9d101255159a24$var$getFieldNameForJqlRaw(fieldName));
const $1e9d101255159a24$var$getFieldIdFromJql = (rawFieldName, getShouldConvertCustomField)=>{
    const fieldName = (0, (/*@__PURE__*/$parcel$interopDefault($2nvJN)))(rawFieldName, '"');
    const shouldConvertCustomField = getShouldConvertCustomField ? getShouldConvertCustomField(fieldName) : true;
    // `cf[id]` -> `customfield_${id}`.
    if (fieldName.indexOf('cf[') === 0 && shouldConvertCustomField) {
        const extraction = new RegExp(/cf\[(.+)\]/).exec(fieldName);
        if (!extraction) return fieldName;
        const fieldId = extraction[1];
        return `customfield_${fieldId}`;
    }
    const startDateJql = $1e9d101255159a24$var$START_DATE_JQL;
    // update this if we add a start date or due date filter
    if (fieldName === startDateJql || fieldName === 'due') return 'dateRange';
    return fieldName;
};
const $1e9d101255159a24$var$sanitizeWord = (word)=>word.replace(/(["\\])/g, '\\$1');
const $1e9d101255159a24$var$sanitizeWordOld = (word)=>word.replace(/'/g, "\\'");
const $1e9d101255159a24$export$e1718e1e441cb0f6 = (filters)=>{
    const jqlQuery = (0, $iEIQF.default).query();
    Object.entries(filters).filter(([, options])=>options != null && (Array.isArray(options) && options.length > 0 || !Array.isArray(options) && typeof options === 'object' && (options.value == null || !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(options.value)))).forEach(([fieldId, options])=>{
        const fieldName = $1e9d101255159a24$var$getFieldNameForJqlRaw(fieldId);
        if (!Array.isArray(options) && typeof options === 'object' && !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(options?.value)) {
            // one additional day will be added to jql 'to' date based on selected date, e.g. when due date is "2021-12-30"
            // date range jql will be formatted to e.g. "Start date[Date]" >= "2021-12-01" AND due < "2021-12-31"
            const toFieldName = fieldId === 'dateRange' ? 'due' : fieldName;
            if (options.value.to != null) {
                const toDate = (0, $f9ece.default)((0, $gwejS.default)(new Date(options.value.to), 1), 'UTC', 'yyyy-MM-dd');
                jqlQuery.appendClause((0, $iEIQF.default).terminalClause((0, $iEIQF.default).field(toFieldName), (0, $iEIQF.default).operator((0, $bzbto.OPERATOR_LT)), (0, $iEIQF.default).valueOperand(toDate)), (0, $3cef51f82b2cbe1d$export$6d6d48d210d3ca97));
            }
            if (options.value.from != null) jqlQuery.appendClause((0, $iEIQF.default).terminalClause((0, $iEIQF.default).field(fieldName), (0, $iEIQF.default).operator((0, $bzbto.OPERATOR_GT_EQUALS)), (0, $iEIQF.default).valueOperand(options.value.from)), (0, $3cef51f82b2cbe1d$export$6d6d48d210d3ca97));
            return;
        }
        if (Array.isArray(options)) {
            const operands = options.map((option)=>{
                if (option.isEmptyOption) return (0, $iEIQF.default).valueOperand((0, $49b29ef7baa2a152$export$1c46dca02aac24dd));
                if (option.value) // Currently, the AST does not sanatize all values correctly (no \ or JQL keywords), so we need to manually wrap in quotes
                // We can remove this once https://jplat.jira.atlassian.cloud/browse/EM-6563 is implemented
                return (0, $iEIQF.default).byText.valueOperand(`"${$1e9d101255159a24$var$sanitizeWord(option.value)}"`);
                return null;
            }).filter((operand)=>operand != null);
            if (operands.length === 1) jqlQuery.appendClause((0, $iEIQF.default).terminalClause((0, $iEIQF.default).field(fieldName), (0, $iEIQF.default).operator((0, $bzbto.OPERATOR_EQUALS)), operands[0]), (0, $3cef51f82b2cbe1d$export$6d6d48d210d3ca97));
            else if (operands.length > 1) jqlQuery.appendClause((0, $iEIQF.default).terminalClause((0, $iEIQF.default).field(fieldName), (0, $iEIQF.default).operator((0, $bzbto.OPERATOR_IN)), (0, $iEIQF.default).listOperand(operands)), (0, $3cef51f82b2cbe1d$export$6d6d48d210d3ca97));
        }
    });
    const jast = (0, $iEIQF.default).jast(jqlQuery);
    return (0, $l0V05.print)(jast, {
        operatorCase: 'upper',
        printWidth: null
    });
};
const $1e9d101255159a24$export$5bd6a523f48a18cd = (filters)=>{
    const pairs = Object.entries(filters).filter(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    ([, options])=>options != null && (Array.isArray(options) && options.length > 0 || !Array.isArray(options) && typeof options === 'object' && (options.value == null || !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(options.value)))) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .map(([fieldId, options])=>{
        const fieldName = $1e9d101255159a24$var$getFieldNameForJql(fieldId);
        if (!Array.isArray(options) && typeof options === 'object' && !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(options?.value)) {
            // one additional day will be added to jql 'to' date based on selected date, e.g. when due date is "2021-12-30"
            // date range jql will be formatted to e.g. "Start date[Date]" >= "2021-12-01" AND due < "2021-12-31"
            const toFieldName = fieldId === 'dateRange' ? $1e9d101255159a24$var$getQuotedFieldName('due') : fieldName;
            let toDate;
            if (options.value.to) toDate = (0, $f9ece.default)((0, $gwejS.default)(new Date(options.value.to), 1), 'UTC', 'yyyy-MM-dd');
            else toDate = options.value.to;
            if (options.value.from != null && options.value.to != null) return `${fieldName} >= ${options.value.from} AND ${toFieldName} < ${toDate}`;
            if (options.value.from != null) return `${fieldName} >= ${options.value.from}`;
            return `${toFieldName} < ${toDate}`;
        }
        if (Array.isArray(options)) {
            const values = options.map((option)=>// make sure we don't wrap EMPTY with quotation marks
                option.value === (0, $7htvz.EMPTY_FILTER_VALUE) ? $1e9d101255159a24$var$EMPTY : `'${$1e9d101255159a24$var$sanitizeWordOld(option.value)}'`).join(',');
            if (options.length > 1) return `${fieldName} in (${values})`;
            if (options.length === 1) return `${fieldName} = ${values}`;
        }
        return null;
    });
    return pairs.join(' AND ');
};
const $1e9d101255159a24$var$extractField = (statement)=>{
    let fieldId;
    const dateOperatorRegex = />=|</;
    if (dateOperatorRegex.test(statement)) {
        const operator = statement.includes('>=') ? ' >= ' : ' < ';
        [fieldId] = statement.split(operator);
    }
    if (statement.includes(' = ')) [fieldId] = statement.split(/ = /);
    if (statement.includes(' in ')) [fieldId] = statement.split(' in ');
    if (fieldId) return $1e9d101255159a24$var$getFieldIdFromJql(fieldId);
};
const $1e9d101255159a24$export$9ee6085825c9cbfa = (jql)=>{
    if (!jql) return {};
    return jql.split(/ AND | OR /).map($1e9d101255159a24$var$extractField).reduce((acc, curr)=>{
        if (curr) acc[curr] = true;
        return acc;
    }, {});
};

});
parcelRegister("2nvJN", function(module, exports) {

var $kHBB0 = parcelRequire("kHBB0");

var $6wH7T = parcelRequire("6wH7T");

var $gvFfr = parcelRequire("gvFfr");

var $4TR1Q = parcelRequire("4TR1Q");

var $c2mKc = parcelRequire("c2mKc");

var $jx6Tp = parcelRequire("jx6Tp");

var $jJVtR = parcelRequire("jJVtR");
/**
 * Removes leading and trailing whitespace or specified characters from `string`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to trim.
 * @param {string} [chars=whitespace] The characters to trim.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {string} Returns the trimmed string.
 * @example
 *
 * _.trim('  abc  ');
 * // => 'abc'
 *
 * _.trim('-_-abc-_-', '_-');
 * // => 'abc'
 *
 * _.map(['  foo  ', '  bar  '], _.trim);
 * // => ['foo', 'bar']
 */ function $1bb6592c97235e03$var$trim(string, chars, guard) {
    string = $jJVtR(string);
    if (string && (guard || chars === undefined)) return $6wH7T(string);
    if (!string || !(chars = $kHBB0(chars))) return string;
    var strSymbols = $jx6Tp(string), chrSymbols = $jx6Tp(chars), start = $c2mKc(strSymbols, chrSymbols), end = $4TR1Q(strSymbols, chrSymbols) + 1;
    return $gvFfr(strSymbols, start, end).join('');
}
module.exports = $1bb6592c97235e03$var$trim;

});
parcelRegister("4TR1Q", function(module, exports) {

var $2wwA6 = parcelRequire("2wwA6");
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
 * that is not found in the character symbols.
 *
 * @private
 * @param {Array} strSymbols The string symbols to inspect.
 * @param {Array} chrSymbols The character symbols to find.
 * @returns {number} Returns the index of the last unmatched string symbol.
 */ function $39156edc40ecb497$var$charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;
    while(index-- && $2wwA6(chrSymbols, strSymbols[index], 0) > -1);
    return index;
}
module.exports = $39156edc40ecb497$var$charsEndIndex;

});

parcelRegister("c2mKc", function(module, exports) {

var $2wwA6 = parcelRequire("2wwA6");
/**
 * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
 * that is not found in the character symbols.
 *
 * @private
 * @param {Array} strSymbols The string symbols to inspect.
 * @param {Array} chrSymbols The character symbols to find.
 * @returns {number} Returns the index of the first unmatched string symbol.
 */ function $8c37507367fba30b$var$charsStartIndex(strSymbols, chrSymbols) {
    var index = -1, length = strSymbols.length;
    while(++index < length && $2wwA6(chrSymbols, strSymbols[index], 0) > -1);
    return index;
}
module.exports = $8c37507367fba30b$var$charsStartIndex;

});


const $3cef51f82b2cbe1d$export$6d6d48d210d3ca97 = 'and';
const $3cef51f82b2cbe1d$export$7b8f0a728d79a753 = 'or';

const $49b29ef7baa2a152$export$38accfc5a5d1c113 = 'value';
const $49b29ef7baa2a152$export$f6049126fd97001f = 'keyword';
const $49b29ef7baa2a152$export$19c7c729db381f9d = 'function';
const $49b29ef7baa2a152$export$fabec4aebba3f4df = 'list';
const $49b29ef7baa2a152$export$1c46dca02aac24dd = 'empty';





parcelRegister("2RV6Z", function(module, exports) {

$parcel$export(module.exports, "deserialiseJql", () => $42cbf7cea9b7c40a$export$214464255b766962);

var $3dHKF = parcelRequire("3dHKF");

var $2nvJN = parcelRequire("2nvJN");

var $pyK8a = parcelRequire("pyK8a");

var $f9ece = parcelRequire("f9ece");

var $bv7J5 = parcelRequire("bv7J5");
var $eK6AG = parcelRequire("eK6AG");
var $bzbto = parcelRequire("bzbto");

var $5fc53 = parcelRequire("5fc53");

var $gBF4Z = parcelRequire("gBF4Z");

var $7htvz = parcelRequire("7htvz");
const $42cbf7cea9b7c40a$var$START_DATE_JQL = 'Start date[Date]';
const $42cbf7cea9b7c40a$var$EMPTY = 'EMPTY';
// some filters should display options retrieved from the URL parameters even when they are not returned amongst the useFieldConfig field values
const $42cbf7cea9b7c40a$var$shouldIncludeUnknownOption = (filterField)=>{
    const allowedFieldTypes = new Set([
        (0, $5fc53.COMPONENTS_TYPE),
        (0, $5fc53.LABELS_TYPE),
        (0, $5fc53.PRIORITY_TYPE),
        (0, $5fc53.CATEGORY_TYPE),
        (0, $5fc53.PARENT_FIELD_TYPE)
    ]);
    return allowedFieldTypes.has(filterField?.type ?? '');
};
const $42cbf7cea9b7c40a$var$getFieldIdFromJql = (rawFieldName, getShouldConvertCustomField)=>{
    const fieldName = (0, (/*@__PURE__*/$parcel$interopDefault($2nvJN)))(rawFieldName, '"');
    const shouldConvertCustomField = getShouldConvertCustomField ? getShouldConvertCustomField(fieldName) : true;
    // `cf[id]` -> `customfield_${id}`.
    if (fieldName.indexOf('cf[') === 0 && shouldConvertCustomField) {
        const extraction = new RegExp(/cf\[(.+)\]/).exec(fieldName);
        if (!extraction) return fieldName;
        const fieldId = extraction[1];
        return `customfield_${fieldId}`;
    }
    const startDateJql = $42cbf7cea9b7c40a$var$START_DATE_JQL;
    // update this if we add a start date or due date filter
    if (fieldName === startDateJql || fieldName === 'due') return 'dateRange';
    return fieldName;
};
const $42cbf7cea9b7c40a$var$transformIntoOptions = async (list, field, resolver, filterField)=>{
    if (resolver && typeof resolver === 'function') return resolver(list);
    const allowUnknownOption = $42cbf7cea9b7c40a$var$shouldIncludeUnknownOption(filterField);
    return list.map((value)=>{
        if (field && !(0, $gBF4Z.isDateField)(field) && Array.isArray(field.options)) {
            const optionInField = field.options.find((option)=>{
                if ((option == null || option.value == null) && !option.isEmptyOption) return null;
                if (option.isEmptyOption) return value === $42cbf7cea9b7c40a$var$EMPTY;
                return option.value === value;
            });
            if (!optionInField && allowUnknownOption) return {
                value: value,
                label: value
            };
            return optionInField;
        }
        return undefined;
    }).filter((item)=>item != null && 'value' in item);
};
class $42cbf7cea9b7c40a$export$5299115fe71e8b39 extends (0, $bv7J5.AbstractJastVisitor) {
    constructor(fieldConfig, filterFields, resolvers){
        super(), this.getOption = (fieldName, items)=>$42cbf7cea9b7c40a$var$transformIntoOptions(items, this.fieldConfig[fieldName], this.resolvers[fieldName], this.filterFields.find((field)=>field.id === fieldName)), this.visitCompoundClause = async (compoundClause)=>{
            const clauseMap = {};
            const operator = compoundClause.operator.value;
            if (operator === (0, $3cef51f82b2cbe1d$export$6d6d48d210d3ca97)) {
                const clausePromises = await Promise.all(compoundClause.clauses.map((clause)=>clause.accept(this)));
                return clausePromises.reduce((result, clause)=>this.aggregateResultSync(clause, result), clauseMap);
            }
            throw new Error(`JQL contains invalid operator between clauses: ${operator}`);
        }, this.parseDateOperand = (operator, operand)=>{
            if (operand?.operandType === (0, $49b29ef7baa2a152$export$38accfc5a5d1c113)) {
                let date = (0, $f9ece.default)(new Date(operand.value), 'UTC', 'yyyy-MM-dd');
                if (operator.value === (0, $bzbto.OPERATOR_LT)) date = (0, $f9ece.default)((0, $pyK8a.default)(new Date(operand.value), 1), 'UTC', 'yyyy-MM-dd');
                const dateType = operator.value === (0, $bzbto.OPERATOR_LT) ? 'to' : 'from';
                return {
                    value: {
                        [dateType]: date
                    }
                };
            }
            throw new Error(`JQL cannot parse date operand type: ${operand.operandType}`);
        }, this.parseSelectOperand = async (fieldName, operand)=>{
            if (operand?.operandType === (0, $49b29ef7baa2a152$export$fabec4aebba3f4df)) {
                const optionPromises = operand.values.flatMap((value)=>this.parseSelectOperand(fieldName, value));
                return (await Promise.all(optionPromises)).flatMap((option)=>option);
            }
            if (operand?.operandType === (0, $49b29ef7baa2a152$export$38accfc5a5d1c113)) return this.getOption(fieldName, [
                operand.value
            ]);
            if (operand?.operandType === (0, $49b29ef7baa2a152$export$f6049126fd97001f)) return [
                {
                    isEmptyOption: true,
                    value: (0, $7htvz.EMPTY_FILTER_VALUE),
                    label: ''
                }
            ];
            throw new Error(`JQL cannot parse select operand type: ${operand.operandType}`);
        }, this.visitTerminalClause = async (terminalClause)=>{
            const { field: field, operand: operand, operator: operator } = terminalClause;
            if (!operand || !operator) return Promise.resolve({});
            const getShouldConvertCustomField = (fieldName)=>// should convert cf[] -> customfield_ if it's not a field from version 2
                !(this.fieldConfig[fieldName] && this.fieldConfig[fieldName].fieldConfigVersion === 2);
            const fieldName = $42cbf7cea9b7c40a$var$getFieldIdFromJql(field.value, getShouldConvertCustomField);
            if (!Object.keys(this.fieldConfig).includes(fieldName)) throw new Error(`JQL contains unsupported fields: ${fieldName}`);
            let value = [];
            if (operator.value === (0, $bzbto.OPERATOR_GT_EQUALS) || operator.value === (0, $bzbto.OPERATOR_LT)) value = this.parseDateOperand(operator, operand);
            else if (operator.value === (0, $bzbto.OPERATOR_EQUALS) || operator.value === (0, $bzbto.OPERATOR_IN)) value = await this.parseSelectOperand(fieldName, operand);
            else throw new Error(`JQL contains unsupported operator in terminal clause: ${operator.value}`);
            return {
                [fieldName]: value
            };
        };
        this.fieldConfig = fieldConfig;
        this.filterFields = filterFields;
        this.resolvers = resolvers;
    }
    visitNotClause() {
        throw new Error('JQL contains invalid clause: NOT');
    }
    defaultResult() {
        return Promise.resolve({});
    }
    /**
	 * @param aggregate new ClauseMap to add into nextResult
	 * @param nextResult ClauseMap with previous results
	 * @returns ClauseMap with the merged results adding the aggregate at the end
	 */ async aggregateResult(aggregate, nextResult) {
        // First parameter is the object where we want to add the values and the second the new values to merge into the first object.
        return (0, (/*@__PURE__*/$parcel$interopDefault($3dHKF)))(await nextResult, await aggregate, (destValue, srcValue)=>{
            if (Array.isArray(srcValue)) return srcValue.concat(destValue ?? []);
            return undefined;
        });
    }
    aggregateResultSync(aggregate, nextResult) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($3dHKF)))(nextResult, aggregate, (destValue, srcValue)=>{
            if (Array.isArray(srcValue)) return srcValue.concat(destValue ?? []);
            return undefined;
        });
    }
}
const $42cbf7cea9b7c40a$export$214464255b766962 = async (jql, fieldConfig, filterFields, resolvers)=>{
    // Create the syntax tree for the filters JQL
    const builder = new (0, $eK6AG.JastBuilder)();
    const jast = builder.build(jql);
    if (jast.query?.orderBy != null) throw new Error('JQL contains unsupported ORDER BY');
    // Parse the JQL AST into a FilterType object
    const parser = new $42cbf7cea9b7c40a$export$5299115fe71e8b39(fieldConfig, filterFields, resolvers);
    const parsedJql = await jast.query?.accept(parser);
    return parsedJql ?? {};
};

});


parcelRegister("33Toe", function(module, exports) {

$parcel$export(module.exports, "IssueCreateProvider", () => $16929302557484c9$export$a975cd9627cdf4b6);
$parcel$export(module.exports, "useCreateIssue", () => $16929302557484c9$export$8af2d18142c8506c);
$parcel$export(module.exports, "isOptimisticIssue", () => $16929302557484c9$export$8512029c7fc94e58);
$parcel$export(module.exports, "useIsHighlighted", () => $16929302557484c9$export$2ecca9d8a7f031af);

var $5MxQY = parcelRequire("5MxQY");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $dqDis = parcelRequire("dqDis");

var $cYlk7 = parcelRequire("cYlk7");

var $ja8d8 = parcelRequire("ja8d8");

var $ecPXN = parcelRequire("ecPXN");
class $16929302557484c9$var$IssueCreateJob {
    constructor(createParams){
        this.createParams = createParams;
        this.promise = new Promise((resolve, reject)=>{
            this.reject = reject;
            this.resolve = resolve;
        });
    }
}
const $16929302557484c9$var$IssueCreateContext = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $16929302557484c9$var$reducer = (state, action)=>{
    switch(action.type){
        case 'enqueue':
            return {
                ...state,
                jobQueue: [
                    ...state.jobQueue,
                    action.job
                ]
            };
        case 'start-job':
            return {
                ...state,
                runningJob: state.jobQueue[0],
                jobQueue: state.jobQueue.slice(1)
            };
        case 'end-job':
            return {
                ...state,
                runningJob: null
            };
        case 'highlight':
            return {
                ...state,
                highlightedIssues: new Set([
                    ...state.highlightedIssues,
                    action.issueId
                ])
            };
        case 'unhighlight':
            return {
                ...state,
                highlightedIssues: new Set([
                    ...state.highlightedIssues
                ].filter((id)=>id !== action.issueId))
            };
        case 'save-summary':
            return {
                ...state,
                summary: action.summary
            };
        default:
            return state;
    }
};
const $16929302557484c9$var$initialState = {
    jobQueue: [],
    runningJob: null,
    highlightedIssues: new Set(),
    summary: ''
};
const $16929302557484c9$export$a975cd9627cdf4b6 = ({ onCreateIssue: onCreateIssue, onRefetchIssue: onRefetchIssue, ignoreFiltersContext: ignoreFiltersContext = false, queryFragment: queryFragment, children: children })=>{
    const { data: { user: user } } = (0, $cYlk7.useCurrentUser)();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const currentUser = user;
    // optimistic issue ids are negative numbers to distinguish them from real issue ids
    const nextIssueId = (0, $5uXOq.useRef)(-1);
    const [{ jobQueue: jobQueue, runningJob: runningJob, highlightedIssues: highlightedIssues, summary: summary }, dispatch] = (0, $5uXOq.useReducer)($16929302557484c9$var$reducer, $16929302557484c9$var$initialState);
    const data = (0, $8Uumt.useFragment)((0, $5MxQY.default), queryFragment);
    const rankFieldId = data.jira.rankField?.fieldId ?? null;
    const createIssueController = (0, $ja8d8.useCreateIssue)(onCreateIssue, onRefetchIssue);
    const highlightIssue = (0, $5uXOq.useCallback)((issueId)=>dispatch({
            type: 'highlight',
            issueId: issueId
        }), []);
    const unhighlightIssue = (0, $5uXOq.useCallback)((issueId)=>setTimeout(()=>{
            dispatch({
                type: 'unhighlight',
                issueId: issueId
            });
        }, 2000), []);
    const createIssue = (0, $5uXOq.useCallback)((createParams)=>{
        const job = new $16929302557484c9$var$IssueCreateJob(createParams);
        dispatch({
            type: 'enqueue',
            job: job
        });
        let rank;
        if (createParams.input.rankAfter) rank = (0, $dqDis.getNextRank)(createParams.input.rankAfter.rank);
        else if (createParams.input.rankBefore) rank = (0, $dqDis.getPreviousRank)(createParams.input.rankBefore.rank);
        const reporter = {
            accountId: currentUser.accountId,
            avatarUrl: currentUser.avatarUrls['48x48'],
            displayName: currentUser.displayName
        };
        const optimisticIssuePayload = {
            issueId: nextIssueId.current--,
            rank: rank,
            reporter: reporter,
            ...createParams.input
        };
        return {
            optimisticIssuePayload: optimisticIssuePayload,
            promise: job.promise
        };
    }, [
        currentUser
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // dequeue and run the next job if there is one and there is no running job
        if (jobQueue.length > 0 && !runningJob) {
            const job = jobQueue[0];
            dispatch({
                type: 'start-job'
            });
            createIssueController({
                createParams: job.createParams,
                highlightIssue: highlightIssue,
                unhighlightIssue: unhighlightIssue,
                ignoreFiltersContext: ignoreFiltersContext,
                rankFieldId: rankFieldId
            }).then(job.resolve).catch(job.reject).finally(()=>dispatch({
                    type: 'end-job'
                }));
        }
    }, [
        createIssueController,
        highlightedIssues,
        jobQueue,
        runningJob,
        highlightIssue,
        unhighlightIssue,
        ignoreFiltersContext,
        rankFieldId
    ]);
    (0, $ecPXN.useCreateParamHandler)(rankFieldId);
    const saveSummary = (0, $5uXOq.useCallback)((newSummary)=>{
        dispatch({
            type: 'save-summary',
            summary: newSummary
        });
    }, []);
    const value = (0, $5uXOq.useMemo)(()=>({
            createIssue: createIssue,
            highlightedIssues: highlightedIssues,
            summary: summary,
            saveSummary: saveSummary,
            rankFieldId: rankFieldId
        }), [
        createIssue,
        highlightedIssues,
        summary,
        saveSummary,
        rankFieldId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($16929302557484c9$var$IssueCreateContext.Provider, {
        value: value
    }, children);
};
const $16929302557484c9$export$8af2d18142c8506c = (onSubmit, onBlur)=>{
    const context = (0, $5uXOq.useContext)($16929302557484c9$var$IssueCreateContext);
    if (!context) throw new Error('useCreateIssue must be used within an IssueCreateProvider');
    const { createIssue: createIssue, summary: summary, saveSummary: saveSummary } = context;
    const summaryRef = (0, $5uXOq.useRef)(summary);
    const hasExitedWithoutUserAction = (0, $5uXOq.useRef)(true);
    const submit = (0, $5uXOq.useCallback)((createParams)=>{
        const result = createIssue(createParams);
        onSubmit(result);
        hasExitedWithoutUserAction.current = false;
        setTimeout(()=>{
            // reset the value as the form can stay open after submitting
            hasExitedWithoutUserAction.current = true;
        }, 100);
        return result;
    }, [
        createIssue,
        onSubmit
    ]);
    const blur = (0, $5uXOq.useCallback)((event)=>{
        onBlur?.(event);
        hasExitedWithoutUserAction.current = false;
    }, [
        onBlur
    ]);
    (0, $5uXOq.useEffect)(()=>()=>{
            // if the component has exited without the user blurring the form or submitting,
            // then save the summary value so it can be reapplied
            saveSummary(hasExitedWithoutUserAction.current ? summaryRef.current : '');
        }, [
        saveSummary
    ]);
    return {
        summaryRef: summaryRef,
        submit: submit,
        blur: blur
    };
};
const $16929302557484c9$export$8512029c7fc94e58 = (issueId)=>issueId < 0;
const $16929302557484c9$export$2ecca9d8a7f031af = ()=>{
    const context = (0, $5uXOq.useContext)($16929302557484c9$var$IssueCreateContext);
    if (!context) throw new Error('useIsHighlighted must be used within an IssueCreateProvider');
    const { highlightedIssues: highlightedIssues } = context;
    return (0, $5uXOq.useCallback)((issueId)=>$16929302557484c9$export$8512029c7fc94e58(issueId) || highlightedIssues.has(issueId), [
        highlightedIssues
    ]);
};

});
parcelRegister("5MxQY", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e535bc522f3f9e2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<585091df852ca82a8e22a918b7bea1b2>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $2e535bc522f3f9e2$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "cloudId"
        }
    ],
    "kind": "Fragment",
    "name": "IssueCreateProvider",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "JiraQuery",
                "kind": "LinkedField",
                "name": "jira",
                "plural": false,
                "selections": [
                    {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "cloudId",
                                "variableName": "cloudId"
                            }
                        ],
                        "concreteType": "JiraJqlFieldWithAliases",
                        "kind": "LinkedField",
                        "name": "rankField",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "fieldId"
                            }
                        ]
                    }
                ]
            },
            "action": "THROW",
            "path": "jira"
        }
    ],
    "type": "Query"
};
$2e535bc522f3f9e2$var$node.hash = "fea400f7b9138349b48b46b455b7d1db";
var $2e535bc522f3f9e2$export$2e2bcd8739ae039 = $2e535bc522f3f9e2$var$node;

});

parcelRegister("dqDis", function(module, exports) {

$parcel$export(module.exports, "getNextRank", () => $d36f563d8781dd11$export$5c16a8b7eebff4b8);
$parcel$export(module.exports, "getPreviousRank", () => $d36f563d8781dd11$export$e2047b3433d9f565);

var $daQYX = parcelRequire("daQYX");
const $d36f563d8781dd11$export$5c16a8b7eebff4b8 = (s)=>`${s}0`;
const $d36f563d8781dd11$export$e2047b3433d9f565 = (s)=>{
    const lastCharCode = s.charCodeAt(s.length - 1);
    const previousLastChar = String.fromCharCode(lastCharCode - 1);
    if (lastCharCode === 0) return $d36f563d8781dd11$export$e2047b3433d9f565(s.substring(0, s.length - 1));
    return `${s.substring(0, s.length - 1)}${previousLastChar}99`;
};
const $d36f563d8781dd11$export$2fbfa09555819a54 = ()=>{
    const { permissions: permissions } = (0, $daQYX.useProject)();
    return permissions.scheduleIssues && permissions.editIssues;
};

});

parcelRegister("ja8d8", function(module, exports) {

$parcel$export(module.exports, "useCreateIssue", () => $50507bfa414423fc$export$8af2d18142c8506c);

var $5uXOq = parcelRequire("5uXOq");

var $1T2vX = parcelRequire("1T2vX");

var $l9KLJ = parcelRequire("l9KLJ");

var $jcw0u = parcelRequire("jcw0u");

var $6s1PB = parcelRequire("6s1PB");

var $jJZqs = parcelRequire("jJZqs");

var $pa9q9 = parcelRequire("pa9q9");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $kpiI3 = parcelRequire("kpiI3");

var $8roPX = parcelRequire("8roPX");

var $lVeTj = parcelRequire("lVeTj");

var $fb3JB = parcelRequire("fb3JB");
const $50507bfa414423fc$export$8edbb6d449614942 = ()=>{
    const workflows = (0, $l9KLJ.useWorkflows)();
    return (0, $5uXOq.useCallback)((createInput)=>{
        if (createInput.status && workflows != null) {
            // find the workflow for the input issue type
            const workflow = workflows.find((w)=>w.issueTypes.some((it)=>it.issueTypeId === createInput.issueType.id));
            // find the first transition to the input status that is initial, or global but not conditional
            const { statusId: statusId } = createInput.status;
            const transition = workflow?.transitions.find((t)=>t.to.statusId === statusId && (t.isInitial || t.isGlobal && !t.isConditional));
            return transition?.transitionId;
        }
    }, [
        workflows
    ]);
};
const $50507bfa414423fc$export$8af2d18142c8506c = (onCreateIssue, onRefetchIssue)=>{
    const showCreateSuccessFlag = (0, $lVeTj.useShowCreateSuccessFlag)();
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const { typesWithFields: typesWithFields } = (0, $1T2vX.useIssueTypesAndFields)({
        issueOperation: 'CREATE'
    });
    const getTransitionId = $50507bfa414423fc$export$8edbb6d449614942();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const showCreateIssueDialog = (0, $8roPX.useCreateIssueDialog)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    return (0, $5uXOq.useCallback)(async ({ createParams: createParams, highlightIssue: highlightIssue, unhighlightIssue: unhighlightIssue, ignoreFiltersContext: ignoreFiltersContext, rankFieldId: rankFieldId })=>{
        const transitionId = getTransitionId(createParams.input);
        const issueTypeName = createParams.input.issueType.name;
        try {
            if (!(0, $kpiI3.hasAllRequiredFields)({
                issueType: typesWithFields.find(({ issueType: issueType })=>issueType.id === createParams.input.issueType.id),
                createInput: createParams.input
            })) throw new (0, $jJZqs.ValidationError)('Missing required fields');
            const response = await onCreateIssue(createParams, {
                transitionId: transitionId
            });
            highlightIssue(response.itemIdentifiers.issueId);
            if (createParams.showSuccessFlag) showCreateSuccessFlag(response.itemIdentifiers.issueKey, issueTypeName);
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'issue created', String(response.itemIdentifiers.issueId), {
                location: createParams.location,
                ...(0, $4R6GH.fg)('add-fields-attributes-to-issue-create') && {
                    fields: {
                        hasAssignee: createParams?.input?.assignee != null,
                        hasDueDate: createParams?.input?.dueDate != null
                    }
                },
                ...createParams.timeMsSinceFocus && (0, $4R6GH.fg)('jira_list_view_inline_create_form_focus_time') ? {
                    timeMsSinceFocus: createParams.timeMsSinceFocus
                } : {}
            });
            unhighlightIssue(response.itemIdentifiers.issueId);
            return response.item;
        } catch (error) {
            let finalError = error;
            try {
                if (error instanceof (0, $jJZqs.ValidationError)) {
                    const { issueId: issueId, issueKey: issueKey } = await showCreateIssueDialog(createParams.input, rankFieldId, {
                        transitionId: transitionId
                    });
                    highlightIssue(issueId);
                    const issue = await onRefetchIssue(issueId, createParams.fieldIdsToReturn, !ignoreFiltersContext);
                    if (createParams.showSuccessFlag) showCreateSuccessFlag(issueKey, issueTypeName);
                    unhighlightIssue(issueId);
                    return issue;
                }
                if (error instanceof Error) (0, $jcw0u.default)({
                    meta: {
                        id: 'JWMCreateIssueInline',
                        packageName: 'jiraBusinessIssueCreate',
                        teamName: 'deliveroo'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
            } catch (refetchError) {
                finalError = refetchError;
            }
            if (finalError instanceof (0, $8roPX.CancelledError)) return null;
            const getTitle = ()=>{
                if ((0, $6s1PB.expVal)('jira-itr-work-type-exp-1', 'isEnabled', false)) return (0, $fb3JB.default).errorFlagTitleIssueTerminologyRefreshM4;
                if ((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false)) return (0, $fb3JB.default).errorFlagTitleIssueTermRefresh;
                return (0, $fb3JB.default).errorFlagTitle;
            };
            showFlag({
                type: 'error',
                title: formatMessage(getTitle(), {
                    workType: issueTypeName
                }),
                description: formatMessage((0, $fb3JB.default).errorFlagDescription),
                messageId: 'business-issue-create.controllers.create-issue.show-flag.error',
                messageType: 'transactional'
            });
            throw finalError;
        }
    }, [
        getTransitionId,
        typesWithFields,
        onCreateIssue,
        createAnalyticsEvent,
        showCreateSuccessFlag,
        showFlag,
        formatMessage,
        showCreateIssueDialog,
        onRefetchIssue
    ]);
};

});
parcelRegister("l9KLJ", function(module, exports) {

$parcel$export(module.exports, "WorkflowsProvider", () => $a3eac8b2a2bf7ce6$export$80a1d3130ff3ec75);
$parcel$export(module.exports, "useWorkflows", () => $a3eac8b2a2bf7ce6$export$437f9bd807b88beb);

var $5uXOq = parcelRequire("5uXOq");

var $7HGHK = parcelRequire("7HGHK");
var $pa9q9 = parcelRequire("pa9q9");

var $6ZYlM = parcelRequire("6ZYlM");

var $lDVEA = parcelRequire("lDVEA");
const $a3eac8b2a2bf7ce6$var$FETCH_WORKFLOW_FLAG_ID = (0, $7HGHK.toFlagId)('fetch-board-error-flag');
const $a3eac8b2a2bf7ce6$var$WorkflowsContext = /*#__PURE__*/ (0, $5uXOq.createContext)(undefined);
const $a3eac8b2a2bf7ce6$export$80a1d3130ff3ec75 = ({ children: children, enabled: enabled = true, workflows: workflows })=>{
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const { fetch: fetch, data: data, error: error } = (0, $6ZYlM.useFetchWorkflows)();
    (0, $5uXOq.useEffect)(()=>{
        if (enabled && workflows == null) fetch();
    }, [
        enabled,
        fetch,
        workflows
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (error) showFlag({
            id: $a3eac8b2a2bf7ce6$var$FETCH_WORKFLOW_FLAG_ID,
            type: 'error',
            title: (0, $lDVEA.default).workflowsErrorTitle,
            description: (0, $lDVEA.default).workflowsErrorDescription,
            messageId: 'business-workflows.controllers.workflows-context.show-flag.error',
            messageType: 'transactional'
        });
    }, [
        error,
        showFlag
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a3eac8b2a2bf7ce6$var$WorkflowsContext.Provider, {
        value: workflows ?? data
    }, children);
};
const $a3eac8b2a2bf7ce6$export$437f9bd807b88beb = ()=>(0, $5uXOq.useContext)($a3eac8b2a2bf7ce6$var$WorkflowsContext);

});
parcelRegister("6ZYlM", function(module, exports) {

$parcel$export(module.exports, "useFetchWorkflows", () => $8896012bd25091f7$export$41ba56ef14d1b9b1);
/* eslint-disable @typescript-eslint/no-non-null-assertion */ 
var $5uXOq = parcelRequire("5uXOq");

var $5tTFS = parcelRequire("5tTFS");

var $daQYX = parcelRequire("daQYX");

var $jcw0u = parcelRequire("jcw0u");

var $6V9lc = parcelRequire("6V9lc");
const $8896012bd25091f7$export$41ba56ef14d1b9b1 = ()=>{
    const project = (0, $daQYX.useProject)();
    const [fetch, { data: data, loading: loading, error: error, refetch: refetch, called: called }] = (0, $5tTFS.useLazyQuery)((0, $6V9lc.WORKFLOWS_QUERY), {
        variables: {
            projectId: project.id,
            first: 100
        },
        onError: (apolloError)=>{
            (0, $jcw0u.default)({
                meta: {
                    id: 'jwmFetchWorkflows',
                    packageName: 'jiraBusinessWorkflows',
                    teamName: 'wanjel'
                },
                attributes: {
                    message: 'Failed to fetch workflows'
                },
                error: apolloError,
                sendToPrivacyUnsafeSplunk: true
            });
        }
    });
    const workflowsDetails = (0, $5uXOq.useMemo)(()=>data?.jwmWorkflowWithIssueTypes?.edges?.map((edge)=>{
            const { workflow: workflow, issueTypes: issueTypes } = edge?.node || {};
            return {
                workflowId: workflow.workflowId,
                name: workflow?.name ?? undefined,
                transitions: workflow.transitions.edges.map((transitionEdge)=>({
                        transitionId: transitionEdge.node.transitionId,
                        name: transitionEdge.node.name ?? undefined,
                        isInitial: transitionEdge.node.isInitial,
                        isGlobal: transitionEdge.node.isGlobal,
                        isConditional: transitionEdge.node.isConditional,
                        to: {
                            statusId: transitionEdge.node.to.statusId
                        }
                    })),
                issueTypes: issueTypes.edges.map((issueTypeEdge)=>({
                        issueTypeId: issueTypeEdge.node.issueTypeId,
                        name: issueTypeEdge.node.name,
                        avatarUrl: issueTypeEdge.node.avatar.medium,
                        hierarchyLevel: issueTypeEdge.node.hierarchy.level
                    }))
            };
        }), [
        data
    ]);
    return {
        fetch: fetch,
        data: workflowsDetails,
        loading: loading,
        error: error,
        refetch: refetch,
        called: called
    };
};

});
parcelRegister("6V9lc", function(module, exports) {

$parcel$export(module.exports, "WORKFLOWS_QUERY", () => $ece8b64659728495$export$d54deb6c2b9695b7);

var $5cllN = parcelRequire("5cllN");
const $ece8b64659728495$export$d54deb6c2b9695b7 = (0, $5cllN.default)`
    query JWMWorkflowWithIssueTypes($projectId: Long!, $filter: JWMWorkflowWithIssueTypesFilter, $first: Int, $after: String, $last: Int, $before: String) {
        jwmWorkflowWithIssueTypes(projectId: $projectId, filter: $filter, first: $first, after: $after, last: $last, before: $before) {
            edges {
                node {
                    workflow {
                        workflowId
                        name
                        transitions(first: $first) {
                            edges {
                                node {
                                    transitionId
                                    name
                                    isInitial
                                    isGlobal
                                    isConditional
                                    to {
                                        statusId
                                    }
                                }
                            }
                        }
                    }
                    issueTypes(first: $first) {
                        edges {
                            node {
                                issueTypeId
                                name
                                avatar {
                                  medium
                                }
                              	hierarchy {
                              	  level
                              	}
                            }
                        }
                    }
                }
            }
        }
    }
`;

});


parcelRegister("lDVEA", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3db26a0042253e3$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $a3db26a0042253e3$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    workflowsErrorTitle: {
        "id": "business-workflows.controllers.workflows-context.workflows-error-title",
        "defaultMessage": "Failed to load workflows details"
    },
    workflowsErrorDescription: {
        "id": "business-workflows.controllers.workflows-context.workflows-error-description",
        "defaultMessage": "We couldn't load your workflow details, try refreshing the page or try again later."
    }
});

});


parcelRegister("kpiI3", function(module, exports) {

$parcel$export(module.exports, "hasAllRequiredFields", () => $5d73fa9073989726$export$146976a1cbd99cd0);

var $hE5wF = parcelRequire("hE5wF");

var $5fc53 = parcelRequire("5fc53");
const $5d73fa9073989726$export$146976a1cbd99cd0 = ({ issueType: issueType, createInput: createInput })=>{
    if (!issueType) return false;
    return issueType.fields.every((field)=>{
        if (!field.fieldConfig?.isRequired) return true;
        if (!field.type && !field.aliasFieldId) return false;
        if (field.aliasFieldId && field.aliasFieldId === (0, $hE5wF.START_DATE_ALIAS_FIELD_ID)) return Boolean(createInput.startDate);
        if (field.aliasFieldId === (0, $hE5wF.STORY_POINTS_ALIAS_FIELD_ID)) return createInput.storyPoints != null;
        if (field.type) switch(field.type){
            case 0, $5fc53.ISSUE_TYPE:
            case 0, $5fc53.REPORTER_TYPE:
                return true;
            case 0, $5fc53.SUMMARY_TYPE:
                return Boolean(createInput.summary);
            case 0, $5fc53.PRIORITY_TYPE:
                return Boolean(createInput.priority);
            case 0, $5fc53.ASSIGNEE_TYPE:
                return Boolean(createInput.assignee);
            case 0, $5fc53.DUE_DATE_TYPE:
                return Boolean(createInput.dueDate);
            case 0, $5fc53.CATEGORY_TYPE:
                return Boolean(createInput.category);
            case 0, $5fc53.STORY_POINT_ESTIMATE_CF_TYPE:
                return createInput.storyPointEstimate != null;
            case 0, $5fc53.SPRINT_TYPE:
                return Boolean(createInput.sprint);
            default:
                break;
        }
        return false;
    });
};

});

parcelRegister("8roPX", function(module, exports) {

$parcel$export(module.exports, "CancelledError", () => $549ab3c244a8a20a$export$a8430ed4188f35a9);
$parcel$export(module.exports, "useCreateIssueDialog", () => $549ab3c244a8a20a$export$8254d39962ec7361);

var $5uXOq = parcelRequire("5uXOq");

var $1T2vX = parcelRequire("1T2vX");

var $5eGnF = parcelRequire("5eGnF");

var $9svjh = parcelRequire("9svjh");

var $hULKg = parcelRequire("hULKg");

var $5rzqz = parcelRequire("5rzqz");

var $3ZKGh = parcelRequire("3ZKGh");
class $549ab3c244a8a20a$export$a8430ed4188f35a9 extends Error {
}
const $549ab3c244a8a20a$export$8d1d8a0d2a7917ac = ()=>{
    const { typesWithFields: typesWithFields } = (0, $1T2vX.useIssueTypesAndFields)({
        issueOperation: 'CREATE'
    });
    return (0, $5uXOq.useCallback)((issueType, predicate)=>{
        if (!issueType) return undefined;
        const issueTypeWithFields = typesWithFields.find((typeWithFields)=>typeWithFields.issueType.id === issueType.id);
        return issueTypeWithFields?.fields.find(predicate);
    }, [
        typesWithFields
    ]);
};
const $549ab3c244a8a20a$export$8254d39962ec7361 = ()=>{
    const [, { openIssueCreateModal: openIssueCreateModal }] = (0, $5rzqz.useTriggerIssueCreateModal)();
    const { subscribe: subscribe } = (0, $9svjh.useGICLifeCycleEvents)();
    const getField = $549ab3c244a8a20a$export$8d1d8a0d2a7917ac();
    return (0, $5uXOq.useCallback)((createInput, rankFieldId, extraPayload)=>new Promise((resolve, reject)=>{
            const unsubscribe = subscribe((0, $5eGnF.GIC_LIFECYCLE_EVENTS).MODAL_KEEP_EDITING_EXISTING_ISSUE, ()=>{
                // the user cancelled editing
                onClose(null);
            });
            // resolve the promise once the GIC has been closed or reject it if cancelled
            const onClose = (data)=>{
                const result = data?.[0];
                if (result) resolve(result);
                else // adding a delay upon user cancelling because of a bug in the GIC's state management logic ICO-303
                setTimeout(()=>{
                    reject(new $549ab3c244a8a20a$export$a8430ed4188f35a9('User cancelled'));
                }, 100);
                unsubscribe();
            };
            const { payload: payload, submitApiData: submitApiData } = (0, $3ZKGh.buildGICPayload)({
                createInput: createInput,
                extraPayload: extraPayload,
                rankFieldId: rankFieldId,
                getField: getField
            });
            const isSubTaskCreationOpen = createInput.issueType?.hierarchyLevel === -1;
            openIssueCreateModal({
                id: 'jwm-create-issue-dialog',
                onClose: onClose,
                payload: payload,
                context: {
                    projectId: createInput.projectId,
                    submitApiData: submitApiData
                },
                isSubTaskCreationOpen: isSubTaskCreationOpen,
                triggerPointKey: (0, $hULKg.JWM_INLINE_CREATE),
                disableProjectDropdown: true,
                disableIssueTypeDropdown: Boolean(payload.issueType?.issueTypeId),
                disableCreationSuccessFlag: true,
                displayCreateAnotherIssueToggle: false,
                minimizableModalView: 'mini'
            });
        }), [
        getField,
        openIssueCreateModal,
        subscribe
    ]);
};

});
parcelRegister("5eGnF", function(module, exports) {

$parcel$export(module.exports, "GIC_LIFECYCLE_EVENTS", () => $700db8c378cd19d9$export$876003a5b887f37e);
const $700db8c378cd19d9$export$876003a5b887f37e = {
    MODAL_OPENED: 'MODAL_OPENED',
    MODAL_CLOSED: 'MODAL_CLOSED',
    MODAL_KEEP_EDITING_EXISTING_ISSUE: 'MODAL_KEEP_EDITING',
    MODAL_DISCARD_EXISTING_IN_PROGRESS_ISSUE: 'MODAL_DISCARD',
    MODAL_DISCARD_SUGGESTED_ISSUE: 'MODAL_DISCARD_SUGGESTED_ISSUE',
    MODAL_DISCARD_SUGGESTED_ISSUE_CHANGES: 'MODAL_DISCARD_SUGGESTED_ISSUE_CHANGES',
    MODAL_DISCARD_ALL_SUGGESTED_ISSUES: 'MODAL_DISCARD_ALL_SUGGESTED_ISSUES',
    CREATE_FORM_FIELD_CONFIG_UPDATE: 'CREATE_FORM_FIELD_CONFIG_UPDATE',
    CREATE_FORM_FIELD_VALUE_CHANGE: 'CREATE_FORM_FIELD_VALUE_CHANGE',
    ISSUE_CREATE_SUCCESS: 'ISSUE_CREATE_SUCCESS',
    PROJECT_FIELD_VALUE_CHANGE: 'PROJECT_FIELD_VALUE_CHANGE',
    ISSUE_TYPE_FIELD_VALUE_CHANGE: 'ISSUE_TYPE_FIELD_VALUE_CHANGE',
    RESET_FORM_FIELDS_FOR_CREATE_ANOTHER: 'RESET_FORM_FIELDS_FOR_CREATE_ANOTHER',
    USE_TRIGGER_ISSUE_CREATE_MODAL_STATE_CHANGE: 'USE_TRIGGER_ISSUE_CREATE_MODAL_STATE_CHANGE',
    STATUS_FIELD_STATE_CHANGE: 'STATUS_FIELD_STATE_CHANGE',
    CREATE_FORM_FIELD_BLUR: 'CREATE_FORM_FIELD_BLUR',
    CLASSIFICATION_LEVEL_FIELD_CHANGE: 'CLASSIFICATION_LEVEL_FIELD_CHANGE',
    FORM_CONTEXT_STATE_CHANGE: 'FORM_CONTEXT_STATE_CHANGE'
};

});

parcelRegister("9svjh", function(module, exports) {

$parcel$export(module.exports, "useGICLifeCycleEvents", () => $d9b2e43e4699b192$export$e3ff72f196296fcc);

var $1mrD8 = parcelRequire("1mrD8");
const $d9b2e43e4699b192$var$GICLifeCycleEventsService = new (0, $1mrD8.PubSubHub)();
const $d9b2e43e4699b192$export$e3ff72f196296fcc = ()=>({
        ...$d9b2e43e4699b192$var$GICLifeCycleEventsService
    });

});
parcelRegister("1mrD8", function(module, exports) {

$parcel$export(module.exports, "PubSubHub", () => $6e9a69c6f6f4fcfe$export$e3607828f8f2c01e);
class $6e9a69c6f6f4fcfe$export$e3607828f8f2c01e {
    constructor(){
        this.subscribers = {};
        this.subscribe = (event, subscriber)=>{
            let subs = this.subscribers[event];
            if (!subs) {
                subs = [];
                this.subscribers[event] = subs;
            }
            subs?.push(subscriber);
            return ()=>this.unsubscribe(event, subscriber);
        };
        this.unsubscribe = (event, subscriber)=>{
            const subs = this.subscribers[event];
            if (subs) this.subscribers[event] = subs.filter((subscription)=>subscription !== subscriber);
        };
        this.publish = (event, data)=>{
            const subs = this.subscribers[event];
            if (subs?.length) subs?.forEach((subscriber)=>subscriber(data));
        };
        this.clearAll = ()=>{
            this.subscribers = {};
        };
    }
}

});


parcelRegister("3ZKGh", function(module, exports) {

$parcel$export(module.exports, "buildGICPayload", () => $1e0041a78523c89b$export$eb18ffe6388f217a);
/* eslint-disable @typescript-eslint/no-non-null-assertion */ 
var $f9ece = parcelRequire("f9ece");

var $k7m40 = parcelRequire("k7m40");
var $el0er = parcelRequire("el0er");

var $4R6GH = parcelRequire("4R6GH");

var $hE5wF = parcelRequire("hE5wF");

var $5fc53 = parcelRequire("5fc53");
const $1e0041a78523c89b$var$assigneeFieldPredicate = (field)=>field.type === (0, $5fc53.ASSIGNEE_TYPE);
const $1e0041a78523c89b$var$categoryFieldPredicate = (field)=>field.type === (0, $5fc53.CATEGORY_TYPE);
const $1e0041a78523c89b$var$dueDateFieldPredicate = (field)=>field.type === (0, $5fc53.DUE_DATE_TYPE);
const $1e0041a78523c89b$var$priorityFieldPredicate = (field)=>field.type === (0, $5fc53.PRIORITY_TYPE);
const $1e0041a78523c89b$var$startDateFieldPredicate = (field)=>field.aliasFieldId === (0, $hE5wF.START_DATE_ALIAS_FIELD_ID);
const $1e0041a78523c89b$var$storyPointEstimateFieldPredicate = (field)=>field.type === (0, $5fc53.STORY_POINT_ESTIMATE_CF_TYPE);
const $1e0041a78523c89b$var$storyPointsFieldPredicate = (field)=>field.type === (0, $5fc53.NUMBER_CF_TYPE) && field.aliasFieldId === (0, $hE5wF.STORY_POINTS_ALIAS_FIELD_ID);
const $1e0041a78523c89b$var$sprintFieldPredicate = (field)=>field.type === (0, $5fc53.SPRINT_TYPE);
const $1e0041a78523c89b$export$eb18ffe6388f217a = ({ createInput: createInput, extraPayload: extraPayload, rankFieldId: rankFieldId, getField: getField })=>{
    const payload = {
        defaultValues: {
            singleLineTextFields: [],
            singleSelectUserPickerFields: [],
            numberFields: [],
            datePickerFields: []
        },
        project: {
            projectId: createInput.projectId
        }
    };
    const additionalFields = {};
    let transition;
    if (createInput.summary) payload.defaultValues.singleLineTextFields.push({
        fieldId: (0, $5fc53.SUMMARY_TYPE),
        text: createInput.summary
    });
    if (createInput.issueType) payload.issueType = {
        issueTypeId: createInput.issueType.id
    };
    if (createInput.dueDate && getField(createInput.issueType, $1e0041a78523c89b$var$dueDateFieldPredicate)) {
        const formattedDueDate = (0, $4R6GH.fg)('change-timezone-formatting-in-duedate-for-icc') ? (0, $k7m40.default)((0, $el0er.default)(createInput.dueDate), 'yyyy-MM-dd') : (0, $f9ece.default)(createInput.dueDate, 'UTC', 'yyyy-MM-dd');
        payload.defaultValues.datePickerFields.push({
            fieldId: (0, $5fc53.DUE_DATE_TYPE),
            date: {
                formattedDate: formattedDueDate
            }
        });
        additionalFields.duedate = formattedDueDate;
    }
    const startDateField = getField(createInput.issueType, $1e0041a78523c89b$var$startDateFieldPredicate);
    if (createInput.startDate && startDateField) {
        const formattedStartDate = (0, $f9ece.default)(createInput.startDate, 'UTC', 'yyyy-MM-dd');
        payload.defaultValues.datePickerFields.push({
            fieldId: startDateField.id,
            date: {
                formattedDate: formattedStartDate
            }
        });
        additionalFields[startDateField.id] = formattedStartDate;
    }
    if (createInput.assignee && getField(createInput.issueType, $1e0041a78523c89b$var$assigneeFieldPredicate)) {
        payload.defaultValues.singleSelectUserPickerFields.push({
            fieldId: (0, $5fc53.ASSIGNEE_TYPE),
            user: {
                accountId: createInput.assignee.accountId
            }
        });
        additionalFields[0, $5fc53.ASSIGNEE_TYPE] = {
            id: createInput.assignee.accountId
        };
    }
    if (createInput.priority && getField(createInput.issueType, $1e0041a78523c89b$var$priorityFieldPredicate)) {
        payload.defaultValues.priority = {
            priorityId: createInput.priority.priorityId
        };
        additionalFields[0, $5fc53.PRIORITY_TYPE] = {
            id: createInput.priority.priorityId
        };
    }
    const categoryField = getField(createInput.issueType, $1e0041a78523c89b$var$categoryFieldPredicate);
    if (createInput.category && categoryField) {
        payload.defaultValues.singleSelectFields = [
            {
                fieldId: categoryField.id,
                option: {
                    id: createInput.category.optionId,
                    optionId: createInput.category.optionId
                }
            }
        ];
        additionalFields[categoryField.id] = {
            id: createInput.category.optionId,
            value: createInput.category.value
        };
    }
    const storyPointEstimateField = getField(createInput.issueType, $1e0041a78523c89b$var$storyPointEstimateFieldPredicate);
    if (createInput.storyPointEstimate && storyPointEstimateField) {
        payload.defaultValues.numberFields.push({
            fieldId: storyPointEstimateField.id,
            value: createInput.storyPointEstimate
        });
        additionalFields[storyPointEstimateField.id] = {
            id: storyPointEstimateField.id,
            value: createInput.storyPointEstimate
        };
    }
    const storyPointsField = getField(createInput.issueType, $1e0041a78523c89b$var$storyPointsFieldPredicate);
    if (createInput.storyPoints && storyPointsField) {
        payload.defaultValues.numberFields.push({
            fieldId: storyPointsField.id,
            value: createInput.storyPoints
        });
        additionalFields[storyPointsField.id] = {
            id: storyPointsField.id,
            value: createInput.storyPoints
        };
    }
    const sprintField = getField(createInput.issueType, $1e0041a78523c89b$var$sprintFieldPredicate);
    if (createInput.sprint && sprintField) {
        payload.defaultValues.sprintsField = {
            fieldId: sprintField.id,
            sprints: [
                {
                    sprintId: createInput.sprint.id
                }
            ]
        };
        additionalFields[sprintField.id] = {
            id: sprintField.id,
            value: createInput.sprint.id
        };
    }
    if (createInput.parentIssueId) {
        payload.parentId = {
            parentId: createInput.parentIssueId
        };
        payload.defaultValues.parentField = {
            issueId: createInput.parentIssueId
        };
    }
    if (createInput.status && extraPayload?.transitionId) {
        payload.status = {
            statusId: createInput.status.statusId
        };
        transition = {
            id: extraPayload.transitionId
        };
    }
    if (rankFieldId && (createInput.rankAfter || createInput.rankBefore)) // rank is always passed as additional field
    additionalFields[rankFieldId] = {
        ...createInput.rankAfter ? {
            rankAfterIssue: createInput.rankAfter.issueId
        } : {},
        ...createInput.rankBefore ? {
            rankBeforeIssue: createInput.rankBefore.issueId
        } : {}
    };
    return {
        payload: payload,
        submitApiData: {
            additionalFields: additionalFields,
            transition: transition
        }
    };
};

});


parcelRegister("lVeTj", function(module, exports) {

$parcel$export(module.exports, "useShowCreateSuccessFlag", () => $374f26855338ec61$export$dfe953d11a91d407);

var $5uXOq = parcelRequire("5uXOq");

var $hE5wF = parcelRequire("hE5wF");

var $l0oHX = parcelRequire("l0oHX");

var $6s1PB = parcelRequire("6s1PB");

var $pa9q9 = parcelRequire("pa9q9");

var $koVbs = parcelRequire("koVbs");

var $ieDtd = parcelRequire("ieDtd");

var $64qgp = parcelRequire("64qgp");

var $7dMty = parcelRequire("7dMty");
const $374f26855338ec61$export$dfe953d11a91d407 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $pa9q9.useFlagsService)();
    const [, setSelectedIssueKey] = (0, $ieDtd.useQueryParam)((0, $hE5wF.SELECTED_ISSUE_PARAM));
    return (0, $5uXOq.useCallback)((issueKey, workType)=>{
        const flagId = `jwm-create-success-flag-${issueKey}`;
        const getTitle = ()=>{
            if ((0, $6s1PB.expVal)('jira-itr-work-type-exp-1', 'isEnabled', false)) return (0, $7dMty.default).createSuccessFlagTitleIssueTerminologyRefreshM4;
            if ((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false)) return (0, $7dMty.default).createSuccessFlagTitleIssueTermRefresh;
            return (0, $7dMty.default).createSuccessFlagTitle;
        };
        const getAction = ()=>{
            if (workType && (0, $64qgp.isWorkTypeAvgLength)(workType) && (0, $6s1PB.expVal)('jira-itr-work-type-exp-1', 'isEnabled', false)) return (0, $7dMty.default).viewIssueLinkTextIssueTerminologyRefreshM4;
            if ((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false)) return (0, $7dMty.default).viewIssueLinkTextIssueTermRefresh;
            return (0, $7dMty.default).viewIssueLinkText;
        };
        showFlag({
            id: flagId,
            isAutoDismiss: true,
            type: 'success',
            title: formatMessage(getTitle(), {
                issueKey: issueKey,
                workType: workType
            }),
            messageId: 'business-issue-create.controllers.show-create-success-flag.show-flag.success',
            messageType: 'transactional',
            actions: [
                {
                    content: [
                        getAction(),
                        {
                            workType: workType
                        }
                    ],
                    href: `/browse/${issueKey}`,
                    onClick: (event)=>{
                        if (event && !(0, $l0oHX.isModifiedEvent)(event)) {
                            setSelectedIssueKey(issueKey);
                            event.preventDefault();
                            event.stopPropagation();
                        }
                        dismissFlag(flagId);
                    }
                }
            ]
        });
    }, [
        dismissFlag,
        formatMessage,
        setSelectedIssueKey,
        showFlag
    ]);
};

});
parcelRegister("l0oHX", function(module, exports) {

$parcel$export(module.exports, "isModifiedEvent", () => $6c9cca471f547e7f$export$642c6f14f6d4bbd5);
const $6c9cca471f547e7f$export$642c6f14f6d4bbd5 = (event)=>Boolean(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);

});

parcelRegister("64qgp", function(module, exports) {

$parcel$export(module.exports, "isWorkTypeAvgLength", () => $75f802d4e52cf385$export$cc4247ae0afa23ac);
const $75f802d4e52cf385$var$WORK_TYPE_AVG_LENGTH = 30;
const $75f802d4e52cf385$export$cc4247ae0afa23ac = (workType)=>workType.length < $75f802d4e52cf385$var$WORK_TYPE_AVG_LENGTH;

});

parcelRegister("7dMty", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ecb7a23bce33f96$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $9ecb7a23bce33f96$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    createSuccessFlagTitle: {
        "id": "business-issue-create.controllers.show-create-success-flag.create-success-flag-title",
        "defaultMessage": "You've created issue \"{issueKey}\""
    },
    viewIssueLinkText: {
        "id": "business-issue-create.controllers.show-create-success-flag.view-issue-link-text",
        "defaultMessage": "View issue"
    },
    createSuccessFlagTitleIssueTermRefresh: {
        "id": "business-issue-create.controllers.show-create-success-flag.create-success-flag-title-issue-term-refresh",
        "defaultMessage": "You've created work item \"{issueKey}\""
    },
    createSuccessFlagTitleIssueTerminologyRefreshM4: {
        "id": "business-issue-create.controllers.show-create-success-flag.create-success-flag-title-issue-terminology-refresh-m4",
        "defaultMessage": "Created {workType} \"{issueKey}\""
    },
    viewIssueLinkTextIssueTermRefresh: {
        "id": "business-issue-create.controllers.show-create-success-flag.view-issue-link-text-issue-term-refresh",
        "defaultMessage": "View"
    },
    viewIssueLinkTextIssueTerminologyRefreshM4: {
        "id": "business-issue-create.controllers.show-create-success-flag.view-issue-link-text-issue-terminology-refresh-m4",
        "defaultMessage": "View {workType}"
    }
});

});


parcelRegister("fb3JB", function(module, exports) {

$parcel$export(module.exports, "default", () => $87c4612732d8fc8d$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $87c4612732d8fc8d$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorFlagTitle: {
        "id": "business-issue-create.controllers.create-issue.error-flag-title",
        "defaultMessage": "We weren't able to create an issue"
    },
    errorFlagDescription: {
        "id": "business-issue-create.controllers.create-issue.error-flag-description",
        "defaultMessage": "Refresh the page and try again."
    },
    errorFlagTitleIssueTermRefresh: {
        "id": "business-issue-create.controllers.create-issue.error-flag-title-issue-term-refresh",
        "defaultMessage": "We weren't able to create a work item"
    },
    errorFlagTitleIssueTerminologyRefreshM4: {
        "id": "business-issue-create.controllers.create-issue.error-flag-title-issue-terminology-refresh-m4",
        "defaultMessage": "We can't create the {workType}"
    }
});

});


parcelRegister("ecPXN", function(module, exports) {

$parcel$export(module.exports, "useCreateParamHandler", () => $eb6f03408afb5aea$export$294bf5b0ba86140);

var $5uXOq = parcelRequire("5uXOq");

var $hE5wF = parcelRequire("hE5wF");

var $daQYX = parcelRequire("daQYX");

var $ieDtd = parcelRequire("ieDtd");

var $8roPX = parcelRequire("8roPX");
const $eb6f03408afb5aea$export$294bf5b0ba86140 = (rankFieldId)=>{
    const [inlineCreateParam, setInlineCreateParam] = (0, $ieDtd.useQueryParam)((0, $hE5wF.INLINE_CREATE_PARAM));
    const showCreateIssueDialog = (0, $8roPX.useCreateIssueDialog)();
    const project = (0, $daQYX.useProject)();
    (0, $5uXOq.useEffect)(()=>{
        if (inlineCreateParam != null) {
            showCreateIssueDialog({
                projectId: String(project.id)
            }, rankFieldId).catch(()=>{
            // we don't care about the error in this scenario
            });
            setInlineCreateParam(undefined);
        }
    }, [
        inlineCreateParam,
        project,
        rankFieldId,
        setInlineCreateParam,
        showCreateIssueDialog
    ]);
};

});


parcelRegister("8xg9P", function(module, exports) {

$parcel$export(module.exports, "WorkflowActionsProvider", () => $58b4801e95090525$export$52383769590f1f7d);
$parcel$export(module.exports, "useIsWorkflowOperationInProgress", () => $58b4801e95090525$export$d8535539ef06db21);
$parcel$export(module.exports, "useWorkflowOperationStatusId", () => $58b4801e95090525$export$fcd0c43b34e1ab49);
$parcel$export(module.exports, "useStopWorkflowOperationInProgress", () => $58b4801e95090525$export$7d25f9f7a4197a33);
$parcel$export(module.exports, "useStartDeleteOperation", () => $58b4801e95090525$export$f125869614239ac);
$parcel$export(module.exports, "useStartAddOperation", () => $58b4801e95090525$export$a9547f77ff1cbe18);
$parcel$export(module.exports, "useStartRenameOperation", () => $58b4801e95090525$export$1763316459ec74d5);

var $5uXOq = parcelRequire("5uXOq");
const $58b4801e95090525$export$98ff4de2f070152d = {
    DELETING: 'deleting-status',
    ADDING: 'adding-status',
    RENAMING: 'renaming-status'
};
const $58b4801e95090525$var$WorkflowActionsContext = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $58b4801e95090525$export$52383769590f1f7d = ({ children: children })=>{
    const [operationInProgress, setOperationInProgress] = (0, $5uXOq.useState)(null);
    const [statusId, setStatusId] = (0, $5uXOq.useState)(null);
    const value = (0, $5uXOq.useMemo)(()=>({
            statusId: statusId,
            operationInProgress: operationInProgress,
            setStatusId: setStatusId,
            setOperationInProgress: setOperationInProgress
        }), [
        statusId,
        operationInProgress
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($58b4801e95090525$var$WorkflowActionsContext.Provider, {
        value: value
    }, children);
};
const $58b4801e95090525$export$1f652ba9a3f9f48e = ()=>{
    const context = (0, $5uXOq.useContext)($58b4801e95090525$var$WorkflowActionsContext);
    if (!context) throw new Error('WorkflowActionsContext must be used within a WorkflowActionsProvider');
    return context;
};
const $58b4801e95090525$export$d8535539ef06db21 = ()=>{
    const context = $58b4801e95090525$export$1f652ba9a3f9f48e();
    return context.operationInProgress != null;
};
const $58b4801e95090525$export$fcd0c43b34e1ab49 = ()=>{
    const context = $58b4801e95090525$export$1f652ba9a3f9f48e();
    return context.statusId;
};
const $58b4801e95090525$export$7d25f9f7a4197a33 = ()=>{
    const { setOperationInProgress: setOperationInProgress, setStatusId: setStatusId } = $58b4801e95090525$export$1f652ba9a3f9f48e();
    return (0, $5uXOq.useCallback)(()=>{
        setOperationInProgress(null);
        setStatusId(null);
    }, [
        setOperationInProgress,
        setStatusId
    ]);
};
const $58b4801e95090525$export$f125869614239ac = ()=>{
    const { setOperationInProgress: setOperationInProgress } = $58b4801e95090525$export$1f652ba9a3f9f48e();
    return (0, $5uXOq.useCallback)(()=>{
        setOperationInProgress($58b4801e95090525$export$98ff4de2f070152d.DELETING);
    }, [
        setOperationInProgress
    ]);
};
const $58b4801e95090525$export$a9547f77ff1cbe18 = ()=>{
    const { setOperationInProgress: setOperationInProgress, setStatusId: setStatusId } = $58b4801e95090525$export$1f652ba9a3f9f48e();
    return (0, $5uXOq.useCallback)((statusId)=>{
        setStatusId(statusId);
        setOperationInProgress($58b4801e95090525$export$98ff4de2f070152d.ADDING);
    }, [
        setOperationInProgress,
        setStatusId
    ]);
};
const $58b4801e95090525$export$1763316459ec74d5 = ()=>{
    const { setOperationInProgress: setOperationInProgress, setStatusId: setStatusId } = $58b4801e95090525$export$1f652ba9a3f9f48e();
    return (0, $5uXOq.useCallback)((statusId)=>{
        setStatusId(statusId);
        setOperationInProgress($58b4801e95090525$export$98ff4de2f070152d.RENAMING);
    }, [
        setStatusId,
        setOperationInProgress
    ]);
};

});

parcelRegister("95qxs", function(module, exports) {

$parcel$export(module.exports, "useMergeWorkflowsOnboarding", () => $8f8c2865c65a6f0d$export$43e70ada3f6380b4);

var $5uXOq = parcelRequire("5uXOq");

var $i205g = parcelRequire("i205g");

var $6s1PB = parcelRequire("6s1PB");
const $8f8c2865c65a6f0d$var$TTL_SEEN = 31536000000; // ~ 365 days
const $8f8c2865c65a6f0d$var$SEEN_ELIGIBLE_BOARD = 'multi-workflow-business-board';
const $8f8c2865c65a6f0d$var$SEEN_ONBOARDING = 'merge-board-workflows';
const $8f8c2865c65a6f0d$export$43e70ada3f6380b4 = ({ isEligible: isEligible })=>{
    const [isOnboardingVisible, setIsOnboardingVisible] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        if (!isEligible) return;
        if (false) return;
        (0, $i205g.getFlags)({
            [$8f8c2865c65a6f0d$var$SEEN_ELIGIBLE_BOARD]: {},
            [$8f8c2865c65a6f0d$var$SEEN_ONBOARDING]: {}
        }).then((seenItResponse)=>{
            if ((0, $6s1PB.expVal)('merge_board_workflows', 'enabled', false)) {
                const isEligibleBoardSeen = seenItResponse[$8f8c2865c65a6f0d$var$SEEN_ELIGIBLE_BOARD]?.status;
                const isOnboardingSeen = seenItResponse[$8f8c2865c65a6f0d$var$SEEN_ONBOARDING]?.status;
                // show the onboarding if the experiment is enabled and an eligible board has been seen
                if (isEligibleBoardSeen === true && isOnboardingSeen !== true) setIsOnboardingVisible(true);
            } else (0, $i205g.setFlag)($8f8c2865c65a6f0d$var$SEEN_ELIGIBLE_BOARD, $8f8c2865c65a6f0d$var$TTL_SEEN);
        }).catch(()=>{
        // Ignore errors
        });
    }, [
        isEligible
    ]);
    const markAsSeen = (0, $5uXOq.useCallback)(()=>{
        setIsOnboardingVisible(false);
        (0, $i205g.setFlag)($8f8c2865c65a6f0d$var$SEEN_ONBOARDING, $8f8c2865c65a6f0d$var$TTL_SEEN);
    }, []);
    return [
        isOnboardingVisible,
        markAsSeen
    ];
};

});
parcelRegister("i205g", function(module, exports) {

$parcel$export(module.exports, "getFlags", () => $2e5c55e74efea073$export$d5815430bcc75df0);
$parcel$export(module.exports, "setFlag", () => $2e5c55e74efea073$export$5e165df1e30a1331);

var $dPSWJ = parcelRequire("dPSWJ");

var $sLb2Q = parcelRequire("sLb2Q");

var $4Pf62 = parcelRequire("4Pf62");

var $1nokx = parcelRequire("1nokx");

var $7UyIQ = parcelRequire("7UyIQ");
const $2e5c55e74efea073$export$442e3330dfabd1f5 = 3600000; // 1 hour
const $2e5c55e74efea073$export$4d45fa66d41a8ca9 = 2592000000; // ~1 month
const $2e5c55e74efea073$export$d5815430bcc75df0 = async (request)=>{
    const { atlassianAccountId: atlassianAccountId, isAnonymous: isAnonymous } = (0, $4Pf62.getTenantContext_DEPRECATED_DO_NOT_USE)();
    const flagKeys = Object.keys(request);
    const retrieveFlagKeysLookup = (0, (/*@__PURE__*/$parcel$interopDefault($sLb2Q)))(flagKeys);
    if (!atlassianAccountId || isAnonymous) return (0, (/*@__PURE__*/$parcel$interopDefault($dPSWJ)))(retrieveFlagKeysLookup, ()=>({
            status: true,
            lastSeenDate: null
        }));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const flags = {};
    if (0, $7UyIQ.default) flagKeys.forEach((flagKey)=>{
        // @ts-expect-error - Object is possibly 'null'.
        const value = (0, $7UyIQ.default).get(flagKey);
        if (value) {
            delete retrieveFlagKeysLookup[flagKey];
            flags[flagKey] = value;
        }
    });
    const retrieveFlagKeys = Object.keys(retrieveFlagKeysLookup);
    if (retrieveFlagKeys.length > 0) Object.assign(flags, await (0, $1nokx.getFlags)(atlassianAccountId, retrieveFlagKeys));
    if (0, $7UyIQ.default) {
        const now = Date.now();
        retrieveFlagKeys.forEach((flagKey)=>{
            // Not sure whats going wrong here - but i assume `apiGetFlags` may not always return all `retrieveFalgKeys`
            // and so `flags[flagKey]` can be undefined - so we have to guard against it
            if (!flags[flagKey]) return;
            const { status: status } = flags[flagKey];
            const ttlNotSeen = request[flagKey].ttlNotSeen || $2e5c55e74efea073$export$442e3330dfabd1f5;
            const ttlSeen = request[flagKey].ttlSeen || $2e5c55e74efea073$export$4d45fa66d41a8ca9;
            // @ts-expect-error - TS2531: Object is possibly 'null'.
            (0, $7UyIQ.default).set(flagKey, flags[flagKey], now + (status ? ttlSeen : ttlNotSeen));
        });
    }
    return flags;
};
const $2e5c55e74efea073$export$5e165df1e30a1331 = async (flagKey, ttl = $2e5c55e74efea073$export$4d45fa66d41a8ca9)=>{
    const { atlassianAccountId: atlassianAccountId, isAnonymous: isAnonymous } = (0, $4Pf62.getTenantContext_DEPRECATED_DO_NOT_USE)();
    if (!atlassianAccountId || isAnonymous) return;
    if (0, $7UyIQ.default) {
        const value = (0, $7UyIQ.default).get(flagKey);
        if (value && value.status) return;
        const now = new Date();
        (0, $7UyIQ.default).set(flagKey, {
            status: true,
            lastSeenDate: now.toISOString()
        }, now.getTime() + ttl);
    }
    await (0, $1nokx.setFlag)(atlassianAccountId, flagKey);
};

});
parcelRegister("sLb2Q", function(module, exports) {

var $hsOo6 = parcelRequire("hsOo6");

var $dVL8S = parcelRequire("dVL8S");
/**
 * This method is like `_.fromPairs` except that it accepts two arrays,
 * one of property identifiers and one of corresponding values.
 *
 * @static
 * @memberOf _
 * @since 0.4.0
 * @category Array
 * @param {Array} [props=[]] The property identifiers.
 * @param {Array} [values=[]] The property values.
 * @returns {Object} Returns the new object.
 * @example
 *
 * _.zipObject(['a', 'b'], [1, 2]);
 * // => { 'a': 1, 'b': 2 }
 */ function $056736098c9e0b45$var$zipObject(props, values) {
    return $dVL8S(props || [], values || [], $hsOo6);
}
module.exports = $056736098c9e0b45$var$zipObject;

});
parcelRegister("dVL8S", function(module, exports) {
/**
 * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
 *
 * @private
 * @param {Array} props The property identifiers.
 * @param {Array} values The property values.
 * @param {Function} assignFunc The function to assign values.
 * @returns {Object} Returns the new object.
 */ function $a2452aab1e6d9d16$var$baseZipObject(props, values, assignFunc) {
    var index = -1, length = props.length, valsLength = values.length, result = {};
    while(++index < length){
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
    }
    return result;
}
module.exports = $a2452aab1e6d9d16$var$baseZipObject;

});


parcelRegister("1nokx", function(module, exports) {

$parcel$export(module.exports, "setFlag", () => $4c27c5726c27889e$export$5e165df1e30a1331);
$parcel$export(module.exports, "getFlags", () => $4c27c5726c27889e$export$d5815430bcc75df0);

var $dPSWJ = parcelRequire("dPSWJ");

var $jJZqs = parcelRequire("jJZqs");
const $4c27c5726c27889e$export$c1f083639d344e75 = 'https://have-i-seen-it.us-east-1.prod.public.atl-paas.net';
const $4c27c5726c27889e$export$5e165df1e30a1331 = (userKey, flagKey)=>{
    const data = {
        userKey: userKey,
        flagKey: flagKey
    };
    return fetch(`${$4c27c5726c27889e$export$c1f083639d344e75}/flag`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    }).then((response)=>{
        if (!response.ok) throw new (0, $jJZqs.default)(response.status, response.statusText);
        return undefined;
    });
};
const $4c27c5726c27889e$var$convertToDates = (response)=>(0, (/*@__PURE__*/$parcel$interopDefault($dPSWJ)))(response, ({ status: status, lastSeenDate: lastSeenDate })=>({
            status: status,
            lastSeenDate: lastSeenDate ? new Date(lastSeenDate) : null
        }));
const $4c27c5726c27889e$export$d5815430bcc75df0 = (userKey, flagKeys)=>{
    const params = new URLSearchParams();
    flagKeys.forEach((flagKey)=>params.append('flagKey', flagKey));
    params.append('userKey', userKey);
    return fetch(`${$4c27c5726c27889e$export$c1f083639d344e75}/flags?${params.toString()}`).then((response)=>{
        if (!response.ok) throw new (0, $jJZqs.default)(response.status, response.statusText);
        return response.json();
    }).then((response)=>$4c27c5726c27889e$var$convertToDates(response));
};

});

parcelRegister("7UyIQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $158da724691281b4$export$2e2bcd8739ae039);

var $eNf8a = parcelRequire("eNf8a");

var $4Pf62 = parcelRequire("4Pf62");

var $2YZCu = parcelRequire("2YZCu");
/**
 * Return an ExpirableStorage to be used with the "have i seen it" service.
 *
 * If the user is anonymous, return null.
 */ const $158da724691281b4$var$createStorage = ()=>{
    let storage = null;
    try {
        let context;
        try {
            context = (0, $4Pf62.getTenantContext_DEPRECATED_DO_NOT_USE)();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            return storage;
        }
        const { atlassianAccountId: atlassianAccountId } = context;
        if (atlassianAccountId) storage = (0, $eNf8a.createSessionExpirableStorageProvider)(`have-i-seen-it-${atlassianAccountId.replace(/:/g, '_')}`);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $2YZCu.default).safeErrorWithoutCustomerData('have-i-seen-it.storage', 'Failed to initialize storage.');
    }
    return storage;
};
var $158da724691281b4$export$2e2bcd8739ae039 = $158da724691281b4$var$createStorage();

});



parcelRegister("iZgee", function(module, exports) {

$parcel$export(module.exports, "IssueLinkingProvider", () => $535a9d8508c2d395$export$5d12661274f6fe9a);
$parcel$export(module.exports, "useIsLinkingEnabled", () => $535a9d8508c2d395$export$76fc5a1eecec5a35);

var $1bx0v = parcelRequire("1bx0v");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");
const $535a9d8508c2d395$var$Context = /*#__PURE__*/ (0, $5uXOq.createContext)(false);
const $535a9d8508c2d395$export$5d12661274f6fe9a = ({ children: children, queryFragment: queryFragment = null })=>{
    const data = (0, $8Uumt.useFragment)((0, $1bx0v.default), queryFragment);
    const issueLinksCount = data?.jira?.issueLinkTypes?.totalCount;
    const isLinkingEnabled = issueLinksCount != null && issueLinksCount > 0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($535a9d8508c2d395$var$Context.Provider, {
        value: isLinkingEnabled
    }, children);
};
const $535a9d8508c2d395$export$76fc5a1eecec5a35 = ()=>{
    const enabled = (0, $5uXOq.useContext)($535a9d8508c2d395$var$Context);
    if (enabled == null) throw new Error('useIsLinkingEnabled must be used within a IssueLinkingProvider');
    return enabled;
};

});
parcelRegister("1bx0v", function(module, exports) {

$parcel$export(module.exports, "default", () => $aaa1123a4362681b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<bdf446de78eb7ae0a8f92a3730eddb03>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $aaa1123a4362681b$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "cloudId"
        }
    ],
    "kind": "Fragment",
    "name": "IssueLinkingProvider",
    "selections": [
        {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        }
                    ],
                    "concreteType": "JiraIssueLinkTypeConnection",
                    "kind": "LinkedField",
                    "name": "issueLinkTypes",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "totalCount"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "Query"
};
$aaa1123a4362681b$var$node.hash = "eb941d2ee07647bf13cbdaa1e8d02999";
var $aaa1123a4362681b$export$2e2bcd8739ae039 = $aaa1123a4362681b$var$node;

});


parcelRegister("cvj5l", function(module, exports) {

$parcel$export(module.exports, "COLLAPSED_COLUMN_FIXED_WIDTH", () => $9487a479105b7a29$export$836c3f1e10326a68);
$parcel$export(module.exports, "COLUMN_FIXED_WIDTH", () => $9487a479105b7a29$export$fb45fce6dbb30982);
$parcel$export(module.exports, "COLUMN_CREATE_WIDTH", () => $9487a479105b7a29$export$a2e40c85b8340e83);
$parcel$export(module.exports, "GAP_BETWEEN_COLUMNS", () => $9487a479105b7a29$export$e4e941da6bdb3c31);
$parcel$export(module.exports, "CARD_DND_TYPE", () => $9487a479105b7a29$export$b05303cbde3e8c8c);
$parcel$export(module.exports, "COLUMN_DND_TYPE", () => $9487a479105b7a29$export$57d0ef745f304b91);
$parcel$export(module.exports, "EMPTY_FILTER_VALUE", () => $9487a479105b7a29$export$9ebaf9fe814731d3);
$parcel$export(module.exports, "VIEW_EXPERIENCE", () => $9487a479105b7a29$export$4a2289be55388ee6);
$parcel$export(module.exports, "NULL_GROUP_KEY", () => $9487a479105b7a29$export$947ad1d92ba954ec);
$parcel$export(module.exports, "OTHER", () => $9487a479105b7a29$export$d46a05f8561f868a);
$parcel$export(module.exports, "BOARD_FIELD_CATEGORY", () => $9487a479105b7a29$export$65fb8d4fddcb3db6);
$parcel$export(module.exports, "BOARD_FIELD_COMPONENTS", () => $9487a479105b7a29$export$c48edb33483d0062);
$parcel$export(module.exports, "BOARD_FIELD_CONFLUENCE_PAGES_COUNT", () => $9487a479105b7a29$export$5f51001602e4f639);
$parcel$export(module.exports, "BOARD_FIELD_DATE", () => $9487a479105b7a29$export$638505006ae9ba93);
$parcel$export(module.exports, "BOARD_FIELD_DATE_TIME", () => $9487a479105b7a29$export$465f5a7204a3dffc);
$parcel$export(module.exports, "BOARD_FIELD_FLOAT", () => $9487a479105b7a29$export$183b99b9ca85ddaa);
$parcel$export(module.exports, "BOARD_FIELD_ISSUE_LINKS_COUNT", () => $9487a479105b7a29$export$9b9930ab0e532c29);
$parcel$export(module.exports, "BOARD_FIELD_ISSUE_TYPE", () => $9487a479105b7a29$export$928ca8ef7db2c7ce);
$parcel$export(module.exports, "BOARD_FIELD_LABEL", () => $9487a479105b7a29$export$4709bd5a74152ae7);
$parcel$export(module.exports, "BOARD_FIELD_MULTI_USER", () => $9487a479105b7a29$export$2c7d7c1c0024ef92);
$parcel$export(module.exports, "BOARD_FIELD_PARENT", () => $9487a479105b7a29$export$d2edf947f6b61359);
$parcel$export(module.exports, "BOARD_FIELD_PRIORITY", () => $9487a479105b7a29$export$eb7c8ce7565d664);
$parcel$export(module.exports, "BOARD_FIELD_SELECT", () => $9487a479105b7a29$export$96d1ec764b4e2f60);
$parcel$export(module.exports, "BOARD_FIELD_STATUS", () => $9487a479105b7a29$export$ad56e5948f48da2c);
$parcel$export(module.exports, "BOARD_FIELD_STORY_POINTS", () => $9487a479105b7a29$export$d2eed83c3ed9ab1d);
$parcel$export(module.exports, "BOARD_FIELD_TEXT", () => $9487a479105b7a29$export$69cbdb5b06ddf32d);
$parcel$export(module.exports, "BOARD_FIELD_TIME_ORIGINAL_ESTIMATE", () => $9487a479105b7a29$export$66de7ee82b097a84);
$parcel$export(module.exports, "BOARD_FIELD_USER", () => $9487a479105b7a29$export$f3e4cc1059d02f6f);
$parcel$export(module.exports, "ASSIGNEE_ID", () => $9487a479105b7a29$export$9059d5c1244fee75);
$parcel$export(module.exports, "CATEGORY_ID", () => $9487a479105b7a29$export$f7c25c2b1222ecd7);
$parcel$export(module.exports, "COMPONENT_ID", () => $9487a479105b7a29$export$723ee4d7411b97b4);
$parcel$export(module.exports, "DUE_DATE_ID", () => $9487a479105b7a29$export$876c8bd8ab9d799b);
$parcel$export(module.exports, "ISSUE_KEY_ID", () => $9487a479105b7a29$export$461d491d7fb1ef7c);
$parcel$export(module.exports, "ISSUE_TYPE_ID", () => $9487a479105b7a29$export$1612a59f1be6d6f3);
$parcel$export(module.exports, "LABEL_ID", () => $9487a479105b7a29$export$4db2521ab6aa047);
$parcel$export(module.exports, "PARENT_ID", () => $9487a479105b7a29$export$3af4d9a28905196d);
$parcel$export(module.exports, "PRIORITY_ID", () => $9487a479105b7a29$export$45ce44d95b47db60);
$parcel$export(module.exports, "RANK_ID", () => $9487a479105b7a29$export$21420526762ffb8);
$parcel$export(module.exports, "STATUS_ID", () => $9487a479105b7a29$export$fac746c9db478fd8);
$parcel$export(module.exports, "SUMMARY_ID", () => $9487a479105b7a29$export$8cadcb0dac4af55);
$parcel$export(module.exports, "CARD_COVER_MEDIA_READ_TOKEN_DURATION", () => $9487a479105b7a29$export$58bbde0bd11b3269);
$parcel$export(module.exports, "CARD_COVER_MEDIA_READ_TOKEN_MAX_LENGTH", () => $9487a479105b7a29$export$c9056a07d77f30a8);
$parcel$export(module.exports, "PAGES", () => $9487a479105b7a29$export$bf0267afb2fbc151);
$parcel$export(module.exports, "CARD_COVER", () => $9487a479105b7a29$export$408b2ddc0d60fec4);

var $5fc53 = parcelRequire("5fc53");
const $9487a479105b7a29$export$42310dd57a41067 = {
    collapsedStickyHeaders: 2,
    stickyHeaders: 4
};
const $9487a479105b7a29$export$5390a88bb80e075f = 200;
const $9487a479105b7a29$export$836c3f1e10326a68 = 40;
const $9487a479105b7a29$export$fb45fce6dbb30982 = 270;
const $9487a479105b7a29$export$ad065eea37c8234b = 48;
const $9487a479105b7a29$export$a2e40c85b8340e83 = 32;
const $9487a479105b7a29$export$e4e941da6bdb3c31 = 12;
const $9487a479105b7a29$export$68cfa75d03564799 = 90;
const $9487a479105b7a29$export$b05303cbde3e8c8c = 'CARD';
const $9487a479105b7a29$export$57d0ef745f304b91 = 'COLUMN';
const $9487a479105b7a29$export$527474bbf19f45e4 = [
    'key',
    'type',
    'dueDate',
    (0, $5fc53.ISSUE_TYPE),
    (0, $5fc53.SUMMARY_TYPE),
    (0, $5fc53.STATUS_TYPE),
    (0, $5fc53.ASSIGNEE_TYPE),
    (0, $5fc53.DUE_DATE_TYPE),
    (0, $5fc53.SUBTASKS_TYPE),
    (0, $5fc53.PRIORITY_TYPE)
];
const $9487a479105b7a29$export$9ebaf9fe814731d3 = null;
const $9487a479105b7a29$export$4a2289be55388ee6 = {
    experience: 'viewBoard',
    packageName: 'jiraWorkManagementBoard',
    teamName: 'wanjel'
};
const $9487a479105b7a29$export$947ad1d92ba954ec = 'null_pivot';
const $9487a479105b7a29$export$d46a05f8561f868a = 'other';
const $9487a479105b7a29$export$65fb8d4fddcb3db6 = 'BOARD_FIELD_CATEGORY';
const $9487a479105b7a29$export$c48edb33483d0062 = 'BOARD_FIELD_COMPONENTS';
const $9487a479105b7a29$export$5f51001602e4f639 = 'BOARD_FIELD_CONFLUENCE_PAGES_COUNT';
const $9487a479105b7a29$export$638505006ae9ba93 = 'BOARD_FIELD_DATE';
const $9487a479105b7a29$export$465f5a7204a3dffc = 'BOARD_FIELD_DATE_TIME';
const $9487a479105b7a29$export$183b99b9ca85ddaa = 'BOARD_FIELD_FLOAT';
const $9487a479105b7a29$export$9b9930ab0e532c29 = 'BOARD_FIELD_ISSUE_LINKS_COUNT';
const $9487a479105b7a29$export$928ca8ef7db2c7ce = 'BOARD_FIELD_ISSUE_TYPE';
const $9487a479105b7a29$export$4709bd5a74152ae7 = 'BOARD_FIELD_LABEL';
const $9487a479105b7a29$export$2c7d7c1c0024ef92 = 'BOARD_FIELD_MULTI_USER';
const $9487a479105b7a29$export$d2edf947f6b61359 = 'BOARD_FIELD_PARENT';
const $9487a479105b7a29$export$eb7c8ce7565d664 = 'BOARD_FIELD_PRIORITY';
const $9487a479105b7a29$export$96d1ec764b4e2f60 = 'BOARD_FIELD_SELECT';
const $9487a479105b7a29$export$ad56e5948f48da2c = 'BOARD_FIELD_STATUS';
const $9487a479105b7a29$export$d2eed83c3ed9ab1d = 'BOARD_FIELD_STORY_POINTS';
const $9487a479105b7a29$export$69cbdb5b06ddf32d = 'BOARD_FIELD_TEXT';
const $9487a479105b7a29$export$66de7ee82b097a84 = 'BOARD_FIELD_TIME_ORIGINAL_ESTIMATE';
const $9487a479105b7a29$export$f3e4cc1059d02f6f = 'BOARD_FIELD_USER';
const $9487a479105b7a29$export$9059d5c1244fee75 = (0, $5fc53.ASSIGNEE_TYPE);
const $9487a479105b7a29$export$f7c25c2b1222ecd7 = 'category';
const $9487a479105b7a29$export$723ee4d7411b97b4 = (0, $5fc53.COMPONENTS_TYPE);
const $9487a479105b7a29$export$876c8bd8ab9d799b = (0, $5fc53.DUE_DATE_TYPE);
const $9487a479105b7a29$export$461d491d7fb1ef7c = (0, $5fc53.ISSUE_KEY_TYPE);
const $9487a479105b7a29$export$1612a59f1be6d6f3 = (0, $5fc53.ISSUE_TYPE);
const $9487a479105b7a29$export$4db2521ab6aa047 = (0, $5fc53.LABELS_TYPE);
const $9487a479105b7a29$export$3af4d9a28905196d = (0, $5fc53.PARENT_TYPE);
const $9487a479105b7a29$export$45ce44d95b47db60 = (0, $5fc53.PRIORITY_TYPE);
const $9487a479105b7a29$export$21420526762ffb8 = 'rank';
const $9487a479105b7a29$export$fac746c9db478fd8 = (0, $5fc53.STATUS_TYPE);
const $9487a479105b7a29$export$8cadcb0dac4af55 = (0, $5fc53.SUMMARY_TYPE);
const $9487a479105b7a29$export$58bbde0bd11b3269 = 900;
const $9487a479105b7a29$export$c9056a07d77f30a8 = 65534;
const $9487a479105b7a29$export$bf0267afb2fbc151 = 'confluenceRemoteIssueLinks';
const $9487a479105b7a29$export$408b2ddc0d60fec4 = 'cardcover';

});

parcelRegister("fPzrH", function(module, exports) {

$parcel$export(module.exports, "BoardDataProvider", () => $2c7d8ade254ad854$export$56f1728b5dbbcb33);
$parcel$export(module.exports, "useBoardData", () => $2c7d8ade254ad854$export$35c54b081e81928);

var $5gXcC = parcelRequire("5gXcC");

var $4u6uH = parcelRequire("4u6uH");

var $5uXOq = parcelRequire("5uXOq");

var $16dzj = parcelRequire("16dzj");

var $8Uumt = parcelRequire("8Uumt");

var $7juH2 = parcelRequire("7juH2");

var $6s1PB = parcelRequire("6s1PB");

var $lODMY = parcelRequire("lODMY");

var $jcw0u = parcelRequire("jcw0u");

var $pa9q9 = parcelRequire("pa9q9");

var $d8VYe = parcelRequire("d8VYe");

var $cvj5l = parcelRequire("cvj5l");

var $hlGFs = parcelRequire("hlGFs");

var $gEtYC = parcelRequire("gEtYC");

var $dxAlC = parcelRequire("dxAlC");

var $23CdY = parcelRequire("23CdY");

var $6xpM6 = parcelRequire("6xpM6");

var $jgcJl = parcelRequire("jgcJl");

var $7OM52 = parcelRequire("7OM52");

var $3pAJH = parcelRequire("3pAJH");
const $2c7d8ade254ad854$export$e5f8ddc48dfc125e = (0, $lODMY.createRouterSelector)((state)=>state.match?.params?.itemId ?? undefined);
const $2c7d8ade254ad854$var$FETCH_FAILED_FLAG_ID = 'FETCH_BOARD_DATA_FAILED';
/**
 * @deprecated delete getActiveWorkflow when cleaning up merge_board_workflows
 */ const $2c7d8ade254ad854$var$getActiveWorkflow = (workflows, activeWorkflowId)=>{
    const activeWorkflow = workflows.find((workflow)=>workflow.workflowId === activeWorkflowId) ?? workflows[0];
    return activeWorkflow;
};
const $2c7d8ade254ad854$var$Context = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $2c7d8ade254ad854$export$56f1728b5dbbcb33 = ({ projectFragment: projectFragment, viewFragment: viewFragment, children: children })=>{
    const { data: data, loading: isWorkflowLoading, error: error } = (0, $d8VYe.useWorkflowIssues)();
    const itemId = $2c7d8ade254ad854$export$e5f8ddc48dfc125e();
    const project = (0, $8Uumt.useFragment)((0, $4u6uH.default), projectFragment);
    const view = (0, $8Uumt.useFragment)((0, $5gXcC.default), viewFragment);
    const { workflowIssuesLastChangedTime: workflowIssuesLastChangedTime } = (0, $jgcJl.useWorkflowStoreState)();
    const { setFetchResponse: setFetchResponse } = (0, $jgcJl.useWorkflowStoreActions)();
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $pa9q9.useFlagsService)();
    const { updateIssues: updateIssues, reset: resetIssueStore } = (0, $gEtYC.useIssueStoreActions)();
    const refetchIssuesWithThrow = (0, $6xpM6.useRefetchIssuesWithThrow)();
    const [initialized, setInitialized] = (0, $5uXOq.useState)(false);
    const fetchedFields = (0, $5uXOq.useRef)([]);
    const filterIssues = (0, $hlGFs.useFilter)();
    const { isLoading: isLoadingFilters } = (0, $hlGFs.useFilterStatus)();
    const allIssues = (0, $dxAlC.useIssues)();
    const fieldIds = (0, $7OM52.useFieldIds)();
    const filteredIssues = (0, $5uXOq.useMemo)(()=>{
        const withoutSubtasks = Array.from(allIssues.values()).filter((issue)=>issue.fields[0, $cvj5l.ISSUE_TYPE_ID].issueType.hierarchyLevel >= 0);
        const issues = filterIssues(withoutSubtasks);
        return (0, $23CdY.sortIssuesBy)('rank', issues);
    }, [
        allIssues,
        filterIssues
    ]);
    const reset = (0, $5uXOq.useCallback)(()=>{
        resetIssueStore();
        setInitialized(false);
        fetchedFields.current = [];
    }, [
        resetIssueStore
    ]);
    let activeWorkflowId = '';
    if (!(0, $6s1PB.expVal)('merge_board_workflows', 'enabled', false)) {
        activeWorkflowId = view?.selectedWorkflowId ?? '';
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const activeWorkflowIdRef = (0, $5uXOq.useRef)(activeWorkflowId);
        // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $5uXOq.useEffect)(()=>{
            if (activeWorkflowId !== activeWorkflowIdRef.current) {
                activeWorkflowIdRef.current = activeWorkflowId;
                reset();
            }
        }, [
            activeWorkflowId,
            reset
        ]);
    }
    const showErrorFlag = (0, $5uXOq.useCallback)(()=>{
        showFlag({
            id: $2c7d8ade254ad854$var$FETCH_FAILED_FLAG_ID,
            type: 'error',
            title: (0, $3pAJH.default).boardInitErrorTitle,
            description: (0, $3pAJH.default).boardInitErrorMessage,
            messageId: 'work-management-board.controllers.board-data.show-flag.error',
            messageType: 'transactional'
        });
    }, [
        showFlag
    ]);
    const handleStatusNotFoundForIssues = (0, $5uXOq.useCallback)((statusNotFoundCounts)=>{
        (0, $jcw0u.default)({
            meta: {
                id: 'mapWorkflowIssuesToBoardIssues',
                packageName: 'jiraWorkManagementBoard',
                teamName: 'wanjel'
            },
            attributes: {
                message: 'Status not found for issues',
                statusNotFoundCounts: Array.from(statusNotFoundCounts, ([statusId, count])=>({
                        statusId: statusId,
                        count: count
                    }))
            },
            sendToPrivacyUnsafeSplunk: true
        });
        showFlag({
            type: 'warning',
            title: (0, $3pAJH.default).boardStatusNotFoundWarningFlagTitle,
            description: (0, $3pAJH.default).boardStatusNotFoundWarningFlagDescription,
            messageId: 'work-management-board.controllers.board-data.show-flag.warning',
            messageType: 'transactional',
            actions: [
                {
                    content: (0, $3pAJH.default).boardStatusNotFoundWarningFlagAction,
                    href: `/issues/?jql=project%20%3D%20"${project.key}"`
                }
            ]
        });
    }, [
        project.key,
        showFlag
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!initialized) {
            if (data) {
                setInitialized(true);
                if ((0, $6s1PB.expVal)('merge_board_workflows', 'enabled', false)) {
                    const mappedIssues = (0, $23CdY.mapWorkflowIssuesToBoardIssues)(data.workflows, handleStatusNotFoundForIssues);
                    updateIssues(mappedIssues);
                    setFetchResponse({
                        workflows: data.workflows,
                        workflowIssuesLastChangedTime: data.lastChangedTime || undefined
                    });
                } else {
                    const activeWorkflowData = $2c7d8ade254ad854$var$getActiveWorkflow(data.workflows, activeWorkflowId);
                    if (!activeWorkflowData) return;
                    const mappedIssues = (0, $23CdY.mapWorkflowIssuesToBoardIssues)([
                        activeWorkflowData
                    ], handleStatusNotFoundForIssues);
                    updateIssues(mappedIssues);
                    setFetchResponse({
                        activeWorkflow: activeWorkflowData,
                        workflows: data.workflows,
                        workflowIssuesLastChangedTime: data.lastChangedTime || undefined
                    });
                }
            } else if (error) {
                setInitialized(true);
                showErrorFlag();
            }
        }
    }, [
        activeWorkflowId,
        data,
        error,
        initialized,
        setFetchResponse,
        updateIssues,
        showErrorFlag,
        handleStatusNotFoundForIssues
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // if the list of fields changes, refetch the issues
        if (initialized && !isLoadingFilters && fieldIds.length > 0 && (0, (/*@__PURE__*/$parcel$interopDefault($16dzj)))(fieldIds, fetchedFields.current).length > 0 && allIssues.size > 0) {
            fetchedFields.current = fieldIds;
            refetchIssuesWithThrow(Array.from(allIssues.keys())).catch(showErrorFlag);
        }
    }, [
        fieldIds,
        initialized,
        isLoadingFilters,
        allIssues,
        refetchIssuesWithThrow,
        showErrorFlag
    ]);
    const refetch = (0, $5uXOq.useCallback)(async ()=>{
        try {
            const response = await (0, $7juH2.fetchWorkflowIssues)({
                projectKey: project.key,
                itemId: itemId,
                ifChangedSince: workflowIssuesLastChangedTime
            });
            const activeWorkflowData = $2c7d8ade254ad854$var$getActiveWorkflow(response.workflows, activeWorkflowId);
            if (!activeWorkflowData) return;
            await refetchIssuesWithThrow(activeWorkflowData.issues.map((issue)=>issue.id), true);
            setFetchResponse({
                activeWorkflow: activeWorkflowData,
                workflows: response.workflows,
                workflowIssuesLastChangedTime: response.lastChangedTime || undefined
            });
            dismissFlag($2c7d8ade254ad854$var$FETCH_FAILED_FLAG_ID);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (refetchError) {
            if (refetchError instanceof (0, $7juH2.Unchanged)) {
                dismissFlag($2c7d8ade254ad854$var$FETCH_FAILED_FLAG_ID);
                return;
            }
            (0, $jcw0u.default)({
                meta: {
                    id: 'refetchBoardData',
                    packageName: 'jiraWorkManagementBoard',
                    teamName: 'wanjel'
                },
                attributes: {
                    message: 'Failed to refetch workflow issues data'
                },
                error: refetchError,
                sendToPrivacyUnsafeSplunk: true
            });
            showErrorFlag();
        }
    }, [
        project.key,
        itemId,
        workflowIssuesLastChangedTime,
        activeWorkflowId,
        refetchIssuesWithThrow,
        setFetchResponse,
        dismissFlag,
        showErrorFlag
    ]);
    // only mark as loading when the page initialises but not when applying filters thereafter
    const [loading, setLoading] = (0, $5uXOq.useState)(isWorkflowLoading || isLoadingFilters);
    (0, $5uXOq.useEffect)(()=>{
        if (loading && !isWorkflowLoading && !isLoadingFilters) setLoading(false);
    }, [
        loading,
        isWorkflowLoading,
        isLoadingFilters
    ]);
    const value = (0, $5uXOq.useMemo)(()=>({
            filteredIssues: filteredIssues,
            refetch: refetch,
            reset: reset,
            // we want to show loading state for server side rendering
            loading: false ? true : loading,
            error: error
        }), [
        filteredIssues,
        refetch,
        reset,
        loading,
        error
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2c7d8ade254ad854$var$Context.Provider, {
        value: value
    }, children);
};
const $2c7d8ade254ad854$export$35c54b081e81928 = ()=>{
    const context = (0, $5uXOq.useContext)($2c7d8ade254ad854$var$Context);
    if (!context) throw new Error('useBoardData must be used within a BoardDataProvider');
    return context;
};

});
parcelRegister("5gXcC", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc225eecc0880b51$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5fcc9431213149ba78d3b6d3c9bcc6eb>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $fc225eecc0880b51$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcmergeboardworkflowsrelayprovider"
        }
    ],
    "kind": "Fragment",
    "name": "BoardDataProvider_view",
    "selections": [
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcmergeboardworkflowsrelayprovider",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "selectedWorkflowId"
                }
            ]
        }
    ],
    "type": "JiraBoardView"
};
$fc225eecc0880b51$var$node.hash = "393cd19c4e74cc16223cf16310e16a74";
var $fc225eecc0880b51$export$2e2bcd8739ae039 = $fc225eecc0880b51$var$node;

});

parcelRegister("4u6uH", function(module, exports) {

$parcel$export(module.exports, "default", () => $566c63422c47c8d3$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d3c8fa82bbb601383fb882c990a3907c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $566c63422c47c8d3$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "BoardDataProvider_project",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "key"
            },
            "action": "THROW",
            "path": "key"
        }
    ],
    "type": "JiraProject"
};
$566c63422c47c8d3$var$node.hash = "e16b750e8a7273f8bdbd3759742ff9a4";
var $566c63422c47c8d3$export$2e2bcd8739ae039 = $566c63422c47c8d3$var$node;

});

parcelRegister("16dzj", function(module, exports) {

var $2GdQn = parcelRequire("2GdQn");

var $g7i7g = parcelRequire("g7i7g");

var $7txx8 = parcelRequire("7txx8");

var $f3SOL = parcelRequire("f3SOL");
/**
 * Creates an array of unique values that is the
 * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
 * of the given arrays. The order of result values is determined by the order
 * they occur in the arrays.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.difference, _.without
 * @example
 *
 * _.xor([2, 1], [2, 3]);
 * // => [1, 3]
 */ var $0cd0e06461d5e057$var$xor = $g7i7g(function(arrays) {
    return $7txx8($2GdQn(arrays, $f3SOL));
});
module.exports = $0cd0e06461d5e057$var$xor;

});
parcelRegister("7txx8", function(module, exports) {

var $55pzo = parcelRequire("55pzo");

var $ekcP3 = parcelRequire("ekcP3");

var $7CoLY = parcelRequire("7CoLY");
/**
 * The base implementation of methods like `_.xor`, without support for
 * iteratee shorthands, that accepts an array of arrays to inspect.
 *
 * @private
 * @param {Array} arrays The arrays to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of values.
 */ function $571540db172adafd$var$baseXor(arrays, iteratee, comparator) {
    var length = arrays.length;
    if (length < 2) return length ? $7CoLY(arrays[0]) : [];
    var index = -1, result = Array(length);
    while(++index < length){
        var array = arrays[index], othIndex = -1;
        while(++othIndex < length)if (othIndex != index) result[index] = $55pzo(result[index] || array, arrays[othIndex], iteratee, comparator);
    }
    return $7CoLY($ekcP3(result, 1), iteratee, comparator);
}
module.exports = $571540db172adafd$var$baseXor;

});


parcelRegister("hlGFs", function(module, exports) {

$parcel$export(module.exports, "useFilterFieldIds", () => $9c840681bd782ce5$export$db2c52178fd751e7);
$parcel$export(module.exports, "useFilterStatus", () => $9c840681bd782ce5$export$66de9151ffa1198a);
$parcel$export(module.exports, "useFilter", () => $9c840681bd782ce5$export$3274cf84b703fff);

var $5uXOq = parcelRequire("5uXOq");

var $gccSB = parcelRequire("gccSB");

var $ajpes = parcelRequire("ajpes");

var $1TU9r = parcelRequire("1TU9r");

var $l4Ejo = parcelRequire("l4Ejo");

var $dpQnO = parcelRequire("dpQnO");

var $1T1ir = parcelRequire("1T1ir");

var $33Toe = parcelRequire("33Toe");

var $g4ZHz = parcelRequire("g4ZHz");

var $9OXo1 = parcelRequire("9OXo1");

var $cvj5l = parcelRequire("cvj5l");

var $3Qivn = parcelRequire("3Qivn");
const $9c840681bd782ce5$var$filterByExtendedFields = (issue, expandedFilters)=>expandedFilters.every((filter)=>{
        // handle parent field filter separately as it searches in two fields parent and issue key
        if (filter.fieldKey === (0, $cvj5l.PARENT_ID)) return (0, $3Qivn.filterByParent)(filter, issue.fields);
        const issueField = issue.fields[filter.fieldKey];
        if (issueField == null) return filter.hasEmptyFilter;
        switch(issueField.type){
            case 0, $cvj5l.BOARD_FIELD_CATEGORY:
                return (0, $3Qivn.filterByCategory)(filter, issueField);
            case 0, $cvj5l.BOARD_FIELD_COMPONENTS:
                return (0, $3Qivn.filterByComponents)(filter, issueField);
            case 0, $cvj5l.BOARD_FIELD_ISSUE_TYPE:
                return (0, $3Qivn.filterByIssueType)(filter, issueField);
            case 0, $cvj5l.BOARD_FIELD_LABEL:
                return (0, $3Qivn.filterByLabels)(filter, issueField);
            case 0, $cvj5l.BOARD_FIELD_PRIORITY:
                return (0, $3Qivn.filterByPriority)(filter, issueField);
            case 0, $cvj5l.BOARD_FIELD_SELECT:
                return (0, $3Qivn.filterBySelect)(filter, issueField);
            case 0, $cvj5l.BOARD_FIELD_STATUS:
                return (0, $3Qivn.filterByStatus)(filter, issueField);
            case 0, $cvj5l.BOARD_FIELD_USER:
                return (0, $3Qivn.filterByUser)(filter, issueField);
            case 0, $cvj5l.BOARD_FIELD_MULTI_USER:
                return (0, $3Qivn.filterByMultiUser)(filter, issueField);
            default:
                return false;
        }
    });
const $9c840681bd782ce5$var$filterIssues = (filters, issues, fields)=>{
    const expandedFilters = (0, $3Qivn.getExpandedFilters)(filters, fields);
    return issues.filter((issue)=>(0, $33Toe.isOptimisticIssue)(issue.id) || $9c840681bd782ce5$var$filterByExtendedFields(issue, expandedFilters));
};
const $9c840681bd782ce5$var$quickFilterIssues = (quickFilters, issues, atlassianAccountId)=>{
    let results = issues;
    if (quickFilters.ASSIGNED_TO_ME && atlassianAccountId != null) results = (0, $3Qivn.isAssignedToMe)(results, atlassianAccountId);
    if (quickFilters.DUE_THIS_WEEK) results = (0, $3Qivn.isDueThisWeek)(results);
    return results;
};
const $9c840681bd782ce5$var$EMPTY_FIELD_IDS = [];
const $9c840681bd782ce5$export$db2c52178fd751e7 = ({ categoryFieldId: categoryFieldId })=>{
    const { data: fields } = (0, $g4ZHz.useFieldsResource)();
    const { filters: filters } = (0, $1TU9r.useDeserialisedFilters)();
    return (0, $5uXOq.useMemo)(()=>filters != null && fields != null ? Object.keys(filters).map((fieldKeyFromFilter)=>(0, $3Qivn.jqlTermToFieldId)(fieldKeyFromFilter, fields, categoryFieldId)).filter(Boolean) : $9c840681bd782ce5$var$EMPTY_FIELD_IDS, [
        categoryFieldId,
        fields,
        filters
    ]);
};
const $9c840681bd782ce5$export$66de9151ffa1198a = ()=>{
    const { loading: fieldsLoading } = (0, $g4ZHz.useFieldsResource)();
    const { jql: jql } = (0, $l4Ejo.useFilters)();
    const { quickFilters: quickFilters } = (0, $dpQnO.useQuickFilters)();
    const [simpleSearch] = (0, $1T1ir.useSimpleSearch)();
    const { isLoading: isDeserializingFilters } = (0, $1TU9r.useDeserialisedFilters)();
    const isFiltering = !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(jql) || quickFilters.ASSIGNED_TO_ME || quickFilters.DUE_THIS_WEEK || !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(simpleSearch);
    return {
        isLoading: isFiltering && (Boolean(isDeserializingFilters) || fieldsLoading),
        isFiltering: isFiltering
    };
};
const $9c840681bd782ce5$var$useMemoizedFiltersDependencies = (simpleSearch, filters, quickFilters)=>{
    const ref = (0, $5uXOq.useRef)({
        simpleSearch: simpleSearch,
        filters: filters,
        quickFilters: quickFilters
    });
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(ref.current, {
        simpleSearch: simpleSearch,
        filters: filters,
        quickFilters: quickFilters
    })) ref.current = {
        simpleSearch: simpleSearch,
        filters: filters,
        quickFilters: quickFilters
    };
    return ref.current;
};
const $9c840681bd782ce5$export$3274cf84b703fff = ()=>{
    const { data: fields } = (0, $g4ZHz.useFieldsResource)();
    const { quickFilters: quickFilters } = (0, $dpQnO.useQuickFilters)();
    const [simpleSearch] = (0, $1T1ir.useSimpleSearch)();
    const { filters: filters } = (0, $1TU9r.useDeserialisedFilters)();
    const { atlassianAccountId: atlassianAccountId } = (0, $9OXo1.useTenantContext)();
    // these dependencies are memoized with deep equality comparison because they are not stable
    const filtersDependencies = $9c840681bd782ce5$var$useMemoizedFiltersDependencies(simpleSearch, filters, quickFilters);
    const filter = (0, $5uXOq.useCallback)((issues)=>{
        // we always want to filter issues with text search
        const results = (0, $3Qivn.filterIssuesByText)(issues, filtersDependencies.simpleSearch);
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(filtersDependencies.filters)) return $9c840681bd782ce5$var$filterIssues(filtersDependencies.filters, results, fields);
        return $9c840681bd782ce5$var$quickFilterIssues(filtersDependencies.quickFilters, results, atlassianAccountId);
    }, [
        filtersDependencies,
        fields,
        atlassianAccountId
    ]);
    return filter;
};

});
parcelRegister("1T1ir", function(module, exports) {

$parcel$export(module.exports, "useSimpleSearch", () => $9ff55c3a873f98f5$export$b549f44e7ca96280);
$parcel$export(module.exports, "useSimpleSearchHighlight", () => $9ff55c3a873f98f5$export$fd04dfca01137d2);
$parcel$export(module.exports, "useSearchText", () => $9ff55c3a873f98f5$export$119186efd4186c93);
$parcel$export(module.exports, "useSimpleSearchJQL", () => $9ff55c3a873f98f5$export$42b8d8a5ec5bc873);

var $5uXOq = parcelRequire("5uXOq");

var $9XS00 = parcelRequire("9XS00");

var $ieDtd = parcelRequire("ieDtd");

var $7htvz = parcelRequire("7htvz");
const $9ff55c3a873f98f5$var$sanitize = (value)=>value.replace(/\\/g, '\\\\').replace(/'/g, "\\'").replace(/\t/g, ' ');
const $9ff55c3a873f98f5$var$issueKeyRegex = new RegExp(`^${(0, $9XS00.ISSUEKEY_REGEX)}$`);
const $9ff55c3a873f98f5$var$japaneseAndChineseRegex = /[\p{Script_Extensions=Hiragana}\p{Script_Extensions=Katakana}\p{Script_Extensions=Han}]/u;
const $9ff55c3a873f98f5$export$b549f44e7ca96280 = ()=>{
    const [simpleSearch, persistSimpleSearch] = (0, $ieDtd.useQueryParam)((0, $7htvz.SIMPLE_SEARCH_PARAM));
    const setSimpleSearch = (0, $5uXOq.useCallback)((searchText)=>{
        searchText != null && searchText.trim() !== '' ? persistSimpleSearch(searchText) : persistSimpleSearch(undefined);
    }, [
        persistSimpleSearch
    ]);
    return [
        simpleSearch ?? '',
        setSimpleSearch
    ];
};
const $9ff55c3a873f98f5$export$72839f749ccf76b2 = (text)=>{
    if (text == null) return [];
    return text.split(' ').filter((word)=>word !== '');
};
const $9ff55c3a873f98f5$export$fd04dfca01137d2 = ()=>{
    const [simpleSearch] = $9ff55c3a873f98f5$export$b549f44e7ca96280();
    return (0, $5uXOq.useMemo)(()=>$9ff55c3a873f98f5$export$72839f749ccf76b2(simpleSearch), [
        simpleSearch
    ]);
};
const $9ff55c3a873f98f5$export$abb78553baf1cfac = (text)=>{
    if (text == null || text.trim() === '') return '';
    let search = $9ff55c3a873f98f5$var$sanitize(text);
    if ($9ff55c3a873f98f5$var$issueKeyRegex.test(text)) return `(summary ~ '${search}*' OR description ~ '${search}*' OR key = '${search}')`;
    // if the text does not contain Chinese or Japanese characters (which are not tokenized),
    // and does not end with a space character
    // make it a wildcard search
    if (!$9ff55c3a873f98f5$var$japaneseAndChineseRegex.test(text) && !text.endsWith(' ')) search = `${search}*`;
    return `(summary ~ '${search}' OR description ~ '${search}')`;
};
const $9ff55c3a873f98f5$export$119186efd4186c93 = (text)=>{
    const jql = (0, $5uXOq.useMemo)(()=>$9ff55c3a873f98f5$export$abb78553baf1cfac(text), [
        text
    ]);
    const highlight = (0, $5uXOq.useMemo)(()=>$9ff55c3a873f98f5$export$72839f749ccf76b2(text), [
        text
    ]);
    return {
        jql: jql,
        highlight: highlight
    };
};
const $9ff55c3a873f98f5$export$42b8d8a5ec5bc873 = ()=>{
    const [simpleSearch] = $9ff55c3a873f98f5$export$b549f44e7ca96280();
    const jql = (0, $5uXOq.useMemo)(()=>$9ff55c3a873f98f5$export$abb78553baf1cfac(simpleSearch), [
        simpleSearch
    ]);
    const addSimpleSearchToJQL = (0, $5uXOq.useCallback)((currentJQL)=>{
        if (jql === '') return currentJQL;
        if (currentJQL == null) return jql;
        return `${currentJQL} AND ${jql}`;
    }, [
        jql
    ]);
    return {
        jql: jql,
        isSearching: jql !== '',
        addSimpleSearchToJQL: addSimpleSearchToJQL
    };
};
var $9ff55c3a873f98f5$export$2e2bcd8739ae039 = $9ff55c3a873f98f5$export$b549f44e7ca96280;

});
parcelRegister("9XS00", function(module, exports) {

$parcel$export(module.exports, "ISSUEKEY_REGEX", () => $76f8b51a225e9798$export$b52c9cee589449a8);
$parcel$export(module.exports, "default", () => $76f8b51a225e9798$export$2e2bcd8739ae039);

var $aZsz6 = parcelRequire("aZsz6");
const $76f8b51a225e9798$export$b52c9cee589449a8 = '([A-Z][A-Z0-9_]+-\\d+)';
var /**
 * Returns the issue key if the URL is a valid full page Jira issue URL. It may also include a trailing
 * hash fragment. A matching URL must look like:
 * <host><baseurl>/browse/<issuekey><#hash?>
 * e.g. https://my-jira-instance.atlassian.net/browse/FOO-123#xyz
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$76f8b51a225e9798$export$2e2bcd8739ae039 = (url, host)=>{
    const parsedUrl = (0, (/*@__PURE__*/$parcel$interopDefault($aZsz6)))(url, {});
    const isMatchingProtocol = parsedUrl.protocol === 'http:' || parsedUrl.protocol === 'https:';
    const isMatchingHost = parsedUrl.host === host;
    const matches = parsedUrl.pathname.match(new RegExp(`^\\/browse\\/${$76f8b51a225e9798$export$b52c9cee589449a8}\\/?$`));
    const issueKey = matches && matches.length > 1 ? matches[1] : null;
    return isMatchingProtocol && isMatchingHost && issueKey || null;
};

});


parcelRegister("3Qivn", function(module, exports) {

$parcel$export(module.exports, "isAssignedToMe", () => $52259b328274ecae$export$e87389f48a5305be);
$parcel$export(module.exports, "isDueThisWeek", () => $52259b328274ecae$export$ff3ea4cb53c4a28);
$parcel$export(module.exports, "filterIssuesByText", () => $52259b328274ecae$export$c0fbf20bc94589ef);
$parcel$export(module.exports, "jqlTermToFieldId", () => $52259b328274ecae$export$f8fe768269c955c0);
$parcel$export(module.exports, "getExpandedFilters", () => $52259b328274ecae$export$eb6a39f031848a63);
$parcel$export(module.exports, "filterByCategory", () => $52259b328274ecae$export$6d1731a321e8bdf4);
$parcel$export(module.exports, "filterByComponents", () => $52259b328274ecae$export$3f1c0440e368606f);
$parcel$export(module.exports, "filterByIssueType", () => $52259b328274ecae$export$f836023a765b3b9f);
$parcel$export(module.exports, "filterByLabels", () => $52259b328274ecae$export$d226d89b96788bab);
$parcel$export(module.exports, "filterByPriority", () => $52259b328274ecae$export$710b0eb282166a50);
$parcel$export(module.exports, "filterBySelect", () => $52259b328274ecae$export$d8a8627f7157d954);
$parcel$export(module.exports, "filterByStatus", () => $52259b328274ecae$export$1caf81d27b0e4d0e);
$parcel$export(module.exports, "filterByUser", () => $52259b328274ecae$export$20a671e3b06cc1b5);
$parcel$export(module.exports, "filterByMultiUser", () => $52259b328274ecae$export$862615c6ba36b321);
$parcel$export(module.exports, "filterByParent", () => $52259b328274ecae$export$20017115067fd3ed);

var $9XE6b = parcelRequire("9XE6b");

var $4XdQG = parcelRequire("4XdQG");

var $33Toe = parcelRequire("33Toe");

var $5fc53 = parcelRequire("5fc53");

var $cvj5l = parcelRequire("cvj5l");
const $52259b328274ecae$export$e87389f48a5305be = (issues, atlassianAccountId)=>issues.filter(({ id: id, fields: fields })=>(0, $33Toe.isOptimisticIssue)(id) || fields[0, $cvj5l.ASSIGNEE_ID]?.user.accountId === atlassianAccountId);
const $52259b328274ecae$export$ff3ea4cb53c4a28 = (issues)=>issues.filter((issue)=>{
        if ((0, $33Toe.isOptimisticIssue)(issue.id)) return true;
        if (!issue.fields[0, $cvj5l.DUE_DATE_ID]) return false;
        const dueDate = new Date(issue.fields[0, $cvj5l.DUE_DATE_ID].value);
        const today = new Date();
        return (0, $4XdQG.default)(dueDate, today);
    });
const $52259b328274ecae$export$c0fbf20bc94589ef = (issues, searchText)=>{
    if (searchText != null && searchText.trim() !== '') {
        const trimmedSearchTextInLowerCase = searchText.trim().toLowerCase();
        return issues.filter(({ id: id, fields: fields })=>(0, $33Toe.isOptimisticIssue)(id) || fields[0, $cvj5l.SUMMARY_ID].value.toLowerCase().includes(trimmedSearchTextInLowerCase) || fields[0, $cvj5l.ASSIGNEE_ID]?.user.name?.toLowerCase().includes(trimmedSearchTextInLowerCase) || fields[0, $cvj5l.ISSUE_KEY_ID].value.toLowerCase().includes(trimmedSearchTextInLowerCase));
    }
    return issues;
};
const $52259b328274ecae$export$f8fe768269c955c0 = (jqlTerm, fields, categoryFieldId)=>{
    const field = fields.find((f)=>f.jqlTerm === jqlTerm);
    if (field?.type === (0, $5fc53.CATEGORY_TYPE)) return categoryFieldId;
    if (field?.type === (0, $5fc53.COMPONENTS_TYPE)) return 0, $5fc53.COMPONENTS_TYPE;
    if (field?.type === (0, $5fc53.ISSUE_TYPE)) return 0, $5fc53.ISSUE_TYPE;
    return jqlTerm;
};
const $52259b328274ecae$var$jqlTermToIssueFieldKey = (jqlTerm, fields)=>{
    const field = fields?.find((f)=>f.jqlTerm === jqlTerm);
    if (field?.type === (0, $5fc53.CATEGORY_TYPE)) return 0, $cvj5l.CATEGORY_ID;
    if (field?.type === (0, $5fc53.COMPONENTS_TYPE)) return 0, $cvj5l.COMPONENT_ID;
    return field?.type ?? jqlTerm;
};
const $52259b328274ecae$var$getFilterValues = (filterValueForExtendedField, valueProperty)=>new Set(filterValueForExtendedField.map((filterValue)=>(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(filterValue, valueProperty, null)));
const $52259b328274ecae$var$isSelectOption = (filterValue)=>Array.isArray(filterValue) && filterValue.length > 0 && 'value' in filterValue[0];
const $52259b328274ecae$var$FILTER_VALUE_PROPERTY = {
    type: 'id',
    issuetype: 'id',
    priority: 'label',
    status: 'label'
};
const $52259b328274ecae$export$eb6a39f031848a63 = (filters, fields)=>Object.entries(filters).map(([jqlTerm, filterValue])=>{
        const filterValues = $52259b328274ecae$var$isSelectOption(filterValue) ? $52259b328274ecae$var$getFilterValues(filterValue, $52259b328274ecae$var$FILTER_VALUE_PROPERTY[jqlTerm] ?? 'value') : new Set();
        return {
            jqlTerm: jqlTerm,
            fieldKey: $52259b328274ecae$var$jqlTermToIssueFieldKey(jqlTerm, fields),
            filterValues: filterValues,
            hasEmptyFilter: filterValues.has((0, $cvj5l.EMPTY_FILTER_VALUE))
        };
    });
const $52259b328274ecae$export$6d1731a321e8bdf4 = (filter, field)=>{
    const category = field.category?.name;
    return filter.filterValues.has(category ?? '') || filter.hasEmptyFilter && !category;
};
const $52259b328274ecae$export$3f1c0440e368606f = (filter, field)=>{
    const components = field.value;
    return Array.isArray(components) && (components.some((component)=>filter.filterValues.has(component)) || filter.hasEmptyFilter && !components.length);
};
const $52259b328274ecae$export$f836023a765b3b9f = (filter, field)=>{
    const issueTypeId = field.issueType.id;
    return filter.filterValues.has(issueTypeId);
};
const $52259b328274ecae$export$d226d89b96788bab = (filter, field)=>{
    const labels = field.value;
    return Array.isArray(labels) && (labels.some((label)=>filter.filterValues.has(label)) || filter.hasEmptyFilter && !labels.length);
};
const $52259b328274ecae$export$710b0eb282166a50 = (filter, field)=>{
    const priorityName = field.priority.name;
    return filter.filterValues.has(priorityName);
};
const $52259b328274ecae$export$d8a8627f7157d954 = (filter, field)=>{
    const selectedValues = field.value;
    return Array.isArray(selectedValues) && (selectedValues.some((selectedValue)=>filter.filterValues.has(selectedValue)) || filter.hasEmptyFilter && !selectedValues.length);
};
const $52259b328274ecae$export$1caf81d27b0e4d0e = (filter, field)=>{
    const statusName = field.status.name;
    return filter.filterValues.has(statusName);
};
const $52259b328274ecae$export$20a671e3b06cc1b5 = (filter, field)=>{
    const user = field.user.accountId;
    return filter.filterValues.has(user);
};
const $52259b328274ecae$export$862615c6ba36b321 = (filter, field)=>{
    const users = field.users.map((user)=>user.accountId);
    return Array.isArray(users) && (users.some((user)=>filter.filterValues.has(user)) || filter.hasEmptyFilter && !users.length);
};
const $52259b328274ecae$export$20017115067fd3ed = (filter, issueFields)=>{
    const issueKey = issueFields[0, $cvj5l.ISSUE_KEY_ID].value;
    const parentKey = issueFields[0, $cvj5l.PARENT_ID]?.parent?.key ?? null;
    return filter.filterValues.has(parentKey) || filter.filterValues.has(issueKey);
};

});


parcelRegister("gEtYC", function(module, exports) {

$parcel$export(module.exports, "IssueStoreContainer", () => $7b0555560f9c1621$export$2f0bbf62c1aadb30);
$parcel$export(module.exports, "Store", () => $7b0555560f9c1621$export$390f32400eaf98c9);
$parcel$export(module.exports, "useIssueStoreActions", () => $7b0555560f9c1621$export$20586bb841d52702);

var $dqDis = parcelRequire("dqDis");

var $3sQ5x = parcelRequire("3sQ5x");
var $gg7kZ = parcelRequire("gg7kZ");
var $iXqE5 = parcelRequire("iXqE5");

var $cvj5l = parcelRequire("cvj5l");
const $7b0555560f9c1621$var$initialState = {
    issues: new Map()
};
const $7b0555560f9c1621$export$2f0bbf62c1aadb30 = (0, $gg7kZ.createContainer)();
const $7b0555560f9c1621$export$390f32400eaf98c9 = (0, $iXqE5.createStore)({
    containedBy: $7b0555560f9c1621$export$2f0bbf62c1aadb30,
    initialState: $7b0555560f9c1621$var$initialState,
    actions: {
        setIssues: (issues)=>({ setState: setState })=>{
                const issueMap = new Map();
                issues.forEach((issue)=>{
                    issueMap.set(issue.id, issue);
                });
                setState({
                    issues: issueMap
                });
            },
        updateIssues: (issues)=>({ setState: setState, getState: getState })=>{
                const issueMap = new Map(getState().issues);
                issues.forEach((issue)=>{
                    issueMap.set(issue.id, issue);
                });
                setState({
                    issues: issueMap
                });
            },
        updateIssueFields: ({ issueId: issueId, fields: fields, rank: rank })=>({ setState: setState, getState: getState })=>{
                const fieldUpdates = {
                    ...fields
                };
                const issueMap = new Map(getState().issues);
                const issue = issueMap.get(issueId);
                if (issue == null) return;
                if (rank != null) {
                    const relativeIssue = issueMap.get(rank.relativeIssueId);
                    if (relativeIssue != null) {
                        const relativeIssueRank = relativeIssue.fields[0, $cvj5l.RANK_ID].value;
                        fieldUpdates[0, $cvj5l.RANK_ID] = {
                            fieldId: (0, $cvj5l.RANK_ID),
                            type: (0, $cvj5l.BOARD_FIELD_TEXT),
                            value: rank.position === 'before' ? (0, $dqDis.getPreviousRank)(relativeIssueRank) : (0, $dqDis.getNextRank)(relativeIssueRank)
                        };
                    }
                }
                if (Object.keys(fieldUpdates).length === 0) return;
                Object.entries(fieldUpdates).forEach(([fieldId, field])=>{
                    if (field == null) {
                        delete issue.fields[fieldId];
                        return;
                    }
                    issue.fields[fieldId] = field;
                });
                issueMap.set(issueId, issue);
                setState({
                    issues: issueMap
                });
            },
        reset: ()=>({ setState: setState })=>{
                setState($7b0555560f9c1621$var$initialState);
            },
        removeIssues: (issueIds)=>({ setState: setState, getState: getState })=>{
                const issueMap = new Map(getState().issues);
                issueIds.forEach((issueId)=>{
                    issueMap.delete(issueId);
                });
                setState({
                    issues: issueMap
                });
            }
    }
});
const $7b0555560f9c1621$export$5c02e8fb28d6ca6c = (0, $3sQ5x.createStateHook)($7b0555560f9c1621$export$390f32400eaf98c9);
const $7b0555560f9c1621$export$20586bb841d52702 = (0, $3sQ5x.createActionsHook)($7b0555560f9c1621$export$390f32400eaf98c9);

});

parcelRegister("dxAlC", function(module, exports) {

$parcel$export(module.exports, "useSubtasksByParentId", () => $b2332a31bbaef8de$export$48744da495950c6b);
$parcel$export(module.exports, "useIssues", () => $b2332a31bbaef8de$export$fdf0b908e72b6bef);

var $6dDSs = parcelRequire("6dDSs");
var $3sQ5x = parcelRequire("3sQ5x");

var $cvj5l = parcelRequire("cvj5l");

var $gEtYC = parcelRequire("gEtYC");
const $b2332a31bbaef8de$var$getAssigneesInIssues = (0, $6dDSs.createSelector)((state)=>state.issues, (issues)=>{
    const userMap = new Map();
    issues.forEach((issue)=>{
        if (issue.fields.assignee) {
            const user = issue.fields.assignee.user;
            userMap.set(user.accountId, user);
        }
    });
    return userMap;
});
const $b2332a31bbaef8de$export$d3a21f46315fa5b8 = (0, $3sQ5x.createStateHook)((0, $gEtYC.Store), {
    selector: $b2332a31bbaef8de$var$getAssigneesInIssues
});
const $b2332a31bbaef8de$var$getSubtasksByParentId = (0, $6dDSs.createSelector)((state)=>state.issues, (_, props)=>props.parentId, (issues, parentId)=>Array.from(issues.values()).filter((issue)=>issue.fields[0, $cvj5l.PARENT_ID] && String(parentId) === issue.fields[0, $cvj5l.PARENT_ID].value));
const $b2332a31bbaef8de$export$48744da495950c6b = (0, $3sQ5x.createStateHook)((0, $gEtYC.Store), {
    selector: $b2332a31bbaef8de$var$getSubtasksByParentId
});
const $b2332a31bbaef8de$var$getIssues = (0, $6dDSs.createSelector)((state)=>state.issues, (issues)=>issues);
const $b2332a31bbaef8de$export$fdf0b908e72b6bef = (0, $3sQ5x.createStateHook)((0, $gEtYC.Store), {
    selector: $b2332a31bbaef8de$var$getIssues
});

});

parcelRegister("23CdY", function(module, exports) {

$parcel$export(module.exports, "sortIssuesBy", () => $943d9aeaa521306b$export$6c4fd61382a93216);
$parcel$export(module.exports, "mapWorkflowIssuesToBoardIssues", () => $943d9aeaa521306b$export$fd35f0368f6a9a66);

var $gULOk = parcelRequire("gULOk");

var $cvj5l = parcelRequire("cvj5l");
const $943d9aeaa521306b$export$6c4fd61382a93216 = (fieldId, issues)=>{
    switch(fieldId){
        case 0, $cvj5l.RANK_ID:
            return issues.sort((a, b)=>{
                const aRank = a.fields[0, $cvj5l.RANK_ID]?.value || '';
                const bRank = b.fields[0, $cvj5l.RANK_ID]?.value || '';
                if (aRank < bRank) return -1;
                if (aRank > bRank) return 1;
                return 0;
            });
        default:
            return issues;
    }
};
const $943d9aeaa521306b$export$fd35f0368f6a9a66 = (workflows, handleStatusNotFoundForIssues)=>{
    const statusMap = new Map();
    const issueTypesMap = new Map();
    for (const workflow of workflows){
        for (const column of workflow.columns)statusMap.set(column.statusId, column);
        for (const issueType of workflow.issueTypes)issueTypesMap.set(issueType.id, issueType);
    }
    const issues = [];
    const statusNotFoundCounts = new Map();
    for (const workflow of workflows)for (const issue of workflow.issues){
        const status = statusMap.get(issue.statusId);
        const issueType = issueTypesMap.get(issue.issueTypeId);
        if (!status) {
            statusNotFoundCounts.set(issue.statusId, (statusNotFoundCounts.get(issue.statusId) || 0) + 1);
            continue;
        }
        if (!issueType) throw new Error(`Issue type with id ${issue.issueTypeId} not found`);
        const fields = {
            [(0, $cvj5l.RANK_ID)]: {
                fieldId: (0, $cvj5l.RANK_ID),
                type: (0, $cvj5l.BOARD_FIELD_TEXT),
                value: issue.rank
            },
            [(0, $cvj5l.SUMMARY_ID)]: {
                fieldId: (0, $cvj5l.SUMMARY_ID),
                type: (0, $cvj5l.BOARD_FIELD_TEXT),
                value: issue.summary
            },
            [(0, $cvj5l.ISSUE_KEY_ID)]: {
                fieldId: (0, $cvj5l.ISSUE_KEY_ID),
                type: (0, $cvj5l.BOARD_FIELD_TEXT),
                value: issue.key
            },
            [(0, $cvj5l.ISSUE_TYPE_ID)]: {
                fieldId: (0, $cvj5l.ISSUE_TYPE_ID),
                type: (0, $cvj5l.BOARD_FIELD_ISSUE_TYPE),
                id: issueType.id,
                issueType: issueType
            },
            [(0, $cvj5l.STATUS_ID)]: {
                fieldId: (0, $cvj5l.STATUS_ID),
                type: (0, $cvj5l.BOARD_FIELD_STATUS),
                value: String(status.statusId),
                status: {
                    id: String(status.statusId),
                    name: status.name,
                    statusCategoryId: (0, $gULOk.StatusCategoryIds)[// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    status.statusCategory]
                }
            }
        };
        if (issue.assigneeKey && issue.assigneeName) {
            const assignee = workflow.people[issue.assigneeKey];
            fields[0, $cvj5l.ASSIGNEE_ID] = {
                fieldId: (0, $cvj5l.ASSIGNEE_ID),
                type: (0, $cvj5l.BOARD_FIELD_USER),
                value: assignee.key,
                user: {
                    accountId: assignee.key,
                    name: assignee.displayName,
                    avatarURL: assignee.avatarUrl
                }
            };
        }
        if (issue.priorityId && issue.priorityIconUrl && issue.priorityName) fields[0, $cvj5l.PRIORITY_ID] = {
            fieldId: (0, $cvj5l.PRIORITY_ID),
            type: (0, $cvj5l.BOARD_FIELD_PRIORITY),
            value: issue.priorityId,
            priority: {
                iconUrl: issue.priorityIconUrl,
                id: issue.priorityId,
                name: issue.priorityName
            }
        };
        if (issue.dueDate) fields[0, $cvj5l.DUE_DATE_ID] = {
            fieldId: (0, $cvj5l.DUE_DATE_ID),
            type: (0, $cvj5l.BOARD_FIELD_DATE),
            value: issue.dueDate
        };
        issues.push({
            id: issue.id,
            coverMedia: null,
            fields: fields,
            subtaskMetadata: issue.subtaskMetadata
        });
    }
    if (statusNotFoundCounts.size) handleStatusNotFoundForIssues(statusNotFoundCounts);
    return issues;
};

});

parcelRegister("6xpM6", function(module, exports) {

$parcel$export(module.exports, "useRefetchIssues", () => $d91468370db4703d$export$8b0ce7bde93e400a);
$parcel$export(module.exports, "useRefetchIssuesWithThrow", () => $d91468370db4703d$export$207597c4678856ab);

var $5uXOq = parcelRequire("5uXOq");

var $k8IPx = parcelRequire("k8IPx");

var $6s1PB = parcelRequire("6s1PB");

var $cvj5l = parcelRequire("cvj5l");

var $bkaQA = parcelRequire("bkaQA");

var $gEtYC = parcelRequire("gEtYC");

var $jgcJl = parcelRequire("jgcJl");
const $d91468370db4703d$export$8b0ce7bde93e400a = ()=>{
    const refetchIssuesWithThrow = $d91468370db4703d$export$207597c4678856ab();
    return (0, $5uXOq.useCallback)(async (issueIds)=>{
        try {
            return await refetchIssuesWithThrow(issueIds);
        } catch (error) {
            // do nothing
            return [];
        }
    }, [
        refetchIssuesWithThrow
    ]);
};
const $d91468370db4703d$var$emptySet = new Set();
const $d91468370db4703d$export$207597c4678856ab = ()=>{
    const fetchIssueDetails = (0, $bkaQA.useFetchIssueDetails)();
    const { updateIssues: updateIssues, setIssues: setIssues, removeIssues: removeIssues } = (0, $gEtYC.useIssueStoreActions)();
    let issueTypeIds = $d91468370db4703d$var$emptySet;
    if (!(0, $6s1PB.expVal)('merge_board_workflows', 'enabled', false)) // eslint-disable-next-line react-hooks/rules-of-hooks
    issueTypeIds = (0, $jgcJl.useIssueTypeIds)();
    return (0, $5uXOq.useCallback)(async (issueIds, replace = false)=>{
        const fetchedIssues = await fetchIssueDetails(issueIds);
        const issues = (0, $6s1PB.expVal)('merge_board_workflows', 'enabled', false) ? fetchedIssues : fetchedIssues.filter((issue)=>{
            const issueTypeId = issue.fields[0, $cvj5l.ISSUE_TYPE_ID].issueType.id;
            return issueTypeIds.has(issueTypeId);
        });
        if (replace) setIssues(issues);
        else {
            updateIssues(issues);
            const fetchedIssueIds = issues.map((issue)=>issue.id);
            const removedIssueIds = (0, (/*@__PURE__*/$parcel$interopDefault($k8IPx)))(issueIds, fetchedIssueIds);
            if (removedIssueIds.length > 0) removeIssues(removedIssueIds);
        }
        return issues;
    }, [
        fetchIssueDetails,
        updateIssues,
        setIssues,
        issueTypeIds,
        removeIssues
    ]);
};

});
parcelRegister("bkaQA", function(module, exports) {

$parcel$export(module.exports, "useFetchIssueDetails", () => $a7bfd3129189c374$export$2e8364353306e0d3);

var $5uXOq = parcelRequire("5uXOq");

var $azYnG = parcelRequire("azYnG");

var $daQYX = parcelRequire("daQYX");

var $93jKl = parcelRequire("93jKl");

var $kaHBi = parcelRequire("kaHBi");

var $3bQtK = parcelRequire("3bQtK");

var $3clZk = parcelRequire("3clZk");

var $hqsgn = parcelRequire("hqsgn");

var $7OM52 = parcelRequire("7OM52");
const $a7bfd3129189c374$var$experience = 'loadExtendedBoardData';
const $a7bfd3129189c374$var$CHUNK_SIZE = 100;
const $a7bfd3129189c374$export$2e8364353306e0d3 = ()=>{
    const project = (0, $daQYX.useProject)();
    const fetchIssues = (0, $3clZk.useFetchBoardIssues)();
    const transformToIssues = (0, $hqsgn.useTransformIssues)();
    const fieldIds = (0, $7OM52.useFieldIds)();
    const startExperience = (0, $kaHBi.useExperienceStart)({
        analyticsSource: 'jiraWorkManagementBoard',
        experience: $a7bfd3129189c374$var$experience
    });
    const markExperienceSuccess = (0, $3bQtK.useExperienceSuccess)({
        experience: $a7bfd3129189c374$var$experience
    });
    const markExperienceFailed = (0, $93jKl.useExperienceFail)({
        experience: $a7bfd3129189c374$var$experience
    });
    return (0, $5uXOq.useCallback)(async (issueIds)=>{
        if (!fieldIds.length) return [];
        startExperience();
        try {
            const chunks = (0, (/*@__PURE__*/$parcel$interopDefault($azYnG)))(issueIds, $a7bfd3129189c374$var$CHUNK_SIZE);
            const results = await Promise.all(chunks.map((chunkIssueIds)=>fetchIssues({
                    jql: `project = '${project.id}' AND id in (${chunkIssueIds.join(',')})`,
                    fieldIds: fieldIds
                })));
            markExperienceSuccess();
            return results.reduce((acc, result)=>acc.concat(transformToIssues(result)), []);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            markExperienceFailed('Failed to load issue details', error);
            throw error;
        }
    }, [
        fetchIssues,
        fieldIds,
        markExperienceFailed,
        markExperienceSuccess,
        project.id,
        startExperience,
        transformToIssues
    ]);
};

});
parcelRegister("3clZk", function(module, exports) {

$parcel$export(module.exports, "useFetchBoardIssues", () => $884a41104d90a7ad$export$26780ba8d679f5d);

var $5uXOq = parcelRequire("5uXOq");

var $h4EJ8 = parcelRequire("h4EJ8");

var $5tTFS = parcelRequire("5tTFS");

var $e3a3O = parcelRequire("e3a3O");

var $2YZCu = parcelRequire("2YZCu");

var $8Wswo = parcelRequire("8Wswo");

var $5fc53 = parcelRequire("5fc53");

var $koeKL = parcelRequire("koeKL");

var $cvj5l = parcelRequire("cvj5l");

var $4ty7u = parcelRequire("4ty7u");
const $884a41104d90a7ad$var$ITEMS_PER_PAGE = 100;
const $884a41104d90a7ad$var$getErrorMessages = (errors)=>(0, (/*@__PURE__*/$parcel$interopDefault($h4EJ8)))((errors || []).map((error)=>error.message).filter(Boolean).join(', '), {
        length: 50
    });
const $884a41104d90a7ad$export$26780ba8d679f5d = ()=>{
    const client = (0, $5tTFS.useApolloClient)();
    const cloudId = (0, $koeKL.useCloudId)();
    return (0, $5uXOq.useCallback)(async ({ jql: jql, fieldIds: fieldIdsInput })=>{
        const fieldIds = new Set(fieldIdsInput);
        const withChildrenCount = fieldIds.has((0, $5fc53.SUBTASKS_TYPE));
        fieldIds.delete((0, $5fc53.SUBTASKS_TYPE));
        const withIssueLinks = fieldIds.has((0, $5fc53.ISSUE_LINKS_TYPE));
        fieldIds.delete((0, $5fc53.ISSUE_LINKS_TYPE));
        const withCoverMedia = fieldIds.has((0, $cvj5l.CARD_COVER));
        fieldIds.delete((0, $cvj5l.CARD_COVER));
        const withConfluenceLinks = fieldIds.has((0, $cvj5l.PAGES));
        fieldIds.delete((0, $cvj5l.PAGES));
        const variables = {
            fieldIds: Array.from(fieldIds),
            first: $884a41104d90a7ad$var$ITEMS_PER_PAGE,
            jql: jql,
            withConfluenceLinks: withConfluenceLinks,
            withCoverMedia: withCoverMedia,
            cloudId: cloudId,
            withIssueLinks: withIssueLinks,
            withChildrenCount: withChildrenCount
        };
        const response = await client.query({
            query: (0, $4ty7u.JIS2_JWMBoardItemsQuery),
            fetchPolicy: 'no-cache',
            errorPolicy: 'all',
            variables: variables
        });
        if (!response) throw new Error('No issue response');
        if (response.errors) {
            const apolloError = new (0, $e3a3O.ApolloError)({
                graphQLErrors: response.errors
            });
            (0, $2YZCu.default).safeErrorWithoutCustomerData('board-issues.fetch-board-issues', `Error fetching board-issues (response with errors). Error details: ${$884a41104d90a7ad$var$getErrorMessages(response.errors)}`);
            if ((0, $8Wswo.shouldHandleTheError)(apolloError)) throw apolloError;
        }
        const responseData = response.data?.jira?.jwmViewItems;
        // successful response
        if (responseData?.__typename === 'JiraWorkManagementViewItemConnection' && responseData.edges != null) return responseData.edges.map((edge)=>edge?.node).filter((node)=>node != null);
        // error cases
        if (responseData?.__typename !== 'JiraWorkManagementViewItemConnection') {
            (0, $2YZCu.default).safeErrorWithoutCustomerData('board-issues.fetch-board-issues', `Error fetching board-issues (typename ${responseData?.__typename}). Error details: "${responseData?.message})}"`);
            throw new Error(`Invalid issue response (typename): ${responseData?.__typename}`);
        }
        if (responseData.edges == null) {
            (0, $2YZCu.default).safeErrorWithoutCustomerData('board-issues.fetch-board-issues', `Error fetching board-issues (nullable edges). Error details: ${$884a41104d90a7ad$var$getErrorMessages(response.errors)}`);
            throw new Error('Invalid issue response (nullable edges)');
        }
        throw new Error('Invalid issue response');
    }, [
        client,
        cloudId
    ]);
};

});
parcelRegister("h4EJ8", function(module, exports) {

var $kHBB0 = parcelRequire("kHBB0");

var $gvFfr = parcelRequire("gvFfr");

var $axH2S = parcelRequire("axH2S");

var $k0qYG = parcelRequire("k0qYG");

var $cErmc = parcelRequire("cErmc");

var $ifYxh = parcelRequire("ifYxh");

var $jx6Tp = parcelRequire("jx6Tp");

var $kPZpS = parcelRequire("kPZpS");

var $jJVtR = parcelRequire("jJVtR");
/** Used as default options for `_.truncate`. */ var $c6e266ef199f8e9f$var$DEFAULT_TRUNC_LENGTH = 30, $c6e266ef199f8e9f$var$DEFAULT_TRUNC_OMISSION = '...';
/** Used to match `RegExp` flags from their coerced string values. */ var $c6e266ef199f8e9f$var$reFlags = /\w*$/;
/**
 * Truncates `string` if it's longer than the given maximum string length.
 * The last characters of the truncated string are replaced with the omission
 * string which defaults to "...".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to truncate.
 * @param {Object} [options={}] The options object.
 * @param {number} [options.length=30] The maximum string length.
 * @param {string} [options.omission='...'] The string to indicate text is omitted.
 * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
 * @returns {string} Returns the truncated string.
 * @example
 *
 * _.truncate('hi-diddly-ho there, neighborino');
 * // => 'hi-diddly-ho there, neighbo...'
 *
 * _.truncate('hi-diddly-ho there, neighborino', {
 *   'length': 24,
 *   'separator': ' '
 * });
 * // => 'hi-diddly-ho there,...'
 *
 * _.truncate('hi-diddly-ho there, neighborino', {
 *   'length': 24,
 *   'separator': /,? +/
 * });
 * // => 'hi-diddly-ho there...'
 *
 * _.truncate('hi-diddly-ho there, neighborino', {
 *   'omission': ' [...]'
 * });
 * // => 'hi-diddly-ho there, neig [...]'
 */ function $c6e266ef199f8e9f$var$truncate(string, options) {
    var length = $c6e266ef199f8e9f$var$DEFAULT_TRUNC_LENGTH, omission = $c6e266ef199f8e9f$var$DEFAULT_TRUNC_OMISSION;
    if ($k0qYG(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? $kPZpS(options.length) : length;
        omission = 'omission' in options ? $kHBB0(options.omission) : omission;
    }
    string = $jJVtR(string);
    var strLength = string.length;
    if ($axH2S(string)) {
        var strSymbols = $jx6Tp(string);
        strLength = strSymbols.length;
    }
    if (length >= strLength) return string;
    var end = length - $ifYxh(omission);
    if (end < 1) return omission;
    var result = strSymbols ? $gvFfr(strSymbols, 0, end).join('') : string.slice(0, end);
    if (separator === undefined) return result + omission;
    if (strSymbols) end += result.length - end;
    if ($cErmc(separator)) {
        if (string.slice(end).search(separator)) {
            var match, substring = result;
            if (!separator.global) separator = RegExp(separator.source, $jJVtR($c6e266ef199f8e9f$var$reFlags.exec(separator)) + 'g');
            separator.lastIndex = 0;
            while(match = separator.exec(substring))var newEnd = match.index;
            result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
    } else if (string.indexOf($kHBB0(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) result = result.slice(0, index);
    }
    return result + omission;
}
module.exports = $c6e266ef199f8e9f$var$truncate;

});
parcelRegister("cErmc", function(module, exports) {

var $3euyi = parcelRequire("3euyi");

var $cW28x = parcelRequire("cW28x");

var $lMQGH = parcelRequire("lMQGH");
/* Node.js helper references. */ var $935e70fe57caa939$var$nodeIsRegExp = $lMQGH && $lMQGH.isRegExp;
/**
 * Checks if `value` is classified as a `RegExp` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
 * @example
 *
 * _.isRegExp(/abc/);
 * // => true
 *
 * _.isRegExp('/abc/');
 * // => false
 */ var $935e70fe57caa939$var$isRegExp = $935e70fe57caa939$var$nodeIsRegExp ? $cW28x($935e70fe57caa939$var$nodeIsRegExp) : $3euyi;
module.exports = $935e70fe57caa939$var$isRegExp;

});
parcelRegister("3euyi", function(module, exports) {

var $beQoo = parcelRequire("beQoo");

var $fC1Kz = parcelRequire("fC1Kz");
/** `Object#toString` result references. */ var $25aa60f3dfdc1028$var$regexpTag = '[object RegExp]';
/**
 * The base implementation of `_.isRegExp` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
 */ function $25aa60f3dfdc1028$var$baseIsRegExp(value) {
    return $fC1Kz(value) && $beQoo(value) == $25aa60f3dfdc1028$var$regexpTag;
}
module.exports = $25aa60f3dfdc1028$var$baseIsRegExp;

});


parcelRegister("ifYxh", function(module, exports) {

var $dkmPN = parcelRequire("dkmPN");

var $axH2S = parcelRequire("axH2S");

var $61ekh = parcelRequire("61ekh");
/**
 * Gets the number of symbols in `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the string size.
 */ function $d4a895dd16218f22$var$stringSize(string) {
    return $axH2S(string) ? $61ekh(string) : $dkmPN(string);
}
module.exports = $d4a895dd16218f22$var$stringSize;

});
parcelRegister("dkmPN", function(module, exports) {

var $8hdQS = parcelRequire("8hdQS");
/**
 * Gets the size of an ASCII `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */ var $9b3edb0cff432526$var$asciiSize = $8hdQS('length');
module.exports = $9b3edb0cff432526$var$asciiSize;

});

parcelRegister("61ekh", function(module, exports) {
/** Used to compose unicode character classes. */ var $461df2ef275f3803$var$rsAstralRange = '\\ud800-\\udfff', $461df2ef275f3803$var$rsComboMarksRange = '\\u0300-\\u036f', $461df2ef275f3803$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $461df2ef275f3803$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $461df2ef275f3803$var$rsComboRange = $461df2ef275f3803$var$rsComboMarksRange + $461df2ef275f3803$var$reComboHalfMarksRange + $461df2ef275f3803$var$rsComboSymbolsRange, $461df2ef275f3803$var$rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var $461df2ef275f3803$var$rsAstral = '[' + $461df2ef275f3803$var$rsAstralRange + ']', $461df2ef275f3803$var$rsCombo = '[' + $461df2ef275f3803$var$rsComboRange + ']', $461df2ef275f3803$var$rsFitz = '\\ud83c[\\udffb-\\udfff]', $461df2ef275f3803$var$rsModifier = '(?:' + $461df2ef275f3803$var$rsCombo + '|' + $461df2ef275f3803$var$rsFitz + ')', $461df2ef275f3803$var$rsNonAstral = '[^' + $461df2ef275f3803$var$rsAstralRange + ']', $461df2ef275f3803$var$rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', $461df2ef275f3803$var$rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', $461df2ef275f3803$var$rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var $461df2ef275f3803$var$reOptMod = $461df2ef275f3803$var$rsModifier + '?', $461df2ef275f3803$var$rsOptVar = '[' + $461df2ef275f3803$var$rsVarRange + ']?', $461df2ef275f3803$var$rsOptJoin = '(?:' + $461df2ef275f3803$var$rsZWJ + '(?:' + [
    $461df2ef275f3803$var$rsNonAstral,
    $461df2ef275f3803$var$rsRegional,
    $461df2ef275f3803$var$rsSurrPair
].join('|') + ')' + $461df2ef275f3803$var$rsOptVar + $461df2ef275f3803$var$reOptMod + ')*', $461df2ef275f3803$var$rsSeq = $461df2ef275f3803$var$rsOptVar + $461df2ef275f3803$var$reOptMod + $461df2ef275f3803$var$rsOptJoin, $461df2ef275f3803$var$rsSymbol = '(?:' + [
    $461df2ef275f3803$var$rsNonAstral + $461df2ef275f3803$var$rsCombo + '?',
    $461df2ef275f3803$var$rsCombo,
    $461df2ef275f3803$var$rsRegional,
    $461df2ef275f3803$var$rsSurrPair,
    $461df2ef275f3803$var$rsAstral
].join('|') + ')';
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var $461df2ef275f3803$var$reUnicode = RegExp($461df2ef275f3803$var$rsFitz + '(?=' + $461df2ef275f3803$var$rsFitz + ')|' + $461df2ef275f3803$var$rsSymbol + $461df2ef275f3803$var$rsSeq, 'g');
/**
 * Gets the size of a Unicode `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */ function $461df2ef275f3803$var$unicodeSize(string) {
    var result = $461df2ef275f3803$var$reUnicode.lastIndex = 0;
    while($461df2ef275f3803$var$reUnicode.test(string))++result;
    return result;
}
module.exports = $461df2ef275f3803$var$unicodeSize;

});



parcelRegister("4ty7u", function(module, exports) {

$parcel$export(module.exports, "JIS2_JWMBOARD_CONFLUENCE_LINKS_FRAGMENT", () => $be924fd3fa0f033e$export$9ed9a1cb8188c743);
$parcel$export(module.exports, "JIS2_JWMBOARD_ISSUE_LINKS_FRAGMENT", () => $be924fd3fa0f033e$export$cb794cef9d65b633);
$parcel$export(module.exports, "JIS2_JWMBOARD_ITEM_COVER_MEDIA_FRAGMENT", () => $be924fd3fa0f033e$export$832c0260442bf18d);
$parcel$export(module.exports, "JIS2_JWMBOARD_ITEM_FRAGMENT", () => $be924fd3fa0f033e$export$8a4c8763de723c1b);
$parcel$export(module.exports, "JIS2_JWMBoardItemsQuery", () => $be924fd3fa0f033e$export$aeea67f0727d06fb);

var $5cllN = parcelRequire("5cllN");
const $be924fd3fa0f033e$export$9ed9a1cb8188c743 = (0, $5cllN.default)`
fragment JIS2_JWMBoardConfluenceLinksFragment on JiraWorkManagementViewItem {
  legacyConfluenceLinks (getFirstOnly: true) {
    linkedConfluencePages {
      pageCount
    }
  }
}
`;
const $be924fd3fa0f033e$export$cb794cef9d65b633 = (0, $5cllN.default)`
fragment JIS2_JWMBoardIssueLinksFragment on JiraWorkManagementViewItem {
  issueLinks(first: 10) {
    edges {
      node {
        issue {
          issueId
        }
      }
    }
  }
}
`;
const $be924fd3fa0f033e$var$JIS2_JWMBOARD_ACCOUNT_FRAGMENT = (0, $5cllN.default)`
fragment JIS2_JWMBoardAccountFragment on AtlassianAccountUser {
  accountId
  name
  picture
}
`;
const $be924fd3fa0f033e$var$JIS2_JWMBOARD_USER_FRAGMENT = (0, $5cllN.default)`
fragment JIS2_JWMBoardUserFragment on JiraUserConnection {
  edges {
    node {
      ...JIS2_JWMBoardAccountFragment
    }
  }
}
${$be924fd3fa0f033e$var$JIS2_JWMBOARD_ACCOUNT_FRAGMENT}
`;
const $be924fd3fa0f033e$export$832c0260442bf18d = (0, $5cllN.default)`
fragment JIS2_JWMBoardItemCoverMediaFragment on JiraWorkManagementViewItem {
  coverMedia {
    ... on JiraWorkManagementColorBackground {
      entityId
      colorValue
    }
    ... on JiraWorkManagementGradientBackground {
      entityId
      gradientValue
    }
    ... on JiraWorkManagementAttachmentBackground {
        entityId
        attachment {
            attachmentId
            mediaReadToken(durationInSeconds: 900, maxTokenLength: 65534)
            fileName
            mediaApiFileId
            __typename
            # Helpful for determining the source of the attachment, such as Unsplash so that we can attribute the source
            ... on JiraPlatformAttachment {
                sourceType: attachmentProperty(key: "sourceType")
                sourceIdentifier: attachmentProperty(key: "sourceIdentifier")
            }
        }
    }
		... on JiraWorkManagementMediaBackground {
			customBackground {
				id
				mediaApiFileId
				mediaReadToken(durationInSeconds: 900)
				altText
				sourceType
				sourceIdentifier
			}
		}
  }
}`;
const $be924fd3fa0f033e$export$8a4c8763de723c1b = (0, $5cllN.default)`
fragment JIS2_JWMBoardItemFragment on JiraWorkManagementViewItem {
  id
  issueId
  fieldsByIdOrAlias(idsOrAliases: $fieldIds, ignoreMissingFields: true) {
    __typename
    fieldId
    name
    ... on JiraSingleLineTextField {
      text
      type
    }
    ... on JiraLabelsField {
      selectedLabelsConnection {
        edges {
          node {
            name,
          }
        }
      }
    }
    ... on JiraSingleSelectUserPickerField {
      user {
        ... JIS2_JWMBoardAccountFragment
      }
    }
    ... on JiraDatePickerField {
      date
    }
    ... on JiraDateTimePickerField {
      dateTime
    }
    ... on JiraComponentsField {
      selectedComponentsConnection {
        edges {
          node {
            name
          }
        }
      }
    }
    ... on JiraOriginalTimeEstimateField {
      originalEstimate {
        timeInSeconds
      }
    }
    ... on JiraSingleSelectField {
      type
      fieldOption {
        optionId
        value
        color {
          colorKey
        }
      }
    }
    ... on JiraMultipleSelectField {
      selectedOptions {
        edges {
          node {
            value
          }
        }
      }
    }
    ... on JiraNumberField {
      number
    }
    ... on JiraMultipleSelectUserPickerField {
      selectedUsersConnection {
        ...JIS2_JWMBoardUserFragment
      }
    }
    ... on JiraPeopleField {
      selectedUsersConnection {
        ... JIS2_JWMBoardUserFragment
      }
    }
    ... on JiraTimeTrackingField {
      originalEstimate {
        timeInSeconds
      }
      timeTrackingSettings {
        defaultUnit
        defaultFormat
        workingHoursPerDay
        workingDaysPerWeek
      }
    }
    ... on JiraStatusField {
      status {
        name
        statusId
        statusCategory {
          statusCategoryId
        }
      }
    }
    ... on JiraIssueTypeField {
      issueType {
        issueTypeId
        name
        avatar {
          medium
        }
        hierarchy {
          level
        }
      }
    }
    ... on JiraPriorityField {
      priority {
        iconUrl
        name
        priorityId
      }
    }
    ... on JiraParentIssueField {
      parentIssue {
        issueId
        key
        summaryField {
          text
        }
      }
    }
  },
  childrenTotal: childSummary(includeDone:true) @include(if: $withChildrenCount) {
    totalCount,
  }
  childrenNotDone: childSummary(includeDone:false) @include(if: $withChildrenCount) {
    totalCount,
  }
}
${$be924fd3fa0f033e$var$JIS2_JWMBOARD_ACCOUNT_FRAGMENT}
${$be924fd3fa0f033e$var$JIS2_JWMBOARD_USER_FRAGMENT}
`;
const $be924fd3fa0f033e$export$aeea67f0727d06fb = (0, $5cllN.default)`
query JIS2JWMBoardItems($cloudId: ID!, $jql: String!, $fieldIds: [String]!, $first: Int, $after: String, $withConfluenceLinks: Boolean!, $withCoverMedia: Boolean!, $withIssueLinks: Boolean!, $withChildrenCount: Boolean!) {
  jira {
    jwmViewItems(cloudId: $cloudId, jql: $jql, first: $first, after: $after) @connection (key: "boardJIS", filter:["jql"]) {
      __typename
      ... on QueryError {
          message
          extensions {
              statusCode
              errorType
          }
      }
      ... on JiraWorkManagementViewItemConnection {
        edges {
          node {
            ...JIS2_JWMBoardItemFragment
            ...JIS2_JWMBoardConfluenceLinksFragment @include(if: $withConfluenceLinks)
            ...JIS2_JWMBoardItemCoverMediaFragment @include(if: $withCoverMedia)
            ...JIS2_JWMBoardIssueLinksFragment @include(if: $withIssueLinks)
          }
        }
      }
    }
  }
}
${$be924fd3fa0f033e$export$8a4c8763de723c1b}
${$be924fd3fa0f033e$export$9ed9a1cb8188c743}
${$be924fd3fa0f033e$export$832c0260442bf18d}
${$be924fd3fa0f033e$export$cb794cef9d65b633}
`;

});


parcelRegister("hqsgn", function(module, exports) {

$parcel$export(module.exports, "transformCoverMedia", () => $03252bedb57d8f6f$export$2c47b714cdbd1e2a);
$parcel$export(module.exports, "useTransformIssues", () => $03252bedb57d8f6f$export$3746553fffc661a3);

var $5uXOq = parcelRequire("5uXOq");

var $hE5wF = parcelRequire("hE5wF");

var $2Igls = parcelRequire("2Igls");

var $koVbs = parcelRequire("koVbs");

var $5fc53 = parcelRequire("5fc53");

var $etKNj = parcelRequire("etKNj");

var $cvj5l = parcelRequire("cvj5l");

var $8pUMB = parcelRequire("8pUMB");
const $03252bedb57d8f6f$var$transformers = {
    [(0, $5fc53.TEXT_GQL_FIELD)]: (field)=>{
        if (field.__typename !== (0, $5fc53.TEXT_GQL_FIELD) || field.text == null) return null;
        return {
            type: (0, $cvj5l.BOARD_FIELD_TEXT),
            fieldId: field.fieldId,
            name: field.name,
            value: field.text
        };
    },
    [(0, $5fc53.COMPONENTS_GQL_FIELD)]: (field)=>{
        if (field.__typename !== (0, $5fc53.COMPONENTS_GQL_FIELD)) return null;
        const value = field.selectedComponentsConnection?.edges?.map((edge)=>edge?.node?.name ?? null).filter((name)=>name != null);
        if (value == null || value.length === 0) return null;
        return {
            type: (0, $cvj5l.BOARD_FIELD_COMPONENTS),
            fieldId: field.fieldId,
            name: field.name,
            value: value
        };
    },
    [(0, $5fc53.LABEL_GQL_FIELD)]: (field)=>{
        if (field.__typename !== (0, $5fc53.LABEL_GQL_FIELD) || field.selectedLabelsConnection == null) return null;
        const value = field.selectedLabelsConnection.edges?.map((edge)=>edge?.node?.name ?? null).filter((name)=>name != null);
        if (value == null || value.length === 0) return null;
        return {
            type: (0, $cvj5l.BOARD_FIELD_LABEL),
            fieldId: field.fieldId,
            value: value
        };
    },
    [(0, $5fc53.ORIGINAL_ESTIMATE_GQL_FIELD)]: (field, timeTrackingConfig, intl)=>{
        if (field.__typename !== (0, $5fc53.ORIGINAL_ESTIMATE_GQL_FIELD) || field.originalEstimate?.timeInSeconds == null) return null;
        if (!timeTrackingConfig || !intl) // if timeTrackingConfig is not available, return the original estimate in seconds
        return {
            type: (0, $cvj5l.BOARD_FIELD_TIME_ORIGINAL_ESTIMATE),
            fieldId: field.fieldId,
            name: field.name,
            value: field.originalEstimate.timeInSeconds
        };
        const { workingDaysPerWeek: workingDaysPerWeek, workingHoursPerDay: workingHoursPerDay, defaultFormat: timeFormat, defaultUnit: defaultUnit } = timeTrackingConfig;
        return {
            type: (0, $cvj5l.BOARD_FIELD_TIME_ORIGINAL_ESTIMATE),
            fieldId: field.fieldId,
            name: field.name,
            value: (0, $etKNj.timeTrackingFormatter)(field.originalEstimate.timeInSeconds, {
                workingHoursPerDay: workingHoursPerDay,
                workingDaysPerWeek: workingDaysPerWeek,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                timeFormat: timeFormat.toLowerCase() ?? (0, $2Igls.PRETTY),
                defaultUnit: defaultUnit
            }, intl)
        };
    },
    [(0, $5fc53.DATE_PICKER_GQL_FIELD)]: (field)=>{
        if (field.__typename !== (0, $5fc53.DATE_PICKER_GQL_FIELD) || field.date == null) return null;
        return {
            type: (0, $cvj5l.BOARD_FIELD_DATE),
            fieldId: field.fieldId,
            name: field.name,
            value: field.date
        };
    },
    [(0, $5fc53.SINGLE_SELECT_GQL_FIELD)]: (field)=>{
        if (field.__typename !== (0, $5fc53.SINGLE_SELECT_GQL_FIELD) || field.fieldOption?.value == null) return null;
        if (field.__typename === (0, $5fc53.SINGLE_SELECT_GQL_FIELD) && field.type === (0, $5fc53.CATEGORY_TYPE) && field.fieldOption?.value != null) return {
            fieldId: field.fieldId,
            name: field.name,
            type: (0, $cvj5l.BOARD_FIELD_CATEGORY),
            value: field.fieldOption.optionId,
            category: {
                name: field.fieldOption.value,
                color: field.fieldOption.color?.colorKey ?? null
            }
        };
        return {
            type: (0, $cvj5l.BOARD_FIELD_SELECT),
            fieldId: field.fieldId,
            name: field.name,
            value: [
                field.fieldOption.value
            ]
        };
    },
    [(0, $5fc53.DATE_TIME_GQL_FIELD)]: (field)=>{
        if (field.__typename !== (0, $5fc53.DATE_TIME_GQL_FIELD) || field.dateTime == null) return null;
        return {
            type: (0, $cvj5l.BOARD_FIELD_DATE_TIME),
            fieldId: field.fieldId,
            name: field.name,
            value: field.dateTime
        };
    },
    [(0, $5fc53.NUMBER_GQL_FIELD)]: (field)=>{
        if (field.__typename !== (0, $5fc53.NUMBER_GQL_FIELD) || field.number == null) return null;
        return {
            type: (0, $cvj5l.BOARD_FIELD_FLOAT),
            fieldId: field.fieldId,
            name: field.name,
            value: field.number
        };
    },
    [(0, $5fc53.USER_PICKER_GQL_FIELD)]: (field)=>{
        if (field.__typename !== (0, $5fc53.USER_PICKER_GQL_FIELD) || field.user == null) return null;
        return {
            type: (0, $cvj5l.BOARD_FIELD_USER),
            fieldId: field.fieldId,
            name: field.name,
            value: field.user.accountId,
            user: {
                accountId: field.user.accountId,
                name: field.user.name,
                avatarURL: field.user.picture
            }
        };
    },
    [(0, $5fc53.MULTI_USER_PICKER_GQL_FIELD)]: (field)=>{
        if (field.__typename !== (0, $5fc53.MULTI_USER_PICKER_GQL_FIELD)) return null;
        const users = field.selectedUsersConnection?.edges?.map((edge)=>edge?.node).filter((user)=>user != null).map((user)=>({
                accountId: user.accountId,
                name: user.name,
                avatarURL: user.picture
            }));
        if (users == null || users.length < 1) return null;
        return {
            type: (0, $cvj5l.BOARD_FIELD_MULTI_USER),
            fieldId: field.fieldId,
            name: field.name,
            users: users
        };
    },
    [(0, $5fc53.MULTI_SELECT_GQL_FIELD)]: (field)=>{
        if (field.__typename !== (0, $5fc53.MULTI_SELECT_GQL_FIELD)) return null;
        const value = field.selectedOptions?.edges?.map((edge)=>edge?.node).map((node)=>node?.value).filter(// eslint-disable-next-line @typescript-eslint/no-invalid-void-type
        (optionValue)=>optionValue != null);
        if (value == null || value.length < 1) return null;
        return {
            type: (0, $cvj5l.BOARD_FIELD_SELECT),
            fieldId: field.fieldId,
            name: field.name,
            value: value
        };
    },
    [(0, $5fc53.PEOPLE_GQL_FIELD)]: (field)=>{
        if (field.__typename !== (0, $5fc53.PEOPLE_GQL_FIELD)) return null;
        const users = field.selectedUsersConnection?.edges?.map((edge)=>edge?.node).filter((user)=>user != null).map((user)=>({
                accountId: user.accountId,
                name: user.name,
                avatarURL: user.picture
            }));
        if (users == null || users.length < 1) return null;
        return {
            type: (0, $cvj5l.BOARD_FIELD_MULTI_USER),
            fieldId: field.fieldId,
            name: field.name,
            users: users
        };
    },
    [(0, $5fc53.PARENT_GQL_FIELD)]: (field)=>{
        if (field.__typename !== (0, $5fc53.PARENT_GQL_FIELD) || field.parentIssue == null) return null;
        return {
            type: (0, $cvj5l.BOARD_FIELD_PARENT),
            fieldId: field.fieldId,
            name: field.name,
            value: field.parentIssue.issueId,
            parent: {
                key: field.parentIssue.key,
                summary: field.parentIssue.summaryField?.text ?? ''
            }
        };
    },
    [(0, $5fc53.STATUS_GQL_FIELD)]: (field)=>{
        if (field.__typename !== (0, $5fc53.STATUS_GQL_FIELD) || field.status.name == null || field.status.statusCategory?.statusCategoryId == null || field.status.statusId == null) return null;
        return {
            type: (0, $cvj5l.BOARD_FIELD_STATUS),
            fieldId: field.fieldId,
            name: field.name,
            value: field.status.statusId,
            status: {
                id: field.status.statusId,
                name: field.status.name,
                statusCategoryId: Number(field.status.statusCategory.statusCategoryId)
            }
        };
    },
    [(0, $5fc53.ISSUE_TYPE_GQL_FIELD)]: (field)=>{
        if (field.__typename !== (0, $5fc53.ISSUE_TYPE_GQL_FIELD) || field.issueType?.issueTypeId == null || field.issueType.name == null || field.issueType.hierarchy?.level == null) return null;
        return {
            type: (0, $cvj5l.BOARD_FIELD_ISSUE_TYPE),
            fieldId: field.fieldId,
            name: field.name,
            id: field.issueType.issueTypeId,
            issueType: {
                id: field.issueType.issueTypeId,
                name: field.issueType.name,
                iconUrl: field.issueType.avatar?.medium ?? '',
                hierarchyLevel: field.issueType.hierarchy.level
            }
        };
    },
    [(0, $5fc53.PRIORITY_GQL_FIELD)]: (field)=>{
        if (field.__typename !== (0, $5fc53.PRIORITY_GQL_FIELD) || field.priority?.iconUrl == null || field.priority?.name == null || field.priority?.priorityId == null) return null;
        return {
            type: (0, $cvj5l.BOARD_FIELD_PRIORITY),
            fieldId: field.fieldId,
            name: field.name,
            value: field.priority.priorityId,
            priority: {
                iconUrl: field.priority.iconUrl,
                id: field.priority.priorityId,
                name: field.priority.name
            }
        };
    }
};
const $03252bedb57d8f6f$var$transformField = (field, timeTrackingConfig, intl)=>{
    if (field == null) return null;
    if (field.__typename in $03252bedb57d8f6f$var$transformers) return $03252bedb57d8f6f$var$transformers[field.__typename](field, timeTrackingConfig, intl);
    return null;
};
const $03252bedb57d8f6f$var$extractTimeTrackingConfig = (issueDetail)=>{
    const timetracking = issueDetail.fieldsByIdOrAlias?.find((field)=>field?.__typename === (0, $5fc53.TIME_TRACKING_GQL_FIELD));
    if (timetracking && 'timeTrackingSettings' in timetracking && timetracking.timeTrackingSettings?.workingHoursPerDay != null && timetracking.timeTrackingSettings?.workingDaysPerWeek != null && timetracking.timeTrackingSettings?.defaultUnit != null) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return timetracking.timeTrackingSettings;
    return null;
};
const $03252bedb57d8f6f$export$2c47b714cdbd1e2a = (coverMedia)=>{
    if (!coverMedia) return null;
    if (coverMedia.__typename === 'JiraWorkManagementColorBackground') {
        if (coverMedia.colorValue == null) return null;
        return {
            type: 'color',
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            value: coverMedia.colorValue
        };
    }
    if (coverMedia.__typename === 'JiraWorkManagementGradientBackground') {
        if (coverMedia.gradientValue == null) return null;
        return {
            type: 'gradient',
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            value: coverMedia.gradientValue
        };
    }
    /**
   * Images from the trello importer that use the JiraAttachmentBackground
   * instead of the JiraMediaBackground
   */ if (coverMedia.__typename === 'JiraWorkManagementAttachmentBackground') {
        const { fileName: fileName, mediaApiFileId: mediaApiFileId, mediaReadToken: mediaReadToken } = coverMedia.attachment ?? {};
        if (fileName == null || mediaApiFileId == null || mediaReadToken == null) return null;
        let unsplashId = null;
        const unsplashAttachment = coverMedia.attachment?.__typename === 'JiraPlatformAttachment' ? coverMedia.attachment : null;
        if (unsplashAttachment?.sourceType === 'UNSPLASH' && unsplashAttachment?.sourceIdentifier != null) unsplashId = unsplashAttachment.sourceIdentifier;
        return {
            type: 'image',
            fileName: fileName,
            mediaApiFileId: mediaApiFileId,
            mediaReadToken: mediaReadToken,
            unsplashId: unsplashId
        };
    }
    if (coverMedia.__typename === 'JiraWorkManagementMediaBackground') {
        const { altText: altText, mediaApiFileId: mediaApiFileId, mediaReadToken: mediaReadToken, sourceIdentifier: sourceIdentifier } = coverMedia.customBackground ?? {};
        if (mediaApiFileId == null || mediaReadToken == null || sourceIdentifier == null) return null;
        return {
            type: 'image',
            fileName: altText ?? 'Unsplash image',
            mediaApiFileId: mediaApiFileId,
            mediaReadToken: mediaReadToken,
            unsplashId: sourceIdentifier
        };
    }
    return null;
};
const $03252bedb57d8f6f$export$3746553fffc661a3 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return (0, $5uXOq.useCallback)((issueDetails)=>{
        const transformedIssues = [];
        issueDetails.forEach((issueDetail)=>{
            if (!issueDetail.fieldsByIdOrAlias) return;
            const decodedFields = {};
            // required fields
            let issueTypeField = null;
            let issueKeyField = null;
            let statusField = null;
            let summaryField = null;
            // the rank field defaults to an empty rank string
            let rankField = {
                type: (0, $cvj5l.BOARD_FIELD_TEXT),
                fieldId: (0, $5fc53.RANK_CF_TYPE),
                name: '',
                value: ''
            };
            const timeTrackingConfig = $03252bedb57d8f6f$var$extractTimeTrackingConfig(issueDetail);
            issueDetail.fieldsByIdOrAlias?.forEach((field)=>{
                const transformedField = $03252bedb57d8f6f$var$transformField(field, timeTrackingConfig, {
                    formatMessage: formatMessage
                });
                if (transformedField == null) return;
                switch(transformedField.type){
                    case 0, $cvj5l.BOARD_FIELD_ISSUE_TYPE:
                        issueTypeField = transformedField;
                        break;
                    case 0, $cvj5l.BOARD_FIELD_STATUS:
                        statusField = transformedField;
                        break;
                    case 0, $cvj5l.BOARD_FIELD_CATEGORY:
                        decodedFields[0, $cvj5l.CATEGORY_ID] = transformedField;
                        break;
                    case 0, $cvj5l.BOARD_FIELD_LABEL:
                        decodedFields[0, $cvj5l.LABEL_ID] = transformedField;
                        break;
                    case 0, $cvj5l.BOARD_FIELD_PARENT:
                        decodedFields[0, $cvj5l.PARENT_ID] = transformedField;
                        break;
                    case 0, $cvj5l.BOARD_FIELD_TEXT:
                        if (field && field.__typename === (0, $5fc53.TEXT_GQL_FIELD) && field.type === (0, $5fc53.RANK_CF_TYPE)) {
                            rankField = transformedField;
                            break;
                        } else if (field && field.__typename === (0, $5fc53.TEXT_GQL_FIELD) && field.type === (0, $5fc53.SUMMARY_TYPE)) {
                            summaryField = transformedField;
                            break;
                        } else if (field && field.__typename === (0, $5fc53.TEXT_GQL_FIELD) && field.type === (0, $5fc53.ISSUE_KEY_TYPE)) {
                            issueKeyField = transformedField;
                            break;
                        }
                        decodedFields[transformedField.fieldId] = transformedField;
                        break;
                    default:
                        decodedFields[transformedField.fieldId] = transformedField;
                }
            });
            if (issueDetail.legacyConfluenceLinks?.linkedConfluencePages?.pageCount != null) decodedFields[0, $hE5wF.REMOTE_ISSUE_LINKS_TYPE] = {
                type: (0, $cvj5l.BOARD_FIELD_CONFLUENCE_PAGES_COUNT),
                fieldId: 'remoteIssueLinks',
                value: issueDetail.legacyConfluenceLinks.linkedConfluencePages.pageCount
            };
            if (issueDetail.issueLinks?.edges) decodedFields[0, $5fc53.ISSUE_LINKS_TYPE] = {
                type: (0, $cvj5l.BOARD_FIELD_ISSUE_LINKS_COUNT),
                fieldId: (0, $5fc53.ISSUE_LINKS_TYPE),
                value: issueDetail.issueLinks.edges.filter(Boolean).length ?? 0
            };
            // if we are missing any of the required fields, we skip this issue
            if (issueTypeField == null || issueKeyField == null || statusField == null || summaryField == null) return;
            const fields = {
                ...decodedFields,
                [(0, $cvj5l.ISSUE_TYPE_ID)]: issueTypeField,
                [(0, $cvj5l.ISSUE_KEY_ID)]: issueKeyField,
                [(0, $cvj5l.RANK_ID)]: rankField,
                [(0, $cvj5l.STATUS_ID)]: statusField,
                [(0, $cvj5l.SUMMARY_ID)]: summaryField
            };
            const newIssue = {
                id: issueDetail.issueId,
                fields: fields,
                coverMedia: $03252bedb57d8f6f$export$2c47b714cdbd1e2a(issueDetail.coverMedia),
                subtaskMetadata: (0, $8pUMB.getSubtaskMetadata)(issueDetail.childrenTotal?.totalCount, issueDetail.childrenNotDone?.totalCount)
            };
            transformedIssues.push(newIssue);
        });
        return transformedIssues;
    }, [
        formatMessage
    ]);
};

});
parcelRegister("2Igls", function(module, exports) {

$parcel$export(module.exports, "MINUTE", () => $88f80910cde3e0d3$export$f4aba04677f37907);
$parcel$export(module.exports, "HOUR", () => $88f80910cde3e0d3$export$1bf939ebcf31ef0e);
$parcel$export(module.exports, "DAY", () => $88f80910cde3e0d3$export$1a58b8d7f494dd72);
$parcel$export(module.exports, "WEEK", () => $88f80910cde3e0d3$export$3241045aa1844a20);
$parcel$export(module.exports, "DAYS", () => $88f80910cde3e0d3$export$b387b66963374517);
$parcel$export(module.exports, "HOURS", () => $88f80910cde3e0d3$export$f25ebc73c10ad2c);
$parcel$export(module.exports, "PRETTY", () => $88f80910cde3e0d3$export$d39e6ebabedff673);
$parcel$export(module.exports, "defaultTimeTrackingConfiguration", () => $88f80910cde3e0d3$export$e17ebf14f4144ede);
$parcel$export(module.exports, "DEFAULT_TO_NEW_ISSUE_VIEW", () => $88f80910cde3e0d3$export$83f9ac2d887bd06a);
const $88f80910cde3e0d3$export$f4aba04677f37907 = 'minute';
const $88f80910cde3e0d3$export$1bf939ebcf31ef0e = 'hour';
const $88f80910cde3e0d3$export$1a58b8d7f494dd72 = 'day';
const $88f80910cde3e0d3$export$3241045aa1844a20 = 'week';
const $88f80910cde3e0d3$export$b387b66963374517 = 'days';
const $88f80910cde3e0d3$export$f25ebc73c10ad2c = 'hours';
const $88f80910cde3e0d3$export$d39e6ebabedff673 = 'pretty';
const $88f80910cde3e0d3$export$e17ebf14f4144ede = {
    isTimeTrackingEnabled: false,
    daysPerWeek: 5,
    hoursPerDay: 8,
    defaultUnit: $88f80910cde3e0d3$export$f4aba04677f37907,
    format: $88f80910cde3e0d3$export$d39e6ebabedff673
};
const $88f80910cde3e0d3$export$7a0204710d322de6 = 'LOCK_IN_NEW_ISSUE_VIEW';
const $88f80910cde3e0d3$export$83f9ac2d887bd06a = 'DEFAULT_TO_NEW_ISSUE_VIEW';
const $88f80910cde3e0d3$export$f269c0bf10ad77e2 = 'DEFAULT_TO_OLD_ISSUE_VIEW';

});

parcelRegister("etKNj", function(module, exports) {

$parcel$export(module.exports, "timeTrackingFormatter", () => $5d7d4350edc91a82$export$5169d8c8f9327e33);
$parcel$export(module.exports, "timeTrackingFormatterWithDefaults", () => $5d7d4350edc91a82$export$71be3aa954f6065b);
$parcel$export(module.exports, "timeTrackingFormatterLongForm", () => $5d7d4350edc91a82$export$bb4e82d8c2aeeff1);
$parcel$export(module.exports, "transformAGGToJiraTimeFormat", () => $5d7d4350edc91a82$export$9dccd3a07969375d);
$parcel$export(module.exports, "transformAGGToJiraTimeUnit", () => $5d7d4350edc91a82$export$8516173ab945b52f);

var $gBj4V = parcelRequire("gBj4V");

var $lgkxY = parcelRequire("lgkxY");

var $4TB2x = parcelRequire("4TB2x");
const $5d7d4350edc91a82$var$validate = (condition)=>(distance)=>condition ? distance : 0;
// Format time to be 2 decimal places without trailing zeros
const $5d7d4350edc91a82$var$timeFormatter = (time, unit)=>time > 0 ? `${time.toFixed(2).replace(/\.?0+$/, '')}${unit}` : `0${unit}`;
const $5d7d4350edc91a82$var$timePrettyFormatter = (timeInSeconds, units, formatMessage)=>{
    const timeForZero = `0${formatMessage(units[3].suffix)}`;
    if (timeInSeconds <= 0) return timeForZero;
    const initialTimeObj = {
        secondsRemaining: timeInSeconds,
        time: ''
    };
    const result = units.reduce((timeObj, unit)=>{
        if (unit.seconds <= 0) return timeObj;
        const currentTimeValue = Math.floor(timeObj.secondsRemaining / unit.seconds);
        const secondsRemaining = currentTimeValue > 0 ? timeObj.secondsRemaining % unit.seconds : timeObj.secondsRemaining;
        const time = currentTimeValue > 0 ? `${timeObj.time} ${currentTimeValue}${formatMessage(unit.suffix)}` : timeObj.time;
        return {
            secondsRemaining: secondsRemaining,
            time: time
        };
    }, initialTimeObj);
    return result.time.trim() || timeForZero;
};
const $5d7d4350edc91a82$var$timePrettyFormatterLongForm = (timeInSeconds, units, formatMessage)=>{
    const timeForZero = `0 ${formatMessage(units[3].suffix, {
        [units[3].type]: 0
    })}`;
    if (timeInSeconds <= 0) return timeForZero;
    const initialTimeObj = {
        secondsRemaining: timeInSeconds,
        time: ''
    };
    const result = units.reduce((timeObj, unit)=>{
        if (unit.seconds <= 0) return timeObj;
        const { suffix: suffix, type: type } = unit;
        const currentTimeValue = Math.floor(timeObj.secondsRemaining / unit.seconds);
        if (currentTimeValue === 1) return {
            secondsRemaining: timeObj.secondsRemaining % unit.seconds,
            time: `${timeObj.time} ${currentTimeValue} ${formatMessage(suffix, {
                [type]: currentTimeValue
            })}`
        };
        const secondsRemaining = currentTimeValue > 1 ? timeObj.secondsRemaining % unit.seconds : timeObj.secondsRemaining;
        const time = currentTimeValue > 1 ? `${timeObj.time} ${currentTimeValue} ${formatMessage(suffix, {
            [type]: currentTimeValue
        })}` : timeObj.time;
        return {
            secondsRemaining: secondsRemaining,
            time: time
        };
    }, initialTimeObj);
    return result.time.trim() || timeForZero;
};
const $5d7d4350edc91a82$export$5169d8c8f9327e33 = (timeInSeconds, { workingHoursPerDay: workingHoursPerDay, workingDaysPerWeek: workingDaysPerWeek, timeFormat: timeFormat } = (0, $gBj4V.defaultTimeTrackingOptions), { formatMessage: formatMessage })=>{
    const isTimeValid = timeInSeconds > 0;
    const isTimeInDaysValid = isTimeValid && workingHoursPerDay > 0;
    const unit = (0, $4TB2x.createUnit)(timeInSeconds);
    const units = [
        unit({
            type: 'week',
            suffix: (0, $lgkxY.default).timeUnitWeek,
            seconds: Math.max(workingDaysPerWeek, 0) * Math.max(workingHoursPerDay, 0) * (0, $gBj4V.SECONDS_PER_HOUR)
        }),
        unit({
            type: 'day',
            suffix: (0, $lgkxY.default).timeUnitDay,
            transform: $5d7d4350edc91a82$var$validate(isTimeInDaysValid),
            seconds: Math.max(workingHoursPerDay, 0) * (0, $gBj4V.SECONDS_PER_HOUR)
        }),
        unit({
            type: 'hour',
            suffix: (0, $lgkxY.default).timeUnitHour,
            transform: $5d7d4350edc91a82$var$validate(isTimeValid),
            seconds: (0, $gBj4V.SECONDS_PER_HOUR)
        }),
        unit({
            type: 'minute',
            suffix: (0, $lgkxY.default).timeUnitMinute,
            seconds: (0, $gBj4V.SECONDS_PER_MINUTE)
        })
    ];
    switch(timeFormat){
        case (0, $gBj4V.TimeFormats).DAYS:
            return $5d7d4350edc91a82$var$timeFormatter(units[1].time, formatMessage(units[1].suffix));
        case (0, $gBj4V.TimeFormats).HOURS:
            return $5d7d4350edc91a82$var$timeFormatter(units[2].time, formatMessage(units[2].suffix));
        case (0, $gBj4V.TimeFormats).PRETTY:
        default:
            return $5d7d4350edc91a82$var$timePrettyFormatter(timeInSeconds, units, formatMessage);
    }
};
const $5d7d4350edc91a82$export$71be3aa954f6065b = (timeInSeconds, { workingHoursPerDay: workingHoursPerDay, workingDaysPerWeek: workingDaysPerWeek, timeFormat: timeFormat }, intl)=>{
    const timeTrackingSettings = {
        workingHoursPerDay: workingHoursPerDay || (0, $gBj4V.defaultTimeTrackingOptions).workingHoursPerDay,
        workingDaysPerWeek: workingDaysPerWeek || (0, $gBj4V.defaultTimeTrackingOptions).workingDaysPerWeek,
        timeFormat: timeFormat || (0, $gBj4V.defaultTimeTrackingOptions).timeFormat,
        defaultUnit: (0, $gBj4V.defaultTimeTrackingOptions).defaultUnit
    };
    return $5d7d4350edc91a82$export$5169d8c8f9327e33(timeInSeconds || 0, timeTrackingSettings, intl);
};
const $5d7d4350edc91a82$export$bb4e82d8c2aeeff1 = (timeInSeconds, { workingHoursPerDay: workingHoursPerDay, workingDaysPerWeek: workingDaysPerWeek, timeFormat: timeFormat } = (0, $gBj4V.defaultTimeTrackingOptions), { formatMessage: formatMessage })=>{
    const isTimeValid = timeInSeconds > 0;
    const isTimeInDaysValid = isTimeValid && workingHoursPerDay > 0;
    const unit = (0, $4TB2x.createUnit)(timeInSeconds);
    const units = [
        unit({
            type: 'week',
            suffix: (0, $lgkxY.default).timeUnitLongWeek,
            seconds: Math.max(workingDaysPerWeek, 0) * Math.max(workingHoursPerDay, 0) * (0, $gBj4V.SECONDS_PER_HOUR)
        }),
        unit({
            type: 'day',
            suffix: (0, $lgkxY.default).timeUnitLongDay,
            transform: $5d7d4350edc91a82$var$validate(isTimeInDaysValid),
            seconds: Math.max(workingHoursPerDay, 0) * (0, $gBj4V.SECONDS_PER_HOUR)
        }),
        unit({
            type: 'hour',
            suffix: (0, $lgkxY.default).timeUnitLongHour,
            transform: $5d7d4350edc91a82$var$validate(isTimeValid),
            seconds: (0, $gBj4V.SECONDS_PER_HOUR)
        }),
        unit({
            type: 'minute',
            suffix: (0, $lgkxY.default).timeUnitLongMinute,
            seconds: (0, $gBj4V.SECONDS_PER_MINUTE)
        })
    ];
    switch(timeFormat){
        case (0, $gBj4V.TimeFormats).DAYS:
            return $5d7d4350edc91a82$var$timeFormatter(units[1].time, ` ${formatMessage(units[1].suffix, {
                day: units[1].time
            })}`);
        case (0, $gBj4V.TimeFormats).HOURS:
            return $5d7d4350edc91a82$var$timeFormatter(units[2].time, ` ${formatMessage(units[2].suffix, {
                hour: units[2].time
            })}`);
        case (0, $gBj4V.TimeFormats).PRETTY:
        default:
            return $5d7d4350edc91a82$var$timePrettyFormatterLongForm(timeInSeconds, units, formatMessage);
    }
};
const $5d7d4350edc91a82$export$9dccd3a07969375d = (format)=>{
    switch(String(format).toLowerCase()){
        case (0, $gBj4V.TimeFormats).DAYS:
            return (0, $gBj4V.TimeFormats).DAYS;
        case (0, $gBj4V.TimeFormats).HOURS:
            return (0, $gBj4V.TimeFormats).HOURS;
        case (0, $gBj4V.TimeFormats).PRETTY:
            return (0, $gBj4V.TimeFormats).PRETTY;
        default:
            return (0, $gBj4V.TimeFormats).DAYS;
    }
};
const $5d7d4350edc91a82$export$8516173ab945b52f = (defaultUnit)=>{
    switch(String(defaultUnit).toLowerCase()){
        case (0, $gBj4V.TimeUnits).DAY:
            return (0, $gBj4V.TimeUnits).DAY;
        case (0, $gBj4V.TimeUnits).HOUR:
            return (0, $gBj4V.TimeUnits).HOUR;
        case (0, $gBj4V.TimeUnits).MINUTE:
            return (0, $gBj4V.TimeUnits).MINUTE;
        case (0, $gBj4V.TimeUnits).WEEK:
            return (0, $gBj4V.TimeUnits).WEEK;
        default:
            return (0, $gBj4V.TimeUnits).DAY;
    }
};

});
parcelRegister("gBj4V", function(module, exports) {

$parcel$export(module.exports, "SECONDS_PER_MINUTE", () => $f8bb2765f8828f08$export$544c576050746347);
$parcel$export(module.exports, "SECONDS_PER_HOUR", () => $f8bb2765f8828f08$export$3cc7ae4b390f50a);
$parcel$export(module.exports, "TimeFormats", () => $f8bb2765f8828f08$export$5d7ed58d46354b1);
$parcel$export(module.exports, "TimeUnits", () => $f8bb2765f8828f08$export$5d7753c8ad881494);
$parcel$export(module.exports, "defaultTimeTrackingOptions", () => $f8bb2765f8828f08$export$f8d48c1fed813e90);
const $f8bb2765f8828f08$export$544c576050746347 = 60;
const $f8bb2765f8828f08$var$MINUTES_PER_HOUR = 60;
const $f8bb2765f8828f08$export$3cc7ae4b390f50a = $f8bb2765f8828f08$var$MINUTES_PER_HOUR * $f8bb2765f8828f08$export$544c576050746347;
const $f8bb2765f8828f08$var$TIME_FORMAT_PRETTY = 'pretty';
const $f8bb2765f8828f08$var$TIME_FORMAT_DAYS = 'days';
const $f8bb2765f8828f08$var$TIME_FORMAT_HOURS = 'hours';
const $f8bb2765f8828f08$export$5d7ed58d46354b1 = Object.freeze({
    PRETTY: $f8bb2765f8828f08$var$TIME_FORMAT_PRETTY,
    DAYS: $f8bb2765f8828f08$var$TIME_FORMAT_DAYS,
    HOURS: $f8bb2765f8828f08$var$TIME_FORMAT_HOURS
});
const $f8bb2765f8828f08$var$TIME_UNIT_WEEK = 'week';
const $f8bb2765f8828f08$var$TIME_UNIT_DAY = 'day';
const $f8bb2765f8828f08$var$TIME_UNIT_HOUR = 'hour';
const $f8bb2765f8828f08$var$TIME_UNIT_MINUTE = 'minute';
const $f8bb2765f8828f08$export$5d7753c8ad881494 = Object.freeze({
    WEEK: $f8bb2765f8828f08$var$TIME_UNIT_WEEK,
    DAY: $f8bb2765f8828f08$var$TIME_UNIT_DAY,
    HOUR: $f8bb2765f8828f08$var$TIME_UNIT_HOUR,
    MINUTE: $f8bb2765f8828f08$var$TIME_UNIT_MINUTE
});
const $f8bb2765f8828f08$export$f8d48c1fed813e90 = {
    workingHoursPerDay: 8,
    workingDaysPerWeek: 5,
    timeFormat: $f8bb2765f8828f08$export$5d7ed58d46354b1.PRETTY,
    defaultUnit: $f8bb2765f8828f08$export$5d7753c8ad881494.MINUTE
};

});

parcelRegister("lgkxY", function(module, exports) {

$parcel$export(module.exports, "default", () => $00e424f4a1d744f3$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $00e424f4a1d744f3$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    timeUnitWeek: {
        "id": "time-tracking-formatter.time-unit-week",
        "defaultMessage": "w"
    },
    timeUnitDay: {
        "id": "time-tracking-formatter.time-unit-day",
        "defaultMessage": "d"
    },
    timeUnitHour: {
        "id": "time-tracking-formatter.time-unit-hour",
        "defaultMessage": "h"
    },
    timeUnitMinute: {
        "id": "time-tracking-formatter.time-unit-minute",
        "defaultMessage": "m"
    },
    timeUnitLongWeek: {
        "id": "time-tracking-formatter.time-unit-long-week",
        "defaultMessage": "{week, plural, zero {weeks} one {week} other {weeks} }"
    },
    timeUnitLongDay: {
        "id": "time-tracking-formatter.time-unit-long-day",
        "defaultMessage": "{day, plural, zero {days} one {day} other {days} }"
    },
    timeUnitLongHour: {
        "id": "time-tracking-formatter.time-unit-long-hour",
        "defaultMessage": "{hour, plural, zero {hours} one {hour} other {hours} }"
    },
    timeUnitLongMinute: {
        "id": "time-tracking-formatter.time-unit-long-minute",
        "defaultMessage": "{minute, plural, zero {minutes} one {minute} other {minutes} }"
    }
});

});

parcelRegister("4TB2x", function(module, exports) {

$parcel$export(module.exports, "createUnit", () => $d8f5ee4c356dec74$export$aab44654646f3ccc);
const $d8f5ee4c356dec74$export$aab44654646f3ccc = (timeInSeconds)=>({ suffix: suffix, seconds: seconds, type: type, transform: transform })=>{
        const distance = timeInSeconds / seconds;
        const time = transform ? transform(distance) : distance;
        return {
            seconds: seconds,
            suffix: suffix,
            time: time,
            type: type
        };
    };

});


parcelRegister("8pUMB", function(module, exports) {

$parcel$export(module.exports, "getSubtaskMetadata", () => $f5233296ef81c0cb$export$9af279b6109e0217);
const $f5233296ef81c0cb$export$9af279b6109e0217 = (totalCount, totalNotDoneCount)=>{
    if (totalCount == null || totalNotDoneCount == null) return {
        total: 0,
        done: 0
    };
    return {
        total: totalCount,
        done: totalCount - totalNotDoneCount
    };
};

});


parcelRegister("7OM52", function(module, exports) {

$parcel$export(module.exports, "BoardFieldIdsProvider", () => $b6f714cdb4d59913$export$107acacf2030ddb9);
$parcel$export(module.exports, "useFieldIds", () => $b6f714cdb4d59913$export$a8f1976671d75184);

var $e8Ly6 = parcelRequire("e8Ly6");

var $em27W = parcelRequire("em27W");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $5fc53 = parcelRequire("5fc53");

var $hE5wF = parcelRequire("hE5wF");

var $hlGFs = parcelRequire("hlGFs");
const $b6f714cdb4d59913$var$Context = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $b6f714cdb4d59913$var$SYSTEM_FIELDS = [
    (0, $5fc53.ASSIGNEE_TYPE),
    (0, $5fc53.DUE_DATE_TYPE),
    (0, $5fc53.ISSUE_KEY_TYPE),
    (0, $5fc53.ISSUE_TYPE),
    (0, $5fc53.PARENT_TYPE),
    (0, $5fc53.PRIORITY_TYPE),
    (0, $hE5wF.RANK_ALIAS_FIELD_ID),
    (0, $5fc53.STATUS_TYPE),
    (0, $5fc53.SUMMARY_TYPE)
];
const $b6f714cdb4d59913$export$107acacf2030ddb9 = ({ children: children, queryFragment: queryFragment, viewFragment: viewFragment })=>{
    const data = (0, $8Uumt.useFragment)((0, $em27W.default), queryFragment);
    const categoryFieldId = data.jira_categoryField?.fieldId ?? null;
    const filteredFieldIds = (0, $hlGFs.useFilterFieldIds)({
        categoryFieldId: categoryFieldId
    });
    const view = (0, $8Uumt.useFragment)((0, $e8Ly6.default), viewFragment);
    const groupByFieldId = view.groupByConfig.fieldId;
    const selectedFields = (0, $5uXOq.useMemo)(()=>view.cardOptions.edges.map((edge)=>edge?.node?.field ? edge.node.field.fieldId : null).filter(Boolean), [
        view.cardOptions.edges
    ]);
    const value = (0, $5uXOq.useMemo)(()=>{
        const fieldIds = new Set($b6f714cdb4d59913$var$SYSTEM_FIELDS);
        if (groupByFieldId) fieldIds.add(groupByFieldId);
        for (const fieldId of filteredFieldIds)fieldIds.add(fieldId);
        for (const fieldId of selectedFields)fieldIds.add(fieldId);
        // The formatting of the timeoriginalestimate relies on the timetrackingsettings field within timetracking: FUN 1015
        if (fieldIds.has((0, $5fc53.TIME_ESTIMATE_TYPE))) fieldIds.add((0, $5fc53.TIME_TRACKING_TYPE));
        return Array.from(fieldIds);
    }, [
        filteredFieldIds,
        groupByFieldId,
        selectedFields
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b6f714cdb4d59913$var$Context.Provider, {
        value: value
    }, children);
};
const $b6f714cdb4d59913$export$a8f1976671d75184 = ()=>{
    const context = (0, $5uXOq.useContext)($b6f714cdb4d59913$var$Context);
    if (!context) throw new Error('useFieldIds must be used within a BoardFieldIdsProvider');
    return context;
};

});
parcelRegister("e8Ly6", function(module, exports) {

$parcel$export(module.exports, "default", () => $e83881b812ec647e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6c75fbc04197eda8a5478946a14e46b2>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $e83881b812ec647e$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "fieldId"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "BoardFieldIdsProvider_view",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraViewGroupByConfig",
                    "kind": "LinkedField",
                    "name": "groupByConfig",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": v0 /*: any*/ ,
                            "action": "THROW",
                            "path": "groupByConfig.fieldId"
                        }
                    ]
                },
                "action": "THROW",
                "path": "groupByConfig"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "enabledOnly",
                            "value": true
                        },
                        {
                            "kind": "Literal",
                            "name": "first",
                            "value": 100
                        }
                    ],
                    "concreteType": "JiraBoardViewCardOptionConnection",
                    "kind": "LinkedField",
                    "name": "cardOptions",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "concreteType": "JiraBoardViewCardOptionEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": {
                                                                "concreteType": "JiraField",
                                                                "kind": "LinkedField",
                                                                "name": "field",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": v0 /*: any*/ ,
                                                                        "action": "THROW",
                                                                        "path": "cardOptions.edges.node.field.fieldId"
                                                                    }
                                                                ]
                                                            },
                                                            "action": "THROW",
                                                            "path": "cardOptions.edges.node.field"
                                                        }
                                                    ],
                                                    "type": "JiraBoardViewFieldCardOption"
                                                }
                                            ]
                                        },
                                        "action": "THROW",
                                        "path": "cardOptions.edges.node"
                                    }
                                ]
                            },
                            "action": "THROW",
                            "path": "cardOptions.edges"
                        }
                    ],
                    "storageKey": "cardOptions(enabledOnly:true,first:100)"
                },
                "action": "THROW",
                "path": "cardOptions"
            }
        ],
        "type": "JiraBoardView"
    };
}();
$e83881b812ec647e$var$node.hash = "6958b7e8ba10a6f89ef49654fb6a730d";
var $e83881b812ec647e$export$2e2bcd8739ae039 = $e83881b812ec647e$var$node;

});

parcelRegister("em27W", function(module, exports) {

$parcel$export(module.exports, "default", () => $0edcdec2c8a61428$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6536f3cc7cf4e2929d4f8ed5a38ee475>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $0edcdec2c8a61428$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "cloudId"
        }
    ],
    "kind": "Fragment",
    "name": "BoardFieldIdsProvider_query",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                }
            ],
            "concreteType": "JiraJqlField",
            "kind": "LinkedField",
            "name": "jira_categoryField",
            "plural": false,
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "kind": "ScalarField",
                        "name": "fieldId"
                    },
                    "action": "THROW",
                    "path": "jira_categoryField.fieldId"
                }
            ]
        }
    ],
    "type": "Query"
};
$0edcdec2c8a61428$var$node.hash = "bf40229ddd789b5fc14bbbffdfd29e07";
var $0edcdec2c8a61428$export$2e2bcd8739ae039 = $0edcdec2c8a61428$var$node;

});



parcelRegister("jgcJl", function(module, exports) {

$parcel$export(module.exports, "WorkflowStoreContainer", () => $394f80913b59858f$export$704db246c3ac6062);
$parcel$export(module.exports, "useWorkflowStoreState", () => $394f80913b59858f$export$28d1a95bd5ffa117);
$parcel$export(module.exports, "useWorkflowStoreActions", () => $394f80913b59858f$export$d932477502b964cb);
$parcel$export(module.exports, "useIssueTypeIds", () => $394f80913b59858f$export$5f0ae38127fac19f);

var $6s1PB = parcelRequire("6s1PB");

var $3sQ5x = parcelRequire("3sQ5x");
var $gg7kZ = parcelRequire("gg7kZ");
var $6dDSs = parcelRequire("6dDSs");
var $iXqE5 = parcelRequire("iXqE5");
const $394f80913b59858f$var$initialState = {
    workflows: [],
    /* @deprecated delete issueTypes when cleaning up merge_board_workflows */ issueTypes: [],
    /* @deprecated delete transitions when cleaning up merge_board_workflows */ transitions: [],
    /* @deprecated delete workflowId when cleaning up merge_board_workflows */ workflowId: null,
    /* @deprecated delete workflowName when cleaning up merge_board_workflows */ workflowName: null
};
const $394f80913b59858f$var$setFetchResponse = ({ workflows: workflows, workflowIssuesLastChangedTime: workflowIssuesLastChangedTime, activeWorkflow: activeWorkflow })=>async ({ setState: setState })=>{
        if ((0, $6s1PB.expVal)('merge_board_workflows', 'enabled', false)) setState({
            workflows: workflows,
            workflowIssuesLastChangedTime: workflowIssuesLastChangedTime
        });
        else {
            if (!activeWorkflow) return;
            setState({
                issueTypes: activeWorkflow.issueTypes,
                transitions: activeWorkflow.transitions,
                workflows: workflows,
                workflowId: activeWorkflow.workflowId,
                workflowIssuesLastChangedTime: workflowIssuesLastChangedTime,
                workflowName: activeWorkflow.workflowName
            });
        }
    };
const $394f80913b59858f$var$actions = {
    setFetchResponse: $394f80913b59858f$var$setFetchResponse
};
const $394f80913b59858f$export$704db246c3ac6062 = (0, $gg7kZ.createContainer)();
const $394f80913b59858f$var$WorkflowStore = (0, $iXqE5.createStore)({
    initialState: $394f80913b59858f$var$initialState,
    actions: $394f80913b59858f$var$actions,
    name: 'WorkflowStore',
    containedBy: $394f80913b59858f$export$704db246c3ac6062
});
const $394f80913b59858f$var$getIssueTypeIds = (0, $6dDSs.createSelector)((state)=>state.issueTypes, (issueTypes)=>new Set(issueTypes.map((issueType)=>issueType.id)));
const $394f80913b59858f$export$28d1a95bd5ffa117 = (0, $3sQ5x.createStateHook)($394f80913b59858f$var$WorkflowStore);
const $394f80913b59858f$export$d932477502b964cb = (0, $3sQ5x.createActionsHook)($394f80913b59858f$var$WorkflowStore);
const $394f80913b59858f$export$5f0ae38127fac19f = (0, $3sQ5x.createStateHook)($394f80913b59858f$var$WorkflowStore, {
    selector: $394f80913b59858f$var$getIssueTypeIds
});

});


parcelRegister("3pAJH", function(module, exports) {

$parcel$export(module.exports, "default", () => $93f608774da1df30$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $93f608774da1df30$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    boardInitErrorTitle: {
        "id": "work-management-board.controllers.board-data.board-init-error-title",
        "defaultMessage": "Failed to load the board"
    },
    boardInitErrorMessage: {
        "id": "work-management-board.controllers.board-data.board-init-error-message",
        "defaultMessage": "We couldn't load your board, try refreshing the page or try again later."
    },
    boardStatusNotFoundWarningFlagTitle: {
        "id": "work-management-board.controllers.board-data.board-status-not-found-warning-flag-title",
        "defaultMessage": "Some work items couldn't be displayed"
    },
    boardStatusNotFoundWarningFlagDescription: {
        "id": "work-management-board.controllers.board-data.board-status-not-found-warning-flag-description",
        "defaultMessage": "Some work items couldn't be displayed on the board due to unrecognized status IDs. This may occur if the work item's status isn't part of the current workflow."
    },
    boardStatusNotFoundWarningFlagAction: {
        "id": "work-management-board.controllers.board-data.board-status-not-found-warning-flag-action",
        "defaultMessage": "View all work items"
    }
});

});


parcelRegister("jTnjM", function(module, exports) {

$parcel$export(module.exports, "ConfettiColumnsProvider", () => $a90f45fdf7b55744$export$a2ded958dc3b3a);
$parcel$export(module.exports, "useConfettiColumnsActions", () => $a90f45fdf7b55744$export$d6cbd195534cda74);
$parcel$export(module.exports, "useConfettiColumns", () => $a90f45fdf7b55744$export$d2d8be1cdd91d59f);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $gg7kZ = parcelRequire("gg7kZ");
var $iXqE5 = parcelRequire("iXqE5");
const $a90f45fdf7b55744$var$actions = {
    addConfettiColumn: (columnId)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            const confettiColumns = new Set(currentState.confettiColumns);
            confettiColumns.add(columnId);
            setState({
                confettiColumns: confettiColumns
            });
        },
    removeConfettiColumn: (columnId)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            const confettiColumns = new Set(currentState.confettiColumns);
            confettiColumns.delete(columnId);
            setState({
                confettiColumns: confettiColumns
            });
        }
};
const $a90f45fdf7b55744$export$a2ded958dc3b3a = (0, $gg7kZ.createContainer)();
const $a90f45fdf7b55744$var$store = (0, $iXqE5.createStore)({
    name: 'JWMConfettiColumnsStore',
    containedBy: $a90f45fdf7b55744$export$a2ded958dc3b3a,
    initialState: {
        confettiColumns: new Set()
    },
    actions: $a90f45fdf7b55744$var$actions
});
const $a90f45fdf7b55744$var$useConfettiColumnsStore = (0, $3sQ5x.createHook)($a90f45fdf7b55744$var$store);
const $a90f45fdf7b55744$export$d6cbd195534cda74 = (0, $3sQ5x.createActionsHook)($a90f45fdf7b55744$var$store);
const $a90f45fdf7b55744$export$d2d8be1cdd91d59f = ()=>{
    const [{ confettiColumns: confettiColumns }, { removeConfettiColumn: removeConfettiColumn }] = $a90f45fdf7b55744$var$useConfettiColumnsStore();
    return {
        confettiColumns: confettiColumns,
        removeConfettiColumn: removeConfettiColumn
    };
};

});

parcelRegister("kiyQL", function(module, exports) {

$parcel$export(module.exports, "CardDragDropProvider", () => $9b6672eaeaf999fa$export$b1ccb12106075e69);
$parcel$export(module.exports, "useStartCardDrag", () => $9b6672eaeaf999fa$export$c489958ad236599c);
$parcel$export(module.exports, "useCancelConfirmCardDrop", () => $9b6672eaeaf999fa$export$124d43f574a408ec);
$parcel$export(module.exports, "useUpdateDropTarget", () => $9b6672eaeaf999fa$export$fd80b4a210addcaa);
$parcel$export(module.exports, "useResetDropTarget", () => $9b6672eaeaf999fa$export$886c7f1b5e5013b3);
$parcel$export(module.exports, "useHighlightedIssue", () => $9b6672eaeaf999fa$export$daf5b1f2d290b352);
$parcel$export(module.exports, "useCardDragDrop", () => $9b6672eaeaf999fa$export$51dcb5ebefb8c3d7);
$parcel$export(module.exports, "useCanDropCard", () => $9b6672eaeaf999fa$export$6075fd3ad3110a90);
$parcel$export(module.exports, "useInferredDropTargetTransition", () => $9b6672eaeaf999fa$export$79dfb0dde692631b);
$parcel$export(module.exports, "useUpdateSessionId", () => $9b6672eaeaf999fa$export$c6e81f4ae8465e96);

var $5uXOq = parcelRequire("5uXOq");

var $7Jxgt = parcelRequire("7Jxgt");

var $hE5wF = parcelRequire("hE5wF");

var $daQYX = parcelRequire("daQYX");

var $1T2vX = parcelRequire("1T2vX");

var $5fc53 = parcelRequire("5fc53");

var $4R6GH = parcelRequire("4R6GH");

var $cvj5l = parcelRequire("cvj5l");

var $2PV8T = parcelRequire("2PV8T");

var $1Eg2O = parcelRequire("1Eg2O");
const $9b6672eaeaf999fa$var$emptyDropTarget = {
    group: null,
    transition: null
};
const $9b6672eaeaf999fa$var$reducer = (state, action)=>{
    switch(action.type){
        case 'startDrag':
            return {
                ...state,
                ...action.value
            };
        case 'cancelDrop':
            return {
                ...state,
                draggedIssue: null,
                sourceGroup: null,
                dropTarget: $9b6672eaeaf999fa$var$emptyDropTarget,
                ...!(0, $4R6GH.fg)('one_event_improvements_1') && {
                    updateSessionId: null
                }
            };
        case 'confirmDrop':
            return {
                ...state,
                draggedIssue: null,
                sourceGroup: null,
                dropTarget: $9b6672eaeaf999fa$var$emptyDropTarget,
                ...!(0, $4R6GH.fg)('one_event_improvements_1') && {
                    updateSessionId: null
                },
                highlightedIssueId: state.draggedIssue?.id ?? null
            };
        case 'updateDropTarget':
            return {
                ...state,
                dropTarget: {
                    ...state.dropTarget,
                    ...action.value
                }
            };
        case 'resetDropTarget':
            return {
                ...state,
                dropTarget: $9b6672eaeaf999fa$var$emptyDropTarget
            };
        case 'resetHighlightedIssue':
            return {
                ...state,
                highlightedIssueId: null
            };
        default:
            return state;
    }
};
const $9b6672eaeaf999fa$var$initialState = {
    draggedIssue: null,
    sourceGroup: null,
    dropTarget: $9b6672eaeaf999fa$var$emptyDropTarget,
    updateSessionId: null,
    highlightedIssueId: null
};
const $9b6672eaeaf999fa$var$CardDragDropContext = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $9b6672eaeaf999fa$export$b1ccb12106075e69 = ({ children: children })=>{
    const [state, dispatch] = (0, $5uXOq.useReducer)($9b6672eaeaf999fa$var$reducer, $9b6672eaeaf999fa$var$initialState);
    const value = (0, $5uXOq.useMemo)(()=>({
            ...state,
            dispatch: dispatch
        }), [
        state
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9b6672eaeaf999fa$var$CardDragDropContext.Provider, {
        value: value
    }, children);
};
const $9b6672eaeaf999fa$var$useCardDragDropContext = ()=>{
    const context = (0, $5uXOq.useContext)($9b6672eaeaf999fa$var$CardDragDropContext);
    if (!context) throw new Error('useCardDragDropContext must be used within a CardDragDropProvider');
    return context;
};
const $9b6672eaeaf999fa$export$c489958ad236599c = ()=>{
    const { dispatch: dispatch } = $9b6672eaeaf999fa$var$useCardDragDropContext();
    const { fetch: fetchIssueTransitions } = (0, $2PV8T.useIssueTransitions)();
    const { fireStartCardDragAnalytics: fireStartCardDragAnalytics } = (0, $1Eg2O.useCardDragDropAnalytics)();
    return (0, $5uXOq.useCallback)((issue, group)=>{
        const updateSessionId = (0, $7Jxgt.v4)(); // TODO: remove this on one_event_improvements_1 cleanup
        dispatch({
            type: 'startDrag',
            value: {
                draggedIssue: issue,
                sourceGroup: group,
                ...!(0, $4R6GH.fg)('one_event_improvements_1') && {
                    updateSessionId: updateSessionId
                }
            }
        });
        fireStartCardDragAnalytics((0, $4R6GH.fg)('one_event_improvements_1') ? undefined : updateSessionId, (0, $4R6GH.fg)('one_event_improvements_1') ? issue.id : undefined);
        if (group.type === (0, $hE5wF.GROUP_BY_STATUS)) fetchIssueTransitions(issue);
    }, [
        dispatch,
        fetchIssueTransitions,
        fireStartCardDragAnalytics
    ]);
};
const $9b6672eaeaf999fa$export$124d43f574a408ec = ()=>{
    const { dispatch: dispatch } = $9b6672eaeaf999fa$var$useCardDragDropContext();
    const cancelCardDrop = (0, $5uXOq.useCallback)(()=>dispatch({
            type: 'cancelDrop'
        }), [
        dispatch
    ]);
    const confirmCardDrop = (0, $5uXOq.useCallback)(()=>dispatch({
            type: 'confirmDrop'
        }), [
        dispatch
    ]);
    return {
        cancelCardDrop: cancelCardDrop,
        confirmCardDrop: confirmCardDrop
    };
};
const $9b6672eaeaf999fa$export$fd80b4a210addcaa = ()=>{
    const { dispatch: dispatch } = $9b6672eaeaf999fa$var$useCardDragDropContext();
    return (0, $5uXOq.useCallback)((newDropTarget)=>dispatch({
            type: 'updateDropTarget',
            value: newDropTarget
        }), [
        dispatch
    ]);
};
const $9b6672eaeaf999fa$export$886c7f1b5e5013b3 = ()=>{
    const { dispatch: dispatch } = $9b6672eaeaf999fa$var$useCardDragDropContext();
    return (0, $5uXOq.useCallback)(()=>dispatch({
            type: 'resetDropTarget'
        }), [
        dispatch
    ]);
};
const $9b6672eaeaf999fa$export$daf5b1f2d290b352 = ()=>{
    const { dispatch: dispatch, highlightedIssueId: highlightedIssueId } = $9b6672eaeaf999fa$var$useCardDragDropContext();
    const resetHighlightedIssue = (0, $5uXOq.useCallback)(()=>dispatch({
            type: 'resetHighlightedIssue'
        }), [
        dispatch
    ]);
    return {
        highlightedIssueId: highlightedIssueId,
        resetHighlightedIssue: resetHighlightedIssue
    };
};
const $9b6672eaeaf999fa$export$51dcb5ebefb8c3d7 = ()=>$9b6672eaeaf999fa$var$useCardDragDropContext();
const $9b6672eaeaf999fa$var$GROUP_TYPE_TO_FIELD_TYPE = {
    [(0, $hE5wF.GROUP_BY_ASSIGNEE)]: (0, $5fc53.ASSIGNEE_TYPE),
    [(0, $hE5wF.GROUP_BY_CATEGORY)]: (0, $5fc53.CATEGORY_TYPE),
    [(0, $hE5wF.GROUP_BY_PRIORITY)]: (0, $5fc53.PRIORITY_TYPE)
};
const $9b6672eaeaf999fa$export$6075fd3ad3110a90 = (group)=>{
    const project = (0, $daQYX.useProject)();
    const { typesWithFields: typesWithFields } = (0, $1T2vX.useIssueTypesAndFields)();
    const { sourceGroup: sourceGroup, draggedIssue: draggedIssue, dropTarget: dropTarget } = $9b6672eaeaf999fa$var$useCardDragDropContext();
    const { transitions: transitions, loading: loading, hasError: hasError } = (0, $2PV8T.useIssueTransitions)();
    const canRank = project.permissions.editIssues && project.permissions.scheduleIssues;
    const isSameGroup = sourceGroup?.id === group.id;
    const areTransitionsUnavailable = loading || hasError;
    if (!draggedIssue) return {
        canDropInGroup: 'unknown',
        canDropAgainstCard: 'unknown'
    };
    if (group.type !== (0, $hE5wF.GROUP_BY_STATUS)) {
        let canDropInGroup = 'unknown';
        if (!isSameGroup) {
            // check if the field is available for the dragged issue's issue type
            const fieldType = $9b6672eaeaf999fa$var$GROUP_TYPE_TO_FIELD_TYPE[group.type];
            const issueType = typesWithFields.find((type)=>type.issueType.id === draggedIssue.fields[0, $cvj5l.ISSUE_TYPE_ID].issueType.id);
            const hasField = issueType?.fields.some((field)=>field.type === fieldType);
            canDropInGroup = hasField ? 'yes' : 'no';
            // when grouping by assignee, check if the user has assign permission
            if (group.type === (0, $hE5wF.GROUP_BY_ASSIGNEE)) canDropInGroup = canDropInGroup === 'yes' && project.permissions.assignIssues ? 'yes' : 'no';
        }
        return {
            canDropInGroup: canDropInGroup,
            canDropAgainstCard: canRank && canDropInGroup !== 'no' ? 'yes' : 'no'
        };
    }
    if (isSameGroup && areTransitionsUnavailable) return {
        canDropInGroup: 'unknown',
        canDropAgainstCard: canRank ? 'yes' : 'no'
    };
    if (areTransitionsUnavailable) return {
        canDropInGroup: 'unknown',
        canDropAgainstCard: 'unknown'
    };
    const transitionsToGroup = transitions.filter((transition)=>String(transition.toStatusId) === group.id);
    let canDropInGroup = 'no';
    let canDropAgainstCard = canRank ? 'yes' : 'no';
    if (isSameGroup) {
        const selfTransitions = transitionsToGroup.filter((t)=>!t.isGlobal);
        canDropInGroup = selfTransitions.length > 0 ? 'choice-available' : 'unknown';
        if (dropTarget.transition != null) canDropInGroup = 'yes';
    } else if (transitionsToGroup.length === 0) canDropAgainstCard = 'no';
    else if (transitionsToGroup.length === 1) canDropInGroup = 'yes';
    else if (transitionsToGroup.length > 1) {
        canDropInGroup = dropTarget.transition == null ? 'choice-required' : 'yes';
        canDropAgainstCard = canRank && canDropInGroup === 'yes' ? 'yes' : 'no';
    }
    return {
        canDropInGroup: canDropInGroup,
        canDropAgainstCard: canDropAgainstCard
    };
};
const $9b6672eaeaf999fa$export$79dfb0dde692631b = (group)=>{
    const { sourceGroup: sourceGroup } = $9b6672eaeaf999fa$var$useCardDragDropContext();
    const { transitions: transitions } = (0, $2PV8T.useIssueTransitions)();
    const destinationGroupId = group.id;
    if (sourceGroup?.type !== (0, $hE5wF.GROUP_BY_STATUS) || sourceGroup.id === destinationGroupId || transitions.length === 0) return null;
    const transitionsToDestinationGroup = transitions.filter((transition)=>String(transition.toStatusId) === destinationGroupId);
    return transitionsToDestinationGroup.length === 1 ? transitionsToDestinationGroup[0] : null;
};
const $9b6672eaeaf999fa$export$c6e81f4ae8465e96 = ()=>{
    const { updateSessionId: updateSessionId } = $9b6672eaeaf999fa$var$useCardDragDropContext();
    return updateSessionId;
};

});
parcelRegister("2PV8T", function(module, exports) {

$parcel$export(module.exports, "IssueTransitionsProvider", () => $6e91544363019309$export$504c5361b0788bb);
$parcel$export(module.exports, "useIssueTransitions", () => $6e91544363019309$export$4868b6fb356ee1e7);

var $5uXOq = parcelRequire("5uXOq");

var $ccvFs = parcelRequire("ccvFs");

var $6s1PB = parcelRequire("6s1PB");

var $jJZqs = parcelRequire("jJZqs");

var $pa9q9 = parcelRequire("pa9q9");

var $koVbs = parcelRequire("koVbs");

var $cvj5l = parcelRequire("cvj5l");

var $1UtDG = parcelRequire("1UtDG");

var $jgcJl = parcelRequire("jgcJl");

var $3pUdf = parcelRequire("3pUdf");
const $6e91544363019309$var$IssueTransitionsContext = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $6e91544363019309$var$initialState = {
    hasError: false,
    loading: false,
    transitions: []
};
const $6e91544363019309$var$reducer = (state, action)=>{
    switch(action.type){
        case 'fetch':
            return {
                ...state,
                hasError: false,
                loading: true,
                transitions: []
            };
        case 'success':
            return {
                ...state,
                hasError: false,
                loading: false,
                transitions: action.value
            };
        case 'error':
            return {
                ...state,
                hasError: true,
                loading: false,
                transitions: []
            };
        default:
            return state;
    }
};
const $6e91544363019309$export$504c5361b0788bb = ({ children: children })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const { workflows: workflows } = (0, $jgcJl.useWorkflowStoreState)();
    const [{ loading: loading, hasError: hasError, transitions: transitions }, dispatch] = (0, $5uXOq.useReducer)($6e91544363019309$var$reducer, $6e91544363019309$var$initialState);
    const abortableFetchIssueTransitions = (0, $ccvFs.useAbortable)((0, $1UtDG.fetchIssueTransitions));
    const fetch = (0, $5uXOq.useCallback)(async (issue)=>{
        // check if any of the relevant workflow transitions are conditional
        const fromStatusId = Number(issue.fields[0, $cvj5l.STATUS_ID].status.id);
        const issueKey = issue.fields[0, $cvj5l.ISSUE_KEY_ID].value;
        const workType = issue.fields[0, $cvj5l.ISSUE_TYPE_ID].issueType.name;
        // find the workflow where the issue type is defined
        const relevantWorkflow = workflows.find((workflow)=>workflow.issueTypes.some((issueType)=>issueType.id === issue.fields.issuetype.id));
        if (!relevantWorkflow) return;
        const eligibleTransitions = relevantWorkflow.transitions.filter((transition)=>transition.fromStatusId === fromStatusId || transition.isGlobal);
        // if none of the eligible transitions are conditional, then we do not need to fetch
        // the transitions from the server
        if (eligibleTransitions.every((transition)=>!transition.isConditional)) {
            dispatch({
                type: 'success',
                value: eligibleTransitions
            });
            return;
        }
        try {
            dispatch({
                type: 'fetch'
            });
            const response = await abortableFetchIssueTransitions(issue.id);
            dispatch({
                type: 'success',
                value: response
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            if (error === (0, $ccvFs.ABORTED)) return;
            dispatch({
                type: 'error'
            });
            if (error instanceof (0, $jJZqs.default) && error.statusCode === 404) {
                const flagTitle = (()=>{
                    if (workType && (0, $6s1PB.expVal)('jira-itr-m4-exp-3', 'isEnabled', false)) return formatMessage((0, $3pUdf.default).notFoundErrorTitleIssueTerminologyRefreshM4, {
                        workType: workType,
                        issueKey: issueKey
                    });
                    return formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $3pUdf.default).notFoundErrorTitleIssueTermRefresh : (0, $3pUdf.default).notFoundErrorTitle);
                })();
                const flagDescription = (()=>{
                    if (workType && (0, $6s1PB.expVal)('jira-itr-m4-exp-3', 'isEnabled', false)) return formatMessage((0, $3pUdf.default).notFoundErrorMessageIssueTerminologyRefreshM4, {
                        workType: workType
                    });
                    return formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $3pUdf.default).notFoundErrorMessageIssueTermRefresh : (0, $3pUdf.default).notFoundErrorMessage);
                })();
                showFlag({
                    description: flagDescription,
                    title: flagTitle,
                    type: 'error',
                    messageId: 'work-management-board.controllers.issue-transitions.show-flag.error.404',
                    messageType: 'transactional'
                });
                return;
            }
            showFlag({
                description: formatMessage((0, $3pUdf.default).errorMessage),
                title: formatMessage((0, $3pUdf.default).errorTitle),
                type: 'error',
                messageId: 'work-management-board.controllers.issue-transitions.show-flag.error',
                messageType: 'transactional'
            });
        }
    }, [
        abortableFetchIssueTransitions,
        formatMessage,
        showFlag,
        workflows
    ]);
    const value = (0, $5uXOq.useMemo)(()=>({
            fetch: fetch,
            hasError: hasError,
            loading: loading,
            transitions: transitions
        }), [
        fetch,
        hasError,
        loading,
        transitions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6e91544363019309$var$IssueTransitionsContext.Provider, {
        value: value
    }, children);
};
const $6e91544363019309$export$4868b6fb356ee1e7 = ()=>{
    const context = (0, $5uXOq.useContext)($6e91544363019309$var$IssueTransitionsContext);
    if (!context) throw new Error('useIssueTransitions must be used within a IssueTransitionsProvider');
    return context;
};

});
parcelRegister("1UtDG", function(module, exports) {

$parcel$export(module.exports, "fetchIssueTransitions", () => $d37d396cad9d75bb$export$abb47d81cfdbea9e);

var $jcw0u = parcelRequire("jcw0u");

var $fZneA = parcelRequire("fZneA");

var $eusud = parcelRequire("eusud");
const $d37d396cad9d75bb$export$abb47d81cfdbea9e = async (signal, issueId)=>{
    try {
        const response = await (0, $eusud.performGetRequest)(`/rest/api/3/issue/${issueId}/transitions`, {
            signal: signal
        });
        return response.transitions.map((transition)=>({
                transitionId: Number(transition.id),
                name: transition.name,
                isConditional: transition.isConditional,
                isGlobal: transition.isGlobal,
                isInitial: transition.isInitial,
                hasScreen: transition.hasScreen,
                toStatusId: Number(transition.to.id)
            }));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (!(0, $fZneA.isHttpClientErrorResponse)(error) && !signal.aborted) (0, $jcw0u.default)({
            meta: {
                id: 'fetchIssueTransitions',
                packageName: 'jiraWorkManagementBoard',
                teamName: 'wanjel'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};

});

parcelRegister("3pUdf", function(module, exports) {

$parcel$export(module.exports, "default", () => $90297f9b44a9ddc9$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $90297f9b44a9ddc9$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorTitle: {
        "id": "work-management-board.controllers.issue-transitions.error-title",
        "defaultMessage": "We couldn't load transitions"
    },
    errorMessage: {
        "id": "work-management-board.controllers.issue-transitions.error-message",
        "defaultMessage": "Check your connection, then give it another try."
    },
    notFoundErrorTitle: {
        "id": "work-management-board.controllers.issue-transitions.not-found-error-title",
        "defaultMessage": "Issue not found"
    },
    notFoundErrorMessage: {
        "id": "work-management-board.controllers.issue-transitions.not-found-error-message",
        "defaultMessage": "Looks like this issue has been removed. Refresh the page, then try again."
    },
    notFoundErrorTitleIssueTermRefresh: {
        "id": "work-management-board.controllers.issue-transitions.not-found-error-title-issue-term-refresh",
        "defaultMessage": "Work item not found"
    },
    notFoundErrorTitleIssueTerminologyRefreshM4: {
        "id": "work-management-board.controllers.issue-transitions.not-found-error-title-issue-terminology-refresh-m4",
        "defaultMessage": "We can\u2019t find {workType} {issueKey}"
    },
    notFoundErrorMessageIssueTermRefresh: {
        "id": "work-management-board.controllers.issue-transitions.not-found-error-message-issue-term-refresh",
        "defaultMessage": "Looks like this work item has been removed. Refresh the page, then try again."
    },
    notFoundErrorMessageIssueTerminologyRefreshM4: {
        "id": "work-management-board.controllers.issue-transitions.not-found-error-message-issue-terminology-refresh-m4",
        "defaultMessage": "This {workType} has been removed. Refresh the page and try again."
    }
});

});


parcelRegister("1Eg2O", function(module, exports) {

$parcel$export(module.exports, "useCardDragDropAnalytics", () => $3a6a6e34d9b43596$export$bf7082aa7f5f928b);

var $5uXOq = parcelRequire("5uXOq");

var $hE5wF = parcelRequire("hE5wF");

var $daQYX = parcelRequire("daQYX");

var $11oYo = parcelRequire("11oYo");

var $gULOk = parcelRequire("gULOk");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $ctrpc = parcelRequire("ctrpc");

var $4R6GH = parcelRequire("4R6GH");

var $8ikZj = parcelRequire("8ikZj");

var $5fc53 = parcelRequire("5fc53");

var $cvj5l = parcelRequire("cvj5l");
const $3a6a6e34d9b43596$export$bf7082aa7f5f928b = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const project = (0, $daQYX.useProject)();
    const fireStartCardDragAnalytics = (0, $5uXOq.useCallback)(// TODO: remove issueId optional on one_event_improvements_1 cleanup
    (sessionId, issueId)=>{
        // TODO: remove sessionId arg on one_event_improvements_1 cleanup
        if ((0, $4R6GH.fg)('one_event_improvements_1')) {
            (0, $ctrpc.getUpdateAnalyticsFlowHelper)().fireAnalyticsStart((0, $8ikZj.DRAG_DROP_UNKNOWN_FIELD_ID), {
                analytics: createAnalyticsEvent({}),
                attributes: {
                    fieldType: (0, $8ikZj.DRAG_DROP_UNKNOWN_FIELD_ID),
                    isDragEditing: true,
                    ...(0, $4R6GH.fg)('one_event_improvements_1') && {
                        issueId: issueId
                    }
                }
            });
            return;
        }
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'item'
        });
        const analyticsAttributes = {
            isDragEditing: true,
            updateSessionId: sessionId
        };
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'issue', analyticsAttributes);
    }, [
        createAnalyticsEvent
    ]);
    const fireCardDropAnalytics = (0, $5uXOq.useCallback)(({ issue: issue, sourceGroup: sourceGroup, destinationGroup: destinationGroup, rank: rank, transition: transition, updateSessionId: updateSessionId })=>{
        const analyticsAttributes = $3a6a6e34d9b43596$var$getAnalyticsAttributes({
            issue: issue,
            sourceGroup: sourceGroup,
            destinationGroup: destinationGroup,
            rank: rank,
            transition: transition,
            project: project,
            updateSessionId: updateSessionId
        });
        if ((0, $4R6GH.fg)('one_event_improvements_1')) {
            // TODO: remove updateSessionId deconstruction on one_event_improvements_1 cleanup
            const { updateSessionId: excludedSessionId, ...attributes } = analyticsAttributes;
            (0, $ctrpc.getUpdateAnalyticsFlowHelper)().fireAnalyticsEnd((0, $8ikZj.DRAG_DROP_UNKNOWN_FIELD_ID), {
                analytics: createAnalyticsEvent({}),
                attributes: attributes
            });
            return;
        }
        const analyticsEvent = createAnalyticsEvent({
            action: 'update',
            actionSubject: 'issue'
        });
        (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'issue updated', 'ended', analyticsAttributes);
    }, [
        createAnalyticsEvent,
        project
    ]);
    return {
        fireStartCardDragAnalytics: fireStartCardDragAnalytics,
        fireCardDropAnalytics: fireCardDropAnalytics
    };
};
const $3a6a6e34d9b43596$var$getAnalyticsAttributes = ({ issue: issue, sourceGroup: sourceGroup, destinationGroup: destinationGroup, rank: rank, transition: transition, project: project, updateSessionId: updateSessionId })=>{
    const sourceGroupId = sourceGroup.id;
    const destinationGroupId = destinationGroup.id;
    const sourceGroupType = sourceGroup.type;
    const destinationGroupType = destinationGroup.type;
    const issueTypeName = issue.fields[0, $cvj5l.ISSUE_TYPE_ID].issueType.name;
    const attributes = {
        assigneeId: issue.fields[0, $cvj5l.ASSIGNEE_ID]?.user?.accountId ?? '',
        fieldType: destinationGroupType,
        fieldKey: destinationGroupType,
        oldValId: sourceGroupId !== (0, $cvj5l.NULL_GROUP_KEY) ? sourceGroupId : '',
        newValId: destinationGroupId !== (0, $cvj5l.NULL_GROUP_KEY) ? destinationGroupId : '',
        isClassic: !project.isSimplified,
        isDragEditing: true,
        isInlineEditing: false,
        hasRankChanged: rank != null,
        isProjectAdmin: project.permissions.administerProject,
        issueId: issue.id,
        issueType: (0, $11oYo.standardIssueTypes)[issueTypeName] ? issueTypeName : (0, $cvj5l.OTHER),
        projectId: project.id,
        ...updateSessionId && {
            updateSessionId: updateSessionId
        }
    };
    const isStatusUpdate = sourceGroupType === (0, $hE5wF.GROUP_BY_STATUS) && destinationGroupType === (0, $hE5wF.GROUP_BY_STATUS);
    if (isStatusUpdate) {
        attributes.oldStatusCategoryId = sourceGroup.statusCategoryId;
        attributes.newStatusCategoryId = destinationGroup.statusCategoryId;
        attributes.oldStatusCategoryName = (0, $gULOk.statusCategoryForId)(sourceGroup.statusCategoryId);
        attributes.newStatusCategoryName = (0, $gULOk.statusCategoryForId)(destinationGroup.statusCategoryId);
    }
    if (sourceGroupId === destinationGroupId && (isStatusUpdate && (0, $4R6GH.fg)('one_event_iteration_3') || (0, $4R6GH.fg)('one_event_status_update_fix'))) {
        attributes.fieldType = (0, $8ikZj.FIELD_TYPE_MAP)[0, $5fc53.RANK_CF_TYPE];
        attributes.fieldKey = (0, $8ikZj.FIELD_TYPE_MAP)[0, $5fc53.RANK_CF_TYPE];
    }
    if (transition != null) attributes.transitionId = transition.transitionId;
    return attributes;
};

});
parcelRegister("11oYo", function(module, exports) {

$parcel$export(module.exports, "CUSTOM", () => $1b54c33f277795bc$export$952581bc40160893);
$parcel$export(module.exports, "standardIssueTypes", () => $1b54c33f277795bc$export$c5b8a33017b6146a);
$parcel$export(module.exports, "translatedTaskNames", () => $1b54c33f277795bc$export$ae53d86e513cd6);
const $1b54c33f277795bc$var$EPIC = 'Epic';
const $1b54c33f277795bc$var$STORY = 'Story';
const $1b54c33f277795bc$var$BUG = 'Bug';
const $1b54c33f277795bc$var$TASK = 'Task';
const $1b54c33f277795bc$export$952581bc40160893 = 'Custom';
const $1b54c33f277795bc$export$c5b8a33017b6146a = {
    [$1b54c33f277795bc$var$EPIC]: true,
    [$1b54c33f277795bc$var$STORY]: true,
    [$1b54c33f277795bc$var$BUG]: true,
    [$1b54c33f277795bc$var$TASK]: true
};
const $1b54c33f277795bc$export$ae53d86e513cd6 = [
    'Task',
    'Aufgabe',
    'Tarea',
    "T\xe2che",
    "\u30BF\u30B9\u30AF",
    "\uC791\uC5C5",
    'Tarefa',
    "\u0417\u0430\u0434\u0430\u0447\u0430",
    "\xdakol",
    "\xdclesanne",
    "Teht\xe4v\xe4",
    'Feladat',
    'Verk',
    'Taak',
    'Opgave',
    'Oppgave',
    'Zadanie',
    'Activitate',
    "\u0417\u0430\u0434\u0430\u0447\u0430",
    "\xdaloha",
    'Uppgift',
    "G\xf6rev",
    "Nhi\u1EC7m v\u1EE5",
    "\u4EFB\u52A1",
    "\u4EFB\u52D9",
    "Attivit\xe0"
];

});



parcelRegister("eDKuf", function(module, exports) {

$parcel$export(module.exports, "BoardFiltersProvider", () => $479546bd914201c4$export$6a37a41d5e36dc04);

var $9F6cy = parcelRequire("9F6cy");

var $3dR8R = parcelRequire("3dR8R");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $pa9q9 = parcelRequire("pa9q9");

var $93jKl = parcelRequire("93jKl");

var $kaHBi = parcelRequire("kaHBi");

var $3bQtK = parcelRequire("3bQtK");

var $8dXDG = parcelRequire("8dXDG");

var $eERQr = parcelRequire("eERQr");

var $l4Ejo = parcelRequire("l4Ejo");

var $7y8jx = parcelRequire("7y8jx");

var $QW02p = parcelRequire("QW02p");
const $479546bd914201c4$var$experience = 'setBoardViewFilter';
const $479546bd914201c4$export$6a37a41d5e36dc04 = ({ children: children, viewFragment: viewFragment })=>{
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const startExperience = (0, $kaHBi.useExperienceStart)({
        experience: $479546bd914201c4$var$experience,
        analyticsSource: 'jiraWorkManagementBoard'
    });
    const markExperienceSuccess = (0, $3bQtK.useExperienceSuccess)({
        experience: $479546bd914201c4$var$experience
    });
    const markExperienceFailed = (0, $93jKl.useExperienceFail)({
        experience: $479546bd914201c4$var$experience
    });
    const markExperienceAborted = (0, $8dXDG.useExperienceAbort)({
        experience: $479546bd914201c4$var$experience
    });
    const view = (0, $8Uumt.useFragment)((0, $3dR8R.default), viewFragment);
    const [commit] = (0, $8Uumt.useMutation)((0, $9F6cy.default));
    const filterJql = view.filterConfig.jql || undefined;
    const saveJql = (0, $5uXOq.useCallback)((jql)=>{
        startExperience();
        const handleFailure = (error)=>{
            markExperienceFailed('BoardFiltersProvider jira_setBoardViewFilter mutation failed', error);
            showFlag({
                messageId: 'work-management-board.controllers.board-filters.show-flag.error.set-filters-failed',
                messageType: 'transactional',
                title: (0, $QW02p.default).setFiltersFailedTitle,
                description: (0, $QW02p.default).setFiltersFailedMessage,
                type: 'error'
            });
        };
        const newJql = jql ?? '';
        commit({
            variables: {
                input: {
                    viewId: view.id,
                    jql: newJql,
                    settings: (0, $7y8jx.getBoardQueryParams)()
                }
            },
            optimisticResponse: {
                jira_setBoardViewFilter: {
                    success: true,
                    boardView: {
                        ...view,
                        isViewConfigModified: undefined,
                        filterConfig: {
                            jql: newJql
                        }
                    },
                    errors: null
                }
            },
            onError (error) {
                handleFailure(error);
            },
            onCompleted (response) {
                if (response.jira_setBoardViewFilter?.success !== true) {
                    const error = response.jira_setBoardViewFilter?.errors?.[0];
                    const statusCode = error?.extensions?.statusCode ?? 0;
                    if (error?.message && statusCode >= 400 && statusCode < 500) {
                        markExperienceAborted('jira_setBoardViewFilter experience aborted');
                        showFlag({
                            messageId: 'work-management-board.controllers.board-filters.show-flag.error.set-filters-validation-error',
                            messageType: 'transactional',
                            title: (0, $QW02p.default).setFiltersValidationErrorTitle,
                            description: error.message,
                            type: 'error'
                        });
                        return;
                    }
                    const mutationError = new (0, $eERQr.MutationErrorCollection)(response.jira_setBoardViewFilter?.errors);
                    handleFailure(mutationError);
                    return;
                }
                markExperienceSuccess();
            }
        });
    }, [
        commit,
        view,
        showFlag,
        markExperienceAborted,
        markExperienceSuccess,
        startExperience,
        markExperienceFailed
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l4Ejo.InternalFiltersJqlProvider), {
        jql: filterJql,
        saveJql: saveJql
    }, children);
};

});
parcelRegister("9F6cy", function(module, exports) {

$parcel$export(module.exports, "default", () => $77d464465f7fb829$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c5a27ac62d1bc781baed56da4be89f2d>>
 * @relayHash d0d62f0effd7e5fcd1a19c3c17541395
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2114a0add8189bca90bda28de62616b396a480646a6d48bbe0fd434c4e07d5b5
const $77d464465f7fb829$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "ScalarField",
        "name": "isViewConfigModified"
    }, v4 = {
        "kind": "ScalarField",
        "name": "message"
    }, v5 = {
        "kind": "ScalarField",
        "name": "errorType"
    }, v6 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v7 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "BoardFiltersProviderSetFiltersMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "JiraSetBoardViewFilterPayload",
                    "kind": "LinkedField",
                    "name": "jira_setBoardViewFilter",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "JiraBoardView",
                            "kind": "LinkedField",
                            "name": "boardView",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "FragmentSpread",
                                    "name": "BoardFiltersProvider"
                                }
                            ]
                        },
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "BoardFiltersProviderSetFiltersMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "JiraSetBoardViewFilterPayload",
                    "kind": "LinkedField",
                    "name": "jira_setBoardViewFilter",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "JiraBoardView",
                            "kind": "LinkedField",
                            "name": "boardView",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                v7 /*: any*/ ,
                                {
                                    "concreteType": "JiraViewFilterConfig",
                                    "kind": "LinkedField",
                                    "name": "filterConfig",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "jql"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v7 /*: any*/ 
                                            ],
                                            "type": "BulkMutationErrorExtension"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "2114a0add8189bca90bda28de62616b396a480646a6d48bbe0fd434c4e07d5b5",
            "metadata": {},
            "name": "BoardFiltersProviderSetFiltersMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$77d464465f7fb829$var$node.hash = "aeec27652f206f5041fcd9092c50cc2a";
var $77d464465f7fb829$export$2e2bcd8739ae039 = $77d464465f7fb829$var$node;

});

parcelRegister("3dR8R", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf899910ccfad965$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<404e3072d4be50bf8d28b6e2562f0a68>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $bf899910ccfad965$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "BoardFiltersProvider",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "id"
            },
            "action": "THROW",
            "path": "id"
        },
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "JiraViewFilterConfig",
                "kind": "LinkedField",
                "name": "filterConfig",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "jql"
                        },
                        "action": "THROW",
                        "path": "filterConfig.jql"
                    }
                ]
            },
            "action": "THROW",
            "path": "filterConfig"
        }
    ],
    "type": "JiraBoardView"
};
$bf899910ccfad965$var$node.hash = "97474569d53798a2b7137f574cc8a349";
var $bf899910ccfad965$export$2e2bcd8739ae039 = $bf899910ccfad965$var$node;

});

parcelRegister("eERQr", function(module, exports) {

$parcel$export(module.exports, "MutationErrorCollection", () => $b6b9e3c170d256b2$export$d22c6cedeb9f13e);

var $WODVY = parcelRequire("WODVY");
class $b6b9e3c170d256b2$export$d22c6cedeb9f13e extends Error {
    constructor(errors){
        const errorMessage = (0, $WODVY.combineErrorMessages)(errors) ?? 'Unknown error';
        super(errorMessage);
        this.message = errorMessage;
    }
}

});
parcelRegister("WODVY", function(module, exports) {

$parcel$export(module.exports, "combineErrorMessages", () => $3c855403174ad106$export$8a753d214a739485);
/**
 * Formats a mutation error payload into a readable error message string.
 *
 * @param error - The mutation error payload which can be of type `MutationErrorPayload`, `null`, or `undefined`.
 * @returns A formatted error message string.
 *
 * The formatted message includes:
 * - The `__typename` from the `extensions` property, if available, enclosed in parentheses.
 * - The `errorType` from the `extensions` property, if available, enclosed in square brackets.
 * - The `statusCode` from the `extensions` property, if available, prefixed with "HTTP".
 * - The main error message.
 *
 * The parts are concatenated with spaces and any `null` or `undefined` values are filtered out.
 */ function $3c855403174ad106$var$formatErrorMessage(error) {
    const { message: message, extensions: extensions } = error ?? {};
    return [
        extensions?.__typename && `(${extensions.__typename})`,
        extensions?.errorType && `[${extensions.errorType}]`,
        extensions?.statusCode && `HTTP ${extensions.statusCode}:`,
        message
    ].filter(Boolean).join(' ').trim();
}
function $3c855403174ad106$export$8a753d214a739485(errors) {
    return errors?.map($3c855403174ad106$var$formatErrorMessage)?.filter(Boolean)?.join('; ') || undefined;
}

});


parcelRegister("7y8jx", function(module, exports) {

$parcel$export(module.exports, "getBoardQueryParams", () => $e42f2d64c9cfc8e4$export$99a929f88d893f90);
const $e42f2d64c9cfc8e4$export$99a929f88d893f90 = ()=>{
    if (typeof window !== 'undefined') {
        const urlSearchParams = new URLSearchParams(window.location.search);
        const filterJql = urlSearchParams.get('filter') ?? undefined;
        const groupBy = urlSearchParams.get('groupBy') ?? undefined;
        return {
            filterJql: filterJql,
            groupBy: groupBy
        };
    }
    return {};
};

});

parcelRegister("QW02p", function(module, exports) {

$parcel$export(module.exports, "default", () => $38ea749a50111c9c$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $38ea749a50111c9c$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    setFiltersFailedTitle: {
        "id": "work-management-board.controllers.board-filters.set-filters-failed-title",
        "defaultMessage": "Unable to apply your filters"
    },
    setFiltersFailedMessage: {
        "id": "work-management-board.controllers.board-filters.set-filters-failed-message",
        "defaultMessage": "We couldn't apply your filters, try refreshing the page or try again later."
    },
    setFiltersValidationErrorTitle: {
        "id": "work-management-board.controllers.board-filters.set-filters-validation-error-title",
        "defaultMessage": "You cannot apply this filter"
    }
});

});


parcelRegister("dI6Zj", function(module, exports) {

$parcel$export(module.exports, "ColumnDragDropProvider", () => $068a33c3ef7d7d60$export$f18179b46c61fc8e);
$parcel$export(module.exports, "useColumnDragDrop", () => $068a33c3ef7d7d60$export$c7a612ace05118e9);
$parcel$export(module.exports, "useResetDraggedColumn", () => $068a33c3ef7d7d60$export$dd7291f748f70b0f);

var $5uXOq = parcelRequire("5uXOq");
const $068a33c3ef7d7d60$var$ColumnDragDropContext = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $068a33c3ef7d7d60$export$f18179b46c61fc8e = ({ children: children })=>{
    const [dragState, setDragState] = (0, $5uXOq.useState)({
        draggedColumnId: null,
        dragPreviewState: {
            type: 'idle'
        }
    });
    const value = (0, $5uXOq.useMemo)(()=>({
            ...dragState,
            setDragState: setDragState
        }), [
        dragState
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($068a33c3ef7d7d60$var$ColumnDragDropContext.Provider, {
        value: value
    }, children);
};
const $068a33c3ef7d7d60$var$useColumnDragDropContext = ()=>{
    const context = (0, $5uXOq.useContext)($068a33c3ef7d7d60$var$ColumnDragDropContext);
    if (!context) throw new Error('useColumnDragDropContext must be used within a ColumnDragDropProvider');
    return context;
};
const $068a33c3ef7d7d60$export$c7a612ace05118e9 = (columnId)=>{
    const { draggedColumnId: draggedColumnId, dragPreviewState: dragPreviewState, setDragState: setDragState } = $068a33c3ef7d7d60$var$useColumnDragDropContext();
    const startColumnDrag = (0, $5uXOq.useCallback)(()=>setDragState((prevDragState)=>({
                ...prevDragState,
                dragPreviewState: {
                    ...prevDragState.dragPreviewState,
                    draggedColumnId: columnId
                }
            })), [
        columnId,
        setDragState
    ]);
    const resetDraggedColumn = (0, $5uXOq.useCallback)(()=>setDragState((prevDragState)=>({
                ...prevDragState,
                draggedColumnId: null
            })), [
        setDragState
    ]);
    const renderDragPreview = (0, $5uXOq.useCallback)((container)=>setDragState((prevDragState)=>({
                ...prevDragState,
                draggedColumnId: columnId,
                dragPreviewState: {
                    container: container,
                    type: 'preview'
                }
            })), [
        columnId,
        setDragState
    ]);
    const cleanupDragPreview = (0, $5uXOq.useCallback)(()=>setDragState((prevDragState)=>({
                ...prevDragState,
                dragPreviewState: {
                    type: 'idle'
                }
            })), [
        setDragState
    ]);
    const isDragging = draggedColumnId === columnId;
    return {
        cleanupDragPreview: cleanupDragPreview,
        dragPreviewState: dragPreviewState,
        isDragging: isDragging,
        renderDragPreview: renderDragPreview,
        resetDraggedColumn: resetDraggedColumn,
        startColumnDrag: startColumnDrag
    };
};
const $068a33c3ef7d7d60$export$dd7291f748f70b0f = ()=>{
    const { setDragState: setDragState } = $068a33c3ef7d7d60$var$useColumnDragDropContext();
    return (0, $5uXOq.useCallback)(()=>setDragState((prevDragState)=>({
                ...prevDragState,
                draggedColumnId: null
            })), [
        setDragState
    ]);
};

});

parcelRegister("4kGgG", function(module, exports) {

$parcel$export(module.exports, "IssuesByGroupProvider", () => $fd8e605cbbdc055c$export$15e029fbfaee4283);
$parcel$export(module.exports, "useIssuesByGroup", () => $fd8e605cbbdc055c$export$873ca6cec010473a);

var $fjQvQ = parcelRequire("fjQvQ");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $cvj5l = parcelRequire("cvj5l");

var $fPzrH = parcelRequire("fPzrH");

var $cj0Ve = parcelRequire("cj0Ve");
const $fd8e605cbbdc055c$var$IssuesByGroupContext = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $fd8e605cbbdc055c$export$15e029fbfaee4283 = ({ children: children, viewFragment: viewFragment })=>{
    const { filteredIssues: filteredIssues } = (0, $fPzrH.useBoardData)();
    const view = (0, $8Uumt.useFragment)((0, $fjQvQ.default), viewFragment);
    const groupByFieldId = view.groupByConfig.fieldId;
    if (!(0, $cj0Ve.isGroupByType)(groupByFieldId)) throw new Error(`Invalid groupBy fieldId: ${groupByFieldId}`);
    const issuesByGroup = (0, $5uXOq.useMemo)(()=>{
        const map = new Map();
        // iterate over the filtered issues and add them to the correct group
        filteredIssues.forEach((issue)=>{
            const groupId = issue.fields[groupByFieldId]?.value ?? (0, $cvj5l.NULL_GROUP_KEY);
            let groupIssues = map.get(groupId);
            if (!groupIssues) {
                groupIssues = [];
                map.set(groupId, groupIssues);
            }
            groupIssues.push(issue);
        });
        return map;
    }, [
        filteredIssues,
        groupByFieldId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fd8e605cbbdc055c$var$IssuesByGroupContext.Provider, {
        value: issuesByGroup
    }, children);
};
const $fd8e605cbbdc055c$export$873ca6cec010473a = ()=>{
    const issuesByGroup = (0, $5uXOq.useContext)($fd8e605cbbdc055c$var$IssuesByGroupContext);
    if (!issuesByGroup) throw new Error('useIssuesByGroup must be used within a IssuesByGroupProvider');
    return issuesByGroup;
};

});
parcelRegister("fjQvQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $bfd853c59789686f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6f34629355f5d61423d95a69af490f56>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $bfd853c59789686f$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "IssuesByGroupProvider_view",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "JiraViewGroupByConfig",
                "kind": "LinkedField",
                "name": "groupByConfig",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "fieldId"
                        },
                        "action": "THROW",
                        "path": "groupByConfig.fieldId"
                    }
                ]
            },
            "action": "THROW",
            "path": "groupByConfig"
        }
    ],
    "type": "JiraBoardView"
};
$bfd853c59789686f$var$node.hash = "0d0525a4fc8b7803ce3746585687d3aa";
var $bfd853c59789686f$export$2e2bcd8739ae039 = $bfd853c59789686f$var$node;

});

parcelRegister("cj0Ve", function(module, exports) {

$parcel$export(module.exports, "isGroupByType", () => $bb90c384edd41d7e$export$b52524a2780b1a84);

var $hE5wF = parcelRequire("hE5wF");
const $bb90c384edd41d7e$var$GROUP_BY_TYPES = new Set([
    (0, $hE5wF.GROUP_BY_ASSIGNEE),
    (0, $hE5wF.GROUP_BY_CATEGORY),
    (0, $hE5wF.GROUP_BY_PRIORITY),
    (0, $hE5wF.GROUP_BY_STATUS)
]);
const $bb90c384edd41d7e$export$b52524a2780b1a84 = (groupBy)=>{
    return $bb90c384edd41d7e$var$GROUP_BY_TYPES.has(groupBy);
};

});


parcelRegister("5gFbH", function(module, exports) {

$parcel$export(module.exports, "default", () => $20113648c1232e80$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $20113648c1232e80$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    boardHeading: {
        "id": "work-management-board.board-heading",
        "defaultMessage": "Board"
    }
});

});

parcelRegister("hwtkc", function(module, exports) {

$parcel$export(module.exports, "useCreateIssue", () => $021b0a9a98f3aeb0$export$8af2d18142c8506c);

var $5uXOq = parcelRequire("5uXOq");

var $5tTFS = parcelRequire("5tTFS");

var $egmQO = parcelRequire("egmQO");

var $5YBrl = parcelRequire("5YBrl");

var $kRkJF = parcelRequire("kRkJF");

var $jlq4V = parcelRequire("jlq4V");

var $jJZqs = parcelRequire("jJZqs");

var $eCBf9 = parcelRequire("eCBf9");

var $5fc53 = parcelRequire("5fc53");

var $iZgee = parcelRequire("iZgee");

var $koeKL = parcelRequire("koeKL");

var $cvj5l = parcelRequire("cvj5l");

var $b58r7 = parcelRequire("b58r7");

var $ekUhS = parcelRequire("ekUhS");
function $021b0a9a98f3aeb0$export$fd83eea6ecd2d8fa(query) {
    const client = (0, $5tTFS.useApolloClient)();
    return (0, $5uXOq.useCallback)((variables)=>client.query({
            query: query,
            variables: variables,
            errorPolicy: 'all'
        }), [
        client,
        query
    ]);
}
const $021b0a9a98f3aeb0$export$8af2d18142c8506c = ({ categoryFieldId: categoryFieldId })=>{
    const isLinkingEnabled = (0, $iZgee.useIsLinkingEnabled)();
    const cloudId = (0, $koeKL.useCloudId)();
    const jqlContext = (0, $5YBrl.useJqlContext)();
    const filtersJQL = (0, $kRkJF.useFilteredViewJQL)();
    const refetchIssue = $021b0a9a98f3aeb0$export$fd83eea6ecd2d8fa((0, $b58r7.ISSUE_REFETCH_QUERY));
    const [createIssue] = (0, $5tTFS.useMutation)((0, $b58r7.CREATE_ISSUE_MUTATION));
    const createIssueService = (0, $5uXOq.useCallback)(async (createParams, extraPayload = {})=>{
        const input = (0, $ekUhS.buildInput)(createParams.input, extraPayload, categoryFieldId);
        const fieldIdsSet = new Set(createParams.fieldIdsToReturn);
        const withIssueLinks = fieldIdsSet.has((0, $5fc53.ISSUE_LINKS_TYPE)) && isLinkingEnabled;
        fieldIdsSet.delete((0, $5fc53.ISSUE_LINKS_TYPE));
        const withCoverMedia = fieldIdsSet.has((0, $cvj5l.CARD_COVER));
        fieldIdsSet.delete((0, $cvj5l.CARD_COVER));
        const fieldIds = Array.from(fieldIdsSet);
        const { data: data, errors: errors } = await createIssue({
            variables: {
                input: input,
                fieldIds: fieldIds,
                withCoverMedia: withCoverMedia,
                withChildrenCount: false,
                withIssueLinks: withIssueLinks
            },
            // @ts-expect-error - errorPolicy is not in the types but does work
            errorPolicy: 'all'
        });
        const result = data?.createJiraBusinessIssue;
        if (result?.success !== true || !result?.item) {
            const firstMutationError = result?.errors?.[0];
            if (firstMutationError) {
                const statusCode = firstMutationError.extensions?.statusCode;
                if (statusCode && statusCode >= 400 && statusCode < 500) throw new (0, $jJZqs.ValidationError)(firstMutationError.message ?? 'Failed to create issue');
                throw new (0, $eCBf9.MutationError)(firstMutationError);
            }
            throw new (0, $jlq4V.GraphQLErrors)(errors);
        }
        return {
            item: result.item,
            itemIdentifiers: {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                issueId: result.itemIdentifiers.issueId,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-non-null-assertion
                issueKey: result.itemIdentifiers.issueKey[0].text
            }
        };
    }, [
        categoryFieldId,
        createIssue,
        isLinkingEnabled
    ]);
    const refetchIssueService = (0, $5uXOq.useCallback)(async (issueId, fieldIds, withFiltersContext)=>{
        const jql = (0, $egmQO.generateJql)({
            jqlContext: jqlContext,
            quickFiltersJql: withFiltersContext ? filtersJQL : undefined,
            issueIds: [
                issueId
            ]
        });
        const fieldIdsSet = new Set(fieldIds);
        const withIssueLinks = fieldIdsSet.has((0, $5fc53.ISSUE_LINKS_TYPE)) && isLinkingEnabled;
        fieldIdsSet.delete((0, $5fc53.ISSUE_LINKS_TYPE));
        const withCoverMedia = fieldIdsSet.has((0, $cvj5l.CARD_COVER));
        fieldIdsSet.delete((0, $cvj5l.CARD_COVER));
        const fieldIdsToRequest = Array.from(fieldIdsSet);
        const { data: data } = await refetchIssue({
            jql: jql,
            fieldIds: fieldIdsToRequest,
            cloudId: cloudId,
            first: 1,
            withCoverMedia: withCoverMedia,
            withChildrenCount: false,
            withIssueLinks: withIssueLinks
        });
        const viewItems = data?.jira?.jwmViewItems;
        if (!viewItems || viewItems.__typename === 'QueryError') throw new Error('Issue not found');
        const issue = viewItems.edges?.[0]?.node;
        return issue ?? null;
    }, [
        cloudId,
        filtersJQL,
        jqlContext,
        refetchIssue,
        isLinkingEnabled
    ]);
    return {
        createIssue: createIssueService,
        refetchIssue: refetchIssueService
    };
};

});
parcelRegister("egmQO", function(module, exports) {

$parcel$export(module.exports, "generateJql", () => $da4d6eca1d928e18$export$d43e55153d6948c0);
$parcel$export(module.exports, "getVariables", () => $da4d6eca1d928e18$export$a39eddd73bba62c1);

var $hE5wF = parcelRequire("hE5wF");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");


var $42GbZ = parcelRequire("42GbZ");
const $da4d6eca1d928e18$var$DEFAULT_CHILDREN_PER_PAGE = (0, $hE5wF.DEFAULT_PAGE_SIZE);
const $da4d6eca1d928e18$var$IS_EMPTY = 'IS EMPTY';
const $da4d6eca1d928e18$var$IS_NOT_EMPTY = 'IS NOT EMPTY';
const $da4d6eca1d928e18$export$d43e55153d6948c0 = (input, parentIssueForJql)=>{
    const { groupQuery: groupQuery, hierarchyLevel: hierarchyLevel, hierarchyParent: hierarchyParent, issueIds: issueIds, jqlContext: jqlContext, projectIdOrKey: projectIdOrKey, quickFiltersJql: quickFiltersJql, sorting: sorting } = input;
    const defaultSorting = `ORDER BY Rank ${(0, $hE5wF.DEFAULT_RANK_SORTING_DIRECTION)}`;
    const jql = [];
    // Check if sorting direction is valid, the direction possible passed from the URL params which can be invalid
    const isValidDirection = sorting?.direction?.toUpperCase() === 'ASC' || sorting?.direction?.toUpperCase() === 'DESC';
    const sortByClause = sorting != null && sorting.sortBy != null && sorting.direction != null && isValidDirection ? `ORDER By ${(0, $42GbZ.getJqlTerm)(sorting.sortBy)} ${sorting.direction}, Rank ${sorting.direction}` : defaultSorting;
    if (Array.isArray(issueIds) && issueIds.length > 0) jql.push(`(${issueIds.map((id)=>`id = ${id}`).join(' or ')})`);
    if (jqlContext) jql.push(jqlContext);
    else if (typeof projectIdOrKey !== 'undefined') jql.push(`project = '${projectIdOrKey}'`);
    if (typeof hierarchyLevel === 'number' && hierarchyParent === (0, $8debe7dace56daea$export$9355e489ad16f98e)) {
        // fetch items by hierarchyLevel + any item that doesn't have a parent (e.g. tasks that don't belong to any Epic)
        if (typeof projectIdOrKey !== 'undefined') jql.push(`(hierarchyLevel = ${hierarchyLevel} OR parent ${$da4d6eca1d928e18$var$IS_EMPTY} OR (parent ${$da4d6eca1d928e18$var$IS_NOT_EMPTY} AND parentProject != '${projectIdOrKey}'))`);
        else jql.push(`(hierarchyLevel = ${hierarchyLevel} OR parent ${$da4d6eca1d928e18$var$IS_EMPTY})`);
    }
    if (hierarchyParent === (0, $8debe7dace56daea$export$9355e489ad16f98e)) jql.push('type in standardIssueTypes()');
    // Controls the query to get all children for a single parent
    if (parentIssueForJql && parentIssueForJql.hierarchyType === (0, $8debe7dace56daea$export$9355e489ad16f98e)) jql.push(`parent = '${parentIssueForJql.issueId}'`);
    // Controls the query to get group items
    if (groupQuery) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const { jqlTerm: jqlTerm, value: value } = groupQuery;
        if (!value) jql.push(`${jqlTerm} ${$da4d6eca1d928e18$var$IS_EMPTY}`);
        else jql.push(`${jqlTerm} = ${value}`);
        if (hierarchyParent === (0, $8debe7dace56daea$export$9355e489ad16f98e)) {
            if (typeof projectIdOrKey !== 'undefined') jql.push(`(parent ${$da4d6eca1d928e18$var$IS_EMPTY} OR (parent ${$da4d6eca1d928e18$var$IS_NOT_EMPTY} AND parentProject != '${projectIdOrKey}'))`);
            else jql.push(`parent ${$da4d6eca1d928e18$var$IS_EMPTY}`);
        }
    }
    if (quickFiltersJql != null) jql.push(`(${quickFiltersJql})`);
    return `${jql.join(' AND ')} ${sortByClause}`;
};
const $da4d6eca1d928e18$export$a39eddd73bba62c1 = (input)=>{
    const { fieldIds: fieldIds, parentIssue: parentIssue } = input;
    const singleQueryJql = {
        jql: $da4d6eca1d928e18$export$d43e55153d6948c0(input, parentIssue)
    };
    // REMOTE_ISSUE_LINKS_TYPE should not be part of the fieldIds as it is only used to determine
    // whether legacyConfluenceLinks(JIS2) is fetched
    const newFieldIds = Array.isArray(fieldIds) ? [
        ...fieldIds
    ] : [];
    const remoteIssueLinksIndex = newFieldIds.indexOf((0, $hE5wF.REMOTE_ISSUE_LINKS_TYPE));
    const hasConfluenceLinks = remoteIssueLinksIndex > -1;
    if (hasConfluenceLinks) newFieldIds.splice(remoteIssueLinksIndex, 1);
    const shouldAddWithQueryError = input.withQueryError && (0, $4R6GH.fg)('timeline-add-jql-error-boundary');
    return {
        ...singleQueryJql,
        first: parentIssue ? $da4d6eca1d928e18$var$DEFAULT_CHILDREN_PER_PAGE : (0, $hE5wF.DEFAULT_PAGE_SIZE),
        fieldIds: newFieldIds,
        withConfluenceLinks: hasConfluenceLinks,
        includeDoneItems: input.isHidingDoneItems === false,
        isParentFieldVisible: input.isParentFieldVisible ?? false,
        isDevSummaryFieldVisible: input.isDevSummaryFieldVisible ?? false,
        isUnreadCommentsEnabled: (0, $6s1PB.expVal)('jira_unread_comments_in_list_view', 'isEnabled', false),
        includeIsVerifiedInTeamFragment: (0, $4R6GH.fg)('is-verified-in-business-team-field-fragment'),
        ...shouldAddWithQueryError && {
            withQueryError: input.withQueryError
        }
    };
};

});
const $8debe7dace56daea$export$9355e489ad16f98e = 'TASK';
const $8debe7dace56daea$export$3cb4a99a332e4186 = 'EPIC';

parcelRegister("42GbZ", function(module, exports) {

$parcel$export(module.exports, "getJqlTerm", () => $f8ba3884a7b69792$export$43330b5a5235b231);

var $5fc53 = parcelRequire("5fc53");
const $f8ba3884a7b69792$export$43330b5a5235b231 = (fieldId, fieldType)=>{
    // custom fields are indexed by their ids and only work with JQL when referenced as such `cf[id]`.
    if (fieldId.indexOf('customfield_') === 0) {
        const customFieldId = fieldId.split('customfield_')[1];
        return `cf[${customFieldId}]`;
    }
    // We are hardcoding the components field jqlTerm because is not the same as field ID
    // We should get the jqlTerm from the BE
    // https://atlassian.slack.com/archives/CFGMKF5QC/p1724650674231049?thread_ts=1720579171.825049&cid=CFGMKF5QC
    if (fieldType === (0, $5fc53.COMPONENTS_TYPE)) return 'component';
    return fieldId;
};

});


parcelRegister("kRkJF", function(module, exports) {

$parcel$export(module.exports, "useFilteredViewJQL", () => $6b3238559c925b96$export$a50cc7c1087f7d9b);
$parcel$export(module.exports, "useFilteredViewContextInput", () => $6b3238559c925b96$export$d566b5d8a729afa0);

var $5uXOq = parcelRequire("5uXOq");


var $5YBrl = parcelRequire("5YBrl");

var $5fc53 = parcelRequire("5fc53");

var $2UUq6 = parcelRequire("2UUq6");

var $17ot5 = parcelRequire("17ot5");

var $l4Ejo = parcelRequire("l4Ejo");

var $1T1ir = parcelRequire("1T1ir");

var $7VpiX = parcelRequire("7VpiX");
const $6b3238559c925b96$export$a50cc7c1087f7d9b = ()=>{
    const { addSimpleSearchToJQL: addSimpleSearchToJQL } = (0, $1T1ir.useSimpleSearchJQL)();
    const { jql: jql } = (0, $l4Ejo.useFilters)();
    const [isHidingDoneItems] = (0, $17ot5.useHideDoneItems)();
    // ensure views recieve filters jql that will not cause a page crash
    const jqlSanitised = (0, $5uXOq.useMemo)(()=>(0, $7VpiX.sanitiseJql)(jql), [
        jql
    ]);
    const filtersJQL = (0, $5uXOq.useMemo)(()=>{
        if (isHidingDoneItems) {
            const filtersJql = [
                jqlSanitised,
                "StatusCategory != 'Complete'"
            ].filter(Boolean).join(' AND ');
            return addSimpleSearchToJQL(filtersJql);
        }
        return addSimpleSearchToJQL(jqlSanitised || null);
    }, [
        jqlSanitised,
        addSimpleSearchToJQL,
        isHidingDoneItems
    ]);
    return filtersJQL;
};
const $6b3238559c925b96$var$FIX_VERSION_SORTING_JQL = 'fixVersion';
const $6b3238559c925b96$export$d566b5d8a729afa0 = ({ view: view })=>{
    const filtersJQL = $6b3238559c925b96$export$a50cc7c1087f7d9b();
    const { isSearching: isSearching } = (0, $1T1ir.useSimpleSearchJQL)();
    const [sortingBy] = (0, $2UUq6.useSorting)();
    const { jql: jql } = (0, $l4Ejo.useFilters)();
    const isFiltering = jql != null || isSearching;
    const [isHidingDoneItems] = (0, $17ot5.useHideDoneItems)();
    const jqlContext = (0, $5YBrl.useJqlContext)();
    const hierarchyParent = (view === 'list' || view === 'timeline') && !isFiltering ? (0, $8debe7dace56daea$export$9355e489ad16f98e) : undefined;
    const jqlErrors = (0, $5uXOq.useMemo)(()=>(0, $7VpiX.getJqlErrors)(jql), [
        jql
    ]);
    const sorting = (0, $5uXOq.useMemo)(()=>{
        /*
			When sorting by a specific field, we use the fieldId in the JQL query.
			For the fix version field, the fieldId doesn’t work in JQL must be “fixVersion”.
			Apparently, "fixVersion" is the clause name. It's a legacy choice that was made from the very beginning, and now we're unable to change it.
		*/ if (sortingBy.sortBy === (0, $5fc53.FIX_VERSIONS_TYPE)) return {
            ...sortingBy,
            sortBy: $6b3238559c925b96$var$FIX_VERSION_SORTING_JQL
        };
        return sortingBy;
    }, [
        sortingBy
    ]);
    return {
        jqlContext: jqlContext,
        quickFiltersJql: filtersJQL,
        sorting: sorting,
        isFiltering: isFiltering,
        hierarchyParent: hierarchyParent,
        isHidingDoneItems: isHidingDoneItems,
        jqlErrors: jqlErrors
    };
};

});
parcelRegister("2UUq6", function(module, exports) {

$parcel$export(module.exports, "useSorting", () => $46c72127586d4f92$export$21ebc1ba2b2bee67);
$parcel$export(module.exports, "useSorter", () => $46c72127586d4f92$export$f161a6f9d84a6fea);

var $5uXOq = parcelRequire("5uXOq");

var $ftuRD = parcelRequire("ftuRD");

var $1T2vX = parcelRequire("1T2vX");

var $x8FYU = parcelRequire("x8FYU");

var $1kpI8 = parcelRequire("1kpI8");

var $8841m = parcelRequire("8841m");

var $h1cpf = parcelRequire("h1cpf");

var $8Yjb2 = parcelRequire("8Yjb2");
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const $46c72127586d4f92$var$EMPTY_SORTING_ATTRIBUTE = {};
const $46c72127586d4f92$export$21ebc1ba2b2bee67 = ()=>{
    const [sorting, setSorting] = (0, $1kpI8.useViewPreference)((0, $x8FYU.SORTING_PREFERENCE));
    return [
        sorting || $46c72127586d4f92$var$EMPTY_SORTING_ATTRIBUTE,
        setSorting
    ];
};
const $46c72127586d4f92$var$emptyArray = [];
const $46c72127586d4f92$export$f161a6f9d84a6fea = ()=>{
    const [sorting] = $46c72127586d4f92$export$21ebc1ba2b2bee67();
    const [sortingFieldConfig] = (0, $ftuRD.useIssueTypeFieldConfig)({
        screen: 'VIEW',
        issueTypeId: 'default',
        fieldId: sorting.sortBy
    });
    const [priorityFieldConfig] = (0, $ftuRD.useIssueTypeFieldConfig)({
        screen: 'VIEW',
        issueTypeId: 'default',
        fieldId: 'priority'
    });
    const { data: data } = (0, $1T2vX.useIssueTypesAndFields)({
        issueOperation: 'VIEW'
    });
    const sortingFieldConfigFieldType = sortingFieldConfig?.fieldType ?? data?.fields?.find((field)=>field?.id === sorting.sortBy)?.type;
    const { statuses: statuses } = (0, $8841m.useProjectStatuses)();
    const priorities = priorityFieldConfig?.options || $46c72127586d4f92$var$emptyArray;
    const sortFunction = (0, $5uXOq.useCallback)((issues)=>{
        const getPrioritiesSortedList = ()=>[
                ...priorities
            ].reverse().reduce((acc, next, index)=>{
                acc[next.priorityId] = index;
                return acc;
            }, {});
        const getIssueTypesSortedList = ()=>[
                ...data.issueTypes
            ].sort((a, b)=>a.name.localeCompare(b.name)).reduce((acc, next, index)=>{
                acc[next.name] = index;
                return acc;
            }, {});
        const getStatusSortOrder = (key)=>{
            if (key in (0, $h1cpf.STATUS_SORT_ORDER)) return (0, $h1cpf.STATUS_SORT_ORDER)[key];
            return -1;
        };
        const getStatusesSortedList = ()=>[
                ...statuses
            ].sort((a, b)=>{
                const orderComparison = getStatusSortOrder(a.statusCategory.key) - getStatusSortOrder(b.statusCategory.key);
                if (orderComparison !== 0) return orderComparison;
                // If the status category order is the same, then sort alphabetically by name.
                return a.name.localeCompare(b.name);
            }).reduce((acc, next, index)=>{
                acc[next.name] = index;
                return acc;
            }, {});
        const sortedLists = {
            priorities: getPrioritiesSortedList(),
            issueTypes: getIssueTypesSortedList(),
            statuses: getStatusesSortedList()
        };
        const { getters: getters, orders: orders } = (0, $8Yjb2.createSortingGettersAndOrders)(sorting, sortingFieldConfigFieldType, sortedLists);
        return (0, $8Yjb2.sortListBy)(issues, getters, orders);
    }, [
        sorting,
        sortingFieldConfigFieldType,
        priorities,
        data.issueTypes,
        statuses
    ]);
    return {
        sort: sortFunction
    };
};

});
parcelRegister("h1cpf", function(module, exports) {

$parcel$export(module.exports, "STATUS_SORT_ORDER", () => $20cadc5cf5f0437c$export$de9c103e53e690d1);
const $20cadc5cf5f0437c$export$de9c103e53e690d1 = {
    new: 1,
    indeterminate: 2,
    done: 3
};

});

parcelRegister("8Yjb2", function(module, exports) {

$parcel$export(module.exports, "sortListBy", () => $9b7a6804aae1eb73$export$3793ed28be8699ad);
$parcel$export(module.exports, "createSortingGettersAndOrders", () => $9b7a6804aae1eb73$export$b3fdfcb601c683c3);

var $1AkQu = parcelRequire("1AkQu");

var $hE5wF = parcelRequire("hE5wF");

var $ijSZT = parcelRequire("ijSZT");

var $fCkUD = parcelRequire("fCkUD");

var $57lFd = parcelRequire("57lFd");

var $gULOk = parcelRequire("gULOk");

var $5fc53 = parcelRequire("5fc53");

var $ixx6N = parcelRequire("ixx6N");
const $9b7a6804aae1eb73$var$DEFAULT_HIGHER_RANKING_VALUE = 'Z';
const $9b7a6804aae1eb73$var$DEFAULT_LOWER_RANKING_VALUE = '~~';
const $9b7a6804aae1eb73$var$DEFAULT_LOWER_RANKING_NUMBER_VALUE = 0;
const $9b7a6804aae1eb73$var$toAcceptedOrder = (order)=>order != null && order.toLowerCase() === 'asc' ? 'asc' : 'desc';
const $9b7a6804aae1eb73$export$3793ed28be8699ad = (nodes, getters, orders)=>(0, (/*@__PURE__*/$parcel$interopDefault($1AkQu)))(nodes, getters, orders.map($9b7a6804aae1eb73$var$toAcceptedOrder));
const $9b7a6804aae1eb73$var$getValueMapAndJoin = (fields, fieldKey, attributeName, defaultValue, // eslint-disable-next-line @typescript-eslint/no-explicit-any
getMapValueCb)=>{
    // join array with space so alphabetical order can be applied.
    // @ts-expect-error - TS2345 - Argument of type 'string | null | undefined' is not assignable to parameter of type 'string | undefined'.
    const fieldValue = (0, $57lFd.safeGetValue)(fields, fieldKey, attributeName, defaultValue) ?? defaultValue;
    return fieldValue.map(getMapValueCb).join(' ') || $9b7a6804aae1eb73$var$DEFAULT_LOWER_RANKING_VALUE;
};
const $9b7a6804aae1eb73$var$resolvePriorityOrder = (fields, priorities)=>{
    const priorityId = (0, $57lFd.safeGetValue)(fields, 'priority', 'value.priorityId', '');
    const priorityOrder = priorities[priorityId];
    if (priorityOrder == null) return -1;
    return priorityOrder;
};
const $9b7a6804aae1eb73$var$resolveStatusOrder = (fields, statuses)=>{
    const statusName = (0, $57lFd.safeGetValue)(fields, 'status', 'name', '');
    const statusOrder = statuses[statusName];
    if (statusOrder == null) return -1;
    return statusOrder;
};
const $9b7a6804aae1eb73$var$resolveTypeOrder = (fields, types)=>{
    const typeName = (0, $57lFd.safeGetValue)(fields, 'issuetype', 'value', '');
    const typeOrder = types[typeName];
    if (typeOrder == null) return -1;
    return typeOrder;
};
const $9b7a6804aae1eb73$var$resolveIssueKeyOrder = (fields)=>{
    const [, issueKeyNumber = 0] = (0, $57lFd.safeGetValue)(fields, 'issuekey', 'value', '').split('-');
    return Number(issueKeyNumber);
};
const $9b7a6804aae1eb73$var$resolveCustomTextFieldOrder = (fields, sortingField)=>{
    // wiki value will be null when empty
    const value = (0, $57lFd.safeGetValue)(fields, sortingField, 'value', null);
    return value != null ? value.toLowerCase() : $9b7a6804aae1eb73$var$DEFAULT_LOWER_RANKING_VALUE; // empty values should rank lower
};
const $9b7a6804aae1eb73$var$createSortableGetter = (fieldType, sortingField, sortedList)=>(node)=>{
        const { rank: rank, fields: fields = [] } = node;
        if (fieldType != null && (0, $ijSZT.isSortingSupportedFieldTypePredicated)(fieldType) && (0, $ijSZT.isSortingSupported)(fieldType)) {
            const field = (0, $57lFd.getFieldValue)(fields, sortingField);
            if ((0, $fCkUD.isNewTransformedFieldPredicated)(field)) return (0, $ijSZT.getSorting)(fieldType, field) || $9b7a6804aae1eb73$var$DEFAULT_LOWER_RANKING_VALUE;
            return $9b7a6804aae1eb73$var$DEFAULT_LOWER_RANKING_VALUE;
        }
        switch(fieldType){
            case 0, $5fc53.LABELS_TYPE:
            case 0, $5fc53.LABELS_CF_TYPE:
                // The backend will return [''] when it's empty so our default value might not be applied so we force return ~~ when it happens so empty items are ordered properly
                return $9b7a6804aae1eb73$var$getValueMapAndJoin(fields, sortingField, 'value', [
                    ''
                ], (label)=>label.toLowerCase());
            case 0, $5fc53.PRIORITY_TYPE:
                return $9b7a6804aae1eb73$var$resolvePriorityOrder(fields, sortedList != null && sortedList.priorities || {});
            case 0, $5fc53.STATUS_TYPE:
                return $9b7a6804aae1eb73$var$resolveStatusOrder(fields, sortedList != null && sortedList.statuses || {});
            case 0, $5fc53.ISSUE_TYPE:
                return $9b7a6804aae1eb73$var$resolveTypeOrder(fields, sortedList != null && sortedList.issueTypes || {});
            case 0, $5fc53.ASSIGNEE_TYPE:
            case 0, $5fc53.REPORTER_TYPE:
                return (0, $57lFd.safeGetValue)(fields, sortingField, 'value.name', // unassigned items are ranked higher than the ones with an user :shrug:
                $9b7a6804aae1eb73$var$DEFAULT_LOWER_RANKING_VALUE).toLowerCase();
            case 0, $5fc53.USER_CF_TYPE:
                return (0, $57lFd.safeGetValue)(fields, sortingField, 'value.name', // unassigned items are ranked higher than the ones with an user :shrug:
                $9b7a6804aae1eb73$var$DEFAULT_LOWER_RANKING_VALUE).toLowerCase();
            case 'issuekey':
                return $9b7a6804aae1eb73$var$resolveIssueKeyOrder(fields);
            case 0, $5fc53.CREATED:
            case 0, $5fc53.UPDATED:
                return (0, $57lFd.safeGetValue)(fields, sortingField, 'value', '');
            case 0, $5fc53.DATE_CF_TYPE:
                return (0, $57lFd.safeGetValue)(fields, sortingField, 'value', $9b7a6804aae1eb73$var$DEFAULT_HIGHER_RANKING_VALUE);
            case 0, $5fc53.DUE_DATE_TYPE:
                return (0, $57lFd.safeGetValue)(fields, sortingField, 'value', // empty dates are ranked higher than the ones with set date :shrug:
                $9b7a6804aae1eb73$var$DEFAULT_HIGHER_RANKING_VALUE);
            case 0, $5fc53.DATETIME_CF_TYPE:
                return (0, $57lFd.safeGetValue)(fields, sortingField, 'value', $9b7a6804aae1eb73$var$DEFAULT_HIGHER_RANKING_VALUE);
            case 0, $hE5wF.RANK_ALIAS_FIELD_ID:
                // We want to check for l-1 if the new jql parent is on
                if ((0, $57lFd.safeGetValue)(fields, 'issuetype', 'level', undefined) === -1) return (0, $ixx6N.resolveRank)((0, $57lFd.safeGetValue)(fields, 'parent', 'value', undefined), rank ?? '');
                return rank ?? '';
            case 0, $5fc53.SUMMARY_TYPE:
                return (0, $57lFd.safeGetValue)(fields, sortingField, 'value', '').toLowerCase();
            case 0, $5fc53.TEXT_CF_TYPE:
                return $9b7a6804aae1eb73$var$resolveCustomTextFieldOrder(fields, sortingField);
            case 0, $5fc53.SELECT_CF_TYPE:
            case 0, $5fc53.CATEGORY_TYPE:
                return (0, $57lFd.safeGetValue)(fields, sortingField, 'value.value', $9b7a6804aae1eb73$var$DEFAULT_LOWER_RANKING_VALUE);
            case 0, $5fc53.MULTI_SELECT_CF_TYPE:
            case 0, $5fc53.MULTI_CHECKBOXES_CF_TYPE:
                return $9b7a6804aae1eb73$var$getValueMapAndJoin(fields, sortingField, 'value', [], (selectedValue)=>selectedValue?.value.toLowerCase());
            case 0, $5fc53.TIME_ESTIMATE_TYPE:
                return (0, $57lFd.safeGetValue)(fields, sortingField, 'value.timeInSeconds', $9b7a6804aae1eb73$var$DEFAULT_LOWER_RANKING_NUMBER_VALUE);
            case 0, $5fc53.URL_CF_TYPE:
                return (0, $57lFd.safeGetValue)(fields, sortingField, 'value', $9b7a6804aae1eb73$var$DEFAULT_LOWER_RANKING_VALUE);
            case 0, $5fc53.NUMBER_CF_TYPE:
            case 0, $5fc53.STORY_POINTS_TYPE:
            case 0, $5fc53.STORY_POINT_ESTIMATE_CF_TYPE:
                return (0, $57lFd.safeGetValue)(fields, sortingField, 'value', $9b7a6804aae1eb73$var$DEFAULT_LOWER_RANKING_NUMBER_VALUE);
            case 0, $5fc53.COMPONENTS_TYPE:
                return $9b7a6804aae1eb73$var$getValueMapAndJoin(fields, sortingField, 'value', [], (component)=>component?.name.toLowerCase());
            case 0, $5fc53.SPRINT_TYPE:
                {
                    const sprintValue = (0, $57lFd.safeGetValue)(fields, sortingField, 'value', $9b7a6804aae1eb73$var$DEFAULT_LOWER_RANKING_VALUE);
                    if (Array.isArray(sprintValue) && sprintValue.length) {
                        const { name: name, state: state } = sprintValue[0];
                        if (state === 'CLOSED') {
                            const statusId = (0, $57lFd.safeGetValue)(fields, 'status', 'value', '');
                            // closed sprints should not be shown if the status is not done
                            // means that this ticket is on the backlog
                            if (statusId?.toString() !== (0, $gULOk.StatusCategoryIds)[(0, $gULOk.StatusCategoryTypes).DONE].toString()) return $9b7a6804aae1eb73$var$DEFAULT_LOWER_RANKING_VALUE;
                        }
                        return name.toLowerCase();
                    }
                    return $9b7a6804aae1eb73$var$DEFAULT_LOWER_RANKING_VALUE;
                }
            default:
                return (0, $57lFd.safeGetValue)(fields, (0, $hE5wF.RANK_ALIAS_FIELD_ID), 'value', '');
        }
    };
const $9b7a6804aae1eb73$export$b3fdfcb601c683c3 = (sorting, fieldType, sortedLists)=>{
    const getters = [];
    const orders = [];
    let sortFieldType = fieldType;
    // fieldType for key is not returned from useIssueTypeFieldConfig
    if (sorting?.sortBy === 'key') sortFieldType = 'issuekey';
    if (sorting != null && sorting.sortBy != null) {
        orders.push(sorting.direction, sorting.direction);
        getters.push($9b7a6804aae1eb73$var$createSortableGetter(sortFieldType, sorting.sortBy, sortedLists));
        getters.push($9b7a6804aae1eb73$var$createSortableGetter((0, $hE5wF.RANK_ALIAS_FIELD_ID), (0, $hE5wF.RANK_ALIAS_FIELD_ID)));
    } else {
        orders.push((0, $hE5wF.DEFAULT_RANK_SORTING_DIRECTION));
        getters.push($9b7a6804aae1eb73$var$createSortableGetter((0, $hE5wF.RANK_ALIAS_FIELD_ID), (0, $hE5wF.RANK_ALIAS_FIELD_ID)));
    }
    return {
        getters: getters,
        orders: orders
    };
};

});
parcelRegister("1AkQu", function(module, exports) {

var $kE90z = parcelRequire("kE90z");

var $8LQ84 = parcelRequire("8LQ84");
/**
 * This method is like `_.sortBy` except that it allows specifying the sort
 * orders of the iteratees to sort by. If `orders` is unspecified, all values
 * are sorted in ascending order. Otherwise, specify an order of "desc" for
 * descending or "asc" for ascending sort order of corresponding values.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @param {string[]} [orders] The sort orders of `iteratees`.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 34 },
 *   { 'user': 'fred',   'age': 40 },
 *   { 'user': 'barney', 'age': 36 }
 * ];
 *
 * // Sort by `user` in ascending order and by `age` in descending order.
 * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
 */ function $127952ba7d4c15a6$var$orderBy(collection, iteratees, orders, guard) {
    if (collection == null) return [];
    if (!$8LQ84(iteratees)) iteratees = iteratees == null ? [] : [
        iteratees
    ];
    orders = guard ? undefined : orders;
    if (!$8LQ84(orders)) orders = orders == null ? [] : [
        orders
    ];
    return $kE90z(collection, iteratees, orders);
}
module.exports = $127952ba7d4c15a6$var$orderBy;

});

parcelRegister("ijSZT", function(module, exports) {

$parcel$export(module.exports, "getSorting", () => $426da0baa4d91e21$export$654dceec98f3061f);
$parcel$export(module.exports, "isSortingSupported", () => $426da0baa4d91e21$export$c6c6084d02f37d7e);
$parcel$export(module.exports, "isSortingSupportedFieldTypePredicated", () => $426da0baa4d91e21$export$190ed2ad153b150b);
$parcel$export(module.exports, "getSortingDisabledFields", () => $426da0baa4d91e21$export$56c924491e5617ad);

var $8QpSo = parcelRequire("8QpSo");

var $1OjAh = parcelRequire("1OjAh");

var $5nNdw = parcelRequire("5nNdw");

var $cBFqc = parcelRequire("cBFqc");

var $coSD0 = parcelRequire("coSD0");

var $55FhM = parcelRequire("55FhM");

var $gjQcQ = parcelRequire("gjQcQ");

var $4CML6 = parcelRequire("4CML6");

var $WhnfX = parcelRequire("WhnfX");

var $aK7yP = parcelRequire("aK7yP");

var $7LNXH = parcelRequire("7LNXH");

var $dtcdd = parcelRequire("dtcdd");
const $426da0baa4d91e21$var$createSortingHandlers = (0, $8QpSo.default)(()=>({
        ...(0, $55FhM.parentSortingHandler),
        ...(0, $dtcdd.versionSortingHandler),
        ...(0, $WhnfX.resolutionSortingHandler),
        ...(0, $coSD0.groupSortingHandler),
        ...(0, $4CML6.radioSelectSortingHandler),
        ...(0, $1OjAh.cascadingSelectSortingHandler),
        ...(0, $gjQcQ.projectSortingHandler)
    }));
const $426da0baa4d91e21$export$654dceec98f3061f = (fieldType, ...args)=>{
    const handlers = $426da0baa4d91e21$var$createSortingHandlers();
    if (handlers[fieldType] == null) return;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return handlers[fieldType]?.(...args);
};
const $426da0baa4d91e21$export$c6c6084d02f37d7e = (fieldType)=>{
    const handlers = $426da0baa4d91e21$var$createSortingHandlers();
    return handlers[fieldType] != null;
};
const $426da0baa4d91e21$export$190ed2ad153b150b = (fieldType)=>true;
const $426da0baa4d91e21$export$56c924491e5617ad = (0, $8QpSo.default)(()=>({
        ...(0, $5nNdw.devSummaryDisabledSorting),
        ...(0, $7LNXH.teamDisabledSorting),
        ...(0, $aK7yP.statusCategoryDisabledSorting),
        ...(0, $cBFqc.goalsDisabledSorting)
    }));

});
parcelRegister("1OjAh", function(module, exports) {

$parcel$export(module.exports, "cascadingSelectSortingHandler", () => $1924a50c91a471c7$export$7b0bfc6838ff3257);

var $5fc53 = parcelRequire("5fc53");

var $jKNTt = parcelRequire("jKNTt");
const $1924a50c91a471c7$var$getCascadingSelectSorting = (field)=>(0, $jKNTt.getCascadingSelectStringValue)(field.value);
const $1924a50c91a471c7$export$7b0bfc6838ff3257 = {
    [(0, $5fc53.CASCADING_SELECT_CF_TYPE)]: $1924a50c91a471c7$var$getCascadingSelectSorting
};

});
parcelRegister("jKNTt", function(module, exports) {

$parcel$export(module.exports, "getCascadingSelectStringValue", () => $c7661401b6222cfb$export$f110a74eb752aa7e);
$parcel$export(module.exports, "cascadingSelectStringValueHandler", () => $c7661401b6222cfb$export$f39c163ada81742a);
$parcel$export(module.exports, "cascadingSelectRichValueHandler", () => $c7661401b6222cfb$export$af92c160980c340f);

var $5fc53 = parcelRequire("5fc53");
const $c7661401b6222cfb$export$f110a74eb752aa7e = (fieldValue)=>{
    if (fieldValue && fieldValue.parentOptionValue) {
        if (fieldValue.childOptionValue) return `${fieldValue.parentOptionValue.value} - ${fieldValue.childOptionValue.value}`;
        return `${fieldValue.parentOptionValue.value}`;
    }
    return '';
};
const $c7661401b6222cfb$var$getCascadingSelectValue = (field)=>$c7661401b6222cfb$export$f110a74eb752aa7e(field.value);
const $c7661401b6222cfb$var$getCascadingSelectRichValue = (field)=>field.value ?? null;
const $c7661401b6222cfb$export$f39c163ada81742a = {
    [(0, $5fc53.CASCADING_SELECT_CF_TYPE)]: $c7661401b6222cfb$var$getCascadingSelectValue
};
const $c7661401b6222cfb$export$af92c160980c340f = {
    [(0, $5fc53.CASCADING_SELECT_CF_TYPE)]: $c7661401b6222cfb$var$getCascadingSelectRichValue
};

});


parcelRegister("5nNdw", function(module, exports) {

$parcel$export(module.exports, "devSummaryDisabledSorting", () => $8d45926c3e16e57e$export$8cf683615a3ccf77);

var $5fc53 = parcelRequire("5fc53");
const $8d45926c3e16e57e$export$8cf683615a3ccf77 = {
    [(0, $5fc53.DEV_SUMMARY_CF_TYPE)]: false
};

});

parcelRegister("cBFqc", function(module, exports) {

$parcel$export(module.exports, "goalsDisabledSorting", () => $c7872d24a62cd4a6$export$60ff70c996f5c362);

var $5fc53 = parcelRequire("5fc53");
const $c7872d24a62cd4a6$export$60ff70c996f5c362 = {
    [(0, $5fc53.GOALS_CF_TYPE)]: false
};

});

parcelRegister("coSD0", function(module, exports) {

$parcel$export(module.exports, "groupSortingHandler", () => $a9d8ecbf0dcf5f2d$export$a577fd60fa30451d);

var $5fc53 = parcelRequire("5fc53");
const $a9d8ecbf0dcf5f2d$var$getSingleGroupSorting = (field)=>field.value?.name ?? '';
const $a9d8ecbf0dcf5f2d$var$getMultipleGroupSorting = (field)=>field.value == null ? '' : field.value.map((v)=>v.name).join(',');
const $a9d8ecbf0dcf5f2d$export$a577fd60fa30451d = {
    [(0, $5fc53.GROUP_CF_TYPE)]: $a9d8ecbf0dcf5f2d$var$getSingleGroupSorting,
    [(0, $5fc53.MULTI_GROUP_CF_TYPE)]: $a9d8ecbf0dcf5f2d$var$getMultipleGroupSorting
};

});

parcelRegister("55FhM", function(module, exports) {

$parcel$export(module.exports, "parentSortingHandler", () => $a7f27eceaa949fb5$export$20dbdacc158507c9);

var $5fc53 = parcelRequire("5fc53");
const $a7f27eceaa949fb5$var$getParentSorting = (field)=>field.value ? field.value.issueKey : '';
const $a7f27eceaa949fb5$export$20dbdacc158507c9 = {
    [(0, $5fc53.PARENT_TYPE)]: $a7f27eceaa949fb5$var$getParentSorting
};

});

parcelRegister("gjQcQ", function(module, exports) {

$parcel$export(module.exports, "projectSortingHandler", () => $a97b41f281e121d8$export$18c888fa7805bbf9);

var $5fc53 = parcelRequire("5fc53");
const $a97b41f281e121d8$var$getProjectSorting = (field)=>field.value?.name ?? '';
const $a97b41f281e121d8$export$18c888fa7805bbf9 = {
    [(0, $5fc53.PROJECT_PICKER_CF_TYPE)]: $a97b41f281e121d8$var$getProjectSorting
};

});

parcelRegister("4CML6", function(module, exports) {

$parcel$export(module.exports, "radioSelectSortingHandler", () => $0a650a9e38d8f12d$export$d622730346571a2b);

var $5fc53 = parcelRequire("5fc53");
const $0a650a9e38d8f12d$var$getRadioSelectSorting = (field)=>field.value ? field.value.value : '';
const $0a650a9e38d8f12d$export$d622730346571a2b = {
    [(0, $5fc53.RADIO_BUTTONS_CF_TYPE)]: $0a650a9e38d8f12d$var$getRadioSelectSorting
};

});

parcelRegister("WhnfX", function(module, exports) {

$parcel$export(module.exports, "resolutionSortingHandler", () => $5149dcabcac386a7$export$596a643f093db9a7);

var $5fc53 = parcelRequire("5fc53");
const $5149dcabcac386a7$var$getResolutionSorting = (field)=>field.value?.name ?? '';
const $5149dcabcac386a7$export$596a643f093db9a7 = {
    [(0, $5fc53.RESOLUTION_TYPE)]: $5149dcabcac386a7$var$getResolutionSorting
};

});

parcelRegister("aK7yP", function(module, exports) {

$parcel$export(module.exports, "statusCategoryDisabledSorting", () => $a8138d3f5e843f75$export$117cb43589655b27);

var $5fc53 = parcelRequire("5fc53");
const $a8138d3f5e843f75$export$117cb43589655b27 = {
    [(0, $5fc53.STATUS_CATEGORY_TYPE)]: false
};

});

parcelRegister("7LNXH", function(module, exports) {

$parcel$export(module.exports, "teamDisabledSorting", () => $f566370ab4491013$export$1626c947db580b0f);

var $5fc53 = parcelRequire("5fc53");
const $f566370ab4491013$export$1626c947db580b0f = {
    [(0, $5fc53.TEAMS_PLATFORM_CF_TYPE)]: false
};

});

parcelRegister("dtcdd", function(module, exports) {

$parcel$export(module.exports, "versionSortingHandler", () => $b3c9429c32861e4c$export$f2894a637a250eaa);

var $5fc53 = parcelRequire("5fc53");
const $b3c9429c32861e4c$var$getSingleVersionSorting = (field)=>field.value?.name ?? '';
const $b3c9429c32861e4c$var$getMultipleVersionSorting = (field)=>field.value == null ? '' : field.value.map((v)=>v.name).join(',');
const $b3c9429c32861e4c$export$f2894a637a250eaa = {
    [(0, $5fc53.VERSION_CF_TYPE)]: $b3c9429c32861e4c$var$getSingleVersionSorting,
    [(0, $5fc53.MULTI_VERSION_CF_TYPE)]: $b3c9429c32861e4c$var$getMultipleVersionSorting,
    [(0, $5fc53.FIX_VERSIONS_TYPE)]: $b3c9429c32861e4c$var$getMultipleVersionSorting,
    [(0, $5fc53.AFFECTS_VERSIONS_TYPE)]: $b3c9429c32861e4c$var$getMultipleVersionSorting
};

});


parcelRegister("fCkUD", function(module, exports) {

$parcel$export(module.exports, "isNewTransformedFieldPredicated", () => $fb9b3f13d18b237f$export$b018c2b58ea7e0de);
const $fb9b3f13d18b237f$export$b018c2b58ea7e0de = (field)=>field != null;

});

parcelRegister("57lFd", function(module, exports) {

$parcel$export(module.exports, "getFieldValue", () => $9c93e114366691a0$export$2e85048acc9aea83);
$parcel$export(module.exports, "safeGetValue", () => $9c93e114366691a0$export$f17a5eaf5fe57cff);
$parcel$export(module.exports, "safeGetTransformedFieldValue", () => $9c93e114366691a0$export$16456470899ab77f);
$parcel$export(module.exports, "safeGetTransformedValue", () => $9c93e114366691a0$export$c1cc7bc9b4953394);

var $9XE6b = parcelRequire("9XE6b");
const $9c93e114366691a0$export$2e85048acc9aea83 = (fields, fieldKey)=>{
    if (fields && fieldKey != null) return fields.find((field)=>field?.fieldKey && field.fieldKey === fieldKey || field?.fieldId && field.fieldId === fieldKey || field?.aliasFieldId && field.aliasFieldId === fieldKey);
    return undefined;
};
const $9c93e114366691a0$export$f17a5eaf5fe57cff = (fields, fieldKey, attributeName, defaultValue)=>{
    const field = $9c93e114366691a0$export$2e85048acc9aea83(fields, fieldKey);
    return (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(field, attributeName, defaultValue);
};
const $9c93e114366691a0$export$16456470899ab77f = (fields, fieldKey, attributeName, defaultValue)=>{
    const field = $9c93e114366691a0$export$2e85048acc9aea83(fields, fieldKey);
    return $9c93e114366691a0$export$c1cc7bc9b4953394(field, defaultValue);
};
const $9c93e114366691a0$export$c1cc7bc9b4953394 = (field, defaultValue)=>(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(field, 'value', defaultValue);

});

parcelRegister("ixx6N", function(module, exports) {

$parcel$export(module.exports, "resolveRank", () => $0a08bd66273f9a8c$export$992090b26f7c7f11);
const $0a08bd66273f9a8c$export$992090b26f7c7f11 = (parentIssue, rank)=>{
    // for the Sub-task issue types, sorting based on rank considers the parent rank first, then sorts based on item rank
    // concatenating (parentRank + rank) would do that for us!
    const parentRank = parentIssue?.rank ?? '';
    return parentRank.concat(rank);
};

});



parcelRegister("7VpiX", function(module, exports) {

$parcel$export(module.exports, "sanitiseJql", () => $e5742a6c935cce4a$export$78c9a06ab18996fc);
$parcel$export(module.exports, "getJqlErrors", () => $e5742a6c935cce4a$export$cc387523b0acb16d);

var $eK6AG = parcelRequire("eK6AG");
var $l0V05 = parcelRequire("l0V05");
const $e5742a6c935cce4a$export$78c9a06ab18996fc = (jql)=>{
    if (!jql) return jql;
    const builder = new (0, $eK6AG.JastBuilder)();
    const jast = builder.build(jql);
    if (jast.query && jast.query.orderBy) jast.query.orderBy = undefined;
    return (0, $l0V05.print)(jast, {
        operatorCase: 'upper',
        printWidth: null
    });
};
const $e5742a6c935cce4a$export$cc387523b0acb16d = (jql)=>{
    if (!jql) return [];
    const builder = new (0, $eK6AG.JastBuilder)();
    const jast = builder.build(jql);
    return jast.errors;
};

});


parcelRegister("b58r7", function(module, exports) {

$parcel$export(module.exports, "CREATE_ISSUE_MUTATION", () => $41b0d4432ded0aa8$export$f5c1cac020b22be4);
$parcel$export(module.exports, "ISSUE_REFETCH_QUERY", () => $41b0d4432ded0aa8$export$834c81726d4c51eb);

var $5cllN = parcelRequire("5cllN");

var $kkA5E = parcelRequire("kkA5E");

var $4ty7u = parcelRequire("4ty7u");
const $41b0d4432ded0aa8$var$CREATED_ITEM_FRAGMENT = (0, $5cllN.default)`
fragment CreatedBoardItemFragment on JiraWorkManagementViewItem {
    ...JIS2_JWMBoardItemFragment
    ...JIS2_JWMBoardConfluenceLinksFragment
}
${(0, $4ty7u.JIS2_JWMBOARD_ITEM_FRAGMENT)}
${(0, $4ty7u.JIS2_JWMBOARD_CONFLUENCE_LINKS_FRAGMENT)}
`;
const $41b0d4432ded0aa8$export$f5c1cac020b22be4 = (0, $5cllN.default)`
mutation JWMBoardInlineCreateIssue($input: JiraCreateIssueInput!, $fieldIds: [String]!, $withCoverMedia: Boolean!, $withIssueLinks: Boolean!, $withChildrenCount: Boolean!) {
    createJiraBusinessIssue(input: $input, fieldIdsToReturn: $fieldIds) {
        item {
            ...CreatedBoardItemFragment
            ...JIS2_JWMBoardItemCoverMediaFragment @include(if: $withCoverMedia)
            ...JIS2_JWMBoardIssueLinksFragment @include(if: $withIssueLinks)
        }
        ...CreateIssueFragment
    }
}
${$41b0d4432ded0aa8$var$CREATED_ITEM_FRAGMENT}
${(0, $kkA5E.CREATE_ISSUE_FRAGMENT)}
${(0, $4ty7u.JIS2_JWMBOARD_ITEM_COVER_MEDIA_FRAGMENT)}
${(0, $4ty7u.JIS2_JWMBOARD_ISSUE_LINKS_FRAGMENT)}
`;
const $41b0d4432ded0aa8$export$834c81726d4c51eb = (0, $5cllN.default)`
query JWMBoardInlineCreateRefetchQuery($cloudId: ID!, $jql: String!, $fieldIds: [String]!, $first: Int, $withCoverMedia: Boolean!, $withIssueLinks: Boolean!, $withChildrenCount: Boolean!) {
    jira {
        jwmViewItems(cloudId: $cloudId, jql: $jql, first: $first) {
            ... on JiraWorkManagementViewItemConnection {
                edges {
                    node {
                        ...CreatedBoardItemFragment
                        ...JIS2_JWMBoardItemCoverMediaFragment @include(if: $withCoverMedia)
                        ...JIS2_JWMBoardIssueLinksFragment @include(if: $withIssueLinks)
                    }
                }
            }
        }
    }
}
${$41b0d4432ded0aa8$var$CREATED_ITEM_FRAGMENT}
${(0, $4ty7u.JIS2_JWMBOARD_ITEM_COVER_MEDIA_FRAGMENT)}
${(0, $4ty7u.JIS2_JWMBOARD_ISSUE_LINKS_FRAGMENT)}
`;

});
parcelRegister("kkA5E", function(module, exports) {

$parcel$export(module.exports, "CREATE_ISSUE_FRAGMENT", () => $22484cc131c517f0$export$47232071d0e9dfb);

var $5cllN = parcelRequire("5cllN");
const $22484cc131c517f0$export$47232071d0e9dfb = (0, $5cllN.default)`
fragment CreateIssueFragment on JiraBusinessCreateIssuePayload {
  itemIdentifiers: item @connection (key: "issue-create-ids") {
    issueId
    issueKey: fieldsByIdOrAlias(idsOrAliases: ["issuekey"]) {
      ... on JiraSingleLineTextField {
          text
      }
    }
  }
  success
  errors {
    message
    extensions {
      ...on MutationErrorExtension {
        statusCode
        errorType
      }
    }
  }
}`;

});


parcelRegister("ekUhS", function(module, exports) {

$parcel$export(module.exports, "buildInput", () => $bc165c137f3ec280$export$f4db126e014728a3);

var $k7m40 = parcelRequire("k7m40");

var $5fc53 = parcelRequire("5fc53");

var $6s1PB = parcelRequire("6s1PB");
const $bc165c137f3ec280$var$RANK_BEFORE_ID = 'rankBefore';
const $bc165c137f3ec280$var$RANK_AFTER_ID = 'rankAfter';
const $bc165c137f3ec280$export$f4db126e014728a3 = (input, extraPayload, categoryFieldId)=>{
    const singleLineTextFields = [
        {
            fieldId: (0, $5fc53.SUMMARY_TYPE),
            text: input.summary
        }
    ];
    const singleSelectUserPickerFields = [];
    const datePickerFields = [];
    if (input.category && categoryFieldId) singleLineTextFields.push({
        fieldId: categoryFieldId,
        text: input.category.optionId
    });
    if (input.assignee) singleSelectUserPickerFields.push({
        fieldId: (0, $5fc53.ASSIGNEE_TYPE),
        user: {
            accountId: input.assignee.accountId
        }
    });
    if (input.dueDate && (0, $6s1PB.expVal)('jira_powerful_inline_create_for_business_board', 'isEnabled', false)) datePickerFields.push({
        fieldId: (0, $5fc53.DUE_DATE_TYPE),
        date: {
            formattedDate: (0, $k7m40.default)(input.dueDate, 'yyyy-MM-dd')
        }
    });
    const fields = {
        singleLineTextFields: singleLineTextFields,
        singleSelectUserPickerFields: singleSelectUserPickerFields,
        ...input.dueDate && (0, $6s1PB.expVal)('jira_powerful_inline_create_for_business_board', 'isEnabled', false) && {
            datePickerFields: datePickerFields
        },
        ...input.priority && {
            priority: {
                priorityId: input.priority.priorityId
            }
        },
        ...input.parentIssueId && {
            parentField: {
                issueId: input.parentIssueId
            }
        }
    };
    const rank = {
        ...input.rankBefore && {
            before: {
                id: $bc165c137f3ec280$var$RANK_BEFORE_ID,
                issueId: input.rankBefore.issueId
            }
        },
        ...input.rankAfter && {
            after: {
                id: $bc165c137f3ec280$var$RANK_AFTER_ID,
                issueId: input.rankAfter.issueId
            }
        }
    };
    const result = {
        projectId: input.projectId,
        issueType: input.issueType.id,
        fields: fields,
        rank: rank,
        ...extraPayload?.transitionId && {
            transitionId: extraPayload.transitionId
        }
    };
    return result;
};

});


parcelRegister("enS24", function(module, exports) {

$parcel$export(module.exports, "default", () => $07caede9407497d3$export$2e2bcd8739ae039);

var $3FYKr = parcelRequire("3FYKr");

var $2SM7O = parcelRequire("2SM7O");

var $1j5vX = parcelRequire("1j5vX");

var $769qI = parcelRequire("769qI");

var $dq2po = parcelRequire("dq2po");

var $jfCZt = parcelRequire("jfCZt");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $9suPc = parcelRequire("9suPc");

var $8Uumt = parcelRequire("8Uumt");

var $3KYe6 = parcelRequire("3KYe6");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $99gkn = parcelRequire("99gkn");

var $fNobW = parcelRequire("fNobW");

var $kJ1Ne = parcelRequire("kJ1Ne");

var $0z6W8 = parcelRequire("0z6W8");

var $6l4ko = parcelRequire("6l4ko");

var $hE5wF = parcelRequire("hE5wF");

var $8UpTw = parcelRequire("8UpTw");

var $cm8b5 = parcelRequire("cm8b5");

var $1T1ir = parcelRequire("1T1ir");

var $he7sk = parcelRequire("he7sk");

var $1T4FF = parcelRequire("1T4FF");

var $6sVa1 = parcelRequire("6sVa1");

var $3qoA4 = parcelRequire("3qoA4");

var $3kVj2 = parcelRequire("3kVj2");

var $ksKCJ = parcelRequire("ksKCJ");

var $kzL7M = parcelRequire("kzL7M");

var $8HvEs = parcelRequire("8HvEs");

var $7Wnap = parcelRequire("7Wnap");

var $ai0FS = parcelRequire("ai0FS");

var $7yduy = parcelRequire("7yduy");


var $2gCtH = parcelRequire("2gCtH");

var $1XJ20 = parcelRequire("1XJ20");

var $lob44 = parcelRequire("lob44");

var $g5X3G = parcelRequire("g5X3G");

var $l8ruj = parcelRequire("l8ruj");

var $ieDtd = parcelRequire("ieDtd");

var $4R6GH = parcelRequire("4R6GH");

var $cvj5l = parcelRequire("cvj5l");

var $fPzrH = parcelRequire("fPzrH");

var $hlGFs = parcelRequire("hlGFs");

var $3adKM = parcelRequire("3adKM");

var $3WdOs = parcelRequire("3WdOs");

var $dgAvR = parcelRequire("dgAvR");

var $l1jgj = parcelRequire("l1jgj");

var $2EbGw = parcelRequire("2EbGw");

var $c8SYk = parcelRequire("c8SYk");

var $a366m = parcelRequire("a366m");

var $cgEOh = parcelRequire("cgEOh");

var $eMyuP = parcelRequire("eMyuP");
const $07caede9407497d3$var$REALTIME_APP_ID = 'jira-business-board-view';
const $07caede9407497d3$var$BoardContentInner = ({ isEmpty: isEmpty, queryFragment: queryFragment, projectFragment: projectFragment, viewFragment: viewFragment, refresh: refresh })=>{
    const boardContentRef = (0, $5uXOq.useRef)(null);
    const [boardWrapper, setBoardWrapper] = (0, $5uXOq.useState)(null);
    const data = (0, $8Uumt.useFragment)((0, $jfCZt.default), queryFragment);
    const project = (0, $8Uumt.useFragment)((0, $dq2po.default), projectFragment);
    const view = (0, $8Uumt.useFragment)((0, $769qI.default), viewFragment);
    const groupBy = view.groupByConfig.fieldId;
    const isColumnCreateEnabled = project.projectStyle === 'TEAM_MANAGED_PROJECT' && groupBy === (0, $hE5wF.GROUP_BY_STATUS);
    const columns = view.columns.edges.filter(Boolean);
    const numberOfColumns = view.columns.totalCount;
    const totalChildren = isColumnCreateEnabled ? numberOfColumns + 1 : numberOfColumns;
    const getColumnId = (column)=>{
        if (column == null) throw new Error('Column node is missing');
        switch(column.__typename){
            case 'JiraBoardViewAssigneeColumn':
                return column.user?.accountId ?? (0, $cvj5l.NULL_GROUP_KEY);
            case 'JiraBoardViewPriorityColumn':
                if (!column.priority) throw new Error('Missing priority column fields');
                return column.priority.priorityId;
            case 'JiraBoardViewCategoryColumn':
                return column.category?.optionId ?? (0, $cvj5l.NULL_GROUP_KEY);
            case 'JiraBoardViewStatusColumn':
                if (!column.statuses?.[0]) throw new Error('Missing status column fields');
                return column.statuses[0]?.statusId;
            default:
                throw new Error(`Unhandled column type: ${column.__typename}`);
        }
    };
    const estimateSize = (0, $5uXOq.useCallback)((index)=>{
        const column = view.columns?.edges?.[index]?.node;
        if (column == null) return 0, $cvj5l.COLUMN_CREATE_WIDTH;
        return column.collapsed ? (0, $cvj5l.COLLAPSED_COLUMN_FIXED_WIDTH) : (0, $cvj5l.COLUMN_FIXED_WIDTH);
    }, [
        view.columns
    ]);
    const getItemKey = (0, $5uXOq.useCallback)((index)=>{
        const column = view.columns?.edges?.[index]?.node;
        if (column == null) return 'column-create';
        return column.id;
    }, [
        view.columns
    ]);
    const virtualizer = (0, $9suPc.useVirtualizer)({
        count: totalChildren,
        horizontal: true,
        getScrollElement: ()=>boardWrapper,
        estimateSize: estimateSize,
        gap: (0, $cvj5l.GAP_BETWEEN_COLUMNS),
        overscan: 0,
        getItemKey: getItemKey
    });
    (0, $5uXOq.useEffect)(()=>{
        if (!boardWrapper) return;
        return (0, $3KYe6.autoScrollForElements)({
            element: boardWrapper
        });
    }, [
        boardWrapper
    ]);
    const ColumnContent = virtualizer.getVirtualItems().map((virtualItem)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($07caede9407497d3$var$VirtualItemWrapper, {
            key: virtualItem.key,
            "data-index": virtualItem.index,
            "data-vc": "business-board-column",
            start: virtualItem.start,
            ref: virtualizer.measureElement
        }, virtualItem.index === numberOfColumns ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgEOh.BoardColumnCreate), {
            columnsFragment: view.columns,
            projectFragment: project,
            refresh: refresh
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
            name: "business-board-column",
            mode: "list"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1jgj.IssueGroupProvider), {
            key: virtualItem.key,
            groupId: getColumnId(columns[virtualItem.index]?.node)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a366m.default), {
            columnIndex: virtualItem.index,
            columnsNumber: numberOfColumns,
            queryFragment: data,
            projectFragment: project,
            columnFragment: columns[virtualItem.index],
            viewFragment: view,
            refresh: refresh
        })))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($07caede9407497d3$var$BoardWrapper, {
        ref: setBoardWrapper,
        "data-testid": "work-management-board.ui.board.board-wrapper",
        isEmpty: isEmpty
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($07caede9407497d3$var$BoardContentWrapper, {
        "data-vc": "business-board-content-wrapper",
        ref: boardContentRef,
        totalSize: virtualizer.getTotalSize()
    }, ColumnContent), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eMyuP.BoardMinimap), {
        boardContentElement: boardContentRef.current,
        scrollElement: boardWrapper,
        columnsFragment: view.columns
    }));
};
const $07caede9407497d3$var$BoardContent = ({ queryFragment: queryFragment, projectFragment: projectFragment, viewFragment: viewFragment, refresh: refresh })=>{
    const { featureView: featureView } = (0, $3WdOs.useJWMBoardFeatures)();
    const { isFiltering: isFiltering } = (0, $hlGFs.useFilterStatus)();
    const { isSearching: isSearching } = (0, $1T1ir.useSimpleSearchJQL)();
    const data = (0, $8Uumt.useFragment)((0, $1j5vX.default), queryFragment);
    const project = (0, $8Uumt.useFragment)((0, $2SM7O.default), projectFragment);
    const view = (0, $8Uumt.useFragment)((0, $3FYKr.default), viewFragment);
    const reorderColumns = (0, $2EbGw.useReorderColumns)(view.id);
    const { filteredIssues: filteredIssues, loading: loading, error: error, refetch: refetch } = (0, $fPzrH.useBoardData)();
    const { handleUpdatedIssue: handleUpdatedIssue, handleDeletedIssue: handleDeletedIssue } = (0, $dgAvR.useHandleIssueEvents)();
    const { sendClearNodeSelection: sendClearNodeSelection } = (0, $6l4ko.useCollabStoreActions)();
    const [selectedIssueKey, setSelectedIssueKey] = (0, $ieDtd.useQueryParam)((0, $hE5wF.SELECTED_ISSUE_PARAM));
    const prevSelectedIssueKey = (0, $1XJ20.usePreviousWithInitial)(selectedIssueKey);
    const viewMode = (0, $2gCtH.useViewMode)();
    const categoryField = (0, $5uXOq.useMemo)(()=>data.jira_categoryField ? {
            fieldId: data.jira_categoryField.fieldId,
            displayName: data.jira_categoryField.displayName
        } : null, [
        data.jira_categoryField
    ]);
    const isViewModeSideBar = viewMode === 'SIDEBAR';
    const columnIds = view.columns.edges.map((edge)=>edge?.node?.id).filter(Boolean);
    (0, $3adKM.useDropHandler)({
        initialPageLoading: loading,
        columnIds: columnIds,
        onColumnsReordered: reorderColumns,
        categoryField: categoryField
    });
    const boardHasNoIssues = filteredIssues.length === 0;
    const isBoardEmptyAfterFilter = boardHasNoIssues && (isFiltering || isSearching) && !loading;
    const isBoardEmpty = boardHasNoIssues && !isFiltering && !loading;
    const onIssueModalClose = (0, $5uXOq.useCallback)(()=>{
        setSelectedIssueKey(undefined);
    }, [
        setSelectedIssueKey
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // when issueKey param is removed from URL we need to clear node selection
        if (selectedIssueKey == null && prevSelectedIssueKey != null) {
            const issue = filteredIssues.find((item)=>item.fields[0, $cvj5l.ISSUE_KEY_ID].value === prevSelectedIssueKey);
            if (issue) {
                const nodeId = `${view.id}/node/${issue.id}`;
                sendClearNodeSelection({
                    nodeId: nodeId
                });
            }
        }
    }, [
        filteredIssues,
        prevSelectedIssueKey,
        selectedIssueKey,
        sendClearNodeSelection,
        view.id
    ]);
    const onPageVisibilityChange = (0, $5uXOq.useCallback)(({ isVisible: isVisible })=>{
        if (isVisible) {
            refresh();
            refetch();
        }
    }, [
        refresh,
        refetch
    ]);
    const onRealtimeEvent = (0, $5uXOq.useCallback)((event)=>{
        if ((0, $3qoA4.isIssueEvent)(event)) {
            const issueId = Number(event.payload.issueId);
            if (event.type === (0, $1T4FF.ISSUE_DELETED_EVENT)) handleDeletedIssue(issueId);
            else handleUpdatedIssue(issueId);
        }
    }, [
        handleDeletedIssue,
        handleUpdatedIssue
    ]);
    const onBentoChange = (0, $5uXOq.useCallback)((event)=>handleUpdatedIssue(Number(event.issueId)), [
        handleUpdatedIssue
    ]);
    const onBentoDelete = (0, $5uXOq.useCallback)(({ issueId: issueId })=>handleDeletedIssue(Number(issueId)), [
        handleDeletedIssue
    ]); // Memoised to prevent flicker on JIRT updates
    const issueModal = (0, $5uXOq.useMemo)(()=>selectedIssueKey != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
            name: "business-board-issue-modal"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3kVj2.default), {
            issueKey: (0, $g5X3G.toIssueKey)(selectedIssueKey),
            onClose: onIssueModalClose,
            analyticsSource: (0, $fcf97b7a09088940$export$b2c0462ff17aa26e),
            onChange: onBentoChange,
            onDeleteSuccess: onBentoDelete
        })), [
        selectedIssueKey,
        onIssueModalClose,
        onBentoChange,
        onBentoDelete
    ]);
    const ufoCustomData = (0, $5uXOq.useMemo)(()=>({
            hasSelectedIssue: !!selectedIssueKey,
            isViewModeSideBar: isViewModeSideBar,
            isFiltering: isFiltering,
            isSearching: isSearching,
            isBoardEmpty: isBoardEmpty
        }), [
        isBoardEmpty,
        isFiltering,
        isSearching,
        isViewModeSideBar,
        selectedIssueKey
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // we don't want to update metric name when in embed mode
        if (featureView === 'jwm-board') {
            if (selectedIssueKey) (0, $0z6W8.updatePageloadName)('jwm.jwm-board-with-issue-view');
            else if (isFiltering) (0, $0z6W8.updatePageloadName)('jwm.jwm-board-with-filters');
            else (0, $0z6W8.updatePageloadName)('jwm.jwm-board-base');
        } // we only execute this once based on state of the experience on page load
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    if (error != null) {
        const is404 = 'statusCode' in error && error.statusCode === 404;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, is404 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cm8b5.ExperienceAbort), {
            experience: (0, $cvj5l.VIEW_EXPERIENCE),
            error: error
        }), !is404 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cm8b5.ExperienceFailed), {
            experience: (0, $cvj5l.VIEW_EXPERIENCE),
            error: error
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8UpTw.ErrorPage), {
            error: error
        }));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "business-board-content"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($07caede9407497d3$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $99gkn.default), {
        data: ufoCustomData
    }), (0, $4R6GH.fg)('jira-public-forms-changeboarding-modal-bus-board') && (0, $4R6GH.fg)('jira_forms_public_access_changeboarding_gate') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kJ1Ne.default), {
        projectId: project.projectId.toString()
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, loading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fNobW.default), {
        name: "board-container-initial"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $07caede9407497d3$var$loadingWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lob44.ThemedSpinner), null))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($07caede9407497d3$var$BoardContainer, {
        "data-vc": "business-board-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7Wnap.RenderStartMark), {
        view: featureView
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($07caede9407497d3$var$BoardContentInner, {
        isEmpty: isBoardEmpty || isBoardEmptyAfterFilter,
        queryFragment: data,
        projectFragment: project,
        viewFragment: view,
        refresh: refresh
    }), isBoardEmpty ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($07caede9407497d3$var$EmptyStateContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c8SYk.EmptyBoardComponent), null)) : null, isBoardEmptyAfterFilter ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($07caede9407497d3$var$EmptyStateContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $he7sk.ThemedFilterEmptyState), null)) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7yduy.JWMSpaStatePageReady), null)), isViewModeSideBar ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ksKCJ.SidebarIssueView), {
        issueKey: selectedIssueKey,
        onClose: onIssueModalClose,
        onChange: onBentoChange,
        onIssueDeleteSuccess: onBentoDelete,
        analyticsSource: (0, $fcf97b7a09088940$export$b2c0462ff17aa26e)
    }) : issueModal, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8HvEs.PerformanceAnalytics), {
        view: featureView,
        loading: loading,
        itemsCount: filteredIssues.length
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ai0FS.SignupInviteModal), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6sVa1.GqlsRealtime), {
        appId: $07caede9407497d3$var$REALTIME_APP_ID,
        entityId: project.projectId,
        onReceive: onRealtimeEvent
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kzL7M.PageVisibility), {
        onChange: onPageVisibilityChange
    }))));
};
var $07caede9407497d3$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = /*#__PURE__*/ (0, $5uXOq.memo)($07caede9407497d3$var$BoardContent);
const $07caede9407497d3$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1tkeidpf _1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $07caede9407497d3$var$BoardContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _1e0c1txw _2lx21bp4 _1o9zidpf _1n261q9c _4t3i1osq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $07caede9407497d3$var$BoardWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isEmpty: isEmpty, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1osq _1reo1wug _1ul9idpf _kqswh2mm _syaz1fxt _ca0q1b66 _u5f3utpp _n3td1b66 _19bvutpp _19pkr5cr _2hwxxmi2 _otyrr5cr _18u0xmi2",
            __cmplp.isEmpty ? "_16jlidpf _1o9zkb7n _i0dlf1ug" : "_16jlkb7n _1o9zkb7n _i0dlf1ug",
            __cmplp.isEmpty ? "_1tke1yk2" : "_1tkeidpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $07caede9407497d3$var$BoardContentWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { totalSize: totalSize, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_r9fzc2": (0, $lD23V.default)(`${__cmplp.totalSize}px`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _2lx2vrvc _1n261q9c _1e0c1txw _4cvr1y6m _kqswh2mm _4t3i1osq _c71l1osq _1ul91ns9 _uiztglyw _1bsb1651 _m6k4brmi",
            __cmplp.className
        ])
    });
});
const $07caede9407497d3$var$loadingWrapperStyles = (0, $8CUq3.xcss)({
    alignItems: 'center',
    display: 'flex',
    flex: 1,
    justifyContent: 'space-around'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $07caede9407497d3$var$VirtualItemWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_19kxfes": (0, $lD23V.default)(`translateX(${__cmplp.start}px)`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1osq _kqswstnw _154iidpf _1ltvidpf _t9ec1yxo",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $07caede9407497d3$var$EmptyStateContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1bsb1osq _1e0c1txw _2lx21bp4 _4cvr1h6o _1bah1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("3FYKr", function(module, exports) {

$parcel$export(module.exports, "default", () => $da80e6ff5682e039$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5a03d3cb293bba7d1b6792c27c5c2d34>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $da80e6ff5682e039$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "metadata": {
            "connection": [
                {
                    "count": null,
                    "cursor": null,
                    "direction": "forward",
                    "path": [
                        "columns"
                    ]
                }
            ]
        },
        "name": "BoardContent_view",
        "selections": [
            {
                "kind": "FragmentSpread",
                "name": "BoardContent_Inner_view"
            },
            {
                "kind": "RequiredField",
                "field": v0 /*: any*/ ,
                "action": "THROW",
                "path": "id"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "alias": "columns",
                    "concreteType": "JiraBoardViewColumnConnection",
                    "kind": "LinkedField",
                    "name": "__business_board_columns_connection",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "concreteType": "JiraBoardViewColumnEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            v0 /*: any*/ ,
                                            {
                                                "kind": "ScalarField",
                                                "name": "__typename"
                                            }
                                        ]
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "cursor"
                                    }
                                ]
                            },
                            "action": "THROW",
                            "path": "columns.edges"
                        },
                        {
                            "concreteType": "PageInfo",
                            "kind": "LinkedField",
                            "name": "pageInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "endCursor"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "hasNextPage"
                                }
                            ]
                        }
                    ]
                },
                "action": "THROW",
                "path": "columns"
            }
        ],
        "type": "JiraBoardView"
    };
}();
$da80e6ff5682e039$var$node.hash = "ca6bd978a5c0d54bebc57dd1f0d9def5";
var $da80e6ff5682e039$export$2e2bcd8739ae039 = $da80e6ff5682e039$var$node;

});

parcelRegister("2SM7O", function(module, exports) {

$parcel$export(module.exports, "default", () => $67d8d8026fbeda8b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5cfc4150a619253bbb8386ed3449782c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $67d8d8026fbeda8b$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "BoardContent_project",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "BoardContent_Inner_project"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "projectId"
            },
            "action": "THROW",
            "path": "projectId"
        }
    ],
    "type": "JiraProject"
};
$67d8d8026fbeda8b$var$node.hash = "fdbab977793ec3ae94c294396e28e4e6";
var $67d8d8026fbeda8b$export$2e2bcd8739ae039 = $67d8d8026fbeda8b$var$node;

});

parcelRegister("1j5vX", function(module, exports) {

$parcel$export(module.exports, "default", () => $ebfb3fd5b6ffe8e7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<70e71d8cce387a6e87e318544afa060a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $ebfb3fd5b6ffe8e7$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "cloudId"
        }
    ],
    "kind": "Fragment",
    "name": "BoardContent_query",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "BoardContent_Inner_query"
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                }
            ],
            "concreteType": "JiraJqlField",
            "kind": "LinkedField",
            "name": "jira_categoryField",
            "plural": false,
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "kind": "ScalarField",
                        "name": "fieldId"
                    },
                    "action": "THROW",
                    "path": "jira_categoryField.fieldId"
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "kind": "ScalarField",
                        "name": "displayName"
                    },
                    "action": "THROW",
                    "path": "jira_categoryField.displayName"
                }
            ]
        }
    ],
    "type": "Query"
};
$ebfb3fd5b6ffe8e7$var$node.hash = "f935d0cded805fc97122ef6b3cbb2c29";
var $ebfb3fd5b6ffe8e7$export$2e2bcd8739ae039 = $ebfb3fd5b6ffe8e7$var$node;

});

parcelRegister("769qI", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6d87a13500136d6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<acde1fe674b909121c0f8ce7667b29c7>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f6d87a13500136d6$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": {
        "connection": [
            {
                "count": null,
                "cursor": null,
                "direction": "forward",
                "path": [
                    "columns"
                ]
            }
        ]
    },
    "name": "BoardContent_Inner_view",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "JiraViewGroupByConfig",
                "kind": "LinkedField",
                "name": "groupByConfig",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "fieldId"
                        },
                        "action": "THROW",
                        "path": "groupByConfig.fieldId"
                    }
                ]
            },
            "action": "THROW",
            "path": "groupByConfig"
        },
        {
            "kind": "RequiredField",
            "field": {
                "alias": "columns",
                "concreteType": "JiraBoardViewColumnConnection",
                "kind": "LinkedField",
                "name": "__business_board_columns_connection",
                "plural": false,
                "selections": [
                    {
                        "kind": "FragmentSpread",
                        "name": "BoardColumnCreate_columns"
                    },
                    {
                        "kind": "FragmentSpread",
                        "name": "BoardMinimap_columns"
                    },
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "totalCount"
                        },
                        "action": "THROW",
                        "path": "columns.totalCount"
                    },
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "JiraBoardViewColumnEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "BoardColumn_column"
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "collapsed"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "concreteType": "JiraStatus",
                                                    "kind": "LinkedField",
                                                    "name": "statuses",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": {
                                                                "kind": "ScalarField",
                                                                "name": "statusId"
                                                            },
                                                            "action": "THROW",
                                                            "path": "columns.edges.node.statuses.statusId"
                                                        }
                                                    ]
                                                }
                                            ],
                                            "type": "JiraBoardViewStatusColumn"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "concreteType": "JiraPriority",
                                                    "kind": "LinkedField",
                                                    "name": "priority",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": {
                                                                "kind": "ScalarField",
                                                                "name": "priorityId"
                                                            },
                                                            "action": "THROW",
                                                            "path": "columns.edges.node.priority.priorityId"
                                                        }
                                                    ]
                                                }
                                            ],
                                            "type": "JiraBoardViewPriorityColumn"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "user",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": {
                                                                "kind": "ScalarField",
                                                                "name": "accountId"
                                                            },
                                                            "action": "THROW",
                                                            "path": "columns.edges.node.user.accountId"
                                                        }
                                                    ]
                                                }
                                            ],
                                            "type": "JiraBoardViewAssigneeColumn"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "concreteType": "JiraOption",
                                                    "kind": "LinkedField",
                                                    "name": "category",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": {
                                                                "kind": "ScalarField",
                                                                "name": "optionId"
                                                            },
                                                            "action": "THROW",
                                                            "path": "columns.edges.node.category.optionId"
                                                        }
                                                    ]
                                                }
                                            ],
                                            "type": "JiraBoardViewCategoryColumn"
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "cursor"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "columns.edges"
                    },
                    {
                        "concreteType": "PageInfo",
                        "kind": "LinkedField",
                        "name": "pageInfo",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "endCursor"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "hasNextPage"
                            }
                        ]
                    }
                ]
            },
            "action": "THROW",
            "path": "columns"
        },
        {
            "kind": "FragmentSpread",
            "name": "BoardColumn_view"
        }
    ],
    "type": "JiraBoardView"
};
$f6d87a13500136d6$var$node.hash = "aafe2fbc5cd5fd2c95d3bea18cbcf965";
var $f6d87a13500136d6$export$2e2bcd8739ae039 = $f6d87a13500136d6$var$node;

});

parcelRegister("dq2po", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc2cc1137c8007dd$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<dbe95cfa06f799fbe17cb8b28922ffb1>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $bc2cc1137c8007dd$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "BoardContent_Inner_project",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "BoardColumn_project"
        },
        {
            "kind": "FragmentSpread",
            "name": "BoardColumnCreate_project"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "projectStyle"
            },
            "action": "THROW",
            "path": "projectStyle"
        }
    ],
    "type": "JiraProject"
};
$bc2cc1137c8007dd$var$node.hash = "deffd039bf947c3b4d5d319d85ac5ffb";
var $bc2cc1137c8007dd$export$2e2bcd8739ae039 = $bc2cc1137c8007dd$var$node;

});

parcelRegister("jfCZt", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3d97c3c49be6f61$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d8eaf8ed0d07bdef309446c3b060737e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a3d97c3c49be6f61$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "BoardContent_Inner_query",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "BoardColumn_query"
        }
    ],
    "type": "Query"
};
$a3d97c3c49be6f61$var$node.hash = "6b11931fc8ec0186be67833a2a622e1c";
var $a3d97c3c49be6f61$export$2e2bcd8739ae039 = $a3d97c3c49be6f61$var$node;

});

parcelRegister("9suPc", function(module, exports) {
$parcel$export(module.exports, "defaultRangeExtractor", () => (parcelRequire("lASGB")).defaultRangeExtractor);
$parcel$export(module.exports, "elementScroll", () => (parcelRequire("lASGB")).elementScroll);
$parcel$export(module.exports, "notUndefined", () => (parcelRequire("cDbvq")).notUndefined);
$parcel$export(module.exports, "observeElementOffset", () => (parcelRequire("lASGB")).observeElementOffset);
$parcel$export(module.exports, "observeElementRect", () => (parcelRequire("lASGB")).observeElementRect);
$parcel$export(module.exports, "observeWindowOffset", () => (parcelRequire("lASGB")).observeWindowOffset);
$parcel$export(module.exports, "observeWindowRect", () => (parcelRequire("lASGB")).observeWindowRect);
$parcel$export(module.exports, "Virtualizer", () => (parcelRequire("lASGB")).Virtualizer);
$parcel$export(module.exports, "windowScroll", () => (parcelRequire("lASGB")).windowScroll);

$parcel$export(module.exports, "useVirtualizer", () => $6e2ea3c4609c52d6$export$dd6d526d88b5a137);

var $5uXOq = parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");

var $lASGB = parcelRequire("lASGB");
const $6e2ea3c4609c52d6$var$useIsomorphicLayoutEffect = typeof document !== "undefined" ? $5uXOq.useLayoutEffect : $5uXOq.useEffect;
function $6e2ea3c4609c52d6$var$useVirtualizerBase(options) {
    const rerender = $5uXOq.useReducer(()=>({}), {})[1];
    const resolvedOptions = {
        ...options,
        onChange: (instance2, sync)=>{
            var _a;
            if (sync) (0, $7nsd3.flushSync)(rerender);
            else rerender();
            (_a = options.onChange) == null || _a.call(options, instance2, sync);
        }
    };
    const [instance] = $5uXOq.useState(()=>new (0, $lASGB.Virtualizer)(resolvedOptions));
    instance.setOptions(resolvedOptions);
    $5uXOq.useEffect(()=>{
        return instance._didMount();
    }, []);
    $6e2ea3c4609c52d6$var$useIsomorphicLayoutEffect(()=>{
        return instance._willUpdate();
    });
    return instance;
}
function $6e2ea3c4609c52d6$export$dd6d526d88b5a137(options) {
    return $6e2ea3c4609c52d6$var$useVirtualizerBase({
        observeElementRect: $lASGB.observeElementRect,
        observeElementOffset: $lASGB.observeElementOffset,
        scrollToFn: (0, $lASGB.elementScroll),
        ...options
    });
}
function $6e2ea3c4609c52d6$export$645722dcac657cb9(options) {
    return $6e2ea3c4609c52d6$var$useVirtualizerBase({
        getScrollElement: ()=>typeof document !== "undefined" ? window : null,
        observeElementRect: (0, $lASGB.observeWindowRect),
        observeElementOffset: (0, $lASGB.observeWindowOffset),
        scrollToFn: (0, $lASGB.windowScroll),
        initialOffset: ()=>typeof document !== "undefined" ? window.scrollY : 0,
        ...options
    });
}

});
parcelRegister("lASGB", function(module, exports) {

$parcel$export(module.exports, "defaultRangeExtractor", () => $fb876145852c2505$export$7eb7cb13fd21e5e1);
$parcel$export(module.exports, "observeElementRect", () => $fb876145852c2505$export$5a50ff2cde8c3802);
$parcel$export(module.exports, "observeWindowRect", () => $fb876145852c2505$export$e911b82c7a99311);
$parcel$export(module.exports, "observeElementOffset", () => $fb876145852c2505$export$fbc040aee017375a);
$parcel$export(module.exports, "observeWindowOffset", () => $fb876145852c2505$export$518998f8c5d09287);
$parcel$export(module.exports, "windowScroll", () => $fb876145852c2505$export$2162c5b3eeedd27);
$parcel$export(module.exports, "elementScroll", () => $fb876145852c2505$export$1cdb988e5ab69fe7);
$parcel$export(module.exports, "Virtualizer", () => $fb876145852c2505$export$89be5a243e59c4b2);
$parcel$export(module.exports, "notUndefined", () => (parcelRequire("cDbvq")).notUndefined);

var $cDbvq = parcelRequire("cDbvq");
const $fb876145852c2505$export$76974b428a49f15b = (index)=>index;
const $fb876145852c2505$export$7eb7cb13fd21e5e1 = (range)=>{
    const start = Math.max(range.startIndex - range.overscan, 0);
    const end = Math.min(range.endIndex + range.overscan, range.count - 1);
    const arr = [];
    for(let i = start; i <= end; i++)arr.push(i);
    return arr;
};
const $fb876145852c2505$export$5a50ff2cde8c3802 = (instance, cb)=>{
    const element = instance.scrollElement;
    if (!element) return;
    const targetWindow = instance.targetWindow;
    if (!targetWindow) return;
    const handler = (rect)=>{
        const { width: width, height: height } = rect;
        cb({
            width: Math.round(width),
            height: Math.round(height)
        });
    };
    handler(element.getBoundingClientRect());
    if (!targetWindow.ResizeObserver) return ()=>{};
    const observer = new targetWindow.ResizeObserver((entries)=>{
        const entry = entries[0];
        if (entry == null ? void 0 : entry.borderBoxSize) {
            const box = entry.borderBoxSize[0];
            if (box) {
                handler({
                    width: box.inlineSize,
                    height: box.blockSize
                });
                return;
            }
        }
        handler(element.getBoundingClientRect());
    });
    observer.observe(element, {
        box: "border-box"
    });
    return ()=>{
        observer.unobserve(element);
    };
};
const $fb876145852c2505$var$addEventListenerOptions = {
    passive: true
};
const $fb876145852c2505$export$e911b82c7a99311 = (instance, cb)=>{
    const element = instance.scrollElement;
    if (!element) return;
    const handler = ()=>{
        cb({
            width: element.innerWidth,
            height: element.innerHeight
        });
    };
    handler();
    element.addEventListener("resize", handler, $fb876145852c2505$var$addEventListenerOptions);
    return ()=>{
        element.removeEventListener("resize", handler);
    };
};
const $fb876145852c2505$var$supportsScrollend = typeof window == "undefined" ? true : "onscrollend" in window;
const $fb876145852c2505$export$fbc040aee017375a = (instance, cb)=>{
    const element = instance.scrollElement;
    if (!element) return;
    const targetWindow = instance.targetWindow;
    if (!targetWindow) return;
    let offset = 0;
    const fallback = $fb876145852c2505$var$supportsScrollend ? ()=>void 0 : (0, $cDbvq.debounce)(targetWindow, ()=>{
        cb(offset, false);
    }, instance.options.isScrollingResetDelay);
    const createHandler = (isScrolling)=>()=>{
            const { horizontal: horizontal, isRtl: isRtl } = instance.options;
            offset = horizontal ? element["scrollLeft"] * (isRtl && -1 || 1) : element["scrollTop"];
            fallback();
            cb(offset, isScrolling);
        };
    const handler = createHandler(true);
    const endHandler = createHandler(false);
    endHandler();
    element.addEventListener("scroll", handler, $fb876145852c2505$var$addEventListenerOptions);
    element.addEventListener("scrollend", endHandler, $fb876145852c2505$var$addEventListenerOptions);
    return ()=>{
        element.removeEventListener("scroll", handler);
        element.removeEventListener("scrollend", endHandler);
    };
};
const $fb876145852c2505$export$518998f8c5d09287 = (instance, cb)=>{
    const element = instance.scrollElement;
    if (!element) return;
    const targetWindow = instance.targetWindow;
    if (!targetWindow) return;
    let offset = 0;
    const fallback = $fb876145852c2505$var$supportsScrollend ? ()=>void 0 : (0, $cDbvq.debounce)(targetWindow, ()=>{
        cb(offset, false);
    }, instance.options.isScrollingResetDelay);
    const createHandler = (isScrolling)=>()=>{
            offset = element[instance.options.horizontal ? "scrollX" : "scrollY"];
            fallback();
            cb(offset, isScrolling);
        };
    const handler = createHandler(true);
    const endHandler = createHandler(false);
    endHandler();
    element.addEventListener("scroll", handler, $fb876145852c2505$var$addEventListenerOptions);
    element.addEventListener("scrollend", endHandler, $fb876145852c2505$var$addEventListenerOptions);
    return ()=>{
        element.removeEventListener("scroll", handler);
        element.removeEventListener("scrollend", endHandler);
    };
};
const $fb876145852c2505$export$6aa9c23c0f5932af = (element, entry, instance)=>{
    if (entry == null ? void 0 : entry.borderBoxSize) {
        const box = entry.borderBoxSize[0];
        if (box) {
            const size = Math.round(box[instance.options.horizontal ? "inlineSize" : "blockSize"]);
            return size;
        }
    }
    return Math.round(element.getBoundingClientRect()[instance.options.horizontal ? "width" : "height"]);
};
const $fb876145852c2505$export$2162c5b3eeedd27 = (offset, { adjustments: adjustments = 0, behavior: behavior }, instance)=>{
    var _a, _b;
    const toOffset = offset + adjustments;
    (_b = (_a = instance.scrollElement) == null ? void 0 : _a.scrollTo) == null || _b.call(_a, {
        [instance.options.horizontal ? "left" : "top"]: toOffset,
        behavior: behavior
    });
};
const $fb876145852c2505$export$1cdb988e5ab69fe7 = (offset, { adjustments: adjustments = 0, behavior: behavior }, instance)=>{
    var _a, _b;
    const toOffset = offset + adjustments;
    (_b = (_a = instance.scrollElement) == null ? void 0 : _a.scrollTo) == null || _b.call(_a, {
        [instance.options.horizontal ? "left" : "top"]: toOffset,
        behavior: behavior
    });
};
class $fb876145852c2505$export$89be5a243e59c4b2 {
    constructor(opts){
        this.unsubs = [];
        this.scrollElement = null;
        this.targetWindow = null;
        this.isScrolling = false;
        this.scrollToIndexTimeoutId = null;
        this.measurementsCache = [];
        this.itemSizeCache = /* @__PURE__ */ new Map();
        this.pendingMeasuredCacheIndexes = [];
        this.scrollRect = null;
        this.scrollOffset = null;
        this.scrollDirection = null;
        this.scrollAdjustments = 0;
        this.elementsCache = /* @__PURE__ */ new Map();
        this.observer = /* @__PURE__ */ (()=>{
            let _ro = null;
            const get = ()=>{
                if (_ro) return _ro;
                if (!this.targetWindow || !this.targetWindow.ResizeObserver) return null;
                return _ro = new this.targetWindow.ResizeObserver((entries)=>{
                    entries.forEach((entry)=>{
                        this._measureElement(entry.target, entry);
                    });
                });
            };
            return {
                disconnect: ()=>{
                    var _a;
                    (_a = get()) == null || _a.disconnect();
                    _ro = null;
                },
                observe: (target)=>{
                    var _a;
                    return (_a = get()) == null ? void 0 : _a.observe(target, {
                        box: "border-box"
                    });
                },
                unobserve: (target)=>{
                    var _a;
                    return (_a = get()) == null ? void 0 : _a.unobserve(target);
                }
            };
        })();
        this.range = null;
        this.setOptions = (opts2)=>{
            Object.entries(opts2).forEach(([key, value])=>{
                if (typeof value === "undefined") delete opts2[key];
            });
            this.options = {
                debug: false,
                initialOffset: 0,
                overscan: 1,
                paddingStart: 0,
                paddingEnd: 0,
                scrollPaddingStart: 0,
                scrollPaddingEnd: 0,
                horizontal: false,
                getItemKey: $fb876145852c2505$export$76974b428a49f15b,
                rangeExtractor: $fb876145852c2505$export$7eb7cb13fd21e5e1,
                onChange: ()=>{},
                measureElement: $fb876145852c2505$export$6aa9c23c0f5932af,
                initialRect: {
                    width: 0,
                    height: 0
                },
                scrollMargin: 0,
                gap: 0,
                indexAttribute: "data-index",
                initialMeasurementsCache: [],
                lanes: 1,
                isScrollingResetDelay: 150,
                enabled: true,
                isRtl: false,
                ...opts2
            };
        };
        this.notify = (sync)=>{
            var _a, _b;
            (_b = (_a = this.options).onChange) == null || _b.call(_a, this, sync);
        };
        this.maybeNotify = (0, $cDbvq.memo)(()=>{
            this.calculateRange();
            return [
                this.isScrolling,
                this.range ? this.range.startIndex : null,
                this.range ? this.range.endIndex : null
            ];
        }, (isScrolling)=>{
            this.notify(isScrolling);
        }, {
            key: false,
            debug: ()=>this.options.debug,
            initialDeps: [
                this.isScrolling,
                this.range ? this.range.startIndex : null,
                this.range ? this.range.endIndex : null
            ]
        });
        this.cleanup = ()=>{
            this.unsubs.filter(Boolean).forEach((d)=>d());
            this.unsubs = [];
            this.observer.disconnect();
            this.scrollElement = null;
            this.targetWindow = null;
        };
        this._didMount = ()=>{
            return ()=>{
                this.cleanup();
            };
        };
        this._willUpdate = ()=>{
            var _a;
            const scrollElement = this.options.enabled ? this.options.getScrollElement() : null;
            if (this.scrollElement !== scrollElement) {
                this.cleanup();
                if (!scrollElement) {
                    this.maybeNotify();
                    return;
                }
                this.scrollElement = scrollElement;
                if (this.scrollElement && "ownerDocument" in this.scrollElement) this.targetWindow = this.scrollElement.ownerDocument.defaultView;
                else this.targetWindow = ((_a = this.scrollElement) == null ? void 0 : _a.window) ?? null;
                this.elementsCache.forEach((cached)=>{
                    this.observer.observe(cached);
                });
                this._scrollToOffset(this.getScrollOffset(), {
                    adjustments: void 0,
                    behavior: void 0
                });
                this.unsubs.push(this.options.observeElementRect(this, (rect)=>{
                    this.scrollRect = rect;
                    this.maybeNotify();
                }));
                this.unsubs.push(this.options.observeElementOffset(this, (offset, isScrolling)=>{
                    this.scrollAdjustments = 0;
                    this.scrollDirection = isScrolling ? this.getScrollOffset() < offset ? "forward" : "backward" : null;
                    this.scrollOffset = offset;
                    this.isScrolling = isScrolling;
                    this.maybeNotify();
                }));
            }
        };
        this.getSize = ()=>{
            if (!this.options.enabled) {
                this.scrollRect = null;
                return 0;
            }
            this.scrollRect = this.scrollRect ?? this.options.initialRect;
            return this.scrollRect[this.options.horizontal ? "width" : "height"];
        };
        this.getScrollOffset = ()=>{
            if (!this.options.enabled) {
                this.scrollOffset = null;
                return 0;
            }
            this.scrollOffset = this.scrollOffset ?? (typeof this.options.initialOffset === "function" ? this.options.initialOffset() : this.options.initialOffset);
            return this.scrollOffset;
        };
        this.getFurthestMeasurement = (measurements, index)=>{
            const furthestMeasurementsFound = /* @__PURE__ */ new Map();
            const furthestMeasurements = /* @__PURE__ */ new Map();
            for(let m = index - 1; m >= 0; m--){
                const measurement = measurements[m];
                if (furthestMeasurementsFound.has(measurement.lane)) continue;
                const previousFurthestMeasurement = furthestMeasurements.get(measurement.lane);
                if (previousFurthestMeasurement == null || measurement.end > previousFurthestMeasurement.end) furthestMeasurements.set(measurement.lane, measurement);
                else if (measurement.end < previousFurthestMeasurement.end) furthestMeasurementsFound.set(measurement.lane, true);
                if (furthestMeasurementsFound.size === this.options.lanes) break;
            }
            return furthestMeasurements.size === this.options.lanes ? Array.from(furthestMeasurements.values()).sort((a, b)=>{
                if (a.end === b.end) return a.index - b.index;
                return a.end - b.end;
            })[0] : void 0;
        };
        this.getMeasurementOptions = (0, $cDbvq.memo)(()=>[
                this.options.count,
                this.options.paddingStart,
                this.options.scrollMargin,
                this.options.getItemKey,
                this.options.enabled
            ], (count, paddingStart, scrollMargin, getItemKey, enabled)=>{
            this.pendingMeasuredCacheIndexes = [];
            return {
                count: count,
                paddingStart: paddingStart,
                scrollMargin: scrollMargin,
                getItemKey: getItemKey,
                enabled: enabled
            };
        }, {
            key: false
        });
        this.getMeasurements = (0, $cDbvq.memo)(()=>[
                this.getMeasurementOptions(),
                this.itemSizeCache
            ], ({ count: count, paddingStart: paddingStart, scrollMargin: scrollMargin, getItemKey: getItemKey, enabled: enabled }, itemSizeCache)=>{
            if (!enabled) {
                this.measurementsCache = [];
                this.itemSizeCache.clear();
                return [];
            }
            if (this.measurementsCache.length === 0) {
                this.measurementsCache = this.options.initialMeasurementsCache;
                this.measurementsCache.forEach((item)=>{
                    this.itemSizeCache.set(item.key, item.size);
                });
            }
            const min = this.pendingMeasuredCacheIndexes.length > 0 ? Math.min(...this.pendingMeasuredCacheIndexes) : 0;
            this.pendingMeasuredCacheIndexes = [];
            const measurements = this.measurementsCache.slice(0, min);
            for(let i = min; i < count; i++){
                const key = getItemKey(i);
                const furthestMeasurement = this.options.lanes === 1 ? measurements[i - 1] : this.getFurthestMeasurement(measurements, i);
                const start = furthestMeasurement ? furthestMeasurement.end + this.options.gap : paddingStart + scrollMargin;
                const measuredSize = itemSizeCache.get(key);
                const size = typeof measuredSize === "number" ? measuredSize : this.options.estimateSize(i);
                const end = start + size;
                const lane = furthestMeasurement ? furthestMeasurement.lane : i % this.options.lanes;
                measurements[i] = {
                    index: i,
                    start: start,
                    size: size,
                    end: end,
                    key: key,
                    lane: lane
                };
            }
            this.measurementsCache = measurements;
            return measurements;
        }, {
            key: false,
            debug: ()=>this.options.debug
        });
        this.calculateRange = (0, $cDbvq.memo)(()=>[
                this.getMeasurements(),
                this.getSize(),
                this.getScrollOffset()
            ], (measurements, outerSize, scrollOffset)=>{
            return this.range = measurements.length > 0 && outerSize > 0 ? $fb876145852c2505$var$calculateRange({
                measurements: measurements,
                outerSize: outerSize,
                scrollOffset: scrollOffset
            }) : null;
        }, {
            key: false,
            debug: ()=>this.options.debug
        });
        this.getIndexes = (0, $cDbvq.memo)(()=>[
                this.options.rangeExtractor,
                this.calculateRange(),
                this.options.overscan,
                this.options.count
            ], (rangeExtractor, range, overscan, count)=>{
            return range === null ? [] : rangeExtractor({
                startIndex: range.startIndex,
                endIndex: range.endIndex,
                overscan: overscan,
                count: count
            });
        }, {
            key: false,
            debug: ()=>this.options.debug
        });
        this.indexFromElement = (node)=>{
            const attributeName = this.options.indexAttribute;
            const indexStr = node.getAttribute(attributeName);
            if (!indexStr) {
                console.warn(`Missing attribute name '${attributeName}={index}' on measured element.`);
                return -1;
            }
            return parseInt(indexStr, 10);
        };
        this._measureElement = (node, entry)=>{
            const index = this.indexFromElement(node);
            const item = this.measurementsCache[index];
            if (!item) return;
            const key = item.key;
            const prevNode = this.elementsCache.get(key);
            if (prevNode !== node) {
                if (prevNode) this.observer.unobserve(prevNode);
                this.observer.observe(node);
                this.elementsCache.set(key, node);
            }
            if (node.isConnected) this.resizeItem(index, this.options.measureElement(node, entry, this));
        };
        this.resizeItem = (index, size)=>{
            const item = this.measurementsCache[index];
            if (!item) return;
            const itemSize = this.itemSizeCache.get(item.key) ?? item.size;
            const delta = size - itemSize;
            if (delta !== 0) {
                if (this.shouldAdjustScrollPositionOnItemSizeChange !== void 0 ? this.shouldAdjustScrollPositionOnItemSizeChange(item, delta, this) : item.start < this.getScrollOffset() + this.scrollAdjustments) this._scrollToOffset(this.getScrollOffset(), {
                    adjustments: this.scrollAdjustments += delta,
                    behavior: void 0
                });
                this.pendingMeasuredCacheIndexes.push(item.index);
                this.itemSizeCache = new Map(this.itemSizeCache.set(item.key, size));
                this.notify(false);
            }
        };
        this.measureElement = (node)=>{
            if (!node) {
                this.elementsCache.forEach((cached, key)=>{
                    if (!cached.isConnected) {
                        this.observer.unobserve(cached);
                        this.elementsCache.delete(key);
                    }
                });
                return;
            }
            this._measureElement(node, void 0);
        };
        this.getVirtualItems = (0, $cDbvq.memo)(()=>[
                this.getIndexes(),
                this.getMeasurements()
            ], (indexes, measurements)=>{
            const virtualItems = [];
            for(let k = 0, len = indexes.length; k < len; k++){
                const i = indexes[k];
                const measurement = measurements[i];
                virtualItems.push(measurement);
            }
            return virtualItems;
        }, {
            key: false,
            debug: ()=>this.options.debug
        });
        this.getVirtualItemForOffset = (offset)=>{
            const measurements = this.getMeasurements();
            if (measurements.length === 0) return void 0;
            return (0, $cDbvq.notUndefined)(measurements[$fb876145852c2505$var$findNearestBinarySearch(0, measurements.length - 1, (index)=>(0, $cDbvq.notUndefined)(measurements[index]).start, offset)]);
        };
        this.getOffsetForAlignment = (toOffset, align)=>{
            const size = this.getSize();
            const scrollOffset = this.getScrollOffset();
            if (align === "auto") {
                if (toOffset <= scrollOffset) align = "start";
                else if (toOffset >= scrollOffset + size) align = "end";
                else align = "start";
            }
            if (align === "start") toOffset;
            else if (align === "end") toOffset = toOffset - size;
            else if (align === "center") toOffset = toOffset - size / 2;
            const scrollSizeProp = this.options.horizontal ? "scrollWidth" : "scrollHeight";
            const scrollSize = this.scrollElement ? "document" in this.scrollElement ? this.scrollElement.document.documentElement[scrollSizeProp] : this.scrollElement[scrollSizeProp] : 0;
            const maxOffset = scrollSize - size;
            return Math.max(Math.min(maxOffset, toOffset), 0);
        };
        this.getOffsetForIndex = (index, align = "auto")=>{
            index = Math.max(0, Math.min(index, this.options.count - 1));
            const item = this.measurementsCache[index];
            if (!item) return void 0;
            const size = this.getSize();
            const scrollOffset = this.getScrollOffset();
            if (align === "auto") {
                if (item.end >= scrollOffset + size - this.options.scrollPaddingEnd) align = "end";
                else if (item.start <= scrollOffset + this.options.scrollPaddingStart) align = "start";
                else return [
                    scrollOffset,
                    align
                ];
            }
            const toOffset = align === "end" ? item.end + this.options.scrollPaddingEnd : item.start - this.options.scrollPaddingStart;
            return [
                this.getOffsetForAlignment(toOffset, align),
                align
            ];
        };
        this.isDynamicMode = ()=>this.elementsCache.size > 0;
        this.cancelScrollToIndex = ()=>{
            if (this.scrollToIndexTimeoutId !== null && this.targetWindow) {
                this.targetWindow.clearTimeout(this.scrollToIndexTimeoutId);
                this.scrollToIndexTimeoutId = null;
            }
        };
        this.scrollToOffset = (toOffset, { align: align = "start", behavior: behavior } = {})=>{
            this.cancelScrollToIndex();
            if (behavior === "smooth" && this.isDynamicMode()) console.warn("The `smooth` scroll behavior is not fully supported with dynamic size.");
            this._scrollToOffset(this.getOffsetForAlignment(toOffset, align), {
                adjustments: void 0,
                behavior: behavior
            });
        };
        this.scrollToIndex = (index, { align: initialAlign = "auto", behavior: behavior } = {})=>{
            index = Math.max(0, Math.min(index, this.options.count - 1));
            this.cancelScrollToIndex();
            if (behavior === "smooth" && this.isDynamicMode()) console.warn("The `smooth` scroll behavior is not fully supported with dynamic size.");
            const offsetAndAlign = this.getOffsetForIndex(index, initialAlign);
            if (!offsetAndAlign) return;
            const [offset, align] = offsetAndAlign;
            this._scrollToOffset(offset, {
                adjustments: void 0,
                behavior: behavior
            });
            if (behavior !== "smooth" && this.isDynamicMode() && this.targetWindow) this.scrollToIndexTimeoutId = this.targetWindow.setTimeout(()=>{
                this.scrollToIndexTimeoutId = null;
                const elementInDOM = this.elementsCache.has(this.options.getItemKey(index));
                if (elementInDOM) {
                    const [latestOffset] = (0, $cDbvq.notUndefined)(this.getOffsetForIndex(index, align));
                    if (!(0, $cDbvq.approxEqual)(latestOffset, this.getScrollOffset())) this.scrollToIndex(index, {
                        align: align,
                        behavior: behavior
                    });
                } else this.scrollToIndex(index, {
                    align: align,
                    behavior: behavior
                });
            });
        };
        this.scrollBy = (delta, { behavior: behavior } = {})=>{
            this.cancelScrollToIndex();
            if (behavior === "smooth" && this.isDynamicMode()) console.warn("The `smooth` scroll behavior is not fully supported with dynamic size.");
            this._scrollToOffset(this.getScrollOffset() + delta, {
                adjustments: void 0,
                behavior: behavior
            });
        };
        this.getTotalSize = ()=>{
            var _a;
            const measurements = this.getMeasurements();
            let end;
            if (measurements.length === 0) end = this.options.paddingStart;
            else end = this.options.lanes === 1 ? ((_a = measurements[measurements.length - 1]) == null ? void 0 : _a.end) ?? 0 : Math.max(...measurements.slice(-this.options.lanes).map((m)=>m.end));
            return Math.max(end - this.options.scrollMargin + this.options.paddingEnd, 0);
        };
        this._scrollToOffset = (offset, { adjustments: adjustments, behavior: behavior })=>{
            this.options.scrollToFn(offset, {
                behavior: behavior,
                adjustments: adjustments
            }, this);
        };
        this.measure = ()=>{
            this.itemSizeCache = /* @__PURE__ */ new Map();
            this.notify(false);
        };
        this.setOptions(opts);
    }
}
const $fb876145852c2505$var$findNearestBinarySearch = (low, high, getCurrentValue, value)=>{
    while(low <= high){
        const middle = (low + high) / 2 | 0;
        const currentValue = getCurrentValue(middle);
        if (currentValue < value) low = middle + 1;
        else if (currentValue > value) high = middle - 1;
        else return middle;
    }
    if (low > 0) return low - 1;
    else return 0;
};
function $fb876145852c2505$var$calculateRange({ measurements: measurements, outerSize: outerSize, scrollOffset: scrollOffset }) {
    const count = measurements.length - 1;
    const getOffset = (index)=>measurements[index].start;
    const startIndex = $fb876145852c2505$var$findNearestBinarySearch(0, count, getOffset, scrollOffset);
    let endIndex = startIndex;
    while(endIndex < count && measurements[endIndex].end < scrollOffset + outerSize)endIndex++;
    return {
        startIndex: startIndex,
        endIndex: endIndex
    };
}

});
parcelRegister("cDbvq", function(module, exports) {

$parcel$export(module.exports, "memo", () => $93220d646a94e11c$export$7c73462e0d25e514);
$parcel$export(module.exports, "notUndefined", () => $93220d646a94e11c$export$9a1adf421b69c6a);
$parcel$export(module.exports, "approxEqual", () => $93220d646a94e11c$export$8a4f1dcc58a69dbd);
$parcel$export(module.exports, "debounce", () => $93220d646a94e11c$export$61fc7d43ac8f84b0);
function $93220d646a94e11c$export$7c73462e0d25e514(getDeps, fn, opts) {
    let deps = opts.initialDeps ?? [];
    let result;
    return ()=>{
        var _a, _b, _c, _d;
        let depTime;
        if (opts.key && ((_a = opts.debug) == null ? void 0 : _a.call(opts))) depTime = Date.now();
        const newDeps = getDeps();
        const depsChanged = newDeps.length !== deps.length || newDeps.some((dep, index)=>deps[index] !== dep);
        if (!depsChanged) return result;
        deps = newDeps;
        let resultTime;
        if (opts.key && ((_b = opts.debug) == null ? void 0 : _b.call(opts))) resultTime = Date.now();
        result = fn(...newDeps);
        if (opts.key && ((_c = opts.debug) == null ? void 0 : _c.call(opts))) {
            const depEndTime = Math.round((Date.now() - depTime) * 100) / 100;
            const resultEndTime = Math.round((Date.now() - resultTime) * 100) / 100;
            const resultFpsPercentage = resultEndTime / 16;
            const pad = (str, num)=>{
                str = String(str);
                while(str.length < num)str = " " + str;
                return str;
            };
            console.info(`%c\u{23F1} ${pad(resultEndTime, 5)} /${pad(depEndTime, 5)} ms`, `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(0, Math.min(120 - 120 * resultFpsPercentage, 120))}deg 100% 31%);`, opts == null ? void 0 : opts.key);
        }
        (_d = opts == null ? void 0 : opts.onChange) == null || _d.call(opts, result);
        return result;
    };
}
function $93220d646a94e11c$export$9a1adf421b69c6a(value, msg) {
    if (value === void 0) throw new Error(`Unexpected undefined${msg ? `: ${msg}` : ""}`);
    else return value;
}
const $93220d646a94e11c$export$8a4f1dcc58a69dbd = (a, b)=>Math.abs(a - b) < 1;
const $93220d646a94e11c$export$61fc7d43ac8f84b0 = (targetWindow, fn, ms)=>{
    let timeoutId;
    return function(...args) {
        targetWindow.clearTimeout(timeoutId);
        timeoutId = targetWindow.setTimeout(()=>fn.apply(this, args), ms);
    };
};

});



parcelRegister("3KYe6", function(module, exports) {

$parcel$export(module.exports, "autoScrollForElements", () => $5ea44a3a02963798$export$4b66ee8317094cdb);

var $7gWdR = parcelRequire("7gWdR");

var $1XBB4 = parcelRequire("1XBB4");
const $5ea44a3a02963798$var$api = (0, $1XBB4.makeApi)({
    monitor: (0, $7gWdR.monitorForElements)
});
const $5ea44a3a02963798$export$4b66ee8317094cdb = $5ea44a3a02963798$var$api.autoScroll;
const $5ea44a3a02963798$export$c9168f41de61f525 = $5ea44a3a02963798$var$api.autoScrollWindow;

});
parcelRegister("1XBB4", function(module, exports) {

$parcel$export(module.exports, "makeApi", () => $7c9f5b9e5aad06df$export$b8fa21320a811083);

var $4hDdm = parcelRequire("4hDdm");

var $4HETl = parcelRequire("4HETl");

var $5DMYW = parcelRequire("5DMYW");

var $dN2fr = parcelRequire("dN2fr");
function $7c9f5b9e5aad06df$export$b8fa21320a811083({ monitor: monitor }) {
    const elementRegistry = new Map();
    const windowRegistry = new Set();
    function autoScroll(args) {
        elementRegistry.set(args.element, args);
        return (0, $4hDdm.combine)((0, $5DMYW.addScrollableAttribute)(args.element), ()=>elementRegistry.delete(args.element));
    }
    function autoScrollWindow(args = {}) {
        // Putting `args` in a unique object so that
        // each call will create a unique entry, even if a consumer
        // shares the `args` object between calls.
        // Just being safe here.
        const unique = {
            ...args
        };
        windowRegistry.add(unique);
        return ()=>windowRegistry.delete(unique);
    }
    function findEntry(element) {
        return elementRegistry.get(element) ?? null;
    }
    function getWindowScrollEntries() {
        return Array.from(windowRegistry);
    }
    function onFrame({ latestArgs: latestArgs, underUsersPointer: underUsersPointer, timeSinceLastFrame: timeSinceLastFrame }) {
        (0, $dN2fr.tryScroll)({
            input: latestArgs.location.current.input,
            source: latestArgs.source,
            findEntry: findEntry,
            underUsersPointer: underUsersPointer,
            timeSinceLastFrame: timeSinceLastFrame,
            getWindowScrollEntries: getWindowScrollEntries
        });
    }
    (0, $4HETl.getScheduler)(monitor).onFrame(onFrame);
    return {
        autoScroll: autoScroll,
        autoScrollWindow: autoScrollWindow
    };
}

});
parcelRegister("4HETl", function(module, exports) {

$parcel$export(module.exports, "getScheduler", () => $76249ae4e9f30f38$export$5cff7ac265db316a);
parcelRequire("i6e0j");
var $kKgsQ = parcelRequire("kKgsQ");

var $3d4ga = parcelRequire("3d4ga");
// We keep this map so that "over element" scrolling and "overflow" scrolling
// can leverage the same scheduler.
// The 'monitor' is the key for looking up schedulers
const $76249ae4e9f30f38$var$schedulers = new Map();
function $76249ae4e9f30f38$export$5cff7ac265db316a(monitor) {
    const scheduler = $76249ae4e9f30f38$var$schedulers.get(monitor);
    if (scheduler) // @ts-expect-error: I don't know how to link the DragType generic between the key and the value when the
    // monitor itself is the key
    return scheduler;
    const created = $76249ae4e9f30f38$var$makeScheduler(monitor);
    $76249ae4e9f30f38$var$schedulers.set(monitor, created);
    return created;
}
function $76249ae4e9f30f38$var$makeScheduler(monitor) {
    let state = {
        type: 'idle'
    };
    const callbacks = [];
    function loop(timeLastFrameFinished) {
        if (state.type !== 'running') return;
        const timeSinceLastFrame = timeLastFrameFinished - state.timeLastFrameFinished;
        const { latestArgs: latestArgs } = state;
        // A common starting lookup point for determining
        // which auto scroller should be used, and what should be scrolled.
        const underUsersPointer = (0, $kKgsQ.getElementFromPointWithoutHoneypot)({
            x: latestArgs.location.current.input.clientX,
            y: latestArgs.location.current.input.clientY
        });
        (0, $3d4ga.clearUnusedEngagements)(()=>{
            callbacks.forEach((onFrame)=>onFrame({
                    underUsersPointer: underUsersPointer,
                    latestArgs: latestArgs,
                    timeSinceLastFrame: timeSinceLastFrame
                }));
        });
        state.timeLastFrameFinished = timeLastFrameFinished;
        state.frameId = requestAnimationFrame(loop);
    }
    function reset() {
        if (state.type === 'idle') return;
        cancelAnimationFrame(state.frameId);
        (0, $3d4ga.clearEngagementHistory)();
        state = {
            type: 'idle'
        };
    }
    function start(args) {
        if (state.type !== 'idle') return;
        state = {
            // Waiting a frame so we can accurately determine `timeSinceLastFrame`.
            type: 'initializing',
            latestArgs: args,
            frameId: requestAnimationFrame((timeLastFrameFinished)=>{
                if (state.type !== 'initializing') return;
                state = {
                    type: 'running',
                    timeLastFrameFinished: timeLastFrameFinished,
                    latestArgs: state.latestArgs,
                    frameId: requestAnimationFrame(loop)
                };
            })
        };
    }
    // this module might have been imported after a drag has started
    // We are starting the auto scroller if we get an update event and
    // the auto scroller has not started yet
    function update(args) {
        if (state.type === 'idle') {
            start(args);
            return;
        }
        state.latestArgs = args;
    }
    // Not exposing a way to stop listening
    monitor({
        onDragStart: start,
        onDropTargetChange: update,
        onDrag: update,
        onDrop: reset
    });
    const api = {
        onFrame (fn) {
            callbacks.push(fn);
        }
    };
    return api;
}

});
parcelRegister("i6e0j", function(module, exports) {

$parcel$export(module.exports, "getElementFromPointWithoutHoneypot", () => (parcelRequire("kKgsQ")).getElementFromPointWithoutHoneypot);

var $kKgsQ = parcelRequire("kKgsQ");

});

parcelRegister("3d4ga", function(module, exports) {

$parcel$export(module.exports, "markAndGetEngagement", () => $cdcee60ad04716da$export$8c764c3f2fc3d2d2);
$parcel$export(module.exports, "clearUnusedEngagements", () => $cdcee60ad04716da$export$991e77dd347f3df1);
$parcel$export(module.exports, "clearEngagementHistory", () => $cdcee60ad04716da$export$13ae770ed39b71ea);
const $cdcee60ad04716da$var$ledger = new Map();
const $cdcee60ad04716da$var$requested = new Set();
function $cdcee60ad04716da$export$8c764c3f2fc3d2d2(element) {
    $cdcee60ad04716da$export$1cb7cbb266b6f6fa(element);
    const entry = $cdcee60ad04716da$var$ledger.get(element);
    if (entry) return entry;
    const fresh = {
        timeOfEngagementStart: Date.now()
    };
    $cdcee60ad04716da$var$ledger.set(element, fresh);
    return fresh;
}
function $cdcee60ad04716da$export$1cb7cbb266b6f6fa(element) {
    $cdcee60ad04716da$var$requested.add(element);
}
function $cdcee60ad04716da$export$991e77dd347f3df1(fn) {
    // make sure previous engagement requests don't linger
    $cdcee60ad04716da$var$requested.clear();
    // perform the required work
    fn();
    // if engagements where not requested, purge it
    $cdcee60ad04716da$var$ledger.forEach((_, element)=>{
        if (!$cdcee60ad04716da$var$requested.has(element)) $cdcee60ad04716da$var$ledger.delete(element);
    });
    // cleaning up after ourselves
    $cdcee60ad04716da$var$requested.clear();
}
function $cdcee60ad04716da$export$13ae770ed39b71ea() {
    $cdcee60ad04716da$var$ledger.clear();
}

});


parcelRegister("5DMYW", function(module, exports) {

$parcel$export(module.exports, "selector", () => $05e8460564c70d18$export$aea217a45095ce11);
$parcel$export(module.exports, "addScrollableAttribute", () => $05e8460564c70d18$export$4ec12fb57dfebd53);
const $05e8460564c70d18$export$4b152ab55cad4fd6 = 'data-auto-scrollable';
const $05e8460564c70d18$export$aea217a45095ce11 = `[${$05e8460564c70d18$export$4b152ab55cad4fd6}="true"]`;
function $05e8460564c70d18$export$4ec12fb57dfebd53(element) {
    element.setAttribute($05e8460564c70d18$export$4b152ab55cad4fd6, 'true');
    return ()=>element.removeAttribute($05e8460564c70d18$export$4b152ab55cad4fd6);
}

});

parcelRegister("dN2fr", function(module, exports) {

$parcel$export(module.exports, "tryScroll", () => $95daf559d8aa786a$export$233199807749476d);

var $kjAuM = parcelRequire("kjAuM");

var $3d4ga = parcelRequire("3d4ga");

var $5DMYW = parcelRequire("5DMYW");

var $i4SSA = parcelRequire("i4SSA");
function $95daf559d8aa786a$var$isScrollingAvailable(value) {
    return Boolean(value.top || value.left);
}
function $95daf559d8aa786a$var$tryScrollElements({ target: target, input: input, source: source, findEntry: findEntry, timeSinceLastFrame: timeSinceLastFrame, available: available = {
    top: true,
    left: true
} }) {
    // we cannot do any more scrolling
    if (!$95daf559d8aa786a$var$isScrollingAvailable(available)) return available;
    // run out of parents to search
    if (!target) return available;
    const element = target.closest((0, $5DMYW.selector));
    // cannot find any more scroll containers
    if (!element) return available;
    const container = findEntry(element);
    // cannot find registration, this is bad.
    // fail and just exit
    if (!container) return available;
    function continueSearchUp() {
        return $95daf559d8aa786a$var$tryScrollElements({
            target: element?.parentElement ?? null,
            findEntry: findEntry,
            source: source,
            timeSinceLastFrame: timeSinceLastFrame,
            input: input,
            available: available
        });
    }
    const feedback = {
        input: input,
        source: source,
        element: element
    };
    // Engagement is not marked if scrolling is explicitly not allowed
    if (container.canScroll && !container.canScroll(feedback)) return continueSearchUp();
    // Marking engagement even if no edges are scrollable.
    // We are marking engagement as soon as the element is scrolled over
    const engagement = (0, $3d4ga.markAndGetEngagement)(element);
    const config = (0, $kjAuM.getInternalConfig)(container.getConfiguration?.(feedback));
    const allowedAxis = container.getAllowedAxis?.(feedback) ?? 'all';
    const scrollBy = (0, $i4SSA.getScrollBy)({
        element: element,
        engagement: engagement,
        input: input,
        timeSinceLastFrame: timeSinceLastFrame,
        allowedAxis: allowedAxis,
        config: config
    });
    // Only allow scrolling in directions that have not already been used
    const scroll = {
        top: 0,
        left: 0
    };
    if (available.top && scrollBy.top !== 0) {
        scroll.top = scrollBy.top;
        // can no longer scroll on the top after this
        available.top = false;
    }
    if (available.left && scrollBy.left !== 0) {
        scroll.left = scrollBy.left;
        // can no longer scroll on the left after this
        available.left = false;
    }
    // Only scroll if there is something to scroll
    if (scroll.top !== 0 || scroll.left !== 0) element.scrollBy(scroll);
    return continueSearchUp();
}
function $95daf559d8aa786a$var$tryScrollWindow({ input: input, timeSinceLastFrame: timeSinceLastFrame, available: available, source: source, entries: entries }) {
    const element = document.documentElement;
    const feedback = {
        input: input,
        source: source,
        element: element
    };
    for (const entry of entries){
        // this entry is not allowing scrolling, we need to look for another
        if (entry.canScroll && !entry.canScroll(feedback)) continue;
        // Note: if we had an event for when the user is leaving a tab
        // we _could_ conceptually reset the engagement
        const engagement = (0, $3d4ga.markAndGetEngagement)(element);
        const config = (0, $kjAuM.getInternalConfig)(entry.getConfiguration?.(feedback));
        const allowedAxis = entry.getAllowedAxis?.(feedback) ?? 'all';
        const scrollBy = (0, $i4SSA.getScrollBy)({
            element: element,
            engagement: engagement,
            input: input,
            config: config,
            allowedAxis: allowedAxis,
            getRect: (element)=>DOMRect.fromRect({
                    y: 0,
                    x: 0,
                    width: element.clientWidth,
                    height: element.clientHeight
                }),
            timeSinceLastFrame: timeSinceLastFrame
        });
        const scroll = {
            top: available.top ? scrollBy.top : 0,
            left: available.left ? scrollBy.left : 0
        };
        // only trigger a scroll if we are actually scrolling
        if (scroll.top !== 0 || scroll.left !== 0) element.scrollBy(scroll);
        break;
    }
}
function $95daf559d8aa786a$export$233199807749476d({ input: input, findEntry: findEntry, timeSinceLastFrame: timeSinceLastFrame, source: source, getWindowScrollEntries: getWindowScrollEntries, underUsersPointer: underUsersPointer }) {
    // We are matching browser behaviour and scrolling inner elements
    // before outer ones. So we try to scroll scroller containers before
    // the window.
    const remainder = $95daf559d8aa786a$var$tryScrollElements({
        target: underUsersPointer,
        timeSinceLastFrame: timeSinceLastFrame,
        input: input,
        source: source,
        findEntry: findEntry
    });
    // Check if we can do any window scrolling
    if (!$95daf559d8aa786a$var$isScrollingAvailable(remainder)) return;
    $95daf559d8aa786a$var$tryScrollWindow({
        input: input,
        source: source,
        entries: getWindowScrollEntries(),
        timeSinceLastFrame: timeSinceLastFrame,
        available: remainder
    });
}

});
parcelRegister("kjAuM", function(module, exports) {

$parcel$export(module.exports, "getInternalConfig", () => $8aedd24a4f7bb643$export$e96028ec7ff9d079);
const $8aedd24a4f7bb643$var$baseConfig = {
    startHitboxAtPercentageRemainingOfElement: {
        top: 0.25,
        right: 0.25,
        bottom: 0.25,
        left: 0.25
    },
    maxScrollAtPercentageRemainingOfHitbox: {
        top: 0.5,
        right: 0.5,
        bottom: 0.5,
        left: 0.5
    },
    timeDampeningDurationMs: 400,
    // Too big and it's too easy to trigger auto scrolling
    // Too small and it's too hard 😅
    maxMainAxisHitboxSize: 180
};
/** What the max scroll should be per second. Using "per second" rather than "per frame"
 * as we want a consistent scroll speed regardless of frame rate.
 *
 *
 * I explored trying to make the max scroll speed dynamic based on particular factors.
 * However, it ended up being difficult to find a _perfect_ formula.
 *
 * Likely the perfect answer would involve:
 * - the size of the scrollable element
 * - the size of the scrollable element relative to the screen size
 * - the size of the drag preview
 * - the size of elements being scrolled in scrollable elements (expensive and difficult to compute)
 */ const $8aedd24a4f7bb643$var$maxPixelScrollPerSecond = {
    // What the value would be if we were scrolling at 15px per frame at 60fps.
    // This is the default as it works well for most experiences.
    // In certain scenarios though it can feel a bit slow.
    standard: 900,
    // What the value would be if we were scrolling at 25px per frame at 60fps.
    // This is not the default as it feels too fast for a lot of experiences.
    fast: 1500
};
function $8aedd24a4f7bb643$export$e96028ec7ff9d079(provided) {
    return {
        ...$8aedd24a4f7bb643$var$baseConfig,
        // only allowing limited control over the config at this stage
        maxPixelScrollPerSecond: $8aedd24a4f7bb643$var$maxPixelScrollPerSecond[provided?.maxScrollSpeed ?? 'standard']
    };
}

});

parcelRegister("i4SSA", function(module, exports) {

$parcel$export(module.exports, "getScrollBy", () => $f221acff344cd122$export$6cfa6dfe6898b98f);

var $iduok = parcelRequire("iduok");

var $ffSUw = parcelRequire("ffSUw");

var $c3M8M = parcelRequire("c3M8M");

var $gfxd2 = parcelRequire("gfxd2");

var $hTDOm = parcelRequire("hTDOm");

var $2dwAb = parcelRequire("2dwAb");
function $f221acff344cd122$var$getRectDefault(element) {
    return element.getBoundingClientRect();
}
function $f221acff344cd122$export$6cfa6dfe6898b98f({ element: element, input: input, timeSinceLastFrame: timeSinceLastFrame, engagement: engagement, config: config, allowedAxis: allowedAxis, getRect: getRect = $f221acff344cd122$var$getRectDefault }) {
    const client = {
        x: input.clientX,
        y: input.clientY
    };
    const clientRect = getRect(element);
    const scrollableEdges = (0, $ffSUw.edges).reduce((map, edge)=>{
        const hitbox = (0, $c3M8M.getOverElementHitbox)[edge]({
            clientRect: clientRect,
            config: config
        });
        const axis = (0, $ffSUw.edgeAxisLookup)[edge];
        // Note: changing the allowed axis during a drag will not
        // reset time dampening. It was decided it would be too
        // complex to implement initially, and we can add it
        // later if needed.
        if (!(0, $hTDOm.isAxisAllowed)(axis, allowedAxis)) return map;
        if (!(0, $2dwAb.isWithin)({
            client: client,
            clientRect: hitbox
        })) return map;
        if (!(0, $iduok.canScrollOnEdge)[edge](element)) return map;
        map.set(edge, {
            edge: edge,
            hitbox: hitbox
        });
        return map;
    }, new Map());
    const left = (()=>{
        const axis = 'horizontal';
        const leftEdge = scrollableEdges.get('left');
        if (leftEdge) return (0, $gfxd2.getScrollChange)({
            client: client,
            edge: leftEdge.edge,
            hitbox: leftEdge.hitbox,
            axis: axis,
            timeSinceLastFrame: timeSinceLastFrame,
            engagement: engagement,
            isDistanceDampeningEnabled: true,
            config: config
        });
        const rightEdge = scrollableEdges.get('right');
        if (rightEdge) return (0, $gfxd2.getScrollChange)({
            client: client,
            edge: rightEdge.edge,
            hitbox: rightEdge.hitbox,
            axis: axis,
            timeSinceLastFrame: timeSinceLastFrame,
            engagement: engagement,
            isDistanceDampeningEnabled: true,
            config: config
        });
        return 0;
    })();
    const top = (()=>{
        const axis = 'vertical';
        const bottomEdge = scrollableEdges.get('bottom');
        if (bottomEdge) return (0, $gfxd2.getScrollChange)({
            client: client,
            edge: bottomEdge.edge,
            hitbox: bottomEdge.hitbox,
            axis: axis,
            timeSinceLastFrame: timeSinceLastFrame,
            engagement: engagement,
            isDistanceDampeningEnabled: true,
            config: config
        });
        const topEdge = scrollableEdges.get('top');
        if (topEdge) return (0, $gfxd2.getScrollChange)({
            client: client,
            edge: topEdge.edge,
            hitbox: topEdge.hitbox,
            axis: axis,
            timeSinceLastFrame: timeSinceLastFrame,
            engagement: engagement,
            isDistanceDampeningEnabled: true,
            config: config
        });
        return 0;
    })();
    return {
        left: left,
        top: top
    };
}

});
parcelRegister("iduok", function(module, exports) {

$parcel$export(module.exports, "canScrollOnEdge", () => $dc24cd2fd79e74bd$export$ccd6d9407403fcad);
const $dc24cd2fd79e74bd$export$ccd6d9407403fcad = {
    // Notes:
    //
    // 🌏 Chrome 115.0: uses fractional units for `scrollLeft` and `scrollTop`
    //    (and fractional units don't reach true integer maximum when zoomed in / out)
    // 🍎 Safari 16.5.2: no fractional units
    // 🦊 Firefox 115.0: no fractional units
    // we have some scroll we can move backwards into
    top: (element)=>element.scrollTop > 0,
    // We have some scroll we can move forward into
    right: (element)=>Math.ceil(element.scrollLeft) + element.clientWidth < element.scrollWidth,
    // We have some scroll we can move forwards into
    bottom: (element)=>Math.ceil(element.scrollTop) + element.clientHeight < element.scrollHeight,
    // we have some scroll we can move back into.
    left: (element)=>element.scrollLeft > 0
};

});

parcelRegister("ffSUw", function(module, exports) {

$parcel$export(module.exports, "edges", () => $77e5ecf85ecb98dd$export$4544a00f8eb65eb2);
$parcel$export(module.exports, "edgeAxisLookup", () => $77e5ecf85ecb98dd$export$7fc144124ccf8292);
const $77e5ecf85ecb98dd$export$4544a00f8eb65eb2 = [
    'top',
    'right',
    'bottom',
    'left'
];
const $77e5ecf85ecb98dd$export$7fc144124ccf8292 = {
    top: 'vertical',
    right: 'horizontal',
    bottom: 'vertical',
    left: 'horizontal'
};

});

parcelRegister("c3M8M", function(module, exports) {

$parcel$export(module.exports, "getOverElementHitbox", () => $4e0c1489e6f6f1ed$export$b9a449c20abb0e9);

var $9w8nT = parcelRequire("9w8nT");

var $aHtK2 = parcelRequire("aHtK2");
function $4e0c1489e6f6f1ed$var$makeGetHitbox({ edge: edge, axis: axis }) {
    return function hitbox({ clientRect: clientRect, config: config }) {
        const { mainAxis: mainAxis, crossAxis: crossAxis } = (0, $9w8nT.axisLookup)[axis];
        const side = (0, $aHtK2.mainAxisSideLookup)[edge];
        const mainAxisHitboxSize = Math.min(// scale the size of the hitbox down for smaller elements
        config.startHitboxAtPercentageRemainingOfElement[edge] * clientRect[mainAxis.size], // Don't let the hitbox grow too big for big elements
        config.maxMainAxisHitboxSize);
        return DOMRect.fromRect({
            [mainAxis.point]: side === 'start' ? clientRect[mainAxis.point] : clientRect[mainAxis.point] + clientRect[mainAxis.size] - mainAxisHitboxSize,
            [crossAxis.point]: clientRect[crossAxis.point],
            [mainAxis.size]: mainAxisHitboxSize,
            [crossAxis.size]: clientRect[crossAxis.size]
        });
    };
}
const $4e0c1489e6f6f1ed$export$b9a449c20abb0e9 = {
    top: $4e0c1489e6f6f1ed$var$makeGetHitbox({
        axis: 'vertical',
        edge: 'top'
    }),
    right: $4e0c1489e6f6f1ed$var$makeGetHitbox({
        axis: 'horizontal',
        edge: 'right'
    }),
    bottom: $4e0c1489e6f6f1ed$var$makeGetHitbox({
        axis: 'vertical',
        edge: 'bottom'
    }),
    left: $4e0c1489e6f6f1ed$var$makeGetHitbox({
        axis: 'horizontal',
        edge: 'left'
    })
};

});
parcelRegister("9w8nT", function(module, exports) {

$parcel$export(module.exports, "axisLookup", () => $4007ed2af13415f1$export$42e42cdab35a2b96);
const $4007ed2af13415f1$var$vertical = {
    start: 'top',
    end: 'bottom',
    point: 'y',
    size: 'height'
};
const $4007ed2af13415f1$var$horizontal = {
    start: 'left',
    end: 'right',
    point: 'x',
    size: 'width'
};
const $4007ed2af13415f1$export$42e42cdab35a2b96 = {
    vertical: {
        mainAxis: $4007ed2af13415f1$var$vertical,
        crossAxis: $4007ed2af13415f1$var$horizontal
    },
    horizontal: {
        mainAxis: $4007ed2af13415f1$var$horizontal,
        crossAxis: $4007ed2af13415f1$var$vertical
    }
};

});

parcelRegister("aHtK2", function(module, exports) {

$parcel$export(module.exports, "mainAxisSideLookup", () => $4b97aced6f7f08e4$export$a45c0cd714a4dbaa);
const $4b97aced6f7f08e4$export$a45c0cd714a4dbaa = {
    top: 'start',
    right: 'end',
    bottom: 'end',
    left: 'start'
};

});


parcelRegister("gfxd2", function(module, exports) {

$parcel$export(module.exports, "getScrollChange", () => $b3ae2158089b2ceb$export$470a2ff46db8cee8);

var $9w8nT = parcelRequire("9w8nT");

var $lUX3m = parcelRequire("lUX3m");

var $aHtK2 = parcelRequire("aHtK2");
// We want a consistent scroll speed across devices, regardless of framerate
function $b3ae2158089b2ceb$var$getMaxScrollChange({ timeSinceLastFrame: timeSinceLastFrame, config: config }) {
    const targetScrollPerMs = config.maxPixelScrollPerSecond / 1000;
    // Adjusting out target scroll rate to match the frame rate of the target device
    // This will pull the scroll speed down on high frame rate devices
    // so we get a consistent visual scroll speed regardless of device.
    const proposed = Math.ceil(targetScrollPerMs * timeSinceLastFrame);
    // If lots of time as passed since that last frame (such on lower frame rate devices)
    // we don't want the scroll speed to be too fast, otherwise it can feel jumpy
    // We are capping the scroll speed at what it would be if we were hitting 60fps
    const maximum = config.maxPixelScrollPerSecond / 60;
    return Math.min(proposed, maximum);
}
function $b3ae2158089b2ceb$var$getDistanceDampening({ client: client, axis: axis, edge: edge, hitbox: hitbox, config: config }) {
    const { mainAxis: mainAxis } = (0, $9w8nT.axisLookup)[axis];
    const side = (0, $aHtK2.mainAxisSideLookup)[edge];
    // We want to hit the max speed before the edge of the hitbox
    const maxSpeedBuffer = hitbox[mainAxis.size] * config.maxScrollAtPercentageRemainingOfHitbox[edge];
    if (side === 'end') return (0, $lUX3m.getPercentageInRange)({
        startOfRange: hitbox[mainAxis.start],
        endOfRange: hitbox[mainAxis.end] - maxSpeedBuffer,
        value: client[mainAxis.point]
    });
    // Moving towards start edge
    const raw = (0, $lUX3m.getPercentageInRange)({
        startOfRange: hitbox[mainAxis.start] + maxSpeedBuffer,
        endOfRange: hitbox[mainAxis.end],
        value: client[mainAxis.point]
    });
    // When moving near start edge
    // - the 'end' edge is where we start scrolling
    // - the 'start' edge is where we reach max speed
    // So we need to invert the percentage when moving backwards
    return 1 - raw;
}
function $b3ae2158089b2ceb$export$470a2ff46db8cee8({ client: client, timeSinceLastFrame: timeSinceLastFrame, engagement: engagement, axis: axis, hitbox: hitbox, edge: edge, isDistanceDampeningEnabled: isDistanceDampeningEnabled, config: config }) {
    // We have two forms of speed dampening:
    // 1. 🗺️ Distance
    // The closer you are to a hitbox edge, the faster the scroll speed will be
    // 2. ⏱️ Time
    // When first entering a scroll container we want to dampening all scrolling
    // This is to prevent super fast auto scrolling when first entering into
    // a scroll container, or when lifting in a scroll container
    const maxScroll = $b3ae2158089b2ceb$var$getMaxScrollChange({
        timeSinceLastFrame: timeSinceLastFrame,
        config: config
    });
    const percentageDistanceDampening = isDistanceDampeningEnabled ? $b3ae2158089b2ceb$var$getDistanceDampening({
        client: client,
        edge: edge,
        hitbox: hitbox,
        axis: axis,
        config: config
    }) : 1;
    // Dampen speed by time
    const percentageThroughTimeDampening = (0, $lUX3m.getPercentageInRange)({
        startOfRange: engagement.timeOfEngagementStart,
        endOfRange: engagement.timeOfEngagementStart + config.timeDampeningDurationMs,
        value: Date.now()
    });
    // Calculate how much of the max scroll we should apply based on dampening
    const percentageOfMaxScroll = percentageDistanceDampening * percentageThroughTimeDampening;
    // We _could_ ease this update (`Math.pow(percentageOfMaxSpeed, 2)`)
    // But linear is feeling really good
    // Always scrolling by at least one pixel, otherwise the scroll does nothing
    const scroll = Math.max(maxScroll * percentageOfMaxScroll, 1);
    const side = (0, $aHtK2.mainAxisSideLookup)[edge];
    // When moving backwards, we will be scrolling backwards
    return side === 'end' ? scroll : -1 * scroll;
}

});
parcelRegister("lUX3m", function(module, exports) {

$parcel$export(module.exports, "getPercentageInRange", () => $15bc8d2c21c8e1e4$export$1a29de000a332d74);
function $15bc8d2c21c8e1e4$export$1a29de000a332d74({ startOfRange: startOfRange, endOfRange: endOfRange, value: value }) {
    // checking inputs
    const isValid = startOfRange < endOfRange;
    if (!isValid) return 0;
    if (value < startOfRange) return 0;
    if (value > endOfRange) return 1;
    const range = endOfRange - startOfRange;
    return (value - startOfRange) / range;
}

});


parcelRegister("hTDOm", function(module, exports) {

$parcel$export(module.exports, "isAxisAllowed", () => $9d9969f3e7f53880$export$7120fdbd90bd1292);
function $9d9969f3e7f53880$export$7120fdbd90bd1292(axis, allowedAxis) {
    return allowedAxis === 'all' || axis === allowedAxis;
}

});

parcelRegister("2dwAb", function(module, exports) {

$parcel$export(module.exports, "isWithin", () => $df40d0415a8c41aa$export$cda7a9d4399bf2e3);
function $df40d0415a8c41aa$export$cda7a9d4399bf2e3({ client: client, clientRect: clientRect }) {
    return(// is within horizontal bounds
    client.x >= clientRect.x && client.x <= clientRect.x + clientRect.width && // is within vertical bounds
    client.y >= clientRect.y && client.y <= clientRect.y + clientRect.height);
}

});





parcelRegister("kJ1Ne", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce599d26c9577203$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $i8Qvm = parcelRequire("i8Qvm");

var $8uFbT = parcelRequire("8uFbT");

var $4mO32 = parcelRequire("4mO32");

var $7XluA = parcelRequire("7XluA");

var $7CMCs = parcelRequire("7CMCs");

var $AeWM3 = parcelRequire("AeWM3");

var $aXhsp = parcelRequire("aXhsp");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $e43Es = parcelRequire("e43Es");

var $hN7SF = parcelRequire("hN7SF");

var $getng = parcelRequire("getng");

var $6P8fi = parcelRequire("6P8fi");

const $ce599d26c9577203$var$entryPointParams = {};
const $ce599d26c9577203$var$PublicFormChangeboardingModalRoot = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "public-forms-changeboarding-modal",
        packageName: "@atlassian/jira-public-forms-changeboarding-modal",
        teamName: "a4t-tanuki",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $AeWM3.ApolloClientProvider), {
        client: (0, $aXhsp.default)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i8Qvm.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ce599d26c9577203$var$PublicFormChangeboardingModalContainer, props))));
};
const $ce599d26c9577203$var$PublicFormChangeboardingModalContainer = ({ projectId: projectId })=>{
    const { isActive: isModalTriggerActive } = (0, $8uFbT.useTrigger)((0, $1a3ee76b747d2e0b$export$245c2608a15570d3));
    const { isActive: isFlagTriggerActive } = (0, $8uFbT.useTrigger)((0, $1a3ee76b747d2e0b$export$6c605e0a476d3e4b));
    const data = (0, $e43Es.useGetData)({
        projectId: projectId,
        isEnabled: (isModalTriggerActive || isFlagTriggerActive) && (0, $4R6GH.fg)('jira_forms_public_access_changeboarding_gate')
    });
    const hasLoadedEntrypoint = (0, $5uXOq.useRef)(false);
    const { entryPointActions: modalEntryPointActions, entryPointReferenceSubject: modalEntryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $getng.asyncChangeboardingModalEntryPoint), $ce599d26c9577203$var$entryPointParams);
    const { entryPointActions: flagEntryPointActions, entryPointReferenceSubject: flagEntryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $hN7SF.asyncChangeboardingFlagEntryPoint), $ce599d26c9577203$var$entryPointParams);
    const isEligibleToViewChangeboarding = data && !data.projectHasPublicForm && data.isPublicFormEnabledForSite && data.canAdministerProject && data.projectHasFormNavItem;
    const shouldLoadModal = isModalTriggerActive && isEligibleToViewChangeboarding;
    const shouldRenderFlag = isFlagTriggerActive && isEligibleToViewChangeboarding;
    (0, $5uXOq.useEffect)(()=>{
        // if project already has public forms or has been disabled for the site, then
        // they already are aware of the feature and do not need to be notified
        if (data?.projectHasPublicForm || data?.isPublicFormEnabledForSite === false) {
            (0, $6P8fi.emitModalMessageEvent)({
                action: 'filter'
            });
            (0, $6P8fi.emitFlagMessageEvent)({
                action: 'filter'
            });
        }
    }, [
        data?.projectHasPublicForm,
        data?.isPublicFormEnabledForSite
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!hasLoadedEntrypoint.current) {
            if (shouldRenderFlag) {
                if (!(0, $6s1PB.expVal)('jira_forms_public_access_changeboarding', 'isEnabled', false)) {
                    // if in control cohort, snooze the post office message and check again later
                    // as experiment gradually rolls out
                    (0, $6P8fi.emitFlagMessageEvent)({
                        action: 'snooze'
                    });
                    return;
                }
                flagEntryPointActions.load();
                hasLoadedEntrypoint.current = true;
            }
            if (shouldLoadModal) {
                if (!(0, $6s1PB.expVal)('jira_forms_public_access_changeboarding', 'isEnabled', false)) {
                    (0, $6P8fi.emitModalMessageEvent)({
                        action: 'snooze'
                    });
                    return;
                }
                modalEntryPointActions.load();
                hasLoadedEntrypoint.current = true;
            }
        }
    }, [
        flagEntryPointActions,
        modalEntryPointActions,
        shouldLoadModal,
        shouldRenderFlag
    ]);
    if (!data || !data.project || !shouldLoadModal && !shouldRenderFlag) return null;
    const firstFormIdInProject = data.forms?.[0]?.formId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        entryPointReferenceSubject: modalEntryPointReferenceSubject,
        id: "public-forms-changeboarding-modal",
        packageName: "@atlassian/jira-public-forms-changeboarding-modal",
        teamName: "a4t-tanuki",
        fallback: null,
        errorFallback: "unmount",
        runtimeProps: {
            firstFormIdInProject: firstFormIdInProject,
            project: data.project
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        entryPointReferenceSubject: flagEntryPointReferenceSubject,
        id: "public-forms-changeboarding-flag",
        packageName: "@atlassian/jira-public-forms-changeboarding-modal",
        teamName: "a4t-tanuki",
        fallback: null,
        errorFallback: "unmount",
        runtimeProps: {
            firstFormIdInProject: firstFormIdInProject,
            project: data.project
        }
    }));
};
var $ce599d26c9577203$export$2e2bcd8739ae039 = $ce599d26c9577203$var$PublicFormChangeboardingModalRoot;

});
parcelRegister("e43Es", function(module, exports) {

$parcel$export(module.exports, "useGetData", () => $41a4c09c49cfff36$export$1f47bbb09bba389a);

var $5tTFS = parcelRequire("5tTFS");

var $kV9ss = parcelRequire("kV9ss");

var $koeKL = parcelRequire("koeKL");

var $lHhTR = parcelRequire("lHhTR");
const $41a4c09c49cfff36$var$getProjectHasFormNavItem = (data)=>{
    if (!data.jira?.containerNavigation) return false;
    if (!('navigationItems' in data.jira.containerNavigation)) return false;
    return data.jira.containerNavigation.navigationItems?.edges?.some((node)=>node?.node?.typeKey === 'FORMS') ?? false;
};
const $41a4c09c49cfff36$var$getProjectHasPublicForm = (data)=>{
    return data.jiraBusinessFormsByProjectId?.nodes?.some((node)=>node?.accessLevel === 'public') ?? false;
};
const $41a4c09c49cfff36$export$1f47bbb09bba389a = ({ projectId: projectId, isEnabled: isEnabled })=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const projectAri = (0, $kV9ss.JiraProjectAri).create({
        siteId: cloudId,
        projectId: projectId
    });
    const { data: data } = (0, $5tTFS.useQuery)((0, $lHhTR.GET_DATA_QUERY), {
        variables: {
            projectId: projectId,
            projectAri: projectAri.toString()
        },
        fetchPolicy: 'network-only',
        skip: !isEnabled
    });
    if (!data) return undefined;
    const projectHasFormNavItem = $41a4c09c49cfff36$var$getProjectHasFormNavItem(data);
    const isPublicFormEnabledForSite = data.jiraBusinessFormsByProjectId?.publicFormsEnabled ?? null;
    const canAdministerProject = data.jira?.jiraProject?.administerProject?.canPerform ?? false;
    const projectHasPublicForm = $41a4c09c49cfff36$var$getProjectHasPublicForm(data);
    const firstStoryLevelIssueTypeId = data.jira?.jiraProject?.issueTypes?.edges?.[0]?.node?.issueTypeId ?? null;
    return {
        forms: data.jiraBusinessFormsByProjectId?.nodes,
        project: data.jira?.jiraProject,
        projectHasFormNavItem: projectHasFormNavItem,
        isPublicFormEnabledForSite: isPublicFormEnabledForSite,
        canAdministerProject: canAdministerProject,
        projectHasPublicForm: projectHasPublicForm,
        firstStoryLevelIssueTypeId: firstStoryLevelIssueTypeId
    };
};

});
parcelRegister("lHhTR", function(module, exports) {

$parcel$export(module.exports, "GET_DATA_QUERY", () => $91b4b63945405a40$export$d51f8ada234b77b5);

var $5cllN = parcelRequire("5cllN");
const $91b4b63945405a40$export$d51f8ada234b77b5 = (0, $5cllN.default)`
query getPublicFormChangeboardingData ($projectId: Long!, $projectAri: ID!) {
    jira {
        containerNavigation(
            input: {scopeId: $projectAri}
        ) {
            ... on JiraContainerNavigation {
                id
                navigationItems(first: 100) {
                    edges {
                        node {
                            typeKey
                            id
                        }
                    }
                }
            }
        }

        jiraProject(id: $projectAri) {
            id
            projectId
            key
            name
            projectType
			tmpBoardId
            administerProject: action(type: EDIT_PROJECT_CONFIG) {
              canPerform
            }
            issueTypes(
                first: 1,
                filter: { minHierarchyLevel: 0, maxHierarchyLevel: 0 }
            ) {
                edges {
                    node {
                        id
                        name
                        issueTypeId
                    }
                }
            }
        }
    }

    jiraBusinessFormsByProjectId(projectId: $projectId, first: 50) {
        publicFormsEnabled
        nodes {
            formId
            accessLevel
        }
    }
}
`;

});


parcelRegister("hN7SF", function(module, exports) {

$parcel$export(module.exports, "asyncChangeboardingFlagEntryPoint", () => $b78bb725d4342816$export$b6311e50754a3c1b);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $b78bb725d4342816$export$b6311e50754a3c1b = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("eoxUT")), {
        moduleId: "8f6b3883",
        moduleName: "PublicFormChangeboardingFlag"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("eoxUT", function(module, exports) {

let $a7ad9db866bbc73d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a7ad9db866bbc73d$var$load("3G2OT").then(()=>parcelRequire('f17IT'));

});


parcelRegister("getng", function(module, exports) {

$parcel$export(module.exports, "asyncChangeboardingModalEntryPoint", () => $fe964ab657d9125c$export$6f32a80685928724);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $fe964ab657d9125c$export$6f32a80685928724 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("djZZ9")), {
        moduleId: "2cab4041",
        moduleName: "PublicFormChangeboardingModal"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("djZZ9", function(module, exports) {

let $9b2d21b108df2c1e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9b2d21b108df2c1e$var$load("aeZUn").then(()=>parcelRequire('aHFvH'));

});


parcelRegister("6P8fi", function(module, exports) {

$parcel$export(module.exports, "getFormBuilderUrl", () => $d9991abb643263eb$export$1a0bdbdcca54ab65);
$parcel$export(module.exports, "emitModalMessageEvent", () => $d9991abb643263eb$export$bd83076b2e7fa91a);
$parcel$export(module.exports, "emitFlagMessageEvent", () => $d9991abb643263eb$export$e40f3f03094e29dc);

const $d9991abb643263eb$var$SOFTWARE_TMP_PREFIX = '/jira/software';
const $d9991abb643263eb$var$SOFTWARE_CMP_PREFIX = '/jira/software/c';
const $d9991abb643263eb$var$BUSINESS_PREFIX = '/jira/core';
const $d9991abb643263eb$export$36e24695f02d4503 = (project)=>{
    if (project.projectType === 'SOFTWARE') {
        if (project.tmpBoardId !== null) return $d9991abb643263eb$var$SOFTWARE_TMP_PREFIX;
        return $d9991abb643263eb$var$SOFTWARE_CMP_PREFIX;
    }
    return $d9991abb643263eb$var$BUSINESS_PREFIX;
};
const $d9991abb643263eb$export$1a0bdbdcca54ab65 = ({ project: project, formId: formId })=>{
    return `${$d9991abb643263eb$export$36e24695f02d4503(project)}/projects/${project.key}/form/${formId}/builder`;
};
const $d9991abb643263eb$export$bd83076b2e7fa91a = (eventDetails)=>{
    const event = new CustomEvent((0, $1a3ee76b747d2e0b$export$ca851eafcdc960ee), {
        detail: eventDetails
    });
    if (typeof document !== 'undefined') document.dispatchEvent(event);
};
const $d9991abb643263eb$export$e40f3f03094e29dc = (eventDetails)=>{
    const event = new CustomEvent((0, $1a3ee76b747d2e0b$export$a963aea3558fe23a), {
        detail: eventDetails
    });
    if (typeof document !== 'undefined') document.dispatchEvent(event);
};

});
const $1a3ee76b747d2e0b$export$ca3d56c0d6d21363 = 'jira_business_public-forms-changeboarding';
const $1a3ee76b747d2e0b$export$3b45ec1a607f2838 = 'SHOULD_SHOW_FORM_BUILDER_SPOTLIGHTING';
const $1a3ee76b747d2e0b$export$64e47a95ce32c8b2 = 'PUBLIC_FORM_CHANGEBOARDING_SPOTLIGHTS_FORM_ACCESS_STEP';
const $1a3ee76b747d2e0b$export$51318ec2f5085d87 = 'PUBLIC_FORM_CHANGEBOARDING_SPOTLIGHTS_FORM_FIELD_STEP';
const $1a3ee76b747d2e0b$export$ca851eafcdc960ee = 'jira-forms-public-forms-changeboarding-event';
const $1a3ee76b747d2e0b$export$245c2608a15570d3 = 'jira-forms-public-forms-changeboarding-trigger-id';
const $1a3ee76b747d2e0b$export$a963aea3558fe23a = 'jira-forms-public-forms-changeboarding-flag-event';
const $1a3ee76b747d2e0b$export$6c605e0a476d3e4b = 'jira-forms-public-forms-changeboarding-flag-trigger-id';



parcelRegister("6l4ko", function(module, exports) {

$parcel$export(module.exports, "useCollabStore", () => $b8a7111dc9f99b0c$export$4159ae80cfa2156);
$parcel$export(module.exports, "useCollabStoreActions", () => $b8a7111dc9f99b0c$export$534626027136f733);
$parcel$export(module.exports, "useNodeSelections", () => $b8a7111dc9f99b0c$export$28a23d5e701a52d9);

var $3JOCw = parcelRequire("3JOCw");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $lVnZu = parcelRequire("lVnZu");

const $b8a7111dc9f99b0c$var$updateUserInParticipants = (user)=>({ getState: getState, setState: setState })=>{
        const state = getState();
        setState({
            ...state,
            participants: state.participants.map((participant)=>{
                if (participant.clientId === user.userId) return {
                    ...participant,
                    avatar: user.avatar,
                    name: user.name,
                    email: user.email
                };
                return participant;
            })
        });
    };
const $b8a7111dc9f99b0c$var$participantsJoined = (joined)=>({ getState: getState, setState: setState })=>{
        const uniqueJoined = (0, (/*@__PURE__*/$parcel$interopDefault($3JOCw)))(joined, ({ sessionId: sessionId })=>sessionId);
        const newParticipantSessionIds = uniqueJoined.map(({ sessionId: sessionId })=>sessionId);
        const state = getState();
        const { provider: provider } = state;
        const newParticipants = [
            ...state.participants.filter(({ sessionId: sessionId })=>!newParticipantSessionIds.includes(sessionId)),
            ...uniqueJoined
        ];
        // Collab team advised we should limit the number of max connections to control the load on collab service
        if (newParticipants.length >= (0, $8c1bce549db6af3b$export$3debf01bbfa135e5) && provider) {
            // sort users by last active (last joined)
            const sortedUsers = newParticipants.sort((userA, userB)=>userA.lastActive > userB.lastActive ? 1 : -1);
            const currentUser = sortedUsers.find((user)=>user.sessionId === provider.sessionId);
            const lastActiveUser = sortedUsers[sortedUsers.length - 1];
            // kick the last joined user out
            setState({
                ...state,
                participants: newParticipants.filter(({ sessionId: sessionId })=>sessionId !== lastActiveUser.sessionId)
            });
            if (lastActiveUser.sessionId === currentUser?.sessionId) provider.destroy();
            return;
        }
        setState({
            ...state,
            participants: newParticipants
        });
    };
const $b8a7111dc9f99b0c$var$participantsLeft = (left)=>({ getState: getState, setState: setState })=>{
        const leftSessionIds = left.map(({ sessionId: sessionId })=>sessionId);
        const state = getState();
        // cleanup user selection when they leave the session
        const newSelection = {};
        Object.keys(state.nodeSelection).forEach((nodeIdKey)=>{
            const selections = state.nodeSelection[nodeIdKey];
            if (selections.length > 0) {
                const filteredSelections = selections.filter((selection)=>!leftSessionIds.includes(selection.sessionId));
                if (filteredSelections.length === 0) return;
                newSelection[nodeIdKey] = filteredSelections;
            }
        });
        setState({
            ...state,
            participants: state.participants.filter(({ sessionId: sessionId })=>!leftSessionIds.includes(sessionId)),
            nodeSelection: newSelection
        });
    };
const $b8a7111dc9f99b0c$var$setProvider = (provider)=>({ getState: getState, setState: setState })=>setState({
            ...getState(),
            provider: provider
        });
const $b8a7111dc9f99b0c$var$sendNodeSelected = ({ nodeId: nodeId })=>({ getState: getState })=>{
        if (nodeId == null) return;
        const { provider: provider, participants: participants } = getState();
        if (participants.length <= 1) return;
        if (provider) provider.sendMessage({
            type: 'telepointer',
            sessionId: provider.sessionId,
            selection: {
                type: 'nodeSelection',
                anchor: JSON.stringify({
                    nodeId: nodeId
                })
            }
        });
    };
const $b8a7111dc9f99b0c$var$sendClearNodeSelection = ({ nodeId: nodeId, dropParams: dropParams })=>({ getState: getState })=>{
        if (nodeId == null) return;
        const { provider: provider, participants: participants } = getState();
        if (participants.length <= 1) return;
        if (provider) provider.sendMessage({
            type: 'telepointer',
            sessionId: provider.sessionId,
            selection: {
                type: 'nodeSelection',
                head: JSON.stringify({
                    nodeId: nodeId,
                    dropParams: dropParams
                })
            }
        });
    };
const $b8a7111dc9f99b0c$var$setNodeSelection = ({ nodeId: nodeId, sessionId: sessionId, user: user })=>({ setState: setState, getState: getState })=>{
        const { color: color } = (0, $lVnZu.getColorFromString)(sessionId);
        const newSelection = {
            nodeId: nodeId,
            user: user,
            color: color,
            sessionId: sessionId
        };
        const state = getState();
        const dedupCurrentSelection = state.nodeSelection[nodeId] && state.nodeSelection[nodeId].filter((selection)=>selection.user.userId !== user.userId);
        const nodeSelection = dedupCurrentSelection ? [
            ...dedupCurrentSelection,
            newSelection
        ] : [
            newSelection
        ];
        // deduplicate selected nodes from this user, because each user can have only one selected node on the page
        // see JET-2794
        const dedupOtherSelections = {};
        Object.keys(state.nodeSelection).forEach((nodeIdKey)=>{
            // keep selections from all other users
            const selections = state.nodeSelection[nodeIdKey];
            if (selections.length > 0) {
                const filteredSelections = selections.filter((selection)=>selection.user.userId !== user.userId);
                if (filteredSelections.length === 0) return;
                dedupOtherSelections[nodeIdKey] = filteredSelections;
            }
        });
        setState({
            ...state,
            nodeSelection: {
                ...dedupOtherSelections,
                [nodeId]: nodeSelection
            }
        });
    };
const $b8a7111dc9f99b0c$var$clearNodeSelection = ({ nodeId: nodeId })=>({ setState: setState, getState: getState })=>{
        const state = getState();
        const newNodeSelection = {};
        Object.keys(state.nodeSelection).forEach((nodeIdKey)=>{
            if (nodeIdKey !== nodeId) newNodeSelection[nodeIdKey] = state.nodeSelection[nodeIdKey];
        });
        setState({
            ...state,
            nodeSelection: newNodeSelection
        });
    };
const $b8a7111dc9f99b0c$var$actions = {
    setProvider: $b8a7111dc9f99b0c$var$setProvider,
    participantsLeft: $b8a7111dc9f99b0c$var$participantsLeft,
    participantsJoined: $b8a7111dc9f99b0c$var$participantsJoined,
    updateUserInParticipants: $b8a7111dc9f99b0c$var$updateUserInParticipants,
    sendNodeSelected: $b8a7111dc9f99b0c$var$sendNodeSelected,
    sendClearNodeSelection: $b8a7111dc9f99b0c$var$sendClearNodeSelection,
    setNodeSelection: $b8a7111dc9f99b0c$var$setNodeSelection,
    clearNodeSelection: $b8a7111dc9f99b0c$var$clearNodeSelection
};
const $b8a7111dc9f99b0c$var$Store = (0, $iXqE5.createStore)({
    initialState: {
        provider: null,
        participants: [],
        nodeSelection: {}
    },
    actions: $b8a7111dc9f99b0c$var$actions,
    name: 'JWMCollabStore'
});
const $b8a7111dc9f99b0c$export$4159ae80cfa2156 = (0, $3sQ5x.createHook)($b8a7111dc9f99b0c$var$Store);
const $b8a7111dc9f99b0c$export$534626027136f733 = (0, $3sQ5x.createActionsHook)($b8a7111dc9f99b0c$var$Store);
const $b8a7111dc9f99b0c$export$28a23d5e701a52d9 = (0, $3sQ5x.createStateHook)($b8a7111dc9f99b0c$var$Store, {
    selector: (state, props)=>{
        const selections = state.nodeSelection[props.nodeId];
        return Array.isArray(selections) && selections.length ? selections : undefined;
    }
});

});
parcelRegister("lVnZu", function(module, exports) {

$parcel$export(module.exports, "getColorFromString", () => $cb176b2a2314f98e$export$137ec5185b12f5a2);

const $cb176b2a2314f98e$var$colors = [
    (0, $829f609a65d26a98$exports).R300,
    (0, $829f609a65d26a98$exports).R400,
    (0, $829f609a65d26a98$exports).R500,
    (0, $829f609a65d26a98$exports).Y300,
    (0, $829f609a65d26a98$exports).Y400,
    (0, $829f609a65d26a98$exports).Y500,
    (0, $829f609a65d26a98$exports).G300,
    (0, $829f609a65d26a98$exports).G400,
    (0, $829f609a65d26a98$exports).G500,
    (0, $829f609a65d26a98$exports).T300,
    (0, $829f609a65d26a98$exports).T400,
    (0, $829f609a65d26a98$exports).T500,
    (0, $829f609a65d26a98$exports).P300,
    (0, $829f609a65d26a98$exports).P400,
    (0, $829f609a65d26a98$exports).P500,
    (0, $829f609a65d26a98$exports).N200,
    (0, $829f609a65d26a98$exports).N500,
    (0, $829f609a65d26a98$exports).N800
];
const $cb176b2a2314f98e$export$137ec5185b12f5a2 = (str)=>{
    let hash = 0;
    for(let i = 0; i < str.length; i += 1){
        /* eslint-disable no-bitwise */ hash = (hash << 5) - hash + str.charCodeAt(i);
        hash &= hash;
    /* eslint-enable no-bitwise */ }
    const index = Math.abs(hash) % $cb176b2a2314f98e$var$colors.length;
    const hexColor = $cb176b2a2314f98e$var$colors[index];
    return {
        index: index,
        color: hexColor
    };
};

});
var $829f609a65d26a98$exports = {};

$parcel$export($829f609a65d26a98$exports, "R50", () => $829f609a65d26a98$export$4b84fd0e2c617bd);
$parcel$export($829f609a65d26a98$exports, "R75", () => $829f609a65d26a98$export$b34b069eff244586);
$parcel$export($829f609a65d26a98$exports, "R100", () => $829f609a65d26a98$export$be802dd0d8b57f35);
$parcel$export($829f609a65d26a98$exports, "R200", () => $829f609a65d26a98$export$60847d42f9da92a6);
$parcel$export($829f609a65d26a98$exports, "R300", () => $829f609a65d26a98$export$4a7404f376229999);
$parcel$export($829f609a65d26a98$exports, "R400", () => $829f609a65d26a98$export$2010d0fb4295b346);
$parcel$export($829f609a65d26a98$exports, "R500", () => $829f609a65d26a98$export$2837b5a1a71d5c02);
$parcel$export($829f609a65d26a98$exports, "Y50", () => $829f609a65d26a98$export$8d9596b529bbb9cf);
$parcel$export($829f609a65d26a98$exports, "Y75", () => $829f609a65d26a98$export$41060a744ab0b7ae);
$parcel$export($829f609a65d26a98$exports, "Y100", () => $829f609a65d26a98$export$1cc05bbbf340e559);
$parcel$export($829f609a65d26a98$exports, "Y200", () => $829f609a65d26a98$export$5aae31392d72caaa);
$parcel$export($829f609a65d26a98$exports, "Y300", () => $829f609a65d26a98$export$c6930421db9fa514);
$parcel$export($829f609a65d26a98$exports, "Y400", () => $829f609a65d26a98$export$59619663aa6500fb);
$parcel$export($829f609a65d26a98$exports, "Y500", () => $829f609a65d26a98$export$874739ea9e379ab6);
$parcel$export($829f609a65d26a98$exports, "G50", () => $829f609a65d26a98$export$8a6341c32b6a3ee6);
$parcel$export($829f609a65d26a98$exports, "G75", () => $829f609a65d26a98$export$69a3bf21b9686c2b);
$parcel$export($829f609a65d26a98$exports, "G100", () => $829f609a65d26a98$export$afbce1382ec95f73);
$parcel$export($829f609a65d26a98$exports, "G200", () => $829f609a65d26a98$export$747d86715d4175de);
$parcel$export($829f609a65d26a98$exports, "G300", () => $829f609a65d26a98$export$940e1f69e873f202);
$parcel$export($829f609a65d26a98$exports, "G400", () => $829f609a65d26a98$export$a49394138f7b8e85);
$parcel$export($829f609a65d26a98$exports, "G500", () => $829f609a65d26a98$export$6fa04827ac68a4fb);
$parcel$export($829f609a65d26a98$exports, "B50", () => $829f609a65d26a98$export$226de0355ed012f8);
$parcel$export($829f609a65d26a98$exports, "B75", () => $829f609a65d26a98$export$8c13c2ee36917869);
$parcel$export($829f609a65d26a98$exports, "B100", () => $829f609a65d26a98$export$ecfc1dff386a3e7a);
$parcel$export($829f609a65d26a98$exports, "B200", () => $829f609a65d26a98$export$215b7063051591f1);
$parcel$export($829f609a65d26a98$exports, "B300", () => $829f609a65d26a98$export$e62e8919cca44969);
$parcel$export($829f609a65d26a98$exports, "B400", () => $829f609a65d26a98$export$b3de0ae08da2ce64);
$parcel$export($829f609a65d26a98$exports, "B500", () => $829f609a65d26a98$export$a6ee3d71bc067634);
$parcel$export($829f609a65d26a98$exports, "B600", () => $829f609a65d26a98$export$67f15409e87642a1);
$parcel$export($829f609a65d26a98$exports, "B700", () => $829f609a65d26a98$export$f0539dbc42dbb067);
$parcel$export($829f609a65d26a98$exports, "P50", () => $829f609a65d26a98$export$363e4475840015bb);
$parcel$export($829f609a65d26a98$exports, "P75", () => $829f609a65d26a98$export$4b0a4417ed59760f);
$parcel$export($829f609a65d26a98$exports, "P100", () => $829f609a65d26a98$export$6011520a64d9a187);
$parcel$export($829f609a65d26a98$exports, "P200", () => $829f609a65d26a98$export$a7175d4e9206bc80);
$parcel$export($829f609a65d26a98$exports, "P300", () => $829f609a65d26a98$export$b48405b95304b5a1);
$parcel$export($829f609a65d26a98$exports, "P400", () => $829f609a65d26a98$export$c71e4279dd54a18d);
$parcel$export($829f609a65d26a98$exports, "P500", () => $829f609a65d26a98$export$147899de772240ec);
$parcel$export($829f609a65d26a98$exports, "T50", () => $829f609a65d26a98$export$2cf711fe14c66f06);
$parcel$export($829f609a65d26a98$exports, "T75", () => $829f609a65d26a98$export$7a8f4d33f6f9772c);
$parcel$export($829f609a65d26a98$exports, "T100", () => $829f609a65d26a98$export$776c9c497ef08533);
$parcel$export($829f609a65d26a98$exports, "T200", () => $829f609a65d26a98$export$69cb3ca10c1e330e);
$parcel$export($829f609a65d26a98$exports, "T300", () => $829f609a65d26a98$export$9dc1ef0f3f48059b);
$parcel$export($829f609a65d26a98$exports, "T400", () => $829f609a65d26a98$export$7c835c78b6fcdef8);
$parcel$export($829f609a65d26a98$exports, "T500", () => $829f609a65d26a98$export$6036577f95c3877e);
$parcel$export($829f609a65d26a98$exports, "N0", () => $829f609a65d26a98$export$29a4f05edc054374);
$parcel$export($829f609a65d26a98$exports, "N10", () => $829f609a65d26a98$export$e655ef011c4aa1a2);
$parcel$export($829f609a65d26a98$exports, "N20", () => $829f609a65d26a98$export$9fdfb749e33cdf97);
$parcel$export($829f609a65d26a98$exports, "N30", () => $829f609a65d26a98$export$3e51e8f1440314ba);
$parcel$export($829f609a65d26a98$exports, "N40", () => $829f609a65d26a98$export$1ce2d1575d444ceb);
$parcel$export($829f609a65d26a98$exports, "N50", () => $829f609a65d26a98$export$8754fc7e6d8b3000);
$parcel$export($829f609a65d26a98$exports, "N60", () => $829f609a65d26a98$export$c2e91cbeada39b8b);
$parcel$export($829f609a65d26a98$exports, "N70", () => $829f609a65d26a98$export$5f71e19f3a7ad9de);
$parcel$export($829f609a65d26a98$exports, "N80", () => $829f609a65d26a98$export$eaa8c8a70ac22806);
$parcel$export($829f609a65d26a98$exports, "N90", () => $829f609a65d26a98$export$7c87d337fb91a97d);
$parcel$export($829f609a65d26a98$exports, "N100", () => $829f609a65d26a98$export$d6447c357493214f);
$parcel$export($829f609a65d26a98$exports, "N200", () => $829f609a65d26a98$export$f563ee71e9ee74cd);
$parcel$export($829f609a65d26a98$exports, "N300", () => $829f609a65d26a98$export$e2ef2124cf4024b1);
$parcel$export($829f609a65d26a98$exports, "N400", () => $829f609a65d26a98$export$eece5f492e429f08);
$parcel$export($829f609a65d26a98$exports, "N500", () => $829f609a65d26a98$export$c39c0fe0f26207ae);
$parcel$export($829f609a65d26a98$exports, "N600", () => $829f609a65d26a98$export$7090862dc3038a9f);
$parcel$export($829f609a65d26a98$exports, "N700", () => $829f609a65d26a98$export$ad0bacf983b7ddaa);
$parcel$export($829f609a65d26a98$exports, "N800", () => $829f609a65d26a98$export$7d61b15e0da132af);
$parcel$export($829f609a65d26a98$exports, "N900", () => $829f609a65d26a98$export$fbda843f0a27fe96);
$parcel$export($829f609a65d26a98$exports, "N10A", () => $829f609a65d26a98$export$791e57b27ca738ef);
$parcel$export($829f609a65d26a98$exports, "N20A", () => $829f609a65d26a98$export$8d43898f60b96a82);
$parcel$export($829f609a65d26a98$exports, "N30A", () => $829f609a65d26a98$export$920c0d5c49070351);
$parcel$export($829f609a65d26a98$exports, "N40A", () => $829f609a65d26a98$export$46987b49aab6d1a8);
$parcel$export($829f609a65d26a98$exports, "N50A", () => $829f609a65d26a98$export$7d3359664e8bb0e5);
$parcel$export($829f609a65d26a98$exports, "N60A", () => $829f609a65d26a98$export$d2d3bedfb276cac0);
$parcel$export($829f609a65d26a98$exports, "N70A", () => $829f609a65d26a98$export$6e5e7499ff054f6d);
$parcel$export($829f609a65d26a98$exports, "N80A", () => $829f609a65d26a98$export$59264b346c877fa7);
$parcel$export($829f609a65d26a98$exports, "N90A", () => $829f609a65d26a98$export$d092757d7c64925c);
$parcel$export($829f609a65d26a98$exports, "N100A", () => $829f609a65d26a98$export$486ab785e4bac3c6);
$parcel$export($829f609a65d26a98$exports, "N200A", () => $829f609a65d26a98$export$fba592bbc6419fea);
$parcel$export($829f609a65d26a98$exports, "N300A", () => $829f609a65d26a98$export$13609db0e6812ab8);
$parcel$export($829f609a65d26a98$exports, "N400A", () => $829f609a65d26a98$export$fbae4efaa892d883);
$parcel$export($829f609a65d26a98$exports, "N500A", () => $829f609a65d26a98$export$f13946d26f440ce6);
$parcel$export($829f609a65d26a98$exports, "N600A", () => $829f609a65d26a98$export$19f58225ac52a306);
$parcel$export($829f609a65d26a98$exports, "N700A", () => $829f609a65d26a98$export$6384f09da70e7b62);
$parcel$export($829f609a65d26a98$exports, "N800A", () => $829f609a65d26a98$export$d0dccc730683edc2);
$parcel$export($829f609a65d26a98$exports, "DN900", () => $829f609a65d26a98$export$2f6319cf7d736c2a);
$parcel$export($829f609a65d26a98$exports, "DN800", () => $829f609a65d26a98$export$95126bc8884d6634);
$parcel$export($829f609a65d26a98$exports, "DN700", () => $829f609a65d26a98$export$8338d8c35d44ff1);
$parcel$export($829f609a65d26a98$exports, "DN600", () => $829f609a65d26a98$export$5368d76ae4fbbda7);
$parcel$export($829f609a65d26a98$exports, "DN500", () => $829f609a65d26a98$export$9f0a771d16ec8d36);
$parcel$export($829f609a65d26a98$exports, "DN400", () => $829f609a65d26a98$export$abcf8c38338b4aa5);
$parcel$export($829f609a65d26a98$exports, "DN300", () => $829f609a65d26a98$export$97e81faa16a182c7);
$parcel$export($829f609a65d26a98$exports, "DN200", () => $829f609a65d26a98$export$bfe21c59123ecf33);
$parcel$export($829f609a65d26a98$exports, "DN100", () => $829f609a65d26a98$export$ee82aa2ea6a1558);
$parcel$export($829f609a65d26a98$exports, "DN90", () => $829f609a65d26a98$export$682927c6ed76be02);
$parcel$export($829f609a65d26a98$exports, "DN80", () => $829f609a65d26a98$export$91fd9994c5be9757);
$parcel$export($829f609a65d26a98$exports, "DN70", () => $829f609a65d26a98$export$d281fbfe3cff2df6);
$parcel$export($829f609a65d26a98$exports, "DN60", () => $829f609a65d26a98$export$3902c91d8b98a753);
$parcel$export($829f609a65d26a98$exports, "DN50", () => $829f609a65d26a98$export$8e8133c1ba5845b5);
$parcel$export($829f609a65d26a98$exports, "DN40", () => $829f609a65d26a98$export$33ff357f6620b39);
$parcel$export($829f609a65d26a98$exports, "DN30", () => $829f609a65d26a98$export$633847cf062b69e0);
$parcel$export($829f609a65d26a98$exports, "DN20", () => $829f609a65d26a98$export$9776a6e503bdbf76);
$parcel$export($829f609a65d26a98$exports, "DN10", () => $829f609a65d26a98$export$6c813d5160dff5db);
$parcel$export($829f609a65d26a98$exports, "DN0", () => $829f609a65d26a98$export$3d4f271a500072a);
$parcel$export($829f609a65d26a98$exports, "DN800A", () => $829f609a65d26a98$export$fe151285c22759ec);
$parcel$export($829f609a65d26a98$exports, "DN700A", () => $829f609a65d26a98$export$a101c6190d0da34);
$parcel$export($829f609a65d26a98$exports, "DN600A", () => $829f609a65d26a98$export$4b16f52932fda51);
$parcel$export($829f609a65d26a98$exports, "DN500A", () => $829f609a65d26a98$export$a74bcd7b9845b0d8);
$parcel$export($829f609a65d26a98$exports, "DN400A", () => $829f609a65d26a98$export$9209c179316d1751);
$parcel$export($829f609a65d26a98$exports, "DN300A", () => $829f609a65d26a98$export$88f55133f636c8dd);
$parcel$export($829f609a65d26a98$exports, "DN200A", () => $829f609a65d26a98$export$51126f85d1009512);
$parcel$export($829f609a65d26a98$exports, "DN100A", () => $829f609a65d26a98$export$a069b547bd23af78);
$parcel$export($829f609a65d26a98$exports, "DN90A", () => $829f609a65d26a98$export$40cce05af3b2600a);
$parcel$export($829f609a65d26a98$exports, "DN80A", () => $829f609a65d26a98$export$b78942185925a0d);
$parcel$export($829f609a65d26a98$exports, "DN70A", () => $829f609a65d26a98$export$e058fb44b8eaafca);
$parcel$export($829f609a65d26a98$exports, "DN60A", () => $829f609a65d26a98$export$92b0b8de26920c18);
$parcel$export($829f609a65d26a98$exports, "DN50A", () => $829f609a65d26a98$export$67564f7459d3fc9e);
$parcel$export($829f609a65d26a98$exports, "DN40A", () => $829f609a65d26a98$export$77868e1ca884ffa3);
$parcel$export($829f609a65d26a98$exports, "DN30A", () => $829f609a65d26a98$export$2afd71d7d3ea2cd5);
$parcel$export($829f609a65d26a98$exports, "DN20A", () => $829f609a65d26a98$export$f2a0acaab9972c70);
$parcel$export($829f609a65d26a98$exports, "DN10A", () => $829f609a65d26a98$export$9ab70e67d6475361);
$parcel$export($829f609a65d26a98$exports, "T30", () => $829f609a65d26a98$export$d2adc5dedf09fced);
$parcel$export($829f609a65d26a98$exports, "L50", () => $829f609a65d26a98$export$f51762073d2bb381);
$parcel$export($829f609a65d26a98$exports, "L75", () => $829f609a65d26a98$export$95e26d54def96891);
// Reds
const $829f609a65d26a98$export$4b84fd0e2c617bd = '#FFEBE6';
const $829f609a65d26a98$export$b34b069eff244586 = '#FFBDAD';
const $829f609a65d26a98$export$be802dd0d8b57f35 = '#FF8F73';
const $829f609a65d26a98$export$60847d42f9da92a6 = '#FF7452';
const $829f609a65d26a98$export$4a7404f376229999 = '#FF5630';
const $829f609a65d26a98$export$2010d0fb4295b346 = '#DE350B';
const $829f609a65d26a98$export$2837b5a1a71d5c02 = '#BF2600';
const $829f609a65d26a98$export$8d9596b529bbb9cf = '#FFFAE6';
const $829f609a65d26a98$export$41060a744ab0b7ae = '#FFF0B3';
const $829f609a65d26a98$export$1cc05bbbf340e559 = '#FFE380';
const $829f609a65d26a98$export$5aae31392d72caaa = '#FFC400';
const $829f609a65d26a98$export$c6930421db9fa514 = '#FFAB00';
const $829f609a65d26a98$export$59619663aa6500fb = '#FF991F';
const $829f609a65d26a98$export$874739ea9e379ab6 = '#FF8B00';
const $829f609a65d26a98$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $829f609a65d26a98$export$69a3bf21b9686c2b = '#ABF5D1';
const $829f609a65d26a98$export$afbce1382ec95f73 = '#79F2C0';
const $829f609a65d26a98$export$747d86715d4175de = '#57D9A3';
const $829f609a65d26a98$export$940e1f69e873f202 = '#36B37E';
const $829f609a65d26a98$export$a49394138f7b8e85 = '#00875A';
const $829f609a65d26a98$export$6fa04827ac68a4fb = '#006644';
const $829f609a65d26a98$export$226de0355ed012f8 = '#DEEBFF';
const $829f609a65d26a98$export$8c13c2ee36917869 = '#B3D4FF';
const $829f609a65d26a98$export$ecfc1dff386a3e7a = '#4C9AFF';
const $829f609a65d26a98$export$215b7063051591f1 = '#2684FF';
const $829f609a65d26a98$export$e62e8919cca44969 = '#0065FF';
const $829f609a65d26a98$export$b3de0ae08da2ce64 = '#0052CC';
const $829f609a65d26a98$export$a6ee3d71bc067634 = '#0747A6';
const $829f609a65d26a98$export$67f15409e87642a1 = '#669DF1';
const $829f609a65d26a98$export$f0539dbc42dbb067 = '#8FB8F6';
const $829f609a65d26a98$export$363e4475840015bb = '#EAE6FF';
const $829f609a65d26a98$export$4b0a4417ed59760f = '#C0B6F2';
const $829f609a65d26a98$export$6011520a64d9a187 = '#998DD9';
const $829f609a65d26a98$export$a7175d4e9206bc80 = '#8777D9';
const $829f609a65d26a98$export$b48405b95304b5a1 = '#6554C0';
const $829f609a65d26a98$export$c71e4279dd54a18d = '#5243AA';
const $829f609a65d26a98$export$147899de772240ec = '#403294';
const $829f609a65d26a98$export$2cf711fe14c66f06 = '#E6FCFF';
const $829f609a65d26a98$export$7a8f4d33f6f9772c = '#B3F5FF';
const $829f609a65d26a98$export$776c9c497ef08533 = '#79E2F2';
const $829f609a65d26a98$export$69cb3ca10c1e330e = '#00C7E6';
const $829f609a65d26a98$export$9dc1ef0f3f48059b = '#00B8D9';
const $829f609a65d26a98$export$7c835c78b6fcdef8 = '#00A3BF';
const $829f609a65d26a98$export$6036577f95c3877e = '#008DA6';
const $829f609a65d26a98$export$29a4f05edc054374 = '#FFFFFF';
const $829f609a65d26a98$export$e655ef011c4aa1a2 = '#FAFBFC';
const $829f609a65d26a98$export$9fdfb749e33cdf97 = '#F4F5F7';
const $829f609a65d26a98$export$3e51e8f1440314ba = '#EBECF0';
const $829f609a65d26a98$export$1ce2d1575d444ceb = '#DFE1E6';
const $829f609a65d26a98$export$8754fc7e6d8b3000 = '#C1C7D0';
const $829f609a65d26a98$export$c2e91cbeada39b8b = '#B3BAC5';
const $829f609a65d26a98$export$5f71e19f3a7ad9de = '#A5ADBA';
const $829f609a65d26a98$export$eaa8c8a70ac22806 = '#97A0AF';
const $829f609a65d26a98$export$7c87d337fb91a97d = '#8993A4';
const $829f609a65d26a98$export$d6447c357493214f = '#7A869A';
const $829f609a65d26a98$export$f563ee71e9ee74cd = '#6B778C';
const $829f609a65d26a98$export$e2ef2124cf4024b1 = '#5E6C84';
const $829f609a65d26a98$export$eece5f492e429f08 = '#505F79';
const $829f609a65d26a98$export$c39c0fe0f26207ae = '#42526E';
const $829f609a65d26a98$export$7090862dc3038a9f = '#344563';
const $829f609a65d26a98$export$ad0bacf983b7ddaa = '#253858';
const $829f609a65d26a98$export$7d61b15e0da132af = '#172B4D';
const $829f609a65d26a98$export$fbda843f0a27fe96 = '#091E42';
const $829f609a65d26a98$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $829f609a65d26a98$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $829f609a65d26a98$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $829f609a65d26a98$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $829f609a65d26a98$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $829f609a65d26a98$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $829f609a65d26a98$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $829f609a65d26a98$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $829f609a65d26a98$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $829f609a65d26a98$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $829f609a65d26a98$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $829f609a65d26a98$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $829f609a65d26a98$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $829f609a65d26a98$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $829f609a65d26a98$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $829f609a65d26a98$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $829f609a65d26a98$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $829f609a65d26a98$export$2f6319cf7d736c2a = '#E6EDFA';
const $829f609a65d26a98$export$95126bc8884d6634 = '#DCE5F5';
const $829f609a65d26a98$export$8338d8c35d44ff1 = '#CED9EB';
const $829f609a65d26a98$export$5368d76ae4fbbda7 = '#B8C7E0';
const $829f609a65d26a98$export$9f0a771d16ec8d36 = '#ABBBD6';
const $829f609a65d26a98$export$abcf8c38338b4aa5 = '#9FB0CC';
const $829f609a65d26a98$export$97e81faa16a182c7 = '#8C9CB8';
const $829f609a65d26a98$export$bfe21c59123ecf33 = '#7988A3';
const $829f609a65d26a98$export$ee82aa2ea6a1558 = '#67758F';
const $829f609a65d26a98$export$682927c6ed76be02 = '#56637A';
const $829f609a65d26a98$export$91fd9994c5be9757 = '#455166';
const $829f609a65d26a98$export$d281fbfe3cff2df6 = '#3B475C';
const $829f609a65d26a98$export$3902c91d8b98a753 = '#313D52';
const $829f609a65d26a98$export$8e8133c1ba5845b5 = '#283447';
const $829f609a65d26a98$export$33ff357f6620b39 = '#202B3D';
const $829f609a65d26a98$export$633847cf062b69e0 = '#1B2638';
const $829f609a65d26a98$export$9776a6e503bdbf76 = '#121A29';
const $829f609a65d26a98$export$6c813d5160dff5db = '#0E1624';
const $829f609a65d26a98$export$3d4f271a500072a = '#0D1424';
const $829f609a65d26a98$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $829f609a65d26a98$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $829f609a65d26a98$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $829f609a65d26a98$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $829f609a65d26a98$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $829f609a65d26a98$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $829f609a65d26a98$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $829f609a65d26a98$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $829f609a65d26a98$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $829f609a65d26a98$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $829f609a65d26a98$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $829f609a65d26a98$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $829f609a65d26a98$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $829f609a65d26a98$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $829f609a65d26a98$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $829f609a65d26a98$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $829f609a65d26a98$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $829f609a65d26a98$export$d2adc5dedf09fced = '#292A2E';
const $829f609a65d26a98$export$f51762073d2bb381 = '#94C748';
const $829f609a65d26a98$export$95e26d54def96891 = '#B3DF72';


const $8c1bce549db6af3b$export$3debf01bbfa135e5 = 80;


parcelRegister("he7sk", function(module, exports) {

$parcel$export(module.exports, "ThemedFilterEmptyState", () => $cd3da1c859fecc93$export$e911425bb76dd69e);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $6cG4N = parcelRequire("6cG4N");

var $47SnX = parcelRequire("47SnX");

var $koVbs = parcelRequire("koVbs");

var $22OQR = parcelRequire("22OQR");

var $lODMY = parcelRequire("lODMY");

var $4R6GH = parcelRequire("4R6GH");

var $l4Ejo = parcelRequire("l4Ejo");

var $7htvz = parcelRequire("7htvz");

var $23WHC = parcelRequire("23WHC");
const $cd3da1c859fecc93$export$e911425bb76dd69e = ({ reason: reason, clearError: clearError, handleOnClearOverride: handleOnClearOverride })=>{
    const { updateQueryParam: updateQueryParam } = (0, $lODMY.useRouterStoreActions)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { saveJql: saveJql } = (0, $l4Ejo.useFiltersPreference)();
    const handleOnClear = (0, $5uXOq.useCallback)(()=>{
        if (handleOnClearOverride && (0, $4R6GH.fg)('update-filter-empty-state')) {
            handleOnClearOverride();
            return;
        }
        saveJql(undefined);
        updateQueryParam({
            [(0, $7htvz.SIMPLE_SEARCH_PARAM)]: undefined
        }, 'replace');
        (0, $4R6GH.fg)('timeline-add-jql-error-boundary') && clearError?.();
    }, [
        saveJql,
        updateQueryParam,
        clearError,
        handleOnClearOverride
    ]);
    const message = reason === 'INVALID_JQL' ? formatMessage((0, $23WHC.default).invalidStateHeading) : formatMessage((0, $23WHC.default).emptyStateHeading);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $cd3da1c859fecc93$var$wrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cd3da1c859fecc93$var$Illustration, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($47SnX))),
        alt: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cd3da1c859fecc93$var$HeadingWrapper, null, message), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $22OQR.ThemedButton), {
        appearance: "primary",
        onClick: handleOnClear
    }, formatMessage((0, $23WHC.default).clearFiltersButton)));
};
const $cd3da1c859fecc93$var$wrapperStyles = (0, $8CUq3.xcss)({
    textAlign: 'center',
    margin: 'auto',
    width: '450px',
    padding: 'space.300',
    borderRadius: 'border.radius.200',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    background: (0, $6cG4N.Tokens).ELEVATION_SURFACE_CONTRAST_BOLDER
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cd3da1c859fecc93$var$HeadingWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "h3", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syazfrbu _otyr1ejb",
            __cmplp.className
        ])
    });
});
const $cd3da1c859fecc93$var$Illustration = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1yk2 _4t3i13i4",
            __cmplp.className
        ])
    });
});

});
parcelRegister("47SnX", function(module, exports) {
module.exports = new URL("search-no-results-old.10b14394.svg", import.meta.url).toString();

});

parcelRegister("23WHC", function(module, exports) {

$parcel$export(module.exports, "default", () => $4708df9bdc612950$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $4708df9bdc612950$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    emptyStateHeading: {
        "id": "business-filters.themed-filter-empty-state.empty-state-heading",
        "defaultMessage": "It looks like we can't find any results that match."
    },
    invalidStateHeading: {
        "id": "business-filters.themed-filter-empty-state.invalid-state-heading",
        "defaultMessage": "We can't handle the current filters, please clear to continue."
    },
    clearFiltersButton: {
        "id": "business-filters.themed-filter-empty-state.clear-filters-button",
        "defaultMessage": "Clear"
    }
});

});


parcelRegister("1T4FF", function(module, exports) {

$parcel$export(module.exports, "ISSUE_CREATED_EVENT", () => $ac829f3b425e0434$export$b22a14d5dac59664);
$parcel$export(module.exports, "ISSUE_DELETED_EVENT", () => $ac829f3b425e0434$export$25fa37e5059c5a99);
$parcel$export(module.exports, "ISSUE_UPDATED_EVENT", () => $ac829f3b425e0434$export$b22142e61b3fdbee);
$parcel$export(module.exports, "FIELD_MUTATION_EVENT", () => $ac829f3b425e0434$export$eddbca92a5bee91f);
$parcel$export(module.exports, "ISSUE_EVENTS", () => $ac829f3b425e0434$export$f01b4f4e297998a0);
$parcel$export(module.exports, "DEFAULT_EVENTS_TO_SUBSCRIBE_TO", () => $ac829f3b425e0434$export$edc58098c8ddf4cb);
$parcel$export(module.exports, "CREATE_SUBSCRIPTIONS_EXPERIENCE", () => $ac829f3b425e0434$export$75b82bac1ec985d9);
$parcel$export(module.exports, "REALTIME_EVENT_EXPERIENCE", () => $ac829f3b425e0434$export$245947dc0e8c134b);
const $ac829f3b425e0434$export$b22a14d5dac59664 = 'avi:jira:created:issue';
const $ac829f3b425e0434$export$25fa37e5059c5a99 = 'avi:jira:deleted:issue';
const $ac829f3b425e0434$export$b22142e61b3fdbee = 'avi:jira:updated:issue';
const $ac829f3b425e0434$export$eddbca92a5bee91f = 'avi:jira:field:updated';
const $ac829f3b425e0434$export$f01b4f4e297998a0 = [
    $ac829f3b425e0434$export$b22a14d5dac59664,
    $ac829f3b425e0434$export$25fa37e5059c5a99,
    $ac829f3b425e0434$export$b22142e61b3fdbee
];
const $ac829f3b425e0434$export$edc58098c8ddf4cb = $ac829f3b425e0434$export$f01b4f4e297998a0;
const $ac829f3b425e0434$var$PACKAGE_NAME = 'jiraBusinessGqlsRealtime';
const $ac829f3b425e0434$export$75b82bac1ec985d9 = {
    experience: 'createSubscriptions',
    packageName: $ac829f3b425e0434$var$PACKAGE_NAME,
    teamName: 'keystone'
};
const $ac829f3b425e0434$export$245947dc0e8c134b = {
    experience: 'realtimeEvent',
    packageName: $ac829f3b425e0434$var$PACKAGE_NAME,
    teamName: 'keystone'
};

});

parcelRegister("6sVa1", function(module, exports) {

$parcel$export(module.exports, "GqlsRealtime", () => $c64a00289bd38048$export$ad092969d774a1ab);

var $5uXOq = parcelRequire("5uXOq");

var $1Zr0i = parcelRequire("1Zr0i");

var $cm8b5 = parcelRequire("cm8b5");

var $b71gk = parcelRequire("b71gk");

var $4R6GH = parcelRequire("4R6GH");

var $dXq4S = parcelRequire("dXq4S");

var $hnYwO = parcelRequire("hnYwO");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $9OXo1 = parcelRequire("9OXo1");

var $1T4FF = parcelRequire("1T4FF");

var $x3opw = parcelRequire("x3opw");

var $8EXvJ = parcelRequire("8EXvJ");

var $8hBpB = parcelRequire("8hBpB");

var $bGo96 = parcelRequire("bGo96");
const $c64a00289bd38048$export$ad092969d774a1ab = /*#__PURE__*/ (0, $5uXOq.memo)(({ appId: appId, entityId: entityId, onReceive: onReceive, eventsToSubscribeTo: eventsToSubscribeTo = (0, $1T4FF.DEFAULT_EVENTS_TO_SUBSCRIBE_TO) })=>{
    const { cloudId: cloudId } = (0, $9OXo1.useTenantContext)();
    let siteId = (0, $dXq4S.createAri)({
        resourceOwner: 'jira',
        resourceType: 'site',
        resourceId: cloudId
    });
    if ((0, $4R6GH.fg)('migrate-deprecated-jira-platform-ari-fns')) siteId = (0, $hnYwO.JiraSiteAri).create({
        siteId: cloudId
    }).toString();
    const realtimeIds = (0, $1Zr0i.useRealtimeContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const createSubsExperienceStart = (0, $cm8b5.useExperienceStart)((0, $1T4FF.CREATE_SUBSCRIPTIONS_EXPERIENCE));
    const createSubsExperienceSuccess = (0, $cm8b5.useExperienceSuccess)((0, $1T4FF.CREATE_SUBSCRIPTIONS_EXPERIENCE));
    const createSubsExperienceFail = (0, $cm8b5.useExperienceFail)((0, $1T4FF.CREATE_SUBSCRIPTIONS_EXPERIENCE));
    const realtimeEventExperienceStart = (0, $cm8b5.useExperienceStart)((0, $1T4FF.REALTIME_EVENT_EXPERIENCE));
    const realtimeEventExperienceSuccess = (0, $cm8b5.useExperienceSuccess)((0, $1T4FF.REALTIME_EVENT_EXPERIENCE));
    const realtimeEventExperienceFail = (0, $cm8b5.useExperienceFail)((0, $1T4FF.REALTIME_EVENT_EXPERIENCE));
    createSubsExperienceStart();
    // We need to be careful not to re-trigger the subscriptions useMemo, as this
    // causes new subscribe messages to be sent over the WS, which we only want to
    // happen when something directly related to the subscription changes
    // So we are using Refs to prevent the handleReceive function from changing too much
    const extraEventDataRef = (0, $5uXOq.useRef)({
        appId: appId,
        entityId: entityId
    });
    extraEventDataRef.current.appId = appId;
    extraEventDataRef.current.entityId = entityId;
    const onReceiveRef = (0, $5uXOq.useRef)(onReceive);
    onReceiveRef.current = onReceive;
    const handleReceive = (0, $5uXOq.useCallback)((event)=>{
        realtimeEventExperienceStart();
        try {
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'subscription next', {
                ...extraEventDataRef.current,
                realtimeEvent: event.type
            });
            onReceiveRef.current(event);
            realtimeEventExperienceSuccess({
                realtimeEvent: event.type
            });
        } catch (error) {
            realtimeEventExperienceFail('jiraBusinessGqlsRealtime.gqlsRealtime', // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
            error, {
                realtimeEvent: event.type
            });
        }
    }, [
        createAnalyticsEvent,
        realtimeEventExperienceStart,
        realtimeEventExperienceSuccess,
        realtimeEventExperienceFail
    ]);
    const handleReactError = (0, $5uXOq.useCallback)((_location, error, event)=>{
        (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'jiraBusinessGqlsRealtime.gqlsRealtime failed', event);
        createSubsExperienceFail('jiraBusinessGqlsRealtime.gqlsRealtime', error);
    }, [
        createAnalyticsEvent,
        createSubsExperienceFail
    ]);
    const handleSubscriptionError = (0, $5uXOq.useCallback)((errorMessage, operationName)=>{
        (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'jiraBusinessGqlsRealtime.subscription failed', {
            errorMessage: errorMessage,
            operationName: operationName,
            ...extraEventDataRef.current
        });
    }, [
        createAnalyticsEvent
    ]);
    const subscriptions = (0, $5uXOq.useMemo)(()=>!realtimeIds.length ? null : realtimeIds.map((projectId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Fragment), {
                key: projectId
            }, eventsToSubscribeTo.includes((0, $1T4FF.ISSUE_UPDATED_EVENT)) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bGo96.UpdateIssueSubscription), {
                cloudId: cloudId,
                projectId: projectId,
                onReceive: handleReceive,
                onError: handleSubscriptionError
            }), eventsToSubscribeTo.includes((0, $1T4FF.ISSUE_CREATED_EVENT)) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $x3opw.CreateIssueSubscription), {
                cloudId: cloudId,
                projectId: projectId,
                onReceive: handleReceive,
                onError: handleSubscriptionError
            }), eventsToSubscribeTo.includes((0, $1T4FF.ISSUE_DELETED_EVENT)) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8EXvJ.DeleteIssueSubscription), {
                cloudId: cloudId,
                projectId: projectId,
                onReceive: handleReceive,
                onError: handleSubscriptionError
            }), eventsToSubscribeTo.includes((0, $1T4FF.FIELD_MUTATION_EVENT)) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8hBpB.FieldMutationSubscription), {
                siteId: siteId,
                onReceive: handleReceive,
                onError: handleSubscriptionError
            }))), [
        cloudId,
        siteId,
        realtimeIds,
        eventsToSubscribeTo,
        handleReceive,
        handleSubscriptionError
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const realtimeEvents = {
            issueCreated: eventsToSubscribeTo.includes((0, $1T4FF.ISSUE_CREATED_EVENT)),
            issueUpdated: eventsToSubscribeTo.includes((0, $1T4FF.ISSUE_UPDATED_EVENT)),
            issueDeleted: eventsToSubscribeTo.includes((0, $1T4FF.ISSUE_DELETED_EVENT)),
            fieldMutation: eventsToSubscribeTo.includes((0, $1T4FF.FIELD_MUTATION_EVENT))
        };
        (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'subscriptions created', {
            ...extraEventDataRef.current,
            ...realtimeEvents,
            subscriptions: realtimeIds.length * eventsToSubscribeTo.length
        });
        createSubsExperienceSuccess();
    }, [
        subscriptions,
        createAnalyticsEvent,
        realtimeIds,
        eventsToSubscribeTo,
        createSubsExperienceSuccess
    ]);
    (0, $5uXOq.useEffect)(()=>{
        (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'subscriptions init', extraEventDataRef.current);
        const extraEventData = extraEventDataRef.current;
        return ()=>{
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'subscriptions closed', extraEventData);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "gqlsRealtime",
        packageName: "jiraBusinessGqlsRealtime",
        extraEventData: extraEventDataRef.current,
        onError: handleReactError
    }, subscriptions);
});

});
parcelRegister("x3opw", function(module, exports) {

$parcel$export(module.exports, "CreateIssueSubscription", () => $04c21e90a72c6b66$export$7876efe7a86fd4f1);

var $5uXOq = parcelRequire("5uXOq");

var $WnsY2 = parcelRequire("WnsY2");

var $1T4FF = parcelRequire("1T4FF");

var $3qoA4 = parcelRequire("3qoA4");

const $04c21e90a72c6b66$var$operationName = 'JwmIssueCreatedSubscription';
const $04c21e90a72c6b66$export$7876efe7a86fd4f1 = /*#__PURE__*/ (0, $5uXOq.memo)(({ cloudId: cloudId, projectId: projectId, onReceive: onReceive, onError: onError })=>{
    (0, $WnsY2.useSubscribe)({
        query: (0, $d3fb5f72d359d914$export$89cddb5ca4c806e4),
        variables: {
            cloudId: cloudId,
            projectId: projectId
        },
        operationName: $04c21e90a72c6b66$var$operationName
    }, {
        next: (value)=>{
            const error = (0, $3qoA4.getResponseError)(value);
            if (error) onError(error, $04c21e90a72c6b66$var$operationName);
            else {
                const payload = value.data?.jira?.onIssueCreatedByProject;
                if (payload) onReceive({
                    type: (0, $1T4FF.ISSUE_CREATED_EVENT),
                    payload: payload
                });
            }
        }
    });
    return null;
});

});
parcelRegister("WnsY2", function(module, exports) {

$parcel$export(module.exports, "useSubscribe", () => $292b86c5ae12bc26$export$d3d523392640272);

var $5uXOq = parcelRequire("5uXOq");

var $laTox = parcelRequire("laTox");

var $jcw0u = parcelRequire("jcw0u");

var $cfDZ3 = parcelRequire("cfDZ3");


var $lWhTC = parcelRequire("lWhTC");

var $hoQbP = parcelRequire("hoQbP");

var $1Uhm6 = parcelRequire("1Uhm6");
// Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
const $292b86c5ae12bc26$var$noop = ()=>{};
const $292b86c5ae12bc26$var$subscribe = (payload, sink)=>{
    const client = (0, $lWhTC.getClient)();
    if (!client) return;
    const { query: query, variables: variables, operationName: operationName, extensions: extensions } = payload;
    const { next: next, error: error, complete: complete = $292b86c5ae12bc26$var$noop } = sink;
    let requestId;
    return client.subscribe({
        query: query,
        variables: variables,
        operationName: operationName,
        extensions: {
            ...extensions ?? {}
        }
    }, {
        next: (value)=>{
            // @ts-expect-error agg prop is missing on generic "extensions" type
            const aggRequestId = value?.extensions?.agg?.request_id;
            if (aggRequestId) requestId = aggRequestId;
            // @ts-expect-error incompatible types between two libraries
            next(value);
        },
        complete: complete,
        error: (sinkError)=>{
            const errorInfo = (0, $1Uhm6.getSinkError)(sinkError);
            const attributes = {
                operationName: operationName,
                requestId: requestId,
                userLocation: (0, $cfDZ3.getUserLocation)()
            };
            error?.(errorInfo, attributes);
            (0, $jcw0u.default)({
                meta: {
                    id: 'subscription',
                    packageName: 'jiraGraphqlSubscription',
                    teamName: 'uip-graphql'
                },
                error: errorInfo,
                attributes: attributes,
                sendToPrivacyUnsafeSplunk: true
            });
        }
    });
};
const $292b86c5ae12bc26$export$d3d523392640272 = (payload, sink)=>{
    (0, $5uXOq.useEffect)(()=>{
        let unsubscribe = $292b86c5ae12bc26$var$subscribe(payload, sink);
        let timeout;
        const onVisibilityChange = ()=>{
            if ((0, $laTox.isPageVisible)()) {
                if (timeout) {
                    clearTimeout(timeout);
                    timeout = undefined;
                } else unsubscribe = $292b86c5ae12bc26$var$subscribe(payload, sink);
            } else if (!timeout) timeout = setTimeout(()=>{
                unsubscribe?.();
                unsubscribe = undefined;
                timeout = undefined;
            }, (0, $37d1b046897e548f$export$1ad8434180c5936c));
        };
        if (!(0, $hoQbP.isSSR)()) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.addEventListener((0, $laTox.supportedVisiblityEvent), onVisibilityChange);
        return ()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.removeEventListener((0, $laTox.supportedVisiblityEvent), onVisibilityChange);
            unsubscribe?.();
        };
    }, [
        payload,
        sink
    ]);
};

});
const $37d1b046897e548f$export$8b012b965402e06a = 580000; // 9m 40 - timeframe needed for UCT token refresh: https://developer.atlassian.com/platform/graphql-gateway/subscriptions/security/#long-lived-user-context-token
const $37d1b046897e548f$export$bf6cd96e19b2987f = 100;
const $37d1b046897e548f$export$1ad8434180c5936c = 300000; // 5m


parcelRegister("3qoA4", function(module, exports) {

$parcel$export(module.exports, "isIssueEvent", () => $ca6633b6fecadea7$export$734ba008b9d9e61c);
$parcel$export(module.exports, "getResponseError", () => $ca6633b6fecadea7$export$135f2bf83a3d73b1);

var $1T4FF = parcelRequire("1T4FF");
const $ca6633b6fecadea7$export$734ba008b9d9e61c = (event)=>(0, $1T4FF.ISSUE_EVENTS).includes(event.type);
const $ca6633b6fecadea7$export$135f2bf83a3d73b1 = (response)=>Array.isArray(response.errors) && response.errors.length && response.errors[0].message;

});

const $d3fb5f72d359d914$export$89cddb5ca4c806e4 = `
  subscription JwmIssueCreatedSubscription(
    $cloudId: ID!
    $projectId: String!
  ) {
    jira {
      onIssueCreatedByProject(cloudId: $cloudId, projectId: $projectId) {
        issueId
      }
    }
  }
`;


parcelRegister("8EXvJ", function(module, exports) {

$parcel$export(module.exports, "DeleteIssueSubscription", () => $642754f18ab6266b$export$cba4fc39801f6792);

var $5uXOq = parcelRequire("5uXOq");

var $WnsY2 = parcelRequire("WnsY2");

var $dXq4S = parcelRequire("dXq4S");

var $jUlV7 = parcelRequire("jUlV7");

var $4R6GH = parcelRequire("4R6GH");

var $1T4FF = parcelRequire("1T4FF");

var $3qoA4 = parcelRequire("3qoA4");

const $642754f18ab6266b$var$operationName = 'JwmIssueDeletedSubscription';
const $642754f18ab6266b$export$cba4fc39801f6792 = /*#__PURE__*/ (0, $5uXOq.memo)(({ cloudId: cloudId, projectId: projectId, onReceive: onReceive, onError: onError })=>{
    (0, $WnsY2.useSubscribe)({
        query: (0, $36128e87a5f55340$export$9c299c317f46fdc4),
        variables: {
            cloudId: cloudId,
            projectId: projectId
        },
        operationName: $642754f18ab6266b$var$operationName
    }, {
        next: (value)=>{
            const error = (0, $3qoA4.getResponseError)(value);
            if (error) onError(error, $642754f18ab6266b$var$operationName);
            else {
                const payload = value.data?.jira?.onIssueDeletedByProject;
                if (payload) {
                    let issueId = (0, $dXq4S.getAriConfig)(payload.resource).resourceId;
                    if ((0, $4R6GH.fg)('migrate-deprecated-jira-platform-ari-fns')) issueId = payload.resource && (0, $jUlV7.JiraIssueAri).check(payload.resource) ? (0, $jUlV7.JiraIssueAri).parse(payload.resource).issueId : null;
                    onReceive({
                        type: (0, $1T4FF.ISSUE_DELETED_EVENT),
                        payload: {
                            ...payload,
                            issueId: issueId || ''
                        }
                    });
                }
            }
        }
    });
    return null;
});

});
parcelRegister("jUlV7", function(module, exports) {

$parcel$export(module.exports, "JiraIssueAri", () => $e7e440357f375b75$export$1da6808e89ee03e);

var $bQ5aj = parcelRequire("bQ5aj");

var $3NoER = parcelRequire("3NoER");

var $gYPG7 = parcelRequire("gYPG7");
// src/jira/issue/manifest.ts
var $e7e440357f375b75$var$jiraIssueAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $bQ5aj.JiraIssueAriResourceOwner),
    resourceType: (0, $bQ5aj.JiraIssueAriResourceType),
    resourceIdSlug: "{issueId}",
    resourceIdSegmentFormats: {
        issueId: /[0-9]+/
    }
};
// src/jira/issue/index.ts
var $e7e440357f375b75$export$1da6808e89ee03e = class _JiraIssueAri extends (0, $3NoER.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._issueId = opts.resourceIdSegmentValues.issueId;
    }
    get siteId() {
        return this._siteId;
    }
    get issueId() {
        return this._issueId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $e7e440357f375b75$var$jiraIssueAriStaticOpts.qualifier,
            platformQualifier: $e7e440357f375b75$var$jiraIssueAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $e7e440357f375b75$var$jiraIssueAriStaticOpts.resourceOwner,
            resourceType: $e7e440357f375b75$var$jiraIssueAriStaticOpts.resourceType,
            resourceId: `${opts.issueId}`,
            resourceIdSegmentValues: {
                issueId: opts.issueId
            }
        }, ariOpts = (0, $gYPG7.AriParser).fromOpts(derivedOpts, $e7e440357f375b75$var$jiraIssueAriStaticOpts);
        return new _JiraIssueAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $gYPG7.AriParser).fromString(maybeAri, $e7e440357f375b75$var$jiraIssueAriStaticOpts);
        return new _JiraIssueAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            issueId: this.issueId
        };
    }
};

});
parcelRegister("bQ5aj", function(module, exports) {

$parcel$export(module.exports, "JiraIssueAriResourceOwner", () => $89e88ec215209f61$export$665a39f1b4e29e0a);
$parcel$export(module.exports, "JiraIssueAriResourceType", () => $89e88ec215209f61$export$76beb4d0da177ad4);
// src/jira/issue/types.ts
var $89e88ec215209f61$export$665a39f1b4e29e0a = "jira", $89e88ec215209f61$export$76beb4d0da177ad4 = "issue";

});


const $36128e87a5f55340$export$9c299c317f46fdc4 = `
  subscription JwmIssueDeletedSubscription(
    $cloudId: ID!
    $projectId: String!
  ) {
    jira {
      onIssueDeletedByProject(cloudId: $cloudId, projectId: $projectId) {
        resource
      }
    }
  }
`;


parcelRegister("8hBpB", function(module, exports) {

$parcel$export(module.exports, "FieldMutationSubscription", () => $4521bfd09c42e07c$export$d82ea923ea48fa52);

var $5uXOq = parcelRequire("5uXOq");

var $WnsY2 = parcelRequire("WnsY2");

var $1T4FF = parcelRequire("1T4FF");

var $3qoA4 = parcelRequire("3qoA4");

const $4521bfd09c42e07c$var$operationName = 'JwmFieldMutationSubscription';
const $4521bfd09c42e07c$export$d82ea923ea48fa52 = /*#__PURE__*/ (0, $5uXOq.memo)(({ siteId: siteId, onReceive: onReceive, onError: onError })=>{
    (0, $WnsY2.useSubscribe)({
        query: (0, $0831eb0e06b13614$export$2e75a8174f7cddb8),
        operationName: $4521bfd09c42e07c$var$operationName,
        variables: {
            siteId: siteId
        }
    }, {
        next: (value)=>{
            const error = (0, $3qoA4.getResponseError)(value);
            if (error) onError(error, $4521bfd09c42e07c$var$operationName);
            else if (value.data?.jira?.onJwmFieldMutation) onReceive({
                type: (0, $1T4FF.FIELD_MUTATION_EVENT),
                payload: {}
            });
        }
    });
    return null;
});

});
const $0831eb0e06b13614$export$2e75a8174f7cddb8 = `
  subscription JwmFieldMutationSubscription($siteId: ID!) {
    jira {
      onJwmFieldMutation(siteId: $siteId) {
        encryptedData
      }
    }
  }
`;


parcelRegister("bGo96", function(module, exports) {

$parcel$export(module.exports, "UpdateIssueSubscription", () => $0971ff6ea0a776a8$export$51fac6481c0b4595);

var $5uXOq = parcelRequire("5uXOq");

var $WnsY2 = parcelRequire("WnsY2");

var $1T4FF = parcelRequire("1T4FF");

var $3qoA4 = parcelRequire("3qoA4");

const $0971ff6ea0a776a8$var$operationName = 'JwmIssueUpdatedSubscription';
const $0971ff6ea0a776a8$export$51fac6481c0b4595 = /*#__PURE__*/ (0, $5uXOq.memo)(({ cloudId: cloudId, projectId: projectId, onReceive: onReceive, onError: onError })=>{
    (0, $WnsY2.useSubscribe)({
        query: (0, $fabb0a5a91b2db55$export$54c41e3133084b81),
        variables: {
            cloudId: cloudId,
            projectId: projectId
        },
        operationName: $0971ff6ea0a776a8$var$operationName
    }, {
        next: (value)=>{
            const error = (0, $3qoA4.getResponseError)(value);
            if (error) onError(error, $0971ff6ea0a776a8$var$operationName);
            else {
                const payload = value.data?.jira?.onIssueUpdatedByProject;
                if (payload) onReceive({
                    type: (0, $1T4FF.ISSUE_UPDATED_EVENT),
                    payload: payload
                });
            }
        }
    });
    return null;
});

});
const $fabb0a5a91b2db55$export$54c41e3133084b81 = `
  subscription JwmIssueUpdatedSubscription(
    $cloudId: ID!
    $projectId: String!
  ) {
    jira {
      onIssueUpdatedByProject(cloudId: $cloudId, projectId: $projectId) {
        issueId
      }
    }
  }
`;



parcelRegister("3kVj2", function(module, exports) {

$parcel$export(module.exports, "default", () => $e9988a92625a64f1$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $bUSNl = parcelRequire("bUSNl");

var $hE5wF = parcelRequire("hE5wF");


var $2gCtH = parcelRequire("2gCtH");

var $gjEtj = parcelRequire("gjEtj");

var $lfTZh = parcelRequire("lfTZh");

var $iXVV6 = parcelRequire("iXVV6");
var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $l8ruj = parcelRequire("l8ruj");

var $kxZPA = parcelRequire("kxZPA");

var $ieDtd = parcelRequire("ieDtd");

const $e9988a92625a64f1$export$843a6e93936e3b60 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("jr9Is")), {
    ssr: false,
    moduleId: "./src/packages/issue/issue-view/src/views/issue-details/modal-issue-app.tsx"
});
const $e9988a92625a64f1$var$ModalIssueAppWrapper = ({ issueKey: issueKey, onClose: onClose, onChange: onChange, onDeleteSuccess: onDeleteSuccess, analyticsSource: analyticsSource = (0, $fcf97b7a09088940$export$82540942fb014b0a), viewModeSwitchDisabled: viewModeSwitchDisabled, isSoftwareProject: isSoftwareProject })=>{
    const [, setSelectedIssue] = (0, $ieDtd.useQueryParam)((0, $hE5wF.SELECTED_ISSUE_PARAM));
    const onIssueKeyChange = (0, $5uXOq.useCallback)(({ toIssueKey: toIssueKey })=>setSelectedIssue(toIssueKey), [
        setSelectedIssue
    ]);
    const [, { setSidebarContent: setSidebarContent }] = (0, $bUSNl.useSidebar)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [, { setDetailViewAsSidebar: setDetailViewAsSidebar, setDetailViewAsModal: setDetailViewAsModal }] = (0, $2gCtH.useIssueContextActions)();
    const onSwitchToModal = (0, $5uXOq.useCallback)(()=>{
        setDetailViewAsModal();
        setSidebarContent(null);
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'issueAppMenuItem clicked', 'switchToModal');
    }, [
        createAnalyticsEvent,
        setDetailViewAsModal,
        setSidebarContent
    ]);
    const onSwitchToSidebar = (0, $5uXOq.useCallback)(()=>{
        setSidebarContent(null);
        setDetailViewAsSidebar();
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'issueAppMenuItem clicked', 'switchToSidebar');
    }, [
        createAnalyticsEvent,
        setDetailViewAsSidebar,
        setSidebarContent
    ]);
    const viewModeOptions = (0, $5uXOq.useMemo)(()=>!viewModeSwitchDisabled ? {
            viewModeSwitchEnabled: true,
            onSwitchToModal: onSwitchToModal,
            onSwitchToSidebar: onSwitchToSidebar
        } : undefined, [
        onSwitchToModal,
        onSwitchToSidebar,
        viewModeSwitchDisabled
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "business-modal-issue-app"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
        sourceName: isSoftwareProject ? 'jswModalIssueApp' : 'jwmModalIssueApp'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjEtj.ModalBoundary), {
        packageName: isSoftwareProject ? 'software' : 'business',
        id: "issue-modal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "modal-issue-app",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e9988a92625a64f1$export$843a6e93936e3b60, {
        analyticsSource: analyticsSource,
        issueKey: issueKey,
        onClose: onClose,
        onChange: onChange,
        onIssueDeleteSuccess: onDeleteSuccess,
        onIssueKeyChange: onIssueKeyChange,
        viewModeOptions: viewModeOptions
    })))));
};
var $e9988a92625a64f1$export$2e2bcd8739ae039 = $e9988a92625a64f1$var$ModalIssueAppWrapper;

});
const $fcf97b7a09088940$export$53d41ff2666118e1 = 'agility-backlog';
const $fcf97b7a09088940$export$7552fe2669628499 = 'bitbucket-issue';
const $fcf97b7a09088940$export$41a718da0a8636f4 = 'connect-issue';
const $fcf97b7a09088940$export$cebf0bc8b2ccaf57 = 'core-issue';
const $fcf97b7a09088940$export$5e91e17726e54450 = 'jiraCalendar';
const $fcf97b7a09088940$export$2dac1950892123f5 = 'jiraTimeline';
const $fcf97b7a09088940$export$82540942fb014b0a = 'business-calendar';
const $fcf97b7a09088940$export$7ca28938a07e0c33 = 'business-list';
const $fcf97b7a09088940$export$f6cf06aaaeb58a54 = 'business-timeline';
const $fcf97b7a09088940$export$b2c0462ff17aa26e = 'business-board';
const $fcf97b7a09088940$export$a607850ebccd28ac = 'business-approvals';
const $fcf97b7a09088940$export$1da6cede3561048f = 'business-files';
const $fcf97b7a09088940$export$b19f949fb9713614 = 'full-issue';
const $fcf97b7a09088940$export$a5132300c5214280 = 'embed-issue';
const $fcf97b7a09088940$export$710114090a811b37 = 'global-issue-navigator-issue';
const $fcf97b7a09088940$export$ce88447986394f2d = 'mobile-issue';
const $fcf97b7a09088940$export$6a90d9196d330040 = 'project-issue-navigator';
const $fcf97b7a09088940$export$2247c9059c171db1 = 'roadmap-issue';
const $fcf97b7a09088940$export$cd16d39c55c569d0 = 'simple-software-board';
const $fcf97b7a09088940$export$f72626bf0d75dfad = 'software-backlog-issue';
const $fcf97b7a09088940$export$778b4609e784cb27 = 'software-deployments-issue';
const $fcf97b7a09088940$export$5b73d694a6048002 = 'version-detail-issue';
const $fcf97b7a09088940$export$accce97178e4e049 = 'software-cycle-time-report-issue';
const $fcf97b7a09088940$export$21b5b7189add7861 = 'software-incidents-issue';
const $fcf97b7a09088940$export$9c5d81b901471b27 = 'software-issue';
const $fcf97b7a09088940$export$1735f6ad917dc411 = 'change-calendar';
const $fcf97b7a09088940$export$7063ee6d0035a982 = 'queues-issue-view';
const $fcf97b7a09088940$export$5bd5011b6596a0e7 = 'reports-issue-view';
const $fcf97b7a09088940$export$9dfa9e993d3e0520 = 'forge-full-page-extension';
const $fcf97b7a09088940$export$14a8072f422804fd = 'issue-navigator-next';
const $fcf97b7a09088940$export$5f3c20fe2ff6c0a2 = 'staffing-issue';

parcelRegister("jr9Is", function(module, exports) {

let $e268135c1a0ba255$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $e268135c1a0ba255$var$load("76n7a"),
    $e268135c1a0ba255$var$load("l253H"),
    $e268135c1a0ba255$var$load("ffQaD"),
    $e268135c1a0ba255$var$load("kvRbA"),
    $e268135c1a0ba255$var$load("3yAl4"),
    $e268135c1a0ba255$var$load("kNFvF"),
    $e268135c1a0ba255$var$load("bWP0X")
]).then(()=>parcelRequire('2555l'));

});


parcelRegister("ksKCJ", function(module, exports) {

$parcel$export(module.exports, "SidebarIssueView", () => $15a07712b759f270$export$ccdf533f42a8d6f8);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $bUSNl = parcelRequire("bUSNl");

var $2xJgT = parcelRequire("2xJgT");

var $1XJ20 = parcelRequire("1XJ20");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $g5X3G = parcelRequire("g5X3G");

var $cZ5o7 = parcelRequire("cZ5o7");

var $2ax5r = parcelRequire("2ax5r");
const $15a07712b759f270$var$ISSUE_VIEW_SIDEBAR_CONTENT_KEY = 'issueViewSidebar';
const $15a07712b759f270$export$ccdf533f42a8d6f8 = /*#__PURE__*/ (0, $5uXOq.memo)(({ issueKey: issueKey, onClose: onClose, analyticsSource: analyticsSource, onChange: onChange, onIssueDeleteSuccess: onIssueDeleteSuccess, isSoftwareProject: isSoftwareProject })=>{
    const [{ content: content }, { setSidebarContent: setSidebarContent }] = (0, $bUSNl.useSidebar)();
    const prevIssueKey = (0, $1XJ20.usePreviousWithInitial)(issueKey);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    (0, $2ax5r.useSetSidebarStyleVar)();
    const onCloseSidebar = (0, $5uXOq.useCallback)(()=>{
        onClose();
    }, [
        onClose
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // avoid re-rendering in case props aren't memoised
        if (issueKey === prevIssueKey && !!content) return;
        if (issueKey) {
            const newContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($15a07712b759f270$var$CSSAntiCorruptionLayer, {
                key: $15a07712b759f270$var$ISSUE_VIEW_SIDEBAR_CONTENT_KEY
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cZ5o7.SidebarIssueApp), {
                issueKey: (0, $g5X3G.toIssueKey)(issueKey),
                onClose: onCloseSidebar,
                analyticsSource: analyticsSource,
                onChange: onChange,
                onIssueDeleteSuccess: onIssueDeleteSuccess,
                isSoftwareProject: isSoftwareProject
            }));
            setSidebarContent(newContent);
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'sidebarIssueApp opened');
        } else {
            if (content?.key === $15a07712b759f270$var$ISSUE_VIEW_SIDEBAR_CONTENT_KEY) setSidebarContent(null);
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'sidebarIssueApp closed');
        }
    }, [
        analyticsSource,
        content,
        createAnalyticsEvent,
        isSoftwareProject,
        issueKey,
        onChange,
        onCloseSidebar,
        onIssueDeleteSuccess,
        prevIssueKey,
        setSidebarContent
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // Preload IssueApp here, otherwise it'd be loaded when Sidebar opens up for the first time, which is a bit slow
        (0, $2xJgT.callWhenIdle)(()=>{
            (0, $cZ5o7.IssueApp).preload();
        }, 3000);
    }, []);
    return null;
});
// put an extra div around issue view to "adopt" styles from `SidebarContent` (`> div`)
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $15a07712b759f270$var$CSSAntiCorruptionLayer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1osq _vchhusvi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("2xJgT", function(module, exports) {

$parcel$export(module.exports, "callWhenIdle", () => $8c65c2dcde2b90c3$export$d2542992df1e054);
const $8c65c2dcde2b90c3$export$d2542992df1e054 = (callback, timeout = 200)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (typeof window.requestIdleCallback === 'function') {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const callbackId = window.requestIdleCallback(callback);
        return ()=>cancelIdleCallback(callbackId);
    }
    const timer = setTimeout(callback, timeout);
    return ()=>{
        clearTimeout(timer);
    };
};

});

parcelRegister("cZ5o7", function(module, exports) {

$parcel$export(module.exports, "IssueApp", () => $f0984329e6d3d9e6$export$35dd9ab573b87c3f);
$parcel$export(module.exports, "SidebarIssueApp", () => $f0984329e6d3d9e6$export$e402f7c18d4d7f37);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $bUSNl = parcelRequire("bUSNl");

var $2gCtH = parcelRequire("2gCtH");

var $7eqRV = parcelRequire("7eqRV");

var $lfTZh = parcelRequire("lfTZh");

var $1XJ20 = parcelRequire("1XJ20");

var $iXVV6 = parcelRequire("iXVV6");
var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $lb0Dk = parcelRequire("lb0Dk");

var $l8ruj = parcelRequire("l8ruj");

var $kxZPA = parcelRequire("kxZPA");

const $f0984329e6d3d9e6$export$35dd9ab573b87c3f = (0, $kxZPA.lazy)(()=>(parcelRequire("iPF14")), {
    ssr: false,
    moduleId: "./src/packages/issue/issue-view/src/views/issue-details/issue-app.tsx"
});
const $f0984329e6d3d9e6$export$e402f7c18d4d7f37 = ({ analyticsSource: analyticsSource, issueKey: issueKey, onClose: onClose, onIssueDeleteSuccess: onIssueDeleteSuccess, onChange: onChange, isSoftwareProject: isSoftwareProject })=>{
    const [currentIssueKey, setCurrentIssueKey] = (0, $5uXOq.useState)(issueKey);
    const prevIssueKey = (0, $1XJ20.usePreviousWithInitial)(issueKey);
    // @ts-expect-error - TS7031 - Binding element 'nextIssueKey' implicitly has an 'any' type.
    const onIssueKeyChange = (0, $5uXOq.useCallback)(({ toIssueKey: nextIssueKey })=>{
        setCurrentIssueKey(nextIssueKey);
    }, []);
    const [, { setDetailViewAsSidebar: setDetailViewAsSidebar, setDetailViewAsModal: setDetailViewAsModal }] = (0, $2gCtH.useIssueContextActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [, { setSidebarContent: setSidebarContent }] = (0, $bUSNl.useSidebar)();
    (0, $5uXOq.useEffect)(()=>{
        if (prevIssueKey !== issueKey) setCurrentIssueKey(issueKey);
    }, [
        currentIssueKey,
        issueKey,
        prevIssueKey
    ]);
    const onSwitchToModal = (0, $5uXOq.useCallback)(()=>{
        setDetailViewAsModal();
        setSidebarContent(null);
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'issueAppMenuItem clicked', 'switchToModal');
    }, [
        createAnalyticsEvent,
        setDetailViewAsModal,
        setSidebarContent
    ]);
    const onSwitchToSidebar = (0, $5uXOq.useCallback)(()=>{
        setDetailViewAsSidebar();
        setSidebarContent(null);
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'issueAppMenuItem clicked', 'switchToSidebar');
    }, [
        createAnalyticsEvent,
        setDetailViewAsSidebar,
        setSidebarContent
    ]);
    const PACKAGE_NAME = (0, $5uXOq.useMemo)(()=>isSoftwareProject ? 'jswSidebarIssueApp' : 'jwmSidebarIssueApp', [
        isSoftwareProject
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "business-sidebar-issue-app"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
        sourceName: PACKAGE_NAME
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "issue-app",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lb0Dk.IssueViewSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7eqRV.IssueBoundary), {
        packageName: PACKAGE_NAME
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f0984329e6d3d9e6$export$35dd9ab573b87c3f, {
        viewModeOptions: {
            viewMode: 'SIDEBAR',
            viewModeSwitchEnabled: true,
            onSwitchToModal: onSwitchToModal,
            onSwitchToSidebar: onSwitchToSidebar
        },
        issueKey: currentIssueKey,
        analyticsSource: analyticsSource,
        shouldShowCloseButton: true,
        onClose: onClose,
        onIssueKeyChange: onIssueKeyChange,
        shouldSetInitialFocus: true,
        shouldShowRootProjectsBreadcrumb: true,
        onIssueDeleteSuccess: onIssueDeleteSuccess,
        onIssueDeleteFailure: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        isSpaEnabled: false,
        isLoadedWithPage: false,
        onChange: onChange
    })))));
};

});
parcelRegister("7eqRV", function(module, exports) {

$parcel$export(module.exports, "IssueBoundary", () => $e3c8771effba3477$export$fbf48ede0cf52b5a);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");

var $b71gk = parcelRequire("b71gk");

var $gjEtj = parcelRequire("gjEtj");

var $lfTZh = parcelRequire("lfTZh");

var $lb0Dk = parcelRequire("lb0Dk");
const $e3c8771effba3477$export$fbf48ede0cf52b5a = ({ children: children, isEmbedView: isEmbedView = true, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "issue",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "issue-boundary",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lb0Dk.IssueViewSkeleton), {
            isEmbedView: isEmbedView
        })
    }, children));
const $e3c8771effba3477$export$74d408982642a541 = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjEtj.ModalBoundary), {
        id: "issue-modal",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "issue-modal-boundary",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lb0Dk.IssueViewSkeleton), {
            isModalView: true
        })
    }, children));

});

parcelRegister("iPF14", function(module, exports) {

let $db5cce6427597049$var$load = (parcelRequire("28QjX"))(4);










module.exports = Promise.all([
    (parcelRequire("avM1e"))('redaction_onboarding_iv_llc', function() {
        return Promise.all([
            $db5cce6427597049$var$load("czPin")
        ]);
    }, function() {
        return Promise.all([
            $db5cce6427597049$var$load("iGvP4")
        ]);
    }),
    (parcelRequire("avM1e"))('magma-3467-iv-renderer-sync-small-nodes', function() {
        return Promise.all([
            $db5cce6427597049$var$load("d5z58"),
            $db5cce6427597049$var$load("kvRbA"),
            $db5cce6427597049$var$load("ffQaD"),
            $db5cce6427597049$var$load("l253H"),
            $db5cce6427597049$var$load("76n7a")
        ]);
    }, function() {
        return Promise.all([
            $db5cce6427597049$var$load("f771T")
        ]);
    }),
    (parcelRequire("avM1e"))('magma-3467-iv-renderer-sync-media-nodes', function() {
        return Promise.all([
            $db5cce6427597049$var$load("gXEyJ"),
            $db5cce6427597049$var$load("l253H"),
            $db5cce6427597049$var$load("76n7a")
        ]);
    }, function() {
        return Promise.all([
            $db5cce6427597049$var$load("hy7ba")
        ]);
    }),
    (parcelRequire("avM1e"))('magma-3467-iv-renderer-sync-card-nodes', function() {
        return Promise.all([
            $db5cce6427597049$var$load("lh7CA"),
            $db5cce6427597049$var$load("kNFvF"),
            $db5cce6427597049$var$load("kvRbA"),
            $db5cce6427597049$var$load("ffQaD"),
            $db5cce6427597049$var$load("l253H"),
            $db5cce6427597049$var$load("76n7a"),
            $db5cce6427597049$var$load("fliVL")
        ]);
    }, function() {
        return Promise.all([
            $db5cce6427597049$var$load("jrRVX")
        ]);
    }),
    (parcelRequire("avM1e"))('jira_amplitude_sr', function() {
        return Promise.all([
            $db5cce6427597049$var$load("8EtZR"),
            $db5cce6427597049$var$load("kVX56")
        ]);
    }, function() {
        return Promise.all([
            $db5cce6427597049$var$load("6jOz3")
        ]);
    }),
    (parcelRequire("avM1e"))('details_loader_to_entrypoint_iv_llc_dev_panel', function() {
        return Promise.all([
            $db5cce6427597049$var$load("84z1X")
        ]);
    }, function() {
        return Promise.all([
            $db5cce6427597049$var$load("eBkr0")
        ]);
    }),
    (parcelRequire("avM1e"))('empanada_profilecard_trial_sync_trigger_import', function() {
        return Promise.all([
            $db5cce6427597049$var$load("czifk"),
            $db5cce6427597049$var$load("kvRbA"),
            $db5cce6427597049$var$load("ffQaD")
        ]);
    }, function() {
        return Promise.all([
            $db5cce6427597049$var$load("kcs34")
        ]);
    }),
    (parcelRequire("avM1e"))('empanada_team_profilecard_trial_sync_trigger', function() {
        return Promise.all([
            $db5cce6427597049$var$load("cTJTG"),
            $db5cce6427597049$var$load("l253H"),
            $db5cce6427597049$var$load("76n7a")
        ]);
    }, function() {
        return Promise.all([
            $db5cce6427597049$var$load("4Qxp7")
        ]);
    }),
    (parcelRequire("avM1e"))('improve_rendering_child_issues_summary_bar', function() {
        return Promise.all([
            $db5cce6427597049$var$load("juSGb")
        ]);
    }, function() {
        return Promise.all([
            $db5cce6427597049$var$load("5FVQh")
        ]);
    }),
    (parcelRequire("avM1e"))('link_paste_recommendations', function() {
        return Promise.all([]);
    }, function() {
        return Promise.all([
            $db5cce6427597049$var$load("7ClEP")
        ]);
    }),
    $db5cce6427597049$var$load("3yAl4"),
    $db5cce6427597049$var$load("fliVL"),
    $db5cce6427597049$var$load("7mIf9"),
    $db5cce6427597049$var$load("jXweD"),
    $db5cce6427597049$var$load("jbxE1"),
    $db5cce6427597049$var$load("7imUH"),
    $db5cce6427597049$var$load("kVX56"),
    $db5cce6427597049$var$load("kNFvF"),
    $db5cce6427597049$var$load("ffQaD"),
    $db5cce6427597049$var$load("kvRbA"),
    $db5cce6427597049$var$load("76n7a"),
    $db5cce6427597049$var$load("l253H"),
    $db5cce6427597049$var$load("gaip1")
]).then(()=>parcelRequire('6qbjz'));

});
parcelRegister("avM1e", function(module, exports) {
"use strict";
module.exports = function(cond, ifTrue, ifFalse) {
    return globalThis.__MCOND && globalThis.__MCOND(cond) ? ifTrue() : ifFalse();
};

});



parcelRegister("2ax5r", function(module, exports) {

$parcel$export(module.exports, "useSetSidebarStyleVar", () => $f33586d1e0f68dde$export$70b20cd72362e39d);

var $5uXOq = parcelRequire("5uXOq");

var $bUSNl = parcelRequire("bUSNl");


var $5e5zm = parcelRequire("5e5zm");

var $jnA4H = parcelRequire("jnA4H");
const $f33586d1e0f68dde$var$MARGIN = 24;
const $f33586d1e0f68dde$export$70b20cd72362e39d = ()=>{
    const [store] = (0, $bUSNl.useSidebar)();
    const { content: content } = store;
    const sidebarWidth = (0, $jnA4H.getSidebarWidthFromStore)(store);
    const { setWidth: setWidth } = (0, $5e5zm.useDetailPanelActions)();
    (0, $5uXOq.useEffect)(()=>{
        if (content !== null) {
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.documentElement?.style.setProperty((0, $563deb1efef5771e$export$c83c5cba188418d8), `${sidebarWidth}px`);
            setWidth(sidebarWidth + $f33586d1e0f68dde$var$MARGIN);
        } else // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.documentElement?.style.removeProperty((0, $563deb1efef5771e$export$c83c5cba188418d8));
        return ()=>{
            setWidth(0);
        };
    }, [
        content,
        setWidth,
        sidebarWidth
    ]);
};

});
const $563deb1efef5771e$export$c83c5cba188418d8 = '--detailPanelWidth';



parcelRegister("kzL7M", function(module, exports) {

$parcel$export(module.exports, "PageVisibility", () => $598dc46c30d3c9ff$export$ddb3b5bf3df25efc);

var $5uXOq = parcelRequire("5uXOq");

var $laWvb = parcelRequire("laWvb");

var $laTox = parcelRequire("laTox");
const $598dc46c30d3c9ff$export$e39301eefbc90236 = 500;
const $598dc46c30d3c9ff$export$ddb3b5bf3df25efc = ({ onChange: onChange })=>{
    // debouncing the page visibility change to prevent when people switching tabs too fast
    // useDebouncedCallback will always call the latest parameter for every re-render
    // so even though `onChange` may change each re-render, only the last one will be called when debounce finishes
    const [onVisibilityChangeDebounced] = (0, $laWvb.default)(()=>{
        onChange({
            isVisible: (0, $laTox.isPageVisible)()
        });
    }, $598dc46c30d3c9ff$export$e39301eefbc90236);
    (0, $5uXOq.useEffect)(()=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.addEventListener((0, $laTox.supportedVisiblityEvent), onVisibilityChangeDebounced);
        return ()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.removeEventListener((0, $laTox.supportedVisiblityEvent), onVisibilityChangeDebounced);
        };
    }, [
        onVisibilityChangeDebounced
    ]);
    return null;
};

});

parcelRegister("8HvEs", function(module, exports) {

$parcel$export(module.exports, "PerformanceAnalytics", () => $0eced7986dcab954$export$ec3c3b39c046a620);

var $5uXOq = parcelRequire("5uXOq");

var $fNobW = parcelRequire("fNobW");


var $2nbdU = parcelRequire("2nbdU");

var $3vR0I = parcelRequire("3vR0I");

var $7Wnap = parcelRequire("7Wnap");
const $0eced7986dcab954$export$ec3c3b39c046a620 = /*#__PURE__*/ (0, $5uXOq.memo)(({ view: view, loading: loading, itemsCount: itemsCount, attributes: attributes })=>{
    const loadingRef = (0, $5uXOq.useRef)(loading);
    loadingRef.current = loading;
    if (loading === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fNobW.default), {
        name: "performance-analytics-loading"
    });
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const scrollElement = false ? null : document.getElementById((0, $c15b7ab4e654e0c4$export$e5e75ff4daca6597));
    const product = view.startsWith('software') ? 'jsw' : 'jwm';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7Wnap.PageLoadMetrics), {
        view: view,
        attributes: attributes,
        product: product
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3vR0I.FirstInteractionMetric), {
        view: view,
        product: product
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2nbdU.default), {
        viewId: `${product}.${view}`,
        scrollElement: scrollElement,
        itemsCount: itemsCount,
        attributes: attributes
    }));
});

});
parcelRegister("2nbdU", function(module, exports) {

$parcel$export(module.exports, "default", () => $551da07557368f71$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

const $551da07557368f71$export$df7175b69b5630dd = (frames, elapsedMs)=>Math.min(Math.floor(1000 * (frames / elapsedMs)), (0, $ed1164448c2018a0$export$9d3e6d8a99023567));
const $551da07557368f71$export$46962be62755f053 = /*#__PURE__*/ (0, $5uXOq.memo)(({ viewId: viewId, itemsCount: itemsCount, samplingRate: samplingRate = (0, $ed1164448c2018a0$export$71d024136796e395), scrollElement: scrollElement, attributes: attributes })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const samplingCount = (0, $5uXOq.useRef)(0);
    const frames = (0, $5uXOq.useRef)(0);
    const rafId = (0, $5uXOq.useRef)(null);
    const start = (0, $5uXOq.useRef)(0);
    (0, $5uXOq.useEffect)(()=>{
        const container = scrollElement ?? document;
        const hasScrollCapture = true;
        const tick = ()=>{
            if (frames.current < (0, $ed1164448c2018a0$export$299249b1dad3b14a)) {
                frames.current += 1;
                rafId.current = requestAnimationFrame(tick);
            } else {
                const stopTime = performance.now();
                const elapsedMs = stopTime - start.current;
                const fps = $551da07557368f71$export$df7175b69b5630dd(frames.current, elapsedMs);
                const avgFrameDuration = Math.floor(elapsedMs / frames.current);
                frames.current = 0;
                const attr = {
                    ...attributes || {},
                    itemsCount: itemsCount,
                    avgFrameDuration: avgFrameDuration,
                    fps: fps
                };
                (0, $8zOmE.fireOperationalAnalyticsDeferred)(createAnalyticsEvent({}), `${viewId} scrolled`, attr);
            }
        };
        const handleOnScroll = ()=>{
            samplingCount.current += 1;
            if (samplingCount.current !== samplingRate) return;
            samplingCount.current = 0;
            // start counting frames
            start.current = performance.now();
            tick();
        };
        container.addEventListener('scroll', handleOnScroll, hasScrollCapture);
        return ()=>{
            container.removeEventListener('scroll', handleOnScroll, hasScrollCapture);
            if (rafId.current) cancelAnimationFrame(rafId.current);
        };
    }, [
        scrollElement,
        createAnalyticsEvent,
        itemsCount,
        samplingRate,
        viewId,
        attributes
    ]);
    return null;
});
var $551da07557368f71$export$2e2bcd8739ae039 = $551da07557368f71$export$46962be62755f053;

});
// how often do we measure, e.g. every 100th scroll
const $ed1164448c2018a0$export$71d024136796e395 = 100;
const $ed1164448c2018a0$export$299249b1dad3b14a = 20;
const $ed1164448c2018a0$export$9d3e6d8a99023567 = 60;


parcelRegister("3vR0I", function(module, exports) {

$parcel$export(module.exports, "FirstInteractionMetric", () => $43e497a79074b7d0$export$70b569bf2edd0b7f);

var $5uXOq = parcelRequire("5uXOq");


var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");
const $43e497a79074b7d0$export$70b569bf2edd0b7f = ({ view: view, product: product = 'jwm' })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const container = document.getElementById((0, $c15b7ab4e654e0c4$export$e5e75ff4daca6597)) ?? document;
        const hasScrollCapture = true;
        const startTime = performance.now();
        const handleFirstClick = ()=>{
            (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), `${product}.${view}.first-interaction clicked`, {
                duration: performance.now() - startTime
            });
            container.removeEventListener('click', handleFirstClick);
        };
        const handleFirstScroll = ()=>{
            (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), `${product}.${view}.first-interaction scrolled`, {
                duration: performance.now() - startTime
            });
            container.removeEventListener('scroll', handleFirstScroll, hasScrollCapture);
        };
        container.addEventListener('click', handleFirstClick);
        container.addEventListener('scroll', handleFirstScroll, hasScrollCapture);
        return ()=>{
            container.removeEventListener('click', handleFirstClick);
            container.removeEventListener('scroll', handleFirstScroll, hasScrollCapture);
        };
    }, [
        createAnalyticsEvent,
        view,
        product
    ]);
    return null;
};

});

parcelRegister("7Wnap", function(module, exports) {

$parcel$export(module.exports, "RenderStartMark", () => $4c177752bab6a832$export$2128f295d6adb861);
$parcel$export(module.exports, "PageLoadMetrics", () => $4c177752bab6a832$export$66b33c055cbb625e);

var $5uXOq = parcelRequire("5uXOq");

var $5rqex = parcelRequire("5rqex");


var $gN11a = parcelRequire("gN11a");
const $4c177752bab6a832$export$2128f295d6adb861 = ({ view: view, loading: loading })=>{
    if (loading === true) return null;
    (0, $gN11a.markViewMetric)(view, (0, $a286480ec63fa4c8$export$b78f0bbf209e5f4));
    return null;
};
const $4c177752bab6a832$export$66b33c055cbb625e = /*#__PURE__*/ (0, $5uXOq.memo)(({ view: view, attributes: attributes, product: product = 'jwm' })=>{
    // set UI_RENDER_END mark to indicate the end of UI render
    (0, $gN11a.markViewMetric)(view, (0, $a286480ec63fa4c8$export$88ea1e280513690f));
    const metric = (0, $gN11a.pageLoadMetrics)[view];
    return metric && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5rqex.default), {
        appName: `${product}.${view}`,
        metric: metric,
        extra: attributes
    });
});

});
parcelRegister("5rqex", function(module, exports) {

$parcel$export(module.exports, "checkAndEmitApdexSignal", () => $ab527e70454bab7e$export$3082c88b693a5230);
$parcel$export(module.exports, "default", () => $ab527e70454bab7e$export$2e2bcd8739ae039);
$parcel$export(module.exports, "baseDefaultProps", () => $ab527e70454bab7e$export$9b3029ee6188a41f);

var $5uXOq = parcelRequire("5uXOq");

var $99gkn = parcelRequire("99gkn");

var $aOr3t = parcelRequire("aOr3t");

var $1u4q7 = parcelRequire("1u4q7");

var $1AZST = parcelRequire("1AZST");

var $6G6w0 = parcelRequire("6G6w0");

var $3wLoG = parcelRequire("3wLoG");

var $gtdbK = parcelRequire("gtdbK");

var $zbAs4 = parcelRequire("zbAs4");

var $3B7oW = parcelRequire("3B7oW");
const $ab527e70454bab7e$export$3082c88b693a5230 = (appName, metricKey)=>{
    var emitSignal;
};
class $ab527e70454bab7e$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isExpectedToHaveSsr: false,
            withMarks: [],
            extra: {},
            emitOnAnimationFrame: false
        };
    }
    render() {
        const { appName: appName, metricKey: metricKey, extra: extra, metric: metric, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
        $ab527e70454bab7e$export$3082c88b693a5230(appName, metricKey);
        const isUFODefined = (0, $1AZST.GlobalPageLoadExperience).loadingPageLoadId !== 'UNKNOWN';
        if (isUFODefined) (0, $zbAs4.addUFOSSRDoneAsFMPToInteraction)();
        if (metric) {
            // https://product-fabric.atlassian.net/browse/UFO-323
            (0, $gtdbK.addBM3SSRDoneAsFMPToInteraction)(metric);
            (0, $3B7oW.trackBM3FeatureFlagsAccessed)(metric);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $99gkn.default), {
            data: extra
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aOr3t.UFOBM3TimingsToUFO), {
            marks: metric?.getData()?.marks,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            timings: metric?.getData()?.config?.timings
        }), isUFODefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3wLoG.StopUfo), {
            appName: appName,
            customData: extra,
            key: (0, $1u4q7.getInteractionId)().current
        }) : metric && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6G6w0.StopBrowserMetrics3), {
            metric: metric,
            customData: extra,
            emitOnAnimationFrame: emitOnAnimationFrame
        }));
    }
}
const $ab527e70454bab7e$export$9b3029ee6188a41f = $ab527e70454bab7e$export$2e2bcd8739ae039.defaultProps;

});
parcelRegister("aOr3t", function(module, exports) {

$parcel$export(module.exports, "getBm3Timings", () => $a3e67858f0c2f8da$export$f02972da195a43bb);
$parcel$export(module.exports, "UFOBM3TimingsToUFO", () => $a3e67858f0c2f8da$export$30f0b5e5acd268bf);
$parcel$export(module.exports, "addBM3TimingsToUFO", () => $a3e67858f0c2f8da$export$d93d677ef2f33c5c);

var $5uXOq = parcelRequire("5uXOq");

var $1tcYS = parcelRequire("1tcYS");

var $1u4q7 = parcelRequire("1u4q7");

var $bFU4G = parcelRequire("bFU4G");
function $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timingConfigs) {
    const bm3Timings = {};
    if (!marks || !timingConfigs) return bm3Timings;
    timingConfigs.forEach((item)=>{
        if (!item.startMark || !item.endMark) return;
        const startTime = marks[item.startMark];
        if (!startTime) return;
        const endTime = marks[item.endMark];
        if (!endTime) return;
        bm3Timings[item.key] = {
            startTime: startTime,
            endTime: endTime
        };
    });
    return bm3Timings;
}
function $a3e67858f0c2f8da$export$30f0b5e5acd268bf({ marks: marks, timings: timings }) {
    const interactionContext = (0, $5uXOq.useContext)((0, $1tcYS.default));
    const interactionId = (0, $1u4q7.getInteractionId)().current;
    (0, $5uXOq.useMemo)(()=>{
        if (interactionContext != null && interactionId != null && marks != null && timings != null) {
            const interactionType = (0, $bFU4G.getCurrentInteractionType)(interactionId);
            if (interactionType === 'press') return;
            const bm3Timings = $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timings);
            interactionContext.addCustomTimings(bm3Timings);
        }
    }, [
        interactionContext,
        interactionId,
        marks,
        timings
    ]);
    return null;
}
function $a3e67858f0c2f8da$export$d93d677ef2f33c5c(marks, timingsConfig) {
    const interactionId = (0, $1u4q7.getInteractionId)().current;
    if (interactionId) {
        const interactionType = (0, $bFU4G.getCurrentInteractionType)(interactionId);
        if (interactionType === 'press') return;
        const bm3Timings = $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timingsConfig);
        (0, $bFU4G.addCustomTiming)(interactionId, [], bm3Timings);
    }
}

});

parcelRegister("6G6w0", function(module, exports) {

$parcel$export(module.exports, "StopBrowserMetrics3", () => $84d0d168ebb35c8a$export$575e93c0f9905999);

var $5uXOq = parcelRequire("5uXOq");

var $1tcYS = parcelRequire("1tcYS");

var $21pfT = parcelRequire("21pfT");

var $x9xyg = parcelRequire("x9xyg");

var $7N30e = parcelRequire("7N30e");

var $4dRjY = parcelRequire("4dRjY");

var $2SVPM = parcelRequire("2SVPM");

var $6b6Tk = parcelRequire("6b6Tk");

const $84d0d168ebb35c8a$var$emitMetrics = (metric, customData, stopTime)=>{
    (0, $2SVPM.setInitialPageLoadTimingFromPerformanceMarks)('batch-js-heritage.eval', 'jira.heritage_batch_file_eval:start', 'jira.heritage_batch_file_eval:end');
    if (stopTime !== undefined) metric.stop({
        customData: customData,
        stopTime: stopTime
    });
    else metric.stop({
        customData: customData
    });
    if ((0, $6b6Tk.isAutomaticExposureCollectionEnabled)()) (0, $7N30e.stopLowPriorityEventDelay)();
};
class $84d0d168ebb35c8a$export$575e93c0f9905999 extends (0, $5uXOq.Component) {
    componentDidMount() {
        const { metric: metric, customData: customData, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
        if (!metric) return;
        const start = (0, $21pfT.browserMetrics).getPageLoadMetric()?.getData()?.start || 0;
        (0, $x9xyg.setMark)('BROWSER_METRICS_TTI_START', {
            startTime: start
        });
        (0, $x9xyg.setMark)('BROWSER_METRICS_TTI_END');
        (0, $x9xyg.setMeasure)('BROWSER_METRICS_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_END');
        const bm3Data = metric.getData();
        if (emitOnAnimationFrame) {
            const stopTime = performance.now();
            (0, $2SVPM.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $4dRjY.PRODUCT_START_MARK), true);
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: stopTime
            });
            if (typeof queueMicrotask !== 'undefined') queueMicrotask(()=>{
                (0, $x9xyg.setMark)('BROWSER_METRICS_TTI_TASK_END');
                (0, $x9xyg.setMeasure)('BROWSER_METRICS_TTI_TASK', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_TASK_END');
            });
            requestAnimationFrame(()=>{
                metric.mark((0, $ce556f125dee8174$export$99c08ec92759c71c));
                (0, $x9xyg.setMark)((0, $ce556f125dee8174$export$99c08ec92759c71c));
                (0, $x9xyg.setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $ce556f125dee8174$export$99c08ec92759c71c));
                setTimeout(()=>{
                    $84d0d168ebb35c8a$var$emitMetrics(metric, customData, stopTime);
                }, 500);
            });
        } else {
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: performance.now()
            });
            (0, $2SVPM.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $4dRjY.PRODUCT_START_MARK), true);
            $84d0d168ebb35c8a$var$emitMetrics(metric, customData);
        }
    }
    static{
        this.contextType = (0, $1tcYS.default);
    }
    render() {
        return null;
    }
}

});
parcelRegister("4dRjY", function(module, exports) {

$parcel$export(module.exports, "PRODUCT_START_MARK", () => $9953c23a4f71adac$export$8e54fca0a680fdfd);
$parcel$export(module.exports, "MarkProductStart", () => $9953c23a4f71adac$export$2a999c5f84501025);

var $x9xyg = parcelRequire("x9xyg");
const $9953c23a4f71adac$export$8e54fca0a680fdfd = 'PRODUCT_START';
const $9953c23a4f71adac$export$2a999c5f84501025 = ()=>{
    if (!false) {
        performance.clearMarks($9953c23a4f71adac$export$8e54fca0a680fdfd);
        (0, $x9xyg.setMark)($9953c23a4f71adac$export$8e54fca0a680fdfd);
    }
    return null;
};

});

const $ce556f125dee8174$export$56940a9488e85199 = 'jira.fe.spa-';
const $ce556f125dee8174$export$45c4b6bf7935c69a = `${$ce556f125dee8174$export$56940a9488e85199}start`;
const $ce556f125dee8174$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $ce556f125dee8174$export$ff834eccc35b9089 = 'appBundleReady';
const $ce556f125dee8174$export$86b05e34d462ead8 = 'prefetchApiReady';
const $ce556f125dee8174$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $ce556f125dee8174$export$3ae43cc1782d058f = 'jswRenderStart';
const $ce556f125dee8174$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $ce556f125dee8174$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $ce556f125dee8174$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $ce556f125dee8174$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $ce556f125dee8174$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $ce556f125dee8174$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $ce556f125dee8174$export$99c08ec92759c71c = 'tti-raf-mark';
const $ce556f125dee8174$export$48552baa9db8ce1d = 'tti-raf';


parcelRegister("3wLoG", function(module, exports) {

$parcel$export(module.exports, "StopUfo", () => $bc9c50f4292c4530$export$d91154f099475c5);

var $5uXOq = parcelRequire("5uXOq");

var $1tcYS = parcelRequire("1tcYS");

var $1AZST = parcelRequire("1AZST");
class $bc9c50f4292c4530$export$d91154f099475c5 extends (0, $5uXOq.Component) {
    componentDidMount() {
        const { customData: customData, appName: appName } = this.props;
        (0, $1AZST.GlobalPageLoadExperience).success({
            force: true,
            metadata: customData
        });
        const name = appName || (0, $1AZST.GlobalPageLoadExperience).loadingPageLoadId;
        if (name) this.context?.addApdex({
            key: name,
            stopTime: performance.now()
        });
    }
    static{
        this.contextType = (0, $1tcYS.default);
    }
    render() {
        return null;
    }
}

});

parcelRegister("gtdbK", function(module, exports) {

$parcel$export(module.exports, "addBM3SSRDoneAsFMPToInteraction", () => $9088c71f7c9189f4$export$bf239ac2bfb04967);

var $1u4q7 = parcelRequire("1u4q7");

var $bFU4G = parcelRequire("bFU4G");
function $9088c71f7c9189f4$export$bf239ac2bfb04967(metric) {
    const interactionId = (0, $1u4q7.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // Use BM3 SSR mark as FMP config for UFO if it exists, temporarily.
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && data?.isInitial) (0, $bFU4G.addMetadata)(currentInteractionId, {
        __legacy__bm3ConfigSSRDoneAsFmp: config.ssr?.doneAsFmp || false
    });
}

});

parcelRegister("zbAs4", function(module, exports) {

$parcel$export(module.exports, "addUFOSSRDoneAsFMPToInteraction", () => $30d390cd1767d57f$export$e63862cd888fe05a);

var $1u4q7 = parcelRequire("1u4q7");

var $bFU4G = parcelRequire("bFU4G");

var $1AZST = parcelRequire("1AZST");
var $49z18 = parcelRequire("49z18");
async function $30d390cd1767d57f$export$e63862cd888fe05a() {
    const interactionId = (0, $1u4q7.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    // Use UFO SSR mark as FMP config for rUFO if it exists, temporarily.
    const data = await (0, $1AZST.GlobalPageLoadExperience).exportData();
    const fmpMark = data.metrics.marks.find((mark)=>mark.name === 'fmp') || (0, $49z18.payloadPublisher).ssr?.getDoneMark();
    if (data.initial && fmpMark) (0, $bFU4G.addMetadata)(currentInteractionId, {
        __legacy__ufoConfigSSRDoneAsFmp: true
    });
}

});

parcelRegister("3B7oW", function(module, exports) {

$parcel$export(module.exports, "trackBM3FeatureFlagsAccessed", () => $afa764d83f81f55e$export$f00f1e874ce869e9);

var $1u4q7 = parcelRequire("1u4q7");

var $y7eb2 = parcelRequire("y7eb2");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $afa764d83f81f55e$var$startsAsObject = (value)=>{
    try {
        if (value.charAt(0) === '{') return true;
    } catch (e) {
        return false;
    }
    return false;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $afa764d83f81f55e$var$isObject = (value)=>value && typeof value === 'object' && value.constructor === Object;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $afa764d83f81f55e$var$isString = (input)=>{
    let result;
    try {
        result = typeof input === 'string' || input instanceof String;
    } catch (err) {
        // swallow any errors
        result = false;
    }
    return result;
};
const $afa764d83f81f55e$export$7b4abba432e57989 = (value)=>$afa764d83f81f55e$var$isString(value) && $afa764d83f81f55e$var$startsAsObject(value) || $afa764d83f81f55e$var$isObject(value);
const $afa764d83f81f55e$export$fcc03ee4c944962f = (featureFlagValue)=>$afa764d83f81f55e$export$7b4abba432e57989(featureFlagValue) ? 'non_boolean' : featureFlagValue;
const $afa764d83f81f55e$export$d2818866b4acbea4 = new Map();
const $afa764d83f81f55e$export$f00f1e874ce869e9 = (metric)=>{
    const interactionId = (0, $1u4q7.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && config?.featureFlags?.length) {
        const allFeatureFlags = (0, $y7eb2.default)();
        config.featureFlags.forEach((featureFlagName)=>{
            const value = allFeatureFlags[featureFlagName];
            if (value === undefined) return;
            const featureFlagValue = $afa764d83f81f55e$export$fcc03ee4c944962f(value);
            $afa764d83f81f55e$export$d2818866b4acbea4.set(featureFlagName, featureFlagValue);
        });
    }
};

});




parcelRegister("ai0FS", function(module, exports) {

$parcel$export(module.exports, "SignupInviteModal", () => $f77380779db19e53$export$eb44438138f66a46);

var $5uXOq = parcelRequire("5uXOq");

var $b71gk = parcelRequire("b71gk");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $f77380779db19e53$var$LazySignupInviteModal = (0, $kxZPA.lazy)(()=>(parcelRequire("30vGX")).then(({ SignupInviteModal: SignupInviteModal })=>SignupInviteModal), {
    ssr: false,
    moduleId: "./src/packages/business/shared/components/signup-invite-modal/src/ui/main.tsx"
});
const $f77380779db19e53$export$eb44438138f66a46 = /*#__PURE__*/ (0, $5uXOq.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "jira-business.signup-invite-modal.modal",
        packageName: "jira-business.signup-invite-modal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "signup-invite-modal",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f77380779db19e53$var$LazySignupInviteModal, null))));

});
parcelRegister("30vGX", function(module, exports) {

let $2309f48d09759e13$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2309f48d09759e13$var$load("lsIX4").then(()=>parcelRequire('jJ3Ht'));

});


parcelRegister("7yduy", function(module, exports) {

$parcel$export(module.exports, "JWMSpaStatePageReady", () => $150b436063f0aaae$export$d54524c142a057f);

var $5uXOq = parcelRequire("5uXOq");

var $dZw8H = parcelRequire("dZw8H");
const $150b436063f0aaae$export$d54524c142a057f = ()=>{
    const [isReady, setIsReady] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        /**
		 * Waiting for 2 animation frames is equivalent to waiting for react to paint the DOM.
		 */ // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        let id = window.requestAnimationFrame(()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            id = window.requestAnimationFrame(()=>{
                setIsReady(true);
            });
        });
        return ()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.cancelAnimationFrame(id);
        };
    }, []);
    if (!isReady) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZw8H.SpaStatePageReady), null);
};

});

parcelRegister("3adKM", function(module, exports) {

$parcel$export(module.exports, "useDropHandler", () => $c2c00faa4cc00c7d$export$c0f5f9f6a076ec6b);

var $5uXOq = parcelRequire("5uXOq");

var $biEfA = parcelRequire("biEfA");

var $3m5yC = parcelRequire("3m5yC");

var $7gWdR = parcelRequire("7gWdR");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $2PV8T = parcelRequire("2PV8T");

var $lW2vI = parcelRequire("lW2vI");

var $kiyQL = parcelRequire("kiyQL");

var $dI6Zj = parcelRequire("dI6Zj");

var $dblxc = parcelRequire("dblxc");
const $c2c00faa4cc00c7d$export$c0f5f9f6a076ec6b = ({ initialPageLoading: initialPageLoading, columnIds: columnIds, onColumnsReordered: onColumnsReordered, categoryField: categoryField })=>{
    const moveIssue = (0, $lW2vI.useMoveIssue)();
    const { cancelCardDrop: cancelCardDrop, confirmCardDrop: confirmCardDrop } = (0, $kiyQL.useCancelConfirmCardDrop)();
    const { transitions: transitions } = (0, $2PV8T.useIssueTransitions)();
    const { draggedIssue: draggedIssue, dropTarget: dropTarget, sourceGroup: sourceGroup } = (0, $kiyQL.useCardDragDrop)();
    const resetDraggedColumn = (0, $dI6Zj.useResetDraggedColumn)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>(0, $7gWdR.monitorForElements)({
            canMonitor: ()=>!initialPageLoading,
            onDrop: ({ location: location, source: source })=>{
                const sourceData = source.data;
                if (location.current.dropTargets[0]?.data == null) {
                    if ((0, $dblxc.isCard)(sourceData)) {
                        cancelCardDrop();
                        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'card invalidDrop');
                    }
                    return;
                }
                const destinationData = location.current.dropTargets[0].data;
                // Dropping a card.
                if ((0, $dblxc.isCard)(sourceData) && draggedIssue != null) {
                    // Dropping a card next to another card.
                    if ((0, $dblxc.isCard)(destinationData)) {
                        const closestEdgeOfTarget = (0, $biEfA.extractClosestEdge)(destinationData);
                        const sourceIndex = sourceData.cardIndex;
                        const destinationIndex = destinationData.cardIndex;
                        const sourceColumnId = sourceData.columnId;
                        const destinationColumnId = destinationData.columnId;
                        // Return early if unable to determine the closest edge of the target.
                        if (closestEdgeOfTarget == null) {
                            cancelCardDrop();
                            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'card invalidDrop');
                            return;
                        }
                        // Return early if the card is dropped in the same place.
                        if (sourceData.issueId === destinationData.issueId) {
                            cancelCardDrop();
                            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'card invalidDrop');
                            return;
                        }
                        // Return early if the drop location would not result in a change in rank.
                        // e.g. dropping a card near the bottom of the previous card or near the top of the next card.
                        if (sourceColumnId === destinationColumnId && (0, $dblxc.isClosestEdgeAdjacentToSource)(sourceIndex, destinationIndex, closestEdgeOfTarget)) {
                            cancelCardDrop();
                            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'card invalidDrop');
                            return;
                        }
                        moveIssue({
                            issue: draggedIssue,
                            sourceGroup: sourceGroup,
                            destinationGroup: dropTarget.group,
                            rank: {
                                position: closestEdgeOfTarget === 'top' ? 'before' : 'after',
                                relativeIssueId: destinationData.issueId
                            },
                            transition: dropTarget.transition,
                            categoryField: categoryField
                        });
                        confirmCardDrop();
                    } else if ((0, $dblxc.isColumn)(destinationData) || (0, $dblxc.isTransitionZone)(destinationData)) {
                        if (!dropTarget.group) return;
                        const transition = (0, $dblxc.isColumn)(destinationData) ? dropTarget.transition : transitions.find((t)=>t.transitionId === destinationData.transitionId);
                        // prevents calling moveIssue when the dropTarget is updated with the wrong group when dragging a card across multiple transition zones within the same column
                        // the moveIssue will be handled by the transition zone
                        if ((0, $dblxc.isTransitionZone)(destinationData) && transition?.toStatusId !== Number(dropTarget.group.id)) return;
                        moveIssue({
                            issue: draggedIssue,
                            sourceGroup: sourceGroup,
                            destinationGroup: dropTarget.group,
                            transition: transition,
                            categoryField: categoryField
                        });
                        confirmCardDrop();
                    } else {
                        cancelCardDrop();
                        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'card invalidDrop');
                    }
                }
                // Dropping a column.
                if ((0, $dblxc.isColumn)(sourceData) && (0, $dblxc.isColumn)(destinationData)) {
                    resetDraggedColumn();
                    const sourceIndex = sourceData.index;
                    const destinationIndex = destinationData.index;
                    if (sourceIndex === destinationIndex) return;
                    const closestEdgeOfTarget = (0, $biEfA.extractClosestEdge)(destinationData);
                    // Return early if the drop location would not change the order of the columns.
                    // e.g. dropping a column near the right edge of the previous column or near the left edge of the next column.
                    if ((0, $dblxc.isClosestEdgeAdjacentToSource)(sourceIndex, destinationIndex, closestEdgeOfTarget)) return;
                    const reorderedColumnIds = (0, $3m5yC.reorderWithEdge)({
                        list: columnIds,
                        startIndex: sourceIndex,
                        indexOfTarget: destinationIndex,
                        closestEdgeOfTarget: closestEdgeOfTarget,
                        axis: 'horizontal'
                    });
                    onColumnsReordered(reorderedColumnIds);
                }
            }
        }), [
        cancelCardDrop,
        confirmCardDrop,
        createAnalyticsEvent,
        draggedIssue,
        dropTarget.transition,
        initialPageLoading,
        moveIssue,
        transitions,
        dropTarget.group,
        sourceGroup,
        columnIds,
        onColumnsReordered,
        categoryField,
        resetDraggedColumn
    ]);
};

});
parcelRegister("biEfA", function(module, exports) {

$parcel$export(module.exports, "attachClosestEdge", () => $934cfe81468fb31a$export$f0cafff222395e89);
$parcel$export(module.exports, "extractClosestEdge", () => $934cfe81468fb31a$export$945a571f3b658bf);
const $934cfe81468fb31a$var$getDistanceToEdge = {
    top: (rect, client)=>Math.abs(client.y - rect.top),
    right: (rect, client)=>Math.abs(rect.right - client.x),
    bottom: (rect, client)=>Math.abs(rect.bottom - client.y),
    left: (rect, client)=>Math.abs(client.x - rect.left)
};
// using a symbol so we can guarantee a key with a unique value
const $934cfe81468fb31a$var$uniqueKey = Symbol('closestEdge');
function $934cfe81468fb31a$export$f0cafff222395e89(userData, { element: element, input: input, allowedEdges: allowedEdges }) {
    const client = {
        x: input.clientX,
        y: input.clientY
    };
    // I tried caching the result of `getBoundingClientRect()` for a single
    // frame in order to improve performance.
    // However, on measurement I saw no improvement. So no longer caching
    const rect = element.getBoundingClientRect();
    const entries = allowedEdges.map((edge)=>{
        return {
            edge: edge,
            value: $934cfe81468fb31a$var$getDistanceToEdge[edge](rect, client)
        };
    });
    // edge can be `null` when `allowedEdges` is []
    const addClosestEdge = entries.sort((a, b)=>a.value - b.value)[0]?.edge ?? null;
    return {
        ...userData,
        [$934cfe81468fb31a$var$uniqueKey]: addClosestEdge
    };
}
function $934cfe81468fb31a$export$945a571f3b658bf(userData) {
    return userData[$934cfe81468fb31a$var$uniqueKey] ?? null;
}

});

parcelRegister("3m5yC", function(module, exports) {

$parcel$export(module.exports, "reorderWithEdge", () => $503dd84564f0390c$export$d0bc664d2812b3ba);
parcelRequire("ii3zs");
var $a44uV = parcelRequire("a44uV");

var $9EGGH = parcelRequire("9EGGH");
function $503dd84564f0390c$export$d0bc664d2812b3ba({ list: list, startIndex: startIndex, closestEdgeOfTarget: closestEdgeOfTarget, indexOfTarget: indexOfTarget, axis: axis }) {
    return (0, $a44uV.reorder)({
        list: list,
        startIndex: startIndex,
        finishIndex: (0, $9EGGH.getReorderDestinationIndex)({
            closestEdgeOfTarget: closestEdgeOfTarget,
            startIndex: startIndex,
            indexOfTarget: indexOfTarget,
            axis: axis
        })
    });
}

});
parcelRegister("ii3zs", function(module, exports) {

$parcel$export(module.exports, "reorder", () => (parcelRequire("a44uV")).reorder);

var $a44uV = parcelRequire("a44uV");

});
parcelRegister("a44uV", function(module, exports) {

$parcel$export(module.exports, "reorder", () => $921c81942b5fc66a$export$fc77a6137e3f91c);
/**
 * A function that will reorder an array (`list`).
 * `reorder` returns a new array with reordered items and does not
 *  modify the original array. The items in the array are also not modified.
 */ function $921c81942b5fc66a$export$fc77a6137e3f91c({ list: list, startIndex: startIndex, finishIndex: finishIndex }) {
    if (startIndex === -1 || finishIndex === -1) // Making this function consistently return a new array reference.
    // This is consistent with .toSorted() which always returns a new array
    // even when it does not do anything
    return Array.from(list);
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(finishIndex, 0, removed);
    return result;
}

});


parcelRegister("9EGGH", function(module, exports) {

$parcel$export(module.exports, "getReorderDestinationIndex", () => $178b6900979d74e0$export$846f792f51b92b6e);
function $178b6900979d74e0$export$846f792f51b92b6e({ startIndex: startIndex, closestEdgeOfTarget: closestEdgeOfTarget, indexOfTarget: indexOfTarget, axis: axis }) {
    // invalid index's
    if (startIndex === -1 || indexOfTarget === -1) return startIndex;
    // if we are targeting the same index we don't need to do anything
    if (startIndex === indexOfTarget) return startIndex;
    if (closestEdgeOfTarget == null) return indexOfTarget;
    const isGoingAfter = axis === 'vertical' && closestEdgeOfTarget === 'bottom' || axis === 'horizontal' && closestEdgeOfTarget === 'right';
    const isMovingForward = startIndex < indexOfTarget;
    // moving forward
    if (isMovingForward) return isGoingAfter ? indexOfTarget : indexOfTarget - 1;
    // moving backwards
    return isGoingAfter ? indexOfTarget + 1 : indexOfTarget;
}

});


parcelRegister("lW2vI", function(module, exports) {

$parcel$export(module.exports, "useMoveIssue", () => $33811029666865a4$export$47e46c713d0f867d);

var $5uXOq = parcelRequire("5uXOq");

var $hE5wF = parcelRequire("hE5wF");

var $gULOk = parcelRequire("gULOk");

var $5fc53 = parcelRequire("5fc53");

var $4R6GH = parcelRequire("4R6GH");

var $cvj5l = parcelRequire("cvj5l");

var $jTnjM = parcelRequire("jTnjM");

var $kiyQL = parcelRequire("kiyQL");

var $1Eg2O = parcelRequire("1Eg2O");

var $71Bze = parcelRequire("71Bze");
const $33811029666865a4$var$isIssueNewlyMarkedAsDone = (sourceColumn, destinationColumn)=>{
    if (sourceColumn.type !== (0, $hE5wF.GROUP_BY_STATUS)) return false;
    return sourceColumn.statusCategoryId !== (0, $gULOk.StatusCategoryIds).done && destinationColumn.statusCategoryId === (0, $gULOk.StatusCategoryIds).done;
};
const $33811029666865a4$export$47e46c713d0f867d = ()=>{
    const { addConfettiColumn: addConfettiColumn } = (0, $jTnjM.useConfettiColumnsActions)();
    const updateIssue = (0, $71Bze.useUpdateIssue)();
    const { fireCardDropAnalytics: fireCardDropAnalytics } = (0, $1Eg2O.useCardDragDropAnalytics)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const updateSessionId = (0, $4R6GH.fg)('one_event_improvements_1') ? undefined : (0, $kiyQL.useUpdateSessionId)();
    return (0, $5uXOq.useCallback)(async ({ issue: issue, sourceGroup: sourceGroup, destinationGroup: destinationGroup, rank: rank, transition: transition, categoryField: categoryField })=>{
        let showConfetti = false;
        if (sourceGroup == null || destinationGroup == null) throw new Error('Source or destination group not found');
        const destinationGroupType = destinationGroup.type;
        const fieldUpdates = {};
        if (sourceGroup.id !== destinationGroup.id) switch(destinationGroupType){
            case 0, $hE5wF.GROUP_BY_ASSIGNEE:
                fieldUpdates[0, $cvj5l.ASSIGNEE_ID] = destinationGroup.id === (0, $cvj5l.NULL_GROUP_KEY) ? undefined : {
                    fieldId: (0, $5fc53.ASSIGNEE_TYPE),
                    type: (0, $cvj5l.BOARD_FIELD_USER),
                    value: destinationGroup.id,
                    user: {
                        accountId: destinationGroup.id,
                        avatarURL: destinationGroup.imageUrl,
                        name: destinationGroup.name
                    }
                };
                break;
            case 0, $hE5wF.GROUP_BY_CATEGORY:
                if (categoryField) fieldUpdates[0, $cvj5l.CATEGORY_ID] = destinationGroup.id === (0, $cvj5l.NULL_GROUP_KEY) ? undefined : {
                    name: categoryField.displayName,
                    fieldId: categoryField.fieldId,
                    type: (0, $cvj5l.BOARD_FIELD_CATEGORY),
                    value: destinationGroup.id,
                    category: {
                        color: destinationGroup.color,
                        name: destinationGroup.name
                    }
                };
                break;
            case 0, $hE5wF.GROUP_BY_PRIORITY:
                fieldUpdates[0, $cvj5l.PRIORITY_ID] = destinationGroup.id === (0, $cvj5l.NULL_GROUP_KEY) ? undefined : {
                    fieldId: (0, $5fc53.PRIORITY_TYPE),
                    type: (0, $cvj5l.BOARD_FIELD_PRIORITY),
                    value: destinationGroup.id,
                    priority: {
                        id: destinationGroup.id,
                        iconUrl: destinationGroup.imageUrl ?? '',
                        name: destinationGroup.name
                    }
                };
                break;
            case 0, $hE5wF.GROUP_BY_STATUS:
                showConfetti = !destinationGroup.isCollapsed && $33811029666865a4$var$isIssueNewlyMarkedAsDone(sourceGroup, destinationGroup);
                fieldUpdates[0, $cvj5l.STATUS_ID] = {
                    fieldId: (0, $5fc53.STATUS_TYPE),
                    type: (0, $cvj5l.BOARD_FIELD_STATUS),
                    value: destinationGroup.id,
                    status: {
                        id: destinationGroup.id,
                        statusCategoryId: destinationGroup.statusCategoryId,
                        name: destinationGroup.name
                    }
                };
                break;
            default:
                {
                    const exhaustiveCheck = destinationGroupType;
                    throw new Error(`Unexpected destination group type: ${exhaustiveCheck}`);
                }
        }
        try {
            await updateIssue({
                issue: issue,
                fields: fieldUpdates,
                transition: transition,
                rank: rank,
                categoryFieldId: categoryField?.fieldId ?? null
            });
            if (showConfetti) addConfettiColumn(destinationGroup.id);
            if (!(0, $4R6GH.fg)('one_event_improvements_1')) {
                if (updateSessionId == null) throw new Error('updateSessionId is required for card drop analytics');
            }
            fireCardDropAnalytics({
                issue: issue,
                sourceGroup: sourceGroup,
                destinationGroup: destinationGroup,
                rank: rank,
                transition: transition,
                ...!updateSessionId ? {} : {
                    updateSessionId: updateSessionId
                }
            });
        } catch (error) {
        // errors handled in updateIssue controller
        }
    }, [
        addConfettiColumn,
        fireCardDropAnalytics,
        updateIssue,
        updateSessionId
    ]);
};

});
parcelRegister("71Bze", function(module, exports) {

$parcel$export(module.exports, "useUpdateIssue", () => $155daef0aae13763$export$5ad547ae8fa63f55);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");

var $pa9q9 = parcelRequire("pa9q9");

var $dTUtq = parcelRequire("dTUtq");

var $cvj5l = parcelRequire("cvj5l");

var $cy1Jt = parcelRequire("cy1Jt");

var $d5RIK = parcelRequire("d5RIK");

var $lLmHi = parcelRequire("lLmHi");

var $1uL7Q = parcelRequire("1uL7Q");

var $em4SX = parcelRequire("em4SX");

var $hqsgn = parcelRequire("hqsgn");

var $gEtYC = parcelRequire("gEtYC");

var $6xpM6 = parcelRequire("6xpM6");

var $7OM52 = parcelRequire("7OM52");

var $hfX4S = parcelRequire("hfX4S");

var $9LhEA = parcelRequire("9LhEA");
// eslint-disable-next-line @typescript-eslint/no-empty-function, @typescript-eslint/no-explicit-any
const $155daef0aae13763$var$noop = (_arg1, _arg2)=>{};
const $155daef0aae13763$export$5ad547ae8fa63f55 = ()=>{
    const { showFlag: showFlag } = (0, $pa9q9.useFlagService)();
    const { updateIssueFields: updateIssueFields, updateIssues: updateIssues } = (0, $gEtYC.useIssueStoreActions)();
    const transformToIssues = (0, $hqsgn.useTransformIssues)();
    const refetchIssues = (0, $6xpM6.useRefetchIssues)();
    const transitionAndRankIssueService = (0, $cy1Jt.useTransitionAndRankIssueService)();
    const updateAssignee = (0, $d5RIK.useUpdateAssignee)();
    const updatePriority = (0, $1uL7Q.useUpdatePriority)();
    const updateCategory = (0, $lLmHi.useUpdateCategory)();
    const openTransitionScreenModal = (0, $hfX4S.useTransitionScreenModal)();
    const fieldIds = (0, $7OM52.useFieldIds)();
    const { showIssueTransitionSuccessFlag: showIssueTransitionSuccessFlag } = (0, $4R6GH.fg)('show-modernised-issue-transition-success-flag') ? (0, $dTUtq.useShowFlag)() : {
        showIssueTransitionSuccessFlag: $155daef0aae13763$var$noop
    };
    return (0, $5uXOq.useCallback)(async ({ issue: issue, fields: fields, rank: rank, transition: transition, categoryFieldId: categoryFieldId })=>{
        // optimistically update the issue fields
        updateIssueFields({
            issueId: issue.id,
            fields: fields,
            rank: rank
        });
        const issueKey = issue.fields[0, $cvj5l.ISSUE_KEY_ID].value;
        let hasTriedFieldsUpdate = false;
        let hasTriedStatusTransition = false;
        let hasTriedRanking = false;
        try {
            // perform field updates first as the mutations/endpoints
            // cannot return the full issue data
            if (fields != null) {
                if ((0, $cvj5l.ASSIGNEE_ID) in fields) {
                    hasTriedFieldsUpdate = true;
                    await updateAssignee({
                        issueId: issue.id,
                        assigneeId: fields[0, $cvj5l.ASSIGNEE_ID]?.user.accountId ?? null
                    });
                } else if ((0, $cvj5l.PRIORITY_ID) in fields && fields[0, $cvj5l.PRIORITY_ID]?.priority.id != null) {
                    hasTriedFieldsUpdate = true;
                    await updatePriority({
                        issueId: issue.id,
                        priorityId: fields[0, $cvj5l.PRIORITY_ID].priority.id
                    });
                } else if ((0, $cvj5l.CATEGORY_ID) in fields && categoryFieldId != null) {
                    hasTriedFieldsUpdate = true;
                    await updateCategory({
                        issueId: issue.id,
                        optionId: fields[0, $cvj5l.CATEGORY_ID]?.value ?? null,
                        categoryFieldId: categoryFieldId
                    });
                }
            }
            if (transition != null || rank != null) {
                hasTriedStatusTransition = transition != null;
                hasTriedRanking = rank != null;
                if (transition?.hasScreen) {
                    // if the transition has a screen, the transition is done through the modal
                    await openTransitionScreenModal(issue, transition.transitionId);
                    // only the ranking needs to be updated after the transition
                    if (rank == null) refetchIssues([
                        issue.id
                    ]);
                    else {
                        const response = await transitionAndRankIssueService({
                            fieldIds: fieldIds,
                            issueId: issue.id,
                            rank: rank
                        });
                        updateIssues(transformToIssues([
                            response
                        ]));
                    }
                } else {
                    const response = await transitionAndRankIssueService({
                        fieldIds: fieldIds,
                        issueId: issue.id,
                        rank: rank,
                        transitionId: transition?.transitionId
                    });
                    updateIssues(transformToIssues([
                        response
                    ]));
                }
                const destinationStatusName = fields?.[0, $cvj5l.STATUS_ID]?.status.name;
                if (destinationStatusName != null && (0, $4R6GH.fg)('show-modernised-issue-transition-success-flag')) showIssueTransitionSuccessFlag(issueKey, destinationStatusName);
            }
        } catch (error) {
            // if anything failed, refetch issues
            refetchIssues([
                issue.id
            ]);
            // if the user cancelled the transition modal, do not show an error flag
            if (error instanceof (0, $hfX4S.TransitionModalCanceled)) throw error;
            if (error instanceof (0, $cy1Jt.TransitionValidationError)) showFlag({
                type: 'warning',
                title: (0, $9LhEA.default).transitionValidationErrorTitle,
                description: error.message,
                messageId: 'work-management-board.controllers.update-issue.show-flag.warning.transition-validation-error',
                messageType: 'transactional'
            });
            else if (hasTriedStatusTransition) showFlag({
                type: 'error',
                title: (0, $9LhEA.default).failedToTransitionErrorTitle,
                description: (0, $9LhEA.default).failedToTransitionErrorDescription,
                messageId: 'work-management-board.controllers.update-issue.show-flag.error.failed-to-transition-error',
                messageType: 'transactional'
            });
            else if (error instanceof (0, $em4SX.UpdateFieldsValidationError)) showFlag({
                type: 'error',
                title: (0, $9LhEA.default).failedToUpdateFieldsErrorTitle,
                description: error.message ?? (0, $9LhEA.default).failedToUpdateFieldsErrorDescription,
                messageId: 'work-management-board.controllers.update-issue.show-flag.error.failed-to-update-fields-error.update-fields-validation-error',
                messageType: 'transactional'
            });
            else if (hasTriedFieldsUpdate) showFlag({
                type: 'error',
                title: (0, $9LhEA.default).failedToUpdateFieldsErrorTitle,
                description: (0, $9LhEA.default).failedToUpdateFieldsErrorDescription,
                messageId: 'work-management-board.controllers.update-issue.show-flag.error.failed-to-update-fields-error.has-tried-fields-update',
                messageType: 'transactional'
            });
            else if (hasTriedRanking) showFlag({
                type: 'error',
                title: (0, $9LhEA.default).failedToRankErrorTitle,
                description: (0, $9LhEA.default).failedToRankErrorDescription,
                messageId: 'work-management-board.controllers.update-issue.show-flag.error.has-tried-ranking',
                messageType: 'transactional'
            });
            throw error;
        }
    }, [
        updateIssueFields,
        updateAssignee,
        updatePriority,
        updateCategory,
        openTransitionScreenModal,
        refetchIssues,
        transitionAndRankIssueService,
        fieldIds,
        updateIssues,
        transformToIssues,
        showIssueTransitionSuccessFlag,
        showFlag
    ]);
};

});
parcelRegister("dTUtq", function(module, exports) {

$parcel$export(module.exports, "useShowFlag", () => $4e3d7d0cd8105532$export$46b5557ad4264ef7);

var $5uXOq = parcelRequire("5uXOq");

var $lTEVZ = parcelRequire("lTEVZ");

var $pa9q9 = parcelRequire("pa9q9");

var $koVbs = parcelRequire("koVbs");

var $6OtcO = parcelRequire("6OtcO");
const $4e3d7d0cd8105532$export$46b5557ad4264ef7 = ()=>{
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const showIssueTransitionSuccessFlag = (0, $5uXOq.useCallback)((issueKey, status)=>{
        try {
            showFlag((0, $6OtcO.getTransitionSuccessFlag)(issueKey, status, formatMessage));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $lTEVZ.fireIssueTransitionErrorAnalytics)({
                meta: {
                    id: 'showSuccessFlag',
                    packageName: 'jiraIssueTransitionUseShowFlag',
                    teamName: 'gryffindor'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        }
    }, [
        formatMessage,
        showFlag
    ]);
    const showIssueTransitionFailureFlag = (0, $5uXOq.useCallback)((issueKey, traceId)=>showFlag((0, $6OtcO.getTransitionFailureFlag)(issueKey, formatMessage, traceId)), [
        formatMessage,
        showFlag
    ]);
    return {
        showIssueTransitionSuccessFlag: showIssueTransitionSuccessFlag,
        showIssueTransitionFailureFlag: showIssueTransitionFailureFlag
    };
};

});
parcelRegister("lTEVZ", function(module, exports) {

$parcel$export(module.exports, "fireIssueTransitionErrorAnalytics", () => $63e82840dc2f165f$export$3839c9497170b08f);

var $jcw0u = parcelRequire("jcw0u");

var $4R6GH = parcelRequire("4R6GH");

var $fukJp = parcelRequire("fukJp");
const $63e82840dc2f165f$export$3839c9497170b08f = (payload)=>{
    if (!(0, $4R6GH.fg)('issue-transition-fire-error-analytics-refactor')) return (0, $jcw0u.default)(payload);
    const { attributes: attributes = {}, error: error, ...otherPayload } = payload;
    (0, $fukJp.fireErrorAnalyticsCommon)({
        ...otherPayload,
        attributes: {
            ...attributes
        },
        error: error
    });
};

});
parcelRegister("fukJp", function(module, exports) {

$parcel$export(module.exports, "fireErrorAnalyticsCommon", () => $2a45d398159543ce$export$51f199f6846377f7);

var $jcw0u = parcelRequire("jcw0u");

var $1qgAp = parcelRequire("1qgAp");
const $2a45d398159543ce$export$51f199f6846377f7 = (payload)=>{
    const { skipSentry: skipSentry = true, attributes: attributes, ...otherPayload } = payload;
    (0, $jcw0u.default)({
        ...otherPayload,
        attributes: {
            ...attributes,
            ...(0, $1qgAp.getTenantAttributes)()
        },
        skipSentry: // skiping sentry as true for fireErrorAnalytics
        skipSentry
    });
};

});
parcelRegister("1qgAp", function(module, exports) {

$parcel$export(module.exports, "getTenantAttributes", () => $b69c35ebd4c3a77a$export$bc31ff13a0bbe592);

var $j8DrX = parcelRequire("j8DrX");

var $c04PQ = parcelRequire("c04PQ");
const $b69c35ebd4c3a77a$export$bc31ff13a0bbe592 = ()=>{
    const shard = (0, $j8DrX.default)('ajs-shard');
    const region = (0, $j8DrX.default)('ajs-region');
    return {
        shard: shard,
        region: region,
        isFedRamp: (0, $c04PQ.isFedRamp)()
    };
};

});



parcelRegister("6OtcO", function(module, exports) {

$parcel$export(module.exports, "getTransitionSuccessFlag", () => $12ec3642dfb43880$export$8cfa71b43d733669);
$parcel$export(module.exports, "getTransitionFailureFlag", () => $12ec3642dfb43880$export$d9438db72c9548f1);

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $7HGHK = parcelRequire("7HGHK");

var $4O0IR = parcelRequire("4O0IR");
const $12ec3642dfb43880$var$ISSUE_TRANSITION_SUCCESS_FLAG_ID = 'issueTransitionSuccessful';
const $12ec3642dfb43880$var$ISSUE_TRANSITION_FAILURE_FLAG_ID = 'issueTransitionFailure';
const $12ec3642dfb43880$export$8cfa71b43d733669 = (issueKey, status, formatMessage)=>{
    const showLinkToIssue = Boolean(issueKey && status);
    if (showLinkToIssue) return {
        id: (0, $7HGHK.toFlagId)($12ec3642dfb43880$var$ISSUE_TRANSITION_SUCCESS_FLAG_ID),
        type: 'success',
        title: formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $4O0IR.default).issueTransitionSuccessfulWithIssueKeyAndStatusIssueTermRefresh : (0, $4O0IR.default).issueTransitionSuccessfulWithIssueKeyAndStatus, {
            issueKey: issueKey,
            status: status
        }),
        description: (0, $4O0IR.default).issueTransitionSuccessfulFlagDescription,
        messageId: `issue-transition-use-show-flag.ui.use-show-flag.${$12ec3642dfb43880$var$ISSUE_TRANSITION_SUCCESS_FLAG_ID}.success.issueTransitionSuccessfulWithIssueKeyAndStatus`,
        messageType: 'transactional'
    };
    return {
        id: (0, $7HGHK.toFlagId)($12ec3642dfb43880$var$ISSUE_TRANSITION_SUCCESS_FLAG_ID),
        type: 'success',
        title: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $4O0IR.default).issueTransitionSuccessfulIssueTermRefresh : (0, $4O0IR.default).issueTransitionSuccessful),
        messageId: `issue-transition-use-show-flag.ui.use-show-flag.${$12ec3642dfb43880$var$ISSUE_TRANSITION_SUCCESS_FLAG_ID}.success.issueTransitionSuccessful`,
        messageType: 'transactional'
    };
};
const $12ec3642dfb43880$export$d9438db72c9548f1 = (issueKey, formatMessage, traceId)=>({
        id: (0, $7HGHK.toFlagId)($12ec3642dfb43880$var$ISSUE_TRANSITION_FAILURE_FLAG_ID),
        type: 'error',
        title: issueKey ? formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $4O0IR.default).issueTransitionFailureWithKeyIssueTermRefresh : (0, $4O0IR.default).issueTransitionFailureWithKey, {
            issueKey: issueKey
        }) : formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $4O0IR.default).issueTransitionFailureIssueTermRefresh : (0, $4O0IR.default).issueTransitionFailure),
        messageId: `issue-transition-use-show-flag.ui.use-show-flag.${$12ec3642dfb43880$var$ISSUE_TRANSITION_FAILURE_FLAG_ID}.error`,
        messageType: 'transactional',
        ...traceId ? {
            traceId: traceId,
            error: new Error('TransitionFailureFlag')
        } : {}
    });

});
parcelRegister("4O0IR", function(module, exports) {

$parcel$export(module.exports, "default", () => $d201576bd998790a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $d201576bd998790a$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    issueTransitionSuccessful: {
        "id": "issue-transition-use-show-flag.use-show-flag.issue-transition-successful",
        "defaultMessage": "Issue has been updated."
    },
    issueTransitionSuccessfulWithIssueKeyAndStatus: {
        "id": "issue-transition-use-show-flag.use-show-flag.issue-transition-successful-with-issue-key-and-status",
        "defaultMessage": "{issueKey} moved to {status}."
    },
    issueTransitionSuccessfulFlagDescription: {
        "id": "issue-transition-use-show-flag.use-show-flag.issue-transition-successful-flag-description",
        "defaultMessage": "Kudos for keeping things up-to-date!"
    },
    issueTransitionFailure: {
        "id": "issue-transition-use-show-flag.use-show-flag.issue-transition-failure",
        "defaultMessage": "Issue could not be updated."
    },
    issueTransitionFailureWithKey: {
        "id": "issue-transition-use-show-flag.use-show-flag.issue-transition-failure-with-key",
        "defaultMessage": "We couldn't update {issueKey}."
    },
    viewIssue: {
        "id": "issue-transition-use-show-flag.use-show-flag.view-issue",
        "defaultMessage": "View issue"
    },
    issueTransitionSuccessfulIssueTermRefresh: {
        "id": "issue-transition-use-show-flag.use-show-flag.issue-transition-successful-issue-term-refresh",
        "defaultMessage": "Work item has been updated."
    },
    issueTransitionFailureIssueTermRefresh: {
        "id": "issue-transition-use-show-flag.use-show-flag.issue-transition-failure-issue-term-refresh",
        "defaultMessage": "Work item could not be updated."
    },
    viewIssueIssueTermRefresh: {
        "id": "issue-transition-use-show-flag.use-show-flag.view-issue-issue-term-refresh",
        "defaultMessage": "View"
    },
    issueTransitionSuccessfulWithIssueKeyAndStatusIssueTermRefresh: {
        "id": "issue-transition-use-show-flag.use-show-flag.issue-transition-successful-with-issue-key-and-status-issue-term-refresh",
        "defaultMessage": "{issueKey} moved to {status}."
    },
    issueTransitionFailureWithKeyIssueTermRefresh: {
        "id": "issue-transition-use-show-flag.use-show-flag.issue-transition-failure-with-key-issue-term-refresh",
        "defaultMessage": "We couldn't update {issueKey}."
    }
});

});



parcelRegister("cy1Jt", function(module, exports) {

$parcel$export(module.exports, "TransitionValidationError", () => $c1ddbf985793af52$export$eab080807dcecbbf);
$parcel$export(module.exports, "useTransitionAndRankIssueService", () => $c1ddbf985793af52$export$13974bef1886fce4);

var $5uXOq = parcelRequire("5uXOq");

var $5tTFS = parcelRequire("5tTFS");

var $e3a3O = parcelRequire("e3a3O");

var $8Wswo = parcelRequire("8Wswo");

var $93jKl = parcelRequire("93jKl");

var $kaHBi = parcelRequire("kaHBi");

var $3bQtK = parcelRequire("3bQtK");

var $8dXDG = parcelRequire("8dXDG");

var $eCBf9 = parcelRequire("eCBf9");

var $5fc53 = parcelRequire("5fc53");

var $iZgee = parcelRequire("iZgee");

var $cvj5l = parcelRequire("cvj5l");

var $7qcZk = parcelRequire("7qcZk");
const $c1ddbf985793af52$var$experience = 'transitionAndRankIssue';
class $c1ddbf985793af52$export$eab080807dcecbbf extends Error {
}
const $c1ddbf985793af52$export$13974bef1886fce4 = ()=>{
    const isLinkingEnabled = (0, $iZgee.useIsLinkingEnabled)();
    const startTransitionAndRankIssueExperience = (0, $kaHBi.useExperienceStart)({
        analyticsSource: 'jiraWorkManagementBoard',
        experience: $c1ddbf985793af52$var$experience
    });
    const markTransitionAndRankIssueSuccess = (0, $3bQtK.useExperienceSuccess)({
        experience: $c1ddbf985793af52$var$experience
    });
    const markTransitionAndRankIssueFailed = (0, $93jKl.useExperienceFail)({
        experience: $c1ddbf985793af52$var$experience
    });
    const abortTransitionAndRankIssueExperience = (0, $8dXDG.useExperienceAbort)({
        experience: $c1ddbf985793af52$var$experience
    });
    const [transitionAndRankMutation] = (0, $5tTFS.useMutation)((0, $7qcZk.TRANSITION_AND_RANK_ISSUE_MUTATION));
    return (0, $5uXOq.useCallback)(async ({ fieldIds: fieldIdsInput, issueId: issueId, rank: rank, transitionId: transitionId })=>{
        startTransitionAndRankIssueExperience();
        try {
            const fieldIds = new Set(fieldIdsInput);
            const withChildrenCount = fieldIds.has((0, $5fc53.SUBTASKS_TYPE));
            fieldIds.delete((0, $5fc53.SUBTASKS_TYPE));
            const withIssueLinks = fieldIds.has((0, $5fc53.ISSUE_LINKS_TYPE)) && isLinkingEnabled;
            fieldIds.delete((0, $5fc53.ISSUE_LINKS_TYPE));
            const withCoverMedia = fieldIds.has((0, $cvj5l.CARD_COVER));
            fieldIds.delete((0, $cvj5l.CARD_COVER));
            const withConfluenceLinks = fieldIds.has((0, $cvj5l.PAGES));
            fieldIds.delete((0, $cvj5l.PAGES));
            let rankInput;
            if (rank?.position === 'before') rankInput = {
                beforeIssueId: rank.relativeIssueId
            };
            else if (rank?.position === 'after') rankInput = {
                afterIssueId: rank.relativeIssueId
            };
            const { data: data, errors: errors } = await transitionAndRankMutation({
                variables: {
                    fieldIds: Array.from(fieldIds),
                    input: {
                        issueIds: [
                            issueId
                        ],
                        rank: rankInput,
                        transitionId: transitionId
                    },
                    withConfluenceLinks: withConfluenceLinks,
                    withCoverMedia: withCoverMedia,
                    withIssueLinks: withIssueLinks,
                    withChildrenCount: withChildrenCount
                },
                // @ts-expect-error - errorPolicy is not in the types but does work
                errorPolicy: 'all'
            });
            const mutationError = data?.transitionAndRankJwmItems?.errors?.[0];
            if (mutationError != null) {
                if (mutationError.message != null && mutationError.extensions?.statusCode === 400 && mutationError.extensions.errorType === 'TRANSITION_ERROR') throw new $c1ddbf985793af52$export$eab080807dcecbbf(mutationError.message);
                throw new (0, $eCBf9.MutationError)(mutationError);
            }
            if (errors) {
                const apolloError = new (0, $e3a3O.ApolloError)({
                    graphQLErrors: errors
                });
                if ((0, $8Wswo.shouldHandleTheError)(apolloError)) throw apolloError;
            }
            if (!data) throw new Error('No transition and rank response');
            const responseData = data.transitionAndRankJwmItems;
            const issue = data.transitionAndRankJwmItems?.items?.[0]?.fieldsByIdOrAlias != null ? responseData?.items?.[0] : null;
            if (issue == null) throw new Error('Invalid transition and rank response');
            markTransitionAndRankIssueSuccess();
            return issue;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            if (error instanceof $c1ddbf985793af52$export$eab080807dcecbbf) abortTransitionAndRankIssueExperience('Transition validation error');
            else markTransitionAndRankIssueFailed('Failed to transition and rank issue', error);
            throw error;
        }
    }, [
        startTransitionAndRankIssueExperience,
        isLinkingEnabled,
        transitionAndRankMutation,
        markTransitionAndRankIssueSuccess,
        abortTransitionAndRankIssueExperience,
        markTransitionAndRankIssueFailed
    ]);
};

});
parcelRegister("7qcZk", function(module, exports) {

$parcel$export(module.exports, "TRANSITION_AND_RANK_ISSUE_MUTATION", () => $f97a209403025dc1$export$f0fa92a42f51bf9b);

var $5cllN = parcelRequire("5cllN");

var $4ty7u = parcelRequire("4ty7u");
const $f97a209403025dc1$export$f0fa92a42f51bf9b = (0, $5cllN.default)`
mutation JWMBoardTransitionAndRankIssue($input: JWMTransitionAndRankItemInput!, $fieldIds: [String]!, $withConfluenceLinks: Boolean!, $withCoverMedia: Boolean!, $withIssueLinks: Boolean!, $withChildrenCount: Boolean!) {
    transitionAndRankJwmItems(input: $input, fieldIdsToReturn: $fieldIds) {
      items {
        ...JIS2_JWMBoardItemFragment
        ...JIS2_JWMBoardConfluenceLinksFragment @include(if: $withConfluenceLinks)
        ...JIS2_JWMBoardItemCoverMediaFragment @include(if: $withCoverMedia)
        ...JIS2_JWMBoardIssueLinksFragment @include(if: $withIssueLinks)
      }
      success
      errors {
        message
        extensions {
          statusCode
          errorType
          __typename
        }
        __typename
      }
      __typename
    }
}
${(0, $4ty7u.JIS2_JWMBOARD_ITEM_FRAGMENT)}
${(0, $4ty7u.JIS2_JWMBOARD_CONFLUENCE_LINKS_FRAGMENT)}
${(0, $4ty7u.JIS2_JWMBOARD_ITEM_COVER_MEDIA_FRAGMENT)}
${(0, $4ty7u.JIS2_JWMBOARD_ISSUE_LINKS_FRAGMENT)}
`;

});


parcelRegister("d5RIK", function(module, exports) {

$parcel$export(module.exports, "useUpdateAssignee", () => $43cd617f686f2548$export$a00b0d7bb5562f44);

var $5uXOq = parcelRequire("5uXOq");

var $5tTFS = parcelRequire("5tTFS");

var $e3a3O = parcelRequire("e3a3O");

var $95KxO = parcelRequire("95KxO");

var $2RKeg = parcelRequire("2RKeg");

var $93jKl = parcelRequire("93jKl");

var $kaHBi = parcelRequire("kaHBi");

var $3bQtK = parcelRequire("3bQtK");

var $8dXDG = parcelRequire("8dXDG");

var $eCBf9 = parcelRequire("eCBf9");

var $5fc53 = parcelRequire("5fc53");

var $koeKL = parcelRequire("koeKL");

var $em4SX = parcelRequire("em4SX");

var $4LCjN = parcelRequire("4LCjN");
const $43cd617f686f2548$var$experience = 'updateIssueFields';
const $43cd617f686f2548$export$a00b0d7bb5562f44 = ()=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const startExperience = (0, $kaHBi.useExperienceStart)({
        analyticsSource: 'jiraWorkManagementBoard',
        experience: $43cd617f686f2548$var$experience
    });
    const markExperienceSuccessful = (0, $3bQtK.useExperienceSuccess)({
        experience: $43cd617f686f2548$var$experience
    });
    const markExperienceFailed = (0, $93jKl.useExperienceFail)({
        experience: $43cd617f686f2548$var$experience
    });
    const abortExperience = (0, $8dXDG.useExperienceAbort)({
        experience: $43cd617f686f2548$var$experience
    });
    const [updateAssignee] = (0, $5tTFS.useMutation)((0, $4LCjN.UPDATE_ASSIGNEE_MUTATION));
    return (0, $5uXOq.useCallback)(async ({ issueId: issueId, assigneeId: assigneeId })=>{
        startExperience();
        try {
            const input = {
                id: (0, $2RKeg.JiraIssuefieldvalueAri).create({
                    issueId: String(issueId),
                    fieldId: (0, $5fc53.ASSIGNEE_TYPE),
                    siteId: cloudId
                }).toString(),
                operation: {
                    id: assigneeId ? (0, $95KxO.IdentityUserAri).create({
                        userId: assigneeId
                    }).toString() : null,
                    // @ts-expect-error - cannot import the enum from the generated types
                    operation: 'SET'
                }
            };
            const { data: data, errors: errors } = await updateAssignee({
                variables: {
                    input: input
                },
                // @ts-expect-error - errorPolicy is not in the types but does work
                errorPolicy: 'all'
            });
            const mutationResponse = data?.jira?.updateSingleSelectUserPickerField;
            if (mutationResponse?.success !== true) {
                const mutationError = mutationResponse?.errors?.[0];
                if (mutationError != null) {
                    const statusCode = mutationError.extensions?.statusCode ?? 0;
                    if (statusCode >= 400 && statusCode < 500) throw new (0, $em4SX.UpdateFieldsValidationError)(mutationError.message ?? undefined);
                    throw new (0, $eCBf9.MutationError)(mutationError);
                }
                if (errors) {
                    const apolloError = new (0, $e3a3O.ApolloError)({
                        graphQLErrors: errors
                    });
                    throw apolloError;
                }
                throw new Error('No data returned from update assignee mutation');
            }
            markExperienceSuccessful();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            if (error instanceof (0, $em4SX.UpdateFieldsValidationError)) abortExperience('Updating assignee failed with validation error');
            else markExperienceFailed('Failed to update issue assignee', error);
            throw error;
        }
    }, [
        startExperience,
        cloudId,
        updateAssignee,
        markExperienceSuccessful,
        abortExperience,
        markExperienceFailed
    ]);
};

});
parcelRegister("2RKeg", function(module, exports) {

$parcel$export(module.exports, "JiraIssuefieldvalueAri", () => $2164641f4a4b33a7$export$828c4931ae562af7);

var $gB07r = parcelRequire("gB07r");

var $3NoER = parcelRequire("3NoER");

var $gYPG7 = parcelRequire("gYPG7");
// src/jira/issuefieldvalue/manifest.ts
var $2164641f4a4b33a7$var$jiraIssuefieldvalueAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $gB07r.JiraIssuefieldvalueAriResourceOwner),
    resourceType: (0, $gB07r.JiraIssuefieldvalueAriResourceType),
    resourceIdSlug: "{issueId}/{fieldId}",
    resourceIdSegmentFormats: {
        issueId: /[0-9]+/,
        // eslint-disable-line no-useless-escape
        fieldId: /[a-zA-Z0-9_\-]+/
    }
};
// src/jira/issuefieldvalue/index.ts
var $2164641f4a4b33a7$export$828c4931ae562af7 = class _JiraIssuefieldvalueAri extends (0, $3NoER.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._issueId = opts.resourceIdSegmentValues.issueId, this._fieldId = opts.resourceIdSegmentValues.fieldId;
    }
    get siteId() {
        return this._siteId;
    }
    get issueId() {
        return this._issueId;
    }
    get fieldId() {
        return this._fieldId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $2164641f4a4b33a7$var$jiraIssuefieldvalueAriStaticOpts.qualifier,
            platformQualifier: $2164641f4a4b33a7$var$jiraIssuefieldvalueAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $2164641f4a4b33a7$var$jiraIssuefieldvalueAriStaticOpts.resourceOwner,
            resourceType: $2164641f4a4b33a7$var$jiraIssuefieldvalueAriStaticOpts.resourceType,
            resourceId: `${opts.issueId}/${opts.fieldId}`,
            resourceIdSegmentValues: {
                issueId: opts.issueId,
                fieldId: opts.fieldId
            }
        }, ariOpts = (0, $gYPG7.AriParser).fromOpts(derivedOpts, $2164641f4a4b33a7$var$jiraIssuefieldvalueAriStaticOpts);
        return new _JiraIssuefieldvalueAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $gYPG7.AriParser).fromString(maybeAri, $2164641f4a4b33a7$var$jiraIssuefieldvalueAriStaticOpts);
        return new _JiraIssuefieldvalueAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            issueId: this.issueId,
            fieldId: this.fieldId
        };
    }
};

});
parcelRegister("gB07r", function(module, exports) {

$parcel$export(module.exports, "JiraIssuefieldvalueAriResourceOwner", () => $c15031ac9edfd973$export$39e9358142fbbc64);
$parcel$export(module.exports, "JiraIssuefieldvalueAriResourceType", () => $c15031ac9edfd973$export$f9e57427271adc95);
// src/jira/issuefieldvalue/types.ts
var $c15031ac9edfd973$export$39e9358142fbbc64 = "jira", $c15031ac9edfd973$export$f9e57427271adc95 = "issuefieldvalue";

});


parcelRegister("em4SX", function(module, exports) {

$parcel$export(module.exports, "UpdateFieldsValidationError", () => $3564631686804147$export$83c85dc72810de5c);
class $3564631686804147$export$83c85dc72810de5c extends Error {
}

});

parcelRegister("4LCjN", function(module, exports) {

$parcel$export(module.exports, "UPDATE_ASSIGNEE_MUTATION", () => $badb167ae0eb7042$export$9f83b9d9ec4b6bdb);

var $5cllN = parcelRequire("5cllN");
const $badb167ae0eb7042$export$9f83b9d9ec4b6bdb = (0, $5cllN.default)`
mutation BusinessBoardUpdateAssignee($input: JiraUpdateSingleSelectUserPickerFieldInput!) {
  jira {
    updateSingleSelectUserPickerField(input: $input) {
      success
      errors {
        message
        extensions {
          statusCode
          errorType
          __typename
        }
        __typename
      }
      __typename
    }
  }
}`;

});


parcelRegister("lLmHi", function(module, exports) {

$parcel$export(module.exports, "useUpdateCategory", () => $bc01b5bd9c7b1743$export$89393e180ebe9dba);

var $5uXOq = parcelRequire("5uXOq");

var $5tTFS = parcelRequire("5tTFS");

var $e3a3O = parcelRequire("e3a3O");

var $erdwt = parcelRequire("erdwt");

var $2RKeg = parcelRequire("2RKeg");

var $93jKl = parcelRequire("93jKl");

var $kaHBi = parcelRequire("kaHBi");

var $3bQtK = parcelRequire("3bQtK");

var $8dXDG = parcelRequire("8dXDG");

var $eCBf9 = parcelRequire("eCBf9");

var $fY39E = parcelRequire("fY39E");

var $koeKL = parcelRequire("koeKL");

var $em4SX = parcelRequire("em4SX");

var $gT8D9 = parcelRequire("gT8D9");
const $bc01b5bd9c7b1743$var$experience = 'updateIssueFields';
const $bc01b5bd9c7b1743$export$89393e180ebe9dba = ()=>{
    const siteId = (0, $koeKL.useCloudId)();
    const activationId = (0, $fY39E.useActivationId)();
    const startExperience = (0, $kaHBi.useExperienceStart)({
        analyticsSource: 'jiraWorkManagementBoard',
        experience: $bc01b5bd9c7b1743$var$experience
    });
    const markExperienceSuccessful = (0, $3bQtK.useExperienceSuccess)({
        experience: $bc01b5bd9c7b1743$var$experience
    });
    const markExperienceFailed = (0, $93jKl.useExperienceFail)({
        experience: $bc01b5bd9c7b1743$var$experience
    });
    const abortExperience = (0, $8dXDG.useExperienceAbort)({
        experience: $bc01b5bd9c7b1743$var$experience
    });
    const [updateCategory] = (0, $5tTFS.useMutation)((0, $gT8D9.UPDATE_CATEGORY_MUTATION));
    return (0, $5uXOq.useCallback)(async ({ issueId: issueId, optionId: optionId, categoryFieldId: categoryFieldId })=>{
        startExperience();
        try {
            const input = {
                id: (0, $2RKeg.JiraIssuefieldvalueAri).create({
                    issueId: String(issueId),
                    fieldId: categoryFieldId,
                    siteId: siteId
                }).toString(),
                operation: {
                    id: optionId ? (0, $erdwt.JiraIssueFieldOptionAri).create({
                        siteId: siteId,
                        activationId: activationId,
                        fieldId: categoryFieldId,
                        optionId: optionId
                    }).toString() : null,
                    // @ts-expect-error - cannot import the enum from the generated types
                    operation: 'SET'
                }
            };
            const { data: data, errors: errors } = await updateCategory({
                variables: {
                    input: input
                },
                // @ts-expect-error - errorPolicy is not in the types but does work
                errorPolicy: 'all'
            });
            const mutationResponse = data?.jira?.updateSingleSelectField;
            if (mutationResponse?.success !== true) {
                const mutationError = mutationResponse?.errors?.[0];
                if (mutationError != null) {
                    const statusCode = mutationError.extensions?.statusCode ?? 0;
                    if (statusCode >= 400 && statusCode < 500) throw new (0, $em4SX.UpdateFieldsValidationError)(mutationError.message ?? undefined);
                    throw new (0, $eCBf9.MutationError)(mutationError);
                }
                if (errors) {
                    const apolloError = new (0, $e3a3O.ApolloError)({
                        graphQLErrors: errors
                    });
                    throw apolloError;
                }
                throw new Error('No data returned from update category mutation');
            }
            markExperienceSuccessful();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            if (error instanceof (0, $em4SX.UpdateFieldsValidationError)) abortExperience('Updating category failed with validation error');
            else markExperienceFailed('Failed to update issue category', error);
            throw error;
        }
    }, [
        startExperience,
        siteId,
        activationId,
        updateCategory,
        markExperienceSuccessful,
        abortExperience,
        markExperienceFailed
    ]);
};

});
parcelRegister("erdwt", function(module, exports) {

$parcel$export(module.exports, "JiraIssueFieldOptionAri", () => $a82e13aa7ad841f1$export$e3bc1ec22f941fbe);

var $aeXsV = parcelRequire("aeXsV");

var $3NoER = parcelRequire("3NoER");

var $gYPG7 = parcelRequire("gYPG7");
// src/jira/issue-field-option/manifest.ts
var $a82e13aa7ad841f1$var$jiraIssueFieldOptionAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $aeXsV.JiraIssueFieldOptionAriResourceOwner),
    resourceType: (0, $aeXsV.JiraIssueFieldOptionAriResourceType),
    resourceIdSlug: "activation/{activationId}/{fieldId}/{optionId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        fieldId: /[!a-zA-Z0-9\-_.~@:;{}=]+(\/[!a-zA-Z0-9\-_.~@:;{}=]+)*/,
        // eslint-disable-line no-useless-escape
        optionId: /[!a-zA-Z0-9\-_.~@:;{}=]+(\/[!a-zA-Z0-9\-_.~@:;{}=]+)*/
    }
};
// src/jira/issue-field-option/index.ts
var $a82e13aa7ad841f1$export$e3bc1ec22f941fbe = class _JiraIssueFieldOptionAri extends (0, $3NoER.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._fieldId = opts.resourceIdSegmentValues.fieldId, this._optionId = opts.resourceIdSegmentValues.optionId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get fieldId() {
        return this._fieldId;
    }
    get optionId() {
        return this._optionId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $a82e13aa7ad841f1$var$jiraIssueFieldOptionAriStaticOpts.qualifier,
            platformQualifier: $a82e13aa7ad841f1$var$jiraIssueFieldOptionAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $a82e13aa7ad841f1$var$jiraIssueFieldOptionAriStaticOpts.resourceOwner,
            resourceType: $a82e13aa7ad841f1$var$jiraIssueFieldOptionAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.fieldId}/${opts.optionId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                fieldId: opts.fieldId,
                optionId: opts.optionId
            }
        }, ariOpts = (0, $gYPG7.AriParser).fromOpts(derivedOpts, $a82e13aa7ad841f1$var$jiraIssueFieldOptionAriStaticOpts);
        return new _JiraIssueFieldOptionAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $gYPG7.AriParser).fromString(maybeAri, $a82e13aa7ad841f1$var$jiraIssueFieldOptionAriStaticOpts);
        return new _JiraIssueFieldOptionAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            fieldId: this.fieldId,
            optionId: this.optionId
        };
    }
};

});
parcelRegister("aeXsV", function(module, exports) {

$parcel$export(module.exports, "JiraIssueFieldOptionAriResourceOwner", () => $774956c9da7baac8$export$eb4f4cf0880fe5a8);
$parcel$export(module.exports, "JiraIssueFieldOptionAriResourceType", () => $774956c9da7baac8$export$4bec333360908e78);
// src/jira/issue-field-option/types.ts
var $774956c9da7baac8$export$eb4f4cf0880fe5a8 = "jira", $774956c9da7baac8$export$4bec333360908e78 = "issue-field-option";

});


parcelRegister("gT8D9", function(module, exports) {

$parcel$export(module.exports, "UPDATE_CATEGORY_MUTATION", () => $6cccbb6aebabd7b6$export$bf268466d37e369);

var $5cllN = parcelRequire("5cllN");
const $6cccbb6aebabd7b6$export$bf268466d37e369 = (0, $5cllN.default)`
mutation BusinessBoardUpdateCategory($input: JiraUpdateSingleSelectFieldInput!) {
  jira {
    updateSingleSelectField(input: $input) {
      success
      errors {
        message
        extensions {
          statusCode
          errorType
          __typename
        }
        __typename
      }
      __typename
    }
  }
}`;

});


parcelRegister("1uL7Q", function(module, exports) {

$parcel$export(module.exports, "useUpdatePriority", () => $d6f33c9186bb24d0$export$6f99e069161a47df);

var $5uXOq = parcelRequire("5uXOq");

var $5tTFS = parcelRequire("5tTFS");

var $e3a3O = parcelRequire("e3a3O");

var $2RKeg = parcelRequire("2RKeg");

var $2O65s = parcelRequire("2O65s");

var $93jKl = parcelRequire("93jKl");

var $kaHBi = parcelRequire("kaHBi");

var $3bQtK = parcelRequire("3bQtK");

var $8dXDG = parcelRequire("8dXDG");

var $eCBf9 = parcelRequire("eCBf9");

var $5fc53 = parcelRequire("5fc53");

var $fY39E = parcelRequire("fY39E");

var $koeKL = parcelRequire("koeKL");

var $em4SX = parcelRequire("em4SX");

var $6FgP2 = parcelRequire("6FgP2");
const $d6f33c9186bb24d0$var$experience = 'updateIssueFields';
const $d6f33c9186bb24d0$export$6f99e069161a47df = ()=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const activationId = (0, $fY39E.useActivationId)();
    const startExperience = (0, $kaHBi.useExperienceStart)({
        analyticsSource: 'jiraWorkManagementBoard',
        experience: $d6f33c9186bb24d0$var$experience
    });
    const markExperienceSuccessful = (0, $3bQtK.useExperienceSuccess)({
        experience: $d6f33c9186bb24d0$var$experience
    });
    const markExperienceFailed = (0, $93jKl.useExperienceFail)({
        experience: $d6f33c9186bb24d0$var$experience
    });
    const abortExperience = (0, $8dXDG.useExperienceAbort)({
        experience: $d6f33c9186bb24d0$var$experience
    });
    const [updatePriority] = (0, $5tTFS.useMutation)((0, $6FgP2.UPDATE_PRIORITY_MUTATION));
    return (0, $5uXOq.useCallback)(async ({ issueId: issueId, priorityId: priorityId })=>{
        startExperience();
        try {
            const input = {
                id: (0, $2RKeg.JiraIssuefieldvalueAri).create({
                    issueId: String(issueId),
                    fieldId: (0, $5fc53.PRIORITY_TYPE),
                    siteId: cloudId
                }).toString(),
                operation: {
                    id: (0, $2O65s.JiraPriorityAri).create({
                        siteId: cloudId,
                        activationId: activationId,
                        priorityId: priorityId
                    }).toString(),
                    // @ts-expect-error - cannot import the enum from the generated types
                    operation: 'SET'
                }
            };
            const { data: data, errors: errors } = await updatePriority({
                variables: {
                    input: input
                },
                // @ts-expect-error - errorPolicy is not in the types but does work
                errorPolicy: 'all'
            });
            const mutationResponse = data?.jira?.updatePriorityField;
            if (mutationResponse?.success !== true) {
                const mutationError = mutationResponse?.errors?.[0];
                if (mutationError != null) {
                    const statusCode = mutationError.extensions?.statusCode ?? 0;
                    if (statusCode >= 400 && statusCode < 500) throw new (0, $em4SX.UpdateFieldsValidationError)(mutationError.message ?? undefined);
                    throw new (0, $eCBf9.MutationError)(mutationError);
                }
                if (errors) {
                    const apolloError = new (0, $e3a3O.ApolloError)({
                        graphQLErrors: errors
                    });
                    throw apolloError;
                }
                throw new Error('No data returned from update priority mutation');
            }
            markExperienceSuccessful();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            if (error instanceof (0, $em4SX.UpdateFieldsValidationError)) abortExperience('Updating priority failed with validation error');
            else markExperienceFailed('Failed to update issue priority', error);
            throw error;
        }
    }, [
        startExperience,
        cloudId,
        activationId,
        updatePriority,
        markExperienceSuccessful,
        abortExperience,
        markExperienceFailed
    ]);
};

});
parcelRegister("2O65s", function(module, exports) {

$parcel$export(module.exports, "JiraPriorityAri", () => $20b4f9052b3cf7d9$export$5f41709ebd395cb1);

var $7ZK4B = parcelRequire("7ZK4B");

var $3NoER = parcelRequire("3NoER");

var $gYPG7 = parcelRequire("gYPG7");
// src/jira/priority/manifest.ts
var $20b4f9052b3cf7d9$var$jiraPriorityAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $7ZK4B.JiraPriorityAriResourceOwner),
    resourceType: (0, $7ZK4B.JiraPriorityAriResourceType),
    resourceIdSlug: "activation/{activationId}/{priorityId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        priorityId: /[!a-zA-Z0-9\-_.~@:;{}=]+(\/[!a-zA-Z0-9\-_.~@:;{}=]+)*/
    }
};
// src/jira/priority/index.ts
var $20b4f9052b3cf7d9$export$5f41709ebd395cb1 = class _JiraPriorityAri extends (0, $3NoER.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._priorityId = opts.resourceIdSegmentValues.priorityId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get priorityId() {
        return this._priorityId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $20b4f9052b3cf7d9$var$jiraPriorityAriStaticOpts.qualifier,
            platformQualifier: $20b4f9052b3cf7d9$var$jiraPriorityAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $20b4f9052b3cf7d9$var$jiraPriorityAriStaticOpts.resourceOwner,
            resourceType: $20b4f9052b3cf7d9$var$jiraPriorityAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.priorityId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                priorityId: opts.priorityId
            }
        }, ariOpts = (0, $gYPG7.AriParser).fromOpts(derivedOpts, $20b4f9052b3cf7d9$var$jiraPriorityAriStaticOpts);
        return new _JiraPriorityAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $gYPG7.AriParser).fromString(maybeAri, $20b4f9052b3cf7d9$var$jiraPriorityAriStaticOpts);
        return new _JiraPriorityAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            priorityId: this.priorityId
        };
    }
};

});
parcelRegister("7ZK4B", function(module, exports) {

$parcel$export(module.exports, "JiraPriorityAriResourceOwner", () => $5d21f81242417687$export$a154bdc743e3d7f4);
$parcel$export(module.exports, "JiraPriorityAriResourceType", () => $5d21f81242417687$export$f5f5f4d1fc71ee3e);
// src/jira/priority/types.ts
var $5d21f81242417687$export$a154bdc743e3d7f4 = "jira", $5d21f81242417687$export$f5f5f4d1fc71ee3e = "priority";

});


parcelRegister("6FgP2", function(module, exports) {

$parcel$export(module.exports, "UPDATE_PRIORITY_MUTATION", () => $a9004f07e541a107$export$955bde0f3c238ff5);

var $5cllN = parcelRequire("5cllN");
const $a9004f07e541a107$export$955bde0f3c238ff5 = (0, $5cllN.default)`
mutation BusinessBoardUpdatePriority($input: JiraUpdatePriorityFieldInput!) {
  jira {
    updatePriorityField(input: $input) {
      success
      errors {
        message
        extensions {
          statusCode
          errorType
          __typename
        }
        __typename
      }
      __typename
    }
  }
}`;

});


parcelRegister("hfX4S", function(module, exports) {

$parcel$export(module.exports, "TransitionModalCanceled", () => $c08814244ee7411a$export$193fd3145c53120d);
$parcel$export(module.exports, "useTransitionScreenModal", () => $c08814244ee7411a$export$216691fd9138d702);

var $5uXOq = parcelRequire("5uXOq");

var $jUlV7 = parcelRequire("jUlV7");

var $jpZIw = parcelRequire("jpZIw");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $koeKL = parcelRequire("koeKL");

var $cvj5l = parcelRequire("cvj5l");
const $c08814244ee7411a$var$TRIGGER_POINT_KEY = 'issue-transition-board-card-transition';
class $c08814244ee7411a$export$193fd3145c53120d extends Error {
}
const $c08814244ee7411a$export$216691fd9138d702 = ()=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const openIssueTransitionModal = (0, $jpZIw.useOpenIssueTransitionModal)();
    return (0, $5uXOq.useCallback)((issue, transitionId)=>new Promise((resolve, reject)=>{
            const issueKey = issue.fields[0, $cvj5l.ISSUE_KEY_ID].value;
            const ariIssueId = (0, $jUlV7.JiraIssueAri).create({
                issueId: String(issue.id),
                siteId: cloudId
            }).toString();
            const onDialogSuccess = ()=>{
                (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'issueTransition success', {
                    triggerPointKey: $c08814244ee7411a$var$TRIGGER_POINT_KEY,
                    isModalOpen: true
                });
                resolve(undefined);
            };
            const onDialogError = ()=>{
                (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'issueTransition failed', {
                    triggerPointKey: $c08814244ee7411a$var$TRIGGER_POINT_KEY,
                    isModalOpen: true
                });
                reject(new Error('Issue transition failed'));
            };
            const onDialogCancel = ()=>{
                (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'issueTransition cancel', {
                    triggerPointKey: $c08814244ee7411a$var$TRIGGER_POINT_KEY,
                    isModalOpen: true
                });
                reject(new $c08814244ee7411a$export$193fd3145c53120d('Issue transition canceled'));
            };
            openIssueTransitionModal({
                payload: {
                    issueId: ariIssueId,
                    issueKey: issueKey,
                    transitionId: String(transitionId)
                },
                triggerPointKey: $c08814244ee7411a$var$TRIGGER_POINT_KEY,
                onDialogSuccess: onDialogSuccess,
                onDialogCancel: onDialogCancel,
                onDialogError: onDialogError
            });
        }), [
        cloudId,
        createAnalyticsEvent,
        openIssueTransitionModal
    ]);
};

});
parcelRegister("jpZIw", function(module, exports) {

$parcel$export(module.exports, "useOpenIssueTransitionModal", () => $f41d32ebe3d90af0$export$736bd10472c63b49);
$parcel$export(module.exports, "useCloseIssueTransitionModal", () => $f41d32ebe3d90af0$export$4629f18d511ad32e);
$parcel$export(module.exports, "useTriggerIssueTransitionModal", () => $f41d32ebe3d90af0$export$95a1e9702d78f223);
$parcel$export(module.exports, "default", () => $f41d32ebe3d90af0$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $lTEVZ = parcelRequire("lTEVZ");

var $4R6GH = parcelRequire("4R6GH");

var $6ikhl = parcelRequire("6ikhl");

var $2gCtH = parcelRequire("2gCtH");

var $ct2PA = parcelRequire("ct2PA");

var $3NlyR = parcelRequire("3NlyR");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $9MiT2 = parcelRequire("9MiT2");

var $fNOVA = parcelRequire("fNOVA");

var $1btwe = parcelRequire("1btwe");

var $gjoNn = parcelRequire("gjoNn");

var $ipUU1 = parcelRequire("ipUU1");

var $jHYHS = parcelRequire("jHYHS");
const $f41d32ebe3d90af0$export$736bd10472c63b49 = ()=>{
    const { openIssueTransitionModal: openIssueTransitionModalAction, openIssueTransitionModalNew: openIssueTransitionModalNew } = (0, $gjoNn.useTriggerIssueTransitionModalActions)();
    const { stateGet: { state: { isEnabled: isEnabled = true } = {} } = {} } = (0, $fNOVA.useIssueTransitionLabsOptIn)();
    const publish = (0, $1btwe.usePublishOpenIssueTransitionModalPubSub)();
    const source = (0, $2gCtH.useAnalyticsSource)();
    const { fireUIEvent: fireUIEvent } = (0, $3NlyR.useIssueTransitionUIAnalyticsEvent)();
    const { stateGet: { state: state } } = (0, $9MiT2.useIssueTransitionChangeboardingPreferences)();
    const { fireOperationalAnalyticsTransitionScreenOpened: fireOperationalAnalyticsTransitionScreenOpened } = (0, $ct2PA.useIssueTransitionsOperationalAnalyticsEvent)();
    const benefitsModal = typeof state !== 'number' ? state?.benefitsModal : undefined;
    const { isDisabled: isDisabled, nextDateToShowBenefitsModal: nextDateToShowBenefitsModal } = benefitsModal || {};
    return (0, $5uXOq.useCallback)((nextState)=>{
        try {
            const { triggerPointKey: triggerPointKey } = nextState || {};
            const isNewITSEnabled = (0, $jHYHS.isNewTransitionScreenEnabled)(isEnabled, triggerPointKey);
            if ((0, $4R6GH.fg)('modern_issue_transition_enable_benefits_modal')) {
                fireOperationalAnalyticsTransitionScreenOpened({
                    actionSubject: 'issueTransition triggered',
                    isBenefitsModalFGEneabled: (0, $4R6GH.fg)('modern_issue_transition_enable_benefits_modal'),
                    preferNewIssueTransitionScreen: isEnabled,
                    issueViewAnalyticsSource: source,
                    isBenefitsModalDisabled: isDisabled,
                    dateToShowBenefitsModal: nextDateToShowBenefitsModal || undefined
                });
                openIssueTransitionModalNew({
                    nextState: nextState,
                    preferNewIssueTransitionScreen: isEnabled,
                    issueViewAnalyticsSource: source,
                    publishTriggerToOpenTransitions: publish,
                    isBenefitsModalDisabled: isDisabled,
                    dateToShowBenefitsModal: nextDateToShowBenefitsModal || undefined,
                    fireUIEvent: fireUIEvent
                });
                return;
            }
            if ((0, $4R6GH.fg)('fix-connect-app-not-loading')) {
                if (isNewITSEnabled && source === 'connect-issue') {
                    // fire UI event when issue transition is opened via connect API
                    fireUIEvent({
                        actionSubject: 'issueTransition',
                        actionSubjectId: 'connectIssue',
                        action: 'opened'
                    });
                    publish(nextState, isEnabled);
                } else openIssueTransitionModalAction(nextState, isEnabled);
            } else if (source === 'connect-issue') {
                // fire UI event when issue transition is opened via connect API
                fireUIEvent({
                    actionSubject: 'issueTransition',
                    actionSubjectId: 'connectIssue',
                    action: 'opened'
                });
                publish(nextState, isEnabled);
            } else openIssueTransitionModalAction(nextState, isEnabled);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $lTEVZ.fireIssueTransitionErrorAnalytics)({
                meta: {
                    id: 'transitionIssueTrigger',
                    packageName: 'jiraIssueTransitionTrigger',
                    teamName: 'gryffindor'
                },
                attributes: {
                    transitionModalVersion: 'NEW'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    }, [
        fireOperationalAnalyticsTransitionScreenOpened,
        isEnabled,
        source,
        isDisabled,
        nextDateToShowBenefitsModal,
        openIssueTransitionModalNew,
        publish,
        fireUIEvent,
        openIssueTransitionModalAction
    ]);
};
const $f41d32ebe3d90af0$export$4629f18d511ad32e = ()=>{
    const [, { resetState: resetState }] = (0, $6ikhl.useInlineFieldsActions)();
    const { closeIssueTransitionModal: closeIssueTransitionModalAction } = (0, $gjoNn.useTriggerIssueTransitionModalActions)();
    const { payload: { issueKey: issueKey, transitionId: transitionId }, onDialogCancel: onDialogCancel, onDialogError: onDialogError, onDialogSuccess: onDialogSuccess } = (0, $gjoNn.useTriggerIssueTransitionModalState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    return (0, $5uXOq.useCallback)((shouldOpenLegacyModal = false)=>{
        closeIssueTransitionModalAction();
        resetState();
        if (shouldOpenLegacyModal) {
            const onOpenDialog = ()=>{
                (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'legacyTransitionsScreen Switched');
            };
            (0, $ipUU1.openLegacyIssueTransitionModal)({
                issueKey: issueKey,
                isReopenScenario: true,
                transitionId: transitionId,
                onDialogCancel: onDialogCancel,
                onDialogError: onDialogError,
                onDialogSuccess: onDialogSuccess,
                onOpenDialog: onOpenDialog
            });
        }
    }, [
        closeIssueTransitionModalAction,
        createAnalyticsEvent,
        issueKey,
        onDialogCancel,
        onDialogError,
        onDialogSuccess,
        transitionId,
        resetState
    ]);
};
const $f41d32ebe3d90af0$export$95a1e9702d78f223 = ()=>{
    const state = (0, $gjoNn.useTriggerIssueTransitionModalState)();
    const actions = (0, $gjoNn.useTriggerIssueTransitionModalActions)();
    const { openIssueTransitionModalNew: openIssueTransitionModalNew, ...restActions } = actions;
    const openIssueTransitionModal = $f41d32ebe3d90af0$export$736bd10472c63b49();
    return [
        state,
        {
            ...restActions,
            openIssueTransitionModal: openIssueTransitionModal
        }
    ];
};
var $f41d32ebe3d90af0$export$2e2bcd8739ae039 = $f41d32ebe3d90af0$export$95a1e9702d78f223;

});
parcelRegister("6ikhl", function(module, exports) {

$parcel$export(module.exports, "useInlineFields", () => $d56dd4f138add558$export$71d5b5acb7d7f5ce);
$parcel$export(module.exports, "useInlineField", () => $d56dd4f138add558$export$14c9655e9d9e873c);
$parcel$export(module.exports, "useInlineFieldsActions", () => $d56dd4f138add558$export$cdb4b503c6154b35);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $5rCpD = parcelRequire("5rCpD");
// Inline fields state tracks field states in create issue view as the user interacts with them
// this is particularly needed as we want to save the field's value when the user
// unfocuses the field
const $d56dd4f138add558$var$store = (0, $iXqE5.createStore)({
    name: 'forge.inline-fields-state',
    initialState: {},
    actions: $5rCpD.default
});
const $d56dd4f138add558$export$71d5b5acb7d7f5ce = (0, $3sQ5x.createHook)($d56dd4f138add558$var$store);
const $d56dd4f138add558$export$14c9655e9d9e873c = (0, $3sQ5x.createHook)($d56dd4f138add558$var$store, {
    selector: (state, fieldId)=>state[fieldId]
});
const $d56dd4f138add558$export$cdb4b503c6154b35 = (0, $3sQ5x.createHook)($d56dd4f138add558$var$store, {
    selector: null
});

});
parcelRegister("5rCpD", function(module, exports) {

$parcel$export(module.exports, "default", () => $02373df28193ad93$export$2e2bcd8739ae039);

var $hPhpd = parcelRequire("hPhpd");
const $02373df28193ad93$var$actions = {
    setFieldState: $hPhpd.setFieldState,
    resetState: $hPhpd.resetState,
    dispatchRetryFunction: $hPhpd.dispatchRetryFunction,
    dispatchFormSubmits: $hPhpd.dispatchFormSubmits
};
var $02373df28193ad93$export$2e2bcd8739ae039 = $02373df28193ad93$var$actions;

});
parcelRegister("hPhpd", function(module, exports) {

$parcel$export(module.exports, "setFieldState", () => $9eca433be421af07$export$80fd62d9217dd703);
$parcel$export(module.exports, "resetState", () => $9eca433be421af07$export$8e84bad0b35de9e8);
$parcel$export(module.exports, "dispatchRetryFunction", () => $9eca433be421af07$export$27c59f06a7c1fe26);
$parcel$export(module.exports, "dispatchFormSubmits", () => $9eca433be421af07$export$42fd5e650971333b);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $4R6GH = parcelRequire("4R6GH");


var $9J85a = parcelRequire("9J85a");
const $9eca433be421af07$export$80fd62d9217dd703 = (data)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const stateObject = {
            status: data.status !== undefined ? data.status : currentState[data.fieldId]?.status,
            formRef: data.formRef !== undefined ? data.formRef : currentState[data.fieldId]?.formRef,
            retryFunction: data.retryFunction !== undefined ? data.retryFunction : currentState[data.fieldId]?.retryFunction,
            ...(0, $4R6GH.fg)('fcf-new-submit-on-gic-and-tv') ? {
                onFormSubmit: data.onFormSubmit !== undefined ? data.onFormSubmit : currentState[data.fieldId]?.onFormSubmit
            } : {}
        };
        setState({
            ...getState(),
            [data.fieldId]: stateObject
        });
    };
const $9eca433be421af07$export$8e84bad0b35de9e8 = ()=>({ getState: getState, setState: setState })=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const stateToOverride = {};
        Object.getOwnPropertyNames(getState()).forEach((fieldId)=>{
            stateToOverride[fieldId] = {
                status: (0, $3e5c7761c2e3cf02$export$bbf78c43fa5268c8)
            };
        });
        setState(stateToOverride);
    };
const $9eca433be421af07$export$27c59f06a7c1fe26 = (fieldId)=>async ({ getState: getState })=>{
        const currentState = getState();
        const fieldData = currentState[fieldId];
        const retryFunction = fieldData?.retryFunction;
        retryFunction && retryFunction();
    };
const $9eca433be421af07$export$42fd5e650971333b = ()=>async ({ getState: getState })=>{
        const currentState = getState();
        Object.keys(currentState).forEach((fieldId)=>{
            if (currentState[fieldId]?.status === (0, $3e5c7761c2e3cf02$export$32bbcfb76243a487)) {
                if ((0, $4R6GH.fg)('fcf-new-submit-on-gic-and-tv')) currentState[fieldId]?.onFormSubmit?.();
                else {
                    const formRef = currentState[fieldId]?.formRef;
                    (0, $9J85a.dispatchFormSubmitAndBlurElements)(formRef);
                }
            }
        });
    };

});
const $3e5c7761c2e3cf02$export$32bbcfb76243a487 = 'FOCUSED';
const $3e5c7761c2e3cf02$export$f81c1d6b9217380c = 'PENDING';
const $3e5c7761c2e3cf02$export$2ace7d3737836262 = 'RESOLVED';
const $3e5c7761c2e3cf02$export$9956c6a700e724c4 = 'STORED';
const $3e5c7761c2e3cf02$export$742c877aeb0f3dbd = 'FAILED';
const $3e5c7761c2e3cf02$export$bbf78c43fa5268c8 = 'IDLE';
const $3e5c7761c2e3cf02$export$ae7c16bdba5e2e15 = 10000;
const $3e5c7761c2e3cf02$export$30daef8830f2505d = 'WAIT';
const $3e5c7761c2e3cf02$export$f86e250f1a7b07c8 = 'PROCEED';
const $3e5c7761c2e3cf02$export$e784a07a62e2e0e5 = 'TIMEOUT';

parcelRegister("9J85a", function(module, exports) {

$parcel$export(module.exports, "submitForgeFormField", () => $b1c36799aab2b39a$export$7e50fee868362aa2);
$parcel$export(module.exports, "dispatchFormSubmitAndBlurElements", () => $b1c36799aab2b39a$export$4d639a8e0790daf2);
$parcel$export(module.exports, "isBlurEventTriggeredOutsideTheField", () => $b1c36799aab2b39a$export$ee23412a8bea9333);

const $b1c36799aab2b39a$export$7e50fee868362aa2 = (formRef)=>{
    formRef?.current?.requestSubmit();
};
const $b1c36799aab2b39a$export$4d639a8e0790daf2 = (formRef)=>{
    $b1c36799aab2b39a$export$7e50fee868362aa2(formRef);
    if (formRef?.current?.elements) Array.from(formRef.current.elements).forEach((element)=>{
        if ('blur' in element && typeof element.blur === 'function') element?.blur();
    });
};
const $b1c36799aab2b39a$export$ee23412a8bea9333 = (fieldState, event, divRef)=>fieldState?.status === (0, $3e5c7761c2e3cf02$export$32bbcfb76243a487) && !divRef.current?.contains(event.relatedTarget);

});




parcelRegister("ct2PA", function(module, exports) {

$parcel$export(module.exports, "useIssueTransitionsOperationalAnalyticsEvent", () => $539a3126b0b48d6d$export$4d10663856b750d0);

var $5uXOq = parcelRequire("5uXOq");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");
const $539a3126b0b48d6d$export$4d10663856b750d0 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const fireOperationalEventIssueTransitionFieldsCount = (0, $5uXOq.useCallback)(({ actionSubject: actionSubject, fieldCount: fieldCount })=>{
        const analyticsEvent = createAnalyticsEvent({});
        (0, $8zOmE.fireOperationalAnalyticsDeferred)(analyticsEvent, actionSubject, {
            fieldCount: fieldCount
        });
    }, [
        createAnalyticsEvent
    ]);
    const fireOperationalAnalyticsPermissionsUnAvailable = (0, $5uXOq.useCallback)(({ actionSubject: actionSubject })=>{
        const analyticsEvent = createAnalyticsEvent({});
        (0, $8zOmE.fireOperationalAnalyticsDeferred)(analyticsEvent, actionSubject);
    }, [
        createAnalyticsEvent
    ]);
    const fireOperationalAnalyticsTransitionScreenOpened = (0, $5uXOq.useCallback)(({ actionSubject: actionSubject, isBenefitsModalFGEneabled: isBenefitsModalFGEneabled, preferNewIssueTransitionScreen: preferNewIssueTransitionScreen, issueViewAnalyticsSource: issueViewAnalyticsSource, isBenefitsModalDisabled: isBenefitsModalDisabled, dateToShowBenefitsModal: dateToShowBenefitsModal })=>{
        const analyticsEvent = createAnalyticsEvent({});
        (0, $8zOmE.fireOperationalAnalyticsDeferred)(analyticsEvent, actionSubject, {
            isBenefitsModalFGEneabled: isBenefitsModalFGEneabled,
            preferNewIssueTransitionScreen: preferNewIssueTransitionScreen,
            issueViewAnalyticsSource: issueViewAnalyticsSource,
            isBenefitsModalDisabled: isBenefitsModalDisabled,
            dateToShowBenefitsModal: dateToShowBenefitsModal
        });
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireOperationalEventIssueTransitionFieldsCount: fireOperationalEventIssueTransitionFieldsCount,
        fireOperationalAnalyticsPermissionsUnAvailable: fireOperationalAnalyticsPermissionsUnAvailable,
        fireOperationalAnalyticsTransitionScreenOpened: fireOperationalAnalyticsTransitionScreenOpened
    };
};

});

parcelRegister("3NlyR", function(module, exports) {

$parcel$export(module.exports, "useIssueTransitionUIAnalyticsEvent", () => $5656c248adec15f1$export$d0823e3d2e087672);

var $5uXOq = parcelRequire("5uXOq");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");
const $5656c248adec15f1$export$d0823e3d2e087672 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const fireUIEvent = (0, $5uXOq.useCallback)(({ analyticsEvent: analyticsEvent, actionSubjectId: actionSubjectId, action: action = 'clicked', actionSubject: actionSubject, attributes: attributes = {} })=>{
        if (analyticsEvent !== undefined) (0, $8zOmE.fireUIAnalytics)(analyticsEvent, actionSubjectId, attributes);
        else {
            const createdAnalyticsEvent = createAnalyticsEvent({
                action: action,
                actionSubject: actionSubject
            });
            (0, $8zOmE.fireUIAnalytics)(createdAnalyticsEvent, actionSubjectId, attributes);
        }
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireUIEvent: fireUIEvent
    };
};

});

parcelRegister("1btwe", function(module, exports) {

$parcel$export(module.exports, "usePublishOpenIssueTransitionModalPubSub", () => $9796b79be99bbec0$export$76b6328962c9935f);

var $5uXOq = parcelRequire("5uXOq");


var $iXy8e = parcelRequire("iXy8e");
const $9796b79be99bbec0$export$76b6328962c9935f = ()=>(0, $5uXOq.useCallback)((payload, isEnabled)=>{
        (0, $iXy8e.ITSPubSub).publish((0, $10a759732c3f1985$export$283bfc4a4b25707a), {
            payload: payload,
            isEnabled: isEnabled
        });
    }, []);

});
const $10a759732c3f1985$export$283bfc4a4b25707a = 'open-issue-transition-modal';

parcelRegister("iXy8e", function(module, exports) {

$parcel$export(module.exports, "ITSPubSub", () => $c6c4e897a3edd1a2$export$a3877931259d622e);

var $da7iT = parcelRequire("da7iT");
const $c6c4e897a3edd1a2$export$a3877931259d622e = new (0, $da7iT.PubSubHub)();
const $c6c4e897a3edd1a2$export$58b86c4766378620 = ()=>({
        ...$c6c4e897a3edd1a2$export$a3877931259d622e
    });

});
parcelRegister("da7iT", function(module, exports) {

$parcel$export(module.exports, "PubSubHub", () => $4d1dbccbbe967a62$export$e3607828f8f2c01e);
class $4d1dbccbbe967a62$export$e3607828f8f2c01e {
    constructor(){
        this.subscribers = {};
        this.subscribe = (event, subscriber)=>{
            let subs = this.subscribers[event];
            if (!subs) {
                subs = [];
                this.subscribers[event] = subs;
            }
            subs?.push(subscriber);
            return ()=>this.unsubscribe(event, subscriber);
        };
        this.unsubscribe = (event, subscriber)=>{
            const subs = this.subscribers[event];
            if (subs) this.subscribers[event] = subs.filter((subscription)=>subscription !== subscriber);
        };
        this.publish = (event, data)=>{
            const subs = this.subscribers[event];
            if (subs?.length) subs?.forEach((subscriber)=>subscriber(data));
        };
        this.clearAll = ()=>{
            this.subscribers = {};
        };
    }
}

});



parcelRegister("gjoNn", function(module, exports) {

$parcel$export(module.exports, "TriggerIssueTransitionModalContainer", () => $18f6c8628e84d111$export$8ad65e459a406a8a);
$parcel$export(module.exports, "useTriggerIssueTransitionModalActions", () => $18f6c8628e84d111$export$68de001c738e4145);
$parcel$export(module.exports, "useTriggerIssueTransitionModalState", () => $18f6c8628e84d111$export$d3aceeec551eaab5);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $gg7kZ = parcelRequire("gg7kZ");
var $iXqE5 = parcelRequire("iXqE5");

var $QnL9H = parcelRequire("QnL9H");

var $bpOxh = parcelRequire("bpOxh");
const $18f6c8628e84d111$var$store = (0, $iXqE5.createStore)({
    name: 'issue-transition.issue-transition-form.use-trigger-issue-transition-modal',
    initialState: $QnL9H.initialState,
    actions: $bpOxh
});
const $18f6c8628e84d111$export$8ad65e459a406a8a = (0, $gg7kZ.createContainer)($18f6c8628e84d111$var$store);
const $18f6c8628e84d111$export$68de001c738e4145 = (0, $3sQ5x.createActionsHook)($18f6c8628e84d111$var$store);
const $18f6c8628e84d111$export$d3aceeec551eaab5 = (0, $3sQ5x.createStateHook)($18f6c8628e84d111$var$store);

});
parcelRegister("QnL9H", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $b1651ed43432db50$export$d4c72bab9d6cc13a);
$parcel$export(module.exports, "OPEN_MODERN_TRANSITION_MODAL", () => $b1651ed43432db50$export$7320afd6d2c7276d);
$parcel$export(module.exports, "OPEN_LEGACY_TRANSITION_MODAL", () => $b1651ed43432db50$export$8ed7400ca8e89de2);

const $b1651ed43432db50$export$d4c72bab9d6cc13a = {
    isModalOpen: false,
    isBenefitsModalOpen: false,
    isSubsequentLoad: false,
    payload: {
        issueId: '',
        issueKey: '',
        transitionId: ''
    },
    id: 'issue-transition-dialog',
    title: null,
    fetchedIssueId: '',
    triggerPointKey: (0, $b09837015a6d4fc3$export$8d987f6e80b74000),
    openLegacyTransitionsDialog: null,
    onDialogSuccess: null,
    onDialogCancel: null,
    onDialogError: null
};
const $b1651ed43432db50$export$7320afd6d2c7276d = 'OPEN_MODERN_TRANSITION_MODAL';
const $b1651ed43432db50$export$8ed7400ca8e89de2 = 'OPEN_LEGACY_TRANSITION_MODAL';

});
const $b09837015a6d4fc3$export$ef94a84e2990361c = 'issue-transition-issue-view';
const $b09837015a6d4fc3$export$de11f84a7d32933b = 'issue-transition-board-card-transition';
const $b09837015a6d4fc3$export$6c46e4003e7b7e9c = 'issue-transition-advanced-roadmaps-jira-transition';
const $b09837015a6d4fc3$export$e77cd508fbc3b5ba = 'issue-transition-backlog-inline-transition';
const $b09837015a6d4fc3$export$4edf4c3eee5081f6 = 'issue-transition-issue-view-shortcut-dialog';
const $b09837015a6d4fc3$export$27b74e685c26e665 = 'issue-transition-command-palette-status-field-transition';
const $b09837015a6d4fc3$export$290710ac08f770c0 = 'issue-transition-issue-results-shortcut-transition';
const $b09837015a6d4fc3$export$ddade13ad1b89bf0 = 'issue-transition-status-field-trigger';
const $b09837015a6d4fc3$export$8d987f6e80b74000 = 'trigger-point-key-not-defined';
const $b09837015a6d4fc3$export$2bf0e335b815a90b = 'comment';
const $b09837015a6d4fc3$export$1b8cc53b37a62399 = 'worklog';
const $b09837015a6d4fc3$export$d624b8367eb730df = 'issuelinks';


parcelRegister("bpOxh", function(module, exports) {

$parcel$export(module.exports, "closeIssueTransitionModal", () => (parcelRequire("3KYVT")).default);
$parcel$export(module.exports, "openIssueTransitionModal", () => (parcelRequire("3cIaS")).default);
$parcel$export(module.exports, "restoreState", () => (parcelRequire("keQtD")).default);
$parcel$export(module.exports, "setFetchedIssueId", () => (parcelRequire("fb5Xn")).default);
$parcel$export(module.exports, "hideBenefitsModal", () => (parcelRequire("bemkp")).default);
$parcel$export(module.exports, "openIssueTransitionModalNew", () => (parcelRequire("bnv5t")).default);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports

var $3KYVT = parcelRequire("3KYVT");

var $3cIaS = parcelRequire("3cIaS");

var $keQtD = parcelRequire("keQtD");

var $fb5Xn = parcelRequire("fb5Xn");

var $bemkp = parcelRequire("bemkp");

var $bnv5t = parcelRequire("bnv5t");

});
parcelRegister("3KYVT", function(module, exports) {

$parcel$export(module.exports, "default", () => $09ddf425c332ed49$export$2e2bcd8739ae039);

var $QnL9H = parcelRequire("QnL9H");
const $09ddf425c332ed49$var$closeIssueTransitionModal = ()=>({ setState: setState })=>{
        setState({
            ...(0, $QnL9H.initialState),
            isModalOpen: false,
            isSubsequentLoad: true
        });
    };
var $09ddf425c332ed49$export$2e2bcd8739ae039 = $09ddf425c332ed49$var$closeIssueTransitionModal;

});

parcelRegister("3cIaS", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc7e957c004b1c31$export$2e2bcd8739ae039);

var $8Rkzz = parcelRequire("8Rkzz");

var $eVcDT = parcelRequire("eVcDT");

var $emTT1 = parcelRequire("emTT1");

var $lTEVZ = parcelRequire("lTEVZ");

var $jtjyW = parcelRequire("jtjyW");

var $jHYHS = parcelRequire("jHYHS");
const $cc7e957c004b1c31$var$openIssueTransitionModal = (nextState, preferNewIssueTransitionScreen = true)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const { payload: { issueKey: issueKey = '', transitionId: transitionId = '' }, onDialogSuccess: onDialogSuccess, onDialogCancel: onDialogCancel, onDialogError: onDialogError, triggerPointKey: triggerPointKey } = nextState || {
            payload: {}
        };
        let transitionModalVersion = '';
        const isNewITSEnabled = (0, $jHYHS.isNewTransitionScreenEnabled)(preferNewIssueTransitionScreen, triggerPointKey);
        try {
            if (isNewITSEnabled) {
                transitionModalVersion = 'NEW';
                (0, $jtjyW.startIssueTransitionMetrics)(currentState.isSubsequentLoad);
                setState({
                    ...currentState,
                    isModalOpen: true,
                    // making fetchedIssueId as blank to ensure we donot end up using stale issueId
                    fetchedIssueId: '',
                    ...nextState
                });
            } else {
                transitionModalVersion = 'OLD';
                (0, $emTT1.timeToRenderTransitionModal).start();
                new (0, $eVcDT.default)({
                    issueKey: issueKey,
                    transitionId: transitionId
                }).onDialogSuccess(onDialogSuccess || (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))).onDialogCancel(onDialogCancel || (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))).onDialogError(onDialogError || (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))).show();
            }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $lTEVZ.fireIssueTransitionErrorAnalytics)({
                meta: {
                    id: 'transitionIssueTrigger',
                    packageName: 'jiraIssueTransitionTrigger',
                    teamName: 'gryffindor'
                },
                error: error,
                attributes: {
                    transitionModalVersion: transitionModalVersion
                },
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    };
var $cc7e957c004b1c31$export$2e2bcd8739ae039 = $cc7e957c004b1c31$var$openIssueTransitionModal;

});
parcelRegister("eVcDT", function(module, exports) {

$parcel$export(module.exports, "default", () => $25bfe0b90f22578e$export$2e2bcd8739ae039);

var $8Rkzz = parcelRequire("8Rkzz");

var $6BZYo = parcelRequire("6BZYo");
var $ig88W = parcelRequire("ig88W");
var $7T84i = parcelRequire("7T84i");
var $9B86Q = parcelRequire("9B86Q");
var $cQZXC = parcelRequire("cQZXC");
var $8JNtu = parcelRequire("8JNtu");

var $4tcSU = parcelRequire("4tcSU");

var $4R6GH = parcelRequire("4R6GH");

var $emTT1 = parcelRequire("emTT1");
class $25bfe0b90f22578e$export$2e2bcd8739ae039 {
    constructor({ issueId: issueId, transitionId: transitionId, issueKey: issueKey, issueKeys: issueKeys }){
        this.onDialogSuccessCallback = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)));
        this.onDialogErrorCallback = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)));
        this.onDialogCancelCallback = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)));
        this.issueId = issueId;
        this.transitionId = transitionId;
        this.issueKey = issueKey;
        this.issueKeys = issueKeys;
    }
    static{
        this.onDialogContentReady = ()=>{
            // This event fired by a dialog before the dialog itself is rendered and visible to the user
            // That's why we need to postpone sending the response to the next moment after it became visible
            setTimeout(()=>{
                (0, $emTT1.timeToRenderTransitionModal).stop();
            });
        };
    }
    onDialogSuccess(onDialogSuccessCallback) {
        this.onDialogSuccessCallback = onDialogSuccessCallback;
        return this;
    }
    onDialogError(onDialogErrorCallback) {
        this.onDialogErrorCallback = onDialogErrorCallback;
        return this;
    }
    onDialogCancel(onDialogCancelCallback) {
        this.onDialogCancelCallback = onDialogCancelCallback;
        return this;
    }
    getIssueParam() {
        if (this.issueId != null) return `id=${this.issueId}`;
        if (this.issueKey != null) return `key=${this.issueKey}`;
        return '';
    }
    getUrl() {
        const { issueKeys: issueKeys } = this;
        if (issueKeys != null) // key= is needed to be sent together with keys= because of legacy API
        return `/secure/BulkTransitionIssue!default.jspa?keys=${issueKeys.join(',')}&key=${issueKeys[0]}&action=${this.transitionId}&atl_token=${(0, $4tcSU.default)() || ''}&decorator=dialog&inline=true&returnUrl=`;
        return `/secure/WorkflowUIDispatcher.jspa?${this.getIssueParam()}&action=${this.transitionId}&atl_token=${(0, $4tcSU.default)() || ''}&returnUrl=`;
    }
    async show() {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.addEventListener('legacyJiraDialogContentReady', $25bfe0b90f22578e$export$2e2bcd8739ae039.onDialogContentReady);
        let FormDialog;
        /**
		 * Trying out different ways of load the AMD bundle for legacy issue transition dialog
		 */ /* eslint-disable jira/wrm/no-load-bridge */ if ((0, $4R6GH.fg)('legacy-its-modal-load-with-load-bridge-weak')) FormDialog = await (0, $9B86Q.loadBridgeWeak)({
            name: 'jira/dialog/form-dialog'
        });
        else if ((0, $4R6GH.fg)('legacy-its-modal-load-with-load-bridge-strict')) {
            await (0, $cQZXC.waitForHeritage)();
            FormDialog = await (0, $7T84i.loadBridgeStrict)({
                name: 'jira/dialog/form-dialog',
                wrmKeys: [
                    'wrc!jira.webresources:dialogs'
                ]
            });
        } else if ((0, $4R6GH.fg)('legacy-issue-transition-load-bridge')) {
            await (0, $8JNtu.wrmRequire)([
                'wrc!jira.webresources:dialogs'
            ]);
            FormDialog = await (0, $ig88W.loadBridgeRace)({
                name: 'jira/dialog/form-dialog',
                timeout: 2000
            });
        } else FormDialog = await (0, $6BZYo.loadBridge)({
            name: 'jira/dialog/form-dialog',
            wrmKeys: 'wrc!jira.webresources:dialogs'
        });
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        const dialog = new FormDialog({
            id: 'edit-issue-dialog',
            ajaxOptions: {
                url: this.getUrl(),
                dataType: 'json'
            },
            autoClose: true,
            widthClass: 'large',
            onDialogFinished: this.onDialogSuccessCallback,
            onUnSuccessfulSubmit: this.onDialogErrorCallback,
            shouldLoadHeritageFormDialogContext: true
        });
        const cancelNativeHandler = (event)=>{
            if (!(event instanceof CustomEvent)) return;
            const dialogElement = event.detail.popup;
            const { reason: reason } = event.detail;
            if (dialogElement.is(dialog.get$popup())) {
                if (reason === 'cancel' || reason === 'esc') this.onDialogCancelCallback(event, dialogElement, reason);
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                document.removeEventListener('legacyJiraDialogBeforeHide', cancelNativeHandler);
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                document.removeEventListener('legacyJiraDialogContentReady', $25bfe0b90f22578e$export$2e2bcd8739ae039.onDialogContentReady);
            }
        };
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.addEventListener('legacyJiraDialogBeforeHide', cancelNativeHandler);
        dialog.show();
    }
}

});
parcelRegister("emTT1", function(module, exports) {

$parcel$export(module.exports, "timeToRenderTransitionModal", () => $4a78c80c71ff3414$export$9d20a86383e90d09);

var $dGrdR = parcelRequire("dGrdR");
const $4a78c80c71ff3414$export$9d20a86383e90d09 = (0, $dGrdR.metrics).interaction({
    key: 'issue.time-to.render-issue-transition-screen',
    // @ts-expect-error - TS2741 - Property '[BMInteractionMetrics.response]' is missing in type '{ result: string; }' but required in type 'InteractionHistogramConfig'.
    histogram: {
        result: '500_1000_2500_4000_7000_10000'
    }
});

});


parcelRegister("jtjyW", function(module, exports) {

$parcel$export(module.exports, "startIssueTransitionMetrics", () => $1832266ecf87e128$export$3fc439100e136a52);

var $eTXmK = parcelRequire("eTXmK");

var $lL2Jl = parcelRequire("lL2Jl");

var $lP1Jn = parcelRequire("lP1Jn");

var $fc6nm = parcelRequire("fc6nm");
const $1832266ecf87e128$export$3fc439100e136a52 = (isSubsequentLoad)=>{
    (0, $lL2Jl.IssueTransitionLoadUFOExperience).start();
    (0, $lL2Jl.IssueTransitionUFOExperience).start();
    const issueTransitionModalLoadMetric = isSubsequentLoad ? (0, $lP1Jn.issueTransittionModalLoadSubsequent) : (0, $lP1Jn.issueTransitionModalLoad);
    if (isSubsequentLoad) (0, $eTXmK.default)('issue-transition.transition-modal-subsequent');
    else (0, $eTXmK.default)('issue-transition.transition-modal');
    issueTransitionModalLoadMetric.start();
    (0, $fc6nm.startUimTTI)();
};

});
parcelRegister("lL2Jl", function(module, exports) {

$parcel$export(module.exports, "IssueTransitionLoadUFOExperience", () => $f07939f1a4892f29$export$8fb308d8abecd81a);
$parcel$export(module.exports, "IssueTransitionSubmitUFOExpereince", () => $f07939f1a4892f29$export$bd3bf8b90a131c50);
$parcel$export(module.exports, "IssueTransitionUFOExperience", () => $f07939f1a4892f29$export$2f3b26e8acf79182);

var $atdLB = parcelRequire("atdLB");
var $duUGa = parcelRequire("duUGa");
const $f07939f1a4892f29$export$8fb308d8abecd81a = new (0, $duUGa.UFOExperience)('issue-transition-screen.transition-load', {
    type: (0, $atdLB.ExperienceTypes).Experience,
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).Custom,
    category: 'issue-transition-screen.transition-load'
});
const $f07939f1a4892f29$export$bd3bf8b90a131c50 = new (0, $duUGa.UFOExperience)('issue-transition-screen.transition-submit', {
    type: (0, $atdLB.ExperienceTypes).Experience,
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).Custom,
    category: 'issue-transition-screen.transition-sumbit'
});
const $f07939f1a4892f29$export$2f3b26e8acf79182 = new (0, $duUGa.UFOExperience)('issue-transition-screen.transition-issue', {
    type: (0, $atdLB.ExperienceTypes).Experience,
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).Custom,
    category: 'issue-transition-screen.transition-issue'
});

});

parcelRegister("lP1Jn", function(module, exports) {

$parcel$export(module.exports, "issueTransitionModalLoad", () => $e48205cb6c384272$export$772fb4a8bd181fd6);
$parcel$export(module.exports, "issueTransittionModalLoadSubsequent", () => $e48205cb6c384272$export$afa89f024c56a00a);

var $dGrdR = parcelRequire("dGrdR");
const $e48205cb6c384272$export$772fb4a8bd181fd6 = (0, $dGrdR.metrics).interaction({
    key: 'issue-transition-modal'
});
const $e48205cb6c384272$export$afa89f024c56a00a = (0, $dGrdR.metrics).interaction({
    key: 'issue-transition-modal-subsequent'
});

});

parcelRegister("fc6nm", function(module, exports) {

$parcel$export(module.exports, "startUimTTI", () => $50f6a9f98192a4eb$export$ae34c17d9cd2c876);
$parcel$export(module.exports, "markIssueTransitionLoaded", () => $50f6a9f98192a4eb$export$7cc1bb35860c7c25);
$parcel$export(module.exports, "stopTTI", () => $50f6a9f98192a4eb$export$30ca4c461fab486c);
$parcel$export(module.exports, "cancelTTI", () => $50f6a9f98192a4eb$export$27f2445288b528c);
$parcel$export(module.exports, "markIframeLoad", () => $50f6a9f98192a4eb$export$7a2709fc1e33401a);
$parcel$export(module.exports, "markFieldsRegistered", () => $50f6a9f98192a4eb$export$cf3893335c93e33b);
$parcel$export(module.exports, "markOnInitResolved", () => $50f6a9f98192a4eb$export$d86f4868694f2aa7);
/**
 * For issue view, we moved similar constants to view-specific packages.
 * However, for issue-transition, such a move causes a circular dependency with @atlassian/jira-issue-transition-trigger package,
 * since view-specific/issue-transition imports trigger points related functionality from @atlassian/jira-issue-transition-trigger.
 * Therefore, for now, let's keep it here.
 */ 
var $dGrdR = parcelRequire("dGrdR");
const $50f6a9f98192a4eb$var$uimInIssueTransitionTTI = (0, $dGrdR.metrics).interaction({
    key: 'ui-modifications-in-issue-transition',
    timings: [
        {
            key: 'issue-transition-tti-delta',
            startMark: 'issue-transition-tti'
        },
        {
            key: 'script-execution',
            startMark: 'iframe-load'
        },
        {
            key: 'loading-indicators-visibility',
            startMark: 'fields-registered'
        },
        {
            key: 'time-until-oninit-resolved',
            endMark: 'oninit-resolved'
        }
    ]
});
const $50f6a9f98192a4eb$export$ae34c17d9cd2c876 = ()=>{
    $50f6a9f98192a4eb$var$uimInIssueTransitionTTI.start();
};
const $50f6a9f98192a4eb$export$7cc1bb35860c7c25 = ()=>$50f6a9f98192a4eb$var$uimInIssueTransitionTTI.mark('issue-transition-tti');
const $50f6a9f98192a4eb$export$30ca4c461fab486c = (customData)=>{
    $50f6a9f98192a4eb$var$uimInIssueTransitionTTI.stop({
        customData: customData
    });
};
const $50f6a9f98192a4eb$export$27f2445288b528c = ()=>{
    $50f6a9f98192a4eb$var$uimInIssueTransitionTTI.cancel();
};
const $50f6a9f98192a4eb$export$7a2709fc1e33401a = ()=>{
    $50f6a9f98192a4eb$var$uimInIssueTransitionTTI.mark('iframe-load');
};
const $50f6a9f98192a4eb$export$cf3893335c93e33b = ()=>{
    $50f6a9f98192a4eb$var$uimInIssueTransitionTTI.mark('fields-registered');
};
const $50f6a9f98192a4eb$export$d86f4868694f2aa7 = ()=>{
    $50f6a9f98192a4eb$var$uimInIssueTransitionTTI.mark('oninit-resolved');
};

});


parcelRegister("jHYHS", function(module, exports) {

$parcel$export(module.exports, "isNewTransitionScreenEnabled", () => $5f3a7dc1f1182e00$export$1f5b72e7dbe0548d);

var $c04PQ = parcelRequire("c04PQ");

var $4R6GH = parcelRequire("4R6GH");
const $5f3a7dc1f1182e00$export$1f5b72e7dbe0548d = (preferNewIssueTransitionScreen, triggerPointKey)=>{
    if ((0, $c04PQ.isFedRamp)()) return true;
    if (!(0, $4R6GH.fg)('render-modern-issue-transition')) return false;
    if (!triggerPointKey) return false;
    return preferNewIssueTransitionScreen || (0, $4R6GH.fg)('issue-transition-customisation-for-srb');
};

});


parcelRegister("keQtD", function(module, exports) {

$parcel$export(module.exports, "default", () => $9984214aecd9b0cd$export$2e2bcd8739ae039);
const $9984214aecd9b0cd$var$restoreState = (stateToRestore)=>({ setState: setState })=>{
        setState(stateToRestore);
    };
var $9984214aecd9b0cd$export$2e2bcd8739ae039 = $9984214aecd9b0cd$var$restoreState;

});

parcelRegister("fb5Xn", function(module, exports) {

$parcel$export(module.exports, "default", () => $58f04f71b4951234$export$2e2bcd8739ae039);
/**
 *
 * @deprecated since we should not be using this in the log run
 * we should not call this method any where and should clean this up as soon as GIC-JIS migration is done
 * @param issueId
 * @returns
 */ const $58f04f71b4951234$var$setFetchedIssueId = (issueId)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const { fetchedIssueId: fetchedIssueId } = currentState;
        if (issueId !== fetchedIssueId) setState({
            ...currentState,
            fetchedIssueId: issueId
        });
    };
var $58f04f71b4951234$export$2e2bcd8739ae039 = $58f04f71b4951234$var$setFetchedIssueId;

});

parcelRegister("bemkp", function(module, exports) {

$parcel$export(module.exports, "default", () => $66c42f9cd1814e06$export$2e2bcd8739ae039);

var $QnL9H = parcelRequire("QnL9H");

var $jtjyW = parcelRequire("jtjyW");
const $66c42f9cd1814e06$var$hideBenefitsModal = (nextAction)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        if (nextAction === (0, $QnL9H.OPEN_MODERN_TRANSITION_MODAL)) {
            (0, $jtjyW.startIssueTransitionMetrics)(currentState.isSubsequentLoad);
            setState({
                ...currentState,
                isBenefitsModalOpen: false,
                isModalOpen: true
            });
        } else if (nextAction === (0, $QnL9H.OPEN_LEGACY_TRANSITION_MODAL)) {
            const { openLegacyTransitionsDialog: openLegacyTransitionsDialog } = getState();
            setState({
                ...currentState,
                isBenefitsModalOpen: false,
                isModalOpen: false
            });
            openLegacyTransitionsDialog?.();
        }
    };
var $66c42f9cd1814e06$export$2e2bcd8739ae039 = $66c42f9cd1814e06$var$hideBenefitsModal;

});

parcelRegister("bnv5t", function(module, exports) {

$parcel$export(module.exports, "default", () => $0522276a96c69778$export$2e2bcd8739ae039);

var $8Rkzz = parcelRequire("8Rkzz");

var $eVcDT = parcelRequire("eVcDT");

var $emTT1 = parcelRequire("emTT1");

var $lTEVZ = parcelRequire("lTEVZ");

var $4R6GH = parcelRequire("4R6GH");

var $jtjyW = parcelRequire("jtjyW");

var $jHYHS = parcelRequire("jHYHS");
const $0522276a96c69778$var$openIssueTransitionModalNew = ({ nextState: nextState, preferNewIssueTransitionScreen: preferNewIssueTransitionScreen = true, issueViewAnalyticsSource: issueViewAnalyticsSource, publishTriggerToOpenTransitions: publishTriggerToOpenTransitions, isBenefitsModalDisabled: isBenefitsModalDisabled, dateToShowBenefitsModal: dateToShowBenefitsModal, fireUIEvent: fireUIEvent })=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const { payload: { issueKey: issueKey = '', transitionId: transitionId = '' }, onDialogSuccess: onDialogSuccess, onDialogCancel: onDialogCancel, onDialogError: onDialogError, triggerPointKey: triggerPointKey } = nextState || {
            payload: {}
        };
        let transitionModalVersion = '';
        const isNewITSEnabled = (0, $jHYHS.isNewTransitionScreenEnabled)(preferNewIssueTransitionScreen, triggerPointKey);
        try {
            if (isNewITSEnabled) {
                if (issueViewAnalyticsSource === 'connect-issue') {
                    publishTriggerToOpenTransitions?.(nextState, preferNewIssueTransitionScreen);
                    fireUIEvent?.({
                        actionSubject: 'issueTransition',
                        actionSubjectId: 'connectIssue',
                        action: 'opened'
                    });
                    return;
                }
                transitionModalVersion = 'NEW';
                (0, $jtjyW.startIssueTransitionMetrics)(currentState.isSubsequentLoad);
                setState({
                    ...currentState,
                    isModalOpen: true,
                    // making fetchedIssueId as blank to ensure we donot end up using stale issueId
                    fetchedIssueId: '',
                    ...nextState
                });
                return;
            }
            const currentDate = new Date();
            const showBenefitsModalOnDate = dateToShowBenefitsModal && dateToShowBenefitsModal !== 'null' ? new Date(dateToShowBenefitsModal) : new Date(-1);
            const isDateToShowBenefitsModalLessThanCurrentDate = currentDate >= showBenefitsModalOnDate;
            if (!isBenefitsModalDisabled && issueViewAnalyticsSource !== 'connect-issue' && isDateToShowBenefitsModalLessThanCurrentDate && (0, $4R6GH.fg)('render-modern-issue-transition')) {
                // add condition to show BenefitsModal
                transitionModalVersion = 'NEW';
                const callback = ()=>{
                    (0, $emTT1.timeToRenderTransitionModal).start();
                    new (0, $eVcDT.default)({
                        issueKey: issueKey,
                        transitionId: transitionId
                    }).onDialogSuccess(onDialogSuccess || (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))).onDialogCancel(onDialogCancel || (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))).onDialogError(onDialogError || (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))).show();
                };
                setState({
                    ...currentState,
                    isBenefitsModalOpen: true,
                    // making fetchedIssueId as blank to ensure we donot end up using stale issueId
                    fetchedIssueId: '',
                    ...nextState,
                    openLegacyTransitionsDialog: callback
                });
            } else {
                transitionModalVersion = 'OLD';
                (0, $emTT1.timeToRenderTransitionModal).start();
                new (0, $eVcDT.default)({
                    issueKey: issueKey,
                    transitionId: transitionId
                }).onDialogSuccess(onDialogSuccess || (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))).onDialogCancel(onDialogCancel || (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))).onDialogError(onDialogError || (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))).show();
            }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $lTEVZ.fireIssueTransitionErrorAnalytics)({
                meta: {
                    id: 'transitionIssueTrigger',
                    packageName: 'jiraIssueTransitionTrigger',
                    teamName: 'gryffindor'
                },
                error: error,
                attributes: {
                    transitionModalVersion: transitionModalVersion
                },
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    };
var $0522276a96c69778$export$2e2bcd8739ae039 = $0522276a96c69778$var$openIssueTransitionModalNew;

});



parcelRegister("ipUU1", function(module, exports) {

$parcel$export(module.exports, "openLegacyIssueTransitionModal", () => $f258fa9a0604f29b$export$6bfef2005bd55204);

var $8Rkzz = parcelRequire("8Rkzz");

var $eVcDT = parcelRequire("eVcDT");

var $emTT1 = parcelRequire("emTT1");

var $lTEVZ = parcelRequire("lTEVZ");
const $f258fa9a0604f29b$export$6bfef2005bd55204 = ({ issueKey: issueKey, transitionId: transitionId, onDialogSuccess: onDialogSuccess, onDialogCancel: onDialogCancel, onDialogError: onDialogError, isReopenScenario: isReopenScenario = false, onOpenDialog: onOpenDialog })=>{
    try {
        (0, $emTT1.timeToRenderTransitionModal).start();
        new (0, $eVcDT.default)({
            issueKey: issueKey,
            transitionId: transitionId
        }).onDialogSuccess(onDialogSuccess || (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))).onDialogCancel(onDialogCancel || (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))).onDialogError(onDialogError || (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))).show();
        onOpenDialog?.();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $lTEVZ.fireIssueTransitionErrorAnalytics)({
            meta: {
                id: 'transitionIssueTrigger',
                packageName: 'jiraIssueTransitionTrigger',
                teamName: 'gryffindor'
            },
            error: error,
            attributes: {
                transitionModalVersion: 'OLD',
                isReopenScenario: isReopenScenario
            },
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};

});



parcelRegister("9LhEA", function(module, exports) {

$parcel$export(module.exports, "default", () => $9219ecc11e56ae54$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $9219ecc11e56ae54$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    transitionValidationErrorTitle: {
        "id": "work-management-board.controllers.update-issue.transition-validation-error-title",
        "defaultMessage": "Transition failed"
    },
    failedToTransitionErrorTitle: {
        "id": "work-management-board.controllers.update-issue.failed-to-transition-error-title",
        "defaultMessage": "We couldn't change the status of the item"
    },
    failedToTransitionErrorDescription: {
        "id": "work-management-board.controllers.update-issue.failed-to-transition-error-description",
        "defaultMessage": "Check your connection, then give it another try."
    },
    failedToRankErrorTitle: {
        "id": "work-management-board.controllers.update-issue.failed-to-rank-error-title",
        "defaultMessage": "We couldn't move the item"
    },
    failedToRankErrorDescription: {
        "id": "work-management-board.controllers.update-issue.failed-to-rank-error-description",
        "defaultMessage": "Check your connection, then give it another try."
    },
    failedToUpdateFieldsErrorTitle: {
        "id": "work-management-board.controllers.update-issue.failed-to-update-fields-error-title",
        "defaultMessage": "We couldn't update the item"
    },
    failedToUpdateFieldsErrorDescription: {
        "id": "work-management-board.controllers.update-issue.failed-to-update-fields-error-description",
        "defaultMessage": "Check your connection, then give it another try."
    }
});

});



parcelRegister("dblxc", function(module, exports) {

$parcel$export(module.exports, "isCard", () => $963b3e0c4208df74$export$8aa6e45444373ba8);
$parcel$export(module.exports, "isColumn", () => $963b3e0c4208df74$export$891484e65a02ec71);
$parcel$export(module.exports, "isTransitionZone", () => $963b3e0c4208df74$export$3efcc0a6b0c287c2);
$parcel$export(module.exports, "isClosestEdgeAdjacentToSource", () => $963b3e0c4208df74$export$775b69cd23194e37);


var $cvj5l = parcelRequire("cvj5l");
function $963b3e0c4208df74$export$8aa6e45444373ba8(data) {
    return data.type === (0, $cvj5l.CARD_DND_TYPE);
}
function $963b3e0c4208df74$export$891484e65a02ec71(data) {
    return data.type === (0, $cvj5l.COLUMN_DND_TYPE);
}
function $963b3e0c4208df74$export$3efcc0a6b0c287c2(data) {
    return data.type === (0, $25c2ea87c2b04bf9$export$2927f4d423091b16);
}
const $963b3e0c4208df74$export$775b69cd23194e37 = (sourceIndex, destinationIndex, closestEdge)=>{
    if (closestEdge == null) return false;
    const adjacentEdges = {
        top: sourceIndex + 1,
        bottom: sourceIndex - 1,
        left: sourceIndex + 1,
        right: sourceIndex - 1
    };
    return destinationIndex === adjacentEdges[closestEdge];
};

});
const $25c2ea87c2b04bf9$export$b05303cbde3e8c8c = 'CARD';
const $25c2ea87c2b04bf9$export$57d0ef745f304b91 = 'COLUMN';
const $25c2ea87c2b04bf9$export$2927f4d423091b16 = 'TRANSITION_ZONE';



parcelRegister("3WdOs", function(module, exports) {

$parcel$export(module.exports, "useJWMBoardFeatures", () => $46231830c597c708$export$2e6493f557c370c4);
$parcel$export(module.exports, "default", () => $46231830c597c708$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $46231830c597c708$var$defaultFeaturesContext = {
    isShareButtonEnabled: true,
    isPresenceEnabled: true,
    withSaveRevertView: true,
    issueViewInteraction: 'default',
    isOnboardingEnabled: true,
    featureView: 'jwm-board',
    inviteButtonInteraction: 'default',
    typeSelectInteraction: 'default'
};
const $46231830c597c708$var$BusinessBoardFeaturesContext = /*#__PURE__*/ (0, $5uXOq.createContext)($46231830c597c708$var$defaultFeaturesContext);
const $46231830c597c708$export$2e6493f557c370c4 = ()=>(0, $5uXOq.useContext)($46231830c597c708$var$BusinessBoardFeaturesContext);
var $46231830c597c708$export$2e2bcd8739ae039 = $46231830c597c708$var$BusinessBoardFeaturesContext;

});

parcelRegister("dgAvR", function(module, exports) {

$parcel$export(module.exports, "useHandleIssueEvents", () => $6d7be09486e7cb41$export$6339e8336d465669);

var $5uXOq = parcelRequire("5uXOq");

var $33Toe = parcelRequire("33Toe");

var $cvj5l = parcelRequire("cvj5l");

var $gEtYC = parcelRequire("gEtYC");

var $dxAlC = parcelRequire("dxAlC");

var $6xpM6 = parcelRequire("6xpM6");
const $6d7be09486e7cb41$export$6339e8336d465669 = ()=>{
    const issues = (0, $dxAlC.useIssues)();
    const getIsHighlighted = (0, $33Toe.useIsHighlighted)();
    const refetchIssues = (0, $6xpM6.useRefetchIssues)();
    const { removeIssues: removeIssues } = (0, $gEtYC.useIssueStoreActions)();
    const handleUpdatedIssue = (0, $5uXOq.useCallback)(async (issueId)=>{
        // Return early when we receive realtime events for an issue that was
        // recently created via the issue create component in the current window.
        // This avoid race conditions.
        if (getIsHighlighted(issueId)) return;
        const [updatedIssue] = await refetchIssues([
            issueId
        ]);
        if (updatedIssue) {
            const parentIssueId = updatedIssue.fields[0, $cvj5l.PARENT_ID]?.value;
            if (parentIssueId) refetchIssues([
                Number(parentIssueId)
            ]);
        }
    }, [
        getIsHighlighted,
        refetchIssues
    ]);
    const handleDeletedIssue = (0, $5uXOq.useCallback)((issueId)=>{
        const deletedIssue = issues.get(issueId);
        if (deletedIssue == null) return;
        const parentIssue = issues.get(Number(deletedIssue.fields[0, $cvj5l.PARENT_ID]?.value));
        if (parentIssue) refetchIssues([
            parentIssue.id
        ]);
        removeIssues([
            issueId
        ]);
    }, [
        issues,
        refetchIssues,
        removeIssues
    ]);
    return {
        handleUpdatedIssue: handleUpdatedIssue,
        handleDeletedIssue: handleDeletedIssue
    };
};

});

parcelRegister("l1jgj", function(module, exports) {

$parcel$export(module.exports, "IssueGroupProvider", () => $a86452c03fb10e72$export$dc797f621868b0d5);
$parcel$export(module.exports, "useIssueGroup", () => $a86452c03fb10e72$export$7169da554b06d9e9);

var $5uXOq = parcelRequire("5uXOq");

var $4kGgG = parcelRequire("4kGgG");
const $a86452c03fb10e72$var$EMPTY_ISSUES = [];
const $a86452c03fb10e72$var$IssueGroupContext = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $a86452c03fb10e72$export$dc797f621868b0d5 = ({ groupId: groupId, children: children })=>{
    const issuesByGroup = (0, $4kGgG.useIssuesByGroup)();
    const issues = issuesByGroup.get(groupId) ?? $a86452c03fb10e72$var$EMPTY_ISSUES;
    const value = (0, $5uXOq.useMemo)(()=>({
            issues: issues
        }), [
        issues
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a86452c03fb10e72$var$IssueGroupContext.Provider, {
        value: value
    }, children);
};
const $a86452c03fb10e72$export$7169da554b06d9e9 = ()=>{
    const issueGroup = (0, $5uXOq.useContext)($a86452c03fb10e72$var$IssueGroupContext);
    if (!issueGroup) throw new Error('useIssueGroup must be used within a IssueGroupProvider');
    return issueGroup;
};

});

parcelRegister("2EbGw", function(module, exports) {

$parcel$export(module.exports, "useReorderColumns", () => $b8f2b8ec199cb157$export$b250c61f32d9da58);

var $69qbK = parcelRequire("69qbK");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $kaHBi = parcelRequire("kaHBi");

var $93jKl = parcelRequire("93jKl");

var $3bQtK = parcelRequire("3bQtK");

var $pa9q9 = parcelRequire("pa9q9");

var $iJZ8l = parcelRequire("iJZ8l");

var $eERQr = parcelRequire("eERQr");

var $7y8jx = parcelRequire("7y8jx");

var $5R49c = parcelRequire("5R49c");
const $b8f2b8ec199cb157$var$experience = 'setBoardViewColumnsOrder';
const $b8f2b8ec199cb157$export$b250c61f32d9da58 = (viewId)=>{
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const startExperience = (0, $kaHBi.useExperienceStart)({
        experience: $b8f2b8ec199cb157$var$experience,
        analyticsSource: 'jiraWorkManagementBoard'
    });
    const markExperienceSuccess = (0, $3bQtK.useExperienceSuccess)({
        experience: $b8f2b8ec199cb157$var$experience
    });
    const markExperienceFailed = (0, $93jKl.useExperienceFail)({
        experience: $b8f2b8ec199cb157$var$experience
    });
    const [commit] = (0, $8Uumt.useMutation)((0, $69qbK.default));
    return (0, $5uXOq.useCallback)((reorderedColumnIds)=>{
        startExperience();
        const handleFailure = (error)=>{
            markExperienceFailed('BoardContent jira_setBoardViewColumnsOrder mutation failed', error);
            showFlag({
                messageId: 'work-management-board.controllers.reorder-columns.show-flag.error.columns-reordered.show-flag.error.ui.board.show-flag.error.set-board-view-columns-order',
                messageType: 'transactional',
                title: (0, $5R49c.default).setBoardViewColumnsOrderFailedTitle,
                description: (0, $5R49c.default).setBoardViewColumnsOrderFailedMessage,
                type: 'error'
            });
        };
        commit({
            variables: {
                input: {
                    columnIds: reorderedColumnIds,
                    viewId: viewId,
                    settings: (0, $7y8jx.getBoardQueryParams)()
                }
            },
            optimisticUpdater: (store)=>{
                const relayId = (0, $iJZ8l.default)({
                    id: viewId
                }, 'JiraBoardView');
                const boardViewRecord = relayId && store.get(relayId);
                const connection = boardViewRecord && (0, $8Uumt.ConnectionHandler).getConnection(boardViewRecord, 'business_board_columns');
                if (!connection) return;
                const existingEdges = connection.getLinkedRecords('edges') || [];
                const newEdges = reorderedColumnIds.map((columnId)=>existingEdges.find((edge)=>edge?.getLinkedRecord('node')?.getValue('id') === columnId)).filter(Boolean);
                connection.setLinkedRecords(newEdges, 'edges');
            },
            onError (error) {
                handleFailure(error);
            },
            onCompleted (response) {
                if (response.jira_setBoardViewColumnsOrder?.success !== true) {
                    const error = new (0, $eERQr.MutationErrorCollection)(response.jira_setBoardViewColumnsOrder?.errors);
                    handleFailure(error);
                    return;
                }
                markExperienceSuccess();
            }
        });
    }, [
        commit,
        markExperienceFailed,
        markExperienceSuccess,
        showFlag,
        startExperience,
        viewId
    ]);
};

});
parcelRegister("69qbK", function(module, exports) {

$parcel$export(module.exports, "default", () => $3512c7dc2ce6f51d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<bf7d596140617225d700e88162ce60c4>>
 * @relayHash 5c63a9f1906c3276691d54a588fa6a48
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a9e9b826139d945b48471b110912f25cf6c805e159f28bf23b86f8d5497a4c3c

var $apYuT = parcelRequire("apYuT");
const $3512c7dc2ce6f51d$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "input"
    }, v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "ScalarField",
        "name": "message"
    }, v4 = {
        "kind": "ScalarField",
        "name": "errorType"
    }, v5 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v6 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v7 = [
        v6 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "fieldName"
        }
    ], v8 = {
        "kind": "ScalarField",
        "name": "id"
    }, v9 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v10 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "reorderColumnsMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "JiraSetBoardViewColumnsOrderPayload",
                    "kind": "LinkedField",
                    "name": "jira_setBoardViewColumnsOrder",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "JiraBoardView",
                            "kind": "LinkedField",
                            "name": "boardView",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "BusinessBoard_view"
                                }
                            ]
                        },
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcmergeboardworkflowsrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "reorderColumnsMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "JiraSetBoardViewColumnsOrderPayload",
                    "kind": "LinkedField",
                    "name": "jira_setBoardViewColumnsOrder",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "JiraBoardView",
                            "kind": "LinkedField",
                            "name": "boardView",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraViewFilterConfig",
                                    "kind": "LinkedField",
                                    "name": "filterConfig",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "jql"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "JiraViewGroupByConfig",
                                    "kind": "LinkedField",
                                    "name": "groupByConfig",
                                    "plural": false,
                                    "selections": v7 /*: any*/ 
                                },
                                v8 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "isViewConfigModified"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canPublishViewConfig"
                                },
                                {
                                    "concreteType": "JiraViewGroupByConfig",
                                    "kind": "LinkedField",
                                    "name": "groupByOptions",
                                    "plural": true,
                                    "selections": v7 /*: any*/ 
                                },
                                {
                                    "concreteType": "JiraBoardViewColumnConnection",
                                    "kind": "LinkedField",
                                    "name": "columns",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraBoardViewColumnEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        v8 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "collapsed"
                                                        },
                                                        {
                                                            "kind": "TypeDiscriminator",
                                                            "abstractKey": "__isJiraBoardViewColumn"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraStatus",
                                                                    "kind": "LinkedField",
                                                                    "name": "statuses",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v10 /*: any*/ ,
                                                                        v8 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "statusId"
                                                                        },
                                                                        {
                                                                            "concreteType": "JiraStatusCategory",
                                                                            "kind": "LinkedField",
                                                                            "name": "statusCategory",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "statusCategoryId"
                                                                                },
                                                                                v8 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraBoardViewStatusColumn"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraPriority",
                                                                    "kind": "LinkedField",
                                                                    "name": "priority",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v10 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "priorityId"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "iconUrl"
                                                                        },
                                                                        v8 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraBoardViewPriorityColumn"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "user",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v9 /*: any*/ ,
                                                                        v10 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "accountId"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "picture"
                                                                        },
                                                                        v8 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraBoardViewAssigneeColumn"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraOption",
                                                                    "kind": "LinkedField",
                                                                    "name": "category",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "value"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "optionId"
                                                                        },
                                                                        {
                                                                            "concreteType": "JiraColor",
                                                                            "kind": "LinkedField",
                                                                            "name": "color",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "colorKey"
                                                                                },
                                                                                v8 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v8 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraBoardViewCategoryColumn"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "cursor"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "totalCount"
                                        },
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "endCursor"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasNextPage"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "handle": "connection",
                                    "key": "business_board_columns",
                                    "kind": "LinkedHandle",
                                    "name": "columns"
                                },
                                {
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "enabledOnly",
                                            "value": true
                                        },
                                        {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 100
                                        }
                                    ],
                                    "concreteType": "JiraBoardViewCardOptionConnection",
                                    "kind": "LinkedField",
                                    "name": "cardOptions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraBoardViewCardOptionEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraField",
                                                                    "kind": "LinkedField",
                                                                    "name": "field",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v6 /*: any*/ ,
                                                                        v8 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraBoardViewFieldCardOption"
                                                        },
                                                        v8 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    "storageKey": "cardOptions(enabledOnly:true,first:100)"
                                },
                                {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcmergeboardworkflowsrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "selectedWorkflowId"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        v9 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v8 /*: any*/ 
                                            ],
                                            "type": "BulkMutationErrorExtension"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "a9e9b826139d945b48471b110912f25cf6c805e159f28bf23b86f8d5497a4c3c",
            "metadata": {},
            "name": "reorderColumnsMutation",
            "operationKind": "mutation",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcmergeboardworkflowsrelayprovider": (0, $apYuT.default)
            }
        }
    };
}();
$3512c7dc2ce6f51d$var$node.hash = "761403be1c8b0189fd46e11d96f9ae4f";
var $3512c7dc2ce6f51d$export$2e2bcd8739ae039 = $3512c7dc2ce6f51d$var$node;

});

parcelRegister("5R49c", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf2f4194ce4548cb$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $cf2f4194ce4548cb$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    setBoardViewColumnsOrderFailedTitle: {
        "id": "business.board.view.controllers.reorder-columns.set-board-view-columns-order-failed-title",
        "defaultMessage": "Unable to reorder columns"
    },
    setBoardViewColumnsOrderFailedMessage: {
        "id": "business.board.view.controllers.reorder-columns.set-board-view-columns-order-failed-message",
        "defaultMessage": "We couldn't apply your column order settings, try refreshing the page or try again later."
    }
});

});


parcelRegister("c8SYk", function(module, exports) {

$parcel$export(module.exports, "EmptyBoardComponent", () => $c4a7f3f6522b2791$export$7f64d91ed0b9fc41);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $hE5wF = parcelRequire("hE5wF");

var $koVbs = parcelRequire("koVbs");

var $22OQR = parcelRequire("22OQR");

var $ieDtd = parcelRequire("ieDtd");

var $4R6GH = parcelRequire("4R6GH");

var $J2orP = parcelRequire("J2orP");

var $dFbHJ = parcelRequire("dFbHJ");
const $c4a7f3f6522b2791$export$7f64d91ed0b9fc41 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const emptyBoardTitle = formatMessage((0, $dFbHJ.default).emptyBoardTitle);
    const emptyBoardDescription = (0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? formatMessage((0, $dFbHJ.default).emptyBoardDescriptionIssueTermRefresh) : formatMessage((0, $dFbHJ.default).emptyBoardDescription);
    const buttonTitle = (0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? formatMessage((0, $dFbHJ.default).emptyBoardCreateItemIssueTermRefresh) : formatMessage((0, $dFbHJ.default).emptyBoardCreateItem);
    const [, setInlineCreateParam] = (0, $ieDtd.useQueryParam)((0, $hE5wF.INLINE_CREATE_PARAM));
    const handleItemCreateClick = (0, $5uXOq.useCallback)((_e)=>{
        setInlineCreateParam('true');
    }, [
        setInlineCreateParam
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c4a7f3f6522b2791$var$MessageContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c4a7f3f6522b2791$var$EmptyBoardImageContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $J2orP.default), {
        alt: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $c4a7f3f6522b2791$var$emptyBoardTextContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c4a7f3f6522b2791$var$Header, null, emptyBoardTitle), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, emptyBoardDescription)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $22OQR.ThemedButton), {
        appearance: "primary",
        onClick: handleItemCreateClick
    }, buttonTitle));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c4a7f3f6522b2791$var$MessageContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11q7lpjm _2rkopd34 _p12f1kdj _vchhusvi _y3gn1h6o _ca0q1ejb _u5f31ejb _n3td1ejb _19bv1ejb",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c4a7f3f6522b2791$var$EmptyBoardImageContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zidpf _i0dl1wug _1e0c1txw _1bah1h6o",
            __cmplp.className
        ])
    });
});
const $c4a7f3f6522b2791$var$emptyBoardTextContainerStyles = (0, $8CUq3.xcss)({
    marginBottom: 'space.300',
    marginTop: 'space.100'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c4a7f3f6522b2791$var$Header = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "h2", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syazfrbu",
            __cmplp.className
        ])
    });
});

});
parcelRegister("J2orP", function(module, exports) {

$parcel$export(module.exports, "default", () => $f0bdf068e691bf4c$export$2e2bcd8739ae039);

var $dCLgq = parcelRequire("dCLgq");

var $jKNzI = parcelRequire("jKNzI");

var $jgQxz = parcelRequire("jgQxz");
const $f0bdf068e691bf4c$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($jgQxz)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($jKNzI))
});
var $f0bdf068e691bf4c$export$2e2bcd8739ae039 = $f0bdf068e691bf4c$var$Illustration;

});
parcelRegister("jKNzI", function(module, exports) {
module.exports = new URL("business-board-empty-state-darkmode.137379d7.svg", import.meta.url).toString();

});

parcelRegister("jgQxz", function(module, exports) {
module.exports = new URL("business-board-empty-state.86be8cfc.svg", import.meta.url).toString();

});


parcelRegister("dFbHJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a89da4ee5244c58$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $3a89da4ee5244c58$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    emptyBoardTitle: {
        "id": "work-management-board.board.empty-state.empty-board-title",
        "defaultMessage": "Visualize your work with a board"
    },
    emptyBoardDescription: {
        "id": "work-management-board.board.empty-state.empty-board-description",
        "defaultMessage": "Track, organize and prioritize your team\u2019s work. Get started by creating an item for your team. "
    },
    emptyBoardCreateItem: {
        "id": "work-management-board.board.empty-state.empty-board-create-item",
        "defaultMessage": "Create an item"
    },
    emptyBoardDescriptionIssueTermRefresh: {
        "id": "work-management-board.board.empty-state.empty-board-description-issue-term-refresh",
        "defaultMessage": "Track, organize and prioritize your team\u2019s work. Get started by creating a work item for your team. "
    },
    emptyBoardCreateItemIssueTermRefresh: {
        "id": "work-management-board.board.empty-state.empty-board-create-item-issue-term-refresh",
        "defaultMessage": "Create a work item"
    }
});

});


parcelRegister("a366m", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef0ba2e9a2b309c0$export$2e2bcd8739ae039);

var $bhsjH = parcelRequire("bhsjH");

var $eWLTc = parcelRequire("eWLTc");

var $c6lkw = parcelRequire("c6lkw");

var $2TlE5 = parcelRequire("2TlE5");

var $4S7A3 = parcelRequire("4S7A3");

var $5aOXg = parcelRequire("5aOXg");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $7nsd3 = parcelRequire("7nsd3");

var $9suPc = parcelRequire("9suPc");

var $8Uumt = parcelRequire("8Uumt");

var $3KYe6 = parcelRequire("3KYe6");

var $5uJ9N = parcelRequire("5uJ9N");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $4R6GH = parcelRequire("4R6GH");

var $hE5wF = parcelRequire("hE5wF");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $cm8b5 = parcelRequire("cm8b5");

var $1T1ir = parcelRequire("1T1ir");

var $5njbg = parcelRequire("5njbg");

var $8xg9P = parcelRequire("8xg9P");

var $l9KLJ = parcelRequire("l9KLJ");

var $jpY8v = parcelRequire("jpY8v");

var $8GOso = parcelRequire("8GOso");

var $3t5QD = parcelRequire("3t5QD");

var $a3p8w = parcelRequire("a3p8w");

var $pa9q9 = parcelRequire("pa9q9");

var $l8ruj = parcelRequire("l8ruj");

var $7y8jx = parcelRequire("7y8jx");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $cvj5l = parcelRequire("cvj5l");

var $bh9Ty = parcelRequire("bh9Ty");

var $l1jgj = parcelRequire("l1jgj");

var $jgcJl = parcelRequire("jgcJl");

var $fx09t = parcelRequire("fx09t");

var $khNhv = parcelRequire("khNhv");

var $l0z0H = parcelRequire("l0z0H");

var $lvP0W = parcelRequire("lvP0W");

var $lyv9B = parcelRequire("lyv9B");

var $hGG2j = parcelRequire("hGG2j");

var $3iV3X = parcelRequire("3iV3X");

var $74h6I = parcelRequire("74h6I");

var $ejglV = parcelRequire("ejglV");
const $ef0ba2e9a2b309c0$var$isSafariBrowser = (0, $jpY8v.isSafari)();
const $ef0ba2e9a2b309c0$var$renderCardDropIndicator = (cardsCount, cardDragMeta, virtualizer)=>{
    if (!cardDragMeta) return null;
    const virtualItem = virtualizer.getVirtualItems().find((item)=>item.index === cardDragMeta.cardIndex);
    if (!virtualItem) return null;
    const isAtVeryTop = cardDragMeta.cardIndex === 0 && cardDragMeta.closestEdge === 'top';
    const isAtVeryBottom = cardDragMeta.cardIndex === cardsCount - 1 && cardDragMeta.closestEdge === 'bottom';
    let start = cardDragMeta.closestEdge === 'top' ? virtualItem.start - 3 : virtualItem.end + 1;
    if (isAtVeryTop) // makes sure the drop indicator is not clipped
    start = 3;
    else if (isAtVeryBottom) // makes sure the drop indicator doesn't cause a scrollbar
    start -= 6;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef0ba2e9a2b309c0$export$5a1a2d64cf6af79f, {
        start: start
    });
};
const $ef0ba2e9a2b309c0$var$BoardColumn = ({ columnFragment: columnFragment, projectFragment: projectFragment, queryFragment: queryFragment, viewFragment: viewFragment, columnsNumber: columnsNumber, columnIndex: columnIndex, refresh: refresh })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { issues: issues } = (0, $l1jgj.useIssueGroup)();
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const data = (0, $8Uumt.useFragment)((0, $5aOXg.default), queryFragment);
    const project = (0, $8Uumt.useFragment)((0, $4S7A3.default), projectFragment);
    const view = (0, $8Uumt.useFragment)((0, $2TlE5.default), viewFragment);
    const columnEdge = (0, $8Uumt.useFragment)((0, $c6lkw.default), columnFragment);
    const [commit] = (0, $8Uumt.useMutation)((0, $eWLTc.default));
    const allStatusNames = (0, $5uXOq.useMemo)(()=>view.columns.edges.map((edge)=>edge?.node?.statuses?.[0]?.name !== columnEdge.node?.statuses?.[0]?.name && edge?.node?.statuses?.[0]?.name).filter(Boolean) ?? [], [
        columnEdge.node?.statuses,
        view.columns.edges
    ]);
    const onToggle = (0, $5uXOq.useCallback)(()=>{
        const showFailureFlag = ()=>{
            showFlag({
                messageId: 'work-management-board.ui.board.column.show-flag.error.set-column-collapsed-state-failed',
                messageType: 'transactional',
                title: (0, $ejglV.default).setColumnCollapsedStateFailedTitle,
                description: (0, $ejglV.default).setColumnCollapsedStateFailedMessage,
                type: 'error'
            });
        };
        const newCollapsedState = !columnEdge.node.collapsed;
        commit({
            variables: {
                input: {
                    viewId: view.id,
                    columnId: columnEdge.node.id,
                    collapsed: newCollapsedState,
                    settings: (0, $7y8jx.getBoardQueryParams)()
                }
            },
            optimisticUpdater: (store)=>{
                const { updatableData: updatableData } = store.readUpdatableFragment((0, $bhsjH.default), columnEdge.node);
                updatableData.collapsed = newCollapsedState;
            },
            onError () {
                showFailureFlag();
            },
            onCompleted (response) {
                if (response.jira_setBoardViewColumnState?.success !== true) showFailureFlag();
            }
        });
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'expandCollapseColumn', {
            action: columnEdge.node.collapsed ? 'expand' : 'collapse'
        });
    }, [
        columnEdge.node,
        commit,
        view.id,
        createAnalyticsEvent,
        showFlag
    ]);
    const dragAndDropColumnData = (0, $5uXOq.useMemo)(()=>{
        switch(columnEdge.node.__typename){
            case 'JiraBoardViewStatusColumn':
                if (!columnEdge.node.statuses?.[0]) throw new Error('Missing status column fields');
                return {
                    id: columnEdge.node.statuses[0].statusId,
                    name: columnEdge.node.statuses[0].name,
                    type: (0, $hE5wF.GROUP_BY_STATUS),
                    statusCategoryId: Number(columnEdge.node.statuses[0].statusCategory.statusCategoryId),
                    isCollapsed: columnEdge.node.collapsed
                };
            case 'JiraBoardViewPriorityColumn':
                if (!columnEdge.node.priority) throw new Error('Missing priority column fields');
                return {
                    id: columnEdge.node.priority.priorityId,
                    name: columnEdge.node.priority.name,
                    imageUrl: columnEdge.node.priority.iconUrl ?? null,
                    type: (0, $hE5wF.GROUP_BY_PRIORITY),
                    isCollapsed: columnEdge.node.collapsed
                };
            case 'JiraBoardViewAssigneeColumn':
                return {
                    id: columnEdge.node.user?.accountId ?? (0, $cvj5l.NULL_GROUP_KEY),
                    name: columnEdge.node.user?.name ?? formatMessage((0, $ejglV.default).noAssignee),
                    imageUrl: columnEdge.node.user?.picture ?? null,
                    type: (0, $hE5wF.GROUP_BY_ASSIGNEE),
                    isCollapsed: columnEdge.node.collapsed
                };
            case 'JiraBoardViewCategoryColumn':
                return {
                    id: columnEdge.node.category?.optionId ?? (0, $cvj5l.NULL_GROUP_KEY),
                    name: columnEdge.node.category?.value ?? formatMessage((0, $ejglV.default).noCategory),
                    color: columnEdge.node.category?.color?.colorKey ?? null,
                    type: (0, $hE5wF.GROUP_BY_CATEGORY),
                    isCollapsed: columnEdge.node.collapsed
                };
            default:
                throw new Error(`Unhandled column type: ${columnEdge.node.__typename}`);
        }
    }, [
        columnEdge.node,
        formatMessage
    ]);
    const isWorkflowOperationInProgress = (0, $8xg9P.useIsWorkflowOperationInProgress)();
    const canCreateIssues = project.canCreateIssues.canPerform;
    const [simpleSearch] = (0, $1T1ir.useSimpleSearch)();
    const isCollapsed = columnEdge.node.collapsed;
    const checkCanCreateIssueInStatus = (0, $5njbg.useCanCreateIssueInStatus)();
    const [siblingCreateIssueId, setSiblingCreateIssueId] = (0, $5uXOq.useState)(null);
    const workflows = (0, $l9KLJ.useWorkflows)();
    const [cardContainer, setCardContainer] = (0, $5uXOq.useState)(null);
    const columnDropTargetRef = (0, $5uXOq.useRef)(null);
    const columnHandleRef = (0, $5uXOq.useRef)(null);
    const [cardDragMeta, setCardDragMeta] = (0, $5uXOq.useState)(null);
    const isGroupedByStatus = columnEdge.node.__typename === 'JiraBoardViewStatusColumn';
    const isEnabledForTailoredOnboardingM2 = (0, $8GOso.useIsTailoredOnboardingM2ForQuickstartEnabled)() || (0, $4R6GH.fg)('tailored_onboarding_m2p5_gate');
    const { canDropInGroup: canDropInGroup, closestEdge: closestEdge, dragPreviewState: dragPreviewState, isCardOverColumn: isCardOverColumn, isDraggingColumn: isDraggingColumn } = (0, $bh9Ty.useDraggableColumn)({
        columnDropTargetRef: columnDropTargetRef,
        columnHandleRef: columnHandleRef,
        column: dragAndDropColumnData,
        index: columnIndex
    });
    const shouldShowInvalidDropTargetMessage = !isCollapsed && canDropInGroup === 'no';
    const virtualizer = (0, $9suPc.useVirtualizer)({
        count: isCollapsed ? 0 : issues.length,
        getScrollElement: ()=>cardContainer,
        estimateSize: ()=>300,
        overscan: 2,
        gap: 4,
        getItemKey: (0, $5uXOq.useCallback)((index)=>issues[index].id, [
            issues
        ])
    });
    (0, $5uXOq.useEffect)(()=>{
        if (!cardContainer) return;
        return (0, $3KYe6.autoScrollForElements)({
            canScroll: ({ source: source })=>source.data.type === (0, $cvj5l.CARD_DND_TYPE),
            element: cardContainer,
            getAllowedAxis: ()=>'vertical'
        });
    }, [
        cardContainer
    ]);
    const scrollToLastElement = (0, $5uXOq.useCallback)(()=>{
        const issueCount = issues.length;
        if (issueCount === 0) return;
        virtualizer.scrollToIndex(issueCount, {
            align: 'start'
        });
    }, [
        issues.length,
        virtualizer
    ]);
    const textHighlight = (0, $5uXOq.useMemo)(()=>simpleSearch != null ? [
            simpleSearch
        ] : undefined, [
        simpleSearch
    ]);
    let canCreateIssuesInColumn;
    if ((0, $6s1PB.expVal)('merge_board_workflows', 'enabled', false)) {
        if (isCollapsed) canCreateIssuesInColumn = false;
        else if (!canCreateIssues) canCreateIssuesInColumn = false;
        else if (isGroupedByStatus && columnEdge.node.statuses?.[0]?.statusId && !checkCanCreateIssueInStatus(columnEdge.node.statuses[0].statusId)) canCreateIssuesInColumn = false;
        else canCreateIssuesInColumn = true;
    } else {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const { workflowId: workflowId } = (0, $jgcJl.useWorkflowStoreState)(); // eslint-disable-next-line react-hooks/rules-of-hooks
        canCreateIssuesInColumn = (0, $5uXOq.useMemo)(()=>{
            if (isCollapsed) return false;
            if (!canCreateIssues) return false;
            if (isGroupedByStatus && columnEdge.node.statuses?.[0]?.statusId && !checkCanCreateIssueInStatus(columnEdge.node.statuses[0].statusId, workflows?.find((workflow)=>workflow.workflowId === workflowId))) return false;
            return true;
        }, [
            isCollapsed,
            canCreateIssues,
            isGroupedByStatus,
            checkCanCreateIssueInStatus,
            workflows,
            workflowId,
            columnEdge.node
        ]);
    }
    const isDropDisabled = canDropInGroup === 'no' || isCollapsed && canDropInGroup === 'choice-required';
    const renderColumnHeader = (isDragPreview = false)=>{
        const commonProps = {
            key: columnEdge.node.id,
            dragHandleRef: isDragPreview ? undefined : columnHandleRef,
            isCardOverColumn: isCardOverColumn,
            isDragPreview: isDragPreview,
            isDropDisabled: isDragPreview ? false : isDropDisabled,
            issueCount: issues.length,
            testId: 'work-management-board.ui.board.column.header'
        };
        switch(columnEdge.node.__typename){
            case 'JiraBoardViewStatusColumn':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lyv9B.default), {
                    ...commonProps,
                    projectFragment: project,
                    statusColumnFragment: columnEdge.node,
                    viewFragment: view,
                    onToggle: onToggle,
                    refresh: refresh,
                    allStatusNames: allStatusNames,
                    columnIndex: columnIndex
                });
            case 'JiraBoardViewPriorityColumn':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hGG2j.default), {
                    ...commonProps,
                    priorityColumnFragment: columnEdge.node,
                    onToggle: onToggle
                });
            case 'JiraBoardViewAssigneeColumn':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3iV3X.default), {
                    ...commonProps,
                    assigneeColumnFragment: columnEdge.node,
                    onToggle: onToggle
                });
            case 'JiraBoardViewCategoryColumn':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $74h6I.default), {
                    ...commonProps,
                    categoryColumnFragment: columnEdge.node,
                    onToggle: onToggle
                });
            default:
                throw new Error(`Unhandled column type: ${columnEdge.node.__typename}`);
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $ef0ba2e9a2b309c0$var$columnDropTargetStyles,
        ref: columnDropTargetRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef0ba2e9a2b309c0$var$Column, {
        isCardOverColumn: isCardOverColumn,
        isCollapsed: isCollapsed,
        isDragging: isDraggingColumn,
        isDropDisabled: isDropDisabled,
        isShowingInvalidDropTargetMessage: shouldShowInvalidDropTargetMessage,
        "data-testid": "work-management-board.ui.board.column"
    }, isEnabledForTailoredOnboardingM2 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3t5QD.ConditionalNudgeWrapper), {
        conditionsToApplyWrapper: isGroupedByStatus && (columnsNumber > 1 ? columnIndex === 1 : columnIndex === 0),
        Wrapper: (0, $a3p8w.TailorBoardColumnsAsync)
    }, renderColumnHeader()) : renderColumnHeader(), !isCollapsed && issues.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef0ba2e9a2b309c0$var$ScrollContainer, {
        isDragging: isDraggingColumn,
        isScrollbarForced: (0, $jpY8v.isFirefox)(),
        ref: setCardContainer,
        "data-testid": "work-management-board.ui.board.column.scroll-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef0ba2e9a2b309c0$var$VirtualCardsContainer, {
        height: virtualizer.getTotalSize(),
        "data-vc": "business-board-cards-container"
    }, virtualizer.getVirtualItems().map((virtualItem)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef0ba2e9a2b309c0$var$VirtualCardWrapper, {
            key: virtualItem.key,
            "data-index": virtualItem.index,
            "data-vc": "business-board-card",
            start: virtualItem.start,
            isSiblingCreateFormOpen: (0, $4R6GH.fg)('wanjel-a11y-enterprise-grade') ? siblingCreateIssueId === issues[virtualItem.index].id : false,
            ref: virtualizer.measureElement
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
            name: "business-board-card",
            mode: "list"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fx09t.default), {
            columnFragment: columnEdge.node,
            projectFragment: project,
            queryFragment: data,
            viewFragment: view,
            key: virtualItem.key,
            draggableIndex: virtualItem.index,
            dragAndDropColumnData: dragAndDropColumnData,
            canCreateIssues: canCreateIssuesInColumn,
            prevIssueKey: issues[virtualItem.index - 1]?.fields[0, $cvj5l.ISSUE_KEY_ID].value ?? null,
            issue: issues[virtualItem.index],
            highlight: textHighlight,
            isSiblingCreateFormOpen: siblingCreateIssueId === issues[virtualItem.index].id,
            toggleSiblingCreateForm: setSiblingCreateIssueId,
            onCardDragChange: setCardDragMeta
        })))), $ef0ba2e9a2b309c0$var$renderCardDropIndicator(issues.length, cardDragMeta, virtualizer), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cm8b5.ExperienceSuccess), {
        experience: (0, $cvj5l.VIEW_EXPERIENCE)
    }))), shouldShowInvalidDropTargetMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l0z0H.BoardInvalidDropTargetMessage), {
        columnFragment: columnEdge.node
    }), !isCollapsed && [
        'choice-available',
        'choice-required'
    ].includes(canDropInGroup) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lvP0W.default), {
        queryFragment: data,
        dragAndDropColumnData: dragAndDropColumnData
    }), canCreateIssuesInColumn && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $khNhv.default), {
        queryFragment: data,
        columnFragment: columnEdge.node,
        scrollToLastElement: scrollToLastElement
    }), isWorkflowOperationInProgress && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $ef0ba2e9a2b309c0$var$overlayStyles,
        testId: "work-management-board.ui.board.column.overlay"
    }), closestEdge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef0ba2e9a2b309c0$var$ColumnDropIndicatorWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5uJ9N.DropIndicator), {
        edge: closestEdge,
        gap: `${(0, $cvj5l.GAP_BETWEEN_COLUMNS)}px`
    })))), dragPreviewState.type === 'preview' && isDraggingColumn ? /*#__PURE__*/ (0, $7nsd3.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef0ba2e9a2b309c0$export$18a854943bcb82fa, {
        isCollapsed: isCollapsed,
        isTilted: !$ef0ba2e9a2b309c0$var$isSafariBrowser
    }, renderColumnHeader(true)), dragPreviewState.container) : null);
};
var $ef0ba2e9a2b309c0$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($ef0ba2e9a2b309c0$var$BoardColumn);
const $ef0ba2e9a2b309c0$var$columnDropTargetStyles = (0, $8CUq3.xcss)({
    height: '100%'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $ef0ba2e9a2b309c0$export$18a854943bcb82fa = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isTilted: isTilted, isCollapsed: isCollapsed, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rkopd34 _bfhkqbzx _1bsb1ogy",
            __cmplp.isTilted ? "_139ek9zm" : "_139e1i1e",
            __cmplp.isCollapsed && "_1bsb1ylp",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ef0ba2e9a2b309c0$var$ColumnDropIndicatorWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_z1i3eyly _4t3i1kxc _kqswstnw _1bsb1osq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ef0ba2e9a2b309c0$var$Column = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isShowingInvalidDropTargetMessage: isShowingInvalidDropTargetMessage, isCardOverColumn: isCardOverColumn, isCollapsed: isCollapsed, isDropDisabled: isDropDisabled, isDragging: isDragging, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_v5641czr _2rkopd34 _16jlkb7n _1o9zkb7n _i0dl1wug _bfhkqbzx _1e0c1txw _2lx21bp4 _c71l1osq _1bsb1ogy _kqswh2mm _12ji3acm _1cwgidpf _1qu2nqa1 _12y31bk5",
            __cmplp.isShowingInvalidDropTargetMessage && "_1tkep3fh",
            __cmplp.isCardOverColumn && "_bfhki1yw _12ji1yqz",
            __cmplp.isCollapsed && "_1bsb1ylp _c71luuw1",
            __cmplp.isDropDisabled && "_bfhk1gly _12ji1bqt",
            __cmplp.isDragging && "_tzy42wxo",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ef0ba2e9a2b309c0$var$ScrollContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isScrollbarForced: isScrollbarForced, isDragging: isDragging, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1tke1ylp _1reo15vq _ca0qt94y _n3tdt94y _u5f31b66 _19bvv47k _18u0mgjw _otyr1b66",
            __cmplp.isScrollbarForced ? "_18m915zi" : "_18m91wug",
            __cmplp.isDragging && "_1reo15vq _18m915vq _19bv1b66 _18u0idpf",
            __cmplp.className
        ])
    });
});
const $ef0ba2e9a2b309c0$var$overlayStyles = (0, $8CUq3.xcss)({
    position: 'absolute',
    left: '0px',
    right: '0px',
    top: '0px',
    bottom: '0px',
    background: "var(--ds-background-disabled, #091E4208)",
    zIndex: 'blanket'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ef0ba2e9a2b309c0$var$VirtualCardsContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1neqek2": (0, $lD23V.default)(`${__cmplp.height}px`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i2nrh _kqswh2mm",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ef0ba2e9a2b309c0$var$VirtualCardWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSiblingCreateFormOpen: isSiblingCreateFormOpen, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_10d4ua4": (0, $lD23V.default)(`translateY(${__cmplp.start}px)`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswstnw _154iidpf _1ltvidpf _1bsb1osq _t9ec1dpj",
            __cmplp.isSiblingCreateFormOpen ? "_1pbykb7n" : "_1pby1wug",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $ef0ba2e9a2b309c0$export$5a1a2d64cf6af79f = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_10d4ua4": (0, $lD23V.default)(`translateY(${__cmplp.start}px)`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1ule _kqswstnw _1pbycs5v _lcxvglyw _bfhk1yqz _4t3iyh40 _1ltv1y44 _1xi2idpf _t9ec1dpj _rfx31ssb _3l88yh40 _kzdanqa1 _15m61yqz _1kt9b3bt _1mp4ftgi _kfgtftgi _qnecyjp0 _1aukj39m _13y0usvi _1cs8stnw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("bhsjH", function(module, exports) {

$parcel$export(module.exports, "default", () => $348aecc4cebd076d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e8060ad88d3b3a55f198220caf5dcdb7>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $348aecc4cebd076d$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "BoardColumn_updatable",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "collapsed"
        }
    ],
    "type": "JiraBoardViewColumn",
    "abstractKey": "__isJiraBoardViewColumn"
};
$348aecc4cebd076d$var$node.hash = "7e9f8626b6287567aefc198a72ac29c5";
var $348aecc4cebd076d$export$2e2bcd8739ae039 = $348aecc4cebd076d$var$node;

});

parcelRegister("eWLTc", function(module, exports) {

$parcel$export(module.exports, "default", () => $05f984f74a012617$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6983d696f4ab50000fd632096a9e3a77>>
 * @relayHash 036905723d2f0bb00215405b5fbfbbf0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 479d916c0fe5cfc011d855b6ee12e458f74438bfeb2561f1c2cfbf9d3ad52314
const $05f984f74a012617$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = [
        {
            "kind": "ScalarField",
            "name": "fieldId"
        },
        {
            "kind": "ScalarField",
            "name": "fieldName"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v6 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "BoardColumnCollapsedStateMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "JiraSetBoardViewColumnStatePayload",
                    "kind": "LinkedField",
                    "name": "jira_setBoardViewColumnState",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "JiraBoardView",
                            "kind": "LinkedField",
                            "name": "boardView",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "BoardHeader_view"
                                },
                                {
                                    "concreteType": "JiraBoardViewColumnConnection",
                                    "kind": "LinkedField",
                                    "name": "columns",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraBoardViewColumnEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "BoardColumn_column"
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "FragmentSpread",
                                                            "name": "BoardColumn_updatable"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "BoardColumnCollapsedStateMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "JiraSetBoardViewColumnStatePayload",
                    "kind": "LinkedField",
                    "name": "jira_setBoardViewColumnState",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "JiraBoardView",
                            "kind": "LinkedField",
                            "name": "boardView",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "isViewConfigModified"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canPublishViewConfig"
                                },
                                {
                                    "concreteType": "JiraViewGroupByConfig",
                                    "kind": "LinkedField",
                                    "name": "groupByConfig",
                                    "plural": false,
                                    "selections": v4 /*: any*/ 
                                },
                                {
                                    "concreteType": "JiraViewGroupByConfig",
                                    "kind": "LinkedField",
                                    "name": "groupByOptions",
                                    "plural": true,
                                    "selections": v4 /*: any*/ 
                                },
                                {
                                    "concreteType": "JiraBoardViewColumnConnection",
                                    "kind": "LinkedField",
                                    "name": "columns",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraBoardViewColumnEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "TypeDiscriminator",
                                                            "abstractKey": "__isJiraBoardViewColumn"
                                                        },
                                                        v5 /*: any*/ ,
                                                        v3 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "collapsed"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraStatus",
                                                                    "kind": "LinkedField",
                                                                    "name": "statuses",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v6 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "statusId"
                                                                        },
                                                                        {
                                                                            "concreteType": "JiraStatusCategory",
                                                                            "kind": "LinkedField",
                                                                            "name": "statusCategory",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "statusCategoryId"
                                                                                },
                                                                                v3 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v3 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraBoardViewStatusColumn"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraPriority",
                                                                    "kind": "LinkedField",
                                                                    "name": "priority",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v6 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "priorityId"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "iconUrl"
                                                                        },
                                                                        v3 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraBoardViewPriorityColumn"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "user",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v5 /*: any*/ ,
                                                                        v6 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "accountId"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "picture"
                                                                        },
                                                                        v3 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraBoardViewAssigneeColumn"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraOption",
                                                                    "kind": "LinkedField",
                                                                    "name": "category",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "value"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "optionId"
                                                                        },
                                                                        {
                                                                            "concreteType": "JiraColor",
                                                                            "kind": "LinkedField",
                                                                            "name": "color",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "colorKey"
                                                                                },
                                                                                v3 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v3 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraBoardViewCategoryColumn"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "479d916c0fe5cfc011d855b6ee12e458f74438bfeb2561f1c2cfbf9d3ad52314",
            "metadata": {},
            "name": "BoardColumnCollapsedStateMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$05f984f74a012617$var$node.hash = "d585cacd44e20dd24efa8c1da0ef9af6";
var $05f984f74a012617$export$2e2bcd8739ae039 = $05f984f74a012617$var$node;

});

parcelRegister("c6lkw", function(module, exports) {

$parcel$export(module.exports, "default", () => $924593fe4a1f76aa$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<40b3353e704880682815743b62260ae9>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $924593fe4a1f76aa$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "BoardColumn_column",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "BoardInlineCreate_column"
                        },
                        {
                            "kind": "FragmentSpread",
                            "name": "BoardCard_column"
                        },
                        {
                            "kind": "FragmentSpread",
                            "name": "BoardInvalidDropTargetMessage_column"
                        },
                        {
                            "kind": "FragmentSpread",
                            "name": "BoardInvalidDropTargetMessage_old_column"
                        },
                        {
                            "kind": "FragmentSpread",
                            "name": "BoardColumn_updatable"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "__typename"
                        },
                        {
                            "kind": "RequiredField",
                            "field": {
                                "kind": "ScalarField",
                                "name": "id"
                            },
                            "action": "THROW",
                            "path": "node.id"
                        },
                        {
                            "kind": "RequiredField",
                            "field": {
                                "kind": "ScalarField",
                                "name": "collapsed"
                            },
                            "action": "THROW",
                            "path": "node.collapsed"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "StatusColumnHeader_column"
                                },
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "concreteType": "JiraStatus",
                                        "kind": "LinkedField",
                                        "name": "statuses",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": v0 /*: any*/ ,
                                                "action": "THROW",
                                                "path": "node.statuses.name"
                                            },
                                            {
                                                "kind": "RequiredField",
                                                "field": {
                                                    "kind": "ScalarField",
                                                    "name": "statusId"
                                                },
                                                "action": "THROW",
                                                "path": "node.statuses.statusId"
                                            },
                                            {
                                                "kind": "RequiredField",
                                                "field": {
                                                    "concreteType": "JiraStatusCategory",
                                                    "kind": "LinkedField",
                                                    "name": "statusCategory",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": {
                                                                "kind": "ScalarField",
                                                                "name": "statusCategoryId"
                                                            },
                                                            "action": "THROW",
                                                            "path": "node.statuses.statusCategory.statusCategoryId"
                                                        }
                                                    ]
                                                },
                                                "action": "THROW",
                                                "path": "node.statuses.statusCategory"
                                            }
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "node.statuses"
                                }
                            ],
                            "type": "JiraBoardViewStatusColumn"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "PriorityColumnHeader_column"
                                },
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "concreteType": "JiraPriority",
                                        "kind": "LinkedField",
                                        "name": "priority",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": v0 /*: any*/ ,
                                                "action": "THROW",
                                                "path": "node.priority.name"
                                            },
                                            {
                                                "kind": "RequiredField",
                                                "field": {
                                                    "kind": "ScalarField",
                                                    "name": "priorityId"
                                                },
                                                "action": "THROW",
                                                "path": "node.priority.priorityId"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "iconUrl"
                                            }
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "node.priority"
                                }
                            ],
                            "type": "JiraBoardViewPriorityColumn"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "AssigneeColumnHeader_column"
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "user",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": v0 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "node.user.name"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "kind": "ScalarField",
                                                "name": "accountId"
                                            },
                                            "action": "THROW",
                                            "path": "node.user.accountId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "picture"
                                        }
                                    ]
                                }
                            ],
                            "type": "JiraBoardViewAssigneeColumn"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "CategoryColumnHeader_column"
                                },
                                {
                                    "concreteType": "JiraOption",
                                    "kind": "LinkedField",
                                    "name": "category",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "kind": "ScalarField",
                                                "name": "value"
                                            },
                                            "action": "THROW",
                                            "path": "node.category.value"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "kind": "ScalarField",
                                                "name": "optionId"
                                            },
                                            "action": "THROW",
                                            "path": "node.category.optionId"
                                        },
                                        {
                                            "concreteType": "JiraColor",
                                            "kind": "LinkedField",
                                            "name": "color",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "colorKey"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "type": "JiraBoardViewCategoryColumn"
                        }
                    ]
                },
                "action": "THROW",
                "path": "node"
            }
        ],
        "type": "JiraBoardViewColumnEdge"
    };
}();
$924593fe4a1f76aa$var$node.hash = "d6fed6d20f790e144b54bfa3b819e9f1";
var $924593fe4a1f76aa$export$2e2bcd8739ae039 = $924593fe4a1f76aa$var$node;

});

parcelRegister("2TlE5", function(module, exports) {

$parcel$export(module.exports, "default", () => $c59ad3be7cd77349$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7a0e0591c6bea19d695bce41aa5cbd74>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $c59ad3be7cd77349$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": {
        "connection": [
            {
                "count": null,
                "cursor": null,
                "direction": "forward",
                "path": [
                    "columns"
                ]
            }
        ]
    },
    "name": "BoardColumn_view",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "id"
            },
            "action": "THROW",
            "path": "id"
        },
        {
            "kind": "FragmentSpread",
            "name": "BoardCard_view"
        },
        {
            "kind": "FragmentSpread",
            "name": "StatusColumnHeader_view"
        },
        {
            "kind": "RequiredField",
            "field": {
                "alias": "columns",
                "concreteType": "JiraBoardViewColumnConnection",
                "kind": "LinkedField",
                "name": "__business_board_columns_connection",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "JiraBoardViewColumnEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "concreteType": "JiraStatus",
                                                    "kind": "LinkedField",
                                                    "name": "statuses",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": {
                                                                "kind": "ScalarField",
                                                                "name": "name"
                                                            },
                                                            "action": "THROW",
                                                            "path": "columns.edges.node.statuses.name"
                                                        }
                                                    ]
                                                }
                                            ],
                                            "type": "JiraBoardViewStatusColumn"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "cursor"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "columns.edges"
                    },
                    {
                        "concreteType": "PageInfo",
                        "kind": "LinkedField",
                        "name": "pageInfo",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "endCursor"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "hasNextPage"
                            }
                        ]
                    }
                ]
            },
            "action": "THROW",
            "path": "columns"
        }
    ],
    "type": "JiraBoardView"
};
$c59ad3be7cd77349$var$node.hash = "a1c380fa667a8758c75127e17757f5cc";
var $c59ad3be7cd77349$export$2e2bcd8739ae039 = $c59ad3be7cd77349$var$node;

});

parcelRegister("4S7A3", function(module, exports) {

$parcel$export(module.exports, "default", () => $08e15e2e2f4a192d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<93744eeaec51d00e261ffce5324710a4>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $08e15e2e2f4a192d$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "BoardColumn_project",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "alias": "canCreateIssues",
                "args": [
                    {
                        "kind": "Literal",
                        "name": "type",
                        "value": "CREATE_ISSUES"
                    }
                ],
                "concreteType": "JiraProjectAction",
                "kind": "LinkedField",
                "name": "action",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "canPerform"
                        },
                        "action": "THROW",
                        "path": "canCreateIssues.canPerform"
                    }
                ],
                "storageKey": "action(type:\"CREATE_ISSUES\")"
            },
            "action": "THROW",
            "path": "canCreateIssues"
        },
        {
            "kind": "FragmentSpread",
            "name": "StatusColumnHeader_project"
        },
        {
            "kind": "FragmentSpread",
            "name": "BoardCard_project"
        }
    ],
    "type": "JiraProject"
};
$08e15e2e2f4a192d$var$node.hash = "d0866ea5902e81ead6917f3eba007c22";
var $08e15e2e2f4a192d$export$2e2bcd8739ae039 = $08e15e2e2f4a192d$var$node;

});

parcelRegister("5aOXg", function(module, exports) {

$parcel$export(module.exports, "default", () => $3498488c1aec7eb9$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2ce2694195c30251763b254e455c1b4b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $3498488c1aec7eb9$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "BoardColumn_query",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "BoardCard_query"
        },
        {
            "kind": "FragmentSpread",
            "name": "BoardInlineCreate_query"
        },
        {
            "kind": "FragmentSpread",
            "name": "BoardTransitionZones_query"
        }
    ],
    "type": "Query"
};
$3498488c1aec7eb9$var$node.hash = "cce86a5e60223cf7f6455822e667725b";
var $3498488c1aec7eb9$export$2e2bcd8739ae039 = $3498488c1aec7eb9$var$node;

});

parcelRegister("5uJ9N", function(module, exports) {

$parcel$export(module.exports, "DropIndicator", () => $057503bea847bf4c$export$62ed72bc21f6b8a6);
$parcel$export(module.exports, "default", () => $057503bea847bf4c$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $40bhS = parcelRequire("40bhS");

var $choBO = parcelRequire("choBO");
function $057503bea847bf4c$export$62ed72bc21f6b8a6({ appearance: appearance = 'default', edge: edge, gap: gap, indent: indent, type: type }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $40bhS.Line), {
        edge: edge,
        gap: gap,
        strokeColor: (0, $choBO.presetStrokeColors)[appearance],
        type: type,
        indent: indent
    });
}
var // This default export is intended for usage with React.lazy
$057503bea847bf4c$export$2e2bcd8739ae039 = $057503bea847bf4c$export$62ed72bc21f6b8a6;

});
parcelRegister("40bhS", function(module, exports) {

$parcel$export(module.exports, "Line", () => $5554523a258e458d$export$17d680238e50603e);
/* line.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $choBO = parcelRequire("choBO");
const $5554523a258e458d$var$edgeToOrientationMap = {
    top: 'horizontal',
    bottom: 'horizontal',
    left: 'vertical',
    right: 'vertical'
};
const $5554523a258e458d$var$baseStyles = {
    root: "_1e0c1ule _kqswstnw _1pbykb7n _lcxvglyw _bfhkys7w _rfx31ssb _3l8810ly _kzdanqa1 _15m6ys7w _cfu11ld9 _1kt9b3bt _1cs8stnw _13y0usvi _1mp4vjfa _kfgtvjfa"
};
const $5554523a258e458d$var$orientationStyles = {
    horizontal: "_4t3i10ly _1e02fghn _rjxpidpf _z5wtuj5p",
    vertical: "_1bsb10ly _154ifghn _94n5idpf _1aukuj5p"
};
const $5554523a258e458d$var$edgeStyles = {
    top: "_154ihv0e _1auk70hn",
    right: "_1xi2hv0e _ooun70hn",
    bottom: "_94n5hv0e _19wo70hn",
    left: "_1ltvhv0e _qnec70hn"
};
const $5554523a258e458d$var$lineStartFrom = {
    // - half the terminal bleeding out the containing element
    // - half the terminal inside the containing element (we need to position the line next to this)
    terminal: ({ indent: indent })=>`calc(var(--terminal-radius) + ${indent})`,
    // The full terminal is inside the containing element (we need to position the line next to this)
    'terminal-no-bleed': ({ indent: indent })=>`calc(var(--terminal-diameter) + ${indent})`,
    // No terminal to worry about, line should take up all the space
    'no-terminal': ({ indent: indent })=>indent
};
function $5554523a258e458d$export$17d680238e50603e({ edge: edge, gap: gap = '0px', indent: indent = '0px', strokeColor: strokeColor = (0, $choBO.presetStrokeColors).default, strokeWidth: strokeWidth = (0, $choBO.presetStrokeWidth), type: type = 'terminal' }) {
    const orientation = $5554523a258e458d$var$edgeToOrientationMap[edge];
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        style: {
            // ## All
            '--stroke-color': strokeColor,
            '--stroke-width': strokeWidth,
            // Shift line and terminal on the main access to account for gaps between items
            '--main-axis-offset': `calc(-0.5 * (${gap} + var(--stroke-width)))`,
            // ## Line
            // If there is a terminal, we want the line to start from next to it
            '--line-main-axis-start': $5554523a258e458d$var$lineStartFrom[type]({
                indent: indent
            }),
            // ## Terminal
            '--terminal-display': type === 'no-terminal' ? 'none' : 'block',
            '--terminal-diameter': 'calc(var(--stroke-width) * 4)',
            '--terminal-radius': 'calc(var(--terminal-diameter) / 2)',
            // The line is positioned to account for the the terminal (--line-main-axis-start).
            // The terminal is rendered relative to the line (it's a `::before`)
            // We need to pull the terminal backwards so it sits before the start of the line
            '--terminal-main-axis-start': 'calc(-1 * var(--terminal-diameter))',
            // Pull the terminal backwards on the cross axis (eg "up" on "vertical")
            // so the center of the terminal lines up with the center of the line
            '--terminal-cross-axis-offset': 'calc(calc(var(--stroke-width) - var(--terminal-diameter)) / 2)'
        },
        className: (0, $bwpsq.default)([
            $5554523a258e458d$var$baseStyles.root,
            $5554523a258e458d$var$orientationStyles[orientation],
            $5554523a258e458d$var$edgeStyles[edge]
        ])
    });
}
var // For React.lazy
$5554523a258e458d$export$2e2bcd8739ae039 = $5554523a258e458d$export$17d680238e50603e;

});
parcelRegister("choBO", function(module, exports) {

$parcel$export(module.exports, "presetStrokeColors", () => $9f99301ec58274c5$export$477fafec326bfca0);
$parcel$export(module.exports, "presetStrokeWidth", () => $9f99301ec58274c5$export$45db03aa04b685e3);
const $9f99301ec58274c5$export$477fafec326bfca0 = {
    default: "var(--ds-border-selected, #0C66E4)",
    warning: "var(--ds-border-warning, #E56910)"
};
const $9f99301ec58274c5$export$45db03aa04b685e3 = "var(--ds-border-width-outline, 2px)";

});



parcelRegister("5njbg", function(module, exports) {

$parcel$export(module.exports, "useCanCreateIssueInStatus", () => $fee15ae5c2026453$export$efe8838d1712139f);

var $5uXOq = parcelRequire("5uXOq");

var $daQYX = parcelRequire("daQYX");

var $l9KLJ = parcelRequire("l9KLJ");
const $fee15ae5c2026453$export$efe8838d1712139f = ()=>{
    const workflows = (0, $l9KLJ.useWorkflows)();
    const project = (0, $daQYX.useProject)();
    return (0, $5uXOq.useCallback)((statusId, workflow = null)=>{
        if (!workflows) return false;
        const eligibleWorkflows = workflow != null ? [
            workflow
        ] : workflows.filter((w)=>w.issueTypes.some((it)=>it.hierarchyLevel >= 0));
        // we want to show the create button on the group if it can:
        // - be created from the initial transition,
        // - OR if it has a global transition leading to it
        //      AND the transition isn't conditional
        //      AND the user is allowed to transition issues
        return eligibleWorkflows.some((w)=>w.transitions.some((transition)=>transition.to.statusId === statusId && (transition.isInitial || transition.isGlobal && !transition.isConditional && project.permissions.transitionIssues)));
    }, [
        project,
        workflows
    ]);
};

});

parcelRegister("8GOso", function(module, exports) {

$parcel$export(module.exports, "usePersonalisationActions", () => $adde9919a40069db$export$5b1d43353c334c00);
$parcel$export(module.exports, "useCommonEligibilityConditionsForJtbdOnboarding", () => $adde9919a40069db$export$c89644b13b6e777f);
$parcel$export(module.exports, "useCommonEligibilityConditionsForTOM2P5", () => $adde9919a40069db$export$b633031bd0a88786);
$parcel$export(module.exports, "useTailoredOnboardingPersonalisationAttributes", () => $adde9919a40069db$export$9aad8798ea46e07f);
$parcel$export(module.exports, "useTailoredOnboardingPersonalisationM2", () => $adde9919a40069db$export$5875295cb096b1f2);
$parcel$export(module.exports, "useIsTailoredOnboardingM2ForQuickstartEnabled", () => $adde9919a40069db$export$6bc15f8ade1cf36);

var $5uXOq = parcelRequire("5uXOq");

var $2vSU6 = parcelRequire("2vSU6");

var $jcw0u = parcelRequire("jcw0u");

var $4R6GH = parcelRequire("4R6GH");

var $cNd4s = parcelRequire("cNd4s");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $dAfqg = parcelRequire("dAfqg");

var $AK64q = parcelRequire("AK64q");

var $8UmI9 = parcelRequire("8UmI9");

var $4mXzi = parcelRequire("4mXzi");

var $iAFnF = parcelRequire("iAFnF");
const $adde9919a40069db$var$store = (0, $iXqE5.createStore)({
    name: 'jira-onboarding-personalisation',
    initialState: (0, $AK64q.initialCachedEndpointState),
    actions: $4mXzi.actions
});
const $adde9919a40069db$export$5b1d43353c334c00 = (0, $3sQ5x.createActionsHook)($adde9919a40069db$var$store);
const $adde9919a40069db$export$31a443426d101362 = (0, $3sQ5x.createHook)($adde9919a40069db$var$store);
const $adde9919a40069db$export$c89644b13b6e777f = ()=>{
    const isSiteAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const { data: projectContextData } = (0, $dAfqg.useProjectContext)();
    const isBusinessProject = projectContextData?.projectType === undefined || // letting undefined pass for non-project context usage, eg: onboarding
    projectContextData?.projectType === (0, $2vSU6.CORE_PROJECT); // limiting only to CORE for Tailired Onboarding M2 usage
    return isBusinessProject && isSiteAdmin;
};
const $adde9919a40069db$export$b633031bd0a88786 = ()=>{
    const isSiteAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const { isBusinessProject: isBusinessProject } = (0, $8UmI9.useIsBusinessProject)();
    return isBusinessProject && isSiteAdmin && (0, $4R6GH.fg)('tailored_onboarding_m2p5_gate');
};
const $adde9919a40069db$export$6f87e1662a24f8b9 = ({ isEligible: isEligible, experienceTypes: experienceTypes, additionalParameters: additionalParameters })=>{
    const [{ fetchedOnce: fetchedOnce, isFetching: isFetching, data: data }, { fetchOnboardingPersonalisation: fetchOnboardingPersonalisation }] = $adde9919a40069db$export$31a443426d101362();
    (0, $5uXOq.useEffect)(()=>{
        if (isEligible && !fetchedOnce && !isFetching && data === undefined) fetchOnboardingPersonalisation({
            experienceTypes: experienceTypes,
            additionalParameters: additionalParameters
        });
    }, [
        additionalParameters,
        data,
        experienceTypes,
        fetchOnboardingPersonalisation,
        fetchedOnce,
        isEligible,
        isFetching
    ]);
    if (!isEligible) // If not eligible, no fetching is done. Data is ready to be read
    return {
        data: undefined,
        isReady: true
    };
    return {
        data: data,
        isReady: fetchedOnce && !isFetching
    };
};
const $adde9919a40069db$export$9aad8798ea46e07f = ()=>{
    const isEligibleForTailoredOnboardingM2 = $adde9919a40069db$export$c89644b13b6e777f();
    const { data: personalisationData, isReady: personalisationDataIsReady } = $adde9919a40069db$export$6f87e1662a24f8b9({
        isEligible: isEligibleForTailoredOnboardingM2
    });
    return {
        personalisationDataIsReady: personalisationDataIsReady,
        teamType: personalisationData?.matched.variants.find((variant)=>variant.startsWith('teamType.'))?.replace('teamType.', ''),
        jtbd: personalisationData?.matched.variants.filter((variant)=>variant.startsWith('jtbd.option_')).map((option)=>option.replace('jtbd.option_', '')).join(',')
    };
};
const $adde9919a40069db$export$5875295cb096b1f2 = ({ isEligible: isEligible, additionalParameters: additionalParameters })=>{
    const hasSentErrorOnce = (0, $5uXOq.useRef)(false);
    const { data: data, isReady: isReady } = $adde9919a40069db$export$6f87e1662a24f8b9({
        isEligible: isEligible,
        experienceTypes: [
            'QUICKSTART',
            'TEMPLATE',
            'LANDING_PAGE'
        ],
        additionalParameters: additionalParameters
    });
    try {
        const conditionalProjectType = `projectType.${additionalParameters?.projectType}`;
        // If projectType is not given as parameter, ignore restriction to match on projectType
        const isMatchingProjectType = Boolean(!additionalParameters?.projectType || data?.matched.variants.some((variant)=>variant === conditionalProjectType));
        const isMatchingTeamType = Boolean(data?.matched.variants.some((variant)=>variant.startsWith('teamType.') && (0, $iAFnF.ELIGIBLE_TEAM_TYPES_M2_FULL_NOTATION).includes(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            variant.split('.')[1])));
        const isMatchingJtbd = Boolean(data?.matched.variants.some((variant)=>variant.startsWith('jtbd')));
        const matched = Boolean(data && isMatchingJtbd && isMatchingProjectType && isMatchingTeamType);
        return {
            isReady: isReady,
            data: {
                matched: matched,
                matchedVariants: {
                    projectType: isMatchingProjectType,
                    tt: isMatchingTeamType,
                    jtbd: isMatchingJtbd
                },
                QUICKSTART: matched && data ? data.experience.QUICKSTART : [],
                TEMPLATE: matched && data ? data.experience.TEMPLATE?.[0] : undefined,
                LANDING_PAGE: matched && data ? data.experience.LANDING_PAGE?.[0] : undefined
            }
        };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (!hasSentErrorOnce.current) {
            (0, $jcw0u.default)({
                error: error,
                meta: {
                    id: 'useTailoredOnboardingPersonalisationM2',
                    packageName: 'jiraOnboardingCore',
                    teamName: 'jlove-makkuro'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            hasSentErrorOnce.current = true;
        }
    }
    return {
        isReady: isReady,
        data: {
            matched: false,
            matchedVariants: {
                jtbd: false,
                tt: false,
                projectType: false
            },
            QUICKSTART: [],
            TEMPLATE: undefined,
            LANDING_PAGE: undefined
        }
    };
};
const $adde9919a40069db$export$6bc15f8ade1cf36 = ()=>{
    const isEligibleForJtbdOnboarding = $adde9919a40069db$export$c89644b13b6e777f();
    const { data: projectContextData } = (0, $dAfqg.useProjectContext)();
    const projectType = (0, $4R6GH.fg)('tailored_onboarding_m3_gate') ? projectContextData?.projectType : (0, $2vSU6.CORE_PROJECT);
    const { isReady: personalisationDataIsReady, data: personalisationData } = $adde9919a40069db$export$5875295cb096b1f2({
        isEligible: isEligibleForJtbdOnboarding,
        additionalParameters: {
            projectType: projectType
        }
    });
    return Boolean(personalisationDataIsReady && personalisationData.QUICKSTART && personalisationData.QUICKSTART?.length > 0);
};

});
parcelRegister("8UmI9", function(module, exports) {

$parcel$export(module.exports, "useIsBusinessProject", () => $d1bed05bd9fbc7d5$export$f1bf366948a19b0f);

var $dAfqg = parcelRequire("dAfqg");

var $2vSU6 = parcelRequire("2vSU6");
const $d1bed05bd9fbc7d5$export$f1bf366948a19b0f = ()=>{
    const { data: data, loading: loading } = (0, $dAfqg.useProjectContext)();
    const isBusinessProject = data?.projectType === (0, $2vSU6.CORE_PROJECT);
    return {
        isBusinessProject: isBusinessProject,
        loading: loading
    };
};

});

parcelRegister("4mXzi", function(module, exports) {

$parcel$export(module.exports, "actions", () => $f50a5e3bb7b9f239$export$e324594224ef24da);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $7bRcT = parcelRequire("7bRcT");

var $FroD7 = parcelRequire("FroD7");
const $f50a5e3bb7b9f239$var$fetchOnboardingPersonalisation = (0, $7bRcT.cachedEndpointCall)((args)=>(0, $FroD7.fetchOnboardingPersonalisationWithRethrow)(args));
const $f50a5e3bb7b9f239$var$trackPersonalisationAction = ({ additionalParameters: additionalParameters })=>()=>(0, $FroD7.trackPersonalisation)({
            additionalParameters: additionalParameters
        });
const $f50a5e3bb7b9f239$export$e324594224ef24da = {
    fetchOnboardingPersonalisation: $f50a5e3bb7b9f239$var$fetchOnboardingPersonalisation,
    trackPersonalisation: $f50a5e3bb7b9f239$var$trackPersonalisationAction
};

});
parcelRegister("FroD7", function(module, exports) {

$parcel$export(module.exports, "fetchOnboardingPersonalisationWithRethrow", () => $501ec097caecd266$export$6bc39428b6510a7c);
$parcel$export(module.exports, "trackPersonalisation", () => $501ec097caecd266$export$9835c32b78102887);

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

var $fv5ut = parcelRequire("fv5ut");
const $501ec097caecd266$var$PERSONALISATION_ENDPOINT = '/rest/personalisation/v1/experience';
const $501ec097caecd266$var$TRACK_PERSONALISATION_ENDPOINT = '/rest/personalisation/v1/track';
const $501ec097caecd266$var$responseHasAllRequestedExperienceTypes = ({ response: response, requestedExperienceTypes: requestedExperienceTypes })=>requestedExperienceTypes.every((requestedExperienceType)=>response.experience[requestedExperienceType]);
const $501ec097caecd266$export$6bc39428b6510a7c = async ({ experienceTypes: experienceTypes = [
    'QUICKSTART',
    'TEMPLATE',
    'LANDING_PAGE'
], additionalParameters: additionalParameters })=>{
    try {
        const localStorageOnboardingPersonalisationResponse = (0, $fv5ut.getLocalStorageOnboardingPersonalisationResponse)();
        if (localStorageOnboardingPersonalisationResponse && $501ec097caecd266$var$responseHasAllRequestedExperienceTypes({
            response: localStorageOnboardingPersonalisationResponse,
            requestedExperienceTypes: experienceTypes
        })) return localStorageOnboardingPersonalisationResponse;
        const response = await (0, $eusud.performPostRequestWithRetry)($501ec097caecd266$var$PERSONALISATION_ENDPOINT, {
            body: JSON.stringify({
                experienceTypes: experienceTypes,
                additionalParameters: additionalParameters
            })
        });
        if (response) {
            const mergedResponse = {
                experience: {
                    ...localStorageOnboardingPersonalisationResponse?.experience,
                    ...response.experience
                },
                matched: response.matched
            };
            (0, $fv5ut.setLocalStorageOnboardingPersonalisationResponse)(mergedResponse);
            return mergedResponse;
        }
        throw new Error('response from OnboardingPersonalisation is falsy');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            error: error,
            meta: {
                id: 'fetchOnboardingPersonalisationWithRethrow',
                packageName: 'jiraOnboardingCore',
                teamName: 'jlove-makkuro'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};
const $501ec097caecd266$export$9835c32b78102887 = ({ additionalParameters: additionalParameters })=>{
    try {
        (0, $eusud.performPostRequestWithRetry)($501ec097caecd266$var$TRACK_PERSONALISATION_ENDPOINT, {
            body: JSON.stringify({
                additionalParameters: additionalParameters
            })
        });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            error: error,
            meta: {
                id: 'trackOnboardingPersonalisation',
                packageName: 'jiraOnboardingCore',
                teamName: 'jlove-makkuro'
            },
            sendToPrivacyUnsafeSplunk: true
        });
    }
};

});
parcelRegister("fv5ut", function(module, exports) {

$parcel$export(module.exports, "getLocalStorageOnboardingPersonalisationResponse", () => $673c953eac85fdf0$export$e9fb5b94c03fa495);
$parcel$export(module.exports, "setLocalStorageOnboardingPersonalisationResponse", () => $673c953eac85fdf0$export$dda9cd59669fc243);

var $bSSG7 = parcelRequire("bSSG7");

var $jcw0u = parcelRequire("jcw0u");
const $673c953eac85fdf0$var$LOCALSTORAGE_ONBOARDING_PERSONALISATION_RESPONSE = 'response';
const $673c953eac85fdf0$var$localStorage = (0, $bSSG7.createLocalStorageProvider)('jira-onboarding-personalisation');
const $673c953eac85fdf0$export$e9fb5b94c03fa495 = ()=>{
    try {
        return $673c953eac85fdf0$var$localStorage.get($673c953eac85fdf0$var$LOCALSTORAGE_ONBOARDING_PERSONALISATION_RESPONSE);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            error: error,
            meta: {
                id: 'localStorageGetOnboardingPersonalisation',
                packageName: 'jiraOnboardingCore',
                teamName: 'jlove-makkuro'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        return undefined;
    }
};
const $673c953eac85fdf0$export$dda9cd59669fc243 = (response)=>{
    try {
        $673c953eac85fdf0$var$localStorage.set($673c953eac85fdf0$var$LOCALSTORAGE_ONBOARDING_PERSONALISATION_RESPONSE, response);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            error: error,
            meta: {
                id: 'localStorageSetOnboardingPersonalisationResponse',
                packageName: 'jiraOnboardingCore',
                teamName: 'jlove-makkuro'
            },
            sendToPrivacyUnsafeSplunk: true
        });
    }
};

});



parcelRegister("iAFnF", function(module, exports) {

$parcel$export(module.exports, "ELIGIBLE_TEAM_TYPES_M2_FULL_NOTATION", () => $afa1ef0e1c3d15e2$export$1d38dc41bb005254);

var $5PxqD = parcelRequire("5PxqD");
const $afa1ef0e1c3d15e2$export$1d38dc41bb005254 = [
    (0, $5PxqD.USER_SEGMENTATION_TEAM_TYPE_MARKETING),
    (0, $5PxqD.USER_SEGMENTATION_TEAM_TYPE_OPERATIONS)
];

});
parcelRegister("5PxqD", function(module, exports) {

$parcel$export(module.exports, "USER_SEGMENTATION_TEAM_TYPE_MARKETING", () => $5d0851fa8905d151$export$e4824f74b9879164);
$parcel$export(module.exports, "USER_SEGMENTATION_TEAM_TYPE_OPERATIONS", () => $5d0851fa8905d151$export$4f3cb0844009af52);
$parcel$export(module.exports, "userBelongsToBusinessUserSegCategory", () => $5d0851fa8905d151$export$517f94ab07724226);

var $jcw0u = parcelRequire("jcw0u");
// Roles defined in user segmentation
const $5d0851fa8905d151$var$USER_SEGMENTATION_ROLE_DESIGNER = 'designer';
const $5d0851fa8905d151$export$572242e58bd07594 = 'customer-service';
const $5d0851fa8905d151$export$d7de553940261eba = 'it-support';
const $5d0851fa8905d151$export$4c29d0d04c15e55d = 'human-resources';
const $5d0851fa8905d151$export$3950f7f841bf94b6 = 'finance';
const $5d0851fa8905d151$export$881249b988b6030f = 'legal';
const $5d0851fa8905d151$export$e4824f74b9879164 = 'marketing';
const $5d0851fa8905d151$export$4f3cb0844009af52 = 'operations';
const $5d0851fa8905d151$export$1a65d50c4a641bb4 = 'sales';
const $5d0851fa8905d151$export$b8b1ac856ba1434b = 'software-development';
// Unique identifier used where all roles in a team type are eligible
const $5d0851fa8905d151$var$ALL_ROLES_ELIGIBLE = 'all-roles-eligible';
const $5d0851fa8905d151$export$2f3f9640393bd078 = 'unknown';
const $5d0851fa8905d151$export$4c9a72dac5ce80ae = '';
// @ts-expect-error - It seems to be missing some translations (for all-roles-eligible).
const $5d0851fa8905d151$var$USER_SEGMENTATION_CLIENT_MAPPING = {
    [$5d0851fa8905d151$var$USER_SEGMENTATION_ROLE_DESIGNER]: [
        'Designer',
        'Disainer',
        "Dise\xf1ador",
        'Formgivare',
        "Nh\xe0 thi\u1EBFt k\u1EBF",
        'Projektant',
        'Suunnittelija',
        "Tasar\u0131mc\u0131",
        "Tervez\u0151",
        "\u0414\u0438\u0437\u0430\u0439\u043D\u0435\u0440",
        "\u0E19\u0E31\u0E01\u0E2D\u0E2D\u0E01\u0E41\u0E1A\u0E1A",
        "\u30C7\u30B6\u30A4\u30CA\u30FC",
        "\u8A2D\u8A08\u5E2B",
        "\u8BBE\u8BA1\u5E08",
        "\uB514\uC790\uC774\uB108"
    ],
    [$5d0851fa8905d151$export$572242e58bd07594]: [
        'Asiakaspalvelu',
        'Atendimento ao cliente',
        'Customer Service',
        "D\u1ECBch v\u1EE5 kh\xe1ch h\xe0ng",
        'Klantenservice',
        'Klienditeenindus',
        'Kundenservice',
        'Kundeservice',
        'Kundservice',
        "M\xfc\u015Fteri Hizmetleri",
        "Obs\u0142uga klienta",
        "Service \xe0 la client\xe8le",
        "Servicio de atenci\xf3n al cliente",
        'Servizio clienti',
        "Servi\xe7o de apoio ao cliente",
        "Z\xe1kaznick\xfd servis",
        "Z\xe1kazn\xedcky servis",
        "\xdcgyf\xe9lszolg\xe1lati",
        "\u041E\u0431\u0441\u043B\u0443\u0436\u0438\u0432\u0430\u043D\u0438\u0435 \u043A\u043B\u0438\u0435\u043D\u0442\u043E\u0432",
        "\u0421\u043B\u0443\u0436\u0431\u0430 \u043F\u0456\u0434\u0442\u0440\u0438\u043C\u043A\u0438 \u043A\u043B\u0456\u0454\u043D\u0442\u0456\u0432",
        "\u0E1A\u0E23\u0E34\u0E01\u0E32\u0E23\u0E25\u0E39\u0E01\u0E04\u0E49\u0E32",
        "\u30AB\u30B9\u30BF\u30DE\u30FC \u30B5\u30FC\u30D3\u30B9",
        "\u5BA2\u6237\u670D\u52A1",
        "\u9867\u5BA2\u670D\u52D9",
        "\uACE0\uAC1D \uC11C\uBE44\uC2A4"
    ],
    [$5d0851fa8905d151$export$d7de553940261eba]: [
        'Assistenza IT',
        "BT Deste\u011Fi",
        "H\u1ED7 tr\u1EE3 CNTT",
        'IT',
        'IT Support',
        'IT podpora',
        "IT \u30B5\u30DD\u30FC\u30C8",
        "IT \u652F\u6301",
        "IT \u652F\u63F4",
        "IT \uC9C0\uC6D0",
        'IT_Support',
        "IT_st\xf8tte",
        'IT_support',
        'IT_tugi',
        'IT_tuki',
        "Informatikai t\xe1mogat\xe1si",
        'Soporte de TI',
        'Suporte de TI',
        "Support\xa0IT",
        'Wsparcie IT',
        "\u0418\u0422-\u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0430",
        "\u0421\u043B\u0443\u0436\u0431\u0430 \u0442\u0435\u0445\u043D\u0456\u0447\u043D\u043E\u0457 \u043F\u0456\u0434\u0442\u0440\u0438\u043C\u043A\u0438",
        "\u0E1D\u0E48\u0E32\u0E22\u0E2A\u0E19\u0E31\u0E1A\u0E2A\u0E19\u0E38\u0E19 IT"
    ],
    [$5d0851fa8905d151$export$3950f7f841bf94b6]: [
        'Ekonomi',
        'Finance',
        'Financeiro',
        'Financie',
        'Finans',
        'Finanse',
        'Finants',
        'Finanza',
        'Finanzas',
        'Finanzen',
        "Finan\xe7as",
        "P\xe9nz\xfcgyi",
        'Rahoitus',
        "T\xe0i ch\xednh",
        "\xd8konomi",
        "\u0424\u0438\u043D\u0430\u043D\u0441\u044B",
        "\u0424\u0456\u043D\u0430\u043D\u0441\u0438",
        "\u0E01\u0E32\u0E23\u0E40\u0E07\u0E34\u0E19",
        "\u8CA1\u52D9",
        "\u91D1\u878D",
        "\uC7AC\uBB34"
    ],
    [$5d0851fa8905d151$export$4c29d0d04c15e55d]: [
        'HR',
        "Henkil\xf6st\xf6hallinto",
        'Human Resources',
        'Human resources',
        'human-resources',
        "Lidsk\xe9 zdroje",
        'Menneskelige ressourcer',
        "Nh\xe2n s\u1EF1",
        'Personal',
        "Personalfr\xe5gor",
        'RH',
        'Recursos Humanos',
        'Recursos humanos',
        'Risorse umane',
        "Szem\xe9lyzeti",
        'Zasoby ludzkie',
        "\u0130nsan Kaynaklar\u0131",
        "\u013Dudsk\xe9 zdroje",
        "\u0412\u0456\u0434\u0434\u0456\u043B \u043A\u0430\u0434\u0440\u0456\u0432",
        "\u041A\u0430\u0434\u0440\u043E\u0432\u044B\u0435 \u0432\u043E\u043F\u0440\u043E\u0441\u044B",
        "\u0E17\u0E23\u0E31\u0E1E\u0E22\u0E32\u0E01\u0E23\u0E1A\u0E38\u0E04\u0E04\u0E25",
        "\u4EBA\u4E8B",
        "\u4EBA\u529B\u8CC7\u6E90",
        "\u4EBA\u529B\u8D44\u6E90",
        "\uC778\uC0AC"
    ],
    [$5d0851fa8905d151$export$881249b988b6030f]: [
        "Departamento jur\xeddico",
        'Hukuk',
        'Jogi',
        'Jura',
        'Juridik',
        'Juridisk',
        "Jur\xeddico",
        'Legal',
        'Legale',
        'Oikeudelliset asiat',
        "Ph\xe1p l\xfd",
        'Prawo',
        "Pr\xe1vne oddelenie",
        "Pr\xe1vn\xed odd\u011Blen\xed",
        'Rechtliches',
        'Service juridique',
        "\xd5igus",
        "\u042E\u0440\u0438\u0434\u0438\u0447\u0435\u0441\u043A\u0438\u0435 \u0432\u043E\u043F\u0440\u043E\u0441\u044B",
        "\u042E\u0440\u0438\u0434\u0438\u0447\u043D\u0438\u0439 \u0432\u0456\u0434\u0434\u0456\u043B",
        "\u0E01\u0E0E\u0E2B\u0E21\u0E32\u0E22",
        "\u6CD5\u52D9",
        "\u6CD5\u5F8B",
        "\uBC95\uB960"
    ],
    [$5d0851fa8905d151$export$e4824f74b9879164]: [
        "Markedsf\xf8ring",
        'Marketing',
        'Markkinointi',
        "Marknadsf\xf6ring",
        'Pazarlama',
        "Ti\u1EBFp th\u1ECB",
        'Turundus',
        "\u041C\u0430\u0440\u043A\u0435\u0442\u0438\u043D\u0433",
        "\u0E01\u0E32\u0E23\u0E15\u0E25\u0E32\u0E14",
        "\u30DE\u30FC\u30B1\u30C6\u30A3\u30F3\u30B0",
        "\u8425\u9500",
        "\u884C\u92B7",
        "\uB9C8\uCF00\uD305"
    ],
    [$5d0851fa8905d151$export$4f3cb0844009af52]: [
        'Drift',
        'Haldus',
        'Operacional',
        'Operaciones',
        'Operacje',
        'Operasyonlar',
        'Operations',
        'Operativer Betrieb',
        'Operazioni',
        "Opera\xe7\xf5es",
        "Op\xe9rations",
        "Prev\xe1dzka",
        'Provoz',
        'Toiminnot',
        "V\u1EADn h\xe0nh",
        "\xdczemeltet\xe9si",
        "\u0412\u0438\u0440\u043E\u0431\u043D\u0438\u0447\u0438\u0439 \u0432\u0456\u0434\u0434\u0456\u043B",
        "\u041E\u043F\u0435\u0440\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0435 \u0432\u043E\u043F\u0440\u043E\u0441\u044B",
        "\u0E1D\u0E48\u0E32\u0E22\u0E1B\u0E0F\u0E34\u0E1A\u0E31\u0E15\u0E34\u0E01\u0E32\u0E23",
        "\u30AA\u30DA\u30EC\u30FC\u30B7\u30E7\u30F3",
        "\u71DF\u904B",
        "\u8FD0\u8425",
        "\uC6B4\uC601"
    ],
    [$5d0851fa8905d151$export$1a65d50c4a641bb4]: [
        "B\xe1n h\xe0ng",
        "F\xf6rs\xe4ljning",
        'Myynti',
        "M\xfc\xfck",
        'Predaj',
        'Prodej',
        'Sales',
        'Salg',
        "Sat\u0131\u015F",
        "Sprzeda\u017C",
        'Vendas',
        'Vendite',
        'Ventas',
        'Ventes',
        'Vertrieb',
        "\xc9rt\xe9kes\xedt\xe9si",
        "\u041F\u0440\u043E\u0434\u0430\u0436\u0438",
        "\u041F\u0440\u043E\u0434\u0430\u0436\u0456",
        "\u0E1D\u0E48\u0E32\u0E22\u0E02\u0E32\u0E22",
        "\u30BB\u30FC\u30EB\u30B9",
        "\u92B7\u552E",
        "\u9500\u552E",
        "\uC601\uC5C5"
    ],
    [$5d0851fa8905d151$export$b8b1ac856ba1434b]: [
        'Desarrollo de software',
        'Desenvolvimento de software',
        "D\xe9veloppement logiciel",
        'Ohjelmistokehitys',
        "Ph\xe1t tri\u1EC3n ph\u1EA7n m\u1EC1m",
        'Programutveckling',
        'Programvareutvikling',
        'Software Development',
        'Softwareentwicklung',
        'Softwareontwikkeling',
        'Softwareudvikling',
        'Sviluppo software',
        "Szoftverfejleszt\u0151",
        'Tarkvaraarendus',
        'Tworzenie oprogramowania',
        "V\xfdvoj softv\xe9ru",
        "V\xfdvoj softwaru",
        "Yaz\u0131l\u0131m Geli\u015Ftirme",
        "\u0420\u0430\u0437\u0440\u0430\u0431\u043E\u0442\u043A\u0430 \u041F\u041E",
        "\u0420\u043E\u0437\u0440\u043E\u0431\u043A\u0430 \u041F\u0417",
        "\u0E1E\u0E31\u0E12\u0E19\u0E32\u0E0B\u0E2D\u0E1F\u0E15\u0E4C\u0E41\u0E27\u0E23\u0E4C",
        "\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u958B\u767A",
        "\u8EDF\u9AD4\u958B\u767C",
        "\u8F6F\u4EF6\u5F00\u53D1",
        "\uC18C\uD504\uD2B8\uC6E8\uC5B4 \uAC1C\uBC1C"
    ]
};
const $5d0851fa8905d151$var$BUSINESS_TEAM_TYPES = [
    $5d0851fa8905d151$export$4c29d0d04c15e55d,
    $5d0851fa8905d151$export$3950f7f841bf94b6,
    $5d0851fa8905d151$export$881249b988b6030f,
    $5d0851fa8905d151$export$e4824f74b9879164,
    $5d0851fa8905d151$export$4f3cb0844009af52,
    $5d0851fa8905d151$export$1a65d50c4a641bb4,
    $5d0851fa8905d151$export$b8b1ac856ba1434b
];
const $5d0851fa8905d151$var$BUSINESS_ROLES_PER_TEAM_TYPE = {
    [$5d0851fa8905d151$export$4c29d0d04c15e55d]: [
        $5d0851fa8905d151$var$ALL_ROLES_ELIGIBLE
    ],
    [$5d0851fa8905d151$export$3950f7f841bf94b6]: [
        $5d0851fa8905d151$var$ALL_ROLES_ELIGIBLE
    ],
    [$5d0851fa8905d151$export$881249b988b6030f]: [
        $5d0851fa8905d151$var$ALL_ROLES_ELIGIBLE
    ],
    [$5d0851fa8905d151$export$e4824f74b9879164]: [
        $5d0851fa8905d151$var$ALL_ROLES_ELIGIBLE
    ],
    [$5d0851fa8905d151$export$4f3cb0844009af52]: [
        $5d0851fa8905d151$var$ALL_ROLES_ELIGIBLE
    ],
    [$5d0851fa8905d151$export$1a65d50c4a641bb4]: [
        $5d0851fa8905d151$var$ALL_ROLES_ELIGIBLE
    ],
    [$5d0851fa8905d151$export$b8b1ac856ba1434b]: [
        $5d0851fa8905d151$var$USER_SEGMENTATION_ROLE_DESIGNER
    ]
};
const $5d0851fa8905d151$var$getNormalizedEntry = (userSegValue)=>{
    const lowerCaseUserSegValue = userSegValue.toLowerCase();
    return Object.entries($5d0851fa8905d151$var$USER_SEGMENTATION_CLIENT_MAPPING).find(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    ([, translatedValues])=>translatedValues.map((v)=>v.toLowerCase()).includes(lowerCaseUserSegValue));
};
const $5d0851fa8905d151$export$d0bc507f0556398 = (value)=>{
    if (value === '') return $5d0851fa8905d151$export$4c9a72dac5ce80ae;
    const normalizedEntry = $5d0851fa8905d151$var$getNormalizedEntry(value);
    return normalizedEntry !== undefined ? normalizedEntry[0] : $5d0851fa8905d151$export$2f3f9640393bd078;
};
class $5d0851fa8905d151$var$SkipSentryError extends Error {
    constructor(message){
        super(message);
        this.skipSentry = true;
    }
}
const $5d0851fa8905d151$var$fireAnalyticsError = ({ id: id, field: field, error: error, unMatchedValue: unMatchedValue })=>{
    (0, $jcw0u.default)({
        meta: {
            id: id,
            packageName: 'jiraOnboardingCore'
        },
        attributes: {
            field: field,
            unMatchedValue: unMatchedValue
        },
        error: error,
        sendToPrivacyUnsafeSplunk: true
    });
};
const $5d0851fa8905d151$export$af8a28b856b3556f = (teamType)=>{
    if (!teamType) return false;
    const normalizedTeamType = $5d0851fa8905d151$export$d0bc507f0556398(teamType);
    if (normalizedTeamType === $5d0851fa8905d151$export$2f3f9640393bd078) $5d0851fa8905d151$var$fireAnalyticsError({
        id: 'isInSoftwareTeam',
        field: 'teamType',
        error: new $5d0851fa8905d151$var$SkipSentryError('teamType mapping is not found'),
        unMatchedValue: teamType
    });
    return normalizedTeamType === $5d0851fa8905d151$export$b8b1ac856ba1434b;
};
const $5d0851fa8905d151$export$517f94ab07724226 = (userAccountData)=>{
    const { teamType: teamType = '', role: role = '' } = userAccountData;
    const normalizedTeamType = $5d0851fa8905d151$export$d0bc507f0556398(teamType);
    if (normalizedTeamType === $5d0851fa8905d151$export$2f3f9640393bd078) $5d0851fa8905d151$var$fireAnalyticsError({
        id: 'userBelongsToBusinessUserSegCategory',
        field: 'teamType',
        error: new $5d0851fa8905d151$var$SkipSentryError('teamType mapping is not found'),
        unMatchedValue: teamType
    });
    const normalizedRole = $5d0851fa8905d151$export$d0bc507f0556398(role);
    if (normalizedRole === $5d0851fa8905d151$export$2f3f9640393bd078) $5d0851fa8905d151$var$fireAnalyticsError({
        id: 'userBelongsToBusinessUserSegCategory',
        field: 'role',
        error: new $5d0851fa8905d151$var$SkipSentryError('role mapping is not found'),
        unMatchedValue: role
    });
    // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'UserSegmentationTeamTypes'.
    const isTeamTypeEligible = $5d0851fa8905d151$var$BUSINESS_TEAM_TYPES.includes(normalizedTeamType);
    const isRoleEligible = // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<UserSegmentationTeamTypes, UserSegmentationRoleTypes[]>>'.
    $5d0851fa8905d151$var$BUSINESS_ROLES_PER_TEAM_TYPE[normalizedTeamType]?.includes($5d0851fa8905d151$var$ALL_ROLES_ELIGIBLE) || // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<UserSegmentationTeamTypes, UserSegmentationRoleTypes[]>>'.
    $5d0851fa8905d151$var$BUSINESS_ROLES_PER_TEAM_TYPE[normalizedTeamType]?.includes(normalizedRole);
    return isTeamTypeEligible && isRoleEligible;
};
const $5d0851fa8905d151$export$6710e0127706b297 = (userAccountData)=>{
    const { teamType: teamType = '', role: role = '' } = userAccountData;
    const normalizedTeamType = $5d0851fa8905d151$export$d0bc507f0556398(teamType);
    if (normalizedTeamType === $5d0851fa8905d151$export$2f3f9640393bd078) $5d0851fa8905d151$var$fireAnalyticsError({
        id: 'userBelongsToSoftwareUserSegCategory',
        field: 'teamType',
        error: new $5d0851fa8905d151$var$SkipSentryError('teamType mapping is not found'),
        unMatchedValue: teamType
    });
    const normalizedRole = $5d0851fa8905d151$export$d0bc507f0556398(role);
    if (normalizedRole === $5d0851fa8905d151$export$2f3f9640393bd078) $5d0851fa8905d151$var$fireAnalyticsError({
        id: 'userBelongsToSoftwareUserSegCategory',
        field: 'role',
        error: new $5d0851fa8905d151$var$SkipSentryError('role mapping is not found'),
        unMatchedValue: role
    });
    const isTeamTypeEligible = normalizedTeamType === $5d0851fa8905d151$export$b8b1ac856ba1434b;
    const isRoleEligible = normalizedRole !== $5d0851fa8905d151$var$USER_SEGMENTATION_ROLE_DESIGNER;
    return isTeamTypeEligible && isRoleEligible;
};

});



parcelRegister("a3p8w", function(module, exports) {

$parcel$export(module.exports, "TailorBoardColumnsAsync", () => $f5a655db25e59df8$export$e4d6b2cdb1678ee0);
$parcel$export(module.exports, "TailorBoardColumnsAsyncChildless", () => $f5a655db25e59df8$export$ae5357db2691b909);

var $5uXOq = parcelRequire("5uXOq");

var $9dZ1c = parcelRequire("9dZ1c");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $4R6GH = parcelRequire("4R6GH");

var $7XYc4 = parcelRequire("7XYc4");

var $cE2Qr = parcelRequire("cE2Qr");



var $7oe20 = parcelRequire("7oe20");
const $f5a655db25e59df8$var$runtimeProps = {};
const $f5a655db25e59df8$var$entryPointParams = {};
const $f5a655db25e59df8$var$TailorBoardColumnsAsyncOld = ({ children: children })=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $7oe20.tailorBoardColumnsNudgeEntryPoint), $f5a655db25e59df8$var$entryPointParams);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    const { ref: tailorBoardColumnsNudgeRef } = (0, $9dZ1c.useRegisterNudgeTarget)((0, $6784cbc7d62e5d7c$export$6ffa29e74c0304c4), true);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        ref: tailorBoardColumnsNudgeRef
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        id: (0, $dbbf68c32d8c4308$export$573d4bf1da6d2bc6),
        packageName: "jiraBoardOnboarding",
        entryPointReferenceSubject: entryPointReferenceSubject,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null),
        runtimeProps: $f5a655db25e59df8$var$runtimeProps
    }));
};
const $f5a655db25e59df8$var$TailorBoardColumnsAsyncNew = ({ children: children })=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $7oe20.tailorBoardColumnsNudgeEntryPoint), $f5a655db25e59df8$var$entryPointParams);
    const [nudgeStep] = (0, $cE2Qr.useNudgeStep)();
    const [hasNudgeActive] = (0, $cE2Qr.useHasNudgeActive)();
    const firstLoadRef = (0, $5uXOq.useRef)(true);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        if (firstLoadRef.current && hasNudgeActive && nudgeStep === (0, $6784cbc7d62e5d7c$export$6ffa29e74c0304c4)) {
            entryPointActions.load();
            firstLoadRef.current = false;
        }
    }, [
        entryPointActions,
        hasNudgeActive,
        nudgeStep
    ]);
    const { ref: tailorBoardColumnsNudgeRef } = (0, $9dZ1c.useRegisterNudgeTarget)((0, $6784cbc7d62e5d7c$export$6ffa29e74c0304c4), true);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        ref: tailorBoardColumnsNudgeRef
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        id: (0, $dbbf68c32d8c4308$export$573d4bf1da6d2bc6),
        packageName: "jiraBoardOnboarding",
        entryPointReferenceSubject: entryPointReferenceSubject,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null),
        runtimeProps: $f5a655db25e59df8$var$runtimeProps
    }));
};
const $f5a655db25e59df8$export$e4d6b2cdb1678ee0 = (0, $7XYc4.componentWithCondition)(()=>(0, $4R6GH.fg)('tailored_onboarding_m3_gate'), $f5a655db25e59df8$var$TailorBoardColumnsAsyncNew, $f5a655db25e59df8$var$TailorBoardColumnsAsyncOld);
const $f5a655db25e59df8$export$ae5357db2691b909 = ()=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $7oe20.tailorBoardColumnsNudgeEntryPoint), $f5a655db25e59df8$var$entryPointParams);
    const [nudgeStep] = (0, $cE2Qr.useNudgeStep)();
    const [hasNudgeActive] = (0, $cE2Qr.useHasNudgeActive)();
    const firstLoadRef = (0, $5uXOq.useRef)(true);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        if (firstLoadRef.current && hasNudgeActive && nudgeStep === (0, $6784cbc7d62e5d7c$export$6ffa29e74c0304c4)) {
            entryPointActions.load();
            firstLoadRef.current = false;
        }
    }, [
        entryPointActions,
        hasNudgeActive,
        nudgeStep
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        id: (0, $dbbf68c32d8c4308$export$573d4bf1da6d2bc6),
        packageName: "jiraBoardOnboarding",
        entryPointReferenceSubject: entryPointReferenceSubject,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null),
        runtimeProps: $f5a655db25e59df8$var$runtimeProps
    }));
};

});
// Session storage constants used between going through initial onboarding screens
// and landing in JIRA
// Note this key used to be 'should-show-scrum-modal' but was changed to prevent a bug where experienced users
// Could see the modal if they were previously enrolled into ISO
const $6784cbc7d62e5d7c$export$67abe0a3b8dfe03f = 'should-show-scrum-modal-v2';
const $6784cbc7d62e5d7c$export$4e1360a3e7785935 = 'should-show-kanban-modal';
const $6784cbc7d62e5d7c$export$e3884212029f7bef = 'should-show-welcome-modal';
const $6784cbc7d62e5d7c$export$c45d2ea50af63a85 = 'showed-welcome-modal-during-signup';
const $6784cbc7d62e5d7c$export$c9dc4cb209930823 = 'can-enroll-in-config-wizard-view';
const $6784cbc7d62e5d7c$export$891ca65264b256bb = 'should-show-personlized-sample-data-for-kanban';
const $6784cbc7d62e5d7c$export$f47dca9dda77d157 = 'should-hide-quickstart-for-personalized-sample-data';
const $6784cbc7d62e5d7c$export$16588d2012f3f89b = 'should-show-business-sample-data-nudge';
const $6784cbc7d62e5d7c$export$928ffae10e4c0006 = 'template-key-to-show-onboarding-modal';
const $6784cbc7d62e5d7c$export$6e69f8dc03075ef8 = 'team-type';
const $6784cbc7d62e5d7c$export$c06666264cd35603 = 'team-type-shorthand';
const $6784cbc7d62e5d7c$export$8a00ecf6498ee2fe = 'onboarding-selected-project-template-type';
const $6784cbc7d62e5d7c$export$6973064a898f5989 = 'should-show-list-view-type-cell-spotlight';
const $6784cbc7d62e5d7c$export$115fac1f1144bda1 = 'should-show-list-view-fields-dropdown-spotlight';
const $6784cbc7d62e5d7c$export$69fe8832c4f79a32 = 'onboarding_started_timestamp';
const $6784cbc7d62e5d7c$export$a8d62e500b59f31e = 'boardCreateColumnButtonNudge';
const $6784cbc7d62e5d7c$export$92c7f0eacc8d8d98 = 'assigneeFilterAddPeopleButtonNudge';
const $6784cbc7d62e5d7c$export$dd63d0099d95ba4f = 'navigationAppsNavItemNudge';
const $6784cbc7d62e5d7c$export$aba87e019f5ccb8d = 'navigationCreateIssueButtonNudge';
const $6784cbc7d62e5d7c$export$46d9a3d441dfd22b = 'navigationPlansNavItemNudge';
const $6784cbc7d62e5d7c$export$e20072f7d0c5357f = 'roadmapCreateEpicButtonNudge';
const $6784cbc7d62e5d7c$export$1e39959907a7f359 = 'roadmapCreateEpicChildIssueButtonNudge';
const $6784cbc7d62e5d7c$export$b74a8fdb2c75b869 = 'navigationPeopleNavItemNudge';
const $6784cbc7d62e5d7c$export$b1a6ab17737f33e = 'backlogAccordionNudge';
const $6784cbc7d62e5d7c$export$eb64d5f1a091478b = 'backlogCreateSprintIssueNudge';
const $6784cbc7d62e5d7c$export$64d75060ee6ba425 = 'backlogCreateIssueNudge';
const $6784cbc7d62e5d7c$export$3366ddefe77d5112 = 'boardCreateColumnNudge';
const $6784cbc7d62e5d7c$export$9d9e95a66a2c6abe = 'addItemsCalendarNudge';
const $6784cbc7d62e5d7c$export$69aca8ebee0d34c8 = 'trelloCrossflowAddItemsCalendarNudge';
const $6784cbc7d62e5d7c$export$7aa8bceae32c7862 = 'navigationAppsProfileItemNudge';
const $6784cbc7d62e5d7c$export$c6df9a2c7447e12d = 'getStartedListNudge';
const $6784cbc7d62e5d7c$export$468488291ccd988 = 'timelineAddItemNudge';
const $6784cbc7d62e5d7c$export$7a33548109ac931d = 'createFormNudge';
const $6784cbc7d62e5d7c$export$b65ba9ea0c0ced43 = 'jsw-onboarding-checklist.open';
const $6784cbc7d62e5d7c$export$3b5d230b66f60471 = 'jsw-onboarding-checklist.visibility';
const $6784cbc7d62e5d7c$export$594d3436316492be = 'summaryViewNudge';
const $6784cbc7d62e5d7c$export$f93b83d735f01fa3 = 'pagesCreatePageNudge';
const $6784cbc7d62e5d7c$export$77bc79debbf5c069 = 'inviteTeamNudge';
const $6784cbc7d62e5d7c$export$6ffa29e74c0304c4 = 'tailorBoardColumnsNudge';
const $6784cbc7d62e5d7c$export$699265ec8ad9a740 = 'Software Development';
const $6784cbc7d62e5d7c$export$e07d1fa2da8ed874 = 'Customer Service';
const $6784cbc7d62e5d7c$export$76dcec3f438d9e56 = 'IT Support';
const $6784cbc7d62e5d7c$export$9a574c301f67ba30 = 'Human Resources';
const $6784cbc7d62e5d7c$export$363ec144a94029c8 = 'Finance';
const $6784cbc7d62e5d7c$export$df0fb32d68ae1e78 = 'Legal';
const $6784cbc7d62e5d7c$export$d9c0e3e59442fb4 = 'Marketing';
const $6784cbc7d62e5d7c$export$27dbc7d7ce66e6e3 = 'Operations';
const $6784cbc7d62e5d7c$export$a5dce388adf922bd = 'Sales';
const $6784cbc7d62e5d7c$export$e1473b31a257caff = 'Data Science';
const $6784cbc7d62e5d7c$export$85657457db93c2c2 = 'Product Management';
const $6784cbc7d62e5d7c$export$c0c2d1dfaeba89dd = 'Project Management';
const $6784cbc7d62e5d7c$export$2e6a7ad3ab9c82a3 = 'Design';
const $6784cbc7d62e5d7c$export$7b60378c3b4372e9 = 'Other or Personal';
const $6784cbc7d62e5d7c$export$572242e58bd07594 = 'CS';
const $6784cbc7d62e5d7c$export$d7de553940261eba = 'ITS';
const $6784cbc7d62e5d7c$export$4c29d0d04c15e55d = 'HR';
const $6784cbc7d62e5d7c$export$3950f7f841bf94b6 = 'FNC';
const $6784cbc7d62e5d7c$export$881249b988b6030f = 'LGL';
const $6784cbc7d62e5d7c$export$e4824f74b9879164 = 'MKT';
const $6784cbc7d62e5d7c$export$4f3cb0844009af52 = 'OPS';
const $6784cbc7d62e5d7c$export$1a65d50c4a641bb4 = 'SAL';
const $6784cbc7d62e5d7c$export$9ee64e8fbd8b03a2 = 'DS';
const $6784cbc7d62e5d7c$export$b8b1ac856ba1434b = 'DEV';
const $6784cbc7d62e5d7c$export$4f54a09a24fd1d74 = 'PDM';
const $6784cbc7d62e5d7c$export$79685802e8ff1098 = 'PJM';
const $6784cbc7d62e5d7c$export$e5c438b7501b5a24 = 'DES';
const $6784cbc7d62e5d7c$export$cbc0e551d91a692d = 'OTR';

const $dbbf68c32d8c4308$export$e0197e09cccd4e50 = 'backlogCreateSprintNudge';
const $dbbf68c32d8c4308$export$6770a2081a63fc15 = 'backlogStartSprintNudge';
const $dbbf68c32d8c4308$export$63b61f654ce3da3d = 'backlogCompleteSprintNudge';
const $dbbf68c32d8c4308$export$1c7a80b00ad9619 = 'backlogInsightsNudge';
const $dbbf68c32d8c4308$export$b8b9d90f9e5bd72b = 'jiraSoftwareOnboardingNudges';
const $dbbf68c32d8c4308$export$65fb0c4e534f03fc = 'asyncScrumTourNudge';
const $dbbf68c32d8c4308$export$f2fe211acb4aa81a = 'asyncKanbanTourNudge';
const $dbbf68c32d8c4308$export$fb9c6e63a7490968 = 'asyncJWMCalendarTourNudge';
const $dbbf68c32d8c4308$export$df53a339af97f102 = 'asyncJWMCalendarAndTimelineTourNudge';
const $dbbf68c32d8c4308$export$573d4bf1da6d2bc6 = 'asyncJWMBoardTourNudge';
const $dbbf68c32d8c4308$export$501e36925fa10eef = 'asyncJWMListTourNudge';
const $dbbf68c32d8c4308$export$2f06a16c987cc1a2 = 'asyncJWMTimelineTourNudge';
const $dbbf68c32d8c4308$export$226bdcb034c75951 = 'asyncJWMFormTourNudge';
const $dbbf68c32d8c4308$export$b72fce9f4cf11b5c = 'asyncJWMTrelloKeyDifferencesTourNudge';
const $dbbf68c32d8c4308$export$306510c7b1760652 = 'asyncJWMSummaryAndReportsTabNudge';
const $dbbf68c32d8c4308$export$cf1943561be3a3c2 = 'asyncJWMSummaryViewNudge';
const $dbbf68c32d8c4308$export$f8bf435a6066832c = 'button clicked';
const $dbbf68c32d8c4308$export$3bc551fe07069f89 = 'asyncJWMInviteTeamNudge';
const $dbbf68c32d8c4308$export$d99767a37baddfc = 'sampleProjectDataNudge';
const $dbbf68c32d8c4308$export$2ef41782ca91324c = 'businessSampleDataNudge';
const $dbbf68c32d8c4308$export$4db327e1949c2108 = 'boardInProgressColumnNudge';
const $dbbf68c32d8c4308$export$a402f2c11da96cd7 = 'boardCreateIssueNudge';
const $dbbf68c32d8c4308$export$1e174cd1e0212f3a = 'navigateCalendarNudge';
const $dbbf68c32d8c4308$export$a1398a6ef9526001 = 'inlineEditListNudge';
const $dbbf68c32d8c4308$export$5908fa8acd2c0739 = 'filterListNudge';
const $dbbf68c32d8c4308$export$50192b0fdc9bdacf = 'moreDropdownListNudge';
const $dbbf68c32d8c4308$export$e34e81ed4f255f6e = 'timelineAddDateNudge';
const $dbbf68c32d8c4308$export$aac6e5779d47ef37 = 'timelineAddChildItemNudge';
const $dbbf68c32d8c4308$export$dd4b359b5a58cdc0 = 'trelloCrossflowTimelineTabNudge';
const $dbbf68c32d8c4308$export$1e0e647cc08bb4d8 = 'trelloKeyDifferencesIssueNudge';
const $dbbf68c32d8c4308$export$762576896c225bd6 = 'trelloKeyDifferencesSummaryNudge';
const $dbbf68c32d8c4308$export$5a96f813312dc7fa = 'trelloKeyDifferencesBoardNudge';
const $dbbf68c32d8c4308$export$ae8eeb04e0b1e9af = 'availableFieldsFormNudge';
const $dbbf68c32d8c4308$export$a54d77300f1dddea = 'changeIssueTypeFormNudge';
const $dbbf68c32d8c4308$export$6afdc7e5f6d2e915 = 'previewSaveFormNudge';
const $dbbf68c32d8c4308$export$eb0b199de90a7ec2 = 'backgroundColorNudge';
const $dbbf68c32d8c4308$export$e9e47a7ad42e71f5 = 'feedbackNudge';
const $dbbf68c32d8c4308$export$791f56b3d78403cc = 'calendarReleasesNudge';
const $dbbf68c32d8c4308$export$a1be34032ee24f78 = 'shareProjectNudge';
const $dbbf68c32d8c4308$export$29fe6611cc093756 = 'summaryTabNudge';
const $dbbf68c32d8c4308$export$f107c06c0830f09d = 'reportsTabNudge';
const $dbbf68c32d8c4308$export$9749a972a54ad7ba = 'boardContainerNudge';
const $dbbf68c32d8c4308$export$fb4f98ca3ff0420 = 'businessSampleDataNudge';
const $dbbf68c32d8c4308$export$b7fd448c62b5fb97 = 'listview';
const $dbbf68c32d8c4308$export$10c63dc5c09466d2 = 'boardview';
const $dbbf68c32d8c4308$export$75b8d65228d517e9 = 'sampleProjectScrumTourNudge';
const $dbbf68c32d8c4308$export$59a47f76d45b99 = 'sampleProjectScrumSprintNudge';
const $dbbf68c32d8c4308$export$513a9459cd6c3f96 = 'sampleProjectScrumBacklogNudge';
const $dbbf68c32d8c4308$export$657cdc4d7e8d9e5f = 'sampleProjectScrumBoardNudge';
const $dbbf68c32d8c4308$export$e16b25a220be9f3b = 'sampleProjectBoardNudge';
const $dbbf68c32d8c4308$export$c2f124710ac3a3ab = 'sampleProjectListNudge';
const $dbbf68c32d8c4308$export$b1c1e2ff4cbedbe = 'sampleProjectScrumSprintNudgeErrorBoundary';
const $dbbf68c32d8c4308$export$b230ed22c9a186d5 = 'sampleProjectScrumBacklogNudgeErrorBoundary';
const $dbbf68c32d8c4308$export$a321b777cf077071 = 'sampleProjectScrumBoardNudgeErrorBoundary';
const $dbbf68c32d8c4308$export$b51b409cb5508624 = 'sampleProjectBoardNudgeErrorBoundary';
const $dbbf68c32d8c4308$export$9757a1f68dc7a9b = 'sampleProjectListNudgeErrorBoundary';
const $dbbf68c32d8c4308$export$63a886637b84800 = 'sampleProjectNavTourNudge';
const $dbbf68c32d8c4308$export$bb40993d16db4a4b = 'SampleProjectNavNudge';
const $dbbf68c32d8c4308$export$8c300ac9d8c53332 = 'SampleProjectNavNudgeErrorBoundary';

parcelRegister("7oe20", function(module, exports) {

$parcel$export(module.exports, "tailorBoardColumnsNudgeEntryPoint", () => $279fd837d49de3a4$export$13278346f7fe314b);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $279fd837d49de3a4$export$13278346f7fe314b = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("5QwO6")), {
        moduleId: "d4273c47"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("5QwO6", function(module, exports) {

let $441b41e2adc548fb$var$load = (parcelRequire("28QjX"))(4);
module.exports = $441b41e2adc548fb$var$load("cKVf8").then(()=>parcelRequire('38BJH'));

});



parcelRegister("bh9Ty", function(module, exports) {

$parcel$export(module.exports, "useDraggableColumn", () => $c2f9ec7c7d9d3582$export$a2d73877a5476992);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $biEfA = parcelRequire("biEfA");

var $4hDdm = parcelRequire("4hDdm");

var $7gWdR = parcelRequire("7gWdR");
parcelRequire("4FF5h");
var $hOQcA = parcelRequire("hOQcA");
parcelRequire("erBEN");
var $kpXwZ = parcelRequire("kpXwZ");

var $cvj5l = parcelRequire("cvj5l");

var $kiyQL = parcelRequire("kiyQL");

var $dI6Zj = parcelRequire("dI6Zj");

var $dblxc = parcelRequire("dblxc");
const $c2f9ec7c7d9d3582$export$a2d73877a5476992 = ({ columnDropTargetRef: columnDropTargetRef, columnHandleRef: columnHandleRef, column: column, index: index })=>{
    const { cleanupDragPreview: cleanupDragPreview, dragPreviewState: dragPreviewState, isDragging: isDraggingColumn, renderDragPreview: renderDragPreview, resetDraggedColumn: resetDraggedColumn, startColumnDrag: startColumnDrag } = (0, $dI6Zj.useColumnDragDrop)(column.id);
    const [closestEdge, setClosestEdge] = (0, $5uXOq.useState)(null);
    const [isCardOverColumn, setIsCardOverColumn] = (0, $5uXOq.useState)(false);
    const updateDropTarget = (0, $kiyQL.useUpdateDropTarget)();
    const resetDropTarget = (0, $kiyQL.useResetDropTarget)();
    const { canDropInGroup: canDropInGroup } = (0, $kiyQL.useCanDropCard)(column);
    const inferredDropTargetTransition = (0, $kiyQL.useInferredDropTargetTransition)(column);
    (0, $5uXOq.useEffect)(()=>{
        const handleDrag = ({ source: { data: data }, self: self })=>{
            const destinationData = self.data;
            if (!(0, $dblxc.isColumn)(destinationData)) return;
            if ((0, $dblxc.isColumn)(data) && data.columnId !== column.id) {
                const extractedClosestEdge = (0, $biEfA.extractClosestEdge)(self.data);
                setClosestEdge((0, $dblxc.isClosestEdgeAdjacentToSource)(data.index, destinationData.index, extractedClosestEdge) ? null : extractedClosestEdge);
                return;
            }
            if ((0, $dblxc.isCard)(data) && ((0, $dblxc.isColumn)(destinationData) || (0, $dblxc.isCard)(destinationData))) {
                setIsCardOverColumn(true);
                if (inferredDropTargetTransition == null) updateDropTarget({
                    group: column
                });
                else updateDropTarget({
                    group: column,
                    transition: inferredDropTargetTransition
                });
            }
        };
        return (0, $4hDdm.combine)(columnHandleRef.current != null ? (0, $7gWdR.draggable)({
            element: columnHandleRef.current,
            getInitialData: ()=>({
                    type: (0, $cvj5l.COLUMN_DND_TYPE),
                    columnId: column.id,
                    index: index
                }),
            onGenerateDragPreview: ({ nativeSetDragImage: nativeSetDragImage, location: location, source: source })=>{
                (0, $kpXwZ.setCustomNativeDragPreview)({
                    getOffset: (0, $hOQcA.preserveOffsetOnSource)({
                        element: source.element,
                        input: location.current.input
                    }),
                    render ({ container: container }) {
                        renderDragPreview(container);
                        return ()=>{
                            cleanupDragPreview();
                        };
                    },
                    nativeSetDragImage: nativeSetDragImage
                });
            },
            onDragStart: startColumnDrag,
            onDrop: resetDraggedColumn
        }) : (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), columnDropTargetRef.current != null ? (0, $7gWdR.dropTargetForElements)({
            element: columnDropTargetRef.current,
            canDrop: ({ source: source })=>(0, $dblxc.isColumn)(source.data) || (0, $dblxc.isCard)(source.data) && canDropInGroup === 'yes',
            getIsSticky: ({ source: source })=>(0, $dblxc.isColumn)(source.data),
            getData: ({ input: input, element: element })=>{
                const data = {
                    type: (0, $cvj5l.COLUMN_DND_TYPE),
                    columnId: column.id,
                    index: index
                };
                return (0, $biEfA.attachClosestEdge)(data, {
                    input: input,
                    element: element,
                    allowedEdges: [
                        'left',
                        'right'
                    ]
                });
            },
            onDragEnter: handleDrag,
            onDrag: handleDrag,
            onDragLeave: ({ source: { data: data } })=>{
                if ((0, $dblxc.isCard)(data)) {
                    resetDropTarget();
                    setIsCardOverColumn(false);
                    return;
                }
                setClosestEdge(null);
            },
            onDrop: ({ source: { data: data } })=>{
                if ((0, $dblxc.isCard)(data)) {
                    setIsCardOverColumn(false);
                    return;
                }
                if ((0, $dblxc.isColumn)(data)) setClosestEdge(null);
            }
        }) : (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))));
    }, [
        canDropInGroup,
        columnDropTargetRef,
        columnHandleRef,
        column,
        index,
        inferredDropTargetTransition,
        resetDropTarget,
        updateDropTarget,
        startColumnDrag,
        renderDragPreview,
        cleanupDragPreview,
        resetDraggedColumn
    ]);
    return {
        canDropInGroup: canDropInGroup,
        closestEdge: closestEdge,
        dragPreviewState: dragPreviewState,
        isCardOverColumn: isCardOverColumn,
        isDraggingColumn: isDraggingColumn
    };
};

});
parcelRegister("4FF5h", function(module, exports) {

$parcel$export(module.exports, "preserveOffsetOnSource", () => (parcelRequire("hOQcA")).preserveOffsetOnSource);

var $hOQcA = parcelRequire("hOQcA");

});
parcelRegister("hOQcA", function(module, exports) {

$parcel$export(module.exports, "preserveOffsetOnSource", () => $204fc61c99793f66$export$8830e7ac6eee750e);
function $204fc61c99793f66$export$8830e7ac6eee750e({ element: element, input: input }) {
    return ({ container: container })=>{
        const sourceRect = element.getBoundingClientRect();
        const containerRect = container.getBoundingClientRect();
        const offsetX = Math.min(// difference
        input.clientX - sourceRect.x, // don't let the difference be more than the width of the container,
        // otherwise the pointer will be off the preview
        containerRect.width);
        const offsetY = Math.min(// difference
        input.clientY - sourceRect.y, // don't let the difference be more than the height of the container,
        // otherwise the pointer will be off the preview
        containerRect.height);
        return {
            x: offsetX,
            y: offsetY
        };
    };
}

});


parcelRegister("erBEN", function(module, exports) {

$parcel$export(module.exports, "setCustomNativeDragPreview", () => (parcelRequire("kpXwZ")).setCustomNativeDragPreview);

var $kpXwZ = parcelRequire("kpXwZ");

});
parcelRegister("kpXwZ", function(module, exports) {

$parcel$export(module.exports, "setCustomNativeDragPreview", () => $39163240d699f88a$export$52d889c66db0f96e);

var $40DDD = parcelRequire("40DDD");

var $6aABs = parcelRequire("6aABs");

/** By default we use the build in values for the native drag preview: {x: 0, y: 0} */ function $39163240d699f88a$var$defaultOffset() {
    return {
        x: 0,
        y: 0
    };
}
function $39163240d699f88a$export$52d889c66db0f96e({ render: render, nativeSetDragImage: nativeSetDragImage, getOffset: getOffset = $39163240d699f88a$var$defaultOffset }) {
    const container = document.createElement('div');
    Object.assign(container.style, {
        // Ensuring we don't cause reflow when adding the element to the page
        // Using `position:fixed` rather than `position:absolute` so we are
        // positioned on the current viewport.
        // `position:fixed` also creates a new stacking context, so we don't need to do that here
        position: 'fixed',
        // According to `mdn`, the element can be offscreen:
        // https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/setDragImage#imgelement
        //
        // However, that  information does not appear in the specs:
        // https://html.spec.whatwg.org/multipage/dnd.html#dom-datatransfer-setdragimage-dev
        //
        // If the element is _completely_ offscreen, Safari@17.1 will cancel the drag
        top: 0,
        left: 0,
        // Using maximum possible z-index so that this element will always be on top
        // https://stackoverflow.com/questions/491052/minimum-and-maximum-value-of-z-index
        // Did not use `layers` in `@atlaskit/theme` because:
        // 1. This element is not a 'layer' in the conventional sense, as this element
        //    is only created for a single frame for the browser to take a photo of it,
        //    and then it is destroyed
        // 2. Did not want to add a dependency onto `@atlaskit/theme`
        // 3. Want to always be on top of product UI which might have higher z-index's
        zIndex: (0, $ff68169bc3de57ec$export$7d0a15ee70427305),
        // Avoiding any additional events caused by the new element (being super safe)
        pointerEvents: 'none'
    });
    document.body.append(container);
    const unmount = render({
        container: container
    });
    /**
	 * Some frameworks (eg `react`) don't render into the container until the next microtask.
	 * - This will run before the browser takes it's picture of the element
	 * - This will run before the animation frame that removes `container`.
	 * */ queueMicrotask(()=>{
        const previewOffset = getOffset({
            container: container
        });
        /**
		 * **Problem**
		 * On `Safari@17.1` if a drag preview element has some opacity,
		 * Safari will include elements behind the drag preview element
		 * in the drag preview.
		 * Bug: https://bugs.webkit.org/show_bug.cgi?id=266025
		 *
		 * **Fix**
		 * We push the drag preview so it is _almost_ completely offscreen so that
		 * there won't be any elements behind the drag preview element.
		 * If the element is _completely_ offscreen, then the drag is cancelled by Safari.
		 *
		 * Using `-0.0001` so that any potential "see through" on the drag preview element
		 * is effectively invisible 👻
		 *
		 * **Unsuccessful alternatives**
		 * Setting a background color (eg "white") on the `container`
		 * → Wrecks the opacity of the drag preview element
		 *
		 * Adding a parent element of the `container` with a background color (eg "white")
		 * → Wrecks the opacity of the drag preview element
		 */ if ((0, $6aABs.isSafari)()) {
            const rect = container.getBoundingClientRect();
            // We cannot apply this fix if nothing has been rendered into the `container`
            if (rect.width === 0) return;
            container.style.left = `-${rect.width - 0.0001}px`;
        }
        nativeSetDragImage?.(container, previewOffset.x, previewOffset.y);
    });
    function cleanup() {
        unbindMonitor();
        unmount?.();
        document.body.removeChild(container);
    }
    const unbindMonitor = (0, $40DDD.monitorForElements)({
        // Remove portal in the dragstart event so that the user will never see it
        onDragStart: cleanup,
        // Backup: remove portal when the drop finishes (this would be an error case)
        onDrop: cleanup
    });
}

});
// Maximum possible z-index
// https://stackoverflow.com/questions/491052/minimum-and-maximum-value-of-z-index
const $ff68169bc3de57ec$export$7d0a15ee70427305 = 2147483647;




parcelRegister("fx09t", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba9193fa372126e5$export$2e2bcd8739ae039);

var $8zL8V = parcelRequire("8zL8V");

var $dj88z = parcelRequire("dj88z");

var $cyhQX = parcelRequire("cyhQX");

var $4lJ2Q = parcelRequire("4lJ2Q");

var $19ZaU = parcelRequire("19ZaU");

var $gnApX = parcelRequire("gnApX");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $7nsd3 = parcelRequire("7nsd3");

var $8Uumt = parcelRequire("8Uumt");

var $6l4ko = parcelRequire("6l4ko");

var $hE5wF = parcelRequire("hE5wF");


var $bG3pQ = parcelRequire("bG3pQ");

var $33Toe = parcelRequire("33Toe");

var $jpY8v = parcelRequire("jpY8v");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $cvj5l = parcelRequire("cvj5l");

var $4XIcI = parcelRequire("4XIcI");

var $kiyQL = parcelRequire("kiyQL");

var $6NyFx = parcelRequire("6NyFx");

var $3WdOs = parcelRequire("3WdOs");

var $850r2 = parcelRequire("850r2");

var $khNhv = parcelRequire("khNhv");

var $ldIU4 = parcelRequire("ldIU4");

var $dmCTb = parcelRequire("dmCTb");

var $gt8ro = parcelRequire("gt8ro");

var $dKta6 = parcelRequire("dKta6");

var $aNAix = parcelRequire("aNAix");

var $a2Vvo = parcelRequire("a2Vvo");

var $f94vf = parcelRequire("f94vf");

var $9LL9k = parcelRequire("9LL9k");
const $ba9193fa372126e5$var$isSafariBrowser = (0, $jpY8v.isSafari)();
const $ba9193fa372126e5$var$useDropHighlight = (issueId)=>{
    const { highlightedIssueId: highlightedIssueId, resetHighlightedIssue: resetHighlightedIssue } = (0, $kiyQL.useHighlightedIssue)();
    const isDropHighlighted = highlightedIssueId === issueId;
    (0, $5uXOq.useEffect)(()=>{
        if (isDropHighlighted) {
            /*
       * We need to reset the highlighted issue after a short delay to ensure the card has enough time to move
       * to the correct position after a successful drop.
       */ const timeoutId = setTimeout(()=>{
                resetHighlightedIssue();
            }, 100);
            return ()=>{
                clearTimeout(timeoutId);
            };
        }
    }, [
        isDropHighlighted,
        resetHighlightedIssue
    ]);
    return isDropHighlighted;
};
const $ba9193fa372126e5$export$cf50394f7430bcfc = /*#__PURE__*/ (0, $5uXOq.memo)(({ columnFragment: columnFragment, projectFragment: projectFragment, queryFragment: queryFragment, viewFragment: viewFragment, canCreateIssues: canCreateIssues, draggableIndex: draggableIndex, dragAndDropColumnData: dragAndDropColumnData, highlight: highlight, isSiblingCreateFormOpen: isSiblingCreateFormOpen, prevIssueKey: prevIssueKey, issue: issue, toggleSiblingCreateForm: toggleSiblingCreateForm, onCardDragChange: onCardDragChange })=>{
    const issueKey = issue.fields[0, $cvj5l.ISSUE_KEY_ID].value;
    const { issueViewInteraction: issueViewInteraction } = (0, $3WdOs.useJWMBoardFeatures)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const shouldUseEmbedIssueClick = issueViewInteraction === 'openNewTab';
    const getIsHighlighted = (0, $33Toe.useIsHighlighted)();
    const isHighlighted = getIsHighlighted(issue.id);
    const isDropHighlighted = $ba9193fa372126e5$var$useDropHighlight(issue.id);
    const isOptimistic = (0, $33Toe.isOptimisticIssue)(issue.id);
    const data = (0, $8Uumt.useFragment)((0, $gnApX.default), queryFragment);
    const project = (0, $8Uumt.useFragment)((0, $19ZaU.default), projectFragment);
    const view = (0, $8Uumt.useFragment)((0, $4lJ2Q.default), viewFragment);
    const column = (0, $8Uumt.useFragment)((0, $cyhQX.default), columnFragment);
    const ref = (0, $5uXOq.useRef)(null);
    const nodeId = `${view.id}/node/${issue.id}`;
    const cardSelections = (0, $6l4ko.useNodeSelections)({
        nodeId: nodeId
    });
    const { draggedIssue: draggedIssue } = (0, $kiyQL.useCardDragDrop)();
    const { dragState: dragState } = (0, $6NyFx.useDraggableCard)({
        ref: ref,
        issue: issue,
        cardIndex: draggableIndex,
        column: dragAndDropColumnData,
        onCardDragChange: onCardDragChange
    });
    const isDragging = draggedIssue?.id === issue.id;
    const applyHighlightingStyles = isHighlighted || isDropHighlighted;
    const onEmbedIssueOpen = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'issue clicked', 'boardEmbedIssue');
        (0, $bG3pQ.openViewFromEmbed)({
            key: (0, $hE5wF.SELECTED_ISSUE_PARAM),
            value: issueKey
        });
    }, [
        createAnalyticsEvent,
        issueKey
    ]);
    const onIssueClick = (0, $850r2.useViewIssue)(nodeId);
    const clickHandler = (0, $5uXOq.useCallback)((e)=>{
        onIssueClick(issue, e.ctrlKey || e.metaKey);
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'issue clicked', 'boardIssue');
    }, [
        onIssueClick,
        issue,
        createAnalyticsEvent
    ]);
    const cardContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_zulp1b66 _1rjcu2gc _18zrutpp _4cvr1y6m _1e0c1txw _1bah1yb4"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ldIU4.CardSummary), {
        highlight: highlight,
        text: issue.fields[0, $cvj5l.SUMMARY_ID].value
    }), isOptimistic ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f94vf.CardSpinner), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9LL9k.default), {
        issue: issue,
        columnFragment: column,
        projectFragment: project,
        viewFragment: view
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gt8ro.CardContent), {
        highlight: highlight,
        issue: issue,
        viewFragment: view
    }));
    const cardContainer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-testid": "work-management-board.ui.board.column.card.container",
        className: (0, $bwpsq.default)([
            "_vchhusvi _1e0c1txw _2lx21bp4"
        ])
    }, cardContent, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a2Vvo.CardFooter), {
        cardOptionsFragment: view.cardOptions,
        issue: issue
    }));
    const inlineSiblingCreateProps = (0, $5uXOq.useMemo)(()=>({
            isTopMost: draggableIndex === 0,
            issue: issue,
            isSiblingCreateFormOpen: isSiblingCreateFormOpen,
            toggleSiblingCreateForm: toggleSiblingCreateForm,
            prevIssueKey: prevIssueKey
        }), [
        draggableIndex,
        isSiblingCreateFormOpen,
        issue,
        toggleSiblingCreateForm,
        prevIssueKey
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, canCreateIssues && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $khNhv.default), {
        queryFragment: data,
        columnFragment: column,
        inlineSiblingCreateProps: inlineSiblingCreateProps,
        isInlineSiblingCreate: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        ref: ref,
        "data-testid": "work-management-board.ui.board.column.card",
        className: (0, $bwpsq.default)([
            $ba9193fa372126e5$var$cardContainerStyles.root,
            isDragging && $ba9193fa372126e5$var$cardContainerStyles.dragging
        ])
    }, !isOptimistic && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dmCTb.InteractionLayer), {
        issue: issue,
        onClick: shouldUseEmbedIssueClick ? onEmbedIssueOpen : clickHandler
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4XIcI.CardCoverEditingContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_vchhusvi _1e0c1txw _2lx21bp4"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ba9193fa372126e5$var$BoardCardCoverWrapper, {
        queryFragment: data,
        viewFragment: view,
        coverMedia: issue.coverMedia
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_kqswh2mm"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            $ba9193fa372126e5$var$highlightContainerStyles.root,
            isOptimistic && $ba9193fa372126e5$var$highlightContainerStyles.dragNotAllowed,
            applyHighlightingStyles && $ba9193fa372126e5$var$highlightContainerStyles.highlighted
        ])
    }, cardSelections ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aNAix.CardBadge), {
        selections: cardSelections,
        position: draggableIndex === 0 ? (0, $44496cc0f0c1ce14$export$86bcdda8e7a22b9d) : (0, $44496cc0f0c1ce14$export$a3a66eb204e551b3)
    }, cardContainer) : cardContainer)))), dragState.type === 'preview' ? /*#__PURE__*/ (0, $7nsd3.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ba9193fa372126e5$export$6bb2a69551ff8f5b, {
        isTilted: !$ba9193fa372126e5$var$isSafariBrowser
    }, cardContent), dragState.container) : null);
});
const $ba9193fa372126e5$var$BoardCardCoverWrapper = /*#__PURE__*/ (0, $5uXOq.memo)(({ queryFragment: queryFragment, viewFragment: viewFragment, coverMedia: coverMedia })=>{
    const data = (0, $8Uumt.useFragment)((0, $dj88z.default), queryFragment);
    const view = (0, $8Uumt.useFragment)((0, $8zL8V.default), viewFragment);
    const showCardCovers = view.cardOptions.edges.some((edge)=>edge?.node?.field?.fieldId === (0, $cvj5l.CARD_COVER));
    return showCardCovers && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dKta6.CardCover), {
        coverMedia: coverMedia,
        queryFragment: data
    });
});
var $ba9193fa372126e5$export$2e2bcd8739ae039 = $ba9193fa372126e5$export$cf50394f7430bcfc;
const $ba9193fa372126e5$var$MAX_CARD_WIDTH = 270;
const $ba9193fa372126e5$var$cardContainerStyles = {
    root: "_2rkoglpi _v5641hrg _p12f1ogy _uiztglyw _vchhusvi _kqswh2mm _16qszucj _bfhkhp5a _syaz1fxt _tzy4kb7n _lcxvglyw _irr3108i _hv3wt94y _15jnt94y",
    dragging: "_v5641hrg _tzy42wxo _d0al5szm"
};
const $ba9193fa372126e5$var$relativeMainContentContainerStyles = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $ba9193fa372126e5$export$6bb2a69551ff8f5b = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isTilted: isTilted, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rkoglpi _1bsb1ogy _vchhusvi _kqswh2mm _bfhkhp5a",
            __cmplp.isTilted ? "_139ek9zm" : "_139e1i1e",
            __cmplp.className
        ])
    });
});
const $ba9193fa372126e5$var$cardContentContainerStyles = null;
const $ba9193fa372126e5$var$cardSummaryAndActionsContainerStyles = null;
const $ba9193fa372126e5$var$highlightContainerStyles = {
    root: "_v56417iv _bfhk18uv",
    dragNotAllowed: "_80om13gf _kqswh2mm _lcxv1wug",
    highlighted: "_v564glyw _bfhk4v9p"
};

});
parcelRegister("8zL8V", function(module, exports) {

$parcel$export(module.exports, "default", () => $3830788717a81b29$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3501c4aea48279ded861867d6323a79d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $3830788717a81b29$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "BoardCard_CoverWrapper_view",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "enabledOnly",
                        "value": true
                    },
                    {
                        "kind": "Literal",
                        "name": "first",
                        "value": 100
                    }
                ],
                "concreteType": "JiraBoardViewCardOptionConnection",
                "kind": "LinkedField",
                "name": "cardOptions",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "JiraBoardViewCardOptionEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "JiraField",
                                                            "kind": "LinkedField",
                                                            "name": "field",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": {
                                                                        "kind": "ScalarField",
                                                                        "name": "fieldId"
                                                                    },
                                                                    "action": "THROW",
                                                                    "path": "cardOptions.edges.node.field.fieldId"
                                                                }
                                                            ]
                                                        },
                                                        "action": "THROW",
                                                        "path": "cardOptions.edges.node.field"
                                                    }
                                                ],
                                                "type": "JiraBoardViewFieldCardOption"
                                            }
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "cardOptions.edges.node"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "cardOptions.edges"
                    }
                ],
                "storageKey": "cardOptions(enabledOnly:true,first:100)"
            },
            "action": "THROW",
            "path": "cardOptions"
        }
    ],
    "type": "JiraBoardView"
};
$3830788717a81b29$var$node.hash = "be105c253847d0a10b4f9a601c3de537";
var $3830788717a81b29$export$2e2bcd8739ae039 = $3830788717a81b29$var$node;

});

parcelRegister("dj88z", function(module, exports) {

$parcel$export(module.exports, "default", () => $f4cab56a85288103$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<05f80dc12871dfc32a0a6107e216623d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f4cab56a85288103$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "BoardCard_CoverWrapper_query",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "cardCover_workManagementBoard_queryFragment"
        }
    ],
    "type": "Query"
};
$f4cab56a85288103$var$node.hash = "cd3cb82e97deed1a96036ee15b098368";
var $f4cab56a85288103$export$2e2bcd8739ae039 = $f4cab56a85288103$var$node;

});

parcelRegister("cyhQX", function(module, exports) {

$parcel$export(module.exports, "default", () => $b33ebf22a821df04$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8b729a55fd26376a09a89fb6b35abb61>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b33ebf22a821df04$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "BoardCard_column",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "BoardInlineCreate_column"
        },
        {
            "kind": "FragmentSpread",
            "name": "BoardCardActions_column"
        }
    ],
    "type": "JiraBoardViewColumn",
    "abstractKey": "__isJiraBoardViewColumn"
};
$b33ebf22a821df04$var$node.hash = "0907f16a7a51541bffdc36fde33bcf25";
var $b33ebf22a821df04$export$2e2bcd8739ae039 = $b33ebf22a821df04$var$node;

});

parcelRegister("4lJ2Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $8631e3ec1e4882b8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<57641dadeb0441c75a9e8a5b8b6aa263>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $8631e3ec1e4882b8$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "BoardCard_view",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "BoardCard_CoverWrapper_view"
        },
        {
            "kind": "FragmentSpread",
            "name": "CardContent_view"
        },
        {
            "kind": "FragmentSpread",
            "name": "BoardCardActions_view"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "id"
            },
            "action": "THROW",
            "path": "id"
        },
        {
            "kind": "RequiredField",
            "field": {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "enabledOnly",
                        "value": true
                    },
                    {
                        "kind": "Literal",
                        "name": "first",
                        "value": 100
                    }
                ],
                "concreteType": "JiraBoardViewCardOptionConnection",
                "kind": "LinkedField",
                "name": "cardOptions",
                "plural": false,
                "selections": [
                    {
                        "kind": "FragmentSpread",
                        "name": "CardFooter_cardOptions"
                    }
                ],
                "storageKey": "cardOptions(enabledOnly:true,first:100)"
            },
            "action": "THROW",
            "path": "cardOptions"
        }
    ],
    "type": "JiraBoardView"
};
$8631e3ec1e4882b8$var$node.hash = "1ff8dbfb9fabf5df2e7225bc0b49db00";
var $8631e3ec1e4882b8$export$2e2bcd8739ae039 = $8631e3ec1e4882b8$var$node;

});

parcelRegister("19ZaU", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc094946c3025536$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<09ebacc47c2cea47b913ac85197520a7>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $bc094946c3025536$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "BoardCard_project",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "BoardCardActions_project"
        }
    ],
    "type": "JiraProject"
};
$bc094946c3025536$var$node.hash = "9c19a343771e205fae0ee649688bf9c8";
var $bc094946c3025536$export$2e2bcd8739ae039 = $bc094946c3025536$var$node;

});

parcelRegister("gnApX", function(module, exports) {

$parcel$export(module.exports, "default", () => $afc20178a2b4d09b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b204f1e49bed41113481d30cc8da4890>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $afc20178a2b4d09b$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "BoardCard_query",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "BoardCard_CoverWrapper_query"
        },
        {
            "kind": "FragmentSpread",
            "name": "BoardInlineCreate_query"
        }
    ],
    "type": "Query"
};
$afc20178a2b4d09b$var$node.hash = "980b30efc0158182f438c7c8adb4f4a6";
var $afc20178a2b4d09b$export$2e2bcd8739ae039 = $afc20178a2b4d09b$var$node;

});

const $44496cc0f0c1ce14$export$86bcdda8e7a22b9d = 'inner';
const $44496cc0f0c1ce14$export$a3a66eb204e551b3 = 'outer';

parcelRegister("bG3pQ", function(module, exports) {

$parcel$export(module.exports, "openViewFromEmbed", () => $b6fc163d26910ed9$export$a29603f2eb9b6da6);

var $gKZoD = parcelRequire("gKZoD");
const $b6fc163d26910ed9$export$a29603f2eb9b6da6 = (param)=>{
    (0, $gKZoD.di)(window);
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const cleanUrl = window.location.href.replace('/embed', '');
    const currentUrl = new URL(cleanUrl);
    if (param != null) currentUrl.searchParams.append(param.key, param.value);
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.open(currentUrl.href, '_blank');
};

});

parcelRegister("4XIcI", function(module, exports) {

$parcel$export(module.exports, "CardCoverEditingContainer", () => $b8722f58ac856bc0$export$13da74796c6022b7);
$parcel$export(module.exports, "useIsCardCoverEditingOpen", () => $b8722f58ac856bc0$export$86192d02f3e50475);
$parcel$export(module.exports, "useCardCoverEditingActions", () => $b8722f58ac856bc0$export$a20e8ef4d07b82c8);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $gg7kZ = parcelRequire("gg7kZ");
var $iXqE5 = parcelRequire("iXqE5");
const $b8722f58ac856bc0$export$13da74796c6022b7 = (0, $gg7kZ.createContainer)();
const $b8722f58ac856bc0$var$actions = {
    setOpen: (isOpen)=>({ setState: setState })=>{
            setState({
                isOpen: isOpen
            });
        }
};
const $b8722f58ac856bc0$var$store = (0, $iXqE5.createStore)({
    name: 'BusinessBoardCardCoverEditingStore',
    initialState: {
        isOpen: false
    },
    actions: $b8722f58ac856bc0$var$actions,
    containedBy: $b8722f58ac856bc0$export$13da74796c6022b7
});
const $b8722f58ac856bc0$export$86192d02f3e50475 = (0, $3sQ5x.createStateHook)($b8722f58ac856bc0$var$store, {
    selector: (state)=>state.isOpen
});
const $b8722f58ac856bc0$export$a20e8ef4d07b82c8 = (0, $3sQ5x.createActionsHook)($b8722f58ac856bc0$var$store);

});

parcelRegister("6NyFx", function(module, exports) {

$parcel$export(module.exports, "useDraggableCard", () => $dbbb4aa2759d4b7d$export$ee9f6369c1b523a9);

var $5uXOq = parcelRequire("5uXOq");

var $biEfA = parcelRequire("biEfA");

var $4hDdm = parcelRequire("4hDdm");

var $7gWdR = parcelRequire("7gWdR");
parcelRequire("4FF5h");
var $hOQcA = parcelRequire("hOQcA");
parcelRequire("erBEN");
var $kpXwZ = parcelRequire("kpXwZ");

var $33Toe = parcelRequire("33Toe");

var $cvj5l = parcelRequire("cvj5l");

var $kiyQL = parcelRequire("kiyQL");

var $dblxc = parcelRequire("dblxc");

var $57RI1 = parcelRequire("57RI1");
const $dbbb4aa2759d4b7d$export$ee9f6369c1b523a9 = ({ ref: ref, issue: issue, cardIndex: cardIndex, column: column, onCardDragChange: onCardDragChange })=>{
    const startCardDrag = (0, $kiyQL.useStartCardDrag)();
    const { canDropAgainstCard: canDropAgainstCard } = (0, $kiyQL.useCanDropCard)(column);
    const [dragState, setDragState] = (0, $5uXOq.useState)({
        type: 'idle'
    });
    const hasDragPermission = (0, $57RI1.useHasDragPermission)(column.type);
    const updateDropTarget = (0, $kiyQL.useUpdateDropTarget)();
    (0, $5uXOq.useEffect)(()=>{
        if (!ref.current) return;
        const handleDrag = ({ source: source, self: self })=>{
            const sourceData = source.data;
            if (!(0, $dblxc.isCard)(sourceData)) return;
            if (sourceData.issueId === issue.id) return;
            const destinationData = self.data;
            const closestEdge = (0, $biEfA.extractClosestEdge)(destinationData);
            const isWithinSameColumn = sourceData.columnId === destinationData.columnId;
            const isClosestEdgeAdjacentToSource = (0, $dblxc.isCard)(destinationData) && isWithinSameColumn && closestEdge != null && (0, $dblxc.isClosestEdgeAdjacentToSource)(sourceData.cardIndex, destinationData.cardIndex, closestEdge);
            onCardDragChange(closestEdge && !isClosestEdgeAdjacentToSource ? {
                cardIndex: cardIndex,
                closestEdge: closestEdge
            } : null);
            if ((0, $dblxc.isCard)(destinationData) && isWithinSameColumn && canDropAgainstCard === 'yes') updateDropTarget({
                group: column
            });
        };
        return (0, $4hDdm.combine)((0, $7gWdR.draggable)({
            element: ref.current,
            canDrag: ()=>hasDragPermission && !(0, $33Toe.isOptimisticIssue)(issue.id),
            getInitialData: ()=>({
                    type: (0, $cvj5l.CARD_DND_TYPE),
                    issueId: issue.id,
                    cardIndex: cardIndex,
                    columnId: column.id
                }),
            onGenerateDragPreview: ({ nativeSetDragImage: nativeSetDragImage, location: location, source: source })=>{
                (0, $kpXwZ.setCustomNativeDragPreview)({
                    getOffset: (0, $hOQcA.preserveOffsetOnSource)({
                        element: source.element,
                        input: location.current.input
                    }),
                    render ({ container: container }) {
                        setDragState({
                            type: 'preview',
                            container: container
                        });
                        return ()=>setDragState({
                                type: 'idle'
                            });
                    },
                    nativeSetDragImage: nativeSetDragImage
                });
            },
            onDragStart: ()=>{
                startCardDrag(issue, column);
            },
            onDrop: ()=>{
                setDragState({
                    type: 'idle'
                });
            }
        }), (0, $7gWdR.dropTargetForElements)({
            element: ref.current,
            canDrop: ({ source: source })=>(0, $dblxc.isCard)(source.data) && canDropAgainstCard === 'yes',
            getIsSticky: ()=>true,
            getData: ({ input: input, element: element })=>{
                const data = {
                    type: (0, $cvj5l.CARD_DND_TYPE),
                    issueId: issue.id,
                    cardIndex: cardIndex,
                    columnId: column.id
                };
                return (0, $biEfA.attachClosestEdge)(data, {
                    input: input,
                    element: element,
                    allowedEdges: [
                        'top',
                        'bottom'
                    ]
                });
            },
            onDragEnter: handleDrag,
            onDrag: handleDrag,
            onDragLeave: ()=>{
                onCardDragChange(null);
            },
            onDrop: ()=>{
                onCardDragChange(null);
            }
        }));
    }, [
        canDropAgainstCard,
        cardIndex,
        column,
        hasDragPermission,
        issue,
        onCardDragChange,
        ref,
        startCardDrag,
        updateDropTarget
    ]);
    return {
        dragState: dragState
    };
};

});
parcelRegister("57RI1", function(module, exports) {

$parcel$export(module.exports, "useHasDragPermission", () => $71420fb61ca76ae1$export$6c4e34ba44c56224);

var $hE5wF = parcelRequire("hE5wF");

var $daQYX = parcelRequire("daQYX");
const $71420fb61ca76ae1$export$6c4e34ba44c56224 = (groupType)=>{
    const { permissions: permissions } = (0, $daQYX.useProject)();
    const hasRankPermission = permissions.editIssues && permissions.scheduleIssues;
    switch(groupType){
        case 0, $hE5wF.GROUP_BY_ASSIGNEE:
            return hasRankPermission || permissions.assignIssues;
        case 0, $hE5wF.GROUP_BY_CATEGORY:
        case 0, $hE5wF.GROUP_BY_PRIORITY:
            return permissions.editIssues;
        case 0, $hE5wF.GROUP_BY_STATUS:
            return hasRankPermission || permissions.transitionIssues;
        default:
            {
                const exhaustiveCheck = groupType;
                throw new Error(`Unexpected groupBy value: ${exhaustiveCheck}`);
            }
    }
};

});


parcelRegister("850r2", function(module, exports) {

$parcel$export(module.exports, "useViewIssue", () => $e81e6101e05dadf3$export$f26a5ae87a55d4f8);

var $5uXOq = parcelRequire("5uXOq");

var $kMSay = parcelRequire("kMSay");

var $6l4ko = parcelRequire("6l4ko");

var $hE5wF = parcelRequire("hE5wF");

var $ieDtd = parcelRequire("ieDtd");

var $cvj5l = parcelRequire("cvj5l");
const $e81e6101e05dadf3$export$f26a5ae87a55d4f8 = (nodeId)=>{
    const ufoPressTracing = (0, $kMSay.default)('jwm.board.issue-view-opened');
    const [, setSelectedIssueKey] = (0, $ieDtd.useQueryParam)((0, $hE5wF.SELECTED_ISSUE_PARAM));
    const { sendNodeSelected: sendNodeSelected } = (0, $6l4ko.useCollabStoreActions)();
    return (0, $5uXOq.useCallback)((issue, withCmd)=>{
        if (issue.id && issue.fields[0, $cvj5l.ISSUE_KEY_ID].value) {
            const issueKey = issue.fields[0, $cvj5l.ISSUE_KEY_ID].value;
            if (withCmd) typeof window !== 'undefined' && window.open(`/browse/${issueKey}`, '_blank');
            else {
                ufoPressTracing();
                setSelectedIssueKey(issueKey);
                if (nodeId) sendNodeSelected({
                    nodeId: nodeId
                });
            }
        }
    }, [
        nodeId,
        sendNodeSelected,
        setSelectedIssueKey,
        ufoPressTracing
    ]);
};

});

parcelRegister("khNhv", function(module, exports) {

$parcel$export(module.exports, "default", () => $c82e417ee56b19da$export$2e2bcd8739ae039);

var $l4vU7 = parcelRequire("l4vU7");

var $aSL16 = parcelRequire("aSL16");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $k7m40 = parcelRequire("k7m40");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $eNaDQ = parcelRequire("eNaDQ");

var $dCm1o = parcelRequire("dCm1o");

var $4R6GH = parcelRequire("4R6GH");

var $6s1PB = parcelRequire("6s1PB");

var $iFFYo = parcelRequire("iFFYo");

var $5fc53 = parcelRequire("5fc53");

var $9ocZh = parcelRequire("9ocZh");

var $koVbs = parcelRequire("koVbs");

var $cvj5l = parcelRequire("cvj5l");

var $hqsgn = parcelRequire("hqsgn");

var $gEtYC = parcelRequire("gEtYC");

var $jgcJl = parcelRequire("jgcJl");

var $7OM52 = parcelRequire("7OM52");

var $li7DW = parcelRequire("li7DW");
const $c82e417ee56b19da$var$INLINE_CREATE_TRIGGER_OFFSET = 12;
const $c82e417ee56b19da$var$inlineCreateStyles = {
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage -- The token value "4px" and fallback "3px" do not match and can't be replaced automatically.
    borderRadius: "var(--ds-border-radius, 3px)"
};
const $c82e417ee56b19da$var$BoardInlineCreate = ({ queryFragment: queryFragment, columnFragment: columnFragment, scrollToLastElement: scrollToLastElement, inlineSiblingCreateProps: inlineSiblingCreateProps, isInlineSiblingCreate: isInlineSiblingCreate = false })=>{
    const data = (0, $8Uumt.useFragment)((0, $aSL16.default), queryFragment);
    const column = (0, $8Uumt.useFragment)((0, $l4vU7.default), columnFragment);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const categoryFieldId = data.jira_categoryField?.fieldId ?? null;
    const { updateIssues: updateIssues, removeIssues: removeIssues } = (0, $gEtYC.useIssueStoreActions)();
    const fieldIdsToReturn = (0, $7OM52.useFieldIds)();
    const transformToIssues = (0, $hqsgn.useTransformIssues)();
    let allowedIssueTypeIds;
    if ((0, $6s1PB.expVal)('merge_board_workflows', 'enabled', false)) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const { workflows: workflows } = (0, $jgcJl.useWorkflowStoreState)();
        // eslint-disable-next-line react-hooks/rules-of-hooks
        allowedIssueTypeIds = (0, $5uXOq.useMemo)(()=>{
            if (column.__typename === 'JiraBoardViewStatusColumn') {
                const statusIds = new Set(column.statuses.map((status)=>status?.statusId).filter(Boolean));
                const issueTypeIds = [];
                workflows.forEach((workflow)=>{
                    // if any of the column statuses are in the workflow, add all issue types
                    if (workflow.columns.some((col)=>statusIds.has(String(col.statusId)))) workflow.issueTypes.forEach((issueType)=>issueTypeIds.push(issueType.id));
                });
                return issueTypeIds;
            }
            // if columns are not by status, allow all issue types
            return undefined;
        }, [
            column,
            workflows
        ]);
    } else {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const { issueTypes: issueTypes } = (0, $jgcJl.useWorkflowStoreState)();
        // eslint-disable-next-line react-hooks/rules-of-hooks
        allowedIssueTypeIds = (0, $5uXOq.useMemo)(()=>issueTypes.map((issueType)=>issueType.id), [
            issueTypes
        ]);
    }
    const onAddOptimisticIssue = (0, $5uXOq.useCallback)(()=>{
        // Only attempt to scroll to the last element after the optimistic issue is created
        scrollToLastElement && requestAnimationFrame(scrollToLastElement);
    }, [
        scrollToLastElement
    ]);
    const { isTopMost: isTopMost = false, isSiblingCreateFormOpen: isSiblingCreateFormOpen = false, issue: issue, prevIssueKey: prevIssueKey, toggleSiblingCreateForm: toggleSiblingCreateForm } = inlineSiblingCreateProps ?? {};
    const prepareIssueContext = (0, $5uXOq.useCallback)(()=>{
        const issueContext = {};
        if (issue) issueContext.rankBefore = {
            issueId: String(issue.id),
            rank: issue.fields[0, $cvj5l.RANK_ID].value
        };
        switch(column.__typename){
            case 'JiraBoardViewAssigneeColumn':
                if (!column.user) return issueContext;
                issueContext.assignee = {
                    accountId: column.user.accountId,
                    avatarUrl: column.user.picture,
                    displayName: column.user.name
                };
                break;
            case 'JiraBoardViewPriorityColumn':
                issueContext.priority = {
                    iconUrl: column.priority.iconUrl ?? '',
                    name: column.priority.name,
                    priorityId: column.priority.priorityId
                };
                break;
            case 'JiraBoardViewCategoryColumn':
                if (!column.category) return issueContext;
                issueContext.category = {
                    color: column.category.color?.colorKey || '',
                    optionId: column.category.optionId,
                    value: column.category.value
                };
                break;
            case 'JiraBoardViewStatusColumn':
                issueContext.status = {
                    name: column.statuses[0]?.name ?? '',
                    statusCategoryId: Number(column.statuses[0]?.statusCategory.statusCategoryId),
                    statusId: column.statuses[0]?.statusId ?? ''
                };
                break;
            default:
                break;
        }
        return issueContext;
    }, [
        column,
        issue
    ]);
    const handleSubmit = (0, $5uXOq.useCallback)(async ({ optimisticIssuePayload: optimisticIssuePayload, promise: promise })=>{
        const optimisticIssue = {
            id: optimisticIssuePayload.issueId,
            coverMedia: null,
            fields: {
                [(0, $cvj5l.ISSUE_TYPE_ID)]: {
                    id: optimisticIssuePayload.issueType.id,
                    fieldId: (0, $5fc53.ISSUE_TYPE),
                    type: (0, $cvj5l.BOARD_FIELD_ISSUE_TYPE),
                    issueType: {
                        id: optimisticIssuePayload.issueType.id,
                        name: optimisticIssuePayload.issueType.name,
                        iconUrl: optimisticIssuePayload.issueType.avatarUrl ?? '',
                        hierarchyLevel: optimisticIssuePayload.issueType.hierarchyLevel
                    }
                },
                [(0, $cvj5l.ISSUE_KEY_ID)]: {
                    fieldId: (0, $5fc53.ISSUE_KEY_TYPE),
                    type: (0, $cvj5l.BOARD_FIELD_TEXT),
                    value: ''
                },
                [(0, $cvj5l.STATUS_ID)]: {
                    fieldId: (0, $5fc53.STATUS_TYPE),
                    status: {
                        id: optimisticIssuePayload.status?.statusId ?? '',
                        name: optimisticIssuePayload.status?.name ?? '',
                        statusCategoryId: optimisticIssuePayload.status?.statusCategoryId ?? 2
                    },
                    type: (0, $cvj5l.BOARD_FIELD_STATUS),
                    value: optimisticIssuePayload.status?.statusId ?? '0'
                },
                [(0, $cvj5l.SUMMARY_ID)]: {
                    fieldId: (0, $5fc53.SUMMARY_TYPE),
                    type: (0, $cvj5l.BOARD_FIELD_TEXT),
                    value: optimisticIssuePayload.summary
                },
                [(0, $cvj5l.RANK_ID)]: {
                    fieldId: '',
                    type: (0, $cvj5l.BOARD_FIELD_TEXT),
                    value: optimisticIssuePayload.rank ?? 'z'
                }
            },
            subtaskMetadata: {
                done: 0,
                total: 0
            }
        };
        if (optimisticIssuePayload.assignee) optimisticIssue.fields[0, $cvj5l.ASSIGNEE_ID] = {
            fieldId: (0, $5fc53.ASSIGNEE_TYPE),
            type: (0, $cvj5l.BOARD_FIELD_USER),
            value: optimisticIssuePayload.assignee.accountId,
            user: {
                accountId: optimisticIssuePayload.assignee.accountId,
                avatarURL: optimisticIssuePayload.assignee.avatarUrl,
                name: optimisticIssuePayload.assignee.displayName
            }
        };
        if (optimisticIssuePayload.priority) optimisticIssue.fields[0, $cvj5l.PRIORITY_ID] = {
            fieldId: (0, $5fc53.PRIORITY_TYPE),
            type: (0, $cvj5l.BOARD_FIELD_PRIORITY),
            value: optimisticIssuePayload.priority.priorityId,
            priority: {
                id: optimisticIssuePayload.priority.priorityId,
                iconUrl: optimisticIssuePayload.priority.iconUrl,
                name: optimisticIssuePayload.priority.name
            }
        };
        if (optimisticIssuePayload.category && categoryFieldId && column.__typename === 'JiraBoardViewCategoryColumn') optimisticIssue.fields[0, $cvj5l.CATEGORY_ID] = {
            fieldId: categoryFieldId,
            type: (0, $cvj5l.BOARD_FIELD_CATEGORY),
            value: optimisticIssuePayload.category.optionId,
            category: {
                color: optimisticIssuePayload.category.color,
                name: optimisticIssuePayload.category.value
            }
        };
        if (optimisticIssuePayload.dueDate && (0, $6s1PB.expVal)('jira_powerful_inline_create_for_business_board', 'isEnabled', false)) optimisticIssue.fields[0, $cvj5l.DUE_DATE_ID] = {
            fieldId: (0, $5fc53.DUE_DATE_TYPE),
            type: (0, $cvj5l.BOARD_FIELD_DATE),
            value: (0, $k7m40.default)(optimisticIssuePayload.dueDate, 'yyyy-MM-dd')
        };
        updateIssues([
            optimisticIssue
        ]);
        onAddOptimisticIssue?.();
        let createdBoardItem;
        try {
            createdBoardItem = await promise;
        } catch (e) {
        // swallow error
        }
        if (createdBoardItem) {
            const issues = transformToIssues([
                createdBoardItem
            ]);
            updateIssues(issues);
        }
        removeIssues([
            optimisticIssue.id
        ]);
    }, [
        categoryFieldId,
        updateIssues,
        onAddOptimisticIssue,
        removeIssues,
        column,
        transformToIssues
    ]);
    const handleToggleForm = (0, $5uXOq.useCallback)((isFormVisible)=>{
        if (isFormVisible) scrollToLastElement?.();
    }, [
        scrollToLastElement
    ]);
    // prevents onBlur from being called before the click event is finished
    const handleTriggerMouseDown = (0, $5uXOq.useCallback)((e)=>{
        e.preventDefault();
    }, []);
    const openSiblingCreate = (0, $5uXOq.useCallback)(()=>issue?.id && toggleSiblingCreateForm?.(issue.id), [
        issue?.id,
        toggleSiblingCreateForm
    ]);
    const closeSiblingCreate = (0, $5uXOq.useCallback)(()=>toggleSiblingCreateForm?.(null), [
        toggleSiblingCreateForm
    ]);
    const shouldShowAdditionalFields = (0, $5uXOq.useCallback)(()=>(0, $dCm1o.isVisualRefreshEnabled)() && (0, $6s1PB.expVal)('jira_powerful_inline_create_for_business_board', 'isEnabled', false), []);
    const group = (0, $5uXOq.useMemo)(()=>{
        if (column.__typename !== 'JiraBoardViewAssigneeColumn') return null;
        return {
            fieldId: (0, $5fc53.ASSIGNEE_TYPE),
            ...column.user && {
                value: {
                    accountId: column.user.accountId,
                    avatarUrl: column.user.picture,
                    displayName: column.user.name
                }
            }
        };
    }, [
        column
    ]);
    const a11yLabel = prevIssueKey ? formatMessage((0, $li7DW.default).createSiblingIssueA11Y, {
        issueKey: prevIssueKey
    }) : formatMessage((0, $li7DW.default).createSiblingIssueAtTheTopOfColumnA11Y);
    if (isInlineSiblingCreate) return isSiblingCreateFormOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $c82e417ee56b19da$var$inlineFormWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iFFYo.default), {
        allowedIssueTypeIds: allowedIssueTypeIds,
        appearance: (0, $iFFYo.CARD_APPEARANCE),
        fieldIdsToReturn: fieldIdsToReturn,
        onPrepareIssueContext: prepareIssueContext,
        onSubmit: handleSubmit,
        location: "boardSibling",
        onBlur: closeSiblingCreate,
        shouldShowAdditionalFields: shouldShowAdditionalFields,
        group: group,
        popperStrategy: (0, $4R6GH.fg)('wanjel-a11y-enterprise-grade') ? 'fixed' : 'absolute'
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9ocZh.default), {
        direction: "row",
        onClick: openSiblingCreate,
        onMouseDown: handleTriggerMouseDown,
        label: (0, $4R6GH.fg)('wanjel-a11y-enterprise-grade') ? formatMessage((0, $li7DW.default).createSiblingIssue) : formatMessage((0, $li7DW.default).createSiblingIssueOld),
        "aria-label": a11yLabel,
        offset: $c82e417ee56b19da$var$INLINE_CREATE_TRIGGER_OFFSET,
        position: isTopMost ? 1 : -2
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $c82e417ee56b19da$var$wrapperStyles,
        testId: "work-management-board.ui.board.column.footer"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eNaDQ.default), {
        allowedIssueTypeIds: allowedIssueTypeIds,
        appearance: (0, $iFFYo.CARD_APPEARANCE),
        fieldIdsToReturn: fieldIdsToReturn,
        onPrepareIssueContext: prepareIssueContext,
        onSubmit: handleSubmit,
        location: "boardFooter",
        inlineCreateStyles: $c82e417ee56b19da$var$inlineCreateStyles,
        onToggleForm: handleToggleForm,
        shouldShowAdditionalFields: shouldShowAdditionalFields,
        group: group,
        allowIssueTypeConfiguration: (0, $4R6GH.fg)('jira_inline_create_issuetype_business_prereqs'),
        isInlineConfigExperimentEnabled: ()=>(0, $6s1PB.expVal)('jira_inline_create_edit_issuetype_business_board', 'isEnabled', false)
    }));
};
const $c82e417ee56b19da$var$wrapperStyles = (0, $8CUq3.xcss)({
    paddingLeft: 'space.050',
    paddingRight: 'space.050',
    paddingBottom: 'space.050'
});
const $c82e417ee56b19da$var$inlineFormWrapperStyles = (0, $8CUq3.xcss)({
    marginBottom: 'space.050'
});
var $c82e417ee56b19da$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($c82e417ee56b19da$var$BoardInlineCreate);

});
parcelRegister("l4vU7", function(module, exports) {

$parcel$export(module.exports, "default", () => $d324a98e7b4c3799$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e06ce07ac88e90d2f6eee9d89e596a19>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d324a98e7b4c3799$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "BoardInlineCreate_column",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "__typename"
                },
                "action": "THROW",
                "path": "__typename"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "JiraStatus",
                            "kind": "LinkedField",
                            "name": "statuses",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": v0 /*: any*/ ,
                                    "action": "THROW",
                                    "path": "statuses.name"
                                },
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "kind": "ScalarField",
                                        "name": "statusId"
                                    },
                                    "action": "THROW",
                                    "path": "statuses.statusId"
                                },
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "concreteType": "JiraStatusCategory",
                                        "kind": "LinkedField",
                                        "name": "statusCategory",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": {
                                                    "kind": "ScalarField",
                                                    "name": "statusCategoryId"
                                                },
                                                "action": "THROW",
                                                "path": "statuses.statusCategory.statusCategoryId"
                                            }
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "statuses.statusCategory"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "statuses"
                    }
                ],
                "type": "JiraBoardViewStatusColumn"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "JiraPriority",
                            "kind": "LinkedField",
                            "name": "priority",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": v0 /*: any*/ ,
                                    "action": "THROW",
                                    "path": "priority.name"
                                },
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "kind": "ScalarField",
                                        "name": "priorityId"
                                    },
                                    "action": "THROW",
                                    "path": "priority.priorityId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "iconUrl"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "priority"
                    }
                ],
                "type": "JiraBoardViewPriorityColumn"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": v0 /*: any*/ ,
                                "action": "THROW",
                                "path": "user.name"
                            },
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "kind": "ScalarField",
                                    "name": "accountId"
                                },
                                "action": "THROW",
                                "path": "user.accountId"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "picture"
                            }
                        ]
                    }
                ],
                "type": "JiraBoardViewAssigneeColumn"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraOption",
                        "kind": "LinkedField",
                        "name": "category",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "kind": "ScalarField",
                                    "name": "value"
                                },
                                "action": "THROW",
                                "path": "category.value"
                            },
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "kind": "ScalarField",
                                    "name": "optionId"
                                },
                                "action": "THROW",
                                "path": "category.optionId"
                            },
                            {
                                "concreteType": "JiraColor",
                                "kind": "LinkedField",
                                "name": "color",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "colorKey"
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "type": "JiraBoardViewCategoryColumn"
            }
        ],
        "type": "JiraBoardViewColumn",
        "abstractKey": "__isJiraBoardViewColumn"
    };
}();
$d324a98e7b4c3799$var$node.hash = "03401b9f93c13be3dd0237d7e3cd36b6";
var $d324a98e7b4c3799$export$2e2bcd8739ae039 = $d324a98e7b4c3799$var$node;

});

parcelRegister("aSL16", function(module, exports) {

$parcel$export(module.exports, "default", () => $48ac8467b5cb88c2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0c317082b607e918ab039971c20c5d86>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $48ac8467b5cb88c2$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "cloudId"
        }
    ],
    "kind": "Fragment",
    "name": "BoardInlineCreate_query",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                }
            ],
            "concreteType": "JiraJqlField",
            "kind": "LinkedField",
            "name": "jira_categoryField",
            "plural": false,
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "kind": "ScalarField",
                        "name": "fieldId"
                    },
                    "action": "THROW",
                    "path": "jira_categoryField.fieldId"
                }
            ]
        }
    ],
    "type": "Query"
};
$48ac8467b5cb88c2$var$node.hash = "4dfc27c25aea596e27407b31fa9c26db";
var $48ac8467b5cb88c2$export$2e2bcd8739ae039 = $48ac8467b5cb88c2$var$node;

});

parcelRegister("eNaDQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $c99115eac966aea2$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $iFFYo = parcelRequire("iFFYo");

var $9hZ86 = parcelRequire("9hZ86");
const $c99115eac966aea2$var$InlineCreate = ({ allowedIssueTypeIds: allowedIssueTypeIds, appearance: appearance, fieldIdsToReturn: fieldIdsToReturn, inlineCreateStyles: inlineCreateStyles, isCompact: isCompact, location: location, maxHierarchyLevel: maxHierarchyLevel, minHierarchyLevel: minHierarchyLevel, onBlur: onBlur, onPrepareIssueContext: onPrepareIssueContext, onSubmit: onSubmit, onToggleForm: onToggleForm, isOpenByDefault: isOpenByDefault = false, popperStrategy: popperStrategy, allowIssueTypeConfiguration: allowIssueTypeConfiguration, onIssueTypeConfigured: onIssueTypeConfigured, shouldShowAdditionalFields: shouldShowAdditionalFields, additionalFieldProps: additionalFieldProps, isCompactCreateButton: isCompactCreateButton, group: group, isInlineConfigExperimentEnabled: isInlineConfigExperimentEnabled })=>{
    const [isFormVisible, setIsFormVisible] = (0, $5uXOq.useState)(isOpenByDefault);
    const showForm = (0, $5uXOq.useCallback)(()=>{
        setIsFormVisible(true);
        onToggleForm?.(true);
    }, [
        onToggleForm
    ]);
    const hideForm = (0, $5uXOq.useCallback)(()=>{
        setIsFormVisible(false);
        onToggleForm?.(false);
    }, [
        onToggleForm
    ]);
    const handleBlur = (0, $5uXOq.useCallback)(()=>{
        hideForm();
        onBlur?.();
    }, [
        hideForm,
        onBlur
    ]);
    return isFormVisible ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iFFYo.default), {
        allowedIssueTypeIds: allowedIssueTypeIds,
        appearance: appearance,
        fieldIdsToReturn: fieldIdsToReturn,
        isCompact: isCompact,
        location: location,
        maxHierarchyLevel: maxHierarchyLevel,
        minHierarchyLevel: minHierarchyLevel,
        onBlur: handleBlur,
        onPrepareIssueContext: onPrepareIssueContext,
        onSubmit: onSubmit,
        popperStrategy: popperStrategy,
        allowIssueTypeConfiguration: allowIssueTypeConfiguration,
        onIssueTypeConfigured: onIssueTypeConfigured,
        shouldShowAdditionalFields: shouldShowAdditionalFields,
        additionalFieldProps: additionalFieldProps,
        isCompactCreateButton: isCompactCreateButton,
        group: group,
        isInlineConfigExperimentEnabled: isInlineConfigExperimentEnabled,
        ...inlineCreateStyles
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9hZ86.default), {
        onClick: showForm,
        ...inlineCreateStyles
    });
};
const $c99115eac966aea2$var$genericMemo = (0, $5uXOq.memo);
var $c99115eac966aea2$export$2e2bcd8739ae039 = $c99115eac966aea2$var$genericMemo($c99115eac966aea2$var$InlineCreate);

});
parcelRegister("iFFYo", function(module, exports) {

$parcel$export(module.exports, "CARD_APPEARANCE", () => $da27b835be8eb6e3$export$2e234a0f40160716);
$parcel$export(module.exports, "ROW_APPEARANCE", () => $da27b835be8eb6e3$export$e99c52f52501386d);
$parcel$export(module.exports, "default", () => $da27b835be8eb6e3$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $fVnbM = parcelRequire("fVnbM");

var $eCeGD = parcelRequire("eCeGD");
var $42CjB = parcelRequire("42CjB");

var $c8Oei = parcelRequire("c8Oei");

var $kgoHi = parcelRequire("kgoHi");
var $5ILhZ = parcelRequire("5ILhZ");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $bChGW = parcelRequire("bChGW");
var $b9dFI = parcelRequire("b9dFI");

var $eZJjh = parcelRequire("eZJjh");

var $3bDjY = parcelRequire("3bDjY");

var $jldZL = parcelRequire("jldZL");

var $daQYX = parcelRequire("daQYX");

var $1T2vX = parcelRequire("1T2vX");

var $cm8b5 = parcelRequire("cm8b5");

var $x8FYU = parcelRequire("x8FYU");

var $1kpI8 = parcelRequire("1kpI8");

var $l4Ejo = parcelRequire("l4Ejo");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");


var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $dCm1o = parcelRequire("dCm1o");

var $jSQ0a = parcelRequire("jSQ0a");

var $5fc53 = parcelRequire("5fc53");

var $x9xyg = parcelRequire("x9xyg");

var $fhSLy = parcelRequire("fhSLy");

var $1XJ20 = parcelRequire("1XJ20");

var $8OpiR = parcelRequire("8OpiR");

var $8roPX = parcelRequire("8roPX");

var $33Toe = parcelRequire("33Toe");

var $6uB1c = parcelRequire("6uB1c");

var $t9aRF = parcelRequire("t9aRF");

var $9ngzl = parcelRequire("9ngzl");

const $da27b835be8eb6e3$var$GENERIC_ICON_URL = '/icons/issuetypes/genericissue.svg';
const $da27b835be8eb6e3$export$2e234a0f40160716 = 'CARD';
const $da27b835be8eb6e3$export$e99c52f52501386d = 'ROW';
const $da27b835be8eb6e3$var$ISSUE_TYPE = 'issueType';
const $da27b835be8eb6e3$export$ff02df9cc4e9618e = ({ group: group, assignee: assignee })=>{
    if (assignee !== undefined || !group) return assignee;
    if (group?.fieldId !== (0, $5fc53.ASSIGNEE_TYPE) || !group?.value) return assignee;
    const assigneeData = group.value;
    return (0, $fhSLy.getUserShape)(assigneeData.accountId, assigneeData.displayName, assigneeData.avatarUrl);
};
const $da27b835be8eb6e3$export$35cad9398ceaeef0 = ()=>{
    const isReadyRef = (0, $5uXOq.useRef)(false);
    (0, $5uXOq.useEffect)(()=>{
        setTimeout(()=>{
            isReadyRef.current = true;
        }, 100);
    }, []);
    return isReadyRef;
};
const $da27b835be8eb6e3$var$useExperience = (location)=>(0, $5uXOq.useMemo)(()=>{
        let experienceId;
        switch(location){
            case 'listFooter':
            case 'listSibling':
            case 'listGroup':
            case 'listHierarchy':
                experienceId = 'list';
                break;
            case 'boardFooter':
            case 'boardSibling':
                experienceId = 'board';
                break;
            case 'calendarDate':
                experienceId = 'calendar';
                break;
            case 'timelineFooter':
            case 'timelineSibling':
            case 'timelineHierarchy':
                experienceId = 'timeline';
                break;
            default:
                throw new Error(`Unknown location ${location}`);
        }
        return {
            ...(0, $8OpiR.CREATE_ISSUE_EXPERIENCE),
            experienceId: experienceId
        };
    }, [
        location
    ]);
const $da27b835be8eb6e3$var$Group = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($da27b835be8eb6e3$var$ExtraLinksGroup, null, children);
};
const $da27b835be8eb6e3$var$Option = ({ children: children, ...props })=>{
    if (props.data.optionType === $da27b835be8eb6e3$var$ISSUE_TYPE) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).Option, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($da27b835be8eb6e3$var$OptionWrapper, {
        "data-testid": "business-issue-create.ui.inline-create-form.option"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($da27b835be8eb6e3$var$OptionTypeIcon, {
        src: props.data.issueType.avatarUrl ?? $da27b835be8eb6e3$var$GENERIC_ICON_URL,
        alt: ""
    }), children));
};
const $da27b835be8eb6e3$var$isComposing = (event)=>event.nativeEvent.isComposing;
const $da27b835be8eb6e3$var$ChevronDownIcon = ()=>{
    if ((0, $dCm1o.isVisualRefreshEnabled)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c8Oei))), {
        label: "",
        color: "var(--ds-icon, #44546F)"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c8Oei))), {
        spacing: "spacious",
        label: ""
    });
};
const $da27b835be8eb6e3$var$InlineCreateForm = ({ allowedIssueTypeIds: allowedIssueTypeIds, appearance: appearance, borderRadius: borderRadius, fieldIdsToReturn: fieldIdsToReturn = [], indent: indent, isCompact: isCompact, location: location, maxHierarchyLevel: maxHierarchyLevel = Number.POSITIVE_INFINITY, minHeight: minHeight, minHierarchyLevel: minHierarchyLevel = 0, onBlur: onBlur, onKeyDown: onKeyDown, onPrepareIssueContext: onPrepareIssueContext, onSubmit: onSubmit, popperStrategy: popperStrategy = 'absolute', allowIssueTypeConfiguration: allowIssueTypeConfiguration, onIssueTypeConfigured: onIssueTypeConfigured, shouldShowAdditionalFields: shouldShowAdditionalFields = ()=>false, additionalFieldProps: additionalFieldProps, additionalFooterContent: additionalFooterContent, group: group, shouldSubmitOnBlur: shouldSubmitOnBlur = true, placeholderOverride: placeholderOverride, isCompactCreateButton: isCompactCreateButton, isInlineConfigExperimentEnabled: isInlineConfigExperimentEnabled, isChildComponentOpen: isChildComponentOpen })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { data: { issueTypes: issueTypes }, loading: loading } = (0, $1T2vX.useIssueTypesAndFields)({
        issueOperation: 'CREATE'
    });
    if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($da27b835be8eb6e3$var$FullContent, {
        appearance: appearance,
        borderRadius: borderRadius,
        indent: indent,
        minHeight: minHeight
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        alignItems: "center",
        justifyContent: "center",
        xcss: $da27b835be8eb6e3$var$spinnerWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
        label: formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $6uB1c.default).loadingIssueCreateFormIssueTermRefresh : (0, $6uB1c.default).loadingIssueCreateForm)
    })));
     // this is not a scenario we expect to happen but we know it does happen when a project is just created
    // the issue types and fields have a retry mechanism to avoid this but we want to handle it here as well
    // to avoid runtime errors
    if (issueTypes.length === 0) throw new Error('Unable to show the issue create form, no issue types available');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($da27b835be8eb6e3$var$InlineCreateFormInternal, {
        allowedIssueTypeIds: allowedIssueTypeIds,
        appearance: appearance,
        borderRadius: borderRadius,
        fieldIdsToReturn: fieldIdsToReturn,
        indent: indent,
        isCompact: isCompact,
        issueTypes: issueTypes,
        location: location,
        maxHierarchyLevel: maxHierarchyLevel,
        minHeight: minHeight,
        minHierarchyLevel: minHierarchyLevel,
        onBlur: onBlur,
        onKeyDown: onKeyDown,
        onPrepareIssueContext: onPrepareIssueContext,
        onSubmit: onSubmit,
        popperStrategy: popperStrategy,
        allowIssueTypeConfiguration: allowIssueTypeConfiguration,
        onIssueTypeConfigured: onIssueTypeConfigured,
        shouldShowAdditionalFields: shouldShowAdditionalFields,
        additionalFieldProps: additionalFieldProps,
        additionalFooterContent: additionalFooterContent,
        group: group,
        placeholderOverride: placeholderOverride,
        shouldSubmitOnBlur: shouldSubmitOnBlur,
        isCompactCreateButton: isCompactCreateButton,
        isInlineConfigExperimentEnabled: isInlineConfigExperimentEnabled,
        isChildComponentOpen: isChildComponentOpen
    });
};
const $da27b835be8eb6e3$var$InlineCreateFormInternal = ({ allowedIssueTypeIds: allowedIssueTypeIds, appearance: appearance, borderRadius: borderRadius, fieldIdsToReturn: fieldIdsToReturn = [], indent: indent, isCompact: isCompact, issueTypes: issueTypes, location: location, maxHierarchyLevel: maxHierarchyLevel = Number.POSITIVE_INFINITY, minHeight: minHeight, minHierarchyLevel: minHierarchyLevel = 0, onBlur: onBlur, onKeyDown: onKeyDown, onPrepareIssueContext: onPrepareIssueContext, onSubmit: onSubmit, popperStrategy: popperStrategy = 'absolute', allowIssueTypeConfiguration: allowIssueTypeConfiguration = false, shouldShowAdditionalFields: shouldShowAdditionalFields = ()=>false, additionalFieldProps: additionalFieldProps = {
    shouldShowNameLabel: true,
    isCompactDueDatePicker: false,
    shouldHideDueDatePicker: false,
    shouldHideAssigneePicker: false
}, onIssueTypeConfigured: onIssueTypeConfigured, additionalFooterContent: additionalFooterContent, group: group, shouldSubmitOnBlur: shouldSubmitOnBlur = false, placeholderOverride: placeholderOverride, isCompactCreateButton: isCompactCreateButton = false, isInlineConfigExperimentEnabled: isInlineConfigExperimentEnabled, isChildComponentOpen: isChildComponentOpen = false })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const project = (0, $daQYX.useProject)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { jql: jql } = (0, $l4Ejo.useFiltersPreference)();
    const [sorting] = (0, $1kpI8.useViewPreference)((0, $x8FYU.SORTING_PREFERENCE));
    const [preferredIssueTypeId, savePreferredIssueTypeId] = (0, $1kpI8.useViewPreference)((0, $x8FYU.CREATE_TYPE_ID_PREFERENCE));
    const showSuccessFlag = jql != null || sorting != null;
    const experience = $da27b835be8eb6e3$var$useExperience(location);
    const startExperience = (0, $cm8b5.useExperienceStart)(experience);
    const markExperienceSuccess = (0, $cm8b5.useExperienceSuccess)(experience);
    const markExperienceFail = (0, $cm8b5.useExperienceFail)(experience);
    const abortExperience = (0, $cm8b5.useExperienceAbort)(experience);
    const previousIsChildComponentOpen = (0, $4R6GH.fg)('aiwb_list_view_fast_follow') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $1XJ20.usePrevious)(isChildComponentOpen) : undefined;
    const issueTypeOptions = (0, $5uXOq.useMemo)(()=>{
        const validIssueTypes = issueTypes.filter((issueType)=>{
            const isAllowed = allowedIssueTypeIds?.includes(issueType.id) ?? true;
            return isAllowed && issueType.hierarchyLevel >= minHierarchyLevel && issueType.hierarchyLevel <= maxHierarchyLevel;
        });
        const typeOptions = validIssueTypes.map((issueType)=>({
                label: issueType.name,
                value: issueType.id,
                issueType: issueType,
                optionType: $da27b835be8eb6e3$var$ISSUE_TYPE
            }));
        typeOptions.sort(// sort by decreasing hierarchy level
        (a, b)=>b.issueType.hierarchyLevel - a.issueType.hierarchyLevel);
        return typeOptions;
    }, [
        allowedIssueTypeIds,
        issueTypes,
        maxHierarchyLevel,
        minHierarchyLevel
    ]);
    const { administerProject: canManageTypes, assignIssues: canAssignIssues = false, scheduleIssues: canScheduleIssues = false } = project.permissions;
    const isTMPProject = project.isSimplified;
    const projectKey = project.key;
    const options = (0, $5uXOq.useMemo)(()=>{
        return [
            ...issueTypeOptions
        ];
    }, [
        issueTypeOptions
    ]);
    const { summaryRef: summaryRef, submit: submit, blur: blur } = (0, $33Toe.useCreateIssue)(onSubmit, onBlur);
    const [selectedType, setSelectedType] = (0, $5uXOq.useState)(()=>{
        if (preferredIssueTypeId) {
            const defaultIssueType = issueTypeOptions.find((issueType)=>issueType.value === preferredIssueTypeId);
            if (defaultIssueType) return defaultIssueType;
        } // Returns the first issue type with hierarchy level of zero if there is no last used issue type
        if (minHierarchyLevel === 0) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return issueTypeOptions.find((option)=>option.issueType.hierarchyLevel === 0) ?? options[0];
         // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return options[0];
    });
    const [textContent, setTextContent] = (0, $5uXOq.useState)(summaryRef.current);
    summaryRef.current = textContent;
    const formRef = (0, $5uXOq.useRef)(null);
    const popperRef = (0, $5uXOq.useRef)(null);
    const isEmptyRef = (0, $5uXOq.useRef)(true);
    const textAreaRef = (0, $5uXOq.useRef)(null);
    const selectRef = (0, $5uXOq.useRef)(null);
    isEmptyRef.current = textContent.trim().length === 0; // assignee would be undefined initially, when user selects unassigned user from picker then it will be null
    const [assignee, setAssignee] = (0, $5uXOq.useState)(undefined);
    const [dueDate, setDueDate] = (0, $5uXOq.useState)(null);
    const defaultAssignee = $da27b835be8eb6e3$export$ff02df9cc4e9618e({
        group: group,
        assignee: assignee
    });
    const { typesWithFields: typesWithFields } = (0, $1T2vX.useIssueTypesAndFields)({
        issueOperation: 'CREATE'
    });
    const isDueDateFieldLinked = (0, $5uXOq.useMemo)(()=>typesWithFields.find(({ issueType: issueType })=>issueType.id === selectedType.issueType.id)?.fields.some((field)=>field.id === (0, $5fc53.DUE_DATE_TYPE)), [
        selectedType.issueType.id,
        typesWithFields
    ]);
    const isAssigneeFieldLinked = (0, $5uXOq.useMemo)(()=>typesWithFields.find(({ issueType: issueType })=>issueType.id === selectedType.issueType.id)?.fields.some((field)=>field.id === (0, $5fc53.ASSIGNEE_TYPE)), [
        selectedType.issueType.id,
        typesWithFields
    ]);
    const shouldShowDueDatePicker = !additionalFieldProps.shouldHideDueDatePicker && canScheduleIssues && isDueDateFieldLinked;
    const shouldShowAssigneePicker = !additionalFieldProps.shouldHideAssigneePicker && canAssignIssues && isAssigneeFieldLinked;
    const resetAssigneeAndDueDate = (0, $5uXOq.useCallback)(()=>{
        const isEligibleToShowAdditionalFields = shouldShowAssigneePicker || shouldShowDueDatePicker;
        if (!(isEligibleToShowAdditionalFields && shouldShowAdditionalFields())) return;
        if (shouldShowAssigneePicker) setAssignee(undefined);
        if (shouldShowDueDatePicker) setDueDate(null);
    }, [
        shouldShowAssigneePicker,
        shouldShowDueDatePicker,
        shouldShowAdditionalFields
    ]);
    const handleCreateIssue = ()=>{
        if (!isEmptyRef.current && selectedType.optionType === $da27b835be8eb6e3$var$ISSUE_TYPE) {
            const issueType = issueTypes.find((type)=>type.id === selectedType.value);
            startExperience();
            let timeMsSinceFocus; // TODO: WOLVES-1917 remove timeMsSinceFocus once metric no longer needed
            if ((0, $4R6GH.fg)('jira_list_view_inline_create_form_focus_time')) {
                (0, $x9xyg.setMark)((0, $838746bcc70be259$export$e1682a3dbec77762));
                (0, $x9xyg.setMeasure)((0, $838746bcc70be259$export$94554a43bdc62f9f), (0, $838746bcc70be259$export$3c53e2610a4054e2), (0, $838746bcc70be259$export$e1682a3dbec77762)); // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                const marks = performance.getEntriesByName((0, $838746bcc70be259$export$94554a43bdc62f9f)) || [];
                const currentMark = marks.length > 0 ? marks[marks.length - 1] : null;
                timeMsSinceFocus = currentMark && Math.round(currentMark.duration); // reuse the start marker as once a user has submitted an issue to create,
                // they can stay on the text area and enter text for the next issue to create...
                // so set the marker again.
                (0, $x9xyg.setMark)((0, $838746bcc70be259$export$3c53e2610a4054e2));
            }
            const selectedAssignee = canAssignIssues && assignee != null && shouldShowAdditionalFields() ? {
                assignee: {
                    accountId: assignee?.accountId ?? '',
                    avatarUrl: assignee?.avatarUrls['48x48'] ?? '',
                    displayName: assignee?.displayName
                }
            } : {};
            const issueContext = onPrepareIssueContext?.();
            const { assignee: assigneeContext, ...restIssueContext } = issueContext ?? {};
            const result = submit({
                input: {
                    summary: textContent.trim(),
                    projectId: String(project.id),
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    issueType: issueType,
                    ...restIssueContext,
                    ...shouldShowAssigneePicker && shouldShowAdditionalFields() ? selectedAssignee : {
                        assignee: assigneeContext
                    },
                    ...shouldShowDueDatePicker && shouldShowAdditionalFields() && dueDate !== null ? {
                        dueDate: dueDate
                    } : {}
                },
                fieldIdsToReturn: fieldIdsToReturn,
                location: location,
                showSuccessFlag: showSuccessFlag,
                timeMsSinceFocus: timeMsSinceFocus
            });
            setTextContent('');
            resetAssigneeAndDueDate();
            result.promise.then(()=>markExperienceSuccess()).catch((error)=>{
                if (error instanceof (0, $8roPX.CancelledError)) abortExperience('User cancelled');
                else markExperienceFail('Failed to create issue', error);
            });
        }
    };
    const handleCreateIssueRef = (0, $5uXOq.useRef)(handleCreateIssue);
    handleCreateIssueRef.current = handleCreateIssue;
    const handleChangeOption = (0, $5uXOq.useCallback)((option)=>{
        if (option?.optionType === $da27b835be8eb6e3$var$ISSUE_TYPE) {
            setIsPopupSelectOpen(false);
            setSelectedType(option);
            savePreferredIssueTypeId(option.value);
        }
    }, [
        savePreferredIssueTypeId
    ]); // prevent blurring from occurring when the form is first rendered
    const isReadyRef = $da27b835be8eb6e3$export$35cad9398ceaeef0();
    const [isConfiguringIssueType, setIsConfiguringIssueType] = (0, $5uXOq.useState)(false);
    const [isUpdatingAssigneePicker, setIsUpdatingAssigneePicker] = (0, $5uXOq.useState)(false);
    const [isUpdatingDueDatePicker, setIsUpdatingDueDatePicker] = (0, $5uXOq.useState)(false);
    const handleBlur = (0, $5uXOq.useCallback)((event)=>{
        if (!isReadyRef.current) return;
         // make sure to make a local copy of the isEmptyRef value before it gets reset by the create handler
        const formEmpty = isEmptyRef.current; // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const inForm = formRef.current?.contains(event.target) ?? false; // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const inPopper = popperRef.current?.contains(event.target) ?? false;
        if (!inForm && !inPopper && !isConfiguringIssueType && !isUpdatingAssigneePicker && !isUpdatingDueDatePicker && shouldSubmitOnBlur) {
            handleCreateIssueRef.current();
            setIsPopupSelectOpen(false);
            blur();
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'form blurred', 'inlineCreate', {
                location: location,
                formEmpty: formEmpty,
                escapeKeyPressed: false
            });
        }
    }, [
        blur,
        createAnalyticsEvent,
        isConfiguringIssueType,
        isReadyRef,
        isUpdatingAssigneePicker,
        isUpdatingDueDatePicker,
        location,
        shouldSubmitOnBlur
    ]);
    const [isPopupSelectOpen, setIsPopupSelectOpen] = (0, $5uXOq.useState)(false);
    const getIssueTypeButtonOnVisualRefresh = (0, $5uXOq.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (triggerProps)=>(0, $4R6GH.fg)('issue_types_dropdown_redesign') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5ILhZ.default), {
            ...triggerProps,
            testId: "business-issue-create.ui.inline-create-form.issue-type-trigger",
            onClick: ()=>setIsPopupSelectOpen(!isPopupSelectOpen),
            xcss: $da27b835be8eb6e3$var$issueTypeButtonWrapperStyles,
            "aria-label": formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $6uB1c.default).selectIssueTypeButtonIssueTermRefresh : (0, $6uB1c.default).selectIssueTypeButton, {
                issueType: selectedType.label
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
            alignItems: "center",
            justifyContent: "center",
            gap: "space.075"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("img", {
            src: selectedType.issueType.avatarUrl ?? undefined,
            alt: "",
            height: 16,
            width: 16
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($da27b835be8eb6e3$var$ChevronDownIcon, null))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
            ...triggerProps,
            appearance: "subtle",
            testId: "business-issue-create.ui.inline-create-form.issue-type-trigger",
            spacing: "compact",
            "aria-label": formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $6uB1c.default).selectIssueTypeButtonIssueTermRefresh : (0, $6uB1c.default).selectIssueTypeButton, {
                issueType: selectedType.label
            }),
            onClick: ()=>setIsPopupSelectOpen(!isPopupSelectOpen)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
            alignItems: "center",
            justifyContent: "center",
            gap: "space.075",
            xcss: $da27b835be8eb6e3$var$issueTypeButtonStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("img", {
            src: selectedType.issueType.avatarUrl ?? undefined,
            alt: "",
            height: 16,
            width: 16
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($da27b835be8eb6e3$var$ChevronDownIcon, null))), [
        formatMessage,
        isPopupSelectOpen,
        selectedType.issueType.avatarUrl,
        selectedType.label
    ]);
    const issueTypeButton = (0, $5uXOq.useCallback)(// PopupSelectTriggerProps is not exported from @atlaskit/select
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (triggerProps)=>(0, $dCm1o.isVisualRefreshEnabled)() ? getIssueTypeButtonOnVisualRefresh(triggerProps) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($da27b835be8eb6e3$var$StyledButton, {
            ...triggerProps,
            "aria-label": formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $6uB1c.default).selectIssueTypeButtonIssueTermRefresh : (0, $6uB1c.default).selectIssueTypeButton, {
                issueType: selectedType.label
            }),
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("img", {
                src: selectedType.issueType.avatarUrl ?? undefined,
                alt: "",
                height: 16,
                width: 16
            }),
            iconAfter: isCompact ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($da27b835be8eb6e3$var$ChevronDownWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($da27b835be8eb6e3$var$ChevronDownIcon, null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($da27b835be8eb6e3$var$ChevronDownIcon, null),
            spacing: "compact",
            testId: "business-issue-create.ui.inline-create-form.issue-type-trigger",
            onClick: ()=>setIsPopupSelectOpen(!isPopupSelectOpen)
        }, !isCompact && selectedType.label), [
        formatMessage,
        isCompact,
        isPopupSelectOpen,
        selectedType.issueType.avatarUrl,
        selectedType.label,
        getIssueTypeButtonOnVisualRefresh
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // on mount, we want to move the cursor to the end of the input
        textAreaRef.current?.setSelectionRange(textAreaRef.current.value.length, textAreaRef.current.value.length);
        if ((0, $4R6GH.fg)('jira_list_view_inline_create_form_focus_time')) (0, $x9xyg.setMark)((0, $838746bcc70be259$export$3c53e2610a4054e2));
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'form focused', 'inlineCreate', {
            location: location
        });
    }, [
        createAnalyticsEvent,
        location
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.addEventListener('click', handleBlur, true);
        return ()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.removeEventListener('click', handleBlur, true);
        };
    }, [
        handleBlur
    ]); // Refocus to the Select component after create/edit issue type modal is closed
    const refocusRef = (0, $5uXOq.useRef)();
    (0, $5uXOq.useEffect)(()=>{
        if (refocusRef && (0, $4R6GH.fg)('fix_refocus_issue_after_modal_close_on_list_view')) return ()=>clearTimeout(refocusRef?.current);
    }, [
        refocusRef
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (assignee === undefined) setAssignee(defaultAssignee);
    }, [
        assignee,
        defaultAssignee
    ]);
    const inlineIssueTypeCreateProps = (0, $5uXOq.useMemo)(()=>{
        const onCreateIssueTypeClick = ()=>{
            setIsConfiguringIssueType(true);
            setIsPopupSelectOpen(false);
        };
        const onCreateIssueTypeClose = ()=>{
            setIsConfiguringIssueType(false);
            if ((0, $4R6GH.fg)('fix_refocus_issue_after_modal_close_on_list_view')) refocusRef.current = setTimeout(()=>{
                selectRef.current?.targetRef?.blur();
                selectRef.current?.targetRef?.focus();
            }, (0, $838746bcc70be259$export$34934e4a629b9612));
            else setTimeout(()=>{
                selectRef.current?.targetRef?.blur();
                selectRef.current?.targetRef?.focus();
            }, (0, $838746bcc70be259$export$34934e4a629b9612));
        };
        const onEditIssueTypeClick = ()=>{
            setIsConfiguringIssueType(true);
            setIsPopupSelectOpen(false);
        };
        const onEditIssueTypeClose = ()=>{
            setIsConfiguringIssueType(false);
            if ((0, $4R6GH.fg)('fix_refocus_issue_after_modal_close_on_list_view')) refocusRef.current = setTimeout(()=>{
                selectRef.current?.targetRef?.blur();
                selectRef.current?.targetRef?.focus();
            }, (0, $838746bcc70be259$export$34934e4a629b9612));
            else setTimeout(()=>{
                selectRef.current?.targetRef?.blur();
                selectRef.current?.targetRef?.focus();
            }, (0, $838746bcc70be259$export$34934e4a629b9612));
        };
        return {
            isOpen: isPopupSelectOpen,
            onKeyDown: (event)=>{
                if (event.key === 'Escape') // handle PopupSelect close on escape when experiment is ON
                setIsPopupSelectOpen(false);
            },
            footer: canManageTypes && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9ngzl.SelectFooter), {
                onIssueTypeConfigured: onIssueTypeConfigured,
                onCreateIssueTypeClick: onCreateIssueTypeClick,
                onCreateIssueTypeClose: onCreateIssueTypeClose,
                allowIssueTypeConfiguration: allowIssueTypeConfiguration && isTMPProject,
                isInlineConfigExperimentEnabled: isInlineConfigExperimentEnabled,
                onEditIssueTypeClick: onEditIssueTypeClick,
                onEditIssueTypeClose: onEditIssueTypeClose,
                issueType: selectedType.issueType,
                issueTypes: issueTypes
            }),
            shouldCloseMenuOnTab: false
        };
    }, [
        isPopupSelectOpen,
        canManageTypes,
        onIssueTypeConfigured,
        allowIssueTypeConfiguration,
        isTMPProject,
        isInlineConfigExperimentEnabled,
        selectedType.issueType,
        issueTypes
    ]);
    const issueTypesSelect = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b9dFI.default), {
            onMenuOpen: ()=>{
                (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'select opened', 'inlineCreateIssueTypes', {
                    location: location
                });
            },
            components: {
                Option: $da27b835be8eb6e3$var$Option,
                Group: $da27b835be8eb6e3$var$Group
            },
            searchThreshold: 10,
            options: options,
            onChange: handleChangeOption,
            popperProps: {
                strategy: popperStrategy,
                innerRef: popperRef
            },
            value: selectedType,
            target: ({ isOpen: isOpen, ...triggerProps })=>isCompact || (appearance === $da27b835be8eb6e3$export$e99c52f52501386d || appearance === $da27b835be8eb6e3$export$2e234a0f40160716 && (0, $4R6GH.fg)('issue_types_dropdown_redesign')) && (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
                    content: selectedType.label
                }, issueTypeButton(triggerProps)) : issueTypeButton(triggerProps),
            ref: selectRef,
            ...inlineIssueTypeCreateProps
        }), [
        appearance,
        createAnalyticsEvent,
        handleChangeOption,
        inlineIssueTypeCreateProps,
        isCompact,
        issueTypeButton,
        location,
        options,
        popperStrategy,
        selectedType
    ]);
    const getRowHeader = (0, $5uXOq.useCallback)(()=>{
        if ((0, $dCm1o.isVisualRefreshEnabled)()) return issueTypesSelect;
        if (!isCompact) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($da27b835be8eb6e3$var$IssueTypeIcon, {
            alt: "",
            src: selectedType.issueType.avatarUrl ?? $da27b835be8eb6e3$var$GENERIC_ICON_URL
        });
        return null;
    }, [
        isCompact,
        issueTypesSelect,
        selectedType
    ]);
    if ((0, $4R6GH.fg)('aiwb_list_view_fast_follow')) // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5uXOq.useEffect)(()=>{
        if (!isChildComponentOpen && previousIsChildComponentOpen) refocusRef.current = setTimeout(()=>{
            textAreaRef.current?.blur();
            textAreaRef.current?.focus();
        }, (0, $838746bcc70be259$export$34934e4a629b9612));
    }, [
        isChildComponentOpen,
        previousIsChildComponentOpen
    ]);
    const styledTextAreaAccessibilityProps = {
        'aria-label': formatMessage((0, $6uB1c.default).createIssueInputLabel),
        'aria-describedby': 'business-issue-create.ui.inline-create-form.textarea-with-description'
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($da27b835be8eb6e3$var$FullContent, {
        appearance: appearance,
        borderRadius: borderRadius,
        indent: indent,
        minHeight: minHeight,
        onKeyDown: (event)=>{
            if (!isChildComponentOpen || !(0, $4R6GH.fg)('aiwb_list_view_fast_follow')) {
                event.stopPropagation();
                if (event.key === 'Escape' && !$da27b835be8eb6e3$var$isComposing(event)) {
                    blur(event);
                    (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'form blurred', 'inlineCreate', {
                        location: location,
                        formEmpty: isEmptyRef.current,
                        escapeKeyPressed: true
                    });
                }
            }
        },
        onSubmit: (event)=>{
            event.preventDefault();
            handleCreateIssue();
        },
        ref: formRef
    }, appearance === $da27b835be8eb6e3$export$e99c52f52501386d && getRowHeader(), (0, $4R6GH.fg)('jfp_a11y_add_lable_for_business_create_issue_input') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jldZL.default), {
        id: "business-issue-create.ui.inline-create-form.textarea-with-description"
    }, formatMessage((0, $6uB1c.default).createIssueInputDescription, {
        issueType: selectedType.issueType.name
    })) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($da27b835be8eb6e3$var$StyledTextArea, {
        appearance: appearance,
        autoFocus: true,
        "data-testid": "business-issue-create.ui.inline-create-form.textarea",
        maxLength: (0, $7462c685f739ed5a$export$193356664cd84c83),
        onChange: (event)=>{
            const content = event.target.value.replace(/[\n\r]+/g, ' ');
            setTextContent(content);
        },
        onKeyDown: (event)=>{
            if (event.key === 'Enter' && !$da27b835be8eb6e3$var$isComposing(event)) {
                event.preventDefault();
                handleCreateIssue();
            }
            if (onKeyDown && (0, $4R6GH.fg)('aiwb_in_list_view_technical_changes')) onKeyDown(event, textContent);
        },
        placeholder: placeholderOverride && (0, $4R6GH.fg)('aiwb_in_list_view_technical_changes') ? placeholderOverride : formatMessage((0, $6uB1c.default).placeholderText),
        value: textContent,
        ref: textAreaRef,
        ...(0, $4R6GH.fg)('jfp_a11y_add_lable_for_business_create_issue_input') ? styledTextAreaAccessibilityProps : {}
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($da27b835be8eb6e3$var$Footer, {
        appearance: appearance
    }, (!(0, $dCm1o.isVisualRefreshEnabled)() || appearance !== $da27b835be8eb6e3$export$e99c52f52501386d) && issueTypesSelect, appearance !== $da27b835be8eb6e3$export$e99c52f52501386d && (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, (shouldShowAssigneePicker || shouldShowDueDatePicker) && shouldShowAdditionalFields() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jSQ0a.InlineCardCreateAdditionalFields), {
        projectKey: projectKey,
        shouldShowNameLabel: false,
        isCompactDueDatePicker: true,
        onAssigneeUpdate: setAssignee,
        defaultAssignee: defaultAssignee,
        shouldShowDueDatePicker: shouldShowDueDatePicker,
        shouldShowAssigneePicker: shouldShowAssigneePicker,
        onDateSelected: setDueDate,
        defaultDueDate: dueDate,
        onUpdatingAssigneePicker: setIsUpdatingAssigneePicker,
        onUpdatingDueDatePicker: setIsUpdatingDueDatePicker,
        fullWidth: additionalFieldProps.fullWidth,
        onClick: ()=>{
            setIsPopupSelectOpen(false);
        },
        source: location
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        label: formatMessage((0, $6uB1c.default).createButton),
        appearance: "default",
        type: "submit",
        onClick: ()=>{
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'inlineCreateSubmit', {
                location: location,
                hierarchyLevel: selectedType.optionType === $da27b835be8eb6e3$var$ISSUE_TYPE ? selectedType.issueType?.hierarchyLevel : undefined
            });
        },
        isDisabled: isEmptyRef.current,
        spacing: "compact",
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
                color: "inherit",
                weight: "medium"
            }, "\u23CE")
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, appearance === $da27b835be8eb6e3$export$e99c52f52501386d && (shouldShowAssigneePicker || shouldShowDueDatePicker) && shouldShowAdditionalFields() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jSQ0a.InlineCardCreateAdditionalFields), {
        projectKey: projectKey,
        shouldShowNameLabel: additionalFieldProps.shouldShowNameLabel,
        isCompactDueDatePicker: additionalFieldProps.isCompactDueDatePicker,
        onAssigneeUpdate: setAssignee,
        shouldShowDueDatePicker: shouldShowDueDatePicker,
        defaultAssignee: defaultAssignee,
        shouldShowAssigneePicker: shouldShowAssigneePicker,
        onDateSelected: setDueDate,
        defaultDueDate: dueDate,
        onUpdatingAssigneePicker: setIsUpdatingAssigneePicker,
        onUpdatingDueDatePicker: setIsUpdatingDueDatePicker,
        fullWidth: additionalFieldProps.fullWidth,
        onClick: ()=>{
            setIsPopupSelectOpen(false);
        },
        source: location
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($da27b835be8eb6e3$var$StyledCreateButton, {
        appearance: "primary",
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $t9aRF.default), null),
        isDisabled: isEmptyRef.current,
        spacing: "compact",
        type: "submit",
        onClick: ()=>{
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'inlineCreateSubmit', {
                location: location,
                hierarchyLevel: selectedType.optionType === $da27b835be8eb6e3$var$ISSUE_TYPE ? selectedType.issueType?.hierarchyLevel : undefined
            });
        },
        ...(0, $4R6GH.fg)('a11y_enghealth_fixes_deliveroo') && {
            'aria-label': formatMessage((0, $6uB1c.default).createButton)
        }
    }, !isCompactCreateButton && formatMessage((0, $6uB1c.default).createButton)), (0, $4R6GH.fg)('aiwb_in_list_view_technical_changes') ? additionalFooterContent : null)));
};
const $da27b835be8eb6e3$var$InlineCreateFormWithErrorBoundary = (props)=>{
    const experience = $da27b835be8eb6e3$var$useExperience(props.location);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cm8b5.ExperienceErrorBoundary), {
        experience: experience,
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($da27b835be8eb6e3$var$InlineCreateForm, props));
};
const $da27b835be8eb6e3$var$genericMemo = (0, $5uXOq.memo);
var $da27b835be8eb6e3$export$2e2bcd8739ae039 = $da27b835be8eb6e3$var$genericMemo($da27b835be8eb6e3$var$InlineCreateFormWithErrorBoundary);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $da27b835be8eb6e3$var$FullContent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "form", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { borderRadius: borderRadius, minHeight: minHeight, appearance: appearance, indent: indent, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_125h9jn": (0, $lD23V.default)(__cmplp.borderRadius ?? "var(--ds-border-radius, 4px)"),
            "--_jfgeee": (0, $lD23V.default)(__cmplp.minHeight ?? '40px'),
            "--_10qudx8": (0, $lD23V.default)(__cmplp.appearance === $da27b835be8eb6e3$export$e99c52f52501386d && 'center'),
            "--_gg0ene": (0, $lD23V.default)(__cmplp.indent)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulpu2gc _v56416gf _12ji1r31 _1qu2glyw _12y31o36 _2rkoh5or _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1e0c1txw _bfhkvuon _16qs1yp9 _vchhusvi _1tkej4pn _4cvrnb98 _ca0q1b66 _u5f3u2gc _n3td1b66 _19bvu2gc",
            __cmplp.appearance === $da27b835be8eb6e3$export$2e234a0f40160716 ? "_2lx21bp4" : "_2lx2vrvc",
            __cmplp.appearance === $da27b835be8eb6e3$export$e99c52f52501386d ? "_4t3i1ylp" : "_4t3i53f4",
            __cmplp.appearance === $da27b835be8eb6e3$export$2e234a0f40160716 && "_ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp",
            __cmplp.indent && "_19bv2uct",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/design-system/no-html-textarea -- To migrate as part of go/ui-styling-standard
const $da27b835be8eb6e3$var$StyledTextArea = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "textarea", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { appearance: appearance, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _19itglyw _12ji1r31 _1qu2glyw _12y31o36 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _11c82smr _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66 _14zgglyw _bfhkvuon _syaz1fxt _ect41gqc _1idr131l _1wfakb7n",
            __cmplp.appearance === $da27b835be8eb6e3$export$2e234a0f40160716 ? "_4t3i1ylp" : "_4t3igktf",
            __cmplp.appearance === $da27b835be8eb6e3$export$e99c52f52501386d && "_o572qvpr _1fjgglyw _1cicglyw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $da27b835be8eb6e3$var$Footer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { appearance: appearance, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulp12x7 _1e0c1txw _4cvr1h6o",
            __cmplp.appearance === $da27b835be8eb6e3$export$2e234a0f40160716 ? "_1bah1yb4" : "_1bahh9n0",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $da27b835be8eb6e3$var$StyledButton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $fVnbM.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1ul9idpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $da27b835be8eb6e3$var$StyledCreateButton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $fVnbM.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $da27b835be8eb6e3$var$OptionWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $da27b835be8eb6e3$var$OptionTypeIcon = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3ipxbi _1bsbpxbi _2hwxu2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $da27b835be8eb6e3$var$ExtraLinksGroup = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_x3doudwz _19pk1b66 _ca0q1b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $da27b835be8eb6e3$var$IssueTypeIcon = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3ipxbi _1bsbpxbi",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $da27b835be8eb6e3$var$ChevronDownWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwxx0bf _otyridpf _18u0r5cr",
            __cmplp.className
        ])
    });
});
const $da27b835be8eb6e3$var$issueTypeButtonStyles = (0, $8CUq3.xcss)({
    marginTop: 'space.025'
});
const $da27b835be8eb6e3$var$spinnerWrapperStyles = (0, $8CUq3.xcss)({
    flex: 1
});
const $da27b835be8eb6e3$var$issueTypeButtonWrapperStyles = (0, $8CUq3.xcss)({
    borderRadius: '3px',
    backgroundColor: 'color.background.neutral.subtle',
    display: 'flex',
    alignItems: 'center',
    gap: 'space.050',
    paddingTop: 'space.050',
    paddingBottom: 'space.050',
    paddingLeft: 'space.050',
    paddingRight: 'space.050',
    borderStyle: 'solid',
    borderWidth: 'border.width',
    borderRightColor: 'transparent',
    borderLeftColor: 'transparent',
    borderTopColor: 'transparent',
    borderBottomColor: 'transparent',
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.subtle.hovered',
        borderColor: 'color.border.selected'
    },
    ':focus': {
        borderColor: 'color.border.selected'
    },
    ':focus-visible': {
        borderRightColor: 'transparent',
        borderLeftColor: 'transparent',
        borderTopColor: 'transparent',
        borderBottomColor: 'transparent'
    }
});

});
const $7462c685f739ed5a$export$3789e4b2a10baa2b = 'full';
const $7462c685f739ed5a$export$db1cdb8627b81f84 = 'compact';
const $7462c685f739ed5a$export$aca095bc476d426f = 'simple';
const $7462c685f739ed5a$export$1aad44a7533f8ad8 = 'table_row';
const $7462c685f739ed5a$export$d2f7b3f0efb6e208 = 'hidden';
const $7462c685f739ed5a$export$dda6912361cddac9 = 'visible';
const $7462c685f739ed5a$export$565566e3df4dad53 = 'blur';
const $7462c685f739ed5a$export$806b905ec7df742f = 'enter';
const $7462c685f739ed5a$export$2bb790b9008907b4 = 'escape';
const $7462c685f739ed5a$export$ba9f60edfdf2e66 = 'create_button';
const $7462c685f739ed5a$export$193356664cd84c83 = 255;
const $7462c685f739ed5a$export$f9e3e7ede9ba929d = 500;
const $7462c685f739ed5a$export$e0bc602b327f818b = 'add-issue-type-option';

parcelRegister("jSQ0a", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "InlineCardCreateAdditionalFields", () => $1ce1dcccf46dcc32$export$bf6bfdf8d39a70ad);
$parcel$export(module.exports, "default", () => $1ce1dcccf46dcc32$export$2e2bcd8739ae039);
/* InlineCardCreateAdditionalFields.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $ksAZG = parcelRequire("ksAZG");

var $lPoet = parcelRequire("lPoet");
const $1ce1dcccf46dcc32$export$bf6bfdf8d39a70ad = ({ projectKey: projectKey, shouldShowNameLabel: shouldShowNameLabel, isCompactDueDatePicker: isCompactDueDatePicker, onAssigneeUpdate: onAssigneeUpdate, defaultAssignee: defaultAssignee, onDateSelected: onDateSelected, defaultDueDate: defaultDueDate, source: source, shouldShowAssigneePicker: shouldShowAssigneePicker = false, shouldShowDueDatePicker: shouldShowDueDatePicker = false, onUpdatingAssigneePicker: onUpdatingAssigneePicker, onUpdatingDueDatePicker: onUpdatingDueDatePicker, fullWidth: fullWidth = true, onClick: onClick, shouldRenderToParent: shouldRenderToParent = false, strategy: strategy = 'absolute', onClose: onClose = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))) })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        role: "presentation",
        onClick: onClick,
        className: (0, $bwpsq.default)([
            "_zulp12x7 _1e0c1txw _4cvr1h6o _1bahv2br _2lx2vrvc _16jlkb7n",
            !fullWidth && "_16jlidpf"
        ])
    }, shouldShowDueDatePicker && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ksAZG.InlineDueDatePicker), {
        onDateSelected: onDateSelected,
        defaultDueDate: defaultDueDate,
        isCompactVersion: isCompactDueDatePicker,
        onUpdatingDueDate: onUpdatingDueDatePicker,
        source: source,
        shouldRenderToParent: shouldRenderToParent,
        onClose: onClose
    }), shouldShowAssigneePicker && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lPoet.InlineAssigneePicker), {
        projectKey: projectKey,
        shouldShowNameLabel: shouldShowNameLabel,
        onAssigneeUpdate: onAssigneeUpdate,
        defaultAssignee: defaultAssignee,
        source: source,
        onUpdatingAssigneePicker: onUpdatingAssigneePicker,
        strategy: strategy,
        onClose: onClose
    }));
};
const $1ce1dcccf46dcc32$var$styles = null;
const $1ce1dcccf46dcc32$var$notFullWidthStyles = null;
var $1ce1dcccf46dcc32$export$2e2bcd8739ae039 = $1ce1dcccf46dcc32$export$bf6bfdf8d39a70ad;

});
parcelRegister("ksAZG", function(module, exports) {

$parcel$export(module.exports, "InlineDueDatePicker", () => $590f770d4aa19e2d$export$2e0bcc5b17522b60);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $3fesp = parcelRequire("3fesp");

var $1I7E8 = parcelRequire("1I7E8");

var $dC5iT = parcelRequire("dC5iT");
var $5ILhZ = parcelRequire("5ILhZ");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $3bDjY = parcelRequire("3bDjY");

var $4kK95 = parcelRequire("4kK95");

var $koVbs = parcelRequire("koVbs");

var $iXVV6 = parcelRequire("iXVV6");
var $8zOmE = parcelRequire("8zOmE");

var $1dQwL = parcelRequire("1dQwL");

var $3KjRe = parcelRequire("3KjRe");
const $590f770d4aa19e2d$export$2e0bcc5b17522b60 = ({ onDateSelected: onDateSelected, isCompactVersion: isCompactVersion = false, source: source, defaultDueDate: defaultDueDate, onUpdatingDueDate: onUpdatingDueDate = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), shouldRenderToParent: shouldRenderToParent = false, onClose: onClose = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))) })=>{
    const { formatMessage: formatMessage, formatDate: formatDate } = (0, $koVbs.default)();
    const currentDate = (0, $4kK95.DateOnly).fromDateAccordingToLocalTime(new Date());
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const [selectedDate, setSelectedDate] = (0, $5uXOq.useState)(null);
    const getFormattedDateString = ()=>{
        if (!defaultDueDate) return null;
        const formattedDate = formatDate(defaultDueDate, {
            day: '2-digit',
            month: 'short'
        });
        return formattedDate;
    };
    const handleDateSelected = (date, analyticsEvent)=>{
        if (date) {
            const formatInputDate = new Date(date.year, date.month - 1, date.day);
            setSelectedDate((0, $4kK95.DateOnly).fromDateAccordingToLocalTime(formatInputDate));
            onDateSelected?.(formatInputDate);
        } else setSelectedDate(null);
        setIsOpen(false);
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'dueDate');
    };
    const handleOnClick = (0, $5uXOq.useCallback)((_e, analyticsEvent)=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'dueDatePickerButton');
        setIsOpen(!isOpen);
    }, [
        isOpen
    ]);
    const handleOnClose = ()=>{
        setIsOpen(false);
    };
    (0, $5uXOq.useEffect)(()=>{
        onUpdatingDueDate?.(isOpen);
    }, [
        isOpen,
        onUpdatingDueDate
    ]);
    (0, $5uXOq.useEffect)(()=>{
        setSelectedDate(defaultDueDate ? (0, $4kK95.DateOnly).fromDateAccordingToLocalTime(defaultDueDate) : null);
    }, [
        defaultDueDate
    ]);
    const handleOnKeyDown = (e)=>{
        if (e.key === 'Escape') {
            // If the popup is not open, we just call onClose and return
            if (!isOpen) {
                onClose();
                return;
            }
            setIsOpen(false);
            e.stopPropagation();
            e.preventDefault();
        }
    };
    const formattedDefaultDate = getFormattedDateString();
    const buttonText = formattedDefaultDate || !isCompactVersion && formatMessage((0, $3KjRe.default).dueDateLabel);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: "inlineDueDatePicker",
        attributes: {
            calledFrom: source
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        onKeyDown: handleOnKeyDown,
        xcss: $590f770d4aa19e2d$var$wrapperStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1I7E8.default), {
        isOpen: isOpen,
        onClose: handleOnClose,
        shouldRenderToParent: shouldRenderToParent,
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1dQwL.CalendarWithInputField), {
                defaultDate: selectedDate || currentDate,
                onDateSelected: handleDateSelected,
                setSelectedDate: setSelectedDate
            }),
        trigger: ({ ref: ref, ...triggerProps })=>{
            const triggerButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5ILhZ.default), {
                ref: ref,
                ...triggerProps,
                "aria-label": formatMessage((0, $3KjRe.default).dueDateLabel),
                onClick: handleOnClick,
                backgroundColor: "color.background.neutral.subtle",
                xcss: [
                    $590f770d4aa19e2d$var$dueDatePickerButtonStyle,
                    isOpen && $590f770d4aa19e2d$var$activeStyles,
                    !buttonText && $590f770d4aa19e2d$var$dueDatePickerCompactButtonStyle
                ]
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3fesp))), {
                label: "",
                testId: "inline-due-date-picker.calender-icon",
                color: "var(--ds-icon-subtle, #626F86)"
            }), buttonText && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
                align: "center",
                color: "color.text"
            }, buttonText));
            return isCompactVersion ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
                content: formatMessage((0, $3KjRe.default).dueDateLabel),
                hideTooltipOnMouseDown: true
            }, triggerButton) : triggerButton;
        }
    })));
};
const $590f770d4aa19e2d$var$wrapperStyle = (0, $8CUq3.xcss)({
    display: 'inline-flex',
    alignItems: 'center'
});
const $590f770d4aa19e2d$var$dueDatePickerButtonStyle = (0, $8CUq3.xcss)({
    display: 'flex',
    alignItems: 'center',
    gap: 'space.050',
    paddingTop: 'space.025',
    paddingBottom: 'space.025',
    paddingLeft: 'space.050',
    paddingRight: 'space.050',
    borderRadius: '3px',
    borderStyle: 'solid',
    borderWidth: 'border.width',
    borderRightColor: 'transparent',
    borderLeftColor: 'transparent',
    borderTopColor: 'transparent',
    borderBottomColor: 'transparent',
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.subtle.hovered',
        borderColor: 'color.border.selected'
    },
    ':focus': {
        borderColor: 'color.border.selected'
    },
    ':focus-visible': {
        borderRightColor: 'transparent',
        borderLeftColor: 'transparent',
        borderTopColor: 'transparent',
        borderBottomColor: 'transparent'
    }
});
const $590f770d4aa19e2d$var$activeStyles = (0, $8CUq3.xcss)({
    borderColor: 'color.border.selected',
    backgroundColor: 'color.background.selected'
});
const $590f770d4aa19e2d$var$dueDatePickerCompactButtonStyle = (0, $8CUq3.xcss)({
    padding: 'space.050'
});

});
parcelRegister("3fesp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::43a4f9fcd22489798c1322bda48936cf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $25cdfcb8bb836404$var$_react = $25cdfcb8bb836404$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $25cdfcb8bb836404$var$_baseNew = $25cdfcb8bb836404$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $25cdfcb8bb836404$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Calendar".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: date metadata, date input field, calendar view, jira status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $25cdfcb8bb836404$var$CalendarIcon = (props)=>/*#__PURE__*/ $25cdfcb8bb836404$var$_react.default.createElement($25cdfcb8bb836404$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.5 2.5v2H6v-2h4v2h1.5v-2H13a.5.5 0 0 1 .5.5v3h-11V3a.5.5 0 0 1 .5-.5zm-2 5V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V7.5zm9-6.5H13a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1.5V0H6v1h4V0h1.5z" clip-rule="evenodd"/>`
    }, props));
$25cdfcb8bb836404$var$CalendarIcon.displayName = 'CalendarIcon';
var $25cdfcb8bb836404$var$_default = module.exports.default = $25cdfcb8bb836404$var$CalendarIcon;

});

parcelRegister("4kK95", function(module, exports) {

$parcel$export(module.exports, "DateOnly", () => $a1048e23edd181e2$export$988b361b394263b6);
$parcel$export(module.exports, "toDateOnly", () => $a1048e23edd181e2$export$b0961ad8aee63b8b);
const $a1048e23edd181e2$export$9cda9b56d134780f = 'Invalid date or date format';
const $a1048e23edd181e2$var$toISOString = (year, month, day)=>`${String(year).padStart(4, '0')}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
const $a1048e23edd181e2$var$isLeapYear = (year)=>year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
const $a1048e23edd181e2$var$daysInMonth = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
/**
 Returns a boolean to indicate that the date specified is valid.

 Note: Dates before Year zero are treated to be invalid.
 */ const $a1048e23edd181e2$var$isDateValid = (year, month, day)=>{
    if ([
        year,
        month,
        day
    ].findIndex((n)=>typeof n !== 'number' || Number.isNaN(n)) !== -1) return false;
    if (year < 0) return false;
    if (month < 1 || month > 12) return false;
    if (day < 1) return false;
    if (day > (month === 2 && $a1048e23edd181e2$var$isLeapYear(year) ? 29 : $a1048e23edd181e2$var$daysInMonth[month - 1])) return false;
    return true;
};
const $a1048e23edd181e2$var$dateFormatRegExp = /^([0-9][0-9][0-9][0-9])-([0-1][0-9])-([0-3][0-9])$/;
class $a1048e23edd181e2$export$988b361b394263b6 {
    /**
	 * Return true if the string is a valid ISO date string in the format 'YYYY-MM-DD'.
	 * @param dateString
	 * @returns {boolean}
	 */ static isISODateString(dateString) {
        try {
            $a1048e23edd181e2$export$988b361b394263b6.fromISODateString(dateString);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            if (e?.message === $a1048e23edd181e2$export$9cda9b56d134780f) return false;
            throw e;
        }
        return true;
    }
    /**
	 * Create a DateOnly object from a string in the format 'YYYY-MM-DD'.
	 */ // go/jfe-eslint
    static fromISODateString(dateString) {
        const matches = $a1048e23edd181e2$var$dateFormatRegExp.exec(dateString);
        if (matches === null) throw new Error($a1048e23edd181e2$export$9cda9b56d134780f);
        const [, year, month, day] = matches;
        // @ts-expect-error - TS2556 - A spread argument must either have a tuple type or be passed to a rest parameter.
        return new $a1048e23edd181e2$export$988b361b394263b6(...[
            year,
            month,
            day
        ].map((s)=>Number.parseInt(s, 10)));
    }
    /**
	 * DISCLAIMER:
	 * Date() does NOT store timezone information.
	 *
	 * Date.prototype.toString() leverages the system's timezone to serialize it into a string according to local time.
	 * Methods getDate(), getMonth(), getFullYear() behave the same and also return values according to local time.
	 *
	 * Methods toUTCString(), getUTCDate(), getUTCMonth(), getUTCFullYear() return values according to universal time.
	 *
	 * Reference: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date
	 */ /**
	 * Create a DateOnly object that reflects the local year, month & day for the specified Date.
	 *
	 * See the disclaimer above for further details.
	 */ // go/jfe-eslint
    static fromDateAccordingToLocalTime(date) {
        return new $a1048e23edd181e2$export$988b361b394263b6(date.getFullYear(), date.getMonth() + 1, date.getDate());
    }
    /**
	 * Create a DateOnly object that reflects the UTC year, month & day of the specified Date.
	 *
	 * See the disclaimer above for further details.
	 */ // go/jfe-eslint
    static fromDateAccordingToUTC(date) {
        return new $a1048e23edd181e2$export$988b361b394263b6(date.getUTCFullYear(), date.getUTCMonth() + 1, date.getUTCDate());
    }
    /**
	 * Compare 2 DateOnly objects.
	 *
	 * (Similar to the TC39 proposal Temporal.PlainDate.compare).
	 *
	 * If a comes before b, return -1.
	 * If a is equal to b, return 0.
	 * If a is greater than b, return 1.
	 */ static compare(a, b) {
        if (a.year === b.year) {
            if (a.month === b.month) {
                if (a.day === b.day) return 0;
                return a.day < b.day ? -1 : 1;
            }
            return a.month < b.month ? -1 : 1;
        }
        return a.year < b.year ? -1 : 1;
    }
    /**
	 * Create a DateOnly object which represents a day. It does not have a time component.
	 * @param year - A year, ranging between 0 and 9999 inclusive.
	 * @param month - A month, ranging between 1 and 12 inclusive.
	 * @param day - A day of the month, ranging between 1 and 31 inclusive.
	 */ constructor(year, month, day){
        if (!$a1048e23edd181e2$var$isDateValid(year, month, day)) throw new Error($a1048e23edd181e2$export$9cda9b56d134780f);
        this.year = year;
        this.month = month;
        this.day = day;
    }
    getYear() {
        return this.year;
    }
    getMonth() {
        return this.month;
    }
    getDay() {
        return this.day;
    }
    toISOString() {
        return $a1048e23edd181e2$var$toISOString(this.year, this.month, this.day);
    }
    /**
	 * Returns a Date object with the same date, with the time component set to 00:00:00 which corresponds to the UTC timezone.
	 */ toUTCDate() {
        return new Date(Date.UTC(this.year, this.month - 1, this.day));
    }
    /**
	 * Returns a Date object with the same date, with the time component set to 00:00:00 for the local timezone.
	 */ toLocalDate() {
        // take the current date (e.g. 1.06.2020)
        const localDate = new Date();
        // store current month in a const to compare below
        const currentMonth = localDate.getMonth();
        // set the year
        localDate.setFullYear(this.year);
        localDate.setHours(0);
        localDate.setMinutes(0);
        localDate.setSeconds(0);
        localDate.setMilliseconds(0);
        localDate.setDate(this.day);
        // if this.day doesn't exist in the current month (e.g. 31 doesn't exist in June ),
        // it will set the month to July instead. We need to make sure setDate doesn't change the month
        if (localDate.getMonth() !== currentMonth) {
            localDate.setMonth(this.month - 1);
            // reset the date after updating the month
            localDate.setDate(this.day);
        } else localDate.setMonth(this.month - 1);
        return localDate;
    }
    equals(dateOnly) {
        return $a1048e23edd181e2$export$988b361b394263b6.compare(this, dateOnly) === 0;
    }
}
const $a1048e23edd181e2$export$b0961ad8aee63b8b = (date)=>typeof date === 'string' ? $a1048e23edd181e2$export$988b361b394263b6.fromISODateString(date.replace(/T.*/, '')) : null;

});

parcelRegister("1dQwL", function(module, exports) {

$parcel$export(module.exports, "CalendarWithInputField", () => $bf26ba40f07c366c$export$36ad8d1894d01015);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $luBm6 = parcelRequire("luBm6");
var $8CUq3 = parcelRequire("8CUq3");

var $1f0Hs = parcelRequire("1f0Hs");

var $kY99m = parcelRequire("kY99m");

var $qfj8c = parcelRequire("qfj8c");
var $2x3Cb = parcelRequire("2x3Cb");

var $2NMNM = parcelRequire("2NMNM");

var $DVljb = parcelRequire("DVljb");

var $1p96B = parcelRequire("1p96B");

var $6yeNV = parcelRequire("6yeNV");

var $koVbs = parcelRequire("koVbs");

var $dBYMG = parcelRequire("dBYMG");

var $2bdzH = parcelRequire("2bdzH");
const $bf26ba40f07c366c$export$36ad8d1894d01015 = ({ defaultDate: defaultDate, onDateSelected: onDateSelected, setSelectedDate: setSelectedDate })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [latestDate, setLatestDate] = (0, $5uXOq.useState)(defaultDate);
    const [inputText, setInputText] = (0, $5uXOq.useState)((0, $2bdzH.formatDateType)(defaultDate, (0, $DVljb.useLocale)()));
    const locale = (0, $DVljb.useLocale)();
    const weekStartDay = (0, $1p96B.getLocale)(locale)?.options?.weekStartsOn;
    const standardizedLocale = (0, $6yeNV.standardizeLocale)(locale);
    const inputRef = (0, $5uXOq.useRef)(null);
    const possiblyValid = (0, $2bdzH.isDatePossiblyValid)(inputText);
    const attemptedDateParse = (0, $2bdzH.parseDateType)(inputText, locale);
    // Don't display an error for an empty input.
    const displayError = (attemptedDateParse === null || !possiblyValid) && inputText !== '';
    (0, $5uXOq.useEffect)(()=>{
        if (latestDate) setSelectedDate(latestDate);
    }, [
        latestDate,
        locale,
        setSelectedDate
    ]);
    const handleOnDateChange = (date)=>{
        setLatestDate(date);
    };
    const handleOnDateSelected = (date, analyticsEvent)=>{
        setInputText((0, $2bdzH.formatDateType)(date, locale));
        onDateSelected(date, analyticsEvent);
    };
    const handleInputChange = (event)=>{
        const textFieldValue = event.target.value;
        const inputDate = (0, $2bdzH.parseDateType)(textFieldValue, locale);
        if (inputDate) setLatestDate(inputDate);
        setInputText(textFieldValue);
    };
    const handleKeyPress = (event)=>{
        if (event.key === 'Enter') {
            const inputDate = (0, $2bdzH.parseDateType)(inputText, locale);
            if (displayError) {
                event.preventDefault();
                event.stopPropagation();
                return;
            }
            const analyticsEvent = createAnalyticsEvent({
                action: 'confirmed',
                actionSubject: 'dueDate'
            });
            onDateSelected(inputDate, analyticsEvent);
        }
    };
    const handleKeyDown = (event)=>{
        const target = event.target;
        if (!(target instanceof HTMLInputElement)) return;
        const dateString = target.value;
        let adjustment;
        if (event.key === 'ArrowUp') adjustment = 1;
        else if (event.key === 'ArrowDown') adjustment = -1;
        if (adjustment === undefined) return;
        const cursorPos = inputRef.current?.selectionStart;
        if (cursorPos === null || cursorPos === undefined) return;
        const activeSegment = (0, $2bdzH.findDateSegmentByPosition)(cursorPos, dateString, locale);
        if (activeSegment === undefined) return;
        const oldDateType = (0, $2bdzH.parseDateType)(dateString, locale);
        if (oldDateType === undefined || oldDateType === null) return;
        const newDateType = (0, $2bdzH.adjustDate)(oldDateType, activeSegment, adjustment);
        setInputText((0, $2bdzH.formatDateType)(newDateType, locale));
        setLatestDate(newDateType);
        event.preventDefault();
    };
    const latestSelectedDate = [
        (0, $1p96B.formatWithLocale)(new Date(latestDate.year, latestDate.month - 1, latestDate.day), 'yyyy-MM-dd', locale)
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        xcss: $bf26ba40f07c366c$var$InlineDueDatePickerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $bf26ba40f07c366c$var$dateTextFieldWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2x3Cb.Label), {
        htmlFor: "datetextfield"
    }, formatMessage((0, $dBYMG.default).dueDateText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kY99m.default), {
        name: "datetextfield",
        id: "datetextfield",
        value: inputText,
        onChange: handleInputChange,
        onKeyPress: handleKeyPress,
        onKeyDown: handleKeyDown,
        ref: inputRef,
        spellCheck: false,
        autoComplete: "off",
        width: "100%",
        "aria-label": formatMessage((0, $dBYMG.default).calenderInputAriaLabel),
        isInvalid: displayError,
        testId: "inline-due-date-picker.calendar-with-input-field.datepicker"
    }), displayError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $qfj8c.ErrorMessage), null, formatMessage((0, $dBYMG.default).invalidDateError))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1f0Hs.default), {
        day: latestDate.day,
        month: latestDate.month,
        year: latestDate.year,
        defaultSelected: latestSelectedDate,
        weekStartDay: weekStartDay,
        locale: standardizedLocale,
        onSelect: handleOnDateSelected,
        onChange: handleOnDateChange,
        "data-testid": "inline-due-date-picker.calendar-with-input-field.datepicker"
    }));
};
const $bf26ba40f07c366c$var$InlineDueDatePickerStyles = (0, $8CUq3.xcss)({
    alignItems: 'center'
});
const $bf26ba40f07c366c$var$dateTextFieldWrapper = (0, $8CUq3.xcss)({
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    padding: 'space.200',
    paddingBottom: '0'
});

});
parcelRegister("1f0Hs", function(module, exports) {

$parcel$export(module.exports, "default", () => $16abbcd9b9109722$export$2e2bcd8739ae039);
/* calendar.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $6QvkM = parcelRequire("6QvkM");

var $eGmKJ = parcelRequire("eGmKJ");

var $9KnKW = parcelRequire("9KnKW");

var $MHKc7 = parcelRequire("MHKc7");
var $414Wj = parcelRequire("414Wj");

var $ePz3p = parcelRequire("ePz3p");

var $lJWdi = parcelRequire("lJWdi");

var $avO9B = parcelRequire("avO9B");

var $iioJV = parcelRequire("iioJV");

var $jihAA = parcelRequire("jihAA");

var $bbnGB = parcelRequire("bbnGB");

var $hbcve = parcelRequire("hbcve");

var $2TGJ3 = parcelRequire("2TGJ3");

var $f9D1v = parcelRequire("f9D1v");

var $9efze = parcelRequire("9efze");
const $16abbcd9b9109722$var$styles = {
    box: "_1e0c1o8l _uiztglyw"
};
const $16abbcd9b9109722$var$analyticsAttributes = {
    componentName: 'calendar',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $16abbcd9b9109722$var$InnerCalendar = /*#__PURE__*/ (0, $5uXOq.forwardRef)(function Calendar({ day: day, defaultDay: defaultDay = 0, defaultMonth: defaultMonth = 0, defaultPreviouslySelected: defaultPreviouslySelected = (0, $iioJV.blankStringArray), defaultSelected: defaultSelected = (0, $iioJV.blankStringArray), defaultYear: defaultYear = 0, disabled: disabled, disabledDateFilter: disabledDateFilter, minDate: minDate, maxDate: maxDate, month: month, nextMonthLabel: nextMonthLabel, onBlur: onBlur = (0, $eGmKJ.default), onChange: onChange = (0, $eGmKJ.default), onFocus: onFocus = (0, $eGmKJ.default), onSelect: onSelect = (0, $eGmKJ.default), previouslySelected: previouslySelected, previousMonthLabel: previousMonthLabel, selected: selected, shouldSetFocusOnCurrentDay: shouldSetFocusOnCurrentDay = false, today: today, locale: locale = 'en-US', year: year, analyticsContext: analyticsContext, weekStartDay: weekStartDay = 0, testId: testId, className: className, style: style, tabIndex: tabIndex = 0 }, ref) {
    const { day: [dayValue, setDayValue], month: [monthValue, setMonthValue], year: [yearValue, setYearValue], today: [todayValue], selected: [selectedValue, setSelectedValue], previous: [previouslySelectedValue, setPreviouslySelectedValue] } = (0, $jihAA.default)({
        day: day,
        defaultDay: defaultDay,
        month: month,
        defaultMonth: defaultMonth,
        year: year,
        defaultYear: defaultYear,
        today: today,
        selected: selected,
        defaultSelected: defaultSelected,
        previouslySelected: previouslySelected,
        defaultPreviouslySelected: defaultPreviouslySelected
    });
    const [shouldSetFocus, setShouldSetFocus] = (0, $5uXOq.useState)(false);
    const onChangeWithAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        ...$16abbcd9b9109722$var$analyticsAttributes
    });
    const { navigate: navigate, handleClickNextMonth: handleClickNextMonth, handleClickNextYear: handleClickNextYear, handleClickPrevMonth: handleClickPrevMonth, handleClickPrevYear: handleClickPrevYear } = (0, $2TGJ3.default)({
        day: [
            dayValue,
            setDayValue
        ],
        month: [
            monthValue,
            setMonthValue
        ],
        year: [
            yearValue,
            setYearValue
        ],
        shouldSetFocus: [
            shouldSetFocus,
            setShouldSetFocus
        ],
        onChange: onChangeWithAnalytics
    });
    const onSelectWithAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: onSelect,
        action: 'selected',
        analyticsData: analyticsContext,
        ...$16abbcd9b9109722$var$analyticsAttributes
    });
    const { handleClickDay: handleClickDay, handleContainerKeyDown: handleContainerKeyDown } = (0, $f9D1v.default)({
        day: [
            dayValue,
            setDayValue
        ],
        month: [
            monthValue,
            setMonthValue
        ],
        year: [
            yearValue,
            setYearValue
        ],
        selected: [
            selectedValue,
            setSelectedValue
        ],
        previous: [
            ,
            setPreviouslySelectedValue
        ],
        onSelect: onSelectWithAnalytics,
        navigate: navigate
    });
    const { handleContainerBlur: handleContainerBlur, handleContainerFocus: handleContainerFocus } = (0, $bbnGB.default)({
        onFocus: onFocus,
        onBlur: onBlur
    });
    const { monthsLong: monthsLong, daysShort: daysShort, daysLong: daysLong } = (0, $9efze.default)({
        locale: locale,
        weekStartDay: weekStartDay
    });
    const weeks = (0, $hbcve.default)({
        day: dayValue,
        month: monthValue,
        year: yearValue,
        today: todayValue,
        selected: selectedValue,
        previouslySelected: previouslySelectedValue,
        disabled: disabled,
        disabledDateFilter: disabledDateFilter,
        minDate: minDate,
        maxDate: maxDate,
        daysLong: daysLong,
        weekStartDay: weekStartDay
    });
    const getNextMonthHeading = ()=>{
        // Next month is (currentMonth - 1) + 1, or just currentMonth in this
        // instance.
        const nextMonth = monthValue % 12;
        const showNextYear = monthValue === 12;
        return `${monthsLong[nextMonth]} ${showNextYear ? yearValue + 1 : yearValue}`;
    };
    const getNextYearHeading = ()=>{
        // Months are held in Date object as zero-indexed
        const thisMonth = (monthValue - 1) % 12;
        const nextYear = yearValue + 1;
        return `${monthsLong[thisMonth]} ${nextYear}`;
    };
    const getPreviousMonthHeading = ()=>{
        // Previous month is (monthValue - 1) - 1. Need to add 12 so the modulo
        // works as expected and stays positive.
        const previousMonth = (monthValue + 12 - 2) % 12;
        const showPreviousYear = monthValue === 1;
        return `${monthsLong[previousMonth]} ${showPreviousYear ? yearValue - 1 : yearValue}`;
    };
    const getPreviousYearHeading = ()=>{
        // Months are held in Date object as zero-indexed
        const thisMonth = (monthValue - 1) % 12;
        const previousYear = yearValue - 1;
        return `${monthsLong[thisMonth]} ${previousYear}`;
    };
    const headerId = (0, $9KnKW.useId)();
    return(// eslint-disable-next-line jsx-a11y/no-static-element-interactions
    /*#__PURE__*/ (0, $2OMIu.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: className,
        style: style,
        onBlur: handleContainerBlur,
        onFocus: handleContainerFocus,
        "data-testid": testId && `${testId}--container`,
        ref: ref,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
            xcss: $16abbcd9b9109722$var$styles.box,
            padding: "space.200",
            "aria-label": "calendar",
            testId: testId && `${testId}--calendar`,
            children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $414Wj.default), {
                space: "space.150",
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ePz3p.default // The month number needs to be translated to index in the month
                    ), {
                        // name array e.g. 1 (January) -> 0
                        monthLongTitle: monthsLong[monthValue - 1],
                        year: yearValue,
                        nextMonthLabel: nextMonthLabel,
                        previousMonthLabel: previousMonthLabel,
                        nextMonthHeading: getNextMonthHeading(),
                        nextYearHeading: getNextYearHeading(),
                        previousMonthHeading: getPreviousMonthHeading(),
                        previousYearHeading: getPreviousYearHeading(),
                        handleClickNextMonth: handleClickNextMonth,
                        handleClickNextYear: handleClickNextYear,
                        handleClickPrevMonth: handleClickPrevMonth,
                        handleClickPrevYear: handleClickPrevYear,
                        headerId: headerId,
                        tabIndex: tabIndex,
                        testId: testId
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $MHKc7.default), {
                        role: "grid",
                        onKeyDown: handleContainerKeyDown,
                        "aria-labelledby": headerId,
                        testId: testId && `${testId}--calendar-dates`,
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $avO9B.default), {
                                daysShort: daysShort,
                                testId: testId
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lJWdi.default), {
                                weeks: weeks,
                                handleClickDay: handleClickDay,
                                monthsLong: monthsLong,
                                shouldSetFocus: shouldSetFocus || shouldSetFocusOnCurrentDay,
                                tabIndex: tabIndex,
                                testId: testId
                            })
                        ]
                    })
                ]
            })
        })
    }));
});
/**
 * __Calendar__
 *
 * A calendar is used for date selection.
 *
 * - [Examples](https://atlassian.design/components/calendar/examples)
 * - [Code](https://atlassian.design/components/calendar/code)
 * - [Usage](https://atlassian.design/components/calendar/usage)
 */ const $16abbcd9b9109722$var$Calendar = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(function Calendar(props, ref) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)($16abbcd9b9109722$var$InnerCalendar, {
        ...props,
        ref: ref
    });
}));
$16abbcd9b9109722$var$Calendar.displayName = 'Calendar';
var $16abbcd9b9109722$export$2e2bcd8739ae039 = $16abbcd9b9109722$var$Calendar;

});
parcelRegister("ePz3p", function(module, exports) {

$parcel$export(module.exports, "default", () => $995afee12cb828f6$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $42CjB = parcelRequire("42CjB");

var $9KnKW = parcelRequire("9KnKW");

var $l1N8i = parcelRequire("l1N8i");

var $iPF0X = parcelRequire("iPF0X");

var $dq6Kz = parcelRequire("dq6Kz");

var $lRheX = parcelRequire("lRheX");

var $3dGN0 = parcelRequire("3dGN0");

var $MHKc7 = parcelRequire("MHKc7");
var $c0aEF = parcelRequire("c0aEF");
const $995afee12cb828f6$var$Header = /*#__PURE__*/ (0, $5uXOq.memo)(function Header({ monthLongTitle: monthLongTitle, year: year, previousMonthLabel: previousMonthLabel = 'Previous month', previousYearLabel: previousYearLabel = 'Previous year', previousMonthHeading: previousMonthHeading, previousYearHeading: previousYearHeading, nextMonthLabel: nextMonthLabel = 'Next month', nextYearLabel: nextYearLabel = 'Next year', nextMonthHeading: nextMonthHeading, nextYearHeading: nextYearHeading, handleClickPrevMonth: handleClickPrevMonth, handleClickPrevYear: handleClickPrevYear, handleClickNextMonth: handleClickNextMonth, handleClickNextYear: handleClickNextYear, headerId: headerId, tabIndex: tabIndex, testId: testId }) {
    const announceId = (0, $9KnKW.useId)();
    // All of this is because `aria-atomic` is not fully supported for different
    // assistive technologies. We want the value of the current month and year to
    // be announced, but *only* if that value has been interacted with since
    // being mounted. This allows us to conditionally apply the `aria-live`
    // attribute.  Without this, the `aria-live` property is set on mount and
    // overrides the default input's readout in downstream consumers (e.g.
    // datetime picker).
    const [hasInteractedWithMonthOrYear, setHasInteractedWithMonthOrYear] = (0, $5uXOq.useState)(false);
    const handlePrevMonthInteraction = (e)=>{
        if (!hasInteractedWithMonthOrYear) setHasInteractedWithMonthOrYear(true);
        handleClickPrevMonth(e);
    };
    const handlePrevYearInteraction = (e)=>{
        if (!hasInteractedWithMonthOrYear) setHasInteractedWithMonthOrYear(true);
        handleClickPrevYear(e);
    };
    const handleNextMonthInteraction = (e)=>{
        if (!hasInteractedWithMonthOrYear) setHasInteractedWithMonthOrYear(true);
        handleClickNextMonth(e);
    };
    const handleNextYearInteraction = (e)=>{
        if (!hasInteractedWithMonthOrYear) setHasInteractedWithMonthOrYear(true);
        handleClickNextYear(e);
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        paddingInline: "space.100",
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $c0aEF.default), {
            space: "space.0",
            alignBlock: "center",
            spread: "space-between",
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $c0aEF.default), {
                    space: "space.100",
                    alignBlock: "start",
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $42CjB.default), {
                            appearance: "subtle",
                            spacing: "compact",
                            tabIndex: tabIndex,
                            onClick: handlePrevYearInteraction,
                            testId: testId && `${testId}--previous-year`,
                            icon: (0, (/*@__PURE__*/$parcel$interopDefault($iPF0X))),
                            label: `${previousYearLabel}, ${previousYearHeading}`
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $42CjB.default), {
                            appearance: "subtle",
                            spacing: "compact",
                            tabIndex: tabIndex,
                            onClick: handlePrevMonthInteraction,
                            testId: testId && `${testId}--previous-month`,
                            icon: (0, (/*@__PURE__*/$parcel$interopDefault($lRheX))),
                            label: `${previousMonthLabel}, ${previousMonthHeading}`
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                    "aria-live": hasInteractedWithMonthOrYear ? 'polite' : undefined,
                    id: announceId,
                    testId: testId && `${testId}--current-month-year--container`,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l1N8i.default), {
                        size: "xsmall",
                        as: "h2",
                        id: headerId,
                        testId: testId && `${testId}--current-month-year`,
                        children: `${monthLongTitle} ${year}`
                    })
                }),
                /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $c0aEF.default), {
                    space: "space.100",
                    alignBlock: "end",
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $42CjB.default), {
                            appearance: "subtle",
                            spacing: "compact",
                            tabIndex: tabIndex,
                            onClick: handleNextMonthInteraction,
                            testId: testId && `${testId}--next-month`,
                            icon: (0, (/*@__PURE__*/$parcel$interopDefault($3dGN0))),
                            label: `${nextMonthLabel}, ${nextMonthHeading}`
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $42CjB.default), {
                            appearance: "subtle",
                            spacing: "compact",
                            tabIndex: tabIndex,
                            onClick: handleNextYearInteraction,
                            testId: testId && `${testId}--next-year`,
                            icon: (0, (/*@__PURE__*/$parcel$interopDefault($dq6Kz))),
                            label: `${nextYearLabel}, ${nextYearHeading}`
                        })
                    ]
                })
            ]
        })
    });
});
$995afee12cb828f6$var$Header.displayName = 'Header';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$995afee12cb828f6$export$2e2bcd8739ae039 = $995afee12cb828f6$var$Header;

});
parcelRegister("iPF0X", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4694b4334ad7c5c52e5a3aa3cac3904d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $db5cce05fac9743f$var$_react = $db5cce05fac9743f$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $db5cce05fac9743f$var$_baseNew = $db5cce05fac9743f$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $db5cce05fac9743f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDoubleLeft".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for calendar year button.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $db5cce05fac9743f$var$ChevronDoubleLeftIcon = (props)=>/*#__PURE__*/ $db5cce05fac9743f$var$_react.default.createElement($db5cce05fac9743f$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m2.31 6 3.97-3.97L5.22.97l-4.5 4.5a.75.75 0 0 0 0 1.06l4.5 4.5 1.06-1.06zm4.75 0 3.97-3.97L9.97.97l-4.5 4.5a.75.75 0 0 0 0 1.06l4.5 4.5 1.06-1.06z" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$db5cce05fac9743f$var$ChevronDoubleLeftIcon.displayName = 'ChevronDoubleLeftIcon';
var $db5cce05fac9743f$var$_default = module.exports.default = $db5cce05fac9743f$var$ChevronDoubleLeftIcon;

});

parcelRegister("dq6Kz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::efb038f49280a8a959174d8021780f6d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9c52f081c61754ba$var$_react = $9c52f081c61754ba$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $9c52f081c61754ba$var$_baseNew = $9c52f081c61754ba$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $9c52f081c61754ba$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDoubleRight".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for calendar year button.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9c52f081c61754ba$var$ChevronDoubleRightIcon = (props)=>/*#__PURE__*/ $9c52f081c61754ba$var$_react.default.createElement($9c52f081c61754ba$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m6.78.97 4.5 4.5a.75.75 0 0 1 0 1.06l-4.5 4.5-1.06-1.06L9.69 6 5.72 2.03zm-4.75 0 4.5 4.5a.75.75 0 0 1 0 1.06l-4.5 4.5L.97 9.97 4.94 6 .97 2.03z" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$9c52f081c61754ba$var$ChevronDoubleRightIcon.displayName = 'ChevronDoubleRightIcon';
var $9c52f081c61754ba$var$_default = module.exports.default = $9c52f081c61754ba$var$ChevronDoubleRightIcon;

});

parcelRegister("lRheX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::29f3eb59553566fe46c3ae42f5cce545>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fe9bebc953515e63$var$_react = $fe9bebc953515e63$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $fe9bebc953515e63$var$_baseNew = $fe9bebc953515e63$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $fe9bebc953515e63$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronLeft".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for collapse side nav and to indicate previous in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fe9bebc953515e63$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $fe9bebc953515e63$var$_react.default.createElement($fe9bebc953515e63$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m4.06 6 3.97-3.97L6.97.97l-4.5 4.5a.75.75 0 0 0 0 1.06l4.5 4.5 1.06-1.06z" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$fe9bebc953515e63$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
var $fe9bebc953515e63$var$_default = module.exports.default = $fe9bebc953515e63$var$ChevronLeftIcon;

});


parcelRegister("lJWdi", function(module, exports) {

$parcel$export(module.exports, "default", () => $43f22a52ec309eeb$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");

var $1q4y8 = parcelRequire("1q4y8");

var $h581D = parcelRequire("h581D");
const $43f22a52ec309eeb$var$WeekDays = /*#__PURE__*/ (0, $5uXOq.memo)(function WeekDays({ weeks: weeks, handleClickDay: handleClickDay, monthsLong: monthsLong, shouldSetFocus: shouldSetFocus, tabIndex: tabIndex, testId: testId }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
        role: "rowgroup",
        testId: testId && `${testId}--month`,
        children: weeks.map((week, i)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $h581D.default), {
                testId: testId && `${testId}--week`,
                children: week.values.map((weekDay)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $1q4y8.default), {
                        isDisabled: weekDay.isDisabled,
                        isFocused: weekDay.isFocused,
                        isToday: weekDay.isToday,
                        dayLong: weekDay.weekDayName,
                        month: weekDay.month,
                        monthLong: monthsLong[weekDay.month - 1],
                        onClick: handleClickDay,
                        isPreviouslySelected: weekDay.isPreviouslySelected,
                        isSelected: weekDay.isSelected,
                        isSibling: weekDay.isSiblingMonth,
                        year: weekDay.year,
                        shouldSetFocus: shouldSetFocus,
                        tabIndex: tabIndex,
                        testId: testId,
                        children: weekDay.day
                    }, `${week.id}-${weekDay.id}`))
            }, i))
    });
});
$43f22a52ec309eeb$var$WeekDays.displayName = 'WeekDays';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$43f22a52ec309eeb$export$2e2bcd8739ae039 = $43f22a52ec309eeb$var$WeekDays;

});
parcelRegister("1q4y8", function(module, exports) {

$parcel$export(module.exports, "default", () => $d70b02566a310b79$export$2e2bcd8739ae039);
/* date.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $eGmKJ = parcelRequire("eGmKJ");

var $joKkQ = parcelRequire("joKkQ");
const $d70b02566a310b79$var$dateCellSiblingStyle = null;
const $d70b02566a310b79$var$dateCellTodayStyle = null;
const $d70b02566a310b79$var$dateCellPrevSelectedStyle = null;
const $d70b02566a310b79$var$dateCellSelectedStyle = null;
const $d70b02566a310b79$var$dateCellDisabledStyle = null;
const $d70b02566a310b79$var$dateCellStyles = null;
const $d70b02566a310b79$var$Date = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(function Date({ children: day, isDisabled: isDisabled = false, isFocused: isFocused = false, isToday: isToday = false, dayLong: dayLong, month: month, monthLong: monthLong, onClick: onClick = (0, $eGmKJ.default), isPreviouslySelected: isPreviouslySelected = false, isSelected: isSelected = false, isSibling: isSibling = false, year: year, shouldSetFocus: shouldSetFocus, tabIndex: tabIndex, testId: testId }, _ref) {
    const dateRef = (0, $5uXOq.useRef)({
        day: day,
        month: month,
        year: year,
        isDisabled: isDisabled
    });
    (0, $5uXOq.useEffect)(()=>{
        dateRef.current = {
            day: day,
            month: month,
            year: year,
            isDisabled: isDisabled
        };
    }, [
        day,
        month,
        year,
        isDisabled
    ]);
    const focusRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        if (isFocused && shouldSetFocus && focusRef.current) focusRef.current.focus();
    }, [
        isFocused,
        shouldSetFocus
    ]);
    const handleClick = (0, $5uXOq.useCallback)(()=>{
        const { day: dayValue, month: monthValue, year: yearValue, isDisabled: isDisabledValue } = dateRef.current;
        if (!isDisabledValue) onClick({
            day: dayValue,
            month: monthValue,
            year: yearValue
        });
    }, [
        onClick
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $joKkQ.default), {
        role: "gridcell",
        alignItems: "center",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("button", {
            "aria-current": isToday ? 'date' : undefined,
            "aria-disabled": isDisabled || undefined,
            "aria-label": `${day}, ${dayLong} ${monthLong} ${year}`,
            "aria-pressed": isSelected ? 'true' : 'false',
            tabIndex: isFocused ? tabIndex : -1,
            type: "button",
            onClick: handleClick,
            ref: focusRef,
            "data-disabled": isDisabled || undefined,
            "data-focused": isFocused || undefined,
            "data-prev-selected": isPreviouslySelected || undefined,
            "data-selected": isSelected || undefined,
            "data-sibling": isSibling || undefined,
            "data-today": isToday || undefined,
            "data-testid": testId && (isSelected ? `${testId}--selected-day` : `${testId}--day`),
            className: (0, $bwpsq.default)([
                "_kkk2n7od _2rko1l7b _11c82smr _1h6d3acm _1dqonqa1 _189eyh40 _1e0c1ule _kqswh2mm _16jlkb7n _bfhk18uv _syazj3m3 _80omtlke _85i51b66 _1q511b66 _y4tirdoj _bozgrdoj _y3gn1h6o _pojj194a _10knnqa1 _1wysyh40 _irr314ae _30l3j3m3 _1di61l7b _9h8hj3m3",
                isSibling && "_syaz1wmz _30l31wmz",
                isToday && "_syaz1ldt _k48p1igg _1ywu1ule _1qdgyh40 _18postnw _1hfk1r31 _aetrb3bt _1gufv77o _1czdv77o _g0nfv77o",
                isPreviouslySelected && "_bfhk29zg _syazc8hx _30l3c8hx",
                isSelected && "_bfhk1p4p _syazqueg _irr3quvt _30l31uqy",
                isDisabled && "_syaz7dlb _80om13gf _irr318uv _30l37dlb"
            ]),
            children: day
        })
    });
}));
$d70b02566a310b79$var$Date.displayName = 'Date';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$d70b02566a310b79$export$2e2bcd8739ae039 = $d70b02566a310b79$var$Date;

});
parcelRegister("joKkQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $975a473d4552aaa0$export$2e2bcd8739ae039);
/* grid.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $975a473d4552aaa0$var$rowGapMap = {
    'space.0': "_1p57ze3t",
    'space.025': "_1p57v77o",
    'space.050': "_1p571b66",
    'space.075': "_1p5712x7",
    'space.100': "_1p57u2gc",
    'space.150': "_1p57utpp",
    'space.200': "_1p57pxbi",
    'space.250': "_1p57v47k",
    'space.300': "_1p571ejb",
    'space.400': "_1p57xy5q",
    'space.500': "_1p571jfw",
    'space.600': "_1p57oahv",
    'space.800': "_1p57xncg",
    'space.1000': "_1p571epz"
};
const $975a473d4552aaa0$var$columnGapMap = {
    'space.0': "_gy1pze3t",
    'space.025': "_gy1pv77o",
    'space.050': "_gy1p1b66",
    'space.075': "_gy1p12x7",
    'space.100': "_gy1pu2gc",
    'space.150': "_gy1putpp",
    'space.200': "_gy1ppxbi",
    'space.250': "_gy1pv47k",
    'space.300': "_gy1p1ejb",
    'space.400': "_gy1pxy5q",
    'space.500': "_gy1p1jfw",
    'space.600': "_gy1poahv",
    'space.800': "_gy1pxncg",
    'space.1000': "_gy1p1epz"
};
const $975a473d4552aaa0$var$justifyContentMap = {
    start: "_1bahv2br",
    center: "_1bah1h6o",
    end: "_1bahh9n0",
    'space-between': "_1bah1yb4",
    'space-around': "_1bah1b1v",
    'space-evenly': "_1bahitcz",
    stretch: "_1bah1fhb"
};
const $975a473d4552aaa0$var$alignContentMap = {
    start: "_ae4vv2br",
    center: "_ae4v1h6o",
    end: "_ae4vh9n0",
    'space-between': "_ae4v1yb4",
    'space-around': "_ae4v1b1v",
    'space-evenly': "_ae4vitcz",
    stretch: "_ae4v1fhb"
};
const $975a473d4552aaa0$var$alignItemsMap = {
    start: "_4cvrv2br",
    center: "_4cvr1h6o",
    baseline: "_4cvr1q9y",
    end: "_4cvrh9n0",
    stretch: "_4cvr1fhb"
};
const $975a473d4552aaa0$var$baseStyles = {
    root: "_1e0c11p5 _vchhusvi"
};
const $975a473d4552aaa0$var$gridAutoFlowMap = {
    row: "_wij2vrvc",
    column: "_wij21bp4",
    dense: "_wij218l3",
    'row dense': "_wij2j5tq",
    'column dense': "_wij2adhi"
};
/**
 * __Grid__
 *
 * `Grid` is a primitive component that implements the CSS Grid API.
 *
 * - [Examples](https://atlassian.design/components/primitives/grid/examples)
 * - [Code](https://atlassian.design/components/primitives/grid/code)
 *
 * @example
 * ```tsx
 * import { Grid, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Grid gap="space.100" gridColumns="1fr 1fr">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Grid>
 * )
 * ```
 */ const $975a473d4552aaa0$var$Grid = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: as, alignItems: alignItems, alignContent: alignContent, justifyContent: justifyContent, gap: gap, columnGap: columnGap, rowGap: rowGap, children: children, id: id, role: role, testId: testId, autoFlow: autoFlow, xcss: xcss }, ref)=>{
    const Component = as || 'div';
    return /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
        id: id,
        role: role,
        className: (0, $bwpsq.default)([
            $975a473d4552aaa0$var$baseStyles.root,
            gap && $975a473d4552aaa0$var$columnGapMap[gap],
            columnGap && $975a473d4552aaa0$var$columnGapMap[columnGap],
            gap && $975a473d4552aaa0$var$rowGapMap[gap],
            rowGap && $975a473d4552aaa0$var$rowGapMap[rowGap],
            alignItems && $975a473d4552aaa0$var$alignItemsMap[alignItems],
            alignContent && $975a473d4552aaa0$var$alignContentMap[alignContent],
            justifyContent && $975a473d4552aaa0$var$justifyContentMap[justifyContent],
            autoFlow && $975a473d4552aaa0$var$gridAutoFlowMap[autoFlow],
            xcss
        ]),
        "data-testid": testId,
        ref: ref,
        children: children
    });
}));
$975a473d4552aaa0$var$Grid.displayName = 'Grid';
var $975a473d4552aaa0$export$2e2bcd8739ae039 = $975a473d4552aaa0$var$Grid;

});


parcelRegister("h581D", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c8aba25f4ae00ff$export$2e2bcd8739ae039);
/* week-day-grid.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $joKkQ = parcelRequire("joKkQ");
const $5c8aba25f4ae00ff$var$styles = {
    templateColumns: "_yv0eloeq"
};
/**
 * __Week day grid__
 *
 * A week day grid aligns elements in a 7 wide grid layout.
 *
 */ const $5c8aba25f4ae00ff$var$WeekDayGrid = ({ testId: testId, children: children, isHidden: isHidden })=>{
    const row = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $joKkQ.default), {
        testId: testId,
        xcss: $5c8aba25f4ae00ff$var$styles.templateColumns,
        role: "row",
        children: children
    });
    return isHidden ? /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "aria-hidden": "true",
        children: row
    }) : row;
};
var $5c8aba25f4ae00ff$export$2e2bcd8739ae039 = $5c8aba25f4ae00ff$var$WeekDayGrid;

});


parcelRegister("avO9B", function(module, exports) {

$parcel$export(module.exports, "default", () => $f29b1b1295ce3a84$export$2e2bcd8739ae039);
/* week-header.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $MHKc7 = parcelRequire("MHKc7");
var $dS3PR = parcelRequire("dS3PR");

var $h581D = parcelRequire("h581D");
const $f29b1b1295ce3a84$var$styles = {
    columnHeader: "_1ul98pqr _o5721q9c _1e0c1txw _1bah1h6o"
};
const $f29b1b1295ce3a84$var$WeekHeader = /*#__PURE__*/ (0, $5uXOq.memo)(function WeekHeader({ daysShort: daysShort, testId: testId }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $h581D.default), {
        isHidden: true,
        testId: testId && `${testId}--column-headers`,
        children: daysShort.map((shortDay)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                padding: "space.100",
                xcss: $f29b1b1295ce3a84$var$styles.columnHeader,
                role: "columnheader",
                testId: testId && `${testId}--column-header`,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dS3PR.default), {
                    weight: "bold",
                    size: "UNSAFE_small",
                    align: "center",
                    color: "color.text.subtle",
                    children: shortDay
                })
            }, shortDay))
    });
});
$f29b1b1295ce3a84$var$WeekHeader.displayName = 'WeekHeader';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$f29b1b1295ce3a84$export$2e2bcd8739ae039 = $f29b1b1295ce3a84$var$WeekHeader;

});

parcelRegister("iioJV", function(module, exports) {

$parcel$export(module.exports, "arrowKeys", () => $85c2ac8e9452c4bf$export$8b15eca9c6d5c48a);
$parcel$export(module.exports, "daysPerWeek", () => $85c2ac8e9452c4bf$export$3ae905d9742bef55);
$parcel$export(module.exports, "monthsPerYear", () => $85c2ac8e9452c4bf$export$c9b7c010035d60c6);
$parcel$export(module.exports, "blankStringArray", () => $85c2ac8e9452c4bf$export$8fa20d70624f8b9d);
const $85c2ac8e9452c4bf$export$8b15eca9c6d5c48a = {
    ArrowDown: 'down',
    ArrowLeft: 'left',
    ArrowRight: 'right',
    ArrowUp: 'up'
};
const $85c2ac8e9452c4bf$export$3ae905d9742bef55 = 7;
const $85c2ac8e9452c4bf$export$c9b7c010035d60c6 = 12;
const $85c2ac8e9452c4bf$export$8fa20d70624f8b9d = [];

});

parcelRegister("jihAA", function(module, exports) {

$parcel$export(module.exports, "default", () => $654a69afe715a212$export$2e2bcd8739ae039);

var $33etG = parcelRequire("33etG");

var $f8qry = parcelRequire("f8qry");

var $3EtUb = parcelRequire("3EtUb");
function $654a69afe715a212$export$2e2bcd8739ae039({ day: day, defaultDay: defaultDay, month: month, defaultMonth: defaultMonth, year: year, defaultYear: defaultYear, today: today, selected: selected, defaultSelected: defaultSelected, previouslySelected: previouslySelected, defaultPreviouslySelected: defaultPreviouslySelected }) {
    const { current: { thisDay: thisDay, thisMonth: thisMonth, thisYear: thisYear } } = (0, $f8qry.default)(()=>{
        const now = new Date();
        const thisDay = now.getDate();
        const thisMonth = now.getMonth() + 1;
        const thisYear = now.getFullYear();
        return {
            thisDay: thisDay,
            thisMonth: thisMonth,
            thisYear: thisYear
        };
    });
    const [dayValue, setDayValue] = (0, $33etG.default)(day, ()=>defaultDay || thisDay);
    const [monthValue, setMonthValue] = (0, $33etG.default)(month, ()=>defaultMonth || thisMonth);
    const [yearValue, setYearValue] = (0, $33etG.default)(year, ()=>defaultYear || thisYear);
    const [todayValue] = (0, $33etG.default)(today, ()=>today || `${thisYear}-${(0, $3EtUb.default)(thisMonth)}-${(0, $3EtUb.default)(thisDay)}`);
    const [selectedValue, setSelectedValue] = (0, $33etG.default)(selected, ()=>defaultSelected);
    const [previouslySelectedValue, setPreviouslySelectedValue] = (0, $33etG.default)(previouslySelected, ()=>defaultPreviouslySelected);
    return {
        day: [
            dayValue,
            setDayValue
        ],
        month: [
            monthValue,
            setMonthValue
        ],
        year: [
            yearValue,
            setYearValue
        ],
        today: [
            todayValue
        ],
        selected: [
            selectedValue,
            setSelectedValue
        ],
        previous: [
            previouslySelectedValue,
            setPreviouslySelectedValue
        ]
    };
}

});
parcelRegister("3EtUb", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd804e1790f6d755$export$2e2bcd8739ae039);
function $cd804e1790f6d755$export$2e2bcd8739ae039(num) {
    return num < 10 ? `0${num}` : `${num}`;
}

});


parcelRegister("bbnGB", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ccb38b64bb63461$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $8ccb38b64bb63461$export$2e2bcd8739ae039({ onBlur: onBlur, onFocus: onFocus }) {
    const handleContainerBlur = (0, $5uXOq.useCallback)((event)=>{
        onBlur(event);
    }, [
        onBlur
    ]);
    const handleContainerFocus = (0, $5uXOq.useCallback)((event)=>{
        onFocus(event);
    }, [
        onFocus
    ]);
    return {
        handleContainerBlur: handleContainerBlur,
        handleContainerFocus: handleContainerFocus
    };
}

});

parcelRegister("hbcve", function(module, exports) {

$parcel$export(module.exports, "default", () => $0fe53b5f3382c02e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $eZDAP = parcelRequire("eZDAP");

var $iioJV = parcelRequire("iioJV");

var $6ASl9 = parcelRequire("6ASl9");

var $5wbTt = parcelRequire("5wbTt");
function $0fe53b5f3382c02e$var$useGetCalendarWithSixthWeek(calendar, { month: month, year: year, weekStartDay: weekStartDay }) {
    const shouldDisplaySixthWeek = calendar.length % 6;
    const calendarLastValue = calendar[calendar.length - 1];
    return (0, $5uXOq.useMemo)(()=>{
        // Some months jump between 5 and 6 weeks to display. In some cases 4 (Feb
        // with the 1st on a Monday etc). This ensures the UI doesn't jump around by
        // catering to always showing 6 weeks.
        if (shouldDisplaySixthWeek) {
            const lastDayIsSibling = calendarLastValue.siblingMonth;
            const sliceStart = lastDayIsSibling ? (0, $iioJV.daysPerWeek) : 0;
            return (0, $5wbTt.default)(year, month, {
                weekStartDay: weekStartDay
            }).slice(sliceStart, sliceStart + (0, $iioJV.daysPerWeek)).map((date)=>({
                    ...date,
                    siblingMonth: true
                }));
        }
    }, [
        calendarLastValue,
        month,
        shouldDisplaySixthWeek,
        weekStartDay,
        year
    ]);
}
function $0fe53b5f3382c02e$export$2e2bcd8739ae039({ day: day, daysLong: daysLong, month: month, year: year, today: today, disabled: disabled, disabledDateFilter: disabledDateFilter, minDate: minDateString, maxDate: maxDateString, selected: selected, previouslySelected: previouslySelected, weekStartDay: weekStartDay }) {
    const calendar = (0, $5uXOq.useMemo)(()=>(0, $5wbTt.default)(year, month - 1, {
            weekStartDay: weekStartDay
        }), [
        month,
        weekStartDay,
        year
    ]);
    const calendarWithSixthWeek = $0fe53b5f3382c02e$var$useGetCalendarWithSixthWeek(calendar, {
        month: month,
        year: year,
        weekStartDay: weekStartDay
    });
    if (calendarWithSixthWeek) calendar.push(...calendarWithSixthWeek);
    const minDate = minDateString ? (0, $eZDAP.default)(minDateString) : undefined;
    const maxDate = maxDateString ? (0, $eZDAP.default)(maxDateString) : undefined;
    const needJsDate = minDateString || maxDateString;
    return (0, $5uXOq.useMemo)(()=>{
        const weeks = [];
        calendar.forEach((date)=>{
            const dateAsString = (0, $6ASl9.default)(date, {
                fixMonth: true
            });
            const JSDate = needJsDate ? (0, $eZDAP.default)(dateAsString) : undefined;
            let week;
            if (date.weekDay === weekStartDay) {
                week = {
                    id: dateAsString,
                    values: []
                };
                weeks.push(week);
            } else week = weeks[weeks.length - 1];
            const weekDayOffset = (date.weekDay - weekStartDay) % 7;
            // Define a bunch of `const`s
            const weekDayName = daysLong[weekDayOffset];
            const isDisabledByArray = disabled ? disabled.indexOf(dateAsString) > -1 : false;
            const isDisabledByFilter = disabledDateFilter ? disabledDateFilter(dateAsString) : false;
            const isDisabledByMin = minDate && JSDate ? JSDate < minDate : false;
            const isDisabledByMax = maxDate && JSDate ? JSDate > maxDate : false;
            const isDisabled = isDisabledByArray || isDisabledByFilter || isDisabledByMin || isDisabledByMax;
            const isFocused = day === date.day && !date.siblingMonth;
            const isPreviouslySelected = !isDisabled && previouslySelected.indexOf(dateAsString) > -1;
            const isSelected = !isDisabled && selected.indexOf(dateAsString) > -1;
            const isSiblingMonth = !!date.siblingMonth;
            const isToday = today === dateAsString;
            week.values.push({
                id: dateAsString,
                isDisabled: isDisabled,
                isFocused: isFocused,
                isToday: isToday,
                month: date.month + 1,
                isPreviouslySelected: isPreviouslySelected,
                isSelected: isSelected,
                isSiblingMonth: isSiblingMonth,
                year: date.year,
                day: date.day,
                weekDayName: weekDayName
            });
        });
        return weeks;
    }, [
        calendar,
        day,
        disabled,
        disabledDateFilter,
        minDate,
        maxDate,
        needJsDate,
        previouslySelected,
        selected,
        today,
        weekStartDay,
        daysLong
    ]);
}

});
parcelRegister("6ASl9", function(module, exports) {

$parcel$export(module.exports, "default", () => $b6ae62fd51c4538f$export$2e2bcd8739ae039);

var $3EtUb = parcelRequire("3EtUb");
function $b6ae62fd51c4538f$export$2e2bcd8739ae039(date, options) {
    return `${date.year}-${(0, $3EtUb.default)(date.month + (options && options.fixMonth ? 1 : 0))}-${(0, $3EtUb.default)(date.day)}`;
}

});

parcelRegister("5wbTt", function(module, exports) {

$parcel$export(module.exports, "default", () => $3dff1ed1384abe91$export$2e2bcd8739ae039);
/**
 * Logic taken from https://github.com/WesSouza/calendar-base which is not maintained for quite sometime.
 * This will help us fixing any issue we might get or any new functionality we might want to support.
 * Not changing much code below. Just removed those parts which we don't need.
 */ 
var $iioJV = parcelRequire("iioJV");

var $9Zmg7 = parcelRequire("9Zmg7");
function $3dff1ed1384abe91$export$2e2bcd8739ae039(year, month, { weekStartDay: weekStartDay = 0 } = {
    weekStartDay: 0
}) {
    const date = new Date(Date.UTC(year, month, 1, 0, 0, 0, 0));
    const utcYear = date.getUTCFullYear();
    const utcMonth = date.getUTCMonth();
    const calendar = [];
    const firstDay = date.getUTCDay();
    const firstDate = -(((0, $iioJV.daysPerWeek) - weekStartDay + firstDay) % (0, $iioJV.daysPerWeek));
    const lastDate = (0, $9Zmg7.default)(utcYear, utcMonth);
    const lastDay = (lastDate - firstDate) % (0, $iioJV.daysPerWeek);
    const lastDateOfPreviousMonth = (0, $9Zmg7.default)(utcYear, utcMonth - 1);
    let dateCounter = firstDate;
    let currentDay;
    let currentDate;
    let currentDateObject = null;
    let calculatedMonth;
    let calculatedYear;
    const maxDateCount = lastDate - dateCounter + (lastDay !== 0 ? (0, $iioJV.daysPerWeek) - lastDay : 0) + firstDate;
    while(dateCounter < maxDateCount){
        currentDate = dateCounter + 1;
        currentDay = ((dateCounter < 1 ? (0, $iioJV.daysPerWeek) + dateCounter : dateCounter) + firstDay) % (0, $iioJV.daysPerWeek);
        if (currentDate < 1 || currentDate > lastDate) {
            if (currentDate < 1) {
                calculatedMonth = utcMonth - 1;
                calculatedYear = utcYear;
                if (calculatedMonth < 0) {
                    calculatedMonth = (0, $iioJV.monthsPerYear) - 1;
                    calculatedYear--;
                }
                currentDate = lastDateOfPreviousMonth + currentDate;
            } else if (currentDate > lastDate) {
                calculatedMonth = utcMonth + 1;
                calculatedYear = utcYear;
                if (calculatedMonth > (0, $iioJV.monthsPerYear) - 1) {
                    calculatedMonth = 0;
                    calculatedYear++;
                }
                currentDate = dateCounter - lastDate + 1;
            }
            if (calculatedMonth !== undefined && calculatedYear !== undefined) currentDateObject = {
                day: currentDate,
                weekDay: currentDay,
                month: calculatedMonth,
                year: calculatedYear,
                siblingMonth: true
            };
        } else currentDateObject = {
            day: currentDate,
            weekDay: currentDay,
            month: utcMonth,
            year: utcYear
        };
        calendar.push(currentDateObject);
        dateCounter++;
    }
    return calendar;
}

});
parcelRegister("9Zmg7", function(module, exports) {

$parcel$export(module.exports, "default", () => $878800070b837d93$export$2e2bcd8739ae039);
function $878800070b837d93$export$2e2bcd8739ae039(year, month) {
    return new Date(year, month + 1, 0).getDate();
}

});



parcelRegister("2TGJ3", function(module, exports) {

$parcel$export(module.exports, "default", () => $caae4eff24f6e8d0$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $iioJV = parcelRequire("iioJV");

var $6ASl9 = parcelRequire("6ASl9");

var $9Zmg7 = parcelRequire("9Zmg7");
const $caae4eff24f6e8d0$var$getNextMonth = (monthValue, yearValue)=>{
    let month = monthValue;
    let year = yearValue;
    if (month === (0, $iioJV.monthsPerYear)) {
        month = 1;
        year += 1;
    } else month += 1;
    return {
        month: month,
        year: year
    };
};
const $caae4eff24f6e8d0$var$getPrevMonth = (monthValue, yearValue)=>{
    let month = monthValue;
    let year = yearValue;
    if (month === 1) {
        month = (0, $iioJV.monthsPerYear);
        year -= 1;
    } else month -= 1;
    return {
        month: month,
        year: year
    };
};
function $caae4eff24f6e8d0$export$2e2bcd8739ae039({ day: [dayValue, setDayValue], month: [monthValue, setMonthValue], year: [yearValue, setYearValue], shouldSetFocus: [_shouldSetFocus, setShouldSetFocus], onChange: onChange }) {
    const dateRef = (0, $5uXOq.useRef)({
        day: dayValue,
        month: monthValue,
        year: yearValue
    });
    (0, $5uXOq.useEffect)(()=>{
        dateRef.current = {
            day: dayValue,
            month: monthValue,
            year: yearValue
        };
    }, [
        dayValue,
        monthValue,
        yearValue
    ]);
    const triggerOnChange = (0, $5uXOq.useCallback)(({ year: year, month: month, day: day, type: type })=>{
        const iso = (0, $6ASl9.default)({
            year: year,
            month: month,
            day: day
        });
        const isFocusableType = [
            'up',
            'down',
            'left',
            'right'
        ].includes(type);
        onChange({
            day: day,
            month: month,
            year: year,
            iso: iso,
            type: type
        });
        setDayValue(day);
        setMonthValue(month);
        setYearValue(year);
        setShouldSetFocus(isFocusableType);
    }, [
        onChange,
        setDayValue,
        setMonthValue,
        setYearValue,
        setShouldSetFocus
    ]);
    const navigate = (0, $5uXOq.useCallback)((type)=>{
        const { day: day, month: month, year: year } = dateRef.current;
        if (type === 'down') {
            const next = day + (0, $iioJV.daysPerWeek);
            const daysInMonth = (0, $9Zmg7.default)(year, month - 1);
            if (next > daysInMonth) {
                const { month: nextMonth, year: nextYear } = $caae4eff24f6e8d0$var$getNextMonth(month, year);
                triggerOnChange({
                    year: nextYear,
                    month: nextMonth,
                    day: next - daysInMonth,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: next,
                type: type
            });
        } else if (type === 'left') {
            const prev = day - 1;
            if (prev < 1) {
                const { month: prevMonth, year: prevYear } = $caae4eff24f6e8d0$var$getPrevMonth(month, year);
                const prevDay = (0, $9Zmg7.default)(prevYear, prevMonth - 1);
                triggerOnChange({
                    year: prevYear,
                    month: prevMonth,
                    day: prevDay,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: prev,
                type: type
            });
        } else if (type === 'right') {
            const next = day + 1;
            const daysInMonth = (0, $9Zmg7.default)(year, month - 1);
            if (next > daysInMonth) {
                const { month: nextMonth, year: nextYear } = $caae4eff24f6e8d0$var$getNextMonth(month, year);
                triggerOnChange({
                    year: nextYear,
                    month: nextMonth,
                    day: 1,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: next,
                type: type
            });
        } else if (type === 'up') {
            const prev = day - (0, $iioJV.daysPerWeek);
            if (prev < 1) {
                const { month: prevMonth, year: prevYear } = $caae4eff24f6e8d0$var$getPrevMonth(month, year);
                const prevDay = (0, $9Zmg7.default)(prevYear, prevMonth - 1) + prev;
                triggerOnChange({
                    year: prevYear,
                    month: prevMonth,
                    day: prevDay,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: prev,
                type: type
            });
        }
    }, [
        triggerOnChange
    ]);
    const handleClickNextMonth = (0, $5uXOq.useCallback)(()=>{
        const { day: day, month: month, year: year } = {
            ...dateRef.current,
            ...$caae4eff24f6e8d0$var$getNextMonth(dateRef.current.month, dateRef.current.year)
        };
        triggerOnChange({
            day: day,
            month: month,
            year: year,
            type: 'nextMonth'
        });
    }, [
        triggerOnChange
    ]);
    const handleClickNextYear = (0, $5uXOq.useCallback)(()=>{
        const { day: day, month: month, year: year } = dateRef.current;
        triggerOnChange({
            day: day,
            month: month,
            year: year + 1,
            type: 'nextYear'
        });
    }, [
        triggerOnChange
    ]);
    const handleClickPrevMonth = (0, $5uXOq.useCallback)(()=>{
        const { day: day, month: month, year: year } = {
            ...dateRef.current,
            ...$caae4eff24f6e8d0$var$getPrevMonth(dateRef.current.month, dateRef.current.year)
        };
        triggerOnChange({
            day: day,
            month: month,
            year: year,
            type: 'prevMonth'
        });
    }, [
        triggerOnChange
    ]);
    const handleClickPrevYear = (0, $5uXOq.useCallback)(()=>{
        const { day: day, month: month, year: year } = dateRef.current;
        triggerOnChange({
            day: day,
            month: month,
            year: year - 1,
            type: 'prevYear'
        });
    }, [
        triggerOnChange
    ]);
    return {
        navigate: navigate,
        handleClickNextMonth: handleClickNextMonth,
        handleClickNextYear: handleClickNextYear,
        handleClickPrevMonth: handleClickPrevMonth,
        handleClickPrevYear: handleClickPrevYear
    };
}

});

parcelRegister("f9D1v", function(module, exports) {

$parcel$export(module.exports, "default", () => $42ec54640e7b9de4$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $iioJV = parcelRequire("iioJV");

var $6ASl9 = parcelRequire("6ASl9");
function $42ec54640e7b9de4$export$2e2bcd8739ae039({ day: [dayValue], month: [monthValue], year: [yearValue], selected: [selectedValue, setSelectedValue], previous: [, setPreviouslySelectedValue], onSelect: onSelect, navigate: navigate }) {
    const dateRef = (0, $5uXOq.useRef)({
        day: dayValue,
        month: monthValue,
        year: yearValue
    });
    (0, $5uXOq.useEffect)(()=>{
        dateRef.current = {
            day: dayValue,
            month: monthValue,
            year: yearValue
        };
    }, [
        dayValue,
        monthValue,
        yearValue
    ]);
    const triggerOnSelect = (0, $5uXOq.useCallback)(({ year: year, month: month, day: day })=>{
        const iso = (0, $6ASl9.default)({
            year: year,
            month: month,
            day: day
        });
        onSelect({
            day: day,
            month: month,
            year: year,
            iso: iso
        });
        setPreviouslySelectedValue(selectedValue);
        setSelectedValue([
            iso
        ]);
    }, [
        onSelect,
        selectedValue,
        setPreviouslySelectedValue,
        setSelectedValue
    ]);
    const handleClickDay = (0, $5uXOq.useCallback)(({ year: year, month: month, day: day })=>{
        triggerOnSelect({
            year: year,
            month: month,
            day: day
        });
    }, [
        triggerOnSelect
    ]);
    const handleContainerKeyDown = (0, $5uXOq.useCallback)((e)=>{
        const { key: key } = e;
        const arrowKey = (0, $iioJV.arrowKeys)[key];
        if (key === 'Enter' || key === ' ') {
            e.preventDefault();
            triggerOnSelect(dateRef.current);
        } else if (arrowKey) {
            e.preventDefault();
            navigate(arrowKey);
        }
    }, [
        triggerOnSelect,
        navigate
    ]);
    return {
        handleClickDay: handleClickDay,
        handleContainerKeyDown: handleContainerKeyDown
    };
}

});

parcelRegister("9efze", function(module, exports) {

$parcel$export(module.exports, "default", () => $fbd6f430b06675a1$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7qZ1x = parcelRequire("7qZ1x");
function $fbd6f430b06675a1$export$2e2bcd8739ae039({ locale: locale, weekStartDay: weekStartDay }) {
    const l10n = (0, $5uXOq.useMemo)(()=>(0, $7qZ1x.createLocalizationProvider)(locale), [
        locale
    ]);
    const monthsLong = (0, $5uXOq.useMemo)(()=>l10n.getMonthsLong(), [
        l10n
    ]);
    const daysShort = (0, $5uXOq.useMemo)(()=>l10n.getDaysShort(weekStartDay), [
        l10n,
        weekStartDay
    ]);
    const daysLong = (0, $5uXOq.useMemo)(()=>l10n.getDaysLong(weekStartDay), [
        l10n,
        weekStartDay
    ]);
    return {
        monthsLong: monthsLong,
        daysShort: daysShort,
        daysLong: daysLong
    };
}

});
parcelRegister("7qZ1x", function(module, exports) {

$parcel$export(module.exports, "createLocalizationProvider", () => $71bdd27445bf5301$export$ea56ca58f08ffa52);

var $lCAti = parcelRequire("lCAti");

var $is0Fy = parcelRequire("is0Fy");

var $1cWOp = parcelRequire("1cWOp");
const $71bdd27445bf5301$export$ea56ca58f08ffa52 = (locale, formatterOptions)=>{
    // Intl.DateFormat expects locales in the format of 'la-CO' however it is
    // common for locale to be provided in the format of 'la_CO', where 'la' is
    // language and 'CO' is country.
    const normalizedLocale = (0, $lCAti.normalizeLocale)(locale);
    const formatDate = (date)=>Intl.DateTimeFormat(normalizedLocale).format(date);
    const formatTime = (date)=>Intl.DateTimeFormat(normalizedLocale, {
            hour: 'numeric',
            minute: 'numeric'
        }).format(date);
    const getDays = (weekStartDay = 0, length)=>{
        const dayFormatter = Intl.DateTimeFormat(normalizedLocale, {
            weekday: length
        });
        // Right now there is no way to find out first day of the week based on Intl (locale)
        // api. Check issue here: https://github.com/tc39/ecma402/issues/6
        // So we rotate the weekdays based on #weekStartDay parameter.
        const weekdays = [
            0,
            1,
            2,
            3,
            4,
            5,
            6
        ];
        const rotatedWeekdays = weekStartDay > 0 ? [
            ...weekdays.slice(weekStartDay),
            ...weekdays.slice(0, weekStartDay)
        ] : weekdays;
        return rotatedWeekdays.map((day)=>{
            // Some short days are longer than 3 characters but are unique if the first
            // three non-white characters are used.
            const result = dayFormatter// Date range chosen which has a Sun-Sat range so we can extract the names
            .format(new Date(2000, 9, day + 1, 12))// \u200E matches on the Left-to-Right Mark character in IE/Edge
            .replace(/[\s\u200E]/g, '');
            // If short days, only return first three characters. Else return whole thing
            if (length === 'short') return result.substring(0, 3);
            else return result;
        });
    };
    const getDaysShort = (weekStartDay = 0)=>{
        return getDays(weekStartDay, 'short');
    };
    const getDaysLong = (weekStartDay = 0)=>{
        return getDays(weekStartDay, 'long');
    };
    const getMonthsLong = ()=>{
        const monthFormatter = Intl.DateTimeFormat(normalizedLocale, {
            month: 'long'
        });
        return [
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11
        ].map((month)=>// Date chosen for no real reason, the only important part is the month
            // Using 2020 'cos Safari has a faulty implementation when we use the year 2000
            // Intl.DateTimeFormat("en-US", { month: 'long'}).format(new Date(2000, 3, 1))
            // should give "April" but gives "March" in Safari
            monthFormatter.format(new Date(2020, month, 1)));
    };
    const parseDate = (date, options = {})=>(0, $is0Fy.createDateParser)(normalizedLocale)(date, options);
    const formatToParts = (date = new Date())=>{
        const formatter = new Intl.DateTimeFormat(normalizedLocale, formatterOptions);
        /**
		 * Safari has a bug that returns the wrong month for years 2005 and before.
		 * The error occurs when the passed date has been created with numbers, like new Date(2000, 3, 1)
		 * Not all the months fail in each year. To ensure the correct output,
		 * we select 2020 as the base year for the whole date,
		 * then we replace in the result the original input year
		 */ const fixedDate = new Date(date);
        fixedDate.setFullYear(2020);
        const fixedParts = (0, $1cWOp.toFormattedParts)(formatter.formatToParts(fixedDate));
        const originalParts = (0, $1cWOp.toFormattedParts)(formatter.formatToParts(date));
        if (fixedParts.year) fixedParts.year = originalParts.year;
        /**
		 * Chrome has a bug that returns hour="00" when it's 12:00pm in certain languages
		 * We fix it by detecting the real time with getHours method
		 */ if (fixedParts.hour === '00' && fixedDate.getHours() === 12) fixedParts.hour = '12';
        return fixedParts;
    };
    return {
        getDaysShort: getDaysShort,
        getDaysLong: getDaysLong,
        getMonthsLong: getMonthsLong,
        formatDate: formatDate,
        formatTime: formatTime,
        parseDate: parseDate,
        formatToParts: formatToParts
    };
};

});
parcelRegister("lCAti", function(module, exports) {

$parcel$export(module.exports, "normalizeLocale", () => $13af55a9724edafd$export$dca0327c9b9c6498);
const $13af55a9724edafd$export$dca0327c9b9c6498 = (locale)=>locale.replace(/_/g, '-');

});

parcelRegister("is0Fy", function(module, exports) {

$parcel$export(module.exports, "createDateParser", () => $d8bb223589902df4$export$cfa2ef2687faeda2);

var $lCAti = parcelRequire("lCAti");

var $3wYKB = parcelRequire("3wYKB");
const $d8bb223589902df4$var$INVALID_DATE = new Date(NaN);
const $d8bb223589902df4$var$INVARIANT = {
    year: 1993,
    month: 2,
    day: 18
};
const $d8bb223589902df4$var$INVARIANT_DATE = (0, $3wYKB.toDate)($d8bb223589902df4$var$INVARIANT);
const $d8bb223589902df4$var$FORMAT_EXTRACTOR_REGEX = /(\d+)[^\d]+(\d+)[^\d]+(\d+)\.?/;
const $d8bb223589902df4$var$DATE_PARSER_REGEX = /(\d+)[^\d]*(\d+)?[^\d]*(\d+)?\.?/;
// Internet Explorer returns non-printing characters when formatting a date
const $d8bb223589902df4$var$stripExtras = (str)=>str.replace(/\u200E/g, '');
const $d8bb223589902df4$var$extractDateParts = (matchResult)=>{
    return matchResult// Get the 3 capture groups
    .splice(1, 4)// Convert them to numbers
    .map((datePart)=>parseInt(datePart, 10));
};
const $d8bb223589902df4$export$cfa2ef2687faeda2 = (locale)=>{
    // Intl.DateFormat expects locales in the format of 'la-CO' however it is
    // common for locale to be provided in the format of 'la_CO', where 'la' is
    // language and 'CO' is country.
    const normalizedLocale = (0, $lCAti.normalizeLocale)(locale);
    const dateFormatter = Intl.DateTimeFormat(normalizedLocale);
    // Generate a date string from a hard coded date, this allows us to determine
    // the year/month/day position for the provided locale.
    const rawDateString = dateFormatter.format($d8bb223589902df4$var$INVARIANT_DATE);
    const shortDate = $d8bb223589902df4$var$stripExtras(rawDateString);
    // Extract the date pieces from the locale formatted date string
    const formatMatch = shortDate.match($d8bb223589902df4$var$FORMAT_EXTRACTOR_REGEX);
    if (!formatMatch) throw new Error('Unable to create DateParser');
    const formatParts = $d8bb223589902df4$var$extractDateParts(formatMatch);
    // Find the year/month/day positions of the locale formatted invariant date
    const yearPosition = formatParts.indexOf($d8bb223589902df4$var$INVARIANT.year);
    const monthPosition = formatParts.indexOf($d8bb223589902df4$var$INVARIANT.month);
    const dayPosition = formatParts.indexOf($d8bb223589902df4$var$INVARIANT.day);
    return (date, options = {})=>{
        const dateMatch = $d8bb223589902df4$var$stripExtras(date).match($d8bb223589902df4$var$DATE_PARSER_REGEX);
        if (!dateMatch) return $d8bb223589902df4$var$INVALID_DATE;
        const dateParts = $d8bb223589902df4$var$extractDateParts(dateMatch);
        // Use the previously extracted year/month/day positions to extract each
        // date piece.
        const extractedDate = {
            year: dateParts[yearPosition],
            month: dateParts[monthPosition],
            day: dateParts[dayPosition]
        };
        const normalizedDate = (0, $3wYKB.normalizeDate)(extractedDate, options?.defaultFirstDay);
        if (!(0, $3wYKB.isValid)(normalizedDate)) return $d8bb223589902df4$var$INVALID_DATE;
        return (0, $3wYKB.toDate)(normalizedDate);
    };
};

});
parcelRegister("3wYKB", function(module, exports) {

$parcel$export(module.exports, "toDate", () => $121d324fc62f760d$export$e67a095c620b86fe);
$parcel$export(module.exports, "isValid", () => $121d324fc62f760d$export$1ea939691cdc45b8);
$parcel$export(module.exports, "normalizeDate", () => $121d324fc62f760d$export$fcc71269590ba0a8);
/**
 * A numerical representation of a date:
 *  - year: any positive integer
 *  - month: 1 - 12 (Jan - Dec)
 *  - day: 1 - [28, 29, 30, 31] (depending on month)
 */ const $121d324fc62f760d$export$abe96da78d4f59dd = (date)=>({
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate()
    });
const $121d324fc62f760d$export$e67a095c620b86fe = (date)=>// The 'proper' month is stored in a DateObj but Date expects month index
    new Date(date.year, date.month - 1, date.day);
const $121d324fc62f760d$export$553d7fa8e3805fc0 = (year)=>{
    return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
};
const $121d324fc62f760d$export$f645ddd439eb259d = (year, month)=>{
    // February depends on leap year
    if (month === 2 && $121d324fc62f760d$export$553d7fa8e3805fc0(year)) return 29;
    return [
        31,
        28,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ][month - 1];
};
const $121d324fc62f760d$export$1ea939691cdc45b8 = (date)=>{
    const { year: year, month: month, day: day } = date;
    const daysInMonth = $121d324fc62f760d$export$f645ddd439eb259d(year, month);
    return 1 <= month && month <= 12 && 1 <= day && day <= daysInMonth;
};
const $121d324fc62f760d$export$fcc71269590ba0a8 = (date, defaultFirstDay = false)=>{
    const now = $121d324fc62f760d$export$abe96da78d4f59dd(new Date());
    const { year: year, month: month, day: day } = date;
    // 19 should evaluate to 2019
    const fullYear = year < 100 ? 2000 + year : year;
    // Missing date pieces are filled in with their current date values
    const normalizedYear = !isNaN(fullYear) ? fullYear : now.year;
    const normalizedMonth = !isNaN(month) && month !== 0 ? month : now.month;
    const normalizedDay = !isNaN(day) && day !== 0 ? day : month !== 0 && defaultFirstDay ? 1 : now.day;
    return {
        year: normalizedYear,
        month: normalizedMonth,
        day: normalizedDay
    };
};

});


parcelRegister("1cWOp", function(module, exports) {

$parcel$export(module.exports, "toFormattedParts", () => $56bd04270448c035$export$9b7ca29af37c192);
const $56bd04270448c035$export$9b7ca29af37c192 = (rawParts)=>rawParts.reduce((result, datePart)=>({
            ...result,
            [datePart.type]: datePart.value
        }), {});

});




parcelRegister("qfj8c", function(module, exports) {

$parcel$export(module.exports, "HelperMessage", () => $b2d5b368fed948c9$export$8fbe3c7d0ed2c683);
$parcel$export(module.exports, "ErrorMessage", () => $b2d5b368fed948c9$export$915e9e7bd4f0f96d);
$parcel$export(module.exports, "ValidMessage", () => $b2d5b368fed948c9$export$5505afb209a532c8);
$parcel$export(module.exports, "MessageWrapper", () => $b2d5b368fed948c9$export$ec445f12f63100a5);
/* messages.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $059q9 = parcelRequire("059q9");

var $g4M8x = parcelRequire("g4M8x");

var $dRN65 = parcelRequire("dRN65");
const $b2d5b368fed948c9$var$messageStyles = null;
const $b2d5b368fed948c9$var$messageAppearanceStyles = {
    default: "_syaz1wmz",
    error: "_syaze6sf",
    valid: "_syazy73q"
};
const $b2d5b368fed948c9$var$iconWrapperStyles = {
    root: "_1e0c1txw _4t3i7vkz _4cvr1h6o"
};
const $b2d5b368fed948c9$var$IconWrapper = ({ children: children })=>/*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        className: (0, $bwpsq.default)([
            $b2d5b368fed948c9$var$iconWrapperStyles.root
        ]),
        children: children
    });
const $b2d5b368fed948c9$var$messageIcons = {
    error: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($059q9))), {
        LEGACY_margin: "0 -2px 0 0",
        color: "currentColor",
        LEGACY_size: "small",
        label: "error"
    }),
    valid: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($g4M8x))), {
        LEGACY_margin: "0 -2px 0 0",
        color: "currentColor",
        LEGACY_size: "small",
        label: "success"
    })
};
const $b2d5b368fed948c9$var$Message = ({ children: children, appearance: appearance = 'default', fieldId: fieldId, testId: testId })=>{
    const icon = $b2d5b368fed948c9$var$messageIcons[appearance];
    const messageRef = (0, $5uXOq.useRef)(null);
    const [hasMessageWrapper, setHasMessageWrapper] = (0, $5uXOq.useState)(false);
    const { isWrapper: isWrapper } = (0, $5uXOq.useContext)($b2d5b368fed948c9$var$MessageWrapperContext);
    (0, $5uXOq.useEffect)(()=>{
        if (messageRef.current) setHasMessageWrapper(isWrapper);
    }, [
        isWrapper
    ]);
    /**
   * The wrapping span is necessary to preserve spaces between children.
   * Otherwise the flex layout of the message will remove any whitespace
   * between children.
   *
   * If the child is just a string, this is not required and we can use one
   * less DOM element.
   */ const content = typeof children === 'string' ? children : /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        children: children
    });
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        "data-testid": testId,
        id: fieldId,
        ref: messageRef,
        // For backwards compatability, if there is a wrapper, aria-live is not needed
        "aria-live": !hasMessageWrapper ? 'polite' : undefined,
        className: (0, $bwpsq.default)([
            "_zulp12x7 _11c8dcr7 _1e0c1txw _1bah1q9y _1pfh1b66",
            $b2d5b368fed948c9$var$messageAppearanceStyles[appearance]
        ]),
        children: [
            icon && /*#__PURE__*/ (0, $2OMIu.jsx)($b2d5b368fed948c9$var$IconWrapper, {
                children: icon
            }),
            content
        ]
    });
};
const $b2d5b368fed948c9$export$8fbe3c7d0ed2c683 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $dRN65.FieldId).Consumer, {
        children: (fieldId)=>/*#__PURE__*/ (0, $2OMIu.jsx)($b2d5b368fed948c9$var$Message, {
                fieldId: fieldId ? `${fieldId}-helper` : undefined,
                testId: testId,
                children: children
            })
    });
const $b2d5b368fed948c9$export$915e9e7bd4f0f96d = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $dRN65.FieldId).Consumer, {
        children: (fieldId)=>/*#__PURE__*/ (0, $2OMIu.jsx)($b2d5b368fed948c9$var$Message, {
                appearance: "error",
                fieldId: fieldId ? `${fieldId}-error` : undefined,
                testId: testId,
                children: children
            })
    });
const $b2d5b368fed948c9$export$5505afb209a532c8 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $dRN65.FieldId).Consumer, {
        children: (fieldId)=>/*#__PURE__*/ (0, $2OMIu.jsx)($b2d5b368fed948c9$var$Message, {
                appearance: "valid",
                fieldId: fieldId ? `${fieldId}-valid` : undefined,
                testId: testId,
                children: children
            })
    });
/**
 * __Message wrapper context__
 *
 * A message wrapper context allows the children to check
 * if it is contained within the MessageWrapper.
 */ const $b2d5b368fed948c9$var$MessageWrapperContext = /*#__PURE__*/ (0, $5uXOq.createContext)({
    isWrapper: false
});
const $b2d5b368fed948c9$export$ec445f12f63100a5 = ({ children: children })=>{
    const contextValue = {
        isWrapper: true
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)($b2d5b368fed948c9$var$MessageWrapperContext.Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            "aria-live": "polite",
            "data-testid": "message-wrapper",
            children: children
        })
    });
};

});
parcelRegister("059q9", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::98606756a92a07f2e7585c76d3cbd084>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $00f7c68b1ac9eeb3$var$_react = $00f7c68b1ac9eeb3$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $00f7c68b1ac9eeb3$var$_error = $00f7c68b1ac9eeb3$var$_interopRequireDefault((parcelRequire("hAZqC")));

var $00f7c68b1ac9eeb3$var$_error2 = $00f7c68b1ac9eeb3$var$_interopRequireDefault((parcelRequire("7nnPp")));
function $00f7c68b1ac9eeb3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ErrorIcon.
 * This component is ErrorIcon, with `UNSAFE_fallbackIcon` set to "ErrorIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $00f7c68b1ac9eeb3$var$ErrorIcon = (props)=>/*#__PURE__*/ $00f7c68b1ac9eeb3$var$_react.default.createElement($00f7c68b1ac9eeb3$var$_error.default, Object.assign({
        LEGACY_fallbackIcon: $00f7c68b1ac9eeb3$var$_error2.default
    }, props));
$00f7c68b1ac9eeb3$var$ErrorIcon.Name = 'ErrorIconMigration';
var $00f7c68b1ac9eeb3$var$_default = module.exports.default = $00f7c68b1ac9eeb3$var$ErrorIcon;

});
parcelRegister("hAZqC", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d97879d6b889ef4621929c7dd705b0ff>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ccf572dfbabebdf7$var$_react = $ccf572dfbabebdf7$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $ccf572dfbabebdf7$var$_baseNew = $ccf572dfbabebdf7$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $ccf572dfbabebdf7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Error".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ccf572dfbabebdf7$var$ErrorIcon = (props)=>/*#__PURE__*/ $ccf572dfbabebdf7$var$_react.default.createElement($ccf572dfbabebdf7$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M.384 5.116 5.116.384a1.25 1.25 0 0 1 1.768 0l4.732 4.732a1.25 1.25 0 0 1 0 1.768l-4.732 4.732a1.25 1.25 0 0 1-1.768 0L.384 6.884a1.25 1.25 0 0 1 0-1.768M6.75 2.5v4h-1.5v-4zM6 9.75a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$ccf572dfbabebdf7$var$ErrorIcon.displayName = 'ErrorIcon';
var $ccf572dfbabebdf7$var$_default = module.exports.default = $ccf572dfbabebdf7$var$ErrorIcon;

});


parcelRegister("g4M8x", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d345d1980a5e7ce7680063890c36f7e3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bb425bfe72dc5677$var$_react = $bb425bfe72dc5677$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $bb425bfe72dc5677$var$_success = $bb425bfe72dc5677$var$_interopRequireDefault((parcelRequire("hs3k8")));

var $bb425bfe72dc5677$var$_success2 = $bb425bfe72dc5677$var$_interopRequireDefault((parcelRequire("kJ541")));
function $bb425bfe72dc5677$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for SuccessIcon.
 * This component is SuccessIcon, with `UNSAFE_fallbackIcon` set to "EditorSuccessIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bb425bfe72dc5677$var$SuccessIcon = (props)=>/*#__PURE__*/ $bb425bfe72dc5677$var$_react.default.createElement($bb425bfe72dc5677$var$_success.default, Object.assign({
        LEGACY_fallbackIcon: $bb425bfe72dc5677$var$_success2.default
    }, props));
$bb425bfe72dc5677$var$SuccessIcon.Name = 'SuccessIconMigration';
var $bb425bfe72dc5677$var$_default = module.exports.default = $bb425bfe72dc5677$var$SuccessIcon;

});
parcelRegister("hs3k8", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b91b2ac4848db507d9eb71a2b738b7fc>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0347594f5084a834$var$_react = $0347594f5084a834$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $0347594f5084a834$var$_baseNew = $0347594f5084a834$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $0347594f5084a834$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Success".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0347594f5084a834$var$SuccessIcon = (props)=>/*#__PURE__*/ $0347594f5084a834$var$_react.default.createElement($0347594f5084a834$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 6a6 6 0 1 1 12 0A6 6 0 0 1 0 6m9.389-1.77-1.153-.96-3.174 3.808L3.765 5.52l-1.153.96 1.875 2.25a.75.75 0 0 0 1.153 0z" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$0347594f5084a834$var$SuccessIcon.displayName = 'SuccessIcon';
var $0347594f5084a834$var$_default = module.exports.default = $0347594f5084a834$var$SuccessIcon;

});

parcelRegister("kJ541", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f16bf031974cd311$var$_react = $f16bf031974cd311$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $f16bf031974cd311$var$_success = $f16bf031974cd311$var$_interopRequireDefault((parcelRequire("b0JGA")));
function $f16bf031974cd311$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $f16bf031974cd311$var$EditorSuccessIcon = (props)=>/*#__PURE__*/ $f16bf031974cd311$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16m1.364-10.964-2.152 4.11-1.543-1.39a1 1 0 1 0-1.338 1.487l2.5 2.25a1 1 0 0 0 1.555-.279l2.75-5.25a1 1 0 0 0-1.772-.928"/></svg>`
    }, props, {
        newIcon: $f16bf031974cd311$var$_success.default
    }));
$f16bf031974cd311$var$EditorSuccessIcon.displayName = 'EditorSuccessIcon';
var $f16bf031974cd311$var$_default = module.exports.default = $f16bf031974cd311$var$EditorSuccessIcon;

});


parcelRegister("dRN65", function(module, exports) {

$parcel$export(module.exports, "FieldId", () => $706cd4dbd4574fd7$export$3c4232819458a302);

var $5uXOq = parcelRequire("5uXOq");
const $706cd4dbd4574fd7$export$3c4232819458a302 = /*#__PURE__*/ (0, $5uXOq.createContext)(undefined);

});


parcelRegister("2x3Cb", function(module, exports) {

$parcel$export(module.exports, "Label", () => $987b76a5b7a0ea9b$export$b04be29aa201d4f5);
$parcel$export(module.exports, "Legend", () => $987b76a5b7a0ea9b$export$ed247974535929c7);
/* label.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $987b76a5b7a0ea9b$var$fieldsetLabelStyles = null;
const $987b76a5b7a0ea9b$export$b04be29aa201d4f5 = ({ children: children, htmlFor: htmlFor, id: id, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)("label", {
        id: id,
        htmlFor: htmlFor,
        "data-testid": testId,
        className: (0, $bwpsq.default)([
            "_11c8dcr7 _1e0c1o8l _syaz1gjq _k48pmoej _6rth1b66 _1pfhze3t"
        ]),
        children: children
    });
const $987b76a5b7a0ea9b$export$ed247974535929c7 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("legend", {
        className: (0, $bwpsq.default)([
            "_11c8dcr7 _1e0c1o8l _syaz1gjq _k48pmoej _6rth1b66 _1pfhze3t"
        ]),
        children: children
    });
};

});

parcelRegister("DVljb", function(module, exports) {

$parcel$export(module.exports, "useLocale", () => $7c760643dc748494$export$43bb16f9c6d9e3f7);
$parcel$export(module.exports, "useNativeLocale", () => $7c760643dc748494$export$31652d9c30d7d3f3);

var $5uXOq = parcelRequire("5uXOq");

var $lzeFL = parcelRequire("lzeFL");

var $9OXo1 = parcelRequire("9OXo1");
const $7c760643dc748494$export$43bb16f9c6d9e3f7 = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext && tenantContext.locale || (0, $lzeFL.defaultLocale);
};
const $7c760643dc748494$export$31652d9c30d7d3f3 = ()=>{
    const locale = $7c760643dc748494$export$43bb16f9c6d9e3f7();
    const standardizedLocale = (0, $5uXOq.useMemo)(()=>(0, $lzeFL.standardizeLocale)(locale), [
        locale
    ]);
    return standardizedLocale;
};

});

parcelRegister("6yeNV", function(module, exports) {

$parcel$export(module.exports, "standardizeLocale", () => $e3b19be89da6c3f8$export$ca06804549ae25fb);
$parcel$export(module.exports, "verifyTimeZone", () => $e3b19be89da6c3f8$export$93ff13646da25bd);

var $lzeFL = parcelRequire("lzeFL");

var $2YZCu = parcelRequire("2YZCu");
const $e3b19be89da6c3f8$export$95b7602913551865 = 'en-US';
const $e3b19be89da6c3f8$export$ca06804549ae25fb = (jiraLocale)=>{
    if (typeof jiraLocale !== 'string') {
        (0, $2YZCu.default).safeErrorWithoutCustomerData('jira-issue-format-date.standardize-locale', `Invalid input type for locale was passed in: ${jiraLocale}. Falling back to ${$e3b19be89da6c3f8$export$95b7602913551865}.`);
        return $e3b19be89da6c3f8$export$95b7602913551865;
    }
    const standardizedLocale = jiraLocale.replace('_', '-');
    switch(standardizedLocale){
        case 'en':
            return 'en-US';
        case 'en-UK':
            return 'en-GB';
        default:
            if (!(0, $lzeFL.default).includes(jiraLocale)) (0, $2YZCu.default).safeWarnWithoutCustomerData('jira-issue-format-date.standardize-locale', `Discovered unsupported locale: ${jiraLocale}. This value was not modified, but its use may lead to unpredictable behaviour for formatting.`);
            return standardizedLocale;
    }
};
const $e3b19be89da6c3f8$export$93ff13646da25bd = (timeZone)=>{
    try {
        Intl.DateTimeFormat($e3b19be89da6c3f8$export$95b7602913551865, {
            timeZone: timeZone
        });
        return timeZone;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $2YZCu.default).safeErrorWithoutCustomerData('jira-issue-format-date.verify-time-zone', `Invalid timeZone: ${String(timeZone)}. Date time formatting cannot be performed with this value. Falling back to undefined`, error);
        return undefined;
    }
};

});

parcelRegister("dBYMG", function(module, exports) {

$parcel$export(module.exports, "default", () => $64f99e481522b718$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $64f99e481522b718$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    calenderInputAriaLabel: {
        "id": "issue-field-due-date-picker-input-aria-label",
        "defaultMessage": "On the use of up and down arrow keys into the following input field, the date will update below"
    },
    invalidDateError: {
        "id": "issue-field-due-date-picker-invalid-date-error",
        "defaultMessage": "Enter a valid date"
    },
    dueDateText: {
        "id": "issue-field-due-date-picker-due-date-text",
        "defaultMessage": "Due date"
    }
});

});

parcelRegister("2bdzH", function(module, exports) {

$parcel$export(module.exports, "formatDateType", () => $2074dd5968251042$export$c1b0befbc45d5daf);
$parcel$export(module.exports, "parseDateType", () => $2074dd5968251042$export$9f54bd296c9b15c8);
$parcel$export(module.exports, "findDateSegmentByPosition", () => $2074dd5968251042$export$ff5a653e9ab9c0bc);
$parcel$export(module.exports, "adjustDate", () => $2074dd5968251042$export$6c4de3b0bb035f06);
$parcel$export(module.exports, "isDatePossiblyValid", () => $2074dd5968251042$export$6e7fa6d67147cb9e);

var $7qZ1x = parcelRequire("7qZ1x");
const $2074dd5968251042$export$c1b0befbc45d5daf = (date, locale)=>{
    const { day: day, month: month, year: year } = date;
    const l10n = (0, $7qZ1x.createLocalizationProvider)(locale);
    const dateObj = new Date(year, month - 1, day);
    return l10n.formatDate(dateObj);
};
const $2074dd5968251042$export$9f54bd296c9b15c8 = (dateString, locale)=>{
    try {
        const l10n = (0, $7qZ1x.createLocalizationProvider)(locale);
        const date = l10n.parseDate(dateString);
        // If date is invalid
        if (Number.isNaN(date.getTime())) return null;
        const year = date.getFullYear();
        if (year < 1000 || year > 9999) return null;
        const dateObj = {
            day: date.getDate(),
            month: date.getMonth() + 1,
            year: year
        };
        return dateObj;
    } catch (e) {
        return null;
    }
};
const $2074dd5968251042$export$ff5a653e9ab9c0bc = (cursorPos, dateString, locale)=>{
    const l10n = (0, $7qZ1x.createLocalizationProvider)(locale);
    const dateFormat = l10n.formatDate(new Date()).replace(/\d/g, 'd').replace(/[a-zA-Z]/g, 'M');
    const dayIndex = dateFormat.indexOf('d');
    const monthIndex = dateFormat.indexOf('M');
    const yearIndex = dateFormat.indexOf('y');
    if (cursorPos <= dayIndex + 2) return 'day';
    if (cursorPos <= monthIndex + 2) return 'month';
    if (cursorPos <= yearIndex + 4) return 'year';
    return undefined;
};
const $2074dd5968251042$export$6c4de3b0bb035f06 = (date, segment, adjustment)=>{
    const newDate = new Date(date.year, date.month - 1, date.day);
    switch(segment){
        case 'day':
            newDate.setDate(newDate.getDate() + adjustment);
            break;
        case 'month':
            newDate.setMonth(newDate.getMonth() + adjustment);
            break;
        case 'year':
            newDate.setFullYear(newDate.getFullYear() + adjustment);
            break;
        default:
            break;
    }
    return {
        day: newDate.getDate(),
        month: newDate.getMonth() + 1,
        year: newDate.getFullYear()
    };
};
const $2074dd5968251042$export$6e7fa6d67147cb9e = (date)=>{
    for (const c of date){
        const isNumber = c >= '0' && c <= '9';
        const isValidPunctuation = '. ,/-'.indexOf(c) !== -1;
        if (!(isNumber || isValidPunctuation)) return false;
    }
    return true;
};

});


parcelRegister("3KjRe", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c524311c7e040e9$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $4c524311c7e040e9$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    dueDateLabel: {
        "id": "issue-field-due-date-label",
        "defaultMessage": "Due date"
    }
});

});


parcelRegister("lPoet", function(module, exports) {

$parcel$export(module.exports, "InlineAssigneePicker", () => $578dda061fa3ffab$export$ede2cc474eb6c5b6);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $5pc5W = parcelRequire("5pc5W");
const $578dda061fa3ffab$export$ede2cc474eb6c5b6 = ({ projectKey: projectKey, onAssigneeUpdate: onAssigneeUpdate, defaultAssignee: defaultAssignee = null, shouldShowNameLabel: shouldShowNameLabel = false, source: source, actionSubject: actionSubject = 'inlineAssignee', onUpdatingAssigneePicker: onUpdatingAssigneePicker = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), strategy: strategy = 'fixed', iconSize: iconSize, onClose: onClose = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))) })=>{
    const SEARCH_ASSIGNEE_ENDPOINT = `/rest/api/2/user/assignable/search?project=${projectKey}&query=`;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const handleOnChange = (updatedValue)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'confirmed',
            actionSubject: actionSubject
        });
        onAssigneeUpdate?.(updatedValue);
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, {
            calledFrom: source
        });
    };
    const handleOnOpen = ()=>{
        onUpdatingAssigneePicker?.(true);
    };
    const handleOnClose = ()=>{
        onUpdatingAssigneePicker?.(false);
    };
    const handleOnTriggerClick = (event)=>{
        // Prevent default is needed to prevent the form from being submitted when the user clicks on the assignee picker
        event?.preventDefault();
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: actionSubject
        });
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, {
            calledFrom: source
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5pc5W.AssigneePickerPopup), {
        autoCompleteUrl: SEARCH_ASSIGNEE_ENDPOINT,
        value: defaultAssignee,
        onChange: handleOnChange,
        shouldShowNameLabel: shouldShowNameLabel,
        actionSubject: actionSubject,
        onOpen: handleOnOpen,
        onClose: handleOnClose,
        strategy: strategy,
        onTriggerClick: handleOnTriggerClick,
        iconSize: iconSize,
        onCloseParent: onClose
    });
};

});
parcelRegister("5pc5W", function(module, exports) {

$parcel$export(module.exports, "AssigneePickerPopup", () => $97151138ad76379f$export$710b391cecc5e899);

var $5uXOq = parcelRequire("5uXOq");

var $lFKmC = parcelRequire("lFKmC");

var $8Rkzz = parcelRequire("8Rkzz");

var $5ILhZ = parcelRequire("5ILhZ");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $5cK2s = parcelRequire("5cK2s");

var $3bDjY = parcelRequire("3bDjY");

var $evUrF = parcelRequire("evUrF");

var $kt8K4 = parcelRequire("kt8K4");

var $h36wX = parcelRequire("h36wX");

var $7lGt2 = parcelRequire("7lGt2");

var $fhSLy = parcelRequire("fhSLy");


var $4R6GH = parcelRequire("4R6GH");

var $aWse0 = parcelRequire("aWse0");


var $1rEZQ = parcelRequire("1rEZQ");

var $ctrpc = parcelRequire("ctrpc");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $atdLB = parcelRequire("atdLB");
var $duUGa = parcelRequire("duUGa");

var $6yQD6 = parcelRequire("6yQD6");
const $97151138ad76379f$var$DEFAULT_SEARCH_DEBOUCE_TIMEOUT = 300;
const $97151138ad76379f$var$ACTION_SUBJECT = 'assigneePicker';
const $97151138ad76379f$var$AssigneeFieldOptionsLoadExperience = new (0, $duUGa.UFOExperience)('assignee-picker.field-options-load', {
    type: (0, $atdLB.ExperienceTypes).Operation,
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).Custom,
    category: 'assignee-picker.field-options-load'
});
const $97151138ad76379f$export$710b391cecc5e899 = ({ actionSubject: actionSubject, shouldPreloadAssignToMe: shouldPreloadAssignToMe = false, autoCompleteUrl: autoCompleteUrl, value: value = null, onFocus: onFocus, onBlur: onBlur, onChange: onChange, searchDebounceTimeout: searchDebounceTimeout = $97151138ad76379f$var$DEFAULT_SEARCH_DEBOUCE_TIMEOUT, enablePeopleInvite: enablePeopleInvite = true, popupPlacement: popupPlacement = 'auto', isEligibleForInviteAndAssign: isEligibleForInviteAndAssign, suggestedEmailDomain: suggestedEmailDomain, onInviteAndAssignOption: onInviteAndAssignOption, onOpen: onOpen, onClose: onClose, enableAutomaticOption: enableAutomaticOption = true, customFetchUsers: customFetchUsers, shouldShowNameLabel: shouldShowNameLabel = false, strategy: strategy = 'fixed', onTriggerClick: onTriggerClick, iconSize: iconSize, onCloseParent: onCloseParent = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))) })=>{
    const intl = (0, $aWse0.useIntlV2)();
    const self = (0, $5uXOq.useRef)({
        previousQuery: undefined
    }).current;
    const [{ data: users, loading: loading, error: error }, fetchUsers] = (0, $kt8K4.default)(autoCompleteUrl || '', (0, $4R6GH.fg)('issue_cards_in_program_board') ? customFetchUsers : undefined);
    const [assigneeValue, assigneeOptions] = (0, $h36wX.useAssigneeOptions)({
        value: value,
        users: users,
        intl: intl,
        shouldPreloadAssignToMe: shouldPreloadAssignToMe,
        search: self.previousQuery,
        enablePeopleInvite: enablePeopleInvite,
        enableAutomaticOption: enableAutomaticOption,
        suggestedEmailDomain: suggestedEmailDomain,
        isEligibleForInviteAndAssign: isEligibleForInviteAndAssign
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [, { openModal: openModal }] = (0, $1rEZQ.useInvitePeopleModal)();
    (0, $5uXOq.useEffect)(()=>{
        if (loading) {
            (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({
                actionSubject: actionSubject ?? $97151138ad76379f$var$ACTION_SUBJECT,
                action: 'loading'
            }), 'assigneeOptions loading');
            $97151138ad76379f$var$AssigneeFieldOptionsLoadExperience.start();
        }
        if (error) {
            (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({
                actionSubject: actionSubject ?? $97151138ad76379f$var$ACTION_SUBJECT,
                action: 'failed'
            }), 'assigneeOptions failed');
            $97151138ad76379f$var$AssigneeFieldOptionsLoadExperience.failure();
        }
        if (users.length) {
            (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({
                actionSubject: actionSubject ?? $97151138ad76379f$var$ACTION_SUBJECT,
                action: 'loaded'
            }), 'assigneeOptions loaded');
            $97151138ad76379f$var$AssigneeFieldOptionsLoadExperience.success();
        }
    }, [
        loading,
        error,
        users,
        createAnalyticsEvent,
        actionSubject
    ]);
    const handleSearch = (0, $5uXOq.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))((query)=>{
            query !== self.previousQuery && fetchUsers(query);
            self.previousQuery = query;
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
                actionSubject: actionSubject ?? $97151138ad76379f$var$ACTION_SUBJECT,
                action: 'searched'
            }));
        }, searchDebounceTimeout), // go/jfe-eslint
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        fetchUsers,
        searchDebounceTimeout,
        self.previousQuery
    ]);
    const handleOnFocus = (0, $5uXOq.useCallback)((sessionId)=>{
        onFocus?.(sessionId);
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            actionSubject: actionSubject ?? $97151138ad76379f$var$ACTION_SUBJECT,
            action: 'focused'
        }));
        if (!users || !users.length) fetchUsers();
    }, [
        onFocus,
        users,
        createAnalyticsEvent,
        actionSubject,
        fetchUsers
    ]);
    const handleOnBlur = (0, $5uXOq.useCallback)((sessionId)=>{
        onBlur?.(sessionId);
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            actionSubject: actionSubject ?? $97151138ad76379f$var$ACTION_SUBJECT,
            action: 'blurred'
        }));
        self.previousQuery = undefined;
    }, [
        actionSubject,
        createAnalyticsEvent,
        onBlur,
        self
    ]);
    const handleOnChange = (0, $5uXOq.useCallback)((updatedValue, action)=>{
        if (!updatedValue || Array.isArray(updatedValue)) return;
        if (isEligibleForInviteAndAssign && updatedValue.id === (0, $a56e5eac5897104f$export$898547b9297d1a3a)) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            onInviteAndAssignOption?.(updatedValue, action);
            return;
        }
        if ((0, $4R6GH.fg)('one_event_rules_them_all_fg')) (0, $ctrpc.getUpdateAnalyticsFlowHelper)().setAttributes('assignee', {
            oldValId: value ? value.accountId : null,
            newValId: updatedValue ? updatedValue.id : null
        });
        if (enablePeopleInvite && updatedValue.id === (0, $c1e3a0a8493b8e86$export$d875316cb0cd94f7)) {
            openModal(createAnalyticsEvent ?? null, {
                inviteFlow: 'assignee'
            });
            onChange?.(value, action);
            return;
        }
        const newValue = updatedValue.id === (0, $c1e3a0a8493b8e86$export$bdab9bfb39981463) ? null : users.find(({ accountId: accountId })=>accountId === updatedValue.id) || (0, $fhSLy.getUserFromUserOption)(updatedValue);
        onChange?.(newValue, action);
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            actionSubject: actionSubject ?? $97151138ad76379f$var$ACTION_SUBJECT,
            action: 'changed'
        }));
    }, [
        isEligibleForInviteAndAssign,
        enablePeopleInvite,
        users,
        onChange,
        createAnalyticsEvent,
        actionSubject,
        onInviteAndAssignOption,
        openModal,
        value
    ]);
    const buttonTimeoutRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>()=>{
            if (buttonTimeoutRef.current) clearTimeout(buttonTimeoutRef.current);
        }, []);
    const buttonRef = (0, $5uXOq.useRef)(null);
    const handleOnClose = (0, $5uXOq.useCallback)(()=>{
        onClose?.();
        // using setTimeout to ensure focus is set after the popup is closed + another render cycle is triggered for reasons unknown and not worth investigating further
        // check the close method of PopupSelect in jira/platform/packages/design-system/select/src/PopupSelect/PopupSelect.tsx
        // focus() is attempted, but erased by an extra render cycle
        // Further details here https://bitbucket.org/atlassian/atlassian-frontend-monorepo/pull-requests/138357
        buttonTimeoutRef.current = setTimeout(()=>buttonRef.current?.focus(), 0);
    }, [
        onClose
    ]);
    const assigneeNameLabel = value ? intl.formatMessage((0, $evUrF.default).assigneeTooltip, {
        name: value.displayName
    }) : intl.formatMessage((0, $7lGt2.default).unassignedOption);
    const handleOnKeydown = (0, $5uXOq.useCallback)((event, isOpen)=>{
        if (event.key === 'Escape' && !isOpen) // If the popup is not open, we just call onCloseParent and return
        onCloseParent?.();
    }, [
        onCloseParent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5cK2s.PopupUserPicker), {
        fieldId: null,
        placeholder: intl.formatMessage((0, $7lGt2.default).searchForAssignee),
        isLoading: loading,
        ariaLabel: intl.formatMessage((0, $7lGt2.default).searchForAssignee),
        options: assigneeOptions,
        target: ({ ref: ref, isOpen: isOpen, ...triggerProps })=>{
            const assigneePickerButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5ILhZ.default), {
                ref: (internalButtonRef)=>{
                    ref?.(internalButtonRef);
                    buttonRef.current = internalButtonRef;
                },
                ...triggerProps,
                xcss: [
                    $97151138ad76379f$var$buttonWrapperStyles,
                    isOpen && $97151138ad76379f$var$activeStyles
                ],
                onClick: onTriggerClick,
                backgroundColor: "color.background.neutral.subtle",
                testId: "inline-assignee-picker.assignee-picker-popup.test",
                "aria-expanded": isOpen,
                onKeyDown: (event)=>handleOnKeydown(event, isOpen)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6yQD6.AssigneeAvatar), {
                value: value,
                assigneeNameLabel: assigneeNameLabel,
                iconSize: iconSize
            }), shouldShowNameLabel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
                color: "color.text",
                testId: "inline-assignee-picker.assignee-picker-popup.text"
            }, value ? value.displayName : intl.formatMessage((0, $7lGt2.default).unassignedOption)));
            return shouldShowNameLabel ? assigneePickerButton : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
                content: assigneeNameLabel,
                hideTooltipOnMouseDown: true
            }, assigneePickerButton);
        },
        value: assigneeValue,
        onFocus: handleOnFocus,
        onBlur: handleOnBlur,
        onChange: handleOnChange,
        onInputChange: handleSearch,
        placement: popupPlacement,
        onOpen: onOpen,
        onClose: handleOnClose,
        strategy: strategy,
        offset: [
            0,
            8
        ]
    });
};
const $97151138ad76379f$var$buttonWrapperStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    alignItems: 'center',
    gap: 'space.050',
    padding: 'space.025',
    cursor: 'pointer',
    borderRadius: '3px',
    borderStyle: 'solid',
    borderWidth: 'border.width',
    borderRightColor: 'transparent',
    borderLeftColor: 'transparent',
    borderTopColor: 'transparent',
    borderBottomColor: 'transparent',
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.subtle.hovered',
        borderColor: 'color.border.selected'
    },
    ':focus': {
        borderColor: 'color.border.selected'
    },
    ':focus-visible': {
        borderRightColor: 'transparent',
        borderLeftColor: 'transparent',
        borderTopColor: 'transparent',
        borderBottomColor: 'transparent'
    }
});
const $97151138ad76379f$var$activeStyles = (0, $8CUq3.xcss)({
    borderColor: 'color.border.selected',
    backgroundColor: 'color.background.selected'
});

});
parcelRegister("5cK2s", function(module, exports) {

$parcel$export(module.exports, "PopupUserPicker", () => $b3c879a34def3ff8$export$3687c7ed123b6b2b);

var $2OMIu = parcelRequire("2OMIu");

var $cb25w = parcelRequire("cb25w");

var $b9dFI = parcelRequire("b9dFI");

var $5uXOq = parcelRequire("5uXOq");

var $dyegP = parcelRequire("dyegP");

var $2wgOn = parcelRequire("2wgOn");

var $b3Rxh = parcelRequire("b3Rxh");

var $d3gzD = parcelRequire("d3gzD");

var $VSDnB = parcelRequire("VSDnB");
class $b3c879a34def3ff8$export$c87d8f24e24a8ae2 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    static{
        this.defaultProps = {
            boundariesElement: 'viewport',
            width: 300,
            isMulti: false,
            offset: [
                0,
                0
            ],
            placement: 'auto',
            rootBoundary: 'viewport',
            shouldFlip: true,
            strategy: 'fixed'
        };
    }
    render() {
        const { target: target, popupTitle: popupTitle, boundariesElement: boundariesElement, isMulti: isMulti, offset: offset, placement: placement, rootBoundary: rootBoundary, shouldFlip: shouldFlip, styles: styles, strategy: strategy } = this.props;
        const width = this.props.width;
        const selectStyles = (0, $2wgOn.getPopupStyles)(width, isMulti, styles, // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        (0, $VSDnB.fg)('platform-component-visual-refresh'));
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $d3gzD.BaseUserPickerWithoutAnalytics), {
            ...this.props,
            SelectComponent: (0, $b9dFI.default),
            width: width,
            styles: selectStyles,
            components: (0, $dyegP.getPopupComponents)(!!popupTitle),
            pickerProps: (0, $b3Rxh.getPopupProps)(width, target, this.handleFlipStyle, boundariesElement, offset, placement, rootBoundary, shouldFlip, popupTitle, strategy)
        });
    }
    constructor(...args){
        super(...args), this.state = {
            flipped: false
        }, this.handleFlipStyle = (data)=>{
            const { flipped: flipped, styles: { transform: transform }, popper: { height: height } } = data;
            this.setState({
                flipped: flipped
            });
            if (!flipped) return data;
            data.styles.transform = transform + `translate(0, ${height}px) translate(0, -100%)`;
            return data;
        };
    }
}
const $b3c879a34def3ff8$export$3687c7ed123b6b2b = (0, $cb25w.default)()($b3c879a34def3ff8$export$c87d8f24e24a8ae2);

});
parcelRegister("dyegP", function(module, exports) {

$parcel$export(module.exports, "getComponents", () => $27e51ea041192381$export$4e811121b221213b);
$parcel$export(module.exports, "getPopupComponents", () => $27e51ea041192381$export$19205fd341a6bb08);

var $8QpSo = parcelRequire("8QpSo");

var $dqbw8 = parcelRequire("dqbw8");

var $8Y8Qe = parcelRequire("8Y8Qe");

var $fIpmY = parcelRequire("fIpmY");

var $3QONt = parcelRequire("3QONt");

var $6Kkci = parcelRequire("6Kkci");

var $OxpB4 = parcelRequire("OxpB4");

var $ee8bl = parcelRequire("ee8bl");

var $h3ej5 = parcelRequire("h3ej5");

var $6Ks8i = parcelRequire("6Ks8i");

var $lYehz = parcelRequire("lYehz");

var $7mofJ = parcelRequire("7mofJ");
const $27e51ea041192381$export$4e811121b221213b = (0, $8QpSo.default)((multi, anchor, showClearIndicator, customComponents)=>{
    if (anchor) return {
        Control: anchor,
        Option: $3QONt.Option
    };
    else return {
        MultiValue: $8Y8Qe.MultiValue,
        DropdownIndicator: null,
        SingleValue: $6Kkci.SingleValue,
        ClearIndicator: showClearIndicator || !multi ? (0, $dqbw8.ClearIndicator) : null,
        Option: $3QONt.Option,
        ValueContainer: multi ? (0, $fIpmY.MultiValueContainer) : (0, $ee8bl.SingleValueContainer),
        Input: $OxpB4.Input,
        Menu: $lYehz.Menu,
        Control: $7mofJ.default,
        ...customComponents ? customComponents : {}
    };
});
const $27e51ea041192381$export$19205fd341a6bb08 = (0, $8QpSo.default)((hasPopupTitle)=>{
    const baseProps = {
        DropdownIndicator: null,
        SingleValue: $6Kkci.SingleValue,
        ClearIndicator: $dqbw8.ClearIndicator,
        Option: $3QONt.Option,
        ValueContainer: (0, $ee8bl.SingleValueContainer),
        Input: (0, $h3ej5.PopupInput)
    };
    if (hasPopupTitle) return {
        ...baseProps,
        Control: (0, $6Ks8i.PopupControl)
    };
    return baseProps;
});

});
parcelRegister("dqbw8", function(module, exports) {

$parcel$export(module.exports, "ClearIndicator", () => $11bf495008933d24$export$ecf9cf59142dd54a);
/* ClearIndicator.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bChGW = parcelRequire("bChGW");

const $11bf495008933d24$var$AsyncTooltip = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("7LtDy")).then((module)=>{
        return {
            default: module.default
        };
    }));
const $11bf495008933d24$var$clearIndicatorStyles = {
    root: "_v5641ppt _tzy4kb7n _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _30l3s4qr _1mhjgrf3"
};
class $11bf495008933d24$export$ecf9cf59142dd54a extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).PureComponent {
    render() {
        const { //@ts-ignore react-select unsupported props
        selectProps: { clearValueLabel: clearValueLabel } } = this.props;
        const Indicator = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bChGW.components).ClearIndicator, {
            ...this.props,
            innerProps: {
                ...this.props.innerProps,
                onMouseDown: this.handleMouseDown
            },
            xcss: $11bf495008933d24$var$clearIndicatorStyles.root
        });
        return clearValueLabel ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Suspense, {
            fallback: Indicator,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)($11bf495008933d24$var$AsyncTooltip, {
                content: clearValueLabel,
                children: Indicator
            })
        }) : Indicator;
    }
    constructor(...args){
        super(...args), this.handleMouseDown = (event)=>{
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            // Prevent focus when clear on blurred state
            const { clearValue: clearValue, selectProps: selectProps } = this.props;
            clearValue();
            //@ts-ignore react-select unsupported props
            if (selectProps && !selectProps.isFocused) event.stopPropagation();
        };
    }
}

});
parcelRegister("7LtDy", function(module, exports) {

let $5a73e97eb510a942$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5a73e97eb510a942$var$load("9EQz0").then(()=>parcelRequire('8hfZh'));

});


parcelRegister("8Y8Qe", function(module, exports) {

$parcel$export(module.exports, "MultiValue", () => $65368b71d1856c3a$export$419cdf50db8b579);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $8CUq3 = parcelRequire("8CUq3");

var $bChGW = parcelRequire("bChGW");

var $f8Sb3 = parcelRequire("f8Sb3");

var $dW8NE = parcelRequire("dW8NE");

var $5pJx4 = parcelRequire("5pJx4");

var $3smIt = parcelRequire("3smIt");

var $4hqZ5 = parcelRequire("4hqZ5");

var $fuhQD = parcelRequire("fuhQD");
function $65368b71d1856c3a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $65368b71d1856c3a$export$118122ebc1e626fa = (valueContainer, control)=>{
    const { top: top, height: height } = valueContainer.getBoundingClientRect();
    const { height: controlHeight } = control.getBoundingClientRect();
    if (top - height < 0) valueContainer.scrollIntoView();
    if (top + height > controlHeight) valueContainer.scrollIntoView(false);
};
const $65368b71d1856c3a$var$groupTagContainer = (0, $8CUq3.xcss)({
    paddingLeft: 'space.025',
    marginTop: 'space.025'
});
const $65368b71d1856c3a$var$nameWrapper = {
    name: "1ebbz80",
    styles: "font:var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);padding-left:var(--ds-space-050, 4px)"
};
class $65368b71d1856c3a$export$419cdf50db8b579 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    constructor(props){
        super(props), this.getElemBefore = ()=>{
            const { data: { data: data } } = this.props;
            if ((0, $3smIt.isEmail)(data)) // This element is a decorative icon and does not require a label
            return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dW8NE.AddOptionAvatar), {
                isLozenge: true
            });
            if ((0, $3smIt.isGroup)(data)) return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dC5iT.default), {
                xcss: $65368b71d1856c3a$var$groupTagContainer
            }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4hqZ5))), {
                LEGACY_margin: "-2px 0 0 0",
                color: "currentColor",
                label: "" // This element is a decorative icon and does not require a label
                ,
                LEGACY_size: "small"
            }));
            return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5pJx4.SizeableAvatar), {
                appearance: "multi",
                src: (0, $3smIt.getAvatarUrl)(data),
                type: (0, $3smIt.isTeam)(data) ? 'team' : 'person'
            });
        }, this.getElemAfter = ()=>{
            const { data: { data: data } } = this.props;
            if ((0, $3smIt.isTeam)(data) && data.verified) return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $fuhQD.VerifiedTeamIcon), null);
            return null;
        };
        this.containerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef();
    }
    componentDidUpdate() {
        const { isFocused: isFocused } = this.props;
        if (isFocused && this.containerRef.current && this.containerRef.current.parentElement && this.containerRef.current.parentElement.parentElement) $65368b71d1856c3a$export$118122ebc1e626fa(this.containerRef.current, this.containerRef.current.parentElement.parentElement);
    }
    shouldComponentUpdate(nextProps) {
        const { data: { label: label, data: data }, innerProps: innerProps, isFocused: isFocused } = this.props;
        const { data: { label: nextLabel, data: nextData }, innerProps: nextInnerProps, isFocused: nextIsFocused } = nextProps;
        // We can ignore onRemove here because it is an anonymous function
        // that will be recreated every time but with the same implementation.
        return data !== nextData || label !== nextLabel || innerProps !== nextInnerProps || isFocused !== nextIsFocused;
    }
    render() {
        const { children: children, innerProps: innerProps, ...rest } = this.props;
        return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $bChGW.components).MultiValue, {
            ...rest,
            innerProps: {
                ref: this.containerRef
            },
            cropWithEllipsis: false
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $f5TWP.default), {
            alignBlock: "center"
        }, this.getElemBefore(), " ", /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: $65368b71d1856c3a$var$nameWrapper
        }, children), this.getElemAfter()));
    }
}

});
parcelRegister("dW8NE", function(module, exports) {

$parcel$export(module.exports, "AddOptionAvatar", () => $f3236d5a67f7ff1f$export$df396db45e491922);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $aVnO1 = parcelRequire("aVnO1");


var $f8Sb3 = parcelRequire("f8Sb3");
parcelRequire("5uXOq");
const $f3236d5a67f7ff1f$var$getEmailAvatarWrapperStyle = (isLozenge)=>{
    const padding = isLozenge ? `${"var(--ds-space-0, 0px)"}` : `${"var(--ds-space-050, 4px)"}`;
    return /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        padding: padding,
        backgroundColor: `var(--ds-background-neutral, ${(0, $829f609a65d26a98$export$1ce2d1575d444ceb)})`,
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        marginLeft: "var(--ds-space-025, 2px)"
    });
};
const $f3236d5a67f7ff1f$export$df396db45e491922 = ({ isLozenge: isLozenge, label: label })=>{
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $f3236d5a67f7ff1f$var$getEmailAvatarWrapperStyle(isLozenge)
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aVnO1))), {
        testId: "add-option-avatar-email-icon",
        label: label || '',
        LEGACY_size: isLozenge ? 'small' : 'medium',
        LEGACY_margin: "0 0 0 -2px",
        color: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`
    })));
};

});
parcelRegister("aVnO1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b2014ecb862bd114df9c4eca3bb7d0c3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7f41b19bed4136e0$var$_react = $7f41b19bed4136e0$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $7f41b19bed4136e0$var$_email = $7f41b19bed4136e0$var$_interopRequireDefault((parcelRequire("eRB05")));

var $7f41b19bed4136e0$var$_email2 = $7f41b19bed4136e0$var$_interopRequireDefault((parcelRequire("5bEkJ")));
function $7f41b19bed4136e0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for EmailIcon.
 * This component is EmailIcon, with `UNSAFE_fallbackIcon` set to "EmailIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for when an email-related things.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7f41b19bed4136e0$var$EmailIcon = (props)=>/*#__PURE__*/ $7f41b19bed4136e0$var$_react.default.createElement($7f41b19bed4136e0$var$_email.default, Object.assign({
        LEGACY_fallbackIcon: $7f41b19bed4136e0$var$_email2.default
    }, props));
$7f41b19bed4136e0$var$EmailIcon.Name = 'EmailIconMigration';
var $7f41b19bed4136e0$var$_default = module.exports.default = $7f41b19bed4136e0$var$EmailIcon;

});
parcelRegister("eRB05", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::19440c8dd0e3db5766add744ad314d45>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ad22b76beceec928$var$_react = $ad22b76beceec928$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $ad22b76beceec928$var$_baseNew = $ad22b76beceec928$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $ad22b76beceec928$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Email".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for when an email-related things.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ad22b76beceec928$var$EmailIcon = (props)=>/*#__PURE__*/ $ad22b76beceec928$var$_react.default.createElement($ad22b76beceec928$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v.529L8 8.128l6.5-3.6V4a.5.5 0 0 0-.5-.5zm12.5 2.743L8.363 9.641a.75.75 0 0 1-.726 0L1.5 6.243V12a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5z" clip-rule="evenodd"/>`
    }, props));
$ad22b76beceec928$var$EmailIcon.displayName = 'EmailIcon';
var $ad22b76beceec928$var$_default = module.exports.default = $ad22b76beceec928$var$EmailIcon;

});

parcelRegister("5bEkJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3c6d443366bf8cbb$var$_react = $3c6d443366bf8cbb$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $3c6d443366bf8cbb$var$_email = $3c6d443366bf8cbb$var$_interopRequireDefault((parcelRequire("eRB05")));
function $3c6d443366bf8cbb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3c6d443366bf8cbb$var$EmailIcon = (props)=>/*#__PURE__*/ $3c6d443366bf8cbb$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M5 7v10h14V7zm14-2c1.1 0 2 .9 2 2v10c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V7c0-1.1.9-2 2-2z"/><path d="M5.498 6.5H3.124c.149.44.399.854.75 1.205l5.882 5.881a3.117 3.117 0 0 0 4.41 0l5.882-5.881c.35-.351.6-.765.749-1.205h-2.373l-5.672 5.672a1.12 1.12 0 0 1-1.583 0z"/></g></svg>`
    }, props, {
        newIcon: $3c6d443366bf8cbb$var$_email.default
    }));
$3c6d443366bf8cbb$var$EmailIcon.displayName = 'EmailIcon';
var $3c6d443366bf8cbb$var$_default = module.exports.default = $3c6d443366bf8cbb$var$EmailIcon;

});



parcelRegister("5pJx4", function(module, exports) {

$parcel$export(module.exports, "SizeableAvatar", () => $50cd04ab4dcbd6e5$export$44d81a88129649da);

var $2OMIu = parcelRequire("2OMIu");

var $ujWmd = parcelRequire("ujWmd");

var $fwSAz = parcelRequire("fwSAz");

var $5uXOq = parcelRequire("5uXOq");

var $3smIt = parcelRequire("3smIt");
class $50cd04ab4dcbd6e5$export$44d81a88129649da extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).PureComponent {
    render() {
        const { src: src, presence: presence, appearance: appearance, type: type = 'person' } = this.props;
        const props = {
            size: (0, $3smIt.getAvatarSize)(appearance),
            src: src,
            borderColor: 'transparent',
            presence: presence
        };
        return type === 'team' ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fwSAz.default), {
            ...props
        }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ujWmd.default), {
            ...props
        });
    }
}

});
parcelRegister("fwSAz", function(module, exports) {

$parcel$export(module.exports, "default", () => $6cdf5ede1a400c9d$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ujWmd = parcelRequire("ujWmd");


var $2w1D3 = parcelRequire("2w1D3");

var $ggnNZ = parcelRequire("ggnNZ");
const $6cdf5ede1a400c9d$export$ebe0b8fe8b6acbfd = `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`;
const $6cdf5ede1a400c9d$export$72502e51aebdd94e = `var(--ds-icon-subtle, ${(0, $829f609a65d26a98$export$7c87d337fb91a97d)})`;
function $6cdf5ede1a400c9d$export$2e2bcd8739ae039({ testId: testId, src: src, size: size = 'medium', ...props }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ujWmd.default), {
        appearance: (0, $ggnNZ.isSquareIcon)(src) ? 'square' : 'circle',
        ...props,
        size: size,
        src: src,
        testId: `${testId}-team-avatar`,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2w1D3.TeamAvatarImage), {
            src: src,
            size: size,
            testId: testId
        })
    });
}

});
parcelRegister("2w1D3", function(module, exports) {

$parcel$export(module.exports, "TeamAvatarImage", () => $7d2527153712d181$export$ac3673635a5387be);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $vIiRg = parcelRequire("vIiRg");
var $cEPfF = parcelRequire("cEPfF");

var $fptva = parcelRequire("fptva");

var $h8cgU = parcelRequire("h8cgU");

var $VSDnB = parcelRequire("VSDnB");


var $4jyNe = parcelRequire("4jyNe");

var $3WiFt = parcelRequire("3WiFt");
function $7d2527153712d181$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7d2527153712d181$var$ICON_BACKGROUND = `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`;
const $7d2527153712d181$var$ICON_COLOR = `var(--ds-icon-subtle, ${(0, $829f609a65d26a98$export$7c87d337fb91a97d)})`;
// used in a size calculation so can't be a token. Without this the avatar looks very squished
const $7d2527153712d181$var$ICON_PADDING = 4;
const $7d2527153712d181$var$avatarDefaultIconStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'flex',
    backgroundColor: $7d2527153712d181$var$ICON_COLOR,
    borderRadius: '50%',
    width: '100%',
    height: '100%',
    justifyContent: 'center',
    alignItems: 'center'
});
const $7d2527153712d181$var$SIZES = {
    xsmall: 16,
    small: 24,
    medium: 32,
    large: 40,
    xlarge: 96,
    xxlarge: 128
};
const $7d2527153712d181$var$nestedAvatarStyles = Object.entries((0, $vIiRg.AVATAR_SIZES)).reduce((styles, [key, size])=>{
    return {
        ...styles,
        [key]: /*#__PURE__*/ (0, $f8Sb3.css)({
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            width: `${size}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            height: `${size}px`,
            // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '& svg': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                width: `${size - $7d2527153712d181$var$ICON_PADDING}px`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                height: `${size - $7d2527153712d181$var$ICON_PADDING}px`
            }
        })
    };
}, {});
const $7d2527153712d181$var$avatarImageStyles = {
    name: "n68006",
    styles: "display:flex;flex:1 1 100%;width:100%;height:100%"
};
const $7d2527153712d181$export$9cfabd93718c0a2e = ({ alt: alt = '', src: src, size: size, testId: testId })=>{
    const [hasImageErrored, setHasImageErrored] = (0, $5uXOq.useState)(false);
    // If src changes, reset state
    (0, $5uXOq.useEffect)(()=>{
        setHasImageErrored(false);
    }, [
        src
    ]);
    if (!src || hasImageErrored) {
        if ((0, $VSDnB.fg)('enable-team-avatar-switch')) return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $4jyNe.FallbackAvatar), {
            "aria-label": alt,
            width: $7d2527153712d181$var$SIZES[size],
            height: $7d2527153712d181$var$SIZES[size],
            "data-testid": testId
        });
        return /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
            css: [
                $7d2527153712d181$var$avatarDefaultIconStyles,
                $7d2527153712d181$var$nestedAvatarStyles[size]
            ]
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fptva))), {
            label: alt,
            color: $7d2527153712d181$var$ICON_BACKGROUND,
            LEGACY_secondaryColor: $7d2527153712d181$var$ICON_COLOR,
            testId: testId && `${testId}--team`,
            spacing: "spacious",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($h8cgU)))
        }));
    }
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $cEPfF.AvatarContent), null, /*#__PURE__*/ (0, $f8Sb3.jsx)("img", {
        src: src,
        alt: alt,
        "data-testid": testId && `${testId}--image`,
        css: $7d2527153712d181$var$avatarImageStyles,
        onError: ()=>setHasImageErrored(true)
    }));
};
const $7d2527153712d181$export$ac3673635a5387be = (props)=>{
    if ((0, $VSDnB.fg)('team-avatar-radii')) return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $3WiFt.TeamAvatarImage), props);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)($7d2527153712d181$export$9cfabd93718c0a2e, props);
};

});
parcelRegister("h8cgU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c78cb3eb85357720$var$_react = $c78cb3eb85357720$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $c78cb3eb85357720$var$_peopleGroup = $c78cb3eb85357720$var$_interopRequireDefault((parcelRequire("fptva")));
function $c78cb3eb85357720$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c78cb3eb85357720$var$PeopleIcon = (props)=>/*#__PURE__*/ $c78cb3eb85357720$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><circle cx="16" cy="9" r="3"/><circle cx="8" cy="6" r="3"/><path d="M11 15c0-1.105.887-2 2-2h6c1.105 0 2 .885 2 2v3.73c0 3.027-10 3.027-10 0z"/><path d="M13 12a1.997 1.997 0 0 0-2-2H5c-1.113 0-2 .897-2 2.003v3.826c0 1.921 4.054 2.518 7 1.984v-2.807A3 3 0 0 1 12.997 12z"/></g></svg>`
    }, props, {
        newIcon: $c78cb3eb85357720$var$_peopleGroup.default
    }));
$c78cb3eb85357720$var$PeopleIcon.displayName = 'PeopleIcon';
var $c78cb3eb85357720$var$_default = module.exports.default = $c78cb3eb85357720$var$PeopleIcon;

});

parcelRegister("4jyNe", function(module, exports) {

$parcel$export(module.exports, "FallbackAvatar", () => $c800ab58c4d12cbb$export$eb63dcc490f6bbcd);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $MHKc7 = parcelRequire("MHKc7");
const $c800ab58c4d12cbb$var$styles = {
    wrapper: "_1e0c1txw _19pkv77o _2hwxv77o _otyrv77o _18u0v77o"
};
function $c800ab58c4d12cbb$export$eb63dcc490f6bbcd(props) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: $c800ab58c4d12cbb$var$styles.wrapper,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
            width: "32",
            height: "32",
            viewBox: "0 0 32 32",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            ...props,
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsxs)("g", {
                    clipPath: "url(#clip0_2032_552)",
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                            width: "32",
                            height: "32",
                            rx: "4",
                            fill: "#DCDFE4"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M10.6666 12.6666C11.7712 12.6666 12.6666 11.7712 12.6666 10.6666C12.6666 9.56206 11.7712 8.66663 10.6666 8.66663C9.56202 8.66663 8.66658 9.56206 8.66658 10.6666C8.66658 11.7712 9.56202 12.6666 10.6666 12.6666ZM10.6666 14.6666C12.8757 14.6666 14.6666 12.8758 14.6666 10.6666C14.6666 8.45749 12.8757 6.66663 10.6666 6.66663C8.45745 6.66663 6.66658 8.45749 6.66658 10.6666C6.66658 12.8758 8.45745 14.6666 10.6666 14.6666Z",
                            fill: "#44546F"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M21.3333 12.6666C22.4378 12.6666 23.3333 11.7712 23.3333 10.6666C23.3333 9.56206 22.4378 8.66663 21.3333 8.66663C20.2287 8.66663 19.3333 9.56206 19.3333 10.6666C19.3333 11.7712 20.2287 12.6666 21.3333 12.6666ZM21.3333 14.6666C23.5424 14.6666 25.3333 12.8758 25.3333 10.6666C25.3333 8.45749 23.5424 6.66663 21.3333 6.66663C19.1241 6.66663 17.3333 8.45749 17.3333 10.6666C17.3333 12.8758 19.1241 14.6666 21.3333 14.6666Z",
                            fill: "#44546F"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                            d: "M21.6666 16C24.4273 16.0004 26.6666 18.2385 26.6666 21V22.6666C26.6666 24.1394 25.4727 25.3333 23.9999 25.3333H20.135C18.0324 25.3333 16.1545 24.018 15.436 22.042L14.6843 19.9747C14.2531 18.7892 13.1264 18 11.8649 18H10.3333C8.6764 18 7.33325 19.3431 7.33325 21V22.6666C7.33325 23.0348 7.63173 23.3333 7.99992 23.3333H13.3333V25.3333H7.99992C6.52716 25.3333 5.33325 24.1394 5.33325 22.6666V21C5.33325 18.2385 7.57183 16 10.3333 16H11.8649C13.9674 16 15.8453 17.3153 16.5638 19.2913L17.3156 21.3585C17.7467 22.5441 18.8734 23.3333 20.135 23.3333H23.9999C24.3681 23.3333 24.6666 23.0348 24.6666 22.6666V21C24.6666 19.3437 23.3233 18.0004 21.6666 18H20.135V16H21.6666Z",
                            fill: "#44546F"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                            d: "M20.135 16C19.5972 16 18.7183 16.1407 18.0518 16.4564L18.908 18.2639C19.064 18.19 19.288 18.1205 19.537 18.0703C19.785 18.0203 20.0045 18 20.135 18V16Z",
                            fill: "#44546F"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("defs", {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)("clipPath", {
                        id: "clip0_2032_552",
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                            width: "32",
                            height: "32",
                            rx: "4",
                            fill: "white"
                        })
                    })
                })
            ]
        })
    });
}

});

parcelRegister("3WiFt", function(module, exports) {

$parcel$export(module.exports, "TeamAvatarImage", () => $ed1385df3f8966b5$export$ac3673635a5387be);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $a9yTd = parcelRequire("a9yTd");
const $ed1385df3f8966b5$var$boxShadowCssVar = '--avatar-box-shadow';
const $ed1385df3f8966b5$var$bgColorCssVar = '--avatar-bg-color';
/**
 * We need to maintan the container styles manually until Avatar provides the correct border radius.
 * After that we can return to wrapping in <AvatarContent> rather than span
 */ const $ed1385df3f8966b5$var$containerStyles = {
    root: "_19itglyw _12ji1r31 _1qu2glyw _12y31o36 _1reo15vq _18m915vq _v564ieh6 _1e0c1txw _kqswpfqs _4cvr1fhb _1bah1h6o _2lx21bp4 _80om1kw7 _6rthv77o _1pfhv77o _12l2v77o _ahbqv77o _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t _t9ec1aqe _9v7aze3t _qc5o1p41 _z0ai1osq _18postnw _1hfk18uv _aetrf705 _1peqidpf _11fnglyw",
    circle: "_2rko1q5u _14mj1q5u",
    positionRelative: "_kqswh2mm",
    disabled: "_80om13gf _1hfkvuon _1peqs237"
};
const $ed1385df3f8966b5$var$unboundStyles = {
    root: "_vchh18uv _bfhkcxp3 _16qs1nhn",
    interactive: "_80omtlke _4tpuw83z _ez1ykb7n _gcm11et6 _eeh8kb7n _jlxit94y"
};
const $ed1385df3f8966b5$var$avatarImageStyles = {
    image: "_16jlkb7n _1o9zkb7n _i0dl1osq _1e0c1txw _1bsb1osq _4t3i1osq"
};
const $ed1385df3f8966b5$var$SIZES = {
    xsmall: 16,
    small: 24,
    medium: 32,
    large: 40,
    xlarge: 96,
    xxlarge: 128
};
const $ed1385df3f8966b5$var$borderRadiusMap = {
    xsmall: "_2rko1y44",
    small: "_2rkoi2wt",
    medium: "_2rkoftgi",
    large: "_2rko19bv",
    xlarge: "_2rko1tcg",
    xxlarge: "_2rkozwfg"
};
const $ed1385df3f8966b5$var$widthHeightMap = {
    xsmall: "_1bsb7vkz _4t3i7vkz",
    small: "_1bsb1tcg _4t3i1tcg",
    medium: "_1bsbzwfg _4t3izwfg",
    large: "_1bsb1ylp _4t3i1ylp",
    xlarge: "_1bsb16xz _4t3i16xz",
    xxlarge: "_1bsb1qr7 _4t3i1qr7"
};
const $ed1385df3f8966b5$export$ac3673635a5387be = ({ alt: alt = '', src: src, size: size, testId: testId })=>{
    const [hasImageErrored, setHasImageErrored] = (0, $5uXOq.useState)(false);
    // If src changes, reset state
    (0, $5uXOq.useEffect)(()=>{
        setHasImageErrored(false);
    }, [
        src
    ]);
    if (!src || hasImageErrored) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $a9yTd.FallbackAvatar), {
        "aria-label": alt,
        width: $ed1385df3f8966b5$var$SIZES[size],
        height: $ed1385df3f8966b5$var$SIZES[size],
        "data-testid": testId
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "data-testid": testId,
        "aria-label": alt,
        className: (0, $bwpsq.default)([
            $ed1385df3f8966b5$var$unboundStyles.root,
            $ed1385df3f8966b5$var$containerStyles.root,
            $ed1385df3f8966b5$var$borderRadiusMap[size],
            $ed1385df3f8966b5$var$widthHeightMap[size]
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("img", {
            src: src,
            alt: alt,
            "data-testId": testId && `${testId}--image`,
            onError: ()=>setHasImageErrored(true),
            className: (0, $bwpsq.default)([
                $ed1385df3f8966b5$var$avatarImageStyles.image
            ])
        })
    });
};

});
parcelRegister("a9yTd", function(module, exports) {

$parcel$export(module.exports, "FallbackAvatar", () => $dc76f912cc56de65$export$eb63dcc490f6bbcd);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $MHKc7 = parcelRequire("MHKc7");
const $dc76f912cc56de65$var$styles = {
    wrapper: "_1e0c1txw _19pkv77o _2hwxv77o _otyrv77o _18u0v77o"
};
function $dc76f912cc56de65$export$eb63dcc490f6bbcd(props) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: $dc76f912cc56de65$var$styles.wrapper,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
            width: "32",
            height: "32",
            viewBox: "0 0 32 32",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            ...props,
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsxs)("g", {
                    clipPath: "url(#clip0_2032_552)",
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                            width: "32",
                            height: "32",
                            rx: "4",
                            fill: "#DCDFE4"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M10.6666 12.6666C11.7712 12.6666 12.6666 11.7712 12.6666 10.6666C12.6666 9.56206 11.7712 8.66663 10.6666 8.66663C9.56202 8.66663 8.66658 9.56206 8.66658 10.6666C8.66658 11.7712 9.56202 12.6666 10.6666 12.6666ZM10.6666 14.6666C12.8757 14.6666 14.6666 12.8758 14.6666 10.6666C14.6666 8.45749 12.8757 6.66663 10.6666 6.66663C8.45745 6.66663 6.66658 8.45749 6.66658 10.6666C6.66658 12.8758 8.45745 14.6666 10.6666 14.6666Z",
                            fill: "#44546F"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M21.3333 12.6666C22.4378 12.6666 23.3333 11.7712 23.3333 10.6666C23.3333 9.56206 22.4378 8.66663 21.3333 8.66663C20.2287 8.66663 19.3333 9.56206 19.3333 10.6666C19.3333 11.7712 20.2287 12.6666 21.3333 12.6666ZM21.3333 14.6666C23.5424 14.6666 25.3333 12.8758 25.3333 10.6666C25.3333 8.45749 23.5424 6.66663 21.3333 6.66663C19.1241 6.66663 17.3333 8.45749 17.3333 10.6666C17.3333 12.8758 19.1241 14.6666 21.3333 14.6666Z",
                            fill: "#44546F"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                            d: "M21.6666 16C24.4273 16.0004 26.6666 18.2385 26.6666 21V22.6666C26.6666 24.1394 25.4727 25.3333 23.9999 25.3333H20.135C18.0324 25.3333 16.1545 24.018 15.436 22.042L14.6843 19.9747C14.2531 18.7892 13.1264 18 11.8649 18H10.3333C8.6764 18 7.33325 19.3431 7.33325 21V22.6666C7.33325 23.0348 7.63173 23.3333 7.99992 23.3333H13.3333V25.3333H7.99992C6.52716 25.3333 5.33325 24.1394 5.33325 22.6666V21C5.33325 18.2385 7.57183 16 10.3333 16H11.8649C13.9674 16 15.8453 17.3153 16.5638 19.2913L17.3156 21.3585C17.7467 22.5441 18.8734 23.3333 20.135 23.3333H23.9999C24.3681 23.3333 24.6666 23.0348 24.6666 22.6666V21C24.6666 19.3437 23.3233 18.0004 21.6666 18H20.135V16H21.6666Z",
                            fill: "#44546F"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                            d: "M20.135 16C19.5972 16 18.7183 16.1407 18.0518 16.4564L18.908 18.2639C19.064 18.19 19.288 18.1205 19.537 18.0703C19.785 18.0203 20.0045 18 20.135 18V16Z",
                            fill: "#44546F"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("defs", {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)("clipPath", {
                        id: "clip0_2032_552",
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                            width: "32",
                            height: "32",
                            rx: "4",
                            fill: "white"
                        })
                    })
                })
            ]
        })
    });
}

});



parcelRegister("ggnNZ", function(module, exports) {

$parcel$export(module.exports, "isSquareIcon", () => $cf7e4fad001aa258$export$d5a05ffb65695bc0);

var $VSDnB = parcelRequire("VSDnB");
function $cf7e4fad001aa258$export$d5a05ffb65695bc0(src) {
    if (!src) return false;
    try {
        const url = new URL(src);
        const host = url.host;
        const path = url.pathname;
        if ((host.startsWith('ptc-directory-sited-static') || host.startsWith('teams-directory-frontend')) && path.includes('teams/avatars/v4') && (0, $VSDnB.fg)('enable-team-avatar-switch')) return true;
    } catch  {
    // The src wasn't a URL, so it's obviously not the refreshed avatar.
    }
    return false;
}

});


parcelRegister("3smIt", function(module, exports) {

$parcel$export(module.exports, "isExternalUser", () => $02015d62698c11ec$export$f6058dbcb5980cb);
$parcel$export(module.exports, "isUser", () => $02015d62698c11ec$export$2e44165f1da65304);
$parcel$export(module.exports, "isTeam", () => $02015d62698c11ec$export$f8c4277cb588611f);
$parcel$export(module.exports, "isGroup", () => $02015d62698c11ec$export$d7976824e9f55785);
$parcel$export(module.exports, "isEmail", () => $02015d62698c11ec$export$7fbbfbca30081d0);
$parcel$export(module.exports, "isCustom", () => $02015d62698c11ec$export$d3a8f0b77e9737fc);
$parcel$export(module.exports, "isDefaultValuePopulated", () => $02015d62698c11ec$export$d6978985a41b0c8);
$parcel$export(module.exports, "extractOptionValue", () => $02015d62698c11ec$export$7ae97131df521bff);
$parcel$export(module.exports, "isIterable", () => $02015d62698c11ec$export$9652023d9040757);
$parcel$export(module.exports, "getOptions", () => $02015d62698c11ec$export$d2312e68e1f5ad00);
$parcel$export(module.exports, "optionToSelectableOptions", () => $02015d62698c11ec$export$e6fda14a194bcbcc);
$parcel$export(module.exports, "getAvatarSize", () => $02015d62698c11ec$export$695fb564e621339a);
$parcel$export(module.exports, "isChildInput", () => $02015d62698c11ec$export$3c62cf9a01367f27);
$parcel$export(module.exports, "isSingleValue", () => $02015d62698c11ec$export$203c2bd2662d1ca2);
$parcel$export(module.exports, "hasValue", () => $02015d62698c11ec$export$96bdbc84526f3739);
$parcel$export(module.exports, "callCallback", () => $02015d62698c11ec$export$df325aa844b03c31);
$parcel$export(module.exports, "getAvatarUrl", () => $02015d62698c11ec$export$b4f8f1f54acec99b);
$parcel$export(module.exports, "isPopupUserPickerByComponent", () => $02015d62698c11ec$export$4f60a74234178416);
$parcel$export(module.exports, "isLozengeText", () => $02015d62698c11ec$export$5419897287f5f1c7);

var $8QpSo = parcelRequire("8QpSo");


var $b9dFI = parcelRequire("b9dFI");
const $02015d62698c11ec$export$f6058dbcb5980cb = (option)=>option.type === (0, $f93312f7d4958f08$export$50042ec1d2e00e63) || Boolean(option.isExternal);
const $02015d62698c11ec$export$2e44165f1da65304 = (option)=>option.type === undefined || option.type === (0, $f93312f7d4958f08$export$8436e53e45ffe15b);
const $02015d62698c11ec$export$f8c4277cb588611f = (option)=>option.type === (0, $f93312f7d4958f08$export$26bc40b960693765);
const $02015d62698c11ec$export$d7976824e9f55785 = (option)=>option.type === (0, $f93312f7d4958f08$export$d460f747b73abb10);
const $02015d62698c11ec$export$7fbbfbca30081d0 = (option)=>option.type === (0, $f93312f7d4958f08$export$6662b3461398ef8c);
const $02015d62698c11ec$export$d3a8f0b77e9737fc = (option)=>option.type === (0, $f93312f7d4958f08$export$eafd0979afa5b224);
const $02015d62698c11ec$export$d6978985a41b0c8 = (value)=>value && !Array.isArray(value) || Array.isArray(value) && value.length > 0;
const $02015d62698c11ec$var$isOptionData = (option)=>option.name !== undefined;
const $02015d62698c11ec$export$3f993c492bd6c728 = (option)=>{
    if ($02015d62698c11ec$var$isOptionData(option)) return {
        data: option,
        isDisabled: option.isDisabled,
        label: option.name,
        value: option.id
    };
    else return {
        data: {
            ...option,
            name: option.id
        },
        isDisabled: option.isDisabled,
        label: option.id,
        value: option.id
    };
};
const $02015d62698c11ec$export$7ae97131df521bff = (value)=>{
    if (!value) return undefined;
    if (Array.isArray(value)) return value.map(({ data: option })=>option);
    return value.data;
};
const $02015d62698c11ec$export$9652023d9040757 = (a)=>typeof a?.[Symbol.iterator] === 'function';
const $02015d62698c11ec$export$d2312e68e1f5ad00 = (0, $8QpSo.default)((options)=>options.map($02015d62698c11ec$export$3f993c492bd6c728));
const $02015d62698c11ec$export$e6fda14a194bcbcc = (0, $8QpSo.default)((defaultValue)=>{
    if (!defaultValue) return null;
    if (Array.isArray(defaultValue)) return defaultValue.map($02015d62698c11ec$export$3f993c492bd6c728);
    return $02015d62698c11ec$export$3f993c492bd6c728(defaultValue);
});
const $02015d62698c11ec$export$695fb564e621339a = (appearance)=>appearance === 'big' ? 'medium' : appearance === 'multi' ? 'xsmall' : 'small';
const $02015d62698c11ec$export$3c62cf9a01367f27 = (child)=>child && typeof child === 'object' && child.props && child.props.type === 'text';
const $02015d62698c11ec$export$203c2bd2662d1ca2 = (value)=>!!value && !Array.isArray(value);
const $02015d62698c11ec$export$96bdbc84526f3739 = (value)=>!!value && value.trim().length > 0;
const $02015d62698c11ec$export$df325aa844b03c31 = (callback, ...args)=>{
    if (typeof callback === 'function') try {
        //  there is mystery error in IE 11, so we need this try-catch
        return callback(...args);
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error('@atlassian/user-select: an error happening in `callCallback`: ', error);
    }
};
const $02015d62698c11ec$export$b4f8f1f54acec99b = (optionData)=>{
    if ($02015d62698c11ec$export$2e44165f1da65304(optionData) || $02015d62698c11ec$export$f8c4277cb588611f(optionData) || $02015d62698c11ec$export$d3a8f0b77e9737fc(optionData)) return optionData.avatarUrl;
    return undefined;
};
const $02015d62698c11ec$export$4f60a74234178416 = (SelectComponent)=>SelectComponent === (0, $b9dFI.default);
const $02015d62698c11ec$export$7add003953ca6733 = (selectProps)=>selectProps.searchThreshold === -1;
const $02015d62698c11ec$export$5419897287f5f1c7 = (lozengeProp)=>{
    return lozengeProp?.hasOwnProperty('text') || false;
};

});
const $f93312f7d4958f08$export$8436e53e45ffe15b = 'user';
const $f93312f7d4958f08$export$50042ec1d2e00e63 = 'external_user';
const $f93312f7d4958f08$export$26bc40b960693765 = 'team';
const $f93312f7d4958f08$export$d460f747b73abb10 = 'group';
const $f93312f7d4958f08$export$6662b3461398ef8c = 'email';
const $f93312f7d4958f08$export$eafd0979afa5b224 = 'custom';



parcelRegister("4hqZ5", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ff23a711b4b109cded01cd0a5945034a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $31ddae7439c341a9$var$_react = $31ddae7439c341a9$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $31ddae7439c341a9$var$_peopleGroup = $31ddae7439c341a9$var$_interopRequireDefault((parcelRequire("fptva")));

var $31ddae7439c341a9$var$_people = $31ddae7439c341a9$var$_interopRequireDefault((parcelRequire("h8cgU")));
function $31ddae7439c341a9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for PeopleGroupIcon.
 * This component is PeopleGroupIcon, with `UNSAFE_fallbackIcon` set to "PeopleIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: representing a group or collection of people or users.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $31ddae7439c341a9$var$PeopleGroupIcon = (props)=>/*#__PURE__*/ $31ddae7439c341a9$var$_react.default.createElement($31ddae7439c341a9$var$_peopleGroup.default, Object.assign({
        LEGACY_fallbackIcon: $31ddae7439c341a9$var$_people.default
    }, props));
$31ddae7439c341a9$var$PeopleGroupIcon.Name = 'PeopleGroupIconMigration';
var $31ddae7439c341a9$var$_default = module.exports.default = $31ddae7439c341a9$var$PeopleGroupIcon;

});

parcelRegister("fuhQD", function(module, exports) {

$parcel$export(module.exports, "VerifiedTeamIcon", () => $a137cc376204c926$export$d7949f68d31e5edd);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $gqGjQ = parcelRequire("gqGjQ");

var $fGmbh = parcelRequire("fGmbh");

var $3bDjY = parcelRequire("3bDjY");

var $27dJz = parcelRequire("27dJz");
const $a137cc376204c926$export$d7949f68d31e5edd = ({ label: label = 'Verified Team', showTooltip: showTooltip, customTooltipContent: customTooltipContent })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const tooltipContent = showTooltip ? customTooltipContent || formatMessage((0, $27dJz.messages).verifiedIconDefaultTooltip) : undefined;
    return tooltipContent ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
        content: tooltipContent,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)("span", {
            tabIndex: 0,
            role: "button",
            "data-testid": "verified-team-icon",
            children: [
                ' ',
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gqGjQ))), {
                    color: "var(--ds-icon-accent-blue, #1D7AFC)",
                    LEGACY_size: "medium",
                    label: tooltipContent,
                    spacing: "spacious",
                    LEGACY_fallbackIcon: (0, $fGmbh.default)
                })
            ]
        })
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gqGjQ))), {
        color: "var(--ds-icon-accent-blue, #1D7AFC)",
        LEGACY_size: "medium",
        spacing: "spacious",
        label: label,
        LEGACY_fallbackIcon: (0, $fGmbh.default)
    });
};

});
parcelRegister("gqGjQ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::08303db08bddd05336395b40b61b967a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bf5fe6b7538334be$var$_react = $bf5fe6b7538334be$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $bf5fe6b7538334be$var$_baseNew = $bf5fe6b7538334be$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $bf5fe6b7538334be$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusVerified".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for representing verified content.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bf5fe6b7538334be$var$StatusVerifiedIcon = (props)=>/*#__PURE__*/ $bf5fe6b7538334be$var$_react.default.createElement($bf5fe6b7538334be$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M9.15.444a1.713 1.713 0 0 0-2.3 0L5.7 1.486a.2.2 0 0 1-.15.055L4 1.481a1.713 1.713 0 0 0-1.763 1.48l-.21 1.536a.2.2 0 0 1-.08.139l-1.225.95c-.697.54-.87 1.52-.4 2.266l.827 1.312c.03.047.04.104.027.159l-.328 1.515A1.713 1.713 0 0 0 2 12.831l1.477.474a.2.2 0 0 1 .123.103l.723 1.372c.41.78 1.346 1.12 2.162.787l1.436-.586a.2.2 0 0 1 .16 0l1.436.586a1.713 1.713 0 0 0 2.162-.787l.723-1.372a.2.2 0 0 1 .123-.103l1.477-.474a1.713 1.713 0 0 0 1.15-1.993l-.328-1.515a.2.2 0 0 1 .028-.159l.827-1.312a1.71 1.71 0 0 0-.4-2.266l-1.225-.95a.2.2 0 0 1-.08-.14l-.21-1.536A1.713 1.713 0 0 0 12 1.481l-1.55.06a.2.2 0 0 1-.15-.055zm3.176 5.036-1.152-.96L6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0z" clip-rule="evenodd"/>`
    }, props));
$bf5fe6b7538334be$var$StatusVerifiedIcon.displayName = 'StatusVerifiedIcon';
var $bf5fe6b7538334be$var$_default = module.exports.default = $bf5fe6b7538334be$var$StatusVerifiedIcon;

});

parcelRegister("fGmbh", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9bd2ad2ea16bb95$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $5LWLA = parcelRequire("5LWLA");
const $d9bd2ad2ea16bb95$var$VerifiedIconGlyph = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)("svg", {
        width: "33",
        height: "32",
        viewBox: "0 0 33 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: props.className,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M18.6666 6.65507C17.7592 4.89362 15.2407 4.89362 14.3332 6.65507C13.7879 7.7135 12.5577 8.22306 11.4237 7.86022C9.53648 7.25639 7.75565 9.03721 8.35949 10.9244C8.72232 12.0584 8.21276 13.2886 7.15434 13.8339C5.39289 14.7414 5.39289 17.2599 7.15434 18.1674C8.21276 18.7127 8.72232 19.9429 8.35949 21.0769C7.75565 22.9641 9.53648 24.7449 11.4237 24.1411C12.5577 23.7783 13.7879 24.2878 14.3332 25.3462C15.2407 27.1077 17.7592 27.1077 18.6666 25.3462C19.212 24.2878 20.4421 23.7783 21.5761 24.1411C23.4634 24.7449 25.2442 22.9641 24.6404 21.0769C24.2775 19.9429 24.7871 18.7127 25.8455 18.1674C27.607 17.2599 27.607 14.7414 25.8455 13.8339C24.7871 13.2886 24.2775 12.0584 24.6404 10.9244C25.2442 9.03721 23.4634 7.25639 21.5761 7.86022C20.4421 8.22306 19.212 7.7135 18.6666 6.65507ZM20.7898 12.7002L20.8932 12.7923C21.323 13.2221 21.3537 13.8998 20.9853 14.365L20.8932 14.4684L16.1524 19.2091C15.7226 19.6389 15.0449 19.6696 14.5797 19.3012L14.4764 19.2091L12.106 16.8388C11.6431 16.3759 11.6431 15.6255 12.106 15.1627C12.5358 14.7329 13.2135 14.7022 13.6787 15.0706L13.7821 15.1627L15.3146 16.6944L19.2171 12.7923C19.6469 12.3625 20.3246 12.3318 20.7898 12.7002Z",
            fill: "currentColor"
        })
    });
/**
 * __VerifiedIcon__
 */ const $d9bd2ad2ea16bb95$var$VerifiedIcon = ({ label: label, primaryColor: primaryColor, secondaryColor: secondaryColor, size: size, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $5LWLA.default), {
        label: label,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        size: size,
        testId: testId,
        glyph: $d9bd2ad2ea16bb95$var$VerifiedIconGlyph
    });
var $d9bd2ad2ea16bb95$export$2e2bcd8739ae039 = $d9bd2ad2ea16bb95$var$VerifiedIcon;

});

parcelRegister("27dJz", function(module, exports) {

$parcel$export(module.exports, "messages", () => $952fb45ddff9712a$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $952fb45ddff9712a$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    verifiedIconDefaultTooltip: {
        id: 'ptc-directory.team-profile-page.team-name.verified-team.icon.tooltip',
        defaultMessage: 'Managed teams are verified because they can only be changed by an admin.',
        description: 'Tooltip text for the verified team icon'
    }
});

});



parcelRegister("fIpmY", function(module, exports) {

$parcel$export(module.exports, "MultiValueContainer", () => $0a44bca42d442dd9$export$cf9cf2a30a59265c);
/* MultiValueContainer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bChGW = parcelRequire("bChGW");

var $5uXOq = parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");

var $ousew = parcelRequire("ousew");

var $8fG8p = parcelRequire("8fG8p");

var $3smIt = parcelRequire("3smIt");

var $jNYXM = parcelRequire("jNYXM");
const $0a44bca42d442dd9$var$valueContainerStyles = {
    root: "_yv0e5bpd _ca0q12x7 _n3td12x7 _19bv12x7 _1reo15vq _18m91wug _1fjgglyw _c71l1osq _1suq18uv _1ke8idpf"
};
class $0a44bca42d442dd9$export$cf9cf2a30a59265c extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).PureComponent {
    static getDerivedStateFromProps(nextProps, prevState) {
        return {
            valueSize: nextProps.getValue ? nextProps.getValue().length : 0,
            previousValueSize: prevState.valueSize
        };
    }
    constructor(props){
        super(props), this.timeoutId = null, this.scrollToBottom = ()=>{
            this.timeoutId = window.setTimeout(()=>{
                const { ref: { current: current } } = this.valueContainerInnerProps;
                if (current !== null) {
                    const container = (0, (/*@__PURE__*/$parcel$interopDefault($7nsd3))).findDOMNode(current);
                    if (container instanceof HTMLDivElement) container.scrollTop = container.scrollHeight;
                }
                this.timeoutId = null;
            });
        }, this.showPlaceholder = ()=>{
            const { selectProps: { value: value } } = this.props;
            return value && value.length > 0;
        }, this.addPlaceholder = (placeholder)=>{
            const children = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.map(this.props.children, (child)=>(0, $3smIt.isChildInput)(child) && this.showPlaceholder() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).cloneElement(child, {
                    placeholder: placeholder
                }) : child);
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Fragment), {
                children: children
            });
        }, this.renderChildren = ()=>{
            const { //@ts-ignore react-select unsupported props
            selectProps: { addMoreMessage: addMoreMessage, isDisabled: isDisabled } } = this.props;
            // Do not render "Add more..." message if picker is disabled
            if (isDisabled) return this.props.children;
            if (addMoreMessage === undefined) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...(0, $8fG8p.messages).addMore,
                children: (addMore)=>{
                    let addMoreMessages = addMore;
                    if (addMore && typeof addMore === 'string') addMoreMessages = [
                        addMore
                    ];
                    const placeholder = addMoreMessages?.join('') ?? '';
                    return this.addPlaceholder(placeholder);
                }
            });
            return this.addPlaceholder(addMoreMessage);
        }, //@ts-ignore react-select unsupported props
        this.onValueContainerClick = this.props.selectProps.onValueContainerClick;
        this.state = {
            valueSize: 0,
            previousValueSize: 0
        };
        this.valueContainerInnerProps = {
            ref: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef()
        };
    }
    componentDidUpdate() {
        const { previousValueSize: previousValueSize, valueSize: valueSize } = this.state;
        //@ts-ignore react-select unsupported props
        const { isFocused: isFocused } = this.props.selectProps;
        if (valueSize > previousValueSize && isFocused) {
            if (this.timeoutId) {
                window.clearTimeout(this.timeoutId);
                this.timeoutId = null;
            }
            this.scrollToBottom();
        }
    }
    componentWillUnmount() {
        if (this.timeoutId) window.clearTimeout(this.timeoutId);
    }
    render() {
        const { children: children, innerProps: innerProps, ...valueContainerProps } = this.props;
        const props = {
            ...valueContainerProps,
            innerProps: this.valueContainerInnerProps
        };
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jNYXM.default), {
            isEnabled: this.onValueContainerClick,
            onMouseDown: this.onValueContainerClick,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bChGW.components).ValueContainer, {
                ...props,
                xcss: $0a44bca42d442dd9$var$valueContainerStyles.root,
                children: this.renderChildren()
            })
        });
    }
}

});
parcelRegister("8fG8p", function(module, exports) {

$parcel$export(module.exports, "messages", () => $7b21650c04984462$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $7b21650c04984462$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    placeholder: {
        id: 'fabric.elements.user-picker.placeholder',
        defaultMessage: 'Enter people or teams...',
        description: 'Placeholder description for empty user/team/email select field.'
    },
    addMore: {
        id: 'fabric.elements.user-picker.placeholder.add-more',
        defaultMessage: 'add more people...',
        description: 'Placeholder for multi user picker when the field is not empty.'
    },
    remove: {
        id: 'fabric.elements.user-picker.multi.remove-item',
        defaultMessage: 'Remove',
        description: 'Tooltip for the single item remove button in a multi user select field.'
    },
    clear: {
        id: 'fabric.elements.user-picker.single.clear',
        defaultMessage: 'Clear',
        description: 'Tooltip for clear button in the single user select field.'
    },
    errorMessage: {
        id: 'fabric.elements.user-picker.error.message',
        defaultMessage: 'Something went wrong',
        description: 'Error message to display when options fail to load.'
    },
    memberCountWithoutYou: {
        id: 'fabric.elements.user-picker.team.member.count',
        defaultMessage: "Team \u2022 {count} {count, plural, one {member} other {members}}",
        description: 'Byline to show the number of members in the team when the current user is not a member of the team'
    },
    memberCountWithYou: {
        id: 'fabric.elements.user-picker.team.member.count.including.you',
        defaultMessage: "Team \u2022 {count} {count, plural, one {member} other {members}}, including you",
        description: 'Byline to show the number of members in the team when the current user is also a member of the team'
    },
    plus50MembersWithoutYou: {
        id: 'fabric.elements.user-picker.team.member.50plus',
        defaultMessage: "Team \u2022 50+ members",
        description: 'Byline to show the number of members in the team when the number exceeds 50'
    },
    plus50MembersWithYou: {
        id: 'fabric.elements.user-picker.team.member.50plus.including.you',
        defaultMessage: "Team \u2022 50+ members, including you",
        description: 'Byline to show the number of members in the team when the number exceeds 50 and also includes the current user'
    },
    addEmail: {
        id: 'fabric.elements.user-picker.email.add',
        defaultMessage: 'Add user',
        description: 'Byline for valid email option.'
    },
    selectToAddEmail: {
        id: 'fabric.elements.user-picker.email.select.to.add',
        defaultMessage: 'Select an email address',
        description: 'Byline for valid email option.'
    },
    continueToAddEmail: {
        id: 'fabric.elements.user-picker.email.add.potential',
        defaultMessage: 'Enter an email address',
        description: 'Byline for a potentially valid email option.'
    },
    groupByline: {
        id: 'fabric.elements.user-picker.group.byline',
        defaultMessage: 'Admin-managed group',
        description: 'Byline for admin-managed groups'
    },
    externalUserSourcesHeading: {
        id: 'fabric.elements.user-picker.external.sourced.from',
        defaultMessage: 'Found in:',
        description: 'From where the external user is coming'
    },
    externalUserSourcesError: {
        id: 'fabric.elements.user-picker.external.sourced.error',
        defaultMessage: "We can't connect you right now.",
        description: "Error message when we can't fetch a user's import sources"
    },
    slackProvider: {
        id: 'fabric.elements.user-picker.slack.provider',
        defaultMessage: 'Slack',
        description: 'This external user is sourced from Slack provider'
    },
    googleProvider: {
        id: 'fabric.elements.user-picker.google.provider',
        defaultMessage: 'Google',
        description: 'This external user is sourced from Google provider'
    },
    microsoftProvider: {
        id: 'fabric.elements.user-picker.microsoft.provider',
        defaultMessage: 'Microsoft',
        description: 'This external user is sourced from Microsoft provider'
    },
    gitHubProvider: {
        id: 'fabric.elements.user-picker.github.provider',
        defaultMessage: 'GitHub',
        description: 'This external user is sourced from GitHub provider'
    },
    jiraSource: {
        id: 'fabric.elements.user-picker.source.jira',
        defaultMessage: 'Jira',
        description: 'This external user is sourced from Jira'
    },
    confluenceSource: {
        id: 'fabric.elements.user-picker.source.confluence',
        defaultMessage: 'Confluence',
        description: 'This external user is sourced from Confluence'
    },
    otherAtlassianSource: {
        id: 'fabric.elements.user-picker.source.other-atlassian',
        defaultMessage: 'Other Atlassian products',
        description: 'This external user is sourced from Atlassian products other than Jira and Confluence'
    },
    memberLozengeText: {
        id: 'fabric.elements.user-picker.member.lozenge.text',
        defaultMessage: 'MEMBER',
        description: 'Text within the Lozenge when the user is a workspace member'
    },
    guestLozengeText: {
        id: 'fabric.elements.user-picker.guest.lozenge.text',
        defaultMessage: 'GUEST',
        description: 'Text within the lozenge when the user is a guest of confluence'
    },
    guestUserLozengeTooltip: {
        id: 'fabric.elements.user-picker.guest.lozenge.tooltip.user',
        defaultMessage: 'Guests can only access certain spaces and have limited access to user info.',
        description: 'Tooltip text for guest lozenge showing that a user is a guest in Confluence'
    },
    guestGroupLozengeTooltip: {
        id: 'fabric.elements.user-picker.guest.lozenge.tooltip.group',
        defaultMessage: 'Guest groups can only access certain spaces and have limited access to user info.',
        description: 'Tooltip text for lozenge showing that a group is for guests in Confluence'
    }
});

});

parcelRegister("jNYXM", function(module, exports) {

$parcel$export(module.exports, "default", () => $4661c12157fe2c0e$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");
function $4661c12157fe2c0e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/**
 * Conditional wrapper for the ValueContainer in Select. Provides a workaround
 * for issues using react-select on react-beautiful-dnd Draggable elements.
 * @returns
 */ var $4661c12157fe2c0e$var$_ref = {
    name: "1ff36h2",
    styles: "flex-grow:1"
};
const $4661c12157fe2c0e$var$ValueContainerWrapper = ({ children: children, isEnabled: isEnabled, onMouseDown: onMouseDown })=>{
    return isEnabled ? // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, jsx-a11y/no-static-element-interactions -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $4661c12157fe2c0e$var$_ref,
        onMouseDown: onMouseDown
    }, children) : children;
};
var $4661c12157fe2c0e$export$2e2bcd8739ae039 = $4661c12157fe2c0e$var$ValueContainerWrapper;

});


parcelRegister("3QONt", function(module, exports) {

$parcel$export(module.exports, "Option", () => $99bbff5d4b124ec0$export$36d18380658d5d20);

var $2OMIu = parcelRequire("2OMIu");

var $MHKc7 = parcelRequire("MHKc7");

var $bChGW = parcelRequire("bChGW");

var $3bDjY = parcelRequire("3bDjY");

var $5uXOq = parcelRequire("5uXOq");

var $7SChb = parcelRequire("7SChb");

var $IMPHa = parcelRequire("IMPHa");

var $8QliZ = parcelRequire("8QliZ");

var $jC9IK = parcelRequire("jC9IK");

var $3SqqV = parcelRequire("3SqqV");

var $f4ndh = parcelRequire("f4ndh");

var $3smIt = parcelRequire("3smIt");

var $M0UM1 = parcelRequire("M0UM1");
const $99bbff5d4b124ec0$var$defaultOption = ({ data: { data: data }, isSelected: isSelected, status: status })=>// @ts-expect-error - <UserOption> expects `data` to be of User interface, but data is OptionData interface by default. Check if the `user` props in UserOption should also accept OptionData or refactor this file to accept generics
    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7SChb.UserOption), {
        user: data,
        status: status,
        isSelected: isSelected
    });
const $99bbff5d4b124ec0$var$dataOption = ({ data: { data: data }, isSelected: isSelected, status: status, selectProps: selectProps })=>{
    if ((0, $3smIt.isExternalUser)(data)) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $IMPHa.default), {
        user: data,
        status: status,
        isSelected: isSelected
    });
    if ((0, $3smIt.isUser)(data)) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7SChb.UserOption), {
        user: data,
        status: status,
        isSelected: isSelected
    });
    if ((0, $3smIt.isEmail)(data)) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3SqqV.default), {
        email: data,
        emailValidity: (0, $M0UM1.isValidEmail)(data.id),
        isSelected: isSelected,
        label: selectProps.emailLabel
    });
    if ((0, $3smIt.isTeam)(data)) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8QliZ.default), {
        team: data,
        isSelected: isSelected
    });
    if ((0, $3smIt.isGroup)(data)) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jC9IK.default), {
        group: data,
        isSelected: isSelected
    });
    if ((0, $3smIt.isCustom)(data)) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $f4ndh.default), {
        data: data,
        isSelected: isSelected
    });
    return null;
};
const $99bbff5d4b124ec0$var$dataOptionWithTooltip = (props)=>{
    if (props.data?.data?.tooltip) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
        content: props.data?.data?.tooltip,
        children: (tooltipProps)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                ...tooltipProps,
                children: $99bbff5d4b124ec0$var$dataOption(props)
            })
    });
    return $99bbff5d4b124ec0$var$dataOption(props);
};
const $99bbff5d4b124ec0$export$36d18380658d5d20 = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $bChGW.components).Option, {
        ...props,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Suspense, {
            fallback: $99bbff5d4b124ec0$var$defaultOption(props),
            children: $99bbff5d4b124ec0$var$dataOptionWithTooltip(props)
        })
    });

});
parcelRegister("7SChb", function(module, exports) {

$parcel$export(module.exports, "UserOption", () => $f97ab606ddc0972b$export$8e59f78010871662);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 

var $f8Sb3 = parcelRequire("f8Sb3");

var $5uXOq = parcelRequire("5uXOq");

var $bfXHv = parcelRequire("bfXHv");

var $1Y8bw = parcelRequire("1Y8bw");

var $5pJx4 = parcelRequire("5pJx4");

var $3smIt = parcelRequire("3smIt");

var $VSDnB = parcelRequire("VSDnB");
class $f97ab606ddc0972b$export$8e59f78010871662 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).PureComponent {
    render() {
        return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $bfXHv.AvatarItemOption), {
            avatar: this.renderAvatar(),
            lozenge: this.getLozengeProps(),
            isDisabled: this.props.user.isDisabled,
            primaryText: this.getPrimaryText(),
            secondaryText: this.renderSecondaryText()
        });
    }
    constructor(...args){
        super(...args), this.getPrimaryText = ()=>{
            const { user: { name: name, publicName: publicName, highlight: highlight } } = this.props;
            const result = [
                /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
                    key: "name",
                    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    css: (0, $bfXHv.textWrapper)(this.props.isSelected ? `var(--ds-text-selected, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})` : `var(--ds-text, ${0, $829f609a65d26a98$export$7d61b15e0da132af})`)
                }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $1Y8bw.HighlightText), {
                    highlights: highlight && highlight.name
                }, name))
            ];
            if ((0, $3smIt.hasValue)(publicName) && name.trim() !== publicName.trim()) result.push(/*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, {
                key: "publicName"
            }, ' ', /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
                // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                css: (0, $bfXHv.textWrapper)(this.props.isSelected ? `var(--ds-text-selected, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})` : `var(--ds-text-subtlest, ${0, $829f609a65d26a98$export$f563ee71e9ee74cd})`)
            }, "(", /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $1Y8bw.HighlightText), {
                highlights: highlight && highlight.publicName
            }, publicName), ")")));
            return result;
        }, this.renderSecondaryText = ()=>this.props.user.byline ? /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
                // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                css: (0, $bfXHv.textWrapper)(this.props.isSelected ? `var(--ds-text-selected, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})` : `var(--ds-text-subtlest, ${0, $829f609a65d26a98$export$f563ee71e9ee74cd})`)
            }, this.props.user.byline) : undefined, this.renderAvatar = ()=>{
            const { user: { avatarUrl: avatarUrl }, status: status } = this.props;
            return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5pJx4.SizeableAvatar), {
                appearance: // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
                (0, $VSDnB.fg)('platform-component-visual-refresh') ? 'medium' : 'big',
                src: avatarUrl,
                presence: status
            });
        }, this.getLozengeProps = ()=>typeof this.props.user.lozenge === 'string' ? {
                text: this.props.user.lozenge
            } : this.props.user.lozenge;
    }
}

});
parcelRegister("bfXHv", function(module, exports) {

$parcel$export(module.exports, "textWrapper", () => $9d51fec62de0f8e9$export$aa6223da92b253dd);
$parcel$export(module.exports, "AvatarItemOption", () => $9d51fec62de0f8e9$export$164a9d9b3b86dd0c);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $3u0c5 = parcelRequire("3u0c5");

var $3smIt = parcelRequire("3smIt");
function $9d51fec62de0f8e9$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

const $9d51fec62de0f8e9$var$AsyncTooltip = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("7LtDy")).then((module)=>{
        return {
            default: module.default
        };
    }));
const $9d51fec62de0f8e9$var$wrapper = (isDisabled)=>/*#__PURE__*/ (0, $f8Sb3.css)({
        alignItems: 'center',
        boxSizing: 'border-box',
        display: 'flex',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 1,
        outline: 'none',
        margin: 0,
        width: '100%',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        cursor: isDisabled ? 'not-allowed' : 'pointer',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: isDisabled ? "var(--ds-opacity-disabled, 0.4)" : undefined
    });
const $9d51fec62de0f8e9$var$optionWrapper = {
    name: "yyrqoa",
    styles: "max-width:100%;min-width:0;flex:1 1 100%;line-height:1.4;padding-left:var(--ds-space-100, 8px)"
};
const $9d51fec62de0f8e9$var$getTextStyle = (isSecondary)=>{
    const secondaryCssArgs = isSecondary ? {
        font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
    } : {};
    return /*#__PURE__*/ (0, $f8Sb3.css)({
        margin: 0,
        overflowX: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...secondaryCssArgs
    });
};
const $9d51fec62de0f8e9$var$additionalInfo = {
    name: "tjo4qw",
    styles: "float:right"
};
const $9d51fec62de0f8e9$export$aa6223da92b253dd = (color)=>/*#__PURE__*/ (0, $f8Sb3.css)({
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        display: 'inline',
        color: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color
    });
const $9d51fec62de0f8e9$export$164a9d9b3b86dd0c = ({ avatar: avatar, isDisabled: isDisabled, lozenge: lozenge, primaryText: primaryText, secondaryText: secondaryText })=>{
    const renderLozenge = ()=>{
        if ((0, $3smIt.isLozengeText)(lozenge)) {
            if (lozenge?.tooltip) // Note that entire Lozenge must be wrapped in the Tooltip (rather than just the
            // Lozenge text) or tooltip won't work
            return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Suspense, {
                fallback: /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $3u0c5.default), lozenge, lozenge.text)
            }, /*#__PURE__*/ (0, $f8Sb3.jsx)($9d51fec62de0f8e9$var$AsyncTooltip, {
                content: lozenge.tooltip
            }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $3u0c5.default), lozenge, lozenge.text)));
            return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $3u0c5.default), lozenge, lozenge.text);
        }
        return lozenge;
    };
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: $9d51fec62de0f8e9$var$wrapper(isDisabled)
    }, avatar, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $9d51fec62de0f8e9$var$optionWrapper
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", null, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $9d51fec62de0f8e9$var$getTextStyle()
    }, primaryText), secondaryText && /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $9d51fec62de0f8e9$var$getTextStyle(true)
    }, secondaryText))), lozenge && /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $9d51fec62de0f8e9$var$additionalInfo
    }, renderLozenge())));
};

});

parcelRegister("1Y8bw", function(module, exports) {

$parcel$export(module.exports, "HighlightText", () => $dbc13bb98bfc2c59$export$bb02e7bc6e1a7119);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
class $dbc13bb98bfc2c59$export$bb02e7bc6e1a7119 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).PureComponent {
    render() {
        const { children: children, highlights: highlights } = this.props;
        const parts = [];
        let lastIndex = 0;
        if (highlights) highlights.sort((a, b)=>a.start - b.start).reduce((highlights, highlight)=>{
            const lastHighlight = highlights[highlights.length - 1];
            if (!lastHighlight || highlight.start > lastHighlight.end + 1) return highlights.concat(highlight);
            if (highlight.end > lastHighlight.end) lastHighlight.end = highlight.end;
            return highlights;
        }, []).forEach((highlight)=>{
            const { start: start, end: end } = highlight;
            if (start >= end) return;
            if (start > lastIndex) parts.push({
                value: children.substring(lastIndex, start),
                matches: false
            });
            parts.push({
                value: children.substring(start, end + 1),
                matches: true
            });
            lastIndex = end + 1;
        });
        if (lastIndex < children.length) parts.push({
            value: children.substring(lastIndex, children.length),
            matches: false
        });
        return parts.map((part, index)=>{
            if (part.matches) return /*#__PURE__*/ (0, $2OMIu.jsx)("b", {
                children: part.value
            }, index);
            return part.value;
        });
    }
}

});


parcelRegister("IMPHa", function(module, exports) {

$parcel$export(module.exports, "default", () => $244ad38dc6a6e0e3$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

const $244ad38dc6a6e0e3$var$AsyncExternalUserOption = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("gT7hv")).then((module)=>{
        return {
            default: module.ExternalUserOption
        };
    }));
var $244ad38dc6a6e0e3$export$2e2bcd8739ae039 = $244ad38dc6a6e0e3$var$AsyncExternalUserOption;

});
parcelRegister("gT7hv", function(module, exports) {

let $c4b76e5519d7804b$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $c4b76e5519d7804b$var$load("76n7a"),
    $c4b76e5519d7804b$var$load("l253H"),
    $c4b76e5519d7804b$var$load("ffQaD"),
    $c4b76e5519d7804b$var$load("kvRbA"),
    $c4b76e5519d7804b$var$load("5VpQx")
]).then(()=>parcelRequire('358Ik'));

});


parcelRegister("8QliZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e55a6473b89765e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

const $6e55a6473b89765e$var$AsyncTeamOption = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("g6gqU")).then((module)=>{
        return {
            default: module.TeamOption
        };
    }));
var $6e55a6473b89765e$export$2e2bcd8739ae039 = $6e55a6473b89765e$var$AsyncTeamOption;

});
parcelRegister("g6gqU", function(module, exports) {

let $bb89f424849bb75d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $bb89f424849bb75d$var$load("k9jju").then(()=>parcelRequire('8Pt0F'));

});


parcelRegister("jC9IK", function(module, exports) {

$parcel$export(module.exports, "default", () => $d883d47691bcfd0f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

const $d883d47691bcfd0f$var$AsyncGroupOption = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("itjaq")).then((module)=>{
        return {
            default: module.GroupOption
        };
    }));
var $d883d47691bcfd0f$export$2e2bcd8739ae039 = $d883d47691bcfd0f$var$AsyncGroupOption;

});
parcelRegister("itjaq", function(module, exports) {

let $d729cda1eb2cfa2f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d729cda1eb2cfa2f$var$load("ioajZ").then(()=>parcelRequire('ctysX'));

});


parcelRegister("3SqqV", function(module, exports) {

$parcel$export(module.exports, "default", () => $120c09dc4c3dec5f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

const $120c09dc4c3dec5f$var$AsyncEmailOption = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("8Wiyo")).then((module)=>{
        return {
            default: module.EmailOption
        };
    }));
var $120c09dc4c3dec5f$export$2e2bcd8739ae039 = $120c09dc4c3dec5f$var$AsyncEmailOption;

});
parcelRegister("8Wiyo", function(module, exports) {

let $682221e12a9af171$var$load = (parcelRequire("28QjX"))(4);
module.exports = $682221e12a9af171$var$load("9zytF").then(()=>parcelRequire('4CChz'));

});


parcelRegister("f4ndh", function(module, exports) {

$parcel$export(module.exports, "default", () => $57cc7ffb924c0e65$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

const $57cc7ffb924c0e65$var$AsyncCustomOption = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("W94KR")).then((module)=>{
        return {
            default: module.CustomOption
        };
    }));
var $57cc7ffb924c0e65$export$2e2bcd8739ae039 = $57cc7ffb924c0e65$var$AsyncCustomOption;

});
parcelRegister("W94KR", function(module, exports) {

let $0aec75234bb4e828$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0aec75234bb4e828$var$load("bkE8d").then(()=>parcelRequire('iphiD'));

});


parcelRegister("M0UM1", function(module, exports) {

$parcel$export(module.exports, "isValidEmail", () => $8e40db00ccd032ac$export$371e338370561054);
const $8e40db00ccd032ac$var$validRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/i;
const $8e40db00ccd032ac$var$potentialRegex = /^[^\s@]+@[^\s@]*$/i;
const $8e40db00ccd032ac$export$371e338370561054 = (inputText)=>{
    if (inputText.match($8e40db00ccd032ac$var$validRegex)) return 'VALID';
    if (inputText.match($8e40db00ccd032ac$var$potentialRegex)) return 'POTENTIAL';
    return 'INVALID';
};

});


parcelRegister("6Kkci", function(module, exports) {

$parcel$export(module.exports, "SingleValue", () => $667e1159563155af$export$1949dac661ba6e3a);
/* SingleValue.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $bChGW = parcelRequire("bChGW");

var $5pJx4 = parcelRequire("5pJx4");

var $3smIt = parcelRequire("3smIt");

var $fuhQD = parcelRequire("fuhQD");

var $MHKc7 = parcelRequire("MHKc7");
var $bUmQV = parcelRequire("bUmQV");
var $c0aEF = parcelRequire("c0aEF");
const $667e1159563155af$var$styles = {
    avatarItem: "_1reo15vq _18m915vq _4cvr1h6o _1ul953f4",
    avatarItemTextWrapper: "_16jlkb7n _1o9zkb7n _i0dl1osq _1ul9idpf _p12f1osq _bozgu2gc _vwz419ii",
    avatarItemText: "_syaz1fxt _1reo15vq _1bto1l2s _o5721q9c"
};
const $667e1159563155af$var$ElementAfter = (props)=>{
    const { data: { data: data } } = props;
    if ((0, $3smIt.isTeam)(data) && data.verified) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fuhQD.VerifiedTeamIcon), {});
    return null;
};
const $667e1159563155af$export$1949dac661ba6e3a = (props)=>{
    const { data: { label: label, data: data }, //@ts-ignore react-select unsupported props
    selectProps: { appearance: appearance, isFocused: isFocused } } = props;
    return !isFocused ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bChGW.components).SingleValue, {
        ...props,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $bUmQV.default), {
            xcss: $667e1159563155af$var$styles.avatarItem,
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5pJx4.SizeableAvatar), {
                    src: (0, $3smIt.getAvatarUrl)(data),
                    appearance: appearance,
                    type: (0, $3smIt.isTeam)(data) ? 'team' : 'person'
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                    xcss: $667e1159563155af$var$styles.avatarItem,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                        className: (0, $bwpsq.default)([
                            $667e1159563155af$var$styles.avatarItemTextWrapper
                        ]),
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                            xcss: $667e1159563155af$var$styles.avatarItemText,
                            children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $c0aEF.default), {
                                alignBlock: "center",
                                children: [
                                    label,
                                    /*#__PURE__*/ (0, $2OMIu.jsx)($667e1159563155af$var$ElementAfter, {
                                        ...props
                                    })
                                ]
                            })
                        })
                    })
                })
            ]
        })
    }) : null;
};

});

parcelRegister("OxpB4", function(module, exports) {

$parcel$export(module.exports, "Input", () => $98c53988263e2c5c$export$f5b8910cec6cf069);
/* Input.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bChGW = parcelRequire("bChGW");
const $98c53988263e2c5c$var$inputStyles = {
    root: "_5ce6131l _1ir3kb7n _h5gq131l"
};
class $98c53988263e2c5c$export$f5b8910cec6cf069 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    /**
   * Overrides the default behaviour of react-select lib
   *
   * The getter is a workaround for original behaviour of the react-select lib.
   * Placeholder and Input are linked not via label, aria-label or aria-labeledby, but through aria-describedby.
   * Basically in the getter we reassign Placeholder ID from aria-describedby to aria-labelledby
   * {@link https://github.com/JedWatson/react-select/issues/5651#issue-1731353197 GitHub}
   */ get ariaLabelledBy() {
        return this.props['aria-labelledby'] ?? this.props['aria-describedby'];
    }
    get ariaDescribedBy() {
        return this.props.selectProps?.['aria-describedby'] ?? this.props['aria-describedby'];
    }
    render() {
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bChGW.components).Input, {
            ...this.props,
            "aria-labelledby": this.ariaLabelledBy,
            "aria-describedby": this.ariaDescribedBy,
            innerRef: this.props.innerRef,
            onKeyPress: this.handleKeyPress,
            xcss: $98c53988263e2c5c$var$inputStyles.root
        });
    }
    constructor(...args){
        super(...args), // onKeyPress is used instead as
        // react-select is using onKeyDown for capturing keyboard input
        this.handleKeyPress = (e)=>{
            if (e.key === 'Enter') e.preventDefault();
            //@ts-ignore react-select unsupported props
            if (this.props.selectProps?.disableInput) e.preventDefault();
        };
    }
}

});

parcelRegister("ee8bl", function(module, exports) {

$parcel$export(module.exports, "SingleValueContainer", () => $bd8914f05f01f9cc$export$afa5f855316c6a48);
/* SingleValueContainer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $bChGW = parcelRequire("bChGW");

var $5pJx4 = parcelRequire("5pJx4");

var $jNYXM = parcelRequire("jNYXM");
const $bd8914f05f01f9cc$var$valueContainerStyles = {
    root: "_yv0e5bpd _ca0q12x7 _n3td12x7 _19bvze3t _1reo15vq _18m91wug _1fjgglyw _c71l1osq _1suq18uv _1ke8idpf"
};
const $bd8914f05f01f9cc$var$placeholderIconContainer = null;
const $bd8914f05f01f9cc$var$wrapperStyle = null;
const $bd8914f05f01f9cc$var$showUserAvatar = (inputValue, value)=>value && value.data && inputValue === value.label;
class $bd8914f05f01f9cc$export$afa5f855316c6a48 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    render() {
        const { children: children, ...valueContainerProps } = this.props;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jNYXM.default), {
            isEnabled: this.onValueContainerClick,
            onMouseDown: this.onValueContainerClick,
            children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $bChGW.components).ValueContainer, {
                ...valueContainerProps,
                xcss: $bd8914f05f01f9cc$var$valueContainerStyles.root,
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                        className: (0, $bwpsq.default)([
                            "_nd5l1kqh _19bv12x7 _vwz4idpf"
                        ]),
                        children: this.renderAvatar()
                    }),
                    children
                ]
            })
        });
    }
    constructor(...args){
        super(...args), this.renderAvatar = ()=>{
            const { hasValue: hasValue, //@ts-ignore react-select unsupported props
            selectProps: { appearance: appearance, isFocused: isFocused, inputValue: inputValue, value: value, placeholderAvatar: placeholderAvatar } } = this.props;
            if (isFocused || !hasValue) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5pJx4.SizeableAvatar), {
                appearance: appearance,
                type: placeholderAvatar,
                src: $bd8914f05f01f9cc$var$showUserAvatar(inputValue, value) ? value.data.avatarUrl : undefined
            });
            return null;
        }, //@ts-ignore react-select unsupported props
        this.onValueContainerClick = this.props.selectProps.onValueContainerClick, this.Wrapper = ({ children: children })=>{
            return this.onValueContainerClick ? /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                onMouseDown: this.onValueContainerClick,
                className: (0, $bwpsq.default)([
                    "_16jlkb7n"
                ]),
                children: children
            }) : children;
        };
    }
}

});

parcelRegister("h3ej5", function(module, exports) {

$parcel$export(module.exports, "PopupInput", () => $be92b88945d06137$export$d8edbfd510a7db82);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $OxpB4 = parcelRequire("OxpB4");
class $be92b88945d06137$export$d8edbfd510a7db82 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    componentDidMount() {
        if (this.ref) // @ts-ignore
        this.ref.select();
    }
    render() {
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $OxpB4.Input), {
            ...this.props,
            innerRef: this.handleInnerRef
        });
    }
    constructor(...args){
        super(...args), this.ref = null, this.handleInnerRef = (ref)=>{
            this.ref = ref;
            if (this.props.innerRef) this.props.innerRef(ref);
        };
    }
}

});

parcelRegister("6Ks8i", function(module, exports) {

$parcel$export(module.exports, "PopupControl", () => $77b9c0d4ebdf44c2$export$a0cb1b4352357fcc);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");


var $7mofJ = parcelRequire("7mofJ");
const $77b9c0d4ebdf44c2$var$controlWrapper = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'flex',
    flexDirection: 'column',
    padding: `0px ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"}`
});
const $77b9c0d4ebdf44c2$var$labelStyle = /*#__PURE__*/ (0, $f8Sb3.css)({
    color: `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`,
    font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    paddingBottom: "var(--ds-space-050, 4px)",
    paddingLeft: "var(--ds-space-0, 0px)",
    paddingRight: "var(--ds-space-0, 0px)",
    paddingTop: "var(--ds-space-250, 20px)"
});
class $77b9c0d4ebdf44c2$export$a0cb1b4352357fcc extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).PureComponent {
    render() {
        const { //@ts-ignore react-select unsupported props
        selectProps: { popupTitle: popupTitle } } = this.props;
        return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: $77b9c0d4ebdf44c2$var$controlWrapper
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: $77b9c0d4ebdf44c2$var$labelStyle
        }, popupTitle), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $7mofJ.default), this.props));
    }
}

});
parcelRegister("7mofJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $6eb2a834f44e793b$export$2e2bcd8739ae039);
/* Control.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bChGW = parcelRequire("bChGW");

var $DEWI6 = parcelRequire("DEWI6");
const $6eb2a834f44e793b$var$controlStyles = {
    invalid: "_1h6d1bqt _4cvx1bqt",
    focused: "_1h6d1p6i _bfhk1j9a _4cvx1p6i _irr31j9a",
    disabled: "_irr3syzs",
    subtle: "_1h6d3acm _bfhk18uv _4cvx3acm _irr31gly",
    root: "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1h6d1elr _bfhk1j9a _p12f1osq _1fkdidpf _4cvx1elr _irr31d5g _1a98zg3v"
};
const $6eb2a834f44e793b$var$Control = (props)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bChGW.components).Control, {
        ...props,
        xcss: (0, $DEWI6.cx)($6eb2a834f44e793b$var$controlStyles.root, (props.selectProps.subtle || props.selectProps.noBorder) && $6eb2a834f44e793b$var$controlStyles.subtle, props.isFocused && $6eb2a834f44e793b$var$controlStyles.focused, props.isInvalid && $6eb2a834f44e793b$var$controlStyles.invalid, props.isDisabled && $6eb2a834f44e793b$var$controlStyles.disabled)
    });
};
var $6eb2a834f44e793b$export$2e2bcd8739ae039 = $6eb2a834f44e793b$var$Control;

});


parcelRegister("lYehz", function(module, exports) {

$parcel$export(module.exports, "Menu", () => $9f291598157d275c$export$d9b273488cd8ce6f);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bChGW = parcelRequire("bChGW");

var $f8Sb3 = parcelRequire("f8Sb3");
const $9f291598157d275c$var$getFooterStyle = ()=>{
    return /*#__PURE__*/ (0, $f8Sb3.css)({
        padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-200, 16px)"}`
    });
};
class $9f291598157d275c$export$d9b273488cd8ce6f extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    render() {
        return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $bChGW.components).Menu, this.props, this.props.selectProps.header, this.props.children, this.props.selectProps.footer && // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: $9f291598157d275c$var$getFooterStyle()
        }, this.props.selectProps.footer));
    }
}

});


parcelRegister("2wgOn", function(module, exports) {

$parcel$export(module.exports, "getStyles", () => $01bdbab7be42e070$export$ffd58b7f6f099a57);
$parcel$export(module.exports, "getPopupStyles", () => $01bdbab7be42e070$export$4e983f376ad8a3af);


var $8QpSo = parcelRequire("8QpSo");

var $7VXAu = parcelRequire("7VXAu");
const $01bdbab7be42e070$export$59c188914e58c94b = "var(--ds-space-075, 6px)";
const $01bdbab7be42e070$export$53937c04f7dfc2ae = 6;
const $01bdbab7be42e070$export$2c62ba763e976c54 = 39;
const $01bdbab7be42e070$export$ffd58b7f6f099a57 = (0, $8QpSo.default)((width, isMulti, isCompact, overrideStyles, isInvalid, isVisualRefresh, isPopupStyles)=>{
    let styles = {
        menu: (css, state)=>({
                ...css,
                width: width,
                minWidth: state.selectProps.menuMinWidth,
                zIndex: '400'
            }),
        menuList: (css)=>({
                ...css,
                zIndex: '400'
            }),
        control: (css, state)=>{
            const isMulti = state.selectProps.isMulti;
            return {
                ...css,
                width: width,
                borderColor: isInvalid ? `var(--ds-border-danger, ${0, $829f609a65d26a98$export$2010d0fb4295b346})` : state.isFocused ? `var(--ds-border-focused, ${css.borderColor})` : state.selectProps.subtle || state.selectProps.noBorder ? 'transparent' : `var(--ds-border-input, ${0, $829f609a65d26a98$export$7c87d337fb91a97d})`,
                backgroundColor: state.isFocused ? `var(--ds-background-input, ${css['backgroundColor']})` : state.selectProps.subtle ? 'transparent' : state.selectProps.textFieldBackgroundColor ? `var(--ds-background-input, ${0, $829f609a65d26a98$export$e655ef011c4aa1a2})` : `var(--ds-background-input, ${0, $829f609a65d26a98$export$9fdfb749e33cdf97})`,
                '&:hover .fabric-user-picker__clear-indicator': {
                    opacity: 1
                },
                ':hover': {
                    ...css[':hover'],
                    borderColor: isInvalid ? `var(--ds-border-danger, ${0, $829f609a65d26a98$export$2010d0fb4295b346})` : state.isFocused ? css[':hover'] ? `var(--ds-border-focused, ${css[':hover'].borderColor})` : `var(--ds-border-focused, ${0, $829f609a65d26a98$export$ecfc1dff386a3e7a})` : state.selectProps.subtle ? 'transparent' : `var(--ds-border-input, ${0, $829f609a65d26a98$export$7c87d337fb91a97d})`,
                    backgroundColor: state.selectProps.subtle && state.selectProps.hoveringClearIndicator ? `var(--ds-background-danger, ${0, $829f609a65d26a98$export$4b84fd0e2c617bd})` : state.isFocused ? css[':hover'] ? `var(--ds-background-input, ${css[':hover'].backgroundColor})` : `var(--ds-background-input, ${0, $829f609a65d26a98$export$29a4f05edc054374})` : state.isDisabled ? `var(--ds-background-disabled, ${0, $829f609a65d26a98$export$e655ef011c4aa1a2})` : `var(--ds-background-input-hovered, ${0, $829f609a65d26a98$export$3e51e8f1440314ba})`
                },
                padding: 0,
                minHeight: isCompact ? 'none' : 44,
                /* IE 11 needs to set height explicitly to be vertical align when being in not compact mode */ height: isCompact || isMulti ? '100%' : 44,
                maxWidth: '100%'
            };
        },
        clearIndicator: ({ paddingTop: paddingTop, paddingBottom: paddingBottom, paddingLeft: paddingLeft, paddingRight: paddingRight, ...css })=>({
                ...css,
                // By default show clear indicator, except for on devices where "hover" is supported.
                // This means mobile devices (which do not support hover) will be able to see the clear indicator.
                opacity: 1,
                '@media (hover: hover) and (pointer: fine)': {
                    opacity: 0
                },
                transition: css.transition + ', opacity 150ms',
                paddingTop: 0,
                padding: 0,
                ':hover': {
                    color: `var(--ds-icon-danger, ${0, $829f609a65d26a98$export$2010d0fb4295b346})`
                }
            }),
        indicatorsContainer: (css)=>({
                ...css,
                paddingRight: "var(--ds-space-050, 4px)"
            }),
        valueContainer: ({ paddingTop: paddingTop, paddingBottom: paddingBottom, position: position, ...css }, state)=>{
            const isMulti = state.selectProps.isMulti;
            return {
                ...css,
                gridTemplateColumns: 'auto 1fr',
                paddingTop: isCompact ? 0 : $01bdbab7be42e070$export$59c188914e58c94b,
                paddingBottom: isCompact ? 0 : $01bdbab7be42e070$export$59c188914e58c94b,
                paddingLeft: isMulti ? $01bdbab7be42e070$export$59c188914e58c94b : 0,
                overflowX: 'hidden',
                overflowY: 'auto',
                scrollbarWidth: 'none',
                maxHeight: state.selectProps.maxPickerHeight || '100%',
                '::-webkit-scrollbar': {
                    width: 0,
                    background: 'transparent'
                }
            };
        },
        multiValue: (css)=>({
                ...css,
                borderRadius: 24,
                cursor: 'default'
            }),
        multiValueLabel: (css)=>({
                ...css,
                display: 'flex'
            }),
        multiValueRemove: (css)=>({
                ...css,
                borderRadius: 24,
                cursor: 'pointer'
            }),
        placeholder: (css, state)=>{
            // fix styling in IE 11: when the position is absolute and `left` prop is not defined,
            // IE and other browsers auto calculate value of "left" prop differently,
            // so we want to explicitly set value for the `left` property
            if (css.position === 'absolute' && !css.left) css.left = `${$01bdbab7be42e070$export$59c188914e58c94b}px`;
            return {
                ...css,
                gridArea: '1/2/2/3',
                paddingLeft: state.selectProps.isMulti ? 0 : $01bdbab7be42e070$export$59c188914e58c94b,
                /* Margin left right of 2px set by default */ // margin: `0 ${BORDER_PADDING}px`,
                margin: 0,
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis'
            };
        },
        option: (css)=>{
            if (isVisualRefresh) return {
                ...css,
                overflow: 'hidden',
                paddingLeft: isPopupStyles ? "var(--ds-space-200, 16px)" : "var(--ds-space-100, 8px)",
                paddingRight: isPopupStyles ? "var(--ds-space-200, 16px)" : "var(--ds-space-100, 8px)"
            };
            return {
                ...css,
                overflow: 'hidden'
            };
        },
        input: (css, state)=>({
                ...css,
                gridArea: '1/2/2/3',
                gridTemplateColumns: isMulti && state.placeholder ? '0 123px' : css.gridTemplateColumns,
                /* Necessary to make input height and tag height the same. */ margin: `${"var(--ds-space-050, 4px)"} 0`,
                /* Padding top and bottom of 2 is set by default. */ paddingTop: 0,
                paddingBottom: 0,
                paddingLeft: state.selectProps.isMulti ? 0 : $01bdbab7be42e070$export$59c188914e58c94b,
                '& input::placeholder': {
                    /* Chrome, Firefox, Opera, Safari 10.1+ */ color: `var(--ds-text-subtlest, ${0, $829f609a65d26a98$export$d6447c357493214f})`,
                    opacity: 1 /* Firefox */ 
                },
                '& input:-ms-input-placeholder': {
                    /* Internet Explorer 10-11 */ color: `var(--ds-text-subtlest, ${0, $829f609a65d26a98$export$d6447c357493214f})`
                }
            }),
        singleValue: (css)=>({
                ...css,
                margin: 0,
                gridArea: '1/2/2/3'
            })
    };
    return overrideStyles ? (0, $7VXAu.mergeStyles)(styles, overrideStyles) : styles;
});
const $01bdbab7be42e070$export$4e983f376ad8a3af = (0, $8QpSo.default)((width, isMulti, overrideStyles, isVisualRefresh)=>({
        ...$01bdbab7be42e070$export$ffd58b7f6f099a57(width, isMulti, false, overrideStyles, false, isVisualRefresh, true)
    }));

});

parcelRegister("b3Rxh", function(module, exports) {

$parcel$export(module.exports, "getPopupProps", () => $f3e31f19eb34cddb$export$4adcaee797a284b3);

var $8QpSo = parcelRequire("8QpSo");
const $f3e31f19eb34cddb$export$4adcaee797a284b3 = (0, $8QpSo.default)((width, target, onFlip, boundariesElement, offset, placement, rootBoundary, shouldFlip, popupTitle, strategy)=>({
        searchThreshold: -1,
        controlShouldRenderValue: true,
        minMenuWidth: width,
        maxMenuWidth: width,
        autoFocus: false,
        target: target,
        popupTitle: popupTitle,
        popperProps: {
            placement: placement || 'auto',
            strategy: strategy || 'fixed',
            modifiers: [
                {
                    name: 'offset',
                    options: {
                        offset: offset
                    }
                },
                {
                    name: 'handleFlipStyle',
                    enabled: true,
                    order: 910,
                    fn: (data)=>onFlip(data)
                },
                {
                    name: 'preventOverflow',
                    options: {
                        rootBoundary: rootBoundary,
                        boundary: boundariesElement
                    }
                },
                {
                    name: 'flip',
                    enabled: shouldFlip
                }
            ]
        }
    }));

});

parcelRegister("d3gzD", function(module, exports) {

$parcel$export(module.exports, "BaseUserPickerWithoutAnalytics", () => $d045e9522a427a64$export$b4ff48c8d43b18c3);

var $2OMIu = parcelRequire("2OMIu");

var $cb25w = parcelRequire("cb25w");

var $jZA09 = parcelRequire("jZA09");

var $lFKmC = parcelRequire("lFKmC");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $7Jxgt = parcelRequire("7Jxgt");

var $fUmMr = parcelRequire("fUmMr");

var $78Gdn = parcelRequire("78Gdn");

var $8fG8p = parcelRequire("8fG8p");

var $3smIt = parcelRequire("3smIt");

var $pk97C = parcelRequire("pk97C");
const $d045e9522a427a64$var$loadingMessage = ()=>null;
const $d045e9522a427a64$var$classNamePrefix = 'fabric-user-picker';
class $d045e9522a427a64$export$b4ff48c8d43b18c3 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    static{
        this.defaultProps = {
            isMulti: false,
            subtle: false,
            noBorder: false,
            textFieldBackgroundColor: false,
            isClearable: true,
            loadOptionsErrorMessage: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                    ...(0, $8fG8p.messages).errorMessage
                }),
            openMenuOnClick: false
        };
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        const derivedState = {};
        if (nextProps.isDisabled || nextProps.disableInput) derivedState.menuIsOpen = false;
        if (nextProps.open !== undefined) derivedState.menuIsOpen = nextProps.open;
        if (nextProps.value !== undefined) derivedState.value = (0, $3smIt.optionToSelectableOptions)(nextProps.value);
        else if ((0, $3smIt.isDefaultValuePopulated)(nextProps.defaultValue) && !prevState.isDefaultSet) {
            derivedState.value = (0, $3smIt.optionToSelectableOptions)(nextProps.defaultValue);
            derivedState.isDefaultSet = true;
        }
        if (nextProps.search !== undefined && nextProps.search !== prevState.inputValue) derivedState.inputValue = nextProps.search;
        if (nextProps.options !== undefined) derivedState.options = nextProps.options;
        return derivedState;
    }
    constructor(props){
        super(props), this.getSessionId = ()=>this.session && this.session.id ? this.session.id : undefined, this.withSelectRef = (callback)=>()=>{
                if (this.selectRef) callback(this.selectRef);
            }, this.nextOption = this.withSelectRef((select)=>select.focusOption('down')), this.previousOption = this.withSelectRef((select)=>select.focusOption('up')), this.focus = ()=>{
            if (this.selectRef && this.selectRef.focus) this.selectRef.focus();
        }, this.blur = ()=>{
            if (this.selectRef && this.selectRef.blur) this.selectRef.blur();
        }, this.selectOption = this.withSelectRef((select)=>{
            const focusedOption = select.state.focusedOption;
            select.selectOption(focusedOption);
        }), // value = null if user deletes the last item in the user picker
        this.handleChange = (value, { action: action, removedValue: removedValue, option: option })=>{
            if (removedValue && removedValue.data.fixed) return;
            this.resetInputState();
            const { onChange: onChange, onSelection: onSelection, onClear: onClear, isMulti: isMulti } = this.props;
            (0, $3smIt.callCallback)(onChange, (0, $3smIt.extractOptionValue)(value), action);
            switch(action){
                case 'select-option':
                    if (value) (0, $3smIt.callCallback)(onSelection, (0, $3smIt.extractOptionValue)(value), this.getSessionId(), this);
                    this.fireEvent((0, $fUmMr.selectEvent), isMulti ? option : value);
                    this.session = isMulti ? (0, $fUmMr.startSession)() : undefined;
                    break;
                case 'clear':
                    (0, $3smIt.callCallback)(onClear);
                    this.fireEvent((0, $fUmMr.clearEvent));
                    break;
                case 'remove-value':
                case 'pop-value':
                    if (removedValue) this.fireEvent((0, $fUmMr.deleteEvent), removedValue.data);
                    break;
            }
            this.fireEvent((0, $fUmMr.searchedEvent));
            if (removedValue && this.state.value && Array.isArray(this.state.value)) {
                const remainingValues = this.state.value.filter((val)=>val.data.id !== removedValue.data.id);
                this.setState({
                    value: remainingValues ? remainingValues : [],
                    menuIsOpen: true
                });
            }
            if (!this.props.value) this.setState({
                value: value ? value : []
            });
        }, this.handleSelectRef = (ref)=>{
            this.selectRef = ref;
        }, this.addOptions = (0, $78Gdn.batchByKey)((request, newOptions)=>{
            const { resolving: resolving } = this.state;
            this.setState(({ inflightRequest: inflightRequest, options: options, count: count })=>{
                if (inflightRequest.toString() === request) return {
                    options: (resolving ? options : []).concat(newOptions.reduce((nextOptions, item)=>Array.isArray(item) ? nextOptions.concat(item[0]) : nextOptions.concat(item), [])),
                    count: count - newOptions.length,
                    resolving: count - newOptions.length !== 0
                };
                return null;
            });
        }), this.handleLoadOptionsError = ()=>{
            const { count: count } = this.state;
            const newCount = count - 1;
            const resolving = newCount !== 0;
            let showError = false;
            if (!resolving) showError = true;
            this.setState({
                count: newCount,
                resolving: resolving,
                showError: showError
            });
            this.fireEvent((0, $fUmMr.failedEvent));
        }, this.debouncedLoadOptions = (0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))((search)=>{
            const { loadOptions: loadOptions } = this.props;
            if (loadOptions) {
                const inflightRequest = this.state.inflightRequest + 1;
                const result = this.session && this.session.id ? loadOptions(search, this.session.id) : loadOptions(search);
                const addOptions = this.addOptions.bind(this, inflightRequest.toString());
                let count = 0;
                if ((0, $3smIt.isIterable)(result)) for (const value of result){
                    Promise.resolve(value).then(addOptions).catch(this.handleLoadOptionsError);
                    count++;
                }
                else {
                    Promise.resolve(result).then(addOptions).catch(this.handleLoadOptionsError);
                    count++;
                }
                this.setState({
                    inflightRequest: inflightRequest,
                    count: count,
                    resolving: count !== 0,
                    options: []
                });
            }
        }, 200), this.abortOptionsShownUfoExperience = ()=>{
            if (this.optionsShownUfoExperienceInstance.state.id === (0, $jZA09.UFOExperienceState).STARTED.id) // There may be an existing UFO timing running from previous key entry or focus,
            // so abort it and restart it just in case.
            this.optionsShownUfoExperienceInstance.abort();
        }, this.startOptionsShownUfoExperience = ()=>{
            this.abortOptionsShownUfoExperience();
            this.optionsShownUfoExperienceInstance.start();
        }, this.executeLoadOptions = (search)=>{
            const { loadOptions: loadOptions } = this.props;
            if (loadOptions) this.setState({
                resolving: true,
                showError: false
            }, ()=>this.debouncedLoadOptions(search));
        }, this.handleFocus = (event)=>{
            const { value: value, menuIsOpen: menuIsOpen } = this.state;
            if (!menuIsOpen || !this.session) this.startSession();
            this.startOptionsShownUfoExperience();
            (0, $3smIt.callCallback)(this.props.onFocus, this.getSessionId());
            if (!this.isMenuOpenOnClickForSingleSelect) {
                this.setState({
                    menuIsOpen: true
                });
                if (!this.props.isMulti && (0, $3smIt.isSingleValue)(value)) {
                    const input = event.target;
                    this.setState({
                        inputValue: value.label
                    }, ()=>{
                        if (input instanceof HTMLInputElement) input.setSelectionRange(0, value.label.length);
                    });
                }
            }
        }, this.resetInputState = ()=>{
            // Prevent filter if query typed, then blurred with no selection
            this.setState({
                inputValue: ''
            });
            (0, $3smIt.callCallback)(this.props.onInputChange, '', this.getSessionId());
        }, this.handleBlur = ()=>{
            (0, $3smIt.callCallback)(this.props.onBlur, this.getSessionId());
            if ((0, $3smIt.isPopupUserPickerByComponent)(this.props.SelectComponent)) return;
            this.resetInputState();
            this.abortOptionsShownUfoExperience();
            this.setState({
                menuIsOpen: false,
                initialFocusHandled: false,
                options: []
            });
        }, this.handleOpen = ()=>{
            (0, $3smIt.callCallback)(this.props.onOpen, this.getSessionId());
            this.setState({
                menuIsOpen: true
            });
        }, this.handleClose = ()=>{
            this.resetInputState();
            (0, $3smIt.callCallback)(this.props.onClose, this.getSessionId());
            this.setState({
                menuIsOpen: false,
                options: []
            });
        }, this.handleInputChange = (search, { action: action })=>{
            if (action === 'input-change' || action === 'set-value') {
                (0, $3smIt.callCallback)(this.props.onInputChange, search, this.getSessionId());
                this.setState({
                    inputValue: search
                });
                this.startOptionsShownUfoExperience();
            }
        }, this.fireEvent = (eventCreator, ...args)=>{
            const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
            if (createAnalyticsEvent) (0, $fUmMr.createAndFireEventInElementsChannel)(eventCreator(this.props, this.state, this.session, this.journeyId, ...args))(createAnalyticsEvent);
        }, this.startSession = ()=>{
            this.session = (0, $fUmMr.startSession)();
            this.journeyId = this.getSessionId();
            this.fireEvent((0, $fUmMr.focusEvent));
        }, this.handleKeyDown = (event)=>{
            if (!this.isMenuOpenOnClickForSingleSelect) {
                // Escape
                if (event.keyCode === 27) this.blur();
                // Space
                if (event.keyCode === 32 && !this.state.inputValue) {
                    event.preventDefault();
                    !this.props.disableInput && this.setState({
                        inputValue: ' '
                    });
                }
            }
            if (this.session) {
                this.session.lastKey = event.keyCode;
                switch(event.keyCode){
                    // KeyUp 38
                    case 38:
                        this.session.upCount++;
                        break;
                    // KeyDown 40
                    case 40:
                        this.session.downCount++;
                        break;
                }
            }
            this.props.onKeyDown && this.props.onKeyDown(event);
        }, this.handleClearIndicatorHover = (hoveringClearIndicator)=>{
            this.setState({
                hoveringClearIndicator: hoveringClearIndicator
            });
        }, this.getOptions = ()=>{
            const options = (0, $3smIt.getOptions)(this.state.options) || [];
            const { maxOptions: maxOptions, isMulti: isMulti } = this.props;
            if (maxOptions === 0) return [];
            if (maxOptions && maxOptions > 0 && maxOptions < options.length) {
                const { value: value } = this.state;
                let filteredOptions = options;
                // Filter out previously selected options
                if (isMulti && Array.isArray(value)) {
                    const valueIds = value.map((item)=>item.data.id);
                    filteredOptions = options.filter((option)=>valueIds.indexOf(option.data.id) === -1);
                }
                return filteredOptions.slice(0, maxOptions);
            }
            return options;
        }, this.getAppearance = ()=>this.props.appearance ? this.props.appearance : 'normal', this.handleClickDraggableParentComponent = ()=>{
            if (this.state.initialFocusHandled) {
                // As <Select /> is already focused, calling this.selectRef.current.focus() again no longer triggers its own handlers (i.e. onMenuOpen, onMenuClose)
                // We have to manually handle the open and close states of the dropdown menu based on a user's click from this point onwards to prevent the bug
                if (this.state.menuIsOpen) this.handleClose();
                else this.handleOpen();
            } else if (!this.state.menuIsOpen && !this.isMenuOpenOnClickForSingleSelect) {
                // Trigger focus state when ValueContainer is clicked for the first time
                // The focused state will then invoke <Select /> instance's own handlers (e.g. onMenuOpen, onMenuClose)
                // to manage the state of the dropdown menu
                this.focus();
                this.setState(()=>({
                        initialFocusHandled: true
                    }));
            }
        };
        this.state = {
            options: [],
            isDefaultSet: false,
            inflightRequest: 0,
            count: 0,
            hoveringClearIndicator: false,
            menuIsOpen: !!this.props.open,
            inputValue: props.search || '',
            resolving: false,
            showError: false,
            initialFocusHandled: false
        };
        this.optionsShownUfoExperienceInstance = (0, $pk97C.userPickerOptionsShownUfoExperience).getInstance((0, $7Jxgt.v4)());
        if (this.props.forwardedRef) {
            const refValue = {
                focus: this.focus,
                blur: this.blur
            };
            if (typeof this.props.forwardedRef === 'function') this.props.forwardedRef(refValue);
            else this.props.forwardedRef.current = refValue;
        }
    }
    get isMenuOpenOnClickForSingleSelect() {
        return this.props.openMenuOnClick && !this.props.isMulti;
    }
    componentDidMount() {
        const { open: open, search: search } = this.props;
        // load options when the picker open
        if (open) {
            if (!this.session) this.startSession();
            this.executeLoadOptions(search);
        }
    }
    componentDidUpdate(_, prevState) {
        const { menuIsOpen: menuIsOpen, options: options, resolving: resolving, count: count, inputValue: inputValue } = this.state;
        // Create a new session when the menu is opened and there is no session
        if (menuIsOpen && !prevState.menuIsOpen && !this.session) this.startSession();
        // Load options when user picker opens or when input value changes
        if (menuIsOpen && !prevState.menuIsOpen || inputValue !== prevState.inputValue) this.executeLoadOptions(inputValue);
        if (!menuIsOpen && prevState.menuIsOpen && this.session) {
            this.fireEvent((0, $fUmMr.cancelEvent), prevState);
            this.session = undefined;
        }
        if (menuIsOpen && (!prevState.menuIsOpen && options.length > 0 || options.length !== prevState.options.length)) this.fireEvent((0, $fUmMr.searchedEvent));
        if (this.state.inputValue !== prevState.inputValue) {
            if (this.session) this.session.inputChangeTime = Date.now();
        }
        if (menuIsOpen && (!_.loadOptions || prevState.menuIsOpen) && count === 0 && !resolving && [
            (0, $jZA09.UFOExperienceState).STARTED.id,
            (0, $jZA09.UFOExperienceState).IN_PROGRESS.id
        ].includes(this.optionsShownUfoExperienceInstance.state.id)) this.optionsShownUfoExperienceInstance.success();
    }
    get ariaProps() {
        const ariaLabels = Object.keys(this.props).filter((key)=>key.startsWith('aria-'));
        const props = {
            ...this.props
        };
        return ariaLabels.reduce((obj, key)=>({
                ...obj,
                [key]: props[key]
            }), {});
    }
    render() {
        const { isMulti: isMulti, isLoading: isLoading, subtle: subtle, noBorder: noBorder, placeholder: placeholder, isClearable: isClearable, isDisabled: isDisabled, isInvalid: isInvalid, clearValueLabel: clearValueLabel, menuMinWidth: menuMinWidth, menuPortalTarget: menuPortalTarget, loadOptionsErrorMessage: loadOptionsErrorMessage, addMoreMessage: addMoreMessage, noOptionsMessage: noOptionsMessage, footer: footer, disableInput: disableInput, components: components, pickerProps: pickerProps, SelectComponent: SelectComponent, styles: styles, autoFocus: autoFocus, fieldId: fieldId, inputId: inputId, maxPickerHeight: maxPickerHeight, textFieldBackgroundColor: textFieldBackgroundColor, ariaLabelledBy: ariaLabelledBy, ariaDescribedBy: ariaDescribedBy, ariaLive: ariaLive, ariaLabel: ariaLabel, name: name, header: header, required: required, UNSAFE_hasDraggableParentComponent: UNSAFE_hasDraggableParentComponent, placeholderAvatar: placeholderAvatar } = this.props;
        const { count: count, hoveringClearIndicator: hoveringClearIndicator, menuIsOpen: menuIsOpen, value: value, inputValue: inputValue, resolving: resolving, showError: showError } = this.state;
        const appearance = this.getAppearance();
        // these props override the default select menu open and close
        const menuOpenDeciderProps = {
            ...!this.isMenuOpenOnClickForSingleSelect && {
                menuIsOpen: menuIsOpen,
                blurInputOnSelect: !isMulti,
                openMenuOnFocus: true
            }
        };
        return /*#__PURE__*/ (0, $2OMIu.jsx)(SelectComponent, {
            name: name,
            value: value,
            autoFocus: autoFocus !== undefined ? autoFocus : menuIsOpen,
            "aria-labelledby": ariaLabelledBy,
            "aria-describedby": ariaDescribedBy,
            "aria-live": ariaLive,
            "aria-required": required,
            required: required,
            ref: this.handleSelectRef,
            isMulti: isMulti,
            options: this.getOptions(),
            styles: styles,
            enableAnimation: isMulti,
            components: components,
            inputValue: inputValue,
            isLoading: count > 0 || resolving || isLoading,
            loadingMessage: $d045e9522a427a64$var$loadingMessage,
            menuPlacement: "auto",
            placeholder: placeholder ?? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...(0, $8fG8p.messages).placeholder
            }),
            label: ariaLabel,
            addMoreMessage: addMoreMessage,
            classNamePrefix: $d045e9522a427a64$var$classNamePrefix,
            hoveringClearIndicator: hoveringClearIndicator,
            appearance: appearance,
            isClearable: isClearable,
            noBorder: noBorder,
            subtle: subtle,
            closeMenuOnSelect: !isMulti,
            noOptionsMessage: showError ? loadOptionsErrorMessage : typeof noOptionsMessage === 'function' ? noOptionsMessage : ()=>noOptionsMessage,
            footer: footer,
            isDisabled: isDisabled,
            isInvalid: isInvalid,
            isFocused: menuIsOpen,
            backspaceRemovesValue: isMulti,
            filterOption: null,
            clearValueLabel: clearValueLabel,
            menuMinWidth: menuMinWidth,
            menuPortalTarget: menuPortalTarget,
            disableInput: disableInput || isDisabled,
            instanceId: fieldId,
            inputId: inputId,
            onChange: this.handleChange,
            onMenuOpen: this.handleOpen,
            onFocus: this.handleFocus,
            onBlur: this.handleBlur,
            onMenuClose: this.handleClose,
            onInputChange: this.handleInputChange,
            onClearIndicatorHover: this.handleClearIndicatorHover,
            onKeyDown: this.handleKeyDown,
            maxPickerHeight: maxPickerHeight,
            textFieldBackgroundColor: textFieldBackgroundColor,
            header: header,
            placeholderAvatar: placeholderAvatar,
            ...this.ariaProps,
            ...pickerProps,
            ...UNSAFE_hasDraggableParentComponent && {
                onValueContainerClick: this.handleClickDraggableParentComponent
            },
            ...menuOpenDeciderProps
        });
    }
}
const $d045e9522a427a64$export$d099ade7b4f4d2a4 = (0, $cb25w.default)()($d045e9522a427a64$export$b4ff48c8d43b18c3);

});
parcelRegister("jZA09", function(module, exports) {

$parcel$export(module.exports, "UFOExperienceState", () => $175f7a63840c5fab$export$81b70111112841a0);
const $175f7a63840c5fab$export$81b70111112841a0 = {
    NOT_STARTED: {
        id: 'NOT_STARTED',
        final: true
    },
    STARTED: {
        id: 'STARTED'
    },
    IN_PROGRESS: {
        id: 'IN_PROGRESS'
    },
    BLOCKED: {
        id: 'BLOCKED'
    },
    RECOVERED: {
        id: 'RECOVERED'
    },
    SUCCEEDED: {
        id: 'SUCCEEDED',
        final: true,
        success: true
    },
    SUCCEEDED_WAITING_FOR_DEPS: {
        id: 'SUCCEEDED_WAITING_FOR_DEPS'
    },
    FAILED: {
        id: 'FAILED',
        final: true
    },
    ABORTED: {
        id: 'ABORTED',
        final: true
    }
};

});

parcelRegister("fUmMr", function(module, exports) {

$parcel$export(module.exports, "startSession", () => $e345c0b18a65d683$export$c0d84948cecf78d8);
$parcel$export(module.exports, "createAndFireEventInElementsChannel", () => $e345c0b18a65d683$export$53eef0dcd9611650);
$parcel$export(module.exports, "focusEvent", () => $e345c0b18a65d683$export$e7818c470f37c4bd);
$parcel$export(module.exports, "clearEvent", () => $e345c0b18a65d683$export$7b5800e732182efb);
$parcel$export(module.exports, "deleteEvent", () => $e345c0b18a65d683$export$95711ec6c6227e9a);
$parcel$export(module.exports, "cancelEvent", () => $e345c0b18a65d683$export$e9caaaecfee38128);
$parcel$export(module.exports, "selectEvent", () => $e345c0b18a65d683$export$48143d759475d90f);
$parcel$export(module.exports, "searchedEvent", () => $e345c0b18a65d683$export$911fb7184b6037eb);
$parcel$export(module.exports, "failedEvent", () => $e345c0b18a65d683$export$c2aec355fef65c9c);
$parcel$export(module.exports, "userInfoEvent", () => $e345c0b18a65d683$export$f541f04954b0c11e);

var $gB4mS = parcelRequire("gB4mS");

var $7Jxgt = parcelRequire("7Jxgt");

var $3smIt = parcelRequire("3smIt");
const $e345c0b18a65d683$var$packageName = "platform-pkg";
const $e345c0b18a65d683$var$packageVersion = "0.0.0-use.local";
const $e345c0b18a65d683$var$UUID_REGEXP_TEAMS_GROUPS = /^[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}$/;
const $e345c0b18a65d683$var$UUID_REGEXP_OLD_AAID = /^[a-fA-F0-9]{1,8}:[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}$/;
const $e345c0b18a65d683$var$UUID_REGEXP_NEW_AAID = /^[a-fA-F0-9]{24,24}$/;
const $e345c0b18a65d683$export$c0d84948cecf78d8 = ()=>({
        id: (0, $7Jxgt.v4)(),
        start: Date.now(),
        inputChangeTime: Date.now(),
        upCount: 0,
        downCount: 0,
        lastKey: undefined
    });
const $e345c0b18a65d683$export$53eef0dcd9611650 = (0, $gB4mS.default)('fabric-elements');
const $e345c0b18a65d683$var$createEvent = (eventType, action, actionSubject, attributes = {})=>({
        eventType: eventType,
        action: action,
        actionSubject: actionSubject,
        attributes: {
            packageName: $e345c0b18a65d683$var$packageName,
            packageVersion: $e345c0b18a65d683$var$packageVersion,
            ...attributes
        }
    });
const $e345c0b18a65d683$var$checkValidId = (id)=>{
    return $e345c0b18a65d683$var$UUID_REGEXP_NEW_AAID.test(id) || $e345c0b18a65d683$var$UUID_REGEXP_OLD_AAID.test(id) || $e345c0b18a65d683$var$UUID_REGEXP_TEAMS_GROUPS.test(id);
};
const $e345c0b18a65d683$var$optionData2Analytics = (option)=>{
    const { id: id, type: type } = option;
    // id's of email types are emails which is PII
    const validatedData = {
        id: $e345c0b18a65d683$var$checkValidId(id) ? id : null,
        type: type || null
    };
    if ((0, $3smIt.isExternalUser)(option)) return {
        ...validatedData,
        type: 'external_user',
        sources: option.sources,
        externalUserType: option.externalUserType
    };
    if ((0, $3smIt.isCustom)(option) && option.analyticsType) return {
        ...validatedData,
        type: option.analyticsType
    };
    return validatedData;
};
const $e345c0b18a65d683$var$buildValueForAnalytics = (value)=>{
    if (value) {
        const valueToConvert = Array.isArray(value) ? value : [
            value
        ];
        return valueToConvert.map(({ data: data })=>$e345c0b18a65d683$var$optionData2Analytics(data));
    }
    return [];
};
const $e345c0b18a65d683$var$createDefaultPickerAttributes = (props, session, journeyId)=>({
        context: props.fieldId,
        sessionId: $e345c0b18a65d683$var$sessionId(session),
        pickerType: $e345c0b18a65d683$var$pickerType(props),
        journeyId: journeyId
    });
const $e345c0b18a65d683$export$e7818c470f37c4bd = (props, state, session, journeyId)=>$e345c0b18a65d683$var$createEvent('ui', 'focused', 'userPicker', {
        ...$e345c0b18a65d683$var$createDefaultPickerAttributes(props, session, journeyId),
        values: $e345c0b18a65d683$var$buildValueForAnalytics(state.value)
    });
const $e345c0b18a65d683$export$7b5800e732182efb = (props, state, session, journeyId)=>$e345c0b18a65d683$var$createEvent('ui', 'cleared', 'userPicker', {
        ...$e345c0b18a65d683$var$createDefaultPickerAttributes(props, session, journeyId),
        pickerOpen: state.menuIsOpen,
        values: $e345c0b18a65d683$var$values(state)
    });
const $e345c0b18a65d683$export$95711ec6c6227e9a = (props, state, session, journeyId, ...args)=>$e345c0b18a65d683$var$createEvent('ui', 'deleted', 'userPickerItem', {
        context: props.fieldId,
        sessionId: $e345c0b18a65d683$var$sessionId(session),
        journeyId: journeyId,
        value: $e345c0b18a65d683$var$optionData2Analytics(args[0]),
        pickerOpen: state.menuIsOpen
    });
const $e345c0b18a65d683$export$e9caaaecfee38128 = (props, _, session, journeyId, ...args)=>$e345c0b18a65d683$var$createEvent('ui', 'cancelled', 'userPicker', {
        ...$e345c0b18a65d683$var$createDefaultPickerAttributes(props, session, journeyId),
        sessionDuration: $e345c0b18a65d683$var$sessionDuration(session),
        queryLength: $e345c0b18a65d683$var$queryLength(args[0]),
        spaceInQuery: $e345c0b18a65d683$var$spaceInQuery(args[0]),
        upKeyCount: $e345c0b18a65d683$var$upKeyCount(session),
        downKeyCount: $e345c0b18a65d683$var$downKeyCount(session)
    });
const $e345c0b18a65d683$export$48143d759475d90f = (props, state, session, journeyId, ...args)=>{
    return $e345c0b18a65d683$var$createEvent('ui', $e345c0b18a65d683$var$selectEventType(session), 'userPicker', {
        ...$e345c0b18a65d683$var$createDefaultPickerAttributes(props, session, journeyId),
        sessionDuration: $e345c0b18a65d683$var$sessionDuration(session),
        position: $e345c0b18a65d683$var$position(state, args[0]),
        queryLength: $e345c0b18a65d683$var$queryLength(state),
        spaceInQuery: $e345c0b18a65d683$var$spaceInQuery(state),
        upKeyCount: $e345c0b18a65d683$var$upKeyCount(session),
        downKeyCount: $e345c0b18a65d683$var$downKeyCount(session),
        result: $e345c0b18a65d683$var$result(args[0]),
        numberOfResults: $e345c0b18a65d683$var$numberOfResults(state)
    });
};
const $e345c0b18a65d683$export$911fb7184b6037eb = (props, state, session, journeyId)=>{
    const searchResults = $e345c0b18a65d683$var$results(state);
    return $e345c0b18a65d683$var$createEvent('operational', 'searched', 'userPicker', {
        ...$e345c0b18a65d683$var$createDefaultPickerAttributes(props, session, journeyId),
        sessionDuration: $e345c0b18a65d683$var$sessionDuration(session),
        durationSinceInputChange: $e345c0b18a65d683$var$durationSinceInputChange(session),
        queryLength: $e345c0b18a65d683$var$queryLength(state),
        isLoading: $e345c0b18a65d683$var$isLoading(props, state),
        results: searchResults,
        numberOfResults: searchResults.length
    });
};
const $e345c0b18a65d683$export$c2aec355fef65c9c = (props, _, session, journeyId)=>$e345c0b18a65d683$var$createEvent('operational', 'failed', 'userPicker', {
        ...$e345c0b18a65d683$var$createDefaultPickerAttributes(props, session, journeyId)
    });
const $e345c0b18a65d683$export$f541f04954b0c11e = (sources, accountId)=>$e345c0b18a65d683$var$createEvent('ui', 'displayed', 'userInfo', {
        sources: sources,
        // accountId can be PII if it is an email so check that it's an AAID first
        accountId: $e345c0b18a65d683$var$checkValidId(accountId) ? accountId : null
    });
function $e345c0b18a65d683$var$queryLength(state) {
    return state.inputValue.length;
}
function $e345c0b18a65d683$var$selectEventType(session) {
    return session && session.lastKey === 13 ? 'pressed' : 'clicked';
}
function $e345c0b18a65d683$var$upKeyCount(session) {
    return session ? session.upCount : null;
}
function $e345c0b18a65d683$var$downKeyCount(session) {
    return session ? session.downCount : null;
}
function $e345c0b18a65d683$var$spaceInQuery(state) {
    return state.inputValue.indexOf(' ') !== -1;
}
function $e345c0b18a65d683$var$sessionDuration(session) {
    return session ? Date.now() - session.start : null;
}
function $e345c0b18a65d683$var$durationSinceInputChange(session) {
    return session ? Date.now() - session.inputChangeTime : null;
}
function $e345c0b18a65d683$var$sessionId(session) {
    return session && session.id;
}
function $e345c0b18a65d683$var$position(state, value) {
    return value ? state.options.findIndex((option)=>option === value.data) : -1;
}
function $e345c0b18a65d683$var$pickerType(props) {
    return props.isMulti ? 'multi' : 'single';
}
function $e345c0b18a65d683$var$result(option) {
    return option ? $e345c0b18a65d683$var$optionData2Analytics(option.data) : null;
}
function $e345c0b18a65d683$var$results(state) {
    return (state.options || []).map($e345c0b18a65d683$var$optionData2Analytics);
}
function $e345c0b18a65d683$var$isLoading(props, state) {
    return state.count > 0 || props.isLoading;
}
function $e345c0b18a65d683$var$values(state) {
    return state.value ? Array.isArray(state.value) ? state.value.map((option)=>$e345c0b18a65d683$var$optionData2Analytics(option.data)) : [
        $e345c0b18a65d683$var$optionData2Analytics(state.value.data)
    ] : [];
}
function $e345c0b18a65d683$var$numberOfResults(state) {
    return (state.options || []).length;
}

});

parcelRegister("78Gdn", function(module, exports) {

$parcel$export(module.exports, "batchByKey", () => $2e9cc1cdc768945e$export$da86c38211c1c0a8);
function $2e9cc1cdc768945e$export$da86c38211c1c0a8(callback) {
    const calls = {};
    return (key, ...args)=>{
        if (!calls[key]) {
            window.setTimeout(()=>{
                callback(key, calls[key]);
                delete calls[key];
            });
            calls[key] = [];
        }
        calls[key].push(args);
    };
}

});

parcelRegister("pk97C", function(module, exports) {

$parcel$export(module.exports, "userPickerRenderedUfoExperience", () => $06ebadcdd7d5e231$export$b49757166e1acfc2);
$parcel$export(module.exports, "userPickerOptionsShownUfoExperience", () => $06ebadcdd7d5e231$export$135a264e0da507ae);
$parcel$export(module.exports, "UfoErrorBoundary", () => $06ebadcdd7d5e231$export$5ef1c2550074a375);

var $5uXOq = parcelRequire("5uXOq");

var $cBycP = parcelRequire("cBycP");
var $7Zbvr = parcelRequire("7Zbvr");
var $jZA09 = parcelRequire("jZA09");
const $06ebadcdd7d5e231$export$b49757166e1acfc2 = new (0, $cBycP.ConcurrentExperience)('user-picker-rendered', {
    platform: {
        component: 'user-picker'
    },
    type: (0, $7Zbvr.ExperienceTypes).Load,
    performanceType: (0, $7Zbvr.ExperiencePerformanceTypes).PageSegmentLoad
});
const $06ebadcdd7d5e231$export$135a264e0da507ae = new (0, $cBycP.ConcurrentExperience)('user-picker-options-shown', {
    platform: {
        component: 'user-picker'
    },
    type: (0, $7Zbvr.ExperienceTypes).Operation,
    performanceType: (0, $7Zbvr.ExperiencePerformanceTypes).InlineResult
});
class $06ebadcdd7d5e231$export$5ef1c2550074a375 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    componentDidCatch() {
        const instance = $06ebadcdd7d5e231$export$b49757166e1acfc2.getInstance(this.props.id);
        if (instance.state.id !== (0, $jZA09.UFOExperienceState).FAILED.id) instance.failure();
    }
    render() {
        return this.props.children;
    }
}

});
parcelRegister("cBycP", function(module, exports) {

$parcel$export(module.exports, "ConcurrentExperience", () => $d4c0ab33dd6972cc$export$ac1cddfee07ba6ac);

var $dCAsn = parcelRequire("dCAsn");

var $boHLC = parcelRequire("boHLC");
class $d4c0ab33dd6972cc$export$ac1cddfee07ba6ac {
    constructor(experienceId, config){
        this.instances = {};
        this.experienceId = experienceId;
        this.config = config;
    }
    getInstance(instanceId) {
        if (!this.instances[instanceId]) this.instances[instanceId] = new (0, $boHLC.UFOExperience)(this.experienceId, this.config, instanceId);
        return this.instances[instanceId];
    }
    release(instanceId) {
        (0, $dCAsn.ufolog)('instanceId', instanceId);
        if (this.instances[instanceId]) this.instances[instanceId].abort();
        delete this.instances[instanceId];
    }
}

});
parcelRegister("dCAsn", function(module, exports) {

$parcel$export(module.exports, "ufolog", () => $c8856379f9e2d7e8$export$b4958caff08a0960);
$parcel$export(module.exports, "ufowarn", () => $c8856379f9e2d7e8$export$d53d07b6034c4560);
class $c8856379f9e2d7e8$var$UFOLogger {
    static{
        this.UFOprefix = "[ufo\uD83D\uDEF8]";
    }
    log(...args) {
        // eslint-disable-next-line no-console
        this.enabled && console.log($c8856379f9e2d7e8$var$UFOLogger.UFOprefix, ...args);
    }
    warn(...args) {
        // eslint-disable-next-line no-console
        this.enabled && console.warn($c8856379f9e2d7e8$var$UFOLogger.UFOprefix, ...args);
    }
    enable() {
        this.enabled = true;
    }
    disable() {
        this.enabled = false;
    }
    constructor(){
        this.enabled = false;
    }
}
const $c8856379f9e2d7e8$export$4ab84f6f04f6566d = new $c8856379f9e2d7e8$var$UFOLogger();
const $c8856379f9e2d7e8$export$b4958caff08a0960 = (...args)=>{
    $c8856379f9e2d7e8$export$4ab84f6f04f6566d.log(...args);
};
const $c8856379f9e2d7e8$export$d53d07b6034c4560 = (...args)=>{
    $c8856379f9e2d7e8$export$4ab84f6f04f6566d.warn(...args);
};

});

parcelRegister("boHLC", function(module, exports) {

$parcel$export(module.exports, "UFOExperience", () => $69d53cdb5241e240$export$c00d22927c60484a);

var $iLwDN = parcelRequire("iLwDN");
class $69d53cdb5241e240$export$c00d22927c60484a extends (0, $iLwDN.UFOAbstractExperience) {
}

});
parcelRegister("iLwDN", function(module, exports) {

$parcel$export(module.exports, "UFOAbstractExperience", () => $cc70575b2203e361$export$d31c89db257648c);

var $7Jxgt = parcelRequire("7Jxgt");


var $1vlV8 = parcelRequire("1vlV8");

var $dCAsn = parcelRequire("dCAsn");

var $dlucd = parcelRequire("dlucd");

var $blQsS = parcelRequire("blQsS");

var $9tjMO = parcelRequire("9tjMO");

var $1CRHx = parcelRequire("1CRHx");

var $jZA09 = parcelRequire("jZA09");

var $hM2B6 = parcelRequire("hM2B6");

var $7Zbvr = parcelRequire("7Zbvr");
const $cc70575b2203e361$var$getPageVisibleState = ()=>{
    return !(0, $1CRHx.isWindowObjectAvailable)() || !window.document || window.document.visibilityState === 'visible' ? (0, $blQsS.PageVisibleState).VISIBLE : (0, $blQsS.PageVisibleState).HIDDEN;
};
const $cc70575b2203e361$export$c753e8669d30c8ad = (timestamp)=>{
    if (timestamp !== undefined) return ~~timestamp;
    return (0, $9tjMO.roundPerfNow)();
};
class $cc70575b2203e361$export$d31c89db257648c {
    constructor(id, config, instanceId = null){
        this.state = (0, $jZA09.UFOExperienceState).NOT_STARTED;
        this.instanceId = null // for concurrent
        ;
        this.parent = null;
        this.category = null;
        this.metadata = {};
        this.onDoneCallbacks = [];
        this.childExperiences = [];
        this.explicitTimings = {};
        // @todo move to page load experience when proper classes/inheritance prepared
        this.isSSROutputAsFMP = false;
        this.uuid = null;
        this._until = null;
        this.metrics = {
            startTime: null,
            endTime: null,
            marks: []
        };
        this.performanceConfig = {};
        this.setPageVisibleStateToMixed = ()=>{
            this.pageVisibleState = (0, $blQsS.PageVisibleState).MIXED;
            (0, $dlucd.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        };
        this.id = id;
        this.category = config?.category || null;
        this.until = config?.until || null;
        this.instanceId = instanceId;
        this.handleDoneBind = this._handleDoneExperience.bind(this);
        this.type = config.type;
        this.performanceType = config.performanceType;
        this.performanceConfig = config.performanceConfig || {};
        this.config = config;
        this.pageVisibleState = $cc70575b2203e361$var$getPageVisibleState();
        this.featureFlags = config.featureFlags || [];
        this.timings = config.timings || [];
        if (config.performanceType === (0, $7Zbvr.ExperiencePerformanceTypes).PageLoad || config.performanceType === (0, $7Zbvr.ExperiencePerformanceTypes).PageSegmentLoad) this.isSSROutputAsFMP = config.isSSROutputAsFMP || false;
    }
    async transition(newState, timestamp) {
        (0, $dCAsn.ufolog)('async transition', this.id, this.state.id, newState.id);
        if ((0, $hM2B6.canTransition)(this.state, newState)) {
            (0, $dCAsn.ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} successful`, this.state.final, !newState.final);
            if (newState === (0, $jZA09.UFOExperienceState).STARTED) this._reset();
            if (this.state.final && !newState.final) {
                this.metrics.startTime = $cc70575b2203e361$export$c753e8669d30c8ad(timestamp);
                this.uuid = (0, $7Jxgt.v4)();
            }
            this.state = newState;
            if (newState.final) {
                this.metrics.endTime = $cc70575b2203e361$export$c753e8669d30c8ad(timestamp);
                if (!this._isManualStateEnabled()) (0, $1vlV8.getGlobalEventStream)().push((0, $1vlV8.unsubscribeEvent)((0, $blQsS.SUBSCRIBE_ALL), this.handleDoneBind));
                const data = await this.exportData();
                (0, $dCAsn.ufolog)('this.parent', this.parent);
                (0, $1vlV8.getGlobalEventStream)().push((0, $1vlV8.experiencePayloadEvent)(data));
            }
            return true;
        }
        (0, $dCAsn.ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} unsuccessful`);
        (0, $dCAsn.ufowarn)(`transition of ${this.id} from ${this.state} to ${newState} is not possible`);
        return false;
    }
    async start(startTime) {
        const transitionSuccessful = await this.transition((0, $jZA09.UFOExperienceState).STARTED, startTime);
        if (transitionSuccessful) {
            this.pageVisibleState = $cc70575b2203e361$var$getPageVisibleState();
            (0, $dlucd.visibilityChangeObserver).subscribe(this.setPageVisibleStateToMixed);
            if (!this._isManualStateEnabled()) {
                (0, $dCAsn.ufolog)('subscribed', this.id);
                (0, $1vlV8.getGlobalEventStream)().push((0, $1vlV8.subscribeEvent)((0, $blQsS.SUBSCRIBE_ALL), this.handleDoneBind));
            }
        }
    }
    mark(name, timestamp) {
        if (name !== (0, $blQsS.FMP_MARK) && name !== (0, $blQsS.INLINE_RESPONSE_MARK)) this._mark(name, timestamp);
        else (0, $dCAsn.ufowarn)('please use markFMP or markInlineResponse for specialised marks');
    }
    _mark(name, timestamp) {
        this.metrics.marks.push({
            name: name,
            time: $cc70575b2203e361$export$c753e8669d30c8ad(timestamp)
        });
        this.transition((0, $jZA09.UFOExperienceState).IN_PROGRESS);
    }
    markFMP(timestamp) {
        this._mark((0, $blQsS.FMP_MARK), timestamp);
    }
    markInlineResponse(timestamp) {
        this._mark((0, $blQsS.INLINE_RESPONSE_MARK), timestamp);
    }
    _isManualStateEnabled() {
        return this.until === null;
    }
    _validateManualState() {
        if (!this._isManualStateEnabled()) {
            (0, $dCAsn.ufowarn)('manual change of state not allowed as "until" is defined');
            return false;
        }
        return true;
    }
    switchToEndState(state, config) {
        if (!config?.force && !this._validateManualState()) return null;
        if (config?.metadata) this.addMetadata(config.metadata);
        (0, $dlucd.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        return this.transition(state);
    }
    async success(config) {
        return this.switchToEndState((0, $jZA09.UFOExperienceState).SUCCEEDED, config);
    }
    async failure(config) {
        return this.switchToEndState((0, $jZA09.UFOExperienceState).FAILED, config);
    }
    async abort(config) {
        return this.switchToEndState((0, $jZA09.UFOExperienceState).ABORTED, config);
    }
    addMetadata(data) {
        Object.assign(this.metadata, data);
    }
    _handleDoneExperience(data) {
        (0, $dCAsn.ufolog)('_handleDoneExperience in', this.id, data.state, data, this._until);
        if (data.state.final) {
            if (this._until !== null) {
                const { done: done, state: state } = this._until(data);
                if (done && !this.state.final) this.transition(state);
            }
        }
    }
    async getId() {
        return this.id;
    }
    async exportData() {
        return {
            id: await this.getId(),
            uuid: this.uuid,
            type: this.type,
            schemaVersion: (0, $bbbd8b5766b053fb$export$2295b861f318254a) || 'unknown',
            performanceType: this.performanceType,
            category: this.category,
            state: this.state,
            metadata: {
                ...this.metadata
            },
            metrics: {
                ...this.metrics
            },
            children: [
                ...this.childExperiences
            ],
            result: {
                success: !!this.state.success,
                startTime: this.metrics.startTime,
                duration: (this.metrics.endTime || 0) - (this.metrics.startTime || 0)
            },
            platform: this.config.platform || null,
            pageVisibleState: this.pageVisibleState,
            featureFlags: this.featureFlags,
            isSSROutputAsFMP: this.isSSROutputAsFMP,
            timings: this.timings,
            explicitTimings: this.explicitTimings,
            performanceConfig: this.performanceConfig
        };
    }
    _reset() {
        this.parent = null;
        this.metadata = {};
        this.onDoneCallbacks = [];
        this.childExperiences = [];
        this.metrics = {
            startTime: null,
            endTime: null,
            marks: []
        };
        this._until = this.until ? this.until() : null;
    }
}

});
// temp solution until we can get it automated
const $bbbd8b5766b053fb$export$2295b861f318254a = '0.1.5';

parcelRegister("1vlV8", function(module, exports) {

$parcel$export(module.exports, "getGlobalEventStream", () => $d117cb8be5e8747a$export$6123a44dc2384540);
$parcel$export(module.exports, "subscribeEvent", () => $d117cb8be5e8747a$export$37863216db4b714d);
$parcel$export(module.exports, "unsubscribeEvent", () => $d117cb8be5e8747a$export$ee1a7bd1fc9ea85e);
$parcel$export(module.exports, "experiencePayloadEvent", () => $d117cb8be5e8747a$export$7c957416596ca127);

var $dCAsn = parcelRequire("dCAsn");

var $blQsS = parcelRequire("blQsS");
const $d117cb8be5e8747a$var$MAX_EARLY_QUEUE_LENGTH = 250;
const $d117cb8be5e8747a$export$6123a44dc2384540 = ()=>{
    if (!globalThis.__UFO_GLOBAL_EVENT_STREAM__) {
        const earlyStream = (()=>{
            const stream = [];
            return {
                __buffer_only__: true,
                push: (event)=>{
                    if (stream.length < $d117cb8be5e8747a$var$MAX_EARLY_QUEUE_LENGTH) stream.push(event);
                },
                getStream: ()=>stream
            };
        })();
        globalThis.__UFO_GLOBAL_EVENT_STREAM__ = earlyStream;
    }
    return globalThis.__UFO_GLOBAL_EVENT_STREAM__;
};
const $d117cb8be5e8747a$export$c1522520b417b066 = (eventStream)=>{
    if (globalThis.__UFO_GLOBAL_EVENT_STREAM__ && !globalThis.__UFO_GLOBAL_EVENT_STREAM__?.__buffer_only__) {
        (0, $dCAsn.ufowarn)('Global Event Stream already initialised. Ignoring new event stream setup');
        return;
    }
    if (globalThis.__UFO_GLOBAL_EVENT_STREAM__?.__buffer_only__) globalThis.__UFO_GLOBAL_EVENT_STREAM__.getStream().forEach(eventStream.push.bind(eventStream));
    globalThis.__UFO_GLOBAL_EVENT_STREAM__ = eventStream;
};
const $d117cb8be5e8747a$export$37863216db4b714d = (experienceId, callback)=>{
    return {
        type: (0, $blQsS.UFOGlobalEventStreamEventType).SUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
const $d117cb8be5e8747a$export$ee1a7bd1fc9ea85e = (experienceId, callback)=>{
    return {
        type: (0, $blQsS.UFOGlobalEventStreamEventType).UNSUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
const $d117cb8be5e8747a$export$7c957416596ca127 = (data)=>{
    return {
        type: (0, $blQsS.UFOGlobalEventStreamEventType).EXPERIENCE_PAYLOAD,
        payload: data
    };
};

});
parcelRegister("blQsS", function(module, exports) {

$parcel$export(module.exports, "UFOGlobalEventStreamEventType", () => $2d245cff606eb60d$export$96253c35c37cf96b);
$parcel$export(module.exports, "PageVisibleState", () => $2d245cff606eb60d$export$a12c67b37a306b13);
$parcel$export(module.exports, "SUBSCRIBE_ALL", () => $2d245cff606eb60d$export$79bf131685ad41d7);
$parcel$export(module.exports, "FMP_MARK", () => $2d245cff606eb60d$export$9f2bf58999404c75);
$parcel$export(module.exports, "INLINE_RESPONSE_MARK", () => $2d245cff606eb60d$export$837e0f79a8056912);
var $2d245cff606eb60d$export$96253c35c37cf96b = /*#__PURE__*/ function(UFOGlobalEventStreamEventType) {
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["EXPERIENCE_PAYLOAD"] = 0] = "EXPERIENCE_PAYLOAD";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["SUBSCRIBE"] = 1] = "SUBSCRIBE";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["UNSUBSCRIBE"] = 2] = "UNSUBSCRIBE";
    return UFOGlobalEventStreamEventType;
}({});
var $2d245cff606eb60d$export$a12c67b37a306b13 = /*#__PURE__*/ function(PageVisibleState) {
    PageVisibleState["VISIBLE"] = "visible";
    PageVisibleState["HIDDEN"] = "hidden";
    PageVisibleState["MIXED"] = "mixed";
    return PageVisibleState;
}({});
var $2d245cff606eb60d$export$66b33c055cbb625e = /*#__PURE__*/ function(PageLoadMetrics) {
    PageLoadMetrics["fmp"] = "fmp";
    PageLoadMetrics["tti"] = "tti";
    return PageLoadMetrics;
}({});
var $2d245cff606eb60d$export$3ce489cbe02dc21b = /*#__PURE__*/ function(PageSegmentLoadMetrics) {
    PageSegmentLoadMetrics["fmp"] = "fmp";
    PageSegmentLoadMetrics["tti"] = "tti";
    return PageSegmentLoadMetrics;
}({});
var $2d245cff606eb60d$export$341b330828bd3906 = /*#__PURE__*/ function(InteractionMetrics) {
    InteractionMetrics["response"] = "response";
    InteractionMetrics["result"] = "result";
    return InteractionMetrics;
}({});
var $2d245cff606eb60d$export$b9b20160f581e4f8 = /*#__PURE__*/ function(CustomMetrics) {
    CustomMetrics["duration"] = "duration";
    return CustomMetrics;
}({});
const $2d245cff606eb60d$export$79bf131685ad41d7 = '__SUBSCRIBE_ALL__';
const $2d245cff606eb60d$export$9f2bf58999404c75 = 'fmp';
const $2d245cff606eb60d$export$837e0f79a8056912 = 'inline-response';

});


parcelRegister("dlucd", function(module, exports) {

$parcel$export(module.exports, "visibilityChangeObserver", () => $46b8336a04974a29$export$13e680397ec8f3eb);

var $1CRHx = parcelRequire("1CRHx");
class $46b8336a04974a29$var$VisibilityChangeObserver {
    start() {
        if (this.started) return;
        this.started = true;
        document.addEventListener('visibilitychange', this.broadcast);
        /**
		 * According to https://developer.mozilla.org/en-US/docs/Web/API/Document/visibilitychange_event
		 * Safari doesn’t fire visibilitychange as expected when the value of the visibilityState property transitions to hidden;
		 * so for that case, you need to also include code to listen for the pagehide event.
		 */ if ((0, $1CRHx.isWindowObjectAvailable)()) window.addEventListener('pagehide', this.broadcast);
    }
    subscribe(callback) {
        this.observers.push(callback);
    }
    unsubscribe(callback) {
        this.observers = this.observers.filter((fn)=>fn !== callback);
    }
    constructor(){
        this.started = false;
        this.observers = [];
        this.broadcast = ()=>{
            this.observers.forEach((fn)=>fn());
            this.observers = [];
        };
    }
}
const $46b8336a04974a29$export$13e680397ec8f3eb = new $46b8336a04974a29$var$VisibilityChangeObserver();

});
parcelRegister("1CRHx", function(module, exports) {

$parcel$export(module.exports, "isWindowObjectAvailable", () => $5d24ea5e24f61a4f$export$15e172712955e18f);
const $5d24ea5e24f61a4f$export$15e172712955e18f = ()=>{
    return typeof window !== 'undefined';
};

});


parcelRegister("9tjMO", function(module, exports) {

$parcel$export(module.exports, "roundPerfNow", () => $29608d3bcf65c265$export$5f490af6b2b115cf);
const $29608d3bcf65c265$export$5f490af6b2b115cf = ()=>~~performance.now();

});

parcelRegister("hM2B6", function(module, exports) {

$parcel$export(module.exports, "canTransition", () => $6edf4365ea9733d4$export$178881f329fdb81f);

var $jZA09 = parcelRequire("jZA09");
const $6edf4365ea9733d4$var$UFOStateAvailableTransitions = {
    [(0, $jZA09.UFOExperienceState).NOT_STARTED.id]: [
        (0, $jZA09.UFOExperienceState).STARTED.id
    ],
    [(0, $jZA09.UFOExperienceState).STARTED.id]: [
        (0, $jZA09.UFOExperienceState).IN_PROGRESS.id,
        (0, $jZA09.UFOExperienceState).BLOCKED.id,
        (0, $jZA09.UFOExperienceState).SUCCEEDED.id,
        (0, $jZA09.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $jZA09.UFOExperienceState).FAILED.id,
        (0, $jZA09.UFOExperienceState).ABORTED.id
    ],
    [(0, $jZA09.UFOExperienceState).IN_PROGRESS.id]: [
        (0, $jZA09.UFOExperienceState).BLOCKED.id,
        (0, $jZA09.UFOExperienceState).SUCCEEDED.id,
        (0, $jZA09.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $jZA09.UFOExperienceState).FAILED.id,
        (0, $jZA09.UFOExperienceState).ABORTED.id
    ],
    [(0, $jZA09.UFOExperienceState).BLOCKED.id]: [
        (0, $jZA09.UFOExperienceState).RECOVERED.id,
        (0, $jZA09.UFOExperienceState).ABORTED.id
    ],
    [(0, $jZA09.UFOExperienceState).RECOVERED.id]: [
        (0, $jZA09.UFOExperienceState).STARTED.id,
        (0, $jZA09.UFOExperienceState).SUCCEEDED.id,
        (0, $jZA09.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $jZA09.UFOExperienceState).FAILED.id,
        (0, $jZA09.UFOExperienceState).ABORTED.id
    ],
    [(0, $jZA09.UFOExperienceState).SUCCEEDED.id]: [
        (0, $jZA09.UFOExperienceState).STARTED.id
    ],
    [(0, $jZA09.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id]: [
        (0, $jZA09.UFOExperienceState).SUCCEEDED.id,
        (0, $jZA09.UFOExperienceState).FAILED.id,
        (0, $jZA09.UFOExperienceState).ABORTED.id
    ],
    [(0, $jZA09.UFOExperienceState).FAILED.id]: [
        (0, $jZA09.UFOExperienceState).STARTED.id
    ],
    [(0, $jZA09.UFOExperienceState).ABORTED.id]: [
        (0, $jZA09.UFOExperienceState).STARTED.id
    ]
};
const $6edf4365ea9733d4$export$178881f329fdb81f = (state1, state2)=>{
    return $6edf4365ea9733d4$var$UFOStateAvailableTransitions[state1.id] && $6edf4365ea9733d4$var$UFOStateAvailableTransitions[state1.id].includes(state2.id);
};

});

parcelRegister("7Zbvr", function(module, exports) {

$parcel$export(module.exports, "ExperienceTypes", () => $e40e68027603de60$export$994164cf3ae1cc9a);
$parcel$export(module.exports, "ExperiencePerformanceTypes", () => $e40e68027603de60$export$cc26007c03242fff);
var $e40e68027603de60$export$994164cf3ae1cc9a = /*#__PURE__*/ function(ExperienceTypes) {
    ExperienceTypes["Load"] = "load";
    ExperienceTypes["Experience"] = "experience";
    ExperienceTypes["Operation"] = "operation";
    return ExperienceTypes;
}({});
var $e40e68027603de60$export$cc26007c03242fff = /*#__PURE__*/ function(ExperiencePerformanceTypes) {
    ExperiencePerformanceTypes["PageLoad"] = "page-load";
    ExperiencePerformanceTypes["PageSegmentLoad"] = "page-segment-load";
    ExperiencePerformanceTypes["InlineResult"] = "inline-result";
    ExperiencePerformanceTypes["Custom"] = "custom";
    return ExperiencePerformanceTypes;
}({});

});







parcelRegister("evUrF", function(module, exports) {

$parcel$export(module.exports, "default", () => $027660e13143d610$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $027660e13143d610$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    assigneeTooltip: {
        "id": "issue-field-assignee.common.read-view.popover.assignee-tooltip",
        "defaultMessage": "Assignee: {name}"
    }
});

});

parcelRegister("kt8K4", function(module, exports) {

$parcel$export(module.exports, "default", () => $564a5b059c2a0fff$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");

var $2YZCu = parcelRequire("2YZCu");

var $7f4tk = parcelRequire("7f4tk");
const $564a5b059c2a0fff$var$useUsersQuery = (autoCompleteUrl, customFetchUsers)=>{
    const [users, setUsers] = (0, $5uXOq.useState)([]);
    const [error, setError] = (0, $5uXOq.useState)(undefined);
    const [loading, setLoading] = (0, $5uXOq.useState)(false);
    const currentQuery = (0, $5uXOq.useRef)('');
    const fetchUsers = (0, $5uXOq.useCallback)(// @ts-expect-error - TS2345 - Argument of type '(query?: string | undefined) => Promise<void> | Promise<never[]>' is not assignable to parameter of type 'FetchUsers'.
    (query = '')=>{
        if ([
            '',
            null,
            undefined
        ].includes(autoCompleteUrl)) return Promise.resolve([]);
        setLoading(true);
        currentQuery.current = query;
        if (error) setError(undefined);
        const usersFetchUrl = `${autoCompleteUrl || ''}${query}`;
        const fetchUsersMethod = customFetchUsers && (0, $4R6GH.fg)('issue_cards_in_program_board') ? customFetchUsers(query) : (0, $7f4tk.default)(usersFetchUrl);
        return fetchUsersMethod.then((response)=>{
            if (query === currentQuery.current) setUsers(response);
        }).catch((err)=>{
            if (query === currentQuery.current) setError(err);
            const errorMessage = customFetchUsers && (0, $4R6GH.fg)('issue_cards_in_program_board') ? 'Failed to fetch using custom user fetcher' : 'Failed to fetch users';
            (0, $2YZCu.default).safeErrorWithoutCustomerData('issue.fields.assigne', errorMessage, err);
        }).finally(()=>setLoading(false));
    }, [
        autoCompleteUrl,
        error,
        customFetchUsers
    ]);
    return [
        {
            data: users,
            error: error,
            loading: loading
        },
        fetchUsers
    ];
};
var $564a5b059c2a0fff$export$2e2bcd8739ae039 = $564a5b059c2a0fff$var$useUsersQuery;

});

parcelRegister("h36wX", function(module, exports) {

$parcel$export(module.exports, "fireInviteItemRendererEvent", () => $92b31ca8d85d4433$export$85383b532f48700a);
$parcel$export(module.exports, "useAssigneeOptions", () => $92b31ca8d85d4433$export$1eb7ccf9fc55d2e8);

var $3OKtJ = parcelRequire("3OKtJ");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $itmJb = parcelRequire("itmJb");

var $leRCk = parcelRequire("leRCk");


var $fhSLy = parcelRequire("fhSLy");

var $7lGt2 = parcelRequire("7lGt2");
const $92b31ca8d85d4433$export$85383b532f48700a = ({ createAnalyticsEvent: createAnalyticsEvent, suggestionsCount: suggestionsCount, isAdmin: isAdmin, isInviteAndAssignFromBoard: isInviteAndAssignFromBoard = false })=>{
    if (createAnalyticsEvent === undefined || createAnalyticsEvent === null) return;
    const action = 'rendered';
    const actionSubject = 'inviteItem';
    const event = createAnalyticsEvent({
        action: action,
        actionSubject: actionSubject
    });
    const attrs = {
        fieldId: 'assignee',
        userRole: isAdmin ? 'admin' : 'basic',
        suggestionsCount: suggestionsCount,
        source: 'assigneeField',
        ...isInviteAndAssignFromBoard && {
            isInviteAndAssignFromBoard: true
        }
    };
    (0, $8zOmE.fireUIAnalytics)(event, `${actionSubject} ${action}`, attrs);
};
const $92b31ca8d85d4433$export$1eb7ccf9fc55d2e8 = ({ value: value, users: users, intl: intl, shouldPreloadAssignToMe: shouldPreloadAssignToMe, search: search, enablePeopleInvite: enablePeopleInvite, enableAutomaticOption: enableAutomaticOption, suggestedEmailDomain: suggestedEmailDomain, isEligibleForInviteAndAssign: isEligibleForInviteAndAssign, shouldHideUnassigned: shouldHideUnassigned, shouldShowInviteOnOpen: shouldShowInviteOnOpen })=>{
    const isAdmin = (0, $itmJb.useIsAdmin)();
    const unassigned = (0, $fhSLy.getUnassignedUser)(intl);
    const automaticOption = (0, $fhSLy.getAutomaticUserOption)(intl);
    const valueOption = (0, $fhSLy.getUserOptionFromUser)(value || unassigned);
    const [{ data: loggedInUser }] = (0, $leRCk.useUserSubscriber)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const loggedInUserOption = loggedInUser ? {
        ...(0, $fhSLy.getUserOptionFromUser)(loggedInUser),
        publicName: intl.formatMessage((0, $7lGt2.default).assignToMe)
    } : null;
    const isInvalidSearch = search === undefined || search === '';
    // show unassigned option if value is defined and no search or unassigned display name match the search
    const showUnassigned = !shouldHideUnassigned && (isInvalidSearch ? Boolean(value?.accountId) : unassigned.displayName.toLowerCase().startsWith((search || '').toLowerCase()));
    let showAutomaticOption = false;
    if (enableAutomaticOption === true) showAutomaticOption = isInvalidSearch ? Boolean(value?.accountId !== (0, $c1e3a0a8493b8e86$export$f5d5f6bb902f1027)) : automaticOption.displayName.toLowerCase().startsWith((search || '').toLowerCase());
    const isLoggedInUserCurrentValue = loggedInUserOption !== null && valueOption.id === loggedInUserOption.id;
    const isLoggedInUserMatchSearch = users.some((user)=>loggedInUserOption !== null && user.accountId === loggedInUserOption.id);
    const showAssignToMeOnInit = !isLoggedInUserCurrentValue && (shouldPreloadAssignToMe || isLoggedInUserMatchSearch);
    const showAssignToMe = isInvalidSearch ? showAssignToMeOnInit : isLoggedInUserMatchSearch;
    const userOptions = users.filter((user)=>// remove selected user (value) from users list when search is not defined
        (!isInvalidSearch || user.accountId !== valueOption.id) && // remove logged in user (is already added in 2nd position above)
        !(loggedInUserOption !== null && user.accountId === loggedInUserOption.id)).map((0, $fhSLy.getUserOptionFromUser));
    const invitePeopleOptions = [];
    if (enablePeopleInvite === true && shouldShowInviteOnOpen) {
        if (isEligibleForInviteAndAssign && search) invitePeopleOptions.push((0, $3OKtJ.getInviteAndAssignPeopleOption)(intl.formatMessage, search, suggestedEmailDomain));
        else invitePeopleOptions.push((0, $fhSLy.getUserOptionFromUser)((0, $fhSLy.getInvitePeopleOption)(intl, isAdmin)));
    } else if (enablePeopleInvite === true && !isInvalidSearch && userOptions.length < 3) {
        if (isEligibleForInviteAndAssign) {
            invitePeopleOptions.push((0, $3OKtJ.getInviteAndAssignPeopleOption)(intl.formatMessage, search, suggestedEmailDomain));
            $92b31ca8d85d4433$export$85383b532f48700a({
                createAnalyticsEvent: createAnalyticsEvent,
                suggestionsCount: userOptions.length,
                isAdmin: isAdmin,
                isInviteAndAssignFromBoard: true
            });
        } else {
            $92b31ca8d85d4433$export$85383b532f48700a({
                createAnalyticsEvent: createAnalyticsEvent,
                suggestionsCount: userOptions.length,
                isAdmin: isAdmin
            });
            invitePeopleOptions.push((0, $fhSLy.getUserOptionFromUser)((0, $fhSLy.getInvitePeopleOption)(intl, isAdmin)));
        }
    }
    const options = [
        ...showUnassigned ? [
            (0, $fhSLy.getUserOptionFromUser)(unassigned)
        ] : [],
        ...showAutomaticOption ? [
            (0, $fhSLy.getUserOptionFromUser)(automaticOption)
        ] : [],
        ...showAssignToMe && loggedInUserOption !== null ? [
            loggedInUserOption
        ] : [],
        ...userOptions,
        ...invitePeopleOptions
    ];
    return [
        valueOption,
        options,
        {
            userOptionsCount: userOptions.length
        }
    ];
};

});
parcelRegister("3OKtJ", function(module, exports) {

$parcel$export(module.exports, "isValidEmailAddress", () => $d369cb9a3149539e$export$866f45a7554d0870);
$parcel$export(module.exports, "getInviteAndAssignPeopleOption", () => $d369cb9a3149539e$export$34e0d98131b0b98a);

var $M0UM1 = parcelRequire("M0UM1");

var $ePvDo = parcelRequire("ePvDo");


var $eXneb = parcelRequire("eXneb");
const $d369cb9a3149539e$var$getInviteAndAssignOption = (inputValue, suggestedEmailDomain)=>{
    const isEmail = inputValue && [
        (0, $a56e5eac5897104f$export$18d36911c7f94286),
        (0, $a56e5eac5897104f$export$da1c529049028734)
    ].includes((0, $M0UM1.isValidEmail)(inputValue));
    const value = isEmail || !suggestedEmailDomain ? inputValue : `${inputValue.replace(/\s+/g, '.').toLocaleLowerCase()}@${suggestedEmailDomain}`;
    return value;
};
const $d369cb9a3149539e$export$866f45a7554d0870 = (inputValue)=>inputValue && (0, $M0UM1.isValidEmail)(inputValue) === (0, $a56e5eac5897104f$export$18d36911c7f94286);
const $d369cb9a3149539e$export$34e0d98131b0b98a = (formatMessage, input, suggestedEmailDomain)=>{
    const possibleEmail = $d369cb9a3149539e$var$getInviteAndAssignOption(input, suggestedEmailDomain);
    return {
        id: (0, $a56e5eac5897104f$export$898547b9297d1a3a),
        name: possibleEmail,
        avatarUrl: (0, (/*@__PURE__*/$parcel$interopDefault($ePvDo))),
        byline: formatMessage((0, $eXneb.default).inviteAndAssign),
        isDisabled: (0, $M0UM1.isValidEmail)(possibleEmail) !== 'VALID'
    };
};

});
parcelRegister("ePvDo", function(module, exports) {
module.exports = new URL("email.very-specific-illu.3b6402e8.png", import.meta.url).toString();

});

const $a56e5eac5897104f$export$898547b9297d1a3a = '_INVITE_AND_ASSIGN_ID_';
const $a56e5eac5897104f$export$18d36911c7f94286 = 'VALID';
const $a56e5eac5897104f$export$da1c529049028734 = 'POTENTIAL';

parcelRegister("eXneb", function(module, exports) {

$parcel$export(module.exports, "default", () => $31de51ead46cb5cc$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $31de51ead46cb5cc$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    inviteAndAssign: {
        "id": "invite-and-assign.common.invite-and-assign",
        "defaultMessage": "Invite and assign"
    }
});

});


parcelRegister("leRCk", function(module, exports) {

$parcel$export(module.exports, "UserContainer", () => $46a581f1f6efe569$export$7ff085589970ee0a);
$parcel$export(module.exports, "useUserSubscriber", () => $46a581f1f6efe569$export$4e61bbf568682a96);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $314C6 = parcelRequire("314C6");
const $46a581f1f6efe569$var$initialState = {
    data: null,
    loading: false,
    error: null
};
const $46a581f1f6efe569$var$Store = (0, $iXqE5.createStore)({
    name: 'user',
    initialState: $46a581f1f6efe569$var$initialState,
    actions: $314C6
});
const $46a581f1f6efe569$export$7ff085589970ee0a = (0, $gg7kZ.createContainer)($46a581f1f6efe569$var$Store);
const $46a581f1f6efe569$export$4e61bbf568682a96 = (0, $3sQ5x.createHook)($46a581f1f6efe569$var$Store);

});
parcelRegister("314C6", function(module, exports) {

$parcel$export(module.exports, "fetch", () => $acdfee9161693eca$export$e7aa7bc5c1b3cfb3);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iF3m5 = parcelRequire("iF3m5");
const $acdfee9161693eca$export$e7aa7bc5c1b3cfb3 = ({ params: params, header: header }, forceRefetch = false)=>async ({ setState: setState, getState: getState })=>{
        const currentState = getState();
        if (!params || currentState.loading || currentState.data && !forceRefetch) return;
        setState({
            loading: true
        });
        try {
            const data = await (0, $iF3m5.fetchData)({
                params: params,
                header: header
            });
            setState({
                data: data,
                loading: false,
                error: null
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setState({
                error: err,
                loading: false
            });
        }
    };

});
parcelRegister("iF3m5", function(module, exports) {

$parcel$export(module.exports, "fetchData", () => $d22d4c6d892f61f1$export$8134c072fddab6a5);

var $ebyGx = parcelRequire("ebyGx");

var $8QpSo = parcelRequire("8QpSo");

var $eusud = parcelRequire("eusud");

var $4R6GH = parcelRequire("4R6GH");

var $e5wyW = parcelRequire("e5wyW");

var $6Z846 = parcelRequire("6Z846");
const $d22d4c6d892f61f1$export$5e5a6664039ed1cc = ({ params: params, header: header })=>{
    const queryParams = {
        ...params,
        expand: Object.keys(params.expand || {}).filter((key)=>params.expand && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            params.expand[key])
    };
    const query = (0, $ebyGx.stringify)(queryParams, {
        arrayFormat: 'none'
    });
    const queryString = query ? `?${query}` : '';
    const requestUrl = `/rest/api/2/user${queryString}`;
    // @ts-expect-error - TS2345 - Argument of type '{ headers: HeaderParamForceAccountId; } | {}' is not assignable to parameter of type 'RequestInit | undefined'.
    return (0, $eusud.performGetRequest)(requestUrl, header ? {
        headers: header
    } : {});
};
const $d22d4c6d892f61f1$var$fetchDataNew = (0, $8QpSo.default)($d22d4c6d892f61f1$export$5e5a6664039ed1cc, (newArgs, lastArgs)=>// compare params and headers to see if it should be memoised.
    (0, $6Z846.isShallowEqual)(newArgs[0].params, lastArgs[0].params) && (0, $6Z846.isShallowEqual)(newArgs[0].header, lastArgs[0].header));
const $d22d4c6d892f61f1$export$8134c072fddab6a5 = (0, $e5wyW.functionWithCondition)(()=>(0, $4R6GH.fg)('user-iv-llc-unnecessary-api'), $d22d4c6d892f61f1$var$fetchDataNew, $d22d4c6d892f61f1$export$5e5a6664039ed1cc);

});



const $c1e3a0a8493b8e86$export$bdab9bfb39981463 = '__UNASSIGNED_ID__';
const $c1e3a0a8493b8e86$export$d875316cb0cd94f7 = '__INVITE_PEOPLE_ID__';
const $c1e3a0a8493b8e86$export$f5d5f6bb902f1027 = '-1';

parcelRegister("fhSLy", function(module, exports) {

$parcel$export(module.exports, "getUnassignedUser", () => $bdabf260f25df73f$export$42c5a0b65ef9ee80);
$parcel$export(module.exports, "getAutomaticUserOption", () => $bdabf260f25df73f$export$8d7a63500893c8c);
$parcel$export(module.exports, "getInvitePeopleOption", () => $bdabf260f25df73f$export$84a82764cf0a696e);
$parcel$export(module.exports, "getUserOptionFromUser", () => $bdabf260f25df73f$export$16086438354dcc85);
$parcel$export(module.exports, "getUserFromUserOption", () => $bdabf260f25df73f$export$78a8bcc5bd21caa2);
$parcel$export(module.exports, "getUserAvatarUrl", () => $bdabf260f25df73f$export$7d801d84202c7743);
$parcel$export(module.exports, "getUserShape", () => $bdabf260f25df73f$export$322b6ab8c29a006e);

var $7lGt2 = parcelRequire("7lGt2");

var $gRwYv = parcelRequire("gRwYv");

const $bdabf260f25df73f$export$42c5a0b65ef9ee80 = ({ formatMessage: formatMessage })=>({
        accountId: (0, $c1e3a0a8493b8e86$export$bdab9bfb39981463),
        displayName: formatMessage((0, $7lGt2.default).unassignedOption),
        avatarUrls: {}
    });
const $bdabf260f25df73f$export$8d7a63500893c8c = ({ formatMessage: formatMessage })=>({
        accountId: (0, $c1e3a0a8493b8e86$export$f5d5f6bb902f1027),
        displayName: formatMessage((0, $7lGt2.default).automaticOption),
        avatarUrls: {}
    });
const $bdabf260f25df73f$export$84a82764cf0a696e = ({ formatMessage: formatMessage }, isAdmin)=>({
        accountId: (0, $c1e3a0a8493b8e86$export$d875316cb0cd94f7),
        displayName: formatMessage(isAdmin ? (0, $7lGt2.default).invitePeopleOptionAdmin : (0, $7lGt2.default).invitePeopleOption),
        avatarUrls: {
            '48x48': (0, (/*@__PURE__*/$parcel$interopDefault($gRwYv)))
        }
    });
const $bdabf260f25df73f$export$16086438354dcc85 = ({ accountId: accountId, displayName: displayName, avatarUrls: avatarUrls, emailAddress: emailAddress })=>({
        id: accountId || '',
        name: displayName,
        avatarUrl: avatarUrls['48x48'],
        // @ts-expect-error Will be part of JIV-13488; `user.emailAddress` returned by the REST API can be null depending on their privacy settings
        byline: emailAddress
    });
const $bdabf260f25df73f$export$78a8bcc5bd21caa2 = ({ id: id, name: name, avatarUrl: avatarUrl })=>({
        accountId: id,
        displayName: name,
        avatarUrls: {
            '48x48': avatarUrl
        }
    });
const $bdabf260f25df73f$export$7d801d84202c7743 = ({ avatarUrls: avatarUrls })=>avatarUrls['48x48'];
const $bdabf260f25df73f$export$322b6ab8c29a006e = (accountId, displayName, avatarUrl)=>({
        accountId: accountId,
        displayName: displayName,
        avatarUrls: {
            '48x48': avatarUrl
        }
    });

});
parcelRegister("7lGt2", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2aaed3328149e1d$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $e2aaed3328149e1d$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    unassignedOption: {
        "id": "issue-field-assignee.unassigned-option",
        "defaultMessage": "Unassigned"
    },
    automaticOption: {
        "id": "issue-field-assignee.automatic-option",
        "defaultMessage": "Automatic"
    },
    assignToMe: {
        "id": "issue-field-assignee.assign-to-me",
        "defaultMessage": "Assign to me"
    },
    searchForAssignee: {
        "id": "issue-field-assignee.search-for-assignee",
        "defaultMessage": "Search for assignee"
    },
    invitePeopleOption: {
        "id": "issue-field-assignee.invite-people-option",
        "defaultMessage": "Add teammate to Jira"
    },
    invitePeopleOptionAdmin: {
        "id": "issue-field-assignee.invite-people-option-admin",
        "defaultMessage": "Invite teammate to Jira"
    }
});

});

parcelRegister("gRwYv", function(module, exports) {
module.exports = new URL("add.b8fea212.png", import.meta.url).toString();

});



parcelRegister("1rEZQ", function(module, exports) {

$parcel$export(module.exports, "useInvitePeopleModal", () => $cd38c418174b581b$export$b9ec44715ae5ad99);
$parcel$export(module.exports, "triggerOpenModal", () => $cd38c418174b581b$export$3da9a54757b29739);

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
var $51nlc = parcelRequire("51nlc");
var $bKpgX = parcelRequire("bKpgX");

var $bAQ41 = parcelRequire("bAQ41");
const $cd38c418174b581b$var$CONTROLLER_NAME = 'invite-people-modal';
const $cd38c418174b581b$var$initialState = {
    isOpen: false,
    inviteFlow: 'unknown',
    continueUrl: undefined
};
const $cd38c418174b581b$var$Store = (0, $iXqE5.createStore)({
    name: $cd38c418174b581b$var$CONTROLLER_NAME,
    initialState: $cd38c418174b581b$var$initialState,
    actions: {
        openModal: (createAnalyticsEvent, { inviteFlow: inviteFlow, analyticsSource: analyticsSource, continueUrl: continueUrl })=>({ setState: setState })=>{
                (0, $bAQ41.fireAddTeammatetoJiraAnalytics)(createAnalyticsEvent, analyticsSource);
                (0, $bAQ41.fireModalTriggeredAnalytics)(createAnalyticsEvent, inviteFlow, analyticsSource);
                setState({
                    isOpen: true,
                    inviteFlow: inviteFlow,
                    continueUrl: continueUrl
                });
            },
        closeModal: ()=>({ setState: setState })=>setState($cd38c418174b581b$var$initialState)
    }
});
const $cd38c418174b581b$export$b9ec44715ae5ad99 = (0, $3sQ5x.createHook)($cd38c418174b581b$var$Store);
const $cd38c418174b581b$export$42437f35b39968af = (0, $gg7kZ.createContainer)($cd38c418174b581b$var$Store, {
    onInit: ()=>({ setState: setState }, { isOpen: isOpen })=>{
            setState({
                isOpen: isOpen
            });
        }
});
const $cd38c418174b581b$export$c109a2947e32aee9 = (0, $51nlc.createSubscriber)($cd38c418174b581b$var$Store, {
    displayName: 'InvitePeopleModalSubscriber',
    selector: (state)=>state.isOpen
});
const $cd38c418174b581b$export$3da9a54757b29739 = (createAnalyticsEvent, contextConfig)=>{
    (0, $bKpgX.defaultRegistry).getStore($cd38c418174b581b$var$Store)?.actions.openModal(createAnalyticsEvent, contextConfig);
};

});
parcelRegister("bAQ41", function(module, exports) {

$parcel$export(module.exports, "AnalyticsProvider", () => $ac9237b475f93db1$export$1b581a2ec13e37f1);
$parcel$export(module.exports, "fireModalTriggeredAnalytics", () => $ac9237b475f93db1$export$6815765da918b983);
$parcel$export(module.exports, "fireAddTeammatetoJiraAnalytics", () => $ac9237b475f93db1$export$21b810258e82d438);

var $5uXOq = parcelRequire("5uXOq");

var $bvUB1 = parcelRequire("bvUB1");

var $8zOmE = parcelRequire("8zOmE");
var $lhVtI = parcelRequire("lhVtI");

var $fjcgS = parcelRequire("fjcgS");

var $9HRJR = parcelRequire("9HRJR");
const $ac9237b475f93db1$var$useAnalyticsClient = ()=>{
    const analyticsWebClientRef = (0, $5uXOq.useRef)((0, $fjcgS.getAnalyticsWebClientPromise)());
    return {
        sendEvent: (analyticsEvent)=>{
            analyticsWebClientRef.current.then((webClient)=>webClient.sendEvent((0, $lhVtI.getEvent)(analyticsEvent)));
        }
    };
};
const $ac9237b475f93db1$export$1b581a2ec13e37f1 = ({ children: children })=>{
    const { sendEvent: sendEvent } = $ac9237b475f93db1$var$useAnalyticsClient();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bvUB1.default), {
        channel: "peopleAndTeams",
        onEvent: sendEvent
    }, children);
};
const $ac9237b475f93db1$var$sendAnalyticsClientUIEvent = async (createAnalyticsEvent, analyticsPayload)=>{
    if (createAnalyticsEvent) (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), // @ts-expect-error Argument of type '[string, string, Attributes | undefined]' is not assignable to parameter of type 'RestArguments'.
    `${analyticsPayload.actionSubject} ${analyticsPayload.action}`, analyticsPayload?.actionSubjectId || '', analyticsPayload.attributes);
    else {
        const webAnalyticsClient = await (0, $fjcgS.getAnalyticsWebClientPromise)();
        const analyticsClient = webAnalyticsClient.getInstance();
        // SSR doesn't have an analytics client
        if (analyticsClient) analyticsClient.sendUIEvent(analyticsPayload);
    }
};
const $ac9237b475f93db1$export$6815765da918b983 = async (createAnalyticsEvent, inviteFlow, source)=>{
    const analyticsPayload = {
        action: 'triggered',
        actionSubject: 'modal',
        actionSubjectId: 'invitePeopleModal',
        attributes: {
            source: (0, $9HRJR.getSourceByInviteFlow)(inviteFlow)
        },
        source: source != null && source !== '' ? source : 'unknown'
    };
    $ac9237b475f93db1$var$sendAnalyticsClientUIEvent(createAnalyticsEvent, analyticsPayload);
};
const $ac9237b475f93db1$export$21b810258e82d438 = async (createAnalyticsEvent, source)=>{
    const analyticsPayload = {
        action: 'clicked',
        actionSubject: 'addTeammatetoJira',
        product: 'jira',
        source: source != null && source !== '' ? source : 'unknown'
    };
    $ac9237b475f93db1$var$sendAnalyticsClientUIEvent(createAnalyticsEvent, analyticsPayload);
};

});
parcelRegister("9HRJR", function(module, exports) {

$parcel$export(module.exports, "getSourceByInviteFlow", () => $74aef55db4ee6d16$export$c35cd18e9d0123e3);
const $74aef55db4ee6d16$export$c35cd18e9d0123e3 = (inviteFlow)=>{
    let source = inviteFlow;
    if (inviteFlow === 'mention') source = 'mentionInEditor';
    else if (inviteFlow === 'assignee') source = 'assigneeField';
    return source;
};

});



parcelRegister("6yQD6", function(module, exports) {

$parcel$export(module.exports, "AssigneeAvatar", () => $a58b89e15740a36e$export$e970d79be9068ed);

var $5uXOq = parcelRequire("5uXOq");

var $ujWmd = parcelRequire("ujWmd");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $koVbs = parcelRequire("koVbs");


var $fhSLy = parcelRequire("fhSLy");

var $7lGt2 = parcelRequire("7lGt2");
const $a58b89e15740a36e$export$e970d79be9068ed = ({ value: value, assigneeNameLabel: assigneeNameLabel, iconSize: iconSize = 'xsmall' })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const unassignedUser = {
        accountId: (0, $c1e3a0a8493b8e86$export$bdab9bfb39981463),
        displayName: formatMessage((0, $7lGt2.default).unassignedOption),
        avatarUrls: {}
    };
    const user = value || unassignedUser;
    const avatarUrl = (0, $fhSLy.getUserAvatarUrl)(user);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $a58b89e15740a36e$var$avatarStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
        testId: "inline-assignee-picker.assignee-picker-popup.assignee-avatar.avatar",
        size: iconSize,
        src: avatarUrl,
        name: assigneeNameLabel || user.displayName,
        borderColor: "transparent"
    }));
};
const $a58b89e15740a36e$var$avatarStyles = (0, $8CUq3.xcss)({
    display: 'inline-block',
    transform: 'scale(1.2)'
});

});




parcelRegister("8OpiR", function(module, exports) {

$parcel$export(module.exports, "CREATE_ISSUE_EXPERIENCE", () => $1b5c59748aee9f18$export$ed625f60643a6c30);
$parcel$export(module.exports, "EDIT_ISSUE_TYPE_EXPERIENCE", () => $1b5c59748aee9f18$export$babf947cadc294d);
$parcel$export(module.exports, "CREATE_ISSUE_TYPE_EXPERIENCE", () => $1b5c59748aee9f18$export$98bc3d285fdf973e);

var $atdLB = parcelRequire("atdLB");
var $duUGa = parcelRequire("duUGa");
const $1b5c59748aee9f18$export$ed625f60643a6c30 = {
    experience: 'createIssue',
    packageName: 'jiraBusinessIssueCreate',
    teamName: 'deliveroo'
};
const $1b5c59748aee9f18$export$babf947cadc294d = new (0, $duUGa.UFOExperience)('business-list.edit-issue-type', {
    type: (0, $atdLB.ExperienceTypes).Operation,
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).Custom
});
const $1b5c59748aee9f18$export$98bc3d285fdf973e = new (0, $duUGa.UFOExperience)('business-list.create-issue-type', {
    type: (0, $atdLB.ExperienceTypes).Operation,
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).Custom
});

});

parcelRegister("6uB1c", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab3aefe72ec8e0ad$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $ab3aefe72ec8e0ad$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    placeholderText: {
        "id": "business-issue-create.inline-create-form.placeholder-text",
        "defaultMessage": "What needs to be done?"
    },
    createButton: {
        "id": "business-issue-create.inline-create-form.create-button",
        "defaultMessage": "Create"
    },
    createIssueInputLabel: {
        "id": "business-issue-create.inline-create-form.create-issue-input-label",
        "defaultMessage": "What needs to be done?"
    },
    createIssueInputDescription: {
        "id": "business-issue-create.inline-create-form.create-issue-input-description",
        "defaultMessage": "{issueType} selected. Add your summary and then press Enter to submit. Use the Escape key to cancel."
    },
    createIssueTypes: {
        "id": "business-issue-create.inline-create-form.create-issue-types",
        "defaultMessage": "Create issue type"
    },
    createIssueTypesIssueTermRefresh: {
        "id": "business-issue-create.inline-create-form.create-issue-types-issue-term-refresh",
        "defaultMessage": "Create work type"
    },
    addIssueType: {
        "id": "business-issue-create.inline-create-form.add-issue-type",
        "defaultMessage": "Add issue type"
    },
    addWorkType: {
        "id": "business-issue-create.inline-create-form.add-work-type",
        "defaultMessage": "Add work type"
    },
    editIssueTypes: {
        "id": "business-issue-create.inline-create-form.edit-issue-types",
        "defaultMessage": "Edit issue type"
    },
    editIssueTypesIssueTermRefresh: {
        "id": "business-issue-create.inline-create-form.edit-issue-types-issue-term-refresh",
        "defaultMessage": "Edit work type"
    },
    selectIssueTypeButton: {
        "id": "business-issue-create.inline-create-form.select-issue-type-button",
        "defaultMessage": "Select issue type. {issueType} currently selected."
    },
    manageIssueTypes: {
        "id": "business-issue-create.inline-create-form.manage-issue-types",
        "defaultMessage": "Manage types"
    },
    manageIssueTypesIssueTermRefresh: {
        "id": "business-issue-create.inline-create-form.manage-issue-types-issue-term-refresh",
        "defaultMessage": "Manage work types"
    },
    selectIssueTypeButtonIssueTermRefresh: {
        "id": "business-issue-create.inline-create-form.select-issue-type-button-issue-term-refresh",
        "defaultMessage": "Select work type. {issueType} currently selected."
    },
    loadingIssueCreateForm: {
        "id": "business-issue-create.inline-create-form.loading-issue-types",
        "defaultMessage": "Loading issue create form"
    },
    loadingIssueCreateFormIssueTermRefresh: {
        "id": "business-issue-create.inline-create-form.loading-issue-types-issue-term-refresh",
        "defaultMessage": "Loading the form to create a work item"
    }
});

});

parcelRegister("t9aRF", function(module, exports) {

$parcel$export(module.exports, "default", () => $56358a56fb81f180$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5LWLA = parcelRequire("5LWLA");
const $56358a56fb81f180$var$ReturnGlyph = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        width: "24",
        height: "16",
        viewBox: "0 0 24 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3 0C1.34315 0 0 1.34315 0 3V13C0 14.6569 1.34315 16 3 16H21C22.6569 16 24 14.6569 24 13V3C24 1.34315 22.6569 0 21 0H3Z",
        fill: "var(--ds-background-inverse-subtle, #00000029)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M15.5 5.75V6.75C15.5 8.26878 14.2688 9.5 12.75 9.5H8.75C8.33579 9.5 8 9.16421 8 8.75C8 8.33579 8.33579 8 8.75 8H12.75C13.4404 8 14 7.44036 14 6.75V5.75C14 5.33579 14.3358 5 14.75 5C15.1642 5 15.5 5.33579 15.5 5.75Z",
        fill: "var(--ds-text-inverse, #FFFFFF)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M9.28033 9.28033L11.0303 7.53033C11.3232 7.23744 11.3232 6.76256 11.0303 6.46967C10.7374 6.17678 10.2626 6.17678 9.96967 6.46967L8.21967 8.21967C7.92678 8.51256 7.92678 8.98744 8.21967 9.28033C8.51256 9.57322 8.98744 9.57322 9.28033 9.28033Z",
        fill: "var(--ds-text-inverse, #FFFFFF)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M9.28033 8.21967L11.0303 9.96967C11.3232 10.2626 11.3232 10.7374 11.0303 11.0303C10.7374 11.3232 10.2626 11.3232 9.96967 11.0303L8.21967 9.28033C7.92678 8.98744 7.92678 8.51256 8.21967 8.21967C8.51256 7.92678 8.98744 7.92678 9.28033 8.21967Z",
        fill: "var(--ds-text-inverse, #FFFFFF)"
    }));
const $56358a56fb81f180$var$ReturnIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
        glyph: $56358a56fb81f180$var$ReturnGlyph,
        label: ""
    });
var $56358a56fb81f180$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($56358a56fb81f180$var$ReturnIcon);

});

parcelRegister("9ngzl", function(module, exports) {

$parcel$export(module.exports, "SelectFooter", () => $9c7ebf4f2bd1f4d9$export$63792e9b287857db);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $5ILhZ = parcelRequire("5ILhZ");
var $luBm6 = parcelRequire("luBm6");
var $8CUq3 = parcelRequire("8CUq3");

var $koVbs = parcelRequire("koVbs");

var $4R6GH = parcelRequire("4R6GH");

var $2awBM = parcelRequire("2awBM");

var $2KAtx = parcelRequire("2KAtx");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $koeKL = parcelRequire("koeKL");


var $lVJAU = parcelRequire("lVJAU");

var $6s1PB = parcelRequire("6s1PB");

var $dkvNx = parcelRequire("dkvNx");

var $daQYX = parcelRequire("daQYX");

var $b5FXT = parcelRequire("b5FXT");

var $5jhd5 = parcelRequire("5jhd5");

var $6uB1c = parcelRequire("6uB1c");

var $8OpiR = parcelRequire("8OpiR");
const $9c7ebf4f2bd1f4d9$var$fireExposureForCombinedImpactAAExperiment = ()=>{
    (0, $6s1PB.expVal)('combined_adoption_configuration_experiment_aa', 'isEnabled', false);
    return true;
};
const $9c7ebf4f2bd1f4d9$var$filterSubTaskTypePredicate = (currentType, targetType)=>{
    if (currentType.subtask) return targetType.subtask;
    return true;
};
const $9c7ebf4f2bd1f4d9$export$63792e9b287857db = ({ shouldShowManageType: shouldShowManageType = true, allowIssueTypeConfiguration: allowIssueTypeConfiguration = true, onIssueTypeConfigured: onIssueTypeConfigured = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onCreateIssueTypeClick: onCreateIssueTypeClick, onCreateIssueTypeClose: onCreateIssueTypeClose, isInlineConfigExperimentEnabled: isInlineConfigExperimentEnabled = ()=>true, onEditIssueTypeClose: onEditIssueTypeClose, onEditIssueTypeClick: onEditIssueTypeClick, issueType: issueType, issueTypes: issueTypes })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { push: push } = (0, $lVJAU.useRouterActions)();
    const cloudId = (0, $koeKL.useCloudId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const modalConfigProps = (0, $5uXOq.useMemo)(()=>({
            width: 424
        }), []);
    const { key: projectKey, isSimplified: isSimplified, id: projectId } = (0, $daQYX.useProject)();
    const manageIssueTypesLink = (0, $dkvNx.getIssueTypesSettingsUrl)(projectKey, isSimplified);
    const handleCreateWorkTypeClick = (_event, analyticsEvent)=>{
        onCreateIssueTypeClick();
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'createIssueTypeButton');
    };
    const handleManageTypeClick = (_e, analyticsEvent)=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'manageIssueTypesButton');
        push(manageIssueTypesLink);
    };
    const onCloseCreateIssueTypesModal = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            actionSubject: 'inlineCreateIssueTypeModal',
            action: 'closed'
        }));
        onCreateIssueTypeClose();
    }, [
        createAnalyticsEvent,
        onCreateIssueTypeClose
    ]);
    const entryPointProps = (0, $5uXOq.useMemo)(()=>({
            onIssueTypeCreated: onIssueTypeConfigured,
            issueTypesCountLimit: 30,
            onClose: onCloseCreateIssueTypesModal,
            source: (0, $f1340a435190eeda$export$4edb790587638895),
            ufoExperience: (0, $8OpiR.CREATE_ISSUE_TYPE_EXPERIENCE),
            showNewIssueTypeForm: (0, $4R6GH.fg)('inline_issue_type_config_productionization_prereqs')
        }), [
        onCloseCreateIssueTypesModal,
        onIssueTypeConfigured
    ]);
    const entryPointParams = (0, $5uXOq.useMemo)(()=>({
            cloudId: cloudId,
            projectKey: projectKey
        }), [
        cloudId,
        projectKey
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        xcss: $9c7ebf4f2bd1f4d9$var$footerContainerStyles
    }, allowIssueTypeConfiguration && $9c7ebf4f2bd1f4d9$var$fireExposureForCombinedImpactAAExperiment() && isInlineConfigExperimentEnabled() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2KAtx.ModalEntryPointPressableTrigger), {
        entryPoint: (0, $2awBM.asyncCreateIssueTypeModalEntryPoint),
        entryPointProps: entryPointProps,
        entryPointParams: entryPointParams,
        interactionName: "create-issue-type-modal",
        modalProps: modalConfigProps,
        useInternalModal: (0, $4R6GH.fg)('inline_issue_type_config_productionization_prereqs'),
        Fallback: (0, $4R6GH.fg)('jgfeng_new_work_type_fallback_loading_state') ? ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5jhd5.FormDialogSkeleton), {
                numFormFields: 1
            }) : undefined
    }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5ILhZ.default), {
            onClick: handleCreateWorkTypeClick,
            xcss: $9c7ebf4f2bd1f4d9$var$pressableStyles,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            ref: ref
        }, formatMessage(// eslint-disable-next-line no-nested-ternary
        (0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $4R6GH.fg)('jira_rename_inline_create_work_type_button') ? (0, $6uB1c.default).addWorkType : (0, $6uB1c.default).createIssueTypesIssueTermRefresh : (0, $4R6GH.fg)('jira_rename_inline_create_work_type_button') ? (0, $6uB1c.default).addIssueType : (0, $6uB1c.default).createIssueTypes))), allowIssueTypeConfiguration && isInlineConfigExperimentEnabled() && (0, $6s1PB.expVal)('jira_inline_edit_issuetype_list_view', 'isEnabled', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b5FXT.EditIssueTypeModalTrigger), {
        projectId: projectId,
        projectKey: projectKey,
        onIssueTypeUpdated: onIssueTypeConfigured,
        onClose: onEditIssueTypeClose,
        onOpen: onEditIssueTypeClick,
        ufoExperience: (0, $8OpiR.EDIT_ISSUE_TYPE_EXPERIENCE),
        issueTypeId: issueType.id,
        calledFrom: (0, $f1340a435190eeda$export$4edb790587638895),
        relevantIssueTypeIds: issueTypes.filter((type)=>issueType && $9c7ebf4f2bd1f4d9$var$filterSubTaskTypePredicate(issueType, type)).map(({ id: id })=>id.toString()),
        isPressable: true,
        onClick: onEditIssueTypeClick,
        enablePressableStyles: true
    }, formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $6uB1c.default).editIssueTypesIssueTermRefresh : (0, $6uB1c.default).editIssueTypes)), shouldShowManageType && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5ILhZ.default), {
        onClick: handleManageTypeClick,
        xcss: $9c7ebf4f2bd1f4d9$var$pressableStyles
    }, formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $6uB1c.default).manageIssueTypesIssueTermRefresh : (0, $6uB1c.default).manageIssueTypes)));
};
const $9c7ebf4f2bd1f4d9$var$footerContainerStyles = (0, $8CUq3.xcss)({
    borderTop: '2px solid',
    borderTopColor: 'color.border',
    paddingTop: 'space.050',
    paddingBottom: 'space.050',
    marginTop: 'space.050'
});
const $9c7ebf4f2bd1f4d9$var$pressableStyles = (0, $8CUq3.xcss)({
    paddingTop: 'space.100',
    paddingBottom: 'space.100',
    paddingLeft: 'space.150',
    paddingRight: 'space.150',
    textAlign: 'left',
    font: 'inherit',
    color: 'color.text',
    backgroundColor: 'color.background.neutral.subtle',
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.subtle.pressed'
    }
});

});
parcelRegister("2awBM", function(module, exports) {

$parcel$export(module.exports, "asyncCreateIssueTypeModalEntryPoint", () => $5d94d7bcabd38106$export$7f9428aac5b01dff);

var $ekCoo = parcelRequire("ekCoo");

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $5d94d7bcabd38106$export$7f9428aac5b01dff = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("3zpeP")), {
        moduleId: "0ca2b96c"
    }),
    getPreloadProps: ({ projectKey: projectKey, cloudId: cloudId, shouldFetchProjectData: shouldFetchProjectData })=>({
            queries: {
                createIssueTypeModal: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $ekCoo.default,
                    variables: {
                        projectKey: projectKey,
                        cloudId: cloudId,
                        shouldFetchProjectData: shouldFetchProjectData
                    }
                }
            }
        })
});

});
parcelRegister("ekCoo", function(module, exports) {

$parcel$export(module.exports, "default", () => $1115b945d8dda421$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<36277921a8012e0702a65f1227cbbd1b>>
 * @relayHash 4a7b622560b3b3e20bb696680e8560ab
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d8c35e32d8548b68e2966c6dacdbc893c0768a3dd5dc31d2dfca58cd3e11bc76
const $1115b945d8dda421$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        },
        {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "shouldFetchProjectData"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "projectKey"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "name"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "srcAsyncCreateIssueTypeQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v1 /*: any*/ ,
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "jiraProjectByKey",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "JiraIssueTypeConnection",
                                                "kind": "LinkedField",
                                                "name": "issueTypes",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "ui_createIssueTypeModal_CreateIssueTypeModalWrapper_createIssueTypeFragmentRef"
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "jira.jiraProjectByKey.issueTypes"
                                        },
                                        {
                                            "condition": "shouldFetchProjectData",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "ui_createIssueTypeModal_CreateIssueTypeModalWrapper_projectDataFragmentRef"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.jiraProjectByKey"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "srcAsyncCreateIssueTypeQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueTypeConnection",
                                    "kind": "LinkedField",
                                    "name": "issueTypes",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "totalCount"
                                        },
                                        {
                                            "concreteType": "JiraIssueTypeEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueType",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v2 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraIssueTypeHierarchyLevel",
                                                            "kind": "LinkedField",
                                                            "name": "hierarchy",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "level"
                                                                }
                                                            ]
                                                        },
                                                        v3 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "condition": "shouldFetchProjectData",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "projectType"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "projectId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "projectStyle"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "status"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "uuid"
                                        },
                                        v2 /*: any*/ ,
                                        {
                                            "concreteType": "JiraAvatar",
                                            "kind": "LinkedField",
                                            "name": "avatar",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "medium"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v3 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "d8c35e32d8548b68e2966c6dacdbc893c0768a3dd5dc31d2dfca58cd3e11bc76",
            "metadata": {},
            "name": "srcAsyncCreateIssueTypeQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$1115b945d8dda421$var$node.hash = "b50515a18d5488758aa762560868c40c";
var $1115b945d8dda421$export$2e2bcd8739ae039 = $1115b945d8dda421$var$node;

});

parcelRegister("3zpeP", function(module, exports) {

let $299837c6d07f38d0$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $299837c6d07f38d0$var$load("76n7a"),
    $299837c6d07f38d0$var$load("l253H"),
    $299837c6d07f38d0$var$load("ffQaD"),
    $299837c6d07f38d0$var$load("kvRbA"),
    $299837c6d07f38d0$var$load("kNFvF"),
    $299837c6d07f38d0$var$load("7utVE")
]).then(()=>parcelRequire('djJpq'));

});


const $f1340a435190eeda$export$c766acff4513a976 = 'summaryView';
const $f1340a435190eeda$export$4edb790587638895 = 'listView';
const $f1340a435190eeda$export$cafb161c2b21b455 = 'issueView';
const $f1340a435190eeda$export$66397ed56abea4ca = 'gicView';
const $f1340a435190eeda$export$a1077f863a923e94 = 'gicViewNoResults';
const $f1340a435190eeda$export$7f04bd1df3763938 = 'jswBoard';
const $f1340a435190eeda$export$bd8f63529bb9357f = 'jswBacklog';
const $f1340a435190eeda$export$57eacdfdee901d4c = 'jswTimeline';
const $f1340a435190eeda$export$8f4fd516b77f8d43 = 'unknown';
const $f1340a435190eeda$export$334975a13cb19c35 = 'editIssueTypeButton';
const $f1340a435190eeda$export$e970abb363c8ec67 = 'deleteIssueTypeButton';

parcelRegister("dkvNx", function(module, exports) {

$parcel$export(module.exports, "getIssueTypesSettingsUrl", () => $7576de1b6386c946$export$b9500524016e18f0);
const $7576de1b6386c946$export$b9500524016e18f0 = (projectKey, isSimplified)=>isSimplified ? `/jira/core/projects/${projectKey}/settings/issuetypes` : `/plugins/servlet/project-config/${projectKey}/issuetypes`;

});

parcelRegister("b5FXT", function(module, exports) {

$parcel$export(module.exports, "EditIssueTypeModalTrigger", () => $cfaead60d9735bf4$export$8e0c16e9bec511f3);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $dC5iT = parcelRequire("dC5iT");
var $5ILhZ = parcelRequire("5ILhZ");
var $8CUq3 = parcelRequire("8CUq3");

var $2Sffl = parcelRequire("2Sffl");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $koeKL = parcelRequire("koeKL");

var $2KAtx = parcelRequire("2KAtx");

var $havAj = parcelRequire("havAj");

var $5jhd5 = parcelRequire("5jhd5");

var $4R6GH = parcelRequire("4R6GH");
const $cfaead60d9735bf4$export$8e0c16e9bec511f3 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ onIssueTypeUpdated: onIssueTypeUpdated = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onOpen: onOpen, onClose: onClose, relevantIssueTypeIds: relevantIssueTypeIds, calledFrom: calledFrom, issueTypeId: issueTypeId, projectId: projectId, projectKey: projectKey, ufoExperience: ufoExperience, children: children, isPressable: isPressable = false, onClick: onClick = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), enablePressableStyles: enablePressableStyles = false }, forwardedRef)=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const entryPointParams = (0, $5uXOq.useMemo)(()=>({
            projectKey: projectKey,
            cloudId: cloudId
        }), [
        projectKey,
        cloudId
    ]);
    const onModalClose = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            actionSubject: 'inlineEditIssueTypeModal',
            action: 'closed'
        }));
        onClose();
    }, [
        createAnalyticsEvent,
        onClose
    ]);
    const entryPointProps = (0, $5uXOq.useMemo)(()=>({
            onRefetchIssueTypesWhenIssueTypeUpdated: onIssueTypeUpdated,
            onClose: onModalClose,
            onOpen: onOpen,
            calledFrom: calledFrom,
            ufoExperience: ufoExperience,
            shouldShowIssueTypeSelect: true,
            issueTypeId: issueTypeId,
            projectId: projectId,
            projectKey: projectKey,
            relevantIssueTypeIds: relevantIssueTypeIds
        }), [
        onIssueTypeUpdated,
        onModalClose,
        onOpen,
        calledFrom,
        ufoExperience,
        issueTypeId,
        projectId,
        projectKey,
        relevantIssueTypeIds
    ]);
    const onWrapperClick = (0, $5uXOq.useCallback)((e)=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), 'editIssueTypeButton', {
            source: calledFrom
        });
        // If we triggered the click manually for keyboard users (isPressable = false)
        // this handler becomes the source-of-truth handler for both keyboard users and mouse users
        // However, we need to stopPropagation from here to prevent double modal for mouse users
        // When mouse user clicks the button, if we don't stop propagation here, option change handler
        // will be called which will trigger click manually again and cause double modal rendering
        !isPressable && e.stopPropagation();
        onClick();
    }, [
        calledFrom,
        createAnalyticsEvent,
        isPressable,
        onClick
    ]);
    const Wrapper = isPressable ? (0, $5ILhZ.default) : (0, $dC5iT.default);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2KAtx.ModalEntryPointPressableTrigger), {
        entryPoint: (0, $2Sffl.asyncEditIssueTypeModalEntrypoint),
        entryPointParams: entryPointParams,
        entryPointProps: entryPointProps,
        interactionName: "edit-issue-type-modal",
        useInternalModal: true,
        modalProps: (0, $havAj.defaultModalProps),
        forwardedRef: forwardedRef,
        Fallback: (0, $4R6GH.fg)('jgfeng_new_work_type_fallback_loading_state') ? ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5jhd5.FormDialogSkeleton), {
                numFormFields: 3
            }) : undefined
    }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Wrapper, {
            testId: "edit-issue-type-modal-trigger.wrapper",
            onClick: onWrapperClick,
            // @ts-expect-error - The reference type from ModalEntryPointPressableTrigger is incompatible with Pressable/Box,
            // but this works correctly at runtime and is a type-system limitation
            ref: ref,
            xcss: enablePressableStyles && $cfaead60d9735bf4$var$pressableStyles
        }, children));
});
const $cfaead60d9735bf4$var$pressableStyles = (0, $8CUq3.xcss)({
    paddingTop: 'space.100',
    paddingBottom: 'space.100',
    paddingLeft: 'space.150',
    paddingRight: 'space.150',
    textAlign: 'left',
    font: 'inherit',
    color: 'color.text',
    backgroundColor: 'color.background.neutral.subtle',
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.subtle.pressed'
    }
});

});
parcelRegister("2Sffl", function(module, exports) {

$parcel$export(module.exports, "asyncEditIssueTypeModalEntrypoint", () => $e11cd54209640643$export$77154afa25455a57);

var $1YLRE = parcelRequire("1YLRE");

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $e11cd54209640643$export$77154afa25455a57 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("frCB8")).then((module)=>module.AsyncEditIssueTypeModal), {
        moduleId: "22548b83"
    }),
    getPreloadProps: ({ projectKey: projectKey, cloudId: cloudId })=>({
            queries: {
                editIssueTypeModal: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $1YLRE.default,
                    variables: {
                        projectKey: projectKey,
                        cloudId: cloudId
                    }
                }
            }
        })
});

});
parcelRegister("1YLRE", function(module, exports) {

$parcel$export(module.exports, "default", () => $7227964287505d9d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e1192085c48690de29428a79c9d6d1b6>>
 * @relayHash e7bd81102c1dee96dbca11245e366952
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4b119f6603ebb196c870e258ef65c6302b9c0f15a6c9732a0f8d24d5c27ad696
const $7227964287505d9d$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "projectKey"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "issueTypeId"
    }, v3 = {
        "kind": "ScalarField",
        "name": "name"
    }, v4 = {
        "kind": "ScalarField",
        "name": "description"
    }, v5 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "medium"
            }
        ]
    }, v6 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "srcAsyncEditIssueTypeQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v1 /*: any*/ ,
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "jiraProjectByKey",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "JiraIssueTypeConnection",
                                                "kind": "LinkedField",
                                                "name": "issueTypes",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "JiraIssueTypeEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": {
                                                                        "concreteType": "JiraIssueType",
                                                                        "kind": "LinkedField",
                                                                        "name": "node",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v2 /*: any*/ ,
                                                                                "action": "THROW",
                                                                                "path": "jira.jiraProjectByKey.issueTypes.edges.node.issueTypeId"
                                                                            },
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v3 /*: any*/ ,
                                                                                "action": "THROW",
                                                                                "path": "jira.jiraProjectByKey.issueTypes.edges.node.name"
                                                                            },
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v4 /*: any*/ ,
                                                                                "action": "THROW",
                                                                                "path": "jira.jiraProjectByKey.issueTypes.edges.node.description"
                                                                            },
                                                                            v5 /*: any*/ 
                                                                        ]
                                                                    },
                                                                    "action": "THROW",
                                                                    "path": "jira.jiraProjectByKey.issueTypes.edges.node"
                                                                }
                                                            ]
                                                        },
                                                        "action": "THROW",
                                                        "path": "jira.jiraProjectByKey.issueTypes.edges"
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "jira.jiraProjectByKey.issueTypes"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.jiraProjectByKey"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "srcAsyncEditIssueTypeQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueTypeConnection",
                                    "kind": "LinkedField",
                                    "name": "issueTypes",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueTypeEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueType",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v2 /*: any*/ ,
                                                        v3 /*: any*/ ,
                                                        v4 /*: any*/ ,
                                                        v5 /*: any*/ ,
                                                        v6 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v6 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "4b119f6603ebb196c870e258ef65c6302b9c0f15a6c9732a0f8d24d5c27ad696",
            "metadata": {},
            "name": "srcAsyncEditIssueTypeQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$7227964287505d9d$var$node.hash = "95da41f0960685e3830143828659ecad";
var $7227964287505d9d$export$2e2bcd8739ae039 = $7227964287505d9d$var$node;

});

parcelRegister("frCB8", function(module, exports) {

let $b3e751616535a1e0$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $b3e751616535a1e0$var$load("ffQaD"),
    $b3e751616535a1e0$var$load("kvRbA"),
    $b3e751616535a1e0$var$load("bNYX8")
]).then(()=>parcelRequire('jKeZU'));

});


parcelRegister("havAj", function(module, exports) {

$parcel$export(module.exports, "defaultModalProps", () => $15c81a62c11e20dc$export$14c11acc66fd51b3);
const $15c81a62c11e20dc$export$14c11acc66fd51b3 = {
    width: 'small'
};

});

parcelRegister("5jhd5", function(module, exports) {

$parcel$export(module.exports, "FormDialogSkeleton", () => $cbf418453919c3e8$export$3e5b4585c21ca29d);

var $5uXOq = parcelRequire("5uXOq");

var $kgoHi = parcelRequire("kgoHi");
var $luBm6 = parcelRequire("luBm6");
var $8CUq3 = parcelRequire("8CUq3");

var $1DVhQ = parcelRequire("1DVhQ");
const $cbf418453919c3e8$var$COMMON_SKELETON_PROPS = {
    borderRadius: 8,
    isShimmering: true
};
const $cbf418453919c3e8$export$3e5b4585c21ca29d = ({ numFormFields: numFormFields })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        direction: "column",
        xcss: $cbf418453919c3e8$var$modalSkeletonStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        direction: "column",
        xcss: $cbf418453919c3e8$var$headerSkeletonStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.250"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1DVhQ.default), {
        width: "40%",
        height: 24,
        ...$cbf418453919c3e8$var$COMMON_SKELETON_PROPS,
        testId: "form-dialog-skeleton.ui.header-title"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1DVhQ.default), {
        width: "35%",
        height: 16,
        ...$cbf418453919c3e8$var$COMMON_SKELETON_PROPS,
        testId: "form-dialog-skeleton.ui.header-subtitle"
    }))), Array.from({
        length: numFormFields
    }).map((_, idx)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
            space: "space.050",
            key: idx,
            xcss: $cbf418453919c3e8$var$formFieldSkeletonStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1DVhQ.default), {
            width: "30%",
            height: 16,
            ...$cbf418453919c3e8$var$COMMON_SKELETON_PROPS,
            testId: `form-field-label-${idx}`
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1DVhQ.default), {
            width: "100%",
            height: 40,
            ...$cbf418453919c3e8$var$COMMON_SKELETON_PROPS,
            testId: `form-field-input-${idx}`
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        justifyContent: "end",
        gap: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1DVhQ.default), {
        width: 72,
        height: 32,
        ...$cbf418453919c3e8$var$COMMON_SKELETON_PROPS,
        testId: "form-dialog-skeleton.ui.cancel-button"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1DVhQ.default), {
        width: 72,
        height: 32,
        ...$cbf418453919c3e8$var$COMMON_SKELETON_PROPS,
        testId: "form-dialog-skeleton.ui.submit-button"
    }))));
const $cbf418453919c3e8$var$modalSkeletonStyles = (0, $8CUq3.xcss)({
    backgroundColor: 'elevation.surface.overlay',
    borderRadius: '12px',
    width: '394px',
    padding: 'space.300'
});
const $cbf418453919c3e8$var$headerSkeletonStyles = (0, $8CUq3.xcss)({
    marginBottom: 'space.100'
});
const $cbf418453919c3e8$var$formFieldSkeletonStyles = (0, $8CUq3.xcss)({
    marginTop: 'space.100',
    marginBottom: 'space.100'
});

});



const $838746bcc70be259$export$34934e4a629b9612 = 500;
const $838746bcc70be259$export$94554a43bdc62f9f = 'focus-text-area-to-issue-create-duration';
const $838746bcc70be259$export$3c53e2610a4054e2 = `${$838746bcc70be259$export$94554a43bdc62f9f}:start`;
const $838746bcc70be259$export$e1682a3dbec77762 = `${$838746bcc70be259$export$94554a43bdc62f9f}:end`;


parcelRegister("9hZ86", function(module, exports) {

$parcel$export(module.exports, "default", () => $9cc9514c3a53b827$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $99M5v = parcelRequire("99M5v");

var $koVbs = parcelRequire("koVbs");

var $ltFrh = parcelRequire("ltFrh");
const $9cc9514c3a53b827$var$InlineCreateTrigger = ({ onClick: onClick, minHeight: minHeight, borderRadius: borderRadius, horizontalPadding: horizontalPadding })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9cc9514c3a53b827$var$Trigger, {
        borderRadius: borderRadius,
        "data-testid": "business-issue-create.ui.inline-create-trigger",
        horizontalPadding: horizontalPadding,
        minHeight: minHeight,
        onClick: onClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($99M5v))), {
        label: "",
        LEGACY_size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9cc9514c3a53b827$var$Label, null, formatMessage((0, $ltFrh.default).createLabel)));
};
var $9cc9514c3a53b827$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = /*#__PURE__*/ (0, $5uXOq.memo)($9cc9514c3a53b827$var$InlineCreateTrigger);
const $9cc9514c3a53b827$var$Trigger = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { borderRadius: borderRadius, minHeight: minHeight, horizontalPadding: horizontalPadding, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_ri98hz": (0, $lD23V.default)(__cmplp.borderRadius ?? 0),
            "--_19b8a3e": (0, $lD23V.default)(__cmplp.minHeight ?? '32px'),
            "--_1w524p6": (0, $lD23V.default)(`0 ${__cmplp.horizontalPadding ?? "var(--ds-space-100, 8px)"}`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_bfhk18uv _19itglyw _11c82smr _2rko16jm _1yt414jf _zulpu2gc _1e0c1txw _4cvr1h6o _syaz1gjq _k48p1wq8 _1tke1um9 _1bsb1osq _1jhm1q09 _y2mv1q09 _1ygb1q09 _13ro1n1a _1bg41n1a _1ah31n1a _irr3166n _1di61dty",
            __cmplp.className
        ])
    });
});
const $9cc9514c3a53b827$var$Label = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "",
            __cmplp.className
        ])
    });
});

});
parcelRegister("ltFrh", function(module, exports) {

$parcel$export(module.exports, "default", () => $92994995ec79c48c$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $92994995ec79c48c$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    createLabel: {
        "id": "business-issue-create.inline-create-trigger.create-label",
        "defaultMessage": "Create"
    }
});

});



parcelRegister("9ocZh", function(module, exports) {

$parcel$export(module.exports, "default", () => $059df7c6be63503d$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $5uXOq = parcelRequire("5uXOq");

var $faod6 = parcelRequire("faod6");

var $3bDjY = parcelRequire("3bDjY");
const $059df7c6be63503d$var$BUTTON_SIZE = 24;
const $059df7c6be63503d$var$DIVIDER_SIZE = 2;
const $059df7c6be63503d$var$ROW = 'row';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $059df7c6be63503d$var$COLUMN = 'column';
const $059df7c6be63503d$var$InlineCreateTrigger = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ direction: direction, label: label, 'aria-label': ariaLabel, onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onMouseDown: onMouseDown, onMouseUp: onMouseUp, forceVisibility: forceVisibility = false, parentSize: parentSize = '100%', position: position = 0, offset: offset = 0, ...triggerProps }, ref)=>{
    const [isButtonHovered, setIsButtonHovered] = (0, $5uXOq.useState)(false);
    const handleMouseEnterButton = (0, $5uXOq.useCallback)((event)=>{
        onMouseEnter && onMouseEnter(event);
        setIsButtonHovered(true);
    }, [
        onMouseEnter
    ]);
    const handleMouseLeaveButton = (0, $5uXOq.useCallback)((event)=>{
        onMouseLeave && onMouseLeave(event);
        setIsButtonHovered(false);
    }, [
        onMouseLeave
    ]);
    const Container = (0, $5uXOq.useMemo)(()=>direction === $059df7c6be63503d$var$ROW ? $059df7c6be63503d$var$RowContainer : $059df7c6be63503d$var$ColumnContainer, [
        direction
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Container, {
        isButtonHovered: isButtonHovered,
        forceVisibility: forceVisibility,
        parentSize: typeof parentSize === 'number' ? `${parentSize}px` : parentSize,
        position: position,
        offset: offset
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: label,
        isScreenReaderAnnouncementDisabled: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($059df7c6be63503d$var$TriggerButton, {
        "data-testid": "business-inline-create-trigger.ui.trigger-button",
        onClick: onClick,
        onMouseDown: onMouseDown,
        onMouseEnter: handleMouseEnterButton,
        onMouseLeave: handleMouseLeaveButton,
        onMouseUp: onMouseUp,
        ref: ref,
        "aria-label": ariaLabel,
        ...triggerProps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($faod6))), {
        label: label,
        LEGACY_size: "medium",
        spacing: "spacious"
    }))));
});
var $059df7c6be63503d$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($059df7c6be63503d$var$InlineCreateTrigger);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $059df7c6be63503d$var$RowContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { forceVisibility: forceVisibility, isButtonHovered: isButtonHovered, parentSize: parentSize, position: position, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_az6wk1": (0, $lD23V.default)(__cmplp.parentSize),
            "--_1htntus": (0, $lD23V.default)(__cmplp.offset, "px"),
            "--_1gjsdub": (0, $lD23V.default)(`${__cmplp.position - $059df7c6be63503d$var$BUTTON_SIZE * 0.5}px`),
            "--_s3bx6z": (0, $lD23V.default)(`-${__cmplp.offset}px`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_v5641w7c _1pby1kze _1e0c1txw _4cvr1h6o _4t3i1tcg _kqswstnw _154i1wab _1ltvd2z4 _qc5o11zv _z0ai1osq _aetrb3bt _1hfk1p6i _1qdgyh40 _dkthkb7n _1h7hkb7n _1mygkb7n _16l4kb7n",
            __cmplp.forceVisibility ? "_tzy4kb7n" : "_tzy4idpf",
            __cmplp.isButtonHovered || !__cmplp.forceVisibility ? "_1bsbzgxw" : "_1bsb1tcg",
            __cmplp.isButtonHovered ? "_1peqkb7n" : "_1peqidpf",
            __cmplp.className
        ])
    });
});
const $059df7c6be63503d$var$ColumnContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { forceVisibility: forceVisibility, isButtonHovered: isButtonHovered, parentSize: parentSize, position: position, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_az6wk1": (0, $lD23V.default)(__cmplp.parentSize),
            "--_1htntus": (0, $lD23V.default)(__cmplp.offset, "px"),
            "--_s3bx6z": (0, $lD23V.default)(`-${__cmplp.offset}px`),
            "--_1gjsdub": (0, $lD23V.default)(`${__cmplp.position - $059df7c6be63503d$var$BUTTON_SIZE * 0.5}px`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_v5641w7c _1pby1kze _1e0c1txw _2lx21bp4 _4cvr1h6o _1bsb1tcg _kqswstnw _154id2z4 _1ltv1wab _qc5o11zv _z0aiyh40 _aetrb3bt _1hfk1p6i _1qdg1osq _dkthkb7n _1h7hkb7n _1mygkb7n _16l4kb7n",
            __cmplp.forceVisibility ? "_tzy4kb7n" : "_tzy4idpf",
            __cmplp.isButtonHovered || !__cmplp.forceVisibility ? "_4t3izgxw" : "_4t3i1tcg",
            __cmplp.isButtonHovered ? "_1peqkb7n" : "_1peqidpf",
            __cmplp.className
        ])
    });
});
const $059df7c6be63503d$var$TriggerButton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1sit _189et94y _1dqonqa1 _1h6dmuej _1e0c1txw _1bah1h6o _4cvr1h6o _4t3i1tcg _1bsb1tcg _kqswh2mm _16qs1cd0 _bfhk1bhr _80omtlke _1wjnyh40 _1wysyh40 _3qypnqa1 _10knnqa1 _q4zt1p6i _pojj1p6i _nt751r31 _1dit1r31 _49pcglyw _ksodglyw _1hvw1o36 _4hz81o36 _jomr16qz _irr316qz",
            __cmplp.className
        ])
    });
});

});

parcelRegister("li7DW", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a5a4af5788d5b1f$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $2a5a4af5788d5b1f$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    createSiblingIssueOld: {
        "id": "work-management-board.board.column.card.inline-sibling-create.create-sibling-issue-old",
        "defaultMessage": "Create"
    },
    createSiblingIssue: {
        "id": "work-management-board.board.column.card.inline-sibling-create.create-sibling-issue",
        "defaultMessage": "Create work item"
    },
    createSiblingIssueAtTheTopOfColumnA11Y: {
        "id": "work-management-board.board.column.card.inline-sibling-create.create-sibling-issue-at-the-top-of-column-a11y",
        "defaultMessage": "Create work item at the top of the column"
    },
    createSiblingIssueA11Y: {
        "id": "work-management-board.board.column.card.inline-sibling-create.create-sibling-issue-a11y",
        "defaultMessage": "Create work item after work item {issueKey}"
    }
});

});


parcelRegister("ldIU4", function(module, exports) {

$parcel$export(module.exports, "CardSummary", () => $99b1ac9068ed8a13$export$f2e6e773bb9ca12a);
/* CardSummary.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $k2wwp = parcelRequire("k2wwp");
const $99b1ac9068ed8a13$export$f2e6e773bb9ca12a = ({ highlight: highlight, text: text })=>{
    return /*#__PURE__*/ $5uXOq.createElement("span", {
        className: (0, $bwpsq.default)([
            $99b1ac9068ed8a13$var$styles.root
        ])
    }, /*#__PURE__*/ $5uXOq.createElement((0, $k2wwp.default), {
        highlight: highlight ?? null,
        text: text
    }));
};
const $99b1ac9068ed8a13$var$styles = {
    root: "_1i4q1hna _1nmz1hna _slp31hna"
};

});
parcelRegister("k2wwp", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e37bd657627b5db$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $1H6kL = parcelRequire("1H6kL");

var $cM7El = parcelRequire("cM7El");
const $5e37bd657627b5db$var$HighlightTextWithParser = /*#__PURE__*/ (0, $5uXOq.memo)(({ text: text, highlight: highlight })=>{
    const parts = (0, $1H6kL.getParts)(highlight, text);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cM7El.default), {
        parts: parts
    });
});
var $5e37bd657627b5db$export$2e2bcd8739ae039 = $5e37bd657627b5db$var$HighlightTextWithParser;

});
parcelRegister("1H6kL", function(module, exports) {

$parcel$export(module.exports, "removeAccents", () => $0b92ef830f5aa8e4$export$f3f2882e8b11d731);
$parcel$export(module.exports, "getParts", () => $0b92ef830f5aa8e4$export$a3aee8a24a54661f);

var $8QDwl = parcelRequire("8QDwl");

var $ajpes = parcelRequire("ajpes");

var $3JOCw = parcelRequire("3JOCw");

var $8QpSo = parcelRequire("8QpSo");
const $0b92ef830f5aa8e4$export$f3f2882e8b11d731 = (0, $8QpSo.default)((text)=>text.normalize('NFD').replace(/[\u0300-\u036f]/g, ''));
const $0b92ef830f5aa8e4$export$1633667427d99697 = (0, $8QpSo.default)((highlight)=>{
    const escapedFilter = highlight.map((phrase)=>(0, (/*@__PURE__*/$parcel$interopDefault($8QDwl)))(phrase)).join('|');
    return new RegExp(escapedFilter, 'gmi');
}, (newArgs, lastArgs)=>{
    if (newArgs.length !== lastArgs.length) return false;
    const equalityFn = (0, (/*@__PURE__*/$parcel$interopDefault($ajpes)));
    return newArgs.every((newArg, index)=>equalityFn(newArg, lastArgs[index]));
});
const $0b92ef830f5aa8e4$export$2235873b95f89ea = (content)=>({
        type: 'text',
        content: content
    });
const $0b92ef830f5aa8e4$export$39ae7d355c29b45f = (content)=>({
        type: 'highlight',
        content: content
    });
const $0b92ef830f5aa8e4$export$c05c39859172f90c = (str, regExp)=>{
    const ms = [];
    let m = regExp.exec(str);
    while(m){
        ms.push(m);
        m = regExp.exec(str);
    }
    return ms;
};
const $0b92ef830f5aa8e4$export$a3aee8a24a54661f = (highlight, text)=>{
    if (highlight == null || highlight.filter((phrase)=>phrase !== '').length === 0) return [
        $0b92ef830f5aa8e4$export$2235873b95f89ea(text)
    ];
    const parts = [];
    // Long text lengths will cause "Invalid regular expression" error
    const truncatedHighlight = highlight.map((phrase)=>phrase.substring(0, 255));
    const highlightRegExp = $0b92ef830f5aa8e4$export$1633667427d99697(truncatedHighlight.filter((phrase)=>phrase !== ''));
    const textWithoutAccents = $0b92ef830f5aa8e4$export$f3f2882e8b11d731(text);
    const textMatches = $0b92ef830f5aa8e4$export$c05c39859172f90c(text, highlightRegExp);
    const textWithoutAccentsMatches = $0b92ef830f5aa8e4$export$c05c39859172f90c(textWithoutAccents, highlightRegExp);
    const highlightMatches = (0, (/*@__PURE__*/$parcel$interopDefault($3JOCw)))([
        ...textWithoutAccentsMatches,
        ...textMatches
    ], 'index');
    let currentPosition = 0;
    highlightMatches.forEach((match)=>{
        const matchText = text.slice(match.index, match.index + match[0].length);
        const leading = text.slice(currentPosition, match.index);
        if (leading !== '') parts.push($0b92ef830f5aa8e4$export$2235873b95f89ea(leading));
        parts.push($0b92ef830f5aa8e4$export$39ae7d355c29b45f(matchText));
        currentPosition = match.index + matchText.length;
    });
    const trailing = text.slice(currentPosition);
    if (trailing !== '') parts.push($0b92ef830f5aa8e4$export$2235873b95f89ea(trailing));
    return parts;
};

});

parcelRegister("cM7El", function(module, exports) {

$parcel$export(module.exports, "default", () => $328475be93221885$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $328475be93221885$var$Mark = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "mark", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_bfhki1yw _syaz1fxt",
            __cmplp.className
        ])
    });
});
const $328475be93221885$var$HighlightText = ({ parts: parts })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, parts.map((part, i)=>{
        if (part.type === 'text') return part.content;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($328475be93221885$var$Mark, {
            key: i
        }, part.content);
    }));
var $328475be93221885$export$2e2bcd8739ae039 = $328475be93221885$var$HighlightText;

});



parcelRegister("dmCTb", function(module, exports) {

$parcel$export(module.exports, "InteractionLayer", () => $74e1e635e91c9c90$export$4b508ff96d264be7);

var $5uXOq = parcelRequire("5uXOq");

var $8CUq3 = parcelRequire("8CUq3");

var $jhmo0 = parcelRequire("jhmo0");

var $koVbs = parcelRequire("koVbs");

var $lyKBY = parcelRequire("lyKBY");
const $74e1e635e91c9c90$export$4b508ff96d264be7 = ({ issue: issue, onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jhmo0.default), {
        "aria-label": formatMessage((0, $lyKBY.default).interactionLayerLabel, {
            issueKey: issue.fields.issuekey.value,
            issueSummary: issue.fields.summary.value
        }),
        draggable: false,
        href: `/browse/${issue.fields.issuekey.value}`,
        onClick: (event)=>{
            event.preventDefault();
            onClick(event);
        },
        xcss: $74e1e635e91c9c90$var$interactionLayerStyles
    });
};
const $74e1e635e91c9c90$var$interactionLayerStyles = (0, $8CUq3.xcss)({
    pointerEvents: 'auto',
    position: 'absolute',
    inset: '0',
    borderRadius: 'border.radius',
    ':focus': {
        // @ts-expect-error no available token for -1px but it's the desired value
        outlineOffset: '-1px'
    },
    ':focus-visible': {
        // @ts-expect-error no available token for -1px but it's the desired value
        outlineOffset: '-1px'
    },
    ':focus-within': {
        // @ts-expect-error no available token for -1px but it's the desired value
        outlineOffset: '-1px'
    }
});

});
parcelRegister("lyKBY", function(module, exports) {

$parcel$export(module.exports, "default", () => $87f87e48d6134047$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $87f87e48d6134047$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    interactionLayerLabel: {
        "id": "work-management-board.board.column.card.interaction-layer.interaction-layer-label",
        "defaultMessage": "{issueKey} {issueSummary}. Use the enter key to load the work item."
    }
});

});


parcelRegister("gt8ro", function(module, exports) {

$parcel$export(module.exports, "CardContent", () => $c09d6eff03b9810c$export$64ef9b8c11710c47);

var $5H8hl = parcelRequire("5H8hl");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $bmZvc = parcelRequire("bmZvc");

var $hE5wF = parcelRequire("hE5wF");

var $2EwJD = parcelRequire("2EwJD");

var $gULOk = parcelRequire("gULOk");

var $dCm1o = parcelRequire("dCm1o");

var $cvj5l = parcelRequire("cvj5l");

var $3uhPk = parcelRequire("3uhPk");

var $d2nmk = parcelRequire("d2nmk");

var $js19Q = parcelRequire("js19Q");

var $hyu2M = parcelRequire("hyu2M");

var $7b2Jf = parcelRequire("7b2Jf");

var $91Gw4 = parcelRequire("91Gw4");

var $5F5ed = parcelRequire("5F5ed");

var $8aGLP = parcelRequire("8aGLP");
const $c09d6eff03b9810c$export$64ef9b8c11710c47 = /*#__PURE__*/ (0, $5uXOq.memo)(({ highlight: highlight, issue: issue, viewFragment: viewFragment })=>{
    const view = (0, $8Uumt.useFragment)((0, $5H8hl.default), viewFragment);
    const cardOptions = view.cardOptions;
    const groupBy = view.groupByConfig.fieldId;
    const labels = issue.fields[0, $cvj5l.LABEL_ID]?.value ?? undefined;
    const isDone = issue.fields[0, $cvj5l.STATUS_ID].status.statusCategoryId === (0, $gULOk.StatusCategoryIds).done;
    const isStandardIssue = issue.fields[0, $cvj5l.ISSUE_TYPE_ID].issueType.hierarchyLevel === 0;
    const selectedFields = new Set(cardOptions.edges.map((edge)=>edge?.node?.field && edge.node.field.fieldId));
    const renderedLabels = labels && selectedFields.has('labels') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3uhPk.CardLabels), {
        labels: labels
    }) : null;
    const dueDate = issue.fields[0, $cvj5l.DUE_DATE_ID];
    const renderedDueDate = dueDate != null && selectedFields.has('duedate') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d2nmk.CardDueDate), {
        dueDate: dueDate.value,
        isDone: isDone
    }) : null;
    const renderedIssueType = selectedFields.has('issuetype') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5F5ed.CardIssueType), {
        issueType: issue.fields[0, $cvj5l.ISSUE_TYPE_ID]
    }) : null;
    const priority = issue.fields[0, $cvj5l.PRIORITY_ID];
    const renderedPriority = priority && selectedFields.has('priority') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hyu2M.CardPriority), {
        uri: priority.priority.iconUrl,
        name: priority.priority.name
    }) : null;
    const assignee = issue.fields[0, $cvj5l.ASSIGNEE_ID];
    const renderedAssignee = assignee?.user && selectedFields.has('assignee') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_kqswh2mm _lcxv1wug"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bmZvc.AvatarLite), {
        highlight: highlight,
        avatarUrl: assignee.user.avatarURL ?? undefined,
        name: assignee.user.name
    })) : null;
    const renderedKey = selectedFields.has('issuekey') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $js19Q.CardKey), {
        highlight: highlight,
        text: issue.fields[0, $cvj5l.ISSUE_KEY_ID].value
    });
    const { status: status } = issue.fields[0, $cvj5l.STATUS_ID];
    const renderedStatus = groupBy !== (0, $hE5wF.GROUP_BY_STATUS) && status.statusCategoryId && status.name ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2EwJD.default), {
        name: status.name,
        category: (0, $gULOk.statusCategoryForId)(status.statusCategoryId)
    })) : null;
    const showMultiFieldRow = renderedIssueType || renderedKey || isDone || renderedPriority || renderedAssignee;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _zulpu2gc _1e0c1txw _2lx21bp4 _ca0qidpf _u5f3utpp _n3tdutpp _19bvutpp _fiawglyw",
            (0, $dCm1o.isVisualRefreshEnabled)() && "_n3tdu2gc"
        ])
    }, renderedStatus, renderedLabels, renderedDueDate, showMultiFieldRow && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_zulp1b66 _1e0c1txw _4cvr1h6o _1tkegktf"
        ])
    }, renderedIssueType, renderedKey, isDone && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7b2Jf.CardTick), null), renderedPriority, renderedAssignee), selectedFields.has('subtasks') && isStandardIssue && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8aGLP.default), {
        issue: issue
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $91Gw4.CardDetailFields), {
        issue: issue,
        cardOptionsFragment: cardOptions
    }));
});
const $c09d6eff03b9810c$var$contentWrapperStyles = null;
const $c09d6eff03b9810c$var$contentWrapperRefreshStyles = null;
const $c09d6eff03b9810c$var$multiFieldRowStyles = null;
const $c09d6eff03b9810c$var$singleFieldRowStyles = null; // These styles allow elements to receive pointer events even with the use of the
// InteractionLayer component in the board card component. The InteractionLayer
// component is used to create a clickable area for the card, but we want to
// ensure that certain elements within the card can still receive pointer events.
const $c09d6eff03b9810c$var$pointerEventsStyles = null;

});
parcelRegister("5H8hl", function(module, exports) {

$parcel$export(module.exports, "default", () => $a814cf66f668b47d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<492c2e132e07baa4324f74c355dcf368>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a814cf66f668b47d$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "fieldId"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "CardContent_view",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "enabledOnly",
                            "value": true
                        },
                        {
                            "kind": "Literal",
                            "name": "first",
                            "value": 100
                        }
                    ],
                    "concreteType": "JiraBoardViewCardOptionConnection",
                    "kind": "LinkedField",
                    "name": "cardOptions",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "CardDetailFields_cardOptions"
                        },
                        {
                            "kind": "RequiredField",
                            "field": {
                                "concreteType": "JiraBoardViewCardOptionEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": {
                                                                "concreteType": "JiraField",
                                                                "kind": "LinkedField",
                                                                "name": "field",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": v0 /*: any*/ ,
                                                                        "action": "THROW",
                                                                        "path": "cardOptions.edges.node.field.fieldId"
                                                                    }
                                                                ]
                                                            },
                                                            "action": "THROW",
                                                            "path": "cardOptions.edges.node.field"
                                                        }
                                                    ],
                                                    "type": "JiraBoardViewFieldCardOption"
                                                }
                                            ]
                                        },
                                        "action": "THROW",
                                        "path": "cardOptions.edges.node"
                                    }
                                ]
                            },
                            "action": "THROW",
                            "path": "cardOptions.edges"
                        }
                    ],
                    "storageKey": "cardOptions(enabledOnly:true,first:100)"
                },
                "action": "THROW",
                "path": "cardOptions"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraViewGroupByConfig",
                    "kind": "LinkedField",
                    "name": "groupByConfig",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": v0 /*: any*/ ,
                            "action": "THROW",
                            "path": "groupByConfig.fieldId"
                        }
                    ]
                },
                "action": "THROW",
                "path": "groupByConfig"
            }
        ],
        "type": "JiraBoardView"
    };
}();
$a814cf66f668b47d$var$node.hash = "4a3addf11b91d7bb3275b451170961fb";
var $a814cf66f668b47d$export$2e2bcd8739ae039 = $a814cf66f668b47d$var$node;

});

parcelRegister("bmZvc", function(module, exports) {

$parcel$export(module.exports, "AvatarLite", () => $0b2cc805665652bb$export$8b9560cc4e12c651);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");
const $0b2cc805665652bb$var$AVATAR_SIZE = 24;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0b2cc805665652bb$var$Avatar = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { avatarUrl: avatarUrl, isHighlighted: isHighlighted, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1fzlxay": (0, $lD23V.default)(`url(${__cmplp.avatarUrl})`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1ssb _12ji1r31 _1qu2glyw _12y3idpf _1itk1v7f _ouxl1ssb _12vemgnk _1lrw1dfr _bfhk18uv _vchh18uv _4t3i1tcg _1bsb1tcg _1ul91tcg _1tke1tcg _1e0c1o8l _kqswh2mm _80om1kw7 _19pkv77o _2hwxv77o _otyrv77o _18u0v77o",
            __cmplp.isHighlighted ? "_16qsa9gh" : "_16qsglyw",
            __cmplp.className
        ])
    });
});
const $0b2cc805665652bb$var$hasKeywords = (name)=>(keyword)=>name && keyword && name.toLowerCase().includes(keyword.toLowerCase());
const $0b2cc805665652bb$export$8b9560cc4e12c651 = /*#__PURE__*/ (0, $5uXOq.memo)(({ avatarUrl: avatarUrl, name: name = '', highlight: highlight, testId: testId })=>{
    const isHighlighted = highlight && highlight.some($0b2cc805665652bb$var$hasKeywords(name));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0b2cc805665652bb$var$Avatar, {
        // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'string'.
        avatarUrl: avatarUrl,
        title: name,
        // @ts-expect-error - TS2322 - Type 'boolean | undefined' is not assignable to type 'boolean'.
        isHighlighted: isHighlighted,
        "data-testid": testId
    });
});

});

parcelRegister("2EwJD", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd41c6095391bfc6$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $3u0c5 = parcelRequire("3u0c5");

var $gULOk = parcelRequire("gULOk");
const $cd41c6095391bfc6$var$statusCategoryToAppearenceMap = {
    [(0, $gULOk.UNDEFINED)]: 'default',
    [(0, $gULOk.TODO)]: 'default',
    [(0, $gULOk.DONE)]: 'success',
    [(0, $gULOk.IN_PROGRESS)]: 'inprogress'
};
class $cd41c6095391bfc6$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isActive: false
        };
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3u0c5.default), {
            testId: "common-components-status-lozenge.status-lozenge",
            isBold: this.props.isActive,
            appearance: $cd41c6095391bfc6$var$statusCategoryToAppearenceMap[this.props.category],
            maxWidth: this.props.isFullWidth ? '100%' : undefined
        }, this.props.name);
    }
}

});

parcelRegister("3uhPk", function(module, exports) {

$parcel$export(module.exports, "CardLabels", () => $0fcdb686fc0cd153$export$ece436c5ee6469bd);
/* CardLabels.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $d9xxV = parcelRequire("d9xxV");
const $0fcdb686fc0cd153$export$ece436c5ee6469bd = ({ labels: labels })=>{
    return /*#__PURE__*/ $5uXOq.createElement("div", {
        className: (0, $bwpsq.default)([
            $0fcdb686fc0cd153$var$styles.root
        ])
    }, labels.map((label)=>/*#__PURE__*/ $5uXOq.createElement((0, $d9xxV.default), {
            key: label,
            text: label
        })));
};
var $0fcdb686fc0cd153$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($0fcdb686fc0cd153$export$ece436c5ee6469bd);
const $0fcdb686fc0cd153$var$styles = {
    root: "_2lx2vrvc _1n261g80 _1e0c1txw _4cvr1h6o _19pkr5cr _2hwxr5cr _otyrr5cr _18u0r5cr _1bsb1osq"
};

});
parcelRegister("d9xxV", function(module, exports) {

$parcel$export(module.exports, "default", () => $87927dab24395a15$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $5oSQr = parcelRequire("5oSQr");

var $aXLIT = parcelRequire("aXLIT");

var $eYXIO = parcelRequire("eYXIO");
const $87927dab24395a15$var$SimpleTagComponent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ appearance: appearance, elemBefore: elemBefore = null, color: color = 'standard', href: href, testId: testId, text: text = '', linkComponent: linkComponent }, ref)=>{
    const content = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eYXIO.default), {
        elemBefore: elemBefore,
        isRemovable: false,
        text: text,
        color: color,
        href: href,
        linkComponent: linkComponent
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5oSQr.default), {
        ref: ref,
        testId: testId,
        href: href,
        appearance: appearance,
        color: color,
        before: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $aXLIT.default), {
            elemBefore: elemBefore
        }),
        contentElement: content
    });
});
/**
 * __Simple tag__
 *
 * A tag labels UI objects for quick recognition and navigation.
 *
 * `SimpleTag` is the default form of a tag, where text is required. Tags with static text can be used as a flag or as a reference to an object or attribute.
 *
 * - [Examples](https://atlassian.design/components/tag/examples)
 * - [Code](https://atlassian.design/components/tag/code)
 * - [Usage](https://atlassian.design/components/tag/usage)
 */ const $87927dab24395a15$var$SimpleTag = /*#__PURE__*/ (0, $5uXOq.memo)($87927dab24395a15$var$SimpleTagComponent);
var $87927dab24395a15$export$2e2bcd8739ae039 = $87927dab24395a15$var$SimpleTag;

});
parcelRegister("5oSQr", function(module, exports) {

$parcel$export(module.exports, "default", () => $db35d9df42c66ff0$export$2e2bcd8739ae039);
/* base.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $2hnSR = parcelRequire("2hnSR");
const $db35d9df42c66ff0$var$borderColorCssVar = '--ds-bc';
const $db35d9df42c66ff0$var$focusRingCssVar = '--ds-cfr';
const $db35d9df42c66ff0$var$textLinkCssVar = '--ds-ctl';
const $db35d9df42c66ff0$var$textDefaultCssVar = '--ds-ct';
const $db35d9df42c66ff0$var$textHoverCssVar = '--ds-cth';
const $db35d9df42c66ff0$var$textActiveCssVar = '--ds-ctp';
const $db35d9df42c66ff0$var$backgroundDefaultCssVar = '--ds-cb';
const $db35d9df42c66ff0$var$backgroundHoverCssVar = '--ds-cbh';
const $db35d9df42c66ff0$var$backgroundActiveCssVar = '--ds-cba';
const $db35d9df42c66ff0$var$removeButtonDefaultCssVar = '--ds-rb';
const $db35d9df42c66ff0$var$removeButtonHoverCssVar = '--ds-rbh';
const $db35d9df42c66ff0$var$borderRadiusCssVar = '--ds-br';
// To be removed with platform-component-visual-refresh (BLU-2992)
const $db35d9df42c66ff0$var$baseStylesOld = null;
const $db35d9df42c66ff0$var$baseStyles = null;
// To be removed with platform-component-visual-refresh (BLU-2992)
const $db35d9df42c66ff0$var$interactiveStylesOld = null;
const $db35d9df42c66ff0$var$interactiveStyles = null;
// To be removed with platform-component-visual-refresh (BLU-2992)
const $db35d9df42c66ff0$var$focusRingStylesOld = null;
const $db35d9df42c66ff0$var$focusRingStyles = null;
// To be removed with platform-component-visual-refresh (BLU-2992)
const $db35d9df42c66ff0$var$nonStandardLinkStyles = null;
const $db35d9df42c66ff0$var$BaseTag = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef(function BaseTag({ before: before, contentElement: contentElement, after: after, testId: testId, appearance: appearance = 'default', style: style, color: color = 'standard', href: href, className: className, ...other }, ref) {
    const isLink = Boolean(href);
    const isRemovable = Boolean(after);
    const isInteractive = isLink || isRemovable;
    const isStandardLink = isLink && color === 'standard';
    // Change link text color if  the tag is standard color
    const textLinkColors = isStandardLink ? (0, $2hnSR.textColors)['standardLink'] : (0, $2hnSR.textColors)[color];
    const backgroundHoverColors = isRemovable && !isLink ? (0, $2hnSR.backgroundColors)[color] : (0, $2hnSR.linkHoverBackgroundColors)[color];
    const backgroundActiveColors = isRemovable && !isLink ? (0, $2hnSR.backgroundColors)[color] : (0, $2hnSR.linkActiveBackgroundColors)[color];
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("span", {
        ...other,
        ref: ref,
        style: {
            // NOTE: The vast majority of these styles have zero purpose to be runtime computed
            // This can all be migrated to statically distributed atomic CSS with Compiled in the future
            // The main reason for not touching this is there is to avoid excessive changes in the same PR on non-visual-refresh code
            /* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ [$db35d9df42c66ff0$var$borderColorCssVar]: (0, $2hnSR.borderColors)[color],
            [$db35d9df42c66ff0$var$textDefaultCssVar]: (0, $2hnSR.textColors)[color],
            [$db35d9df42c66ff0$var$textHoverCssVar]: (0, $2hnSR.textHoverColors)[color],
            [$db35d9df42c66ff0$var$textActiveCssVar]: (0, $2hnSR.textActiveColors)[color],
            [$db35d9df42c66ff0$var$textLinkCssVar]: textLinkColors,
            [$db35d9df42c66ff0$var$backgroundDefaultCssVar]: (0, $2hnSR.backgroundColors)[color],
            [$db35d9df42c66ff0$var$backgroundHoverCssVar]: backgroundHoverColors,
            [$db35d9df42c66ff0$var$backgroundActiveCssVar]: backgroundActiveColors,
            [$db35d9df42c66ff0$var$focusRingCssVar]: (0, $2hnSR.focusRingColors),
            [$db35d9df42c66ff0$var$removeButtonDefaultCssVar]: (0, $2hnSR.removeButtonColors)[color],
            [$db35d9df42c66ff0$var$removeButtonHoverCssVar]: (0, $2hnSR.removeButtonHoverColors)[color],
            [$db35d9df42c66ff0$var$borderRadiusCssVar]: appearance === 'rounded' ? '10px' : '3px',
            /* eslint-enable @atlaskit/ui-styling-standard/enforce-style-prop */ /* eslint-enable @atlaskit/ui-styling-standard/no-imported-style-values */ // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            ...style
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $bwpsq.default)([
            (0, $VSDnB.fg)('platform-component-visual-refresh') ? "_zulp1b66 _2rko1sit _1h6d2fso _1dqonqa1 _189ee4h9 _1mou1b66 _195g1b66 _18zr1b66 _1e0c116y _vchhusvi _1ul9idpf _4t3iv47k _kqswh2mm _4cvr1h6o _bfhk1w7a _syaz1fxt _80om73ad" : "_2rko1l5z _1mou1b66 _195g1b66 _1rjcze3t _18zrze3t _1e0c116y _1ul9idpf _4t3iv47k _kqswh2mm _bfhklsll _syaz148y _80om73ad",
            (0, $VSDnB.fg)('platform-component-visual-refresh') ? "_1e38ugt7 _7glxv77o" : "_1guj1r31 _pbhaglyw _11ow1o36 _1u6lnr64",
            isLink && (0, $VSDnB.fg)('platform-component-visual-refresh') && "_irr3166n _1di61dty",
            !(0, $VSDnB.fg)('platform-component-visual-refresh') && isLink && !isStandardLink && "_9h8h1348",
            !(0, $VSDnB.fg)('platform-component-visual-refresh') && isInteractive && "_irr31lyj _1di6oo20",
            className
        ]),
        "data-testid": testId,
        children: [
            before,
            contentElement,
            after
        ]
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$db35d9df42c66ff0$export$2e2bcd8739ae039 = $db35d9df42c66ff0$var$BaseTag;

});
parcelRegister("2hnSR", function(module, exports) {

$parcel$export(module.exports, "textColors", () => $5b444d8505b9cc3c$export$daa0ace263cb20d2);
$parcel$export(module.exports, "borderColors", () => $5b444d8505b9cc3c$export$1c1b571cf296eca7);
$parcel$export(module.exports, "textHoverColors", () => $5b444d8505b9cc3c$export$7c7104a5f052cab7);
$parcel$export(module.exports, "textActiveColors", () => $5b444d8505b9cc3c$export$382469baad253eb7);
$parcel$export(module.exports, "backgroundColors", () => $5b444d8505b9cc3c$export$b9d7c59a579c23c6);
$parcel$export(module.exports, "linkHoverBackgroundColors", () => $5b444d8505b9cc3c$export$4410079763249c74);
$parcel$export(module.exports, "linkActiveBackgroundColors", () => $5b444d8505b9cc3c$export$76be99c5e13e3566);
$parcel$export(module.exports, "focusRingColors", () => $5b444d8505b9cc3c$export$2a31dbe82788f940);
$parcel$export(module.exports, "removalHoverBackgroundColors", () => $5b444d8505b9cc3c$export$1202b7eb21da7b58);
$parcel$export(module.exports, "removalActiveBackgroundColors", () => $5b444d8505b9cc3c$export$62ace793ebb16bda);
$parcel$export(module.exports, "removalTextColors", () => $5b444d8505b9cc3c$export$17d206ccea111bbb);
$parcel$export(module.exports, "removeButtonColors", () => $5b444d8505b9cc3c$export$f64c7641cbc22da7);
$parcel$export(module.exports, "removeButtonHoverColors", () => $5b444d8505b9cc3c$export$b03fbc2a369c563e);
// Text colors
const $5b444d8505b9cc3c$export$daa0ace263cb20d2 = {
    standard: "var(--ds-text, #253858)",
    standardLink: "var(--ds-link, #0052CC)",
    blue: "var(--ds-text-accent-blue-bolder, #172B4D)",
    red: "var(--ds-text-accent-red-bolder, #172B4D)",
    yellow: "var(--ds-text-accent-yellow-bolder, #172B4D)",
    green: "var(--ds-text-accent-green-bolder, #172B4D)",
    teal: "var(--ds-text-accent-teal-bolder, #172B4D)",
    purple: "var(--ds-text-accent-purple-bolder, #172B4D)",
    lime: "var(--ds-text-accent-lime-bolder, #37471F)",
    magenta: "var(--ds-text-accent-magenta-bolder, #50253F)",
    orange: "var(--ds-text-accent-orange-bolder, #5F3811)",
    grey: "var(--ds-text-accent-gray-bolder, #FFFFFF)",
    blueLight: "var(--ds-text-accent-blue, #0747A6)",
    redLight: "var(--ds-text-accent-red, #42526E)",
    yellowLight: "var(--ds-text-accent-yellow, #42526E)",
    greenLight: "var(--ds-text-accent-green, #006644)",
    tealLight: "var(--ds-text-accent-teal, #42526E)",
    purpleLight: "var(--ds-text-accent-purple, #403294)",
    limeLight: "var(--ds-text-accent-lime, #4C6B1F)",
    magentaLight: "var(--ds-text-accent-magenta, #943D73)",
    orangeLight: "var(--ds-text-accent-orange, #974F0C)",
    greyLight: "var(--ds-text-accent-gray, #42526E)"
};
const $5b444d8505b9cc3c$export$1c1b571cf296eca7 = {
    standard: '#B7B9BE',
    blue: '#669DF1',
    red: '#F87168',
    yellow: '#DDB30E',
    green: '#4BCE97',
    teal: '#6CC3E0',
    purple: '#C97CF4',
    lime: '#94C748',
    magenta: '#E774BB',
    orange: '#FCA700',
    grey: '#B7B9BE',
    standardLink: '#B7B9BE',
    blueLight: '#669DF1',
    redLight: '#F87168',
    yellowLight: '#DDB30E',
    greenLight: '#4BCE97',
    tealLight: '#6CC3E0',
    purpleLight: '#C97CF4',
    limeLight: '#94C748',
    magentaLight: '#E774BB',
    orangeLight: '#FCA700',
    greyLight: '#B7B9BE'
};
const $5b444d8505b9cc3c$export$7c7104a5f052cab7 = {
    standard: "var(--ds-link, #0065FF)",
    blue: "var(--ds-text-accent-blue-bolder, #172B4D)",
    red: "var(--ds-text-accent-red-bolder, #172B4D)",
    yellow: "var(--ds-text-accent-yellow-bolder, #172B4D)",
    green: "var(--ds-text-accent-green-bolder, #172B4D)",
    teal: "var(--ds-text-accent-teal-bolder, #172B4D)",
    purple: "var(--ds-text-accent-purple-bolder, #172B4D)",
    lime: "var(--ds-text-accent-lime-bolder, #37471F)",
    magenta: "var(--ds-text-accent-magenta-bolder, #50253F)",
    orange: "var(--ds-text-accent-orange-bolder, #5F3811)",
    grey: "var(--ds-text-accent-gray-bolder, #FFFFFF)",
    blueLight: "var(--ds-text-accent-blue, #0747A6)",
    redLight: "var(--ds-text-accent-red, #42526E)",
    yellowLight: "var(--ds-text-accent-yellow, #42526E)",
    greenLight: "var(--ds-text-accent-green, #006644)",
    tealLight: "var(--ds-text-accent-teal, #42526E)",
    purpleLight: "var(--ds-text-accent-purple, #403294)",
    limeLight: "var(--ds-text-accent-lime, #4C6B1F)",
    magentaLight: "var(--ds-text-accent-magenta, #943D73)",
    orangeLight: "var(--ds-text-accent-orange, #974F0C)",
    greyLight: "var(--ds-text-accent-gray, #42526E)"
};
const $5b444d8505b9cc3c$export$382469baad253eb7 = {
    standard: "var(--ds-link-pressed, #0065FF)",
    blue: "var(--ds-text-accent-blue, #172B4D)",
    red: "var(--ds-text-accent-red, #172B4D)",
    yellow: "var(--ds-text-accent-yellow, #172B4D)",
    green: "var(--ds-text-accent-green, #172B4D)",
    teal: "var(--ds-text-accent-teal, #172B4D)",
    purple: "var(--ds-text-accent-purple, #172B4D)",
    lime: "var(--ds-text-accent-lime, #4C6B1F)",
    magenta: "var(--ds-text-accent-magenta, #943D73)",
    orange: "var(--ds-text-accent-orange, #974F0C)",
    grey: "var(--ds-text-accent-gray, #FFFFFF)",
    blueLight: "var(--ds-text-accent-blue-bolder, #0747A6)",
    redLight: "var(--ds-text-accent-red-bolder, #42526E)",
    yellowLight: "var(--ds-text-accent-yellow-bolder, #42526E)",
    greenLight: "var(--ds-text-accent-green-bolder, #006644)",
    tealLight: "var(--ds-text-accent-teal-bolder, #42526E)",
    purpleLight: "var(--ds-text-accent-purple-bolder, #403294)",
    limeLight: "var(--ds-text-accent-lime-bolder, #37471F)",
    magentaLight: "var(--ds-text-accent-magenta-bolder, #50253F)",
    orangeLight: "var(--ds-text-accent-orange-bolder, #5F3811)",
    greyLight: "var(--ds-text-accent-gray-bolder, #42526E)"
};
const $5b444d8505b9cc3c$export$b9d7c59a579c23c6 = {
    standard: "var(--ds-background-neutral, #F4F5F7)",
    blue: "var(--ds-background-accent-blue-subtle, #4C9AFF)",
    red: "var(--ds-background-accent-red-subtle, #FF8F73)",
    yellow: "var(--ds-background-accent-yellow-subtle, #FFC400)",
    green: "var(--ds-background-accent-green-subtle, #57D9A3)",
    teal: "var(--ds-background-accent-teal-subtle, #00C7E6)",
    purple: "var(--ds-background-accent-purple-subtle, #998DD9)",
    lime: "var(--ds-background-accent-lime-subtle, #94C748)",
    magenta: "var(--ds-background-accent-magenta-subtle, #E774BB)",
    orange: "var(--ds-background-accent-orange-subtle, #FAA53D)",
    grey: "var(--ds-background-accent-gray-subtle, #42526E)",
    blueLight: "var(--ds-background-accent-blue-subtler, #B3D4FF)",
    redLight: "var(--ds-background-accent-red-subtler, #FFBDAD)",
    yellowLight: "var(--ds-background-accent-yellow-subtler, #FFE380)",
    greenLight: "var(--ds-background-accent-green-subtler, #79F2C0)",
    tealLight: "var(--ds-background-accent-teal-subtler, #79E2F2)",
    purpleLight: "var(--ds-background-accent-purple-subtler, #C0B6F2)",
    limeLight: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    magentaLight: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    orangeLight: "var(--ds-background-accent-orange-subtler, #FFE2BD)",
    greyLight: "var(--ds-background-accent-gray-subtler, #EBECF0)"
};
const $5b444d8505b9cc3c$export$4410079763249c74 = {
    standard: "var(--ds-background-neutral-hovered, #EBECF0)",
    blue: "var(--ds-background-accent-blue-subtle-hovered, #B3D4FF)",
    red: "var(--ds-background-accent-red-subtle-hovered, #FFBDAD)",
    yellow: "var(--ds-background-accent-yellow-subtle-hovered, #FFE380)",
    green: "var(--ds-background-accent-green-subtle-hovered, #79F2C0)",
    teal: "var(--ds-background-accent-teal-subtle-hovered, #79E2F2)",
    purple: "var(--ds-background-accent-purple-subtle-hovered, #C0B6F2)",
    lime: "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    magenta: "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    orange: "var(--ds-background-accent-orange-subtle-hovered, #FEC57B)",
    grey: "var(--ds-background-accent-gray-subtle-hovered, #505F79)",
    blueLight: "var(--ds-background-accent-blue-subtler-hovered, #DEEBFF)",
    redLight: "var(--ds-background-accent-red-subtler-hovered, #FFEBE6)",
    yellowLight: "var(--ds-background-accent-yellow-subtler-hovered, #FFF0B3)",
    greenLight: "var(--ds-background-accent-green-subtler-hovered, #ABF5D1)",
    tealLight: "var(--ds-background-accent-teal-subtler-hovered, #B3F5FF)",
    purpleLight: "var(--ds-background-accent-purple-subtler-hovered, #EAE6FF)",
    limeLight: "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    magentaLight: "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    orangeLight: "var(--ds-background-accent-orange-subtler-hovered, #FEC57B)",
    greyLight: "var(--ds-background-accent-gray-subtler-hovered, #DFE1E6)"
};
const $5b444d8505b9cc3c$export$76be99c5e13e3566 = {
    standard: "var(--ds-background-neutral-pressed, #EBECF0)",
    blue: "var(--ds-background-accent-blue-subtle-pressed, #DEEBFF)",
    red: "var(--ds-background-accent-red-subtle-pressed, #FFEBE6)",
    yellow: "var(--ds-background-accent-yellow-subtle-pressed, #FFF0B3)",
    green: "var(--ds-background-accent-green-subtle-pressed, #ABF5D1)",
    teal: "var(--ds-background-accent-teal-subtle-pressed, #B3F5FF)",
    purple: "var(--ds-background-accent-purple-subtle-pressed, #EAE6FF)",
    grey: "var(--ds-background-accent-gray-subtle-pressed, #5E6C84)",
    lime: "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    magenta: "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    orange: "var(--ds-background-accent-orange-subtle-pressed, #FFE2BD)",
    blueLight: "var(--ds-background-accent-blue-subtler-pressed, #4C9AFF)",
    redLight: "var(--ds-background-accent-red-subtler-pressed, #FF8F73)",
    yellowLight: "var(--ds-background-accent-yellow-subtler-pressed, #FFC400)",
    greenLight: "var(--ds-background-accent-green-subtler-pressed, #57D9A3)",
    tealLight: "var(--ds-background-accent-teal-subtler-pressed, #00C7E6)",
    purpleLight: "var(--ds-background-accent-purple-subtler-pressed, #998DD9)",
    limeLight: "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    magentaLight: "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    orangeLight: "var(--ds-background-accent-orange-subtler-pressed, #FAA53D)",
    greyLight: "var(--ds-background-accent-gray-subtler-pressed, #C1C7D0)"
};
const $5b444d8505b9cc3c$export$2a31dbe82788f940 = "var(--ds-border-focused, #4C9AFF)";
const $5b444d8505b9cc3c$export$1202b7eb21da7b58 = "var(--ds-background-danger, #FFEBE6)";
const $5b444d8505b9cc3c$export$62ace793ebb16bda = "var(--ds-background-danger-hovered, #FFEBE6)";
const $5b444d8505b9cc3c$export$17d206ccea111bbb = "var(--ds-text-danger, #BF2600)";
const $5b444d8505b9cc3c$export$f64c7641cbc22da7 = {
    standard: "var(--ds-text, #42526E)",
    blue: "var(--ds-text-accent-blue-bolder, #42526E)",
    red: "var(--ds-text-accent-red-bolder, #42526E)",
    yellow: "var(--ds-text-accent-yellow-bolder, #42526E)",
    green: "var(--ds-text-accent-green-bolder, #42526E)",
    teal: "var(--ds-text-accent-teal-bolder, #42526E)",
    purple: "var(--ds-text-accent-purple-bolder, #42526E)",
    lime: "var(--ds-text-accent-lime-bolder, #42526E)",
    magenta: "var(--ds-text-accent-magenta-bolder, #42526E)",
    orange: "var(--ds-text-accent-orange-bolder, #42526E)",
    grey: "var(--ds-text-accent-gray-bolder, #42526E)",
    blueLight: "var(--ds-text-accent-blue, #42526E)",
    redLight: "var(--ds-text-accent-red, #42526E)",
    yellowLight: "var(--ds-text-accent-yellow, #42526E)",
    greenLight: "var(--ds-text-accent-green, #42526E)",
    tealLight: "var(--ds-text-accent-teal, #42526E)",
    purpleLight: "var(--ds-text-accent-purple, #42526E)",
    limeLight: "var(--ds-text-accent-lime, #42526E)",
    magentaLight: "var(--ds-text-accent-magenta, #42526E)",
    orangeLight: "var(--ds-text-accent-orange, #42526E)",
    greyLight: "var(--ds-text-accent-gray, #42526E)"
};
const $5b444d8505b9cc3c$export$b03fbc2a369c563e = {
    standard: "var(--ds-text-danger, #253858)",
    standardLink: "var(--ds-text-danger, #0052CC)",
    blue: "var(--ds-text-danger, #172B4D)",
    red: "var(--ds-text-danger, #172B4D)",
    yellow: "var(--ds-text-danger, #172B4D)",
    green: "var(--ds-text-danger, #172B4D)",
    teal: "var(--ds-text-danger, #172B4D)",
    purple: "var(--ds-text-danger, #172B4D)",
    lime: "var(--ds-text-danger, #172B4D)",
    magenta: "var(--ds-text-danger, #172B4D)",
    orange: "var(--ds-text-danger, #172B4D)",
    grey: "var(--ds-text-danger, #FFFFFF)",
    blueLight: "var(--ds-text-danger, #0747A6)",
    redLight: "var(--ds-text-danger, #42526E)",
    yellowLight: "var(--ds-text-danger, #42526E)",
    greenLight: "var(--ds-text-danger, #006644)",
    tealLight: "var(--ds-text-danger, #42526E)",
    purpleLight: "var(--ds-text-danger, #403294)",
    limeLight: "var(--ds-text-danger, #403294)",
    magentaLight: "var(--ds-text-danger, #403294)",
    orangeLight: "var(--ds-text-danger, #403294)",
    greyLight: "var(--ds-text-danger, #42526E)"
};

});


parcelRegister("aXLIT", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b11e671062d0fc5$export$2e2bcd8739ae039);
/* before.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");
const $4b11e671062d0fc5$var$beforeElementStyles = null;
// To be removed with platform-component-visual-refresh (BLU-2992)
const $4b11e671062d0fc5$var$beforeElementStylesOld = null;
const $4b11e671062d0fc5$var$Before = ({ elemBefore: elemBefore })=>elemBefore ? /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        className: (0, $bwpsq.default)([
            (0, $VSDnB.fg)('platform-component-visual-refresh') ? "_1e0c1txw _4t3i7vkz _4cvr1h6o _1bah1h6o _152tze3t" : "_2rko1l5z _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _152tze3t"
        ]),
        children: elemBefore
    }) : null;
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$4b11e671062d0fc5$export$2e2bcd8739ae039 = $4b11e671062d0fc5$var$Before;

});

parcelRegister("eYXIO", function(module, exports) {

$parcel$export(module.exports, "default", () => $c46b06918fbe54e8$export$2e2bcd8739ae039);
/* content.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");
// To be removed with platform-component-visual-refresh (BLU-2992)
const $c46b06918fbe54e8$var$baseStylesOld = null;
const $c46b06918fbe54e8$var$baseStyles = null;
// To be removed with platform-component-visual-refresh (BLU-2992)
const $c46b06918fbe54e8$var$linkStylesOld = null;
const $c46b06918fbe54e8$var$linkStyles = null;
const $c46b06918fbe54e8$var$hasAfterStylesOld = null;
const $c46b06918fbe54e8$var$hasAfterStyles = null;
// To be removed with platform-component-visual-refresh (BLU-2992)
const $c46b06918fbe54e8$var$hasBeforeStyles = null;
const $c46b06918fbe54e8$var$Content = ({ elemBefore: elemBefore = null, isRemovable: isRemovable = true, text: text = '', color: color = 'standard', href: href, linkComponent: linkComponent })=>{
    const Link = linkComponent ?? 'a';
    if (href) return /*#__PURE__*/ (0, $2OMIu.jsx)(Link, {
        href: href,
        "data-color": color,
        className: (0, $bwpsq.default)([
            (0, $VSDnB.fg)('platform-component-visual-refresh') ? "_11c82smr _1reo15vq _18m915vq _p12fmgvx _1bto1l2s _o5721q9c" : "_11c82smr _1reo15vq _18m915vq _p12fmgvx _y4ti1b66 _bozg1b66 _1bto1l2s _o5721q9c",
            (0, $VSDnB.fg)('platform-component-visual-refresh') ? "_4bfu18uv _1hmsglyw _ajmmnqa1 _syaz1fxt _lcxv1wug _nt751r31 _49pcglyw _1hvw1o36 _9oik18uv _1bnx8stv _jf4cnqa1 _30l31fxt _1nrm18uv _c2wa8stv _1iohnqa1 _9h8h1fxt" : "_4bfu18uv _1hmsglyw _ajmmnqa1 _syazs5nr _lcxv1wug _nt751r31 _49pcglyw _1hvw1o36 _9oik18uv _1bnx8stv _jf4cnqa1 _30l3117u _1nrm18uv _c2wa8stv _1iohnqa1 _9h8h1348",
            !(0, $VSDnB.fg)('platform-component-visual-refresh') && elemBefore && "_ahbqv47k",
            isRemovable && (0, $VSDnB.fg)('platform-component-visual-refresh') && "_p12f1lit",
            isRemovable && !(0, $VSDnB.fg)('platform-component-visual-refresh') && "_p12f1lit _y4tipxbi"
        ]),
        children: text
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        className: (0, $bwpsq.default)([
            (0, $VSDnB.fg)('platform-component-visual-refresh') ? "_11c82smr _1reo15vq _18m915vq _p12fmgvx _1bto1l2s _o5721q9c" : "_11c82smr _1reo15vq _18m915vq _p12fmgvx _y4ti1b66 _bozg1b66 _1bto1l2s _o5721q9c",
            !(0, $VSDnB.fg)('platform-component-visual-refresh') && elemBefore && "_ahbqv47k",
            isRemovable && (0, $VSDnB.fg)('platform-component-visual-refresh') && "_p12f1lit",
            isRemovable && !(0, $VSDnB.fg)('platform-component-visual-refresh') && "_p12f1lit _y4tipxbi"
        ]),
        children: text
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$c46b06918fbe54e8$export$2e2bcd8739ae039 = $c46b06918fbe54e8$var$Content;

});



parcelRegister("d2nmk", function(module, exports) {

$parcel$export(module.exports, "CardDueDate", () => $414cbe3fa5f4a57f$export$9e242219cf1cc36c);
/* CardDueDate.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $4mBKK = parcelRequire("4mBKK");
var $70Rr2 = parcelRequire("70Rr2");
var $eZDAP = parcelRequire("eZDAP");
var $it1wb = parcelRequire("it1wb");

var $f1akg = parcelRequire("f1akg");
const $414cbe3fa5f4a57f$export$9e242219cf1cc36c = /*#__PURE__*/ (0, $5uXOq.memo)(({ dueDate: dueDate, isDone: isDone })=>{
    const dueDateEndOfDay = (0, $70Rr2.default)((0, $eZDAP.default)(dueDate));
    const currentDate = (0, $it1wb.default)(new Date());
    const diffInDays = (0, $4mBKK.default)(dueDateEndOfDay, currentDate);
    return /*#__PURE__*/ $5uXOq.createElement("div", {
        className: (0, $bwpsq.default)([
            $414cbe3fa5f4a57f$var$styles.root
        ])
    }, /*#__PURE__*/ $5uXOq.createElement((0, $f1akg.ColoredDueDate), {
        dateString: dueDate,
        pastDue: !isDone && diffInDays < 0,
        dueToday: diffInDays === 0
    }));
});
const $414cbe3fa5f4a57f$var$styles = {
    root: "_1e0c1txw _4cvr1h6o _kqswh2mm _lcxv1wug"
};

});
parcelRegister("f1akg", function(module, exports) {

$parcel$export(module.exports, "ColoredDueDate", () => $3f739dd1d004c9d2$export$63c54814247cca36);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $jpopi = parcelRequire("jpopi");

var $acknU = parcelRequire("acknU");

var $hyKRO = parcelRequire("hyKRO");

var $jCESp = parcelRequire("jCESp");

var $3bDjY = parcelRequire("3bDjY");

var $DVljb = parcelRequire("DVljb");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $1eyaH = parcelRequire("1eyaH");

var $cpjnU = parcelRequire("cpjnU");

var $CKlOf = parcelRequire("CKlOf");
const $3f739dd1d004c9d2$var$RecurringWorkItemIcon = ({ testId: testId })=>{
    const { issueProperties: issueProperties, isUpdatingRule: isUpdatingRule } = (0, $1eyaH.useRecurWorkItemState)();
    if (!issueProperties && !isUpdatingRule || (0, $cpjnU.isRecurOnCompleteToggleRule)(issueProperties)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jpopi))), {
        label: "",
        testId: testId
    });
};
const $3f739dd1d004c9d2$export$63c54814247cca36 = ({ dateString: dateString, pastDue: pastDue, dueToday: dueToday, warningIconTestId: warningIconTestId, clockIconTestId: clockIconTestId, calendarIconTestId: calendarIconTestId, tooltipTestId: tooltipTestId, isShortFormat: isShortFormat = false, maybeShowRecurIcon: maybeShowRecurIcon = false, recurIconTestId: recurIconTestId })=>{
    const locale = (0, $DVljb.useLocale)();
    const localeString = locale.replace('_', '-');
    const formatter = new Intl.DateTimeFormat(localeString, {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        timeZone: 'UTC',
        timeZoneName: 'short'
    });
    const parts = formatter.formatToParts(new Date(dateString));
    const formatDateParts = ({ dateParts: dateParts, includeYear: includeYear = true, includeTimezone: includeTimezone = false })=>{
        let result = '';
        dateParts.forEach((part, index)=>{
            const nextPart = dateParts[index + 1];
            const skipCurrentPart = !includeTimezone && nextPart?.type === 'timeZoneName' && part.type === 'literal' && part.value === ', ';
            if (!skipCurrentPart && (part.type === 'year' && includeYear || part.type === 'timeZoneName' && includeTimezone || part.type !== 'year' && part.type !== 'timeZoneName')) result += part.value;
        });
        return result;
    };
    const displayDate = isShortFormat ? formatDateParts({
        dateParts: parts,
        includeYear: false
    }) : formatDateParts({
        dateParts: parts
    });
    const tooltipDate = formatDateParts({
        dateParts: parts,
        includeYear: true,
        includeTimezone: true
    });
    const dueMessage = pastDue ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
        ...(0, $CKlOf.messages).overdue,
        values: {
            date: tooltipDate
        }
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
        ...(0, $CKlOf.messages).due,
        values: {
            date: tooltipDate
        }
    });
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const iconLabel = pastDue ? formatMessage((0, $CKlOf.messages).overdue, {
        date: tooltipDate
    }) : formatMessage((0, $CKlOf.messages).due, {
        date: tooltipDate
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: dueMessage,
        position: "top",
        testId: tooltipTestId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $3f739dd1d004c9d2$var$styles.dateTag,
            $3f739dd1d004c9d2$var$styles.flexContainer,
            pastDue ? $3f739dd1d004c9d2$var$styles.overdue : undefined,
            dueToday ? $3f739dd1d004c9d2$var$styles.dueToday : undefined,
            !pastDue && !dueToday ? $3f739dd1d004c9d2$var$styles.normalDate : undefined
        ],
        testId: "coloured-due-date.ui.colored-due-date-container",
        tabIndex: 0,
        role: "button",
        "aria-label": iconLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $3f739dd1d004c9d2$var$styles.dueDateIcon,
        testId: "coloured-due-date.ui.tooltip-container"
    }, pastDue && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jCESp))), {
        LEGACY_size: "medium",
        label: iconLabel,
        color: "var(--ds-text-danger, #AE2E24)",
        testId: warningIconTestId
    }), dueToday && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hyKRO))), {
        LEGACY_size: "medium",
        label: iconLabel,
        color: "var(--ds-text-warning, #A54800)",
        testId: clockIconTestId
    }), !dueToday && !pastDue && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acknU))), {
        label: iconLabel,
        color: "var(--ds-text, #172B4D)",
        LEGACY_size: "medium",
        testId: calendarIconTestId
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        "aria-hidden": "true"
    }, displayDate), maybeShowRecurIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3f739dd1d004c9d2$var$RecurringWorkItemIcon, {
        testId: recurIconTestId
    })));
};
const $3f739dd1d004c9d2$var$styles = {
    dateTag: (0, $8CUq3.xcss)({
        paddingLeft: 'space.075',
        paddingRight: 'space.075',
        borderStyle: 'solid',
        borderRadius: 'border.radius.100',
        borderWidth: 'border.width',
        color: 'color.text',
        cursor: 'pointer'
    }),
    flexContainer: (0, $8CUq3.xcss)({
        display: 'flex',
        alignItems: 'center',
        gap: 'space.050'
    }),
    overdue: (0, $8CUq3.xcss)({
        color: 'color.text.danger',
        borderColor: 'color.border.danger'
    }),
    dueToday: (0, $8CUq3.xcss)({
        color: 'color.text.warning',
        borderColor: 'color.border.warning'
    }),
    normalDate: (0, $8CUq3.xcss)({
        color: 'color.text',
        borderColor: 'color.border'
    }),
    dueDateIcon: (0, $8CUq3.xcss)({
        display: 'flex',
        alignItems: 'center'
    })
};

});
parcelRegister("jpopi", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a88758e67a65d8683bdcd5e828d8b686>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e21348dd48989821$var$_react = $e21348dd48989821$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $e21348dd48989821$var$_baseNew = $e21348dd48989821$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $e21348dd48989821$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Repeat".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for setting objects to recur (eg Work items, Forms)
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e21348dd48989821$var$RepeatIcon = (props)=>/*#__PURE__*/ $e21348dd48989821$var$_react.default.createElement($e21348dd48989821$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m8.78 3.72-3-3-1.06 1.06L6.44 3.5H4.5a4.5 4.5 0 0 0 0 9h1V11h-1a3 3 0 0 1 0-6h1.94L4.72 6.72l1.06 1.06 3-3a.75.75 0 0 0 0-1.06M11.5 5a3 3 0 1 1 0 6H9.56l1.72-1.72-1.06-1.06-3 3a.75.75 0 0 0 0 1.06l3 3 1.06-1.06-1.72-1.72h1.94a4.5 4.5 0 1 0 0-9h-1V5z" clip-rule="evenodd"/>`
    }, props));
$e21348dd48989821$var$RepeatIcon.displayName = 'RepeatIcon';
var $e21348dd48989821$var$_default = module.exports.default = $e21348dd48989821$var$RepeatIcon;

});

parcelRegister("acknU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9571ec76557171a7f54748c218c48225>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $76cad653a4883392$var$_react = $76cad653a4883392$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $76cad653a4883392$var$_calendar = $76cad653a4883392$var$_interopRequireDefault((parcelRequire("3fesp")));

var $76cad653a4883392$var$_calendar2 = $76cad653a4883392$var$_interopRequireDefault((parcelRequire("cTemL")));
function $76cad653a4883392$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CalendarIcon.
 * This component is CalendarIcon, with `UNSAFE_fallbackIcon` set to "CalendarIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: date metadata, date input field, calendar view, jira status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $76cad653a4883392$var$CalendarIcon = (props)=>/*#__PURE__*/ $76cad653a4883392$var$_react.default.createElement($76cad653a4883392$var$_calendar.default, Object.assign({
        LEGACY_fallbackIcon: $76cad653a4883392$var$_calendar2.default
    }, props));
$76cad653a4883392$var$CalendarIcon.Name = 'CalendarIconMigration';
var $76cad653a4883392$var$_default = module.exports.default = $76cad653a4883392$var$CalendarIcon;

});
parcelRegister("cTemL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9625c3edd02eaf26$var$_react = $9625c3edd02eaf26$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $9625c3edd02eaf26$var$_calendar = $9625c3edd02eaf26$var$_interopRequireDefault((parcelRequire("3fesp")));
function $9625c3edd02eaf26$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9625c3edd02eaf26$var$CalendarIcon = (props)=>/*#__PURE__*/ $9625c3edd02eaf26$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4.995 5h14.01C20.107 5 21 5.895 21 6.994v12.012A1.994 1.994 0 0 1 19.005 21H4.995A1.995 1.995 0 0 1 3 19.006V6.994C3 5.893 3.892 5 4.995 5M5 9v9a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V9zm1-5a1 1 0 0 1 2 0v1H6zm10 0a1 1 0 0 1 2 0v1h-2zm-9 9v-2.001h2V13zm8 0v-2.001h2V13zm-4 0v-2.001h2.001V13zm-4 4v-2h2v2zm4 0v-2h2.001v2zm4 0v-2h2v2z"/></svg>`
    }, props, {
        newIcon: $9625c3edd02eaf26$var$_calendar.default
    }));
$9625c3edd02eaf26$var$CalendarIcon.displayName = 'CalendarIcon';
var $9625c3edd02eaf26$var$_default = module.exports.default = $9625c3edd02eaf26$var$CalendarIcon;

});


parcelRegister("jCESp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::22f154a5d93289d4bcc4dadb1207abea>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e49146301a0d3a89$var$_react = $e49146301a0d3a89$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $e49146301a0d3a89$var$_baseNew = $e49146301a0d3a89$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $e49146301a0d3a89$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "WarningOutline".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Low-impact warnings. Overdue dates in Atlassian Home.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e49146301a0d3a89$var$WarningOutlineIcon = (props)=>/*#__PURE__*/ $e49146301a0d3a89$var$_react.default.createElement($e49146301a0d3a89$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5.7 1.384c.996-1.816 3.605-1.818 4.602-.003l5.35 9.73C16.612 12.86 15.346 15 13.35 15H2.667C.67 15-.594 12.862.365 11.113zm3.288.72a1.125 1.125 0 0 0-1.972 0l-5.336 9.73c-.41.75.132 1.666.987 1.666H13.35c.855 0 1.398-.917.986-1.667z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M7.25 9V4h1.5v5z" clip-rule="evenodd"/><path fill="currentcolor" d="M9 11.25a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
    }, props));
$e49146301a0d3a89$var$WarningOutlineIcon.displayName = 'WarningOutlineIcon';
var $e49146301a0d3a89$var$_default = module.exports.default = $e49146301a0d3a89$var$WarningOutlineIcon;

});

parcelRegister("1eyaH", function(module, exports) {

$parcel$export(module.exports, "RecurWorkItemContainer", () => $299cd71373520f02$export$32458a51e0870d6c);
$parcel$export(module.exports, "useRecurWorkItemState", () => $299cd71373520f02$export$5730c874dfb9803f);
$parcel$export(module.exports, "useRecurWorkItemActions", () => $299cd71373520f02$export$eb9ad4e1e739768e);

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $3sQ5x = parcelRequire("3sQ5x");
var $gg7kZ = parcelRequire("gg7kZ");
var $iXqE5 = parcelRequire("iXqE5");

var $koeKL = parcelRequire("koeKL");

var $2tT7R = parcelRequire("2tT7R");

var $93Yeu = parcelRequire("93Yeu");

var $cYlk7 = parcelRequire("cYlk7");

var $2YZCu = parcelRequire("2YZCu");

var $hVn1P = parcelRequire("hVn1P");

var $lQupu = parcelRequire("lQupu");
const $299cd71373520f02$var$RecurWorkItemStoreContainer = (0, $gg7kZ.createContainer)();
const $299cd71373520f02$export$32458a51e0870d6c = ({ children: children, issueKey: issueKey })=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const environment = (0, $2tT7R.useEnvironment)();
    const projectKey = (0, $93Yeu.useProjectKey)(issueKey);
    const projectId = (0, $93Yeu.useProjectId)(projectKey);
    const { data: currentUser } = (0, $cYlk7.useCurrentUser)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    if (!projectId) {
        (0, $2YZCu.default).safeErrorWithoutCustomerData('jira-recur-work-item.src.controllers.RecurWorkItemContainer', 'Error initialising RecurWorkItemContainer, could not retrieve projectId');
        return children;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($299cd71373520f02$var$RecurWorkItemStoreContainer, {
        scope: `recur-${issueKey}`,
        issueKey: issueKey,
        environment: environment,
        cloudId: cloudId,
        currentUserAccountId: currentUser.user.accountId,
        projectId: projectId,
        createAnalyticsEvent: createAnalyticsEvent
    }, children);
};
const $299cd71373520f02$export$390f32400eaf98c9 = (0, $iXqE5.createStore)({
    name: 'RecurWorkItemStore',
    initialState: (0, $lQupu.INITIAL_STATE),
    actions: $hVn1P.actions,
    containedBy: $299cd71373520f02$var$RecurWorkItemStoreContainer,
    handlers: {
        onInit: ()=>async ({ dispatch: dispatch })=>{
                await dispatch((0, $hVn1P.actions).fetch());
            }
    }
});
const $299cd71373520f02$export$6630e454597fb59c = (0, $3sQ5x.createHook)($299cd71373520f02$export$390f32400eaf98c9);
const $299cd71373520f02$export$5730c874dfb9803f = (0, $3sQ5x.createStateHook)($299cd71373520f02$export$390f32400eaf98c9);
const $299cd71373520f02$export$eb9ad4e1e739768e = (0, $3sQ5x.createActionsHook)($299cd71373520f02$export$390f32400eaf98c9);

});
parcelRegister("hVn1P", function(module, exports) {

$parcel$export(module.exports, "actions", () => $a7f343d49f172fdb$export$e324594224ef24da);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $7Sl82 = parcelRequire("7Sl82");

var $l9xxv = parcelRequire("l9xxv");

var $bvhsR = parcelRequire("bvhsR");

var $c8g0F = parcelRequire("c8g0F");
const $a7f343d49f172fdb$export$5153917efea4a83d = (issueProperties)=>({ setState: setState })=>{
        setState({
            issueProperties: issueProperties
        });
    };
const $a7f343d49f172fdb$export$e324594224ef24da = {
    fetch: $7Sl82.fetch,
    setIssueProperties: $a7f343d49f172fdb$export$5153917efea4a83d,
    setAsNonRecurringIssue: $l9xxv.setAsNonRecurringIssue,
    setAsRecurringIssue: $bvhsR.setAsRecurringIssue,
    updateRule: $c8g0F.updateRule
};

});
parcelRegister("7Sl82", function(module, exports) {

$parcel$export(module.exports, "fetch", () => $88fd35b220315252$export$e7aa7bc5c1b3cfb3);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $4R6GH = parcelRequire("4R6GH");

var $m8SHd = parcelRequire("m8SHd");

var $ahBjy = parcelRequire("ahBjy");

var $fAJ3G = parcelRequire("fAJ3G");

var $519t2 = parcelRequire("519t2");

var $cpjnU = parcelRequire("cpjnU");
const $88fd35b220315252$export$e7aa7bc5c1b3cfb3 = ()=>async ({ setState: setState }, { createAnalyticsEvent: createAnalyticsEvent, issueKey: issueKey, environment: environment, cloudId: cloudId, projectId: projectId, currentUserAccountId: currentUserAccountId })=>{
        setState({
            isFetching: true,
            errors: null
        });
        try {
            // First fetch issue-properties
            const { value: issueProperties } = await (0, $519t2.callServiceWithAnalytics)(createAnalyticsEvent({}), (0, $m8SHd.fetchIssueProperties)(issueKey), 'fetchIssueProperties');
            let ruleSummary;
            // Only fetch rule summary if a rule exists in issue-properties and not a grandfathered recur-on-complete rule
            if (issueProperties?.automationRuleUuid) {
                ruleSummary = await (0, $519t2.callServiceWithAnalytics)(createAnalyticsEvent({}), (0, $m8SHd.fetchRuleSummary)(environment, cloudId, projectId, issueProperties.automationRuleUuid), 'fetchRuleSummary');
                // If rule doesn't exist or is disabled, delete issue-properties
                if (!ruleSummary || ruleSummary?.ruleState === (0, $ahBjy.RuleState).DISABLED) {
                    await (0, $519t2.callServiceWithAnalytics)(createAnalyticsEvent({}), (0, $fAJ3G.deleteIssueProperties)({
                        issueKey: issueKey
                    }), 'deleteIssueProperties');
                    setState({
                        isFetching: false,
                        hasFetched: true,
                        issueProperties: null
                    });
                    return;
                }
            }
            let isRuleOwner;
            if ((0, $cpjnU.isRecurOnCompleteToggleRule)(issueProperties)) isRuleOwner = true;
            else if (ruleSummary) isRuleOwner = ruleSummary.authorAccountId === currentUserAccountId;
            else isRuleOwner = null;
            setState({
                isFetching: false,
                hasFetched: true,
                issueProperties: issueProperties,
                isRuleOwner: isRuleOwner,
                ...(0, $4R6GH.fg)('jira-recur-single-work-item-on-sched-due-date-gate') && {
                    hasBootstrapError: false
                }
            });
        } catch (error) {
            setState({
                isFetching: false,
                hasFetched: true,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                errors: [
                    error
                ],
                hasBootstrapError: true
            });
        }
    };

});
parcelRegister("m8SHd", function(module, exports) {

$parcel$export(module.exports, "fetchIssueProperties", () => $85e12c64cfd21e7a$export$efa35964e975bd30);
$parcel$export(module.exports, "fetchRuleSummary", () => $85e12c64cfd21e7a$export$3cada9835f092161);

var $c5wox = parcelRequire("c5wox");

var $jJZqs = parcelRequire("jJZqs");

var $eusud = parcelRequire("eusud");
const $85e12c64cfd21e7a$export$efa35964e975bd30 = async (issueKey)=>{
    const recurrenceConfigEndpoint = `/rest/api/2/issue/${issueKey}/properties/recurrence-config`;
    try {
        return await (0, $eusud.performGetRequest)(recurrenceConfigEndpoint);
    } catch (error) {
        if (error instanceof (0, $jJZqs.default) && error.statusCode === 404) return Promise.resolve({
            value: null
        });
        throw error;
    }
};
const $85e12c64cfd21e7a$export$3cada9835f092161 = async (environment, cloudId, projectId, ruleUuid)=>{
    const automationStack = await (0, $c5wox.getAutomationStack)(environment, cloudId);
    const summaryEndpoint = `/gateway/api/automation/internal-api/jira/${cloudId}/${automationStack}/rest/${projectId}/rule/${ruleUuid}/summary`;
    try {
        return await (0, $eusud.performGetRequest)(summaryEndpoint);
    } catch (error) {
        if (error instanceof (0, $jJZqs.default) && error.statusCode === 404) return null;
        throw error;
    }
};

});
parcelRegister("c5wox", function(module, exports) {

$parcel$export(module.exports, "getAutomationStack", () => $8833cfad9f41bd36$export$6123178d3f5fb24d);
$parcel$export(module.exports, "getAutomationRecommendationsUrl", () => $8833cfad9f41bd36$export$38f41aa7b608011d);
$parcel$export(module.exports, "getBaseAutomationUrl", () => $8833cfad9f41bd36$export$8e479e490e1e69bc);

var $bSSG7 = parcelRequire("bSSG7");

var $4R6GH = parcelRequire("4R6GH");
const $8833cfad9f41bd36$var$localStorage = (0, $bSSG7.createLocalStorageProvider)('automation-menu');
const $8833cfad9f41bd36$var$getLatestStack = async (cloudId)=>fetch(`/gateway/api/automation/internal-api/jira/${cloudId}/pro/rest/environments`).then((response)=>response.json()).then((response)=>{
        const stacks = response.prod.otherStacks.filter(({ releasedSuccessfully: releasedSuccessfully })=>!releasedSuccessfully).map(({ stack: stack })=>stack);
        return stacks.length > 0 ? stacks[0] : null;
    }).catch(()=>null);
const $8833cfad9f41bd36$export$6123178d3f5fb24d = async (env, cloudId)=>{
    if (env === 'prod') {
        if ((0, $4R6GH.fg)('automation-platform-pre-prod-instance')) {
            const stack = await $8833cfad9f41bd36$var$getLatestStack(cloudId);
            return stack ?? 'pro';
        }
        return 'pro';
    }
    // Set this manually to your Automation dev stack e.g. devesukmajaya. The full key is: __storejs_automation-menu_automationStack
    const stackOverride = $8833cfad9f41bd36$var$localStorage.get('automationStack');
    return stackOverride || 'staging';
};
const $8833cfad9f41bd36$export$45ce04a98782e28a = async (env, cloudId, projectId)=>{
    const automationStack = await $8833cfad9f41bd36$export$6123178d3f5fb24d(env, cloudId);
    return `/gateway/api/automation/internal-api/jira/${cloudId}/${automationStack}/rest/rules/invocation/${projectId}`;
};
const $8833cfad9f41bd36$export$f8e019b45a22d26a = async (env, cloudId, ruleId)=>{
    const automationStack = await $8833cfad9f41bd36$export$6123178d3f5fb24d(env, cloudId);
    return `/gateway/api/automation/internal-api/jira/${cloudId}/${automationStack}/rest/rules/invocation/${ruleId}`;
};
const $8833cfad9f41bd36$export$38f41aa7b608011d = async ({ env: env, cloudId: cloudId, target: target })=>{
    const automationStack = await $8833cfad9f41bd36$export$6123178d3f5fb24d(env, cloudId);
    return `/gateway/api/automation/internal-api/jira/${cloudId}/${automationStack}/rest/v1/recommendation/templates?target=${target}`;
};
const $8833cfad9f41bd36$export$8e479e490e1e69bc = ({ projectKey: projectKey, projectType: projectType, isSimplified: isSimplified })=>{
    /**
	 * Confusing mapping of urls here.
	 * Classic Projects - always under /automate
	 * Next Gen Projects - under /automation for all project types except JSD
	 */ if ((0, $4R6GH.fg)('jcs_project_type_m3')) switch(projectType){
        case 'customer_service':
        case 'service_desk':
            return `/jira/servicedesk/projects/${projectKey}/settings/automate`;
        case 'business':
            return `/jira/core/projects/${projectKey}/settings/${isSimplified ? 'automation' : 'automate'}`;
        default:
            return `/jira/software/${isSimplified ? '' : 'c/'}projects/${projectKey}/settings/${isSimplified ? 'automation' : 'automate'}`;
    }
    switch(projectType){
        case 'service_desk':
            return `/jira/servicedesk/projects/${projectKey}/settings/automate`;
        case 'business':
            return `/jira/core/projects/${projectKey}/settings/${isSimplified ? 'automation' : 'automate'}`;
        default:
            return `/jira/software/${isSimplified ? '' : 'c/'}projects/${projectKey}/settings/${isSimplified ? 'automation' : 'automate'}`;
    }
};

});


parcelRegister("ahBjy", function(module, exports) {

$parcel$export(module.exports, "RuleState", () => $50cbc517c5c98dcf$export$c22ef3527b5f5563);
$parcel$export(module.exports, "CONDITION", () => $50cbc517c5c98dcf$export$1cfe08df32bc8f76);
$parcel$export(module.exports, "FORM_TITLE_ID", () => $50cbc517c5c98dcf$export$66f4c6e4b9206abf);
$parcel$export(module.exports, "SOFTWARE_END_USER_TEMPLATE_2", () => $50cbc517c5c98dcf$export$c07ca23c166d6344);
const $50cbc517c5c98dcf$export$c22ef3527b5f5563 = {
    DISABLED: 'DISABLED',
    ENABLED: 'ENABLED',
    MISSING_PERMS: 'MISSING_PERMS'
};
const $50cbc517c5c98dcf$export$1cfe08df32bc8f76 = {
    SCHEDULE: 'SCHEDULE',
    SCHEDULE_IF_COMPLETE: 'SCHEDULE_IF_COMPLETE'
};
const $50cbc517c5c98dcf$export$f7109619a5e9e0d6 = 'recurWorkItemForm';
const $50cbc517c5c98dcf$export$66f4c6e4b9206abf = 'recur-work-item-form-title';
const $50cbc517c5c98dcf$export$c07ca23c166d6344 = 'software_end_user_template_2';

});

parcelRegister("fAJ3G", function(module, exports) {

$parcel$export(module.exports, "deleteRule", () => $dcc2b085f6f8ace7$export$988cba38e738f27d);
$parcel$export(module.exports, "deleteIssueProperties", () => $dcc2b085f6f8ace7$export$3906c12f20991cd1);
$parcel$export(module.exports, "disableRule", () => $dcc2b085f6f8ace7$export$44bd9fdb7edbb04a);

var $c5wox = parcelRequire("c5wox");

var $eusud = parcelRequire("eusud");
const $dcc2b085f6f8ace7$export$988cba38e738f27d = async ({ environment: environment, cloudId: cloudId, projectId: projectId, ruleUuid: ruleUuid })=>{
    const automationStack = await (0, $c5wox.getAutomationStack)(environment, cloudId);
    const DELETE_RULE_URL = `/gateway/api/automation/internal-api/jira/${cloudId}/${automationStack}/rest/${projectId}/rule/${ruleUuid}`;
    return (0, $eusud.performDeleteRequest)(DELETE_RULE_URL);
};
const $dcc2b085f6f8ace7$export$3906c12f20991cd1 = async ({ issueKey: issueKey })=>{
    const ruleConfigEndpoint = `/rest/api/2/issue/${issueKey}/properties/recurrence-config`;
    return (0, $eusud.performDeleteRequest)(ruleConfigEndpoint);
};
const $dcc2b085f6f8ace7$export$44bd9fdb7edbb04a = async ({ environment: environment, cloudId: cloudId, projectId: projectId, ruleUuid: ruleUuid })=>{
    const automationStack = await (0, $c5wox.getAutomationStack)(environment, cloudId);
    const disableRuleEndpoint = `/gateway/api/automation/internal-api/jira/${cloudId}/${automationStack}/rest/${projectId}/rule/${ruleUuid}/disable`;
    return (0, $eusud.performPatchRequest)(disableRuleEndpoint);
};

});

parcelRegister("519t2", function(module, exports) {

$parcel$export(module.exports, "callServiceWithAnalytics", () => $ad2a8aebaff4128f$export$7ad2acdaf7d8c23c);

var $jJZqs = parcelRequire("jJZqs");

var $8zOmE = parcelRequire("8zOmE");
const $ad2a8aebaff4128f$var$getErrorAttributes = (error)=>{
    if (error instanceof Error) return {
        errorMessage: error.message,
        ...error instanceof (0, $jJZqs.default) && {
            statusCode: error.statusCode
        }
    };
    return {};
};
const $ad2a8aebaff4128f$export$7ad2acdaf7d8c23c = async (analyticsEvent, requestPromise, requestName, attributes = {})=>{
    try {
        const response = await requestPromise;
        (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, `${requestName} succeeded`, {
            ...attributes
        });
        return response;
    } catch (err) {
        (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, `${requestName} failed`, {
            ...attributes,
            ...$ad2a8aebaff4128f$var$getErrorAttributes(err)
        });
        throw err;
    }
};

});

parcelRegister("cpjnU", function(module, exports) {

$parcel$export(module.exports, "mapFrequencyToRRule", () => $c35d2016d68e7b8d$export$e01411a3db8dd3d7);
$parcel$export(module.exports, "mapFrequencyToSmartOffsetValue", () => $c35d2016d68e7b8d$export$777fffdd861d4f20);
$parcel$export(module.exports, "getFrequencyFromRRule", () => $c35d2016d68e7b8d$export$71b17ee07540e13b);
$parcel$export(module.exports, "getRecurMenuItemLabel", () => $c35d2016d68e7b8d$export$c7198a7e75d4478b);
$parcel$export(module.exports, "getSuccessFlagContent", () => $c35d2016d68e7b8d$export$8eef89c3d24cb712);
$parcel$export(module.exports, "isRecurOnCompleteToggleRule", () => $c35d2016d68e7b8d$export$b57843f38b80b500);
$parcel$export(module.exports, "hasRuleChanged", () => $c35d2016d68e7b8d$export$8dc77b9e863f46b);
$parcel$export(module.exports, "applyUserTimezone", () => $c35d2016d68e7b8d$export$555109634e8a63b6);

var $ajpes = parcelRequire("ajpes");

var $1GF3c = parcelRequire("1GF3c");

var $gwejS = parcelRequire("gwejS");

var $7jns1 = parcelRequire("7jns1");

var $bbVsP = parcelRequire("bbVsP");
var $jpR5P = parcelRequire("jpR5P");

var $9eJ96 = parcelRequire("9eJ96");

var $5D9Ji = parcelRequire("5D9Ji");
const $c35d2016d68e7b8d$export$e01411a3db8dd3d7 = (timeframe, recurWeeklyConfig)=>{
    switch(timeframe){
        case 'DAILY':
            return {
                frequency: (0, $9eJ96.Frequencies).DAILY,
                interval: 1
            };
        case 'WEEKDAY':
            return {
                frequency: (0, $9eJ96.Frequencies).DAILY,
                byDay: [
                    (0, $9eJ96.Days).MO,
                    (0, $9eJ96.Days).TU,
                    (0, $9eJ96.Days).WE,
                    (0, $9eJ96.Days).TH,
                    (0, $9eJ96.Days).FR
                ],
                interval: 1
            };
        case 'WEEKLY':
            return {
                frequency: (0, $9eJ96.Frequencies).WEEKLY,
                byDay: recurWeeklyConfig,
                interval: 1
            };
        case 'FORTNIGHTLY':
            // There is no native FORTNIGHTLY frequency for ical, so we need to combine WEEKLY with interval 2
            return {
                frequency: (0, $9eJ96.Frequencies).WEEKLY,
                byDay: recurWeeklyConfig,
                interval: 2
            };
        default:
            throw new Error(`Unknown timeframe: ${timeframe}`);
    }
};
const $c35d2016d68e7b8d$export$777fffdd861d4f20 = (timeframe)=>{
    switch(timeframe){
        case 'DAILY':
            return '{{now.plusDays(1)}}';
        case 'WEEKDAY':
            return '{{now.plusBusinessDays(1)}}';
        case 'WEEKLY':
            return '{{now.plusWeeks(1)}}';
        case 'FORTNIGHTLY':
            return '{{now.plusWeeks(2)}}';
        default:
            throw new Error(`Could not calculate due date smart offset value: ${timeframe}`);
    }
};
const $c35d2016d68e7b8d$export$71b17ee07540e13b = (rrule)=>{
    if (rrule.frequency === (0, $9eJ96.Frequencies).DAILY) {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(rrule.byDay, [
            (0, $9eJ96.Days).MO,
            (0, $9eJ96.Days).TU,
            (0, $9eJ96.Days).WE,
            (0, $9eJ96.Days).TH,
            (0, $9eJ96.Days).FR
        ])) return 'WEEKDAY';
        return 'DAILY';
    }
    if (rrule.frequency === (0, $9eJ96.Frequencies).WEEKLY) {
        if (rrule.interval === 2) return 'FORTNIGHTLY';
        return 'WEEKLY';
    }
};
const $c35d2016d68e7b8d$export$c7198a7e75d4478b = (rrule, isRecurOnComplete = false)=>{
    if (isRecurOnComplete) return (0, $5D9Ji.default).recursOnComplete;
    const frequency = $c35d2016d68e7b8d$export$71b17ee07540e13b(rrule);
    // Every business day (Monday to Friday)
    if (frequency === 'WEEKDAY') return (0, $5D9Ji.default).recursEveryWeekday;
    // Daily
    if (frequency === 'DAILY') return (0, $5D9Ji.default).recursDaily;
    // Fortnightly
    if (frequency === 'FORTNIGHTLY') return (0, $5D9Ji.default).recursEveryTwoWeeks;
    // Weekly
    if (frequency === 'WEEKLY') return (0, $5D9Ji.default).recursWeekly;
    return (0, $5D9Ji.default).setToRecur;
};
const $c35d2016d68e7b8d$var$byDayOptions = Object.values((0, $9eJ96.Days));
const $c35d2016d68e7b8d$var$getWeekDayNameFromByDay = (byDayValue, intl)=>{
    const dayIndex = $c35d2016d68e7b8d$var$byDayOptions.indexOf(byDayValue);
    if (dayIndex < 0) throw new Error(`Invalid ByDay value provided: ${byDayValue}. Valid options: ${$c35d2016d68e7b8d$var$byDayOptions}`);
    const firstDayOfWeek = (0, $1GF3c.default)(new Date(), {
        weekStartsOn: 1
    });
    const day = (0, $gwejS.default)(firstDayOfWeek, dayIndex);
    return intl.formatDate(day, {
        weekday: 'long'
    });
};
const $c35d2016d68e7b8d$export$5c6d45150d1588c0 = ({ byDayValues: byDayValues, intl: intl, standardizedLocale: standardizedLocale })=>new Intl.ListFormat(standardizedLocale, {
        style: 'long',
        type: 'conjunction'
    }).format(Array.from(byDayValues, (byDayValue)=>$c35d2016d68e7b8d$var$getWeekDayNameFromByDay(byDayValue, intl)));
const $c35d2016d68e7b8d$export$8eef89c3d24cb712 = ({ frequency: frequency, recurCondition: recurCondition, recurWeeklyConfig: recurWeeklyConfig, intl: intl, standardizedLocale: standardizedLocale, issueKey: issueKey, issueType: issueType })=>{
    const issueTypeLowercase = issueType.toLocaleLowerCase(standardizedLocale);
    switch(recurCondition){
        case 'SCHEDULE_IF_COMPLETE':
            switch(frequency){
                case 'DAILY':
                    return {
                        title: intl.formatMessage((0, $5D9Ji.default).successFlagTitleRecurOnScheduleIfCompleteDaily, {
                            issueKey: issueKey
                        }),
                        description: intl.formatMessage((0, $5D9Ji.default).successFlagDescriptionRecurOnScheduleIfCompleteDaily, {
                            issueType: issueTypeLowercase
                        })
                    };
                case 'WEEKDAY':
                    return {
                        title: intl.formatMessage((0, $5D9Ji.default).successFlagTitleRecurOnScheduleIfCompleteWeekday, {
                            issueKey: issueKey
                        }),
                        description: intl.formatMessage((0, $5D9Ji.default).successFlagDescriptionRecurOnScheduleIfCompleteWeekday, {
                            issueType: issueTypeLowercase
                        })
                    };
                case 'WEEKLY':
                    return {
                        title: intl.formatMessage((0, $5D9Ji.default).successFlagTitleRecurOnScheduleIfCompleteWeekly, {
                            issueKey: issueKey
                        }),
                        description: intl.formatMessage((0, $5D9Ji.default).successFlagDescriptionRecurOnScheduleIfCompleteWeekly, {
                            issueType: issueTypeLowercase,
                            weekDayNames: $c35d2016d68e7b8d$export$5c6d45150d1588c0({
                                byDayValues: recurWeeklyConfig ?? [],
                                intl: intl,
                                standardizedLocale: standardizedLocale
                            })
                        })
                    };
                case 'FORTNIGHTLY':
                    return {
                        title: intl.formatMessage((0, $5D9Ji.default).successFlagTitleRecurOnScheduleIfCompleteFortnightly, {
                            issueKey: issueKey
                        }),
                        description: intl.formatMessage((0, $5D9Ji.default).successFlagDescriptionRecurOnScheduleIfCompleteFortnightly, {
                            issueType: issueTypeLowercase,
                            weekDayNames: $c35d2016d68e7b8d$export$5c6d45150d1588c0({
                                byDayValues: recurWeeklyConfig ?? [],
                                intl: intl,
                                standardizedLocale: standardizedLocale
                            })
                        })
                    };
                default:
                    throw new Error(`Unknown frequency: ${frequency}`);
            }
        case 'SCHEDULE':
            switch(frequency){
                case 'DAILY':
                    return {
                        title: intl.formatMessage((0, $5D9Ji.default).successFlagTitleRecurOnScheduleDaily, {
                            issueKey: issueKey
                        })
                    };
                case 'WEEKDAY':
                    return {
                        title: intl.formatMessage((0, $5D9Ji.default).successFlagTitleRecurOnScheduleWeekday, {
                            issueKey: issueKey
                        })
                    };
                case 'WEEKLY':
                    return {
                        title: intl.formatMessage((0, $5D9Ji.default).successFlagTitleRecurOnScheduleWeekly, {
                            issueKey: issueKey,
                            weekDayNames: $c35d2016d68e7b8d$export$5c6d45150d1588c0({
                                byDayValues: recurWeeklyConfig ?? [],
                                intl: intl,
                                standardizedLocale: standardizedLocale
                            })
                        })
                    };
                case 'FORTNIGHTLY':
                    return {
                        title: intl.formatMessage((0, $5D9Ji.default).successFlagTitleRecurOnScheduleFortnightly, {
                            issueKey: issueKey,
                            weekDayNames: $c35d2016d68e7b8d$export$5c6d45150d1588c0({
                                byDayValues: recurWeeklyConfig ?? [],
                                intl: intl,
                                standardizedLocale: standardizedLocale
                            })
                        })
                    };
                default:
                    throw new Error(`Unknown frequency: ${frequency}`);
            }
        default:
            throw new Error(`Unknown recur condition: ${recurCondition}`);
    }
};
const $c35d2016d68e7b8d$export$b57843f38b80b500 = (issueProperties)=>{
    return !!issueProperties && !!issueProperties.token && (issueProperties.recurOnScheduleConfig === null || issueProperties.recurOnScheduleConfig === undefined);
};
const $c35d2016d68e7b8d$var$areByDaysEqual = ({ byDays: byDays, anotherByDays: anotherByDays })=>{
    // assumes lists have a consistent order
    if (byDays === undefined) return anotherByDays === undefined;
    if (anotherByDays === undefined) return false;
    if (byDays.length !== anotherByDays.length) return false;
    return byDays.every((byDay, index)=>byDay === anotherByDays[index]);
};
const $c35d2016d68e7b8d$var$areDatesEqual = (date1, date2)=>{
    if (date1 === undefined || date2 === undefined) return date1 === date2;
    // We only care about checking the date equality, not the time
    return date1.getFullYear() === date2.getFullYear() && date1.getMonth() === date2.getMonth() && date1.getDate() === date2.getDate();
};
const $c35d2016d68e7b8d$export$8dc77b9e863f46b = ({ formInput: formInput, formOutput: formOutput })=>{
    // comparing 2 recur-on-schedule rules
    if (formInput.frequency !== formOutput.frequency || formInput.condition !== formOutput.condition || !$c35d2016d68e7b8d$var$areDatesEqual(formInput.endsOn, formOutput.endsOn)) return true;
    if (formInput.frequency === 'WEEKLY' || formInput.frequency === 'FORTNIGHTLY') return !$c35d2016d68e7b8d$var$areByDaysEqual({
        byDays: formInput.byDay,
        anotherByDays: formOutput.byDay
    });
    return false;
};
const $c35d2016d68e7b8d$export$555109634e8a63b6 = (date, browserTimezone, userTimezone)=>{
    const browserTimezoneOffsetMs = (0, $7jns1.default)(browserTimezone);
    const userTimezoneOffsetMs = (0, $7jns1.default)(userTimezone);
    return (0, $bbVsP.default)((0, $jpR5P.default)(date, browserTimezoneOffsetMs), userTimezoneOffsetMs);
};

});
parcelRegister("9eJ96", function(module, exports) {

$parcel$export(module.exports, "NEWLINE_REGEX", () => $1079d16957e265b2$export$665ca7211e0c33c);
$parcel$export(module.exports, "FOLD_LINES_REGEX", () => $1079d16957e265b2$export$4b7f22f32fbb5949);
$parcel$export(module.exports, "LF", () => $1079d16957e265b2$export$606cfc2a8896c91f);
$parcel$export(module.exports, "NewlineCharacters", () => $1079d16957e265b2$export$ccae594c20078277);
$parcel$export(module.exports, "NewlineCharacterValues", () => $1079d16957e265b2$export$c3edd2b21ac02f88);
$parcel$export(module.exports, "Frequencies", () => $1079d16957e265b2$export$895ee510b2e84ade);
$parcel$export(module.exports, "Days", () => $1079d16957e265b2$export$d3134eff2123aadb);
$parcel$export(module.exports, "BEGIN_VEVENT", () => $1079d16957e265b2$export$67de00e87412dc6f);
$parcel$export(module.exports, "END_VEVENT", () => $1079d16957e265b2$export$987d86d2e891c4cb);
$parcel$export(module.exports, "DTSTART", () => $1079d16957e265b2$export$fd1a0e011a586e26);
$parcel$export(module.exports, "RRULE", () => $1079d16957e265b2$export$d86ed937a45b0291);
$parcel$export(module.exports, "ICalSpecificationFields", () => $1079d16957e265b2$export$98eba4d8ff00c139);
$parcel$export(module.exports, "ICalSupportedFields", () => $1079d16957e265b2$export$38b1323f325ffd22);
$parcel$export(module.exports, "TZID", () => $1079d16957e265b2$export$5b9a78912028c06d);
$parcel$export(module.exports, "DTStartProperties", () => $1079d16957e265b2$export$20184b745430719e);
$parcel$export(module.exports, "FREQ", () => $1079d16957e265b2$export$fb124b4fa837b262);
$parcel$export(module.exports, "UNTIL", () => $1079d16957e265b2$export$4cc4f35131ed029c);
$parcel$export(module.exports, "INTERVAL", () => $1079d16957e265b2$export$7dea0e6e08f87a8a);
$parcel$export(module.exports, "BYHOUR", () => $1079d16957e265b2$export$a764ed9c4884f76d);
$parcel$export(module.exports, "BYMINUTE", () => $1079d16957e265b2$export$7a96578de7a037b6);
$parcel$export(module.exports, "BYSECOND", () => $1079d16957e265b2$export$55bcca3bd8d3041f);
$parcel$export(module.exports, "BYDAY", () => $1079d16957e265b2$export$f512ea3e90612d03);
$parcel$export(module.exports, "BYMONTH", () => $1079d16957e265b2$export$b3203f635d74ce88);
$parcel$export(module.exports, "BYMONTHDAY", () => $1079d16957e265b2$export$15623ad945e92c4c);
$parcel$export(module.exports, "RRuleProperties", () => $1079d16957e265b2$export$7898bd020dba0a27);
$parcel$export(module.exports, "MISSING", () => $1079d16957e265b2$export$64c81710c321f252);
$parcel$export(module.exports, "EMPTY", () => $1079d16957e265b2$export$ccb33e29d92c9a58);
$parcel$export(module.exports, "INVALID", () => $1079d16957e265b2$export$9a105a556e65c2c0);
$parcel$export(module.exports, "VALID", () => $1079d16957e265b2$export$f3abe3d006c81602);
const $1079d16957e265b2$export$665ca7211e0c33c = /\r?\n/;
const $1079d16957e265b2$export$4b7f22f32fbb5949 = /\r?\n[ \t]/g; // match line breaks followed by a whitespace character (space or tab)
const $1079d16957e265b2$export$ae9ea0d00d3d8982 = 'CRLF';
const $1079d16957e265b2$export$a1f3f1ef020bdc3a = '\r\n';
const $1079d16957e265b2$export$606cfc2a8896c91f = 'LF';
const $1079d16957e265b2$export$477fea8aa280bb1e = '\n';
const $1079d16957e265b2$export$ccae594c20078277 = {
    CRLF: $1079d16957e265b2$export$ae9ea0d00d3d8982,
    LF: $1079d16957e265b2$export$606cfc2a8896c91f
};
const $1079d16957e265b2$export$c3edd2b21ac02f88 = {
    [$1079d16957e265b2$export$ae9ea0d00d3d8982]: $1079d16957e265b2$export$a1f3f1ef020bdc3a,
    [$1079d16957e265b2$export$606cfc2a8896c91f]: $1079d16957e265b2$export$477fea8aa280bb1e
};
const $1079d16957e265b2$export$895ee510b2e84ade = {
    SECONDLY: 'SECONDLY',
    MINUTELY: 'MINUTELY',
    HOURLY: 'HOURLY',
    DAILY: 'DAILY',
    WEEKLY: 'WEEKLY',
    MONTHLY: 'MONTHLY',
    YEARLY: 'YEARLY'
};
const $1079d16957e265b2$export$d3134eff2123aadb = {
    MO: 'MO',
    TU: 'TU',
    WE: 'WE',
    TH: 'TH',
    FR: 'FR',
    SA: 'SA',
    SU: 'SU'
};
const $1079d16957e265b2$export$f62540a8bebc4ed3 = 'BEGIN';
const $1079d16957e265b2$export$32239d68d9c6cb49 = 'END';
const $1079d16957e265b2$export$67de00e87412dc6f = 'BEGIN:VEVENT';
const $1079d16957e265b2$export$987d86d2e891c4cb = 'END:VEVENT';
const $1079d16957e265b2$export$fd1a0e011a586e26 = 'DTSTART';
const $1079d16957e265b2$export$d86ed937a45b0291 = 'RRULE';
const $1079d16957e265b2$export$913055729e1380b2 = 'SUMMARY';
const $1079d16957e265b2$export$87d0ca22edb7493a = 'LOCATION';
const $1079d16957e265b2$export$d44826c816b5619b = 'DESCRIPTION';
const $1079d16957e265b2$export$c8b4a4d253b84ce0 = 'UID';
const $1079d16957e265b2$export$34694f8d8b23ee2a = 'SEQUENCE';
const $1079d16957e265b2$export$e50006273435e7d4 = 'STATUS';
const $1079d16957e265b2$export$36034111438e3f25 = 'TRANSP';
const $1079d16957e265b2$export$bb34f3538ba26c7e = 'PRIORITY';
const $1079d16957e265b2$export$30dbcad954808285 = 'DTEND';
const $1079d16957e265b2$export$bacc88974c736870 = 'DURATION';
const $1079d16957e265b2$export$da3a32b38cbf59ba = 'ATTACH';
const $1079d16957e265b2$export$5e0bdf8bba8d5088 = 'ATTENDEE';
const $1079d16957e265b2$export$a513ea61a7bee91c = 'CATEGORIES';
const $1079d16957e265b2$export$a29989082612d0d9 = 'COMMENT';
const $1079d16957e265b2$export$11038cc09fdccb91 = 'CONTACT';
const $1079d16957e265b2$export$133ffe3c8efbf133 = 'EXDATE';
const $1079d16957e265b2$export$7e27a94778a9d7d7 = 'EXRULE';
const $1079d16957e265b2$export$3d166b1dacd2503a = 'RDATE';
const $1079d16957e265b2$export$47a1d4cd38dddc05 = 'RELATED-TO';
const $1079d16957e265b2$export$4e841128923ef26 = 'RESOURCES';
const $1079d16957e265b2$export$1c0dd28c42f2741e = 'RECURRENCE-ID';
const $1079d16957e265b2$export$61abde59b50deb8e = 'URL';
const $1079d16957e265b2$export$ff39ebd4bb12b718 = 'CREATED';
const $1079d16957e265b2$export$2ebcefe61501d5fe = 'DTSTAMP';
const $1079d16957e265b2$export$90812500f628da64 = 'LAST-MODIFIED';
const $1079d16957e265b2$export$5409f4c14bda7ac = 'ORGANIZER';
const $1079d16957e265b2$export$9fe99b3b71be9378 = 'REQUEST-STATUS';
const $1079d16957e265b2$export$98eba4d8ff00c139 = {
    BEGIN: $1079d16957e265b2$export$f62540a8bebc4ed3,
    END: $1079d16957e265b2$export$32239d68d9c6cb49,
    BEGIN_VEVENT: $1079d16957e265b2$export$67de00e87412dc6f,
    END_VEVENT: $1079d16957e265b2$export$987d86d2e891c4cb,
    SUMMARY: $1079d16957e265b2$export$913055729e1380b2,
    LOCATION: $1079d16957e265b2$export$87d0ca22edb7493a,
    DESCRIPTION: $1079d16957e265b2$export$d44826c816b5619b,
    UID: $1079d16957e265b2$export$c8b4a4d253b84ce0,
    SEQUENCE: $1079d16957e265b2$export$34694f8d8b23ee2a,
    STATUS: $1079d16957e265b2$export$e50006273435e7d4,
    TRANSP: $1079d16957e265b2$export$36034111438e3f25,
    PRIORITY: $1079d16957e265b2$export$bb34f3538ba26c7e,
    DTSTART: $1079d16957e265b2$export$fd1a0e011a586e26,
    RRULE: $1079d16957e265b2$export$d86ed937a45b0291,
    DTEND: $1079d16957e265b2$export$30dbcad954808285,
    DURATION: $1079d16957e265b2$export$bacc88974c736870,
    ATTACH: $1079d16957e265b2$export$da3a32b38cbf59ba,
    ATTENDEE: $1079d16957e265b2$export$5e0bdf8bba8d5088,
    CATEGORIES: $1079d16957e265b2$export$a513ea61a7bee91c,
    COMMENT: $1079d16957e265b2$export$a29989082612d0d9,
    CONTACT: $1079d16957e265b2$export$11038cc09fdccb91,
    EXDATE: $1079d16957e265b2$export$133ffe3c8efbf133,
    EXRULE: $1079d16957e265b2$export$7e27a94778a9d7d7,
    RDATE: $1079d16957e265b2$export$3d166b1dacd2503a,
    RELATED_TO: $1079d16957e265b2$export$47a1d4cd38dddc05,
    RESOURCES: $1079d16957e265b2$export$4e841128923ef26,
    RECURRENCE_ID: $1079d16957e265b2$export$1c0dd28c42f2741e,
    URL: $1079d16957e265b2$export$61abde59b50deb8e,
    CREATED: $1079d16957e265b2$export$ff39ebd4bb12b718,
    DTSTAMP: $1079d16957e265b2$export$2ebcefe61501d5fe,
    LAST_MODIFIED: $1079d16957e265b2$export$90812500f628da64,
    ORGANIZER: $1079d16957e265b2$export$5409f4c14bda7ac,
    REQUEST_STATUS: $1079d16957e265b2$export$9fe99b3b71be9378
};
const $1079d16957e265b2$export$38b1323f325ffd22 = {
    DTSTART: $1079d16957e265b2$export$fd1a0e011a586e26,
    RRULE: $1079d16957e265b2$export$d86ed937a45b0291
};
const $1079d16957e265b2$export$5b9a78912028c06d = 'TZID';
const $1079d16957e265b2$export$20184b745430719e = {
    DTSTART: $1079d16957e265b2$export$fd1a0e011a586e26,
    TZID: $1079d16957e265b2$export$5b9a78912028c06d
};
const $1079d16957e265b2$export$fb124b4fa837b262 = 'FREQ';
const $1079d16957e265b2$export$4cc4f35131ed029c = 'UNTIL';
const $1079d16957e265b2$export$7dea0e6e08f87a8a = 'INTERVAL';
const $1079d16957e265b2$export$a764ed9c4884f76d = 'BYHOUR';
const $1079d16957e265b2$export$7a96578de7a037b6 = 'BYMINUTE';
const $1079d16957e265b2$export$55bcca3bd8d3041f = 'BYSECOND';
const $1079d16957e265b2$export$f512ea3e90612d03 = 'BYDAY';
const $1079d16957e265b2$export$b3203f635d74ce88 = 'BYMONTH';
const $1079d16957e265b2$export$15623ad945e92c4c = 'BYMONTHDAY';
const $1079d16957e265b2$export$7898bd020dba0a27 = {
    FREQ: $1079d16957e265b2$export$fb124b4fa837b262,
    UNTIL: $1079d16957e265b2$export$4cc4f35131ed029c,
    INTERVAL: $1079d16957e265b2$export$7dea0e6e08f87a8a,
    BYHOUR: $1079d16957e265b2$export$a764ed9c4884f76d,
    BYMINUTE: $1079d16957e265b2$export$7a96578de7a037b6,
    BYSECOND: $1079d16957e265b2$export$55bcca3bd8d3041f,
    BYDAY: $1079d16957e265b2$export$f512ea3e90612d03,
    BYMONTH: $1079d16957e265b2$export$b3203f635d74ce88,
    BYMONTHDAY: $1079d16957e265b2$export$15623ad945e92c4c
};
const $1079d16957e265b2$export$64c81710c321f252 = 'MISSING';
const $1079d16957e265b2$export$ccb33e29d92c9a58 = 'EMPTY';
const $1079d16957e265b2$export$9a105a556e65c2c0 = 'INVALID';
const $1079d16957e265b2$export$f3abe3d006c81602 = 'VALID';

});

parcelRegister("5D9Ji", function(module, exports) {

$parcel$export(module.exports, "default", () => $f056e68da25dd6c2$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $f056e68da25dd6c2$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    formTitle: {
        "id": "recur-work-item.form-title",
        "defaultMessage": "Set to recur"
    },
    saveButtonText: {
        "id": "recur-work-item.save-button-text",
        "defaultMessage": "Save"
    },
    cancelButtonText: {
        "id": "recur-work-item.cancel-button-text",
        "defaultMessage": "Cancel"
    },
    deleteButtonText: {
        "id": "recur-work-item.delete-button-text",
        "defaultMessage": "Delete"
    },
    recurFieldsLabel: {
        "id": "recur-work-item.recur-fields-label",
        "defaultMessage": "Recur"
    },
    setToRecur: {
        "id": "recur-work-item.set-to-recur",
        "defaultMessage": "Set to recur"
    },
    recursDaily: {
        "id": "recur-work-item.recurs-daily",
        "defaultMessage": "Recurs daily"
    },
    recursEveryWeekday: {
        "id": "recur-work-item.recurs-every-weekday",
        "defaultMessage": "Every weekday (Monday to Friday)"
    },
    recursWeekly: {
        "id": "recur-work-item.recurs-weekly",
        "defaultMessage": "Recurs weekly"
    },
    recursEveryTwoWeeks: {
        "id": "recur-work-item.recurs-every-two-weeks",
        "defaultMessage": "Recurs every 2 weeks"
    },
    recursOnComplete: {
        "id": "recur-work-item.recurs-on-complete",
        "defaultMessage": "Recurs when completed"
    },
    successFlagTitleRecurOnScheduleIfCompleteDaily: {
        "id": "recur-work-item.success-flag-title-recur-on-schedule-if-complete-daily",
        "defaultMessage": "{issueKey} recurs every day"
    },
    successFlagTitleRecurOnScheduleIfCompleteWeekday: {
        "id": "recur-work-item.success-flag-title-recur-on-schedule-if-complete-weekday",
        "defaultMessage": "{issueKey} recurs every weekday"
    },
    successFlagTitleRecurOnScheduleIfCompleteWeekly: {
        "id": "recur-work-item.success-flag-title-recur-on-schedule-if-complete-weekly",
        "defaultMessage": "{issueKey} recurs every week"
    },
    successFlagTitleRecurOnScheduleIfCompleteFortnightly: {
        "id": "recur-work-item.success-flag-title-recur-on-schedule-if-complete-fortnightly",
        "defaultMessage": "{issueKey} recurs every 2 weeks"
    },
    successFlagDescriptionRecurOnScheduleIfCompleteDaily: {
        "id": "recur-work-item.success-flag-description-recur-on-schedule-if-complete-daily",
        "defaultMessage": "This {issueType} recurs daily when completed"
    },
    successFlagDescriptionRecurOnScheduleIfCompleteWeekday: {
        "id": "recur-work-item.success-flag-description-recur-on-schedule-if-complete-weekday",
        "defaultMessage": "This {issueType} recurs every weekday when completed"
    },
    successFlagDescriptionRecurOnScheduleIfCompleteWeekly: {
        "id": "recur-work-item.success-flag-description-recur-on-schedule-if-complete-weekly",
        "defaultMessage": "This {issueType} recurs weekly on {weekDayNames} when completed"
    },
    successFlagDescriptionRecurOnScheduleIfCompleteFortnightly: {
        "id": "recur-work-item.success-flag-description-recur-on-schedule-if-complete-fortnightly",
        "defaultMessage": "This {issueType} recurs every 2 weeks on {weekDayNames} when completed"
    },
    successFlagTitleRecurOnScheduleDaily: {
        "id": "recur-work-item.success-flag-title-recur-on-schedule-daily",
        "defaultMessage": "{issueKey} recurs every day"
    },
    successFlagTitleRecurOnScheduleWeekday: {
        "id": "recur-work-item.success-flag-title-recur-on-schedule-weekday",
        "defaultMessage": "{issueKey} recurs every weekday"
    },
    successFlagTitleRecurOnScheduleWeekly: {
        "id": "recur-work-item.success-flag-title-recur-on-schedule-weekly",
        "defaultMessage": "{issueKey} recurs every week on {weekDayNames}"
    },
    successFlagTitleRecurOnScheduleFortnightly: {
        "id": "recur-work-item.success-flag-title-recur-on-schedule-fortnightly",
        "defaultMessage": "{issueKey} recurs every 2 weeks on {weekDayNames}"
    },
    goBackLabel: {
        "id": "recur-work-item.go-back-label",
        "defaultMessage": "Go back"
    },
    errorFlagReloadPageButton: {
        "id": "recur-work-item.error-flag-reload-page-button",
        "defaultMessage": "Reload page"
    },
    errorFlagDescription: {
        "id": "recur-work-item.error-flag-description",
        "defaultMessage": "If this keeps happening, share this information with your admin, who should <link>contact support</link>."
    },
    errorFlagTitle: {
        "id": "recur-work-item.error-flag-title",
        "defaultMessage": "Something went wrong on our end"
    }
});

});



parcelRegister("l9xxv", function(module, exports) {

$parcel$export(module.exports, "setAsNonRecurringIssue", () => $867e9b1c0261db63$export$7b76980c59e9a391);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $8zOmE = parcelRequire("8zOmE");

var $lQupu = parcelRequire("lQupu");

var $fAJ3G = parcelRequire("fAJ3G");

var $519t2 = parcelRequire("519t2");
const $867e9b1c0261db63$export$7b76980c59e9a391 = ({ isProjectAdmin: isProjectAdmin, isRuleOwner: isRuleOwner, isSiteAdmin: isSiteAdmin, skipDeletingIssueProperties: skipDeletingIssueProperties = false })=>async ({ setState: setState, getState: getState }, { createAnalyticsEvent: createAnalyticsEvent, issueKey: issueKey, environment: environment, cloudId: cloudId, projectId: projectId })=>{
        const { issueProperties: issueProperties, errors: errors, isUpdatingRule: isUpdatingRule } = getState();
        // this can't be !automationRuleUuid because recur-on-complete rules won't have an
        // automationRuleUuid, but they will have issueProperties
        if (!issueProperties) {
            const error = new Error('User is trying to delete a rule before the rule data has been stored.');
            setState({
                errors: [
                    ...errors ?? [],
                    error
                ]
            });
            throw error;
        }
        if (!isSiteAdmin && !isProjectAdmin && !isRuleOwner) {
            const error = new Error('User does not have permission to set issue as non-recurring.');
            setState({
                // TODO: decide if we want to be appending to this list or overwriting it
                errors: [
                    ...errors ?? [],
                    error
                ]
            });
            throw error;
        }
        const { automationRuleUuid: ruleUuid, templateId: templateId, recurOnScheduleConfig: recurOnScheduleConfig } = issueProperties;
        if (skipDeletingIssueProperties && !ruleUuid) // nothing to do
        return;
        setState({
            isDeletingRule: true
        });
        const analyticsEvent = createAnalyticsEvent({});
        // delete or disable the rule if we know the rule UUID
        if (ruleUuid) try {
            if (isRuleOwner || isSiteAdmin) {
                await (0, $519t2.callServiceWithAnalytics)(analyticsEvent, (0, $fAJ3G.deleteRule)({
                    environment: environment,
                    cloudId: cloudId,
                    projectId: projectId,
                    ruleUuid: ruleUuid
                }), 'deleteRule');
                (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'recurringRule deleted', {
                    issueKey: // TODO: add ruleId attribute
                    issueKey,
                    ruleUuid: ruleUuid,
                    templateId: templateId,
                    recurCondition: recurOnScheduleConfig?.recurCondition,
                    isUpdateForExistingRule: isUpdatingRule
                });
            } else {
                await (0, $519t2.callServiceWithAnalytics)(analyticsEvent, (0, $fAJ3G.disableRule)({
                    environment: environment,
                    cloudId: cloudId,
                    projectId: projectId,
                    ruleUuid: ruleUuid
                }), 'disableRule');
                (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'recurringRule disabled', {
                    issueKey: // TODO: add ruleId attribute
                    issueKey,
                    ruleUuid: ruleUuid,
                    templateId: templateId,
                    recurCondition: recurOnScheduleConfig?.recurCondition,
                    isUpdateForExistingRule: isUpdatingRule
                });
            }
        } catch (error) {
            // abort if the rule cannot be deleted/disabled
            setState({
                isDeletingRule: false,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                errors: [
                    ...errors ?? [],
                    error
                ]
            });
            throw error;
        }
        if (skipDeletingIssueProperties) {
            // we only get here if we've successfully deleted/disabled a recur-on-schedule rule.
            // it's not possible to re-enable disabled rules, so we can assume that the rule will
            // no longer generate future work items. this means that the issue's issue properties
            // are no longer important to store.
            setState({
                isDeletingRule: false,
                ...(0, $lQupu.NO_RULE_PARTIAL_STATE)
            });
            return;
        }
        try {
            await (0, $519t2.callServiceWithAnalytics)(analyticsEvent, (0, $fAJ3G.deleteIssueProperties)({
                issueKey: issueKey
            }), 'deleteIssueProperties');
            setState({
                isDeletingRule: false,
                ...(0, $lQupu.NO_RULE_PARTIAL_STATE)
            });
        } catch (error) {
            if (!ruleUuid) {
                // in this case, we haven't deleted or disabled the rule, so the rule can still generate
                // future work items. we leave the rule stored in state unchanged and rethrow the error.
                setState({
                    isDeletingRule: false,
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    errors: [
                        ...errors ?? [],
                        error
                    ]
                });
                throw error;
            }
            // don't rethrow because from the user's perspective, the work item is no longer recurring.
            setState({
                isDeletingRule: false,
                ...(0, $lQupu.NO_RULE_PARTIAL_STATE),
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                errors: [
                    ...errors ?? [],
                    error
                ]
            });
        }
    };

});
parcelRegister("lQupu", function(module, exports) {

$parcel$export(module.exports, "INITIAL_STATE", () => $6bdecc95b0135cf9$export$36d128238e6b60f5);
$parcel$export(module.exports, "NO_RULE_PARTIAL_STATE", () => $6bdecc95b0135cf9$export$a1b15f9b9ceb0f70);
const $6bdecc95b0135cf9$export$36d128238e6b60f5 = {
    hasFetched: false,
    isFetching: false,
    isCreatingRule: false,
    isDeletingRule: false,
    isUpdatingRule: false,
    errors: null,
    hasBootstrapError: false,
    isRuleOwner: null,
    issueProperties: null
};
const $6bdecc95b0135cf9$export$a1b15f9b9ceb0f70 = {
    isRuleOwner: null,
    issueProperties: null
};

});


parcelRegister("bvhsR", function(module, exports) {

$parcel$export(module.exports, "setAsRecurringIssue", () => $fe7808073e642503$export$5d9cc8e9f9314f21);

var $7Jxgt = parcelRequire("7Jxgt");

var $8zOmE = parcelRequire("8zOmE");

var $cS75I = parcelRequire("cS75I");

var $ahBjy = parcelRequire("ahBjy");

var $519t2 = parcelRequire("519t2");
const $fe7808073e642503$export$5d9cc8e9f9314f21 = ({ recurOnScheduleConfig: { rRule: rRule, recurCondition: recurCondition, dueDateOffsetSmartValue: dueDateOffsetSmartValue } })=>async ({ setState: setState, getState: getState }, { createAnalyticsEvent: createAnalyticsEvent, issueKey: issueKey, environment: environment, cloudId: cloudId, projectId: projectId })=>{
        const { errors: errors, isUpdatingRule: isUpdatingRule } = getState();
        setState({
            isCreatingRule: true
        });
        const recurrenceToken = (0, $7Jxgt.v4)();
        const templateId = (0, $ahBjy.SOFTWARE_END_USER_TEMPLATE_2);
        const analyticsEvent = createAnalyticsEvent({});
        try {
            const createTemplateResponse = await (0, $519t2.callServiceWithAnalytics)(analyticsEvent, (0, $cS75I.createTemplate)({
                environment: environment,
                cloudId: cloudId,
                projectId: projectId,
                recurrenceToken: recurrenceToken,
                recurCondition: recurCondition,
                rRule: rRule,
                dueDateOffsetSmartValue: dueDateOffsetSmartValue
            }), 'createTemplate');
            if (createTemplateResponse?.ruleUuid) {
                await (0, $519t2.callServiceWithAnalytics)(analyticsEvent, (0, $cS75I.setIssueProperties)({
                    issueKey: issueKey,
                    recurrenceToken: recurrenceToken,
                    ruleUuid: createTemplateResponse.ruleUuid,
                    recurCondition: recurCondition,
                    rRule: rRule,
                    templateId: templateId,
                    dueDateOffsetSmartValue: dueDateOffsetSmartValue
                }), 'setIssueProperties');
                (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'recurringRule created', {
                    issueKey: // TODO: add ruleId attribute
                    issueKey,
                    ruleUuid: createTemplateResponse.ruleUuid,
                    templateId: templateId,
                    recurCondition: recurCondition,
                    isUpdateForExistingRule: isUpdatingRule
                });
                const issueProperties = {
                    automationRuleUuid: createTemplateResponse.ruleUuid,
                    token: recurrenceToken,
                    templateId: templateId,
                    recurOnScheduleConfig: {
                        rRule: rRule,
                        dueDateOffsetSmartValue: dueDateOffsetSmartValue,
                        recurCondition: recurCondition
                    }
                };
                setState({
                    isCreatingRule: false,
                    issueProperties: issueProperties,
                    isRuleOwner: true
                });
            } else throw new Error('New rule failed to be created.');
        } catch (error) {
            setState({
                isCreatingRule: false,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                errors: [
                    ...errors ?? [],
                    error
                ]
            });
            throw error;
        }
    };

});
parcelRegister("cS75I", function(module, exports) {

$parcel$export(module.exports, "createTemplate", () => $d425ed86c31f35f6$export$7b7ae612b60e1630);
$parcel$export(module.exports, "setIssueProperties", () => $d425ed86c31f35f6$export$5153917efea4a83d);

var $kV9ss = parcelRequire("kV9ss");

var $c5wox = parcelRequire("c5wox");

var $eusud = parcelRequire("eusud");

var $ahBjy = parcelRequire("ahBjy");
const $d425ed86c31f35f6$export$7b7ae612b60e1630 = async ({ environment: environment, cloudId: cloudId, projectId: projectId, recurrenceToken: recurrenceToken, recurCondition: recurCondition, rRule: rRule, dueDateOffsetSmartValue: dueDateOffsetSmartValue })=>{
    const automationStack = await (0, $c5wox.getAutomationStack)(environment, cloudId);
    const CREATE_TEMPLATE_URL = `/gateway/api/automation/internal-api/jira/${cloudId}/${automationStack}/public/rest/v1/template/create`;
    const ruleHomeARI = (0, $kV9ss.JiraProjectAri).create({
        siteId: cloudId,
        projectId: String(projectId)
    });
    const payload = {
        ruleHome: ruleHomeARI,
        templateId: (0, $ahBjy.SOFTWARE_END_USER_TEMPLATE_2),
        parameters: {
            recurrenceToken: {
                value: recurrenceToken,
                type: 'TEXT'
            },
            rRule: {
                value: rRule,
                type: 'TEXT'
            },
            dueDateOffsetSmartValue: {
                value: dueDateOffsetSmartValue,
                type: 'TEXT'
            },
            recurCondition: {
                value: recurCondition,
                type: 'TEXT'
            }
        }
    };
    return (0, $eusud.performPostRequest)(CREATE_TEMPLATE_URL, {
        body: JSON.stringify(payload)
    });
};
const $d425ed86c31f35f6$export$5153917efea4a83d = async ({ issueKey: issueKey, ruleUuid: ruleUuid, recurrenceToken: recurrenceToken, recurCondition: recurCondition, rRule: rRule, templateId: templateId, dueDateOffsetSmartValue: dueDateOffsetSmartValue })=>{
    const issuePropertiesEndpoint = `/rest/api/2/issue/${issueKey}/properties/recurrence-config`;
    const requestBody = {
        automationRuleUuid: ruleUuid,
        token: recurrenceToken,
        templateId: templateId,
        recurOnScheduleConfig: {
            rRule: rRule,
            dueDateOffsetSmartValue: dueDateOffsetSmartValue,
            recurCondition: recurCondition
        }
    };
    return (0, $eusud.performPutRequest)(issuePropertiesEndpoint, {
        body: JSON.stringify(requestBody)
    });
};

});


parcelRegister("c8g0F", function(module, exports) {

$parcel$export(module.exports, "updateRule", () => $257e932348ccd8c0$export$b2ebf395d72c5a4c);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $8zOmE = parcelRequire("8zOmE");

var $fAJ3G = parcelRequire("fAJ3G");

var $519t2 = parcelRequire("519t2");

var $bvhsR = parcelRequire("bvhsR");

var $l9xxv = parcelRequire("l9xxv");
const $257e932348ccd8c0$export$b2ebf395d72c5a4c = ({ isProjectAdmin: isProjectAdmin, isRuleOwner: isRuleOwner, isSiteAdmin: isSiteAdmin, recurOnScheduleConfig: recurOnScheduleConfig })=>async ({ setState: setState, getState: getState, dispatch: dispatch }, { createAnalyticsEvent: createAnalyticsEvent, issueKey: issueKey })=>{
        const { issueProperties: issueProperties, errors: errors } = getState();
        if (!issueProperties) {
            // if there is no existing rule, then create a new rule and update issue properties
            await dispatch((0, $bvhsR.setAsRecurringIssue)({
                recurOnScheduleConfig: recurOnScheduleConfig
            }));
            return;
        }
        const { automationRuleUuid: ruleUuid, templateId: templateId } = issueProperties;
        setState({
            isUpdatingRule: true
        });
        try {
            await dispatch((0, $l9xxv.setAsNonRecurringIssue)({
                isProjectAdmin: isProjectAdmin,
                isRuleOwner: isRuleOwner,
                isSiteAdmin: isSiteAdmin,
                // we'll update issue properties later
                skipDeletingIssueProperties: true
            }));
        } catch (error) {
            // don't need to save the error to state because setAsNonRecurringIssue should already do this
            setState({
                isUpdatingRule: false
            });
            throw error;
        }
        // create the new rule
        try {
            await dispatch((0, $bvhsR.setAsRecurringIssue)({
                recurOnScheduleConfig: recurOnScheduleConfig
            }));
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'recurringRule updated', {
                issueKey: // TODO: add ruleId attribute
                issueKey,
                ruleUuid: ruleUuid,
                templateId: templateId,
                recurCondition: recurOnScheduleConfig?.recurCondition,
                isUpdateForExistingRule: true
            });
            setState({
                isUpdatingRule: false
            });
        } catch (error) {
            // if we fail to create the rule and update issue properties, then we need to go back and remove the
            // original recurring rule config from issue properties
            try {
                setState({
                    isDeletingRule: true
                });
                await (0, $519t2.callServiceWithAnalytics)(createAnalyticsEvent({}), (0, $fAJ3G.deleteIssueProperties)({
                    issueKey: issueKey
                }), 'deleteIssueProperties');
                setState({
                    isDeletingRule: false,
                    isUpdatingRule: false,
                    issueProperties: null,
                    isRuleOwner: null,
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    errors: [
                        ...errors ?? [],
                        error
                    ]
                });
            } catch (anotherError) {
                // we've made no changes to the rule config since we called `setAsNonRecurringIssue` above,
                // so we don't need to update ruleSummary or issueProperties.
                setState({
                    isDeletingRule: false,
                    isUpdatingRule: false,
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    errors: [
                        ...errors ?? [],
                        error,
                        anotherError
                    ]
                });
                throw anotherError;
            }
            // we've just successfully deleted the existing rule; we haven't actually created a new one.
            throw error;
        }
    };

});



parcelRegister("CKlOf", function(module, exports) {

$parcel$export(module.exports, "messages", () => $d9e9728e1365538b$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $d9e9728e1365538b$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    overdue: {
        "id": "business.list.ui.list-view.date-cell.overdue",
        "defaultMessage": "Overdue since {date}"
    },
    due: {
        "id": "business.list.ui.list-view.date-cell.due",
        "defaultMessage": "Due on {date}"
    }
});

});



parcelRegister("js19Q", function(module, exports) {

$parcel$export(module.exports, "CardKey", () => $99ce87eb455c0195$export$5bcc49a1014b751b);
/* CardKey.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $k2wwp = parcelRequire("k2wwp");
const $99ce87eb455c0195$export$5bcc49a1014b751b = ({ highlight: highlight, text: text })=>{
    return /*#__PURE__*/ $5uXOq.createElement("div", {
        className: (0, $bwpsq.default)([
            $99ce87eb455c0195$var$styles.root
        ])
    }, /*#__PURE__*/ $5uXOq.createElement("div", {
        className: (0, $bwpsq.default)([
            $99ce87eb455c0195$var$styles.key
        ])
    }, /*#__PURE__*/ $5uXOq.createElement((0, $k2wwp.default), {
        highlight: highlight ?? null,
        text: text
    })));
};
const $99ce87eb455c0195$var$styles = {
    root: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _1ul9idpf _o5721q9c",
    key: "_1reo15vq _18m915vq _11c8dcr7 _1bto1l2s _k48p1pd9 _syaz1gjq"
};

});

parcelRegister("hyu2M", function(module, exports) {

$parcel$export(module.exports, "CardPriority", () => $25e2a64d0542820a$export$92d93d4ee23c212c);
/* CardPriority.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $fPIjH = parcelRequire("fPIjH");
const $25e2a64d0542820a$export$92d93d4ee23c212c = ({ name: name, uri: uri })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const label = formatMessage((0, $fPIjH.default).priorityTooltip, {
        priorityLevel: name
    });
    return /*#__PURE__*/ $5uXOq.createElement((0, $3bDjY.default), {
        content: label
    }, /*#__PURE__*/ $5uXOq.createElement("img", {
        alt: label,
        src: uri,
        className: (0, $bwpsq.default)([
            $25e2a64d0542820a$var$styles.root
        ])
    }));
};
const $25e2a64d0542820a$var$styles = {
    root: "_1e0c1txw _4t3i7vkz _1bsb7vkz _kqswh2mm _lcxv1wug"
};

});
parcelRegister("fPIjH", function(module, exports) {

$parcel$export(module.exports, "default", () => $d937695924fab396$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $d937695924fab396$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    priorityTooltip: {
        "id": "work-management-board.board.column.card.card-content.card-priority.priority-tooltip",
        "defaultMessage": "{priorityLevel} priority"
    }
});

});


parcelRegister("7b2Jf", function(module, exports) {

$parcel$export(module.exports, "CardTick", () => $14340c73e253ffdf$export$711ec40e911e6898);
/* CardTick.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $3bDjY = parcelRequire("3bDjY");

var $f22iM = parcelRequire("f22iM");

var $koVbs = parcelRequire("koVbs");

var $aefDr = parcelRequire("aefDr");
const $14340c73e253ffdf$export$711ec40e911e6898 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ $5uXOq.createElement("div", {
        className: (0, $bwpsq.default)([
            $14340c73e253ffdf$var$styles.root
        ])
    }, /*#__PURE__*/ $5uXOq.createElement((0, $3bDjY.default), {
        content: formatMessage((0, $aefDr.default).done)
    }, /*#__PURE__*/ $5uXOq.createElement((0, (/*@__PURE__*/$parcel$interopDefault($f22iM))), {
        color: "var(--ds-icon-success, #22A06B)",
        label: ""
    })));
};
const $14340c73e253ffdf$var$styles = {
    root: "_kqswh2mm _lcxv1wug"
};

});
parcelRegister("f22iM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4f681ccdbe722d68d6bd374c0928f0bd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $af18d40ba5b744b4$var$_react = $af18d40ba5b744b4$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $af18d40ba5b744b4$var$_baseNew = $af18d40ba5b744b4$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $af18d40ba5b744b4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckMark".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: 📦 @atlaskit/icon/utility/check-mark
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $af18d40ba5b744b4$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $af18d40ba5b744b4$var$_react.default.createElement($af18d40ba5b744b4$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m11.06 3-6.25 7a.75.75 0 0 1-1.15-.037l-2.75-3.5 1.18-.926 2.197 2.796L9.94 2z" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$af18d40ba5b744b4$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
var $af18d40ba5b744b4$var$_default = module.exports.default = $af18d40ba5b744b4$var$CheckMarkIcon;

});

parcelRegister("aefDr", function(module, exports) {

$parcel$export(module.exports, "default", () => $21cd80f1d9b08585$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $21cd80f1d9b08585$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    done: {
        "id": "work-management-board.board.column.card.card-content.card-tick.done",
        "defaultMessage": "Done"
    }
});

});


parcelRegister("91Gw4", function(module, exports) {

$parcel$export(module.exports, "CardDetailFields", () => $26f4a32bc9c72642$export$9371dc9f612e169c);

var $gz7Oc = parcelRequire("gz7Oc");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $ujWmd = parcelRequire("ujWmd");

var $jnhNB = parcelRequire("jnhNB");

var $16T6Y = parcelRequire("16T6Y");

var $3u0c5 = parcelRequire("3u0c5");

var $d9xxV = parcelRequire("d9xxV");

var $DhnKp = parcelRequire("DhnKp");

var $koVbs = parcelRequire("koVbs");

var $6ZEN7 = parcelRequire("6ZEN7");

var $5fc53 = parcelRequire("5fc53");

var $4kK95 = parcelRequire("4kK95");

var $3uhPk = parcelRequire("3uhPk");

var $cvj5l = parcelRequire("cvj5l");
const $26f4a32bc9c72642$var$DATE_FORMAT_OPTIONS = {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
};
const $26f4a32bc9c72642$var$TimeStampCss = {
    whenDisplaySettingSwitchable: null
};
const $26f4a32bc9c72642$var$parentFieldRenderer = ({ field: field })=>field.type === (0, $cvj5l.BOARD_FIELD_PARENT) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        key: field.fieldId,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1n261g80 _4cvr1h6o _gy1p1b66 _y08e1osq _18u0ze3t"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3u0c5.default), {
        isBold: true
    }, `${field.parent?.key} ${field.parent?.summary}`));
const $26f4a32bc9c72642$var$categoryFieldRenderer = ({ field: field })=>field.type === (0, $cvj5l.BOARD_FIELD_CATEGORY) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        key: field.fieldId,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1n261g80 _4cvr1h6o _gy1p1b66 _y08e1osq _18u0ze3t",
            "_18u0r5cr"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _11c81o8v _syaz131l _1bsb1osq _1bto1l2s _o5721q9c _k48p1wq8 _18u0ze3t",
            "_18u01b66"
        ])
    }, field.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_ca0q1b66 _19bv1b66 _1ul9idpf"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $DhnKp.default), {
        categoryName: field.category.name,
        categoryColor: field.category.color
    })));
const $26f4a32bc9c72642$var$componentFieldRenderer = ({ field: field })=>field.type === (0, $cvj5l.BOARD_FIELD_COMPONENTS) && field.value.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        key: field.fieldId,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1n261g80 _4cvr1h6o _gy1p1b66 _y08e1osq _18u0ze3t",
            "_18u0r5cr"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _11c81o8v _syaz131l _1bsb1osq _1bto1l2s _o5721q9c _k48p1wq8 _18u0ze3t",
            "_18u01b66"
        ])
    }, field.name), field.value.map((component)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d9xxV.default), {
            key: component,
            text: component
        })));
const $26f4a32bc9c72642$var$dateRenderer = ({ field: field, formatDate: formatDate })=>field.type === (0, $cvj5l.BOARD_FIELD_DATE) && field.value != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        key: field.fieldId,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1n261g80 _4cvr1h6o _gy1p1b66 _y08e1osq _18u0ze3t"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _11c81o8v _syaz131l _1bsb1osq _1bto1l2s _o5721q9c _k48p1wq8 _18u0ze3t"
        ])
    }, field.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        className: (0, $bwpsq.default)([
            "_11c8dcr7 _syaz1fxt"
        ])
    }, formatDate((0, $4kK95.DateOnly).fromISODateString(field.value))));
const $26f4a32bc9c72642$var$textAndNumberRenderer = ({ field: field, formatNumber: formatNumber })=>(field.type === (0, $cvj5l.BOARD_FIELD_TEXT) || field.type === (0, $cvj5l.BOARD_FIELD_FLOAT)) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        key: field.fieldId,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1n261g80 _4cvr1h6o _gy1p1b66 _y08e1osq _18u0ze3t"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _11c81o8v _syaz131l _1bsb1osq _1bto1l2s _o5721q9c _k48p1wq8 _18u0ze3t"
        ])
    }, field.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        className: (0, $bwpsq.default)([
            "_11c8dcr7 _syaz1fxt"
        ])
    }, field.type === (0, $cvj5l.BOARD_FIELD_FLOAT) ? formatNumber(field.value) : field.value));
const $26f4a32bc9c72642$var$dateTimeRenderer = ({ field: field, TimeStampComponent: TimeStampComponent })=>field.type === (0, $cvj5l.BOARD_FIELD_DATE_TIME) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        key: field.fieldId,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1n261g80 _4cvr1h6o _gy1p1b66 _y08e1osq _18u0ze3t"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _11c81o8v _syaz131l _1bsb1osq _1bto1l2s _o5721q9c _k48p1wq8 _18u0ze3t"
        ])
    }, field.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        className: (0, $bwpsq.default)([
            "_11c8dcr7 _syaz1fxt _30l31gjq",
            "_kqswh2mm _lcxv1wug"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(TimeStampComponent, {
        value: field.value,
        extraStyles: $26f4a32bc9c72642$var$TimeStampCss
    })));
const $26f4a32bc9c72642$var$userRenderer = ({ field: field })=>field.type === (0, $cvj5l.BOARD_FIELD_USER) && field.user && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        key: field.fieldId,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1n261g80 _4cvr1h6o _gy1p1b66 _y08e1osq _18u0ze3t"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _11c81o8v _syaz131l _1bsb1osq _1bto1l2s _o5721q9c _k48p1wq8 _18u0ze3t"
        ])
    }, field.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_kqswh2mm _lcxv1wug"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
        name: field.user.name,
        src: field.user.avatarURL ?? undefined,
        size: "small"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        className: (0, $bwpsq.default)([
            "_11c8dcr7 _syaz1fxt"
        ])
    }, field.user.name));
const $26f4a32bc9c72642$var$multiUserRenderer = ({ field: field })=>field.type === (0, $cvj5l.BOARD_FIELD_MULTI_USER) && field.users.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        key: field.fieldId,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1n261g80 _4cvr1h6o _gy1p1b66 _y08e1osq _18u0ze3t"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _11c81o8v _syaz131l _1bsb1osq _1bto1l2s _o5721q9c _k48p1wq8 _18u0ze3t"
        ])
    }, field.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_kqswh2mm _lcxv1wug"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jnhNB.default), {
        appearance: "stack",
        data: field.users.map((user)=>({
                name: user.name,
                src: user.avatarURL ?? undefined,
                enableTooltip: true
            })),
        maxCount: 10,
        size: "small"
    })), field.users.length === 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        className: (0, $bwpsq.default)([
            "_11c8dcr7 _syaz1fxt"
        ])
    }, field.users[0].name));
const $26f4a32bc9c72642$var$selectFieldRenderer = ({ field: field })=>field.type === (0, $cvj5l.BOARD_FIELD_SELECT) && field.value.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        key: field.fieldId,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1n261g80 _4cvr1h6o _gy1p1b66 _y08e1osq _18u0ze3t"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _11c81o8v _syaz131l _1bsb1osq _1bto1l2s _o5721q9c _k48p1wq8 _18u0ze3t"
        ])
    }, field.name), field.value.length > 1 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3uhPk.CardLabels), {
        labels: field.value
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        className: (0, $bwpsq.default)([
            "_11c8dcr7 _syaz1fxt"
        ])
    }, field.value[0]));
const $26f4a32bc9c72642$var$timeOriginalEstimateRenderer = ({ field: field })=>field.type === (0, $cvj5l.BOARD_FIELD_TIME_ORIGINAL_ESTIMATE) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        key: field.fieldId,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1n261g80 _4cvr1h6o _gy1p1b66 _y08e1osq _18u0ze3t"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _11c81o8v _syaz1gjq _1bto1l2s _o5721q9c _k48p1wq8 _18u0ze3t"
        ])
    }, field.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_18u01wug"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $16T6Y.default), null, field.value)));
const $26f4a32bc9c72642$var$FIELD_RENDERERS = {
    [(0, $cvj5l.BOARD_FIELD_PARENT)]: $26f4a32bc9c72642$var$parentFieldRenderer,
    [(0, $cvj5l.BOARD_FIELD_CATEGORY)]: $26f4a32bc9c72642$var$categoryFieldRenderer,
    [(0, $cvj5l.BOARD_FIELD_COMPONENTS)]: $26f4a32bc9c72642$var$componentFieldRenderer,
    [(0, $cvj5l.BOARD_FIELD_DATE)]: $26f4a32bc9c72642$var$dateRenderer,
    [(0, $cvj5l.BOARD_FIELD_TEXT)]: $26f4a32bc9c72642$var$textAndNumberRenderer,
    [(0, $cvj5l.BOARD_FIELD_USER)]: $26f4a32bc9c72642$var$userRenderer,
    [(0, $cvj5l.BOARD_FIELD_MULTI_USER)]: $26f4a32bc9c72642$var$multiUserRenderer,
    [(0, $cvj5l.BOARD_FIELD_SELECT)]: $26f4a32bc9c72642$var$selectFieldRenderer,
    [(0, $cvj5l.BOARD_FIELD_FLOAT)]: $26f4a32bc9c72642$var$textAndNumberRenderer,
    [(0, $cvj5l.BOARD_FIELD_STORY_POINTS)]: $26f4a32bc9c72642$var$textAndNumberRenderer,
    [(0, $cvj5l.BOARD_FIELD_TIME_ORIGINAL_ESTIMATE)]: $26f4a32bc9c72642$var$timeOriginalEstimateRenderer,
    [(0, $cvj5l.BOARD_FIELD_DATE_TIME)]: $26f4a32bc9c72642$var$dateTimeRenderer
};
const $26f4a32bc9c72642$var$FIELD_TYPE_ORDER = Object.keys($26f4a32bc9c72642$var$FIELD_RENDERERS);
const $26f4a32bc9c72642$var$EXCLUDED_SYSTEM_FIELDS = new Set([
    (0, $5fc53.ASSIGNEE_TYPE),
    (0, $5fc53.DUE_DATE_TYPE),
    (0, $5fc53.ISSUE_KEY_TYPE),
    (0, $5fc53.SUMMARY_TYPE)
]);
const $26f4a32bc9c72642$export$9371dc9f612e169c = /*#__PURE__*/ (0, $5uXOq.memo)(({ cardOptionsFragment: cardOptionsFragment, issue: issue })=>{
    const cardOptions = (0, $8Uumt.useFragment)((0, $gz7Oc.default), cardOptionsFragment);
    const selectedFields = new Set(cardOptions.edges.map((edge)=>edge?.node?.field && edge.node.field.fieldId));
    const { formatDate: formatDateIntl, formatNumber: formatNumber } = (0, $koVbs.default)();
    const formatDate = (0, $5uXOq.useCallback)((date)=>date ? formatDateIntl(date.toLocalDate(), $26f4a32bc9c72642$var$DATE_FORMAT_OPTIONS) : '', [
        formatDateIntl
    ]);
    const fields = Object.values(issue.fields)?.filter((field)=>{
        /**
     * Filter out field based off the following criteria:
     * * If the field is not selected via customized card configuration
     * * If the field type is not in the FIELD_TYPE_ORDER (i.e. no renderer for field type available)
     * * If the field is in the EXCLUDED_SYSTEM_FIELDS
     */ if (!selectedFields.has(field.fieldId) || !$26f4a32bc9c72642$var$FIELD_TYPE_ORDER.includes(field.type) || $26f4a32bc9c72642$var$EXCLUDED_SYSTEM_FIELDS.has(field.fieldId)) return false;
        return true;
    }).sort((field1, field2)=>$26f4a32bc9c72642$var$FIELD_TYPE_ORDER.indexOf(field1.type) - $26f4a32bc9c72642$var$FIELD_TYPE_ORDER.indexOf(field2.type)).map((field)=>$26f4a32bc9c72642$var$FIELD_RENDERERS[field.type]?.({
            field: field,
            formatDate: formatDate,
            formatNumber: formatNumber,
            TimeStampComponent: (0, $6ZEN7.default)
        }) ?? null);
    return fields;
});
const $26f4a32bc9c72642$var$detailRowStyles = null;
const $26f4a32bc9c72642$var$noIndentStyles = null;
const $26f4a32bc9c72642$var$fieldLabelStyles = null;
const $26f4a32bc9c72642$var$indentStyles = null;
const $26f4a32bc9c72642$var$inlineLabelStyles = null;
const $26f4a32bc9c72642$var$inlineContentStyles = null;
const $26f4a32bc9c72642$var$subtleTextStyle = null;
const $26f4a32bc9c72642$var$timestampContainerStyles = null;
const $26f4a32bc9c72642$var$categoryTagContainerStyles = null; // These styles allow elements to receive pointer events even with the use of the
// InteractionLayer component in the board card component. The InteractionLayer
// component is used to create a clickable area for the card, but we want to
// ensure that certain elements within the card can still receive pointer events.
const $26f4a32bc9c72642$var$pointerEventsStyles = null;

});
parcelRegister("gz7Oc", function(module, exports) {

$parcel$export(module.exports, "default", () => $87ea53f062545fba$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e49c9a75b82d5a179e7ffc8fab861df4>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $87ea53f062545fba$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "CardDetailFields_cardOptions",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "JiraBoardViewCardOptionEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "JiraField",
                                                "kind": "LinkedField",
                                                "name": "field",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "kind": "ScalarField",
                                                            "name": "fieldId"
                                                        },
                                                        "action": "THROW",
                                                        "path": "edges.node.field.fieldId"
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "edges.node.field"
                                        }
                                    ],
                                    "type": "JiraBoardViewFieldCardOption"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "edges.node"
                    }
                ]
            },
            "action": "THROW",
            "path": "edges"
        }
    ],
    "type": "JiraBoardViewCardOptionConnection"
};
$87ea53f062545fba$var$node.hash = "87681975a68254e1e024103652fa7b6e";
var $87ea53f062545fba$export$2e2bcd8739ae039 = $87ea53f062545fba$var$node;

});

parcelRegister("DhnKp", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3fabf56d1291b24$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $7XYc4 = parcelRequire("7XYc4");

var $dCm1o = parcelRequire("dCm1o");

var $gSwFG = parcelRequire("gSwFG");
const $f3fabf56d1291b24$var$CategoryTag = ({ categoryName: categoryName, categoryColor: categoryColor, isInteractive: isInteractive = true })=>{
    const { textColor: textColor, backgroundColor: tagColor } = (0, $gSwFG.getColorMetadata)(categoryColor);
    return /*#__PURE__*/ $5uXOq.createElement($f3fabf56d1291b24$var$CategoryTagWrapper, {
        isInteractive: isInteractive,
        textColor: (0, $dCm1o.isVisualRefreshEnabled)() ? "var(--ds-text, #172B4D)" : textColor,
        "aria-label": categoryName,
        "data-testid": "business-categories.ui.category-form.category-tag.category-tag-wrapper"
    }, /*#__PURE__*/ $5uXOq.createElement($f3fabf56d1291b24$var$StyledTag, {
        color: tagColor
    }, categoryName));
};
var $f3fabf56d1291b24$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($f3fabf56d1291b24$var$CategoryTag);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f3fabf56d1291b24$var$CategoryTagWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { textColor: textColor, isInteractive: isInteractive, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1qrlcdp": (0, $lD23V.default)(__cmplp.textColor)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_v564188d _1e0c116y _1bah1e5h _4cvr1h6o _p12f1osq _1ul9idpf _1tkeidpf _syazijt0",
            __cmplp.isInteractive ? "_d0altlke" : "_d0al73ad",
            __cmplp.className
        ])
    });
});
const $f3fabf56d1291b24$var$StyledTagOld = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_xexnhp": (0, $lD23V.default)(__cmplp.color)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rkoiti9 _11c82smr _1reo15vq _18m915vq _bfhk1cj8 _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66 _vwz4kb7n _1bto1l2s _o5721q9c _p12f1osq",
            __cmplp.className
        ])
    });
});
const $f3fabf56d1291b24$var$StyledTagNew = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_14v0t1n": (0, $lD23V.default)(`1px solid ${__cmplp.color}`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko5n0m _19it11we _11c82smr _1reo15vq _18m915vq _bfhk18uv _ca0qv77o _u5f31b66 _n3tdv77o _19bv1b66 _vwz4kb7n _1bto1l2s _o5721q9c _p12f1osq",
            __cmplp.className
        ])
    });
});
const $f3fabf56d1291b24$var$StyledTag = (0, $7XYc4.componentWithCondition)((0, $dCm1o.isVisualRefreshEnabled), $f3fabf56d1291b24$var$StyledTagNew, $f3fabf56d1291b24$var$StyledTagOld);

});
parcelRegister("gSwFG", function(module, exports) {

$parcel$export(module.exports, "getRandomColor", () => $371e0387ab2e6a89$export$e4369cabd7e84cd9);
$parcel$export(module.exports, "getColorNameFromValue", () => $371e0387ab2e6a89$export$b5ccbadd112d8ce9);
$parcel$export(module.exports, "getValueFromColorName", () => $371e0387ab2e6a89$export$9eff62e8ee2aaa2c);
$parcel$export(module.exports, "getColorMetadata", () => $371e0387ab2e6a89$export$49fce7fdcf55f26d);

var $3m7Ch = parcelRequire("3m7Ch");
const $371e0387ab2e6a89$export$e4369cabd7e84cd9 = ()=>{
    const randomIndex = Math.floor(Math.random() * (0, $3m7Ch.CATEGORY_THEMES).length);
    return (0, $3m7Ch.CATEGORY_THEMES)[randomIndex].name;
};
const $371e0387ab2e6a89$export$b5ccbadd112d8ce9 = (colorValue)=>(0, $3m7Ch.CATEGORY_THEMES).find((item)=>item.backgroundColor === colorValue)?.name ?? '';
const $371e0387ab2e6a89$export$9eff62e8ee2aaa2c = (colorName)=>(0, $3m7Ch.CATEGORY_THEMES).find((item)=>item.name === colorName)?.backgroundColor ?? '';
const $371e0387ab2e6a89$export$49fce7fdcf55f26d = (colorName)=>{
    if (!colorName) return 0, $3m7Ch.GREY_LIGHTEST_META;
    return (0, $3m7Ch.CATEGORY_THEMES).find((item)=>item.name === colorName) ?? (0, $3m7Ch.GREY_LIGHTEST_META);
};
const $371e0387ab2e6a89$export$4ef6b7574883e63d = ()=>(0, $3m7Ch.CATEGORY_THEMES).map((item)=>item.name);

});
parcelRegister("3m7Ch", function(module, exports) {

$parcel$export(module.exports, "GREY_LIGHTEST_META", () => $b019b47b4798283a$export$cb19a604bb399a88);
$parcel$export(module.exports, "CHECK_MARK_COLOR_DARK", () => $b019b47b4798283a$export$270aee965367aeb3);
$parcel$export(module.exports, "CHECK_MARK_COLOR_LIGHT", () => $b019b47b4798283a$export$941ef40ef5fdd2b1);
$parcel$export(module.exports, "CATEGORY_THEMES", () => $b019b47b4798283a$export$845e69f3af4133a6);

var $gAmq4 = parcelRequire("gAmq4");
const $b019b47b4798283a$export$cb19a604bb399a88 = {
    name: 'GREY_LIGHTEST',
    backgroundColor: "var(--ds-background-neutral, #091E420F)",
    textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
    messageLabel: (0, $gAmq4.default).greyLightest
};
const $b019b47b4798283a$var$GREY_LIGHTER_META = {
    name: 'GREY_LIGHTER',
    backgroundColor: "var(--ds-background-neutral-hovered, #091E4224)",
    textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
    messageLabel: (0, $gAmq4.default).greyLighter
};
const $b019b47b4798283a$var$GREY_META = {
    name: 'GREY',
    backgroundColor: "var(--ds-background-neutral-pressed, #091E424F)",
    textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
    messageLabel: (0, $gAmq4.default).grey
};
const $b019b47b4798283a$var$GREY_DARKER_META = {
    name: 'GREY_DARKER',
    backgroundColor: "var(--ds-background-neutral-bold, #44546F)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $gAmq4.default).greyDarker
};
const $b019b47b4798283a$var$GREY_DARKEST_META = {
    name: 'GREY_DARKEST',
    backgroundColor: "var(--ds-background-neutral-bold-pressed, #172B4D)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $gAmq4.default).greyDarkest
};
const $b019b47b4798283a$var$PURPLE_LIGHTEST_META = {
    name: 'PURPLE_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-purple-subtlest, #F3F0FF)",
    textColor: "var(--ds-text-accent-purple-bolder, #352C63)",
    messageLabel: (0, $gAmq4.default).purpleLightest
};
const $b019b47b4798283a$var$PURPLE_LIGHTER_META = {
    name: 'PURPLE_LIGHTER',
    backgroundColor: "var(--ds-background-accent-purple-subtler, #DFD8FD)",
    textColor: "var(--ds-text-accent-purple-bolder, #352C63)",
    messageLabel: (0, $gAmq4.default).purpleLighter
};
const $b019b47b4798283a$var$PURPLE_META = {
    name: 'PURPLE',
    backgroundColor: "var(--ds-background-accent-purple-subtle, #9F8FEF)",
    textColor: "var(--ds-text-accent-purple-bolder, #352C63)",
    messageLabel: (0, $gAmq4.default).purple
};
const $b019b47b4798283a$var$PURPLE_DARKER_META = {
    name: 'PURPLE_DARKER',
    backgroundColor: "var(--ds-text-accent-purple, #5E4DB2)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $gAmq4.default).purpleDarker
};
const $b019b47b4798283a$var$PURPLE_DARKEST_META = {
    name: 'PURPLE_DARKEST',
    backgroundColor: "var(--ds-text-accent-purple-bolder, #352C63)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $gAmq4.default).purpleDarkest
};
const $b019b47b4798283a$var$BLUE_LIGHTEST_META = {
    name: 'BLUE_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-blue-subtlest, #E9F2FF)",
    textColor: "var(--ds-text-accent-blue-bolder, #09326C)",
    messageLabel: (0, $gAmq4.default).blueLightest
};
const $b019b47b4798283a$var$BLUE_LIGHTER_META = {
    name: 'BLUE_LIGHTER',
    backgroundColor: "var(--ds-background-accent-blue-subtler, #CCE0FF)",
    textColor: "var(--ds-text-accent-blue-bolder, #09326C)",
    messageLabel: (0, $gAmq4.default).blueLighter
};
const $b019b47b4798283a$var$BLUE_META = {
    name: 'BLUE',
    backgroundColor: "var(--ds-background-accent-blue-subtle, #579DFF)",
    textColor: "var(--ds-text-accent-blue-bolder, #09326C)",
    messageLabel: (0, $gAmq4.default).blue
};
const $b019b47b4798283a$var$BLUE_DARKER_META = {
    name: 'BLUE_DARKER',
    backgroundColor: "var(--ds-text-accent-blue, #0055CC)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $gAmq4.default).blueDarker
};
const $b019b47b4798283a$var$BLUE_DARKEST_META = {
    name: 'BLUE_DARKEST',
    backgroundColor: "var(--ds-text-accent-blue-bolder, #09326C)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $gAmq4.default).blueDarkest
};
const $b019b47b4798283a$var$TEAL_LIGHTEST_META = {
    name: 'TEAL_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-teal-subtlest, #E7F9FF)",
    textColor: "var(--ds-text-accent-teal-bolder, #164555)",
    messageLabel: (0, $gAmq4.default).tealLightest
};
const $b019b47b4798283a$var$TEAL_LIGHTER_META = {
    name: 'TEAL_LIGHTER',
    backgroundColor: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
    textColor: "var(--ds-text-accent-teal-bolder, #164555)",
    messageLabel: (0, $gAmq4.default).tealLighter
};
const $b019b47b4798283a$var$TEAL_META = {
    name: 'TEAL',
    backgroundColor: "var(--ds-background-accent-teal-subtle, #6CC3E0)",
    textColor: "var(--ds-text-accent-teal-bolder, #164555)",
    messageLabel: (0, $gAmq4.default).teal
};
const $b019b47b4798283a$var$TEAL_DARKER_META = {
    name: 'TEAL_DARKER',
    backgroundColor: "var(--ds-text-accent-teal, #206A83)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $gAmq4.default).tealDarker
};
const $b019b47b4798283a$var$TEAL_DARKEST_META = {
    name: 'TEAL_DARKEST',
    backgroundColor: "var(--ds-text-accent-teal-bolder, #164555)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $gAmq4.default).tealDarkest
};
const $b019b47b4798283a$var$GREEN_LIGHTEST_META = {
    name: 'GREEN_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-green-subtlest, #DCFFF1)",
    textColor: "var(--ds-text-accent-green-bolder, #164B35)",
    messageLabel: (0, $gAmq4.default).greenLightest
};
const $b019b47b4798283a$var$GREEN_LIGHTER_META = {
    name: 'GREEN_LIGHTER',
    backgroundColor: "var(--ds-background-accent-green-subtler, #BAF3DB)",
    textColor: "var(--ds-text-accent-green-bolder, #164B35)",
    messageLabel: (0, $gAmq4.default).greenLighter
};
const $b019b47b4798283a$var$GREEN_META = {
    name: 'GREEN',
    backgroundColor: "var(--ds-background-accent-green-subtle, #4BCE97)",
    textColor: "var(--ds-text-accent-green-bolder, #164B35)",
    messageLabel: (0, $gAmq4.default).green
};
const $b019b47b4798283a$var$GREEN_DARKER_META = {
    name: 'GREEN_DARKER',
    backgroundColor: "var(--ds-background-accent-green-bolder, #1F845A)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $gAmq4.default).greenDarker
};
const $b019b47b4798283a$var$GREEN_DARKEST_META = {
    name: 'GREEN_DARKEST',
    backgroundColor: "var(--ds-text-accent-green-bolder, #164B35)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $gAmq4.default).greenDarkest
};
const $b019b47b4798283a$var$LIME_LIGHTEST_META = {
    name: 'LIME_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-lime-subtlest, #EFFFD6)",
    textColor: "var(--ds-text-accent-lime-bolder, #37471F)",
    messageLabel: (0, $gAmq4.default).limeLightest
};
const $b019b47b4798283a$var$LIME_LIGHTER_META = {
    name: 'LIME_LIGHTER',
    backgroundColor: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    textColor: "var(--ds-text-accent-lime-bolder, #37471F)",
    messageLabel: (0, $gAmq4.default).limeLighter
};
const $b019b47b4798283a$var$LIME_META = {
    name: 'LIME',
    backgroundColor: "var(--ds-background-accent-lime-subtle, #94C748)",
    textColor: "var(--ds-text-accent-lime-bolder, #37471F)",
    messageLabel: (0, $gAmq4.default).lime
};
const $b019b47b4798283a$var$LIME_DARKER_META = {
    name: 'LIME_DARKER',
    backgroundColor: "var(--ds-text-accent-lime, #4C6B1F)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $gAmq4.default).limeDarker
};
const $b019b47b4798283a$var$LIME_DARKEST_META = {
    name: 'LIME_DARKEST',
    backgroundColor: "var(--ds-text-accent-lime-bolder, #37471F)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $gAmq4.default).limeDarkest
};
const $b019b47b4798283a$var$YELLOW_LIGHTEST_META = {
    name: 'YELLOW_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-yellow-subtlest, #FFF7D6)",
    textColor: "var(--ds-text-accent-yellow-bolder, #533F04)",
    messageLabel: (0, $gAmq4.default).yellowLightest
};
const $b019b47b4798283a$var$YELLOW_LIGHTER_META = {
    name: 'YELLOW_LIGHTER',
    backgroundColor: "var(--ds-background-accent-yellow-subtler, #F8E6A0)",
    textColor: "var(--ds-text-accent-yellow-bolder, #533F04)",
    messageLabel: (0, $gAmq4.default).yellowLighter
};
const $b019b47b4798283a$var$YELLOW_META = {
    name: 'YELLOW',
    backgroundColor: "var(--ds-background-accent-yellow-subtle, #F5CD47)",
    textColor: "var(--ds-text-accent-yellow-bolder, #533F04)",
    messageLabel: (0, $gAmq4.default).yellow
};
const $b019b47b4798283a$var$YELLOW_DARKER_META = {
    name: 'YELLOW_DARKER',
    backgroundColor: "var(--ds-text-accent-yellow, #7F5F01)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $gAmq4.default).yellowDarker
};
const $b019b47b4798283a$var$YELLOW_DARKEST_META = {
    name: 'YELLOW_DARKEST',
    backgroundColor: "var(--ds-text-accent-yellow-bolder, #533F04)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $gAmq4.default).yellowDarkest
};
const $b019b47b4798283a$var$ORANGE_LIGHTEST_META = {
    name: 'ORANGE_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-orange-subtlest, #FFF3EB)",
    textColor: "var(--ds-text-accent-orange-bolder, #702E00)",
    messageLabel: (0, $gAmq4.default).orangeLightest
};
const $b019b47b4798283a$var$ORANGE_LIGHTER_META = {
    name: 'ORANGE_LIGHTER',
    backgroundColor: "var(--ds-background-accent-orange-subtler, #FEDEC8)",
    textColor: "var(--ds-text-accent-orange-bolder, #702E00)",
    messageLabel: (0, $gAmq4.default).orangeLighter
};
const $b019b47b4798283a$var$ORANGE_META = {
    name: 'ORANGE',
    backgroundColor: "var(--ds-background-accent-orange-subtle, #FEA362)",
    textColor: "var(--ds-text-accent-orange-bolder, #702E00)",
    messageLabel: (0, $gAmq4.default).orange
};
const $b019b47b4798283a$var$ORANGE_DARKER_META = {
    name: 'ORANGE_DARKER',
    backgroundColor: "var(--ds-background-accent-orange-bolder, #C25100)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $gAmq4.default).orangeDarker
};
const $b019b47b4798283a$var$ORANGE_DARKEST_META = {
    name: 'ORANGE_DARKEST',
    backgroundColor: "var(--ds-text-accent-orange-bolder, #702E00)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $gAmq4.default).orangeDarkest
};
const $b019b47b4798283a$var$RED_LIGHTEST_META = {
    name: 'RED_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-red-subtlest, #FFECEB)",
    textColor: "var(--ds-text-accent-red-bolder, #5D1F1A)",
    messageLabel: (0, $gAmq4.default).redLightest
};
const $b019b47b4798283a$var$RED_LIGHTER_META = {
    name: 'RED_LIGHTER',
    backgroundColor: "var(--ds-background-accent-red-subtler, #FFD5D2)",
    textColor: "var(--ds-text-accent-red-bolder, #5D1F1A)",
    messageLabel: (0, $gAmq4.default).redLighter
};
const $b019b47b4798283a$var$RED_META = {
    name: 'RED',
    backgroundColor: "var(--ds-background-accent-red-subtle, #F87168)",
    textColor: "var(--ds-text-accent-red-bolder, #5D1F1A)",
    messageLabel: (0, $gAmq4.default).red
};
const $b019b47b4798283a$var$RED_DARKER_META = {
    name: 'RED_DARKER',
    backgroundColor: "var(--ds-background-accent-red-bolder, #C9372C)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $gAmq4.default).redDarker
};
const $b019b47b4798283a$var$RED_DARKEST_META = {
    name: 'RED_DARKEST',
    backgroundColor: "var(--ds-text-accent-red-bolder, #5D1F1A)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $gAmq4.default).redDarkest
};
const $b019b47b4798283a$var$MAGENTA_LIGHTEST_META = {
    name: 'MAGENTA_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    textColor: "var(--ds-text-accent-magenta-bolder, #50253F)",
    messageLabel: (0, $gAmq4.default).magentaLightest
};
const $b019b47b4798283a$var$MAGENTA_LIGHTER_META = {
    name: 'MAGENTA_LIGHTER',
    backgroundColor: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    textColor: "var(--ds-text-accent-magenta-bolder, #50253F)",
    messageLabel: (0, $gAmq4.default).magentaLighter
};
const $b019b47b4798283a$var$MAGENTA_META = {
    name: 'MAGENTA',
    backgroundColor: "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    textColor: "var(--ds-text-accent-magenta-bolder, #50253F)",
    messageLabel: (0, $gAmq4.default).magenta
};
const $b019b47b4798283a$var$MAGENTA_DARKER_META = {
    name: 'MAGENTA_DARKER',
    backgroundColor: "var(--ds-text-accent-magenta, #943D73)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $gAmq4.default).magentaDarker
};
const $b019b47b4798283a$var$MAGENTA_DARKEST_META = {
    name: 'MAGENTA_DARKEST',
    backgroundColor: "var(--ds-text-accent-magenta-bolder, #50253F)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $gAmq4.default).magentaDarkest
};
const $b019b47b4798283a$export$270aee965367aeb3 = "var(--ds-text-inverse, #FFFFFF)";
const $b019b47b4798283a$export$941ef40ef5fdd2b1 = "var(--ds-text, #172B4D)";
const $b019b47b4798283a$export$845e69f3af4133a6 = [
    $b019b47b4798283a$export$cb19a604bb399a88,
    $b019b47b4798283a$var$PURPLE_LIGHTEST_META,
    $b019b47b4798283a$var$BLUE_LIGHTEST_META,
    $b019b47b4798283a$var$TEAL_LIGHTEST_META,
    $b019b47b4798283a$var$GREEN_LIGHTEST_META,
    $b019b47b4798283a$var$LIME_LIGHTEST_META,
    $b019b47b4798283a$var$YELLOW_LIGHTEST_META,
    $b019b47b4798283a$var$ORANGE_LIGHTEST_META,
    $b019b47b4798283a$var$RED_LIGHTEST_META,
    $b019b47b4798283a$var$MAGENTA_LIGHTEST_META,
    $b019b47b4798283a$var$GREY_LIGHTER_META,
    $b019b47b4798283a$var$PURPLE_LIGHTER_META,
    $b019b47b4798283a$var$BLUE_LIGHTER_META,
    $b019b47b4798283a$var$TEAL_LIGHTER_META,
    $b019b47b4798283a$var$GREEN_LIGHTER_META,
    $b019b47b4798283a$var$LIME_LIGHTER_META,
    $b019b47b4798283a$var$YELLOW_LIGHTER_META,
    $b019b47b4798283a$var$ORANGE_LIGHTER_META,
    $b019b47b4798283a$var$RED_LIGHTER_META,
    $b019b47b4798283a$var$MAGENTA_LIGHTER_META,
    $b019b47b4798283a$var$GREY_META,
    $b019b47b4798283a$var$PURPLE_META,
    $b019b47b4798283a$var$BLUE_META,
    $b019b47b4798283a$var$TEAL_META,
    $b019b47b4798283a$var$GREEN_META,
    $b019b47b4798283a$var$LIME_META,
    $b019b47b4798283a$var$YELLOW_META,
    $b019b47b4798283a$var$ORANGE_META,
    $b019b47b4798283a$var$RED_META,
    $b019b47b4798283a$var$MAGENTA_META,
    $b019b47b4798283a$var$GREY_DARKER_META,
    $b019b47b4798283a$var$PURPLE_DARKER_META,
    $b019b47b4798283a$var$BLUE_DARKER_META,
    $b019b47b4798283a$var$TEAL_DARKER_META,
    $b019b47b4798283a$var$GREEN_DARKER_META,
    $b019b47b4798283a$var$LIME_DARKER_META,
    $b019b47b4798283a$var$YELLOW_DARKER_META,
    $b019b47b4798283a$var$ORANGE_DARKER_META,
    $b019b47b4798283a$var$RED_DARKER_META,
    $b019b47b4798283a$var$MAGENTA_DARKER_META,
    $b019b47b4798283a$var$GREY_DARKEST_META,
    $b019b47b4798283a$var$PURPLE_DARKEST_META,
    $b019b47b4798283a$var$BLUE_DARKEST_META,
    $b019b47b4798283a$var$TEAL_DARKEST_META,
    $b019b47b4798283a$var$GREEN_DARKEST_META,
    $b019b47b4798283a$var$LIME_DARKEST_META,
    $b019b47b4798283a$var$YELLOW_DARKEST_META,
    $b019b47b4798283a$var$ORANGE_DARKEST_META,
    $b019b47b4798283a$var$RED_DARKEST_META,
    $b019b47b4798283a$var$MAGENTA_DARKEST_META
];

});
parcelRegister("gAmq4", function(module, exports) {

$parcel$export(module.exports, "default", () => $d59c1f29a6afb9ec$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $d59c1f29a6afb9ec$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    greyLightest: {
        "id": "business-categories.category-form.category-color-picker.grey-lightest",
        "defaultMessage": "Grey lightest"
    },
    greyLighter: {
        "id": "business-categories.category-form.category-color-picker.grey-lighter",
        "defaultMessage": "Grey lighter"
    },
    grey: {
        "id": "business-categories.category-form.category-color-picker.grey",
        "defaultMessage": "Grey"
    },
    greyDarker: {
        "id": "business-categories.category-form.category-color-picker.grey-darker",
        "defaultMessage": "Grey darker"
    },
    greyDarkest: {
        "id": "business-categories.category-form.category-color-picker.grey-darkest",
        "defaultMessage": "Grey darkest"
    },
    purpleLightest: {
        "id": "business-categories.category-form.category-color-picker.purple-lightest",
        "defaultMessage": "Purple lightest"
    },
    purpleLighter: {
        "id": "business-categories.category-form.category-color-picker.purple-lighter",
        "defaultMessage": "Purple lighter"
    },
    purple: {
        "id": "business-categories.category-form.category-color-picker.purple",
        "defaultMessage": "Purple"
    },
    purpleDarker: {
        "id": "business-categories.category-form.category-color-picker.purple-darker",
        "defaultMessage": "Purple darker"
    },
    purpleDarkest: {
        "id": "business-categories.category-form.category-color-picker.purple-darkest",
        "defaultMessage": "Purple darkest"
    },
    blueLightest: {
        "id": "business-categories.category-form.category-color-picker.blue-lightest",
        "defaultMessage": "Blue lightest"
    },
    blueLighter: {
        "id": "business-categories.category-form.category-color-picker.blue-lighter",
        "defaultMessage": "Blue lighter"
    },
    blue: {
        "id": "business-categories.category-form.category-color-picker.blue",
        "defaultMessage": "Blue"
    },
    blueDarker: {
        "id": "business-categories.category-form.category-color-picker.blue-darker",
        "defaultMessage": "Blue darker"
    },
    blueDarkest: {
        "id": "business-categories.category-form.category-color-picker.blue-darkest",
        "defaultMessage": "Blue darkest"
    },
    tealLightest: {
        "id": "business-categories.category-form.category-color-picker.teal-lightest",
        "defaultMessage": "Teal lightest"
    },
    tealLighter: {
        "id": "business-categories.category-form.category-color-picker.teal-lighter",
        "defaultMessage": "Teal lighter"
    },
    teal: {
        "id": "business-categories.category-form.category-color-picker.teal",
        "defaultMessage": "Teal"
    },
    tealDarker: {
        "id": "business-categories.category-form.category-color-picker.teal-darker",
        "defaultMessage": "Teal darker"
    },
    tealDarkest: {
        "id": "business-categories.category-form.category-color-picker.teal-darkest",
        "defaultMessage": "Teal darkest"
    },
    greenLightest: {
        "id": "business-categories.category-form.category-color-picker.green-lightest",
        "defaultMessage": "Green lightest"
    },
    greenLighter: {
        "id": "business-categories.category-form.category-color-picker.green-lighter",
        "defaultMessage": "Green lighter"
    },
    green: {
        "id": "business-categories.category-form.category-color-picker.green",
        "defaultMessage": "Green"
    },
    greenDarker: {
        "id": "business-categories.category-form.category-color-picker.green-darker",
        "defaultMessage": "Green darker"
    },
    greenDarkest: {
        "id": "business-categories.category-form.category-color-picker.green-darkest",
        "defaultMessage": "Green darkest"
    },
    limeLightest: {
        "id": "business-categories.category-form.category-color-picker.lime-lightest",
        "defaultMessage": "Lime lightest"
    },
    limeLighter: {
        "id": "business-categories.category-form.category-color-picker.lime-lighter",
        "defaultMessage": "Lime lighter"
    },
    lime: {
        "id": "business-categories.category-form.category-color-picker.lime",
        "defaultMessage": "Lime"
    },
    limeDarker: {
        "id": "business-categories.category-form.category-color-picker.lime-darker",
        "defaultMessage": "Lime darker"
    },
    limeDarkest: {
        "id": "business-categories.category-form.category-color-picker.lime-darkest",
        "defaultMessage": "Lime darkest"
    },
    yellowLightest: {
        "id": "business-categories.category-form.category-color-picker.yellow-lightest",
        "defaultMessage": "Yellow lightest"
    },
    yellowLighter: {
        "id": "business-categories.category-form.category-color-picker.yellow-lighter",
        "defaultMessage": "Yellow lighter"
    },
    yellow: {
        "id": "business-categories.category-form.category-color-picker.yellow",
        "defaultMessage": "Yellow"
    },
    yellowDarker: {
        "id": "business-categories.category-form.category-color-picker.yellow-darker",
        "defaultMessage": "Yellow darker"
    },
    yellowDarkest: {
        "id": "business-categories.category-form.category-color-picker.yellow-darkest",
        "defaultMessage": "Yellow darkest"
    },
    orangeLightest: {
        "id": "business-categories.category-form.category-color-picker.orange-lightest",
        "defaultMessage": "Orange lightest"
    },
    orangeLighter: {
        "id": "business-categories.category-form.category-color-picker.orange-lighter",
        "defaultMessage": "Orange lighter"
    },
    orange: {
        "id": "business-categories.category-form.category-color-picker.orange",
        "defaultMessage": "Orange"
    },
    orangeDarker: {
        "id": "business-categories.category-form.category-color-picker.orange-darker",
        "defaultMessage": "Orange darker"
    },
    orangeDarkest: {
        "id": "business-categories.category-form.category-color-picker.orange-darkest",
        "defaultMessage": "Orange darkest"
    },
    redLightest: {
        "id": "business-categories.category-form.category-color-picker.red-lightest",
        "defaultMessage": "Red lightest"
    },
    redLighter: {
        "id": "business-categories.category-form.category-color-picker.red-lighter",
        "defaultMessage": "Red lighter"
    },
    red: {
        "id": "business-categories.category-form.category-color-picker.red",
        "defaultMessage": "Red"
    },
    redDarker: {
        "id": "business-categories.category-form.category-color-picker.red-darker",
        "defaultMessage": "Red darker"
    },
    redDarkest: {
        "id": "business-categories.category-form.category-color-picker.red-darkest",
        "defaultMessage": "Red darkest"
    },
    magentaLightest: {
        "id": "business-categories.category-form.category-color-picker.magenta-lightest",
        "defaultMessage": "Magenta lightest"
    },
    magentaLighter: {
        "id": "business-categories.category-form.category-color-picker.magenta-lighter",
        "defaultMessage": "Magenta lighter"
    },
    magenta: {
        "id": "business-categories.category-form.category-color-picker.magenta",
        "defaultMessage": "Magenta"
    },
    magentaDarker: {
        "id": "business-categories.category-form.category-color-picker.magenta-darker",
        "defaultMessage": "Magenta darker"
    },
    magentaDarkest: {
        "id": "business-categories.category-form.category-color-picker.magenta-darkest",
        "defaultMessage": "Magenta darkest"
    }
});

});




parcelRegister("6ZEN7", function(module, exports) {

$parcel$export(module.exports, "default", () => $656c5ed216c75dbe$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $47bDC = parcelRequire("47bDC");

var $hGgHi = parcelRequire("hGgHi");

var $8Rkzz = parcelRequire("8Rkzz");

var $3bDjY = parcelRequire("3bDjY");

var $2YZCu = parcelRequire("2YZCu");

var $15rEL = parcelRequire("15rEL");

var $aWse0 = parcelRequire("aWse0");

var $eDXka = parcelRequire("eDXka");

var $eNNkf = parcelRequire("eNNkf");

var $9E5cm = parcelRequire("9E5cm");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $leRCk = parcelRequire("leRCk");

var $85NCm = parcelRequire("85NCm");

var $boVS3 = parcelRequire("boVS3");
const $656c5ed216c75dbe$var$TimestampView = (props)=>{
    const { value: value, extraStyles: extraStyles = {}, tooltipPosition: tooltipPosition = 'top' } = props;
    const [{ data: loggedInUser }] = (0, $leRCk.useUserSubscriber)();
    const loggedInUserTimeZone = loggedInUser ? loggedInUser.timeZone : undefined;
    const userTimeZone = loggedInUserTimeZone || (0, $9E5cm.getBrowserTimeZone)();
    const isADGTimestampDisplaySettingRelative = (0, $boVS3.getADGTimestampDisplaySetting)(value) === (0, $85NCm.RELATIVE);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { formatDate: formatDate } = (0, $aWse0.useIntlV2)();
    const [userDisplaySetting, { setValue: setTimestampDisplaySetting }] = (0, $eNNkf.useUserPreferencesValue)((0, $eDXka.TIMESTAMP_DISPLAY_SETTING));
    // Use relative display setting if user hasn't set anything
    const displaySetting = (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(userDisplaySetting) || userDisplaySetting === '' ? (0, $85NCm.RELATIVE) : userDisplaySetting;
    const formattedAbsoluteTimestamp = (0, $5uXOq.useMemo)(()=>formatDate(value, {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            timeZone: userTimeZone
        }), [
        formatDate,
        userTimeZone,
        value
    ]);
    const onAbsoluteClick = (0, $5uXOq.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'absoluteTimeButton');
        setTimestampDisplaySetting((0, $85NCm.RELATIVE)).catch((error)=>{
            (0, $2YZCu.default).safeErrorWithoutCustomerData('issue.fields.components.timestamp', 'Failed to set timestamp display to RELATIVE', error);
        });
    }, [
        createAnalyticsEvent,
        setTimestampDisplaySetting
    ]);
    const onRelativeClick = (0, $5uXOq.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'relativeTimeButton');
        setTimestampDisplaySetting((0, $85NCm.ABSOLUTE)).catch((error)=>{
            (0, $2YZCu.default).safeErrorWithoutCustomerData('issue.fields.components.timestamp', 'Failed to set timestamp display to ABSOLUTE', error);
        });
    }, [
        createAnalyticsEvent,
        setTimestampDisplaySetting
    ]);
    const renderAbsolute = (0, $5uXOq.useCallback)((canSwitchDisplaySetting)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($656c5ed216c75dbe$var$TimestampWrapper, {
            canSwitchDisplaySetting: canSwitchDisplaySetting,
            onKeyDown: (e)=>{
                if ((e.key === 'Enter' || e.key === 'Space') && canSwitchDisplaySetting) onAbsoluteClick();
            },
            role: "presentation",
            onClick: canSwitchDisplaySetting ? onAbsoluteClick : (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            extraStyles: extraStyles
        }, formattedAbsoluteTimestamp), [
        extraStyles,
        formattedAbsoluteTimestamp,
        onAbsoluteClick
    ]);
    const renderRelative = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($656c5ed216c75dbe$var$TimestampWrapper, {
            canSwitchDisplaySetting: true,
            onKeyDown: (e)=>(e.key === 'Enter' || e.key === 'Space') && onRelativeClick(),
            role: "presentation",
            onClick: onRelativeClick,
            extraStyles: extraStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            tag: "span",
            content: formattedAbsoluteTimestamp,
            position: tooltipPosition
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
            "data-testid": "issue-timestamp.relative-time"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $15rEL.FormattedRelativeV2), {
            value: value
        })))), [
        extraStyles,
        formattedAbsoluteTimestamp,
        onRelativeClick,
        tooltipPosition,
        value
    ]);
    // BENTO-2569: Users have requested the ability to switch to absolute timestamps when the timestamp is to be displayed as relative.
    // When the timestamp is to be displayed as absolute then we cannot allow them to switch (to comply with ADG)
    return isADGTimestampDisplaySettingRelative && displaySetting === (0, $85NCm.RELATIVE) ? renderRelative() : renderAbsolute(isADGTimestampDisplaySettingRelative);
};
$656c5ed216c75dbe$var$TimestampView.displayName = 'TimestampView';
var $656c5ed216c75dbe$export$2e2bcd8739ae039 = $656c5ed216c75dbe$var$TimestampView;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $656c5ed216c75dbe$var$TimestampWrapper = /*#__PURE__*/ (0, $47bDC.default).span.withConfig({
    componentId: "erd76u-0"
})(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        cursor: props.canSwitchDisplaySetting ? 'pointer' : 'default'
    }), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
({ extraStyles: extraStyles })=>extraStyles.always, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
({ canSwitchDisplaySetting: canSwitchDisplaySetting, extraStyles: { whenDisplaySettingSwitchable: extraStylesWhenSwitchable } })=>canSwitchDisplaySetting ? extraStylesWhenSwitchable : '');
$656c5ed216c75dbe$var$TimestampWrapper.displayName = 'TimestampWrapper';

});
parcelRegister("15rEL", function(module, exports) {

$parcel$export(module.exports, "getRelativeTimeAndUnit", () => $dff2faa5ae8b6f27$export$307c4b8ee56b97bb);
$parcel$export(module.exports, "FormattedRelativeV2", () => $dff2faa5ae8b6f27$export$7317ee2f88fd1276);

var $5uXOq = parcelRequire("5uXOq");

var $j7anB = parcelRequire("j7anB");

var $2tElP = parcelRequire("2tElP");
const $dff2faa5ae8b6f27$var$getTimeInUnits = (unitValue)=>{
    const seconds = unitValue / 1000;
    const minutes = seconds / 60;
    const hours = minutes / 60;
    const days = hours / 24;
    const weeks = days / 7;
    const months = weeks / 4;
    const years = months / 12;
    return {
        seconds: seconds,
        minutes: minutes,
        hours: hours,
        days: days,
        weeks: weeks,
        months: months,
        years: years
    };
};
const $dff2faa5ae8b6f27$export$307c4b8ee56b97bb = (value, units)=>{
    const timeInMilliseconds = new Date(value);
    // @ts-expect-error - TS2362 - The left-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type.
    const delta = timeInMilliseconds - Date.now();
    let valueInUnit;
    if (!units) {
        const { value: time, unit: unit } = (0, $j7anB.selectUnit)(timeInMilliseconds, new Date());
        return {
            time: time,
            unit: unit
        };
    }
    const { seconds: seconds, minutes: minutes, hours: hours, days: days, weeks: weeks, months: months, years: years } = $dff2faa5ae8b6f27$var$getTimeInUnits(delta);
    switch(units){
        case 'second':
            valueInUnit = seconds;
            break;
        case 'minute':
            valueInUnit = minutes;
            break;
        case 'hour':
            valueInUnit = hours;
            break;
        case 'day':
            valueInUnit = days;
            break;
        case 'week':
            valueInUnit = weeks;
            break;
        case 'month':
            valueInUnit = months;
            break;
        case 'year':
            valueInUnit = years;
            break;
        default:
            valueInUnit = 0;
            break;
    }
    return {
        time: Math.ceil(valueInUnit),
        unit: units
    };
};
const $dff2faa5ae8b6f27$export$7317ee2f88fd1276 = ({ value: value, units: units, children: children, style: style, format: format, updateInterval: updateInterval })=>{
    const { time: time, unit: unit } = $dff2faa5ae8b6f27$export$307c4b8ee56b97bb(value, units);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2tElP.default), {
        value: time,
        unit: unit,
        numeric: style === 'numeric' ? 'always' : 'auto',
        format: format,
        updateIntervalInSeconds: updateInterval
    }, children);
};
$dff2faa5ae8b6f27$export$7317ee2f88fd1276.displayName = 'FormattedRelative';

});

parcelRegister("eDXka", function(module, exports) {

$parcel$export(module.exports, "TIMESTAMP_DISPLAY_SETTING", () => $9f0f96bc04f1e77a$export$9f4ee8e6dc9a0a55);
$parcel$export(module.exports, "CHILD_ISSUES_LIMIT_BEST_PRACTICE_FLAG_DISMISSED", () => $9f0f96bc04f1e77a$export$e7d75f9d93dfa3df);
$parcel$export(module.exports, "IssueViewFetchOperations", () => $9f0f96bc04f1e77a$export$b38f30d67f730bc4);
const $9f0f96bc04f1e77a$export$9f4ee8e6dc9a0a55 = 'jira.user.issue.details.timestamp-display-setting';
const $9f0f96bc04f1e77a$export$e7d75f9d93dfa3df = 'jira.user.issue.child-issues-limit.best-practice-flag.dismissed';
const $9f0f96bc04f1e77a$export$b38f30d67f730bc4 = {
    EARLY_FETCH_GRAPHQL: 'earlyFetchIssueDataQuery',
    INITIAL_GRAPHQL: 'issueDataQuery',
    EARLY_FETCH_GIRA: 'earlyFetchIssueViewInteractiveQuery',
    INITIAL_GIRA: 'issueViewInteractiveQuery',
    EARLY_FETCH_AGG: 'earlyFetchMainIssueAggQuery',
    INITIAL_AGG: 'mainIssueAggQuery',
    EARLY_FETCH_NON_CRITICAL_GIRA: 'earlyFetchIssueViewNonCriticalGiraQuery',
    NON_CRITICAL_GIRA: 'issueViewNonCriticalGiraQuery',
    VIEW_SCREEN_ID: 'viewScreenIdQuery',
    FIELD_CONFIGURATION: 'fieldConfigurationQuery',
    FIELD_DESCRIPTION: 'fieldDescriptionQuery',
    ATTACHMENT: 'attachmentsQuery'
};

});

parcelRegister("9E5cm", function(module, exports) {

$parcel$export(module.exports, "SYDNEY_TIMEZONE", () => $6bf10f6ede879313$export$1a022a080ce6c5bb);
$parcel$export(module.exports, "getBrowserTimeZone", () => $6bf10f6ede879313$export$efc596861aea1477);
const $6bf10f6ede879313$export$1a022a080ce6c5bb = 'Australia/Sydney';
const $6bf10f6ede879313$export$efc596861aea1477 = ()=>Intl.DateTimeFormat().resolvedOptions().timeZone || $6bf10f6ede879313$export$1a022a080ce6c5bb;

});

parcelRegister("85NCm", function(module, exports) {

$parcel$export(module.exports, "RELATIVE", () => $f634ecaafde4a9fe$export$91389b1eb9882ae7);
$parcel$export(module.exports, "ABSOLUTE", () => $f634ecaafde4a9fe$export$8cd2c3eb7eeb9644);
const $f634ecaafde4a9fe$export$91389b1eb9882ae7 = 'RELATIVE';
const $f634ecaafde4a9fe$export$8cd2c3eb7eeb9644 = 'ABSOLUTE';

});

parcelRegister("boVS3", function(module, exports) {

$parcel$export(module.exports, "getADGTimestampDisplaySetting", () => $cd56f2d01d691995$export$e89759fbd7b8f45a);

var $85NCm = parcelRequire("85NCm");
// @ts-expect-error - TS2363 - The right-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type.
const $cd56f2d01d691995$var$getDaysElapsed = (date)=>(Date.now() - new Date(date)) / 86400000;
const $cd56f2d01d691995$export$e89759fbd7b8f45a = (date)=>$cd56f2d01d691995$var$getDaysElapsed(date) < 8 ? (0, $85NCm.RELATIVE) : (0, $85NCm.ABSOLUTE);

});



parcelRegister("5F5ed", function(module, exports) {

$parcel$export(module.exports, "CardIssueType", () => $3b78124543f3119b$export$200b8444ace4b1d3);
/* CardIssueType.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $3bDjY = parcelRequire("3bDjY");
const $3b78124543f3119b$export$200b8444ace4b1d3 = ({ issueType: issueType })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $3b78124543f3119b$var$iconStyles
    }, issueType?.issueType.iconUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: issueType.issueType.name
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3b78124543f3119b$var$Image, {
        alt: issueType.issueType.name,
        src: issueType.issueType.iconUrl
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3b78124543f3119b$var$ImagePlaceholder, null));
const $3b78124543f3119b$var$iconStyles = (0, $8CUq3.xcss)({
    marginRight: 'space.025',
    position: 'relative',
    pointerEvents: 'auto'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3b78124543f3119b$var$ImagePlaceholder = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rkoglpi _1bsb7vkz _4t3i7vkz _bfhkn82g",
            __cmplp.className
        ])
    });
});
const $3b78124543f3119b$var$Image = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bsb7vkz _4t3i7vkz",
            __cmplp.className
        ])
    });
});

});

parcelRegister("8aGLP", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb2f7cdf834cf7e5$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $dF8CK = parcelRequire("dF8CK");

var $fAYZ3 = parcelRequire("fAYZ3");

var $7N5GY = parcelRequire("7N5GY");

var $IpU7z = parcelRequire("IpU7z");
const $fb2f7cdf834cf7e5$var$Subtasks = ({ issue: issue })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { isExpanded: isExpanded, toggleSubtasks: toggleSubtasks } = (0, $dF8CK.useExpandCollapseSubtasks)(issue.id);
    const { loading: loading, fetch: fetch } = (0, $fAYZ3.useIssueSubtasks)(issue);
    const hasSubtasks = Boolean(issue.subtaskMetadata?.total);
    (0, $5uXOq.useEffect)(()=>{
        if (isExpanded && hasSubtasks) fetch();
    // empty dependencies as we only want to run this effect once on mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleToggleClick = (0, $5uXOq.useCallback)(()=>{
        if (!isExpanded) fetch();
        toggleSubtasks();
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'jwmBoardCardSubtaskTrigger', {
            isExpanded: isExpanded
        });
    }, [
        createAnalyticsEvent,
        fetch,
        isExpanded,
        toggleSubtasks
    ]);
    // Do not display any subtask UI if there are no subtasks
    if (!issue.subtaskMetadata?.total) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $IpU7z.default), {
        isExpanded: isExpanded,
        isLoading: loading,
        onToggle: handleToggleClick,
        subtaskMetadata: issue.subtaskMetadata
    }), isExpanded && !loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7N5GY.default), {
        parent: issue
    }));
};
var $fb2f7cdf834cf7e5$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($fb2f7cdf834cf7e5$var$Subtasks);

});
parcelRegister("dF8CK", function(module, exports) {

$parcel$export(module.exports, "useExpandCollapseSubtasks", () => $2cb510ebdfc3af73$export$a152b29991d4fa38);

var $5uXOq = parcelRequire("5uXOq");

var $kGsr8 = parcelRequire("kGsr8");

var $x8FYU = parcelRequire("x8FYU");

var $1kpI8 = parcelRequire("1kpI8");
const $2cb510ebdfc3af73$var$EXPANDED_ISSUES_LIMIT = 20;
const $2cb510ebdfc3af73$export$a152b29991d4fa38 = (issueId)=>{
    const [expandedIssues, setExpandedIssues] = (0, $1kpI8.useViewPreference)((0, $x8FYU.EXPANDED_ISSUES_PREFERENCE));
    const isExpanded = Boolean(expandedIssues?.includes(issueId));
    const collapseSubtasks = (0, $5uXOq.useCallback)(()=>{
        const newExpandedIssues = expandedIssues?.filter((id)=>issueId !== id);
        setExpandedIssues(newExpandedIssues);
    }, [
        expandedIssues,
        issueId,
        setExpandedIssues
    ]);
    const expandSubtasks = (0, $5uXOq.useCallback)(()=>{
        const newExpandedIssues = (0, (/*@__PURE__*/$parcel$interopDefault($kGsr8)))([
            ...expandedIssues || [],
            issueId
        ]);
        // Trim to the last 20 items as we don't want to store too many expanded issues
        if (newExpandedIssues.length > $2cb510ebdfc3af73$var$EXPANDED_ISSUES_LIMIT) newExpandedIssues.splice(0, newExpandedIssues.length - $2cb510ebdfc3af73$var$EXPANDED_ISSUES_LIMIT);
        setExpandedIssues(newExpandedIssues);
    }, [
        expandedIssues,
        issueId,
        setExpandedIssues
    ]);
    const toggleSubtasks = (0, $5uXOq.useCallback)(()=>{
        isExpanded ? collapseSubtasks() : expandSubtasks();
    }, [
        isExpanded,
        collapseSubtasks,
        expandSubtasks
    ]);
    return {
        isExpanded: isExpanded,
        toggleSubtasks: toggleSubtasks
    };
};

});

parcelRegister("fAYZ3", function(module, exports) {

$parcel$export(module.exports, "useIssueSubtasks", () => $2b75fff2d8499cee$export$5b5aeea73b6178e9);

var $5uXOq = parcelRequire("5uXOq");

var $93jKl = parcelRequire("93jKl");

var $kaHBi = parcelRequire("kaHBi");

var $3bQtK = parcelRequire("3bQtK");

var $pa9q9 = parcelRequire("pa9q9");

var $5fc53 = parcelRequire("5fc53");

var $3clZk = parcelRequire("3clZk");

var $hqsgn = parcelRequire("hqsgn");

var $gEtYC = parcelRequire("gEtYC");

var $4iv4Q = parcelRequire("4iv4Q");
const $2b75fff2d8499cee$var$experience = 'loadSubtasks';
const $2b75fff2d8499cee$export$b46cc40fdf28878c = [
    (0, $5fc53.ASSIGNEE_TYPE),
    (0, $5fc53.ISSUE_KEY_TYPE),
    (0, $5fc53.ISSUE_TYPE),
    (0, $5fc53.PARENT_TYPE),
    (0, $5fc53.PRIORITY_TYPE),
    (0, $5fc53.STATUS_TYPE),
    (0, $5fc53.SUMMARY_TYPE)
];
const $2b75fff2d8499cee$export$5b5aeea73b6178e9 = (issue)=>{
    const { updateIssues: updateIssues } = (0, $gEtYC.useIssueStoreActions)();
    const fetchIssues = (0, $3clZk.useFetchBoardIssues)();
    const transformToIssues = (0, $hqsgn.useTransformIssues)();
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const [loading, setLoading] = (0, $5uXOq.useState)(false);
    const startExperience = (0, $kaHBi.useExperienceStart)({
        analyticsSource: 'jiraWorkManagementBoard',
        experience: $2b75fff2d8499cee$var$experience
    });
    const markExperienceSuccess = (0, $3bQtK.useExperienceSuccess)({
        experience: $2b75fff2d8499cee$var$experience
    });
    const markExperienceFailed = (0, $93jKl.useExperienceFail)({
        experience: $2b75fff2d8499cee$var$experience
    });
    const fetch = (0, $5uXOq.useCallback)(async ()=>{
        startExperience();
        setLoading(true);
        try {
            const results = await fetchIssues({
                fieldIds: $2b75fff2d8499cee$export$b46cc40fdf28878c,
                jql: `parent = ${issue.id}`
            });
            const boardIssues = transformToIssues(results);
            updateIssues(boardIssues);
            markExperienceSuccess();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            showFlag({
                description: (0, $4iv4Q.default).errorMessage,
                title: (0, $4iv4Q.default).errorTitle,
                type: 'error',
                messageId: 'work-management-board.controllers.issue-subtasks.show-flag.error',
                messageType: 'transactional'
            });
            markExperienceFailed('Failed to load issue subtasks', error);
        } finally{
            setLoading(false);
        }
    }, [
        issue,
        fetchIssues,
        transformToIssues,
        updateIssues,
        showFlag,
        startExperience,
        markExperienceSuccess,
        markExperienceFailed
    ]);
    return {
        loading: loading,
        fetch: fetch
    };
};

});
parcelRegister("4iv4Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $144a2dc62d55f7cd$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $144a2dc62d55f7cd$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorTitle: {
        "id": "work-management-board.controllers.issue-subtasks.error-title",
        "defaultMessage": "Failed to load subtasks"
    },
    errorMessage: {
        "id": "work-management-board.controllers.issue-subtasks.error-message",
        "defaultMessage": "Check your connection, then give it another try."
    }
});

});


parcelRegister("7N5GY", function(module, exports) {

$parcel$export(module.exports, "default", () => $fad2f573716a8587$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $ujWmd = parcelRequire("ujWmd");

var $3u0c5 = parcelRequire("3u0c5");

var $bmZvc = parcelRequire("bmZvc");

var $bG3pQ = parcelRequire("bG3pQ");

var $hE5wF = parcelRequire("hE5wF");

var $gULOk = parcelRequire("gULOk");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $dCm1o = parcelRequire("dCm1o");

var $js19Q = parcelRequire("js19Q");

var $5F5ed = parcelRequire("5F5ed");

var $cvj5l = parcelRequire("cvj5l");

var $dxAlC = parcelRequire("dxAlC");

var $3WdOs = parcelRequire("3WdOs");

var $850r2 = parcelRequire("850r2");

var $1RIZ4 = parcelRequire("1RIZ4");
const $fad2f573716a8587$var$appearanceMap = {
    [(0, $gULOk.UNDEFINED)]: 'default',
    [(0, $gULOk.TODO)]: 'default',
    [(0, $gULOk.DONE)]: 'success',
    [(0, $gULOk.IN_PROGRESS)]: 'inprogress'
};
const $fad2f573716a8587$var$MAX_NUMBER_OF_SUBTASKS_WITHOUT_SCROLL = 3;
const $fad2f573716a8587$var$SubtaskClickWrapper = ({ onClick: onClick, subtask: subtask, children: children })=>{
    const handleClick = (0, $5uXOq.useCallback)((event)=>{
        onClick(event, subtask);
    }, [
        onClick,
        subtask
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fad2f573716a8587$var$SubtaskWrapper, {
        "data-testid": "work-management-board.ui.board.column.card.card-content.subtasks.subtask-list",
        onClick: handleClick
    }, children);
};
const $fad2f573716a8587$var$SubtaskList = ({ parent: parent })=>{
    const subtasks = (0, $dxAlC.useSubtasksByParentId)({
        parentId: parent.id
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { issueViewInteraction: issueViewInteraction } = (0, $3WdOs.useJWMBoardFeatures)();
    const shouldOpenInNewTab = issueViewInteraction === 'openNewTab';
    const onIssueClick = (0, $850r2.useViewIssue)(null);
    const handleSubtaskClick = (0, $5uXOq.useCallback)((event, subtaskIssue)=>{
        const withCmd = event.ctrlKey || event.metaKey;
        event.stopPropagation();
        shouldOpenInNewTab ? (0, $bG3pQ.openViewFromEmbed)({
            key: (0, $hE5wF.SELECTED_ISSUE_PARAM),
            value: subtaskIssue.fields[0, $cvj5l.ISSUE_KEY_ID].value
        }) : onIssueClick(subtaskIssue, withCmd);
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'subtask clicked');
    }, [
        createAnalyticsEvent,
        onIssueClick,
        shouldOpenInNewTab
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1RIZ4.default), {
        subtasks: subtasks
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            $fad2f573716a8587$var$styles.scrollContainer
        ])
    }, subtasks.map((subtaskIssue)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fad2f573716a8587$var$SubtaskClickWrapper, {
            key: subtaskIssue.id,
            onClick: handleSubtaskClick,
            subtask: subtaskIssue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, $bwpsq.default)([
                $fad2f573716a8587$var$styles.summary
            ])
        }, subtaskIssue.fields[0, $cvj5l.SUMMARY_ID].value), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fad2f573716a8587$var$SubtaskRow, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, $bwpsq.default)([
                $fad2f573716a8587$var$styles.issueTypeAndKey
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fad2f573716a8587$var$SubtaskIssueTypeContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5F5ed.CardIssueType), {
            issueType: subtaskIssue.fields[0, $cvj5l.ISSUE_TYPE_ID]
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $js19Q.CardKey), {
            text: subtaskIssue.fields[0, $cvj5l.ISSUE_KEY_ID].value
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fad2f573716a8587$var$SubtaskRowCell, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fad2f573716a8587$var$SubtaskLozengeWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3u0c5.default), {
            appearance: $fad2f573716a8587$var$appearanceMap[(0, $gULOk.statusCategoryForId)(subtaskIssue.fields[0, $cvj5l.STATUS_ID].status.statusCategoryId)],
            isBold: (0, $dCm1o.isVisualRefreshEnabled)()
        }, subtaskIssue.fields[0, $cvj5l.STATUS_ID].status.name)), !subtaskIssue.fields[0, $cvj5l.ASSIGNEE_ID]?.user.avatarURL ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
            appearance: "circle",
            size: "small"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bmZvc.AvatarLite), {
            avatarUrl: subtaskIssue.fields[0, $cvj5l.ASSIGNEE_ID].user.avatarURL,
            name: subtaskIssue.fields[0, $cvj5l.ASSIGNEE_ID].user.name
        })))))), subtasks.length > $fad2f573716a8587$var$MAX_NUMBER_OF_SUBTASKS_WITHOUT_SCROLL && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fad2f573716a8587$var$SubtasksDivider, null));
};
var $fad2f573716a8587$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($fad2f573716a8587$var$SubtaskList);
const $fad2f573716a8587$var$borderWidth = 2;
const $fad2f573716a8587$var$styles = {
    scrollContainer: "_c71leoa3 _18m91wug _18u0xmi2 _2hwxxmi2 _ca0qidpf _n3tdidpf _19bvutpp _u5f3utpp _kqswh2mm _lcxv1wug",
    summary: "_1e0c1txw _otyr1b66",
    issueTypeAndKey: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _4cvr1h6o _1ul9idpf"
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $fad2f573716a8587$var$SubtaskWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _2lx21bp4 _18u0xmi2 _2hwxxmi2 _ca0q12x7 _n3td12x7 _19bvutpp _u5f3utpp _80omtlke _irr3166n",
            __cmplp.className
        ])
    });
});
const $fad2f573716a8587$var$SubtaskRow = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulp1b66 _1e0c1txw _4cvr1h6o _1bah1yb4 _1n261nf0",
            __cmplp.className
        ])
    });
});
const $fad2f573716a8587$var$SubtaskRowCell = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $fad2f573716a8587$var$SubtaskIssueTypeContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2hwxu2gc",
            __cmplp.className
        ])
    });
});
const $fad2f573716a8587$var$SubtasksDivider = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isTop: isTop, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _x3doudwz _1bsb1osq _4t3iidpf",
            __cmplp.isTop ? "_19pk12x7" : "_19pkze3t",
            __cmplp.className
        ])
    });
});
const $fad2f573716a8587$var$SubtaskLozengeWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_u5f31b66 _1e0c1txw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("1RIZ4", function(module, exports) {

$parcel$export(module.exports, "default", () => $778f560feadfa9f6$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $3bDjY = parcelRequire("3bDjY");

var $gULOk = parcelRequire("gULOk");

var $koVbs = parcelRequire("koVbs");

var $cvj5l = parcelRequire("cvj5l");

var $9tJvI = parcelRequire("9tJvI");
const $778f560feadfa9f6$var$SubtaskProgressBar = ({ subtasks: subtasks })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const renderBarSection = (0, $5uXOq.useCallback)((statusCategoryId, BarSectionComponent, message)=>{
        if (!subtasks) return null;
        const count = subtasks.filter((subtask)=>subtask.fields[0, $cvj5l.STATUS_ID].status.statusCategoryId === statusCategoryId).length;
        const label = formatMessage(message, {
            itemCount: count,
            totalCount: subtasks.length
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($778f560feadfa9f6$var$BarSectionContainer, {
            barWidthPct: count / subtasks.length * 100,
            role: "progressbar",
            "aria-valuemax": subtasks.length,
            "aria-valuenow": count,
            "aria-label": label
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: label
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(BarSectionComponent, null)));
    }, [
        subtasks,
        formatMessage
    ]);
    if (!subtasks || subtasks.length === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            $778f560feadfa9f6$var$styles.root
        ])
    }, renderBarSection((0, $gULOk.StatusCategoryIds)[(0, $gULOk.StatusCategoryTypes).DONE], $778f560feadfa9f6$var$DoneBarSection, (0, $9tJvI.default).doneItems), renderBarSection((0, $gULOk.StatusCategoryIds)[(0, $gULOk.StatusCategoryTypes).INDETERMINATE], $778f560feadfa9f6$var$InProgressBarSection, (0, $9tJvI.default).inProgressItems), renderBarSection((0, $gULOk.StatusCategoryIds)[(0, $gULOk.StatusCategoryTypes).NEW], $778f560feadfa9f6$var$TodoBarSection, (0, $9tJvI.default).todoItems));
};
var $778f560feadfa9f6$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($778f560feadfa9f6$var$SubtaskProgressBar);
const $778f560feadfa9f6$var$styles = {
    root: "_2rko1y44 _1reo15vq _18m915vq _bfhkmuej _1bsb1osq _19pk12x7 _otyru2gc _1e0c1txw _80omtlke _kqswh2mm _lcxv1wug"
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $778f560feadfa9f6$var$BarSectionContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { barWidthPct: barWidthPct, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_mkz0ru": (0, $lD23V.default)(`${__cmplp.barWidthPct}%`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_i0dlrmxw _1jqf15vq _8dku15vq _uar715vq _1st315vq _11fs1y44 _1ih21y44 _k8kw1y44 _px611y44",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $778f560feadfa9f6$var$BarSection = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3ii2wt",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $778f560feadfa9f6$var$DoneBarSection = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $778f560feadfa9f6$var$BarSection, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_bfhk1ua5",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $778f560feadfa9f6$var$InProgressBarSection = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $778f560feadfa9f6$var$BarSection, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_bfhkz4b0",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $778f560feadfa9f6$var$TodoBarSection = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $778f560feadfa9f6$var$BarSection, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_bfhkmuej",
            __cmplp.className
        ])
    });
});

});
parcelRegister("9tJvI", function(module, exports) {

$parcel$export(module.exports, "default", () => $12c56c76a8894ee5$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $12c56c76a8894ee5$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    doneItems: {
        "id": "work-management-board.board.column.card.card-content.subtasks.subtask-list.subtask-progress-bar.done-items",
        "defaultMessage": "{itemCount} of {totalCount} done"
    },
    inProgressItems: {
        "id": "work-management-board.board.column.card.card-content.subtasks.subtask-list.subtask-progress-bar.in-progress-items",
        "defaultMessage": "{itemCount} of {totalCount} in progress"
    },
    todoItems: {
        "id": "work-management-board.board.column.card.card-content.subtasks.subtask-list.subtask-progress-bar.todo-items",
        "defaultMessage": "{itemCount} of {totalCount} to do"
    }
});

});



parcelRegister("IpU7z", function(module, exports) {

$parcel$export(module.exports, "default", () => $19a5c6a1bd089818$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $2rqOp = parcelRequire("2rqOp");

var $hWZau = parcelRequire("hWZau");

var $2lRM4 = parcelRequire("2lRM4");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $aEYgJ = parcelRequire("aEYgJ");
const $19a5c6a1bd089818$var$SubtasksExpandCollapse = ({ isExpanded: isExpanded, isLoading: isLoading, onToggle: onToggle, subtaskMetadata: subtaskMetadata })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const tooltipContent = formatMessage(isExpanded ? (0, $aEYgJ.default).hideSubtasksTooltip : (0, $aEYgJ.default).showSubtasksTooltip);
    return /*#__PURE__*/ $5uXOq.createElement("div", {
        className: (0, $bwpsq.default)([
            "_1bsb1ns9 _kqswh2mm _lcxv1wug"
        ])
    }, /*#__PURE__*/ $5uXOq.createElement((0, $3bDjY.default), {
        content: tooltipContent,
        hideTooltipOnMouseDown: true
    }, /*#__PURE__*/ $5uXOq.createElement((0, $2rqOp.default), {
        isLoading: isLoading,
        onClick: onToggle,
        "aria-label": formatMessage((0, $aEYgJ.default).subtasksAriaLabel, {
            done: subtaskMetadata.done,
            total: subtaskMetadata.total
        }),
        "aria-expanded": isExpanded
    }, /*#__PURE__*/ $5uXOq.createElement($19a5c6a1bd089818$var$SubtaskButtonContent, null, /*#__PURE__*/ $5uXOq.createElement((0, (/*@__PURE__*/$parcel$interopDefault($2lRM4))), {
        LEGACY_size: "small",
        label: ""
    }), /*#__PURE__*/ $5uXOq.createElement("span", null, subtaskMetadata.done, "/", subtaskMetadata.total), /*#__PURE__*/ $5uXOq.createElement($19a5c6a1bd089818$var$SubtaskExpandCollapse, {
        expanded: isExpanded
    }, /*#__PURE__*/ $5uXOq.createElement((0, (/*@__PURE__*/$parcel$interopDefault($hWZau))), {
        spacing: "spacious",
        label: ""
    }))))));
};
var $19a5c6a1bd089818$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($19a5c6a1bd089818$var$SubtasksExpandCollapse);
const $19a5c6a1bd089818$var$subtaskContainerStyles = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $19a5c6a1bd089818$var$SubtaskButtonContent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulp1b66 _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $19a5c6a1bd089818$var$SubtaskExpandCollapse = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { expanded: expanded, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_v5644a6k _1e0c1txw _4cvr1h6o",
            __cmplp.expanded ? "_t9ec14w8" : "_t9ec160w",
            __cmplp.className
        ])
    });
});

});
parcelRegister("2lRM4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::200ce97a939b47e9d28e7bba19907286>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1b67416004fa3b5c$var$_react = $1b67416004fa3b5c$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $1b67416004fa3b5c$var$_subtasks = $1b67416004fa3b5c$var$_interopRequireDefault((parcelRequire("iRvAI")));

var $1b67416004fa3b5c$var$_subtask = $1b67416004fa3b5c$var$_interopRequireDefault((parcelRequire("gKopa")));
function $1b67416004fa3b5c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for SubtasksIcon.
 * This component is SubtasksIcon, with `UNSAFE_fallbackIcon` set to "SubtaskIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for subtask work type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1b67416004fa3b5c$var$SubtasksIcon = (props)=>/*#__PURE__*/ $1b67416004fa3b5c$var$_react.default.createElement($1b67416004fa3b5c$var$_subtasks.default, Object.assign({
        LEGACY_fallbackIcon: $1b67416004fa3b5c$var$_subtask.default
    }, props));
$1b67416004fa3b5c$var$SubtasksIcon.Name = 'SubtasksIconMigration';
var $1b67416004fa3b5c$var$_default = module.exports.default = $1b67416004fa3b5c$var$SubtasksIcon;

});
parcelRegister("iRvAI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cb1eed99abd44e812ae4cb98f136c93f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dbb5ae8ec700c853$var$_react = $dbb5ae8ec700c853$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $dbb5ae8ec700c853$var$_baseNew = $dbb5ae8ec700c853$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $dbb5ae8ec700c853$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Subtasks".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for subtask work type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $dbb5ae8ec700c853$var$SubtasksIcon = (props)=>/*#__PURE__*/ $dbb5ae8ec700c853$var$_react.default.createElement($dbb5ae8ec700c853$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.5 9.25a.5.5 0 0 0-.5-.5H8.75V13a.5.5 0 0 0 .5.5H13a.5.5 0 0 0 .5-.5zM7.25 3a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v3.75a.5.5 0 0 0 .5.5h4.25zm1.5 4.25H13a2 2 0 0 1 2 2V13a2 2 0 0 1-2 2H9.25a2 2 0 0 1-2-2V8.75H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h3.75a2 2 0 0 1 2 2z"/>`
    }, props));
$dbb5ae8ec700c853$var$SubtasksIcon.displayName = 'SubtasksIcon';
var $dbb5ae8ec700c853$var$_default = module.exports.default = $dbb5ae8ec700c853$var$SubtasksIcon;

});

parcelRegister("gKopa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c313df89ecedecba$var$_react = $c313df89ecedecba$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $c313df89ecedecba$var$_subtasks = $c313df89ecedecba$var$_interopRequireDefault((parcelRequire("iRvAI")));
function $c313df89ecedecba$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c313df89ecedecba$var$SubtaskIcon = (props)=>/*#__PURE__*/ $c313df89ecedecba$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M19 7c1.105.003 2 .899 2 2.006v9.988A2.005 2.005 0 0 1 18.994 21H9.006A2.005 2.005 0 0 1 7 19h11c.555 0 1-.448 1-1zM3 5.006C3 3.898 3.897 3 5.006 3h9.988C16.102 3 17 3.897 17 5.006v9.988A2.005 2.005 0 0 1 14.994 17H5.006A2.005 2.005 0 0 1 3 14.994zM5 5v10h10V5z"/><path d="M7.707 9.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L9 10.586z"/></g></svg>`
    }, props, {
        newIcon: $c313df89ecedecba$var$_subtasks.default
    }));
$c313df89ecedecba$var$SubtaskIcon.displayName = 'SubtaskIcon';
var $c313df89ecedecba$var$_default = module.exports.default = $c313df89ecedecba$var$SubtaskIcon;

});


parcelRegister("aEYgJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f36d249d8e13de0$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $6f36d249d8e13de0$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    showSubtasksTooltip: {
        "id": "work-management-board.board.column.card.card-content.subtasks.subtasks-expand-collapse.show-subtasks-tooltip",
        "defaultMessage": "Show subtasks"
    },
    hideSubtasksTooltip: {
        "id": "work-management-board.board.column.card.card-content.subtasks.subtasks-expand-collapse.hide-subtasks-tooltip",
        "defaultMessage": "Hide subtasks"
    },
    subtasksAriaLabel: {
        "id": "work-management-board.board.column.card.card-content.subtasks.subtasks-expand-collapse.subtasks-aria-label",
        "defaultMessage": "Subtasks ({done} of {total, plural, one {# subtask} other {# subtasks}} complete)"
    }
});

});




parcelRegister("dKta6", function(module, exports) {

$parcel$export(module.exports, "CardCover", () => $f1e25925a80f58e3$export$1a2d6d8c98d2c941);

var $3qqDh = parcelRequire("3qqDh");

var $9zFm5 = parcelRequire("9zFm5");

var $gdwS2 = parcelRequire("gdwS2");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $8Uumt = parcelRequire("8Uumt");

var $7i3ao = parcelRequire("7i3ao");

var $fHEdP = parcelRequire("fHEdP");

var $azoug = parcelRequire("azoug");

var $cvj5l = parcelRequire("cvj5l");

var $4XIcI = parcelRequire("4XIcI");
const $f1e25925a80f58e3$var$CARD_COVER_COLOR_HEIGHT = 24;
const $f1e25925a80f58e3$var$CARD_COVER_IMAGE_HEIGHT = 140;
const $f1e25925a80f58e3$export$1a2d6d8c98d2c941 = /*#__PURE__*/ (0, $5uXOq.memo)(({ coverMedia: coverMedia, queryFragment: queryFragment })=>{
    const data = (0, $8Uumt.useFragment)((0, $gdwS2.default), queryFragment);
    const isOpen = (0, $4XIcI.useIsCardCoverEditingOpen)();
    const { ref: ref } = (0, $7i3ao.useResizingHeight)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        ref: isOpen ? ref : null
    }, coverMedia !== null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f1e25925a80f58e3$var$CardCoverInner, {
        coverMedia: coverMedia,
        queryFragment: data
    }));
});
const $f1e25925a80f58e3$var$CardCoverInner = /*#__PURE__*/ (0, $5uXOq.memo)(({ coverMedia: coverMedia, queryFragment: queryFragment })=>{
    const data = (0, $8Uumt.useFragment)((0, $9zFm5.default), queryFragment);
    if (coverMedia.type === 'color') {
        const theme = (0, $fHEdP.themeManager).getColor(coverMedia.value)?.theme;
        if (!theme) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f1e25925a80f58e3$var$CardColorCoverContainer, {
            "data-testid": "work-management-board.ui.board.column.card.card-cover.card-cover-color",
            backgroundColor: theme.light['color.elevation.surface']
        });
    }
    if (coverMedia.type === 'gradient') {
        const theme = (0, $fHEdP.themeManager).getGradient(coverMedia.value)?.theme;
        if (!theme) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f1e25925a80f58e3$var$CardGradientCoverContainer, {
            "data-testid": "work-management-board.ui.board.column.card.card-cover.card-cover-gradient",
            background: theme.light['elevation.surface']
        });
    }
    if (coverMedia.type === 'image') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f1e25925a80f58e3$var$CardImageCover, {
        coverMedia: coverMedia,
        queryFragment: data
    });
    return null;
});
const $f1e25925a80f58e3$var$CardImageCover = ({ coverMedia: coverMedia, queryFragment: queryFragment })=>{
    const imageRef = (0, $5uXOq.useRef)(null);
    const data = (0, $8Uumt.useFragment)((0, $3qqDh.default), queryFragment);
    const imgUrl = (0, $5uXOq.useMemo)(()=>{
        if (!data.jira?.mediaClientId || !data.jira?.mediaExternalEndpointUrl) return null;
        return (0, $fHEdP.generateMediaImageUrl)({
            mediaApiFileId: coverMedia.mediaApiFileId,
            mediaClientId: data.jira.mediaClientId,
            mediaExternalEndpointUrl: data.jira.mediaExternalEndpointUrl,
            token: coverMedia.mediaReadToken,
            mediaEndpoint: 'image',
            // A card is really 260px wide, but we want to load the image at a higher resolution
            // and then scale it down to avoid blurry images. If you use 260px, there will be a gap
            // between the image and the card border.
            width: (0, $cvj5l.COLUMN_FIXED_WIDTH),
            'max-age': Number.MAX_SAFE_INTEGER
        });
    }, [
        coverMedia,
        data
    ]); /**
                           * Give attribution to the unsplash api for qualified images.
                           * This is needed for legal reasons to comply with their API terms of service.
                           */ 
    (0, $5uXOq.useEffect)(()=>{
        if (!imgUrl) return;
        if (coverMedia.unsplashId != null && imageRef.current) {
            const unsubscribe = (0, $azoug.unsplashTracker).trackWhileInViewport(imageRef.current, coverMedia.unsplashId);
            return unsubscribe;
        }
    }, [
        coverMedia.unsplashId,
        imgUrl
    ]);
    if (!imgUrl) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f1e25925a80f58e3$var$MemoizedCardImageCover, {
        ref: imageRef,
        "data-testid": "work-management-board.ui.board.column.card.card-cover.card-cover-image",
        src: imgUrl,
        title: coverMedia.fileName
    });
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f1e25925a80f58e3$var$CardImageCoverImg = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_13orr8u": (0, $lD23V.default)(`url(${__cmplp.src})`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1itk2pcs _bfhkm7j4 _1lrw1dfr _12vemgnk _ouxl1ssb _4t3i11ux _1bsb1osq _13liglpi _qrwqglpi",
            __cmplp.className
        ])
    });
});
const $f1e25925a80f58e3$var$urlWithoutToken = (url)=>{
    const parsedUrl = new URL(url);
    parsedUrl.searchParams.delete('token');
    return parsedUrl.toString();
}; /**
    * Since the board items are refetched after any board changes, we receive a new token
    * every time. As a result, the image is refetched and causes a flicker. We don't need
    * to rerender the image in that case. The cases we need to are when the image is removed
    * or added, in which case we will retrieve a token separately and rerender.
    */ 
const $f1e25925a80f58e3$var$MemoizedCardImageCover = /*#__PURE__*/ (0, $5uXOq.memo)($f1e25925a80f58e3$var$CardImageCoverImg, (prevProps, nextProps)=>$f1e25925a80f58e3$var$urlWithoutToken(prevProps.src) === $f1e25925a80f58e3$var$urlWithoutToken(nextProps.src)); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f1e25925a80f58e3$var$CardGradientCoverContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { background: background, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_146l9hq": (0, $lD23V.default)(__cmplp.background)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11q71i36 _4t3i1tcg _1bsb1osq _13liglpi _qrwqglpi",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f1e25925a80f58e3$var$CardColorCoverContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { backgroundColor: backgroundColor, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1hphqkz": (0, $lD23V.default)(__cmplp.backgroundColor)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_bfhk3qkl _4t3i1tcg _1bsb1osq _13liglpi _qrwqglpi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("3qqDh", function(module, exports) {

$parcel$export(module.exports, "default", () => $45752e3d8c19cb59$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c390c936f86c11580305a5c625de2a82>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $45752e3d8c19cb59$var$node = function() {
    var v0 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "cloudId"
            }
        ],
        "kind": "Fragment",
        "name": "cardCover_workManagementBoard_CardImageCover_queryFragment",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v0 /*: any*/ ,
                            "kind": "ScalarField",
                            "name": "mediaClientId"
                        },
                        {
                            "args": v0 /*: any*/ ,
                            "kind": "ScalarField",
                            "name": "mediaExternalEndpointUrl"
                        }
                    ]
                },
                "action": "THROW",
                "path": "jira"
            }
        ],
        "type": "Query"
    };
}();
$45752e3d8c19cb59$var$node.hash = "3e08da767606c294768dfcd7a2b95f9b";
var $45752e3d8c19cb59$export$2e2bcd8739ae039 = $45752e3d8c19cb59$var$node;

});

parcelRegister("9zFm5", function(module, exports) {

$parcel$export(module.exports, "default", () => $a2eeb978943f924c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0e8d63ea22d95a5b8331ff6ede9d3767>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a2eeb978943f924c$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "cardCover_workManagementBoard_CardCoverInner_queryFragment",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "cardCover_workManagementBoard_CardImageCover_queryFragment"
        }
    ],
    "type": "Query"
};
$a2eeb978943f924c$var$node.hash = "01b522623e1ec272cbbaf4ad3c86b91b";
var $a2eeb978943f924c$export$2e2bcd8739ae039 = $a2eeb978943f924c$var$node;

});

parcelRegister("gdwS2", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a3c2e3d8adebcaa$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<05805dacdb6cc979c37fb575cf1789a9>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $4a3c2e3d8adebcaa$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "cardCover_workManagementBoard_queryFragment",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "cardCover_workManagementBoard_CardCoverInner_queryFragment"
        }
    ],
    "type": "Query"
};
$4a3c2e3d8adebcaa$var$node.hash = "d148051529bb139ea401e21c47ccf9d9";
var $4a3c2e3d8adebcaa$export$2e2bcd8739ae039 = $4a3c2e3d8adebcaa$var$node;

});

parcelRegister("7i3ao", function(module, exports) {

$parcel$export(module.exports, "useResizingHeight", () => $5f7cf4464a63f574$export$da99457d6430d83);
$parcel$export(module.exports, "ResizingHeight", () => $5f7cf4464a63f574$export$204d7b6d1491a2d3);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $dWt6p = parcelRequire("dWt6p");


var $lObw7 = parcelRequire("lObw7");

var $bh8Xz = parcelRequire("bh8Xz");

var $3GP8X = parcelRequire("3GP8X");

var $fsENI = parcelRequire("fsENI");

var $5Otrq = parcelRequire("5Otrq");
const $5f7cf4464a63f574$export$da99457d6430d83 = ({ duration: calcDuration = ()=>(0, $lObw7.durations).medium, timingFunction: calcTimingFunction = ()=>(0, $eba99f58997c09b3$export$c07234257a03d5e9) } = {})=>{
    const prevDimensions = (0, $5uXOq.useRef)();
    const [element, setElementRef] = (0, $3GP8X.useElementRef)();
    // We cleanup on the next effect to prevent the previous timeout being called during
    // the next motion - as now the timeout has essentially been extended!
    const setTimeout = (0, $bh8Xz.useSetTimeout)({
        cleanup: 'next-effect'
    });
    const requestAnimationFrame = (0, $bh8Xz.useRequestAnimationFrame)();
    (0, $5Otrq.useSnapshotBeforeUpdate)(()=>{
        if ((0, $dWt6p.isReducedMotion)() || !element) return;
        prevDimensions.current = element.getBoundingClientRect();
    });
    (0, $fsENI.useLayoutEffect)(()=>{
        if ((0, $dWt6p.isReducedMotion)() || !element || !prevDimensions.current) return;
        // We might already be animating.
        // Because of that we need to expand to the destination height first.
        element.setAttribute('style', '');
        const nextDimensions = element.getBoundingClientRect();
        if (nextDimensions.height === prevDimensions.current.height) return;
        const duration = calcDuration(prevDimensions.current.height, nextDimensions.height);
        const newStyles = {
            height: `${prevDimensions.current.height}px`,
            willChange: 'height',
            transitionProperty: 'height',
            transitionDuration: `${duration}ms`,
            boxSizing: 'border-box',
            transitionTimingFunction: calcTimingFunction(prevDimensions.current.height, nextDimensions.height, duration)
        };
        Object.assign(element.style, newStyles);
        // We split this over two animation frames so the DOM has enough time to flush the changes.
        // We are deliberately not skipping this frame if another render happens - if we do the motion doesn't finish properly.
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                if (!element) return;
                element.style.height = `${nextDimensions.height}px`;
                setTimeout(()=>{
                    if (!element) return;
                    element.setAttribute('style', '');
                }, duration);
            });
        });
    });
    return {
        ref: setElementRef
    };
};
const $5f7cf4464a63f574$export$204d7b6d1491a2d3 = ({ children: children, ...props })=>{
    const resizing = $5f7cf4464a63f574$export$da99457d6430d83(props);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Fragment), {
        children: children(resizing)
    });
};

});
const $eba99f58997c09b3$export$c07234257a03d5e9 = 'cubic-bezier(0.15,1,0.3,1)';
const $eba99f58997c09b3$export$57636bb43b1ccbb0 = 'cubic-bezier(0.2,0,0,1)';
const $eba99f58997c09b3$export$929e5a82286172a6 = 'cubic-bezier(0.8,0,0,0.8)';
const $eba99f58997c09b3$export$45db2fc2f15997e7 = 'cubic-bezier(0,0,1,1)';

parcelRegister("3GP8X", function(module, exports) {

$parcel$export(module.exports, "useElementRef", () => $19cc13cbd0e78f53$export$ff879f35a69d56b7);

var $5uXOq = parcelRequire("5uXOq");
const $19cc13cbd0e78f53$export$ff879f35a69d56b7 = ()=>{
    const elementRef = (0, $5uXOq.useRef)(null);
    const setRef = (0, $5uXOq.useCallback)((ref)=>{
        elementRef.current = ref;
    }, []);
    return [
        elementRef.current,
        setRef
    ];
};

});

parcelRegister("5Otrq", function(module, exports) {

$parcel$export(module.exports, "useSnapshotBeforeUpdate", () => $80940ec2167ac037$export$9e95200239cd148b);

var $5uXOq = parcelRequire("5uXOq");

var $fsENI = parcelRequire("fsENI");
const $80940ec2167ac037$export$9e95200239cd148b = (cb)=>{
    const isFirstRender = (0, $5uXOq.useRef)(true);
    if (!isFirstRender.current) cb();
    (0, $fsENI.useLayoutEffect)(()=>{
        isFirstRender.current = false;
    }, []);
};

});



parcelRegister("aNAix", function(module, exports) {

$parcel$export(module.exports, "CardBadge", () => $ae6223354b05c38c$export$bc1a48e1b7ed7af);

var $5uXOq = parcelRequire("5uXOq");

var $3bDjY = parcelRequire("3bDjY");

var $b9ZBg = parcelRequire("b9ZBg");

var $koVbs = parcelRequire("koVbs");

var $j31GY = parcelRequire("j31GY");
const $ae6223354b05c38c$export$bc1a48e1b7ed7af = ({ selections: selections, children: children, position: position })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if (!selections) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
    const cardSelection = selections[0];
    const tooltipContent = selections.length > 1 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, selections.map(({ user: user }, i)=>i !== 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            key: user.name
        }, user.name))) : null;
    const otherSelectionsContent = selections.length > 1 ? formatMessage((0, $j31GY.default).moreSelections, {
        count: selections.length - 1
    }) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b9ZBg.NodeSelectionWrapper), {
        color: cardSelection.color
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: tooltipContent,
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b9ZBg.ParticipantBadge), {
        color: cardSelection.color,
        position: position
    }, cardSelection.user.name, otherSelectionsContent), children));
};

});
parcelRegister("b9ZBg", function(module, exports) {

$parcel$export(module.exports, "NodeSelectionWrapper", () => $245afad9428c4f83$export$f758a58bee5c7927);
$parcel$export(module.exports, "ParticipantBadge", () => $245afad9428c4f83$export$91bc13dfc76fa8fa);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

const $245afad9428c4f83$var$BADGE_SIZE = 16;
// the badge text color will remain white regardless of the theme applied
const $245afad9428c4f83$var$BADGE_TEXT_COLOR = 'white';
const $245afad9428c4f83$export$f758a58bee5c7927 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_oor3vt": (0, $lD23V.default)(`0 0 0 2px ${__cmplp.color} inset`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1sit _1bsb1osq _4t3i1osq _16qs1zte",
            __cmplp.className
        ])
    });
});
const $245afad9428c4f83$export$91bc13dfc76fa8fa = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { position: position, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_xexnhp": (0, $lD23V.default)(__cmplp.color)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11q71cj8 _11c8dcr7 _kqswstnw _1e0c1txw _1bah1h6o _4cvr1h6o _1xi2idpf _1bsb1wug _4t3i7vkz _1pbykb7n _ca0qidpf _u5f31b66 _n3tdidpf _19bv1b66 _vchhusvi _syazu67f",
            __cmplp.position === (0, $44496cc0f0c1ce14$export$86bcdda8e7a22b9d) ? "_154iidpf" : "_154id439",
            __cmplp.position === (0, $44496cc0f0c1ce14$export$86bcdda8e7a22b9d) ? "_2rko1pph" : "_2rko2hs0",
            __cmplp.className
        ])
    });
});

});

parcelRegister("j31GY", function(module, exports) {

$parcel$export(module.exports, "default", () => $af0fdb6dbf323682$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $af0fdb6dbf323682$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    moreSelections: {
        "id": "work-management-board.board.column.card.card-badge.more-selections",
        "defaultMessage": " + {count, plural, one {# other} other {# others}}"
    }
});

});


parcelRegister("a2Vvo", function(module, exports) {

$parcel$export(module.exports, "CardFooter", () => $93d727d2faab5c7a$export$e9897d434e0741ee);

var $flMun = parcelRequire("flMun");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Uumt = parcelRequire("8Uumt");

var $hE5wF = parcelRequire("hE5wF");

var $5fc53 = parcelRequire("5fc53");

var $dCm1o = parcelRequire("dCm1o");

var $cvj5l = parcelRequire("cvj5l");

var $dOEk3 = parcelRequire("dOEk3");

var $7UxVW = parcelRequire("7UxVW");
const $93d727d2faab5c7a$export$e9897d434e0741ee = /*#__PURE__*/ (0, $5uXOq.memo)(({ cardOptionsFragment: cardOptionsFragment, issue: issue })=>{
    const cardOptions = (0, $8Uumt.useFragment)((0, $flMun.default), cardOptionsFragment);
    const pageCount = issue.fields[0, $hE5wF.REMOTE_ISSUE_LINKS_TYPE]?.value ?? 0;
    const issueLinksCount = issue.fields[0, $5fc53.ISSUE_LINKS_TYPE]?.value ?? 0;
    const hasConfluencePages = cardOptions.edges.some((edge)=>edge?.node?.field?.fieldId === (0, $cvj5l.PAGES)) && pageCount > 0;
    const hasIssueLinks = cardOptions.edges.some((edge)=>edge?.node?.field?.fieldId === (0, $5fc53.ISSUE_LINKS_TYPE)) && issueLinksCount > 0;
    const hasFooter = hasConfluencePages || hasIssueLinks;
    if (!hasFooter) return null;
    return /*#__PURE__*/ $5uXOq.createElement("div", {
        className: (0, $bwpsq.default)([
            "_zulp1b66 _1e0c1txw _ca0qu2gc _u5f3utpp _n3tdu2gc _19bvutpp",
            (0, $dCm1o.isVisualRefreshEnabled)() && "_ca0qze3t _u5f3utpp _n3tdu2gc _19bvutpp"
        ])
    }, hasConfluencePages ? /*#__PURE__*/ $5uXOq.createElement((0, $dOEk3.default), {
        issue: issue
    }) : null, hasIssueLinks ? /*#__PURE__*/ $5uXOq.createElement((0, $7UxVW.IssueLinks), {
        issueId: issue.id,
        issueKey: issue.fields[0, $cvj5l.ISSUE_KEY_ID].value,
        issueSummary: issue.fields[0, $cvj5l.SUMMARY_ID].value,
        issueLinksCount: issue.fields[0, $5fc53.ISSUE_LINKS_TYPE]?.value ?? 0,
        issueTypeField: issue.fields[0, $cvj5l.ISSUE_TYPE_ID]
    }) : null);
});
const $93d727d2faab5c7a$var$footerStyles = null;
const $93d727d2faab5c7a$var$footerRefreshStyles = null;

});
parcelRegister("flMun", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf2129892b5e5dc4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c9573d579e2d37f018499a38cbf156b6>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $bf2129892b5e5dc4$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "CardFooter_cardOptions",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "JiraBoardViewCardOptionEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "JiraField",
                                                "kind": "LinkedField",
                                                "name": "field",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "kind": "ScalarField",
                                                            "name": "fieldId"
                                                        },
                                                        "action": "THROW",
                                                        "path": "edges.node.field.fieldId"
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "edges.node.field"
                                        }
                                    ],
                                    "type": "JiraBoardViewFieldCardOption"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "edges.node"
                    }
                ]
            },
            "action": "THROW",
            "path": "edges"
        }
    ],
    "type": "JiraBoardViewCardOptionConnection"
};
$bf2129892b5e5dc4$var$node.hash = "d594220f166975c06eface2769d424c2";
var $bf2129892b5e5dc4$export$2e2bcd8739ae039 = $bf2129892b5e5dc4$var$node;

});

parcelRegister("dOEk3", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f48328bd271abcd$export$2e2bcd8739ae039);
/* CardDetailConfluencePages.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $eQfWH = parcelRequire("eQfWH");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $3bDjY = parcelRequire("3bDjY");

var $eZJjh = parcelRequire("eZJjh");

var $hE5wF = parcelRequire("hE5wF");

var $koVbs = parcelRequire("koVbs");

var $jgJNO = parcelRequire("jgJNO");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $dCm1o = parcelRequire("dCm1o");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $47gW9 = parcelRequire("47gW9");

var $4R6GH = parcelRequire("4R6GH");

var $hWes5 = parcelRequire("hWes5");

var $29zEB = parcelRequire("29zEB");
const $8f48328bd271abcd$var$menuContentEntryPointProps = {};
const $8f48328bd271abcd$var$styles = {
    fallbackMenu: "_1e0c1txw _1bah1h6o _4cvr1h6o _1bsbr0r7 _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi"
};
const $8f48328bd271abcd$var$CardDetailConfluencePages = ({ issue: issue })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const closeMenu = (0, $5uXOq.useCallback)(()=>setIsOpen(false), []);
    const pageCount = issue.fields[0, $hE5wF.REMOTE_ISSUE_LINKS_TYPE]?.value ?? 0;
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $hWes5.cardConfluencePagesMenuContentEntryPoint), $8f48328bd271abcd$var$menuContentEntryPointProps);
    const menuContentTrigger = (0, $47gW9.useEntryPointButtonTrigger)(entryPointActions, !isOpen);
    const popupContent = (0, $5uXOq.useCallback)(({ update: update })=>/*#__PURE__*/ $5uXOq.createElement((0, $7XluA.JiraEntryPointContainer), {
            entryPointReferenceSubject: entryPointReferenceSubject,
            id: "business-board-card-confluence-links-menu",
            packageName: "@atlassian/jira-work-management-board",
            runtimeProps: {
                issue: issue,
                onContentResize: update
            },
            fallback: /*#__PURE__*/ $5uXOq.createElement((0, $dC5iT.default), {
                xcss: $8f48328bd271abcd$var$styles.fallbackMenu
            }, /*#__PURE__*/ $5uXOq.createElement((0, $eZJjh.default), null))
        }), [
        entryPointReferenceSubject,
        issue
    ]);
    const onTriggerClicked = (0, $5uXOq.useCallback)(()=>{
        setIsOpen((prev)=>!prev);
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'confluencePagesField clicked');
    }, [
        createAnalyticsEvent
    ]);
    const popupTrigger = (0, $5uXOq.useCallback)((triggerProps)=>/*#__PURE__*/ $5uXOq.createElement((0, $3bDjY.default), {
            content: formatMessage((0, $4R6GH.fg)('confluence-items-jira-all-work-column-heading') ? (0, $29zEB.default).itemCount : (0, $29zEB.default).pageCount, {
                pageCount: pageCount
            }),
            hideTooltipOnClick: true
        }, /*#__PURE__*/ $5uXOq.createElement("div", {
            className: (0, $bwpsq.default)([
                "_kqswh2mm _lcxv1wug"
            ])
        }, /*#__PURE__*/ $5uXOq.createElement($8f48328bd271abcd$var$StyledButton, {
            ...triggerProps,
            ref: (element)=>{
                menuContentTrigger(element);
                if (typeof triggerProps.ref === 'function') triggerProps.ref(element);
            },
            spacing: "compact",
            appearance: "subtle",
            onClick: onTriggerClicked,
            "aria-label": formatMessage((0, $4R6GH.fg)('confluence-items-jira-all-work-column-heading') ? (0, $29zEB.default).itemCount : (0, $29zEB.default).pageCount, {
                pageCount: pageCount
            }),
            iconBefore: (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ $5uXOq.createElement((0, (/*@__PURE__*/$parcel$interopDefault($eQfWH))), {
                label: "",
                LEGACY_size: "small",
                color: "var(--ds-icon, #44546F)"
            }) : /*#__PURE__*/ $5uXOq.createElement((0, (/*@__PURE__*/$parcel$interopDefault($eQfWH))), {
                label: "",
                color: "var(--ds-icon, #44546F)"
            })
        }, /*#__PURE__*/ $5uXOq.createElement((0, $dC5iT.default), {
            xcss: $8f48328bd271abcd$var$confluencePagesCountStyles
        }, pageCount)))), [
        formatMessage,
        menuContentTrigger,
        onTriggerClicked,
        pageCount
    ]);
    return /*#__PURE__*/ $5uXOq.createElement((0, $jgJNO.JiraPopup), {
        shouldUseCaptureOnOutsideClick: true,
        isOpen: isOpen,
        placement: "right-start",
        messageId: "work-management-board.ui.board.column.card.card-footer.confluence-pages.popup",
        messageType: "transactional",
        autoFocus: false,
        onClose: closeMenu,
        trigger: popupTrigger,
        content: popupContent
    });
};
var $8f48328bd271abcd$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($8f48328bd271abcd$var$CardDetailConfluencePages);
const $8f48328bd271abcd$var$confluencePagesCountStyles = (0, $8CUq3.xcss)({
    marginLeft: 'space.025'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8f48328bd271abcd$var$StyledButton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $fVnbM.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19bv1b66 _u5f31b66",
            __cmplp.className
        ])
    });
}); // These styles allow elements to receive pointer events even with the use of the
const $8f48328bd271abcd$var$pointerEventsStyles = null;

});
parcelRegister("hWes5", function(module, exports) {

$parcel$export(module.exports, "cardConfluencePagesMenuContentEntryPoint", () => $143d1b2e1e26ab3b$export$56f01c3641d8d6c3);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $143d1b2e1e26ab3b$export$56f01c3641d8d6c3 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("baYHW")), {
        moduleId: "29099e71",
        moduleName: "CardConfluencePagesMenuContent"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("baYHW", function(module, exports) {

let $822fb83128a21f61$var$load = (parcelRequire("28QjX"))(4);
module.exports = $822fb83128a21f61$var$load("6y0fm").then(()=>parcelRequire('16RWv'));

});


parcelRegister("29zEB", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ed05180e7e0e701$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $7ed05180e7e0e701$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    pageCount: {
        "id": "work-management-board.board.column.card.card-footer.confluence-pages.page-count",
        "defaultMessage": "{pageCount} linked Confluence {pageCount, plural, one {page} other {pages}}"
    },
    itemCount: {
        "id": "work-management-board.board.column.card.card-footer.confluence-pages.item-count",
        "defaultMessage": "{pageCount} linked Confluence {pageCount, plural, one {item} other {items}}"
    }
});

});


parcelRegister("7UxVW", function(module, exports) {

$parcel$export(module.exports, "IssueLinks", () => $76dd040b71630589$export$a8a190e7e67ab4f5);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $daQYX = parcelRequire("daQYX");

var $2vSU6 = parcelRequire("2vSU6");

var $6TQeL = parcelRequire("6TQeL");

var $6xpM6 = parcelRequire("6xpM6");
const $76dd040b71630589$var$IssueLinksNotMemo = ({ issueKey: issueKey, issueId: issueId, issueSummary: issueSummary, issueLinksCount: issueLinksCount, issueTypeField: issueTypeField })=>{
    const { permissions: { linkIssues: linkIssues } } = (0, $daQYX.useProject)();
    const refetchIssues = (0, $6xpM6.useRefetchIssues)();
    const onIssueUnlink = (0, $5uXOq.useCallback)((issueIds)=>{
        refetchIssues(issueIds.map(Number));
    }, [
        refetchIssues
    ]);
    const onIssueLink = (0, $5uXOq.useCallback)((originalIssueId, updateIssueIds)=>{
        const issueIds = [
            originalIssueId,
            ...updateIssueIds
        ];
        refetchIssues(issueIds.map(Number));
    }, [
        refetchIssues
    ]);
    return /*#__PURE__*/ $5uXOq.createElement("div", {
        className: (0, $bwpsq.default)([
            "_kqswh2mm _lcxv1wug"
        ])
    }, /*#__PURE__*/ $5uXOq.createElement((0, $6TQeL.IssueLinksStats), {
        testId: "work-management-board.ui.board.column.card.card-footer.issue-links",
        issueLinksCount: issueLinksCount,
        issueKey: issueKey,
        issueId: String(issueId),
        issueSummary: issueSummary,
        issueType: issueTypeField?.issueType,
        feedbackCollectorPrefix: "business-board",
        isLinkingEnabled: linkIssues,
        sourceProductType: (0, $2vSU6.CORE_PROJECT),
        onIssueUnlink: onIssueUnlink,
        onIssueLink: onIssueLink,
        maxIssueLinksStatsCount: 9
    }));
};
const $76dd040b71630589$export$a8a190e7e67ab4f5 = /*#__PURE__*/ (0, $5uXOq.memo)($76dd040b71630589$var$IssueLinksNotMemo);
// These styles allow elements to receive pointer events even with the use of the
// InteractionLayer component in the board card component. The InteractionLayer
// component is used to create a clickable area for the card, but we want to
// ensure that certain elements within the card can still receive pointer events.
const $76dd040b71630589$var$pointerEventsStyles = null;

});
parcelRegister("6TQeL", function(module, exports) {

$parcel$export(module.exports, "IssueLinksStats", () => $196fc4cdc44b5704$export$471e3cf08f140899);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $87HMY = parcelRequire("87HMY");
const $196fc4cdc44b5704$export$471e3cf08f140899 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "issue-links-stats-business",
        packageName: "jiraIssueLinksStatsBusiness",
        teamName: "jira-werewolves",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $87HMY.IssueLinksStats), props));

});
parcelRegister("87HMY", function(module, exports) {

$parcel$export(module.exports, "IssueLinksStats", () => $acd2556251777f0a$export$471e3cf08f140899);

var $5uXOq = parcelRequire("5uXOq");

var $eCeGD = parcelRequire("eCeGD");

var $eyYcL = parcelRequire("eyYcL");

var $lJosW = parcelRequire("lJosW");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $3bDjY = parcelRequire("3bDjY");

var $dGrdR = parcelRequire("dGrdR");

var $gwIPs = parcelRequire("gwIPs");

var $47gW9 = parcelRequire("47gW9");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $bMyiD = parcelRequire("bMyiD");

var $1uBR4 = parcelRequire("1uBR4");

var $audJu = parcelRequire("audJu");

var $jgJNO = parcelRequire("jgJNO");

var $iXVV6 = parcelRequire("iXVV6");
var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $efvDm = parcelRequire("efvDm");

var $koeKL = parcelRequire("koeKL");

var $dCm1o = parcelRequire("dCm1o");

var $3ro8E = parcelRequire("3ro8E");

var $eYC4b = parcelRequire("eYC4b");

var $9Iiat = parcelRequire("9Iiat");
const $acd2556251777f0a$export$901087bc7dae0943 = (target)=>{
    if (target instanceof HTMLElement) {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        if (!document.querySelector('#jira-frontend')?.contains(target)) return true;
    }
    return false;
};
const $acd2556251777f0a$var$MAX_ISSUE_LINKS_COUNT = 50;
const $acd2556251777f0a$var$asyncIssueLinksDetailsLoad = (0, $dGrdR.metrics).interaction({
    key: 'issue-links-details-content-load'
});
const $acd2556251777f0a$var$asyncIssueLinkPopupLoad = (0, $dGrdR.metrics).interaction({
    key: 'issue-link-popup-load'
});
const $acd2556251777f0a$export$471e3cf08f140899 = ({ issueLinksCount: issueLinksCount, maxIssueLinksStatsCount: maxIssueLinksStatsCount, testId: testId, issueKey: issueKey, issueId: issueId, issueSummary: issueSummary, issueType: issueType, feedbackCollectorPrefix: feedbackCollectorPrefix, isLinkingEnabled: isLinkingEnabled, onIssueUnlink: onIssueUnlinkProp, onIssueLink: onIssueLinkProp, sourceProductType: sourceProductType, stopPropagationOnClick: stopPropagationOnClick = false })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const cloudId = (0, $koeKL.useCloudId)();
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const [isLinkPopupOpen, setIsLinkPopupOpen] = (0, $5uXOq.useState)(false);
    const { entryPointReferenceSubject: entryPointReferenceSubject, entryPointActions: entryPointActions, stopMetric: stopMetric } = (0, $4mO32.useEntryPoint)((0, $bMyiD.issueLinksDetailsContentEntryPoint), {
        cloudId: cloudId,
        issueKey: issueKey,
        // Fetch 1 more than required so that we show view all linked issues button
        issueCount: $acd2556251777f0a$var$MAX_ISSUE_LINKS_COUNT + 1,
        withDueDate: true,
        fields: [
            'issuetype',
            'summary',
            'status',
            'duedate'
        ]
    }, $acd2556251777f0a$var$asyncIssueLinksDetailsLoad);
    const triggerRef = (0, $47gW9.useEntryPointButtonTrigger)(entryPointActions);
    const { entryPointReferenceSubject: linkIssuePopupEntryPointReferenceSubject, entryPointActions: linkIssuePopupEntryPointActions, stopMetric: linkIssuePopupStopMetric } = (0, $4mO32.useEntryPoint)((0, $1uBR4.linkIssuePopupEntryPoint), {
        cloudId: cloudId
    }, $acd2556251777f0a$var$asyncIssueLinkPopupLoad);
    const onTriggerButtonClick = (event, analyticsEvent)=>{
        if (isOpen) onPopupClose();
        else setIsOpen(true);
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'issueLinksStats', {
            isToOpenPopup: !isOpen
        });
    };
    const onPopupClose = (0, $5uXOq.useCallback)((event)=>{
        if (stopPropagationOnClick && event?.target && $acd2556251777f0a$export$901087bc7dae0943(event.target)) return;
        if (isLinkPopupOpen) {
            if (event instanceof KeyboardEvent && (event.key === 'Escape' || event.key === 'Esc')) (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'linkIssuePopup dismissed', {
                reason: 'escapeKey'
            });
            if (event instanceof MouseEvent) (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'linkIssuePopup dismissed', {
                reason: 'clickOutsidePopup'
            });
        }
        setIsOpen(false);
        setIsLinkPopupOpen(false);
    }, [
        createAnalyticsEvent,
        isLinkPopupOpen,
        stopPropagationOnClick
    ]);
    const onIssueUnlink = (0, $5uXOq.useCallback)((issueIds)=>{
        onIssueUnlinkProp(issueIds);
        setIsOpen(false);
    }, [
        onIssueUnlinkProp
    ]);
    const onIssueLink = (0, $5uXOq.useCallback)((id, updateIssueIds)=>{
        onIssueLinkProp(id, updateIssueIds);
        onPopupClose();
    }, [
        onIssueLinkProp,
        onPopupClose
    ]);
    const onIssueLinkButtonClick = (0, $5uXOq.useCallback)(()=>{
        setIsLinkPopupOpen(true);
        linkIssuePopupEntryPointActions.load();
    }, [
        linkIssuePopupEntryPointActions
    ]);
    const onIssueLinkPopupClose = ()=>{
        setIsLinkPopupOpen(false);
    };
    const tooltipContent = issueLinksCount > maxIssueLinksStatsCount ? formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $9Iiat.messages).genericMaxIssueLinksStatsTooltipLabelIssueTermRefresh : (0, $9Iiat.messages).genericMaxIssueLinksStatsTooltipLabel, {
        maxIssueLinksStatsCount: maxIssueLinksStatsCount
    }) : formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $9Iiat.messages).issueLinksTooltipLabelIssueTermRefresh : (0, $9Iiat.messages).issueLinksTooltipLabel, {
        issueLinksCount: issueLinksCount
    });
    const renderTriggerButton = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: tooltipContent,
            testId: "issue-links-stats-business.ui.linked-issue-stats-tooltip"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
            ...triggerProps,
            appearance: "subtle",
            spacing: "compact",
            testId: `issue-links-stats-business.ui.issue-links-stats-button.custom-theme-button-${issueKey}`,
            ref: (element)=>{
                triggerRef(element);
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                triggerProps.ref(element);
            },
            isSelected: isOpen,
            onClick: onTriggerButtonClick,
            "aria-label": tooltipContent,
            iconBefore: ()=>(0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eyYcL))), {
                    LEGACY_size: "small",
                    color: isOpen ? "var(--ds-icon-accent-blue, #1D7AFC)" : "var(--ds-icon, #44546F)",
                    label: ""
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lJosW))), {
                    LEGACY_size: "small",
                    color: isOpen ? "var(--ds-icon-accent-blue, #1D7AFC)" : "var(--ds-icon, #44546F)",
                    label: ""
                })
        }, issueLinksCount > maxIssueLinksStatsCount ? `${maxIssueLinksStatsCount}+` : issueLinksCount));
    const popupRuntimeProps = (0, $5uXOq.useMemo)(()=>({
            issueId: issueId,
            issueKey: issueKey,
            onSuccessfulIssueLink: onIssueLink,
            onClose: onIssueLinkPopupClose,
            trackOriginSource: 'JWM',
            onReady: linkIssuePopupStopMetric
        }), [
        issueId,
        issueKey,
        linkIssuePopupStopMetric,
        onIssueLink
    ]);
    const contentRuntimeProps = (0, $5uXOq.useMemo)(()=>({
            cloudId: cloudId,
            issueKey: issueKey,
            issueSummary: issueSummary,
            issueId: issueId,
            issueType: issueType,
            canUserLinkIssue: isLinkingEnabled,
            onIssueUnlink: onIssueUnlink,
            onPopupClose: onPopupClose,
            maxIssuesToDisplay: $acd2556251777f0a$var$MAX_ISSUE_LINKS_COUNT,
            feedbackCollectorPrefix: feedbackCollectorPrefix,
            onReady: stopMetric,
            sourceProductType: sourceProductType,
            onIssueLinkButtonClick: onIssueLinkButtonClick,
            openIssueInNewTabOnExceedLimitClick: true
        }), [
        cloudId,
        feedbackCollectorPrefix,
        isLinkingEnabled,
        issueId,
        issueKey,
        issueSummary,
        issueType,
        onIssueLinkButtonClick,
        onIssueUnlink,
        onPopupClose,
        sourceProductType,
        stopMetric
    ]);
    const renderContent = ()=>{
        if (isLinkPopupOpen) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
            id: "businessLinkIssuePopupEntryPoint",
            packageName: "@atlassian/jira-link-issue-popup",
            teamName: "jira-werewolves",
            entryPointReferenceSubject: linkIssuePopupEntryPointReferenceSubject,
            runtimeProps: popupRuntimeProps,
            errorFallback: "flag",
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $audJu.IssueLinksPopupFallback), null)
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            padding: "space.200",
            xcss: $acd2556251777f0a$var$ContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
            entryPointReferenceSubject: entryPointReferenceSubject,
            id: "async-issue-links-details-content",
            runtimeProps: contentRuntimeProps,
            packageName: "@atlassian/jira-issue-links-details-content",
            teamName: "jira-werewolves",
            errorFallback: ({ error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3ro8E.IssueLinksDetailsErrorFallback), {
                    callback: onPopupClose,
                    error: error,
                    testId: "issue-links-stats-business.ui.issue-links-details-popup-entrypoint-container"
                }),
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eYC4b.IssueLinksDetailsPopupSkeleton), {
                noPadding: true,
                smallerWidth: true,
                testId: "issue-links-stats-business.ui.skeleton-loader"
            })
        }));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: "issueLinksStats",
        attributes: {
            application: sourceProductType && (0, $efvDm.getApplicationForProject)(sourceProductType)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        testId: testId,
        onClick: (event)=>stopPropagationOnClick && event.stopPropagation()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        isOpen: isOpen,
        onClose: onPopupClose,
        placement: "bottom-start",
        messageId: "issue-links-stats-business.ui.popup",
        messageType: "transactional",
        testId: "issue-links-stats-business.ui.popup",
        trigger: renderTriggerButton,
        content: renderContent,
        shouldUseCaptureOnOutsideClick: stopPropagationOnClick,
        label: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $9Iiat.messages).issueLinksPopupIssueTermRefresh : (0, $9Iiat.messages).issueLinksPopup)
    })));
};
const $acd2556251777f0a$var$ContainerStyles = (0, $8CUq3.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `${(0, $gwIPs.gridSize) * 64}px`
});

});
parcelRegister("eyYcL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::20c4153f88370509387fcb931f8e0884>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a9a2f11ac805a7dd$var$_react = $a9a2f11ac805a7dd$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $a9a2f11ac805a7dd$var$_issue = $a9a2f11ac805a7dd$var$_interopRequireDefault((parcelRequire("jB3w5")));

var $a9a2f11ac805a7dd$var$_issue2 = $a9a2f11ac805a7dd$var$_interopRequireDefault((parcelRequire("cWNOJ")));
function $a9a2f11ac805a7dd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for IssueIcon.
 * This component is IssueIcon, with `UNSAFE_fallbackIcon` set to "IssueIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for representing work items.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a9a2f11ac805a7dd$var$IssueIcon = (props)=>/*#__PURE__*/ $a9a2f11ac805a7dd$var$_react.default.createElement($a9a2f11ac805a7dd$var$_issue.default, Object.assign({
        LEGACY_fallbackIcon: $a9a2f11ac805a7dd$var$_issue2.default
    }, props));
$a9a2f11ac805a7dd$var$IssueIcon.Name = 'IssueIconMigration';
var $a9a2f11ac805a7dd$var$_default = module.exports.default = $a9a2f11ac805a7dd$var$IssueIcon;

});
parcelRegister("jB3w5", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f1a34ab85cae43bfcc557db6c87d2e59>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e44433503bdca276$var$_react = $e44433503bdca276$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $e44433503bdca276$var$_baseNew = $e44433503bdca276$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $e44433503bdca276$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Issue".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for representing work items.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e44433503bdca276$var$IssueIcon = (props)=>/*#__PURE__*/ $e44433503bdca276$var$_react.default.createElement($e44433503bdca276$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5zm8.426 1.517 1.148.966-4 4.75a.75.75 0 0 1-1.148 0l-2-2.375 1.148-.966L7 9.086z" clip-rule="evenodd"/>`
    }, props));
$e44433503bdca276$var$IssueIcon.displayName = 'IssueIcon';
var $e44433503bdca276$var$_default = module.exports.default = $e44433503bdca276$var$IssueIcon;

});

parcelRegister("cWNOJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $96d18b825901141c$var$_react = $96d18b825901141c$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $96d18b825901141c$var$_issue = $96d18b825901141c$var$_interopRequireDefault((parcelRequire("jB3w5")));
function $96d18b825901141c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $96d18b825901141c$var$IssueIcon = (props)=>/*#__PURE__*/ $96d18b825901141c$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M5 15.991c0 .007 14.005.009 14.005.009C18.999 16 19 8.009 19 8.009 19 8.002 4.995 8 4.995 8 5.001 8 5 15.991 5 15.991M3 8.01C3 6.899 3.893 6 4.995 6h14.01C20.107 6 21 6.902 21 8.009v7.982c0 1.11-.893 2.009-1.995 2.009H4.995A2.004 2.004 0 0 1 3 15.991z"/><path d="M10.674 14.331c.36.36.941.36 1.3 0l2.758-2.763a.92.92 0 0 0-1.301-1.298l-2.108 2.11-.755-.754a.92.92 0 0 0-1.3 1.3z"/></g></svg>`
    }, props, {
        newIcon: $96d18b825901141c$var$_issue.default
    }));
$96d18b825901141c$var$IssueIcon.displayName = 'IssueIcon';
var $96d18b825901141c$var$_default = module.exports.default = $96d18b825901141c$var$IssueIcon;

});


parcelRegister("bMyiD", function(module, exports) {

$parcel$export(module.exports, "issueLinksDetailsContentEntryPoint", () => $46c7c2f756fce2b8$export$ed55e17b62c0c3b0);

var $jGqUc = parcelRequire("jGqUc");

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $46c7c2f756fce2b8$export$ed55e17b62c0c3b0 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("kqWwP")), {
        moduleId: "56ed134e"
    }),
    getPreloadProps: ({ cloudId: cloudId, issueKey: issueKey, issueCount: issueCount, withDueDate: withDueDate, fields: fields })=>({
            queries: {
                issueLinksDetailsPopup: {
                    // policy can be updated to store-or-network once we have issue linking mutation through relay
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $jGqUc.default,
                    variables: {
                        cloudId: cloudId,
                        issueKey: issueKey,
                        issueCount: issueCount,
                        withDueDate: withDueDate,
                        fields: fields
                    }
                }
            }
        })
});

});
parcelRegister("jGqUc", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b5281d96509daab$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3911672bf59cd9c5cbbd5af9f5777951>>
 * @relayHash a08180161ec6ab9c7e11d8f628199d37
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fb7810939eb3c247c90b6c590a41c138ba5abb1fafe8508efd4ed201487f6b41
const $3b5281d96509daab$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "fb7810939eb3c247c90b6c590a41c138ba5abb1fafe8508efd4ed201487f6b41",
        "metadata": {},
        "name": "srcAsyncIssueLinksDetailsContentQuery",
        "operationKind": "query",
        "text": null
    }
};
var $3b5281d96509daab$export$2e2bcd8739ae039 = $3b5281d96509daab$var$node;

});

parcelRegister("kqWwP", function(module, exports) {

let $ee03a2e38ab75996$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ee03a2e38ab75996$var$load("9SSqq").then(()=>parcelRequire('iD2bB'));

});


parcelRegister("1uBR4", function(module, exports) {

$parcel$export(module.exports, "linkIssuePopupEntryPoint", () => $54106a41849af366$export$537a4e334f2de676);

var $XczyX = parcelRequire("XczyX");

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $54106a41849af366$export$537a4e334f2de676 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("2RkTo")), {
        moduleId: "e0e327f9"
    }),
    getPreloadProps: ({ cloudId: cloudId })=>({
            queries: {
                issueLinksTypes: {
                    options: {
                        fetchPolicy: 'store-or-network'
                    },
                    parameters: $XczyX.default,
                    variables: {
                        cloudId: cloudId
                    }
                }
            }
        })
});

});
parcelRegister("XczyX", function(module, exports) {

$parcel$export(module.exports, "default", () => $b447dfe339c10fb6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2f031d559b6b4aa1484052708468df2c>>
 * @relayHash ef080d6ba522722031ef94e4887d4972
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 34d278c2e16727746e37236ed6b6c53c028ecbb07c23708312783363197eb20b
const $b447dfe339c10fb6$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "inwards"
    }, v4 = {
        "kind": "ScalarField",
        "name": "outwards"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "mainAsyncIssueLinksTypesQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraIssueLinkTypeConnection",
                            "kind": "LinkedField",
                            "name": "issueLinkTypes",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueLinkTypeEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueLinkType",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v2 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "jira.issueLinkTypes.edges.node.id"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v3 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "jira.issueLinkTypes.edges.node.inwards"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v4 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "jira.issueLinkTypes.edges.node.outwards"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "mainAsyncIssueLinksTypesQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraIssueLinkTypeConnection",
                            "kind": "LinkedField",
                            "name": "issueLinkTypes",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueLinkTypeEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueLinkType",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                v3 /*: any*/ ,
                                                v4 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "34d278c2e16727746e37236ed6b6c53c028ecbb07c23708312783363197eb20b",
            "metadata": {},
            "name": "mainAsyncIssueLinksTypesQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$b447dfe339c10fb6$var$node.hash = "ad0bf63495377e340f30a9f1531b3f3c";
var $b447dfe339c10fb6$export$2e2bcd8739ae039 = $b447dfe339c10fb6$var$node;

});

parcelRegister("2RkTo", function(module, exports) {

let $2150bcd5c4e36c27$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2150bcd5c4e36c27$var$load("4awiX").then(()=>parcelRequire('fSK3M'));

});


parcelRegister("audJu", function(module, exports) {

$parcel$export(module.exports, "IssueLinksPopupFallback", () => $5dcc262df6ebb118$export$623aae6a1e4b8f7d);

var $5uXOq = parcelRequire("5uXOq");

var $f5TWP = parcelRequire("f5TWP");
var $8CUq3 = parcelRequire("8CUq3");

var $eZJjh = parcelRequire("eZJjh");
const $5dcc262df6ebb118$export$623aae6a1e4b8f7d = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        xcss: $5dcc262df6ebb118$var$linkIssuePopupFallbackStyles,
        alignInline: "center",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
        size: "medium"
    }));
const $5dcc262df6ebb118$var$linkIssuePopupFallbackStyles = (0, $8CUq3.xcss)({
    width: '360px',
    height: '342px'
});

});

parcelRegister("3ro8E", function(module, exports) {

$parcel$export(module.exports, "IssueLinksDetailsErrorFallback", () => $e322445ede8e17c9$export$5489cdf86d4767fd);

var $5uXOq = parcelRequire("5uXOq");

var $fZneA = parcelRequire("fZneA");

var $pa9q9 = parcelRequire("pa9q9");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $ghMce = parcelRequire("ghMce");
const $e322445ede8e17c9$export$5489cdf86d4767fd = ({ callback: callback, testId: testId, error: error })=>{
    callback && callback();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { showFlag: showFlag } = (0, $pa9q9.useFlagService)();
    showFlag({
        id: 'async-issue-links-details-entrypoint-flag',
        type: 'error',
        testId: testId,
        title: formatMessage((0, $ghMce.messages).issueLinksDetailsErrorFlagTitle),
        description: formatMessage((0, $ghMce.messages).issueLinksDetailsErrorFlagDescription),
        isAutoDismiss: true,
        messageId: 'issue-links-stats-business.ui.issue-links-details-error-fallback.show-flag.error',
        messageType: 'transactional'
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'ui taskFail', {
        task: 'viewIssueLinksDetailsPopup',
        isClientFetchError: (0, $fZneA.isClientFetchError)(error)
    });
    // need to return an empty fragment as entrypoint fallback prop only accept ((props: { error: Error }) => ReactElement);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null);
};

});
parcelRegister("ghMce", function(module, exports) {

$parcel$export(module.exports, "messages", () => $ca65a6500a7c5a5d$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $ca65a6500a7c5a5d$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    issueLinksDetailsErrorFlagTitle: {
        "id": "issue-links-stats-business.issue-links-details-error-fallback.issue-links-details-error-flag-title",
        "defaultMessage": "We couldn't load your data"
    },
    issueLinksDetailsErrorFlagDescription: {
        "id": "issue-links-stats-business.issue-links-details-error-fallback.issue-links-details-error-flag-description",
        "defaultMessage": "Refresh the page and try again, or contact your admin."
    }
});

});


parcelRegister("eYC4b", function(module, exports) {

$parcel$export(module.exports, "IssueLinksDetailsPopupSkeleton", () => $452d96198c84cbcf$export$c2d4e4e846447365);

var $5uXOq = parcelRequire("5uXOq");

var $iwwXK = parcelRequire("iwwXK");

var $c8oLN = parcelRequire("c8oLN");
var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");
const $452d96198c84cbcf$export$c2d4e4e846447365 = ({ testId: testId, smallerWidth: smallerWidth, noPadding: noPadding = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        testId: testId,
        xcss: smallerWidth ? $452d96198c84cbcf$var$smallerWidthStyles : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c8oLN.default), {
        inline: noPadding ? 'space.200' : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iwwXK.default), {
        width: "60%"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iwwXK.default), {
        width: "100%",
        hasIcon: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iwwXK.default), {
        width: "100%",
        hasIcon: true
    })));
const $452d96198c84cbcf$var$smallerWidthStyles = (0, $8CUq3.xcss)({
    width: '80%'
});

});

parcelRegister("9Iiat", function(module, exports) {

$parcel$export(module.exports, "messages", () => $24feea004ff9078c$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $24feea004ff9078c$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    issueLinksTooltipLabel: {
        "id": "issue-links-stats-business.issue-links-tooltip-label",
        "defaultMessage": "{issueLinksCount} linked {issueLinksCount, plural, one {issue} other {issues}}"
    },
    genericMaxIssueLinksStatsTooltipLabel: {
        "id": "issue-links-stats-business.generic-max-issue-links-stats-tooltip-label",
        "defaultMessage": "{maxIssueLinksStatsCount}+ linked issues"
    },
    issueLinksPopup: {
        "id": "issue-links-stats-business.issue-links-popup",
        "defaultMessage": "Linked issues pop up"
    },
    issueLinksTooltipLabelIssueTermRefresh: {
        "id": "issue-links-stats-business.issue-links-tooltip-label-issue-term-refresh",
        "defaultMessage": "{issueLinksCount} linked {issueLinksCount, plural, one {work item} other {work items}}"
    },
    genericMaxIssueLinksStatsTooltipLabelIssueTermRefresh: {
        "id": "issue-links-stats-business.generic-max-issue-links-stats-tooltip-label-issue-term-refresh",
        "defaultMessage": "{maxIssueLinksStatsCount}+ linked work items"
    },
    issueLinksPopupIssueTermRefresh: {
        "id": "issue-links-stats-business.issue-links-popup-issue-term-refresh",
        "defaultMessage": "Linked work items pop up"
    }
});

});





parcelRegister("f94vf", function(module, exports) {

$parcel$export(module.exports, "CardSpinner", () => $30683d8d0c6db4fc$export$cbd2bb5b02f5fd3a);
/* CardSpinner.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $eZJjh = parcelRequire("eZJjh");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $tC2oU = parcelRequire("tC2oU");
const $30683d8d0c6db4fc$export$cbd2bb5b02f5fd3a = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const label = formatMessage((0, $tC2oU.default).loading);
    return /*#__PURE__*/ $5uXOq.createElement("div", {
        className: (0, $bwpsq.default)([
            $30683d8d0c6db4fc$var$styles.root
        ])
    }, /*#__PURE__*/ $5uXOq.createElement((0, $3bDjY.default), {
        content: label
    }, /*#__PURE__*/ $5uXOq.createElement((0, $eZJjh.default), {
        label: label,
        size: "small"
    })));
};
const $30683d8d0c6db4fc$var$styles = {
    root: "_kqswh2mm _lcxv1wug"
};

});
parcelRegister("tC2oU", function(module, exports) {

$parcel$export(module.exports, "default", () => $1da908360cd37b4c$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $1da908360cd37b4c$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    loading: {
        "id": "work-management-board.board.column.card.card-content.card-spinner.loading",
        "defaultMessage": "Loading"
    }
});

});


parcelRegister("9LL9k", function(module, exports) {

$parcel$export(module.exports, "default", () => $a82c39304ea456b1$export$2e2bcd8739ae039);

var $XlfsT = parcelRequire("XlfsT");

var $550OK = parcelRequire("550OK");

var $fevoT = parcelRequire("fevoT");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $42CjB = parcelRequire("42CjB");

var $8U6zd = parcelRequire("8U6zd");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $eZJjh = parcelRequire("eZJjh");

var $7mPT9 = parcelRequire("7mPT9");

var $6s1PB = parcelRequire("6s1PB");

var $koeKL = parcelRequire("koeKL");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $2HbP2 = parcelRequire("2HbP2");

var $jgJNO = parcelRequire("jgJNO");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $47gW9 = parcelRequire("47gW9");

var $cvj5l = parcelRequire("cvj5l");

var $apI3s = parcelRequire("apI3s");

var $jgwXE = parcelRequire("jgwXE");
const $a82c39304ea456b1$export$b84b59c6e2eb539a = '--card-actions-opacity';
const $a82c39304ea456b1$var$styles = {
    fallbackMenu: "_1e0c1txw _1bah1h6o _4cvr1h6o _1bsb1wdt _ca0qxy5q _u5f3xy5q _n3tdxy5q _19bvxy5q"
};
const $a82c39304ea456b1$var$BoardCardActions = ({ issue: issue, columnFragment: columnFragment, projectFragment: projectFragment, viewFragment: viewFragment })=>{
    const triggerButtonRef = (0, $5uXOq.useRef)(null);
    const cloudId = (0, $koeKL.useCloudId)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const view = (0, $8Uumt.useFragment)((0, $fevoT.default), viewFragment);
    const project = (0, $8Uumt.useFragment)((0, $550OK.default), projectFragment);
    const column = (0, $8Uumt.useFragment)((0, $XlfsT.default), columnFragment);
    let columnName;
    switch(column.__typename){
        case 'JiraBoardViewAssigneeColumn':
            columnName = column.user?.name ?? formatMessage((0, $jgwXE.default).noAssignee);
            break;
        case 'JiraBoardViewPriorityColumn':
            columnName = column.priority.name;
            break;
        case 'JiraBoardViewCategoryColumn':
            columnName = column.category?.value ?? formatMessage((0, $jgwXE.default).noCategory);
            break;
        case 'JiraBoardViewStatusColumn':
            if (!column.statuses?.[0]) throw new Error('Missing status column fields');
            columnName = column.statuses[0].name;
            break;
        default:
            throw new Error(`Unhandled column type: ${column.__typename}`);
    }
    const [openDialogId, setOpenDialogId] = (0, $5uXOq.useState)(null);
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const openMenu = (0, $5uXOq.useCallback)(()=>setIsOpen(true), []);
    const closeMenu = (0, $5uXOq.useCallback)(()=>{
        setIsOpen(false);
        if ((0, $4R6GH.fg)('wanjel-a11y-enterprise-grade')) {
            setOpenDialogId(null);
            triggerButtonRef.current?.focus();
        }
    }, []);
    const toggleMenu = (0, $5uXOq.useCallback)(()=>setIsOpen((open)=>!open), []);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $apI3s.cardActionsMenuContentEntryPoint), (0, $5uXOq.useMemo)(()=>({
            cloudId: cloudId,
            projectAri: project.id,
            viewId: view.id
        }), [
        cloudId,
        project.id,
        view.id
    ]));
    const menuContentTrigger = (0, $47gW9.useEntryPointButtonTrigger)(entryPointActions, !isOpen);
    const popupContent = (0, $5uXOq.useCallback)(({ update: update })=>/*#__PURE__*/ $5uXOq.createElement((0, $7XluA.JiraEntryPointContainer), {
            entryPointReferenceSubject: entryPointReferenceSubject,
            id: "business-board-card-actions-menu",
            packageName: "@atlassian/jira-work-management-board",
            runtimeProps: {
                issue: issue,
                onContentResize: update,
                onClosePopup: closeMenu,
                onMenuRendered: update,
                onOpenPopup: openMenu,
                openDialogId: openDialogId,
                setOpenDialogId: setOpenDialogId,
                shouldReturnFocus: (0, $4R6GH.fg)('wanjel-a11y-enterprise-grade') ? triggerButtonRef : undefined
            },
            fallback: /*#__PURE__*/ $5uXOq.createElement((0, $dC5iT.default), {
                xcss: $a82c39304ea456b1$var$styles.fallbackMenu
            }, /*#__PURE__*/ $5uXOq.createElement((0, $eZJjh.default), null))
        }), [
        closeMenu,
        entryPointReferenceSubject,
        issue,
        openMenu,
        openDialogId,
        setOpenDialogId
    ]);
    const workType = issue.fields[0, $cvj5l.ISSUE_TYPE_ID].issueType.name;
    const trigger = (0, $5uXOq.useCallback)((triggerProps)=>{
        const label = (()=>{
            if (workType && workType.length && (0, $6s1PB.expVal)('jira-itr-m4-exp-3', 'isEnabled', false)) return formatMessage((0, $jgwXE.default).cardActionsWithIssueNameIssueTerminologyRefreshM4, {
                workType: workType,
                columnName: columnName,
                issueKey: issue.fields.issuekey.value
            });
            return formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $jgwXE.default).cardActionsWithIssueNameIssueTermRefresh : (0, $jgwXE.default).cardActionsWithIssueName, {
                columnName: columnName,
                issueKey: issue.fields.issuekey.value
            });
        })();
        return /*#__PURE__*/ $5uXOq.createElement((0, $dC5iT.default), {
            xcss: [
                $a82c39304ea456b1$var$IconButtonStyles,
                isOpen && $a82c39304ea456b1$var$IconButtonMenuOpenStyles
            ]
        }, /*#__PURE__*/ $5uXOq.createElement((0, $42CjB.default), {
            ...triggerProps,
            ref: (element)=>{
                menuContentTrigger(element);
                if (typeof triggerProps.ref === 'function') {
                    if ((0, $4R6GH.fg)('wanjel-a11y-enterprise-grade')) (0, $7mPT9.mergeRefs)(triggerProps.ref, triggerButtonRef)(element);
                    else triggerProps.ref(element);
                }
            },
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($8U6zd))),
            label: label,
            appearance: "subtle",
            onClick: toggleMenu,
            isSelected: isOpen,
            isTooltipDisabled: false,
            tooltip: {
                content: formatMessage((0, $jgwXE.default).moreActionsTooltip),
                hideTooltipOnClick: true
            },
            testId: "work-management-board.ui.board.column.card.card-actions.trigger"
        }));
    }, [
        isOpen,
        toggleMenu,
        formatMessage,
        workType,
        columnName,
        issue.fields.issuekey.value,
        menuContentTrigger
    ]);
    let popUpRole = 'menu';
    if (openDialogId === 'confluence-pages' || openDialogId === 'issue-links') popUpRole = 'dialog';
    let popupTitleId;
    if (openDialogId === 'confluence-pages') popupTitleId = 'business-confluence-pages.ui.add-link.heading';
    else if (openDialogId === 'issue-links') popupTitleId = 'link-issue-popup-title';
    return /*#__PURE__*/ $5uXOq.createElement((0, $2HbP2.ModalContextProvider), null, /*#__PURE__*/ $5uXOq.createElement((0, $jgJNO.JiraPopup), {
        isOpen: isOpen,
        onClose: closeMenu,
        content: popupContent,
        placement: "right-start",
        messageId: "work-management-board.ui.board.column.card.card-actions.popup",
        messageType: "transactional",
        trigger: trigger,
        role: (0, $4R6GH.fg)('wanjel-a11y-enterprise-grade') ? popUpRole : undefined,
        titleId: popupTitleId,
        autoFocus: !(0, $4R6GH.fg)('wanjel-a11y-enterprise-grade')
    }));
};
var $a82c39304ea456b1$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($a82c39304ea456b1$var$BoardCardActions);
const $a82c39304ea456b1$var$IconButtonStyles = (0, $8CUq3.xcss)({
    opacity: `var(${$a82c39304ea456b1$export$b84b59c6e2eb539a}, 0)`,
    // These styles allow elements to receive pointer events even with the use of the
    // InteractionLayer component in the board card component. The InteractionLayer
    // component is used to create a clickable area for the card, but we want to
    // ensure that certain elements within the card can still receive pointer events.
    position: 'relative',
    pointerEvents: 'auto'
});
const $a82c39304ea456b1$var$IconButtonMenuOpenStyles = (0, $8CUq3.xcss)({
    opacity: 1
});

});
parcelRegister("XlfsT", function(module, exports) {

$parcel$export(module.exports, "default", () => $35c75b568b239f0e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3c4251db9ac6de81ccb322793421d370>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $35c75b568b239f0e$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "BoardCardActions_column",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__typename"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "JiraStatus",
                            "kind": "LinkedField",
                            "name": "statuses",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": v0 /*: any*/ ,
                                    "action": "THROW",
                                    "path": "statuses.name"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "statuses"
                    }
                ],
                "type": "JiraBoardViewStatusColumn"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "JiraPriority",
                            "kind": "LinkedField",
                            "name": "priority",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": v0 /*: any*/ ,
                                    "action": "THROW",
                                    "path": "priority.name"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "priority"
                    }
                ],
                "type": "JiraBoardViewPriorityColumn"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": v0 /*: any*/ ,
                                "action": "THROW",
                                "path": "user.name"
                            }
                        ]
                    }
                ],
                "type": "JiraBoardViewAssigneeColumn"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraOption",
                        "kind": "LinkedField",
                        "name": "category",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "kind": "ScalarField",
                                    "name": "value"
                                },
                                "action": "THROW",
                                "path": "category.value"
                            }
                        ]
                    }
                ],
                "type": "JiraBoardViewCategoryColumn"
            }
        ],
        "type": "JiraBoardViewColumn",
        "abstractKey": "__isJiraBoardViewColumn"
    };
}();
$35c75b568b239f0e$var$node.hash = "129cc1cf470a83897eb3e5b237b82bac";
var $35c75b568b239f0e$export$2e2bcd8739ae039 = $35c75b568b239f0e$var$node;

});

parcelRegister("550OK", function(module, exports) {

$parcel$export(module.exports, "default", () => $797ab82d264d56cd$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<543a1d4ef0d8e2b07e2e7a834b12ce10>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $797ab82d264d56cd$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "BoardCardActions_project",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "id"
            },
            "action": "THROW",
            "path": "id"
        }
    ],
    "type": "JiraProject"
};
$797ab82d264d56cd$var$node.hash = "03f197464c6921a577ef09b6e378f127";
var $797ab82d264d56cd$export$2e2bcd8739ae039 = $797ab82d264d56cd$var$node;

});

parcelRegister("fevoT", function(module, exports) {

$parcel$export(module.exports, "default", () => $dc8184d635397787$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<128ad5ecb4949d93f0cc45e2151b5987>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $dc8184d635397787$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "BoardCardActions_view",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "id"
            },
            "action": "THROW",
            "path": "id"
        }
    ],
    "type": "JiraBoardView"
};
$dc8184d635397787$var$node.hash = "643a2d05820d51e33d5a9cfbb4d16726";
var $dc8184d635397787$export$2e2bcd8739ae039 = $dc8184d635397787$var$node;

});

parcelRegister("apI3s", function(module, exports) {

$parcel$export(module.exports, "cardActionsMenuContentEntryPoint", () => $89c33ef6998ec06a$export$798de2fa6a991c96);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

var $4BoeN = parcelRequire("4BoeN");

var $7y8jx = parcelRequire("7y8jx");

const $89c33ef6998ec06a$export$798de2fa6a991c96 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("h7eY3")), {
        moduleId: "9d9b6855",
        moduleName: "CardActionsMenuContent"
    }),
    getPreloadProps: ({ cloudId: cloudId, projectAri: projectAri, viewId: viewId })=>({
            queries: {
                mainQuery: {
                    parameters: (0, $4BoeN.default),
                    variables: {
                        cloudId: cloudId,
                        projectAri: projectAri,
                        viewInput: {
                            jiraBoardViewQueryInput: {
                                viewId: viewId
                            },
                            settings: (0, $7y8jx.getBoardQueryParams)()
                        }
                    },
                    options: {
                        fetchPolicy: 'store-and-network'
                    }
                }
            }
        })
});

});
parcelRegister("4BoeN", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d8560f7f6869bd4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d9c1b496e13925f098b7aade6a71b6b8>>
 * @relayHash 8fcbb253b1dad6b6e61097d35a44d367
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 374c523a951f59a6c595a275cc070c255ab9d720fa5e91fd08ac043fc7d5453d
const $3d8560f7f6869bd4$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectAri"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewInput"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v5 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "viewInput"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "id"
    }, v7 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "projectAri"
        }
    ], v8 = [
        {
            "kind": "Literal",
            "name": "type",
            "value": "CREATE_ISSUES"
        }
    ], v9 = {
        "kind": "ScalarField",
        "name": "canPerform"
    }, v10 = [
        {
            "kind": "Literal",
            "name": "type",
            "value": "DELETE_ISSUES"
        }
    ], v11 = [
        {
            "kind": "Literal",
            "name": "type",
            "value": "EDIT_ISSUES"
        }
    ], v12 = [
        {
            "kind": "Literal",
            "name": "type",
            "value": "LINK_ISSUES"
        }
    ], v13 = [
        {
            "kind": "Literal",
            "name": "type",
            "value": "SCHEDULE_ISSUES"
        }
    ], v14 = [
        v9 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "CardActionsMenuContentQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "JiraJqlField",
                    "kind": "LinkedField",
                    "name": "jira_categoryField",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": v4 /*: any*/ ,
                            "action": "THROW",
                            "path": "jira_categoryField.fieldId"
                        }
                    ]
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v5 /*: any*/ ,
                        "concreteType": "JiraBoardView",
                        "kind": "LinkedField",
                        "name": "jira_boardView",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": v6 /*: any*/ ,
                                "action": "THROW",
                                "path": "jira_boardView.id"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira_boardView"
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v7 /*: any*/ ,
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "jiraProject",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "alias": "canCreateIssues",
                                                "args": v8 /*: any*/ ,
                                                "concreteType": "JiraProjectAction",
                                                "kind": "LinkedField",
                                                "name": "action",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v9 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "jira.jiraProject.canCreateIssues.canPerform"
                                                    }
                                                ],
                                                "storageKey": "action(type:\"CREATE_ISSUES\")"
                                            },
                                            "action": "THROW",
                                            "path": "jira.jiraProject.canCreateIssues"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "alias": "canDeleteIssues",
                                                "args": v10 /*: any*/ ,
                                                "concreteType": "JiraProjectAction",
                                                "kind": "LinkedField",
                                                "name": "action",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v9 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "jira.jiraProject.canDeleteIssues.canPerform"
                                                    }
                                                ],
                                                "storageKey": "action(type:\"DELETE_ISSUES\")"
                                            },
                                            "action": "THROW",
                                            "path": "jira.jiraProject.canDeleteIssues"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "alias": "canEditIssues",
                                                "args": v11 /*: any*/ ,
                                                "concreteType": "JiraProjectAction",
                                                "kind": "LinkedField",
                                                "name": "action",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v9 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "jira.jiraProject.canEditIssues.canPerform"
                                                    }
                                                ],
                                                "storageKey": "action(type:\"EDIT_ISSUES\")"
                                            },
                                            "action": "THROW",
                                            "path": "jira.jiraProject.canEditIssues"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "alias": "canLinkIssues",
                                                "args": v12 /*: any*/ ,
                                                "concreteType": "JiraProjectAction",
                                                "kind": "LinkedField",
                                                "name": "action",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v9 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "jira.jiraProject.canLinkIssues.canPerform"
                                                    }
                                                ],
                                                "storageKey": "action(type:\"LINK_ISSUES\")"
                                            },
                                            "action": "THROW",
                                            "path": "jira.jiraProject.canLinkIssues"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "alias": "canScheduleIssues",
                                                "args": v13 /*: any*/ ,
                                                "concreteType": "JiraProjectAction",
                                                "kind": "LinkedField",
                                                "name": "action",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v9 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "jira.jiraProject.canScheduleIssues.canPerform"
                                                    }
                                                ],
                                                "storageKey": "action(type:\"SCHEDULE_ISSUES\")"
                                            },
                                            "action": "THROW",
                                            "path": "jira.jiraProject.canScheduleIssues"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.jiraProject"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "CardActionsMenuContentQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "JiraJqlField",
                    "kind": "LinkedField",
                    "name": "jira_categoryField",
                    "plural": false,
                    "selections": [
                        v4 /*: any*/ 
                    ]
                },
                {
                    "args": v5 /*: any*/ ,
                    "concreteType": "JiraBoardView",
                    "kind": "LinkedField",
                    "name": "jira_boardView",
                    "plural": false,
                    "selections": [
                        v6 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v7 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProject",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": "canCreateIssues",
                                    "args": v8 /*: any*/ ,
                                    "concreteType": "JiraProjectAction",
                                    "kind": "LinkedField",
                                    "name": "action",
                                    "plural": false,
                                    "selections": v14 /*: any*/ ,
                                    "storageKey": "action(type:\"CREATE_ISSUES\")"
                                },
                                {
                                    "alias": "canDeleteIssues",
                                    "args": v10 /*: any*/ ,
                                    "concreteType": "JiraProjectAction",
                                    "kind": "LinkedField",
                                    "name": "action",
                                    "plural": false,
                                    "selections": v14 /*: any*/ ,
                                    "storageKey": "action(type:\"DELETE_ISSUES\")"
                                },
                                {
                                    "alias": "canEditIssues",
                                    "args": v11 /*: any*/ ,
                                    "concreteType": "JiraProjectAction",
                                    "kind": "LinkedField",
                                    "name": "action",
                                    "plural": false,
                                    "selections": v14 /*: any*/ ,
                                    "storageKey": "action(type:\"EDIT_ISSUES\")"
                                },
                                {
                                    "alias": "canLinkIssues",
                                    "args": v12 /*: any*/ ,
                                    "concreteType": "JiraProjectAction",
                                    "kind": "LinkedField",
                                    "name": "action",
                                    "plural": false,
                                    "selections": v14 /*: any*/ ,
                                    "storageKey": "action(type:\"LINK_ISSUES\")"
                                },
                                {
                                    "alias": "canScheduleIssues",
                                    "args": v13 /*: any*/ ,
                                    "concreteType": "JiraProjectAction",
                                    "kind": "LinkedField",
                                    "name": "action",
                                    "plural": false,
                                    "selections": v14 /*: any*/ ,
                                    "storageKey": "action(type:\"SCHEDULE_ISSUES\")"
                                },
                                v6 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "374c523a951f59a6c595a275cc070c255ab9d720fa5e91fd08ac043fc7d5453d",
            "metadata": {},
            "name": "CardActionsMenuContentQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$3d8560f7f6869bd4$var$node.hash = "86dc9d98e41a92f0c071c5e4ccd7be2c";
var $3d8560f7f6869bd4$export$2e2bcd8739ae039 = $3d8560f7f6869bd4$var$node;

});

parcelRegister("h7eY3", function(module, exports) {

let $c75eb35c8eeef8ea$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c75eb35c8eeef8ea$var$load("7oJSc").then(()=>parcelRequire('kOUWw'));

});


parcelRegister("jgwXE", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d8d3ab7ccf06a3d$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $6d8d3ab7ccf06a3d$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    cardActionsWithIssueName: {
        "id": "work-management-board.board.column.card.card-actions.card-actions-with-issue-name",
        "defaultMessage": "Card actions on issue {issueKey} of column {columnName}"
    },
    cardActionsWithIssueNameIssueTermRefresh: {
        "id": "work-management-board.board.column.card.card-actions.card-actions-with-issue-name-issue-term-refresh",
        "defaultMessage": "Card actions on work item {issueKey} of column {columnName}"
    },
    cardActionsWithIssueNameIssueTerminologyRefreshM4: {
        "id": "work-management-board.board.column.card.card-actions.card-actions-with-issue-name-issue-terminology-refresh-m4",
        "defaultMessage": "Card actions on {workType} {issueKey} of the {columnName} column"
    },
    noAssignee: {
        "id": "work-management-board.board.column.card.card-actions.no-assignee",
        "defaultMessage": "Unassigned"
    },
    noCategory: {
        "id": "work-management-board.board.column.card.card-actions.no-category",
        "defaultMessage": "Uncategorized"
    },
    moreActionsTooltip: {
        "id": "work-management-board.board.column.card.card-actions.more-actions",
        "defaultMessage": "More actions"
    }
});

});



parcelRegister("l0z0H", function(module, exports) {

$parcel$export(module.exports, "BoardInvalidDropTargetMessage", () => $f54e0e049e4b9c7e$export$354ccd00d6a04803);

var $jtG9r = parcelRequire("jtG9r");

var $7xRtT = parcelRequire("7xRtT");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $dS3PR = parcelRequire("dS3PR");

var $7XYc4 = parcelRequire("7XYc4");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $kiyQL = parcelRequire("kiyQL");

var $jf0VO = parcelRequire("jf0VO");

var $725Cl = parcelRequire("725Cl");
const $f54e0e049e4b9c7e$var$BoardInvalidDropTargetMessageOld = /*#__PURE__*/ (0, $5uXOq.memo)(({ columnFragment: columnFragment })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const column = (0, $8Uumt.useFragment)((0, $7xRtT.default), columnFragment);
    let message;
    switch(column.__typename){
        case 'JiraBoardViewAssigneeColumn':
            message = (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $725Cl.default).unableToUpdateAssigneeMessageIssueTermRefresh : (0, $725Cl.default).unableToUpdateAssigneeMessage;
            break;
        case 'JiraBoardViewCategoryColumn':
            message = (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $725Cl.default).unableToUpdateCategoryMessageIssueTermRefresh : (0, $725Cl.default).unableToUpdateCategoryMessage;
            break;
        case 'JiraBoardViewPriorityColumn':
            message = (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $725Cl.default).unableToUpdatePriorityMessageIssueTermRefresh : (0, $725Cl.default).unableToUpdatePriorityMessage;
            break;
        case 'JiraBoardViewStatusColumn':
            message = (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $725Cl.default).transitionNotAvailableMessageIssueTermRefresh : (0, $725Cl.default).transitionNotAvailableMessage;
            break;
        default:
            {
                const exhaustiveCheck = column.__typename;
                throw new Error(`Unexpected group type: ${exhaustiveCheck}`);
            }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-testid": "work-management-board.ui.board.column.invalid-drop-target-message",
        className: (0, $bwpsq.default)([
            "_2rko3ree _1r04idpf _bfhk1gly _kqswstnw _154ickbl"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_zulpu2gc _4cvr1h6o _1e0c1txw _2lx21bp4 _ca0qxy5q _u5f3pxbi _n3tdxy5q _19bvpxbi _y3gn1h6o"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jf0VO.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), {
        as: "p"
    }, formatMessage(message))));
});
const $f54e0e049e4b9c7e$var$BoardInvalidDropTargetMessageNew = /*#__PURE__*/ (0, $5uXOq.memo)(({ columnFragment: columnFragment })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { draggedIssue: draggedIssue } = (0, $kiyQL.useCardDragDrop)();
    const workType = draggedIssue?.fields.issuetype.issueType.name;
    const column = (0, $8Uumt.useFragment)((0, $jtG9r.default), columnFragment);
    let message;
    switch(column.__typename){
        case 'JiraBoardViewAssigneeColumn':
            message = formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $725Cl.default).unableToUpdateAssigneeMessageIssueTermRefresh : (0, $725Cl.default).unableToUpdateAssigneeMessage);
            break;
        case 'JiraBoardViewCategoryColumn':
            message = formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $725Cl.default).unableToUpdateCategoryMessageIssueTermRefresh : (0, $725Cl.default).unableToUpdateCategoryMessage);
            break;
        case 'JiraBoardViewPriorityColumn':
            message = formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $725Cl.default).unableToUpdatePriorityMessageIssueTermRefresh : (0, $725Cl.default).unableToUpdatePriorityMessage);
            break;
        case 'JiraBoardViewStatusColumn':
            if (workType && (0, $6s1PB.expVal)('jira-itr-m4-exp-3', 'isEnabled', false)) message = formatMessage((0, $725Cl.default).transitionNotAvailableMessageIssueTerminologyRefreshM4, {
                workType: workType
            });
            else message = formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $725Cl.default).transitionNotAvailableMessageIssueTermRefresh : (0, $725Cl.default).transitionNotAvailableMessage);
            break;
        default:
            {
                const exhaustiveCheck = column.__typename;
                throw new Error(`Unexpected group type: ${exhaustiveCheck}`);
            }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-testid": "work-management-board.ui.board.column.invalid-drop-target-message",
        className: (0, $bwpsq.default)([
            "_2rko3ree _1r04idpf _bfhk1gly _kqswstnw _154ickbl"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_zulpu2gc _4cvr1h6o _1e0c1txw _2lx21bp4 _ca0qxy5q _u5f3pxbi _n3tdxy5q _19bvpxbi _y3gn1h6o"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jf0VO.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), {
        as: "p"
    }, message)));
});
const $f54e0e049e4b9c7e$export$354ccd00d6a04803 = (0, $7XYc4.componentWithCondition)(()=>(0, $6s1PB.expVal)('jira-itr-m4-exp-3', 'isEnabled', false), $f54e0e049e4b9c7e$var$BoardInvalidDropTargetMessageNew, $f54e0e049e4b9c7e$var$BoardInvalidDropTargetMessageOld);
const $f54e0e049e4b9c7e$var$wrapperStyes = null;
const $f54e0e049e4b9c7e$var$contentWrapperStyles = null;

});
parcelRegister("jtG9r", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a9cce5fd02379df$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a01cdd949ccce4b84027b63db7b55395>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $3a9cce5fd02379df$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "BoardInvalidDropTargetMessage_column",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "__typename"
        }
    ],
    "type": "JiraBoardViewColumn",
    "abstractKey": "__isJiraBoardViewColumn"
};
$3a9cce5fd02379df$var$node.hash = "4c5d6c91d88154d5cf5da9b3426d94de";
var $3a9cce5fd02379df$export$2e2bcd8739ae039 = $3a9cce5fd02379df$var$node;

});

parcelRegister("7xRtT", function(module, exports) {

$parcel$export(module.exports, "default", () => $cdd0d8a700ea7af2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9f568f9e0c6da06e6428c54183c8f92b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $cdd0d8a700ea7af2$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "BoardInvalidDropTargetMessage_old_column",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "__typename"
        }
    ],
    "type": "JiraBoardViewColumn",
    "abstractKey": "__isJiraBoardViewColumn"
};
$cdd0d8a700ea7af2$var$node.hash = "d8e6d04af7414c5f8f863b2c6f386a96";
var $cdd0d8a700ea7af2$export$2e2bcd8739ae039 = $cdd0d8a700ea7af2$var$node;

});

parcelRegister("jf0VO", function(module, exports) {

$parcel$export(module.exports, "default", () => $11861e2c6e0f3e10$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $11861e2c6e0f3e10$var$RestrictedIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($11861e2c6e0f3e10$var$Graphic, {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M9.82452 2.57897C11.7787 2.57897 13.6529 3.35529 15.0348 4.73713C16.4166 6.11898 17.1929 7.99317 17.1929 9.94739C17.1929 11.9016 16.4166 13.7758 15.0348 15.1577C13.6529 16.5395 11.7787 17.3158 9.82452 17.3158C7.8703 17.3158 5.99611 16.5395 4.61426 15.1577C3.23241 13.7758 2.4561 11.9016 2.4561 9.94739C2.4561 7.99317 3.23241 6.11898 4.61426 4.73713C5.99611 3.35529 7.8703 2.57897 9.82452 2.57897ZM9.82452 0.473709C8.57209 0.460507 7.32946 0.695786 6.16855 1.16594C5.00763 1.63609 3.95146 2.33177 3.06115 3.21275C2.17084 4.09372 1.46406 5.1425 0.981702 6.29839C0.499342 7.45429 0.250977 8.69436 0.250977 9.94687C0.250977 11.1994 0.499342 12.4394 0.981702 13.5953C1.46406 14.7512 2.17084 15.8 3.06115 16.681C3.95146 17.562 5.00763 18.2576 6.16855 18.7278C7.32946 19.1979 8.57209 19.4332 9.82452 19.42C12.3371 19.42 14.7468 18.4219 16.5234 16.6452C18.3001 14.8686 19.2982 12.4589 19.2982 9.94634C19.2982 7.43376 18.3001 5.02409 16.5234 3.24743C14.7468 1.47077 12.3371 0.472656 9.82452 0.472656V0.473709Z",
        fill: "var(--ds-icon-subtle, #626F86)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M3.68457 5.09375L15.0656 16.4695L16.9856 14.7474L5.40352 3.15796C5.43299 3.18954 3.68457 5.09375 3.68457 5.09375Z",
        fill: "var(--ds-icon-subtle, #626F86)"
    })));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $11861e2c6e0f3e10$var$Graphic = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "svg", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug",
            __cmplp.className
        ])
    });
});
var $11861e2c6e0f3e10$export$2e2bcd8739ae039 = $11861e2c6e0f3e10$var$RestrictedIcon;

});

parcelRegister("725Cl", function(module, exports) {

$parcel$export(module.exports, "default", () => $1bc37c2b93b2886b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $1bc37c2b93b2886b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    unableToUpdateAssigneeMessage: {
        "id": "work-management-board.board.column.invalid-drop-target-message.unable-to-update-assignee-message",
        "defaultMessage": "You can't move this issue to this column because you do not have permission to assign issues in this project."
    },
    unableToUpdateCategoryMessage: {
        "id": "work-management-board.board.column.invalid-drop-target-message.unable-to-update-category-message",
        "defaultMessage": "You can't move this issue to this column because the category field is not associated with this issue type."
    },
    unableToUpdatePriorityMessage: {
        "id": "work-management-board.board.column.invalid-drop-target-message.unable-to-update-priority-message",
        "defaultMessage": "You can't move this issue to this column because the priority field is not associated with this issue type."
    },
    transitionNotAvailableMessage: {
        "id": "work-management-board.board.column.invalid-drop-target-message.transition-not-available-message",
        "defaultMessage": "You can't move this issue to this column due to workflow configurations or permissions."
    },
    unableToUpdateAssigneeMessageIssueTermRefresh: {
        "id": "work-management-board.board.column.invalid-drop-target-message.unable-to-update-assignee-message-issue-term-refresh",
        "defaultMessage": "You can't move this work item to this column because you do not have permission to assign work in this project."
    },
    unableToUpdateCategoryMessageIssueTermRefresh: {
        "id": "work-management-board.board.column.invalid-drop-target-message.unable-to-update-category-message-issue-term-refresh",
        "defaultMessage": "You can't move this work item to this column because the category field is not associated with this work type."
    },
    unableToUpdatePriorityMessageIssueTermRefresh: {
        "id": "work-management-board.board.column.invalid-drop-target-message.unable-to-update-priority-message-issue-term-refresh",
        "defaultMessage": "You can't move this work item to this column because the priority field is not associated with this work type."
    },
    transitionNotAvailableMessageIssueTermRefresh: {
        "id": "work-management-board.board.column.invalid-drop-target-message.transition-not-available-message-issue-term-refresh",
        "defaultMessage": "You can't move this work item to this column due to workflow configurations or permissions."
    },
    transitionNotAvailableMessageIssueTerminologyRefreshM4: {
        "id": "work-management-board.board.column.invalid-drop-target-message.transition-not-available-message-issue-terminology-refresh-m4",
        "defaultMessage": "We can\u2019t move this {workType} to this column due to workflow configurations or permissions."
    }
});

});


parcelRegister("lvP0W", function(module, exports) {

$parcel$export(module.exports, "default", () => $e58f7eb674a252a3$export$2e2bcd8739ae039);

var $7Dc2g = parcelRequire("7Dc2g");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $gULOk = parcelRequire("gULOk");

var $6s1PB = parcelRequire("6s1PB");

var $lyM0I = parcelRequire("lyM0I");

var $hE5wF = parcelRequire("hE5wF");

var $koVbs = parcelRequire("koVbs");

var $cvj5l = parcelRequire("cvj5l");

var $kiyQL = parcelRequire("kiyQL");

var $lW2vI = parcelRequire("lW2vI");

var $2PV8T = parcelRequire("2PV8T");

var $cMVLl = parcelRequire("cMVLl");
const $e58f7eb674a252a3$var$getTransitionById = (transitions, transitionId)=>transitions.find((transition)=>transition.transitionId === transitionId);
const $e58f7eb674a252a3$var$BoardTransitionZones = ({ queryFragment: queryFragment, dragAndDropColumnData: dragAndDropColumnData })=>{
    const data = (0, $8Uumt.useFragment)((0, $7Dc2g.default), queryFragment);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const categoryField = (0, $5uXOq.useMemo)(()=>data.jira_categoryField ? {
            fieldId: data.jira_categoryField.fieldId,
            displayName: data.jira_categoryField.displayName
        } : null, [
        data.jira_categoryField
    ]);
    const { transitions: transitions } = (0, $2PV8T.useIssueTransitions)();
    const updateDropTarget = (0, $kiyQL.useUpdateDropTarget)();
    const moveIssue = (0, $lW2vI.useMoveIssue)();
    const { draggedIssue: draggedIssue, sourceGroup: sourceGroup, dropTarget: dropTarget } = (0, $kiyQL.useCardDragDrop)();
    const { confirmCardDrop: confirmCardDrop } = (0, $kiyQL.useCancelConfirmCardDrop)();
    const handleCardDragOver = (0, $5uXOq.useCallback)((transitionId)=>{
        updateDropTarget({
            group: dragAndDropColumnData,
            transition: $e58f7eb674a252a3$var$getTransitionById(transitions, transitionId)
        });
    }, [
        dragAndDropColumnData,
        transitions,
        updateDropTarget
    ]);
    const handleDroppedOnTransition = (0, $5uXOq.useCallback)((transitionId)=>{
        if (!draggedIssue) return;
        const transition = $e58f7eb674a252a3$var$getTransitionById(transitions, transitionId);
        updateDropTarget({
            group: dragAndDropColumnData,
            transition: transition
        });
        moveIssue({
            issue: draggedIssue,
            sourceGroup: sourceGroup,
            destinationGroup: dragAndDropColumnData,
            transition: transition,
            categoryField: categoryField
        });
        confirmCardDrop();
    }, [
        dragAndDropColumnData,
        transitions,
        updateDropTarget,
        draggedIssue,
        moveIssue,
        confirmCardDrop,
        sourceGroup,
        categoryField
    ]);
    const sourceStatus = (0, $5uXOq.useMemo)(()=>sourceGroup ? {
            id: Number(sourceGroup.id),
            name: sourceGroup.name
        } : undefined, [
        sourceGroup
    ]);
    const statusCategoryId = dragAndDropColumnData.type === (0, $hE5wF.GROUP_BY_STATUS) ? dragAndDropColumnData.statusCategoryId : 0;
    const transitionZonesData = (0, $5uXOq.useMemo)(()=>transitions.filter((transition)=>String(transition.toStatusId) === dragAndDropColumnData.id).map((transition)=>({
                transitionId: transition.transitionId,
                transitionName: transition.name,
                targetStatusId: transition.toStatusId,
                targetStatusName: dragAndDropColumnData.name,
                targetStatusCategory: (0, $gULOk.statusCategoryForId)(statusCategoryId),
                isAvailable: true,
                isGlobal: transition.isGlobal
            })), [
        transitions,
        dragAndDropColumnData,
        statusCategoryId
    ]);
    const notAvailableMessage = (0, $5uXOq.useMemo)(()=>{
        const workType = draggedIssue?.fields[0, $cvj5l.ISSUE_TYPE_ID]?.issueType?.name;
        if (workType && (0, $6s1PB.expVal)('jira-itr-m4-exp-3', 'isEnabled', false)) return formatMessage((0, $cMVLl.default).notAvailableMessageIssueTerminologyRefreshM4, {
            workType: workType
        });
        return (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $cMVLl.default).notAvailableMessageIssueTermRefresh : (0, $cMVLl.default).notAvailableMessage;
    }, [
        draggedIssue,
        formatMessage
    ]);
    if (!sourceGroup) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_1wtet4lq _vw7oglyw _1f5il1r9 _pslqidpf _1hvostnw _17hj14y2"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lyM0I.ColumnTransitionZonesContainer), {
        hasSwimlanes: false,
        columnId: dragAndDropColumnData.id,
        sourceColumnId: sourceGroup.id,
        sourceStatus: sourceStatus,
        transitions: transitionZonesData,
        hoverIntent: false,
        columnDraggingOver: dropTarget?.group?.id ?? null,
        notAvailableMessage: notAvailableMessage,
        onCardDragOver: handleCardDragOver,
        onTransitionSelected: handleDroppedOnTransition
    }));
};
var $e58f7eb674a252a3$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($e58f7eb674a252a3$var$BoardTransitionZones);
const $e58f7eb674a252a3$var$transitionZoneWrapperStyles = null;

});
parcelRegister("7Dc2g", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c2916f30059579b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<86df45d6616b90c5ccd88954bdac60af>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $1c2916f30059579b$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "cloudId"
        }
    ],
    "kind": "Fragment",
    "name": "BoardTransitionZones_query",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                }
            ],
            "concreteType": "JiraJqlField",
            "kind": "LinkedField",
            "name": "jira_categoryField",
            "plural": false,
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "kind": "ScalarField",
                        "name": "fieldId"
                    },
                    "action": "THROW",
                    "path": "jira_categoryField.fieldId"
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "kind": "ScalarField",
                        "name": "displayName"
                    },
                    "action": "THROW",
                    "path": "jira_categoryField.displayName"
                }
            ]
        }
    ],
    "type": "Query"
};
$1c2916f30059579b$var$node.hash = "b8d6dfef24e5a9e8ccfbece0bc1b13d8";
var $1c2916f30059579b$export$2e2bcd8739ae039 = $1c2916f30059579b$var$node;

});

parcelRegister("lyM0I", function(module, exports) {

$parcel$export(module.exports, "ColumnTransitionZonesContainer", () => $35a2ac94dcf5015c$export$169a50ebb52c9a6);

var $5uXOq = parcelRequire("5uXOq");

var $47bDC = parcelRequire("47bDC");

var $lFKmC = parcelRequire("lFKmC");

var $7gWdR = parcelRequire("7gWdR");

var $a2e2Q = parcelRequire("a2e2Q");

var $6cG4N = parcelRequire("6cG4N");

var $1fZVH = parcelRequire("1fZVH");

var $645AZ = parcelRequire("645AZ");

var $eEwGl = parcelRequire("eEwGl");

var $iVZBo = parcelRequire("iVZBo");

var $1oeFK = parcelRequire("1oeFK");


var $kMJOb = parcelRequire("kMJOb");
const $35a2ac94dcf5015c$export$169a50ebb52c9a6 = ({ columnId: columnId, swimlaneId: swimlaneId, columnDraggingOver: columnDraggingOver, onCardDragOver: onCardDragOver, hoverIntent: hoverIntent, onTransitionSelected: onTransitionSelected, hasSwimlanes: hasSwimlanes, sourceStatus: sourceStatus, notAvailableMessage: notAvailableMessage, noTransitionMessage: noTransitionMessage, isLoading: isLoading, shouldRenderFullColumnTransitionZone: shouldRenderFullColumnTransitionZone, hideSourceStatusInLabel: hideSourceStatusInLabel, transitions: allTransitions, sourceColumnId: sourceColumnId, showAllTransitionZones: showAllTransitionZones })=>{
    const autobatch = (0, $1fZVH.useAutobatch)();
    const [allowSelfColumnTransitions, setAllowSelfColumnTransitions] = (0, $5uXOq.useState)(false);
    const containerRef = (0, $5uXOq.useRef)(null);
    const { hasSoftwareTheming: hasSoftwareTheming } = (0, $a2e2Q.useSoftwareProjectTheming)();
    const hoverIntentOnThisColumn = hoverIntent && columnDraggingOver === columnId;
    const debouncedOnDragOverTransition = (0, $5uXOq.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))((transitionId, hoverIntentOnZone)=>{
            if (!hoverIntentOnThisColumn) onCardDragOver(transitionId, hoverIntentOnZone);
        }, (0, $ff2886b69dd99cbd$export$c28377001f14d9d)), [
        hoverIntentOnThisColumn,
        onCardDragOver
    ]);
    (0, $5uXOq.useEffect)(()=>()=>{
            debouncedOnDragOverTransition.cancel();
        }, [
        debouncedOnDragOverTransition
    ]);
    const onHoverOverTransitionToZone = (0, $5uXOq.useCallback)(()=>{
        setAllowSelfColumnTransitions(true);
    }, []);
    const renderTransitions = (transitions)=>{
        if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eEwGl.LoadingContainer), null);
        if (transitions.length === 0 && noTransitionMessage) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($35a2ac94dcf5015c$export$819ff6ae0287a04, {
            hasSwimlanes: hasSwimlanes,
            zoneCount: transitions.length,
            shouldRenderFullColumnTransitionZone: Boolean(shouldRenderFullColumnTransitionZone),
            "data-component-selector": "platform-board-kit.ui.column.column-transition-zones-container.inner-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iVZBo.NoTransitionContainer), {
            noTransitionMessage: noTransitionMessage
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($35a2ac94dcf5015c$export$819ff6ae0287a04, {
            hasSwimlanes: hasSwimlanes,
            zoneCount: transitions.length,
            shouldRenderFullColumnTransitionZone: Boolean(shouldRenderFullColumnTransitionZone),
            "data-component-selector": "platform-board-kit.ui.column.column-transition-zones-container.inner-container"
        }, transitions.map(({ transitionId: transitionId, transitionName: transitionName, targetStatusName: targetStatusName, targetStatusCategory: targetStatusCategory, isAvailable: isAvailable, targetStatusId: targetStatusId, isGlobal: isGlobal })=>{
            const filteredSourceStatus = sourceStatus?.id === targetStatusId ? null : sourceStatus;
            const filteredTransitionName = sourceStatus?.id === targetStatusId ? null : transitionName;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kMJOb.ColumnTransitionZone), {
                key: transitionId,
                isHidden: hoverIntent,
                transitionId: transitionId,
                transitionName: filteredTransitionName,
                targetStatusName: targetStatusName,
                onDragOver: debouncedOnDragOverTransition,
                targetStatusCategory: targetStatusCategory,
                isTransitionAvailable: isAvailable,
                isTransitionGlobal: isGlobal,
                notAvailableMessage: notAvailableMessage,
                sourceStatus: filteredSourceStatus,
                onTransitionSelection: onTransitionSelected,
                hideSourceStatusInLabel: hideSourceStatusInLabel,
                columnId: columnId,
                swimlaneId: swimlaneId
            });
        }));
    };
    (0, $5uXOq.useEffect)(()=>{
        if (!containerRef.current || isLoading || allTransitions.length === 0) return undefined;
        return (0, $7gWdR.dropTargetForElements)({
            element: containerRef.current,
            onDragLeave: ()=>{
                autobatch(()=>setAllowSelfColumnTransitions(false));
            }
        });
    }, [
        isLoading,
        allTransitions.length,
        allowSelfColumnTransitions,
        onCardDragOver,
        autobatch
    ]);
    let transitions = allTransitions;
    if (!showAllTransitionZones && columnId === sourceColumnId) {
        transitions = allTransitions.filter((t)=>!t.isGlobal || sourceStatus && t.targetStatusId !== sourceStatus.id);
        if (transitions.length === 0) return null;
    }
    if (!showAllTransitionZones && columnId === sourceColumnId && !allowSelfColumnTransitions && !hoverIntent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1oeFK.default), {
        onHover: onHoverOverTransitionToZone
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($35a2ac94dcf5015c$export$fb3bf400d073b5dd, {
        "data-component-selector": "platform-board-kit.ui.column.column-transition-zones-container.outer-transition-container",
        "data-testid": "platform-board-kit.ui.column.column-transition-zones-container.outer-container",
        isHidden: !shouldRenderFullColumnTransitionZone && hoverIntent,
        hasSwimlanes: hasSwimlanes,
        shouldRenderFullColumnTransitionZone: Boolean(shouldRenderFullColumnTransitionZone),
        innerRef: containerRef,
        theme: hasSoftwareTheming ? {
            background: (0, $6cG4N.Tokens).COLOR_ELEVATION_SURFACE_SUNKEN
        } : undefined
    }, renderTransitions(transitions));
};
const $35a2ac94dcf5015c$export$819ff6ae0287a04 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1064em4-0"
})`--full-column-height:calc( var(--board-scroll-element-height) * 1px - ${(0, $645AZ.columnHeaderHeight) + 8}px );position:sticky;width:100%;display:flex;flex-direction:column;top:${({ hasSwimlanes: hasSwimlanes })=>hasSwimlanes ? (0, $645AZ.columnHeaderHeight) * 2 : (0, $645AZ.columnHeaderHeight)}px;transition:opacity 0.2s;background-color:${({ theme: theme })=>theme.background};height:${({ shouldRenderFullColumnTransitionZone: shouldRenderFullColumnTransitionZone })=>shouldRenderFullColumnTransitionZone ? 'var(--full-column-height)' : '100%'};max-height:${({ shouldRenderFullColumnTransitionZone: shouldRenderFullColumnTransitionZone, zoneCount: zoneCount })=>shouldRenderFullColumnTransitionZone ? 'var(--full-column-height)' : `${zoneCount * (0, $645AZ.columnHeaderHeight) * 2}px`};`;
const $35a2ac94dcf5015c$export$fb3bf400d073b5dd = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1064em4-1"
})`position:absolute;top:${({ hasSwimlanes: hasSwimlanes })=>hasSwimlanes ? 0 : (0, $645AZ.columnHeaderHeight)}px;height:100%;width:100%;z-index:${({ shouldRenderFullColumnTransitionZone: shouldRenderFullColumnTransitionZone })=>shouldRenderFullColumnTransitionZone ? (0, $645AZ.zIndex).fullColumnHeightTransitionZones : (0, $645AZ.zIndex).transitionZones};background-color:${({ theme: theme })=>theme.background};border-radius:${(0, $645AZ.layout).cardListRadius}px;${({ isHidden: isHidden })=>isHidden && 'display: none;'};`;

});
parcelRegister("1fZVH", function(module, exports) {

$parcel$export(module.exports, "autobatch", () => $befa27b0681ab6bc$export$46f5568dd7916109);
$parcel$export(module.exports, "useAutobatch", () => $befa27b0681ab6bc$export$5b8ae94abd7adcf);

var $5uXOq = parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");

var $4R6GH = parcelRequire("4R6GH");
const $befa27b0681ab6bc$var$queue = new Set();
let $befa27b0681ab6bc$var$hasQueuedFlush = false;
function $befa27b0681ab6bc$var$flush() {
    const tasks = Array.from($befa27b0681ab6bc$var$queue);
    $befa27b0681ab6bc$var$queue.clear();
    (0, $7nsd3.unstable_batchedUpdates)(()=>{
        tasks.forEach((task)=>{
            task();
        });
    });
}
function $befa27b0681ab6bc$export$46f5568dd7916109(task) {
    $befa27b0681ab6bc$var$queue.add(task);
    if (!$befa27b0681ab6bc$var$hasQueuedFlush) {
        $befa27b0681ab6bc$var$hasQueuedFlush = true;
        queueMicrotask(()=>{
            $befa27b0681ab6bc$var$hasQueuedFlush = false;
            $befa27b0681ab6bc$var$flush();
        });
    }
    return ()=>{
        $befa27b0681ab6bc$var$queue.delete(task);
    };
}
function $befa27b0681ab6bc$export$5b8ae94abd7adcf() {
    if (!(0, $4R6GH.fg)('jsw_backlog_pragmatic_dnd_automatic_batching')) // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $5uXOq.useCallback)((task)=>task(), []);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const cancelFunctions = (0, $5uXOq.useRef)([]);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const batchingFunction = (0, $5uXOq.useCallback)((task)=>{
        const cancel = $befa27b0681ab6bc$export$46f5568dd7916109(task);
        cancelFunctions.current.push(cancel);
    }, []);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5uXOq.useEffect)(()=>()=>{
            cancelFunctions.current.forEach((cancel)=>{
                cancel();
            });
        }, []);
    return batchingFunction;
}

});

parcelRegister("645AZ", function(module, exports) {

$parcel$export(module.exports, "layout", () => $a67c0a983b5112a4$export$b3219800bda33a1f);
$parcel$export(module.exports, "colors", () => $a67c0a983b5112a4$export$8f45430ccf837300);
$parcel$export(module.exports, "zIndex", () => $a67c0a983b5112a4$export$56446adcecbeec34);
$parcel$export(module.exports, "columnHeaderHeight", () => $a67c0a983b5112a4$export$b10d8d0737c2bc95);
$parcel$export(module.exports, "columnFixedWidth", () => $a67c0a983b5112a4$export$fa05dc858c5009bb);
$parcel$export(module.exports, "columnMinWidth", () => $a67c0a983b5112a4$export$dc572e5846332cb1);
$parcel$export(module.exports, "columnWithMarginWidth", () => $a67c0a983b5112a4$export$28e72c3a8a93ac77);
$parcel$export(module.exports, "swimlaneHeaderHeight", () => $a67c0a983b5112a4$export$b12ee424ee8005de);
$parcel$export(module.exports, "minCardHeight", () => $a67c0a983b5112a4$export$9c20cef8efa8ff1c);
$parcel$export(module.exports, "scrollbarWidth", () => $a67c0a983b5112a4$export$14c8a45ff6da16d);
$parcel$export(module.exports, "unscheduledColumnWidth", () => $a67c0a983b5112a4$export$e635defc4ff8e744);
$parcel$export(module.exports, "unscheduledColumnHeaderHeight", () => $a67c0a983b5112a4$export$1f19522691bf7df6);

var $gwIPs = parcelRequire("gwIPs");
const $a67c0a983b5112a4$export$b3219800bda33a1f = {
    gutter: 10,
    smallGutter: 5,
    cardRadius: 3,
    cardListRadius: 6,
    adg3smallGutter: 8,
    columnMargin: 6,
    boardBorderWidth: (0, $gwIPs.contentHorizontalSpacing)
};
const $a67c0a983b5112a4$export$8f45430ccf837300 = {
    shadow: "var(--ds-border, #091E4224)"
};
const $a67c0a983b5112a4$export$56446adcecbeec34 = {
    // Inside board
    boardBorders: 90,
    minimap: 6,
    cardDoneRipple: 5,
    transitionZoneIndicator: 5,
    stickyHeaders: 4,
    swimlaneTickMask: 3,
    stickySwimlaneBar: 2,
    icc: 1,
    transitionZones: 1,
    fullColumnHeightTransitionZones: 3
};
const $a67c0a983b5112a4$export$b10d8d0737c2bc95 = 32 + 2 * $a67c0a983b5112a4$export$b3219800bda33a1f.adg3smallGutter;
const $a67c0a983b5112a4$export$fa05dc858c5009bb = 270;
const $a67c0a983b5112a4$export$1878bafe4afef3fb = 262;
const $a67c0a983b5112a4$export$dc572e5846332cb1 = 150;
const $a67c0a983b5112a4$export$28e72c3a8a93ac77 = $a67c0a983b5112a4$export$fa05dc858c5009bb + $a67c0a983b5112a4$export$b3219800bda33a1f.columnMargin * 2;
const $a67c0a983b5112a4$export$f47ba5aa0a13b432 = $a67c0a983b5112a4$export$dc572e5846332cb1 + $a67c0a983b5112a4$export$b3219800bda33a1f.columnMargin * 2;
const $a67c0a983b5112a4$export$b12ee424ee8005de = 24 + 2 * $a67c0a983b5112a4$export$b3219800bda33a1f.adg3smallGutter;
const $a67c0a983b5112a4$export$9c20cef8efa8ff1c = (0, $gwIPs.gridSize) * 10;
const $a67c0a983b5112a4$export$73febd7a1d3f7041 = 36;
const $a67c0a983b5112a4$export$7709c197eb61e438 = 40;
const $a67c0a983b5112a4$export$a18d33b11d25b5c7 = $a67c0a983b5112a4$export$7709c197eb61e438 + $a67c0a983b5112a4$export$b3219800bda33a1f.columnMargin * 2;
const $a67c0a983b5112a4$export$14c8a45ff6da16d = '10px';
const $a67c0a983b5112a4$export$e635defc4ff8e744 = '270px';
const $a67c0a983b5112a4$var$unscheduledColumnTitleHeight = 20;
const $a67c0a983b5112a4$export$1f19522691bf7df6 = $a67c0a983b5112a4$export$b12ee424ee8005de + $a67c0a983b5112a4$var$unscheduledColumnTitleHeight;

});

parcelRegister("eEwGl", function(module, exports) {

$parcel$export(module.exports, "LoadingContainer", () => $de32ae575a1b0c8f$export$5e3f251c730829);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $eZJjh = parcelRequire("eZJjh");
function $de32ae575a1b0c8f$export$5e3f251c730829() {
    const [showSpinner, setShowSpinner] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        const timeoutId = setTimeout(()=>setShowSpinner(true), 1000);
        return ()=>clearTimeout(timeoutId);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($de32ae575a1b0c8f$var$Wrapper, null, showSpinner ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
        size: "small"
    }) : null);
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $de32ae575a1b0c8f$var$Wrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqsw1if8 _1e0c1txw _4t3i16xz _4cvr1h6o _1bah1h6o",
            __cmplp.className
        ])
    });
});

});

parcelRegister("iVZBo", function(module, exports) {

$parcel$export(module.exports, "NoTransitionContainer", () => $160bf4691616f8f9$export$35d96e22ed839fc);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $koVbs = parcelRequire("koVbs");

var $fqH6b = parcelRequire("fqH6b");
function $160bf4691616f8f9$export$35d96e22ed839fc({ noTransitionMessage: noTransitionMessage }) {
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const message = formatMessage(noTransitionMessage);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($160bf4691616f8f9$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($160bf4691616f8f9$var$Img, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($fqH6b))),
        role: "presentation",
        alt: message
    }), message);
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $160bf4691616f8f9$var$Wrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c81o8v _kqsw1if8 _1e0c1txw _2lx21bp4 _4t3i16xz _4cvr1h6o _1bah1h6o _y3gn1h6o _syaz131l _ca0q1ejb _u5f31ejb _n3td1ejb _19bv1ejb",
            __cmplp.className
        ])
    });
});
const $160bf4691616f8f9$var$Img = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1tcg _1bsb1tcg _otyru2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("fqH6b", function(module, exports) {
module.exports = new URL("restricted.65d4317c.svg", import.meta.url).toString();

});


parcelRegister("1oeFK", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f746fcf61f7b3f9$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $lFKmC = parcelRequire("lFKmC");

var $7gWdR = parcelRequire("7gWdR");

var $7VHMR = parcelRequire("7VHMR");
var $koVbs = parcelRequire("koVbs");

var $1fZVH = parcelRequire("1fZVH");

var $645AZ = parcelRequire("645AZ");
const $3f746fcf61f7b3f9$var$hoverIntentDelayMs = 100;
const $3f746fcf61f7b3f9$var$messages = (0, $7VHMR.defineMessages)({
    transitionTo: {
        "id": "platform-board-kit.column.column-transition-zones-container.transition-to-zone.transition-to",
        "defaultMessage": "Transition To..."
    }
});
const $3f746fcf61f7b3f9$var$ColumnTransitionToZone = ({ onHover: onHover })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const autobatch = (0, $1fZVH.useAutobatch)();
    const [isDraggingOver, setIsDraggingOver] = (0, $5uXOq.useState)(false);
    const batchSetIsDraggingOver = (0, $5uXOq.useCallback)((draggingOver)=>{
        autobatch(()=>setIsDraggingOver(draggingOver));
    }, [
        autobatch
    ]);
    const containerRef = (0, $5uXOq.useRef)(null);
    const previousInputPosition = (0, $5uXOq.useRef)(null);
    const debouncedHoverIntent = (0, $5uXOq.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))(onHover, $3f746fcf61f7b3f9$var$hoverIntentDelayMs), [
        onHover
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!containerRef.current) return undefined;
        return (0, $7gWdR.dropTargetForElements)({
            element: containerRef.current,
            onDragEnter: ()=>{
                batchSetIsDraggingOver(true);
            },
            onDrag: ({ location: { current: { input: input } } })=>{
                if (previousInputPosition.current?.x !== input.clientX || previousInputPosition.current?.y !== input.clientY) {
                    debouncedHoverIntent();
                    previousInputPosition.current = {
                        x: input.clientX,
                        y: input.clientY
                    };
                }
            },
            onDragLeave: (_args)=>{
                debouncedHoverIntent.cancel();
                batchSetIsDraggingOver(false);
            }
        });
    }, [
        batchSetIsDraggingOver,
        debouncedHoverIntent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3f746fcf61f7b3f9$var$TransitionToZone, {
        isDraggingOver: isDraggingOver,
        ref: containerRef,
        "data-component-selector": "platform-board-kit.ui.column.column-transition-zones-container.transition-to-zone.transition-to-zone",
        "data-testid": "platform-board-kit.ui.column.column-transition-zones-container.transition-to-zone"
    }, formatMessage($3f746fcf61f7b3f9$var$messages.transitionTo));
};
var $3f746fcf61f7b3f9$export$2e2bcd8739ae039 = $3f746fcf61f7b3f9$var$ColumnTransitionToZone;
const $3f746fcf61f7b3f9$var$ttZoneHeight = (0, $645AZ.minCardHeight) * 0.5 - 5;
const $3f746fcf61f7b3f9$var$ttZoneMargin = (0, $645AZ.layout).adg3smallGutter * 0.5;
const $3f746fcf61f7b3f9$var$ttZoneMarginTop = -($3f746fcf61f7b3f9$var$ttZoneHeight + (0, $645AZ.layout).adg3smallGutter);
const $3f746fcf61f7b3f9$var$TransitionToZone = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isDraggingOver: isDraggingOver, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pk13i4 _2hwx1y44 _otyr1y44 _18u01y44 _2rkoi2wt _kqsw1if8 _y3gn1h6o _lcxv4shg _154iidpf _4t3ildb6 _vwz4ldb6 _1bsbzd3w _1pbyzo7u",
            __cmplp.isDraggingOver ? "_19it1ttf" : "_19it1ttf",
            __cmplp.isDraggingOver ? "_bfhki1yw" : "_bfhkfg4m",
            __cmplp.className
        ])
    });
});

});

const $ff2886b69dd99cbd$export$c28377001f14d9d = 350;
const $ff2886b69dd99cbd$export$b2112118f902d683 = 45;

parcelRegister("kMJOb", function(module, exports) {

$parcel$export(module.exports, "ColumnTransitionZone", () => $93d5ae56cae270b2$export$627a5fcef77c9034);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $7gWdR = parcelRequire("7gWdR");

var $1fZVH = parcelRequire("1fZVH");

var $7D59a = parcelRequire("7D59a");


var $645AZ = parcelRequire("645AZ");

var $9EXcX = parcelRequire("9EXcX");
const $93d5ae56cae270b2$export$627a5fcef77c9034 = ({ onDragOver: onDragOverProp, transitionId: transitionId, isTransitionAvailable: isTransitionAvailable, isHidden: isHidden, LabelComponent: LabelComponent = (0, $9EXcX.default), targetStatusName: targetStatusName, transitionName: transitionName, targetStatusCategory: targetStatusCategory, sourceStatus: sourceStatus, isTransitionGlobal: isTransitionGlobal, notAvailableMessage: notAvailableMessage, hideSourceStatusInLabel: hideSourceStatusInLabel, onTransitionSelection: onTransitionSelection, columnId: columnId, swimlaneId: swimlaneId })=>{
    const zoneRef = (0, $5uXOq.useRef)(null);
    const previousInputPosition = (0, $5uXOq.useRef)(null);
    const autobatch = (0, $1fZVH.useAutobatch)();
    const onDragOver = (0, $7D59a.useEvent)(onDragOverProp);
    const [isDraggingOver, setIsDraggingOver] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        if (!zoneRef.current) return undefined;
        return (0, $7gWdR.dropTargetForElements)({
            element: zoneRef.current,
            getData: ()=>({
                    type: (0, $25c2ea87c2b04bf9$export$2927f4d423091b16),
                    columnId: columnId,
                    swimlaneId: swimlaneId,
                    transitionId: transitionId
                }),
            onDragEnter: ()=>{
                onDragOver(transitionId, false);
                setIsDraggingOver(true);
            },
            onDrag: ({ location: { current: { input: input } } })=>{
                if (previousInputPosition.current?.x !== input.clientX || previousInputPosition.current?.y !== input.clientY) {
                    onDragOver(transitionId, true);
                    previousInputPosition.current = {
                        x: input.clientX,
                        y: input.clientY
                    };
                }
            },
            onDragLeave: (_args)=>{
                onDragOver(null, false);
                setIsDraggingOver(false);
            },
            onDrop: ()=>{
                if (isHidden || !isTransitionAvailable) return;
                autobatch(()=>onTransitionSelection(transitionId));
            }
        });
    }, [
        autobatch,
        columnId,
        isHidden,
        isTransitionAvailable,
        onTransitionSelection,
        swimlaneId,
        transitionId,
        onDragOver
    ]);
    const labelEl = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(LabelComponent, {
        source: hideSourceStatusInLabel ? null : transitionName,
        sourceStatus: hideSourceStatusInLabel ? null : sourceStatus,
        target: targetStatusName,
        targetStatusCategory: targetStatusCategory,
        isTransitionAvailable: isTransitionAvailable,
        isTransitionGlobal: isTransitionGlobal,
        showMessage: false,
        notAvailableMessage: notAvailableMessage
    });
    const commonProps = {
        isDraggingOver: isDraggingOver,
        isTransitionAvailable: isTransitionAvailable
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($93d5ae56cae270b2$export$2de257552dc02bf, {
        ref: zoneRef,
        ...commonProps,
        "data-testid": "platform-board-kit.ui.column.column-transition-zones-container.transition-zone.compiled-transition-zones-container",
        "data-component-selector": "platform-board-kit.ui.column.column-transition-zones-container.transition-zone.compiled-transition-zones-container"
    }, labelEl);
};
const $93d5ae56cae270b2$var$borderWidth = 2;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $93d5ae56cae270b2$var$borderRadius = `${(0, $645AZ.layout).cardListRadius}px`;
const $93d5ae56cae270b2$var$getAvailableBorderColour = (props)=>props.isDraggingOver ? "var(--ds-border-brand, #0C66E4)" : "var(--ds-border-focused, #388BFF)";
const $93d5ae56cae270b2$var$getDraggingBackgroundColour = (props)=>props.isDraggingOver ? "var(--ds-background-selected-hovered, #CCE0FF)" : "var(--ds-background-selected, #E9F2FF)";
const $93d5ae56cae270b2$var$getBorder = (props)=>({
        border: `${$93d5ae56cae270b2$var$borderWidth}px solid ${!props.isTransitionAvailable ? "var(--ds-background-accent-red-subtler, #FFD5D2)" : $93d5ae56cae270b2$var$getAvailableBorderColour(props)}`
    });
const $93d5ae56cae270b2$var$getBackgroundColor = (props)=>({
        backgroundColor: `${!props.isTransitionAvailable ? "var(--ds-background-danger, #FFECEB)" : $93d5ae56cae270b2$var$getDraggingBackgroundColour(props)}`
    });
const $93d5ae56cae270b2$export$2de257552dc02bf = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isTransitionAvailable: isTransitionAvailable, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_177x0if": (0, $lD23V.default)(`${$93d5ae56cae270b2$var$borderWidth}px solid ${!__cmplp.isTransitionAvailable ? "var(--ds-background-accent-red-subtler, #FFD5D2)" : $93d5ae56cae270b2$var$getAvailableBorderColour(__cmplp)}`),
            "--_1v6vhty": (0, $lD23V.default)($93d5ae56cae270b2$var$getDraggingBackgroundColour(__cmplp)),
            "--_1lnby5": (0, $lD23V.default)($93d5ae56cae270b2$var$borderRadius)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _ca0q14y2 _u5f314y2 _n3td14y2 _19bv14y2 _19itk9w5 _2lx21bp4 _1tkeidpf _1e0c1txw _4cvr1h6o _1bah1h6o _kqswh2mm _lcxv4shg _1jc111eo _e6mdhnez _kh711qt3 _am38glyw",
            !__cmplp.isTransitionAvailable ? "_bfhk1gly" : "_bfhkikgw",
            __cmplp.className
        ])
    });
});
const $93d5ae56cae270b2$export$7ed12d2a5241e393 = {
    getBackgroundColor: $93d5ae56cae270b2$var$getBackgroundColor,
    getBorder: $93d5ae56cae270b2$var$getBorder
};

});
parcelRegister("7D59a", function(module, exports) {

$parcel$export(module.exports, "useEvent", () => $cc6c832ad15d24e3$export$90fc3a17d93f704c);

var $5uXOq = parcelRequire("5uXOq");
const $cc6c832ad15d24e3$export$90fc3a17d93f704c = (callback)=>{
    const callbackRef = (0, $5uXOq.useRef)(callback);
    (0, $5uXOq.useLayoutEffect)(()=>{
        callbackRef.current = callback;
    }, [
        callback
    ]);
    return (0, $5uXOq.useCallback)((...args)=>callbackRef.current(...args), []);
};

});

parcelRegister("9EXcX", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3a289d543cac7bd$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $h1TKi = parcelRequire("h1TKi");

var $hMVoD = parcelRequire("hMVoD");

var $8RBk4 = parcelRequire("8RBk4");

var $7nnPp = parcelRequire("7nnPp");

var $2EwJD = parcelRequire("2EwJD");

var $az4zD = parcelRequire("az4zD");

var $dxWFc = parcelRequire("dxWFc");
const $a3a289d543cac7bd$var$ColumnTransitionLabel = /*#__PURE__*/ (0, $5uXOq.memo)(({ source: source, target: target, targetStatusCategory: targetStatusCategory, isTransitionAvailable: isTransitionAvailable, isTransitionGlobal: isTransitionGlobal, notAvailableMessage: notAvailableMessage, showMessage: showMessage, sourceStatus: sourceStatus, intl: { formatMessage: formatMessage } })=>{
    const shouldRenderSource = source || sourceStatus; /**
                                                      * check null against the source and the sourceStatus.
                                                      * if they are all null. Do not display the source and arrow
                                                      * e.g.
                                                      * label with source: TO DO -> IN PROGRESS
                                                      * label without source: IN PROGRESS
                                                      */ 
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a3a289d543cac7bd$var$LabelPositioningWrapper, {
        "data-testid": "platform-board-kit.ui.column.column-transition-zones-container.transition-zone.label.label-positioning-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a3a289d543cac7bd$var$TransitionRow, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a3a289d543cac7bd$var$InlineWrapper, null, shouldRenderSource && isTransitionGlobal && sourceStatus?.category ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2EwJD.default), {
        category: sourceStatus.category,
        name: sourceStatus.name
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", null, source)), shouldRenderSource && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a3a289d543cac7bd$var$InlineWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($h1TKi))), {
        label: "arrow",
        spacing: "spacious",
        color: "var(--ds-icon, #44546F)",
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($8RBk4))),
        LEGACY_size: "small",
        LEGACY_primaryColor: "var(--ds-text, #172B4D)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a3a289d543cac7bd$var$InlineFlex, null, !isTransitionAvailable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dxWFc.default), {
        label: "",
        size: "small",
        primaryColor: "var(--ds-icon-subtlest, #626F86)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hMVoD))), {
        label: typeof notAvailableMessage === 'string' ? notAvailableMessage : formatMessage(notAvailableMessage),
        color: "var(--ds-text-danger, #AE2E24)",
        spacing: "spacious",
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($7nnPp))),
        LEGACY_size: "small",
        LEGACY_primaryColor: "var(--ds-text-danger, #AE2E24)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2EwJD.default), {
        category: targetStatusCategory,
        name: target,
        isFullWidth: !shouldRenderSource
    }))), !isTransitionAvailable && showMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a3a289d543cac7bd$var$LabelRow, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a3a289d543cac7bd$var$LabelMessage, null, typeof notAvailableMessage === 'string' ? notAvailableMessage : formatMessage(notAvailableMessage))));
});
var $a3a289d543cac7bd$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $az4zD.injectIntlV2)($a3a289d543cac7bd$var$ColumnTransitionLabel);
const $a3a289d543cac7bd$var$LabelRow = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _p12f1osq _1bto1l2s _2lx2vrvc _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a3a289d543cac7bd$var$LabelPositioningWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _4cvr1h6o _1bah1h6o _p12f1osq _1bto1l2s _1n261g80",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a3a289d543cac7bd$var$InlineWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c116y _p12fn7od _o572n7od _1bto1l2s _s7n4nkob _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a3a289d543cac7bd$var$TransitionRow = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_y3gn1h6o _s7n4nkob _p12f1osq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a3a289d543cac7bd$var$InlineFlex = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c116y _o572n7od _1bto1l2s _s7n4nkob _p12f1osq _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a3a289d543cac7bd$var$LabelMessage = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c81o8v _19pku2gc _y3gn1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("h1TKi", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::11b8e18b02050eefbe32dafc654ee453>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c65dc59efb96b35a$var$_react = $c65dc59efb96b35a$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c65dc59efb96b35a$var$_baseNew = $c65dc59efb96b35a$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $c65dc59efb96b35a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: link to nested menu item, a linked menu item, next slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c65dc59efb96b35a$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $c65dc59efb96b35a$var$_react.default.createElement($c65dc59efb96b35a$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12.44 7.25 8.72 3.53l1.06-1.06 5 5a.75.75 0 0 1 0 1.06l-5 5-1.06-1.06 3.72-3.72H1v-1.5z" clip-rule="evenodd"/>`
    }, props));
$c65dc59efb96b35a$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
var $c65dc59efb96b35a$var$_default = module.exports.default = $c65dc59efb96b35a$var$ArrowRightIcon;

});

parcelRegister("8RBk4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6740397d4ba98b13$var$_react = $6740397d4ba98b13$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $6740397d4ba98b13$var$_arrowRight = $6740397d4ba98b13$var$_interopRequireDefault((parcelRequire("h1TKi")));
function $6740397d4ba98b13$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $6740397d4ba98b13$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $6740397d4ba98b13$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M11.793 5.793a1 1 0 0 0 0 1.414L15.586 11H6a1 1 0 0 0 0 2h9.586l-3.793 3.793a1 1 0 0 0 0 1.414c.39.39 1.024.39 1.415 0l5.499-5.5a1 1 0 0 0 .293-.679v-.057a1 1 0 0 0-.293-.678l-5.499-5.5a1 1 0 0 0-1.415 0"/></svg>`
    }, props, {
        newIcon: $6740397d4ba98b13$var$_arrowRight.default
    }));
$6740397d4ba98b13$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
var $6740397d4ba98b13$var$_default = module.exports.default = $6740397d4ba98b13$var$ArrowRightIcon;

});

parcelRegister("dxWFc", function(module, exports) {

$parcel$export(module.exports, "default", () => $66e9d55c435dacfd$export$2e2bcd8739ae039);
/**
 * Based on custom icon example:
 * https://atlassian.design/components/icon/custom-icon/examples
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $5LWLA = parcelRequire("5LWLA");
const $66e9d55c435dacfd$var$LightningGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: props.className
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.5115 3.99997H15.1546C15.4191 3.99997 15.6335 4.22318 15.6335 4.49852C15.6335 4.57648 15.616 4.65335 15.5823 4.72296L13.6197 8.7755C13.5006 9.02137 13.5955 9.32116 13.8317 9.44512C13.8986 9.48021 13.9724 9.49849 14.0473 9.49849H17.521C17.7855 9.49849 17.9999 9.7217 17.9999 9.99704C17.9999 10.1411 17.9401 10.2781 17.8358 10.3728L7.9973 19.3057C7.79797 19.4867 7.49545 19.4652 7.3216 19.2577C7.20098 19.1137 7.16999 18.9107 7.24181 18.7349L9.20627 13.9262C9.30979 13.6728 9.19639 13.38 8.95299 13.2723C8.89372 13.246 8.82998 13.2325 8.76557 13.2325H6.47884C6.21435 13.2325 5.99994 13.0093 5.99994 12.7339C5.99994 12.6552 6.01784 12.5777 6.05218 12.5075L10.0849 4.2721C10.1667 4.1051 10.3315 3.99997 10.5115 3.99997Z"
    }));
const $66e9d55c435dacfd$var$LightningBolt = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
        ...props,
        glyph: $66e9d55c435dacfd$var$LightningGlyph
    });
var $66e9d55c435dacfd$export$2e2bcd8739ae039 = $66e9d55c435dacfd$var$LightningBolt;

});




parcelRegister("cMVLl", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c1ac0ebef7e8f86$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $7c1ac0ebef7e8f86$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    notAvailableMessage: {
        "id": "work-management-board.board.column.transition-zones.not-available-message",
        "defaultMessage": "A workflow rule prevents you from moving the issue this way."
    },
    notAvailableMessageIssueTermRefresh: {
        "id": "work-management-board.board.column.transition-zones.not-available-message-issue-term-refresh",
        "defaultMessage": "A workflow rule prevents you from moving the work item this way."
    },
    notAvailableMessageIssueTerminologyRefreshM4: {
        "id": "work-management-board.board.column.transition-zones.not-available-message-issue-terminology-refresh-m4",
        "defaultMessage": "We can\u2019t move the {workType} this way because of a workflow rule."
    }
});

});


parcelRegister("lyv9B", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a75378be32c6814$export$2e2bcd8739ae039);

var $dZdp0 = parcelRequire("dZdp0");

var $3bV6d = parcelRequire("3bV6d");

var $8UJwS = parcelRequire("8UJwS");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $42CjB = parcelRequire("42CjB");

var $eGdV2 = parcelRequire("eGdV2");

var $fCfvZ = parcelRequire("fCfvZ");

var $iurLX = parcelRequire("iurLX");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $hE5wF = parcelRequire("hE5wF");

var $3HwlS = parcelRequire("3HwlS");

var $6s1PB = parcelRequire("6s1PB");

var $5cFkk = parcelRequire("5cFkk");

var $8xg9P = parcelRequire("8xg9P");

var $2EwJD = parcelRequire("2EwJD");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $dCm1o = parcelRequire("dCm1o");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $gULOk = parcelRequire("gULOk");

var $fPzrH = parcelRequire("fPzrH");

var $jf0VO = parcelRequire("jf0VO");

var $kiyQL = parcelRequire("kiyQL");

var $jgcJl = parcelRequire("jgcJl");

var $PjAGt = parcelRequire("PjAGt");

var $dp7CP = parcelRequire("dp7CP");

var $3w5Ly = parcelRequire("3w5Ly");

var $aIfUI = parcelRequire("aIfUI");

var $l7SAF = parcelRequire("l7SAF");

var $bvYiw = parcelRequire("bvYiw");
const $7a75378be32c6814$var$renderTransitionInfoOverlay = (sourceGroup, targetGroup)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_4cvr1h6o _1e0c11p5 _wij21bp4 _1bah1e5h _17kn15vq _1hrp15vq _x3fa1l2s _10ca1q9c",
            (0, $dCm1o.isVisualRefreshEnabled)() && "_zulpu2gc"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2EwJD.default), {
        category: (0, $gULOk.statusCategoryForId)(sourceGroup.statusCategoryId),
        name: sourceGroup.name
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eGdV2))), {
        LEGACY_size: "small",
        label: ""
    }), targetGroup?.name && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2EwJD.default), {
        category: (0, $gULOk.statusCategoryForId)(targetGroup.statusCategory?.statusCategoryId),
        name: targetGroup.name
    }));
};
const $7a75378be32c6814$var$StatusColumnHeader = ({ dragHandleRef: dragHandleRef, projectFragment: projectFragment, statusColumnFragment: statusColumnFragment, viewFragment: viewFragment, isCardOverColumn: isCardOverColumn, isDragPreview: isDragPreview, isDropDisabled: isDropDisabled, issueCount: issueCount, onToggle: onToggle, testId: testId, refresh: refresh, allStatusNames: allStatusNames, columnIndex: columnIndex })=>{
    const view = (0, $8Uumt.useFragment)((0, $8UJwS.default), viewFragment);
    const column = (0, $8Uumt.useFragment)((0, $3bV6d.default), statusColumnFragment);
    const [headerName, setHeaderName] = (0, $5uXOq.useState)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const isWorkflowOperationInProgress = (0, $8xg9P.useIsWorkflowOperationInProgress)();
    const workflowOperationStatusId = (0, $8xg9P.useWorkflowOperationStatusId)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { sourceGroup: sourceGroup, dropTarget: { transition: transition } } = (0, $kiyQL.useCardDragDrop)();
    const [isEditMode, setEditMode] = (0, $5uXOq.useState)(false);
    const [isMoreMenuOpen, setMoreMenuOpen] = (0, $5uXOq.useState)(false);
    const { renameStatus: renameStatus, validateRenameStatus: validateRenameStatus } = (0, $5cFkk.useRenameStatus)({
        analyticsSource: 'jiraWorkManagementBoard',
        experience: 'columnActionRename'
    });
    const group = column.statuses[0];
    (0, $5uXOq.useEffect)(()=>{
        group?.name && setHeaderName(group.name);
    }, [
        group?.name
    ]);
    const project = (0, $8Uumt.useFragment)((0, $dZdp0.default), projectFragment);
    const isProjectAdmin = project.canAdministerProject.canPerform;
    const isTeamManaged = project.projectStyle === 'TEAM_MANAGED_PROJECT';
    const { workflows: workflows } = (0, $jgcJl.useWorkflowStoreState)();
    const hasMultipleWorkflows = workflows.length > 1;
    const canReorderColumns = (0, $3HwlS.getWillShowNav4)() && (0, $6s1PB.expVal)('saved_views', 'enabled', false) || isProjectAdmin;
    const onMoreMenuOpenChange = (newState)=>{
        setMoreMenuOpen(newState);
    };
    const shouldRenderReadOnly = !isTeamManaged || !isProjectAdmin || hasMultipleWorkflows || isWorkflowOperationInProgress;
    const { refetch: refetchBoardData } = (0, $fPzrH.useBoardData)();
    if (!group) return;
    const isCollapsed = column.collapsed;
    const shouldShowTransitionInfoOverlay = transition != null && sourceGroup?.type === (0, $hE5wF.GROUP_BY_STATUS) && isCardOverColumn && !isCollapsed;
    const isCollapsedDropNotAllowed = isDropDisabled && isCollapsed;
    const columnName = headerName ?? group.name;
    const readOnlyHeaderContent = group.statusCategory?.statusCategoryId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_zulp1b66 _1e0c1txw _1ul9idpf _1tkeidpf",
            isCollapsed && "_1lfclhck"
        ])
    }, (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $7a75378be32c6814$var$statusHeaderStyles
    }, columnName) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2EwJD.default), {
        name: columnName,
        category: (0, $gULOk.statusCategoryForId)(group.statusCategory.statusCategoryId)
    }), Number(group.statusCategory.statusCategoryId) === (0, $gULOk.StatusCategoryIds).done && (0, $dCm1o.isVisualRefreshEnabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dp7CP.default), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aIfUI.default), {
        isCollapsed: isCollapsed,
        issueCount: issueCount
    }));
    const editHeaderContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_4cvr1h6o _1e0c1txw _16jlkb7n _1ul9idpf _104v1r31 _1m7fglyw _o6xs1o36 _2iu91osq _d8r5idpf"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3w5Ly.default), {
        defaultValue: group.name,
        isEditing: isEditMode,
        readView: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
                className: (0, $bwpsq.default)([
                    "_zulpu2gc _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _4cvr1h6o _80om1kw7 _1e0c1txw _2lx2vrvc _16jlkb7n _1ul9idpf _1tkeidpf"
                ])
            }, readOnlyHeaderContent),
        onCancel: ()=>setEditMode(false),
        onConfirm: async (newName)=>{
            setEditMode(false);
            setHeaderName(newName);
            try {
                const issueTypeId = workflows[0]?.issueTypes[0]?.id;
                if (!issueTypeId) return;
                await renameStatus({
                    oldName: group.name,
                    newName: newName,
                    statusId: Number(group.statusId),
                    issueTypeId: issueTypeId
                });
            } catch  {} finally{
                refresh();
                refetchBoardData();
            }
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'input submitted', 'renameColumn');
        },
        onEdit: ()=>{
            setEditMode(true);
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'input clicked', 'renameColumn', {
                isProjectAdmin: isProjectAdmin,
                hasMultipleWorkflows: hasMultipleWorkflows
            });
        },
        onValidate: (newName)=>validateRenameStatus({
                oldName: group.name,
                newName: newName,
                existingStatusNames: allStatusNames
            })
    }));
    const headerContent = shouldRenderReadOnly || isCollapsed ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_zulpu2gc _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _4cvr1h6o _80om1kw7 _1e0c1txw _2lx2vrvc _16jlkb7n _1ul9idpf _1tkeidpf",
            isCollapsed && "_ca0q1b66 _u5f3idpf _n3tdu2gc _19bvidpf _2lx21bp4"
        ])
    }, readOnlyHeaderContent) : editHeaderContent;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        ref: canReorderColumns && (0, $4R6GH.fg)('update-column-header-design') ? dragHandleRef : undefined,
        "data-testid": testId,
        className: (0, $bwpsq.default)([
            $7a75378be32c6814$var$containerStylesMap.root,
            isMoreMenuOpen && $7a75378be32c6814$var$containerStylesMap.moreMenu,
            isCollapsed && (0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('visual-refresh-headers-buttons') && $7a75378be32c6814$var$containerStylesMap.collapsed,
            isCollapsed && !((0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('visual-refresh-headers-buttons')) && $7a75378be32c6814$var$containerStylesMap.collapsedOld,
            canReorderColumns && (0, $4R6GH.fg)('update-column-header-design') && $7a75378be32c6814$var$containerStylesMap.headerDraggable
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            (0, $4R6GH.fg)('update-column-header-design') && "_zulp1b66 _4cvr1h6o _vchhusvi _syazcdhy _1e0c1txw _2lx2vrvc _1bah1yb4 _ca0qidpf _u5f3utpp _n3tdidpf _19bvutpp _1bsb1osq",
            isCollapsed && (0, $4R6GH.fg)('update-column-header-design') && "_ca0qu2gc _u5f3idpf _n3td1b66 _19bvidpf _2lx21bp4",
            !(0, $4R6GH.fg)('update-column-header-design') && "_zulp1b66 _4cvr1h6o _vchhusvi _syazcdhy _1e0c1txw _2lx2vrvc _1bah1yb4 _ca0qidpf _u5f3u2gc _n3tdidpf _19bvpxbi _1bsb1osq",
            isCollapsed && !(0, $4R6GH.fg)('update-column-header-design') && "_ca0qdlk8 _u5f3idpf _n3td1b66 _19bvidpf _2lx21bp4"
        ])
    }, isCollapsedDropNotAllowed ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jf0VO.default), null) : canReorderColumns && !(0, $4R6GH.fg)('update-column-header-design') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        "aria-hidden": true,
        xcss: $7a75378be32c6814$var$dragHandleStyles,
        ref: dragHandleRef,
        testId: "work-management-board.ui.board.column.column-header.drag-handle"
    }, "\u283F"), shouldShowTransitionInfoOverlay ? $7a75378be32c6814$var$renderTransitionInfoOverlay(sourceGroup, group) : headerContent, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-component-selector": "work-management-board.ui.board.column.column-header.collapse-button-wrapper",
        className: (0, $bwpsq.default)([
            "_zulp1b66 _1e0c1txw _4t3i17is _tzy411de _1bsbeudw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        icon: isCollapsed ? (0, (/*@__PURE__*/$parcel$interopDefault($iurLX))) : (0, (/*@__PURE__*/$parcel$interopDefault($fCfvZ))),
        appearance: "subtle",
        isTooltipDisabled: false,
        label: formatMessage(isCollapsed ? (0, $bvYiw.default).expandButtonLabel : (0, $bvYiw.default).collapseButtonLabel, {
            name: columnName
        }),
        onClick: onToggle
    }), !isCollapsed && isTeamManaged && !isDragPreview && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l7SAF.default), {
        isLoading: workflowOperationStatusId === group.statusId && isWorkflowOperationInProgress,
        hasMultipleWorkflows: hasMultipleWorkflows,
        columnName: group.name,
        onRenameClick: ()=>{
            setEditMode(true);
        },
        onOpenChange: onMoreMenuOpenChange,
        projectFragment: project,
        viewFragment: view,
        statusFragment: group,
        refresh: refresh,
        columnIndex: columnIndex
    })), !isCollapsed && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $PjAGt.default), {
        statusFragment: group
    })));
};
var $7a75378be32c6814$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($7a75378be32c6814$var$StatusColumnHeader);
const $7a75378be32c6814$var$headerTitleWrapperStyles = null;
const $7a75378be32c6814$var$headerTitleWrapperCollapsedStyles = null;
const $7a75378be32c6814$var$headerTitleWrapperStylesOld = null;
const $7a75378be32c6814$var$headerTitleWrapperCollapsedStylesOld = null;
const $7a75378be32c6814$var$headerButtonsWrapperStyles = null;
const $7a75378be32c6814$var$containerStylesMap = {
    root: "_1e0c1txw _kqswh2mm _uiztglyw _1ji3grho _59hlidpf _1xn7grho _1o9zidpf _1pbyegat _4t3ickbl _1rop1wug _3o2n1wug _3bdqt94y _at5wt94y _tdle1wug _1d8n1wug",
    collapsed: "_1tkeidpf _1o9zkb7n _1pbycs5v _4t3i1wug _c71luuw1",
    collapsedOld: "_1tkeidpf _1o9zkb7n _1pbycs5v _4t3i1wug",
    headerDraggable: "_80om1qgj",
    moreMenu: "_1ji31wug _59hlt94y _1xn71wug"
};
const $7a75378be32c6814$var$transitionInfoContainerStyles = null;
const $7a75378be32c6814$var$transitionInfoContainerWithGapStyles = null;
const $7a75378be32c6814$var$dragHandleStyles = (0, $8CUq3.xcss)({
    color: 'color.text.subtle',
    cursor: 'grab'
});
const $7a75378be32c6814$var$writingModeWrapperStyles = null;
const $7a75378be32c6814$var$writingModeWrapperCollapsedStyles = null;
const $7a75378be32c6814$var$headerContentWrapperStyles = null;
const $7a75378be32c6814$var$headerContentWrapperCollapsedStyles = null;
const $7a75378be32c6814$var$editableColumnHeaderWrapperStyles = null;
const $7a75378be32c6814$var$statusHeaderStyles = (0, $8CUq3.xcss)({
    font: 'font.heading.xxsmall',
    fontWeight: 'font.weight.medium',
    color: 'color.text.subtle',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    textTransform: 'uppercase',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
});

});
parcelRegister("dZdp0", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf06a125fff1d01b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<db8753c743a4297a200307d957dd6622>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $bf06a125fff1d01b$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "StatusColumnHeader_project",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "alias": "canAdministerProject",
                "args": [
                    {
                        "kind": "Literal",
                        "name": "type",
                        "value": "EDIT_PROJECT_CONFIG"
                    }
                ],
                "concreteType": "JiraProjectAction",
                "kind": "LinkedField",
                "name": "action",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "canPerform"
                        },
                        "action": "THROW",
                        "path": "canAdministerProject.canPerform"
                    }
                ],
                "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
            },
            "action": "THROW",
            "path": "canAdministerProject"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "projectStyle"
            },
            "action": "THROW",
            "path": "projectStyle"
        },
        {
            "kind": "FragmentSpread",
            "name": "BoardHeaderDropdown_project"
        }
    ],
    "type": "JiraProject"
};
$bf06a125fff1d01b$var$node.hash = "d08380cce943eda78dc8f99fe01644d8";
var $bf06a125fff1d01b$export$2e2bcd8739ae039 = $bf06a125fff1d01b$var$node;

});

parcelRegister("3bV6d", function(module, exports) {

$parcel$export(module.exports, "default", () => $6bed3bce6dfcc3d3$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<451b971e3c82429a05b6eabab0387874>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6bed3bce6dfcc3d3$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "StatusColumnHeader_column",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "collapsed"
            },
            "action": "THROW",
            "path": "collapsed"
        },
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "JiraStatus",
                "kind": "LinkedField",
                "name": "statuses",
                "plural": true,
                "selections": [
                    {
                        "kind": "FragmentSpread",
                        "name": "BoardHeaderDropdown_status"
                    },
                    {
                        "kind": "FragmentSpread",
                        "name": "ColumnConfettiAsync_status"
                    },
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "name"
                        },
                        "action": "THROW",
                        "path": "statuses.name"
                    },
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "statusId"
                        },
                        "action": "THROW",
                        "path": "statuses.statusId"
                    },
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "JiraStatusCategory",
                            "kind": "LinkedField",
                            "name": "statusCategory",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "kind": "ScalarField",
                                        "name": "statusCategoryId"
                                    },
                                    "action": "THROW",
                                    "path": "statuses.statusCategory.statusCategoryId"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "statuses.statusCategory"
                    }
                ]
            },
            "action": "THROW",
            "path": "statuses"
        }
    ],
    "type": "JiraBoardViewStatusColumn"
};
$6bed3bce6dfcc3d3$var$node.hash = "fe785cf784352e4c14d6cb6e5214254e";
var $6bed3bce6dfcc3d3$export$2e2bcd8739ae039 = $6bed3bce6dfcc3d3$var$node;

});

parcelRegister("8UJwS", function(module, exports) {

$parcel$export(module.exports, "default", () => $018fa344596ffbab$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<76d8231d201ad8356c493309770e912e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $018fa344596ffbab$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "StatusColumnHeader_view",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "BoardHeaderDropdown_view"
        }
    ],
    "type": "JiraBoardView"
};
$018fa344596ffbab$var$node.hash = "a7e9bcd61ed41130688a25dae11386d5";
var $018fa344596ffbab$export$2e2bcd8739ae039 = $018fa344596ffbab$var$node;

});

parcelRegister("eGdV2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::101a51255f7076752a2af1f3fc652adc>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $aaffc8f190d8dd35$var$_react = $aaffc8f190d8dd35$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $aaffc8f190d8dd35$var$_arrowRight = $aaffc8f190d8dd35$var$_interopRequireDefault((parcelRequire("h1TKi")));

var $aaffc8f190d8dd35$var$_arrowRight2 = $aaffc8f190d8dd35$var$_interopRequireDefault((parcelRequire("8RBk4")));
function $aaffc8f190d8dd35$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ArrowRightIcon.
 * This component is ArrowRightIcon, with `UNSAFE_fallbackIcon` set to "ArrowRightIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: link to nested menu item, a linked menu item, next slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $aaffc8f190d8dd35$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $aaffc8f190d8dd35$var$_react.default.createElement($aaffc8f190d8dd35$var$_arrowRight.default, Object.assign({
        LEGACY_fallbackIcon: $aaffc8f190d8dd35$var$_arrowRight2.default
    }, props));
$aaffc8f190d8dd35$var$ArrowRightIcon.Name = 'ArrowRightIconMigration';
var $aaffc8f190d8dd35$var$_default = module.exports.default = $aaffc8f190d8dd35$var$ArrowRightIcon;

});

parcelRegister("fCfvZ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::25091e321a5cc356e731192d00270521>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b5e67097e9bd6170$var$_react = $b5e67097e9bd6170$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $b5e67097e9bd6170$var$_shrinkHorizontal = $b5e67097e9bd6170$var$_interopRequireDefault((parcelRequire("hocXQ")));

var $b5e67097e9bd6170$var$_collapse = $b5e67097e9bd6170$var$_interopRequireDefault((parcelRequire("8sVBM")));
function $b5e67097e9bd6170$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ShrinkHorizontalIcon.
 * This component is ShrinkHorizontalIcon, with `UNSAFE_fallbackIcon` set to "EditorCollapseIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for contracting or reducing the width of an element.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b5e67097e9bd6170$var$ShrinkHorizontalIcon = (props)=>/*#__PURE__*/ $b5e67097e9bd6170$var$_react.default.createElement($b5e67097e9bd6170$var$_shrinkHorizontal.default, Object.assign({
        LEGACY_fallbackIcon: $b5e67097e9bd6170$var$_collapse.default
    }, props));
$b5e67097e9bd6170$var$ShrinkHorizontalIcon.Name = 'ShrinkHorizontalIconMigration';
var $b5e67097e9bd6170$var$_default = module.exports.default = $b5e67097e9bd6170$var$ShrinkHorizontalIcon;

});
parcelRegister("hocXQ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6a9e4799467251fb8d42dd325d017373>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ca8ebbfe28d077b2$var$_react = $ca8ebbfe28d077b2$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $ca8ebbfe28d077b2$var$_baseNew = $ca8ebbfe28d077b2$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $ca8ebbfe28d077b2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ShrinkHorizontal".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for contracting or reducing the width of an element.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ca8ebbfe28d077b2$var$ShrinkHorizontalIcon = (props)=>/*#__PURE__*/ $ca8ebbfe28d077b2$var$_react.default.createElement($ca8ebbfe28d077b2$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.25 8.75H0v-1.5h6.25zm3.5-1.5H16v1.5H9.75z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M5.19 8 2.22 5.03l1.06-1.06 3.5 3.5a.75.75 0 0 1 0 1.06l-3.5 3.5-1.06-1.06zm4.03-.53 3.5-3.5 1.06 1.06L10.81 8l2.97 2.97-1.06 1.06-3.5-3.5a.75.75 0 0 1 0-1.06" clip-rule="evenodd"/>`
    }, props));
$ca8ebbfe28d077b2$var$ShrinkHorizontalIcon.displayName = 'ShrinkHorizontalIcon';
var $ca8ebbfe28d077b2$var$_default = module.exports.default = $ca8ebbfe28d077b2$var$ShrinkHorizontalIcon;

});

parcelRegister("8sVBM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $629da0128daed98a$var$_react = $629da0128daed98a$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $629da0128daed98a$var$_shrinkHorizontal = $629da0128daed98a$var$_interopRequireDefault((parcelRequire("hocXQ")));
function $629da0128daed98a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $629da0128daed98a$var$EditorCollapseIcon = (props)=>/*#__PURE__*/ $629da0128daed98a$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M8.062 11 6.5 9.914A1 1 0 0 1 7.914 8.5l2.616 2.616c.28.167.47.5.47.884s-.19.717-.47.884L7.914 15.5A1 1 0 1 1 6.5 14.086L8.062 13h-3.68c-.487 0-.882-.448-.882-1s.395-1 .882-1zm5.408 1.884c-.28-.167-.47-.5-.47-.884s.19-.717.47-.884L16.086 8.5A1 1 0 0 1 17.5 9.914L15.938 11h3.68c.487 0 .882.448.882 1s-.395 1-.882 1h-3.68l1.562 1.086a1 1 0 0 1-1.414 1.414z"/></svg>`
    }, props, {
        newIcon: $629da0128daed98a$var$_shrinkHorizontal.default
    }));
$629da0128daed98a$var$EditorCollapseIcon.displayName = 'EditorCollapseIcon';
var $629da0128daed98a$var$_default = module.exports.default = $629da0128daed98a$var$EditorCollapseIcon;

});


parcelRegister("iurLX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f66a5317b716408a42d96f72b3784ae4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d760925e6e626902$var$_react = $d760925e6e626902$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $d760925e6e626902$var$_growHorizontal = $d760925e6e626902$var$_interopRequireDefault((parcelRequire("eQVzV")));

var $d760925e6e626902$var$_expand = $d760925e6e626902$var$_interopRequireDefault((parcelRequire("10aQ7")));
function $d760925e6e626902$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for GrowHorizontalIcon.
 * This component is GrowHorizontalIcon, with `UNSAFE_fallbackIcon` set to "EditorExpandIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for increasing the width of an element.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d760925e6e626902$var$GrowHorizontalIcon = (props)=>/*#__PURE__*/ $d760925e6e626902$var$_react.default.createElement($d760925e6e626902$var$_growHorizontal.default, Object.assign({
        LEGACY_fallbackIcon: $d760925e6e626902$var$_expand.default
    }, props));
$d760925e6e626902$var$GrowHorizontalIcon.Name = 'GrowHorizontalIconMigration';
var $d760925e6e626902$var$_default = module.exports.default = $d760925e6e626902$var$GrowHorizontalIcon;

});
parcelRegister("eQVzV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::da1cd6bc83afe2b3eb4120a294491d29>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ad0295eaae02a064$var$_react = $ad0295eaae02a064$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $ad0295eaae02a064$var$_baseNew = $ad0295eaae02a064$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $ad0295eaae02a064$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "GrowHorizontal".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for increasing the width of an element.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ad0295eaae02a064$var$GrowHorizontalIcon = (props)=>/*#__PURE__*/ $ad0295eaae02a064$var$_react.default.createElement($ad0295eaae02a064$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m.22 7.47 3.5-3.5 1.06 1.06-2.22 2.22H7v1.5H2.56l2.22 2.22-1.06 1.06-3.5-3.5a.75.75 0 0 1 0-1.06m13.22-.22-2.22-2.22 1.06-1.06 3.5 3.5a.75.75 0 0 1 0 1.06l-3.5 3.5-1.06-1.06 2.22-2.22H9v-1.5z" clip-rule="evenodd"/>`
    }, props));
$ad0295eaae02a064$var$GrowHorizontalIcon.displayName = 'GrowHorizontalIcon';
var $ad0295eaae02a064$var$_default = module.exports.default = $ad0295eaae02a064$var$GrowHorizontalIcon;

});

parcelRegister("10aQ7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0bae3314669faf11$var$_react = $0bae3314669faf11$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $0bae3314669faf11$var$_growHorizontal = $0bae3314669faf11$var$_interopRequireDefault((parcelRequire("eQVzV")));
function $0bae3314669faf11$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $0bae3314669faf11$var$EditorExpandIcon = (props)=>/*#__PURE__*/ $0bae3314669faf11$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M18.062 11 16.5 9.914A1 1 0 1 1 17.914 8.5l2.616 2.616c.28.167.47.5.47.884s-.19.717-.47.884L17.914 15.5a1 1 0 0 1-1.414-1.414L18.062 13h-3.68c-.487 0-.882-.448-.882-1s.395-1 .882-1zM3.47 12.884c-.28-.167-.47-.5-.47-.884s.19-.717.47-.884L6.086 8.5A1 1 0 0 1 7.5 9.914L5.938 11h3.68c.487 0 .882.448.882 1s-.395 1-.882 1h-3.68L7.5 14.086A1 1 0 0 1 6.086 15.5z"/></svg>`
    }, props, {
        newIcon: $0bae3314669faf11$var$_growHorizontal.default
    }));
$0bae3314669faf11$var$EditorExpandIcon.displayName = 'EditorExpandIcon';
var $0bae3314669faf11$var$_default = module.exports.default = $0bae3314669faf11$var$EditorExpandIcon;

});


parcelRegister("5cFkk", function(module, exports) {

$parcel$export(module.exports, "useRenameStatus", () => $f4bf9e3762c9251c$export$a5702435b665f82d);

var $5uXOq = parcelRequire("5uXOq");

var $daQYX = parcelRequire("daQYX");

var $93jKl = parcelRequire("93jKl");

var $kaHBi = parcelRequire("kaHBi");

var $3bQtK = parcelRequire("3bQtK");

var $8dXDG = parcelRequire("8dXDG");

var $6nqwL = parcelRequire("6nqwL");

var $eAapG = parcelRequire("eAapG");

var $pa9q9 = parcelRequire("pa9q9");

var $koVbs = parcelRequire("koVbs");

var $koeKL = parcelRequire("koeKL");

var $atdLB = parcelRequire("atdLB");
var $duUGa = parcelRequire("duUGa");

var $8xg9P = parcelRequire("8xg9P");

var $ayqGc = parcelRequire("ayqGc");

var $9a7GF = parcelRequire("9a7GF");
const $f4bf9e3762c9251c$var$getCleanColumnName = (name)=>name.replace(/\s{2,}/g, ' ').trim();
const $f4bf9e3762c9251c$export$a5702435b665f82d = ({ analyticsSource: analyticsSource, experience: experience })=>{
    const renameStatusExperience = (0, $5uXOq.useMemo)(()=>new (0, $duUGa.UFOExperience)(experience, {
            type: (0, $atdLB.ExperienceTypes).Operation,
            performanceType: (0, $atdLB.ExperiencePerformanceTypes).Custom
        }), [
        experience
    ]);
    const startRenameOperation = (0, $8xg9P.useStartRenameOperation)();
    const stopWorkflowOperationInProgress = (0, $8xg9P.useStopWorkflowOperationInProgress)();
    const { fetchWorkflowsV2: fetchWorkflowsV2, validateAndUpdateWorkflowsV2: validateAndUpdateWorkflowsV2 } = (0, $6nqwL.useWorkflowsV2)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const cloudId = (0, $koeKL.useCloudId)();
    const startExperience = (0, $kaHBi.useExperienceStart)({
        analyticsSource: analyticsSource,
        experience: experience
    });
    const markExperienceSuccess = (0, $3bQtK.useExperienceSuccess)({
        experience: experience
    });
    const markExperienceFailed = (0, $93jKl.useExperienceFail)({
        experience: experience
    });
    const abortExperience = (0, $8dXDG.useExperienceAbort)({
        experience: experience
    });
    const project = (0, $daQYX.useProject)();
    const { showFlag: showFlag } = (0, $pa9q9.useFlagService)();
    /**
   * @returns undefined if it is valid, otherwise return string that will be used as error message
   * this is a pattern used by atlaskit form field validation or inline edit
   */ const validateRenameStatus = (0, $5uXOq.useCallback)(({ oldName: oldName, newName: newName, existingStatusNames: existingStatusNames })=>{
        const cleanNewName = $f4bf9e3762c9251c$var$getCleanColumnName(newName);
        const convertedNewName = cleanNewName.toUpperCase();
        if (convertedNewName === oldName.toUpperCase()) return undefined;
        if (!cleanNewName.length) return formatMessage((0, $9a7GF.default).emptyStatusNameError);
        if (existingStatusNames.some((statusName)=>statusName.toUpperCase() === convertedNewName)) return formatMessage((0, $9a7GF.default).statusAlreadyExists, {
            statusName: cleanNewName
        });
    }, [
        formatMessage
    ]);
    const renameStatus = (0, $5uXOq.useCallback)(async ({ oldName: oldName, statusId: statusId, newName: newName, issueTypeId: issueTypeId })=>{
        const cleanNewName = $f4bf9e3762c9251c$var$getCleanColumnName(newName);
        const convertedNewName = cleanNewName.toUpperCase();
        if (!cleanNewName.length || convertedNewName === oldName.toUpperCase()) return;
        startRenameOperation(String(statusId));
        startExperience();
        renameStatusExperience.start();
        try {
            // fetch workflow data from workflow API
            const workflowsData = await fetchWorkflowsV2({
                cloudId: cloudId,
                projectAndIssueTypes: [
                    {
                        projectId: project.id.toString(),
                        issueTypeId: issueTypeId
                    }
                ]
            });
            if (workflowsData) {
                // rename the status in place
                const toRenameStatus = workflowsData.statuses.find((s)=>s.id === statusId.toString());
                if (toRenameStatus) {
                    toRenameStatus.name = cleanNewName;
                    await validateAndUpdateWorkflowsV2({
                        cloudId: cloudId,
                        payload: {
                            payload: {
                                statuses: (0, $eAapG.mapStatusesToStatusUpdateObjects)(workflowsData.statuses),
                                workflows: [
                                    (0, $eAapG.mapWorkflowToWorkflowUpdateObject)(workflowsData.workflows[0])
                                ]
                            },
                            validationOptions: {
                                levels: [
                                    'ERROR'
                                ]
                            }
                        }
                    });
                    markExperienceSuccess();
                    renameStatusExperience.success();
                }
            }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            showFlag((0, $ayqGc.getStatusActionFailedFlag)({
                messageTitle: (0, $9a7GF.default).errorFlagTitleRenameStatus,
                action: 'rename',
                error: error,
                issueTypeId: issueTypeId,
                projectKey: project.key,
                statusCode: error?.response?.status
            }));
            (0, $ayqGc.failStatusExperience)({
                markExperienceFailed: markExperienceFailed,
                abortExperience: abortExperience,
                ufoExperience: renameStatusExperience,
                error: error,
                errorMessage: 'Failed to validate and update workflow'
            });
            throw error;
        } finally{
            stopWorkflowOperationInProgress();
        }
    }, [
        startRenameOperation,
        renameStatusExperience,
        startExperience,
        fetchWorkflowsV2,
        cloudId,
        project.id,
        project.key,
        validateAndUpdateWorkflowsV2,
        markExperienceSuccess,
        showFlag,
        markExperienceFailed,
        abortExperience,
        stopWorkflowOperationInProgress
    ]);
    return {
        renameStatus: renameStatus,
        validateRenameStatus: validateRenameStatus
    };
};

});
parcelRegister("6nqwL", function(module, exports) {

$parcel$export(module.exports, "useWorkflowsV2", () => $140c546f51be918f$export$32b6f4c35d4611ee);
// The Workflow V2 API is defined here: https://developer.atlassian.com/cloud/jira-workflow/rest/api-group-workflow-v-/

var $5uXOq = parcelRequire("5uXOq");

var $7Jxgt = parcelRequire("7Jxgt");

var $gULOk = parcelRequire("gULOk");

var $jcw0u = parcelRequire("jcw0u");

var $7f4tk = parcelRequire("7f4tk");

var $jJZqs = parcelRequire("jJZqs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");


var $64pOt = parcelRequire("64pOt");

var $eAapG = parcelRequire("eAapG");
// Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
const $140c546f51be918f$var$noop = ()=>{};
const $140c546f51be918f$export$32b6f4c35d4611ee = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const fetchWorkflowsV2 = (0, $5uXOq.useCallback)(async ({ cloudId: cloudId, projectAndIssueTypes: projectAndIssueTypes })=>{
        try {
            const url = `/gateway/api/jira/project-configuration/query/${cloudId}/3/workflow`;
            const response = await (0, $7f4tk.default)(url, {
                method: 'POST',
                body: JSON.stringify({
                    projectAndIssueTypes: projectAndIssueTypes,
                    skipUsageLookup: false
                })
            });
            return response;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            const jsonErrorResponse = error.originalResponse ? await error.originalResponse.json().catch($140c546f51be918f$var$noop) : undefined;
            if (jsonErrorResponse) {
                const errorMessage = `Fetch workflow fail status code: ${error.statusCode}; response: ${JSON.stringify(jsonErrorResponse)}`;
                const errorWithResponseMessage = new (0, $jJZqs.default)(error.statusCode, errorMessage, error.traceId);
                (0, $jcw0u.default)({
                    meta: {
                        id: 'fetchBoardWorkflowsV2',
                        packageName: 'jiraBusinessWorkflows',
                        teamName: 'wanjel'
                    },
                    error: errorWithResponseMessage,
                    sendToPrivacyUnsafeSplunk: true
                });
                throw errorWithResponseMessage;
            }
            (0, $jcw0u.default)({
                meta: {
                    id: 'fetchBoardWorkflowsV2',
                    packageName: 'jiraBusinessWorkflows',
                    teamName: 'wanjel'
                },
                attributes: {
                    message: 'Failed to fetch board workflows'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    }, []);
    /**
	 * Update a single workflow only
	 * The `workflow` array in the payload can only have maximum 1 length
	 */ const updateWorkflowsV2 = (0, $5uXOq.useCallback)(async ({ payload: payload, cloudId: cloudId })=>{
        try {
            const response = await (0, $7f4tk.default)(`/gateway/api/jira/project-configuration/command/${cloudId}/3/workflow/update`, {
                method: 'POST',
                body: JSON.stringify(payload)
            });
            return response;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            const jsonErrorResponse = error.originalResponse ? await error.originalResponse.json().catch($140c546f51be918f$var$noop) : undefined;
            if (jsonErrorResponse) {
                if (error.statusCode === 400 && jsonErrorResponse.errors?.[0].message) throw new (0, $64pOt.TranslatedValidationError)(jsonErrorResponse.errors[0].message);
                const errorMessage = `Update workflow fail status code: ${error.statusCode}; response: ${JSON.stringify(jsonErrorResponse)}`;
                const errorWithResponseMessage = new (0, $jJZqs.default)(error.statusCode, errorMessage, error.traceId);
                (0, $jcw0u.default)({
                    meta: {
                        id: 'updateBoardWorkflowsV2',
                        packageName: 'jiraBusinessWorkflows',
                        teamName: 'wanjel'
                    },
                    error: errorWithResponseMessage,
                    sendToPrivacyUnsafeSplunk: true
                });
                throw errorWithResponseMessage;
            }
            (0, $jcw0u.default)({
                meta: {
                    id: 'updateBoardWorkflowsV2',
                    packageName: 'jiraBusinessWorkflows',
                    teamName: 'wanjel'
                },
                attributes: {
                    message: 'Failed to update board workflows'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    }, []);
    /**
	 * Validates the update payload and calls update workflow if there are no validation errors
	 * The `workflow` array in the payload can only have maximum 1 length
	 */ const validateAndUpdateWorkflowsV2 = (0, $5uXOq.useCallback)(async ({ payload: payload, cloudId: cloudId })=>{
        // validate payload
        let validationResponse;
        try {
            validationResponse = await (0, $7f4tk.default)(`/gateway/api/jira/project-configuration/command/${cloudId}/2/workflow/update/validation`, {
                method: 'POST',
                body: JSON.stringify(payload)
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            const jsonErrorResponse = error.originalResponse ? await error.originalResponse.json().catch($140c546f51be918f$var$noop) : undefined;
            if (jsonErrorResponse) {
                const errorMessage = `Validate workflow fail status code: ${error.statusCode}; response: ${JSON.stringify(jsonErrorResponse)}`;
                const errorWithResponseMessage = new (0, $jJZqs.default)(error.statusCode, errorMessage, error.traceId);
                (0, $jcw0u.default)({
                    meta: {
                        id: 'validateUpdateBoardWorkflowsV2',
                        packageName: 'jiraBusinessWorkflows',
                        teamName: 'wanjel'
                    },
                    error: errorWithResponseMessage,
                    sendToPrivacyUnsafeSplunk: true
                });
                throw errorWithResponseMessage;
            }
            (0, $jcw0u.default)({
                meta: {
                    id: 'validateUpdateBoardWorkflowsV2',
                    packageName: 'jiraBusinessWorkflows',
                    teamName: 'wanjel'
                },
                attributes: {
                    message: 'Failed to validate payload for update workflows'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
        if (validationResponse.errors.length > 0) {
            validationResponse.errors.forEach((e)=>{
                if (e.code === (0, $03da6b4adba8d655$export$fca543997a327d4c)) {
                    (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'workflowValidation failed', {
                        message: e.message,
                        code: e.code
                    });
                    throw new (0, $64pOt.StatusNameIsNotUniqueError)();
                }
                if (e.code === (0, $03da6b4adba8d655$export$cc9aaebfeb8efe99)) {
                    (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'workflowValidation failed', {
                        message: e.message,
                        code: e.code
                    });
                    throw new (0, $64pOt.StatusHasNoIncomingTransitionError)();
                }
                if (e.code === (0, $03da6b4adba8d655$export$cd6873a2b9593ebe)) throw new (0, $64pOt.OldStatusMissingInWorkflowError)();
                if (e.code === (0, $03da6b4adba8d655$export$8f656a1a73ea2b22)) throw new (0, $64pOt.NewStatusMissingInWorkflowError)();
                if (e.code === (0, $03da6b4adba8d655$export$a9ac4cce67a0398e)) throw new (0, $64pOt.OnlyOneInitialTransitionAllowedError)();
                if (e.code === (0, $03da6b4adba8d655$export$7e934b410e3f0768)) throw new (0, $64pOt.ApprovalRuleMisconfiguredError)();
                if (e.code === (0, $03da6b4adba8d655$export$3bf8ed0d6cdbf43d)) throw new (0, $64pOt.WorkflowVersionConflictError)();
            });
            const errorMsgs = validationResponse.errors.map((e)=>e.message).join(', ');
            const errorCodes = validationResponse.errors.map((e)=>e.code).join(', ');
            const errorMessage = `Validation error(s) in update workflows payload - ${errorMsgs}`;
            const error = Error(errorMessage);
            (0, $jcw0u.default)({
                meta: {
                    id: 'validateUpdateBoardWorkflowsV2',
                    packageName: 'jiraBusinessWorkflows',
                    teamName: 'wanjel'
                },
                attributes: {
                    message: errorMessage,
                    totalErrors: validationResponse.errors.length,
                    code: errorCodes
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
        // update workflow
        return updateWorkflowsV2({
            payload: payload.payload,
            cloudId: cloudId
        });
    }, [
        updateWorkflowsV2,
        createAnalyticsEvent
    ]);
    const createWorkflowStatusV2 = (0, $5uXOq.useCallback)(async ({ statusName: statusName, statusCategory: statusCategory, cloudId: cloudId, projectId: projectId, issueTypes: issueTypes, onSuccess: onSuccess })=>{
        const workflowsData = await fetchWorkflowsV2({
            cloudId: cloudId,
            projectAndIssueTypes: issueTypes.map((it)=>({
                    projectId: projectId,
                    issueTypeId: it.id
                }))
        });
        if (workflowsData) {
            const subtaskIssueTypeId = issueTypes.find((issueType)=>issueType.hierarchyLevel === -1)?.id;
            // Remove workflows associated with one subtask issue type only
            const { statuses: statuses, workflows: boardWorkflows } = (0, $eAapG.removeWorkflowAssociatedWithSubtaskOnly)(workflowsData, subtaskIssueTypeId);
            const workflow = boardWorkflows[0];
            const transitionId = (0, $eAapG.getUniqueTransitionId)(workflow.transitions);
            // validate if the new transition name is unique
            const isTransitionNameExists = workflow.transitions.some((t)=>t.name.toUpperCase() === statusName.toUpperCase());
            const newTransitionName = isTransitionNameExists ? `${statusName} ${transitionId}` : statusName;
            const statusReference = (0, $7Jxgt.v4)();
            const newStatus = {
                statusReference: statusReference,
                name: statusName,
                statusCategory: statusCategory ?? (0, $gULOk.IN_PROGRESS),
                description: ''
            };
            const newStatusInWorkflow = {
                statusReference: statusReference,
                properties: {},
                deprecated: false
            };
            const transitionData = {
                links: [],
                toStatusReference: statusReference
            };
            const newTransitionInWorkflow = {
                id: transitionId,
                type: 'GLOBAL',
                name: newTransitionName,
                description: '',
                actions: [],
                validators: [],
                triggers: [],
                properties: {},
                ...transitionData
            };
            // append newly created status and transition into workflow data
            workflow.statuses = [
                ...workflow.statuses,
                newStatusInWorkflow
            ];
            workflow.transitions = [
                ...workflow.transitions,
                newTransitionInWorkflow
            ];
            await validateAndUpdateWorkflowsV2({
                cloudId: cloudId,
                payload: {
                    payload: {
                        statuses: [
                            ...(0, $eAapG.mapStatusesToStatusUpdateObjects)(statuses),
                            newStatus
                        ],
                        workflows: [
                            (0, $eAapG.mapWorkflowToWorkflowUpdateObject)(workflow)
                        ]
                    },
                    validationOptions: {
                        levels: [
                            'ERROR'
                        ]
                    }
                }
            });
            onSuccess();
        }
    }, [
        fetchWorkflowsV2,
        validateAndUpdateWorkflowsV2
    ]);
    const createWorkflowStatusforSingleWorkflow = (0, $5uXOq.useCallback)(async ({ statusName: statusName, statusCategory: statusCategory, cloudId: cloudId, projectId: projectId, issueTypeId: issueTypeId, onSuccess: onSuccess })=>{
        const workflowsData = await fetchWorkflowsV2({
            cloudId: cloudId,
            projectAndIssueTypes: [
                {
                    projectId: projectId,
                    issueTypeId: issueTypeId
                }
            ]
        });
        if (workflowsData) {
            const { statuses: statuses, workflows: workflows } = workflowsData;
            const workflow = workflows[0];
            const transitionId = (0, $eAapG.getUniqueTransitionId)(workflow.transitions);
            // validate if the new transition name is unique
            const isTransitionNameExists = workflow.transitions.some((t)=>t.name.toUpperCase() === statusName.toUpperCase());
            const newTransitionName = isTransitionNameExists ? `${statusName} ${transitionId}` : statusName;
            const statusReference = (0, $7Jxgt.v4)();
            const newStatus = {
                statusReference: statusReference,
                name: statusName,
                statusCategory: statusCategory ?? (0, $gULOk.IN_PROGRESS),
                description: ''
            };
            const newStatusInWorkflow = {
                statusReference: statusReference,
                properties: {},
                deprecated: false
            };
            const transitionData = {
                links: [],
                toStatusReference: statusReference
            };
            const newTransitionInWorkflow = {
                id: transitionId,
                type: 'GLOBAL',
                name: newTransitionName,
                description: '',
                actions: [],
                validators: [],
                triggers: [],
                properties: {},
                ...transitionData
            };
            // append newly created status and transition into workflow data
            workflow.statuses = [
                ...workflow.statuses,
                newStatusInWorkflow
            ];
            workflow.transitions = [
                ...workflow.transitions,
                newTransitionInWorkflow
            ];
            await validateAndUpdateWorkflowsV2({
                cloudId: cloudId,
                payload: {
                    payload: {
                        statuses: [
                            ...(0, $eAapG.mapStatusesToStatusUpdateObjects)(statuses),
                            newStatus
                        ],
                        workflows: [
                            (0, $eAapG.mapWorkflowToWorkflowUpdateObject)(workflow)
                        ]
                    },
                    validationOptions: {
                        levels: [
                            'ERROR'
                        ]
                    }
                }
            });
            onSuccess();
        }
    }, [
        fetchWorkflowsV2,
        validateAndUpdateWorkflowsV2
    ]);
    return {
        fetchWorkflowsV2: fetchWorkflowsV2,
        updateWorkflowsV2: updateWorkflowsV2,
        validateAndUpdateWorkflowsV2: validateAndUpdateWorkflowsV2,
        createWorkflowStatusV2: createWorkflowStatusV2,
        createWorkflowStatusforSingleWorkflow: createWorkflowStatusforSingleWorkflow
    };
};

});
const $03da6b4adba8d655$export$cc9aaebfeb8efe99 = 'NO_INBOUND_TRANSITIONS_TO_STATUS';
const $03da6b4adba8d655$export$fca543997a327d4c = 'NON_UNIQUE_STATUS_NAME';
const $03da6b4adba8d655$export$3bf8ed0d6cdbf43d = 'VERSION_CONFLICT';
const $03da6b4adba8d655$export$cd6873a2b9593ebe = 'OLD_STATUS_MISSING_IN_ORIGINAL_WORKFLOW';
const $03da6b4adba8d655$export$8f656a1a73ea2b22 = 'NEW_STATUS_IN_MAPPING_MISSING_IN_WORKFLOW';
const $03da6b4adba8d655$export$a9ac4cce67a0398e = 'ONLY_ONE_INITIAL_TRANSITION_ALLOWED';
const $03da6b4adba8d655$export$7e934b410e3f0768 = 'APPROVAL_RULE_MISCONFIGURED';

parcelRegister("64pOt", function(module, exports) {

$parcel$export(module.exports, "StatusNameIsNotUniqueError", () => $6c179fd68447a1f2$export$364f122a770d50d5);
$parcel$export(module.exports, "StatusHasNoIncomingTransitionError", () => $6c179fd68447a1f2$export$f19cc85abf8e1b56);
$parcel$export(module.exports, "WorkflowVersionConflictError", () => $6c179fd68447a1f2$export$3bcae14a5d1b7831);
$parcel$export(module.exports, "OldStatusMissingInWorkflowError", () => $6c179fd68447a1f2$export$d019204849f5b18d);
$parcel$export(module.exports, "NewStatusMissingInWorkflowError", () => $6c179fd68447a1f2$export$a2f3292b51bfe008);
$parcel$export(module.exports, "OnlyOneInitialTransitionAllowedError", () => $6c179fd68447a1f2$export$2d54d539af595c13);
$parcel$export(module.exports, "ApprovalRuleMisconfiguredError", () => $6c179fd68447a1f2$export$abac4c6dd3226df);
$parcel$export(module.exports, "TranslatedValidationError", () => $6c179fd68447a1f2$export$f9de6bcf41bd58de);
/* eslint-disable max-classes-per-file */ class $6c179fd68447a1f2$export$364f122a770d50d5 extends Error {
    constructor(){
        super('status name is not unique');
        this.name = 'StatusNameIsNotUniqueError';
    }
}
class $6c179fd68447a1f2$export$f19cc85abf8e1b56 extends Error {
    constructor(){
        super('status has no incoming transition error');
        this.name = 'StatusHasNoIncomingTransitionError';
    }
}
class $6c179fd68447a1f2$export$3bcae14a5d1b7831 extends Error {
    constructor(){
        super('Workflow version and version token must match');
        this.name = 'WorkflowVersionConflictError';
    }
}
class $6c179fd68447a1f2$export$d019204849f5b18d extends Error {
    constructor(){
        super('Old status missing in workflow');
        this.name = 'OldStatusMissingInWorkflowError';
    }
}
class $6c179fd68447a1f2$export$a2f3292b51bfe008 extends Error {
    constructor(){
        super('New status missing in workflow');
        this.name = 'NewStatusMissingInWorkflowError';
    }
}
class $6c179fd68447a1f2$export$2d54d539af595c13 extends Error {
    constructor(){
        super('Workflow must have exactly one initial transition');
        this.name = 'OnlyOneInitialTransitionAllowedError';
    }
}
class $6c179fd68447a1f2$export$abac4c6dd3226df extends Error {
    constructor(){
        super('Approval status has invalid transitions');
        this.name = 'ApprovalRuleMisconfiguredError';
    }
}
class $6c179fd68447a1f2$export$f9de6bcf41bd58de extends Error {
    constructor(message){
        super(message);
        this.name = 'Workflow update status validation error';
    }
}

});

parcelRegister("eAapG", function(module, exports) {

$parcel$export(module.exports, "mapStatusesToStatusUpdateObjects", () => $f33564c11438cc95$export$6ce728204936b996);
$parcel$export(module.exports, "mapWorkflowToWorkflowUpdateObject", () => $f33564c11438cc95$export$aab038e50114d198);
$parcel$export(module.exports, "removeWorkflowAssociatedWithSubtaskOnly", () => $f33564c11438cc95$export$404cd34180e60200);
$parcel$export(module.exports, "getUniqueTransitionId", () => $f33564c11438cc95$export$28172316ffe44a59);
const $f33564c11438cc95$export$6ce728204936b996 = (statuses)=>statuses.map((s)=>({
            id: s.id,
            name: s.name,
            description: s.description,
            statusReference: s.statusReference,
            statusCategory: s.statusCategory
        }));
const $f33564c11438cc95$export$aab038e50114d198 = (workflow)=>({
        id: workflow.id,
        version: workflow.version,
        description: workflow.description,
        statuses: workflow.statuses.map(({ deprecated: deprecated, ...status })=>status),
        transitions: workflow.transitions,
        startPointLayout: workflow.startPointLayout,
        statusMappings: workflow.statusMappings || []
    });
const $f33564c11438cc95$export$404cd34180e60200 = (workflowV2Response, subtaskIssueTypeId)=>{
    if (subtaskIssueTypeId == null) return workflowV2Response;
    const filteredWorkflows = workflowV2Response.workflows.filter((wf)=>// It checks if all workflow associations have only one issue type, and if that issue type is 'subtask'.
        // If this condition is met, it filters out the workflow.
        !wf.associatedWith.every((association)=>association.issueTypes.length === 1 && association.issueTypes[0] === subtaskIssueTypeId));
    // if no workflow specific for subtask, return original response
    if (filteredWorkflows.length === workflowV2Response.workflows.length) return workflowV2Response;
    return {
        ...workflowV2Response,
        workflows: filteredWorkflows
    };
};
const $f33564c11438cc95$export$28172316ffe44a59 = (transitions)=>{
    const largestId = Math.max(...transitions.map((t)=>parseInt(t.id, 10)));
    return String(largestId + 1);
};

});


parcelRegister("ayqGc", function(module, exports) {

$parcel$export(module.exports, "getStatusActionFailedFlag", () => $a5be4d50bda430ec$export$eb1cd60884388450);
$parcel$export(module.exports, "failStatusExperience", () => $a5be4d50bda430ec$export$d258d7669afadfa1);
$parcel$export(module.exports, "WorkflowNotFound", () => $a5be4d50bda430ec$export$eed4bea4cf8c4900);

var $64pOt = parcelRequire("64pOt");

var $jJZqs = parcelRequire("jJZqs");

var $fZneA = parcelRequire("fZneA");

var $7HGHK = parcelRequire("7HGHK");

var $bRR9U = parcelRequire("bRR9U");
const $a5be4d50bda430ec$var$GENERIC_SAVING_ERROR = 'There was an error saving the workflows';
const $a5be4d50bda430ec$var$excludedStatusCodes = new Set([
    401,
    403,
    404,
    409
]);
const $a5be4d50bda430ec$var$isFilteredNetworkError = (error)=>Boolean('statusCode' in error && error.statusCode != null && $a5be4d50bda430ec$var$excludedStatusCodes.has(error.statusCode) || error.message?.includes($a5be4d50bda430ec$var$GENERIC_SAVING_ERROR));
const $a5be4d50bda430ec$export$eb1cd60884388450 = ({ messageTitle: messageTitle, action: action, error: error, projectKey: projectKey, issueTypeId: issueTypeId, statusCode: statusCode })=>{
    const workflowEditorHref = issueTypeId != null && issueTypeId !== '' ? `/jira/core/projects/${projectKey}/settings/issuetypes/${issueTypeId}/workflow` : `/jira/core/projects/${projectKey}/settings/issuetypes`;
    const openWorkflowEditorAction = {
        content: (0, $bRR9U.default).openWorkflowEditorAction,
        href: workflowEditorHref,
        target: '_blank'
    };
    if (error instanceof (0, $64pOt.StatusNameIsNotUniqueError)) return {
        type: 'error',
        title: messageTitle,
        description: (0, $bRR9U.default).statusNameIsNotUniqueDescription,
        messageId: 'business-workflows.controllers.workflow-actions.flag.error.error.status-name-is-not-unique-error',
        messageType: 'transactional',
        actions: [
            openWorkflowEditorAction
        ],
        id: (0, $7HGHK.toFlagId)(`business-${action}-status-name-is-not-unique.flag`)
    };
    if (error instanceof (0, $64pOt.StatusHasNoIncomingTransitionError)) return {
        type: 'error',
        title: (0, $bRR9U.default).statusHasNoIncomingTransitionTitle,
        description: (0, $bRR9U.default).statusHasNoIncomingTransitionDescription,
        messageId: 'business-workflows.controllers.workflow-actions.flag.error.error.status-has-no-incoming-transition-error',
        messageType: 'transactional',
        actions: [
            openWorkflowEditorAction
        ],
        id: (0, $7HGHK.toFlagId)(`business-${action}-status-has-no-incoming-transition.flag`)
    };
    if (error instanceof (0, $64pOt.WorkflowVersionConflictError) || statusCode === 409) return {
        type: 'error',
        title: messageTitle,
        description: (0, $bRR9U.default).workflowVersionConflictDescription,
        messageId: 'business-workflows.controllers.workflow-actions.flag.error.error.workflow-version-conflict-error',
        messageType: 'transactional',
        actions: [
            {
                content: (0, $bRR9U.default).viewWorkflowEditorAction,
                href: workflowEditorHref,
                target: '_blank'
            }
        ],
        id: (0, $7HGHK.toFlagId)(`business-${action}-workflow-version-conflict.flag`)
    };
    if (error instanceof (0, $64pOt.OldStatusMissingInWorkflowError)) return {
        type: 'error',
        title: messageTitle,
        description: (0, $bRR9U.default).oldStatusMissingInWorkflowDescription,
        messageId: 'business-workflows.controllers.workflow-actions.flag.error.error.old-status-missing-in-workflow-error',
        messageType: 'transactional',
        actions: [
            openWorkflowEditorAction
        ],
        id: (0, $7HGHK.toFlagId)(`business-${action}-old-status-missing-in-workflow.flag`)
    };
    if (error instanceof (0, $64pOt.NewStatusMissingInWorkflowError)) return {
        type: 'error',
        title: messageTitle,
        description: (0, $bRR9U.default).newStatusMissingInWorkflowDescription,
        messageId: 'business-workflows.controllers.workflow-actions.flag.error.error.new-status-missing-in-workflow-error',
        messageType: 'transactional',
        actions: [
            openWorkflowEditorAction
        ],
        id: (0, $7HGHK.toFlagId)(`business-${action}-new-status-missing-in-workflow.flag`)
    };
    if (error instanceof (0, $64pOt.OnlyOneInitialTransitionAllowedError)) return {
        type: 'error',
        title: messageTitle,
        description: (0, $bRR9U.default).oneInitialTransitionAllowedWorkflowDescription,
        messageId: 'business-workflows.controllers.workflow-actions.flag.error.error.only-one-initial-transition-allowed-error',
        messageType: 'transactional',
        actions: [
            openWorkflowEditorAction
        ],
        id: (0, $7HGHK.toFlagId)(`business-${action}-only-one-initial-transition-allowed.flag`)
    };
    if (error instanceof (0, $64pOt.ApprovalRuleMisconfiguredError)) return {
        type: 'error',
        title: messageTitle,
        description: (0, $bRR9U.default).approvalRuleMisconfiguredDescription,
        messageId: 'business-workflows.controllers.workflow-actions.flag.error.error.approval-rule-misconfigured-error',
        messageType: 'transactional',
        actions: [
            openWorkflowEditorAction
        ],
        id: (0, $7HGHK.toFlagId)(`business-${action}-approval-rule-misconfigured.flag`)
    };
    if (error instanceof (0, $64pOt.TranslatedValidationError)) return {
        type: 'error',
        title: messageTitle,
        description: error.message,
        messageId: 'business-workflows.controllers.workflow-actions.flag.error.error.translated-validation-error',
        messageType: 'transactional',
        actions: [
            openWorkflowEditorAction
        ]
    };
    if (action === 'delete-polling') return {
        type: 'warning',
        title: messageTitle,
        description: (0, $bRR9U.default).deletePollingTimeoutDescription,
        messageId: `business-workflows.controllers.workflow-actions.warning.delete-polling.${action}`,
        messageType: 'transactional',
        actions: [
            openWorkflowEditorAction
        ],
        id: (0, $7HGHK.toFlagId)(`business-${action}-timeout.flag`)
    };
    return {
        type: 'error',
        title: messageTitle,
        description: (0, $bRR9U.default).errorFlagDescription,
        messageId: `business-workflows.controllers.workflow-actions.error.${action}`,
        messageType: 'transactional',
        actions: [
            {
                content: (0, $bRR9U.default).errorFlagActionsReload,
                onClick: ()=>{
                    typeof window !== 'undefined' && window.location.reload();
                },
                target: '_blank'
            }
        ],
        id: (0, $7HGHK.toFlagId)(`business-${action}-status.flag`)
    };
};
const $a5be4d50bda430ec$export$d258d7669afadfa1 = ({ markExperienceFailed: markExperienceFailed, abortExperience: abortExperience, ufoExperience: ufoExperience, error: error, errorMessage: errorMessage })=>{
    if (error instanceof (0, $64pOt.StatusNameIsNotUniqueError) || error instanceof (0, $64pOt.StatusHasNoIncomingTransitionError) || error instanceof (0, $64pOt.WorkflowVersionConflictError) || error instanceof (0, $64pOt.OldStatusMissingInWorkflowError) || error instanceof (0, $64pOt.NewStatusMissingInWorkflowError) || error instanceof (0, $64pOt.OnlyOneInitialTransitionAllowedError) || error instanceof (0, $64pOt.ApprovalRuleMisconfiguredError) || error instanceof (0, $64pOt.TranslatedValidationError) || (0, $fZneA.isClientFetchError)(error) || (0, $jJZqs.isValidationError)(error) || $a5be4d50bda430ec$var$isFilteredNetworkError(error)) {
        abortExperience(errorMessage);
        ufoExperience.abort({
            metadata: {
                errorMessage: errorMessage
            }
        });
        return;
    }
    markExperienceFailed(errorMessage, error);
    ufoExperience.failure({
        metadata: {
            errorMessage: errorMessage
        }
    });
};
class $a5be4d50bda430ec$export$eed4bea4cf8c4900 extends Error {
    constructor(){
        super();
        this.name = 'WorkflowNotFound';
        this.message = 'Workflow not found';
    }
}

});
parcelRegister("bRR9U", function(module, exports) {

$parcel$export(module.exports, "default", () => $d7875f6ffe76a091$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $d7875f6ffe76a091$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorFlagTitleAddStatus: {
        "id": "business-workflows.controllers.workflow-actions.error-flag-title-add-status",
        "defaultMessage": "Unable to create status"
    },
    errorFlagTitleDeleteStatus: {
        "id": "business-workflows.controllers.workflow-actions.error-flag-title-delete-status",
        "defaultMessage": "Unable to delete status"
    },
    errorFlagDescription: {
        "id": "business-workflows.controllers.workflow-actions.error-flag-description",
        "defaultMessage": "We\u2019ve run into some connection difficulties."
    },
    errorFlagActionsReload: {
        "id": "business-workflows.controllers.workflow-actions.error-flag-actions-reload",
        "defaultMessage": "Reload"
    },
    statusNameIsNotUniqueDescription: {
        "id": "business-workflows.controllers.workflow-actions.status-name-is-not-unique-description",
        "defaultMessage": "This status name has been used before. To use it again, open the workflow editor and create a status with the same name."
    },
    statusHasNoIncomingTransitionTitle: {
        "id": "business-workflows.controllers.workflow-actions.status-has-no-incoming-transition-title",
        "defaultMessage": "Action needed to delete status"
    },
    statusHasNoIncomingTransitionDescription: {
        "id": "business-workflows.controllers.workflow-actions.status-has-no-incoming-transition-description",
        "defaultMessage": "You need to remove the transitions linked to this status before you can delete it."
    },
    workflowVersionConflictDescription: {
        "id": "business-workflows.controllers.workflow-actions.workflow-version-conflict-description",
        "defaultMessage": "Other workflow updates are in progress. Check the workflow editor and make sure they are complete before making any changes."
    },
    openWorkflowEditorAction: {
        "id": "business-workflows.controllers.workflow-actions.open-workflow-editor-action",
        "defaultMessage": "Open workflow editor"
    },
    viewWorkflowEditorAction: {
        "id": "business-workflows.controllers.workflow-actions.view-workflow-editor-action",
        "defaultMessage": "View workflow editor"
    },
    deletePollingTimeoutTitle: {
        "id": "business-workflows.controllers.workflow-actions.delete-polling-timeout-title",
        "defaultMessage": "Your status is being deleted"
    },
    deletePollingTimeoutDescription: {
        "id": "business-workflows.controllers.workflow-actions.delete-polling-timeout-description",
        "defaultMessage": "Before you make other changes, check the workflow editor to make sure your status has been deleted."
    },
    oldStatusMissingInWorkflowDescription: {
        "id": "business-workflows.controllers.workflow-actions.old-status-missing-in-workflow-description",
        "defaultMessage": "The origin status is not in the current workflow. Check the workflow and try again."
    },
    newStatusMissingInWorkflowDescription: {
        "id": "business-workflows.controllers.workflow-actions.new-status-missing-in-workflow-description",
        "defaultMessage": "The target status is not in the current workflow. Check the workflow and try again."
    },
    oneInitialTransitionAllowedWorkflowDescription: {
        "id": "business-workflows.controllers.workflow-actions.one-initial-transition-allowed-workflow-description",
        "defaultMessage": "Workflow must have exactly one initial transition. Check the workflow and try again."
    },
    approvalRuleMisconfiguredDescription: {
        "id": "business-workflows.controllers.workflow-actions.approval-rule-misconfigured-description",
        "defaultMessage": "Approval status has invalid transitions. Check the workflow and try again."
    }
});

});


parcelRegister("9a7GF", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff8da4909b64255e$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $ff8da4909b64255e$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    statusAlreadyExists: {
        "id": "business-workflows.controllers.workflow-actions.rename-status.status-already-exists",
        "defaultMessage": "''{statusName}'' is already a status name in this project"
    },
    emptyStatusNameError: {
        "id": "business-workflows.controllers.workflow-actions.rename-status.empty-status-name-error",
        "defaultMessage": "Status name cannot be empty"
    },
    errorFlagTitleRenameStatus: {
        "id": "business-workflows.controllers.workflow-actions.rename-status.error-flag-title-rename-status",
        "defaultMessage": "Unable to rename status"
    }
});

});


parcelRegister("PjAGt", function(module, exports) {

$parcel$export(module.exports, "default", () => $8bcc525896e28108$export$2e2bcd8739ae039);

var $hFkcp = parcelRequire("hFkcp");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $jTnjM = parcelRequire("jTnjM");

var $iSdL3 = parcelRequire("iSdL3");
const $8bcc525896e28108$var$entryPointParams = {};
const $8bcc525896e28108$var$ColumnConfettiAsync = ({ statusFragment: statusFragment })=>{
    const status = (0, $8Uumt.useFragment)((0, $hFkcp.default), statusFragment);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $iSdL3.boardConfettiEntrypoint), $8bcc525896e28108$var$entryPointParams);
    const [animating, setAnimating] = (0, $5uXOq.useState)(false);
    const { confettiColumns: confettiColumns, removeConfettiColumn: removeConfettiColumn } = (0, $jTnjM.useConfettiColumns)();
    (0, $5uXOq.useEffect)(()=>{
        if (confettiColumns.has(status.statusId)) {
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'boardConfetti created', {
                columnType: 'done',
                columnId: status.statusId
            });
            setAnimating(true);
            removeConfettiColumn(status.statusId);
        }
    }, [
        confettiColumns,
        createAnalyticsEvent,
        status.statusId,
        status.name,
        removeConfettiColumn
    ]);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        if (animating) entryPointActions.load();
    }, [
        animating,
        entryPointActions
    ]);
    const runtimeProps = (0, $5uXOq.useMemo)(()=>({
            onConfettiComplete: ()=>setAnimating(false)
        }), [
        setAnimating
    ]);
    if (!animating) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        id: "jwm-board-confetti",
        packageName: "jiraWorkManagementBoard",
        entryPointReferenceSubject: entryPointReferenceSubject,
        fallback: null,
        runtimeProps: runtimeProps
    });
};
var $8bcc525896e28108$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($8bcc525896e28108$var$ColumnConfettiAsync);

});
parcelRegister("hFkcp", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f3499e7c5a89f44$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a7264af18e07e8c153b54228d9d052ad>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $3f3499e7c5a89f44$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ColumnConfettiAsync_status",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "name"
            },
            "action": "THROW",
            "path": "name"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "statusId"
            },
            "action": "THROW",
            "path": "statusId"
        }
    ],
    "type": "JiraStatus"
};
$3f3499e7c5a89f44$var$node.hash = "0162c2e8e5def2521eecbbf9600cf44a";
var $3f3499e7c5a89f44$export$2e2bcd8739ae039 = $3f3499e7c5a89f44$var$node;

});

parcelRegister("iSdL3", function(module, exports) {

$parcel$export(module.exports, "boardConfettiEntrypoint", () => $81ac92cc4b9523d0$export$1495ab1cfa22b397);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $81ac92cc4b9523d0$export$1495ab1cfa22b397 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("5bwQL")), {
        moduleId: "58031bc6"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("5bwQL", function(module, exports) {

let $3c67762c814ea77d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3c67762c814ea77d$var$load("9bJJt").then(()=>parcelRequire('4hKcR'));

});



parcelRegister("dp7CP", function(module, exports) {

$parcel$export(module.exports, "default", () => $0677508e7399ea58$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $ky7e4 = parcelRequire("ky7e4");

var $kgoHi = parcelRequire("kgoHi");
var $8CUq3 = parcelRequire("8CUq3");

var $3bDjY = parcelRequire("3bDjY");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $iT2AK = parcelRequire("iT2AK");
const $0677508e7399ea58$var$DoneColumnTick = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        xcss: $0677508e7399ea58$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $iT2AK.default).doneTickTooltipIssueTermRefresh : (0, $iT2AK.default).doneTickTooltip)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ky7e4))), {
        label: "",
        color: "var(--ds-icon-success, #22A06B)",
        LEGACY_size: "small"
    })));
};
var $0677508e7399ea58$export$2e2bcd8739ae039 = $0677508e7399ea58$var$DoneColumnTick;
const $0677508e7399ea58$var$containerStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 1
});

});
parcelRegister("ky7e4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4eca488eebd24f6b0c74ed2566069d9c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ef5c96854bbf6178$var$_react = $ef5c96854bbf6178$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $ef5c96854bbf6178$var$_checkMark = $ef5c96854bbf6178$var$_interopRequireDefault((parcelRequire("bjo8S")));

var $ef5c96854bbf6178$var$_check = $ef5c96854bbf6178$var$_interopRequireDefault((parcelRequire("kbxJz")));
function $ef5c96854bbf6178$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CheckMarkIcon.
 * This component is CheckMarkIcon, with `UNSAFE_fallbackIcon` set to "CheckIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ef5c96854bbf6178$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $ef5c96854bbf6178$var$_react.default.createElement($ef5c96854bbf6178$var$_checkMark.default, Object.assign({
        LEGACY_fallbackIcon: $ef5c96854bbf6178$var$_check.default
    }, props));
$ef5c96854bbf6178$var$CheckMarkIcon.Name = 'CheckMarkIconMigration';
var $ef5c96854bbf6178$var$_default = module.exports.default = $ef5c96854bbf6178$var$CheckMarkIcon;

});
parcelRegister("bjo8S", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a3e71f4112aeb66b16fbd284cc49bbc6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $83c43234bc70a485$var$_react = $83c43234bc70a485$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $83c43234bc70a485$var$_baseNew = $83c43234bc70a485$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $83c43234bc70a485$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckMark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $83c43234bc70a485$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $83c43234bc70a485$var$_react.default.createElement($83c43234bc70a485$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m15.076 3.23-8.75 10.5a.75.75 0 0 1-1.159-.008l-4.25-5.25 1.166-.944 3.675 4.54 8.166-9.798z" clip-rule="evenodd"/>`
    }, props));
$83c43234bc70a485$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
var $83c43234bc70a485$var$_default = module.exports.default = $83c43234bc70a485$var$CheckMarkIcon;

});

parcelRegister("kbxJz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eb1f0098e5a023eb$var$_react = $eb1f0098e5a023eb$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $eb1f0098e5a023eb$var$_checkMark = $eb1f0098e5a023eb$var$_interopRequireDefault((parcelRequire("bjo8S")));
function $eb1f0098e5a023eb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $eb1f0098e5a023eb$var$CheckIcon = (props)=>/*#__PURE__*/ $eb1f0098e5a023eb$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M6.735 12.322a1 1 0 0 0-1.47 1.356l3.612 3.919c.537.526 1.337.526 1.834.03l.364-.359a2336 2336 0 0 0 3.939-3.883l.04-.04a493 493 0 0 0 3.658-3.643 1 1 0 0 0-1.424-1.404 518 518 0 0 1-3.64 3.625l-.04.04a2049 2049 0 0 1-3.775 3.722z"/></svg>`
    }, props, {
        newIcon: $eb1f0098e5a023eb$var$_checkMark.default
    }));
$eb1f0098e5a023eb$var$CheckIcon.displayName = 'CheckIcon';
var $eb1f0098e5a023eb$var$_default = module.exports.default = $eb1f0098e5a023eb$var$CheckIcon;

});


parcelRegister("iT2AK", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b918393ee1c813f$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $9b918393ee1c813f$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    doneTickTooltip: {
        "id": "work-management-board.ui.board.column.column-header.header-content.done-column-tick.done-column-tick.done-tick-tooltip",
        "defaultMessage": "Issues moved to this column are marked as done"
    },
    doneTickTooltipIssueTermRefresh: {
        "id": "work-management-board.board.column.column-header.header-content.done-column-tick.done-tick-tooltip-issue-term-refresh",
        "defaultMessage": "Anything moved to this column is marked as done"
    }
});

});


parcelRegister("3w5Ly", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f502a8ae6938874$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $dD7Zc = parcelRequire("dD7Zc");

var $bopR4 = parcelRequire("bopR4");

var $kY99m = parcelRequire("kY99m");

var $4R6GH = parcelRequire("4R6GH");


var $b71gk = parcelRequire("b71gk");

var $eHJxW = parcelRequire("eHJxW");

var $koVbs = parcelRequire("koVbs");

var $13rEN = parcelRequire("13rEN");
const $2f502a8ae6938874$var$ERROR_MESSAGE_ID = 'column-name-error-dialog';
const $2f502a8ae6938874$var$EditableColumnHeader = ({ defaultValue: defaultValue, isEditing: isEditing, onCancel: onCancel, onConfirm: onConfirm, onEdit: onEdit, onValidate: onValidate, readView: readView })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const isReadyRef = (0, $5uXOq.useRef)(false);
    const renameTextFieldRef = (0, $5uXOq.useRef)(null); // sets component to be ready after 10 ms and
    // focus on Textfield when editing
    (0, $5uXOq.useEffect)(()=>{
        if (isEditing) setTimeout(()=>{
            isReadyRef.current = true;
            renameTextFieldRef.current?.focus();
        }, 10);
        else isReadyRef.current = false;
    }, [
        isEditing
    ]);
    const handleConfirm = (0, $5uXOq.useCallback)((value)=>{
        if (isReadyRef.current) onConfirm(value);
    }, [
        onConfirm
    ]);
    const columnNameButtonLabel = formatMessage((0, $13rEN.default).columnNameButtonLabel, {
        statusName: defaultValue
    });
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bopR4.default), {
        readViewFitContainerWidth: true,
        defaultValue: defaultValue,
        isEditing: isEditing,
        readView: readView,
        editView: ({ errorMessage: errorMessage, ...fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eHJxW.JiraInlineDialog), {
                isOpen: fieldProps.isInvalid,
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
                    id: $2f502a8ae6938874$var$ERROR_MESSAGE_ID,
                    role: "alert",
                    "aria-live": "assertive"
                }, errorMessage),
                placement: "bottom",
                messageId: "work-management-board.ui.board.column.column-header.header-content.editable-column-header.inline-dialog",
                messageType: "transactional"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kY99m.default), {
                ...fieldProps,
                ref: renameTextFieldRef,
                elemAfterInput: fieldProps.isInvalid && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dD7Zc))), {
                    spacing: "spacious",
                    label: "error",
                    color: "var(--ds-icon-warning, #E56910)"
                }),
                onBlur: ()=>{
                    if (fieldProps.isInvalid) onCancel();
                },
                maxLength: (0, $8acbf7056aed1170$export$35f245e1b98b8614),
                autoComplete: "off",
                "aria-errormessage": $2f502a8ae6938874$var$ERROR_MESSAGE_ID,
                "aria-label": columnNameButtonLabel
            })),
        onEdit: onEdit,
        onCancel: onCancel,
        onConfirm: handleConfirm,
        validate: onValidate,
        editButtonLabel: columnNameButtonLabel
    });
    if ((0, $4R6GH.fg)('update-column-header-design')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_1bsb1osq _1ul9idpf"
        ])
    }, content);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2f502a8ae6938874$var$Wrapper, null, content);
};
const $2f502a8ae6938874$var$EditableColumnHeaderWithErrorBoundary = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "async.jira-business.board.editable-column-header",
        packageName: "jiraWorkManagementBoard"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2f502a8ae6938874$var$EditableColumnHeader, props));
const $2f502a8ae6938874$var$wrapperStyles = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2f502a8ae6938874$var$Wrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1ul9idpf _18u01i6y _2hwx1i6y",
            __cmplp.className
        ])
    });
});
var $2f502a8ae6938874$export$2e2bcd8739ae039 = $2f502a8ae6938874$var$EditableColumnHeaderWithErrorBoundary;

});
parcelRegister("bopR4", function(module, exports) {

$parcel$export(module.exports, "default", () => $9fb3572edb783a8f$export$2e2bcd8739ae039);
/* inline-edit.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $6QvkM = parcelRequire("6QvkM");

var $7O4UO = parcelRequire("7O4UO");

var $efXp3 = parcelRequire("efXp3");

var $VSDnB = parcelRequire("VSDnB");

var $3Lty3 = parcelRequire("3Lty3");

var $jldZL = parcelRequire("jldZL");

var $1PDuf = parcelRequire("1PDuf");

var $pZGLJ = parcelRequire("pZGLJ");

var $6LLMl = parcelRequire("6LLMl");
const $9fb3572edb783a8f$var$fieldStyles = null;
const $9fb3572edb783a8f$var$analyticsAttributes = {
    componentName: 'inlineEdit',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $9fb3572edb783a8f$var$InnerInlineEdit = (props)=>{
    const { startWithEditViewOpen: startWithEditViewOpen = false, keepEditViewOpenOnBlur: keepEditViewOpenOnBlur = false, hideActionButtons: hideActionButtons = false, isRequired: isRequired = false, readViewFitContainerWidth: readViewFitContainerWidth = false, editButtonLabel: editButtonLabel = 'Edit', editLabel: editLabel = 'edit', confirmButtonLabel: confirmButtonLabel = 'Confirm', cancelButtonLabel: cancelButtonLabel = 'Cancel', defaultValue: defaultValue, isEditing: isEditing, label: label, validate: validate, readView: readView, editView: editView, analyticsContext: analyticsContext, onConfirm: providedOnConfirm, onCancel: providedOnCancel, onEdit: providedOnEdit, testId: testId } = props;
    const wasFocusReceivedSinceLastBlurRef = (0, $5uXOq.useRef)(false);
    const isControlled = typeof isEditing === 'undefined';
    const [isEditingState, setEditingState] = (0, $5uXOq.useState)(startWithEditViewOpen);
    const timerRef = (0, $5uXOq.useRef)();
    const { editButtonRef: editButtonRef, editViewRef: editViewRef, shouldBeEditing: shouldBeEditing, doNotFocusOnEditButton: doNotFocusOnEditButton } = (0, $pZGLJ.default)(isEditing, isEditingState);
    const onCancel = (0, $5uXOq.useCallback)(()=>{
        if (isControlled) setEditingState(false);
        providedOnCancel?.();
    }, [
        isControlled,
        providedOnCancel
    ]);
    const onEditRequested = (0, $5uXOq.useCallback)(()=>{
        if (isControlled) setEditingState(true);
        providedOnEdit?.();
        if (shouldBeEditing && editViewRef.current) editViewRef.current.focus();
    }, [
        isControlled,
        shouldBeEditing,
        editViewRef,
        providedOnEdit
    ]);
    const onConfirm = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: (value, analyticsEvent)=>{
            if (isControlled) setEditingState(false);
            providedOnConfirm(value, analyticsEvent);
        },
        action: 'confirmed',
        analyticsData: analyticsContext,
        ...$9fb3572edb783a8f$var$analyticsAttributes
    });
    const onCancelClick = (0, $5uXOq.useCallback)((event)=>{
        event.preventDefault();
        onCancel();
    }, [
        onCancel
    ]);
    const tryAutoSubmitWhenBlur = (0, $5uXOq.useCallback)((isFieldInvalid, onSubmit, formRef)=>{
        if (!isFieldInvalid && !wasFocusReceivedSinceLastBlurRef.current && formRef.current) {
            doNotFocusOnEditButton();
            if (formRef.current.checkValidity()) onSubmit();
        }
    }, [
        doNotFocusOnEditButton
    ]); /**
                                 * If keepEditViewOpenOnBlur prop is set to false, will call confirmIfUnfocused() which
                                 *  confirms the value, if the focus is not transferred to the action buttons.
                                 *
                                 *  When you're in `editing` state, the focus will be on the input field. And if you use keyboard
                                 *  to navigate to `submit` button, this function will be invoked. Then function `onEditViewWrapperFocus`
                                 *  will be called, the timeout used here is making sure `onEditViewWrapperFocus` is always called before
                                 *  `autoSubmitWhenBlur`.
                                 *
                                 *  There are two paths here the function can be triggered:
                                 *
                                 *  - focus on input first, and then use keyboard to `submit`
                                 *  - focus on input first, and then click anywhere else on the page (outside of edit view wrapper) to `submit` (auto save).
                                 */ 
    const onEditViewWrapperBlur = (0, $5uXOq.useCallback)((isFieldInvalid, onSubmit, formRef)=>{
        if (!keepEditViewOpenOnBlur) {
            wasFocusReceivedSinceLastBlurRef.current = false;
            timerRef.current = setTimeout(()=>tryAutoSubmitWhenBlur(isFieldInvalid, onSubmit, formRef), 0);
        }
    }, [
        keepEditViewOpenOnBlur,
        tryAutoSubmitWhenBlur
    ]); /**
                                                        * Gets called when focus is transferred to the editView, or action buttons.
                                                        *
                                                        * There are three paths here the function can be called:
                                                        *
                                                        * - when a user click the `editView`
                                                        * - when a user use keyboard to tab into `editView`
                                                        * - when a user use keyboard to tab into `submit` when they were on input field.
                                                        */ 
    const onEditViewWrapperFocus = (0, $5uXOq.useCallback)(()=>{
        wasFocusReceivedSinceLastBlurRef.current = true;
    }, []);
    const concatenatedEditButtonLabel = ()=>{
        if (label) return `${editButtonLabel}, ${label}, ${editLabel}`;
        return `${editButtonLabel}, ${editLabel}`;
    };
    const renderReadView = ()=>{
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6LLMl.default), {
            editButtonLabel: concatenatedEditButtonLabel(),
            onEditRequested: onEditRequested,
            postReadViewClick: doNotFocusOnEditButton,
            editButtonRef: editButtonRef,
            readViewFitContainerWidth: readViewFitContainerWidth,
            readView: readView,
            testId: testId
        });
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $efXp3.default), {
        onSubmit: (data)=>onConfirm(data.inlineEdit),
        children: ({ formProps: { onKeyDown: onKeyDown, onSubmit: onSubmit, ref: formRef }, reset: reset })=>/*#__PURE__*/ (0, $2OMIu.jsx)("form", {
                /**
                 * It is not normally acceptable to add key handlers to non-interactive elements
                 * as this is an accessibility anti-pattern. However, because this instance is
                 * to add support for keyboard functionality instead of creating an inaccessible
                 * custom element, we can add role="presentation" so that there is no negative
                 * impacts to assistive technologies.
                 */ role: "presentation",
                onKeyDown: (e)=>{
                    onKeyDown(e);
                    if (e.key === 'Esc' || e.key === 'Escape') {
                        reset();
                        onCancel();
                    }
                },
                onSubmit: onSubmit,
                ref: formRef,
                // This is because due to some default focus being applied to the form element, the inline edit component
                // was being focused automatically and causing scroll issues in issue view
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                className: (0, $VSDnB.fg)('platform_design_system_inline_edit_dont_focus') ? 'dont-default-focus' : undefined,
                children: shouldBeEditing ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7O4UO.default), {
                    name: "inlineEdit",
                    label: label,
                    defaultValue: defaultValue,
                    validate: validate,
                    isRequired: isRequired,
                    children: ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
                            onBlur: (e)=>{
                                if (!e.currentTarget.contains(e.relatedTarget)) onEditViewWrapperBlur(fieldProps.isInvalid, onSubmit, formRef);
                            },
                            onFocus: onEditViewWrapperFocus,
                            className: (0, $bwpsq.default)([
                                "_p12f1osq _kqswh2mm"
                            ]),
                            children: [
                                editView({
                                    ...fieldProps,
                                    errorMessage: error
                                }, editViewRef),
                                !hideActionButtons ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1PDuf.default), {
                                    testId: testId,
                                    cancelButtonLabel: cancelButtonLabel,
                                    confirmButtonLabel: confirmButtonLabel,
                                    onMouseDown: ()=>{
                                        /**
             * Prevents focus on edit button only if mouse is used to click button, but not when keyboard is used
             */ doNotFocusOnEditButton();
                                    },
                                    onCancelClick: (e)=>{
                                        reset();
                                        onCancelClick(e);
                                    }
                                }) : /**
           * This is to allow Ctrl + Enter to submit without action buttons
           */ /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Lty3.default), {
                                    hidden: true,
                                    type: "submit",
                                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jldZL.default), {
                                        children: "Submit"
                                    })
                                })
                            ]
                        })
                }, "edit-view" // used for reset to default value
                ) : /**
       * Field is used here only for the label and spacing
       */ /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7O4UO.default), {
                    name: "inlineEdit",
                    label: label,
                    defaultValue: "",
                    isRequired: isRequired,
                    children: renderReadView
                }, "read-view" // used for reset to default value
                )
            })
    });
};
const $9fb3572edb783a8f$var$InlineEdit = (props)=>{
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, $2OMIu.jsx)($9fb3572edb783a8f$var$InnerInlineEdit, {
        ...props
    });
}; // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $9fb3572edb783a8f$export$2e2bcd8739ae039 = $9fb3572edb783a8f$var$InlineEdit;

});
parcelRegister("1PDuf", function(module, exports) {

$parcel$export(module.exports, "default", () => $55d92d54fb10d87e$export$2e2bcd8739ae039);
/* buttons.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/no-nested-styles */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $42CjB = parcelRequire("42CjB");

var $lLLkM = parcelRequire("lLLkM");

var $bjGSs = parcelRequire("bjGSs");

var $hl2pN = parcelRequire("hl2pN");
const $55d92d54fb10d87e$var$buttonsContainerStyles = null;
const $55d92d54fb10d87e$var$buttonWrapperBaseStyles = null;
const $55d92d54fb10d87e$var$Buttons = ({ confirmButtonLabel: confirmButtonLabel, cancelButtonLabel: cancelButtonLabel, onMouseDown: onMouseDown, onCancelClick: onCancelClick, testId: testId })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        className: (0, $bwpsq.default)([
            "_1e0c1txw _kqswstnw _1o9zidpf _152t1osq _rjxpidpf _1pfh12x7"
        ]),
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                tabIndex: -1,
                className: (0, $bwpsq.default)([
                    "_2rko1sit _11c82smr _vchhusvi _1bsbxy5q _1pby1kze _bfhk1bhr _16qs1mxi _1mpy1b66 _1nlxe0lp _l2uv1d38 _7mfv1dzg _szlb1x4z"
                ]),
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $42CjB.default), {
                    type: "submit",
                    icon: (iconProps)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hl2pN))), {
                            ...iconProps,
                            LEGACY_size: "small"
                        }),
                    onMouseDown: onMouseDown,
                    label: confirmButtonLabel,
                    testId: testId && `${testId}--confirm`
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                tabIndex: -1,
                className: (0, $bwpsq.default)([
                    "_2rko1sit _11c82smr _vchhusvi _1bsbxy5q _1pby1kze _bfhk1bhr _16qs1mxi _1mpy1b66 _1nlxe0lp _l2uv1d38 _7mfv1dzg _szlb1x4z"
                ]),
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $42CjB.default), {
                    icon: (iconProps)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bjGSs))), {
                            ...iconProps,
                            LEGACY_size: "small",
                            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($lLLkM)))
                        }),
                    label: cancelButtonLabel,
                    onClick: onCancelClick,
                    onMouseDown: onMouseDown,
                    testId: testId && `${testId}--cancel`
                })
            })
        ]
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$55d92d54fb10d87e$export$2e2bcd8739ae039 = $55d92d54fb10d87e$var$Buttons;

});
parcelRegister("hl2pN", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9db35ecad695c835ed46bfa4bbde0dff>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c9f6456416d52b22$var$_react = $c9f6456416d52b22$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c9f6456416d52b22$var$_checkMark = $c9f6456416d52b22$var$_interopRequireDefault((parcelRequire("f22iM")));

var $c9f6456416d52b22$var$_check = $c9f6456416d52b22$var$_interopRequireDefault((parcelRequire("kbxJz")));
function $c9f6456416d52b22$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CheckMarkIcon.
 * This component is CheckMarkIcon, with `UNSAFE_fallbackIcon` set to "CheckIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: 📦 @atlaskit/icon/utility/check-mark
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c9f6456416d52b22$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $c9f6456416d52b22$var$_react.default.createElement($c9f6456416d52b22$var$_checkMark.default, Object.assign({
        LEGACY_fallbackIcon: $c9f6456416d52b22$var$_check.default
    }, props));
$c9f6456416d52b22$var$CheckMarkIcon.Name = 'CheckMarkIconMigration';
var $c9f6456416d52b22$var$_default = module.exports.default = $c9f6456416d52b22$var$CheckMarkIcon;

});


parcelRegister("pZGLJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5aa752dd00081f6$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $d5aa752dd00081f6$var$usePrevious = (value)=>{
    const ref = (0, $5uXOq.useRef)();
    (0, $5uXOq.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
};
const $d5aa752dd00081f6$var$useButtonFocusHook = (isEditing, isEditingState)=>{
    const editButtonRef = (0, $5uXOq.useRef)(null);
    const editViewRef = (0, $5uXOq.useRef)();
    const preventFocusOnEditButtonRef = (0, $5uXOq.useRef)(false);
    const isControlled = typeof isEditing === 'undefined';
    const shouldBeEditing = isControlled ? isEditingState : isEditing;
    const prevIsEditing = $d5aa752dd00081f6$var$usePrevious(shouldBeEditing);
    (0, $5uXOq.useEffect)(()=>{
        if (isEditingState && editViewRef.current) editViewRef.current.focus();
    }, [
        editViewRef,
        isEditingState
    ]);
    (0, $5uXOq.useEffect)(()=>{
        /**
		 * This logic puts the focus on the edit button after confirming using
		 * the confirm button or using the keyboard to confirm, but not when
		 * it is confirmed by wrapper blur
		 */ if (prevIsEditing && !shouldBeEditing) {
            if (preventFocusOnEditButtonRef && preventFocusOnEditButtonRef.current) preventFocusOnEditButtonRef.current = false;
            else if (editButtonRef && editButtonRef.current) // @ts-ignore
            editButtonRef.current.focus();
        }
    }, [
        prevIsEditing,
        shouldBeEditing
    ]);
    const doNotFocusOnEditButton = ()=>preventFocusOnEditButtonRef.current = true;
    return {
        editButtonRef: editButtonRef,
        editViewRef: editViewRef,
        shouldBeEditing: shouldBeEditing,
        doNotFocusOnEditButton: doNotFocusOnEditButton
    };
};
var $d5aa752dd00081f6$export$2e2bcd8739ae039 = $d5aa752dd00081f6$var$useButtonFocusHook;

});

parcelRegister("6LLMl", function(module, exports) {

$parcel$export(module.exports, "default", () => $1ba9adf9a6463766$export$2e2bcd8739ae039);
/* read-view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $3Lty3 = parcelRequire("3Lty3");
const $1ba9adf9a6463766$var$readViewContainerStyles = null;
const $1ba9adf9a6463766$var$editButtonStyles = {
    root: "_12ji1r31 _1qu2glyw _12y3idpf _189e1grb _1dqoglyw _1h6d3acm _1e0c1ule _19pkze3t _2hwxze3t _otyrze3t _18u0ze3t _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _r06hglyw _bfhk18uv _vwz4kb7n _1xp41p6i _14ly1bk5 _1j8znqa1 _mizu1r31 _ra3xglyw _128midpf"
};
const $1ba9adf9a6463766$var$readViewWrapperStyles = null;
const $1ba9adf9a6463766$var$readViewFitContainerWidthStyles = null;
const $1ba9adf9a6463766$var$DRAG_THRESHOLD = 5;
const $1ba9adf9a6463766$var$ReadView = ({ editButtonLabel: editButtonLabel, onEditRequested: onEditRequested, postReadViewClick: postReadViewClick, editButtonRef: editButtonRef, readViewFitContainerWidth: readViewFitContainerWidth, readView: readView, testId: testId })=>{
    const startX = (0, $5uXOq.useRef)(0);
    const startY = (0, $5uXOq.useRef)(0);
    const mouseHasMovedAfterMouseDown = (event)=>{
        return Math.abs(startX.current - event.clientX) >= $1ba9adf9a6463766$var$DRAG_THRESHOLD || Math.abs(startY.current - event.clientY) >= $1ba9adf9a6463766$var$DRAG_THRESHOLD;
    };
    const onReadViewClick = (event)=>{
        const element = event.target;
        /**
     * If a link is clicked in the read view, default action should be taken
     */ if (element.tagName.toLowerCase() !== 'a' && !mouseHasMovedAfterMouseDown(event)) {
            event.preventDefault();
            onEditRequested();
            postReadViewClick();
        }
    };
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        className: (0, $bwpsq.default)([
            "_vwz4kb7n"
        ]),
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Lty3.default), {
                xcss: $1ba9adf9a6463766$var$editButtonStyles.root,
                onClick: onEditRequested,
                ref: editButtonRef,
                testId: testId && `${testId}--edit-button`,
                "aria-label": editButtonLabel
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                /**
     * It is not normally acceptable to add click handlers to non-interactive elements
     * as this is an accessibility anti-pattern. However, because this instance is
     * account for clicking on links that may be embedded within inline-edit and not
     * creating an inaccessible custom element, we can add role="presentation" so that
     * there is no negative impacts to assistive technologies.
     * (Why links are embeeded in inline-edit is for another day...)
     */ role: "presentation",
                onClick: onReadViewClick,
                onMouseDown: (e)=>{
                    startX.current = e.clientX;
                    startY.current = e.clientY;
                },
                "data-read-view-fit-container-width": readViewFitContainerWidth,
                className: (0, $bwpsq.default)([
                    "_2rko1sit _v564thzt _1h6d3acm _1dqonqa1 _189e1bk5 _1e0c1o8l _vchhusvi _1bsb1wug _p12f1osq _irr314ae",
                    readViewFitContainerWidth && "_1bsb1osq"
                ]),
                children: readView()
            })
        ]
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$1ba9adf9a6463766$export$2e2bcd8739ae039 = $1ba9adf9a6463766$var$ReadView;

});


const $8acbf7056aed1170$export$35f245e1b98b8614 = 30;
const $8acbf7056aed1170$export$9301910120a61d41 = 42;

parcelRegister("eHJxW", function(module, exports) {

$parcel$export(module.exports, "JiraInlineDialog", () => $51c10262cffee11f$export$7ab52478615504b3);

var $5uXOq = parcelRequire("5uXOq");

var $ctg8C = parcelRequire("ctg8C");

var $10xFf = parcelRequire("10xFf");

var $c0dQj = parcelRequire("c0dQj");

var $5uVz7 = parcelRequire("5uVz7");
const $51c10262cffee11f$export$7ab52478615504b3 = (props)=>{
    if ((0, $10xFf.shouldBeChoreographed)(props)) {
        if ((0, $c0dQj.isMobileAndInViewPanelIterationExperiment)()) return null;
        const { messageType: messageType, ...rest } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5uVz7.ChoreographerInlineDialog), rest);
    }
    const { messageType: messageType, messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ctg8C.default), rest);
};

});
parcelRegister("5uVz7", function(module, exports) {

$parcel$export(module.exports, "ChoreographerInlineDialog", () => $aa901de21f3fc2ba$export$44a404f218b0e66e);

var $ctg8C = parcelRequire("ctg8C");

var $fG5AJ = parcelRequire("fG5AJ");
const $aa901de21f3fc2ba$export$44a404f218b0e66e = (0, $fG5AJ.withChoreographedToggle)((0, $ctg8C.default), 'isOpen', 'content');

});


parcelRegister("13rEN", function(module, exports) {

$parcel$export(module.exports, "default", () => $ddd623f18c01b447$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $ddd623f18c01b447$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    columnNameButtonLabel: {
        "id": "work-management-board.board.column.column-header.header-content.editable-column-header.column-name-button-label",
        "defaultMessage": "Edit {statusName} status column"
    }
});

});


parcelRegister("aIfUI", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b3f7f75f72cc7d8$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $16T6Y = parcelRequire("16T6Y");

var $dCm1o = parcelRequire("dCm1o");
const $3b3f7f75f72cc7d8$var$IssueCount = ({ isCollapsed: isCollapsed, issueCount: issueCount })=>(0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3b3f7f75f72cc7d8$var$BadgeContainer, {
        isVerticalWritingMode: isCollapsed
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $16T6Y.default), {
        appearance: "default"
    }, issueCount)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3b3f7f75f72cc7d8$var$Counter, {
        isVerticalWritingMode: isCollapsed
    }, issueCount);
var $3b3f7f75f72cc7d8$export$2e2bcd8739ae039 = $3b3f7f75f72cc7d8$var$IssueCount;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3b3f7f75f72cc7d8$var$Counter = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isVerticalWritingMode: isVerticalWritingMode, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug",
            __cmplp.isVerticalWritingMode && "_1lfclhck",
            __cmplp.className
        ])
    });
});
const $3b3f7f75f72cc7d8$var$BadgeContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isVerticalWritingMode: isVerticalWritingMode, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug",
            __cmplp.isVerticalWritingMode && "_1lfclhck",
            __cmplp.isVerticalWritingMode && "_x1m21crf",
            __cmplp.isVerticalWritingMode && "_1lg71tcg",
            __cmplp.className
        ])
    });
});

});

parcelRegister("l7SAF", function(module, exports) {

$parcel$export(module.exports, "default", () => $f74777c6e1ae8e73$export$2e2bcd8739ae039);

var $alF1Y = parcelRequire("alF1Y");

var $8gTHy = parcelRequire("8gTHy");

var $9Tcd5 = parcelRequire("9Tcd5");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $42CjB = parcelRequire("42CjB");

var $BLPHT = parcelRequire("BLPHT");
var $6B7KL = parcelRequire("6B7KL");
var $aRoVz = parcelRequire("aRoVz");

var $bJeNF = parcelRequire("bJeNF");

var $3bDjY = parcelRequire("3bDjY");

var $6ByXP = parcelRequire("6ByXP");

var $8xg9P = parcelRequire("8xg9P");

var $b71gk = parcelRequire("b71gk");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $4R6GH = parcelRequire("4R6GH");

var $4mO32 = parcelRequire("4mO32");

var $47gW9 = parcelRequire("47gW9");

var $ivDCs = parcelRequire("ivDCs");

var $bJ4fI = parcelRequire("bJ4fI");

var $TN3UH = parcelRequire("TN3UH");

var $2EbGw = parcelRequire("2EbGw");

var $jyaMY = parcelRequire("jyaMY");

var $eRL0S = parcelRequire("eRL0S");
const $f74777c6e1ae8e73$var$BoardHeaderDropdownContent = ({ projectFragment: projectFragment, viewFragment: viewFragment, statusFragment: statusFragment, hasMultipleWorkflows: hasMultipleWorkflows, isLoading: isLoading, onRenameClick: onRenameClick, columnName: columnName, onOpenChange: onOpenChange, refresh: refresh, columnIndex: columnIndex })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const isWorkflowOperationInProgress = (0, $8xg9P.useIsWorkflowOperationInProgress)();
    const project = (0, $8Uumt.useFragment)((0, $9Tcd5.default), projectFragment);
    const canAdministerProject = project.canAdministerProject.canPerform;
    const actionsDisabled = !canAdministerProject || hasMultipleWorkflows === true || isWorkflowOperationInProgress;
    const view = (0, $8Uumt.useFragment)((0, $8gTHy.default), viewFragment);
    const columnIds = view.columns.edges.map((edge)=>edge?.node?.id).filter(Boolean);
    const reorderColumns = (0, $2EbGw.useReorderColumns)(view.id);
    const moveColumn = (direction)=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'dropdownItem clicked', 'reorderColumn');
        const newIndex = direction === 'left' ? columnIndex - 1 : columnIndex + 1;
        const reorderedColumnIds = [
            ...columnIds
        ];
        const [movedColumn] = reorderedColumnIds.splice(columnIndex, 1);
        reorderedColumnIds.splice(newIndex, 0, movedColumn);
        reorderColumns(reorderedColumnIds);
    };
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $jyaMY.columnDeleteModalEntryPoint), (0, $5uXOq.useMemo)(()=>({
            viewId: view.id
        }), [
        view.id
    ]));
    const buttonTrigger = (0, $47gW9.useEntryPointButtonTrigger)(entryPointActions);
    const status = (0, $8Uumt.useFragment)((0, $alF1Y.default), statusFragment);
    const onlyOneColumnLeft = view.columns.totalCount <= 1;
    const runtimeProps = (0, $5uXOq.useMemo)(()=>({
            columnId: status.statusId,
            refresh: refresh
        }), [
        refresh,
        status.statusId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $BLPHT.default), {
        testId: "work-management-board.ui.board.column.column-header.header-dropdown.header-dropdown-menu",
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
                ...props,
                label: "",
                isLoading: isLoading,
                appearance: "subtle",
                icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bJeNF))), {
                        ...iconProps,
                        label: formatMessage((0, $eRL0S.default).columnActionsWithColumn, {
                            columnName: columnName
                        }),
                        color: "var(--ds-icon, #44546F)"
                    }),
                ref: triggerRef,
                isTooltipDisabled: false,
                tooltip: {
                    content: formatMessage((0, $eRL0S.default).moreActionsTooltip),
                    hideTooltipOnClick: true
                }
            }),
        onOpenChange: ({ isOpen: isOpen })=>{
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'jwmBoardColumnMoreButton', {
                columnMoreActionsDisabled: actionsDisabled
            });
            if (onOpenChange) onOpenChange(isOpen);
        },
        placement: "bottom-end",
        ...(0, $4R6GH.fg)('wanjel-a11y-enterprise-grade') ? {
            shouldRenderToParent: true
        } : {}
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aRoVz.default), {
        title: (0, $4R6GH.fg)('a11y-23270-board-column-drag-and-drop-accessible') ? undefined : formatMessage((0, $eRL0S.default).dropdownHeaderTitle)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        onClick: ()=>{
            onRenameClick();
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'dropdownItem clicked', 'renameColumn');
        },
        isDisabled: actionsDisabled
    }, formatMessage((0, $eRL0S.default).rename)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6ByXP.ConditionalWrapper), {
        condition: onlyOneColumnLeft,
        renderWrapper: (children)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
                content: formatMessage((0, $eRL0S.default).deleteDisabledTooltip)
            }, children)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        isDisabled: onlyOneColumnLeft || actionsDisabled,
        onClick: ()=>{
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'dropdownItem clicked', 'deleteColumn');
        },
        ref: buttonTrigger
    }, formatMessage((0, $eRL0S.default).delete)))), (0, $4R6GH.fg)('a11y-23270-board-column-drag-and-drop-accessible') && !onlyOneColumnLeft && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aRoVz.default), {
        hasSeparator: true
    }, columnIndex !== 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        onClick: ()=>moveColumn('left')
    }, formatMessage((0, $eRL0S.default).moveLeft)), columnIndex !== view.columns.totalCount - 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        onClick: ()=>moveColumn('right')
    }, formatMessage((0, $eRL0S.default).moveRight))), hasMultipleWorkflows === true && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_ca0qu2gc _u5f3utpp _n3tdu2gc _19bvutpp _p12fuuw1 _otyru2gc"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $TN3UH.OpenProjectSettingsMultipleWorkflows), {
        projectFragment: project
    })), !canAdministerProject && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_ca0qu2gc _u5f3utpp _n3tdu2gc _19bvutpp _p12fuuw1 _otyru2gc"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bJ4fI.ContactAdminToModifyBoardMessage), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ivDCs.ModalEntryPointContainer), {
        entryPointActions: entryPointActions,
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "column-delete-modal",
        packageName: "jiraWorkManagementBoard",
        runtimeProps: runtimeProps
    }));
};
const $f74777c6e1ae8e73$var$BoardHeaderDropdown = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "jira-business.board.header-dropdown",
        packageName: "jiraWorkManagementBoard"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f74777c6e1ae8e73$var$BoardHeaderDropdownContent, props));
var $f74777c6e1ae8e73$export$2e2bcd8739ae039 = $f74777c6e1ae8e73$var$BoardHeaderDropdown;
const $f74777c6e1ae8e73$var$dropdownMessageWrapperStyles = null;

});
parcelRegister("alF1Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $471062d16f4b1b27$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a34ed674e96e06d60703da5eca52461b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $471062d16f4b1b27$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "BoardHeaderDropdown_status",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "statusId"
            },
            "action": "THROW",
            "path": "statusId"
        }
    ],
    "type": "JiraStatus"
};
$471062d16f4b1b27$var$node.hash = "c6a4e6e11da61aa0631a5871bcf43d56";
var $471062d16f4b1b27$export$2e2bcd8739ae039 = $471062d16f4b1b27$var$node;

});

parcelRegister("8gTHy", function(module, exports) {

$parcel$export(module.exports, "default", () => $2985b90d6bba645c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<809280a4e7d768cc2a2d183141e6d8da>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $2985b90d6bba645c$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "BoardHeaderDropdown_view",
        "selections": [
            {
                "kind": "RequiredField",
                "field": v0 /*: any*/ ,
                "action": "THROW",
                "path": "id"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraBoardViewColumnConnection",
                    "kind": "LinkedField",
                    "name": "columns",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "kind": "ScalarField",
                                "name": "totalCount"
                            },
                            "action": "THROW",
                            "path": "columns.totalCount"
                        },
                        {
                            "kind": "RequiredField",
                            "field": {
                                "concreteType": "JiraBoardViewColumnEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            v0 /*: any*/ 
                                        ]
                                    }
                                ]
                            },
                            "action": "THROW",
                            "path": "columns.edges"
                        }
                    ]
                },
                "action": "THROW",
                "path": "columns"
            }
        ],
        "type": "JiraBoardView"
    };
}();
$2985b90d6bba645c$var$node.hash = "fba614071e09a0790c888db7eb67278f";
var $2985b90d6bba645c$export$2e2bcd8739ae039 = $2985b90d6bba645c$var$node;

});

parcelRegister("9Tcd5", function(module, exports) {

$parcel$export(module.exports, "default", () => $e0ff80fb19fe59ba$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2302dacb2ab77f2d4339d9526a2e0bf7>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $e0ff80fb19fe59ba$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "BoardHeaderDropdown_project",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "alias": "canAdministerProject",
                "args": [
                    {
                        "kind": "Literal",
                        "name": "type",
                        "value": "EDIT_PROJECT_CONFIG"
                    }
                ],
                "concreteType": "JiraProjectAction",
                "kind": "LinkedField",
                "name": "action",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "canPerform"
                        },
                        "action": "THROW",
                        "path": "canAdministerProject.canPerform"
                    }
                ],
                "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
            },
            "action": "THROW",
            "path": "canAdministerProject"
        },
        {
            "kind": "FragmentSpread",
            "name": "OpenProjectSettingsMultipleWorkflows_project"
        }
    ],
    "type": "JiraProject"
};
$e0ff80fb19fe59ba$var$node.hash = "a0e5236d3e0bf014ceca98247a5f1151";
var $e0ff80fb19fe59ba$export$2e2bcd8739ae039 = $e0ff80fb19fe59ba$var$node;

});

parcelRegister("6ByXP", function(module, exports) {

$parcel$export(module.exports, "ConditionalWrapper", () => $29a10aa5daca2294$export$39aecc95f0365819);

var $5uXOq = parcelRequire("5uXOq");
const $29a10aa5daca2294$export$39aecc95f0365819 = ({ condition: condition, renderWrapper: renderWrapper, children: children })=>condition ? renderWrapper(children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);

});

parcelRegister("bJ4fI", function(module, exports) {

$parcel$export(module.exports, "ContactAdminToModifyBoardMessage", () => $10f03830d7198abe$export$a89755471361f3c1);

var $5uXOq = parcelRequire("5uXOq");

var $e4yMr = parcelRequire("e4yMr");

var $4R6GH = parcelRequire("4R6GH");

var $8Q4sF = parcelRequire("8Q4sF");

var $koVbs = parcelRequire("koVbs");

var $9kI9v = parcelRequire("9kI9v");
const $10f03830d7198abe$var$ContactAdmin = ({ children: children })=>(0, $4R6GH.fg)('replace-anchor-with-link__wanjel') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e4yMr.default), {
        href: "/secure/ContactAdministrators!default.jspa",
        target: "_blank"
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("a", {
        href: "/secure/ContactAdministrators!default.jspa",
        target: "_blank"
    }, children);
const $10f03830d7198abe$export$a89755471361f3c1 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Q4sF.FormattedI18nMessage), {
        componentsMapping: {
            link: $10f03830d7198abe$var$ContactAdmin
        },
        message: formatMessage((0, $9kI9v.default).noPermissionToModify, {
            linkStart: '{linkStart}',
            linkEnd: '{linkEnd}'
        })
    });
};

});
parcelRegister("8Q4sF", function(module, exports) {

$parcel$export(module.exports, "FormattedI18nMessage", () => $7c8c20575fbc9bfc$export$200d7bd7633253ce);

var $5uXOq = parcelRequire("5uXOq");

var $gHDlh = parcelRequire("gHDlh");

var $9Byym = parcelRequire("9Byym");
const $7c8c20575fbc9bfc$export$200d7bd7633253ce = (props)=>{
    const { message: message, packageName: packageName, componentsMapping: componentsMapping } = props;
    const messageParts = (0, $5uXOq.useMemo)(()=>{
        const { tags: tags, openTags: openTags, closeTags: closeTags } = (0, $9Byym.getTags)(componentsMapping);
        try {
            const parts = [];
            let token = '';
            let TagComponent;
            let closeTagLookup;
            for(let i = 0; i < message.length; i += 1){
                const letter = message[i];
                token += letter;
                if ((0, $9Byym.isCloseTagDelimiter)(letter)) {
                    const firstTagFound = (0, $9Byym.findTag)(token, {
                        tags: openTags
                    });
                    if (firstTagFound !== null && firstTagFound !== undefined) {
                        // if we have a tag already means it is a malformed message since it is 2 subsequent open tags
                        if (TagComponent) throw new (0, $gHDlh.MalformedMessageError)();
                        const text = token.replace(firstTagFound, '');
                        parts.push(text);
                        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
                        const tagInfo = tags[firstTagFound];
                        TagComponent = tagInfo.component;
                        closeTagLookup = tagInfo.close;
                        token = '';
                    }
                }
                if (closeTagLookup !== null && closeTagLookup !== undefined && (0, $9Byym.isCloseTagDelimiter)(letter) && (0, $9Byym.isAnyTag)(token, {
                    tags: [
                        closeTagLookup
                    ]
                })) {
                    // this mean that we do not have an open tag for this closing tag
                    if (!TagComponent) throw new (0, $gHDlh.MalformedMessageError)();
                    const text = token.replace(closeTagLookup, '');
                    parts.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(TagComponent, null, text));
                    TagComponent = undefined;
                    token = '';
                    closeTagLookup = undefined;
                }
                if ((0, $9Byym.isCloseTagDelimiter)(letter) && (0, $9Byym.isAnyTag)(token, {
                    tags: closeTags
                })) {
                    // if we do not have an open tag mean we are closing a tag that is not open
                    if (!TagComponent) throw new (0, $gHDlh.MalformedMessageError)();
                }
            }
            // if we reached the end and we have an open tag, mean this message is malformed
            if (TagComponent || closeTagLookup) throw new (0, $gHDlh.MalformedMessageError)();
            // flush anything we keep in the current token
            if (token.length > 0) parts.push(token);
            return parts;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            if (e instanceof (0, $gHDlh.MalformedMessageError)) {
                (0, $gHDlh.logMalformedMessageError)({
                    message: message,
                    packageName: packageName
                });
                return [
                    (0, $gHDlh.getMalformedMessage)({
                        message: message,
                        closeTags: closeTags,
                        openTags: openTags
                    })
                ];
            }
            throw e;
        }
    }, [
        message,
        packageName,
        componentsMapping
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, messageParts.map((item, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Fragment), {
            key: index
        }, item)));
};

});
parcelRegister("gHDlh", function(module, exports) {

$parcel$export(module.exports, "getMalformedMessage", () => $ecff24857c176a60$export$f085cf20ec1f69ab);
$parcel$export(module.exports, "logMalformedMessageError", () => $ecff24857c176a60$export$954c3e6aad1c9429);
$parcel$export(module.exports, "MalformedMessageError", () => $ecff24857c176a60$export$40d900e818b9630e);

var $2YZCu = parcelRequire("2YZCu");

var $jcw0u = parcelRequire("jcw0u");

const $ecff24857c176a60$export$f085cf20ec1f69ab = ({ message: message, openTags: openTags, closeTags: closeTags })=>[
        ...openTags,
        ...closeTags
    ].reduce((acc, tag)=>acc.replace(new RegExp(tag, 'g'), ''), message);
const $ecff24857c176a60$export$954c3e6aad1c9429 = ({ message: message, packageName: packageName })=>{
    if (packageName !== null && packageName !== undefined) {
        const errorMessage = `Malformed message: ${message}`;
        // Send error log to analytics pipeline (i.e. SFX) and Sentry
        (0, $jcw0u.default)({
            meta: {
                packageName: packageName,
                id: (0, $5514815b06163219$export$f3390a0e172fee41)
            },
            attributes: {
                message: errorMessage
            }
        });
        // Send error log to Splunk
        const location = `${packageName}.${(0, $5514815b06163219$export$f3390a0e172fee41)}`;
        (0, $2YZCu.default).unsafeErrorWithCustomerData(location, errorMessage);
    }
};
class $ecff24857c176a60$export$40d900e818b9630e extends Error {
    constructor(){
        super('Malformed i18n message');
    }
}

});
const $5514815b06163219$export$f3390a0e172fee41 = 'formattedI18NMessage';


parcelRegister("9Byym", function(module, exports) {

$parcel$export(module.exports, "getTags", () => $84498158f946a67b$export$af63d7414243dad3);
$parcel$export(module.exports, "isAnyTag", () => $84498158f946a67b$export$38ffa64fc639355f);
$parcel$export(module.exports, "findTag", () => $84498158f946a67b$export$dfca0f74034f8657);
$parcel$export(module.exports, "isCloseTagDelimiter", () => $84498158f946a67b$export$d5170904651e91b1);

const $84498158f946a67b$export$af63d7414243dad3 = (componentsMapping)=>Object.entries(componentsMapping).reduce(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (acc, [key, value])=>{
        const open = `{${key}Start}`;
        const close = `{${key}End}`;
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
        acc.tags[open] = {
            close: close,
            component: value
        };
        // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'never'.
        acc.openTags.push(open);
        // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'never'.
        acc.closeTags.push(close);
        return acc;
    }, {
        tags: {},
        openTags: [],
        closeTags: []
    });
const $84498158f946a67b$export$38ffa64fc639355f = (text, { tags: tags })=>tags.some((tag)=>text.includes(tag));
const $84498158f946a67b$export$dfca0f74034f8657 = (text, { tags: tags })=>tags.find((tag)=>text.includes(tag));
const $84498158f946a67b$export$d5170904651e91b1 = (letter)=>letter === (0, $7ed9c0b663db8b35$export$a10c567c3288a6b4);

});
const $7ed9c0b663db8b35$export$a10c567c3288a6b4 = '}';



parcelRegister("9kI9v", function(module, exports) {

$parcel$export(module.exports, "default", () => $42eb69acdc66b3c0$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $42eb69acdc66b3c0$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    noPermissionToModify: {
        "id": "work-management-board.common.contact-admin-to-modify-board.no-permission-to-modify",
        "defaultMessage": "{linkStart}Contact your admin{linkEnd} to make changes to the board"
    }
});

});


parcelRegister("TN3UH", function(module, exports) {

$parcel$export(module.exports, "OpenProjectSettingsMultipleWorkflows", () => $923fd9a39f4dd53e$export$34713a2d1d1029c);

var $gjE1B = parcelRequire("gjE1B");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $7paD5 = parcelRequire("7paD5");

var $ousew = parcelRequire("ousew");

var $41j30 = parcelRequire("41j30");

var $3ygAi = parcelRequire("3ygAi");
const $923fd9a39f4dd53e$export$34713a2d1d1029c = ({ projectFragment: projectFragment })=>{
    const project = (0, $8Uumt.useFragment)((0, $gjE1B.default), projectFragment);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
        ...(0, $3ygAi.default).multipleWorkflowsBoardActionsDisabled,
        values: {
            link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $41j30.default), {
                    href: `/jira/core/projects/${project.key}/settings/issuetypes`,
                    target: "_blank"
                }, chunks, " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7paD5))), {
                    label: "",
                    LEGACY_size: "small"
                }))
        }
    });
};

});
parcelRegister("gjE1B", function(module, exports) {

$parcel$export(module.exports, "default", () => $b8509d74a6a9f6f3$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0cf9c670257988ef49af813ddf26a905>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b8509d74a6a9f6f3$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "OpenProjectSettingsMultipleWorkflows_project",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "key"
            },
            "action": "THROW",
            "path": "key"
        }
    ],
    "type": "JiraProject"
};
$b8509d74a6a9f6f3$var$node.hash = "7f720ba94aa97b43a3976d34e2193761";
var $b8509d74a6a9f6f3$export$2e2bcd8739ae039 = $b8509d74a6a9f6f3$var$node;

});

parcelRegister("3ygAi", function(module, exports) {

$parcel$export(module.exports, "default", () => $9eb0a0f9089558fa$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $9eb0a0f9089558fa$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    multipleWorkflowsBoardActionsDisabled: {
        "id": "work-management-board.common.open-project-settings-multiple-workflows.multiple-workflows-board-actions-disabled",
        "defaultMessage": "You can't add, delete, or rename columns when a board has multiple workflows. You can <link>change your workflows in project settings</link>."
    }
});

});


parcelRegister("jyaMY", function(module, exports) {

$parcel$export(module.exports, "columnDeleteModalEntryPoint", () => $0986678a9f0551ba$export$10b32977eaf90e38);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

var $glPE0 = parcelRequire("glPE0");

var $7y8jx = parcelRequire("7y8jx");

const $0986678a9f0551ba$export$10b32977eaf90e38 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("j70Nd")), {
        moduleId: "f14d78be",
        moduleName: "ColumnDeleteModal"
    }),
    getPreloadProps: ({ viewId: viewId })=>({
            queries: {
                columnDeleteModalQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $glPE0.default,
                    variables: {
                        viewInput: {
                            jiraBoardViewQueryInput: {
                                viewId: viewId
                            },
                            settings: (0, $7y8jx.getBoardQueryParams)()
                        }
                    }
                }
            }
        })
});

});
parcelRegister("glPE0", function(module, exports) {

$parcel$export(module.exports, "default", () => $1366ec757d64714c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5a61d93066baee6d62214410fb058dcd>>
 * @relayHash a98c949cbc77c039f96c5db02d541f91
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 79756fe2958dd6b39f6fe9af1f5c16a5dc697d519aa6d3f07f927bb025b81bfa
const $1366ec757d64714c$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "79756fe2958dd6b39f6fe9af1f5c16a5dc697d519aa6d3f07f927bb025b81bfa",
        "metadata": {},
        "name": "ColumnDeleteModalQuery",
        "operationKind": "query",
        "text": null
    }
};
var $1366ec757d64714c$export$2e2bcd8739ae039 = $1366ec757d64714c$var$node;

});

parcelRegister("j70Nd", function(module, exports) {

let $de9f4938fca48ea9$var$load = (parcelRequire("28QjX"))(4);
module.exports = $de9f4938fca48ea9$var$load("gCKB6").then(()=>parcelRequire('5AJ39'));

});


parcelRegister("eRL0S", function(module, exports) {

$parcel$export(module.exports, "default", () => $f38279272a862e0b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $f38279272a862e0b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    // Remove when cleaning up a11y-23270-board-column-drag-and-drop-accessible
    dropdownHeaderTitle: {
        "id": "work-management-board.board.column.column-header.header-dropdown.dropdown-header-title",
        "defaultMessage": "Actions"
    },
    rename: {
        "id": "work-management-board.board.column.column-header.header-dropdown.rename",
        "defaultMessage": "Rename"
    },
    delete: {
        "id": "work-management-board.board.column.column-header.header-dropdown.delete",
        "defaultMessage": "Delete"
    },
    moveRight: {
        "id": "work-management-board.board.column.column-header.header-dropdown.move-right",
        "defaultMessage": "Move column right"
    },
    moveLeft: {
        "id": "work-management-board.board.column.column-header.header-dropdown.move-left",
        "defaultMessage": "Move column left"
    },
    deleteDisabledTooltip: {
        "id": "work-management-board.board.column.column-header.header-dropdown.delete-disabled-tooltip",
        "defaultMessage": "The board must contain at least one column"
    },
    columnActionsMenu: {
        "id": "work-management-board.board.column.column-header.header-dropdown.column-actions-menu",
        "defaultMessage": "Column actions"
    },
    columnActionsWithColumn: {
        "id": "work-management-board.board.column.column-header.header-dropdown.column-actions-with-column",
        "defaultMessage": "Column actions on column {columnName}"
    },
    moreActionsTooltip: {
        "id": "work-management-board.board.column.column-header.header-dropdown.more-actions-tooltip",
        "defaultMessage": "More actions"
    }
});

});


parcelRegister("bvYiw", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce917bb67d26fcd0$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $ce917bb67d26fcd0$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    collapseButtonLabel: {
        "id": "work-management-board.board.column.column-header.collapse-button-label",
        "defaultMessage": "Collapse {name}"
    },
    expandButtonLabel: {
        "id": "work-management-board.board.column.column-header.expand-button-label",
        "defaultMessage": "Expand {name}"
    },
    noAssignee: {
        "id": "work-management-board.board.column.column-header.no-assignee",
        "defaultMessage": "Unassigned"
    },
    noCategory: {
        "id": "work-management-board.board.column.column-header.no-category",
        "defaultMessage": "Uncategorized"
    }
});

});


parcelRegister("hGG2j", function(module, exports) {

$parcel$export(module.exports, "default", () => $64904334d79c4b57$export$2e2bcd8739ae039);

var $jk8NO = parcelRequire("jk8NO");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $42CjB = parcelRequire("42CjB");

var $fCfvZ = parcelRequire("fCfvZ");

var $iurLX = parcelRequire("iurLX");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $koVbs = parcelRequire("koVbs");

var $dCm1o = parcelRequire("dCm1o");

var $4R6GH = parcelRequire("4R6GH");

var $jf0VO = parcelRequire("jf0VO");

var $aIfUI = parcelRequire("aIfUI");

var $bvYiw = parcelRequire("bvYiw");
const $64904334d79c4b57$var$PriorityColumnHeader = ({ dragHandleRef: dragHandleRef, priorityColumnFragment: priorityColumnFragment, isDropDisabled: isDropDisabled, issueCount: issueCount, onToggle: onToggle, testId: testId })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const column = (0, $8Uumt.useFragment)((0, $jk8NO.default), priorityColumnFragment);
    const isCollapsed = column.collapsed;
    const isCollapsedDropNotAllowed = isDropDisabled && isCollapsed;
    const columnName = column.priority?.name ?? '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        ref: (0, $4R6GH.fg)('update-column-header-design') ? dragHandleRef : undefined,
        "data-testid": testId,
        className: (0, $bwpsq.default)([
            $64904334d79c4b57$var$containerStylesMap.root,
            isCollapsed && (0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('visual-refresh-headers-buttons') && $64904334d79c4b57$var$containerStylesMap.collapsed,
            isCollapsed && !((0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('visual-refresh-headers-buttons')) && $64904334d79c4b57$var$containerStylesMap.collapsedOld,
            (0, $4R6GH.fg)('update-column-header-design') && $64904334d79c4b57$var$containerStylesMap.headerDraggable
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            (0, $4R6GH.fg)('update-column-header-design') && "_zulp1b66 _4cvr1h6o _vchhusvi _syazcdhy _1e0c1txw _2lx2vrvc _1bah1yb4 _ca0qidpf _u5f3utpp _n3tdidpf _19bvutpp _1bsb1osq",
            isCollapsed && (0, $4R6GH.fg)('update-column-header-design') && "_ca0qu2gc _u5f3idpf _n3td1b66 _19bvidpf _2lx21bp4",
            !(0, $4R6GH.fg)('update-column-header-design') && "_zulp1b66 _4cvr1h6o _vchhusvi _syazcdhy _1e0c1txw _2lx2vrvc _1bah1yb4 _ca0qidpf _u5f3u2gc _n3tdidpf _19bvpxbi _1bsb1osq",
            isCollapsed && !(0, $4R6GH.fg)('update-column-header-design') && "_ca0qdlk8 _u5f3idpf _n3td1b66 _19bvidpf _2lx21bp4"
        ])
    }, isCollapsedDropNotAllowed ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jf0VO.default), null) : !(0, $4R6GH.fg)('update-column-header-design') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        "aria-hidden": true,
        xcss: $64904334d79c4b57$var$dragHandleStyles,
        ref: dragHandleRef,
        testId: "work-management-board.ui.board.column.column-header.drag-handle"
    }, "\u283F"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_zulpu2gc _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _4cvr1h6o _80om1kw7 _1e0c1txw _2lx2vrvc _16jlkb7n _1ul9idpf _1tkeidpf",
            isCollapsed && "_ca0q1b66 _u5f3idpf _n3tdu2gc _19bvidpf _2lx21bp4"
        ])
    }, column.priority?.iconUrl && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("img", {
        alt: "",
        draggable: false,
        src: column.priority.iconUrl,
        className: (0, $bwpsq.default)([
            "_1bsbpxbi _4t3ipxbi _s7n41ndm"
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_11c81vhk _1reo15vq _18m915vq _k48p1wq8 _syaz1gjq _1ul9idpf _1bto1l2s _o5721q9c",
            isCollapsed && "_1lfclhck"
        ])
    }, column.priority.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aIfUI.default), {
        isCollapsed: isCollapsed,
        issueCount: issueCount
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-component-selector": "work-management-board.ui.board.column.column-header.collapse-button-wrapper",
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4t3i17is _tzy411de _1bsbeudw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        icon: isCollapsed ? (0, (/*@__PURE__*/$parcel$interopDefault($iurLX))) : (0, (/*@__PURE__*/$parcel$interopDefault($fCfvZ))),
        appearance: "subtle",
        isTooltipDisabled: false,
        label: formatMessage(isCollapsed ? (0, $bvYiw.default).expandButtonLabel : (0, $bvYiw.default).collapseButtonLabel, {
            name: columnName
        }),
        onClick: onToggle
    }))));
};
var $64904334d79c4b57$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($64904334d79c4b57$var$PriorityColumnHeader);
const $64904334d79c4b57$var$headerTitleWrapperStyles = null;
const $64904334d79c4b57$var$headerTitleWrapperCollapsedStyles = null;
const $64904334d79c4b57$var$headerTitleWrapperStylesOld = null;
const $64904334d79c4b57$var$headerTitleWrapperCollapsedStylesOld = null;
const $64904334d79c4b57$var$expandCollapseButtonWrapperStyles = null;
const $64904334d79c4b57$var$containerStylesMap = {
    root: "_1e0c1txw _kqswh2mm _uiztglyw _1ji3grho _59hlidpf _1xn7grho _1o9zidpf _1pbyegat _4t3ickbl _1rop1wug _3o2n1wug _3bdqt94y _at5wt94y _tdle1wug _1d8n1wug",
    collapsed: "_1tkeidpf _1o9zkb7n _1pbycs5v _4t3i1wug _c71luuw1",
    collapsedOld: "_1tkeidpf _1o9zkb7n _1pbycs5v _4t3i1wug",
    headerDraggable: "_80om1qgj"
};
const $64904334d79c4b57$var$dragHandleStyles = (0, $8CUq3.xcss)({
    color: 'color.text.subtle',
    cursor: 'grab'
});
const $64904334d79c4b57$var$columnNameStyles = null;
const $64904334d79c4b57$var$columnNameVerticalStyle = null;
const $64904334d79c4b57$var$headerContentWrapperStyles = null;
const $64904334d79c4b57$var$headerContentWrapperCollapsedStyles = null;
const $64904334d79c4b57$var$imageStyles = null;

});
parcelRegister("jk8NO", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcdc8dc91f0bf6ed$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4d4c5843f2787325e3d0274e324de77d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $bcdc8dc91f0bf6ed$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "PriorityColumnHeader_column",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "collapsed"
            },
            "action": "THROW",
            "path": "collapsed"
        },
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "JiraPriority",
                "kind": "LinkedField",
                "name": "priority",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "name"
                        },
                        "action": "THROW",
                        "path": "priority.name"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "iconUrl"
                    }
                ]
            },
            "action": "THROW",
            "path": "priority"
        }
    ],
    "type": "JiraBoardViewPriorityColumn"
};
$bcdc8dc91f0bf6ed$var$node.hash = "9558f76cea7c50adf2475a0cb448f925";
var $bcdc8dc91f0bf6ed$export$2e2bcd8739ae039 = $bcdc8dc91f0bf6ed$var$node;

});


parcelRegister("3iV3X", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a512bfa2d574182$export$2e2bcd8739ae039);

var $1RISR = parcelRequire("1RISR");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $42CjB = parcelRequire("42CjB");

var $ujWmd = parcelRequire("ujWmd");

var $fCfvZ = parcelRequire("fCfvZ");

var $iurLX = parcelRequire("iurLX");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $bmZvc = parcelRequire("bmZvc");

var $koVbs = parcelRequire("koVbs");

var $dCm1o = parcelRequire("dCm1o");

var $4R6GH = parcelRequire("4R6GH");

var $jf0VO = parcelRequire("jf0VO");

var $aIfUI = parcelRequire("aIfUI");

var $bvYiw = parcelRequire("bvYiw");
const $5a512bfa2d574182$var$AssigneeColumnHeader = ({ dragHandleRef: dragHandleRef, assigneeColumnFragment: assigneeColumnFragment, isDropDisabled: isDropDisabled, issueCount: issueCount, onToggle: onToggle, testId: testId })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const column = (0, $8Uumt.useFragment)((0, $1RISR.default), assigneeColumnFragment);
    const isCollapsed = column.collapsed;
    const isCollapsedDropNotAllowed = isDropDisabled && isCollapsed;
    const columnName = column.user?.name ?? formatMessage((0, $bvYiw.default).noAssignee);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        ref: (0, $4R6GH.fg)('update-column-header-design') ? dragHandleRef : undefined,
        "data-testid": testId,
        className: (0, $bwpsq.default)([
            $5a512bfa2d574182$var$containerStylesMap.root,
            isCollapsed && (0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('visual-refresh-headers-buttons') && $5a512bfa2d574182$var$containerStylesMap.collapsed,
            isCollapsed && !((0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('visual-refresh-headers-buttons')) && $5a512bfa2d574182$var$containerStylesMap.collapsedOld,
            (0, $4R6GH.fg)('update-column-header-design') && $5a512bfa2d574182$var$containerStylesMap.headerDraggable
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            (0, $4R6GH.fg)('update-column-header-design') && "_zulp1b66 _4cvr1h6o _vchhusvi _syazcdhy _1e0c1txw _2lx2vrvc _1bah1yb4 _ca0qidpf _u5f3utpp _n3tdidpf _19bvutpp _1bsb1osq",
            isCollapsed && (0, $4R6GH.fg)('update-column-header-design') && "_ca0qu2gc _u5f3idpf _n3td1b66 _19bvidpf _2lx21bp4",
            !(0, $4R6GH.fg)('update-column-header-design') && "_zulp1b66 _4cvr1h6o _vchhusvi _syazcdhy _1e0c1txw _2lx2vrvc _1bah1yb4 _ca0qidpf _u5f3u2gc _n3tdidpf _19bvpxbi _1bsb1osq",
            isCollapsed && !(0, $4R6GH.fg)('update-column-header-design') && "_ca0qdlk8 _u5f3idpf _n3td1b66 _19bvidpf _2lx21bp4"
        ])
    }, isCollapsedDropNotAllowed ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jf0VO.default), null) : !(0, $4R6GH.fg)('update-column-header-design') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        "aria-hidden": true,
        xcss: $5a512bfa2d574182$var$dragHandleStyles,
        ref: dragHandleRef,
        testId: "work-management-board.ui.board.column.column-header.drag-handle"
    }, "\u283F"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_zulpu2gc _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _4cvr1h6o _80om1kw7 _1e0c1txw _2lx2vrvc _16jlkb7n _1ul9idpf _1tkeidpf",
            isCollapsed && "_ca0q1b66 _u5f3idpf _n3tdu2gc _19bvidpf _2lx21bp4"
        ])
    }, column.user == null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
        appearance: "circle",
        src: "",
        size: "small"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bmZvc.AvatarLite), {
        avatarUrl: column.user?.picture ?? '',
        name: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_11c81vhk _1reo15vq _18m915vq _k48p1wq8 _syaz1gjq _1ul9idpf _1bto1l2s _o5721q9c",
            isCollapsed && "_1lfclhck"
        ])
    }, column.user == null ? formatMessage((0, $bvYiw.default).noAssignee) : column.user.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aIfUI.default), {
        isCollapsed: isCollapsed,
        issueCount: issueCount
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-component-selector": "work-management-board.ui.board.column.column-header.collapse-button-wrapper",
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4t3i17is _tzy411de _1bsbeudw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        icon: isCollapsed ? (0, (/*@__PURE__*/$parcel$interopDefault($iurLX))) : (0, (/*@__PURE__*/$parcel$interopDefault($fCfvZ))),
        appearance: "subtle",
        isTooltipDisabled: false,
        label: formatMessage(isCollapsed ? (0, $bvYiw.default).expandButtonLabel : (0, $bvYiw.default).collapseButtonLabel, {
            name: columnName
        }),
        onClick: onToggle
    }))));
};
var $5a512bfa2d574182$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($5a512bfa2d574182$var$AssigneeColumnHeader);
const $5a512bfa2d574182$var$headerTitleWrapperStyles = null;
const $5a512bfa2d574182$var$headerTitleWrapperCollapsedStyles = null;
const $5a512bfa2d574182$var$headerTitleWrapperStylesOld = null;
const $5a512bfa2d574182$var$headerTitleWrapperCollapsedStylesOld = null;
const $5a512bfa2d574182$var$expandCollapseButtonWrapperStyles = null;
const $5a512bfa2d574182$var$containerStylesMap = {
    root: "_1e0c1txw _kqswh2mm _uiztglyw _1ji3grho _59hlidpf _1xn7grho _1o9zidpf _1pbyegat _4t3ickbl _1rop1wug _3o2n1wug _3bdqt94y _at5wt94y _tdle1wug _1d8n1wug",
    collapsed: "_1tkeidpf _1o9zkb7n _1pbycs5v _4t3i1wug _c71luuw1",
    collapsedOld: "_1tkeidpf _1o9zkb7n _1pbycs5v _4t3i1wug",
    headerDraggable: "_80om1qgj"
};
const $5a512bfa2d574182$var$dragHandleStyles = (0, $8CUq3.xcss)({
    color: 'color.text.subtle',
    cursor: 'grab'
});
const $5a512bfa2d574182$var$columnNameStyles = null;
const $5a512bfa2d574182$var$columnNameVerticalStyle = null;
const $5a512bfa2d574182$var$headerContentWrapperStyles = null;
const $5a512bfa2d574182$var$headerContentWrapperCollapsedStyles = null;

});
parcelRegister("1RISR", function(module, exports) {

$parcel$export(module.exports, "default", () => $13a2fcc9124e94e3$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<dc72a20d5b02dea78b8e59633fcec413>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $13a2fcc9124e94e3$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "AssigneeColumnHeader_column",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "collapsed"
            },
            "action": "THROW",
            "path": "collapsed"
        },
        {
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "kind": "ScalarField",
                        "name": "name"
                    },
                    "action": "THROW",
                    "path": "user.name"
                },
                {
                    "kind": "ScalarField",
                    "name": "picture"
                }
            ]
        }
    ],
    "type": "JiraBoardViewAssigneeColumn"
};
$13a2fcc9124e94e3$var$node.hash = "5365c77b7b32dc79c9ceaf261c448651";
var $13a2fcc9124e94e3$export$2e2bcd8739ae039 = $13a2fcc9124e94e3$var$node;

});


parcelRegister("74h6I", function(module, exports) {

$parcel$export(module.exports, "default", () => $6169ec9ecd490491$export$2e2bcd8739ae039);

var $19rVH = parcelRequire("19rVH");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $42CjB = parcelRequire("42CjB");

var $fCfvZ = parcelRequire("fCfvZ");

var $iurLX = parcelRequire("iurLX");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $DhnKp = parcelRequire("DhnKp");

var $koVbs = parcelRequire("koVbs");

var $dCm1o = parcelRequire("dCm1o");

var $4R6GH = parcelRequire("4R6GH");

var $jf0VO = parcelRequire("jf0VO");

var $aIfUI = parcelRequire("aIfUI");

var $bvYiw = parcelRequire("bvYiw");
const $6169ec9ecd490491$var$CategoryColumnHeader = ({ dragHandleRef: dragHandleRef, categoryColumnFragment: categoryColumnFragment, isDropDisabled: isDropDisabled, issueCount: issueCount, onToggle: onToggle, testId: testId })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const column = (0, $8Uumt.useFragment)((0, $19rVH.default), categoryColumnFragment);
    const isCollapsed = column.collapsed;
    const isCollapsedDropNotAllowed = isDropDisabled && isCollapsed;
    const columnName = column.category?.value ?? formatMessage((0, $bvYiw.default).noCategory);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        ref: (0, $4R6GH.fg)('update-column-header-design') ? dragHandleRef : undefined,
        "data-testid": testId,
        className: (0, $bwpsq.default)([
            $6169ec9ecd490491$var$containerStylesMap.root,
            isCollapsed && (0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('visual-refresh-headers-buttons') && $6169ec9ecd490491$var$containerStylesMap.collapsed,
            isCollapsed && !((0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('visual-refresh-headers-buttons')) && $6169ec9ecd490491$var$containerStylesMap.collapsedOld,
            (0, $4R6GH.fg)('update-column-header-design') && $6169ec9ecd490491$var$containerStylesMap.headerDraggable
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            (0, $4R6GH.fg)('update-column-header-design') && "_zulp1b66 _4cvr1h6o _vchhusvi _syazcdhy _1e0c1txw _2lx2vrvc _1bah1yb4 _ca0qidpf _u5f3utpp _n3tdidpf _19bvutpp _1bsb1osq",
            isCollapsed && (0, $4R6GH.fg)('update-column-header-design') && "_ca0qu2gc _u5f3idpf _n3td1b66 _19bvidpf _2lx21bp4",
            !(0, $4R6GH.fg)('update-column-header-design') && "_zulp1b66 _4cvr1h6o _vchhusvi _syazcdhy _1e0c1txw _2lx2vrvc _1bah1yb4 _ca0qidpf _u5f3u2gc _n3tdidpf _19bvpxbi _1bsb1osq",
            isCollapsed && !(0, $4R6GH.fg)('update-column-header-design') && "_ca0qdlk8 _u5f3idpf _n3td1b66 _19bvidpf _2lx21bp4"
        ])
    }, isCollapsedDropNotAllowed ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jf0VO.default), null) : !(0, $4R6GH.fg)('update-column-header-design') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        "aria-hidden": true,
        xcss: $6169ec9ecd490491$var$dragHandleStyles,
        ref: dragHandleRef,
        testId: "work-management-board.ui.board.column.column-header.drag-handle"
    }, "\u283F"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_zulpu2gc _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _4cvr1h6o _80om1kw7 _1e0c1txw _2lx2vrvc _16jlkb7n _1ul9idpf _1tkeidpf",
            isCollapsed && "_ca0q1b66 _u5f3idpf _n3tdu2gc _19bvidpf _2lx21bp4"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_zulp1b66 _1e0c1txw _1ul9idpf _1tkeidpf",
            isCollapsed && "_1lfclhck"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $DhnKp.default), {
        categoryName: column.category == null ? formatMessage((0, $bvYiw.default).noCategory) : column.category.value,
        categoryColor: column.category?.color?.colorKey ?? null
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aIfUI.default), {
        isCollapsed: isCollapsed,
        issueCount: issueCount
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-component-selector": "work-management-board.ui.board.column.column-header.collapse-button-wrapper",
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4t3i17is _tzy411de _1bsbeudw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        icon: isCollapsed ? (0, (/*@__PURE__*/$parcel$interopDefault($iurLX))) : (0, (/*@__PURE__*/$parcel$interopDefault($fCfvZ))),
        appearance: "subtle",
        isTooltipDisabled: false,
        label: formatMessage(isCollapsed ? (0, $bvYiw.default).expandButtonLabel : (0, $bvYiw.default).collapseButtonLabel, {
            name: columnName
        }),
        onClick: onToggle
    }))));
};
var $6169ec9ecd490491$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($6169ec9ecd490491$var$CategoryColumnHeader);
const $6169ec9ecd490491$var$headerTitleWrapperStyles = null;
const $6169ec9ecd490491$var$headerTitleWrapperCollapsedStyles = null;
const $6169ec9ecd490491$var$headerTitleWrapperStylesOld = null;
const $6169ec9ecd490491$var$headerTitleWrapperCollapsedStylesOld = null;
const $6169ec9ecd490491$var$expandCollapseButtonWrapperStyles = null;
const $6169ec9ecd490491$var$containerStylesMap = {
    root: "_1e0c1txw _kqswh2mm _uiztglyw _1ji3grho _59hlidpf _1xn7grho _1o9zidpf _1pbyegat _4t3ickbl _1rop1wug _3o2n1wug _3bdqt94y _at5wt94y _tdle1wug _1d8n1wug",
    collapsed: "_1tkeidpf _1o9zkb7n _1pbycs5v _4t3i1wug _c71luuw1",
    collapsedOld: "_1tkeidpf _1o9zkb7n _1pbycs5v _4t3i1wug",
    headerDraggable: "_80om1qgj",
    headerTitleWrapperStyles: "_zulp1b66 _4cvr1h6o _vchhusvi _syazcdhy _1e0c1txw _2lx2vrvc _1bah1yb4 _19bvu2gc _u5f3u2gc _1bsb1osq",
    headerTitleWrapperCollapsedStyles: "_ca0q1b66 _n3td1b66 _2lx21bp4",
    headerTitleWrapperStylesOld: "_zulp1b66 _4cvr1h6o _vchhusvi _syazcdhy _1e0c1txw _2lx2vrvc _1bah1yb4 _ca0qidpf _u5f3u2gc _n3tdidpf _19bvpxbi _1bsb1osq",
    headerTitleWrapperCollapsedStylesOld: "_ca0qdlk8 _u5f3idpf _n3td1b66 _19bvidpf _2lx21bp4"
};
const $6169ec9ecd490491$var$dragHandleStyles = (0, $8CUq3.xcss)({
    color: 'color.text.subtle',
    cursor: 'grab'
});
const $6169ec9ecd490491$var$writingModeWrapperStyles = null;
const $6169ec9ecd490491$var$writingModeWrapperCollapsedStyles = null;
const $6169ec9ecd490491$var$headerContentWrapperStyles = null;
const $6169ec9ecd490491$var$headerContentWrapperCollapsedStyles = null;

});
parcelRegister("19rVH", function(module, exports) {

$parcel$export(module.exports, "default", () => $e8d99c7bfb849b93$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4f505fec75ae47d5b7ce2e8795de460b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $e8d99c7bfb849b93$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "CategoryColumnHeader_column",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "collapsed"
            },
            "action": "THROW",
            "path": "collapsed"
        },
        {
            "concreteType": "JiraOption",
            "kind": "LinkedField",
            "name": "category",
            "plural": false,
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "kind": "ScalarField",
                        "name": "value"
                    },
                    "action": "THROW",
                    "path": "category.value"
                },
                {
                    "concreteType": "JiraColor",
                    "kind": "LinkedField",
                    "name": "color",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "colorKey"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraBoardViewCategoryColumn"
};
$e8d99c7bfb849b93$var$node.hash = "31f0a80e13dd5972370be8d9316bf9c9";
var $e8d99c7bfb849b93$export$2e2bcd8739ae039 = $e8d99c7bfb849b93$var$node;

});


parcelRegister("ejglV", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc51e6b1ab1a81c1$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $fc51e6b1ab1a81c1$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    setColumnCollapsedStateFailedTitle: {
        "id": "work-management-board.column.error-title",
        "defaultMessage": "Unable to set the column state"
    },
    setColumnCollapsedStateFailedMessage: {
        "id": "work-management-board.column.error-message",
        "defaultMessage": "We couldn't apply your column settings, try refreshing the page or try again later."
    },
    noAssignee: {
        "id": "work-management-board.board.column.no-assignee",
        "defaultMessage": "Unassigned"
    },
    noCategory: {
        "id": "work-management-board.board.column.no-category",
        "defaultMessage": "Uncategorized"
    }
});

});


parcelRegister("cgEOh", function(module, exports) {

$parcel$export(module.exports, "BoardColumnCreate", () => $7dfc2a7e05391935$export$74f61e38c544d377);

var $a2ZNb = parcelRequire("a2ZNb");

var $5Cnwm = parcelRequire("5Cnwm");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $42CjB = parcelRequire("42CjB");

var $dZbEw = parcelRequire("dZbEw");

var $9lMrf = parcelRequire("9lMrf");

var $3bDjY = parcelRequire("3bDjY");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $eyhWZ = parcelRequire("eyhWZ");

var $8kNzi = parcelRequire("8kNzi");

var $8xg9P = parcelRequire("8xg9P");

var $eHJxW = parcelRequire("eHJxW");

var $koVbs = parcelRequire("koVbs");

var $iXc3K = parcelRequire("iXc3K");

var $TN3UH = parcelRequire("TN3UH");

var $bJ4fI = parcelRequire("bJ4fI");

var $fPzrH = parcelRequire("fPzrH");

var $jgcJl = parcelRequire("jgcJl");

var $6eb39 = parcelRequire("6eb39");
const $7dfc2a7e05391935$export$74f61e38c544d377 = /*#__PURE__*/ (0, $5uXOq.memo)(({ columnsFragment: columnsFragment, projectFragment: projectFragment, refresh: refresh })=>{
    const columns = (0, $8Uumt.useFragment)((0, $5Cnwm.default), columnsFragment);
    const { workflows: workflows } = (0, $jgcJl.useWorkflowStoreState)();
    const isWorkflowOperationInProgress = (0, $8xg9P.useIsWorkflowOperationInProgress)();
    const issueTypeId = workflows[0]?.issueTypes[0]?.id;
    const existingColumnNames = (0, $5uXOq.useMemo)(()=>columns.edges.flatMap((edge)=>{
            const column = edge?.node;
            if (!column) return null;
            switch(column.__typename){
                case 'JiraBoardViewStatusColumn':
                    if (column.statuses.length === 0) throw new Error('Missing statuses in column');
                    return column.statuses.map((status)=>status?.name);
                default:
                    return null;
            }
        }).filter(Boolean), [
        columns
    ]);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [isNoPermissionMessageOpen, setIsNoPermissionMessageOpen] = (0, $5uXOq.useState)();
    const [isMultipleWorkflowsMessageOpen, setIsMultipleWorkflowsMessageOpen] = (0, $5uXOq.useState)();
    const createNewStatus = (0, $8kNzi.useCreateStatus)({
        analyticsSource: 'jiraWorkManagementBoard',
        experience: 'columnActionAdd'
    });
    const { refetch: refetchBoardData } = (0, $fPzrH.useBoardData)();
    const project = (0, $8Uumt.useFragment)((0, $a2ZNb.default), projectFragment);
    const canAdministerProject = project.canAdministerProject.canPerform;
    const hasMultipleWorkflows = workflows.length > 1;
    const validateStatus = (0, $5uXOq.useCallback)(({ statusName: statusName })=>!existingColumnNames.some((existingColumnName)=>existingColumnName.toUpperCase() === statusName.toUpperCase()), [
        existingColumnNames
    ]);
    const createStatus = (0, $5uXOq.useCallback)(async (payload)=>{
        try {
            await createNewStatus(payload);
        } finally{
            refresh();
            refetchBoardData();
        }
    }, [
        createNewStatus,
        refresh,
        refetchBoardData
    ]);
    const createColumnModalProps = (0, $5uXOq.useMemo)(()=>{
        return {
            createStatus: createStatus,
            validateStatus: validateStatus,
            issueTypeId: issueTypeId
        };
    }, [
        createStatus,
        issueTypeId,
        validateStatus
    ]);
    if (!canAdministerProject) // show button that will trigger no permission message for user without permission
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eHJxW.JiraInlineDialog), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, $bwpsq.default)([
                "_1bsbuuw1"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bJ4fI.ContactAdminToModifyBoardMessage), null)),
        isOpen: Boolean(isNoPermissionMessageOpen),
        onClose: ()=>{
            setIsNoPermissionMessageOpen(false);
        },
        messageId: "work-management-board.ui.board.column-create.inline-dialog",
        messageType: "transactional"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_2rko1sit _bfhkqbzx"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($dZbEw))),
        label: formatMessage((0, $6eb39.default).createStatusLabel),
        testId: "work-management-board.ui.board.column-create.no-permission-button",
        onClick: ()=>{
            setIsNoPermissionMessageOpen(true);
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'createColumn', {
                restricted: 'permission'
            });
        }
    })));
    if (hasMultipleWorkflows) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eHJxW.JiraInlineDialog), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, $bwpsq.default)([
                "_1bsbuuw1"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $TN3UH.OpenProjectSettingsMultipleWorkflows), {
            projectFragment: project
        })),
        isOpen: Boolean(isMultipleWorkflowsMessageOpen),
        onClose: ()=>{
            setIsMultipleWorkflowsMessageOpen(false);
        },
        messageId: "work-management-board.ui.board.column-create.inline-dialog.1",
        messageType: "transactional"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_2rko1sit _bfhkqbzx"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($dZbEw))),
        label: formatMessage((0, $6eb39.default).createStatusLabel),
        testId: "work-management-board.ui.board.column-create.has-multiple-workflows-button",
        onClick: ()=>{
            setIsMultipleWorkflowsMessageOpen(true);
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'createColumn', {
                restricted: 'multipleWorkflows'
            });
        }
    })));
    if (!issueTypeId) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_2rko1sit _bfhkqbzx"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formatMessage((0, $6eb39.default).createStatusLabel)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXc3K.ModalEntryPointIconButtonTrigger), {
        entryPoint: (0, $eyhWZ.createColumnEntryPoint),
        entryPointProps: createColumnModalProps,
        interactionName: "jwmColumnCreate",
        appearance: "subtle",
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dZbEw))), {
                label: "",
                spacing: "spacious",
                color: "currentColor",
                LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($9lMrf)))
            }),
        isDisabled: isWorkflowOperationInProgress,
        label: formatMessage((0, $6eb39.default).createStatusLabel),
        useInternalModal: false,
        onClick: ()=>{
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'createColumn');
        }
    })));
});
const $7dfc2a7e05391935$var$surfaceWrapperStyles = null;
const $7dfc2a7e05391935$var$messageWrapperStyles = null;

});
parcelRegister("a2ZNb", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a404dffee01ace6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0734ac5a9ea15e4edcae6241de0f3f2a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $9a404dffee01ace6$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "BoardColumnCreate_project",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "alias": "canAdministerProject",
                "args": [
                    {
                        "kind": "Literal",
                        "name": "type",
                        "value": "EDIT_PROJECT_CONFIG"
                    }
                ],
                "concreteType": "JiraProjectAction",
                "kind": "LinkedField",
                "name": "action",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "canPerform"
                        },
                        "action": "THROW",
                        "path": "canAdministerProject.canPerform"
                    }
                ],
                "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
            },
            "action": "THROW",
            "path": "canAdministerProject"
        },
        {
            "kind": "FragmentSpread",
            "name": "OpenProjectSettingsMultipleWorkflows_project"
        }
    ],
    "type": "JiraProject"
};
$9a404dffee01ace6$var$node.hash = "df8f0fc7d6ff8c57cc7f6642728a2bb3";
var $9a404dffee01ace6$export$2e2bcd8739ae039 = $9a404dffee01ace6$var$node;

});

parcelRegister("5Cnwm", function(module, exports) {

$parcel$export(module.exports, "default", () => $c812aa220425dff8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f55564c444323ea809d1152df8bdfe49>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $c812aa220425dff8$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "BoardColumnCreate_columns",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "JiraBoardViewColumnEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "JiraStatus",
                                                "kind": "LinkedField",
                                                "name": "statuses",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "kind": "ScalarField",
                                                            "name": "name"
                                                        },
                                                        "action": "THROW",
                                                        "path": "edges.node.statuses.name"
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "edges.node.statuses"
                                        }
                                    ],
                                    "type": "JiraBoardViewStatusColumn"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "edges.node"
                    }
                ]
            },
            "action": "THROW",
            "path": "edges"
        }
    ],
    "type": "JiraBoardViewColumnConnection"
};
$c812aa220425dff8$var$node.hash = "baf06ef75ca6b210abf3051ad9bc7554";
var $c812aa220425dff8$export$2e2bcd8739ae039 = $c812aa220425dff8$var$node;

});

parcelRegister("eyhWZ", function(module, exports) {

$parcel$export(module.exports, "createColumnEntryPoint", () => $ddf95ed273613672$export$e69599a4ee2697d5);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $ddf95ed273613672$export$e69599a4ee2697d5 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("9EPZc")), {
        moduleId: "69f4ff7f"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("9EPZc", function(module, exports) {

let $70802cd569b6bb29$var$load = (parcelRequire("28QjX"))(4);
module.exports = $70802cd569b6bb29$var$load("8rQCa").then(()=>parcelRequire('3k8Yr'));

});


parcelRegister("8kNzi", function(module, exports) {

$parcel$export(module.exports, "useCreateStatus", () => $db31e0702feeb249$export$c2ab89f2f8598b1f);

var $5uXOq = parcelRequire("5uXOq");

var $daQYX = parcelRequire("daQYX");

var $93jKl = parcelRequire("93jKl");

var $kaHBi = parcelRequire("kaHBi");

var $3bQtK = parcelRequire("3bQtK");

var $8dXDG = parcelRequire("8dXDG");

var $6nqwL = parcelRequire("6nqwL");

var $pa9q9 = parcelRequire("pa9q9");

var $koeKL = parcelRequire("koeKL");

var $atdLB = parcelRequire("atdLB");
var $duUGa = parcelRequire("duUGa");


var $8xg9P = parcelRequire("8xg9P");

var $ayqGc = parcelRequire("ayqGc");

var $3YY5f = parcelRequire("3YY5f");
const $db31e0702feeb249$export$c2ab89f2f8598b1f = ({ analyticsSource: analyticsSource, experience: experience })=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const { createWorkflowStatusforSingleWorkflow: createWorkflowStatusforSingleWorkflow } = (0, $6nqwL.useWorkflowsV2)();
    const createStatusExperience = (0, $5uXOq.useMemo)(()=>new (0, $duUGa.UFOExperience)(experience, {
            type: (0, $atdLB.ExperienceTypes).Operation,
            performanceType: (0, $atdLB.ExperiencePerformanceTypes).Custom
        }), [
        experience
    ]);
    const startAddOperation = (0, $8xg9P.useStartAddOperation)();
    const stopWorkflowOperationInProgress = (0, $8xg9P.useStopWorkflowOperationInProgress)();
    const startExperience = (0, $kaHBi.useExperienceStart)({
        analyticsSource: analyticsSource,
        experience: experience
    });
    const markExperienceSuccess = (0, $3bQtK.useExperienceSuccess)({
        experience: experience
    });
    const markExperienceFailed = (0, $93jKl.useExperienceFail)({
        experience: experience
    });
    const abortExperience = (0, $8dXDG.useExperienceAbort)({
        experience: experience
    });
    const project = (0, $daQYX.useProject)();
    const { showFlag: showFlag } = (0, $pa9q9.useFlagService)();
    const markExperienceSuccessWithUFO = (0, $5uXOq.useCallback)(()=>{
        markExperienceSuccess();
        createStatusExperience.success();
    }, [
        markExperienceSuccess,
        createStatusExperience
    ]);
    const createNewStatus = (0, $5uXOq.useCallback)(async ({ statusName: statusName, statusCategory: statusCategory, issueTypeId: issueTypeId })=>{
        startAddOperation(String((0, $8acbf7056aed1170$export$9301910120a61d41)));
        startExperience();
        createStatusExperience.start();
        try {
            await createWorkflowStatusforSingleWorkflow({
                statusName: statusName,
                statusCategory: statusCategory,
                cloudId: cloudId,
                projectId: String(project.id),
                issueTypeId: issueTypeId,
                onSuccess: markExperienceSuccessWithUFO
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            showFlag((0, $ayqGc.getStatusActionFailedFlag)({
                messageTitle: (0, $3YY5f.default).errorFlagTitleAddStatus,
                action: 'add',
                error: error,
                issueTypeId: issueTypeId,
                projectKey: project.key,
                statusCode: error?.response?.status
            }));
            (0, $ayqGc.failStatusExperience)({
                markExperienceFailed: markExperienceFailed,
                abortExperience: abortExperience,
                ufoExperience: createStatusExperience,
                error: error,
                errorMessage: 'Failed to validate and update workflow'
            });
            throw error;
        } finally{
            stopWorkflowOperationInProgress();
        }
    }, [
        startAddOperation,
        createStatusExperience,
        startExperience,
        createWorkflowStatusforSingleWorkflow,
        cloudId,
        project.id,
        project.key,
        markExperienceSuccessWithUFO,
        showFlag,
        markExperienceFailed,
        abortExperience,
        stopWorkflowOperationInProgress
    ]);
    return createNewStatus;
};

});
parcelRegister("3YY5f", function(module, exports) {

$parcel$export(module.exports, "default", () => $31cf02652414d1d8$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $31cf02652414d1d8$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorFlagTitleAddStatus: {
        "id": "business-workflows.controllers.workflow-actions.create-status.error-flag-title-add-status",
        "defaultMessage": "Unable to create status"
    }
});

});


parcelRegister("iXc3K", function(module, exports) {

$parcel$export(module.exports, "ModalEntryPointIconButtonTrigger", () => $b0e020063eb1351b$export$7d379857be6c65e7);

var $5uXOq = parcelRequire("5uXOq");

var $42CjB = parcelRequire("42CjB");

var $2KAtx = parcelRequire("2KAtx");
function $b0e020063eb1351b$export$7d379857be6c65e7({ entryPoint: entryPoint, entryPointParams: entryPointParams, entryPointProps: entryPointProps, errorAttributes: errorAttributes, Fallback: Fallback, modalTitle: modalTitle, modalProps: modalProps, useInternalModal: useInternalModal, ...buttonProps }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2KAtx.ModalEntryPointPressableTrigger), {
        entryPoint: entryPoint,
        entryPointParams: entryPointParams,
        entryPointProps: entryPointProps,
        errorAttributes: errorAttributes,
        Fallback: Fallback,
        modalTitle: modalTitle,
        modalProps: modalProps,
        useInternalModal: useInternalModal
    }, ({ ref: ref })=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
            ref: ref,
            ...buttonProps
        }));
}

});

parcelRegister("6eb39", function(module, exports) {

$parcel$export(module.exports, "default", () => $06c08becb3ea4736$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $06c08becb3ea4736$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    noPermissionToModify: {
        "id": "work-management-board.board.column-create.no-permission-to-modify",
        "defaultMessage": "Contact your admin to make changes to the board"
    },
    createStatusLabel: {
        "id": "work-management-board.board.column-create.create-status-label",
        "defaultMessage": "Create status"
    }
});

});


parcelRegister("eMyuP", function(module, exports) {

$parcel$export(module.exports, "BoardMinimap", () => $a0ca2fd355b72496$export$d0a9287f2955ebdd);

var $9gzm5 = parcelRequire("9gzm5");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $ACELo = parcelRequire("ACELo");

var $l8ruj = parcelRequire("l8ruj");
const $a0ca2fd355b72496$var$MINIMAP_MAP_HEIGHT = 36;
const $a0ca2fd355b72496$var$MIN_SCALING_FACTOR = 14;
const $a0ca2fd355b72496$var$MAX_MAP_WIDTH = 100;
const $a0ca2fd355b72496$var$SHOW_MAP_RATIO = 1.1;
const $a0ca2fd355b72496$var$getScalingFactor = (updatedScrollWidth)=>{
    const maxSizeScalingFactor = updatedScrollWidth / $a0ca2fd355b72496$var$MAX_MAP_WIDTH;
    return Math.max($a0ca2fd355b72496$var$MIN_SCALING_FACTOR, maxSizeScalingFactor);
};
const $a0ca2fd355b72496$export$d0a9287f2955ebdd = /*#__PURE__*/ (0, $5uXOq.memo)(({ boardContentElement: boardContentElement, scrollElement: scrollElement, columnsFragment: columnsFragment })=>{
    const columns = (0, $8Uumt.useFragment)((0, $9gzm5.default), columnsFragment);
    const [scrollLeft, setScrollLeft] = (0, $5uXOq.useState)(0);
    const [scrollWrapperWidth, setScrollWrapperWidth] = (0, $5uXOq.useState)(scrollElement?.clientWidth ?? 0);
    const [contentWrapperWidth, setContentWrapperWidth] = (0, $5uXOq.useState)(boardContentElement?.clientWidth ?? 0);
    const [isDragging, setIsDragging] = (0, $5uXOq.useState)(false);
    const [mouseStart, setMouseStart] = (0, $5uXOq.useState)(null);
    const [initialOffset, setInitialOffset] = (0, $5uXOq.useState)(0);
    const innerViewRef = (0, $5uXOq.useRef)(null);
    const scalingFactor = $a0ca2fd355b72496$var$getScalingFactor(contentWrapperWidth);
    const outerWidth = contentWrapperWidth / scalingFactor;
    const innerWidth = scrollWrapperWidth / scalingFactor;
    const innerOffset = scrollLeft / scalingFactor;
    const onMouseDown = (0, $5uXOq.useCallback)((e)=>{
        if (e.button === 0) {
            setIsDragging(true);
            setMouseStart(e.clientX);
            setInitialOffset(innerOffset);
        }
    }, [
        innerOffset
    ]);
    const onMouseUp = (0, $5uXOq.useCallback)(()=>{
        if (isDragging) setIsDragging(false);
    }, [
        isDragging
    ]);
    const setHorizontalScroll = (0, $5uXOq.useCallback)((newOffset)=>{
        scrollElement?.scrollTo(newOffset, scrollElement?.scrollTop);
    }, [
        scrollElement
    ]);
    const onScroll = (0, $5uXOq.useCallback)((newOffset)=>{
        const newScalingFactor = $a0ca2fd355b72496$var$getScalingFactor(contentWrapperWidth);
        setHorizontalScroll(newOffset * newScalingFactor);
    }, [
        contentWrapperWidth,
        setHorizontalScroll
    ]);
    const onMouseMove = (0, $5uXOq.useCallback)((e)=>{
        if (isDragging && mouseStart !== null) {
            const mouseCurrent = e.clientX;
            onScroll(initialOffset + mouseCurrent - mouseStart);
        }
    }, [
        initialOffset,
        isDragging,
        mouseStart,
        onScroll
    ]);
    const updateInnerViewPosition = (0, $5uXOq.useCallback)(()=>{
        if (innerViewRef.current) innerViewRef.current.style.marginLeft = `${innerOffset}px`;
    }, [
        innerOffset
    ]);
    const handleMinimapRef = (0, $5uXOq.useCallback)((ref)=>{
        innerViewRef.current = ref;
        updateInnerViewPosition();
    }, [
        updateInnerViewPosition
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const handleScroll = ()=>{
            setScrollLeft(scrollElement?.scrollLeft ?? 0);
        };
        const scrollElementResizeObserver = new ResizeObserver((entries)=>{
            for (const entry of entries)setScrollWrapperWidth(entry.contentRect.width);
        });
        if (scrollElement) scrollElementResizeObserver.observe(scrollElement);
        const boardContentElementResizeObserver = new ResizeObserver((entries)=>{
            for (const entry of entries)setContentWrapperWidth(entry.contentRect.width);
        });
        if (boardContentElement) boardContentElementResizeObserver.observe(boardContentElement);
        scrollElement?.addEventListener('scroll', handleScroll);
        return ()=>{
            scrollElement?.removeEventListener('scroll', handleScroll);
            scrollElementResizeObserver.disconnect();
            boardContentElementResizeObserver.disconnect();
        };
    }, [
        scrollElement,
        boardContentElement
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const cleanupListeners = ()=>{
            if (typeof document !== 'undefined') {
                document.removeEventListener('mousemove', onMouseMove);
                document.removeEventListener('mouseup', onMouseUp);
            }
        };
        if (isDragging) {
            if (typeof document !== 'undefined') {
                document.addEventListener('mousemove', onMouseMove);
                document.addEventListener('mouseup', onMouseUp);
            }
        } else cleanupListeners();
        return ()=>{
            cleanupListeners();
        };
    }, [
        isDragging,
        onMouseMove,
        onMouseUp
    ]);
    if (!(contentWrapperWidth / scrollWrapperWidth > $a0ca2fd355b72496$var$SHOW_MAP_RATIO)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "business-board-minimap"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ACELo.JiraBottomRightCornerOutlet), {
        orderFromRight: 2,
        id: "business-board-minimap"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            $a0ca2fd355b72496$var$styles.root
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            $a0ca2fd355b72496$var$styles.innerViewWrapper
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div" // eslint-disable-next-line jira/react/no-style-attribute
    , {
        style: {
            width: `${innerWidth}px`
        },
        onMouseDown: onMouseDown,
        onMouseMove: onMouseMove,
        onMouseUp: onMouseUp,
        ref: handleMinimapRef,
        className: (0, $bwpsq.default)([
            $a0ca2fd355b72496$var$styles.innerView,
            isDragging && $a0ca2fd355b72496$var$styles.innerViewDragging
        ])
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div" // eslint-disable-next-line jira/react/no-style-attribute
    , {
        style: {
            width: `${outerWidth}px`
        },
        className: (0, $bwpsq.default)([
            $a0ca2fd355b72496$var$styles.outerView
        ])
    }, columns.edges.map((edge)=>edge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            key: edge.node.id,
            className: (0, $bwpsq.default)([
                $a0ca2fd355b72496$var$styles.column,
                edge.node.collapsed && $a0ca2fd355b72496$var$styles.columnCollapsed
            ])
        }))))));
});
const $a0ca2fd355b72496$var$styles = {
    root: "_2rkogqwt _bfhk1bhr _16qs1cd0 _1e0c116y _ca0q12x7 _u5f312x7 _n3td12x7 _19bv12x7",
    innerViewWrapper: "_kqswh2mm",
    innerView: "_2rko1l7b _189eyh40 _1dqonqa1 _1h6d13er _80om15ng _4t3i14no _1ltv1n1a _kqswstnw _154i1n1a",
    innerViewDragging: "_1h6d1p6i",
    outerView: "_2rko1l7b _zulpv77o _189et94y _1dqonqa1 _1h6d1bhr _1e0c1txw _1bah1yb4 _4t3i14no",
    column: "_16jlegat _1o9zkb7n _i0dlf1ug _2rko1l7b _bfhkm7j4",
    columnCollapsed: "_16jlkb7n _1o9zkb7n _i0dlf1ug"
};

});
parcelRegister("9gzm5", function(module, exports) {

$parcel$export(module.exports, "default", () => $a6fabe1955fdacdc$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9fe430c8a55e5a2bf4ac501600305518>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a6fabe1955fdacdc$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "BoardMinimap_columns",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "JiraBoardViewColumnEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "kind": "ScalarField",
                                        "name": "id"
                                    },
                                    "action": "THROW",
                                    "path": "edges.node.id"
                                },
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "kind": "ScalarField",
                                        "name": "collapsed"
                                    },
                                    "action": "THROW",
                                    "path": "edges.node.collapsed"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "edges.node"
                    }
                ]
            },
            "action": "THROW",
            "path": "edges"
        }
    ],
    "type": "JiraBoardViewColumnConnection"
};
$a6fabe1955fdacdc$var$node.hash = "2d03302d48be438c0b6d91e3f86f983b";
var $a6fabe1955fdacdc$export$2e2bcd8739ae039 = $a6fabe1955fdacdc$var$node;

});



parcelRegister("3ZzsP", function(module, exports) {

$parcel$export(module.exports, "default", () => $a71f63bd42110457$export$2e2bcd8739ae039);

var $9fbO9 = parcelRequire("9fbO9");

var $19ypb = parcelRequire("19ypb");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $3bDjY = parcelRequire("3bDjY");

var $4QAwn = parcelRequire("4QAwn");

var $MHKc7 = parcelRequire("MHKc7");

var $bJeNF = parcelRequire("bJeNF");

var $eZJjh = parcelRequire("eZJjh");

var $jldZL = parcelRequire("jldZL");

var $jDrwg = parcelRequire("jDrwg");

var $lQFjJ = parcelRequire("lQFjJ");

var $7mPT9 = parcelRequire("7mPT9");

var $5hI3W = parcelRequire("5hI3W");

var $4Mmyc = parcelRequire("4Mmyc");

var $17X6Y = parcelRequire("17X6Y");

var $ccsmj = parcelRequire("ccsmj");

var $koVbs = parcelRequire("koVbs");

var $6s1PB = parcelRequire("6s1PB");

var $jgJNO = parcelRequire("jgJNO");

var $22OQR = parcelRequire("22OQR");

var $hCCtP = parcelRequire("hCCtP");

var $3HwlS = parcelRequire("3HwlS");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $47gW9 = parcelRequire("47gW9");

var $5fc53 = parcelRequire("5fc53");

var $5GqLe = parcelRequire("5GqLe");

var $l8ruj = parcelRequire("l8ruj");

var $dCm1o = parcelRequire("dCm1o");

var $4R6GH = parcelRequire("4R6GH");

var $6jE0j = parcelRequire("6jE0j");

var $cGvzG = parcelRequire("cGvzG");

var $3WdOs = parcelRequire("3WdOs");

var $fPzrH = parcelRequire("fPzrH");

var $5jsYx = parcelRequire("5jsYx");

var $9t9Z1 = parcelRequire("9t9Z1");

var $fvKJM = parcelRequire("fvKJM");

var $5WsXw = parcelRequire("5WsXw");
const $a71f63bd42110457$var$HIDDEN_QUICKFILTERS = [
    'DONE',
    'ACTIVE_SPRINTS'
];
const $a71f63bd42110457$var$ALLOWED_FIELD_TYPES = new Set([
    (0, $5fc53.ASSIGNEE_TYPE),
    (0, $5fc53.ISSUE_TYPE),
    (0, $5fc53.PRIORITY_TYPE),
    (0, $5fc53.CATEGORY_TYPE),
    (0, $5fc53.COMPONENTS_TYPE),
    (0, $5fc53.LABELS_TYPE),
    (0, $5fc53.MULTI_SELECT_CF_TYPE),
    (0, $5fc53.PEOPLE_CF_TYPE),
    (0, $5fc53.REPORTER_TYPE),
    (0, $5fc53.SELECT_CF_TYPE),
    (0, $5fc53.USER_CF_TYPE),
    (0, $5fc53.STATUS_TYPE),
    (0, $5fc53.PARENT_TYPE)
]);
const $a71f63bd42110457$var$styles = {
    menuContent: "_1bsbnklw",
    fallbackMenu: "_1e0c1txw _1bah1h6o _4cvr1h6o _ca0qpxbi _n3tdpxbi",
    saveResetButtonWrapper: "_18u0x0bf"
};
const $a71f63bd42110457$var$BoardHeader = ({ projectFragment: projectFragment, viewFragment: viewFragment })=>{
    const triggerRef = (0, $5uXOq.useRef)(null);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { isShareButtonEnabled: isShareButtonEnabled, inviteButtonInteraction: inviteButtonInteraction, isPresenceEnabled: isPresenceEnabled, withSaveRevertView: withSaveRevertView } = (0, $3WdOs.useJWMBoardFeatures)();
    const [boardSearchStatus, setBoardSearchStatus] = (0, $5uXOq.useState)('');
    const { filteredIssues: filteredIssues } = (0, $4R6GH.fg)('wanjel-a11y-enterprise-grade') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $fPzrH.useBoardData)() : {
        filteredIssues: []
    };
    const project = (0, $8Uumt.useFragment)((0, $19ypb.default), projectFragment);
    const view = (0, $8Uumt.useFragment)((0, $9fbO9.default), viewFragment);
    const shareButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ccsmj.JWMShareButton), {
        shareTitle: (0, $9t9Z1.default).shareTitle,
        integrationType: (0, $5GqLe.integrationTypes).BOARD,
        shareContentType: "board"
    });
    const jiraViewAri = (0, $cGvzG.JiraViewAri).parse(view.id); // scopeId is <projectId>/<viewType>/<viewId>
    const collabView = jiraViewAri.scopeId.split('/').slice(1).join('/');
    const [debouncedHandleSearchTextChange] = (0, $4R6GH.fg)('wanjel-a11y-enterprise-grade') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $jDrwg.default)((text)=>{
        let boardSearchText = '';
        if (text === '') boardSearchText = formatMessage((0, $9t9Z1.default).showAllWorkItems);
        else boardSearchText = formatMessage((0, $9t9Z1.default).showFilteredWorkItems, {
            count: filteredIssues.length
        });
        setBoardSearchStatus(boardSearchText);
    }, 1000) : [];
    const searchBar = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4Mmyc.SimpleSearchField), {
        placeholder: (0, $9t9Z1.default).searchBoardLabel,
        view: "board",
        onChange: debouncedHandleSearchTextChange
    }), (0, $4R6GH.fg)('wanjel-a11y-enterprise-grade') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jldZL.default), {
        role: "status"
    }, boardSearchStatus));
    const addPeopleWithPresence = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $17X6Y.default), {
        view: "board",
        collabView: collabView,
        allowedFieldTypes: $a71f63bd42110457$var$ALLOWED_FIELD_TYPES,
        isPresenceEnabledInContext: isPresenceEnabled,
        isOpenNewTabOnClick: inviteButtonInteraction === 'openNewTab',
        allowCustomFields: true,
        hasInviteButton: !(0, $dCm1o.isVisualRefreshEnabled)(),
        shouldShowUnassignedUser: (0, $4R6GH.fg)('show_unassigned_avatar_in_assignee_filter')
    });
    const shareActionButton = isShareButtonEnabled && shareButton;
    const filters = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5hI3W.Filters), {
        view: "board",
        allowedFieldTypes: $a71f63bd42110457$var$ALLOWED_FIELD_TYPES,
        hiddenQuickFilters: $a71f63bd42110457$var$HIDDEN_QUICKFILTERS,
        allowCustomFields: true
    });
    const [isMoreMenuOpen, setIsMoreMenuOpen] = (0, $5uXOq.useState)(false);
    const closeMoreMenu = (0, $5uXOq.useCallback)(()=>{
        setIsMoreMenuOpen(false);
        if ((0, $4R6GH.fg)('wanjel-a11y-enterprise-grade')) triggerRef.current?.focus();
    }, []);
    const toggleMoreMenu = (0, $5uXOq.useCallback)(()=>setIsMoreMenuOpen((oldIsOpen)=>!oldIsOpen), []);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $5WsXw.moreMenuContentEntryPoint), (0, $5uXOq.useMemo)(()=>({
            projectAri: project.id,
            viewId: view.id
        }), [
        project.id,
        view.id
    ]));
    const moreMenuContentTrigger = (0, $47gW9.useEntryPointButtonTrigger)(entryPointActions, !isMoreMenuOpen);
    const moreMenuContent = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
            xcss: $a71f63bd42110457$var$styles.menuContent
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
            entryPointReferenceSubject: entryPointReferenceSubject,
            id: "business-board-more-menu",
            packageName: "@atlassian/jira-work-management-board",
            runtimeProps: {
                onClose: closeMoreMenu
            },
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
                xcss: $a71f63bd42110457$var$styles.fallbackMenu
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), null))
        })), [
        closeMoreMenu,
        entryPointReferenceSubject
    ]);
    const moreMenuTrigger = (0, $5uXOq.useCallback)((triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: formatMessage((0, $9t9Z1.default).viewSettingsButton),
            hideTooltipOnClick: true,
            position: "top"
        }, (0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('board_view_setting_button') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCCtP.ThemedIconButton), {
            ...triggerProps,
            ref: (element)=>{
                moreMenuContentTrigger(element);
                if (typeof triggerProps.ref === 'function') {
                    if ((0, $4R6GH.fg)('wanjel-a11y-enterprise-grade')) (0, $7mPT9.mergeRefs)(triggerRef, triggerProps.ref)(element);
                    else triggerProps.ref(element);
                }
            },
            label: formatMessage((0, $9t9Z1.default).viewSettingsButton),
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($4QAwn))),
            isSelected: isMoreMenuOpen,
            onClick: toggleMoreMenu
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $22OQR.ThemedButton), {
            ...triggerProps,
            ref: (element)=>{
                moreMenuContentTrigger(element);
                if (typeof triggerProps.ref === 'function') {
                    if ((0, $4R6GH.fg)('wanjel-a11y-enterprise-grade')) (0, $7mPT9.mergeRefs)(triggerRef, triggerProps.ref)(element);
                    else triggerProps.ref(element);
                }
            },
            appearance: (0, $dCm1o.isVisualRefreshEnabled)() ? undefined : 'subtle',
            iconBefore: (0, $dCm1o.isVisualRefreshEnabled)() ? undefined : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bJeNF))), {
                label: "",
                LEGACY_size: "small"
            }),
            iconAfter: (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4QAwn))), {
                label: "",
                spacing: "spacious",
                color: "currentColor"
            }) : undefined,
            isSelected: isMoreMenuOpen,
            onClick: toggleMoreMenu,
            "aria-label": formatMessage((0, $9t9Z1.default).viewSettingsButton)
        }, (0, $dCm1o.isVisualRefreshEnabled)() ? null : formatMessage((0, $9t9Z1.default).moreButtonOld))), [
        formatMessage,
        isMoreMenuOpen,
        moreMenuContentTrigger,
        toggleMoreMenu
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "business-board-header"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lQFjJ.ActionsWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lQFjJ.LeftActionsWrapper), null, searchBar, addPeopleWithPresence, (0, $dCm1o.isVisualRefreshEnabled)() && filters), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lQFjJ.RightActionsWrapper), null, !(0, $dCm1o.isVisualRefreshEnabled)() && !(0, $3HwlS.getWillShowNav4)() && shareActionButton, !(0, $dCm1o.isVisualRefreshEnabled)() && filters, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5jsYx.default), {
        viewFragment: view
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        isOpen: isMoreMenuOpen,
        onClose: closeMoreMenu,
        placement: "bottom-end",
        messageId: "work-management-board.ui.header.popup",
        messageType: "transactional",
        content: moreMenuContent,
        trigger: moreMenuTrigger,
        autoFocus: false,
        testId: "work-management-board.ui.header.more-menu-popup",
        ...(0, $4R6GH.fg)('wanjel-fix-rendertoparent-header-popup-in-board') ? {
            shouldRenderToParent: true
        } : {}
    }), withSaveRevertView && view && (0, $3HwlS.getWillShowNav4)() && (0, $6s1PB.expVal)('saved_views', 'enabled', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            $a71f63bd42110457$var$styles.saveResetButtonWrapper
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6jE0j.Collapsible), {
        animationDuration: 260,
        direction: "horizontal",
        isExpanded: view.isViewConfigModified ?? false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fvKJM.SaveResetViewSettings), {
        viewFragment: view
    }))))));
};
var $a71f63bd42110457$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($a71f63bd42110457$var$BoardHeader);

});
parcelRegister("9fbO9", function(module, exports) {

$parcel$export(module.exports, "default", () => $69a955c232e0cf0e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4e222cbc69f06d73479244fed52fb435>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $69a955c232e0cf0e$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "BoardHeader_view",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "id"
            },
            "action": "THROW",
            "path": "id"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "isViewConfigModified"
            },
            "action": "THROW",
            "path": "isViewConfigModified"
        },
        {
            "kind": "FragmentSpread",
            "name": "SaveResetViewSettings_view"
        },
        {
            "kind": "FragmentSpread",
            "name": "BoardGroupSelector_view"
        }
    ],
    "type": "JiraBoardView"
};
$69a955c232e0cf0e$var$node.hash = "717ca3a5897c05f29d846d023794b115";
var $69a955c232e0cf0e$export$2e2bcd8739ae039 = $69a955c232e0cf0e$var$node;

});

parcelRegister("19ypb", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb98a1ce030941bd$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4a253bbfff0b8f9209e280d4dd60ee74>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $fb98a1ce030941bd$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "BoardHeader_project",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "id"
            },
            "action": "THROW",
            "path": "id"
        }
    ],
    "type": "JiraProject"
};
$fb98a1ce030941bd$var$node.hash = "6186ec952679bce0e0c89550d072b648";
var $fb98a1ce030941bd$export$2e2bcd8739ae039 = $fb98a1ce030941bd$var$node;

});

parcelRegister("jDrwg", function(module, exports) {

$parcel$export(module.exports, "default", () => $049f084810e3e7c4$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $lFKmC = parcelRequire("lFKmC");
function $049f084810e3e7c4$export$2e2bcd8739ae039(callback, delay, options) {
    const optionsRef = (0, $5uXOq.useRef)(options);
    // @ts-expect-error - TS7019 - Rest parameter 'args' implicitly has an 'any[]' type.
    const callbackRef = (0, $5uXOq.useRef)((...args)=>{
        callback(...args);
    });
    callbackRef.current = callback;
    const debouncedCallBack = (0, $5uXOq.useMemo)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    ()=>(0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))((...args)=>callbackRef.current(...args), delay, optionsRef.current), [
        delay
    ]);
    (0, $5uXOq.useEffect)(()=>debouncedCallBack.cancel, [
        debouncedCallBack
    ]);
    return [
        debouncedCallBack,
        debouncedCallBack.cancel
    ];
}

});

parcelRegister("lQFjJ", function(module, exports) {

$parcel$export(module.exports, "ActionsWrapper", () => $31ed5059f3fb9550$export$c8223871eecc8f3a);
$parcel$export(module.exports, "ActionsWrapperStyled", () => $31ed5059f3fb9550$export$ac9cdc71f29d2899);
$parcel$export(module.exports, "LeftActionsWrapper", () => $31ed5059f3fb9550$export$42cb1c7ab389bf4d);
$parcel$export(module.exports, "RightActionsWrapper", () => $31ed5059f3fb9550$export$4aa2cd250ec24dcc);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $dCm1o = parcelRequire("dCm1o");

var $7XYc4 = parcelRequire("7XYc4");

var $g3TqM = parcelRequire("g3TqM");

var $lmBAt = parcelRequire("lmBAt");

var $4R6GH = parcelRequire("4R6GH");

var $bUSNl = parcelRequire("bUSNl");
const $31ed5059f3fb9550$export$c8223871eecc8f3a = ({ children: children, testId: testId })=>{
    const [{ content: content }] = (0, $bUSNl.useSidebar)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($31ed5059f3fb9550$export$ac9cdc71f29d2899, {
        sidebarOpen: !!content,
        "data-testid": testId,
        visualRefresh: (0, $dCm1o.isVisualRefreshEnabled)()
    }, children);
};
const $31ed5059f3fb9550$var$actionsWrapperStyles = {
    root: "_1e0c1txw _ca0qutpp _u5f31ejb _n3tdutpp _19bv1ejb _19pkidpf _2hwx10v4 _otyrpxbi _18u010v4 _bfhk1iew _kqswh2mm _1kt9f705 _1cs8stnw _kfgt1osq _1mp41osq _m9csad7r _1aukidpf _qnecidpf",
    increaseVerticalPadding: "_ca0qv47k _n3tdv47k",
    noRightMargin: "_2hwxidpf",
    noBottomMargin: "_otyridpf"
};
const $31ed5059f3fb9550$var$actionsWrapperInnerStyles = {
    root: "_zulpu2gc _16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _1tke1ylp _4cvr1h6o _1n261g80 _kqswh2mm"
};
const $31ed5059f3fb9550$export$3ca8f6d44a62ab0 = ({ sidebarOpen: sidebarOpen, hasBottomSpacing: hasBottomSpacing = true, visualRefresh: visualRefresh, children: children })=>{
    const Wrapper = (0, $lmBAt.getIsSoftwareThemingM2Enabled)() ? (0, $g3TqM.ContrastThemeWrapper) : (0, $5uXOq.Fragment);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            $31ed5059f3fb9550$var$actionsWrapperStyles.root,
            visualRefresh && $31ed5059f3fb9550$var$actionsWrapperStyles.increaseVerticalPadding,
            !visualRefresh && sidebarOpen && $31ed5059f3fb9550$var$actionsWrapperStyles.noRightMargin,
            !hasBottomSpacing && $31ed5059f3fb9550$var$actionsWrapperStyles.noBottomMargin
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            $31ed5059f3fb9550$var$actionsWrapperInnerStyles.root
        ])
    }, children)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $31ed5059f3fb9550$var$CenterAlignedWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulpu2gc _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $31ed5059f3fb9550$var$ActionsWrapperStyledOld = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $31ed5059f3fb9550$var$CenterAlignedWrapper, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1w54sxz": (0, $lD23V.default)((()=>{
                if (__cmplp.visualRefresh) return `0 ${"var(--ds-space-negative-300, -24px)"} ${__cmplp.hasBottomSpacing ?? true ? "var(--ds-space-200, 16px)" : 0} ${"var(--ds-space-negative-300, -24px)"}`;
                return `0 ${__cmplp.sidebarOpen ? 0 : "var(--ds-space-negative-300, -24px)"} ${__cmplp.hasBottomSpacing ?? true ? "var(--ds-space-200, 16px)" : 0} ${"var(--ds-space-negative-300, -24px)"}`;
            })())
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18s8c1cy _1tke1ylp _1n261g80 _bfhk1iew _18k9ad7r",
            __cmplp.visualRefresh ? "_1yt41big" : "_1yt46hdp",
            __cmplp.className
        ])
    });
});
const $31ed5059f3fb9550$export$42cb1c7ab389bf4d = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $31ed5059f3fb9550$var$CenterAlignedWrapper, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug",
            __cmplp.className
        ])
    });
});
const $31ed5059f3fb9550$export$4aa2cd250ec24dcc = $31ed5059f3fb9550$var$CenterAlignedWrapper;
const $31ed5059f3fb9550$export$ac9cdc71f29d2899 = (0, $7XYc4.componentWithCondition)(()=>(0, $4R6GH.fg)('bugfix_stacking_context_of_navigation'), $31ed5059f3fb9550$export$3ca8f6d44a62ab0, $31ed5059f3fb9550$var$ActionsWrapperStyledOld);

});
parcelRegister("g3TqM", function(module, exports) {

$parcel$export(module.exports, "ContrastThemeWrapper", () => $7d5fccb6e2bd27bd$export$83167134ef4aca8c);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");


var $a2e2Q = parcelRequire("a2e2Q");
const $7d5fccb6e2bd27bd$export$83167134ef4aca8c = ({ children: children })=>{
    const { isSoftwareProject: isSoftwareProject } = (0, $a2e2Q.useSoftwareProjectTheming)();
    if (isSoftwareProject) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $7d5fccb6e2bd27bd$var$overrideStyles
    }, children);
    return children;
};
const $7d5fccb6e2bd27bd$var$overrideStyles = (0, $8CUq3.xcss)({
    // @ts-expect-error Object literal may only specify known properties, and ''--ds-background-brand-bold'' does not exist in type 'SafeCSSObject'.ts(2353)
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--project-color-text': `var(${(0, $5b25b2eb4e8be764$export$7748fdcd335afdc0)}, ${"var(--ds-text, #172B4D)"})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--project-color-text-subtle': `var(${(0, $5b25b2eb4e8be764$export$fac615ceaa871e35)}, ${"var(--ds-text-subtle, #44546F)"})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    '--project-color-border': `var(${(0, $5b25b2eb4e8be764$export$4cd72d361867c565)}, ${"var(--ds-border, #091E4224)"})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    '--project-background-selected': `var(${(0, $5b25b2eb4e8be764$export$6377a47d5e33fe0c)}, ${"var(--ds-background-selected, #E9F2FF)"})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    '--project-color-border-selected': `var(${(0, $5b25b2eb4e8be764$export$e2e8fadb946a45d2)}, ${"var(--ds-border-selected, #0C66E4)"})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    '--project-color-text-selected': `var(${(0, $5b25b2eb4e8be764$export$7d1315b9160d905c)}, ${"var(--ds-text-selected, #0C66E4)"})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    '--project-text-accent-selected': `var(${(0, $5b25b2eb4e8be764$export$b7b95e9772d9313)}, ${"var(--ds-text-selected, #0C66E4)"})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    '--project-color-background-input': `var(${(0, $5b25b2eb4e8be764$export$6c9f7212e806df4b)}, ${"var(--ds-background-input, #FFFFFF)"})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    '--project-color-background-brand-bold': `var(${(0, $5b25b2eb4e8be764$export$7156de003aaa81f0)}, ${"var(--ds-background-brand-bold, #0C66E4)"})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    '--project-color-text-inverse': `var(${(0, $5b25b2eb4e8be764$export$8993323021b69878)}, ${"var(--ds-text-inverse, #FFFFFF)"})`
});

});
const $5b25b2eb4e8be764$export$d1b9ea3245b6a5de = 3;
const $5b25b2eb4e8be764$export$d07bba395c9390f1 = 32;
const $5b25b2eb4e8be764$export$29911ec08ab2ca2d = 5;
const $5b25b2eb4e8be764$export$b61e6f89a9db76de = 4;
const $5b25b2eb4e8be764$export$7fd2e391116c6ef5 = 9;
const $5b25b2eb4e8be764$export$e1633e494d305bfb = 'MORE';
const $5b25b2eb4e8be764$export$1cfe9795423425c = '--horizontal-navigation-color-background-neutral-hovered';
const $5b25b2eb4e8be764$export$539c074adec2188a = '--horizontal-navigation-color-link';
const $5b25b2eb4e8be764$export$6f76912df5477959 = '--horizontal-navigation-color-link-pressed';
const $5b25b2eb4e8be764$export$fac615ceaa871e35 = '--horizontal-navigation-color-text-subtle';
const $5b25b2eb4e8be764$export$7748fdcd335afdc0 = '--horizontal-navigation-color-text';
const $5b25b2eb4e8be764$export$88e550ed188132a7 = '--horizontal-navigation-color-elevation-surface';
const $5b25b2eb4e8be764$export$e2e8fadb946a45d2 = '--horizontal-navigation-color-border-selected';
const $5b25b2eb4e8be764$export$4cd72d361867c565 = '--horizontal-navigation-color-border';
const $5b25b2eb4e8be764$export$be4d7e23cb48401e = '--horizontal-navigation-color-background-neutral';
const $5b25b2eb4e8be764$export$8dd437f6d09d567 = '--horizontal-navigation-color-background-neutral-selected';
const $5b25b2eb4e8be764$export$cf26c31143daa350 = '--hn-yjlbv';
const $5b25b2eb4e8be764$export$6377a47d5e33fe0c = '--horizontal-navigation-background-selected';
const $5b25b2eb4e8be764$export$7d1315b9160d905c = '--horizontal-navigation-color-text-selected';
const $5b25b2eb4e8be764$export$b7b95e9772d9313 = '--horizontal-navigation-text-accent-selected';
const $5b25b2eb4e8be764$export$6c9f7212e806df4b = '--horizontal-navigation-color-background-input';
const $5b25b2eb4e8be764$export$7156de003aaa81f0 = '--horizontal-navigation-color-background-brand-bold';
const $5b25b2eb4e8be764$export$8993323021b69878 = '--horizontal-navigation-color-text-inverse';



parcelRegister("5hI3W", function(module, exports) {

$parcel$export(module.exports, "Filters", () => $afeed5d78bb3bf98$export$92a576f896a9bf72);

var $5uXOq = parcelRequire("5uXOq");

var $7mPT9 = parcelRequire("7mPT9");

var $jgJNO = parcelRequire("jgJNO");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $l8ruj = parcelRequire("l8ruj");

var $4R6GH = parcelRequire("4R6GH");

var $lM9c1 = parcelRequire("lM9c1");

var $1TU9r = parcelRequire("1TU9r");

var $gxGcZ = parcelRequire("gxGcZ");

var $dpQnO = parcelRequire("dpQnO");

var $ab4a1 = parcelRequire("ab4a1");

var $6xNkv = parcelRequire("6xNkv");
const $afeed5d78bb3bf98$var$hiddenQuickFiltersDefault = [
    'ACTIVE_SPRINTS'
];
const $afeed5d78bb3bf98$export$92a576f896a9bf72 = /*#__PURE__*/ (0, $5uXOq.memo)(({ view: view, allowedFieldTypes: inputAllowedFieldTypes, allowedAliasFieldId: allowedAliasFieldId, hiddenQuickFilters: hiddenQuickFilters = $afeed5d78bb3bf98$var$hiddenQuickFiltersDefault, allowCustomFields: allowCustomFields, allowSavedFilters: allowSavedFilters = true, handleHasFiltersApplied: handleHasFiltersApplied, appearance: appearance })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const allowedFieldTypes = (0, $gxGcZ.useAllowedFieldTypes)(inputAllowedFieldTypes);
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const triggerRef = (0, $5uXOq.useRef)(null);
    const close = (0, $5uXOq.useCallback)(()=>{
        setIsOpen(false);
        if ((0, $4R6GH.fg)('wanjel-a11y-enterprise-grade')) triggerRef.current?.focus();
    }, []);
    const toggle = (0, $5uXOq.useCallback)(()=>{
        setIsOpen((prevIsOpen)=>!prevIsOpen);
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'jwmFilterButton clicked');
    }, [
        createAnalyticsEvent
    ]);
    const { quickFilters: quickFilters, persistQuickFilters: setQuickFilters } = (0, $dpQnO.useQuickFilters)();
    const { filters: filters, fieldConfig: fieldConfig, customFieldsLoader: customFieldsLoader, hasFilterError: hasFilterError, setFilters: setFilters } = (0, $1TU9r.useDeserialiseJqlFiltersWithContext)({
        view: view,
        allowedFieldTypes: allowedFieldTypes,
        allowedAliasFieldId: allowedAliasFieldId,
        allowCustomFields: allowCustomFields
    });
    const count = Object.values(filters).flat().length + Object.values(quickFilters).filter((value)=>value).length;
    (0, $5uXOq.useEffect)(()=>{
        if (handleHasFiltersApplied) handleHasFiltersApplied(count);
    }, [
        count,
        handleHasFiltersApplied
    ]);
    (0, $lM9c1.useGoalsFilterAnalyticsEvent)({
        filters: filters,
        view: view
    });
    const hasFiltersApplied = count > 0 || hasFilterError;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "business-filters"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        isOpen: isOpen,
        onClose: close,
        placement: "bottom-end",
        messageId: "business-filters.ui.filters.popup",
        messageType: "transactional",
        autoFocus: !(0, $4R6GH.fg)('wanjel-a11y-enterprise-grade'),
        ...(0, $4R6GH.fg)('wanjel-fix-rendertoparent-header-popup-in-board') ? {
            shouldRenderToParent: true,
            strategy: 'absolute'
        } : {},
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ab4a1.MenuContent), {
                "data-testid": "business-filters.ui.filters.menu-content",
                count: count,
                fieldConfig: fieldConfig,
                filters: filters,
                quickFilters: quickFilters,
                setQuickFilters: setQuickFilters,
                setFilters: setFilters,
                hiddenQuickFilters: hiddenQuickFilters,
                view: view,
                allowCustomFields: allowCustomFields,
                allowSavedFilters: allowSavedFilters,
                hasFilterError: hasFilterError
            })),
        trigger: ({ ref: ref, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6xNkv.Trigger), {
                ...triggerProps,
                appearance: appearance,
                count: count,
                hasFiltersApplied: hasFiltersApplied,
                isSelected: isOpen,
                onClick: toggle,
                ref: (0, $4R6GH.fg)('wanjel-a11y-enterprise-grade') ? (0, $7mPT9.mergeRefs)(triggerRef, ref) : ref
            })
    }), customFieldsLoader));
});

});
parcelRegister("lM9c1", function(module, exports) {

$parcel$export(module.exports, "useGoalsFilterAnalyticsEvent", () => $a083b46fb378eaf3$export$c9b2aef46b42c898);

var $5uXOq = parcelRequire("5uXOq");

var $5fc53 = parcelRequire("5fc53");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $8DJTW = parcelRequire("8DJTW");
const $a083b46fb378eaf3$export$c9b2aef46b42c898 = ({ filters: filters, view: view })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { data: filterFields } = (0, $8DJTW.useFilterFields)();
    const goalField = (0, $5uXOq.useMemo)(()=>filterFields.find((field)=>field.type === (0, $5fc53.GOALS_CF_TYPE)), [
        filterFields
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (goalField && filters[goalField.id]) {
            const goalsFilter = filters[goalField.id];
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'goalsFilter applied', {
                source: view,
                goalsCount: Array.isArray(goalsFilter) ? goalsFilter.length : 0
            });
        }
    }, [
        createAnalyticsEvent,
        filters,
        goalField,
        view
    ]);
};

});

parcelRegister("ab4a1", function(module, exports) {

$parcel$export(module.exports, "MenuContent", () => $1b74022ad6f4d372$export$479f0f2f71193efe);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

var $hMVQe = parcelRequire("hMVQe");

var $kn3Xd = parcelRequire("kn3Xd");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $1b74022ad6f4d372$var$LazyMenuContent = (0, $kxZPA.lazy)(()=>(parcelRequire("aOglh")), {
    moduleId: "./src/packages/business/shared/components/filters/src/ui/filters/menu-content/main.tsx"
});
const $1b74022ad6f4d372$export$479f0f2f71193efe = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kn3Xd.DropdownWrapper), {
        "data-testid": "business-filters.ui.filters.menu-content"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "menu-content",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hMVQe.MenuFallback), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1b74022ad6f4d372$var$LazyMenuContent, props)));

});
parcelRegister("hMVQe", function(module, exports) {

$parcel$export(module.exports, "MenuFallback", () => $a630aa0f7c48ef76$export$1198e585d599d03);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $eZJjh = parcelRequire("eZJjh");
const $a630aa0f7c48ef76$export$1198e585d599d03 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a630aa0f7c48ef76$var$SpinnerWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
        size: "medium",
        testId: "business-filters.common.ui.menu-fallback.spinner"
    }));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a630aa0f7c48ef76$var$SpinnerWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi",
            __cmplp.className
        ])
    });
});

});

parcelRegister("kn3Xd", function(module, exports) {

$parcel$export(module.exports, "DropdownWrapper", () => $5ca6b1e17ddf2f10$export$5f7211d21bfdae05);
$parcel$export(module.exports, "ScrollableContent", () => $5ca6b1e17ddf2f10$export$6c560fdadeb11d78);
$parcel$export(module.exports, "DropdownHeaderWrapper", () => $5ca6b1e17ddf2f10$export$e23294aded7a8a49);
$parcel$export(module.exports, "DropdownHeaderButtons", () => $5ca6b1e17ddf2f10$export$53ca7a3701b98335);
$parcel$export(module.exports, "FiltersListSeparator", () => $5ca6b1e17ddf2f10$export$1a67069896d998b9);
$parcel$export(module.exports, "FiltersListWrapper", () => $5ca6b1e17ddf2f10$export$a5a9080bd2c85987);
$parcel$export(module.exports, "Section", () => $5ca6b1e17ddf2f10$export$6e2c8f0811a474ce);
$parcel$export(module.exports, "LastSection", () => $5ca6b1e17ddf2f10$export$1faf3c7558df435);
$parcel$export(module.exports, "SectionMessageWrapper", () => $5ca6b1e17ddf2f10$export$c5e20d5e200edfe2);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $gzkAf = parcelRequire("gzkAf");
const $5ca6b1e17ddf2f10$var$DROPDOWN_HEADER_HEIGHT = 52;
const $5ca6b1e17ddf2f10$var$DROPDOWN_HEADER_VERTICAL_PADDING = "var(--ds-space-150, 12px)";
const $5ca6b1e17ddf2f10$export$5f7211d21bfdae05 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1ul91gwv",
            __cmplp.className
        ])
    });
});
const $5ca6b1e17ddf2f10$export$6c560fdadeb11d78 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { offsetTop: offsetTop, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1uik9ob": (0, $lD23V.default)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            `calc(${__cmplp.offsetTop && __cmplp.offsetTop > (0, $gzkAf.POPUP_OFFSET_TOP) ? '95vh' : '85vh'} - ${// dynamically calculating offsetTop on popup mount
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (__cmplp.offsetTop ?? (0, $gzkAf.POPUP_OFFSET_TOP)) + $5ca6b1e17ddf2f10$var$DROPDOWN_HEADER_HEIGHT}px)`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo1wug _18m91wug _ln19p27b _c71l1pam",
            __cmplp.className
        ])
    });
});
const $5ca6b1e17ddf2f10$export$e23294aded7a8a49 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { stickyHeader: stickyHeader, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11q71bhr _2rko1sit _1yt4jd10 _11c8dcr7 _1pbykb7n _kqswh2mm _1e0c1txw _1bah1yb4 _4cvr1h6o _1tke1ejb",
            __cmplp.stickyHeader ? "_16qs9g9j" : "_16qsglyw",
            __cmplp.className
        ])
    });
});
const $5ca6b1e17ddf2f10$export$53ca7a3701b98335 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bahesu3",
            __cmplp.className
        ])
    });
});
const $5ca6b1e17ddf2f10$export$1a67069896d998b9 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18s81alc _x3dozgxb",
            __cmplp.className
        ])
    });
});
const $5ca6b1e17ddf2f10$export$a5a9080bd2c85987 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_p12f1gwv",
            __cmplp.className
        ])
    });
});
const $5ca6b1e17ddf2f10$export$6e2c8f0811a474ce = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulp1f4h _1e0c1txw _2lx21bp4 _n3td1f4h",
            __cmplp.className
        ])
    });
});
const $5ca6b1e17ddf2f10$export$1faf3c7558df435 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $5ca6b1e17ddf2f10$export$6e2c8f0811a474ce, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulpidpf _n3tdidpf",
            __cmplp.className
        ])
    });
});
const $5ca6b1e17ddf2f10$export$c5e20d5e200edfe2 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi",
            __cmplp.className
        ])
    });
});

});

parcelRegister("aOglh", function(module, exports) {

let $0207ec639d971ae3$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $0207ec639d971ae3$var$load("ffQaD"),
    $0207ec639d971ae3$var$load("kvRbA"),
    $0207ec639d971ae3$var$load("kNFvF"),
    $0207ec639d971ae3$var$load("kPkde")
]).then(()=>parcelRequire('lk6eZ'));

});


parcelRegister("6xNkv", function(module, exports) {

$parcel$export(module.exports, "Trigger", () => $9499219f0b3ef189$export$41fb9f06171c75f4);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $2o8gl = parcelRequire("2o8gl");

var $hORKG = parcelRequire("hORKG");

var $dC5iT = parcelRequire("dC5iT");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $koVbs = parcelRequire("koVbs");

var $22OQR = parcelRequire("22OQR");

var $dCm1o = parcelRequire("dCm1o");

var $4R6GH = parcelRequire("4R6GH");

var $fj0YT = parcelRequire("fj0YT");
const $9499219f0b3ef189$var$FILTER_ICON = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2o8gl))), {
    label: "",
    LEGACY_size: "small"
});
const $9499219f0b3ef189$export$41fb9f06171c75f4 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ onClick: onClick, isSelected: isSelected, count: count, hasFiltersApplied: hasFiltersApplied, withThemedButton: withThemedButton = true, isDisabled: isDisabled, appearance: appearance = 'subtle', ...otherProps }, ref)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const filterMessageOld = (0, $5uXOq.useMemo)(()=>{
        if (count > 0) return formatMessage((0, $fj0YT.default).filtersCount, {
            filters: count
        });
        if (hasFiltersApplied) return formatMessage((0, $fj0YT.default).buttonWithFilters);
        return formatMessage((0, $fj0YT.default).filterButton);
    }, [
        count,
        formatMessage,
        hasFiltersApplied
    ]);
    const filterMessage = (0, $5uXOq.useMemo)(()=>{
        if (hasFiltersApplied && count === 0) return formatMessage((0, $fj0YT.default).buttonWithFilters);
        if ((0, $4R6GH.fg)('visual-refresh-headers-buttons')) return isSelected || count > 0 ? formatMessage((0, $fj0YT.default).filterButton) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $9499219f0b3ef189$var$triggerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
            color: "color.text.subtle",
            weight: "medium",
            maxLines: 1
        }, formatMessage((0, $fj0YT.default).filterButton)));
        return formatMessage((0, $fj0YT.default).filterButton);
    }, [
        count,
        formatMessage,
        hasFiltersApplied,
        isSelected
    ]);
    const TriggerButton = withThemedButton ? (0, $22OQR.ThemedButton) : (0, $fVnbM.default);
    return (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(TriggerButton, {
        ...otherProps,
        "aria-label": formatMessage((0, $fj0YT.default).filtersCount, {
            filters: count
        }),
        ref: ref,
        isDisabled: isDisabled,
        isSelected: isSelected || count > 0,
        onClick: onClick,
        testId: "business-filters.ui.filters.trigger.button-wrapper",
        iconAfter: count === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hORKG))), {
            label: "" // eslint-disable-next-line no-nested-ternary
            ,
            ...(0, $4R6GH.fg)('visual-refresh-headers-buttons') ? !(isSelected || count > 0) ? {
                color: "var(--ds-icon-subtle, #626F86)"
            } : {} : {
                color: 'currentColor'
            }
        }) : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9499219f0b3ef189$var$ButtonContents, null, filterMessage, count > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9499219f0b3ef189$var$BadgeContents, null, count))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(TriggerButton, {
        ...otherProps,
        ref: ref,
        testId: "business-filters.ui.filters.trigger.button-wrapper",
        iconBefore: $9499219f0b3ef189$var$FILTER_ICON,
        isSelected: isSelected,
        onClick: onClick,
        appearance: appearance,
        isDisabled: isDisabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9499219f0b3ef189$var$ButtonContents, null, filterMessageOld));
});
const $9499219f0b3ef189$var$triggerStyles = (0, $8CUq3.xcss)({
    paddingTop: 'space.075',
    paddingBottom: 'space.075'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9499219f0b3ef189$var$ButtonContents = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulp12x7 _1e0c1txw _2lx2vrvc _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $9499219f0b3ef189$var$BadgeContents = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qidpf _u5f36mu8 _n3tdidpf _19bv6mu8 _2rkogqwt _11c82smr _1e0c1txw _1bah1h6o _4cvr1h6o _bfhkllho _4t3i1j6v _1ul91j6v",
            __cmplp.className
        ])
    });
});

});
parcelRegister("fj0YT", function(module, exports) {

$parcel$export(module.exports, "default", () => $483bd49c4d6c7782$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $483bd49c4d6c7782$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    filtersCount: {
        "id": "business-filters.filters.trigger.filters-count",
        "defaultMessage": "{filters, number} {filters, plural, one {filter applied} other {filters applied}}"
    },
    filterButton: {
        "id": "business-filters.filters.trigger.filter-button",
        "defaultMessage": "Filter"
    },
    buttonWithFilters: {
        "id": "business-filters.filters.trigger.button-with-filters",
        "defaultMessage": "Filters applied"
    },
    newLozenge: {
        "id": "business-filters.filters.trigger.new-lozenge",
        "defaultMessage": "New"
    },
    newLozengeTooltip: {
        "id": "business-filters.filters.trigger.new-lozenge-tooltip",
        "defaultMessage": "Now you can save your frequently used filters. Apply some filters to get started."
    }
});

});



parcelRegister("4Mmyc", function(module, exports) {

$parcel$export(module.exports, "SimpleSearchTextField", () => $c9154e4bfb02bfbe$export$63f96dda4bd4f7dc);
$parcel$export(module.exports, "SimpleSearchField", () => $c9154e4bfb02bfbe$export$44e8ccf3428dc1d5);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $42CjB = parcelRequire("42CjB");

var $84THj = parcelRequire("84THj");

var $26g7Y = parcelRequire("26g7Y");

var $hyOJh = parcelRequire("hyOJh");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $kY99m = parcelRequire("kY99m");

var $6cG4N = parcelRequire("6cG4N");

var $koVbs = parcelRequire("koVbs");

var $jDrwg = parcelRequire("jDrwg");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $dCm1o = parcelRequire("dCm1o");

var $l4v6E = parcelRequire("l4v6E");

var $1T1ir = parcelRequire("1T1ir");

var $emybt = parcelRequire("emybt");
const $c9154e4bfb02bfbe$var$SEARCH_FIELD_WIDTH = 184;
const $c9154e4bfb02bfbe$export$63f96dda4bd4f7dc = /*#__PURE__*/ (0, $5uXOq.memo)(({ inputRef: inputRef, placeholder: placeholder, value: externalValue = '', onChange: onChange, onFocus: onFocus, view: view, testId: testId = 'searchfield', isDisabled: isDisabled, label: label, describedbyId: describedbyId, themedField: themedField = true, isFullWidth: isFullWidth = false })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [searchValue, setSearchValue] = (0, $5uXOq.useState)(externalValue);
    const handleSearchChange = (0, $5uXOq.useCallback)((newValue)=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'simpleSearchField updated', {
            view: view,
            ...(0, $l4v6E.getTextFieldAttributes)(newValue)
        });
        onChange(newValue);
    }, [
        createAnalyticsEvent,
        onChange,
        view
    ]);
    const [handleSearchChangeDebounced] = (0, $jDrwg.default)(handleSearchChange, 500);
    const handleChange = (0, $5uXOq.useCallback)((e)=>{
        setSearchValue(e.target.value);
        handleSearchChangeDebounced(e.target.value);
    }, [
        handleSearchChangeDebounced
    ]);
    const handleClear = (0, $5uXOq.useCallback)(()=>{
        setSearchValue('');
        handleSearchChangeDebounced('');
    }, [
        setSearchValue,
        handleSearchChangeDebounced
    ]);
    const themedIconPrimaryColor = isDisabled ? (0, $6cG4N.Tokens).COLOR_TEXT_DISABLED : (0, $6cG4N.Tokens).COLOR_TEXT_SUBTLEST; // eslint-disable-next-line no-nested-ternary
    const Container = themedField ? (0, $dCm1o.isVisualRefreshEnabled)() ? $c9154e4bfb02bfbe$var$ThemedContainer : $c9154e4bfb02bfbe$var$ThemedContainerOld : (0, $5uXOq.Fragment);
    (0, $5uXOq.useEffect)(()=>{
        setSearchValue(externalValue);
    }, [
        externalValue
    ]);
    const elemAfterSearchIcon = !(0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($26g7Y))), {
        label: "",
        color: "currentColor",
        LEGACY_size: "small",
        LEGACY_primaryColor: themedField ? themedIconPrimaryColor : undefined
    }) : null;
    let textFieldWidth;
    if ((0, $dCm1o.isVisualRefreshEnabled)()) textFieldWidth = isFullWidth ? '100%' : $c9154e4bfb02bfbe$var$SEARCH_FIELD_WIDTH;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kY99m.default), {
        ref: inputRef,
        "aria-describedby": describedbyId,
        testId: testId,
        value: searchValue,
        isCompact: true,
        placeholder: formatMessage(placeholder),
        "aria-label": label || formatMessage(placeholder),
        onChange: handleChange,
        onFocus: onFocus,
        isDisabled: isDisabled,
        elemAfterInput: searchValue !== '' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            paddingInlineEnd: (0, $dCm1o.isVisualRefreshEnabled)() ? 'space.025' : undefined
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
            icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($84THj))), {
                    ...iconProps,
                    label: formatMessage((0, $emybt.default).clear),
                    spacing: "none",
                    color: "var(--ds-text, #172B4D)",
                    LEGACY_size: "small",
                    LEGACY_primaryColor: themedField ? themedIconPrimaryColor : undefined
                }),
            appearance: "subtle",
            spacing: "compact",
            label: formatMessage((0, $emybt.default).clear),
            testId: "business-filters.ui.simple-search-field.clear-button",
            onClick: handleClear
        })) : elemAfterSearchIcon,
        elemBeforeInput: (0, $dCm1o.isVisualRefreshEnabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $c9154e4bfb02bfbe$var$iconStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hyOJh))), {
            color: "currentColor",
            label: "",
            spacing: "none"
        })),
        width: textFieldWidth,
        className: (0, $bwpsq.default)([
            !(0, $dCm1o.isVisualRefreshEnabled)() && "_dzcou2gc"
        ])
    }));
});
const $c9154e4bfb02bfbe$export$44e8ccf3428dc1d5 = /*#__PURE__*/ (0, $5uXOq.memo)(({ placeholder: placeholder, view: view, describedbyId: describedbyId, onChange: onChange })=>{
    const [simpleSearch, setSimpleSearch] = (0, $1T1ir.useSimpleSearch)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const handleFocus = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'simpleSearchField focused', {
            view: view
        });
    }, [
        createAnalyticsEvent,
        view
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (onChange) onChange(simpleSearch);
    }, [
        onChange,
        simpleSearch
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c9154e4bfb02bfbe$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c9154e4bfb02bfbe$export$63f96dda4bd4f7dc, {
        view: view,
        onFocus: handleFocus,
        describedbyId: describedbyId,
        onChange: (text)=>{
            if (onChange) onChange(text);
            return setSimpleSearch(text);
        },
        value: simpleSearch,
        placeholder: placeholder
    }));
});
const $c9154e4bfb02bfbe$var$textFieldStyles = null;
const $c9154e4bfb02bfbe$var$iconStyles = (0, $8CUq3.xcss)({
    display: 'inline-flex',
    marginLeft: 'space.075'
}); /* eslint-disable @atlaskit/design-system/no-unsafe-design-token-usage */ 
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c9154e4bfb02bfbe$var$ThemedContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_6l8rjjc1 _x2xkjjc1 _sg3vjjc1 _w15ajjc1 _n8yf4zrn _jeievy9e _7n83frbu _1o8h13fh _n2ul1jo4",
            __cmplp.className
        ])
    });
}); /* eslint-enable @atlaskit/design-system/no-unsafe-design-token-usage */ 
const $c9154e4bfb02bfbe$var$ThemedContainerOld = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $c9154e4bfb02bfbe$var$ThemedContainer, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_n8yfim6e",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c9154e4bfb02bfbe$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("l4v6E", function(module, exports) {

$parcel$export(module.exports, "getTextFieldAttributes", () => $211f318fc379b0d9$export$dfd7972bcd113afb);
const $211f318fc379b0d9$export$dfd7972bcd113afb = (value = '')=>{
    const wordCount = value.split(/s+/).filter((word)=>word !== '').length;
    return {
        queryLength: value.length,
        wordCount: wordCount
    };
};

});

parcelRegister("emybt", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5a1b27b61b41126$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $a5a1b27b61b41126$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    clear: {
        "id": "business-filters.simple-search-field.clear",
        "defaultMessage": "Clear"
    }
});

});


parcelRegister("17X6Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a40c8fa5f1e21a1$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $b71gk = parcelRequire("b71gk");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

var $e1OxR = parcelRequire("e1OxR");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $0a40c8fa5f1e21a1$var$LazyAddPeopleWithAvatars = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("67GjI")), {
    ssr: false,
    moduleId: "./src/packages/business/shared/components/invite-people/src/ui/add-people-with-avatars/main.tsx"
});
const $0a40c8fa5f1e21a1$var$AddPeopleWithAvatar = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "async.jira-business.invite-people.add-people-with-avatars",
        packageName: "jiraBusinessInvitePeople",
        teamName: "jira-warepil"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "invite-button-with-avatars",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0a40c8fa5f1e21a1$var$AvatarFallback, null)
    }, props?.hasInviteButton === false ? // not including the Add People provider if the invite button is not needed
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0a40c8fa5f1e21a1$var$LazyAddPeopleWithAvatars, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e1OxR.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0a40c8fa5f1e21a1$var$LazyAddPeopleWithAvatars, props))));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0a40c8fa5f1e21a1$var$AvatarFallback = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1ylp",
            __cmplp.className
        ])
    });
});
var $0a40c8fa5f1e21a1$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($0a40c8fa5f1e21a1$var$AddPeopleWithAvatar);

});
parcelRegister("e1OxR", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f3117b4e456671f$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $b71gk = parcelRequire("b71gk");

var $7wK4b = parcelRequire("7wK4b");

var $bZLPe = parcelRequire("bZLPe");
const $0f3117b4e456671f$var$AddPeopleModal = ({ shouldUseInvitePeopleModal: shouldUseInvitePeopleModal, source: source })=>{
    const { isModalOpen: isModalOpen, closeAddPeopleModal: closeAddPeopleModal } = (0, $7wK4b.useAddPeople)();
    if (isModalOpen) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bZLPe.ProjectInvitePeopleModal), {
        onModalClose: closeAddPeopleModal,
        shouldUseInvitePeopleModal: shouldUseInvitePeopleModal,
        source: source
    });
    return null;
};
const $0f3117b4e456671f$var$AddPeople = ({ children: children, shouldUseInvitePeopleModal: shouldUseInvitePeopleModal, source: source })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7wK4b.AddPeopleProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "jira-business.invite-people.ui.add-people",
        packageName: "jira-business.invite-people.ui.add-people",
        teamName: "jira-warepil"
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0f3117b4e456671f$var$InviteWrapper, {
        "data-testid": "business-invite-people.ui.add-people-with-avatars.add-people.invite-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0f3117b4e456671f$var$AddPeopleModal, {
        shouldUseInvitePeopleModal: shouldUseInvitePeopleModal,
        source: source
    }))));
var $0f3117b4e456671f$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($0f3117b4e456671f$var$AddPeople);
// this wrapper prevents the modal component to inherit any css logic from its parent, which could cause interferences in the consumer's UI
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0f3117b4e456671f$var$InviteWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0cglyw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("7wK4b", function(module, exports) {

$parcel$export(module.exports, "AddPeopleProvider", () => $3ebbf4ad1e53c7be$export$6d41c2327e862d9d);
$parcel$export(module.exports, "useAddPeople", () => $3ebbf4ad1e53c7be$export$93ea361ec674cff6);

var $5uXOq = parcelRequire("5uXOq");

var $daQYX = parcelRequire("daQYX");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");
const $3ebbf4ad1e53c7be$var$AddPeopleContext = /*#__PURE__*/ (0, $5uXOq.createContext)({
    triggerBtnRef: {
        current: null
    },
    isModalOpen: false,
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    openAddPeopleModal: ()=>{},
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    closeAddPeopleModal: ()=>{}
});
const $3ebbf4ad1e53c7be$export$6d41c2327e862d9d = ({ children: children })=>{
    const projectData = (0, $daQYX.useProject)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [isModalOpen, setIsModalOpen] = (0, $5uXOq.useState)(false);
    const triggerBtnRef = (0, $5uXOq.useRef)(null);
    const onCloseCallbackRef = (0, $5uXOq.useRef)();
    const openAddPeopleModal = (0, $5uXOq.useCallback)((onClose, source)=>{
        setIsModalOpen(true);
        const eventName = projectData.isSimplified ? 'jwmProjectInviteComponent' : 'jwmInstanceInviteComponent';
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', eventName, {
            source: source
        });
        if (onClose) onCloseCallbackRef.current = onClose;
    }, [
        createAnalyticsEvent,
        projectData.isSimplified
    ]);
    const closeAddPeopleModal = (0, $5uXOq.useCallback)(()=>{
        setIsModalOpen(false);
        if (typeof onCloseCallbackRef.current === 'function') {
            onCloseCallbackRef.current();
            onCloseCallbackRef.current = null;
        }
    }, []);
    const context = (0, $5uXOq.useMemo)(()=>({
            triggerBtnRef: triggerBtnRef,
            isModalOpen: isModalOpen,
            openAddPeopleModal: openAddPeopleModal,
            closeAddPeopleModal: closeAddPeopleModal
        }), [
        triggerBtnRef,
        isModalOpen,
        openAddPeopleModal,
        closeAddPeopleModal
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3ebbf4ad1e53c7be$var$AddPeopleContext.Provider, {
        value: context
    }, children);
};
const $3ebbf4ad1e53c7be$export$93ea361ec674cff6 = ()=>(0, $5uXOq.useContext)($3ebbf4ad1e53c7be$var$AddPeopleContext);

});

parcelRegister("bZLPe", function(module, exports) {

$parcel$export(module.exports, "ProjectInvitePeopleModal", () => $74aeebd820c67267$export$6dfea89767cb5ac1);

var $5uXOq = parcelRequire("5uXOq");

var $daQYX = parcelRequire("daQYX");

var $2erM2 = parcelRequire("2erM2");

var $cb8cx = parcelRequire("cb8cx");

var $9AFuM = parcelRequire("9AFuM");
const $74aeebd820c67267$export$6dfea89767cb5ac1 = ({ onModalClose: onModalClose, shouldUseInvitePeopleModal: shouldUseInvitePeopleModal = false, source: source })=>{
    const projectData = (0, $daQYX.useProject)();
    const { handleAddSuccess: handleAddSuccess, handleError: handleError } = (0, $2erM2.useInviteModalHandlers)();
    if (!shouldUseInvitePeopleModal && projectData.isSimplified) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cb8cx.AddPeopleModal), {
        onModalClose: onModalClose,
        onInviteSuccess: handleAddSuccess,
        onInviteError: handleError
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9AFuM.InvitePeopleModal), {
        onModalClose: onModalClose,
        onInviteSuccess: handleAddSuccess,
        onInviteError: handleError,
        source: source
    });
};

});
parcelRegister("2erM2", function(module, exports) {

$parcel$export(module.exports, "useInviteModalHandlers", () => $d23a63b1c343bca5$export$f696e14fc423d0b);

var $5uXOq = parcelRequire("5uXOq");

var $daQYX = parcelRequire("daQYX");

var $jcw0u = parcelRequire("jcw0u");

var $pa9q9 = parcelRequire("pa9q9");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $9OXo1 = parcelRequire("9OXo1");


var $99ejj = parcelRequire("99ejj");

var $kPioc = parcelRequire("kPioc");
const $d23a63b1c343bca5$export$f696e14fc423d0b = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { showFlag: showFlag } = (0, $pa9q9.useFlagService)();
    const { isSiteAdmin: isSiteAdmin } = (0, $9OXo1.useTenantContext)();
    const projectData = (0, $daQYX.useProject)();
    const handleAddSuccess = (0, $5uXOq.useCallback)(({ modalType: modalType, totalPeopleAdded: totalPeopleAdded, email: email, inviteStatus: inviteStatus })=>{
        const hasSentInvitation = inviteStatus === (0, $99ejj.InvitationStatusEnum).INVITED;
        const hasSuccessfullyAddedPeople = !inviteStatus && projectData.permissions.administerProject;
        showFlag(hasSuccessfullyAddedPeople ? (0, $kPioc.createAddSuccessFlagConfig)({
            totalPeopleAdded: totalPeopleAdded,
            email: email,
            projectKey: projectData.key
        }) : (0, $kPioc.createInviteSuccessFlagConfig)({
            totalPeopleAdded: totalPeopleAdded,
            email: email,
            hasSentInvitation: hasSentInvitation
        }));
        // The event tracked by the Invite People SLOs
        (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), `jwm${modalType}Invite success`, {
            inviteStatus: inviteStatus
        });
    }, [
        createAnalyticsEvent,
        showFlag,
        projectData
    ]);
    const handleError = (0, $5uXOq.useCallback)(({ modalType: modalType, errorMessage: errorMessage, statusCode: statusCode })=>{
        if (errorMessage.includes((0, $20132b2015719a62$export$4e427f77b64bbbed)) || errorMessage.includes((0, $20132b2015719a62$export$20ef020abfaa9ec))) {
            showFlag((0, $kPioc.createInviteFailedUserLimitFlagConfig)(isSiteAdmin, createAnalyticsEvent));
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'userLimit reached', `jwm${modalType}Invite`);
            return;
        }
        if (errorMessage.includes((0, $20132b2015719a62$export$a1d765adf759361e))) showFlag((0, $kPioc.inviteFailBadRequestFlagConfig));
        else if (errorMessage.includes((0, $20132b2015719a62$export$c7f012c6e67c4217))) showFlag((0, $kPioc.inviteFailNetworkErrorFlagConfig));
        else if (errorMessage.includes((0, $20132b2015719a62$export$c8a538cf4ae41623)) || errorMessage.includes((0, $20132b2015719a62$export$9bbcbc11675c1278)) || errorMessage.includes((0, $20132b2015719a62$export$a51af3c30283d234))) showFlag((0, $kPioc.inviteFailGenericFlagConfig));
        else showFlag((0, $kPioc.inviteFailFlagConfig));
        const isClientError = statusCode && statusCode >= 400 && statusCode < 500;
        if (errorMessage.includes((0, $20132b2015719a62$export$14fb68f74ccc8b23)) || isClientError) return;
        (0, $jcw0u.default)({
            meta: {
                id: `jwm${modalType}Invite`,
                packageName: (0, $20132b2015719a62$export$b8b9d90f9e5bd72b),
                teamName: 'jira-warepil'
            },
            attributes: {
                message: errorMessage
            },
            error: new Error(errorMessage),
            sendToPrivacyUnsafeSplunk: true
        });
        // The event tracked by the Invite People SLOs
        (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), `jwm${modalType}Invite failed`);
    }, [
        createAnalyticsEvent,
        isSiteAdmin,
        showFlag
    ]);
    return {
        handleAddSuccess: handleAddSuccess,
        handleError: handleError
    };
};

});
const $20132b2015719a62$export$b8b9d90f9e5bd72b = 'jira-business.invite-people';
const $20132b2015719a62$export$a1d765adf759361e = 'Check your request, then give it another try.';
const $20132b2015719a62$export$c7f012c6e67c4217 = 'Check your network connection, then give it another try.';
const $20132b2015719a62$export$c8a538cf4ae41623 = 'AUTH_FAILED';
const $20132b2015719a62$export$9bbcbc11675c1278 = 'SERVER_ERROR';
const $20132b2015719a62$export$a51af3c30283d234 = 'USER_NOT_FOUND';
const $20132b2015719a62$export$4e427f77b64bbbed = 'LICENSE_LIMIT_REACHED';
const $20132b2015719a62$export$20ef020abfaa9ec = 'Licence Exceeded';
const $20132b2015719a62$export$14fb68f74ccc8b23 = 'Recaptcha validation failed';

parcelRegister("99ejj", function(module, exports) {

$parcel$export(module.exports, "InvitationStatusEnum", () => $e49e7d7763027049$export$2e0a7d2dc28c9a18);
const $e49e7d7763027049$export$2e0a7d2dc28c9a18 = {
    ACCESS_REQUESTED: 'ACCESS_REQUESTED',
    INVITED: 'INVITED'
};

});

parcelRegister("kPioc", function(module, exports) {

$parcel$export(module.exports, "inviteFailFlagConfig", () => $366128c003d2496b$export$95c6157ced8b3439);
$parcel$export(module.exports, "inviteFailGenericFlagConfig", () => $366128c003d2496b$export$1108ab4b8a5d8a7d);
$parcel$export(module.exports, "inviteFailBadRequestFlagConfig", () => $366128c003d2496b$export$7f2d6442eed4d708);
$parcel$export(module.exports, "inviteFailNetworkErrorFlagConfig", () => $366128c003d2496b$export$c3bdacfc2255a9ed);
$parcel$export(module.exports, "createInviteSuccessFlagConfig", () => $366128c003d2496b$export$d456881895c2a0b2);
$parcel$export(module.exports, "createAddSuccessFlagConfig", () => $366128c003d2496b$export$cca35dec2a083169);
$parcel$export(module.exports, "createInviteFailedUserLimitFlagConfig", () => $366128c003d2496b$export$251dc06b3962c565);

var $8zOmE = parcelRequire("8zOmE");

var $6OFcj = parcelRequire("6OFcj");
const $366128c003d2496b$export$8c9a09c293b933fb = ({ specificDescription: specificDescription, agnosticDescription: agnosticDescription, totalPeopleAdded: totalPeopleAdded, email: email })=>{
    if (totalPeopleAdded <= 0) return [
        agnosticDescription,
        {}
    ];
    return [
        specificDescription,
        {
            totalPeopleAddedMinusOne: totalPeopleAdded - 1,
            totalPeopleAdded: totalPeopleAdded,
            email: email
        }
    ];
};
const $366128c003d2496b$export$95c6157ced8b3439 = {
    type: 'error',
    title: (0, $6OFcj.default).inviteFailedMessageTitle,
    description: (0, $6OFcj.default).inviteFailedMessageDescription,
    actions: [
        {
            content: (0, $6OFcj.default).inviteFailedMessageCta,
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            onClick: ()=>window.open('/secure/ContactAdministrators!default.jspa', '_blank')
        }
    ],
    messageId: 'business-invite-people.controllers.modal-handlers.invite-fail-flag-config.error.error.invite-fail-flag-config',
    messageType: 'transactional'
};
const $366128c003d2496b$export$1108ab4b8a5d8a7d = {
    type: 'error',
    title: (0, $6OFcj.default).inviteFailedMessageTitle,
    description: (0, $6OFcj.default).inviteFailedGenericMessageDescription,
    messageId: 'business-invite-people.controllers.modal-handlers.invite-fail-generic-flag-config.error.error.invite-fail-generic-flag-config',
    messageType: 'transactional'
};
const $366128c003d2496b$export$7f2d6442eed4d708 = {
    type: 'error',
    title: (0, $6OFcj.default).inviteFailedMessageTitle,
    description: (0, $6OFcj.default).inviteFailedBadRequestMessageDescription,
    messageId: 'business-invite-people.controllers.modal-handlers.invite-fail-bad-request-flag-config.error.error.invite-fail-bad-request-flag-config',
    messageType: 'transactional'
};
const $366128c003d2496b$export$c3bdacfc2255a9ed = {
    type: 'error',
    title: (0, $6OFcj.default).inviteFailedMessageTitle,
    description: (0, $6OFcj.default).inviteFailedNetworkErrorMessageDescription,
    messageId: 'business-invite-people.controllers.modal-handlers.invite-fail-network-error-flag-config.error.error.invite-fail-network-error-flag-config',
    messageType: 'transactional'
};
const $366128c003d2496b$export$d456881895c2a0b2 = ({ totalPeopleAdded: totalPeopleAdded, email: email, hasSentInvitation: hasSentInvitation })=>{
    if (!hasSentInvitation) return {
        type: 'success',
        title: (0, $6OFcj.default).requestInviteSuccessMessageTitle,
        description: $366128c003d2496b$export$8c9a09c293b933fb({
            agnosticDescription: (0, $6OFcj.default).requestInviteSuccessMessageDescriptionAgnostic,
            specificDescription: (0, $6OFcj.default).requestInviteSuccessMessageDescription,
            totalPeopleAdded: totalPeopleAdded,
            email: email
        }),
        messageId: 'business-invite-people.controllers.modal-handlers.flag.success.success.request-invite-success',
        messageType: 'transactional'
    };
    return {
        type: 'success',
        title: (0, $6OFcj.default).inviteSuccessMessageTitle,
        description: $366128c003d2496b$export$8c9a09c293b933fb({
            agnosticDescription: (0, $6OFcj.default).inviteSuccessMessageDescriptionAgnostic,
            specificDescription: (0, $6OFcj.default).inviteSuccessMessageDescription,
            totalPeopleAdded: totalPeopleAdded,
            email: email
        }),
        messageId: 'business-invite-people.controllers.modal-handlers.flag.success.success.invite-success',
        messageType: 'transactional'
    };
};
const $366128c003d2496b$export$cca35dec2a083169 = ({ totalPeopleAdded: totalPeopleAdded, email: email, projectKey: projectKey })=>({
        type: 'success',
        title: (0, $6OFcj.default).peopleAddedSuccessMessageTitle,
        description: $366128c003d2496b$export$8c9a09c293b933fb({
            agnosticDescription: (0, $6OFcj.default).peopleAddedSuccessMessageDescriptionAgnostic,
            specificDescription: (0, $6OFcj.default).peopleAddedSuccessMessageDescription,
            totalPeopleAdded: totalPeopleAdded,
            email: email
        }),
        actions: [
            {
                content: (0, $6OFcj.default).peopleAddedManageAccess,
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                onClick: ()=>window.location.assign(`/jira/core/projects/${projectKey}/settings/access`)
            }
        ],
        messageId: 'business-invite-people.controllers.modal-handlers.flag.success.success.people-added-success',
        messageType: 'transactional'
    });
const $366128c003d2496b$export$251dc06b3962c565 = (isSiteAdmin, createAnalyticsEvent)=>({
        type: 'warning',
        title: (0, $6OFcj.default).userLimitInviteErrorTitle,
        description: isSiteAdmin ? (0, $6OFcj.default).userLimitInviteErrorDescriptionAdmin : (0, $6OFcj.default).userLimitInviteErrorDescription,
        actions: isSiteAdmin ? [
            {
                content: (0, $6OFcj.default).upgradePlan,
                onClick: ()=>{
                    (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'upgradePlan');
                    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                    window.open('/admin/billing/applications', '_blank');
                }
            },
            {
                content: (0, $6OFcj.default).viewUsers,
                onClick: ()=>{
                    (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'viewUsers');
                    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                    window.open('/admin/users', '_blank');
                }
            }
        ] : [
            {
                content: (0, $6OFcj.default).inviteFailedMessageCta,
                onClick: ()=>{
                    (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'contactAdmin');
                    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                    window.open('/secure/ContactAdministrators!default.jspa', '_blank');
                }
            }
        ],
        messageId: 'business-invite-people.controllers.modal-handlers.flag.warning.warning.user-limit-invite',
        messageType: 'transactional'
    });

});
parcelRegister("6OFcj", function(module, exports) {

$parcel$export(module.exports, "default", () => $d87007b6d35f6d31$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $d87007b6d35f6d31$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    inviteSuccessMessageTitle: {
        "id": "business-invite-people.controllers.modal-handlers.invite-success-message-title",
        "defaultMessage": "Invitation sent"
    },
    inviteSuccessMessageDescription: {
        "id": "business-invite-people.controllers.modal-handlers.invite-success-message-description",
        "defaultMessage": "You've invited {totalPeopleAdded, plural, one {{email}} =2 {{email} and {totalPeopleAddedMinusOne} other} other {{email} and {totalPeopleAddedMinusOne} others}} to this business project."
    },
    inviteSuccessMessageDescriptionAgnostic: {
        "id": "business-invite-people.controllers.modal-handlers.invite-success-message-description-agnostic",
        "defaultMessage": "You've successfully invited people to your business project."
    },
    inviteFailedMessageTitle: {
        "id": "business-invite-people.controllers.modal-handlers.invite-failed-message-title",
        "defaultMessage": "Something went wrong"
    },
    inviteFailedMessageDescription: {
        "id": "business-invite-people.controllers.modal-handlers.invite-failed-message-description",
        "defaultMessage": "We weren\u2019t able to invite any users. Contact your admin for help."
    },
    inviteFailedMessageCta: {
        "id": "business-invite-people.controllers.modal-handlers.invite-failed-message-cta",
        "defaultMessage": "Contact your admin"
    },
    inviteFailedGenericMessageDescription: {
        "id": "business-invite-people.controllers.modal-handlers.invite-failed-generic-message-description",
        "defaultMessage": "We weren\u2019t able to invite any users, please try again."
    },
    inviteFailedBadRequestMessageDescription: {
        "id": "business-invite-people.controllers.modal-handlers.invite-failed-bad-request-message-description",
        "defaultMessage": "We weren\u2019t able to invite any users. Check your request, then give it another try."
    },
    inviteFailedNetworkErrorMessageDescription: {
        "id": "business-invite-people.controllers.modal-handlers.invite-failed-network-error-message-description",
        "defaultMessage": "We weren\u2019t able to invite any users. Check your network connection, then give it another try."
    },
    requestInviteSuccessMessageTitle: {
        "id": "business-invite-people.controllers.modal-handlers.request-invite-success-message-title",
        "defaultMessage": "Access request sent to your admin"
    },
    requestInviteSuccessMessageDescription: {
        "id": "business-invite-people.controllers.modal-handlers.request-invite-success-message-description",
        "defaultMessage": "Your admin needs to approve access for {totalPeopleAdded, plural, one {{email}} =2 {{email} and {totalPeopleAddedMinusOne} other} other {{email} and {totalPeopleAddedMinusOne} others}}."
    },
    requestInviteSuccessMessageDescriptionAgnostic: {
        "id": "business-invite-people.controllers.modal-handlers.request-invite-success-message-description-agnostic",
        "defaultMessage": "Your admin needs to approve access for people to your business project."
    },
    peopleAddedSuccessMessageTitle: {
        "id": "business-invite-people.controllers.modal-handlers.people-added-success-message-title",
        "defaultMessage": "New people added"
    },
    peopleAddedSuccessMessageDescription: {
        "id": "business-invite-people.controllers.modal-handlers.people-added-success-message-description",
        "defaultMessage": "{totalPeopleAdded, plural, one {{email}} =2 {{email} and {totalPeopleAddedMinusOne} other} other {{email} and {totalPeopleAddedMinusOne} others}} added to the project. You can also add teammates and manage their access to the project from Project settings"
    },
    peopleAddedSuccessMessageDescriptionAgnostic: {
        "id": "business-invite-people.controllers.modal-handlers.people-added-success-message-description-agnostic",
        "defaultMessage": "People added to the project. You can also add teammates and manage their access to the project from Project settings"
    },
    peopleAddedManageAccess: {
        "id": "business-invite-people.controllers.modal-handlers.people-added-manage-access",
        "defaultMessage": "Manage access"
    },
    userLimitInviteErrorTitle: {
        "id": "business-invite-people.controllers.modal-handlers.user-limit-invite-error-title",
        "defaultMessage": "Can't add more people"
    },
    userLimitInviteErrorDescriptionAdmin: {
        "id": "business-invite-people.controllers.modal-handlers.user-limit-invite-error-description-admin",
        "defaultMessage": "You've reached your user limit. Upgrade your plan or remove other users."
    },
    userLimitInviteErrorDescription: {
        "id": "business-invite-people.controllers.modal-handlers.user-limit-invite-error-description",
        "defaultMessage": "You've reached your user limit. Contact your admin for help."
    },
    viewUsers: {
        "id": "business-invite-people.controllers.modal-handlers.view-users",
        "defaultMessage": "View users"
    },
    upgradePlan: {
        "id": "business-invite-people.controllers.modal-handlers.upgrade-plan",
        "defaultMessage": "Upgrade plan"
    }
});

});



parcelRegister("cb8cx", function(module, exports) {

$parcel$export(module.exports, "AddPeopleModal", () => $4afbb4a2961eae5f$export$b28f48897cdf7241);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $daQYX = parcelRequire("daQYX");

var $b71gk = parcelRequire("b71gk");

var $lfTZh = parcelRequire("lfTZh");

var $5oFIy = parcelRequire("5oFIy");

var $itmJb = parcelRequire("itmJb");

var $kxZPA = parcelRequire("kxZPA");

var $7wK4b = parcelRequire("7wK4b");


const $4afbb4a2961eae5f$export$a4917c848b5c6ce8 = (0, $kxZPA.lazy)(()=>(parcelRequire("4XHmI")), {
    ssr: false,
    moduleId: "./src/packages/permissions-administration/components/project-add-people/src/index.tsx"
});
const $4afbb4a2961eae5f$var$userInviteErrorCodes = {
    BAD_REQUEST_ERROR_CODE: $20132b2015719a62$export$a1d765adf759361e,
    NETWORK_ERROR_CODE: $20132b2015719a62$export$c7f012c6e67c4217,
    AUTH_FAILED_ERROR_CODE: $20132b2015719a62$export$c8a538cf4ae41623,
    SERVER_ERROR_ERROR_CODE: $20132b2015719a62$export$9bbcbc11675c1278,
    USER_NOT_FOUND_ERROR_CODE: $20132b2015719a62$export$a51af3c30283d234
};
const $4afbb4a2961eae5f$export$b28f48897cdf7241 = /*#__PURE__*/ (0, $5uXOq.memo)(({ onInviteSuccess: onInviteSuccess, onInviteError: onInviteError, onModalClose: onModalClose })=>{
    const { triggerBtnRef: triggerBtnRef } = (0, $7wK4b.useAddPeople)();
    const projectData = (0, $daQYX.useProject)();
    const isAdmin = (0, $itmJb.useIsAdmin)();
    const handleInviteSuccess = (0, $5uXOq.useCallback)((addedParties, _role)=>{
        onInviteSuccess({
            totalPeopleAdded: addedParties.length,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            email: addedParties[0]?.email || addedParties[0]?.displayName,
            modalType: 'Project'
        });
    }, [
        onInviteSuccess
    ]);
    // From the given error message, we want to search for a known error code defined under the user invite endpoint
    // Otherwise, we return the whole message and use that as error code for mapping later on
    const extractErrorCode = (message)=>{
        // Typescript assumes Object.keys is of type string[] so need to type cast
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        for (const errorCode of Object.keys($4afbb4a2961eae5f$var$userInviteErrorCodes)){
            const errorMessage = $4afbb4a2961eae5f$var$userInviteErrorCodes[errorCode];
            if (message.includes(errorMessage)) return errorCode;
        }
        return message; // Return original message if no error code found
    };
    const handleInviteFailure = (0, $5uXOq.useCallback)((errors)=>{
        const userInviteErrorsWithCode = {};
        errors.forEach((error)=>{
            // Group all errors by known user invite error codes
            const errorCode = extractErrorCode(error.message);
            if (errorCode) {
                if (!userInviteErrorsWithCode[errorCode]) userInviteErrorsWithCode[errorCode] = [];
                userInviteErrorsWithCode[errorCode].push(error);
            }
        });
        // Join messages with the same error code
        const groupedUserInviteErrors = Object.values(userInviteErrorsWithCode).map((group)=>{
            const statusCode = group[0]?.statusCode; // Assuming all errors with same error code have the same status code
            const messages = group.map((obj)=>obj.message).join('\n');
            return {
                message: messages,
                statusCode: statusCode
            };
        });
        groupedUserInviteErrors.forEach((groupedUserInviteError)=>{
            onInviteError({
                modalType: 'Project',
                errorMessage: groupedUserInviteError.message,
                statusCode: groupedUserInviteError.statusCode
            });
        });
    }, [
        onInviteError
    ]);
    const { id: id, key: key } = projectData;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "async.jira-business.project-invite-people-modal.add-people",
        packageName: "jira-business.project-invite-people-modal.add-people",
        teamName: "jira-warepil"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireTrackAnalytics), {
        eventName: "jwmProjectInviteComponent viewed"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "add-people-modal-lazy",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4afbb4a2961eae5f$export$a4917c848b5c6ce8, {
        isOpen: true,
        triggerBtnRef: triggerBtnRef,
        onClose: onModalClose,
        onAddSuccess: handleInviteSuccess,
        onError: handleInviteFailure,
        projectId: id,
        projectKey: key,
        projectType: "business",
        isAdmin: isAdmin,
        analyticsPrefix: "",
        allowFlags: false,
        onStopPerfMetric: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
    })));
});

});
parcelRegister("4XHmI", function(module, exports) {

let $39ce4f92c98d2430$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $39ce4f92c98d2430$var$load("kNFvF"),
    $39ce4f92c98d2430$var$load("ffQaD"),
    $39ce4f92c98d2430$var$load("kvRbA"),
    $39ce4f92c98d2430$var$load("76n7a"),
    $39ce4f92c98d2430$var$load("l253H"),
    $39ce4f92c98d2430$var$load("jJdCl")
]).then(()=>parcelRequire('jd2mv'));

});


parcelRegister("9AFuM", function(module, exports) {

$parcel$export(module.exports, "InvitePeopleModal", () => $5ae346fd9b1f20af$export$e3ec81c4d0451f63);

var $5uXOq = parcelRequire("5uXOq");

var $daQYX = parcelRequire("daQYX");

var $9fuVs = parcelRequire("9fuVs");

var $b71gk = parcelRequire("b71gk");

var $7NYq5 = parcelRequire("7NYq5");

var $lfTZh = parcelRequire("lfTZh");

var $6jY6G = parcelRequire("6jY6G");

var $5oFIy = parcelRequire("5oFIy");

var $12hlA = parcelRequire("12hlA");

var $14XJw = parcelRequire("14XJw");

var $efvDm = parcelRequire("efvDm");

var $ldyPw = parcelRequire("ldyPw");

var $k9JTq = parcelRequire("k9JTq");

var $koeKL = parcelRequire("koeKL");

var $itmJb = parcelRequire("itmJb");

var $kxZPA = parcelRequire("kxZPA");

var $99ejj = parcelRequire("99ejj");

const $5ae346fd9b1f20af$export$cbfde4f653ce234 = (0, $kxZPA.lazy)(()=>(parcelRequire("bJInk")), {
    ssr: false,
    moduleId: "../platform/packages/people-and-teams/invite-people/src/index.ts"
});
const $5ae346fd9b1f20af$export$4d2a63c83bbce998 = (res)=>{
    if (res.accessRequested?.length) return (0, $99ejj.InvitationStatusEnum).ACCESS_REQUESTED;
    return (0, $99ejj.InvitationStatusEnum).INVITED;
};
const $5ae346fd9b1f20af$var$LIST_ROUTES = [
    'software-list-classic',
    'software-list'
];
const $5ae346fd9b1f20af$var$isFailureResponse = (res)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    res.failure !== undefined;
const $5ae346fd9b1f20af$export$e3ec81c4d0451f63 = /*#__PURE__*/ (0, $5uXOq.memo)(({ onInviteSuccess: onInviteSuccess, onInviteError: onInviteError, onModalClose: onModalClose, source: source = 'projectBoard' })=>{
    const route = (0, $6jY6G.useCurrentRoute)();
    const cloudId = (0, $koeKL.useCloudId)();
    const appEditions = (0, $k9JTq.useAppEditions)();
    const { data: orgId } = (0, $14XJw.useOrgId)();
    const projectData = (0, $daQYX.useProject)();
    const isAdmin = (0, $itmJb.useIsAdmin)();
    const onInviteCompleteHandler = (0, $5uXOq.useCallback)((response)=>{
        if ($5ae346fd9b1f20af$var$isFailureResponse(response)) {
            const { message: message, status: status } = response.failure;
            onInviteError({
                modalType: 'Instance',
                errorMessage: message,
                statusCode: status
            });
            return;
        }
        const inviteStatus = $5ae346fd9b1f20af$export$4d2a63c83bbce998(response);
        const { invited: invited, accessRequested: accessRequested } = response;
        onInviteSuccess({
            totalPeopleAdded: invited.length || accessRequested.length,
            email: invited[0]?.email || accessRequested[0]?.email || '',
            modalType: 'Instance',
            inviteStatus: inviteStatus
        });
    }, [
        onInviteError,
        onInviteSuccess
    ]);
    const isSoftwareRoute = (0, $5uXOq.useMemo)(()=>$5ae346fd9b1f20af$var$LIST_ROUTES.includes(route.name), [
        route
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "async.jira-business.project-invite-people-modal.invite-people",
        packageName: "jira-business.project-invite-people-modal.invite-people",
        teamName: "jira-warepil"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "project-invite-people-modal.invite-people",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9fuVs.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7NYq5.JiraModal), {
        messageId: "business-invite-people.ui.add-people-with-avatars.add-people.project-invite-people-modal.invite-people-modal.jira-modal",
        messageType: "transactional",
        onClose: onModalClose,
        width: "small",
        shouldScrollInViewport: true,
        testId: "business-invite-people.ui.add-people-with-avatars.add-people.project-invite-people-modal.invite-people-modal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireTrackAnalytics), {
        eventName: "jwmInstanceInviteComponent viewed"
    }), isSoftwareRoute ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $12hlA.default), {
        isOpen: true,
        cloudId: cloudId,
        projectId: projectData.id,
        jiraProjectKey: projectData.key,
        isSiteAdmin: isAdmin,
        onClose: onModalClose,
        appEdition: (0, $ldyPw.getEdition)((0, $efvDm.JIRA_SOFTWARE), appEditions),
        jiraProjectName: projectData.name
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5ae346fd9b1f20af$export$cbfde4f653ce234, {
        onSendHandler: onModalClose,
        onInviteCompletedHandler: onInviteCompleteHandler,
        onCancelHandler: onModalClose,
        resourceAri: `ari:cloud:jira::site/${cloudId}`,
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        continueUrl: window.location.href,
        enableThirdParty: true,
        source: source,
        orgId: orgId
    })))));
});

});
parcelRegister("12hlA", function(module, exports) {

$parcel$export(module.exports, "default", () => $0bc8c7c74346f034$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $0bc8c7c74346f034$var$LazyComponent = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("dc1Hs")), {
    ssr: false,
    moduleId: "./src/packages/project-settings/invite-people-modal-project/src/index.tsx"
});
const $0bc8c7c74346f034$export$6a02a79fa2b0ddab = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "async-project-invite-people-modal",
        packageName: "jira-project-invite-people-modal",
        teamName: "groot-growth"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "project-invite-people-modal",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0bc8c7c74346f034$var$LazyComponent, props)));
var $0bc8c7c74346f034$export$2e2bcd8739ae039 = $0bc8c7c74346f034$export$6a02a79fa2b0ddab;

});
parcelRegister("dc1Hs", function(module, exports) {

let $99adb6ea021a0d60$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $99adb6ea021a0d60$var$load("76n7a"),
    $99adb6ea021a0d60$var$load("l253H"),
    $99adb6ea021a0d60$var$load("ffQaD"),
    $99adb6ea021a0d60$var$load("kvRbA"),
    $99adb6ea021a0d60$var$load("kNFvF"),
    $99adb6ea021a0d60$var$load("jLXj7")
]).then(()=>parcelRequire('3dNZP'));

});


parcelRegister("bJInk", function(module, exports) {

let $88b651aa95001e56$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $88b651aa95001e56$var$load("76n7a"),
    $88b651aa95001e56$var$load("l253H"),
    $88b651aa95001e56$var$load("MmE0u")
]).then(()=>parcelRequire('ddHJI'));

});




parcelRegister("67GjI", function(module, exports) {

let $475438c977c8b3a1$var$load = (parcelRequire("28QjX"))(4);
module.exports = $475438c977c8b3a1$var$load("fTMHe").then(()=>parcelRequire('62h3r'));

});


parcelRegister("ccsmj", function(module, exports) {

$parcel$export(module.exports, "JWMShareButton", () => $e895e30d5d3d8dcc$export$b326da26415fdf10);

var $5uXOq = parcelRequire("5uXOq");

var $kOEld = parcelRequire("kOEld");

var $12jwF = parcelRequire("12jwF");

var $koVbs = parcelRequire("koVbs");

var $22OQR = parcelRequire("22OQR");

var $iL8EU = parcelRequire("iL8EU");

var $9j8is = parcelRequire("9j8is");

var $fjgF8 = parcelRequire("fjgF8");

var $4XKuc = parcelRequire("4XKuc");
const $e895e30d5d3d8dcc$var$SHARE_ICON = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kOEld))), {
    label: "",
    LEGACY_size: "small"
});
const $e895e30d5d3d8dcc$export$b326da26415fdf10 = ({ shareTitle: shareTitle, integrationType: integrationType, shareContentType: shareContentType, isAutoOpenDialog: isAutoOpenDialog = false, onDialogClose: onDialogClose })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { shareIntegrations: shareIntegrations } = (0, $9j8is.useShareIntegrations)(shareContentType);
    const entityAri = (0, $12jwF.useEntityAri)();
    const shareButtonRef = (0, $5uXOq.useRef)(null);
    const renderCustomTriggerButton = (0, $5uXOq.useCallback)(// @ts-expect-error - TS7031 - Binding element 'onClick' implicitly has an 'any' type. | TS7031 - Binding element 'isSelected' implicitly has an 'any' type. | TS7031 - Binding element 'ref' implicitly has an 'any' type.
    ({ onClick: onClick, isSelected: isSelected }, { ref: ref, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            ref: ref
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $22OQR.ThemedButton), {
            ...triggerProps,
            ref: shareButtonRef,
            onClick: onClick,
            isSelected: isSelected,
            iconBefore: $e895e30d5d3d8dcc$var$SHARE_ICON,
            appearance: "subtle"
        }, formatMessage((0, $4XKuc.default).share))), [
        formatMessage
    ]);
    const handleDialogClose = ()=>{
        onDialogClose?.();
        shareButtonRef?.current?.focus();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fjgF8.AsyncShareProjectNudge), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iL8EU.ShareButton), {
        isAutoOpenDialog: isAutoOpenDialog,
        integrationType: integrationType,
        triggerButtonStyle: "icon-with-text",
        productId: "jira",
        subProductId: "jira-core",
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        shareLink: false ? '' : window.location.href,
        shareTitle: formatMessage(shareTitle),
        shareContentType: shareContentType,
        // @ts-expect-error - TS2322 - Type '({ onClick, isSelected }: { onClick: any; isSelected: any; }, { ref, ...triggerProps }: { [x: string]: any; ref: any; }) => Element' is not assignable to type 'RenderCustomTriggerButton'.
        renderCustomTriggerButton: renderCustomTriggerButton,
        objectAri: entityAri,
        onDialogClose: handleDialogClose,
        copyTooltipText: formatMessage((0, $4XKuc.default).shareTooltipText),
        shareIntegrations: shareIntegrations,
        integrationMode: "tabs",
        shareFormHelperMessage: formatMessage((0, $4XKuc.default).shareJwmHelperMessage)
    }));
};

});
parcelRegister("kOEld", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::eddb3c8fd23121248d7a9663e3c0819a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f277c50ed79b6741$var$_react = $f277c50ed79b6741$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $f277c50ed79b6741$var$_share = $f277c50ed79b6741$var$_interopRequireDefault((parcelRequire("empdx")));

var $f277c50ed79b6741$var$_share2 = $f277c50ed79b6741$var$_interopRequireDefault((parcelRequire("jZX0t")));
function $f277c50ed79b6741$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ShareIcon.
 * This component is ShareIcon, with `UNSAFE_fallbackIcon` set to "ShareIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for sharing an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f277c50ed79b6741$var$ShareIcon = (props)=>/*#__PURE__*/ $f277c50ed79b6741$var$_react.default.createElement($f277c50ed79b6741$var$_share.default, Object.assign({
        LEGACY_fallbackIcon: $f277c50ed79b6741$var$_share2.default
    }, props));
$f277c50ed79b6741$var$ShareIcon.Name = 'ShareIconMigration';
var $f277c50ed79b6741$var$_default = module.exports.default = $f277c50ed79b6741$var$ShareIcon;

});
parcelRegister("jZX0t", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e8f17c524b03e26b$var$_react = $e8f17c524b03e26b$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $e8f17c524b03e26b$var$_share = $e8f17c524b03e26b$var$_interopRequireDefault((parcelRequire("empdx")));
function $e8f17c524b03e26b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e8f17c524b03e26b$var$ShareIcon = (props)=>/*#__PURE__*/ $e8f17c524b03e26b$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M6 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2m12-4a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2m0 14a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2"/><path d="m7 13.562 8.66 5 1-1.732-8.66-5z"/><path d="m7 10.83 1 1.732 8.66-5-1-1.732z"/></g></svg>`
    }, props, {
        newIcon: $e8f17c524b03e26b$var$_share.default
    }));
$e8f17c524b03e26b$var$ShareIcon.displayName = 'ShareIcon';
var $e8f17c524b03e26b$var$_default = module.exports.default = $e8f17c524b03e26b$var$ShareIcon;

});


parcelRegister("iL8EU", function(module, exports) {

$parcel$export(module.exports, "ShareLoadingPlaceholder", () => $4e5335f44d688bbf$export$5619d05bf511476b);
$parcel$export(module.exports, "ShareButtonAnalyticsWrapperWithGating", () => $4e5335f44d688bbf$export$593c5080db936480);
$parcel$export(module.exports, "ShareButton", () => $4e5335f44d688bbf$export$e980dfbc2840e8bc);
$parcel$export(module.exports, "ShareButtonAsync", () => $4e5335f44d688bbf$export$3585ee2128ae4c25);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $fVnbM = parcelRequire("fVnbM");

var $kOEld = parcelRequire("kOEld");

var $42CjB = parcelRequire("42CjB");

var $1PVpv = parcelRequire("1PVpv");

var $empdx = parcelRequire("empdx");

var $b71gk = parcelRequire("b71gk");

var $koVbs = parcelRequire("koVbs");

var $cfDZ3 = parcelRequire("cfDZ3");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

var $itmJb = parcelRequire("itmJb");

var $4R6GH = parcelRequire("4R6GH");

var $dAfqg = parcelRequire("dAfqg");

var $7XYc4 = parcelRequire("7XYc4");

var $67hPg = parcelRequire("67hPg");
var $kNJSJ = parcelRequire("kNJSJ");

var $7CMCs = parcelRequire("7CMCs");

var $iXVV6 = parcelRequire("iXVV6");

var $2vSU6 = parcelRequire("2vSU6");

var $Kpokz = parcelRequire("Kpokz");

var $8BVfN = parcelRequire("8BVfN");
const $4e5335f44d688bbf$export$5619d05bf511476b = ({ triggerButtonStyle: triggerButtonStyle = 'icon-only' })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kOEld))), {
            LEGACY_size: "medium",
            spacing: "spacious",
            label: formatMessage((0, $Kpokz.messages).shareTriggerButtonText),
            color: "var(--ds-icon, #44546F)"
        }),
        isDisabled: true
    }, triggerButtonStyle === 'icon-with-text' ? formatMessage((0, $Kpokz.messages).shareTriggerButtonText) : null));
};

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $4e5335f44d688bbf$var$ShareButtonBase = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("dsrMt")), {
    ssr: false,
    moduleId: "./src/packages/growth/share-button/src/ui/index.tsx"
});
const $4e5335f44d688bbf$var$ShareButtonAnalyticsWrapper = ({ children: children })=>{
    const { data: data } = (0, $dAfqg.useProjectContext)();
    const projectKey = data?.projectKey || '';
    const projectType = data?.projectType;
    const projectStyle = data?.simplified ? (0, $2vSU6.TEAM_MANAGED_PROJECT) : (0, $2vSU6.COMPANY_MANAGED_PROJECT);
    const userLocation = (0, $cfDZ3.getUserLocation)();
    const isAdmin = (0, $itmJb.useIsAdmin)();
    const isProjectAdmin = data?.isProjectAdmin || false;
    const analyticsData = (0, $5uXOq.useMemo)(()=>{
        const projectContextData = projectKey ? {
            projectType: projectType,
            projectStyle: projectStyle,
            isProjectAdmin: isProjectAdmin
        } : undefined;
        return {
            isAdmin: isAdmin,
            userLocation: userLocation,
            ...projectContextData
        };
    }, [
        projectKey,
        projectType,
        projectStyle,
        isProjectAdmin,
        userLocation,
        isAdmin
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: analyticsData
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1PVpv.FabricElementsAnalyticsContext), {
        data: analyticsData
    }, children));
};
const $4e5335f44d688bbf$export$593c5080db936480 = (0, $7XYc4.componentWithCondition)(()=>(0, $4R6GH.fg)('jsw-smart-access-extended-analytics-enabled'), $4e5335f44d688bbf$var$ShareButtonAnalyticsWrapper, (0, $5uXOq.Fragment));
const $4e5335f44d688bbf$export$e980dfbc2840e8bc = (props)=>(0, $4R6GH.fg)('migrate_share_dialog_error_boundary') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4e5335f44d688bbf$export$593c5080db936480, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "async.share.button",
        packageName: "share-button",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "share-button",
        fallback: props.renderCustomTriggerButton === undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4e5335f44d688bbf$export$5619d05bf511476b, {
            triggerButtonStyle: props.triggerButtonStyle
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(props.renderCustomTriggerButton, {
            isDisabled: true,
            onClick: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4e5335f44d688bbf$var$ShareButtonBase, props)))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "async.share.button",
        packageName: "share-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "share-button",
        fallback: props.renderCustomTriggerButton === undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4e5335f44d688bbf$export$5619d05bf511476b, {
            triggerButtonStyle: props.triggerButtonStyle
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(props.renderCustomTriggerButton, {
            isDisabled: true,
            onClick: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4e5335f44d688bbf$export$593c5080db936480, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4e5335f44d688bbf$var$ShareButtonBase, props))));
const $4e5335f44d688bbf$export$3585ee2128ae4c25 = (props)=>{
    const { Panel: Panel, trigger: trigger } = (0, $kNJSJ.usePanel)();
    const entryPointParams = (0, $5uXOq.useMemo)(()=>({}), []);
    const entryPointProps = (0, $5uXOq.useMemo)(()=>({
            ...props
        }), [
        props
    ]);
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: props.errorBoundaryId,
        packageName: "jiraShareButton",
        teamName: props.teamName,
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $67hPg.Trigger), {
        trigger: trigger,
        entryPoint: (0, $8BVfN.shareButtonEntryPoint),
        entryPointParams: entryPointParams,
        entryPointProps: entryPointProps
    }, ({ ref: ref })=>!isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            ref: ref,
            testId: "share-button.button",
            label: formatMessage((0, $Kpokz.messages).shareTriggerButtonText),
            appearance: "default",
            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($empdx))), {
                    spacing: "spacious",
                    label: "",
                    color: "var(--ds-icon, #44546F)"
                }),
            onClick: ()=>setIsOpen(true)
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Panel, null));
};

});
parcelRegister("67hPg", function(module, exports) {

$parcel$export(module.exports, "Trigger", () => $f5abbb29b5666c06$export$41fb9f06171c75f4);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $3Du7S = parcelRequire("3Du7S");

var $7F2yO = parcelRequire("7F2yO");

var $kKgGa = parcelRequire("kKgGa");

var $e2pRJ = parcelRequire("e2pRJ");

var $hDhQq = parcelRequire("hDhQq");
const $f5abbb29b5666c06$var$emptyEntryPointParams = {};
const $f5abbb29b5666c06$var$emptyEntryPointProps = {};
function $f5abbb29b5666c06$export$41fb9f06171c75f4({ children: children, entryPoint: entryPoint, entryPointParams: entryPointParams, entryPointProps: entryPointProps, fallback: fallback, errorFallback: errorFallback, forwardedRef: forwardedRef, trigger: trigger }) {
    const { setPanel: setPanel } = trigger;
    const environmentProvider = (0, $e2pRJ.useRelayEnvironmentProvider)();
    const id = (0, $5uXOq.useMemo)(()=>{
        return entryPoint.root.getModuleName() || 'unknown';
    }, [
        entryPoint
    ]);
    const load = (0, $5uXOq.useCallback)(()=>(0, $8Uumt.loadEntryPoint)(environmentProvider, entryPoint, entryPointParams ?? $f5abbb29b5666c06$var$emptyEntryPointParams), [
        entryPoint,
        entryPointParams,
        environmentProvider
    ]);
    const onLoad = (0, $5uXOq.useCallback)(({ reference: entryPointReference })=>{
        setPanel(/*#__PURE__*/ (0, $2OMIu.jsx)((0, $kKgGa.InternalEntryPointContainer), {
            id: id,
            entryPointReference: entryPointReference,
            fallback: fallback || /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hDhQq.DefaultFallback), {}),
            errorFallback: errorFallback,
            runtimeProps: entryPointProps || $f5abbb29b5666c06$var$emptyEntryPointProps
        }));
    }, [
        setPanel,
        id,
        entryPointProps,
        fallback,
        errorFallback
    ]);
    const triggerRef = (0, $7F2yO.usePressablePreloadRef)({
        load: load,
        onLoad: onLoad
    });
    const mergedRef = (0, $3Du7S.useMergeRefs)([
        triggerRef,
        forwardedRef || null
    ]);
    return children({
        ref: mergedRef
    });
}

});
parcelRegister("hDhQq", function(module, exports) {

$parcel$export(module.exports, "DefaultFallback", () => $5d43ace1d77c91f8$export$93c734e924cdbdaa);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $iwwXK = parcelRequire("iwwXK");
function $5d43ace1d77c91f8$export$93c734e924cdbdaa() {
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iwwXK.default), {}),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iwwXK.default), {}),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iwwXK.default), {}),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iwwXK.default), {})
        ]
    });
}

});


parcelRegister("kNJSJ", function(module, exports) {

$parcel$export(module.exports, "usePanel", () => $0ef0a2f3e739e762$export$9168a42f32e3d071);

var $5uXOq = parcelRequire("5uXOq");
function $0ef0a2f3e739e762$export$9168a42f32e3d071(preloadedPanel) {
    const [panel, setPanel] = (0, $5uXOq.useState)(preloadedPanel);
    const Panel = (0, $5uXOq.useMemo)(()=>{
        const PanelComponent = ()=>panel ?? null;
        return PanelComponent;
    }, [
        panel
    ]);
    const trigger = (0, $5uXOq.useMemo)(()=>({
            setPanel: (panel)=>setPanel(panel)
        }), [
        setPanel
    ]);
    return (0, $5uXOq.useMemo)(()=>({
            Panel: Panel,
            trigger: trigger
        }), [
        Panel,
        trigger
    ]);
}

});

parcelRegister("Kpokz", function(module, exports) {

$parcel$export(module.exports, "messages", () => $026d1258a1c95d57$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $026d1258a1c95d57$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    shareTriggerButtonText: {
        "id": "share-button.share-trigger-button-text",
        "defaultMessage": "Share"
    }
});

});

parcelRegister("8BVfN", function(module, exports) {

$parcel$export(module.exports, "shareButtonEntryPoint", () => $735d063ad5974451$export$ad8b1559c594245d);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $735d063ad5974451$export$ad8b1559c594245d = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>{
        if (!false) return (parcelRequire("2YwsS"));
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return Promise.resolve({
            default: ()=>null
        });
    }, {
        moduleId: "50ae946e"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("2YwsS", function(module, exports) {

let $22aa5e30b1ec71b3$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $22aa5e30b1ec71b3$var$load("3yAl4"),
    $22aa5e30b1ec71b3$var$load("76n7a"),
    $22aa5e30b1ec71b3$var$load("l253H"),
    $22aa5e30b1ec71b3$var$load("kNFvF"),
    $22aa5e30b1ec71b3$var$load("ffQaD"),
    $22aa5e30b1ec71b3$var$load("kvRbA"),
    $22aa5e30b1ec71b3$var$load("lMH7t")
]).then(()=>parcelRequire('8kufr'));

});


parcelRegister("dsrMt", function(module, exports) {

let $9cc3709afec5d7a8$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $9cc3709afec5d7a8$var$load("3yAl4"),
    $9cc3709afec5d7a8$var$load("76n7a"),
    $9cc3709afec5d7a8$var$load("l253H"),
    $9cc3709afec5d7a8$var$load("kNFvF"),
    $9cc3709afec5d7a8$var$load("ffQaD"),
    $9cc3709afec5d7a8$var$load("kvRbA"),
    $9cc3709afec5d7a8$var$load("61BKk")
]).then(()=>parcelRequire('7aU9g'));

});


parcelRegister("9j8is", function(module, exports) {

$parcel$export(module.exports, "useShareIntegrations", () => $d021f3111fd4c646$export$58a9f7a7ab3466f4);

var $5uXOq = parcelRequire("5uXOq");

var $c04PQ = parcelRequire("c04PQ");

var $bCdIp = parcelRequire("bCdIp");

var $pa9q9 = parcelRequire("pa9q9");

var $koeKL = parcelRequire("koeKL");

var $2UEtd = parcelRequire("2UEtd");

var $aMZmw = parcelRequire("aMZmw");
const $d021f3111fd4c646$export$58a9f7a7ab3466f4 = (shareContentType)=>{
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const cloudId = (0, $koeKL.useCloudId)();
    const ineligibilityReasons = (0, $5uXOq.useMemo)(()=>{
        const reasons = [];
        if ((0, $bCdIp.default)()) reasons.push('notDesktop');
        // All Share to Slack must be disabled in FedRAMP environment as
        // Slack Jira Integration app is not available in FedRAMP
        if ((0, $c04PQ.isFedRamp)()) reasons.push('isFedRAMP');
        return reasons;
    }, []);
    const shareIntegrations = (0, $5uXOq.useMemo)(()=>ineligibilityReasons.length === 0 ? [
            {
                type: 'Slack',
                Icon: (0, $aMZmw.default),
                Content: ({ onClose: onClose, changeTab: changeTab })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2UEtd.ShareToSlack), {
                        showFlag: showFlag,
                        product: "jira",
                        channel: "productAnalytics",
                        onClose: onClose,
                        cloudId: cloudId,
                        changeTab: changeTab,
                        shareContentType: shareContentType
                    })
            }
        ] : [], [
        ineligibilityReasons.length,
        showFlag,
        cloudId,
        shareContentType
    ]);
    return {
        shareIntegrations: shareIntegrations
    };
};

});
parcelRegister("2UEtd", function(module, exports) {

$parcel$export(module.exports, "ShareToSlack", () => $168b88234834bfea$export$2cc56764fd9edb21);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $eZJjh = parcelRequire("eZJjh");

var $b71gk = parcelRequire("b71gk");

var $lfTZh = parcelRequire("lfTZh");

var $3xc3R = parcelRequire("3xc3R");

const $168b88234834bfea$export$2cc56764fd9edb21 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "async-share-to-slack",
        packageName: "integrations"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "share-to-slack",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($168b88234834bfea$var$StyledShareToSlackLoader, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($168b88234834bfea$var$StyledShareToSlack, props)));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $168b88234834bfea$var$StyledShareToSlackLoader = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $eZJjh.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _1bsb1osq",
            __cmplp.className
        ])
    });
});
const $168b88234834bfea$var$StyledShareToSlack = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $3xc3R.LazyShareToSlack), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkmgjw _2hwx10v4 _otyrmgjw _18u010v4",
            __cmplp.className
        ])
    });
});

});
parcelRegister("3xc3R", function(module, exports) {

$parcel$export(module.exports, "LazyShareToSlack", () => $0733f18014b5074d$export$24281652e6b89b3b);

var $kxZPA = parcelRequire("kxZPA");

const $0733f18014b5074d$export$24281652e6b89b3b = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("lkjYU")), {
    ssr: false,
    moduleId: "../platform/packages/growth/integrations/src/share-to-slack/ui/index.tsx"
});

});
parcelRegister("lkjYU", function(module, exports) {

let $f86af723f983b7c6$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $f86af723f983b7c6$var$load("kNFvF"),
    $f86af723f983b7c6$var$load("ff9v5")
]).then(()=>parcelRequire('2B8HF'));

});



parcelRegister("aMZmw", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1ef732ae0096135$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$a1ef732ae0096135$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        width: "16",
        height: "16",
        viewBox: "4 4 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M7.50403 13.8563C7.50403 14.727 6.79278 15.4382 5.92212 15.4382C5.05146 15.4382 4.34021 14.727 4.34021 13.8563C4.34021 12.9857 5.05146 12.2744 5.92212 12.2744H7.50403V13.8563Z",
        fill: "#E01E5A"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M8.30115 13.8563C8.30115 12.9857 9.0124 12.2744 9.88307 12.2744C10.7537 12.2744 11.465 12.9857 11.465 13.8563V17.8172C11.465 18.6879 10.7537 19.3991 9.88307 19.3991C9.0124 19.3991 8.30115 18.6879 8.30115 17.8172V13.8563Z",
        fill: "#E01E5A"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M9.88307 7.50415C9.0124 7.50415 8.30115 6.79291 8.30115 5.92224C8.30115 5.05158 9.0124 4.34033 9.88307 4.34033C10.7537 4.34033 11.465 5.05158 11.465 5.92224V7.50415H9.88307Z",
        fill: "#36C5F0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M9.88304 8.30127C10.7537 8.30127 11.465 9.01251 11.465 9.88317C11.465 10.7538 10.7537 11.4651 9.88304 11.4651H5.92212C5.05146 11.4651 4.34021 10.7538 4.34021 9.88317C4.34021 9.01251 5.05146 8.30127 5.92212 8.30127H9.88304Z",
        fill: "#36C5F0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M16.2354 9.88317C16.2354 9.01251 16.9466 8.30127 17.8172 8.30127C18.6879 8.30127 19.3991 9.01251 19.3991 9.88317C19.3991 10.7538 18.6879 11.4651 17.8172 11.4651H16.2354V9.88317Z",
        fill: "#2EB67D"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M15.4381 9.88316C15.4381 10.7538 14.7269 11.4651 13.8562 11.4651C12.9855 11.4651 12.2743 10.7538 12.2743 9.88316V5.92225C12.2743 5.05158 12.9855 4.34033 13.8562 4.34033C14.7269 4.34033 15.4381 5.05158 15.4381 5.92225V9.88316Z",
        fill: "#2EB67D"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M13.8562 16.2354C14.7269 16.2354 15.4381 16.9466 15.4381 17.8172C15.4381 18.6879 14.7269 19.3991 13.8562 19.3991C12.9855 19.3991 12.2743 18.6879 12.2743 17.8172V16.2354H13.8562Z",
        fill: "#ECB22E"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M13.8562 15.4382C12.9855 15.4382 12.2743 14.727 12.2743 13.8563C12.2743 12.9857 12.9855 12.2744 13.8562 12.2744H17.8171C18.6878 12.2744 19.399 12.9857 19.399 13.8563C19.399 14.727 18.6878 15.4382 17.8171 15.4382H13.8562Z",
        fill: "#ECB22E"
    }));

});


parcelRegister("fjgF8", function(module, exports) {

$parcel$export(module.exports, "AsyncShareProjectNudge", () => $7ce891b6fd7965bb$export$d95995d6ca76620b);

var $5uXOq = parcelRequire("5uXOq");

var $bBbEG = parcelRequire("bBbEG");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");


// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $7ce891b6fd7965bb$var$LazyShareProjectNudge = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("5ke97")), {
    ssr: false,
    moduleId: "./src/packages/software/onboarding-nudges/src/ui/jwm-share-project/index.tsx"
});
const $7ce891b6fd7965bb$export$d95995d6ca76620b = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bBbEG.OnboardingNudgeErrorBoundary), {
        id: (0, $dbbf68c32d8c4308$export$a1be34032ee24f78),
        fallback: children,
        attributes: {
            nudgeId: (0, $dbbf68c32d8c4308$export$a1be34032ee24f78)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "jwm-share-project-nudge",
        fallback: children
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7ce891b6fd7965bb$var$LazyShareProjectNudge, null, children)));

});
parcelRegister("5ke97", function(module, exports) {

let $3e09cb24ccda0426$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3e09cb24ccda0426$var$load("aFhM0").then(()=>parcelRequire('dRf63'));

});


parcelRegister("4XKuc", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ed6b88152ef6ea6$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $5ed6b88152ef6ea6$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    share: {
        "id": "business-invite-people.jwm-share-button.share",
        "defaultMessage": "Share"
    },
    shareTooltipText: {
        "id": "business-invite-people.jwm-share-button.share-tooltip-text",
        "defaultMessage": "Embed this Smart Link in other Atlassian products such as Confluence"
    },
    shareJwmHelperMessage: {
        "id": "business-invite-people.jwm-share-button.share-jwm-helper-message",
        "defaultMessage": "This view, along with any applied groups and filters are shared"
    }
});

});


parcelRegister("hCCtP", function(module, exports) {

$parcel$export(module.exports, "ThemedButtonWrapper", () => $34060b1367424582$export$269674ad0c604d30);
$parcel$export(module.exports, "ThemedButtonNew", () => $34060b1367424582$export$15536ee0f9ee7c0b);
$parcel$export(module.exports, "ThemedIconButton", () => $34060b1367424582$export$d9c2d067feb61447);
$parcel$export(module.exports, "ThemedLinkButton", () => $34060b1367424582$export$b0b5aeed52623827);
$parcel$export(module.exports, "ThemedLinkIconButton", () => $34060b1367424582$export$a1ab08e79d264ec8);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $eCeGD = parcelRequire("eCeGD");
var $42CjB = parcelRequire("42CjB");
var $1GGwS = parcelRequire("1GGwS");
var $krXdA = parcelRequire("krXdA");

var $6cG4N = parcelRequire("6cG4N");

var $4R6GH = parcelRequire("4R6GH");

var $dCm1o = parcelRequire("dCm1o");

var $lmBAt = parcelRequire("lmBAt");

const $34060b1367424582$export$269674ad0c604d30 = ({ children: children })=>(0, $lmBAt.getIsSoftwareThemingEnabled)() || (0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('visual-refresh-headers-buttons') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: "span",
        xcss: [
            $34060b1367424582$var$overrideStyles,
            (0, $lmBAt.getIsSoftwareThemingM2Enabled)() && $34060b1367424582$var$themingM2Styles,
            (0, $4R6GH.fg)('jira_themed_button_styling_fix') && $34060b1367424582$var$wrapperStyles
        ]
    }, children) : children;
const $34060b1367424582$export$15536ee0f9ee7c0b = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($34060b1367424582$export$269674ad0c604d30, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
        ...props,
        ref: ref
    }))));
const $34060b1367424582$export$d9c2d067feb61447 = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($34060b1367424582$export$269674ad0c604d30, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        ...props,
        ref: ref
    }))));
const $34060b1367424582$export$b0b5aeed52623827 = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($34060b1367424582$export$269674ad0c604d30, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1GGwS.default), {
        ...props,
        ref: ref
    }))));
const $34060b1367424582$export$a1ab08e79d264ec8 = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($34060b1367424582$export$269674ad0c604d30, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $krXdA.default), {
        ...props,
        ref: ref
    }))));
const $34060b1367424582$var$overrideStyles = (0, $8CUq3.xcss)({
    // @ts-expect-error Object literal may only specify known properties, and ''--ds-background-brand-bold'' does not exist in type 'SafeCSSObject'.ts(2353)
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-background-brand-bold': (0, $6cG4N.Tokens).COLOR_BACKGROUND_BRAND_BOLD,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-background-brand-bold-hovered': (0, $6cG4N.Tokens).COLOR_BACKGROUND_BRAND_BOLD_HOVERED,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-background-brand-bold-pressed': (0, $6cG4N.Tokens).COLOR_BACKGROUND_BRAND_BOLD_PRESSED,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-background-disabled': (0, $6cG4N.Tokens).COLOR_BACKGROUND_DISABLED,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-background-selected': (0, $6cG4N.Tokens).COLOR_BACKGROUND_SELECTED,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-background-selected-hovered': (0, $6cG4N.Tokens).COLOR_BACKGROUND_SELECTED,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-background-selected-pressed': (0, $6cG4N.Tokens).COLOR_BACKGROUND_SELECTED,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-background-neutral': (0, $6cG4N.Tokens).COLOR_BACKGROUND_NEUTRAL,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-background-neutral-hovered': (0, $6cG4N.Tokens).COLOR_BACKGROUND_NEUTRAL_HOVERED,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-background-neutral-pressed': (0, $6cG4N.Tokens).COLOR_BACKGROUND_NEUTRAL_PRESSED,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-background-neutral-subtle-hovered': (0, $6cG4N.Tokens).COLOR_BACKGROUND_NEUTRAL_SUBTLE_HOVERED,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-background-neutral-subtle-pressed': (0, $6cG4N.Tokens).COLOR_BACKGROUND_NEUTRAL_SUBTLE_PRESSED,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-icon-subtle': (0, $6cG4N.Tokens).COLOR_TEXT_SUBTLE,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-icon': (0, $6cG4N.Tokens).COLOR_TEXT,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-link': (0, $6cG4N.Tokens).COLOR_LINK,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-link-pressed': (0, $6cG4N.Tokens).COLOR_LINK_PRESSED,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-text': (0, $6cG4N.Tokens).COLOR_TEXT_SUBTLE,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-text-disabled': (0, $6cG4N.Tokens).COLOR_TEXT_DISABLED,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-text-inverse': (0, $6cG4N.Tokens).COLOR_TEXT_INVERSE,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-text-selected': (0, $6cG4N.Tokens).COLOR_TEXT_SELECTED,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-text-subtle': (0, $6cG4N.Tokens).COLOR_TEXT_SUBTLE,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-border': (0, $6cG4N.Tokens).COLOR_BORDER,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-border-selected': (0, $6cG4N.Tokens).COLOR_BORDER_SELECTED
});
const $34060b1367424582$var$themingM2Styles = (0, $8CUq3.xcss)({
    // @ts-expect-error Object literal may only specify known properties, and ''--ds-background-brand-bold'' does not exist in type 'SafeCSSObject'.ts(2353)
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--project-color-link': `var(${(0, $5b25b2eb4e8be764$export$fac615ceaa871e35)}, ${"var(--ds-text, #172B4D)"})`
});
const $34060b1367424582$var$wrapperStyles = (0, $8CUq3.xcss)({
    display: 'inline-flex'
});

});

parcelRegister("5GqLe", function(module, exports) {

$parcel$export(module.exports, "integrationTypes", () => $0970fea694a8095f$export$a7359bcfb0ca8e98);
const $0970fea694a8095f$export$a7359bcfb0ca8e98 = {
    BENTO_ISSUE: 'bentoIssue',
    CLASSIC_BOARD: 'classicBoard',
    NEXTGEN_BOARD: 'nextGenBoard',
    ROADMAP: 'roadmap',
    TIMELINE: 'timeline',
    LIST: 'list',
    CALENDAR: 'calendar',
    BOARD: 'board',
    FORM: 'form',
    SUMMARY: 'summary',
    ATTACHMENTS: 'attachments',
    DEPENDENCIES: 'dependencies',
    INCREMENT: 'increment',
    QUEUE: 'queue'
};

});

parcelRegister("6jE0j", function(module, exports) {

$parcel$export(module.exports, "Collapsible", () => $23992aab491d57ae$export$6eb0f7ddcda6131f);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");
const $23992aab491d57ae$var$getSize = (element, direction)=>{
    return direction === 'horizontal' ? element.scrollWidth : element.scrollHeight;
};
const $23992aab491d57ae$var$setCollapsedStyle = (wrapper, direction)=>{
    // set max width to 0 and opacity to 0
    wrapper.style.setProperty(`max-${direction === 'horizontal' ? 'width' : 'height'}`, '0px');
    wrapper.style.setProperty('opacity', '0');
    wrapper.style.setProperty('overflow', 'hidden');
};
const $23992aab491d57ae$var$setExpandedStyle = (wrapper, content, direction)=>{
    // set the max size to content size and opacity to 1
    wrapper.style.setProperty(`max-${direction === 'horizontal' ? 'width' : 'height'}`, `${$23992aab491d57ae$var$getSize(content, direction)}px`);
    wrapper.style.setProperty('opacity', '1');
};
const $23992aab491d57ae$var$resetStyle = (wrapper, direction, resetOverflow)=>{
    wrapper.style.removeProperty(`max-${direction === 'horizontal' ? 'width' : 'height'}`);
    wrapper.style.removeProperty('opacity');
    if (resetOverflow) wrapper.style.removeProperty('overflow');
};
const $23992aab491d57ae$export$6eb0f7ddcda6131f = ({ animationDuration: animationDuration = 250, children: children, direction: direction = 'vertical', id: id, isExpanded: isExpanded, resetOverflow: resetOverflow = true })=>{
    const didMountRef = (0, $5uXOq.useRef)(false);
    const wrapperRef = (0, $5uXOq.useRef)(null);
    const contentRef = (0, $5uXOq.useRef)(null);
    const [isRendered, setIsRendered] = (0, $5uXOq.useState)(isExpanded);
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (!wrapperRef.current) return;
        // add the transition to the wrapper
        wrapperRef.current.style.setProperty('transition', `max-${direction === 'horizontal' ? 'width' : 'height'} ${animationDuration}ms ease-in-out, opacity ${animationDuration}ms ease-in-out`);
        if (!resetOverflow) wrapperRef.current.style.setProperty('overflow', 'hidden');
        if (!isExpanded) $23992aab491d57ae$var$setCollapsedStyle(wrapperRef.current, direction);
    // initial render only
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $5uXOq.useEffect)(()=>{
        if (!didMountRef.current) {
            didMountRef.current = true;
            return;
        }
        if (isExpanded) {
            if (!isRendered) setIsRendered(true);
            else requestAnimationFrame(()=>{
                if (!wrapperRef.current || !contentRef.current) return;
                $23992aab491d57ae$var$setExpandedStyle(wrapperRef.current, contentRef.current, direction);
                // wait for the animation to finish before removing the overflow
                Promise.all(wrapperRef.current.getAnimations().map((animation)=>animation.finished) ?? []).then(()=>{
                    wrapperRef.current && $23992aab491d57ae$var$resetStyle(wrapperRef.current, direction, resetOverflow);
                });
            });
        } else if (isRendered) {
            if (!wrapperRef.current || !contentRef.current) return;
            $23992aab491d57ae$var$setExpandedStyle(wrapperRef.current, contentRef.current, direction);
            requestAnimationFrame(()=>{
                requestAnimationFrame(()=>{
                    if (!wrapperRef.current) return;
                    $23992aab491d57ae$var$setCollapsedStyle(wrapperRef.current, direction);
                    // wait for the animation to finish before removing the content
                    Promise.all(wrapperRef.current.getAnimations().map((animation)=>animation.finished) ?? []).then(()=>{
                        setIsRendered(false);
                    });
                });
            });
        }
    }, [
        direction,
        isExpanded,
        isRendered,
        resetOverflow
    ]);
    return /*#__PURE__*/ $5uXOq.createElement("div", {
        id: id,
        ref: wrapperRef
    }, isRendered && /*#__PURE__*/ $5uXOq.createElement("div", {
        ref: contentRef
    }, children));
};

});

parcelRegister("cGvzG", function(module, exports) {

$parcel$export(module.exports, "JiraViewAri", () => $93c1e64ca07778c1$export$259cce321cdbcc);

var $frfhC = parcelRequire("frfhC");

var $3NoER = parcelRequire("3NoER");

var $gYPG7 = parcelRequire("gYPG7");
// src/jira/view/manifest.ts
var $93c1e64ca07778c1$var$jiraViewAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $frfhC.JiraViewAriResourceOwner),
    resourceType: (0, $frfhC.JiraViewAriResourceType),
    resourceIdSlug: "activation/{activationId}/{scopeType}/{scopeId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        scopeType: /(global|project|board)/,
        // eslint-disable-line no-useless-escape
        scopeId: /[!a-zA-Z0-9\-_.~@:;{}=]+(\/[!a-zA-Z0-9\-_.~@:;{}=]+)*/
    }
};
// src/jira/view/index.ts
var $93c1e64ca07778c1$export$259cce321cdbcc = class _JiraViewAri extends (0, $3NoER.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._scopeType = opts.resourceIdSegmentValues.scopeType, this._scopeId = opts.resourceIdSegmentValues.scopeId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get scopeType() {
        return this._scopeType;
    }
    get scopeId() {
        return this._scopeId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $93c1e64ca07778c1$var$jiraViewAriStaticOpts.qualifier,
            platformQualifier: $93c1e64ca07778c1$var$jiraViewAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $93c1e64ca07778c1$var$jiraViewAriStaticOpts.resourceOwner,
            resourceType: $93c1e64ca07778c1$var$jiraViewAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.scopeType}/${opts.scopeId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                scopeType: opts.scopeType,
                scopeId: opts.scopeId
            }
        }, ariOpts = (0, $gYPG7.AriParser).fromOpts(derivedOpts, $93c1e64ca07778c1$var$jiraViewAriStaticOpts);
        return new _JiraViewAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $gYPG7.AriParser).fromString(maybeAri, $93c1e64ca07778c1$var$jiraViewAriStaticOpts);
        return new _JiraViewAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            scopeType: this.scopeType,
            scopeId: this.scopeId
        };
    }
};

});
parcelRegister("frfhC", function(module, exports) {

$parcel$export(module.exports, "JiraViewAriResourceOwner", () => $b3d53b90426675a7$export$c63cbf12e88f62b6);
$parcel$export(module.exports, "JiraViewAriResourceType", () => $b3d53b90426675a7$export$4b456bf9436bd47e);
// src/jira/view/types.ts
var $b3d53b90426675a7$export$c63cbf12e88f62b6 = "jira", $b3d53b90426675a7$export$4b456bf9436bd47e = "view";

});


parcelRegister("5jsYx", function(module, exports) {

$parcel$export(module.exports, "default", () => $64537213db3d1335$export$2e2bcd8739ae039);

var $6MPcp = parcelRequire("6MPcp");

var $cBOn0 = parcelRequire("cBOn0");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $ky7e4 = parcelRequire("ky7e4");

var $hRkFS = parcelRequire("hRkFS");

var $kJpBP = parcelRequire("kJpBP");
var $eZUJu = parcelRequire("eZUJu");

var $1I7E8 = parcelRequire("1I7E8");

var $koVbs = parcelRequire("koVbs");

var $93jKl = parcelRequire("93jKl");

var $kaHBi = parcelRequire("kaHBi");

var $3bQtK = parcelRequire("3bQtK");

var $eERQr = parcelRequire("eERQr");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $22OQR = parcelRequire("22OQR");

var $dCm1o = parcelRequire("dCm1o");

var $pa9q9 = parcelRequire("pa9q9");

var $7y8jx = parcelRequire("7y8jx");

var $4R6GH = parcelRequire("4R6GH");

var $aVLHQ = parcelRequire("aVLHQ");
const $64537213db3d1335$var$experience = 'setBoardViewGroupBy';
const $64537213db3d1335$var$BoardGroupSelector = ({ viewFragment: viewFragment })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const closeMenu = (0, $5uXOq.useCallback)(()=>setIsOpen(false), []);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const startExperience = (0, $kaHBi.useExperienceStart)({
        experience: $64537213db3d1335$var$experience,
        analyticsSource: 'jiraWorkManagementBoard'
    });
    const markExperienceSuccess = (0, $3bQtK.useExperienceSuccess)({
        experience: $64537213db3d1335$var$experience
    });
    const markExperienceFailed = (0, $93jKl.useExperienceFail)({
        experience: $64537213db3d1335$var$experience
    });
    const view = (0, $8Uumt.useFragment)((0, $cBOn0.default), viewFragment);
    const [commit, isInFlight] = (0, $8Uumt.useMutation)((0, $6MPcp.default));
    const setGroupBy = (0, $5uXOq.useCallback)((newGroupBy)=>{
        startExperience();
        const handleFailure = (error)=>{
            markExperienceFailed('BoardGroupSelector jira_setBoardViewGroupBy mutation failed', error);
            showFlag({
                messageId: 'work-management-board.ui.header.group-selector.show-flag.error.set-group-by-failed',
                messageType: 'transactional',
                title: (0, $aVLHQ.default).setGroupByFailedTitle,
                description: (0, $aVLHQ.default).setGroupByFailedMessage,
                type: 'error'
            });
        };
        commit({
            variables: {
                input: {
                    viewId: view.id,
                    fieldId: newGroupBy,
                    settings: (0, $7y8jx.getBoardQueryParams)()
                }
            },
            onError (error) {
                handleFailure(error);
            },
            onCompleted (response) {
                if (response.jira_setBoardViewGroupBy?.success !== true) {
                    const error = new (0, $eERQr.MutationErrorCollection)(response.jira_setBoardViewGroupBy?.errors);
                    handleFailure(error);
                    return;
                }
                markExperienceSuccess();
                (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'groupBy changed');
            }
        });
        closeMenu();
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'groupBy', {
            value: newGroupBy
        });
    }, [
        closeMenu,
        commit,
        createAnalyticsEvent,
        markExperienceFailed,
        markExperienceSuccess,
        showFlag,
        startExperience,
        view.id
    ]);
    const popupContent = (0, $5uXOq.useCallback)(({ setInitialFocusRef: setInitialFocusRef })=>{
        const checkIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ky7e4))), {
            LEGACY_size: "medium",
            spacing: "spacious",
            label: formatMessage((0, $aVLHQ.default).groupBySelected),
            color: "var(--ds-icon-selected, #0C66E4)"
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZUJu.default), {
            role: "radiogroup",
            "aria-label": formatMessage((0, $aVLHQ.default).groupBySectionTitle)
        }, view.groupByOptions.map((option, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kJpBP.default), {
                role: "radio",
                "aria-checked": view.groupByConfig.fieldId === option.fieldId,
                key: option.fieldId,
                onClick: ()=>setGroupBy(option.fieldId),
                iconAfter: view.groupByConfig.fieldId === option.fieldId && checkIcon,
                ref: index === 0 ? setInitialFocusRef : undefined
            }, option.fieldName)));
    }, [
        formatMessage,
        setGroupBy,
        view.groupByConfig.fieldId,
        view.groupByOptions
    ]);
    const popupTrigger = (0, $5uXOq.useCallback)((triggerProps)=>(0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $22OQR.ThemedButton), {
            ...triggerProps,
            "aria-label": formatMessage((0, $aVLHQ.default).groupByButtonAriaLabel, {
                label: view.groupByConfig.fieldName
            }),
            isLoading: isInFlight,
            isSelected: true,
            onClick: ()=>setIsOpen((wasOpen)=>!wasOpen)
        }, formatMessage((0, $aVLHQ.default).groupByButtonLabel), view.groupByConfig.fieldName) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $22OQR.ThemedButton), {
            ...triggerProps,
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hRkFS))), {
                label: "",
                LEGACY_size: "small"
            }),
            isLoading: isInFlight,
            isSelected: isOpen,
            onClick: ()=>setIsOpen((wasOpen)=>!wasOpen),
            appearance: "subtle"
        }, formatMessage((0, $aVLHQ.default).groupByButtonLabelOld), view.groupByConfig.fieldName), [
        formatMessage,
        isInFlight,
        isOpen,
        view.groupByConfig.fieldName
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1I7E8.default), {
        content: popupContent,
        isOpen: isOpen,
        onClose: closeMenu,
        placement: "bottom-end",
        trigger: popupTrigger,
        autoFocus: !(0, $4R6GH.fg)('wanjel-a11y-enterprise-grade'),
        shouldRenderToParent: (0, $4R6GH.fg)('wanjel-fix-rendertoparent-header-popup-in-board')
    });
};
var $64537213db3d1335$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($64537213db3d1335$var$BoardGroupSelector);

});
parcelRegister("6MPcp", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d37841b4f01cb63$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8742db1e1af5d03c2f4976d06684fbe1>>
 * @relayHash d5d59440bc891e7fd5770d0cfbce1fa8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8cec56bbfe0f789f51d6b48194a6cd4d5cd31ba412251a2a6e175427a86720d7

var $apYuT = parcelRequire("apYuT");
const $9d37841b4f01cb63$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "input"
    }, v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "ScalarField",
        "name": "message"
    }, v4 = {
        "kind": "ScalarField",
        "name": "errorType"
    }, v5 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v6 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v7 = [
        v6 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "fieldName"
        }
    ], v8 = {
        "kind": "ScalarField",
        "name": "id"
    }, v9 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v10 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "BoardGroupSelectorSetGroupByMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "JiraSetBoardViewGroupByPayload",
                    "kind": "LinkedField",
                    "name": "jira_setBoardViewGroupBy",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "JiraBoardView",
                            "kind": "LinkedField",
                            "name": "boardView",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "BusinessBoard_view"
                                }
                            ]
                        },
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcmergeboardworkflowsrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "BoardGroupSelectorSetGroupByMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "JiraSetBoardViewGroupByPayload",
                    "kind": "LinkedField",
                    "name": "jira_setBoardViewGroupBy",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "JiraBoardView",
                            "kind": "LinkedField",
                            "name": "boardView",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraViewFilterConfig",
                                    "kind": "LinkedField",
                                    "name": "filterConfig",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "jql"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "JiraViewGroupByConfig",
                                    "kind": "LinkedField",
                                    "name": "groupByConfig",
                                    "plural": false,
                                    "selections": v7 /*: any*/ 
                                },
                                v8 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "isViewConfigModified"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canPublishViewConfig"
                                },
                                {
                                    "concreteType": "JiraViewGroupByConfig",
                                    "kind": "LinkedField",
                                    "name": "groupByOptions",
                                    "plural": true,
                                    "selections": v7 /*: any*/ 
                                },
                                {
                                    "concreteType": "JiraBoardViewColumnConnection",
                                    "kind": "LinkedField",
                                    "name": "columns",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraBoardViewColumnEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        v8 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "collapsed"
                                                        },
                                                        {
                                                            "kind": "TypeDiscriminator",
                                                            "abstractKey": "__isJiraBoardViewColumn"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraStatus",
                                                                    "kind": "LinkedField",
                                                                    "name": "statuses",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v10 /*: any*/ ,
                                                                        v8 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "statusId"
                                                                        },
                                                                        {
                                                                            "concreteType": "JiraStatusCategory",
                                                                            "kind": "LinkedField",
                                                                            "name": "statusCategory",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "statusCategoryId"
                                                                                },
                                                                                v8 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraBoardViewStatusColumn"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraPriority",
                                                                    "kind": "LinkedField",
                                                                    "name": "priority",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v10 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "priorityId"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "iconUrl"
                                                                        },
                                                                        v8 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraBoardViewPriorityColumn"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "user",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v9 /*: any*/ ,
                                                                        v10 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "accountId"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "picture"
                                                                        },
                                                                        v8 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraBoardViewAssigneeColumn"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraOption",
                                                                    "kind": "LinkedField",
                                                                    "name": "category",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "value"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "optionId"
                                                                        },
                                                                        {
                                                                            "concreteType": "JiraColor",
                                                                            "kind": "LinkedField",
                                                                            "name": "color",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "colorKey"
                                                                                },
                                                                                v8 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v8 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraBoardViewCategoryColumn"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "cursor"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "totalCount"
                                        },
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "endCursor"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasNextPage"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "handle": "connection",
                                    "key": "business_board_columns",
                                    "kind": "LinkedHandle",
                                    "name": "columns"
                                },
                                {
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "enabledOnly",
                                            "value": true
                                        },
                                        {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 100
                                        }
                                    ],
                                    "concreteType": "JiraBoardViewCardOptionConnection",
                                    "kind": "LinkedField",
                                    "name": "cardOptions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraBoardViewCardOptionEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraField",
                                                                    "kind": "LinkedField",
                                                                    "name": "field",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v6 /*: any*/ ,
                                                                        v8 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraBoardViewFieldCardOption"
                                                        },
                                                        v8 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    "storageKey": "cardOptions(enabledOnly:true,first:100)"
                                },
                                {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcmergeboardworkflowsrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "selectedWorkflowId"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        v9 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v8 /*: any*/ 
                                            ],
                                            "type": "BulkMutationErrorExtension"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "8cec56bbfe0f789f51d6b48194a6cd4d5cd31ba412251a2a6e175427a86720d7",
            "metadata": {},
            "name": "BoardGroupSelectorSetGroupByMutation",
            "operationKind": "mutation",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcmergeboardworkflowsrelayprovider": (0, $apYuT.default)
            }
        }
    };
}();
$9d37841b4f01cb63$var$node.hash = "d16ec68a073c480a1634cb4b2815bb74";
var $9d37841b4f01cb63$export$2e2bcd8739ae039 = $9d37841b4f01cb63$var$node;

});

parcelRegister("cBOn0", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a84626ffce406e6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<235be1041e6980bd6bd29373d4afa657>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $4a84626ffce406e6$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v1 = {
        "kind": "ScalarField",
        "name": "fieldName"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "BoardGroupSelector_view",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "id"
                },
                "action": "THROW",
                "path": "id"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraViewGroupByConfig",
                    "kind": "LinkedField",
                    "name": "groupByConfig",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": v0 /*: any*/ ,
                            "action": "THROW",
                            "path": "groupByConfig.fieldId"
                        },
                        {
                            "kind": "RequiredField",
                            "field": v1 /*: any*/ ,
                            "action": "THROW",
                            "path": "groupByConfig.fieldName"
                        }
                    ]
                },
                "action": "THROW",
                "path": "groupByConfig"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraViewGroupByConfig",
                    "kind": "LinkedField",
                    "name": "groupByOptions",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": v0 /*: any*/ ,
                            "action": "THROW",
                            "path": "groupByOptions.fieldId"
                        },
                        {
                            "kind": "RequiredField",
                            "field": v1 /*: any*/ ,
                            "action": "THROW",
                            "path": "groupByOptions.fieldName"
                        }
                    ]
                },
                "action": "THROW",
                "path": "groupByOptions"
            }
        ],
        "type": "JiraBoardView"
    };
}();
$4a84626ffce406e6$var$node.hash = "1cf2e14c5b47c0a9b5809df9d0fa287b";
var $4a84626ffce406e6$export$2e2bcd8739ae039 = $4a84626ffce406e6$var$node;

});

parcelRegister("hRkFS", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3c013b1e05bf2dafdcad36de91a04a78>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d0076c6993b9840f$var$_react = $d0076c6993b9840f$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $d0076c6993b9840f$var$_menu = $d0076c6993b9840f$var$_interopRequireDefault((parcelRequire("fYy29")));

var $d0076c6993b9840f$var$_menuExpand = $d0076c6993b9840f$var$_interopRequireDefault((parcelRequire("aLbwz")));
function $d0076c6993b9840f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for MenuIcon.
 * This component is MenuIcon, with `UNSAFE_fallbackIcon` set to "MenuExpandIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for accessing the menu in global product navigation.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d0076c6993b9840f$var$MenuIcon = (props)=>/*#__PURE__*/ $d0076c6993b9840f$var$_react.default.createElement($d0076c6993b9840f$var$_menu.default, Object.assign({
        LEGACY_fallbackIcon: $d0076c6993b9840f$var$_menuExpand.default
    }, props));
$d0076c6993b9840f$var$MenuIcon.Name = 'MenuIconMigration';
var $d0076c6993b9840f$var$_default = module.exports.default = $d0076c6993b9840f$var$MenuIcon;

});
parcelRegister("fYy29", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ecb53df8812f428ed0814030a719aff1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ba16dbfa24557687$var$_react = $ba16dbfa24557687$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $ba16dbfa24557687$var$_baseNew = $ba16dbfa24557687$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $ba16dbfa24557687$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Menu".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for accessing the menu in global product navigation.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ba16dbfa24557687$var$MenuIcon = (props)=>/*#__PURE__*/ $ba16dbfa24557687$var$_react.default.createElement($ba16dbfa24557687$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 3.5H1V2h14zm0 5.25H1v-1.5h14zM15 14H1v-1.5h14z" clip-rule="evenodd"/>`
    }, props));
$ba16dbfa24557687$var$MenuIcon.displayName = 'MenuIcon';
var $ba16dbfa24557687$var$_default = module.exports.default = $ba16dbfa24557687$var$MenuIcon;

});

parcelRegister("aLbwz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7d573baeaf377068$var$_react = $7d573baeaf377068$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $7d573baeaf377068$var$_menu = $7d573baeaf377068$var$_interopRequireDefault((parcelRequire("fYy29")));
function $7d573baeaf377068$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $7d573baeaf377068$var$MenuExpandIcon = (props)=>/*#__PURE__*/ $7d573baeaf377068$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M6 12c0-.552.456-1 1.002-1h9.996a.999.999 0 1 1 0 2H7.002A1 1 0 0 1 6 12m0 4c0-.552.456-1 1.002-1h9.996a.999.999 0 1 1 0 2H7.002A1 1 0 0 1 6 16m0-8c0-.552.456-1 1.002-1h9.996a.999.999 0 1 1 0 2H7.002A1 1 0 0 1 6 8"/></svg>`
    }, props, {
        newIcon: $7d573baeaf377068$var$_menu.default
    }));
$7d573baeaf377068$var$MenuExpandIcon.displayName = 'MenuExpandIcon';
var $7d573baeaf377068$var$_default = module.exports.default = $7d573baeaf377068$var$MenuExpandIcon;

});


parcelRegister("aVLHQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $1939d56bba257c70$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $1939d56bba257c70$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    groupBySectionTitle: {
        "id": "work-management-board.header.group-selector.group-by-section-title",
        "defaultMessage": "Group By"
    },
    groupByButtonAriaLabel: {
        "id": "work-management-board.header.group-selector.group-by-button-aria-label",
        "defaultMessage": "Group by {label}"
    },
    groupByButtonLabelOld: {
        "id": "work-management-board.header.group-selector.group-by-button-label-old",
        "defaultMessage": "Group by: "
    },
    groupByButtonLabel: {
        "id": "work-management-board.header.group-selector.group-by-button-label",
        "defaultMessage": "Group: "
    },
    groupByStatusLabel: {
        "id": "work-management-board.header.group-selector.group-by-status-label",
        "defaultMessage": "Status"
    },
    groupByPriorityLabel: {
        "id": "work-management-board.header.group-selector.group-by-priority-label",
        "defaultMessage": "Priority"
    },
    groupByAssigneeLabel: {
        "id": "work-management-board.header.group-selector.group-by-assignee-label",
        "defaultMessage": "Assignee"
    },
    groupByCategoryLabel: {
        "id": "work-management-board.header.group-selector.group-by-category-label",
        "defaultMessage": "Category"
    },
    groupBySelected: {
        "id": "work-management-board.header.group-selector.group-by-selected",
        "defaultMessage": "Selected"
    },
    setGroupByFailedTitle: {
        "id": "work-management-board.header.group-selector.set-group-by-failed-title",
        "defaultMessage": "Unable to change group by setting"
    },
    setGroupByFailedMessage: {
        "id": "work-management-board.header.group-selector.set-group-by-failed-message",
        "defaultMessage": "We couldn't change the group by setting, try refreshing the page or try again later."
    }
});

});


parcelRegister("9t9Z1", function(module, exports) {

$parcel$export(module.exports, "default", () => $750efa675d54f51b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $750efa675d54f51b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    shareTitle: {
        "id": "work-management-board.header.share-title",
        "defaultMessage": "Board"
    },
    searchBoardLabel: {
        "id": "work-management-board.header.search-board-label",
        "defaultMessage": "Search board"
    },
    showAllWorkItems: {
        "id": "work-management-board.header.show-all-work-items",
        "defaultMessage": "Showing all work items"
    },
    showFilteredWorkItems: {
        "id": "work-management-board.header.show-filtered-work-items",
        "defaultMessage": "{count, plural, one {Showing # work item} other {Showing # work items}}"
    },
    viewSettingsButton: {
        "id": "work-management-board.header.view-settings-button",
        "defaultMessage": "View settings"
    },
    moreButtonOld: {
        "id": "work-management-board.header.more-button-old",
        "defaultMessage": "More"
    }
});

});

parcelRegister("fvKJM", function(module, exports) {

$parcel$export(module.exports, "SaveResetViewSettings", () => $157faf72b90e61ba$export$4d1c38ab1dc99daa);

var $b8cN4 = parcelRequire("b8cN4");

var $jmRKe = parcelRequire("jmRKe");

var $alNtn = parcelRequire("alNtn");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $7sLAO = parcelRequire("7sLAO");

var $3bDjY = parcelRequire("3bDjY");

var $1L8xR = parcelRequire("1L8xR");

var $eCeGD = parcelRequire("eCeGD");

var $BLPHT = parcelRequire("BLPHT");
var $6B7KL = parcelRequire("6B7KL");
var $aRoVz = parcelRequire("aRoVz");

var $1R1Ge = parcelRequire("1R1Ge");
var $7QSqG = parcelRequire("7QSqG");
var $juxqI = parcelRequire("juxqI");
var $jgVsb = parcelRequire("jgVsb");
var $gofOI = parcelRequire("gofOI");
var $i8Qvm = parcelRequire("i8Qvm");

var $7gs1W = parcelRequire("7gs1W");
var $imZsD = parcelRequire("imZsD");
var $k6T4f = parcelRequire("k6T4f");
var $5Fk4Z = parcelRequire("5Fk4Z");
var $1QiBP = parcelRequire("1QiBP");

var $22OQR = parcelRequire("22OQR");

var $koVbs = parcelRequire("koVbs");

var $pa9q9 = parcelRequire("pa9q9");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $cUcEa = parcelRequire("cUcEa");

var $7y8jx = parcelRequire("7y8jx");

var $fPzrH = parcelRequire("fPzrH");

var $bbbyF = parcelRequire("bbbyF");
const $157faf72b90e61ba$var$styles = {
    root: "_1e0c1txw _19bvu2gc"
};
const $157faf72b90e61ba$export$4d1c38ab1dc99daa = /*#__PURE__*/ (0, $5uXOq.memo)(({ viewFragment: viewFragment })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [isOnboardingVisible, markAsSeen] = (0, $cUcEa.useOnboarding)((0, $cUcEa.SAVE_VIEW_ONBOARDING));
    const [isSpotlightVisible, setSpotlightVisible] = (0, $5uXOq.useState)(false);
    const [isMenuOpen, setIsMenuOpen] = (0, $5uXOq.useState)(false);
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const { refetch: refetch } = (0, $fPzrH.useBoardData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [isModalOpen, setModalOpen] = (0, $5uXOq.useState)(false);
    const openModal = (0, $5uXOq.useCallback)(()=>setModalOpen(true), []);
    const closeModal = (0, $5uXOq.useCallback)(()=>setModalOpen(false), []);
    const view = (0, $8Uumt.useFragment)((0, $alNtn.default), viewFragment);
    const [publish, publishing] = (0, $8Uumt.useMutation)((0, $jmRKe.default));
    const [discard, discarding] = (0, $8Uumt.useMutation)((0, $b8cN4.default));
    const onClickSave = (0, $5uXOq.useCallback)(()=>{
        closeModal();
        const showFailureFlag = ()=>{
            showFlag({
                messageId: 'work-management-board.ui.header.save-reset-view-settings.show-flag.error.save-settings-failed',
                messageType: 'transactional',
                title: (0, $bbbyF.default).saveSettingsFailedTitle,
                description: (0, $bbbyF.default).saveSettingsFailedMessage,
                type: 'error'
            });
        };
        publish({
            variables: {
                input: {
                    viewId: view.id,
                    settings: (0, $7y8jx.getBoardQueryParams)()
                }
            },
            onError () {
                showFailureFlag();
            },
            onCompleted (response) {
                if (response.jira_publishBoardViewConfig?.success !== true) {
                    showFailureFlag();
                    return;
                }
                showFlag({
                    messageId: 'work-management-board.ui.header.save-reset-view-settings.show-flag.success.save-settings-success',
                    messageType: 'transactional',
                    title: (0, $bbbyF.default).saveSettingsSuccessTitle,
                    description: (0, $bbbyF.default).saveSettingsSuccessMessage,
                    type: 'success'
                });
                (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'viewSettings saved');
            }
        });
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'saveSettings');
    }, [
        closeModal,
        createAnalyticsEvent,
        publish,
        showFlag,
        view.id
    ]);
    const onClickReset = (0, $5uXOq.useCallback)(()=>{
        const showFailureFlag = ()=>{
            showFlag({
                messageId: 'work-management-board.ui.header.save-reset-view-settings.show-flag.error.reset-settings-failed',
                messageType: 'transactional',
                title: (0, $bbbyF.default).resetSettingsFailedTitle,
                description: (0, $bbbyF.default).resetSettingsFailedMessage,
                type: 'error'
            });
        };
        discard({
            variables: {
                input: {
                    viewId: view.id,
                    // we are specifically not passing overrides when discarding the settings
                    settings: null
                }
            },
            onError () {
                showFailureFlag();
            },
            onCompleted (response) {
                if (response.jira_discardUserBoardViewConfig?.success !== true) {
                    showFailureFlag();
                    return;
                }
                (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'viewSettings reset');
                refetch();
            }
        });
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'resetSettings', {
            isProjectAdmin: view.canPublishViewConfig
        });
    }, [
        createAnalyticsEvent,
        discard,
        refetch,
        showFlag,
        view
    ]);
    if (!view.canPublishViewConfig) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            $157faf72b90e61ba$var$styles.root
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formatMessage((0, $bbbyF.default).resetViewSettingsButton),
        position: "top",
        hideTooltipOnClick: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $22OQR.ThemedButton), {
        onClick: onClickReset,
        isLoading: discarding,
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sLAO))), {
            label: formatMessage((0, $bbbyF.default).resetViewSettingsButton),
            spacing: "spacious",
            color: "currentColor"
        })
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            $157faf72b90e61ba$var$styles.root
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $imZsD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $BLPHT.default), {
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
                content: formatMessage((0, $bbbyF.default).saveOrResetViewSettingsButton),
                position: "top",
                hideTooltipOnClick: true
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k6T4f.Pulse), {
                radius: 3,
                pulse: isOnboardingVisible
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $22OQR.ThemedButton), {
                ...props,
                isLoading: discarding || publishing,
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1L8xR))), {
                    label: formatMessage((0, $bbbyF.default).saveOrResetViewSettingsButton),
                    spacing: "spacious",
                    color: "currentColor"
                }),
                ref: triggerRef,
                onClick: ()=>{
                    setIsMenuOpen(!isMenuOpen);
                    if (isOnboardingVisible) {
                        markAsSeen();
                        setTimeout(()=>{
                            setSpotlightVisible(true);
                        }, 0);
                    }
                }
            }))),
        shouldRenderToParent: false,
        isOpen: isMenuOpen,
        onOpenChange: ({ isOpen: isOpen })=>!isSpotlightVisible && setIsMenuOpen(isOpen)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), {
        name: "save-reset-view-settings-menu"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k6T4f.Pulse), {
        radius: 3,
        pulse: isSpotlightVisible
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aRoVz.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        onClick: openModal
    }, formatMessage((0, $bbbyF.default).saveViewSettingsMenuItem)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        onClick: onClickReset
    }, formatMessage((0, $bbbyF.default).resetViewSettingsMenuItem)))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1QiBP.default), null, isSpotlightVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7gs1W.default), {
        actions: [
            {
                onClick: ()=>{
                    setSpotlightVisible(false);
                },
                text: formatMessage((0, $bbbyF.default).onboardingNudgeAcknowledged)
            }
        ],
        heading: formatMessage((0, $bbbyF.default).onboardingNudgeTitle),
        target: "save-reset-view-settings-menu",
        targetRadius: 3,
        dialogPlacement: "left top",
        dialogWidth: 280,
        targetBgColor: "var(--ds-surface, #FFFFFF)"
    }, formatMessage((0, $bbbyF.default).onboardingNudgeDescription)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i8Qvm.default), null, isModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1R1Ge.default), {
        onClose: closeModal,
        width: "small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgVsb.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gofOI.default), null, formatMessage((0, $bbbyF.default).saveConfirmationModalTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7QSqG.default), null, formatMessage((0, $bbbyF.default).saveConfirmationModalBody)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $juxqI.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
        appearance: "subtle",
        onClick: closeModal
    }, formatMessage((0, $bbbyF.default).cancelButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
        appearance: "primary",
        onClick: onClickSave
    }, formatMessage((0, $bbbyF.default).saveButton))))));
});

});
parcelRegister("b8cN4", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d2c4aa5f19f7b1f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d48a3acfc8691af623801b3014a1e43f>>
 * @relayHash 9df6dafc74f21f45568981fadccd2962
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 273c6ed82dc852e6a4f962cb2854147521e7b32ebfb7044eac4150bc83b68f29

var $apYuT = parcelRequire("apYuT");
const $5d2c4aa5f19f7b1f$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "input"
    }, v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "ScalarField",
        "name": "message"
    }, v4 = {
        "kind": "ScalarField",
        "name": "errorType"
    }, v5 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v6 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v7 = [
        v6 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "fieldName"
        }
    ], v8 = {
        "kind": "ScalarField",
        "name": "id"
    }, v9 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v10 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "SaveResetViewSettingsDiscardSettingsMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "JiraDiscardUserBoardViewConfigPayload",
                    "kind": "LinkedField",
                    "name": "jira_discardUserBoardViewConfig",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "JiraBoardView",
                            "kind": "LinkedField",
                            "name": "boardView",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "BusinessBoard_view"
                                }
                            ]
                        },
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcmergeboardworkflowsrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "SaveResetViewSettingsDiscardSettingsMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "JiraDiscardUserBoardViewConfigPayload",
                    "kind": "LinkedField",
                    "name": "jira_discardUserBoardViewConfig",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "JiraBoardView",
                            "kind": "LinkedField",
                            "name": "boardView",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraViewFilterConfig",
                                    "kind": "LinkedField",
                                    "name": "filterConfig",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "jql"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "JiraViewGroupByConfig",
                                    "kind": "LinkedField",
                                    "name": "groupByConfig",
                                    "plural": false,
                                    "selections": v7 /*: any*/ 
                                },
                                v8 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "isViewConfigModified"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canPublishViewConfig"
                                },
                                {
                                    "concreteType": "JiraViewGroupByConfig",
                                    "kind": "LinkedField",
                                    "name": "groupByOptions",
                                    "plural": true,
                                    "selections": v7 /*: any*/ 
                                },
                                {
                                    "concreteType": "JiraBoardViewColumnConnection",
                                    "kind": "LinkedField",
                                    "name": "columns",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraBoardViewColumnEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        v8 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "collapsed"
                                                        },
                                                        {
                                                            "kind": "TypeDiscriminator",
                                                            "abstractKey": "__isJiraBoardViewColumn"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraStatus",
                                                                    "kind": "LinkedField",
                                                                    "name": "statuses",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v10 /*: any*/ ,
                                                                        v8 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "statusId"
                                                                        },
                                                                        {
                                                                            "concreteType": "JiraStatusCategory",
                                                                            "kind": "LinkedField",
                                                                            "name": "statusCategory",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "statusCategoryId"
                                                                                },
                                                                                v8 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraBoardViewStatusColumn"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraPriority",
                                                                    "kind": "LinkedField",
                                                                    "name": "priority",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v10 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "priorityId"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "iconUrl"
                                                                        },
                                                                        v8 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraBoardViewPriorityColumn"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "user",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v9 /*: any*/ ,
                                                                        v10 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "accountId"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "picture"
                                                                        },
                                                                        v8 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraBoardViewAssigneeColumn"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraOption",
                                                                    "kind": "LinkedField",
                                                                    "name": "category",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "value"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "optionId"
                                                                        },
                                                                        {
                                                                            "concreteType": "JiraColor",
                                                                            "kind": "LinkedField",
                                                                            "name": "color",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "colorKey"
                                                                                },
                                                                                v8 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v8 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraBoardViewCategoryColumn"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "cursor"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "totalCount"
                                        },
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "endCursor"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasNextPage"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "handle": "connection",
                                    "key": "business_board_columns",
                                    "kind": "LinkedHandle",
                                    "name": "columns"
                                },
                                {
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "enabledOnly",
                                            "value": true
                                        },
                                        {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 100
                                        }
                                    ],
                                    "concreteType": "JiraBoardViewCardOptionConnection",
                                    "kind": "LinkedField",
                                    "name": "cardOptions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraBoardViewCardOptionEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraField",
                                                                    "kind": "LinkedField",
                                                                    "name": "field",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v6 /*: any*/ ,
                                                                        v8 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraBoardViewFieldCardOption"
                                                        },
                                                        v8 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    "storageKey": "cardOptions(enabledOnly:true,first:100)"
                                },
                                {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcmergeboardworkflowsrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "selectedWorkflowId"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        v9 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v8 /*: any*/ 
                                            ],
                                            "type": "BulkMutationErrorExtension"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "273c6ed82dc852e6a4f962cb2854147521e7b32ebfb7044eac4150bc83b68f29",
            "metadata": {},
            "name": "SaveResetViewSettingsDiscardSettingsMutation",
            "operationKind": "mutation",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcmergeboardworkflowsrelayprovider": (0, $apYuT.default)
            }
        }
    };
}();
$5d2c4aa5f19f7b1f$var$node.hash = "ffc8839515761fa873d3e33eb5c9010d";
var $5d2c4aa5f19f7b1f$export$2e2bcd8739ae039 = $5d2c4aa5f19f7b1f$var$node;

});

parcelRegister("jmRKe", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a9b1773bf483950$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a1cf58419542c5fd866d6d997bb0502e>>
 * @relayHash 832f4e667da8f12c77210c4660c41182
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fa8f12d778faffbbcb7869b21dc6a0087fc8477858b834ae51ae06c583ec1b59
const $0a9b1773bf483950$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "ScalarField",
        "name": "message"
    }, v4 = {
        "kind": "ScalarField",
        "name": "errorType"
    }, v5 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v6 = {
        "kind": "ScalarField",
        "name": "id"
    }, v7 = [
        {
            "kind": "ScalarField",
            "name": "fieldId"
        },
        {
            "kind": "ScalarField",
            "name": "fieldName"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SaveResetViewSettingsPublishSettingsMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "JiraPublishBoardViewConfigPayload",
                    "kind": "LinkedField",
                    "name": "jira_publishBoardViewConfig",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "JiraBoardView",
                            "kind": "LinkedField",
                            "name": "boardView",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "SaveResetViewSettings_view"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "BoardHeader_view"
                                }
                            ]
                        },
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SaveResetViewSettingsPublishSettingsMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "JiraPublishBoardViewConfigPayload",
                    "kind": "LinkedField",
                    "name": "jira_publishBoardViewConfig",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "JiraBoardView",
                            "kind": "LinkedField",
                            "name": "boardView",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "canPublishViewConfig"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isViewConfigModified"
                                },
                                {
                                    "concreteType": "JiraViewGroupByConfig",
                                    "kind": "LinkedField",
                                    "name": "groupByConfig",
                                    "plural": false,
                                    "selections": v7 /*: any*/ 
                                },
                                {
                                    "concreteType": "JiraViewGroupByConfig",
                                    "kind": "LinkedField",
                                    "name": "groupByOptions",
                                    "plural": true,
                                    "selections": v7 /*: any*/ 
                                }
                            ]
                        },
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v6 /*: any*/ 
                                            ],
                                            "type": "BulkMutationErrorExtension"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "fa8f12d778faffbbcb7869b21dc6a0087fc8477858b834ae51ae06c583ec1b59",
            "metadata": {},
            "name": "SaveResetViewSettingsPublishSettingsMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$0a9b1773bf483950$var$node.hash = "7ed0f82d0e65763cd418c88dd8bb3e20";
var $0a9b1773bf483950$export$2e2bcd8739ae039 = $0a9b1773bf483950$var$node;

});

parcelRegister("alNtn", function(module, exports) {

$parcel$export(module.exports, "default", () => $1376548480e0b708$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f021762a9c66ab8bf5bfab4c2d129d80>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $1376548480e0b708$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "SaveResetViewSettings_view",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "id"
            },
            "action": "THROW",
            "path": "id"
        },
        {
            "kind": "ScalarField",
            "name": "canPublishViewConfig"
        }
    ],
    "type": "JiraBoardView"
};
$1376548480e0b708$var$node.hash = "4984ccf5ecf43d6b96d4d712dfe4633b";
var $1376548480e0b708$export$2e2bcd8739ae039 = $1376548480e0b708$var$node;

});

parcelRegister("7sLAO", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2edf8e8e6d811ed80e747695771356e6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $56f010d97236ea23$var$_react = $56f010d97236ea23$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $56f010d97236ea23$var$_baseNew = $56f010d97236ea23$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $56f010d97236ea23$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Undo".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for undo in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $56f010d97236ea23$var$UndoIcon = (props)=>/*#__PURE__*/ $56f010d97236ea23$var$_react.default.createElement($56f010d97236ea23$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m1.22 4.72 3.5-3.5 1.06 1.06L3.56 4.5h6.69a4.75 4.75 0 1 1 0 9.5H8v-1.5h2.25a3.25 3.25 0 0 0 0-6.5H3.56l2.22 2.22-1.06 1.06-3.5-3.5a.75.75 0 0 1 0-1.06" clip-rule="evenodd"/>`
    }, props));
$56f010d97236ea23$var$UndoIcon.displayName = 'UndoIcon';
var $56f010d97236ea23$var$_default = module.exports.default = $56f010d97236ea23$var$UndoIcon;

});

parcelRegister("1L8xR", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d64019569838190420a4f4f1d7102ef7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1480cf1bcddc807a$var$_react = $1480cf1bcddc807a$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $1480cf1bcddc807a$var$_baseNew = $1480cf1bcddc807a$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $1480cf1bcddc807a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Sync".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for syncing changes and save operations.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1480cf1bcddc807a$var$SyncIcon = (props)=>/*#__PURE__*/ $1480cf1bcddc807a$var$_react.default.createElement($1480cf1bcddc807a$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 .5h4.25a.75.75 0 0 1 .75.75V5.5H5.5V2.941a9 9 0 0 0-1.094.916C3.42 4.83 2.5 6.214 2.5 8c0 1.813.817 3.18 1.871 4.11 1.079.95 2.346 1.39 3.129 1.39V15c-1.217 0-2.825-.623-4.121-1.765C2.058 12.07 1 10.312 1 8c0-2.339 1.21-4.084 2.354-5.211.308-.304.615-.567.9-.789H2zm10.621 2.266C13.942 3.93 15 5.688 15 8c0 2.338-1.204 4.079-2.344 5.201-.304.3-.607.56-.889.78H14v1.5H9.75a.75.75 0 0 1-.75-.75v-4.25h1.5v2.573a9 9 0 0 0 1.104-.921C12.584 11.166 13.5 9.787 13.5 8c0-1.813-.817-3.18-1.871-4.11C10.551 2.94 9.283 2.5 8.5 2.5V1c1.217 0 2.825.623 4.121 1.766" clip-rule="evenodd"/>`
    }, props));
$1480cf1bcddc807a$var$SyncIcon.displayName = 'SyncIcon';
var $1480cf1bcddc807a$var$_default = module.exports.default = $1480cf1bcddc807a$var$SyncIcon;

});

parcelRegister("cUcEa", function(module, exports) {

$parcel$export(module.exports, "RENAME_ONBOARDING", () => $dcaed4e80c6c1d23$export$8b943171fca14870);
$parcel$export(module.exports, "SAVE_VIEW_ONBOARDING", () => $dcaed4e80c6c1d23$export$a5717569cf53d503);
$parcel$export(module.exports, "SavedViewsOnboardingInitializer", () => $dcaed4e80c6c1d23$export$816ee139d9a87d77);
$parcel$export(module.exports, "useOnboarding", () => $dcaed4e80c6c1d23$export$5520b3b17c256ea3);

var $5uXOq = parcelRequire("5uXOq");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $i205g = parcelRequire("i205g");

var $6s1PB = parcelRequire("6s1PB");
const $dcaed4e80c6c1d23$var$TTL_SEEN = 31536000000; // ~ 365 days
const $dcaed4e80c6c1d23$export$8b943171fca14870 = 'board-saved-views-rename';
const $dcaed4e80c6c1d23$export$a5717569cf53d503 = 'board-saved-views-save-view';
const $dcaed4e80c6c1d23$var$actions = {
    initialize: (seenItResponse)=>({ setState: setState })=>{
            setState({
                [$dcaed4e80c6c1d23$export$8b943171fca14870]: seenItResponse[$dcaed4e80c6c1d23$export$8b943171fca14870]?.status !== true,
                [$dcaed4e80c6c1d23$export$a5717569cf53d503]: seenItResponse[$dcaed4e80c6c1d23$export$a5717569cf53d503]?.status !== true
            });
        },
    markAsSeen: (key)=>({ setState: setState, getState: getState })=>setState({
                ...getState(),
                [key]: false
            })
};
const $dcaed4e80c6c1d23$var$store = (0, $iXqE5.createStore)({
    name: 'SavedViewsOnboardingStore',
    initialState: {
        [$dcaed4e80c6c1d23$export$8b943171fca14870]: false,
        [$dcaed4e80c6c1d23$export$a5717569cf53d503]: false
    },
    actions: $dcaed4e80c6c1d23$var$actions
});
const $dcaed4e80c6c1d23$var$useActions = (0, $3sQ5x.createActionsHook)($dcaed4e80c6c1d23$var$store);
const $dcaed4e80c6c1d23$var$getOnboardingByKey = (state, args)=>state[args[0]];
const $dcaed4e80c6c1d23$var$useOnboardingState = (0, $3sQ5x.createStateHook)($dcaed4e80c6c1d23$var$store, {
    selector: $dcaed4e80c6c1d23$var$getOnboardingByKey
});
const $dcaed4e80c6c1d23$export$816ee139d9a87d77 = ()=>{
    const { initialize: initialize } = $dcaed4e80c6c1d23$var$useActions();
    (0, $5uXOq.useEffect)(()=>{
        if (!(0, $6s1PB.expVal)('saved_views', 'enabled', false)) return;
        if (false) return;
        (0, $i205g.getFlags)({
            [$dcaed4e80c6c1d23$export$8b943171fca14870]: {},
            [$dcaed4e80c6c1d23$export$a5717569cf53d503]: {}
        }).then(initialize).catch(()=>{
        // Ignore errors
        });
    }, [
        initialize
    ]);
    return null;
};
const $dcaed4e80c6c1d23$export$5520b3b17c256ea3 = (key)=>{
    const { markAsSeen: markAsSeen } = $dcaed4e80c6c1d23$var$useActions();
    const isOnboardingVisible = $dcaed4e80c6c1d23$var$useOnboardingState([
        key
    ]);
    const markOnboardingAsSeen = (0, $5uXOq.useCallback)(()=>{
        markAsSeen(key);
        (0, $i205g.setFlag)(key, $dcaed4e80c6c1d23$var$TTL_SEEN);
    }, [
        key,
        markAsSeen
    ]);
    return [
        isOnboardingVisible,
        markOnboardingAsSeen
    ];
};

});

parcelRegister("bbbyF", function(module, exports) {

$parcel$export(module.exports, "default", () => $31037de2bddc6efe$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $31037de2bddc6efe$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    resetViewSettingsButton: {
        "id": "work-management-board.header.save-reset-view-settings.reset-view-config-button",
        "defaultMessage": "Reset board back to default"
    },
    saveOrResetViewSettingsButton: {
        "id": "work-management-board.header.save-reset-view-settings.save-or-reset-view-settings-button",
        "defaultMessage": "Save or reset view settings"
    },
    saveViewSettingsMenuItem: {
        "id": "work-management-board.header.save-reset-view-settings.save-view-config-menu-item",
        "defaultMessage": "Save board"
    },
    resetViewSettingsMenuItem: {
        "id": "work-management-board.header.save-reset-view-settings.reset-view-config-menu-item",
        "defaultMessage": "Reset to last saved"
    },
    saveSettingsSuccessTitle: {
        "id": "work-management-board.header.save-reset-view-settings.save-settings-success-title",
        "defaultMessage": "Board view saved"
    },
    saveSettingsSuccessMessage: {
        "id": "work-management-board.header.save-reset-view-settings.save-settings-success-message",
        "defaultMessage": "This view has been updated for everyone in this project."
    },
    saveSettingsFailedTitle: {
        "id": "work-management-board.header.save-reset-view-settings.save-settings-failed-title",
        "defaultMessage": "Unable to save your settings"
    },
    saveSettingsFailedMessage: {
        "id": "work-management-board.header.save-reset-view-settings.save-settings-failed-message",
        "defaultMessage": "We couldn't save your settings, try refreshing the page or try again later."
    },
    resetSettingsFailedTitle: {
        "id": "work-management-board.header.save-reset-view-settings.reset-settings-failed-title",
        "defaultMessage": "Unable to reset your settings"
    },
    resetSettingsFailedMessage: {
        "id": "work-management-board.header.save-reset-view-settings.reset-settings-failed-message",
        "defaultMessage": "We couldn't reset your settings, try refreshing the page or try again later."
    },
    saveConfirmationModalTitle: {
        "id": "work-management-board.header.save-reset-view-settings.save-confirmation-modal-title",
        "defaultMessage": "Save board view"
    },
    saveConfirmationModalBody: {
        "id": "work-management-board.header.save-reset-view-settings.save-confirmation-modal-description",
        "defaultMessage": "The board will be saved for everyone in the project. They'll see the applied filters, grouping, fields, and columns."
    },
    saveButton: {
        "id": "work-management-board.header.save-reset-view-settings.save-confirmation-modal-button",
        "defaultMessage": "Save"
    },
    cancelButton: {
        "id": "work-management-board.header.save-reset-view-settings.cancel-confirmation-modal-button",
        "defaultMessage": "Cancel"
    },
    onboardingNudgeTitle: {
        "id": "work-management-board.header.save-reset-view-settings.onboarding-nudge-title",
        "defaultMessage": "Save and reset your board view"
    },
    onboardingNudgeDescription: {
        "id": "work-management-board.header.save-reset-view-settings.onboarding-nudge-description",
        "defaultMessage": "Save your view for everyone in the project or reset it back to the default settings."
    },
    onboardingNudgeAcknowledged: {
        "id": "work-management-board.header.save-reset-view-settings.onboarding-nudge-acknowledged",
        "defaultMessage": "OK"
    }
});

});


parcelRegister("5WsXw", function(module, exports) {

$parcel$export(module.exports, "moreMenuContentEntryPoint", () => $de054a77272fcd28$export$b4db54f6e08979a8);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

var $jIdzg = parcelRequire("jIdzg");

var $6s1PB = parcelRequire("6s1PB");

var $7y8jx = parcelRequire("7y8jx");

const $de054a77272fcd28$export$b4db54f6e08979a8 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("9L79W")), {
        moduleId: "e34641db",
        moduleName: "BoardMoreMenuContent"
    }),
    getPreloadProps: ({ projectAri: projectAri, viewId: viewId })=>({
            queries: {
                mainQuery: {
                    parameters: (0, $jIdzg.default),
                    variables: {
                        projectAri: projectAri,
                        viewInput: {
                            jiraBoardViewQueryInput: {
                                viewId: viewId
                            },
                            settings: (0, $7y8jx.getBoardQueryParams)()
                        },
                        withMergedWorkflows: (0, $6s1PB.expVal)('merge_board_workflows', 'enabled', false)
                    },
                    options: {
                        fetchPolicy: 'store-and-network'
                    }
                }
            }
        })
});

});
parcelRegister("jIdzg", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d3836e144d81c9f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b170fadf0055783b18cb27f76017064c>>
 * @relayHash 2da4ae7661b646746b18386f70f3c831
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e27d6da23b42336bf9e89a0160f29b3a79e15d77df77ca2bb5b6865f0bcc3fda
const $4d3836e144d81c9f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectAri"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "viewInput"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "withMergedWorkflows"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "projectAri"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "viewInput"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "BoardMoreMenuContentQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProject",
                            "plural": false,
                            "selections": [
                                {
                                    "condition": "withMergedWorkflows",
                                    "kind": "Condition",
                                    "passingValue": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "WorkflowSelectorMenu_project"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v2 /*: any*/ ,
                        "concreteType": "JiraBoardView",
                        "kind": "LinkedField",
                        "name": "jira_boardView",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "FragmentSpread",
                                "name": "CardFieldsMenu"
                            },
                            {
                                "condition": "withMergedWorkflows",
                                "kind": "Condition",
                                "passingValue": false,
                                "selections": [
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "WorkflowSelectorMenu_view"
                                    }
                                ]
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "RemoveResolvedItemsMenu"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "ExpandCollapseAll_view"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira_boardView"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "BoardMoreMenuContentQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProject",
                            "plural": false,
                            "selections": [
                                {
                                    "condition": "withMergedWorkflows",
                                    "kind": "Condition",
                                    "passingValue": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "projectStyle"
                                        },
                                        {
                                            "alias": "canAdministerProject",
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "type",
                                                    "value": "EDIT_PROJECT_CONFIG"
                                                }
                                            ],
                                            "concreteType": "JiraProjectAction",
                                            "kind": "LinkedField",
                                            "name": "action",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "canPerform"
                                                }
                                            ],
                                            "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
                                        }
                                    ]
                                },
                                v3 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "JiraBoardView",
                    "kind": "LinkedField",
                    "name": "jira_boardView",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        {
                            "alias": "menuCardOptions",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 200
                                }
                            ],
                            "concreteType": "JiraBoardViewCardOptionConnection",
                            "kind": "LinkedField",
                            "name": "cardOptions",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraBoardViewCardOptionEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraField",
                                                            "kind": "LinkedField",
                                                            "name": "field",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "name"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "fieldId"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "typeKey"
                                                                },
                                                                v3 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "canToggle"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "enabled"
                                                        }
                                                    ],
                                                    "type": "JiraBoardViewFieldCardOption"
                                                },
                                                v4 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "cardOptions(first:200)"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "completedIssueSearchCutOffInDays"
                        },
                        {
                            "concreteType": "JiraBoardViewColumnConnection",
                            "kind": "LinkedField",
                            "name": "columns",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ 
                            ]
                        },
                        {
                            "condition": "withMergedWorkflows",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "selectedWorkflowId"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "e27d6da23b42336bf9e89a0160f29b3a79e15d77df77ca2bb5b6865f0bcc3fda",
            "metadata": {},
            "name": "BoardMoreMenuContentQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$4d3836e144d81c9f$var$node.hash = "147180b29613be81c66264f73f45a4d0";
var $4d3836e144d81c9f$export$2e2bcd8739ae039 = $4d3836e144d81c9f$var$node;

});

parcelRegister("9L79W", function(module, exports) {

let $71ae0e86088a07c9$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $71ae0e86088a07c9$var$load("ffQaD"),
    $71ae0e86088a07c9$var$load("kvRbA"),
    $71ae0e86088a07c9$var$load("dpHO5")
]).then(()=>parcelRequire('3xOdt'));

});



parcelRegister("d9Nxy", function(module, exports) {

$parcel$export(module.exports, "transformWorkflow", () => $12d76f9343c6d5de$export$bbcfebdec0ab6a21);
const $12d76f9343c6d5de$export$bbcfebdec0ab6a21 = ({ issueTypes: issueTypes, transitions: transitions, workflowId: workflowId, workflowName: workflowName })=>({
        issueTypes: issueTypes.map(({ iconUrl: iconUrl, hierarchyLevel: hierarchyLevel, id: id, name: name })=>({
                avatarUrl: iconUrl,
                hierarchyLevel: hierarchyLevel,
                issueTypeId: id,
                name: name
            })),
        name: workflowName,
        transitions: transitions.map(({ isConditional: isConditional, isGlobal: isGlobal, isInitial: isInitial, name: name, toStatusId: toStatusId, transitionId: transitionId })=>({
                isConditional: isConditional,
                isGlobal: isGlobal,
                isInitial: isInitial,
                name: name,
                to: {
                    statusId: String(toStatusId)
                },
                transitionId: String(transitionId)
            })),
        workflowId: workflowId
    });

});

parcelRegister("iYmhw", function(module, exports) {

$parcel$export(module.exports, "BusinessBoardScreenAnalytics", () => $a87e02e5b94c90b8$export$eaa39c399bdba76);

var $hesYC = parcelRequire("hesYC");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $5oFIy = parcelRequire("5oFIy");
const $a87e02e5b94c90b8$export$eaa39c399bdba76 = /*#__PURE__*/ (0, $5uXOq.memo)(({ viewFragment: viewFragment })=>{
    const view = (0, $8Uumt.useFragment)((0, $hesYC.default), viewFragment);
    const withFilters = Boolean(view.filterConfig.jql);
    const groupByField = view.groupByConfig.fieldId;
    const attributes = (0, $5uXOq.useMemo)(()=>({
            groupedBy: groupByField,
            withFilters: withFilters,
            isViewConfigModified: view.isViewConfigModified
        }), [
        groupByField,
        view.isViewConfigModified,
        withFilters
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), {
        attributes: attributes
    });
});

});
parcelRegister("hesYC", function(module, exports) {

$parcel$export(module.exports, "default", () => $430c5285c5e2fa24$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<71733446f7feb0b25ded972e4b7e6c09>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $430c5285c5e2fa24$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "BusinessBoardScreenAnalytics_view",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "JiraViewFilterConfig",
                "kind": "LinkedField",
                "name": "filterConfig",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "jql"
                        },
                        "action": "THROW",
                        "path": "filterConfig.jql"
                    }
                ]
            },
            "action": "THROW",
            "path": "filterConfig"
        },
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "JiraViewGroupByConfig",
                "kind": "LinkedField",
                "name": "groupByConfig",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "fieldId"
                        },
                        "action": "THROW",
                        "path": "groupByConfig.fieldId"
                    }
                ]
            },
            "action": "THROW",
            "path": "groupByConfig"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "isViewConfigModified"
            },
            "action": "THROW",
            "path": "isViewConfigModified"
        }
    ],
    "type": "JiraBoardView"
};
$430c5285c5e2fa24$var$node.hash = "15b0a43b0bdaabb721154c95f12efff8";
var $430c5285c5e2fa24$export$2e2bcd8739ae039 = $430c5285c5e2fa24$var$node;

});


parcelRegister("4lW8s", function(module, exports) {

$parcel$export(module.exports, "BusinessBoardQueryParamSync", () => $8fe9322006597ca3$export$203ad9ef673e1b5c);

var $e5WCi = parcelRequire("e5WCi");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $lODMY = parcelRequire("lODMY");
const $8fe9322006597ca3$export$45d76561a5302f2b = (0, $lODMY.createRouterSelector)((state)=>state.location);
const $8fe9322006597ca3$export$203ad9ef673e1b5c = ({ viewFragment: viewFragment })=>{
    const location = $8fe9322006597ca3$export$45d76561a5302f2b();
    const { updateQueryParam: updateQueryParam } = (0, $lODMY.useRouterStoreActions)();
    const view = (0, $8Uumt.useFragment)((0, $e5WCi.default), viewFragment);
    (0, $5uXOq.useEffect)(()=>{
        const filter = view.filterConfig.jql;
        const groupBy = view.groupByConfig.fieldId;
        const currentParams = new URLSearchParams(location.search);
        const currentFilter = currentParams.get('filter') ?? '';
        const currentGroupBy = currentParams.get('groupBy');
        if (filter !== currentFilter || groupBy !== currentGroupBy) updateQueryParam({
            // empty JQL string means no filter query param
            filter: filter || undefined,
            groupBy: groupBy
        }, 'replace');
    // recalculate if the location has changed (not just the search)
    }, [
        location,
        updateQueryParam,
        view.filterConfig.jql,
        view.groupByConfig.fieldId
    ]);
    return null;
};

});
parcelRegister("e5WCi", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d0a2ad9b200e4e3$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<11e4fbedc75998a5e67779ba07f05200>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $9d0a2ad9b200e4e3$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "BusinessBoardQueryParamSync_view",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "JiraViewFilterConfig",
                "kind": "LinkedField",
                "name": "filterConfig",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "jql"
                        },
                        "action": "THROW",
                        "path": "filterConfig.jql"
                    }
                ]
            },
            "action": "THROW",
            "path": "filterConfig"
        },
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "JiraViewGroupByConfig",
                "kind": "LinkedField",
                "name": "groupByConfig",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "fieldId"
                        },
                        "action": "THROW",
                        "path": "groupByConfig.fieldId"
                    }
                ]
            },
            "action": "THROW",
            "path": "groupByConfig"
        }
    ],
    "type": "JiraBoardView"
};
$9d0a2ad9b200e4e3$var$node.hash = "980b6fd1d42f858b1606feb74cb67a1a";
var $9d0a2ad9b200e4e3$export$2e2bcd8739ae039 = $9d0a2ad9b200e4e3$var$node;

});





//# sourceMappingURL=async-business-board-entrypoint.8eae2914.js.map
